(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["collab-ui-react"] = factory(require("react"), require("react-dom"));
	else
		root["collab-ui-react"] = factory(root["React"], root["ReactDOM"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_61__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 290);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(10);
var core = __webpack_require__(29);
var hide = __webpack_require__(22);
var redefine = __webpack_require__(23);
var ctx = __webpack_require__(30);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date = new Date(y, m, d, h, M, s, ms);

        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
        return date;
    }

    function createUTCDate (y) {
        var date = new Date(Date.UTC.apply(null, arguments));

        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        if (!m) {
            return isArray(this._weekdays) ? this._weekdays :
                this._weekdays['standalone'];
        }
        return isArray(this._weekdays) ? this._weekdays[m.day()] :
            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                __webpack_require__(507)("./" + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {milliseconds: 0, months: 0};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    function startOf (units) {
        units = normalizeUnits(units);
        // the following switch intentionally omits break keywords
        // to utilize falling through the cases.
        switch (units) {
            case 'year':
                this.month(0);
                /* falls through */
            case 'quarter':
            case 'month':
                this.date(1);
                /* falls through */
            case 'week':
            case 'isoWeek':
            case 'day':
            case 'date':
                this.hours(0);
                /* falls through */
            case 'hour':
                this.minutes(0);
                /* falls through */
            case 'minute':
                this.seconds(0);
                /* falls through */
            case 'second':
                this.milliseconds(0);
        }

        // weeks are a special case
        if (units === 'week') {
            this.weekday(0);
        }
        if (units === 'isoWeek') {
            this.isoWeekday(1);
        }

        // quarters are also special
        if (units === 'quarter') {
            this.month(Math.floor(this.month() / 3) * 3);
        }

        return this;
    }

    function endOf (units) {
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond') {
            return this;
        }

        // 'date' is an alias for 'day', so it should be considered as such.
        if (units === 'date') {
            units = 'day';
        }

        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'year') {
            days   = this._days   + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            return units === 'month' ? months : months / 12;
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.23.0';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(163)(module)))

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(467)();
}


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(0);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(119) });


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(43);
var step = __webpack_require__(141);
var Iterators = __webpack_require__(57);
var toIObject = __webpack_require__(26);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(96)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(5);
var getKeys = __webpack_require__(46);
var redefine = __webpack_require__(23);
var global = __webpack_require__(10);
var hide = __webpack_require__(22);
var Iterators = __webpack_require__(57);
var wks = __webpack_require__(14);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(18);
var $keys = __webpack_require__(46);

__webpack_require__(36)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.utils = exports.Tooltip = exports.TopbarRight = exports.TopbarNav = exports.TopbarMobile = exports.Topbar = exports.ToggleSwitch = exports.TimePicker = exports.Tabs = exports.TabPane = exports.TabList = exports.TabHeader = exports.TabContent = exports.Tab = exports.SubMenu = exports.Spinner = exports.SpaceListMeeting = exports.SpaceListItem = exports.SocialList = exports.Slider = exports.SideNav = exports.SelectOption = exports.Select = exports.SearchInput = exports.RadioGroup = exports.Radio = exports.ProgressBar = exports.Popover = exports.ModalHeader = exports.ModalFooter = exports.ModalBody = exports.Modal = exports.MenuItem = exports.MenuOverlay = exports.MenuContent = exports.Menu = exports.Loading = exports.ListSeparator = exports.ListItemSection = exports.ListItemMeeting = exports.ListItemHeader = exports.ListItem = exports.List = exports.Link = exports.Lightbox = exports.Label = exports.InputHelper = exports.InputError = exports.Input = exports.Icon = exports.FormSubSection = exports.FormSection = exports.FormInfo = exports.FormContent = exports.Form = exports.Footer = exports.ErrorBoundary = exports.EventOverlay = exports.EditableTextfield = exports.DatePicker = exports.ContentItem = exports.CollapseButton = exports.CompositeAvatar = exports.ComboBox = exports.Coachmark = exports.CloseIcon = exports.Chip = exports.CheckboxGroup = exports.Checkbox = exports.Card = exports.CallControl = exports.ButtonGroup = exports.Button = exports.Breadcrumbs = exports.Badge = exports.Avatar = exports.AlertMeetingContainer = exports.AlertMeeting = exports.AlertContainer = exports.AlertCallContainer = exports.AlertCall = exports.AlertBanner = exports.Alert = exports.ActivityButton = exports.AccordionContent = exports.AccordionHeader = exports.AccordionGroup = exports.Accordion = void 0;

var _Accordion = _interopRequireDefault(__webpack_require__(466));

exports.Accordion = _Accordion.default;

var _AccordionGroup = _interopRequireDefault(__webpack_require__(471));

exports.AccordionGroup = _AccordionGroup.default;

var _AccordionHeader = _interopRequireDefault(__webpack_require__(472));

exports.AccordionHeader = _AccordionHeader.default;

var _AccordionContent = _interopRequireDefault(__webpack_require__(473));

exports.AccordionContent = _AccordionContent.default;

var _ActivityButton = _interopRequireDefault(__webpack_require__(474));

exports.ActivityButton = _ActivityButton.default;

var _Alert = _interopRequireDefault(__webpack_require__(475));

exports.Alert = _Alert.default;

var _AlertBanner = _interopRequireDefault(__webpack_require__(476));

exports.AlertBanner = _AlertBanner.default;

var _AlertCall = _interopRequireDefault(__webpack_require__(477));

exports.AlertCall = _AlertCall.default;

var _AlertCallContainer = _interopRequireDefault(__webpack_require__(479));

exports.AlertCallContainer = _AlertCallContainer.default;

var _AlertContainer = _interopRequireDefault(__webpack_require__(480));

exports.AlertContainer = _AlertContainer.default;

var _AlertMeeting = _interopRequireDefault(__webpack_require__(481));

exports.AlertMeeting = _AlertMeeting.default;

var _AlertMeetingContainer = _interopRequireDefault(__webpack_require__(482));

exports.AlertMeetingContainer = _AlertMeetingContainer.default;

var _Avatar = _interopRequireDefault(__webpack_require__(483));

exports.Avatar = _Avatar.default;

var _Badge = _interopRequireDefault(__webpack_require__(484));

exports.Badge = _Badge.default;

var _Breadcrumbs = _interopRequireDefault(__webpack_require__(485));

exports.Breadcrumbs = _Breadcrumbs.default;

var _Button = _interopRequireDefault(__webpack_require__(486));

exports.Button = _Button.default;

var _ButtonGroup = _interopRequireDefault(__webpack_require__(487));

exports.ButtonGroup = _ButtonGroup.default;

var _CallControl = _interopRequireDefault(__webpack_require__(488));

exports.CallControl = _CallControl.default;

var _Card = _interopRequireDefault(__webpack_require__(489));

exports.Card = _Card.default;

var _Checkbox = _interopRequireDefault(__webpack_require__(490));

exports.Checkbox = _Checkbox.default;

var _CheckboxGroup = _interopRequireDefault(__webpack_require__(491));

exports.CheckboxGroup = _CheckboxGroup.default;

var _Chip = _interopRequireDefault(__webpack_require__(492));

exports.Chip = _Chip.default;

var _CloseIcon = _interopRequireDefault(__webpack_require__(493));

exports.CloseIcon = _CloseIcon.default;

var _Coachmark = _interopRequireDefault(__webpack_require__(494));

exports.Coachmark = _Coachmark.default;

var _ComboBox = _interopRequireDefault(__webpack_require__(495));

exports.ComboBox = _ComboBox.default;

var _CompositeAvatar = _interopRequireDefault(__webpack_require__(496));

exports.CompositeAvatar = _CompositeAvatar.default;

var _CollapseButton = _interopRequireDefault(__webpack_require__(497));

exports.CollapseButton = _CollapseButton.default;

var _ContentItem = _interopRequireDefault(__webpack_require__(498));

exports.ContentItem = _ContentItem.default;

var _DatePicker = _interopRequireDefault(__webpack_require__(502));

exports.DatePicker = _DatePicker.default;

var _EditableTextfield = _interopRequireDefault(__webpack_require__(508));

exports.EditableTextfield = _EditableTextfield.default;

var _EventOverlay = _interopRequireDefault(__webpack_require__(509));

exports.EventOverlay = _EventOverlay.default;

var _ErrorBoundary = _interopRequireDefault(__webpack_require__(510));

exports.ErrorBoundary = _ErrorBoundary.default;

var _Footer = _interopRequireDefault(__webpack_require__(511));

exports.Footer = _Footer.default;

var _Form = _interopRequireDefault(__webpack_require__(512));

exports.Form = _Form.default;

var _FormContent = _interopRequireDefault(__webpack_require__(513));

exports.FormContent = _FormContent.default;

var _FormInfo = _interopRequireDefault(__webpack_require__(514));

exports.FormInfo = _FormInfo.default;

var _FormSection = _interopRequireDefault(__webpack_require__(515));

exports.FormSection = _FormSection.default;

var _FormSubSection = _interopRequireDefault(__webpack_require__(516));

exports.FormSubSection = _FormSubSection.default;

var _Icon = _interopRequireDefault(__webpack_require__(517));

exports.Icon = _Icon.default;

var _Input = _interopRequireDefault(__webpack_require__(520));

exports.Input = _Input.default;

var _InputError = _interopRequireDefault(__webpack_require__(521));

exports.InputError = _InputError.default;

var _InputHelper = _interopRequireDefault(__webpack_require__(522));

exports.InputHelper = _InputHelper.default;

var _Label = _interopRequireDefault(__webpack_require__(523));

exports.Label = _Label.default;

var _Lightbox = _interopRequireDefault(__webpack_require__(524));

exports.Lightbox = _Lightbox.default;

var _Link = _interopRequireDefault(__webpack_require__(530));

exports.Link = _Link.default;

var _List = _interopRequireDefault(__webpack_require__(531));

exports.List = _List.default;

var _ListItem = _interopRequireDefault(__webpack_require__(532));

exports.ListItem = _ListItem.default;

var _ListItemHeader = _interopRequireDefault(__webpack_require__(533));

exports.ListItemHeader = _ListItemHeader.default;

var _ListItemMeeting = _interopRequireDefault(__webpack_require__(534));

exports.ListItemMeeting = _ListItemMeeting.default;

var _ListItemSection = _interopRequireDefault(__webpack_require__(535));

exports.ListItemSection = _ListItemSection.default;

var _ListSeparator = _interopRequireDefault(__webpack_require__(536));

exports.ListSeparator = _ListSeparator.default;

var _Loading = _interopRequireDefault(__webpack_require__(537));

exports.Loading = _Loading.default;

var _Menu = _interopRequireDefault(__webpack_require__(538));

exports.Menu = _Menu.default;

var _MenuContent = _interopRequireDefault(__webpack_require__(539));

exports.MenuContent = _MenuContent.default;

var _MenuOverlay = _interopRequireDefault(__webpack_require__(540));

exports.MenuOverlay = _MenuOverlay.default;

var _MenuItem = _interopRequireDefault(__webpack_require__(541));

exports.MenuItem = _MenuItem.default;

var _Modal = _interopRequireDefault(__webpack_require__(542));

exports.Modal = _Modal.default;

var _ModalBody = _interopRequireDefault(__webpack_require__(543));

exports.ModalBody = _ModalBody.default;

var _ModalFooter = _interopRequireDefault(__webpack_require__(544));

exports.ModalFooter = _ModalFooter.default;

var _ModalHeader = _interopRequireDefault(__webpack_require__(545));

exports.ModalHeader = _ModalHeader.default;

var _Popover = _interopRequireDefault(__webpack_require__(546));

exports.Popover = _Popover.default;

var _ProgressBar = _interopRequireDefault(__webpack_require__(547));

exports.ProgressBar = _ProgressBar.default;

var _Radio = _interopRequireDefault(__webpack_require__(548));

exports.Radio = _Radio.default;

var _RadioGroup = _interopRequireDefault(__webpack_require__(549));

exports.RadioGroup = _RadioGroup.default;

var _SearchInput = _interopRequireDefault(__webpack_require__(550));

exports.SearchInput = _SearchInput.default;

var _Select = _interopRequireDefault(__webpack_require__(551));

exports.Select = _Select.default;

var _SelectOption = _interopRequireDefault(__webpack_require__(552));

exports.SelectOption = _SelectOption.default;

var _SideNav = _interopRequireDefault(__webpack_require__(553));

exports.SideNav = _SideNav.default;

var _Slider = _interopRequireDefault(__webpack_require__(554));

exports.Slider = _Slider.default;

var _SocialList = _interopRequireDefault(__webpack_require__(556));

exports.SocialList = _SocialList.default;

var _SpaceListItem = _interopRequireDefault(__webpack_require__(557));

exports.SpaceListItem = _SpaceListItem.default;

var _SpaceListMeeting = _interopRequireDefault(__webpack_require__(558));

exports.SpaceListMeeting = _SpaceListMeeting.default;

var _Spinner = _interopRequireDefault(__webpack_require__(559));

exports.Spinner = _Spinner.default;

var _SubMenu = _interopRequireDefault(__webpack_require__(560));

exports.SubMenu = _SubMenu.default;

var _Tab = _interopRequireDefault(__webpack_require__(561));

exports.Tab = _Tab.default;

var _TabContent = _interopRequireDefault(__webpack_require__(562));

exports.TabContent = _TabContent.default;

var _TabHeader = _interopRequireDefault(__webpack_require__(563));

exports.TabHeader = _TabHeader.default;

var _TabList = _interopRequireDefault(__webpack_require__(564));

exports.TabList = _TabList.default;

var _TabPane = _interopRequireDefault(__webpack_require__(565));

exports.TabPane = _TabPane.default;

var _Tabs = _interopRequireDefault(__webpack_require__(566));

exports.Tabs = _Tabs.default;

var _TimePicker = _interopRequireDefault(__webpack_require__(567));

exports.TimePicker = _TimePicker.default;

var _ToggleSwitch = _interopRequireDefault(__webpack_require__(570));

exports.ToggleSwitch = _ToggleSwitch.default;

var _Topbar = _interopRequireDefault(__webpack_require__(571));

exports.Topbar = _Topbar.default;

var _TopbarMobile = _interopRequireDefault(__webpack_require__(572));

exports.TopbarMobile = _TopbarMobile.default;

var _TopbarNav = _interopRequireDefault(__webpack_require__(573));

exports.TopbarNav = _TopbarNav.default;

var _TopbarRight = _interopRequireDefault(__webpack_require__(574));

exports.TopbarRight = _TopbarRight.default;

var _Tooltip = _interopRequireDefault(__webpack_require__(575));

exports.Tooltip = _Tooltip.default;

var _utils = _interopRequireWildcard(__webpack_require__(576));

exports.utils = _utils;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(12);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 10 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.11';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });

        return result;
      }

      if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });

        return result;
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        if (isObject(srcValue)) {
          stack || (stack = new Stack);
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = (lodashFunc.name + ''),
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68), __webpack_require__(163)(module)))

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(69)('wks');
var uid = __webpack_require__(45);
var Symbol = __webpack_require__(10).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(32);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(11)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(9);
var IE8_DOM_DEFINE = __webpack_require__(114);
var toPrimitive = __webpack_require__(34);
var dP = Object.defineProperty;

exports.f = __webpack_require__(16) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(35);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(0);
var $includes = __webpack_require__(70)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(43)('includes');


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(0);
var context = __webpack_require__(98);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(99)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(17);
var createDesc = __webpack_require__(44);
module.exports = __webpack_require__(16) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(10);
var hide = __webpack_require__(22);
var has = __webpack_require__(25);
var SRC = __webpack_require__(45)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(29).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var fails = __webpack_require__(11);
var defined = __webpack_require__(35);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 25 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(62);
var defined = __webpack_require__(35);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(63);
var createDesc = __webpack_require__(44);
var toIObject = __webpack_require__(26);
var toPrimitive = __webpack_require__(34);
var has = __webpack_require__(25);
var IE8_DOM_DEFINE = __webpack_require__(114);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(16) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(25);
var toObject = __webpack_require__(18);
var IE_PROTO = __webpack_require__(86)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 29 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(21);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 31 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 32 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(11);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(12);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 35 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(0);
var core = __webpack_require__(29);
var fails = __webpack_require__(11);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(17).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(16) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(30);
var IObject = __webpack_require__(62);
var toObject = __webpack_require__(18);
var toLength = __webpack_require__(15);
var asc = __webpack_require__(104);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(16)) {
  var LIBRARY = __webpack_require__(42);
  var global = __webpack_require__(10);
  var fails = __webpack_require__(11);
  var $export = __webpack_require__(0);
  var $typed = __webpack_require__(80);
  var $buffer = __webpack_require__(112);
  var ctx = __webpack_require__(30);
  var anInstance = __webpack_require__(51);
  var propertyDesc = __webpack_require__(44);
  var hide = __webpack_require__(22);
  var redefineAll = __webpack_require__(53);
  var toInteger = __webpack_require__(32);
  var toLength = __webpack_require__(15);
  var toIndex = __webpack_require__(153);
  var toAbsoluteIndex = __webpack_require__(47);
  var toPrimitive = __webpack_require__(34);
  var has = __webpack_require__(25);
  var classof = __webpack_require__(55);
  var isObject = __webpack_require__(12);
  var toObject = __webpack_require__(18);
  var isArrayIter = __webpack_require__(101);
  var create = __webpack_require__(48);
  var getPrototypeOf = __webpack_require__(28);
  var gOPN = __webpack_require__(49).f;
  var getIterFn = __webpack_require__(103);
  var uid = __webpack_require__(45);
  var wks = __webpack_require__(14);
  var createArrayMethod = __webpack_require__(38);
  var createArrayIncludes = __webpack_require__(70);
  var speciesConstructor = __webpack_require__(67);
  var ArrayIterators = __webpack_require__(5);
  var Iterators = __webpack_require__(57);
  var $iterDetect = __webpack_require__(75);
  var setSpecies = __webpack_require__(50);
  var arrayFill = __webpack_require__(105);
  var arrayCopyWithin = __webpack_require__(140);
  var $DP = __webpack_require__(17);
  var $GOPD = __webpack_require__(27);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(148);
var $export = __webpack_require__(0);
var shared = __webpack_require__(69)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(151))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(45)('meta');
var isObject = __webpack_require__(12);
var has = __webpack_require__(25);
var setDesc = __webpack_require__(17).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(11)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 42 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(14)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(22)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 44 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 45 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(116);
var enumBugKeys = __webpack_require__(87);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(32);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(9);
var dPs = __webpack_require__(117);
var enumBugKeys = __webpack_require__(87);
var IE_PROTO = __webpack_require__(86)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(84)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(88).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(116);
var hiddenKeys = __webpack_require__(87).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(10);
var dP = __webpack_require__(17);
var DESCRIPTORS = __webpack_require__(16);
var SPECIES = __webpack_require__(14)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(30);
var call = __webpack_require__(138);
var isArrayIter = __webpack_require__(101);
var anObject = __webpack_require__(9);
var toLength = __webpack_require__(15);
var getIterFn = __webpack_require__(103);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(23);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(17).f;
var has = __webpack_require__(25);
var TAG = __webpack_require__(14)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(31);
var TAG = __webpack_require__(14)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var defined = __webpack_require__(35);
var fails = __webpack_require__(11);
var spaces = __webpack_require__(90);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(9);
var toLength = __webpack_require__(15);
var advanceStringIndex = __webpack_require__(108);
var regExpExec = __webpack_require__(76);

// @@match logic
__webpack_require__(77)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(12);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.newDateWithOffset = newDateWithOffset;
exports.now = now;
exports.getStartOfWeek = getStartOfWeek;
exports.getStartOfMonth = getStartOfMonth;
exports.getDate = getDate;
exports.getMonth = getMonth;
exports.addDays = addDays;
exports.addWeeks = addWeeks;
exports.addMonths = addMonths;
exports.subtractDays = subtractDays;
exports.subtractWeeks = subtractWeeks;
exports.subtractMonths = subtractMonths;
exports.getLocaleData = getLocaleData;
exports.getWeekdayMinInLocale = getWeekdayMinInLocale;
exports.localizeDate = localizeDate;
exports.isSameDay = isSameDay;
exports.isSameMonth = isSameMonth;
exports.isDayDisabled = isDayDisabled;
exports.shouldPrevMonthDisable = shouldPrevMonthDisable;
exports.shouldNextMonthDisable = shouldNextMonthDisable;

var _moment = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function newDateWithOffset(utcOffset) {
  return (0, _moment.default)().utc().utcOffset(utcOffset);
}

function now(maybeFixedUtcOffset) {
  if (maybeFixedUtcOffset == null) {
    return (0, _moment.default)();
  }

  return newDateWithOffset(maybeFixedUtcOffset);
}

function getStartOfWeek(date) {
  return date.startOf('week');
}

function getStartOfMonth(date) {
  return date.startOf('month');
} // Returns day of month


function getDate(date) {
  return date.get('date');
}

function getMonth(date) {
  return date.get('month');
}

function addDays(date, amount) {
  return date.add(amount, 'days');
}

function addWeeks(date, amount) {
  return date.add(amount, 'weeks');
}

function addMonths(date, amount) {
  return date.add(amount, 'months');
}

function subtractDays(date, amount) {
  return date.subtract(amount, "days");
}

function subtractWeeks(date, amount) {
  return date.subtract(amount, "weeks");
}

function subtractMonths(date, amount) {
  return date.subtract(amount, 'months');
}

function getLocaleData(date) {
  return date.localeData();
}

function getWeekdayMinInLocale(locale, date) {
  return locale.weekdaysMin(date).substr(0, 1);
}

function localizeDate(date, locale) {
  if (locale === void 0) {
    locale = _moment.default.locale();
  }

  return date.clone().locale(locale);
}

function isSameDay(moment1, moment2) {
  if (moment1 && moment2) {
    return moment1.isSame(moment2, 'day');
  } else {
    return !moment1 && !moment2;
  }
}

function isSameMonth(date1, date2) {
  if (date1 && date2) {
    return date1.isSame(date2, 'month');
  } else {
    return !date1 && !date2;
  }
}

function isDayDisabled(day, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      filterDate = _ref.filterDate;

  return minDate && day.isBefore((0, _moment.default)(minDate), 'day') || maxDate && day.isAfter((0, _moment.default)(maxDate), 'day') || filterDate && filterDate(day.clone()) || false;
}

function shouldPrevMonthDisable(day, minDate) {
  var firstDayOfCurrMonth = day.clone().startOf('month');
  return minDate && !(0, _moment.default)(minDate).isBefore(firstDayOfCurrMonth);
}

function shouldNextMonthDisable(day, maxDate) {
  var lastDayOfCurrMonth = day.clone().endOf('month');
  return maxDate && !(0, _moment.default)(maxDate).isAfter(lastDayOfCurrMonth);
}

/***/ }),
/* 61 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_61__;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(31);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 63 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(9);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(9);
var toObject = __webpack_require__(18);
var toLength = __webpack_require__(15);
var toInteger = __webpack_require__(32);
var advanceStringIndex = __webpack_require__(108);
var regExpExec = __webpack_require__(76);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(77)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return ch;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return ch;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return ch;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(74);
var anObject = __webpack_require__(9);
var speciesConstructor = __webpack_require__(67);
var advanceStringIndex = __webpack_require__(108);
var toLength = __webpack_require__(15);
var callRegExpExec = __webpack_require__(76);
var regexpExec = __webpack_require__(107);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';

// eslint-disable-next-line no-empty
var SUPPORTS_Y = !!(function () { try { return new RegExp('x', 'y'); } catch (e) {} })();

// @@split logic
__webpack_require__(77)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                    (rx.multiline ? 'm' : '') +
                    (rx.unicode ? 'u' : '') +
                    (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? 0xffffffff : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(9);
var aFunction = __webpack_require__(21);
var SPECIES = __webpack_require__(14)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 68 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(29);
var global = __webpack_require__(10);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(42) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(26);
var toLength = __webpack_require__(15);
var toAbsoluteIndex = __webpack_require__(47);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 71 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(31);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(32);
var defined = __webpack_require__(35);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(12);
var cof = __webpack_require__(31);
var MATCH = __webpack_require__(14)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(14)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(55);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(143);
var redefine = __webpack_require__(23);
var hide = __webpack_require__(22);
var fails = __webpack_require__(11);
var defined = __webpack_require__(35);
var wks = __webpack_require__(14);
var regexpExec = __webpack_require__(107);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(10);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(10);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(23);
var redefineAll = __webpack_require__(53);
var meta = __webpack_require__(41);
var forOf = __webpack_require__(52);
var anInstance = __webpack_require__(51);
var isObject = __webpack_require__(12);
var fails = __webpack_require__(11);
var $iterDetect = __webpack_require__(75);
var setToStringTag = __webpack_require__(54);
var inheritIfRequired = __webpack_require__(92);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(10);
var hide = __webpack_require__(22);
var uid = __webpack_require__(45);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(42) || !__webpack_require__(11)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(10)[K];
});


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(21);
var ctx = __webpack_require__(30);
var forOf = __webpack_require__(52);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(12);
var document = __webpack_require__(10).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(10);
var core = __webpack_require__(29);
var LIBRARY = __webpack_require__(42);
var wksExt = __webpack_require__(115);
var defineProperty = __webpack_require__(17).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(69)('keys');
var uid = __webpack_require__(45);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 87 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(10).document;
module.exports = document && document.documentElement;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(12);
var anObject = __webpack_require__(9);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(30)(Function.call, __webpack_require__(27).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(10);
var has = __webpack_require__(25);
var cof = __webpack_require__(31);
var inheritIfRequired = __webpack_require__(92);
var toPrimitive = __webpack_require__(34);
var fails = __webpack_require__(11);
var gOPN = __webpack_require__(49).f;
var gOPD = __webpack_require__(27).f;
var dP = __webpack_require__(17).f;
var $trim = __webpack_require__(56).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(48)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(16) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(23)(global, NUMBER, $Number);
}


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(12);
var setPrototypeOf = __webpack_require__(89).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(32);
var defined = __webpack_require__(35);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 94 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 95 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(42);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(23);
var hide = __webpack_require__(22);
var Iterators = __webpack_require__(57);
var $iterCreate = __webpack_require__(97);
var setToStringTag = __webpack_require__(54);
var getPrototypeOf = __webpack_require__(28);
var ITERATOR = __webpack_require__(14)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(48);
var descriptor = __webpack_require__(44);
var setToStringTag = __webpack_require__(54);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(22)(IteratorPrototype, __webpack_require__(14)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(74);
var defined = __webpack_require__(35);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(14)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(24)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(57);
var ITERATOR = __webpack_require__(14)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(17);
var createDesc = __webpack_require__(44);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(55);
var ITERATOR = __webpack_require__(14)('iterator');
var Iterators = __webpack_require__(57);
module.exports = __webpack_require__(29).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(366);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(18);
var toAbsoluteIndex = __webpack_require__(47);
var toLength = __webpack_require__(15);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(38)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(43)(KEY);


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(64);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(73)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(30);
var invoke = __webpack_require__(122);
var html = __webpack_require__(88);
var cel = __webpack_require__(84);
var global = __webpack_require__(10);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(31)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(10);
var macrotask = __webpack_require__(109).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(31)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(21);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(10);
var DESCRIPTORS = __webpack_require__(16);
var LIBRARY = __webpack_require__(42);
var $typed = __webpack_require__(80);
var hide = __webpack_require__(22);
var redefineAll = __webpack_require__(53);
var fails = __webpack_require__(11);
var anInstance = __webpack_require__(51);
var toInteger = __webpack_require__(32);
var toLength = __webpack_require__(15);
var toIndex = __webpack_require__(153);
var gOPN = __webpack_require__(49).f;
var dP = __webpack_require__(17).f;
var arrayFill = __webpack_require__(105);
var setToStringTag = __webpack_require__(54);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(10);
var has = __webpack_require__(25);
var DESCRIPTORS = __webpack_require__(16);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(23);
var META = __webpack_require__(41).KEY;
var $fails = __webpack_require__(11);
var shared = __webpack_require__(69);
var setToStringTag = __webpack_require__(54);
var uid = __webpack_require__(45);
var wks = __webpack_require__(14);
var wksExt = __webpack_require__(115);
var wksDefine = __webpack_require__(85);
var enumKeys = __webpack_require__(293);
var isArray = __webpack_require__(72);
var anObject = __webpack_require__(9);
var isObject = __webpack_require__(12);
var toIObject = __webpack_require__(26);
var toPrimitive = __webpack_require__(34);
var createDesc = __webpack_require__(44);
var _create = __webpack_require__(48);
var gOPNExt = __webpack_require__(118);
var $GOPD = __webpack_require__(27);
var $DP = __webpack_require__(17);
var $keys = __webpack_require__(46);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(49).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(63).f = $propertyIsEnumerable;
  __webpack_require__(71).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(42)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(22)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(16) && !__webpack_require__(11)(function () {
  return Object.defineProperty(__webpack_require__(84)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(14);


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(25);
var toIObject = __webpack_require__(26);
var arrayIndexOf = __webpack_require__(70)(false);
var IE_PROTO = __webpack_require__(86)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(17);
var anObject = __webpack_require__(9);
var getKeys = __webpack_require__(46);

module.exports = __webpack_require__(16) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(26);
var gOPN = __webpack_require__(49).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(46);
var gOPS = __webpack_require__(71);
var pIE = __webpack_require__(63);
var toObject = __webpack_require__(18);
var IObject = __webpack_require__(62);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(11)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 120 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(21);
var isObject = __webpack_require__(12);
var invoke = __webpack_require__(122);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 122 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(10).parseInt;
var $trim = __webpack_require__(56).trim;
var ws = __webpack_require__(90);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(10).parseFloat;
var $trim = __webpack_require__(56).trim;

module.exports = 1 / $parseFloat(__webpack_require__(90) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(31);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', { isInteger: __webpack_require__(127) });


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(12);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 128 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(94);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toAbsoluteIndex = __webpack_require__(47);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $at = __webpack_require__(73)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(15);
var context = __webpack_require__(98);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(99)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(15);
var context = __webpack_require__(98);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(99)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(24)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(24)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(24)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(23)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(9);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(21);
var toObject = __webpack_require__(18);
var IObject = __webpack_require__(62);
var toLength = __webpack_require__(15);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(18);
var toAbsoluteIndex = __webpack_require__(47);
var toLength = __webpack_require__(15);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(10);
var inheritIfRequired = __webpack_require__(92);
var dP = __webpack_require__(17).f;
var gOPN = __webpack_require__(49).f;
var isRegExp = __webpack_require__(74);
var $flags = __webpack_require__(64);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(16) && (!CORRECT_NEW || __webpack_require__(11)(function () {
  re2[__webpack_require__(14)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(23)(global, 'RegExp', $RegExp);
}

__webpack_require__(50)('RegExp');


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(107);
__webpack_require__(0)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(145);
var anObject = __webpack_require__(9);
var $flags = __webpack_require__(64);
var DESCRIPTORS = __webpack_require__(16);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(23)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(11)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(16) && /./g.flags != 'g') __webpack_require__(17).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(64)
});


/***/ }),
/* 146 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(9);
var isObject = __webpack_require__(12);
var newPromiseCapability = __webpack_require__(111);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(149);
var validate = __webpack_require__(59);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(79)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(17).f;
var create = __webpack_require__(48);
var redefineAll = __webpack_require__(53);
var ctx = __webpack_require__(30);
var anInstance = __webpack_require__(51);
var forOf = __webpack_require__(52);
var $iterDefine = __webpack_require__(96);
var step = __webpack_require__(141);
var setSpecies = __webpack_require__(50);
var DESCRIPTORS = __webpack_require__(16);
var fastKey = __webpack_require__(41).fastKey;
var validate = __webpack_require__(59);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(149);
var validate = __webpack_require__(59);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(79)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var each = __webpack_require__(38)(0);
var redefine = __webpack_require__(23);
var meta = __webpack_require__(41);
var assign = __webpack_require__(119);
var weak = __webpack_require__(152);
var isObject = __webpack_require__(12);
var fails = __webpack_require__(11);
var validate = __webpack_require__(59);
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var tmp = {};
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(79)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(53);
var getWeak = __webpack_require__(41).getWeak;
var anObject = __webpack_require__(9);
var isObject = __webpack_require__(12);
var anInstance = __webpack_require__(51);
var forOf = __webpack_require__(52);
var createArrayMethod = __webpack_require__(38);
var $has = __webpack_require__(25);
var validate = __webpack_require__(59);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(32);
var toLength = __webpack_require__(15);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(49);
var gOPS = __webpack_require__(71);
var anObject = __webpack_require__(9);
var Reflect = __webpack_require__(10).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(72);
var isObject = __webpack_require__(12);
var toLength = __webpack_require__(15);
var ctx = __webpack_require__(30);
var IS_CONCAT_SPREADABLE = __webpack_require__(14)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(15);
var repeat = __webpack_require__(93);
var defined = __webpack_require__(35);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(85)('asyncIterator');


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $values = __webpack_require__(159)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(46);
var toIObject = __webpack_require__(26);
var isEnum = __webpack_require__(63).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(55);
var from = __webpack_require__(161);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(52);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 162 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.snakeCase = snakeCase;

__webpack_require__(65);

function snakeCase(word) {
  return "" + word.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var af = moment.defineLocale('af', {
        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
        monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
        meridiemParse: /vm|nm/i,
        isPM : function (input) {
            return /^nm$/i.test(input);
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'vm' : 'VM';
            } else {
                return isLower ? 'nm' : 'NM';
            }
        },
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Vandag om] LT',
            nextDay : '[Môre om] LT',
            nextWeek : 'dddd [om] LT',
            lastDay : '[Gister om] LT',
            lastWeek : '[Laas] dddd [om] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'oor %s',
            past : '%s gelede',
            s : '\'n paar sekondes',
            ss : '%d sekondes',
            m : '\'n minuut',
            mm : '%d minute',
            h : '\'n uur',
            hh : '%d ure',
            d : '\'n dag',
            dd : '%d dae',
            M : '\'n maand',
            MM : '%d maande',
            y : '\'n jaar',
            yy : '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
        },
        week : {
            dow : 1, // Maandag is die eerste dag van die week.
            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
        }
    });

    return af;

})));


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '١',
        '2': '٢',
        '3': '٣',
        '4': '٤',
        '5': '٥',
        '6': '٦',
        '7': '٧',
        '8': '٨',
        '9': '٩',
        '0': '٠'
    }, numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    }, pluralForm = function (n) {
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
    }, plurals = {
        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
    }, pluralize = function (u) {
        return function (number, withoutSuffix, string, isFuture) {
            var f = pluralForm(number),
                str = plurals[u][pluralForm(number)];
            if (f === 2) {
                str = str[withoutSuffix ? 0 : 1];
            }
            return str.replace(/%d/i, number);
        };
    }, months = [
        'يناير',
        'فبراير',
        'مارس',
        'أبريل',
        'مايو',
        'يونيو',
        'يوليو',
        'أغسطس',
        'سبتمبر',
        'أكتوبر',
        'نوفمبر',
        'ديسمبر'
    ];

    var ar = moment.defineLocale('ar', {
        months : months,
        monthsShort : months,
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'D/\u200FM/\u200FYYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM : function (input) {
            return 'م' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar : {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'بعد %s',
            past : 'منذ %s',
            s : pluralize('s'),
            ss : pluralize('s'),
            m : pluralize('m'),
            mm : pluralize('m'),
            h : pluralize('h'),
            hh : pluralize('h'),
            d : pluralize('d'),
            dd : pluralize('d'),
            M : pluralize('M'),
            MM : pluralize('M'),
            y : pluralize('y'),
            yy : pluralize('y')
        },
        preparse: function (string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return ar;

})));


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var arDz = moment.defineLocale('ar-dz', {
        months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return arDz;

})));


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var arKw = moment.defineLocale('ar-kw', {
        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return arKw;

})));


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0'
    }, pluralForm = function (n) {
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
    }, plurals = {
        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
    }, pluralize = function (u) {
        return function (number, withoutSuffix, string, isFuture) {
            var f = pluralForm(number),
                str = plurals[u][pluralForm(number)];
            if (f === 2) {
                str = str[withoutSuffix ? 0 : 1];
            }
            return str.replace(/%d/i, number);
        };
    }, months = [
        'يناير',
        'فبراير',
        'مارس',
        'أبريل',
        'مايو',
        'يونيو',
        'يوليو',
        'أغسطس',
        'سبتمبر',
        'أكتوبر',
        'نوفمبر',
        'ديسمبر'
    ];

    var arLy = moment.defineLocale('ar-ly', {
        months : months,
        monthsShort : months,
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'D/\u200FM/\u200FYYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM : function (input) {
            return 'م' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar : {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'بعد %s',
            past : 'منذ %s',
            s : pluralize('s'),
            ss : pluralize('s'),
            m : pluralize('m'),
            mm : pluralize('m'),
            h : pluralize('h'),
            hh : pluralize('h'),
            d : pluralize('d'),
            dd : pluralize('d'),
            M : pluralize('M'),
            MM : pluralize('M'),
            y : pluralize('y'),
            yy : pluralize('y')
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return arLy;

})));


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var arMa = moment.defineLocale('ar-ma', {
        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return arMa;

})));


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '١',
        '2': '٢',
        '3': '٣',
        '4': '٤',
        '5': '٥',
        '6': '٦',
        '7': '٧',
        '8': '٨',
        '9': '٩',
        '0': '٠'
    }, numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    };

    var arSa = moment.defineLocale('ar-sa', {
        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM : function (input) {
            return 'م' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        preparse: function (string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return arSa;

})));


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var arTn = moment.defineLocale('ar-tn', {
        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss : '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات'
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return arTn;

})));


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var suffixes = {
        1: '-inci',
        5: '-inci',
        8: '-inci',
        70: '-inci',
        80: '-inci',
        2: '-nci',
        7: '-nci',
        20: '-nci',
        50: '-nci',
        3: '-üncü',
        4: '-üncü',
        100: '-üncü',
        6: '-ncı',
        9: '-uncu',
        10: '-uncu',
        30: '-uncu',
        60: '-ıncı',
        90: '-ıncı'
    };

    var az = moment.defineLocale('az', {
        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[bugün saat] LT',
            nextDay : '[sabah saat] LT',
            nextWeek : '[gələn həftə] dddd [saat] LT',
            lastDay : '[dünən] LT',
            lastWeek : '[keçən həftə] dddd [saat] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s sonra',
            past : '%s əvvəl',
            s : 'birneçə saniyə',
            ss : '%d saniyə',
            m : 'bir dəqiqə',
            mm : '%d dəqiqə',
            h : 'bir saat',
            hh : '%d saat',
            d : 'bir gün',
            dd : '%d gün',
            M : 'bir ay',
            MM : '%d ay',
            y : 'bir il',
            yy : '%d il'
        },
        meridiemParse: /gecə|səhər|gündüz|axşam/,
        isPM : function (input) {
            return /^(gündüz|axşam)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'gecə';
            } else if (hour < 12) {
                return 'səhər';
            } else if (hour < 17) {
                return 'gündüz';
            } else {
                return 'axşam';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
        ordinal : function (number) {
            if (number === 0) {  // special case for zero
                return number + '-ıncı';
            }
            var a = number % 10,
                b = number % 100 - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return az;

})));


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
            'dd': 'дзень_дні_дзён',
            'MM': 'месяц_месяцы_месяцаў',
            'yy': 'год_гады_гадоў'
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвіліна' : 'хвіліну';
        }
        else if (key === 'h') {
            return withoutSuffix ? 'гадзіна' : 'гадзіну';
        }
        else {
            return number + ' ' + plural(format[key], +number);
        }
    }

    var be = moment.defineLocale('be', {
        months : {
            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
        },
        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
        weekdays : {
            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/
        },
        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY г.',
            LLL : 'D MMMM YYYY г., HH:mm',
            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
        },
        calendar : {
            sameDay: '[Сёння ў] LT',
            nextDay: '[Заўтра ў] LT',
            lastDay: '[Учора ў] LT',
            nextWeek: function () {
                return '[У] dddd [ў] LT';
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return '[У мінулую] dddd [ў] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[У мінулы] dddd [ў] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'праз %s',
            past : '%s таму',
            s : 'некалькі секунд',
            m : relativeTimeWithPlural,
            mm : relativeTimeWithPlural,
            h : relativeTimeWithPlural,
            hh : relativeTimeWithPlural,
            d : 'дзень',
            dd : relativeTimeWithPlural,
            M : 'месяц',
            MM : relativeTimeWithPlural,
            y : 'год',
            yy : relativeTimeWithPlural
        },
        meridiemParse: /ночы|раніцы|дня|вечара/,
        isPM : function (input) {
            return /^(дня|вечара)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночы';
            } else if (hour < 12) {
                return 'раніцы';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечара';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
                case 'D':
                    return number + '-га';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return be;

})));


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var bg = moment.defineLocale('bg', {
        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'D.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY H:mm',
            LLLL : 'dddd, D MMMM YYYY H:mm'
        },
        calendar : {
            sameDay : '[Днес в] LT',
            nextDay : '[Утре в] LT',
            nextWeek : 'dddd [в] LT',
            lastDay : '[Вчера в] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[В изминалата] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[В изминалия] dddd [в] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'след %s',
            past : 'преди %s',
            s : 'няколко секунди',
            ss : '%d секунди',
            m : 'минута',
            mm : '%d минути',
            h : 'час',
            hh : '%d часа',
            d : 'ден',
            dd : '%d дни',
            M : 'месец',
            MM : '%d месеца',
            y : 'година',
            yy : '%d години'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal : function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return bg;

})));


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var bm = moment.defineLocale('bm', {
        months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
        monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
        weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
        weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
        weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'MMMM [tile] D [san] YYYY',
            LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
            LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
        },
        calendar : {
            sameDay : '[Bi lɛrɛ] LT',
            nextDay : '[Sini lɛrɛ] LT',
            nextWeek : 'dddd [don lɛrɛ] LT',
            lastDay : '[Kunu lɛrɛ] LT',
            lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s kɔnɔ',
            past : 'a bɛ %s bɔ',
            s : 'sanga dama dama',
            ss : 'sekondi %d',
            m : 'miniti kelen',
            mm : 'miniti %d',
            h : 'lɛrɛ kelen',
            hh : 'lɛrɛ %d',
            d : 'tile kelen',
            dd : 'tile %d',
            M : 'kalo kelen',
            MM : 'kalo %d',
            y : 'san kelen',
            yy : 'san %d'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return bm;

})));


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '১',
        '2': '২',
        '3': '৩',
        '4': '৪',
        '5': '৫',
        '6': '৬',
        '7': '৭',
        '8': '৮',
        '9': '৯',
        '0': '০'
    },
    numberMap = {
        '১': '1',
        '২': '2',
        '৩': '3',
        '৪': '4',
        '৫': '5',
        '৬': '6',
        '৭': '7',
        '৮': '8',
        '৯': '9',
        '০': '0'
    };

    var bn = moment.defineLocale('bn', {
        months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
        monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
        longDateFormat : {
            LT : 'A h:mm সময়',
            LTS : 'A h:mm:ss সময়',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm সময়',
            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
        },
        calendar : {
            sameDay : '[আজ] LT',
            nextDay : '[আগামীকাল] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[গতকাল] LT',
            lastWeek : '[গত] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s পরে',
            past : '%s আগে',
            s : 'কয়েক সেকেন্ড',
            ss : '%d সেকেন্ড',
            m : 'এক মিনিট',
            mm : '%d মিনিট',
            h : 'এক ঘন্টা',
            hh : '%d ঘন্টা',
            d : 'এক দিন',
            dd : '%d দিন',
            M : 'এক মাস',
            MM : '%d মাস',
            y : 'এক বছর',
            yy : '%d বছর'
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if ((meridiem === 'রাত' && hour >= 4) ||
                    (meridiem === 'দুপুর' && hour < 5) ||
                    meridiem === 'বিকাল') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 10) {
                return 'সকাল';
            } else if (hour < 17) {
                return 'দুপুর';
            } else if (hour < 20) {
                return 'বিকাল';
            } else {
                return 'রাত';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return bn;

})));


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '༡',
        '2': '༢',
        '3': '༣',
        '4': '༤',
        '5': '༥',
        '6': '༦',
        '7': '༧',
        '8': '༨',
        '9': '༩',
        '0': '༠'
    },
    numberMap = {
        '༡': '1',
        '༢': '2',
        '༣': '3',
        '༤': '4',
        '༥': '5',
        '༦': '6',
        '༧': '7',
        '༨': '8',
        '༩': '9',
        '༠': '0'
    };

    var bo = moment.defineLocale('bo', {
        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm',
            LLLL : 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar : {
            sameDay : '[དི་རིང] LT',
            nextDay : '[སང་ཉིན] LT',
            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
            lastDay : '[ཁ་སང] LT',
            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ལ་',
            past : '%s སྔན་ལ',
            s : 'ལམ་སང',
            ss : '%d སྐར་ཆ།',
            m : 'སྐར་མ་གཅིག',
            mm : '%d སྐར་མ',
            h : 'ཆུ་ཚོད་གཅིག',
            hh : '%d ཆུ་ཚོད',
            d : 'ཉིན་གཅིག',
            dd : '%d ཉིན་',
            M : 'ཟླ་བ་གཅིག',
            MM : '%d ཟླ་བ',
            y : 'ལོ་གཅིག',
            yy : '%d ལོ'
        },
        preparse: function (string) {
            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
                    (meridiem === 'ཉིན་གུང' && hour < 5) ||
                    meridiem === 'དགོང་དག') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'མཚན་མོ';
            } else if (hour < 10) {
                return 'ཞོགས་ཀས';
            } else if (hour < 17) {
                return 'ཉིན་གུང';
            } else if (hour < 20) {
                return 'དགོང་དག';
            } else {
                return 'མཚན་མོ';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return bo;

})));


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function relativeTimeWithMutation(number, withoutSuffix, key) {
        var format = {
            'mm': 'munutenn',
            'MM': 'miz',
            'dd': 'devezh'
        };
        return number + ' ' + mutation(format[key], number);
    }
    function specialMutationForYears(number) {
        switch (lastNumber(number)) {
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
                return number + ' bloaz';
            default:
                return number + ' vloaz';
        }
    }
    function lastNumber(number) {
        if (number > 9) {
            return lastNumber(number % 10);
        }
        return number;
    }
    function mutation(text, number) {
        if (number === 2) {
            return softMutation(text);
        }
        return text;
    }
    function softMutation(text) {
        var mutationTable = {
            'm': 'v',
            'b': 'v',
            'd': 'z'
        };
        if (mutationTable[text.charAt(0)] === undefined) {
            return text;
        }
        return mutationTable[text.charAt(0)] + text.substring(1);
    }

    var br = moment.defineLocale('br', {
        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h[e]mm A',
            LTS : 'h[e]mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D [a viz] MMMM YYYY',
            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
        },
        calendar : {
            sameDay : '[Hiziv da] LT',
            nextDay : '[Warc\'hoazh da] LT',
            nextWeek : 'dddd [da] LT',
            lastDay : '[Dec\'h da] LT',
            lastWeek : 'dddd [paset da] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'a-benn %s',
            past : '%s \'zo',
            s : 'un nebeud segondennoù',
            ss : '%d eilenn',
            m : 'ur vunutenn',
            mm : relativeTimeWithMutation,
            h : 'un eur',
            hh : '%d eur',
            d : 'un devezh',
            dd : relativeTimeWithMutation,
            M : 'ur miz',
            MM : relativeTimeWithMutation,
            y : 'ur bloaz',
            yy : specialMutationForYears
        },
        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
        ordinal : function (number) {
            var output = (number === 1) ? 'añ' : 'vet';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return br;

})));


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var bs = moment.defineLocale('bs', {
        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[danas u] LT',
            nextDay  : '[sutra u] LT',
            nextWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[jučer u] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'prije %s',
            s      : 'par sekundi',
            ss     : translate,
            m      : translate,
            mm     : translate,
            h      : translate,
            hh     : translate,
            d      : 'dan',
            dd     : translate,
            M      : 'mjesec',
            MM     : translate,
            y      : 'godinu',
            yy     : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return bs;

})));


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ca = moment.defineLocale('ca', {
        months : {
            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
            format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
            isFormat: /D[oD]?(\s)+MMMM/
        },
        monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
        monthsParseExact : true,
        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
        weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM [de] YYYY',
            ll : 'D MMM YYYY',
            LLL : 'D MMMM [de] YYYY [a les] H:mm',
            lll : 'D MMM YYYY, H:mm',
            LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
            llll : 'ddd D MMM YYYY, H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            nextDay : function () {
                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            lastDay : function () {
                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'd\'aquí %s',
            past : 'fa %s',
            s : 'uns segons',
            ss : '%d segons',
            m : 'un minut',
            mm : '%d minuts',
            h : 'una hora',
            hh : '%d hores',
            d : 'un dia',
            dd : '%d dies',
            M : 'un mes',
            MM : '%d mesos',
            y : 'un any',
            yy : '%d anys'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal : function (number, period) {
            var output = (number === 1) ? 'r' :
                (number === 2) ? 'n' :
                (number === 3) ? 'r' :
                (number === 4) ? 't' : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ca;

})));


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
    function plural(n) {
        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':  // a few seconds / in a few seconds / a few seconds ago
                return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekund');
                } else {
                    return result + 'sekundami';
                }
                break;
            case 'm':  // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minuty' : 'minut');
                } else {
                    return result + 'minutami';
                }
                break;
            case 'h':  // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodin');
                } else {
                    return result + 'hodinami';
                }
                break;
            case 'd':  // a day / in a day / a day ago
                return (withoutSuffix || isFuture) ? 'den' : 'dnem';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dny' : 'dní');
                } else {
                    return result + 'dny';
                }
                break;
            case 'M':  // a month / in a month / a month ago
                return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'měsíce' : 'měsíců');
                } else {
                    return result + 'měsíci';
                }
                break;
            case 'y':  // a year / in a year / a year ago
                return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'let');
                } else {
                    return result + 'lety';
                }
                break;
        }
    }

    var cs = moment.defineLocale('cs', {
        months : months,
        monthsShort : monthsShort,
        monthsParse : (function (months, monthsShort) {
            var i, _monthsParse = [];
            for (i = 0; i < 12; i++) {
                // use custom parser to solve problem with July (červenec)
                _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
            }
            return _monthsParse;
        }(months, monthsShort)),
        shortMonthsParse : (function (monthsShort) {
            var i, _shortMonthsParse = [];
            for (i = 0; i < 12; i++) {
                _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
            }
            return _shortMonthsParse;
        }(monthsShort)),
        longMonthsParse : (function (months) {
            var i, _longMonthsParse = [];
            for (i = 0; i < 12; i++) {
                _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
            }
            return _longMonthsParse;
        }(months)),
        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
        longDateFormat : {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd D. MMMM YYYY H:mm',
            l : 'D. M. YYYY'
        },
        calendar : {
            sameDay: '[dnes v] LT',
            nextDay: '[zítra v] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v neděli v] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [v] LT';
                    case 3:
                        return '[ve středu v] LT';
                    case 4:
                        return '[ve čtvrtek v] LT';
                    case 5:
                        return '[v pátek v] LT';
                    case 6:
                        return '[v sobotu v] LT';
                }
            },
            lastDay: '[včera v] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulou neděli v] LT';
                    case 1:
                    case 2:
                        return '[minulé] dddd [v] LT';
                    case 3:
                        return '[minulou středu v] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [v] LT';
                    case 6:
                        return '[minulou sobotu v] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'za %s',
            past : 'před %s',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse : /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return cs;

})));


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var cv = moment.defineLocale('cv', {
        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
        },
        calendar : {
            sameDay: '[Паян] LT [сехетре]',
            nextDay: '[Ыран] LT [сехетре]',
            lastDay: '[Ӗнер] LT [сехетре]',
            nextWeek: '[Ҫитес] dddd LT [сехетре]',
            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
            sameElse: 'L'
        },
        relativeTime : {
            future : function (output) {
                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
                return output + affix;
            },
            past : '%s каялла',
            s : 'пӗр-ик ҫеккунт',
            ss : '%d ҫеккунт',
            m : 'пӗр минут',
            mm : '%d минут',
            h : 'пӗр сехет',
            hh : '%d сехет',
            d : 'пӗр кун',
            dd : '%d кун',
            M : 'пӗр уйӑх',
            MM : '%d уйӑх',
            y : 'пӗр ҫул',
            yy : '%d ҫул'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
        ordinal : '%d-мӗш',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return cv;

})));


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var cy = moment.defineLocale('cy', {
        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
        weekdaysParseExact : true,
        // time formats are the same as en-gb
        longDateFormat: {
            LT: 'HH:mm',
            LTS : 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Heddiw am] LT',
            nextDay: '[Yfory am] LT',
            nextWeek: 'dddd [am] LT',
            lastDay: '[Ddoe am] LT',
            lastWeek: 'dddd [diwethaf am] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'mewn %s',
            past: '%s yn ôl',
            s: 'ychydig eiliadau',
            ss: '%d eiliad',
            m: 'munud',
            mm: '%d munud',
            h: 'awr',
            hh: '%d awr',
            d: 'diwrnod',
            dd: '%d diwrnod',
            M: 'mis',
            MM: '%d mis',
            y: 'blwyddyn',
            yy: '%d flynedd'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
        ordinal: function (number) {
            var b = number,
                output = '',
                lookup = [
                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
                ];
            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                    output = 'fed'; // not 30ain, 70ain or 90ain
                } else {
                    output = 'ain';
                }
            } else if (b > 0) {
                output = lookup[b];
            }
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return cy;

})));


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var da = moment.defineLocale('da', {
        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
        },
        calendar : {
            sameDay : '[i dag kl.] LT',
            nextDay : '[i morgen kl.] LT',
            nextWeek : 'på dddd [kl.] LT',
            lastDay : '[i går kl.] LT',
            lastWeek : '[i] dddd[s kl.] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : '%s siden',
            s : 'få sekunder',
            ss : '%d sekunder',
            m : 'et minut',
            mm : '%d minutter',
            h : 'en time',
            hh : '%d timer',
            d : 'en dag',
            dd : '%d dage',
            M : 'en måned',
            MM : '%d måneder',
            y : 'et år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return da;

})));


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            ss : '%d Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return de;

})));


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deAt = moment.defineLocale('de-at', {
        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            ss : '%d Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return deAt;

})));


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deCh = moment.defineLocale('de-ch', {
        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            ss : '%d Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return deCh;

})));


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = [
        'ޖެނުއަރީ',
        'ފެބްރުއަރީ',
        'މާރިޗު',
        'އޭޕްރީލު',
        'މޭ',
        'ޖޫން',
        'ޖުލައި',
        'އޯގަސްޓު',
        'ސެޕްޓެމްބަރު',
        'އޮކްޓޯބަރު',
        'ނޮވެމްބަރު',
        'ޑިސެމްބަރު'
    ], weekdays = [
        'އާދިއްތަ',
        'ހޯމަ',
        'އަންގާރަ',
        'ބުދަ',
        'ބުރާސްފަތި',
        'ހުކުރު',
        'ހޮނިހިރު'
    ];

    var dv = moment.defineLocale('dv', {
        months : months,
        monthsShort : months,
        weekdays : weekdays,
        weekdaysShort : weekdays,
        weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
        longDateFormat : {

            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'D/M/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /މކ|މފ/,
        isPM : function (input) {
            return 'މފ' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'މކ';
            } else {
                return 'މފ';
            }
        },
        calendar : {
            sameDay : '[މިއަދު] LT',
            nextDay : '[މާދަމާ] LT',
            nextWeek : 'dddd LT',
            lastDay : '[އިއްޔެ] LT',
            lastWeek : '[ފާއިތުވި] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ތެރޭގައި %s',
            past : 'ކުރިން %s',
            s : 'ސިކުންތުކޮޅެއް',
            ss : 'd% ސިކުންތު',
            m : 'މިނިޓެއް',
            mm : 'މިނިޓު %d',
            h : 'ގަޑިއިރެއް',
            hh : 'ގަޑިއިރު %d',
            d : 'ދުވަހެއް',
            dd : 'ދުވަސް %d',
            M : 'މަހެއް',
            MM : 'މަސް %d',
            y : 'އަހަރެއް',
            yy : 'އަހަރު %d'
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week : {
            dow : 7,  // Sunday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return dv;

})));


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }


    var el = moment.defineLocale('el', {
        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
        months : function (momentToFormat, format) {
            if (!momentToFormat) {
                return this._monthsNominativeEl;
            } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
                return this._monthsGenitiveEl[momentToFormat.month()];
            } else {
                return this._monthsNominativeEl[momentToFormat.month()];
            }
        },
        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'μμ' : 'ΜΜ';
            } else {
                return isLower ? 'πμ' : 'ΠΜ';
            }
        },
        isPM : function (input) {
            return ((input + '').toLowerCase()[0] === 'μ');
        },
        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendarEl : {
            sameDay : '[Σήμερα {}] LT',
            nextDay : '[Αύριο {}] LT',
            nextWeek : 'dddd [{}] LT',
            lastDay : '[Χθες {}] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 6:
                        return '[το προηγούμενο] dddd [{}] LT';
                    default:
                        return '[την προηγούμενη] dddd [{}] LT';
                }
            },
            sameElse : 'L'
        },
        calendar : function (key, mom) {
            var output = this._calendarEl[key],
                hours = mom && mom.hours();
            if (isFunction(output)) {
                output = output.apply(mom);
            }
            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
        },
        relativeTime : {
            future : 'σε %s',
            past : '%s πριν',
            s : 'λίγα δευτερόλεπτα',
            ss : '%d δευτερόλεπτα',
            m : 'ένα λεπτό',
            mm : '%d λεπτά',
            h : 'μία ώρα',
            hh : '%d ώρες',
            d : 'μία μέρα',
            dd : '%d μέρες',
            M : 'ένας μήνας',
            MM : '%d μήνες',
            y : 'ένας χρόνος',
            yy : '%d χρόνια'
        },
        dayOfMonthOrdinalParse: /\d{1,2}η/,
        ordinal: '%dη',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4st is the first week of the year.
        }
    });

    return el;

})));


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enAu = moment.defineLocale('en-au', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enAu;

})));


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enCa = moment.defineLocale('en-ca', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'YYYY-MM-DD',
            LL : 'MMMM D, YYYY',
            LLL : 'MMMM D, YYYY h:mm A',
            LLLL : 'dddd, MMMM D, YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    return enCa;

})));


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enGb = moment.defineLocale('en-gb', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enGb;

})));


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enIe = moment.defineLocale('en-ie', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enIe;

})));


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enIl = moment.defineLocale('en-il', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    return enIl;

})));


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enNz = moment.defineLocale('en-nz', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enNz;

})));


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var eo = moment.defineLocale('eo', {
        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
        weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
        weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
        weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'D[-a de] MMMM, YYYY',
            LLL : 'D[-a de] MMMM, YYYY HH:mm',
            LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function (input) {
            return input.charAt(0).toLowerCase() === 'p';
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'p.t.m.' : 'P.T.M.';
            } else {
                return isLower ? 'a.t.m.' : 'A.T.M.';
            }
        },
        calendar : {
            sameDay : '[Hodiaŭ je] LT',
            nextDay : '[Morgaŭ je] LT',
            nextWeek : 'dddd [je] LT',
            lastDay : '[Hieraŭ je] LT',
            lastWeek : '[pasinta] dddd [je] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'post %s',
            past : 'antaŭ %s',
            s : 'sekundoj',
            ss : '%d sekundoj',
            m : 'minuto',
            mm : '%d minutoj',
            h : 'horo',
            hh : '%d horoj',
            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
            dd : '%d tagoj',
            M : 'monato',
            MM : '%d monatoj',
            y : 'jaro',
            yy : '%d jaroj'
        },
        dayOfMonthOrdinalParse: /\d{1,2}a/,
        ordinal : '%da',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return eo;

})));


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex : monthsRegex,
        monthsShortRegex : monthsRegex,
        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY H:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return es;

})));


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esDo = moment.defineLocale('es-do', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY h:mm A',
            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return esDo;

})));


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var esUs = moment.defineLocale('es-us', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsParseExact : true,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'MM/DD/YYYY',
            LL : 'MMMM [de] D [de] YYYY',
            LLL : 'MMMM [de] D [de] YYYY h:mm A',
            LLLL : 'dddd, MMMM [de] D [de] YYYY h:mm A'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return esUs;

})));


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
            'ss': [number + 'sekundi', number + 'sekundit'],
            'm' : ['ühe minuti', 'üks minut'],
            'mm': [number + ' minuti', number + ' minutit'],
            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
            'hh': [number + ' tunni', number + ' tundi'],
            'd' : ['ühe päeva', 'üks päev'],
            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
            'MM': [number + ' kuu', number + ' kuud'],
            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
            'yy': [number + ' aasta', number + ' aastat']
        };
        if (withoutSuffix) {
            return format[key][2] ? format[key][2] : format[key][1];
        }
        return isFuture ? format[key][0] : format[key][1];
    }

    var et = moment.defineLocale('et', {
        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
        longDateFormat : {
            LT   : 'H:mm',
            LTS : 'H:mm:ss',
            L    : 'DD.MM.YYYY',
            LL   : 'D. MMMM YYYY',
            LLL  : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[Täna,] LT',
            nextDay  : '[Homme,] LT',
            nextWeek : '[Järgmine] dddd LT',
            lastDay  : '[Eile,] LT',
            lastWeek : '[Eelmine] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s pärast',
            past   : '%s tagasi',
            s      : processRelativeTime,
            ss     : processRelativeTime,
            m      : processRelativeTime,
            mm     : processRelativeTime,
            h      : processRelativeTime,
            hh     : processRelativeTime,
            d      : processRelativeTime,
            dd     : '%d päeva',
            M      : processRelativeTime,
            MM     : processRelativeTime,
            y      : processRelativeTime,
            yy     : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return et;

})));


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var eu = moment.defineLocale('eu', {
        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
        monthsParseExact : true,
        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'YYYY[ko] MMMM[ren] D[a]',
            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
            l : 'YYYY-M-D',
            ll : 'YYYY[ko] MMM D[a]',
            lll : 'YYYY[ko] MMM D[a] HH:mm',
            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
        },
        calendar : {
            sameDay : '[gaur] LT[etan]',
            nextDay : '[bihar] LT[etan]',
            nextWeek : 'dddd LT[etan]',
            lastDay : '[atzo] LT[etan]',
            lastWeek : '[aurreko] dddd LT[etan]',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s barru',
            past : 'duela %s',
            s : 'segundo batzuk',
            ss : '%d segundo',
            m : 'minutu bat',
            mm : '%d minutu',
            h : 'ordu bat',
            hh : '%d ordu',
            d : 'egun bat',
            dd : '%d egun',
            M : 'hilabete bat',
            MM : '%d hilabete',
            y : 'urte bat',
            yy : '%d urte'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return eu;

})));


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '۱',
        '2': '۲',
        '3': '۳',
        '4': '۴',
        '5': '۵',
        '6': '۶',
        '7': '۷',
        '8': '۸',
        '9': '۹',
        '0': '۰'
    }, numberMap = {
        '۱': '1',
        '۲': '2',
        '۳': '3',
        '۴': '4',
        '۵': '5',
        '۶': '6',
        '۷': '7',
        '۸': '8',
        '۹': '9',
        '۰': '0'
    };

    var fa = moment.defineLocale('fa', {
        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        meridiemParse: /قبل از ظهر|بعد از ظهر/,
        isPM: function (input) {
            return /بعد از ظهر/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'قبل از ظهر';
            } else {
                return 'بعد از ظهر';
            }
        },
        calendar : {
            sameDay : '[امروز ساعت] LT',
            nextDay : '[فردا ساعت] LT',
            nextWeek : 'dddd [ساعت] LT',
            lastDay : '[دیروز ساعت] LT',
            lastWeek : 'dddd [پیش] [ساعت] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'در %s',
            past : '%s پیش',
            s : 'چند ثانیه',
            ss : 'ثانیه d%',
            m : 'یک دقیقه',
            mm : '%d دقیقه',
            h : 'یک ساعت',
            hh : '%d ساعت',
            d : 'یک روز',
            dd : '%d روز',
            M : 'یک ماه',
            MM : '%d ماه',
            y : 'یک سال',
            yy : '%d سال'
        },
        preparse: function (string) {
            return string.replace(/[۰-۹]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        dayOfMonthOrdinalParse: /\d{1,2}م/,
        ordinal : '%dم',
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12 // The week that contains Jan 12th is the first week of the year.
        }
    });

    return fa;

})));


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
        numbersFuture = [
            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
            numbersPast[7], numbersPast[8], numbersPast[9]
        ];
    function translate(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch (key) {
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'ss':
                return isFuture ? 'sekunnin' : 'sekuntia';
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? 'päivän' : 'päivä';
            case 'dd':
                result = isFuture ? 'päivän' : 'päivää';
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
    }

    var fi = moment.defineLocale('fi', {
        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD.MM.YYYY',
            LL : 'Do MMMM[ta] YYYY',
            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l : 'D.M.YYYY',
            ll : 'Do MMM YYYY',
            lll : 'Do MMM YYYY, [klo] HH.mm',
            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
        },
        calendar : {
            sameDay : '[tänään] [klo] LT',
            nextDay : '[huomenna] [klo] LT',
            nextWeek : 'dddd [klo] LT',
            lastDay : '[eilen] [klo] LT',
            lastWeek : '[viime] dddd[na] [klo] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s päästä',
            past : '%s sitten',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fi;

})));


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var fo = moment.defineLocale('fo', {
        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D. MMMM, YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Í dag kl.] LT',
            nextDay : '[Í morgin kl.] LT',
            nextWeek : 'dddd [kl.] LT',
            lastDay : '[Í gjár kl.] LT',
            lastWeek : '[síðstu] dddd [kl] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'um %s',
            past : '%s síðani',
            s : 'fá sekund',
            ss : '%d sekundir',
            m : 'ein minutt',
            mm : '%d minuttir',
            h : 'ein tími',
            hh : '%d tímar',
            d : 'ein dagur',
            dd : '%d dagar',
            M : 'ein mánaði',
            MM : '%d mánaðir',
            y : 'eitt ár',
            yy : '%d ár'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fo;

})));


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var fr = moment.defineLocale('fr', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal : function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fr;

})));


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var frCa = moment.defineLocale('fr-ca', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal : function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        }
    });

    return frCa;

})));


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var frCh = moment.defineLocale('fr-ch', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal : function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return frCh;

})));


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

    var fy = moment.defineLocale('fy', {
        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },
        monthsParseExact : true,
        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[hjoed om] LT',
            nextDay: '[moarn om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[juster om] LT',
            lastWeek: '[ôfrûne] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'oer %s',
            past : '%s lyn',
            s : 'in pear sekonden',
            ss : '%d sekonden',
            m : 'ien minút',
            mm : '%d minuten',
            h : 'ien oere',
            hh : '%d oeren',
            d : 'ien dei',
            dd : '%d dagen',
            M : 'ien moanne',
            MM : '%d moannen',
            y : 'ien jier',
            yy : '%d jierren'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fy;

})));


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = [
        'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
    ];

    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];

    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];

    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];

    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

    var gd = moment.defineLocale('gd', {
        months : months,
        monthsShort : monthsShort,
        monthsParseExact : true,
        weekdays : weekdays,
        weekdaysShort : weekdaysShort,
        weekdaysMin : weekdaysMin,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[An-diugh aig] LT',
            nextDay : '[A-màireach aig] LT',
            nextWeek : 'dddd [aig] LT',
            lastDay : '[An-dè aig] LT',
            lastWeek : 'dddd [seo chaidh] [aig] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ann an %s',
            past : 'bho chionn %s',
            s : 'beagan diogan',
            ss : '%d diogan',
            m : 'mionaid',
            mm : '%d mionaidean',
            h : 'uair',
            hh : '%d uairean',
            d : 'latha',
            dd : '%d latha',
            M : 'mìos',
            MM : '%d mìosan',
            y : 'bliadhna',
            yy : '%d bliadhna'
        },
        dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
        ordinal : function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return gd;

})));


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var gl = moment.defineLocale('gl', {
        months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
        monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY H:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
            },
            nextDay : function () {
                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
            },
            lastDay : function () {
                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
            },
            lastWeek : function () {
                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : function (str) {
                if (str.indexOf('un') === 0) {
                    return 'n' + str;
                }
                return 'en ' + str;
            },
            past : 'hai %s',
            s : 'uns segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'unha hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un ano',
            yy : '%d anos'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return gl;

})));


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            's': ['thodde secondanim', 'thodde second'],
            'ss': [number + ' secondanim', number + ' second'],
            'm': ['eka mintan', 'ek minute'],
            'mm': [number + ' mintanim', number + ' mintam'],
            'h': ['eka horan', 'ek hor'],
            'hh': [number + ' horanim', number + ' horam'],
            'd': ['eka disan', 'ek dis'],
            'dd': [number + ' disanim', number + ' dis'],
            'M': ['eka mhoinean', 'ek mhoino'],
            'MM': [number + ' mhoineanim', number + ' mhoine'],
            'y': ['eka vorsan', 'ek voros'],
            'yy': [number + ' vorsanim', number + ' vorsam']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var gomLatn = moment.defineLocale('gom-latn', {
        months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
        monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
        weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
        weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'A h:mm [vazta]',
            LTS : 'A h:mm:ss [vazta]',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY A h:mm [vazta]',
            LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
            llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
        },
        calendar : {
            sameDay: '[Aiz] LT',
            nextDay: '[Faleam] LT',
            nextWeek: '[Ieta to] dddd[,] LT',
            lastDay: '[Kal] LT',
            lastWeek: '[Fatlo] dddd[,] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s',
            past : '%s adim',
            s : processRelativeTime,
            ss : processRelativeTime,
            m : processRelativeTime,
            mm : processRelativeTime,
            h : processRelativeTime,
            hh : processRelativeTime,
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse : /\d{1,2}(er)/,
        ordinal : function (number, period) {
            switch (period) {
                // the ordinal 'er' only applies to day of the month
                case 'D':
                    return number + 'er';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        },
        meridiemParse: /rati|sokalli|donparam|sanje/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'rati') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'sokalli') {
                return hour;
            } else if (meridiem === 'donparam') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'sanje') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'rati';
            } else if (hour < 12) {
                return 'sokalli';
            } else if (hour < 16) {
                return 'donparam';
            } else if (hour < 20) {
                return 'sanje';
            } else {
                return 'rati';
            }
        }
    });

    return gomLatn;

})));


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
            '1': '૧',
            '2': '૨',
            '3': '૩',
            '4': '૪',
            '5': '૫',
            '6': '૬',
            '7': '૭',
            '8': '૮',
            '9': '૯',
            '0': '૦'
        },
        numberMap = {
            '૧': '1',
            '૨': '2',
            '૩': '3',
            '૪': '4',
            '૫': '5',
            '૬': '6',
            '૭': '7',
            '૮': '8',
            '૯': '9',
            '૦': '0'
        };

    var gu = moment.defineLocale('gu', {
        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
        monthsParseExact: true,
        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm વાગ્યે',
            LTS: 'A h:mm:ss વાગ્યે',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
        },
        calendar: {
            sameDay: '[આજ] LT',
            nextDay: '[કાલે] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ગઇકાલે] LT',
            lastWeek: '[પાછલા] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s મા',
            past: '%s પેહલા',
            s: 'અમુક પળો',
            ss: '%d સેકંડ',
            m: 'એક મિનિટ',
            mm: '%d મિનિટ',
            h: 'એક કલાક',
            hh: '%d કલાક',
            d: 'એક દિવસ',
            dd: '%d દિવસ',
            M: 'એક મહિનો',
            MM: '%d મહિનો',
            y: 'એક વર્ષ',
            yy: '%d વર્ષ'
        },
        preparse: function (string) {
            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'રાત') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'સવાર') {
                return hour;
            } else if (meridiem === 'બપોર') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'સાંજ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'રાત';
            } else if (hour < 10) {
                return 'સવાર';
            } else if (hour < 17) {
                return 'બપોર';
            } else if (hour < 20) {
                return 'સાંજ';
            } else {
                return 'રાત';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.
        }
    });

    return gu;

})));


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var he = moment.defineLocale('he', {
        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [ב]MMMM YYYY',
            LLL : 'D [ב]MMMM YYYY HH:mm',
            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
            l : 'D/M/YYYY',
            ll : 'D MMM YYYY',
            lll : 'D MMM YYYY HH:mm',
            llll : 'ddd, D MMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[היום ב־]LT',
            nextDay : '[מחר ב־]LT',
            nextWeek : 'dddd [בשעה] LT',
            lastDay : '[אתמול ב־]LT',
            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'בעוד %s',
            past : 'לפני %s',
            s : 'מספר שניות',
            ss : '%d שניות',
            m : 'דקה',
            mm : '%d דקות',
            h : 'שעה',
            hh : function (number) {
                if (number === 2) {
                    return 'שעתיים';
                }
                return number + ' שעות';
            },
            d : 'יום',
            dd : function (number) {
                if (number === 2) {
                    return 'יומיים';
                }
                return number + ' ימים';
            },
            M : 'חודש',
            MM : function (number) {
                if (number === 2) {
                    return 'חודשיים';
                }
                return number + ' חודשים';
            },
            y : 'שנה',
            yy : function (number) {
                if (number === 2) {
                    return 'שנתיים';
                } else if (number % 10 === 0 && number !== 10) {
                    return number + ' שנה';
                }
                return number + ' שנים';
            }
        },
        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
        isPM : function (input) {
            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 5) {
                return 'לפנות בוקר';
            } else if (hour < 10) {
                return 'בבוקר';
            } else if (hour < 12) {
                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
            } else if (hour < 18) {
                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
            } else {
                return 'בערב';
            }
        }
    });

    return he;

})));


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    },
    numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    var hi = moment.defineLocale('hi', {
        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
        monthsParseExact: true,
        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat : {
            LT : 'A h:mm बजे',
            LTS : 'A h:mm:ss बजे',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm बजे',
            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
        },
        calendar : {
            sameDay : '[आज] LT',
            nextDay : '[कल] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[कल] LT',
            lastWeek : '[पिछले] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s में',
            past : '%s पहले',
            s : 'कुछ ही क्षण',
            ss : '%d सेकंड',
            m : 'एक मिनट',
            mm : '%d मिनट',
            h : 'एक घंटा',
            hh : '%d घंटे',
            d : 'एक दिन',
            dd : '%d दिन',
            M : 'एक महीने',
            MM : '%d महीने',
            y : 'एक वर्ष',
            yy : '%d वर्ष'
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
        meridiemParse: /रात|सुबह|दोपहर|शाम/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सुबह') {
                return hour;
            } else if (meridiem === 'दोपहर') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'शाम') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात';
            } else if (hour < 10) {
                return 'सुबह';
            } else if (hour < 17) {
                return 'दोपहर';
            } else if (hour < 20) {
                return 'शाम';
            } else {
                return 'रात';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return hi;

})));


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var hr = moment.defineLocale('hr', {
        months : {
            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
        },
        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
        monthsParseExact: true,
        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[danas u] LT',
            nextDay  : '[sutra u] LT',
            nextWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[jučer u] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'prije %s',
            s      : 'par sekundi',
            ss     : translate,
            m      : translate,
            mm     : translate,
            h      : translate,
            hh     : translate,
            d      : 'dan',
            dd     : translate,
            M      : 'mjesec',
            MM     : translate,
            y      : 'godinu',
            yy     : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return hr;

})));


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
    function translate(number, withoutSuffix, key, isFuture) {
        var num = number;
        switch (key) {
            case 's':
                return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
            case 'ss':
                return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
            case 'm':
                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'mm':
                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'h':
                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'hh':
                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'd':
                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'dd':
                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'M':
                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'MM':
                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'y':
                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
            case 'yy':
                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
        }
        return '';
    }
    function week(isFuture) {
        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
    }

    var hu = moment.defineLocale('hu', {
        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'YYYY.MM.DD.',
            LL : 'YYYY. MMMM D.',
            LLL : 'YYYY. MMMM D. H:mm',
            LLLL : 'YYYY. MMMM D., dddd H:mm'
        },
        meridiemParse: /de|du/i,
        isPM: function (input) {
            return input.charAt(1).toLowerCase() === 'u';
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower === true ? 'de' : 'DE';
            } else {
                return isLower === true ? 'du' : 'DU';
            }
        },
        calendar : {
            sameDay : '[ma] LT[-kor]',
            nextDay : '[holnap] LT[-kor]',
            nextWeek : function () {
                return week.call(this, true);
            },
            lastDay : '[tegnap] LT[-kor]',
            lastWeek : function () {
                return week.call(this, false);
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s múlva',
            past : '%s',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return hu;

})));


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var hyAm = moment.defineLocale('hy-am', {
        months : {
            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
        },
        monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
        weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY թ.',
            LLL : 'D MMMM YYYY թ., HH:mm',
            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
        },
        calendar : {
            sameDay: '[այսօր] LT',
            nextDay: '[վաղը] LT',
            lastDay: '[երեկ] LT',
            nextWeek: function () {
                return 'dddd [օրը ժամը] LT';
            },
            lastWeek: function () {
                return '[անցած] dddd [օրը ժամը] LT';
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s հետո',
            past : '%s առաջ',
            s : 'մի քանի վայրկյան',
            ss : '%d վայրկյան',
            m : 'րոպե',
            mm : '%d րոպե',
            h : 'ժամ',
            hh : '%d ժամ',
            d : 'օր',
            dd : '%d օր',
            M : 'ամիս',
            MM : '%d ամիս',
            y : 'տարի',
            yy : '%d տարի'
        },
        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
        isPM: function (input) {
            return /^(ցերեկվա|երեկոյան)$/.test(input);
        },
        meridiem : function (hour) {
            if (hour < 4) {
                return 'գիշերվա';
            } else if (hour < 12) {
                return 'առավոտվա';
            } else if (hour < 17) {
                return 'ցերեկվա';
            } else {
                return 'երեկոյան';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'DDD':
                case 'w':
                case 'W':
                case 'DDDo':
                    if (number === 1) {
                        return number + '-ին';
                    }
                    return number + '-րդ';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return hyAm;

})));


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var id = moment.defineLocale('id', {
        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'siang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sore' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'siang';
            } else if (hours < 19) {
                return 'sore';
            } else {
                return 'malam';
            }
        },
        calendar : {
            sameDay : '[Hari ini pukul] LT',
            nextDay : '[Besok pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kemarin pukul] LT',
            lastWeek : 'dddd [lalu pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dalam %s',
            past : '%s yang lalu',
            s : 'beberapa detik',
            ss : '%d detik',
            m : 'semenit',
            mm : '%d menit',
            h : 'sejam',
            hh : '%d jam',
            d : 'sehari',
            dd : '%d hari',
            M : 'sebulan',
            MM : '%d bulan',
            y : 'setahun',
            yy : '%d tahun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return id;

})));


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(n) {
        if (n % 100 === 11) {
            return true;
        } else if (n % 10 === 1) {
            return false;
        }
        return true;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
            case 'ss':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
                }
                return result + 'sekúnda';
            case 'm':
                return withoutSuffix ? 'mínúta' : 'mínútu';
            case 'mm':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
                } else if (withoutSuffix) {
                    return result + 'mínúta';
                }
                return result + 'mínútu';
            case 'hh':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
                }
                return result + 'klukkustund';
            case 'd':
                if (withoutSuffix) {
                    return 'dagur';
                }
                return isFuture ? 'dag' : 'degi';
            case 'dd':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'dagar';
                    }
                    return result + (isFuture ? 'daga' : 'dögum');
                } else if (withoutSuffix) {
                    return result + 'dagur';
                }
                return result + (isFuture ? 'dag' : 'degi');
            case 'M':
                if (withoutSuffix) {
                    return 'mánuður';
                }
                return isFuture ? 'mánuð' : 'mánuði';
            case 'MM':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'mánuðir';
                    }
                    return result + (isFuture ? 'mánuði' : 'mánuðum');
                } else if (withoutSuffix) {
                    return result + 'mánuður';
                }
                return result + (isFuture ? 'mánuð' : 'mánuði');
            case 'y':
                return withoutSuffix || isFuture ? 'ár' : 'ári';
            case 'yy':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
                }
                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
        }
    }

    var is = moment.defineLocale('is', {
        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY [kl.] H:mm',
            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
        },
        calendar : {
            sameDay : '[í dag kl.] LT',
            nextDay : '[á morgun kl.] LT',
            nextWeek : 'dddd [kl.] LT',
            lastDay : '[í gær kl.] LT',
            lastWeek : '[síðasta] dddd [kl.] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'eftir %s',
            past : 'fyrir %s síðan',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : 'klukkustund',
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return is;

})));


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var it = moment.defineLocale('it', {
        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : function (s) {
                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past : '%s fa',
            s : 'alcuni secondi',
            ss : '%d secondi',
            m : 'un minuto',
            mm : '%d minuti',
            h : 'un\'ora',
            hh : '%d ore',
            d : 'un giorno',
            dd : '%d giorni',
            M : 'un mese',
            MM : '%d mesi',
            y : 'un anno',
            yy : '%d anni'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return it;

})));


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ja = moment.defineLocale('ja', {
        months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日 HH:mm',
            LLLL : 'YYYY年M月D日 dddd HH:mm',
            l : 'YYYY/MM/DD',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日(ddd) HH:mm'
        },
        meridiemParse: /午前|午後/i,
        isPM : function (input) {
            return input === '午後';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return '午前';
            } else {
                return '午後';
            }
        },
        calendar : {
            sameDay : '[今日] LT',
            nextDay : '[明日] LT',
            nextWeek : function (now) {
                if (now.week() < this.week()) {
                    return '[来週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            lastDay : '[昨日] LT',
            lastWeek : function (now) {
                if (this.week() < now.week()) {
                    return '[先週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse : /\d{1,2}日/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                default:
                    return number;
            }
        },
        relativeTime : {
            future : '%s後',
            past : '%s前',
            s : '数秒',
            ss : '%d秒',
            m : '1分',
            mm : '%d分',
            h : '1時間',
            hh : '%d時間',
            d : '1日',
            dd : '%d日',
            M : '1ヶ月',
            MM : '%dヶ月',
            y : '1年',
            yy : '%d年'
        }
    });

    return ja;

})));


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var jv = moment.defineLocale('jv', {
        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'enjing') {
                return hour;
            } else if (meridiem === 'siyang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'enjing';
            } else if (hours < 15) {
                return 'siyang';
            } else if (hours < 19) {
                return 'sonten';
            } else {
                return 'ndalu';
            }
        },
        calendar : {
            sameDay : '[Dinten puniko pukul] LT',
            nextDay : '[Mbenjang pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kala wingi pukul] LT',
            lastWeek : 'dddd [kepengker pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'wonten ing %s',
            past : '%s ingkang kepengker',
            s : 'sawetawis detik',
            ss : '%d detik',
            m : 'setunggal menit',
            mm : '%d menit',
            h : 'setunggal jam',
            hh : '%d jam',
            d : 'sedinten',
            dd : '%d dinten',
            M : 'sewulan',
            MM : '%d wulan',
            y : 'setaun',
            yy : '%d taun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return jv;

})));


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ka = moment.defineLocale('ka', {
        months : {
            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
        },
        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
        weekdays : {
            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
            isFormat: /(წინა|შემდეგ)/
        },
        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[დღეს] LT[-ზე]',
            nextDay : '[ხვალ] LT[-ზე]',
            lastDay : '[გუშინ] LT[-ზე]',
            nextWeek : '[შემდეგ] dddd LT[-ზე]',
            lastWeek : '[წინა] dddd LT-ზე',
            sameElse : 'L'
        },
        relativeTime : {
            future : function (s) {
                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
                    s.replace(/ი$/, 'ში') :
                    s + 'ში';
            },
            past : function (s) {
                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
                    return s.replace(/(ი|ე)$/, 'ის წინ');
                }
                if ((/წელი/).test(s)) {
                    return s.replace(/წელი$/, 'წლის წინ');
                }
            },
            s : 'რამდენიმე წამი',
            ss : '%d წამი',
            m : 'წუთი',
            mm : '%d წუთი',
            h : 'საათი',
            hh : '%d საათი',
            d : 'დღე',
            dd : '%d დღე',
            M : 'თვე',
            MM : '%d თვე',
            y : 'წელი',
            yy : '%d წელი'
        },
        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
        ordinal : function (number) {
            if (number === 0) {
                return number;
            }
            if (number === 1) {
                return number + '-ლი';
            }
            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
                return 'მე-' + number;
            }
            return number + '-ე';
        },
        week : {
            dow : 1,
            doy : 7
        }
    });

    return ka;

})));


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var suffixes = {
        0: '-ші',
        1: '-ші',
        2: '-ші',
        3: '-ші',
        4: '-ші',
        5: '-ші',
        6: '-шы',
        7: '-ші',
        8: '-ші',
        9: '-шы',
        10: '-шы',
        20: '-шы',
        30: '-шы',
        40: '-шы',
        50: '-ші',
        60: '-шы',
        70: '-ші',
        80: '-ші',
        90: '-шы',
        100: '-ші'
    };

    var kk = moment.defineLocale('kk', {
        months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
        monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
        weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
        weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
        weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Бүгін сағат] LT',
            nextDay : '[Ертең сағат] LT',
            nextWeek : 'dddd [сағат] LT',
            lastDay : '[Кеше сағат] LT',
            lastWeek : '[Өткен аптаның] dddd [сағат] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ішінде',
            past : '%s бұрын',
            s : 'бірнеше секунд',
            ss : '%d секунд',
            m : 'бір минут',
            mm : '%d минут',
            h : 'бір сағат',
            hh : '%d сағат',
            d : 'бір күн',
            dd : '%d күн',
            M : 'бір ай',
            MM : '%d ай',
            y : 'бір жыл',
            yy : '%d жыл'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
        ordinal : function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return kk;

})));


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '១',
        '2': '២',
        '3': '៣',
        '4': '៤',
        '5': '៥',
        '6': '៦',
        '7': '៧',
        '8': '៨',
        '9': '៩',
        '0': '០'
    }, numberMap = {
        '១': '1',
        '២': '2',
        '៣': '3',
        '៤': '4',
        '៥': '5',
        '៦': '6',
        '៧': '7',
        '៨': '8',
        '៩': '9',
        '០': '0'
    };

    var km = moment.defineLocale('km', {
        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        meridiemParse: /ព្រឹក|ល្ងាច/,
        isPM: function (input) {
            return input === 'ល្ងាច';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ព្រឹក';
            } else {
                return 'ល្ងាច';
            }
        },
        calendar: {
            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
            nextDay: '[ស្អែក ម៉ោង] LT',
            nextWeek: 'dddd [ម៉ោង] LT',
            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%sទៀត',
            past: '%sមុន',
            s: 'ប៉ុន្មានវិនាទី',
            ss: '%d វិនាទី',
            m: 'មួយនាទី',
            mm: '%d នាទី',
            h: 'មួយម៉ោង',
            hh: '%d ម៉ោង',
            d: 'មួយថ្ងៃ',
            dd: '%d ថ្ងៃ',
            M: 'មួយខែ',
            MM: '%d ខែ',
            y: 'មួយឆ្នាំ',
            yy: '%d ឆ្នាំ'
        },
        dayOfMonthOrdinalParse : /ទី\d{1,2}/,
        ordinal : 'ទី%d',
        preparse: function (string) {
            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return km;

})));


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '೧',
        '2': '೨',
        '3': '೩',
        '4': '೪',
        '5': '೫',
        '6': '೬',
        '7': '೭',
        '8': '೮',
        '9': '೯',
        '0': '೦'
    },
    numberMap = {
        '೧': '1',
        '೨': '2',
        '೩': '3',
        '೪': '4',
        '೫': '5',
        '೬': '6',
        '೭': '7',
        '೮': '8',
        '೯': '9',
        '೦': '0'
    };

    var kn = moment.defineLocale('kn', {
        months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
        monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split('_'),
        monthsParseExact: true,
        weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
        weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
        weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm',
            LLLL : 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar : {
            sameDay : '[ಇಂದು] LT',
            nextDay : '[ನಾಳೆ] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[ನಿನ್ನೆ] LT',
            lastWeek : '[ಕೊನೆಯ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ನಂತರ',
            past : '%s ಹಿಂದೆ',
            s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
            ss : '%d ಸೆಕೆಂಡುಗಳು',
            m : 'ಒಂದು ನಿಮಿಷ',
            mm : '%d ನಿಮಿಷ',
            h : 'ಒಂದು ಗಂಟೆ',
            hh : '%d ಗಂಟೆ',
            d : 'ಒಂದು ದಿನ',
            dd : '%d ದಿನ',
            M : 'ಒಂದು ತಿಂಗಳು',
            MM : '%d ತಿಂಗಳು',
            y : 'ಒಂದು ವರ್ಷ',
            yy : '%d ವರ್ಷ'
        },
        preparse: function (string) {
            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ರಾತ್ರಿ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
                return hour;
            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ಸಂಜೆ') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ರಾತ್ರಿ';
            } else if (hour < 10) {
                return 'ಬೆಳಿಗ್ಗೆ';
            } else if (hour < 17) {
                return 'ಮಧ್ಯಾಹ್ನ';
            } else if (hour < 20) {
                return 'ಸಂಜೆ';
            } else {
                return 'ರಾತ್ರಿ';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
        ordinal : function (number) {
            return number + 'ನೇ';
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return kn;

})));


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ko = moment.defineLocale('ko', {
        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'YYYY.MM.DD.',
            LL : 'YYYY년 MMMM D일',
            LLL : 'YYYY년 MMMM D일 A h:mm',
            LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
            l : 'YYYY.MM.DD.',
            ll : 'YYYY년 MMMM D일',
            lll : 'YYYY년 MMMM D일 A h:mm',
            llll : 'YYYY년 MMMM D일 dddd A h:mm'
        },
        calendar : {
            sameDay : '오늘 LT',
            nextDay : '내일 LT',
            nextWeek : 'dddd LT',
            lastDay : '어제 LT',
            lastWeek : '지난주 dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s 후',
            past : '%s 전',
            s : '몇 초',
            ss : '%d초',
            m : '1분',
            mm : '%d분',
            h : '한 시간',
            hh : '%d시간',
            d : '하루',
            dd : '%d일',
            M : '한 달',
            MM : '%d달',
            y : '일 년',
            yy : '%d년'
        },
        dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '일';
                case 'M':
                    return number + '월';
                case 'w':
                case 'W':
                    return number + '주';
                default:
                    return number;
            }
        },
        meridiemParse : /오전|오후/,
        isPM : function (token) {
            return token === '오후';
        },
        meridiem : function (hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        }
    });

    return ko;

})));


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '١',
        '2': '٢',
        '3': '٣',
        '4': '٤',
        '5': '٥',
        '6': '٦',
        '7': '٧',
        '8': '٨',
        '9': '٩',
        '0': '٠'
    }, numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    },
    months = [
        'کانونی دووەم',
        'شوبات',
        'ئازار',
        'نیسان',
        'ئایار',
        'حوزەیران',
        'تەمموز',
        'ئاب',
        'ئەیلوول',
        'تشرینی یەكەم',
        'تشرینی دووەم',
        'كانونی یەکەم'
    ];


    var ku = moment.defineLocale('ku', {
        months : months,
        monthsShort : months,
        weekdays : 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split('_'),
        weekdaysShort : 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
        weekdaysMin : 'ی_د_س_چ_پ_ه_ش'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        meridiemParse: /ئێواره‌|به‌یانی/,
        isPM: function (input) {
            return /ئێواره‌/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'به‌یانی';
            } else {
                return 'ئێواره‌';
            }
        },
        calendar : {
            sameDay : '[ئه‌مرۆ كاتژمێر] LT',
            nextDay : '[به‌یانی كاتژمێر] LT',
            nextWeek : 'dddd [كاتژمێر] LT',
            lastDay : '[دوێنێ كاتژمێر] LT',
            lastWeek : 'dddd [كاتژمێر] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'له‌ %s',
            past : '%s',
            s : 'چه‌ند چركه‌یه‌ك',
            ss : 'چركه‌ %d',
            m : 'یه‌ك خوله‌ك',
            mm : '%d خوله‌ك',
            h : 'یه‌ك كاتژمێر',
            hh : '%d كاتژمێر',
            d : 'یه‌ك ڕۆژ',
            dd : '%d ڕۆژ',
            M : 'یه‌ك مانگ',
            MM : '%d مانگ',
            y : 'یه‌ك ساڵ',
            yy : '%d ساڵ'
        },
        preparse: function (string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12 // The week that contains Jan 12th is the first week of the year.
        }
    });

    return ku;

})));


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var suffixes = {
        0: '-чү',
        1: '-чи',
        2: '-чи',
        3: '-чү',
        4: '-чү',
        5: '-чи',
        6: '-чы',
        7: '-чи',
        8: '-чи',
        9: '-чу',
        10: '-чу',
        20: '-чы',
        30: '-чу',
        40: '-чы',
        50: '-чү',
        60: '-чы',
        70: '-чи',
        80: '-чи',
        90: '-чу',
        100: '-чү'
    };

    var ky = moment.defineLocale('ky', {
        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
        monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
        weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
        weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
        weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Бүгүн саат] LT',
            nextDay : '[Эртең саат] LT',
            nextWeek : 'dddd [саат] LT',
            lastDay : '[Кечээ саат] LT',
            lastWeek : '[Өткөн аптанын] dddd [күнү] [саат] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ичинде',
            past : '%s мурун',
            s : 'бирнече секунд',
            ss : '%d секунд',
            m : 'бир мүнөт',
            mm : '%d мүнөт',
            h : 'бир саат',
            hh : '%d саат',
            d : 'бир күн',
            dd : '%d күн',
            M : 'бир ай',
            MM : '%d ай',
            y : 'бир жыл',
            yy : '%d жыл'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
        ordinal : function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return ky;

})));


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eng Minutt', 'enger Minutt'],
            'h': ['eng Stonn', 'enger Stonn'],
            'd': ['een Dag', 'engem Dag'],
            'M': ['ee Mount', 'engem Mount'],
            'y': ['ee Joer', 'engem Joer']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    function processFutureTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'a ' + string;
        }
        return 'an ' + string;
    }
    function processPastTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'viru ' + string;
        }
        return 'virun ' + string;
    }
    /**
     * Returns true if the word before the given number loses the '-n' ending.
     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
     *
     * @param number {integer}
     * @returns {boolean}
     */
    function eifelerRegelAppliesToNumber(number) {
        number = parseInt(number, 10);
        if (isNaN(number)) {
            return false;
        }
        if (number < 0) {
            // Negative Number --> always true
            return true;
        } else if (number < 10) {
            // Only 1 digit
            if (4 <= number && number <= 7) {
                return true;
            }
            return false;
        } else if (number < 100) {
            // 2 digits
            var lastDigit = number % 10, firstDigit = number / 10;
            if (lastDigit === 0) {
                return eifelerRegelAppliesToNumber(firstDigit);
            }
            return eifelerRegelAppliesToNumber(lastDigit);
        } else if (number < 10000) {
            // 3 or 4 digits --> recursively check first digit
            while (number >= 10) {
                number = number / 10;
            }
            return eifelerRegelAppliesToNumber(number);
        } else {
            // Anything larger than 4 digits: recursively check first n-3 digits
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
        }
    }

    var lb = moment.defineLocale('lb', {
        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm [Auer]',
            LTS: 'H:mm:ss [Auer]',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm [Auer]',
            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
        },
        calendar: {
            sameDay: '[Haut um] LT',
            sameElse: 'L',
            nextDay: '[Muer um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: '[Gëschter um] LT',
            lastWeek: function () {
                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
                switch (this.day()) {
                    case 2:
                    case 4:
                        return '[Leschten] dddd [um] LT';
                    default:
                        return '[Leschte] dddd [um] LT';
                }
            }
        },
        relativeTime : {
            future : processFutureTime,
            past : processPastTime,
            s : 'e puer Sekonnen',
            ss : '%d Sekonnen',
            m : processRelativeTime,
            mm : '%d Minutten',
            h : processRelativeTime,
            hh : '%d Stonnen',
            d : processRelativeTime,
            dd : '%d Deeg',
            M : processRelativeTime,
            MM : '%d Méint',
            y : processRelativeTime,
            yy : '%d Joer'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lb;

})));


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var lo = moment.defineLocale('lo', {
        months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
        monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
        weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
        isPM: function (input) {
            return input === 'ຕອນແລງ';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ຕອນເຊົ້າ';
            } else {
                return 'ຕອນແລງ';
            }
        },
        calendar : {
            sameDay : '[ມື້ນີ້ເວລາ] LT',
            nextDay : '[ມື້ອື່ນເວລາ] LT',
            nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
            lastDay : '[ມື້ວານນີ້ເວລາ] LT',
            lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ອີກ %s',
            past : '%sຜ່ານມາ',
            s : 'ບໍ່ເທົ່າໃດວິນາທີ',
            ss : '%d ວິນາທີ' ,
            m : '1 ນາທີ',
            mm : '%d ນາທີ',
            h : '1 ຊົ່ວໂມງ',
            hh : '%d ຊົ່ວໂມງ',
            d : '1 ມື້',
            dd : '%d ມື້',
            M : '1 ເດືອນ',
            MM : '%d ເດືອນ',
            y : '1 ປີ',
            yy : '%d ປີ'
        },
        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
        ordinal : function (number) {
            return 'ທີ່' + number;
        }
    });

    return lo;

})));


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var units = {
        'ss' : 'sekundė_sekundžių_sekundes',
        'm' : 'minutė_minutės_minutę',
        'mm': 'minutės_minučių_minutes',
        'h' : 'valanda_valandos_valandą',
        'hh': 'valandos_valandų_valandas',
        'd' : 'diena_dienos_dieną',
        'dd': 'dienos_dienų_dienas',
        'M' : 'mėnuo_mėnesio_mėnesį',
        'MM': 'mėnesiai_mėnesių_mėnesius',
        'y' : 'metai_metų_metus',
        'yy': 'metai_metų_metus'
    };
    function translateSeconds(number, withoutSuffix, key, isFuture) {
        if (withoutSuffix) {
            return 'kelios sekundės';
        } else {
            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
        }
    }
    function translateSingular(number, withoutSuffix, key, isFuture) {
        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
    }
    function special(number) {
        return number % 10 === 0 || (number > 10 && number < 20);
    }
    function forms(key) {
        return units[key].split('_');
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        if (number === 1) {
            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
        } else if (withoutSuffix) {
            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        } else {
            if (isFuture) {
                return result + forms(key)[1];
            } else {
                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
            }
        }
    }
    var lt = moment.defineLocale('lt', {
        months : {
            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
        },
        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
        weekdays : {
            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
            isFormat: /dddd HH:mm/
        },
        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'YYYY [m.] MMMM D [d.]',
            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
            l : 'YYYY-MM-DD',
            ll : 'YYYY [m.] MMMM D [d.]',
            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
        },
        calendar : {
            sameDay : '[Šiandien] LT',
            nextDay : '[Rytoj] LT',
            nextWeek : 'dddd LT',
            lastDay : '[Vakar] LT',
            lastWeek : '[Praėjusį] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'po %s',
            past : 'prieš %s',
            s : translateSeconds,
            ss : translate,
            m : translateSingular,
            mm : translate,
            h : translateSingular,
            hh : translate,
            d : translateSingular,
            dd : translate,
            M : translateSingular,
            MM : translate,
            y : translateSingular,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal : function (number) {
            return number + '-oji';
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lt;

})));


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var units = {
        'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        'h': 'stundas_stundām_stunda_stundas'.split('_'),
        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
        'd': 'dienas_dienām_diena_dienas'.split('_'),
        'dd': 'dienas_dienām_diena_dienas'.split('_'),
        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        'y': 'gada_gadiem_gads_gadi'.split('_'),
        'yy': 'gada_gadiem_gads_gadi'.split('_')
    };
    /**
     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
     */
    function format(forms, number, withoutSuffix) {
        if (withoutSuffix) {
            // E.g. "21 minūte", "3 minūtes".
            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
        } else {
            // E.g. "21 minūtes" as in "pēc 21 minūtes".
            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
        }
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        return number + ' ' + format(units[key], number, withoutSuffix);
    }
    function relativeTimeWithSingular(number, withoutSuffix, key) {
        return format(units[key], number, withoutSuffix);
    }
    function relativeSeconds(number, withoutSuffix) {
        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
    }

    var lv = moment.defineLocale('lv', {
        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY.',
            LL : 'YYYY. [gada] D. MMMM',
            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
        },
        calendar : {
            sameDay : '[Šodien pulksten] LT',
            nextDay : '[Rīt pulksten] LT',
            nextWeek : 'dddd [pulksten] LT',
            lastDay : '[Vakar pulksten] LT',
            lastWeek : '[Pagājušā] dddd [pulksten] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'pēc %s',
            past : 'pirms %s',
            s : relativeSeconds,
            ss : relativeTimeWithPlural,
            m : relativeTimeWithSingular,
            mm : relativeTimeWithPlural,
            h : relativeTimeWithSingular,
            hh : relativeTimeWithPlural,
            d : relativeTimeWithSingular,
            dd : relativeTimeWithPlural,
            M : relativeTimeWithSingular,
            MM : relativeTimeWithPlural,
            y : relativeTimeWithSingular,
            yy : relativeTimeWithPlural
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lv;

})));


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var translator = {
        words: { //Different grammatical cases
            ss: ['sekund', 'sekunda', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mjesec', 'mjeseca', 'mjeseci'],
            yy: ['godina', 'godine', 'godina']
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var me = moment.defineLocale('me', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact : true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sjutra u] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[juče u] LT',
            lastWeek : function () {
                var lastWeekDays = [
                    '[prošle] [nedjelje] [u] LT',
                    '[prošlog] [ponedjeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srijede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT'
                ];
                return lastWeekDays[this.day()];
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'prije %s',
            s      : 'nekoliko sekundi',
            ss     : translator.translate,
            m      : translator.translate,
            mm     : translator.translate,
            h      : translator.translate,
            hh     : translator.translate,
            d      : 'dan',
            dd     : translator.translate,
            M      : 'mjesec',
            MM     : translator.translate,
            y      : 'godinu',
            yy     : translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return me;

})));


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var mi = moment.defineLocale('mi', {
        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [i] HH:mm',
            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
        },
        calendar: {
            sameDay: '[i teie mahana, i] LT',
            nextDay: '[apopo i] LT',
            nextWeek: 'dddd [i] LT',
            lastDay: '[inanahi i] LT',
            lastWeek: 'dddd [whakamutunga i] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'i roto i %s',
            past: '%s i mua',
            s: 'te hēkona ruarua',
            ss: '%d hēkona',
            m: 'he meneti',
            mm: '%d meneti',
            h: 'te haora',
            hh: '%d haora',
            d: 'he ra',
            dd: '%d ra',
            M: 'he marama',
            MM: '%d marama',
            y: 'he tau',
            yy: '%d tau'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return mi;

})));


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var mk = moment.defineLocale('mk', {
        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'D.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY H:mm',
            LLLL : 'dddd, D MMMM YYYY H:mm'
        },
        calendar : {
            sameDay : '[Денес во] LT',
            nextDay : '[Утре во] LT',
            nextWeek : '[Во] dddd [во] LT',
            lastDay : '[Вчера во] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Изминатата] dddd [во] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Изминатиот] dddd [во] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'после %s',
            past : 'пред %s',
            s : 'неколку секунди',
            ss : '%d секунди',
            m : 'минута',
            mm : '%d минути',
            h : 'час',
            hh : '%d часа',
            d : 'ден',
            dd : '%d дена',
            M : 'месец',
            MM : '%d месеци',
            y : 'година',
            yy : '%d години'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal : function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return mk;

})));


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ml = moment.defineLocale('ml', {
        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
        monthsParseExact : true,
        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm -നു',
            LTS : 'A h:mm:ss -നു',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm -നു',
            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
        },
        calendar : {
            sameDay : '[ഇന്ന്] LT',
            nextDay : '[നാളെ] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[ഇന്നലെ] LT',
            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s കഴിഞ്ഞ്',
            past : '%s മുൻപ്',
            s : 'അൽപ നിമിഷങ്ങൾ',
            ss : '%d സെക്കൻഡ്',
            m : 'ഒരു മിനിറ്റ്',
            mm : '%d മിനിറ്റ്',
            h : 'ഒരു മണിക്കൂർ',
            hh : '%d മണിക്കൂർ',
            d : 'ഒരു ദിവസം',
            dd : '%d ദിവസം',
            M : 'ഒരു മാസം',
            MM : '%d മാസം',
            y : 'ഒരു വർഷം',
            yy : '%d വർഷം'
        },
        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if ((meridiem === 'രാത്രി' && hour >= 4) ||
                    meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                    meridiem === 'വൈകുന്നേരം') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'രാത്രി';
            } else if (hour < 12) {
                return 'രാവിലെ';
            } else if (hour < 17) {
                return 'ഉച്ച കഴിഞ്ഞ്';
            } else if (hour < 20) {
                return 'വൈകുന്നേരം';
            } else {
                return 'രാത്രി';
            }
        }
    });

    return ml;

})));


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function translate(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 's':
                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
            case 'ss':
                return number + (withoutSuffix ? ' секунд' : ' секундын');
            case 'm':
            case 'mm':
                return number + (withoutSuffix ? ' минут' : ' минутын');
            case 'h':
            case 'hh':
                return number + (withoutSuffix ? ' цаг' : ' цагийн');
            case 'd':
            case 'dd':
                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
            case 'M':
            case 'MM':
                return number + (withoutSuffix ? ' сар' : ' сарын');
            case 'y':
            case 'yy':
                return number + (withoutSuffix ? ' жил' : ' жилийн');
            default:
                return number;
        }
    }

    var mn = moment.defineLocale('mn', {
        months : 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split('_'),
        monthsShort : '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split('_'),
        monthsParseExact : true,
        weekdays : 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
        weekdaysShort : 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
        weekdaysMin : 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'YYYY оны MMMMын D',
            LLL : 'YYYY оны MMMMын D HH:mm',
            LLLL : 'dddd, YYYY оны MMMMын D HH:mm'
        },
        meridiemParse: /ҮӨ|ҮХ/i,
        isPM : function (input) {
            return input === 'ҮХ';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ҮӨ';
            } else {
                return 'ҮХ';
            }
        },
        calendar : {
            sameDay : '[Өнөөдөр] LT',
            nextDay : '[Маргааш] LT',
            nextWeek : '[Ирэх] dddd LT',
            lastDay : '[Өчигдөр] LT',
            lastWeek : '[Өнгөрсөн] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s дараа',
            past : '%s өмнө',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + ' өдөр';
                default:
                    return number;
            }
        }
    });

    return mn;

})));


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    },
    numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    function relativeTimeMr(number, withoutSuffix, string, isFuture)
    {
        var output = '';
        if (withoutSuffix) {
            switch (string) {
                case 's': output = 'काही सेकंद'; break;
                case 'ss': output = '%d सेकंद'; break;
                case 'm': output = 'एक मिनिट'; break;
                case 'mm': output = '%d मिनिटे'; break;
                case 'h': output = 'एक तास'; break;
                case 'hh': output = '%d तास'; break;
                case 'd': output = 'एक दिवस'; break;
                case 'dd': output = '%d दिवस'; break;
                case 'M': output = 'एक महिना'; break;
                case 'MM': output = '%d महिने'; break;
                case 'y': output = 'एक वर्ष'; break;
                case 'yy': output = '%d वर्षे'; break;
            }
        }
        else {
            switch (string) {
                case 's': output = 'काही सेकंदां'; break;
                case 'ss': output = '%d सेकंदां'; break;
                case 'm': output = 'एका मिनिटा'; break;
                case 'mm': output = '%d मिनिटां'; break;
                case 'h': output = 'एका तासा'; break;
                case 'hh': output = '%d तासां'; break;
                case 'd': output = 'एका दिवसा'; break;
                case 'dd': output = '%d दिवसां'; break;
                case 'M': output = 'एका महिन्या'; break;
                case 'MM': output = '%d महिन्यां'; break;
                case 'y': output = 'एका वर्षा'; break;
                case 'yy': output = '%d वर्षां'; break;
            }
        }
        return output.replace(/%d/i, number);
    }

    var mr = moment.defineLocale('mr', {
        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
        monthsParseExact : true,
        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat : {
            LT : 'A h:mm वाजता',
            LTS : 'A h:mm:ss वाजता',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm वाजता',
            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
        },
        calendar : {
            sameDay : '[आज] LT',
            nextDay : '[उद्या] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[काल] LT',
            lastWeek: '[मागील] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future: '%sमध्ये',
            past: '%sपूर्वी',
            s: relativeTimeMr,
            ss: relativeTimeMr,
            m: relativeTimeMr,
            mm: relativeTimeMr,
            h: relativeTimeMr,
            hh: relativeTimeMr,
            d: relativeTimeMr,
            dd: relativeTimeMr,
            M: relativeTimeMr,
            MM: relativeTimeMr,
            y: relativeTimeMr,
            yy: relativeTimeMr
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात्री') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सकाळी') {
                return hour;
            } else if (meridiem === 'दुपारी') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'सायंकाळी') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात्री';
            } else if (hour < 10) {
                return 'सकाळी';
            } else if (hour < 17) {
                return 'दुपारी';
            } else if (hour < 20) {
                return 'सायंकाळी';
            } else {
                return 'रात्री';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return mr;

})));


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ms = moment.defineLocale('ms', {
        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar : {
            sameDay : '[Hari ini pukul] LT',
            nextDay : '[Esok pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kelmarin pukul] LT',
            lastWeek : 'dddd [lepas pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dalam %s',
            past : '%s yang lepas',
            s : 'beberapa saat',
            ss : '%d saat',
            m : 'seminit',
            mm : '%d minit',
            h : 'sejam',
            hh : '%d jam',
            d : 'sehari',
            dd : '%d hari',
            M : 'sebulan',
            MM : '%d bulan',
            y : 'setahun',
            yy : '%d tahun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return ms;

})));


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var msMy = moment.defineLocale('ms-my', {
        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar : {
            sameDay : '[Hari ini pukul] LT',
            nextDay : '[Esok pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kelmarin pukul] LT',
            lastWeek : 'dddd [lepas pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dalam %s',
            past : '%s yang lepas',
            s : 'beberapa saat',
            ss : '%d saat',
            m : 'seminit',
            mm : '%d minit',
            h : 'sejam',
            hh : '%d jam',
            d : 'sehari',
            dd : '%d hari',
            M : 'sebulan',
            MM : '%d bulan',
            y : 'setahun',
            yy : '%d tahun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return msMy;

})));


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var mt = moment.defineLocale('mt', {
        months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
        monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
        weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
        weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
        weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Illum fil-]LT',
            nextDay : '[Għada fil-]LT',
            nextWeek : 'dddd [fil-]LT',
            lastDay : '[Il-bieraħ fil-]LT',
            lastWeek : 'dddd [li għadda] [fil-]LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'f’ %s',
            past : '%s ilu',
            s : 'ftit sekondi',
            ss : '%d sekondi',
            m : 'minuta',
            mm : '%d minuti',
            h : 'siegħa',
            hh : '%d siegħat',
            d : 'ġurnata',
            dd : '%d ġranet',
            M : 'xahar',
            MM : '%d xhur',
            y : 'sena',
            yy : '%d sni'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return mt;

})));


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '၁',
        '2': '၂',
        '3': '၃',
        '4': '၄',
        '5': '၅',
        '6': '၆',
        '7': '၇',
        '8': '၈',
        '9': '၉',
        '0': '၀'
    }, numberMap = {
        '၁': '1',
        '၂': '2',
        '၃': '3',
        '၄': '4',
        '၅': '5',
        '၆': '6',
        '၇': '7',
        '၈': '8',
        '၉': '9',
        '၀': '0'
    };

    var my = moment.defineLocale('my', {
        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[ယနေ.] LT [မှာ]',
            nextDay: '[မနက်ဖြန်] LT [မှာ]',
            nextWeek: 'dddd LT [မှာ]',
            lastDay: '[မနေ.က] LT [မှာ]',
            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'လာမည့် %s မှာ',
            past: 'လွန်ခဲ့သော %s က',
            s: 'စက္ကန်.အနည်းငယ်',
            ss : '%d စက္ကန့်',
            m: 'တစ်မိနစ်',
            mm: '%d မိနစ်',
            h: 'တစ်နာရီ',
            hh: '%d နာရီ',
            d: 'တစ်ရက်',
            dd: '%d ရက်',
            M: 'တစ်လ',
            MM: '%d လ',
            y: 'တစ်နှစ်',
            yy: '%d နှစ်'
        },
        preparse: function (string) {
            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return my;

})));


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var nb = moment.defineLocale('nb', {
        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact : true,
        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY [kl.] HH:mm',
            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
        },
        calendar : {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : '%s siden',
            s : 'noen sekunder',
            ss : '%d sekunder',
            m : 'ett minutt',
            mm : '%d minutter',
            h : 'en time',
            hh : '%d timer',
            d : 'en dag',
            dd : '%d dager',
            M : 'en måned',
            MM : '%d måneder',
            y : 'ett år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nb;

})));


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    },
    numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    var ne = moment.defineLocale('ne', {
        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
        monthsParseExact : true,
        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
        weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'Aको h:mm बजे',
            LTS : 'Aको h:mm:ss बजे',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, Aको h:mm बजे',
            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राति') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'बिहान') {
                return hour;
            } else if (meridiem === 'दिउँसो') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'साँझ') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 3) {
                return 'राति';
            } else if (hour < 12) {
                return 'बिहान';
            } else if (hour < 16) {
                return 'दिउँसो';
            } else if (hour < 20) {
                return 'साँझ';
            } else {
                return 'राति';
            }
        },
        calendar : {
            sameDay : '[आज] LT',
            nextDay : '[भोलि] LT',
            nextWeek : '[आउँदो] dddd[,] LT',
            lastDay : '[हिजो] LT',
            lastWeek : '[गएको] dddd[,] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%sमा',
            past : '%s अगाडि',
            s : 'केही क्षण',
            ss : '%d सेकेण्ड',
            m : 'एक मिनेट',
            mm : '%d मिनेट',
            h : 'एक घण्टा',
            hh : '%d घण्टा',
            d : 'एक दिन',
            dd : '%d दिन',
            M : 'एक महिना',
            MM : '%d महिना',
            y : 'एक बर्ष',
            yy : '%d बर्ष'
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return ne;

})));


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nl = moment.defineLocale('nl', {
        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,

        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'over %s',
            past : '%s geleden',
            s : 'een paar seconden',
            ss : '%d seconden',
            m : 'één minuut',
            mm : '%d minuten',
            h : 'één uur',
            hh : '%d uur',
            d : 'één dag',
            dd : '%d dagen',
            M : 'één maand',
            MM : '%d maanden',
            y : 'één jaar',
            yy : '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nl;

})));


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nlBe = moment.defineLocale('nl-be', {
        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,

        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'over %s',
            past : '%s geleden',
            s : 'een paar seconden',
            ss : '%d seconden',
            m : 'één minuut',
            mm : '%d minuten',
            h : 'één uur',
            hh : '%d uur',
            d : 'één dag',
            dd : '%d dagen',
            M : 'één maand',
            MM : '%d maanden',
            y : 'één jaar',
            yy : '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nlBe;

})));


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var nn = moment.defineLocale('nn', {
        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY [kl.] H:mm',
            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
        },
        calendar : {
            sameDay: '[I dag klokka] LT',
            nextDay: '[I morgon klokka] LT',
            nextWeek: 'dddd [klokka] LT',
            lastDay: '[I går klokka] LT',
            lastWeek: '[Føregåande] dddd [klokka] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : '%s sidan',
            s : 'nokre sekund',
            ss : '%d sekund',
            m : 'eit minutt',
            mm : '%d minutt',
            h : 'ein time',
            hh : '%d timar',
            d : 'ein dag',
            dd : '%d dagar',
            M : 'ein månad',
            MM : '%d månader',
            y : 'eit år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nn;

})));


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '੧',
        '2': '੨',
        '3': '੩',
        '4': '੪',
        '5': '੫',
        '6': '੬',
        '7': '੭',
        '8': '੮',
        '9': '੯',
        '0': '੦'
    },
    numberMap = {
        '੧': '1',
        '੨': '2',
        '੩': '3',
        '੪': '4',
        '੫': '5',
        '੬': '6',
        '੭': '7',
        '੮': '8',
        '੯': '9',
        '੦': '0'
    };

    var paIn = moment.defineLocale('pa-in', {
        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
        months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
        monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
        weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
        weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm ਵਜੇ',
            LTS : 'A h:mm:ss ਵਜੇ',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
            LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
        },
        calendar : {
            sameDay : '[ਅਜ] LT',
            nextDay : '[ਕਲ] LT',
            nextWeek : '[ਅਗਲਾ] dddd, LT',
            lastDay : '[ਕਲ] LT',
            lastWeek : '[ਪਿਛਲੇ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ਵਿੱਚ',
            past : '%s ਪਿਛਲੇ',
            s : 'ਕੁਝ ਸਕਿੰਟ',
            ss : '%d ਸਕਿੰਟ',
            m : 'ਇਕ ਮਿੰਟ',
            mm : '%d ਮਿੰਟ',
            h : 'ਇੱਕ ਘੰਟਾ',
            hh : '%d ਘੰਟੇ',
            d : 'ਇੱਕ ਦਿਨ',
            dd : '%d ਦਿਨ',
            M : 'ਇੱਕ ਮਹੀਨਾ',
            MM : '%d ਮਹੀਨੇ',
            y : 'ਇੱਕ ਸਾਲ',
            yy : '%d ਸਾਲ'
        },
        preparse: function (string) {
            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ਰਾਤ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ਸਵੇਰ') {
                return hour;
            } else if (meridiem === 'ਦੁਪਹਿਰ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ਸ਼ਾਮ') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ਰਾਤ';
            } else if (hour < 10) {
                return 'ਸਵੇਰ';
            } else if (hour < 17) {
                return 'ਦੁਪਹਿਰ';
            } else if (hour < 20) {
                return 'ਸ਼ਾਮ';
            } else {
                return 'ਰਾਤ';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return paIn;

})));


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
    function plural(n) {
        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
    }
    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                return result + (plural(number) ? 'sekundy' : 'sekund');
            case 'm':
                return withoutSuffix ? 'minuta' : 'minutę';
            case 'mm':
                return result + (plural(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix  ? 'godzina'  : 'godzinę';
            case 'hh':
                return result + (plural(number) ? 'godziny' : 'godzin');
            case 'MM':
                return result + (plural(number) ? 'miesiące' : 'miesięcy');
            case 'yy':
                return result + (plural(number) ? 'lata' : 'lat');
        }
    }

    var pl = moment.defineLocale('pl', {
        months : function (momentToFormat, format) {
            if (!momentToFormat) {
                return monthsNominative;
            } else if (format === '') {
                // Hack: if format empty we know this is used to generate
                // RegExp by moment. Give then back both valid forms of months
                // in RegExp ready format.
                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
            } else if (/D MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
        weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W niedzielę o] LT';

                    case 2:
                        return '[We wtorek o] LT';

                    case 3:
                        return '[W środę o] LT';

                    case 6:
                        return '[W sobotę o] LT';

                    default:
                        return '[W] dddd [o] LT';
                }
            },
            lastDay: '[Wczoraj o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W zeszłą niedzielę o] LT';
                    case 3:
                        return '[W zeszłą środę o] LT';
                    case 6:
                        return '[W zeszłą sobotę o] LT';
                    default:
                        return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'za %s',
            past : '%s temu',
            s : 'kilka sekund',
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : '1 dzień',
            dd : '%d dni',
            M : 'miesiąc',
            MM : translate,
            y : 'rok',
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return pl;

})));


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var pt = moment.defineLocale('pt', {
        months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
        monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY HH:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return (this.day() === 0 || this.day() === 6) ?
                    '[Último] dddd [às] LT' : // Saturday + Sunday
                    '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'em %s',
            past : 'há %s',
            s : 'segundos',
            ss : '%d segundos',
            m : 'um minuto',
            mm : '%d minutos',
            h : 'uma hora',
            hh : '%d horas',
            d : 'um dia',
            dd : '%d dias',
            M : 'um mês',
            MM : '%d meses',
            y : 'um ano',
            yy : '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return pt;

})));


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ptBr = moment.defineLocale('pt-br', {
        months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
        monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
        },
        calendar : {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return (this.day() === 0 || this.day() === 6) ?
                    '[Último] dddd [às] LT' : // Saturday + Sunday
                    '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'em %s',
            past : 'há %s',
            s : 'poucos segundos',
            ss : '%d segundos',
            m : 'um minuto',
            mm : '%d minutos',
            h : 'uma hora',
            hh : '%d horas',
            d : 'um dia',
            dd : '%d dias',
            M : 'um mês',
            MM : '%d meses',
            y : 'um ano',
            yy : '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal : '%dº'
    });

    return ptBr;

})));


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
                'ss': 'secunde',
                'mm': 'minute',
                'hh': 'ore',
                'dd': 'zile',
                'MM': 'luni',
                'yy': 'ani'
            },
            separator = ' ';
        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
            separator = ' de ';
        }
        return number + separator + format[key];
    }

    var ro = moment.defineLocale('ro', {
        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY H:mm',
            LLLL : 'dddd, D MMMM YYYY H:mm'
        },
        calendar : {
            sameDay: '[azi la] LT',
            nextDay: '[mâine la] LT',
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'peste %s',
            past : '%s în urmă',
            s : 'câteva secunde',
            ss : relativeTimeWithPlural,
            m : 'un minut',
            mm : relativeTimeWithPlural,
            h : 'o oră',
            hh : relativeTimeWithPlural,
            d : 'o zi',
            dd : relativeTimeWithPlural,
            M : 'o lună',
            MM : relativeTimeWithPlural,
            y : 'un an',
            yy : relativeTimeWithPlural
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return ro;

})));


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            'hh': 'час_часа_часов',
            'dd': 'день_дня_дней',
            'MM': 'месяц_месяца_месяцев',
            'yy': 'год_года_лет'
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        }
        else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];

    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    var ru = moment.defineLocale('ru', {
        months : {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
        },
        monthsShort : {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
        },
        weekdays : {
            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
        },
        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,

        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // копия предыдущего
        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // полные названия с падежами
        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

        // Выражение, которое соотвествует только сокращённым формам
        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY г.',
            LLL : 'D MMMM YYYY г., H:mm',
            LLLL : 'dddd, D MMMM YYYY г., H:mm'
        },
        calendar : {
            sameDay: '[Сегодня, в] LT',
            nextDay: '[Завтра, в] LT',
            lastDay: '[Вчера, в] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В следующее] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В следующий] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В следующую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            lastWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В прошлое] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В прошлый] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В прошлую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'через %s',
            past : '%s назад',
            s : 'несколько секунд',
            ss : relativeTimeWithPlural,
            m : relativeTimeWithPlural,
            mm : relativeTimeWithPlural,
            h : 'час',
            hh : relativeTimeWithPlural,
            d : 'день',
            dd : relativeTimeWithPlural,
            M : 'месяц',
            MM : relativeTimeWithPlural,
            y : 'год',
            yy : relativeTimeWithPlural
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM : function (input) {
            return /^(дня|вечера)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночи';
            } else if (hour < 12) {
                return 'утра';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечера';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                case 'w':
                case 'W':
                    return number + '-я';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ru;

})));


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = [
        'جنوري',
        'فيبروري',
        'مارچ',
        'اپريل',
        'مئي',
        'جون',
        'جولاءِ',
        'آگسٽ',
        'سيپٽمبر',
        'آڪٽوبر',
        'نومبر',
        'ڊسمبر'
    ];
    var days = [
        'آچر',
        'سومر',
        'اڱارو',
        'اربع',
        'خميس',
        'جمع',
        'ڇنڇر'
    ];

    var sd = moment.defineLocale('sd', {
        months : months,
        monthsShort : months,
        weekdays : days,
        weekdaysShort : days,
        weekdaysMin : days,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd، D MMMM YYYY HH:mm'
        },
        meridiemParse: /صبح|شام/,
        isPM : function (input) {
            return 'شام' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar : {
            sameDay : '[اڄ] LT',
            nextDay : '[سڀاڻي] LT',
            nextWeek : 'dddd [اڳين هفتي تي] LT',
            lastDay : '[ڪالهه] LT',
            lastWeek : '[گزريل هفتي] dddd [تي] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s پوء',
            past : '%s اڳ',
            s : 'چند سيڪنڊ',
            ss : '%d سيڪنڊ',
            m : 'هڪ منٽ',
            mm : '%d منٽ',
            h : 'هڪ ڪلاڪ',
            hh : '%d ڪلاڪ',
            d : 'هڪ ڏينهن',
            dd : '%d ڏينهن',
            M : 'هڪ مهينو',
            MM : '%d مهينا',
            y : 'هڪ سال',
            yy : '%d سال'
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sd;

})));


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var se = moment.defineLocale('se', {
        months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
        monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
        weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
        weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
        weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'MMMM D. [b.] YYYY',
            LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
            LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
        },
        calendar : {
            sameDay: '[otne ti] LT',
            nextDay: '[ihttin ti] LT',
            nextWeek: 'dddd [ti] LT',
            lastDay: '[ikte ti] LT',
            lastWeek: '[ovddit] dddd [ti] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s geažes',
            past : 'maŋit %s',
            s : 'moadde sekunddat',
            ss: '%d sekunddat',
            m : 'okta minuhta',
            mm : '%d minuhtat',
            h : 'okta diimmu',
            hh : '%d diimmut',
            d : 'okta beaivi',
            dd : '%d beaivvit',
            M : 'okta mánnu',
            MM : '%d mánut',
            y : 'okta jahki',
            yy : '%d jagit'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return se;

})));


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    /*jshint -W100*/
    var si = moment.defineLocale('si', {
        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'a h:mm',
            LTS : 'a h:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY MMMM D',
            LLL : 'YYYY MMMM D, a h:mm',
            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
        },
        calendar : {
            sameDay : '[අද] LT[ට]',
            nextDay : '[හෙට] LT[ට]',
            nextWeek : 'dddd LT[ට]',
            lastDay : '[ඊයේ] LT[ට]',
            lastWeek : '[පසුගිය] dddd LT[ට]',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%sකින්',
            past : '%sකට පෙර',
            s : 'තත්පර කිහිපය',
            ss : 'තත්පර %d',
            m : 'මිනිත්තුව',
            mm : 'මිනිත්තු %d',
            h : 'පැය',
            hh : 'පැය %d',
            d : 'දිනය',
            dd : 'දින %d',
            M : 'මාසය',
            MM : 'මාස %d',
            y : 'වසර',
            yy : 'වසර %d'
        },
        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
        ordinal : function (number) {
            return number + ' වැනි';
        },
        meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM : function (input) {
            return input === 'ප.ව.' || input === 'පස් වරු';
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'ප.ව.' : 'පස් වරු';
            } else {
                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
            }
        }
    });

    return si;

})));


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
    function plural(n) {
        return (n > 1) && (n < 5);
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':  // a few seconds / in a few seconds / a few seconds ago
                return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
                } else {
                    return result + 'sekundami';
                }
                break;
            case 'm':  // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minúty' : 'minút');
                } else {
                    return result + 'minútami';
                }
                break;
            case 'h':  // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodín');
                } else {
                    return result + 'hodinami';
                }
                break;
            case 'd':  // a day / in a day / a day ago
                return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dni' : 'dní');
                } else {
                    return result + 'dňami';
                }
                break;
            case 'M':  // a month / in a month / a month ago
                return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
                } else {
                    return result + 'mesiacmi';
                }
                break;
            case 'y':  // a year / in a year / a year ago
                return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'rokov');
                } else {
                    return result + 'rokmi';
                }
                break;
        }
    }

    var sk = moment.defineLocale('sk', {
        months : months,
        monthsShort : monthsShort,
        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
        longDateFormat : {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay: '[dnes o] LT',
            nextDay: '[zajtra o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [o] LT';
                    case 3:
                        return '[v stredu o] LT';
                    case 4:
                        return '[vo štvrtok o] LT';
                    case 5:
                        return '[v piatok o] LT';
                    case 6:
                        return '[v sobotu o] LT';
                }
            },
            lastDay: '[včera o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulú nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[minulý] dddd [o] LT';
                    case 3:
                        return '[minulú stredu o] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [o] LT';
                    case 6:
                        return '[minulú sobotu o] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'za %s',
            past : 'pred %s',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sk;

})));


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
            case 'ss':
                if (number === 1) {
                    result += withoutSuffix ? 'sekundo' : 'sekundi';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
                } else {
                    result += 'sekund';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'ena minuta' : 'eno minuto';
            case 'mm':
                if (number === 1) {
                    result += withoutSuffix ? 'minuta' : 'minuto';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
                } else {
                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'ena ura' : 'eno uro';
            case 'hh':
                if (number === 1) {
                    result += withoutSuffix ? 'ura' : 'uro';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
                } else {
                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
                }
                return result;
            case 'd':
                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
            case 'dd':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
                } else {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
                }
                return result;
            case 'M':
                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
            case 'MM':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
                } else {
                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
                }
                return result;
            case 'y':
                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
            case 'yy':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
                } else {
                    result += withoutSuffix || isFuture ? 'let' : 'leti';
                }
                return result;
        }
    }

    var sl = moment.defineLocale('sl', {
        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[danes ob] LT',
            nextDay  : '[jutri ob] LT',

            nextWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[v] [nedeljo] [ob] LT';
                    case 3:
                        return '[v] [sredo] [ob] LT';
                    case 6:
                        return '[v] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[v] dddd [ob] LT';
                }
            },
            lastDay  : '[včeraj ob] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[prejšnjo] [nedeljo] [ob] LT';
                    case 3:
                        return '[prejšnjo] [sredo] [ob] LT';
                    case 6:
                        return '[prejšnjo] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prejšnji] dddd [ob] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'čez %s',
            past   : 'pred %s',
            s      : processRelativeTime,
            ss     : processRelativeTime,
            m      : processRelativeTime,
            mm     : processRelativeTime,
            h      : processRelativeTime,
            hh     : processRelativeTime,
            d      : processRelativeTime,
            dd     : processRelativeTime,
            M      : processRelativeTime,
            MM     : processRelativeTime,
            y      : processRelativeTime,
            yy     : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return sl;

})));


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var sq = moment.defineLocale('sq', {
        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
        weekdaysParseExact : true,
        meridiemParse: /PD|MD/,
        isPM: function (input) {
            return input.charAt(0) === 'M';
        },
        meridiem : function (hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
        },
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Sot në] LT',
            nextDay : '[Nesër në] LT',
            nextWeek : 'dddd [në] LT',
            lastDay : '[Dje në] LT',
            lastWeek : 'dddd [e kaluar në] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'në %s',
            past : '%s më parë',
            s : 'disa sekonda',
            ss : '%d sekonda',
            m : 'një minutë',
            mm : '%d minuta',
            h : 'një orë',
            hh : '%d orë',
            d : 'një ditë',
            dd : '%d ditë',
            M : 'një muaj',
            MM : '%d muaj',
            y : 'një vit',
            yy : '%d vite'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sq;

})));


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var translator = {
        words: { //Different grammatical cases
            ss: ['sekunda', 'sekunde', 'sekundi'],
            m: ['jedan minut', 'jedne minute'],
            mm: ['minut', 'minute', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mesec', 'meseca', 'meseci'],
            yy: ['godina', 'godine', 'godina']
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var sr = moment.defineLocale('sr', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedelju] [u] LT';
                    case 3:
                        return '[u] [sredu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[juče u] LT',
            lastWeek : function () {
                var lastWeekDays = [
                    '[prošle] [nedelje] [u] LT',
                    '[prošlog] [ponedeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT'
                ];
                return lastWeekDays[this.day()];
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'pre %s',
            s      : 'nekoliko sekundi',
            ss     : translator.translate,
            m      : translator.translate,
            mm     : translator.translate,
            h      : translator.translate,
            hh     : translator.translate,
            d      : 'dan',
            dd     : translator.translate,
            M      : 'mesec',
            MM     : translator.translate,
            y      : 'godinu',
            yy     : translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return sr;

})));


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var translator = {
        words: { //Different grammatical cases
            ss: ['секунда', 'секунде', 'секунди'],
            m: ['један минут', 'једне минуте'],
            mm: ['минут', 'минуте', 'минута'],
            h: ['један сат', 'једног сата'],
            hh: ['сат', 'сата', 'сати'],
            dd: ['дан', 'дана', 'дана'],
            MM: ['месец', 'месеца', 'месеци'],
            yy: ['година', 'године', 'година']
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var srCyrl = moment.defineLocale('sr-cyrl', {
        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
        monthsParseExact: true,
        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[данас у] LT',
            nextDay: '[сутра у] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[у] [недељу] [у] LT';
                    case 3:
                        return '[у] [среду] [у] LT';
                    case 6:
                        return '[у] [суботу] [у] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[у] dddd [у] LT';
                }
            },
            lastDay  : '[јуче у] LT',
            lastWeek : function () {
                var lastWeekDays = [
                    '[прошле] [недеље] [у] LT',
                    '[прошлог] [понедељка] [у] LT',
                    '[прошлог] [уторка] [у] LT',
                    '[прошле] [среде] [у] LT',
                    '[прошлог] [четвртка] [у] LT',
                    '[прошлог] [петка] [у] LT',
                    '[прошле] [суботе] [у] LT'
                ];
                return lastWeekDays[this.day()];
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'за %s',
            past   : 'пре %s',
            s      : 'неколико секунди',
            ss     : translator.translate,
            m      : translator.translate,
            mm     : translator.translate,
            h      : translator.translate,
            hh     : translator.translate,
            d      : 'дан',
            dd     : translator.translate,
            M      : 'месец',
            MM     : translator.translate,
            y      : 'годину',
            yy     : translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return srCyrl;

})));


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ss = moment.defineLocale('ss', {
        months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
        monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
        weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
        weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
        weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Namuhla nga] LT',
            nextDay : '[Kusasa nga] LT',
            nextWeek : 'dddd [nga] LT',
            lastDay : '[Itolo nga] LT',
            lastWeek : 'dddd [leliphelile] [nga] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'nga %s',
            past : 'wenteka nga %s',
            s : 'emizuzwana lomcane',
            ss : '%d mzuzwana',
            m : 'umzuzu',
            mm : '%d emizuzu',
            h : 'lihora',
            hh : '%d emahora',
            d : 'lilanga',
            dd : '%d emalanga',
            M : 'inyanga',
            MM : '%d tinyanga',
            y : 'umnyaka',
            yy : '%d iminyaka'
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'ekuseni';
            } else if (hours < 15) {
                return 'emini';
            } else if (hours < 19) {
                return 'entsambama';
            } else {
                return 'ebusuku';
            }
        },
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ekuseni') {
                return hour;
            } else if (meridiem === 'emini') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
                if (hour === 0) {
                    return 0;
                }
                return hour + 12;
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal : '%d',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ss;

})));


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var sv = moment.defineLocale('sv', {
        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [kl.] HH:mm',
            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
            lll : 'D MMM YYYY HH:mm',
            llll : 'ddd D MMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : 'för %s sedan',
            s : 'några sekunder',
            ss : '%d sekunder',
            m : 'en minut',
            mm : '%d minuter',
            h : 'en timme',
            hh : '%d timmar',
            d : 'en dag',
            dd : '%d dagar',
            M : 'en månad',
            MM : '%d månader',
            y : 'ett år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'e' :
                (b === 1) ? 'a' :
                (b === 2) ? 'a' :
                (b === 3) ? 'e' : 'e';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sv;

})));


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var sw = moment.defineLocale('sw', {
        months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
        weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
        weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
        weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[leo saa] LT',
            nextDay : '[kesho saa] LT',
            nextWeek : '[wiki ijayo] dddd [saat] LT',
            lastDay : '[jana] LT',
            lastWeek : '[wiki iliyopita] dddd [saat] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s baadaye',
            past : 'tokea %s',
            s : 'hivi punde',
            ss : 'sekunde %d',
            m : 'dakika moja',
            mm : 'dakika %d',
            h : 'saa limoja',
            hh : 'masaa %d',
            d : 'siku moja',
            dd : 'masiku %d',
            M : 'mwezi mmoja',
            MM : 'miezi %d',
            y : 'mwaka mmoja',
            yy : 'miaka %d'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return sw;

})));


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '௧',
        '2': '௨',
        '3': '௩',
        '4': '௪',
        '5': '௫',
        '6': '௬',
        '7': '௭',
        '8': '௮',
        '9': '௯',
        '0': '௦'
    }, numberMap = {
        '௧': '1',
        '௨': '2',
        '௩': '3',
        '௪': '4',
        '௫': '5',
        '௬': '6',
        '௭': '7',
        '௮': '8',
        '௯': '9',
        '௦': '0'
    };

    var ta = moment.defineLocale('ta', {
        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, HH:mm',
            LLLL : 'dddd, D MMMM YYYY, HH:mm'
        },
        calendar : {
            sameDay : '[இன்று] LT',
            nextDay : '[நாளை] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[நேற்று] LT',
            lastWeek : '[கடந்த வாரம்] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s இல்',
            past : '%s முன்',
            s : 'ஒரு சில விநாடிகள்',
            ss : '%d விநாடிகள்',
            m : 'ஒரு நிமிடம்',
            mm : '%d நிமிடங்கள்',
            h : 'ஒரு மணி நேரம்',
            hh : '%d மணி நேரம்',
            d : 'ஒரு நாள்',
            dd : '%d நாட்கள்',
            M : 'ஒரு மாதம்',
            MM : '%d மாதங்கள்',
            y : 'ஒரு வருடம்',
            yy : '%d ஆண்டுகள்'
        },
        dayOfMonthOrdinalParse: /\d{1,2}வது/,
        ordinal : function (number) {
            return number + 'வது';
        },
        preparse: function (string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // refer http://ta.wikipedia.org/s/1er1
        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
        meridiem : function (hour, minute, isLower) {
            if (hour < 2) {
                return ' யாமம்';
            } else if (hour < 6) {
                return ' வைகறை';  // வைகறை
            } else if (hour < 10) {
                return ' காலை'; // காலை
            } else if (hour < 14) {
                return ' நண்பகல்'; // நண்பகல்
            } else if (hour < 18) {
                return ' எற்பாடு'; // எற்பாடு
            } else if (hour < 22) {
                return ' மாலை'; // மாலை
            } else {
                return ' யாமம்';
            }
        },
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'யாமம்') {
                return hour < 2 ? hour : hour + 12;
            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
                return hour;
            } else if (meridiem === 'நண்பகல்') {
                return hour >= 10 ? hour : hour + 12;
            } else {
                return hour + 12;
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return ta;

})));


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var te = moment.defineLocale('te', {
        months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
        monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
        monthsParseExact : true,
        weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
        weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
        weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm',
            LLLL : 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar : {
            sameDay : '[నేడు] LT',
            nextDay : '[రేపు] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[నిన్న] LT',
            lastWeek : '[గత] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s లో',
            past : '%s క్రితం',
            s : 'కొన్ని క్షణాలు',
            ss : '%d సెకన్లు',
            m : 'ఒక నిమిషం',
            mm : '%d నిమిషాలు',
            h : 'ఒక గంట',
            hh : '%d గంటలు',
            d : 'ఒక రోజు',
            dd : '%d రోజులు',
            M : 'ఒక నెల',
            MM : '%d నెలలు',
            y : 'ఒక సంవత్సరం',
            yy : '%d సంవత్సరాలు'
        },
        dayOfMonthOrdinalParse : /\d{1,2}వ/,
        ordinal : '%dవ',
        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'రాత్రి') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ఉదయం') {
                return hour;
            } else if (meridiem === 'మధ్యాహ్నం') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'సాయంత్రం') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'రాత్రి';
            } else if (hour < 10) {
                return 'ఉదయం';
            } else if (hour < 17) {
                return 'మధ్యాహ్నం';
            } else if (hour < 20) {
                return 'సాయంత్రం';
            } else {
                return 'రాత్రి';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return te;

})));


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var tet = moment.defineLocale('tet', {
        months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
        weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
        weekdaysMin : 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Ohin iha] LT',
            nextDay: '[Aban iha] LT',
            nextWeek: 'dddd [iha] LT',
            lastDay: '[Horiseik iha] LT',
            lastWeek: 'dddd [semana kotuk] [iha] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'iha %s',
            past : '%s liuba',
            s : 'minutu balun',
            ss : 'minutu %d',
            m : 'minutu ida',
            mm : 'minutu %d',
            h : 'oras ida',
            hh : 'oras %d',
            d : 'loron ida',
            dd : 'loron %d',
            M : 'fulan ida',
            MM : 'fulan %d',
            y : 'tinan ida',
            yy : 'tinan %d'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return tet;

})));


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var suffixes = {
        0: '-ум',
        1: '-ум',
        2: '-юм',
        3: '-юм',
        4: '-ум',
        5: '-ум',
        6: '-ум',
        7: '-ум',
        8: '-ум',
        9: '-ум',
        10: '-ум',
        12: '-ум',
        13: '-ум',
        20: '-ум',
        30: '-юм',
        40: '-ум',
        50: '-ум',
        60: '-ум',
        70: '-ум',
        80: '-ум',
        90: '-ум',
        100: '-ум'
    };

    var tg = moment.defineLocale('tg', {
        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays : 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split('_'),
        weekdaysShort : 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
        weekdaysMin : 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Имрӯз соати] LT',
            nextDay : '[Пагоҳ соати] LT',
            lastDay : '[Дирӯз соати] LT',
            nextWeek : 'dddd[и] [ҳафтаи оянда соати] LT',
            lastWeek : 'dddd[и] [ҳафтаи гузашта соати] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'баъди %s',
            past : '%s пеш',
            s : 'якчанд сония',
            m : 'як дақиқа',
            mm : '%d дақиқа',
            h : 'як соат',
            hh : '%d соат',
            d : 'як рӯз',
            dd : '%d рӯз',
            M : 'як моҳ',
            MM : '%d моҳ',
            y : 'як сол',
            yy : '%d сол'
        },
        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'шаб') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'субҳ') {
                return hour;
            } else if (meridiem === 'рӯз') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'бегоҳ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'шаб';
            } else if (hour < 11) {
                return 'субҳ';
            } else if (hour < 16) {
                return 'рӯз';
            } else if (hour < 19) {
                return 'бегоҳ';
            } else {
                return 'шаб';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1th is the first week of the year.
        }
    });

    return tg;

})));


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var th = moment.defineLocale('th', {
        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
        monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
        monthsParseExact: true,
        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY เวลา H:mm',
            LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function (input) {
            return input === 'หลังเที่ยง';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ก่อนเที่ยง';
            } else {
                return 'หลังเที่ยง';
            }
        },
        calendar : {
            sameDay : '[วันนี้ เวลา] LT',
            nextDay : '[พรุ่งนี้ เวลา] LT',
            nextWeek : 'dddd[หน้า เวลา] LT',
            lastDay : '[เมื่อวานนี้ เวลา] LT',
            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'อีก %s',
            past : '%sที่แล้ว',
            s : 'ไม่กี่วินาที',
            ss : '%d วินาที',
            m : '1 นาที',
            mm : '%d นาที',
            h : '1 ชั่วโมง',
            hh : '%d ชั่วโมง',
            d : '1 วัน',
            dd : '%d วัน',
            M : '1 เดือน',
            MM : '%d เดือน',
            y : '1 ปี',
            yy : '%d ปี'
        }
    });

    return th;

})));


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var tlPh = moment.defineLocale('tl-ph', {
        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'MM/D/YYYY',
            LL : 'MMMM D, YYYY',
            LLL : 'MMMM D, YYYY HH:mm',
            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
        },
        calendar : {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'sa loob ng %s',
            past : '%s ang nakalipas',
            s : 'ilang segundo',
            ss : '%d segundo',
            m : 'isang minuto',
            mm : '%d minuto',
            h : 'isang oras',
            hh : '%d oras',
            d : 'isang araw',
            dd : '%d araw',
            M : 'isang buwan',
            MM : '%d buwan',
            y : 'isang taon',
            yy : '%d taon'
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal : function (number) {
            return number;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return tlPh;

})));


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

    function translateFuture(output) {
        var time = output;
        time = (output.indexOf('jaj') !== -1) ?
        time.slice(0, -3) + 'leS' :
        (output.indexOf('jar') !== -1) ?
        time.slice(0, -3) + 'waQ' :
        (output.indexOf('DIS') !== -1) ?
        time.slice(0, -3) + 'nem' :
        time + ' pIq';
        return time;
    }

    function translatePast(output) {
        var time = output;
        time = (output.indexOf('jaj') !== -1) ?
        time.slice(0, -3) + 'Hu’' :
        (output.indexOf('jar') !== -1) ?
        time.slice(0, -3) + 'wen' :
        (output.indexOf('DIS') !== -1) ?
        time.slice(0, -3) + 'ben' :
        time + ' ret';
        return time;
    }

    function translate(number, withoutSuffix, string, isFuture) {
        var numberNoun = numberAsNoun(number);
        switch (string) {
            case 'ss':
                return numberNoun + ' lup';
            case 'mm':
                return numberNoun + ' tup';
            case 'hh':
                return numberNoun + ' rep';
            case 'dd':
                return numberNoun + ' jaj';
            case 'MM':
                return numberNoun + ' jar';
            case 'yy':
                return numberNoun + ' DIS';
        }
    }

    function numberAsNoun(number) {
        var hundred = Math.floor((number % 1000) / 100),
        ten = Math.floor((number % 100) / 10),
        one = number % 10,
        word = '';
        if (hundred > 0) {
            word += numbersNouns[hundred] + 'vatlh';
        }
        if (ten > 0) {
            word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
        }
        if (one > 0) {
            word += ((word !== '') ? ' ' : '') + numbersNouns[one];
        }
        return (word === '') ? 'pagh' : word;
    }

    var tlh = moment.defineLocale('tlh', {
        months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
        monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
        monthsParseExact : true,
        weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[DaHjaj] LT',
            nextDay: '[wa’leS] LT',
            nextWeek: 'LLL',
            lastDay: '[wa’Hu’] LT',
            lastWeek: 'LLL',
            sameElse: 'L'
        },
        relativeTime : {
            future : translateFuture,
            past : translatePast,
            s : 'puS lup',
            ss : translate,
            m : 'wa’ tup',
            mm : translate,
            h : 'wa’ rep',
            hh : translate,
            d : 'wa’ jaj',
            dd : translate,
            M : 'wa’ jar',
            MM : translate,
            y : 'wa’ DIS',
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return tlh;

})));


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {


;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    var suffixes = {
        1: '\'inci',
        5: '\'inci',
        8: '\'inci',
        70: '\'inci',
        80: '\'inci',
        2: '\'nci',
        7: '\'nci',
        20: '\'nci',
        50: '\'nci',
        3: '\'üncü',
        4: '\'üncü',
        100: '\'üncü',
        6: '\'ncı',
        9: '\'uncu',
        10: '\'uncu',
        30: '\'uncu',
        60: '\'ıncı',
        90: '\'ıncı'
    };

    var tr = moment.defineLocale('tr', {
        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[bugün saat] LT',
            nextDay : '[yarın saat] LT',
            nextWeek : '[gelecek] dddd [saat] LT',
            lastDay : '[dün] LT',
            lastWeek : '[geçen] dddd [saat] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s sonra',
            past : '%s önce',
            s : 'birkaç saniye',
            ss : '%d saniye',
            m : 'bir dakika',
            mm : '%d dakika',
            h : 'bir saat',
            hh : '%d saat',
            d : 'bir gün',
            dd : '%d gün',
            M : 'bir ay',
            MM : '%d ay',
            y : 'bir yıl',
            yy : '%d yıl'
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {  // special case for zero
                        return number + '\'ıncı';
                    }
                    var a = number % 10,
                        b = number % 100 - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return tr;

})));


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
    // This is currently too difficult (maybe even impossible) to add.
    var tzl = moment.defineLocale('tzl', {
        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM [dallas] YYYY',
            LLL : 'D. MMMM [dallas] YYYY HH.mm',
            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM : function (input) {
            return 'd\'o' === input.toLowerCase();
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'd\'o' : 'D\'O';
            } else {
                return isLower ? 'd\'a' : 'D\'A';
            }
        },
        calendar : {
            sameDay : '[oxhi à] LT',
            nextDay : '[demà à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[ieiri à] LT',
            lastWeek : '[sür el] dddd [lasteu à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'osprei %s',
            past : 'ja%s',
            s : processRelativeTime,
            ss : processRelativeTime,
            m : processRelativeTime,
            mm : processRelativeTime,
            h : processRelativeTime,
            hh : processRelativeTime,
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            's': ['viensas secunds', '\'iensas secunds'],
            'ss': [number + ' secunds', '' + number + ' secunds'],
            'm': ['\'n míut', '\'iens míut'],
            'mm': [number + ' míuts', '' + number + ' míuts'],
            'h': ['\'n þora', '\'iensa þora'],
            'hh': [number + ' þoras', '' + number + ' þoras'],
            'd': ['\'n ziua', '\'iensa ziua'],
            'dd': [number + ' ziuas', '' + number + ' ziuas'],
            'M': ['\'n mes', '\'iens mes'],
            'MM': [number + ' mesen', '' + number + ' mesen'],
            'y': ['\'n ar', '\'iens ar'],
            'yy': [number + ' ars', '' + number + ' ars']
        };
        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
    }

    return tzl;

})));


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var tzm = moment.defineLocale('tzm', {
        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
            nextWeek: 'dddd [ⴴ] LT',
            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
            lastWeek: 'dddd [ⴴ] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
            past : 'ⵢⴰⵏ %s',
            s : 'ⵉⵎⵉⴽ',
            ss : '%d ⵉⵎⵉⴽ',
            m : 'ⵎⵉⵏⵓⴺ',
            mm : '%d ⵎⵉⵏⵓⴺ',
            h : 'ⵙⴰⵄⴰ',
            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
            d : 'ⴰⵙⵙ',
            dd : '%d oⵙⵙⴰⵏ',
            M : 'ⴰⵢoⵓⵔ',
            MM : '%d ⵉⵢⵢⵉⵔⵏ',
            y : 'ⴰⵙⴳⴰⵙ',
            yy : '%d ⵉⵙⴳⴰⵙⵏ'
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return tzm;

})));


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var tzmLatn = moment.defineLocale('tzm-latn', {
        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[asdkh g] LT',
            nextDay: '[aska g] LT',
            nextWeek: 'dddd [g] LT',
            lastDay: '[assant g] LT',
            lastWeek: 'dddd [g] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'dadkh s yan %s',
            past : 'yan %s',
            s : 'imik',
            ss : '%d imik',
            m : 'minuḍ',
            mm : '%d minuḍ',
            h : 'saɛa',
            hh : '%d tassaɛin',
            d : 'ass',
            dd : '%d ossan',
            M : 'ayowr',
            MM : '%d iyyirn',
            y : 'asgas',
            yy : '%d isgasn'
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return tzmLatn;

})));


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js language configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ugCn = moment.defineLocale('ug-cn', {
        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
            '_'
        ),
        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm'
        },
        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                meridiem === 'يېرىم كېچە' ||
                meridiem === 'سەھەر' ||
                meridiem === 'چۈشتىن بۇرۇن'
            ) {
                return hour;
            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
                return hour + 12;
            } else {
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return 'يېرىم كېچە';
            } else if (hm < 900) {
                return 'سەھەر';
            } else if (hm < 1130) {
                return 'چۈشتىن بۇرۇن';
            } else if (hm < 1230) {
                return 'چۈش';
            } else if (hm < 1800) {
                return 'چۈشتىن كېيىن';
            } else {
                return 'كەچ';
            }
        },
        calendar: {
            sameDay: '[بۈگۈن سائەت] LT',
            nextDay: '[ئەتە سائەت] LT',
            nextWeek: '[كېلەركى] dddd [سائەت] LT',
            lastDay: '[تۆنۈگۈن] LT',
            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s كېيىن',
            past: '%s بۇرۇن',
            s: 'نەچچە سېكونت',
            ss: '%d سېكونت',
            m: 'بىر مىنۇت',
            mm: '%d مىنۇت',
            h: 'بىر سائەت',
            hh: '%d سائەت',
            d: 'بىر كۈن',
            dd: '%d كۈن',
            M: 'بىر ئاي',
            MM: '%d ئاي',
            y: 'بىر يىل',
            yy: '%d يىل'
        },

        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '-كۈنى';
                case 'w':
                case 'W':
                    return number + '-ھەپتە';
                default:
                    return number;
            }
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ugCn;

})));


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
            'dd': 'день_дні_днів',
            'MM': 'місяць_місяці_місяців',
            'yy': 'рік_роки_років'
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвилина' : 'хвилину';
        }
        else if (key === 'h') {
            return withoutSuffix ? 'година' : 'годину';
        }
        else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    function weekdaysCaseReplace(m, format) {
        var weekdays = {
            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
        };

        if (!m) {
            return weekdays['nominative'];
        }

        var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
            'accusative' :
            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
                'genitive' :
                'nominative');
        return weekdays[nounCase][m.day()];
    }
    function processHoursFunction(str) {
        return function () {
            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
        };
    }

    var uk = moment.defineLocale('uk', {
        months : {
            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
        },
        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
        weekdays : weekdaysCaseReplace,
        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY р.',
            LLL : 'D MMMM YYYY р., HH:mm',
            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
        },
        calendar : {
            sameDay: processHoursFunction('[Сьогодні '),
            nextDay: processHoursFunction('[Завтра '),
            lastDay: processHoursFunction('[Вчора '),
            nextWeek: processHoursFunction('[У] dddd ['),
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return processHoursFunction('[Минулої] dddd [').call(this);
                    case 1:
                    case 2:
                    case 4:
                        return processHoursFunction('[Минулого] dddd [').call(this);
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'за %s',
            past : '%s тому',
            s : 'декілька секунд',
            ss : relativeTimeWithPlural,
            m : relativeTimeWithPlural,
            mm : relativeTimeWithPlural,
            h : 'годину',
            hh : relativeTimeWithPlural,
            d : 'день',
            dd : relativeTimeWithPlural,
            M : 'місяць',
            MM : relativeTimeWithPlural,
            y : 'рік',
            yy : relativeTimeWithPlural
        },
        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function (input) {
            return /^(дня|вечора)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночі';
            } else if (hour < 12) {
                return 'ранку';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечора';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return uk;

})));


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = [
        'جنوری',
        'فروری',
        'مارچ',
        'اپریل',
        'مئی',
        'جون',
        'جولائی',
        'اگست',
        'ستمبر',
        'اکتوبر',
        'نومبر',
        'دسمبر'
    ];
    var days = [
        'اتوار',
        'پیر',
        'منگل',
        'بدھ',
        'جمعرات',
        'جمعہ',
        'ہفتہ'
    ];

    var ur = moment.defineLocale('ur', {
        months : months,
        monthsShort : months,
        weekdays : days,
        weekdaysShort : days,
        weekdaysMin : days,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd، D MMMM YYYY HH:mm'
        },
        meridiemParse: /صبح|شام/,
        isPM : function (input) {
            return 'شام' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar : {
            sameDay : '[آج بوقت] LT',
            nextDay : '[کل بوقت] LT',
            nextWeek : 'dddd [بوقت] LT',
            lastDay : '[گذشتہ روز بوقت] LT',
            lastWeek : '[گذشتہ] dddd [بوقت] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s بعد',
            past : '%s قبل',
            s : 'چند سیکنڈ',
            ss : '%d سیکنڈ',
            m : 'ایک منٹ',
            mm : '%d منٹ',
            h : 'ایک گھنٹہ',
            hh : '%d گھنٹے',
            d : 'ایک دن',
            dd : '%d دن',
            M : 'ایک ماہ',
            MM : '%d ماہ',
            y : 'ایک سال',
            yy : '%d سال'
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ur;

})));


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var uz = moment.defineLocale('uz', {
        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'D MMMM YYYY, dddd HH:mm'
        },
        calendar : {
            sameDay : '[Бугун соат] LT [да]',
            nextDay : '[Эртага] LT [да]',
            nextWeek : 'dddd [куни соат] LT [да]',
            lastDay : '[Кеча соат] LT [да]',
            lastWeek : '[Утган] dddd [куни соат] LT [да]',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'Якин %s ичида',
            past : 'Бир неча %s олдин',
            s : 'фурсат',
            ss : '%d фурсат',
            m : 'бир дакика',
            mm : '%d дакика',
            h : 'бир соат',
            hh : '%d соат',
            d : 'бир кун',
            dd : '%d кун',
            M : 'бир ой',
            MM : '%d ой',
            y : 'бир йил',
            yy : '%d йил'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return uz;

})));


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var uzLatn = moment.defineLocale('uz-latn', {
        months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
        monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
        weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
        weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
        weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'D MMMM YYYY, dddd HH:mm'
        },
        calendar : {
            sameDay : '[Bugun soat] LT [da]',
            nextDay : '[Ertaga] LT [da]',
            nextWeek : 'dddd [kuni soat] LT [da]',
            lastDay : '[Kecha soat] LT [da]',
            lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'Yaqin %s ichida',
            past : 'Bir necha %s oldin',
            s : 'soniya',
            ss : '%d soniya',
            m : 'bir daqiqa',
            mm : '%d daqiqa',
            h : 'bir soat',
            hh : '%d soat',
            d : 'bir kun',
            dd : '%d kun',
            M : 'bir oy',
            MM : '%d oy',
            y : 'bir yil',
            yy : '%d yil'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return uzLatn;

})));


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var vi = moment.defineLocale('vi', {
        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
        monthsParseExact : true,
        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysParseExact : true,
        meridiemParse: /sa|ch/i,
        isPM : function (input) {
            return /^ch$/i.test(input);
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'sa' : 'SA';
            } else {
                return isLower ? 'ch' : 'CH';
            }
        },
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM [năm] YYYY',
            LLL : 'D MMMM [năm] YYYY HH:mm',
            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
            l : 'DD/M/YYYY',
            ll : 'D MMM YYYY',
            lll : 'D MMM YYYY HH:mm',
            llll : 'ddd, D MMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Hôm nay lúc] LT',
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần rồi lúc] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s tới',
            past : '%s trước',
            s : 'vài giây',
            ss : '%d giây' ,
            m : 'một phút',
            mm : '%d phút',
            h : 'một giờ',
            hh : '%d giờ',
            d : 'một ngày',
            dd : '%d ngày',
            M : 'một tháng',
            MM : '%d tháng',
            y : 'một năm',
            yy : '%d năm'
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal : function (number) {
            return number;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return vi;

})));


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var xPseudo = moment.defineLocale('x-pseudo', {
        months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
        monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
        monthsParseExact : true,
        weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
        weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
        weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[T~ódá~ý át] LT',
            nextDay : '[T~ómó~rró~w át] LT',
            nextWeek : 'dddd [át] LT',
            lastDay : '[Ý~ést~érdá~ý át] LT',
            lastWeek : '[L~ást] dddd [át] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'í~ñ %s',
            past : '%s á~gó',
            s : 'á ~féw ~sécó~ñds',
            ss : '%d s~écóñ~ds',
            m : 'á ~míñ~úté',
            mm : '%d m~íñú~tés',
            h : 'á~ñ hó~úr',
            hh : '%d h~óúrs',
            d : 'á ~dáý',
            dd : '%d d~áýs',
            M : 'á ~móñ~th',
            MM : '%d m~óñt~hs',
            y : 'á ~ýéár',
            yy : '%d ý~éárs'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return xPseudo;

})));


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var yo = moment.defineLocale('yo', {
        months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
        monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
        weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
        weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
        weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Ònì ni] LT',
            nextDay : '[Ọ̀la ni] LT',
            nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
            lastDay : '[Àna ni] LT',
            lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ní %s',
            past : '%s kọjá',
            s : 'ìsẹjú aayá die',
            ss :'aayá %d',
            m : 'ìsẹjú kan',
            mm : 'ìsẹjú %d',
            h : 'wákati kan',
            hh : 'wákati %d',
            d : 'ọjọ́ kan',
            dd : 'ọjọ́ %d',
            M : 'osù kan',
            MM : 'osù %d',
            y : 'ọdún kan',
            yy : 'ọdún %d'
        },
        dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
        ordinal : 'ọjọ́ %d',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return yo;

})));


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var zhCn = moment.defineLocale('zh-cn', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日Ah点mm分',
            LLLL : 'YYYY年M月D日ddddAh点mm分',
            l : 'YYYY/M/D',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' ||
                    meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : '[今天]LT',
            nextDay : '[明天]LT',
            nextWeek : '[下]ddddLT',
            lastDay : '[昨天]LT',
            lastWeek : '[上]ddddLT',
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime : {
            future : '%s内',
            past : '%s前',
            s : '几秒',
            ss : '%d 秒',
            m : '1 分钟',
            mm : '%d 分钟',
            h : '1 小时',
            hh : '%d 小时',
            d : '1 天',
            dd : '%d 天',
            M : '1 个月',
            MM : '%d 个月',
            y : '1 年',
            yy : '%d 年'
        },
        week : {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return zhCn;

})));


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var zhHk = moment.defineLocale('zh-hk', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日 HH:mm',
            LLLL : 'YYYY年M月D日dddd HH:mm',
            l : 'YYYY/M/D',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : '[今天]LT',
            nextDay : '[明天]LT',
            nextWeek : '[下]ddddLT',
            lastDay : '[昨天]LT',
            lastWeek : '[上]ddddLT',
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd' :
                case 'D' :
                case 'DDD' :
                    return number + '日';
                case 'M' :
                    return number + '月';
                case 'w' :
                case 'W' :
                    return number + '週';
                default :
                    return number;
            }
        },
        relativeTime : {
            future : '%s內',
            past : '%s前',
            s : '幾秒',
            ss : '%d 秒',
            m : '1 分鐘',
            mm : '%d 分鐘',
            h : '1 小時',
            hh : '%d 小時',
            d : '1 天',
            dd : '%d 天',
            M : '1 個月',
            MM : '%d 個月',
            y : '1 年',
            yy : '%d 年'
        }
    });

    return zhHk;

})));


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var zhTw = moment.defineLocale('zh-tw', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日 HH:mm',
            LLLL : 'YYYY年M月D日dddd HH:mm',
            l : 'YYYY/M/D',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : '[今天] LT',
            nextDay : '[明天] LT',
            nextWeek : '[下]dddd LT',
            lastDay : '[昨天] LT',
            lastWeek : '[上]dddd LT',
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd' :
                case 'D' :
                case 'DDD' :
                    return number + '日';
                case 'M' :
                    return number + '月';
                case 'w' :
                case 'W' :
                    return number + '週';
                default :
                    return number;
            }
        },
        relativeTime : {
            future : '%s內',
            past : '%s前',
            s : '幾秒',
            ss : '%d 秒',
            m : '1 分鐘',
            mm : '%d 分鐘',
            h : '1 小時',
            hh : '%d 小時',
            d : '1 天',
            dd : '%d 天',
            M : '1 個月',
            MM : '%d 個月',
            y : '1 年',
            yy : '%d 年'
        }
    });

    return zhTw;

})));


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(2);
var FocusTrap = __webpack_require__(525);
var displace = __webpack_require__(528);
var noScroll = __webpack_require__(529);

var Modal = function (_React$Component) {
  _inherits(Modal, _React$Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.getApplicationNode = function () {
      if (_this.props.getApplicationNode) return _this.props.getApplicationNode();
      return _this.props.applicationNode;
    }, _this.checkUnderlayClick = function (event) {
      if (_this.dialogNode && _this.dialogNode.contains(event.target)) return;
      _this.exit();
    }, _this.checkDocumentKeyDown = function (event) {
      if (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27) {
        _this.exit();
      }
    }, _this.exit = function () {
      if (_this.props.onExit) {
        _this.props.onExit();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (!this.props.titleText && !this.props.titleId) {
        throw new Error('react-aria-modal instances should have a `titleText` or `titleId`');
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var props = this.props;
      if (props.onEnter) {
        props.onEnter();
      }

      // Timeout to ensure this happens *after* focus has moved
      var applicationNode = this.getApplicationNode();
      setTimeout(function () {
        if (applicationNode) {
          applicationNode.setAttribute('aria-hidden', 'true');
        }
      }, 0);

      if (props.escapeExits) {
        document.addEventListener('keydown', this.checkDocumentKeyDown);
      }

      if (this.props.scrollDisabled) {
        noScroll.on();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.scrollDisabled && !this.props.scrollDisabled) {
        noScroll.off();
      } else if (!prevProps.scrollDisabled && this.props.scrollDisabled) {
        noScroll.on();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.scrollDisabled) {
        noScroll.off();
      }
      var applicationNode = this.getApplicationNode();
      if (applicationNode) {
        applicationNode.setAttribute('aria-hidden', 'false');
      }
      document.removeEventListener('keydown', this.checkDocumentKeyDown);
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props;

      var style = {};
      if (props.includeDefaultStyles) {
        style = {
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 1050,
          overflowX: 'hidden',
          overflowY: 'auto',
          WebkitOverflowScrolling: 'touch',
          textAlign: 'center'
        };

        if (props.underlayColor) {
          style.background = props.underlayColor;
        }

        if (props.underlayClickExits) {
          style.cursor = 'pointer';
        }
      }

      if (props.underlayStyle) {
        for (var key in props.underlayStyle) {
          if (!props.underlayStyle.hasOwnProperty(key)) continue;
          style[key] = props.underlayStyle[key];
        }
      }

      var underlayProps = {
        className: props.underlayClass,
        style: style
      };

      if (props.underlayClickExits) {
        underlayProps.onMouseDown = this.checkUnderlayClick;
      }

      for (var prop in this.props.underlayProps) {
        underlayProps[prop] = this.props.underlayProps[prop];
      }

      var verticalCenterStyle = {};
      if (props.includeDefaultStyles) {
        verticalCenterStyle = {
          display: 'inline-block',
          height: '100%',
          verticalAlign: 'middle'
        };
      }

      var verticalCenterHelperProps = {
        key: 'a',
        style: verticalCenterStyle
      };

      var dialogStyle = {};
      if (props.includeDefaultStyles) {
        dialogStyle = {
          display: 'inline-block',
          textAlign: 'left',
          top: 0,
          maxWidth: '100%',
          cursor: 'default',
          outline: props.focusDialog ? 0 : null
        };

        if (props.verticallyCenter) {
          dialogStyle.verticalAlign = 'middle';
          dialogStyle.top = 0;
        }
      }

      if (props.dialogStyle) {
        for (var _key2 in props.dialogStyle) {
          if (!props.dialogStyle.hasOwnProperty(_key2)) continue;
          dialogStyle[_key2] = props.dialogStyle[_key2];
        }
      }

      var dialogProps = {
        key: 'b',
        ref: function (el) {
          this.dialogNode = el;
        }.bind(this),
        role: props.alert ? 'alertdialog' : 'dialog',
        id: props.dialogId,
        className: props.dialogClass,
        style: dialogStyle
      };
      if (props.titleId) {
        dialogProps['aria-labelledby'] = props.titleId;
      } else if (props.titleText) {
        dialogProps['aria-label'] = props.titleText;
      }
      if (props.focusDialog) {
        dialogProps.tabIndex = '-1';
      }

      // Apply data- and aria- attributes passed as props
      for (var _key3 in props) {
        if (/^(data-|aria-)/.test(_key3)) {
          dialogProps[_key3] = props[_key3];
        }
      }

      var childrenArray = [React.createElement('div', dialogProps, props.children)];

      if (props.verticallyCenter) {
        childrenArray.unshift(React.createElement('div', verticalCenterHelperProps));
      }

      var focusTrapOptions = props.focusTrapOptions || {};
      if (props.focusDialog || props.initialFocus) {
        focusTrapOptions.initialFocus = props.focusDialog ? '#' + this.props.dialogId : props.initialFocus;
      }
      focusTrapOptions.escapeDeactivates = props.escapeExits;

      return React.createElement(FocusTrap, {
        focusTrapOptions: focusTrapOptions,
        paused: props.focusTrapPaused
      }, React.createElement('div', underlayProps, childrenArray));
    }
  }]);

  return Modal;
}(React.Component);

Modal.defaultProps = {
  underlayProps: {},
  dialogId: 'react-aria-modal-dialog',
  underlayClickExits: true,
  escapeExits: true,
  underlayColor: 'rgba(0,0,0,0.5)',
  includeDefaultStyles: true,
  focusTrapPaused: false,
  scrollDisabled: true
};


var DisplacedModal = displace(Modal);

DisplacedModal.renderTo = function (input) {
  return displace(Modal, { renderTo: input });
};

module.exports = DisplacedModal;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(291);
module.exports = __webpack_require__(8);


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(292);

__webpack_require__(462);

__webpack_require__(463);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)))

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(113);
__webpack_require__(294);
__webpack_require__(295);
__webpack_require__(296);
__webpack_require__(297);
__webpack_require__(298);
__webpack_require__(7);
__webpack_require__(299);
__webpack_require__(300);
__webpack_require__(301);
__webpack_require__(302);
__webpack_require__(303);
__webpack_require__(304);
__webpack_require__(305);
__webpack_require__(4);
__webpack_require__(306);
__webpack_require__(307);
__webpack_require__(308);
__webpack_require__(309);
__webpack_require__(37);
__webpack_require__(310);
__webpack_require__(311);
__webpack_require__(312);
__webpack_require__(91);
__webpack_require__(313);
__webpack_require__(314);
__webpack_require__(315);
__webpack_require__(316);
__webpack_require__(126);
__webpack_require__(317);
__webpack_require__(318);
__webpack_require__(319);
__webpack_require__(320);
__webpack_require__(321);
__webpack_require__(322);
__webpack_require__(323);
__webpack_require__(324);
__webpack_require__(325);
__webpack_require__(326);
__webpack_require__(327);
__webpack_require__(328);
__webpack_require__(329);
__webpack_require__(330);
__webpack_require__(331);
__webpack_require__(332);
__webpack_require__(333);
__webpack_require__(334);
__webpack_require__(335);
__webpack_require__(336);
__webpack_require__(337);
__webpack_require__(338);
__webpack_require__(339);
__webpack_require__(130);
__webpack_require__(340);
__webpack_require__(341);
__webpack_require__(342);
__webpack_require__(131);
__webpack_require__(132);
__webpack_require__(20);
__webpack_require__(343);
__webpack_require__(133);
__webpack_require__(100);
__webpack_require__(344);
__webpack_require__(345);
__webpack_require__(346);
__webpack_require__(134);
__webpack_require__(347);
__webpack_require__(348);
__webpack_require__(349);
__webpack_require__(135);
__webpack_require__(136);
__webpack_require__(350);
__webpack_require__(351);
__webpack_require__(352);
__webpack_require__(353);
__webpack_require__(354);
__webpack_require__(355);
__webpack_require__(137);
__webpack_require__(357);
__webpack_require__(359);
__webpack_require__(360);
__webpack_require__(361);
__webpack_require__(362);
__webpack_require__(363);
__webpack_require__(364);
__webpack_require__(365);
__webpack_require__(367);
__webpack_require__(368);
__webpack_require__(369);
__webpack_require__(370);
__webpack_require__(371);
__webpack_require__(372);
__webpack_require__(373);
__webpack_require__(374);
__webpack_require__(375);
__webpack_require__(376);
__webpack_require__(106);
__webpack_require__(377);
__webpack_require__(378);
__webpack_require__(5);
__webpack_require__(142);
__webpack_require__(143);
__webpack_require__(144);
__webpack_require__(145);
__webpack_require__(58);
__webpack_require__(65);
__webpack_require__(379);
__webpack_require__(66);
__webpack_require__(380);
__webpack_require__(148);
__webpack_require__(150);
__webpack_require__(151);
__webpack_require__(381);
__webpack_require__(382);
__webpack_require__(383);
__webpack_require__(384);
__webpack_require__(385);
__webpack_require__(386);
__webpack_require__(387);
__webpack_require__(388);
__webpack_require__(389);
__webpack_require__(390);
__webpack_require__(391);
__webpack_require__(392);
__webpack_require__(393);
__webpack_require__(394);
__webpack_require__(395);
__webpack_require__(396);
__webpack_require__(397);
__webpack_require__(398);
__webpack_require__(399);
__webpack_require__(400);
__webpack_require__(401);
__webpack_require__(402);
__webpack_require__(403);
__webpack_require__(404);
__webpack_require__(405);
__webpack_require__(406);
__webpack_require__(19);
__webpack_require__(407);
__webpack_require__(408);
__webpack_require__(409);
__webpack_require__(410);
__webpack_require__(411);
__webpack_require__(412);
__webpack_require__(413);
__webpack_require__(414);
__webpack_require__(157);
__webpack_require__(415);
__webpack_require__(416);
__webpack_require__(158);
__webpack_require__(417);
__webpack_require__(418);
__webpack_require__(419);
__webpack_require__(420);
__webpack_require__(421);
__webpack_require__(422);
__webpack_require__(423);
__webpack_require__(424);
__webpack_require__(425);
__webpack_require__(426);
__webpack_require__(427);
__webpack_require__(428);
__webpack_require__(429);
__webpack_require__(430);
__webpack_require__(431);
__webpack_require__(432);
__webpack_require__(433);
__webpack_require__(434);
__webpack_require__(435);
__webpack_require__(436);
__webpack_require__(437);
__webpack_require__(438);
__webpack_require__(439);
__webpack_require__(440);
__webpack_require__(441);
__webpack_require__(442);
__webpack_require__(443);
__webpack_require__(444);
__webpack_require__(445);
__webpack_require__(446);
__webpack_require__(447);
__webpack_require__(448);
__webpack_require__(449);
__webpack_require__(450);
__webpack_require__(451);
__webpack_require__(452);
__webpack_require__(453);
__webpack_require__(454);
__webpack_require__(455);
__webpack_require__(456);
__webpack_require__(457);
__webpack_require__(458);
__webpack_require__(459);
__webpack_require__(460);
__webpack_require__(461);
__webpack_require__(6);
module.exports = __webpack_require__(29);


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(46);
var gOPS = __webpack_require__(71);
var pIE = __webpack_require__(63);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(48) });


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(16), 'Object', { defineProperty: __webpack_require__(17).f });


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(16), 'Object', { defineProperties: __webpack_require__(117) });


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(26);
var $getOwnPropertyDescriptor = __webpack_require__(27).f;

__webpack_require__(36)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(18);
var $getPrototypeOf = __webpack_require__(28);

__webpack_require__(36)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(36)('getOwnPropertyNames', function () {
  return __webpack_require__(118).f;
});


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(12);
var meta = __webpack_require__(41).onFreeze;

__webpack_require__(36)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(12);
var meta = __webpack_require__(41).onFreeze;

__webpack_require__(36)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(12);
var meta = __webpack_require__(41).onFreeze;

__webpack_require__(36)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(12);

__webpack_require__(36)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(12);

__webpack_require__(36)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(12);

__webpack_require__(36)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { is: __webpack_require__(120) });


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(89).set });


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(55);
var test = {};
test[__webpack_require__(14)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(23)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(0);

$export($export.P, 'Function', { bind: __webpack_require__(121) });


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(12);
var getPrototypeOf = __webpack_require__(28);
var HAS_INSTANCE = __webpack_require__(14)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(17).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(123);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(124);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toInteger = __webpack_require__(32);
var aNumberValue = __webpack_require__(125);
var repeat = __webpack_require__(93);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(11)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $fails = __webpack_require__(11);
var aNumberValue = __webpack_require__(125);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(0);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(0);
var _isFinite = __webpack_require__(10).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(0);
var isInteger = __webpack_require__(127);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(124);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(123);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(0);
var log1p = __webpack_require__(128);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(0);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(0);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(0);
var sign = __webpack_require__(94);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(0);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(0);
var $expm1 = __webpack_require__(95);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { fround: __webpack_require__(129) });


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(0);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(0);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(11)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { log1p: __webpack_require__(128) });


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { sign: __webpack_require__(94) });


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(95);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(11)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(95);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(26);
var toLength = __webpack_require__(15);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(56)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(73)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(96)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(93)
});


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(24)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(24)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(24)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(24)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(24)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(24)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(24)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(24)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(24)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(0);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(18);
var toPrimitive = __webpack_require__(34);

$export($export.P + $export.F * __webpack_require__(11)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(0);
var toISOString = __webpack_require__(356);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(11);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(14)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(22)(proto, TO_PRIMITIVE, __webpack_require__(358));


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(9);
var toPrimitive = __webpack_require__(34);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(0);

$export($export.S, 'Array', { isArray: __webpack_require__(72) });


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(30);
var $export = __webpack_require__(0);
var toObject = __webpack_require__(18);
var call = __webpack_require__(138);
var isArrayIter = __webpack_require__(101);
var toLength = __webpack_require__(15);
var createProperty = __webpack_require__(102);
var getIterFn = __webpack_require__(103);

$export($export.S + $export.F * !__webpack_require__(75)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var createProperty = __webpack_require__(102);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(11)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(0);
var toIObject = __webpack_require__(26);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(62) != Object || !__webpack_require__(33)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var html = __webpack_require__(88);
var cof = __webpack_require__(31);
var toAbsoluteIndex = __webpack_require__(47);
var toLength = __webpack_require__(15);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(11)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var aFunction = __webpack_require__(21);
var toObject = __webpack_require__(18);
var fails = __webpack_require__(11);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(33)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $forEach = __webpack_require__(38)(0);
var STRICT = __webpack_require__(33)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(12);
var isArray = __webpack_require__(72);
var SPECIES = __webpack_require__(14)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $map = __webpack_require__(38)(1);

$export($export.P + $export.F * !__webpack_require__(33)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $filter = __webpack_require__(38)(2);

$export($export.P + $export.F * !__webpack_require__(33)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $some = __webpack_require__(38)(3);

$export($export.P + $export.F * !__webpack_require__(33)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $every = __webpack_require__(38)(4);

$export($export.P + $export.F * !__webpack_require__(33)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(139);

$export($export.P + $export.F * !__webpack_require__(33)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(139);

$export($export.P + $export.F * !__webpack_require__(33)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $indexOf = __webpack_require__(70)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(33)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(26);
var toInteger = __webpack_require__(32);
var toLength = __webpack_require__(15);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(33)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { copyWithin: __webpack_require__(140) });

__webpack_require__(43)('copyWithin');


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { fill: __webpack_require__(105) });

__webpack_require__(43)('fill');


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(38)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(43)(KEY);


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(50)('Array');


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(9);
var sameValue = __webpack_require__(120);
var regExpExec = __webpack_require__(76);

// @@search logic
__webpack_require__(77)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(42);
var global = __webpack_require__(10);
var ctx = __webpack_require__(30);
var classof = __webpack_require__(55);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(12);
var aFunction = __webpack_require__(21);
var anInstance = __webpack_require__(51);
var forOf = __webpack_require__(52);
var speciesConstructor = __webpack_require__(67);
var task = __webpack_require__(109).set;
var microtask = __webpack_require__(110)();
var newPromiseCapabilityModule = __webpack_require__(111);
var perform = __webpack_require__(146);
var userAgent = __webpack_require__(78);
var promiseResolve = __webpack_require__(147);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(14)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(53)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(54)($Promise, PROMISE);
__webpack_require__(50)(PROMISE);
Wrapper = __webpack_require__(29)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(75)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(152);
var validate = __webpack_require__(59);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(79)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $typed = __webpack_require__(80);
var buffer = __webpack_require__(112);
var anObject = __webpack_require__(9);
var toAbsoluteIndex = __webpack_require__(47);
var toLength = __webpack_require__(15);
var isObject = __webpack_require__(12);
var ArrayBuffer = __webpack_require__(10).ArrayBuffer;
var speciesConstructor = __webpack_require__(67);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(11)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(50)(ARRAY_BUFFER);


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
$export($export.G + $export.W + $export.F * !__webpack_require__(80).ABV, {
  DataView: __webpack_require__(112).DataView
});


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(39)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(39)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(39)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(39)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(39)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(39)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(39)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(39)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(39)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(21);
var anObject = __webpack_require__(9);
var rApply = (__webpack_require__(10).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(11)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(0);
var create = __webpack_require__(48);
var aFunction = __webpack_require__(21);
var anObject = __webpack_require__(9);
var isObject = __webpack_require__(12);
var fails = __webpack_require__(11);
var bind = __webpack_require__(121);
var rConstruct = (__webpack_require__(10).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(17);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(9);
var toPrimitive = __webpack_require__(34);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(11)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(0);
var gOPD = __webpack_require__(27).f;
var anObject = __webpack_require__(9);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(9);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(97)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(27);
var getPrototypeOf = __webpack_require__(28);
var has = __webpack_require__(25);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(12);
var anObject = __webpack_require__(9);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(27);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(9);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(0);
var getProto = __webpack_require__(28);
var anObject = __webpack_require__(9);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(9);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(154) });


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(9);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(17);
var gOPD = __webpack_require__(27);
var getPrototypeOf = __webpack_require__(28);
var has = __webpack_require__(25);
var $export = __webpack_require__(0);
var createDesc = __webpack_require__(44);
var anObject = __webpack_require__(9);
var isObject = __webpack_require__(12);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(0);
var setProto = __webpack_require__(89);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(155);
var toObject = __webpack_require__(18);
var toLength = __webpack_require__(15);
var aFunction = __webpack_require__(21);
var arraySpeciesCreate = __webpack_require__(104);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(43)('flatMap');


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(155);
var toObject = __webpack_require__(18);
var toLength = __webpack_require__(15);
var toInteger = __webpack_require__(32);
var arraySpeciesCreate = __webpack_require__(104);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(43)('flatten');


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(0);
var $at = __webpack_require__(73)(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(156);
var userAgent = __webpack_require__(78);

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(156);
var userAgent = __webpack_require__(78);

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(56)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(56)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(0);
var defined = __webpack_require__(35);
var toLength = __webpack_require__(15);
var isRegExp = __webpack_require__(74);
var getFlags = __webpack_require__(64);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(97)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(85)('observable');


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(0);
var ownKeys = __webpack_require__(154);
var toIObject = __webpack_require__(26);
var gOPD = __webpack_require__(27);
var createProperty = __webpack_require__(102);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $entries = __webpack_require__(159)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(18);
var aFunction = __webpack_require__(21);
var $defineProperty = __webpack_require__(17);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(16) && $export($export.P + __webpack_require__(81), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(18);
var aFunction = __webpack_require__(21);
var $defineProperty = __webpack_require__(17);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(16) && $export($export.P + __webpack_require__(81), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(18);
var toPrimitive = __webpack_require__(34);
var getPrototypeOf = __webpack_require__(28);
var getOwnPropertyDescriptor = __webpack_require__(27).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(16) && $export($export.P + __webpack_require__(81), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(18);
var toPrimitive = __webpack_require__(34);
var getPrototypeOf = __webpack_require__(28);
var getOwnPropertyDescriptor = __webpack_require__(27).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(16) && $export($export.P + __webpack_require__(81), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(160)('Map') });


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(160)('Set') });


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(82)('Map');


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(82)('Set');


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(82)('WeakMap');


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(82)('WeakSet');


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(83)('Map');


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(83)('Set');


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(83)('WeakMap');


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(83)('WeakSet');


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.G, { global: __webpack_require__(10) });


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.S, 'System', { global: __webpack_require__(10) });


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(0);
var cof = __webpack_require__(31);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var scale = __webpack_require__(162);
var fround = __webpack_require__(129);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { scale: __webpack_require__(162) });


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(0);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(0);
var core = __webpack_require__(29);
var global = __webpack_require__(10);
var speciesConstructor = __webpack_require__(67);
var promiseResolve = __webpack_require__(147);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(0);
var newPromiseCapability = __webpack_require__(111);
var perform = __webpack_require__(146);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(40);
var anObject = __webpack_require__(9);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(40);
var anObject = __webpack_require__(9);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(40);
var anObject = __webpack_require__(9);
var getPrototypeOf = __webpack_require__(28);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(150);
var from = __webpack_require__(161);
var metadata = __webpack_require__(40);
var anObject = __webpack_require__(9);
var getPrototypeOf = __webpack_require__(28);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(40);
var anObject = __webpack_require__(9);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(40);
var anObject = __webpack_require__(9);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(40);
var anObject = __webpack_require__(9);
var getPrototypeOf = __webpack_require__(28);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(40);
var anObject = __webpack_require__(9);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(40);
var anObject = __webpack_require__(9);
var aFunction = __webpack_require__(21);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(0);
var microtask = __webpack_require__(110)();
var process = __webpack_require__(10).process;
var isNode = __webpack_require__(31)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(0);
var global = __webpack_require__(10);
var core = __webpack_require__(29);
var microtask = __webpack_require__(110)();
var OBSERVABLE = __webpack_require__(14)('observable');
var aFunction = __webpack_require__(21);
var anObject = __webpack_require__(9);
var anInstance = __webpack_require__(51);
var redefineAll = __webpack_require__(53);
var hide = __webpack_require__(22);
var forOf = __webpack_require__(52);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(50)('Observable');


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(10);
var $export = __webpack_require__(0);
var userAgent = __webpack_require__(78);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $task = __webpack_require__(109);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)))

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(464);
module.exports = __webpack_require__(29).RegExp.escape;


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(0);
var $re = __webpack_require__(465)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 465 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(19);

__webpack_require__(20);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var AccordionMenu =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(AccordionMenu, _React$Component);

  function AccordionMenu() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      activeIndices: _this.props.initialActive || [],
      focus: false
    };

    _this.verifyChildren = function () {
      var children = _this.props.children;

      var childrenArr = _react.default.Children.toArray(children);

      var status = childrenArr.reduce(function (status, child) {
        return status && child.type.displayName === 'AccordionGroup';
      }, true);
      return children && childrenArr.length && status;
    };

    _this.determineInitialFocus = function () {
      var nonDisabledIndex = _react.default.Children.toArray(_this.props.children).reduceRight(function (agg, child, idx) {
        return !child.props.disabled ? idx : agg;
      }, null);

      _this.setFocus(nonDisabledIndex);
    };

    _this.handleClick = function (index) {
      return _this.props.multipleVisible ? _this.setMultiple(index) : _this.setSelected(index);
    };

    _this.setMultiple = function (index) {
      var newValues;
      var onSelect = _this.props.onSelect;
      var activeIndices = _this.state.activeIndices;
      var isActive = activeIndices.includes(index);

      if (isActive) {
        newValues = activeIndices.filter(function (v) {
          return v !== index;
        });
      } else {
        newValues = activeIndices.concat(index);
      }

      _this.setFocus(index);

      _this.setState(function () {
        onSelect && onSelect(newValues);
        return {
          activeIndices: newValues
        };
      });
    };

    _this.setSelected = function (index) {
      var activeIndices = _this.state.activeIndices;
      var _this$props = _this.props,
          children = _this$props.children,
          onSelect = _this$props.onSelect; // Don't do anything if index is the same or outside of the bounds

      if (activeIndices.includes(index) || index < 0 || index >= children.length) return; // Keep reference to last index for event handler

      var last = activeIndices[0]; // Update state with selected index

      _this.setState(function () {
        return {
          activeIndices: [index]
        };
      });

      _this.setFocus(index);

      onSelect && onSelect(index, last);
    };

    _this.handleKeyPress = function (e, idx, length, disabled) {
      if (disabled) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }

      var newIndex, clickEvent;
      var tgt = e.currentTarget;
      var flag = false;

      var getNewIndex = function getNewIndex(currentIndex, change) {
        var getPossibleIndex = function getPossibleIndex() {
          if (currentIndex + change < 0) {
            return length;
          } else if (currentIndex + change > length) {
            return 0;
          }

          return currentIndex + change;
        };

        var possibleIndex = getPossibleIndex();
        return _react.default.Children.toArray(_this.props.children)[possibleIndex].props.disabled ? getNewIndex(possibleIndex, change) : possibleIndex;
      };

      switch (e.which) {
        case 32:
        case 13:
          try {
            clickEvent = new MouseEvent('click', {
              view: window,
              bubbles: true,
              cancelable: true
            });
          } catch (err) {
            if (document.createEvent) {
              // DOM Level 3 for IE 9+
              clickEvent = document.createEvent('MouseEvents');
              clickEvent.initEvent('click', true, true);
            }
          }

          tgt.dispatchEvent(clickEvent);
          flag = true;
          break;

        case 38:
        case 37:
          newIndex = getNewIndex(idx, -1);

          _this.setFocus(newIndex);

          flag = true;
          break;

        case 39:
        case 40:
          newIndex = getNewIndex(idx, 1);

          _this.setFocus(newIndex);

          flag = true;
          break;

        case 33:
        case 36:
          _this.setFocus(0);

          flag = true;
          break;

        case 34:
        case 35:
          _this.setFocus(length);

          flag = true;
          break;

        default:
          break;
      }

      if (flag) {
        e.stopPropagation();
        e.preventDefault();
      }
    };

    _this.setFocus = function (index) {
      _this.setState({
        focus: index
      });
    };

    return _this;
  }

  var _proto = AccordionMenu.prototype;

  _proto.componentWillMount = function componentWillMount() {
    if (!this.verifyChildren()) {
      throw new Error('Accordion should contain one or more AccordionGroup as children.');
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    this.determineInitialFocus();
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        children = _this$props2.children,
        className = _this$props2.className,
        showSeparator = _this$props2.showSeparator;
    var activeIndices = this.state.activeIndices;

    var setAccordionGroups = _react.default.Children.map(children, function (child, idx) {
      return _react.default.cloneElement(child, {
        isExpanded: !child.props.disabled && activeIndices.includes(idx),
        onClick: function onClick() {
          return _this2.handleClick(idx);
        },
        onKeyDown: function onKeyDown(e) {
          return _this2.handleKeyPress(e, idx, children.length - 1, child.props.disabled);
        },
        focus: _this2.state.focus === idx,
        showSeparator: showSeparator
      });
    });

    return _react.default.createElement("div", {
      className: 'cui-accordion' + ("" + (className && " " + className || ''))
    }, setAccordionGroups);
  };

  return AccordionMenu;
}(_react.default.Component);

AccordionMenu.displayName = 'AccordionMenu';
AccordionMenu.propTypes = {
  /** @prop Children nodes to render inside Accordion | null */
  children: _propTypes.default.node,

  /** @prop Set to allow expansion of multiple AccordionGroups | false */
  multipleVisible: _propTypes.default.bool,

  /** @prop Handler to be called when the user selects Accordion | null */
  onSelect: _propTypes.default.func,

  /** @prop An array of indexes that are preselected | [] */
  initialActive: _propTypes.default.array,

  /** @prop Optional css class string | '' */
  className: _propTypes.default.string,

  /** @prop Optional underline under Accordion menu item | false  */
  showSeparator: _propTypes.default.bool
};
AccordionMenu.defaultProps = {
  children: null,
  multipleVisible: false,
  onSelect: null,
  initialActive: [],
  className: '',
  showSeparator: false
};
var _default = AccordionMenu;
/**
* @component accordion
* @section default
*
* @react
import {
  Accordion,
  AccordionContent,
  AccordionGroup,
  AccordionHeader,
  AccordionMenu,
  ListItem,
} from '@collabui/react';

export default class AccordionDefault extends React.Component {
  render() {
    return (
      <Accordion>
        <AccordionGroup>
          <AccordionHeader>
            <div>Accordion 1</div>
          </AccordionHeader>
          <AccordionContent>
            <ListItem label="Content 1" />
          </AccordionContent>
        </AccordionGroup>
        <AccordionGroup>
          <AccordionHeader>
            <div>Accordion 2</div>
          </AccordionHeader>
          <AccordionContent>
            <ListItem label="Content 2" />
          </AccordionContent>
        </AccordionGroup>
      </Accordion>
    );
  }
}
**/

/**
* @component accordion
* @section multi-open
*
* @react
import {
  Accordion,
  AccordionContent,
  AccordionGroup,
  AccordionHeader,
  AccordionMenu,
  ListItem,
} from '@collabui/react';

export default class AccordionMultiOpen extends React.Component {
  render() {
    return (
      <Accordion multipleVisible>
        <AccordionGroup>
          <AccordionHeader>
            <div>Accordion 1</div>
          </AccordionHeader>
          <AccordionContent>
            <ListItem label="Content 1" />
          </AccordionContent>
        </AccordionGroup>
        <AccordionGroup>
          <AccordionHeader>
            <div>Accordion 2</div>
          </AccordionHeader>
          <AccordionContent>
            <ListItem label="Content 2" />
          </AccordionContent>
        </AccordionGroup>
      </Accordion>
    );
  }
}
**/

/**
* @component accordion
* @section pre-selected-open
*
* @react
import {
  Accordion,
  AccordionContent,
  AccordionGroup,
  AccordionHeader,
  AccordionMenu,
  ListItem,
} from '@collabui/react';

export default class AccordionPreSelectedOpen extends React.Component {
  render() {
    return (
      <Accordion multipleVisible initialActive={[0]}>
        <AccordionGroup>
          <AccordionHeader>
            <div>Accordion 1</div>
          </AccordionHeader>
          <AccordionContent>
            <ListItem label="Content 1" />
          </AccordionContent>
        </AccordionGroup>
        <AccordionGroup>
          <AccordionHeader>
            <div>Accordion 2</div>
          </AccordionHeader>
          <AccordionContent>
            <ListItem label="Content 2" />
          </AccordionContent>
        </AccordionGroup>
      </Accordion>
    );
  }
}
**/

exports.default = _default;

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(468);
var invariant = __webpack_require__(469);
var ReactPropTypesSecret = __webpack_require__(470);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var AccordionGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(AccordionGroup, _React$Component);

  function AccordionGroup() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.getChildContext = function () {
      return {
        onClick: _this.props.onClick,
        onKeyDown: _this.props.onKeyDown
      };
    };

    _this.verifyChildren = function () {
      var children = _this.props.children;

      var childrenArr = _react.default.Children.toArray(children);

      return children && childrenArr.length === 2 && childrenArr[0].type.displayName === 'AccordionHeader' && childrenArr[1].type.displayName === 'AccordionContent';
    };

    return _this;
  }

  var _proto = AccordionGroup.prototype;

  _proto.componentWillMount = function componentWillMount() {
    if (!this.verifyChildren()) {
      throw new Error('AccordionGroup should contain 2 children ' + 'AccordionHeader and AccordionContent respectively.');
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        isExpanded = _this$props.isExpanded,
        disabled = _this$props.disabled,
        focus = _this$props.focus,
        showSeparator = _this$props.showSeparator;

    var setGroupContent = _react.default.Children.map(children, function (child) {
      return _react.default.cloneElement(child, {
        disabled: disabled,
        focus: focus,
        showSeparator: showSeparator
      });
    });

    return _react.default.createElement("div", {
      "aria-expanded": isExpanded,
      className: "cui-accordion__group" + ("" + (disabled && ' cui-accordion__group--disabled' || '')) + ("" + (isExpanded && " cui-accordion__group--active" || '')) + ("" + (className && " " + className || ''))
    }, setGroupContent);
  };

  return AccordionGroup;
}(_react.default.Component);

AccordionGroup.displayName = 'AccordionGroup';
AccordionGroup.childContextTypes = {
  onClick: _propTypes.default.func,
  onKeyDown: _propTypes.default.func
};
AccordionGroup.propTypes = {
  /** @prop Children nodes to render inside Accordion | null  */
  children: _propTypes.default.node,

  /** @prop Set accordionGroup to be expanded | false  */
  isExpanded: _propTypes.default.bool,

  /** @prop Handler to be called when the user taps the AccordionGroup | null */
  onClick: _propTypes.default.func,

  /** @prop Handler to be called when the user presses a key | null */
  onKeyDown: _propTypes.default.func,

  /** @prop Optional css class string | '' */
  className: _propTypes.default.string,

  /** @prop Set the attribute disabled to the accordionGroup | false */
  disabled: _propTypes.default.bool,

  /** @prop Specifies if AccordionGroup show automatically get focus when page loads | false  */
  focus: _propTypes.default.bool,

  /** @prop Optional underline under Accordion menu item | false */
  showSeparator: _propTypes.default.bool
};
AccordionGroup.defaultProps = {
  children: null,
  isExpanded: false,
  onClick: null,
  onKeyDown: null,
  className: '',
  disabled: false,
  focus: false,
  showSeparator: false
};
var _default = AccordionGroup;
exports.default = _default;

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var AccordionHeader =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(AccordionHeader, _React$Component);

  function AccordionHeader() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = AccordionHeader.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var focus = this.props.focus;
    !prevProps.focus && focus && this.headerRef.focus();
  };

  _proto.render = function render() {
    var _this = this;

    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        disabled = _this$props.disabled,
        showSeparator = _this$props.showSeparator,
        height = _this$props.height;
    var _this$context = this.context,
        onClick = _this$context.onClick,
        onKeyDown = _this$context.onKeyDown;
    return _react.default.createElement("div", {
      role: "button",
      ref: function ref(_ref) {
        return _this.headerRef = _ref;
      },
      onClick: onClick,
      onKeyDown: onKeyDown,
      tabIndex: !disabled ? 0 : -1,
      className: 'cui-accordion__header' + ("" + (showSeparator && " cui-accordion__header--separator" || '')) + ("" + (height && " cui-accordion__header--" + height || '')) + ("" + (className && " " + className || ''))
    }, children, _react.default.createElement("span", {
      className: "cui-accordion__header-icon"
    }));
  };

  return AccordionHeader;
}(_react.default.Component);

AccordionHeader.displayName = 'AccordionHeader';
AccordionHeader.contextTypes = {
  onClick: _propTypes.default.func,
  onKeyDown: _propTypes.default.func
};
AccordionHeader.propTypes = {
  /** @prop Children nodes to render inside AccordionHeader | null  */
  children: _propTypes.default.node,

  /** @prop Optional css class string | '' */
  className: _propTypes.default.string,

  /** @prop Set the attribute disabled to the AccordionHeader | false */
  disabled: _propTypes.default.bool,

  /** @prop Specifies if AccordionHeader automatically gets focus when page loads | false  */
  focus: _propTypes.default.bool,

  /** @prop Optional underline under Accordion menu item | false */
  showSeparator: _propTypes.default.bool,

  /** @prop Set the height of the AccordionHeader to either the default or 56px | '' */
  height: _propTypes.default.oneOf(['', 56])
};
AccordionHeader.defaultProps = {
  children: null,
  className: '',
  disabled: false,
  focus: false,
  showSeparator: true,
  height: ''
};
var _default = AccordionHeader;
exports.default = _default;

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @category layout
 * @component accordion
 * @variations collab-ui-react
 */
var AccordionContent = function AccordionContent(props) {
  var children = props.children,
      className = props.className;
  return _react.default.createElement("div", {
    className: "cui-accordion__content" + ("" + (className && " " + className || ''))
  }, children);
};

AccordionContent.displayName = 'AccordionContent';
AccordionContent.propTypes = {
  /** @prop Children nodes to render inside AccordionContent | null */
  children: _propTypes.default.node,

  /** @prop Optional css class string | ''  */
  className: _propTypes.default.string
};
AccordionContent.defaultProps = {
  children: null,
  className: ''
};
var _default = AccordionContent;
exports.default = _default;

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(4);

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(7);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _lodash = __webpack_require__(13);

var _ = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * @category controls
 * @component activity-button
 * @variations collab-ui-react
 */
var ActivityButton = function ActivityButton(props) {
  var ariaLabel = props.ariaLabel,
      className = props.className,
      disabled = props.disabled,
      large = props.large,
      onClick = props.onClick,
      type = props.type,
      otherHTMLProps = _objectWithoutPropertiesLoose(props, ["ariaLabel", "className", "disabled", "large", "onClick", "type"]);

  return _react.default.createElement(_.Button, _extends({
    ariaLabel: ariaLabel || !type.icon && type || '',
    circle: true,
    className: 'cui-activity' + ("" + (!type.icon && " cui-activity__" + type || '')) + ("" + (className && " " + className || '')),
    color: (0, _lodash.get)(type, 'color'),
    disabled: disabled,
    onClick: onClick
  }, large ? {
    size: 84,
    containerLarge: true
  } : {
    size: 68
  }, otherHTMLProps), type.icon ? type.icon : _react.default.createElement(_.Icon, {
    name: "" + type + (large ? '_36' : '_28')
  }));
};

ActivityButton.displayName = 'ActivityButton';
ActivityButton.propTypes = {
  /** @prop Text to display for blindness accessibility features | '' */
  ariaLabel: _propTypes.default.string,

  /** @prop Optional css class string | '' */
  className: _propTypes.default.string,

  /** @prop Sets the attribute disabled to the button | false */
  disabled: _propTypes.default.bool,

  /** @prop Sets the large attribute to the button | false */
  large: _propTypes.default.bool,

  /** @prop Handler to be called when the user taps the button | null */
  onClick: _propTypes.default.func,

  /** @prop Sets the button's activity type */
  type: _propTypes.default.oneOfType([_propTypes.default.oneOf(['chat', 'camera', 'meetings', 'whiteboard', 'files', 'share-screen', 'tasks']), _propTypes.default.shape({
    color: _propTypes.default.string,
    icon: _propTypes.default.element.isRequired
  })]).isRequired
};
ActivityButton.defaultProps = {
  ariaLabel: '',
  className: '',
  disabled: false,
  large: false,
  onClick: null,
  type: ''
};
var _default = ActivityButton;
/**
* @component activity-button
* @section default
*
* @react
import { ActivityButton } from '@collabui/react';

export default function ActivityButtonDefault() {
  return(
      <div>
        <ActivityButton
          type='chat'
          ariaLabel='jlshjksfghjl'
          onClick={()=>{}}
          label='Chat'
        />
        <ActivityButton
          type='camera'
          onClick={()=>{}}
          label='Camera'
        />
        <ActivityButton
          type='meetings'
          onClick={()=>{}}
          label='Meetings'
        />
        <ActivityButton
          type='whiteboard'
          onClick={()=>{}}
          label='Whiteboard'
        />
        <ActivityButton
          type='files'
          onClick={()=>{}}
          label='Files'
        />
        <ActivityButton
          type='share-screen'
          onClick={()=>{}}
          label='Share'
        />
        <ActivityButton
          type='tasks'
          onClick={()=>{}}
          label='Tasks'
        />
      </div>
  );
}

**/

/**
* @component activity-button
* @section large
*
* @react
import { ActivityButton } from '@collabui/react';

export default function ActivityButtonLarge() {
  return(
      <div>
        <ActivityButton
          type='chat'
          large
          onClick={()=>{}}
          label='Chat'
          ariaLabel='Chat'
        />
        <ActivityButton
          type='camera'
          large
          onClick={()=>{}}
          label='Camera'
          ariaLabel='Camera'
        />
        <ActivityButton
          type='meetings'
          large
          onClick={()=>{}}
          label='Meetings'
          ariaLabel='Meetings'
        />
        <ActivityButton
          type='whiteboard'
          large
          onClick={()=>{}}
          label='Whiteboard'
          ariaLabel='Whiteboard'
        />
        <ActivityButton
          type='files'
          large
          onClick={()=>{}}
          label='Files'
          ariaLabel='Files'
        />
        <ActivityButton
          type='share-screen'
          large
          onClick={()=>{}}
          label='Share'
          ariaLabel='Share'
        />
        <ActivityButton
          type='tasks'
          large
          onClick={()=>{}}
          label='Tasks'
          ariaLabel='Tasks'
          title='tasks'
        />
      </div>
  );
}

**/

/**
* @component activityButton
* @section custom
*
* @react
import { ActivityButton } from '@collabui/react';

export default function ActivityButtonCustom() {
  return(
    <div>
      <ActivityButton
        type={{
          color: 'mint',
          icon: <span className='icon icon-arrow-left_32'/>
        }}
        large
        onClick={()=>{}}
        ariaLabel='Left Arrow'
      />
      <ActivityButton
        type={{
          color: 'red',
          icon: <span className='icon icon-keyboard_16'/>
        }}
        onClick={()=>{}}
        ariaLabel='Keyboard'
      />
    </div>
  );
}

**/

exports.default = _default;

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(4);

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(7);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _ = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * @category communication
 * @component alert
 * @variations collab-ui-react
 */
var Alert = function Alert(props) {
  var closable = props.closable,
      message = props.message,
      onHide = props.onHide,
      show = props.show,
      title = props.title,
      type = props.type,
      otherProps = _objectWithoutPropertiesLoose(props, ["closable", "message", "onHide", "show", "title", "type"]);

  return show && _react.default.createElement("div", {
    className: "cui-alert cui-alert--" + type
  }, _react.default.createElement("div", {
    className: "cui-alert__icon"
  }), _react.default.createElement("div", {
    className: 'cui-alert__content'
  }, _react.default.createElement("div", {
    className: "cui-alert__title"
  }, title), _react.default.createElement("div", {
    className: "cui-alert__message"
  }, message)), closable && _react.default.createElement("div", {
    className: "cui-alert__button"
  }, _react.default.createElement(_.Button, _extends({
    circle: true,
    onClick: onHide,
    size: 44
  }, otherProps), _react.default.createElement(_.Icon, {
    name: "cancel_16"
  }))));
};

Alert.defaultProps = {
  closable: false,
  message: '',
  onHide: null,
  title: '',
  type: 'info'
};
Alert.propTypes = {
  /** @prop To show/hide Close button of the Alert | false */
  closable: _propTypes.default.bool,

  /** @prop Optional Alert message | '' */
  message: _propTypes.default.string,

  /** @prop Mandatory handler invoked when the user presses on the Alert's close button or hit's the esc key | null */
  onHide: _propTypes.default.func,

  /** @prop Set Alert visibility */
  show: _propTypes.default.bool.isRequired,

  /** @prop Optional Alert title | '' */
  title: _propTypes.default.string,

  /** @prop Sets the type of the Alert | 'info' */
  type: _propTypes.default.oneOf(['info', 'success', 'warning', 'error'])
};
Alert.displayName = 'Alert';
var _default = Alert;
/**
* @component alert
* @section default
*
* @react

import {
  Alert,
  AlertContainer,
  Button
} from '@collabui/react';

export default class AlertDefault extends React.PureComponent {
  state = {
    alertMessage: 'Who\'s awesome?  You are!'
  }

  render() {
    let alertContainer;
    return (
      <section>
        <div>
          <div className='row'>
            <Button
              ariaLabel='Click to Open'
              onClick={() => alertContainer.info(
                'Alert',
                this.state.alertMessage,
                () => console.log('onHide info'),
                { ariaLabel: 'Close Alert' }
              )}
              children='Info/Default'
              color='primary'
            />
          </div>
        </div>
        <br />
        <AlertContainer
          ref={ref => alertContainer = ref}
          orderNewest={false}
        />
      </section>
    );
  }
}

**/

/**
* @component alert
* @section success
*
* @react

import {
  Alert,
  AlertContainer,
  Button
} from '@collabui/react';

export default class AlertSuccess extends React.PureComponent {
  state = {
    alertMessage: 'Who\'s awesome?  You are!'
  }

  render() {
    let alertContainer;
    return (
      <section>
        <div>
          <div className='row'>
            <br />
            <Button
              ariaLabel='Click to Open'
              onClick={() => alertContainer.success(
                'Alert',
                this.state.alertMessage,
                () => console.log('onHide info'),
                { ariaLabel: 'Close Alert' }
              )}
              children='Success'
              color='primary'
            />
          </div>
        </div>
        <br />
        <AlertContainer
          ref={ref => alertContainer = ref}
          orderNewest={false}
        />
      </section>
    );
  }
}

**/

/**
* @component alert
* @section warning
*
* @react

import {
  Alert,
  AlertContainer,
  Button
} from '@collabui/react';

export default class AlertWarning extends React.PureComponent {
  state = {
    alertMessage: 'Who\'s awesome?  You are!'
  }

  render() {
    let alertContainer;
    return (
      <section>
        <div>
          <div className='row'>
            <br />
            <Button
              ariaLabel='Click to Open'
              onClick={() => alertContainer.warning(
                'Alert',
                this.state.alertMessage,
                () => console.log('onHide info'),
                { ariaLabel: 'Close Alert' }
              )}
              children='Warning'
              color='primary'
            />
          </div>
        </div>
        <br />
        <AlertContainer
          ref={ref => alertContainer = ref}
          orderNewest={false}
        />
      </section>
    );
  }
}

**/

/**
* @component alert
* @section error
*
* @react

import {
  Alert,
  AlertContainer,
  Button
} from '@collabui/react';

export default class AlertError extends React.PureComponent {
  state = {
    alertMessage: 'Who\'s awesome?  You are!'
  }

  render() {
    let alertContainer;
    return (
      <section>
        <div>
          <div className='row'>
            <br />
            <Button
              ariaLabel='Click to Open'
              onClick={() => alertContainer.error(
                'Alert',
                this.state.alertMessage,
                () => console.log('onHide info'),
                { ariaLabel: 'Close Alert' }
              )}
              children='Error'
              color='primary'
            />
          </div>
        </div>
        <br />
        <AlertContainer
          ref={ref => alertContainer = ref}
          orderNewest={false}
        />
      </section>
    );
  }
}

**/

exports.default = _default;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _ = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @category communication
 * @component alert-banner
 * @variations collab-ui-react
 */
var AlertBanner = function AlertBanner(props) {
  var show = props.show,
      type = props.type,
      closable = props.closable,
      children = props.children,
      onHide = props.onHide;

  var handleKeyPress = function handleKeyPress(e) {
    e.preventDefault();

    if (e.which === 32 || e.which === 13) {
      return onHide(e);
    } else if (e.charCode === 32 || e.charCode === 13) {
      return onHide(e);
    }
  };

  return show && _react.default.createElement("div", {
    type: type
  }, _react.default.createElement("div", {
    className: "cui-alert-banner " + ("cui-alert-banner--" + type)
  }, _react.default.createElement("div", {
    className: "cui-alert-banner__text"
  }, children), closable && _react.default.createElement("div", {
    className: "cui-alert-banner__close",
    onClick: onHide,
    tabIndex: 0,
    onKeyPress: handleKeyPress,
    role: 'button'
  }, _react.default.createElement(_.Icon, {
    name: "cancel_16"
  }))));
};

AlertBanner.defaultProps = {
  children: null,
  type: 'info',
  closable: false,
  onHide: function onHide() {}
};
AlertBanner.propTypes = {
  /** @prop Set AlertBanner visibility */
  show: _propTypes.default.bool.isRequired,

  /** @prop Children nodes to render inside AccordionHeader | null  */
  children: _propTypes.default.node,

  /** @prop Sets the AlertBanner type | 'info' */
  type: _propTypes.default.oneOf(['info', 'warning', 'error']),

  /** @prop Mandatory handler invoked when the user presses on the AlertBanner's close button or hit's the esc key | () => {} */
  onHide: _propTypes.default.func,

  /** @prop Sets the visibility of AlertBanner's close button | false */
  closable: _propTypes.default.bool
};
AlertBanner.displayName = 'AlertBanner';
var _default = AlertBanner;
/**
* @component alert-banner
* @section default
* @react
import { AlertBanner, Button } from '@collabui/react';

export default class AlertBannerDefault extends React.PureComponent {
  state = {
    showAlert1: true,
  }

  render() {
    return (
     <div>
       <div>
         <AlertBanner
           show={this.state.showAlert1}
           closable
           onHide={() => this.setState({showAlert1: false})}
         >
           Default Alert Banner
         </AlertBanner>
       </div>
       <div>
         <div className='row'>
           <br />
           <Button
             children='Toggle Default Alert Banner'
             onClick={() => this.setState({showAlert1: !this.state.showAlert1})}
             ariaLabel='Default Alert Banner'
             className='btn--primary btn--large'
           />
         </div>
       </div>
     </div>
    );
  }
}
**/

/**
* @component alert-banner
* @section warning
* @react
import { AlertBanner, Button } from '@collabui/react';

export default class AlertBannerWarning extends React.PureComponent {
  state = {
    showAlert1: true
  }

  render() {
    return (
     <div>
       <div>
         <AlertBanner
           show={this.state.showAlert1}
           closable
           onHide={() => this.setState({showAlert1: false})}
           type='warning'
         >
           Warning Alert Banner
         </AlertBanner>
       </div>
       <div>
         <div className='row'>
           <br />
           <Button
             children='Toggle Warning Alert Banner'
             onClick={() => this.setState({showAlert1: !this.state.showAlert1})}
             ariaLabel='Warning Alert Banner'
             className='btn--primary btn--large'
           />
         </div>
       </div>
     </div>
    );
  }
}
**/

/**
* @component alert-banner
* @section error
* @react
import { AlertBanner, Button } from '@collabui/react';

export default class AlertBannerError extends React.PureComponent {
  state = {
    showAlert1: true
  }

  render() {
    return (
     <div>
       <div>
         <AlertBanner
           show={this.state.showAlert1}
           closable
           onHide={() => this.setState({showAlert1: false})}
           type='error'
         >
           Error Alert Banner
         </AlertBanner>
       </div>
       <div>
         <div className='row'>
           <br />
           <Button
             children='Toggle Error Alert Banner'
             onClick={() => this.setState({showAlert1: !this.state.showAlert1})}
             ariaLabel='Error Alert Banner'
             className='btn--primary btn--large'
           />
         </div>
       </div>
     </div>
    );
  }
}
**/

exports.default = _default;

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _DeviceListCall = _interopRequireDefault(__webpack_require__(478));

var _ = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @category communication
 * @component alert-call
 * @variations collab-ui-react
 */
var AlertCall = function AlertCall(props) {
  var avatar = props.avatar,
      caller = props.caller,
      defaultSelectedDevice = props.defaultSelectedDevice,
      deviceListHeader = props.deviceListHeader,
      devices = props.devices,
      onAnswerVideo = props.onAnswerVideo,
      onAnswerVoice = props.onAnswerVoice,
      onDeviceSelect = props.onDeviceSelect,
      onReject = props.onReject,
      rejectAriaLabel = props.rejectAriaLabel,
      show = props.show,
      title = props.title,
      videoAriaLabel = props.videoAriaLabel,
      voiceAriaLabel = props.voiceAriaLabel;

  var getAvatar = function getAvatar() {
    if (avatar) {
      return avatar;
    } else {
      switch (caller.type) {
        case 'number':
          return _react.default.createElement(_.Avatar, {
            title: "#",
            alt: caller.title,
            size: "xlarge"
          });

        case 'device':
          return _react.default.createElement(_.Avatar, {
            icon: _react.default.createElement(_.Icon, {
              name: "spark-board_32"
            }),
            alt: caller.title,
            size: "xlarge"
          });

        default:
          return _react.default.createElement(_.Avatar, {
            title: caller.title,
            alt: caller.title,
            size: "xlarge"
          });
      }
    }
  };

  var getDeviceList = function getDeviceList() {
    return devices.length > 0 && _react.default.createElement(_DeviceListCall.default, {
      devices: devices,
      header: deviceListHeader,
      onSelect: onDeviceSelect,
      defaultSelected: defaultSelectedDevice
    });
  };

  return show && _react.default.createElement("div", {
    className: "cui-alert cui-alert--call"
  }, _react.default.createElement("div", {
    className: "cui-alert__title"
  }, title), _react.default.createElement("div", {
    className: "cui-alert__caller"
  }, getAvatar(), _react.default.createElement("div", {
    className: "cui-alert__caller-title"
  }, caller.title), _react.default.createElement("div", {
    className: "cui-alert__caller-subtitle"
  }, caller.alt)), getDeviceList(), _react.default.createElement("div", {
    className: "cui-alert--call--buttons"
  }, _react.default.createElement(_.Button, {
    children: _react.default.createElement(_.Icon, {
      name: "camera_24"
    }),
    onClick: onAnswerVideo,
    ariaLabel: videoAriaLabel,
    color: "green",
    circle: true,
    size: 44
  }), onAnswerVoice && _react.default.createElement(_.Button, {
    children: _react.default.createElement(_.Icon, {
      name: "handset_24"
    }),
    onClick: onAnswerVoice,
    ariaLabel: voiceAriaLabel,
    color: "green",
    circle: true,
    size: 44
  }), _react.default.createElement(_.Button, {
    children: _react.default.createElement(_.Icon, {
      name: "cancel_24"
    }),
    onClick: onReject,
    ariaLabel: rejectAriaLabel,
    color: "red",
    circle: true,
    size: 44
  })));
};

AlertCall.defaultProps = {
  avatar: null,
  caller: null,
  defaultSelectedDevice: 0,
  deviceListHeader: 'Device selection',
  devices: [],
  onAnswerVideo: null,
  onAnswerVoice: null,
  onDeviceSelect: null,
  onReject: null,
  rejectAriaLabel: 'reject call',
  title: '',
  videoAriaLabel: 'answer call with voice and video',
  voiceAriaLabel: 'answer call with voice only'
};
AlertCall.propTypes = {
  /** @prop Optional avatar prop | null */
  avatar: _propTypes.default.node,

  /** @prop Required caller object */
  caller: _propTypes.default.shape({
    title: _propTypes.default.string.isRequired,
    alt: _propTypes.default.string,
    src: _propTypes.default.string,
    type: _propTypes.default.oneOf(['', 'number', 'device'])
  }).isRequired,

  /** @prop Optional default selected device | 0 */
  defaultSelectedDevice: _propTypes.default.number,

  /** @prop Optional header string for device selection list | "Device selection" */
  deviceListHeader: _propTypes.default.string,

  /** @prop Optional list of devices to answer call with | [] */
  devices: _propTypes.default.array,

  /** @prop Callback function invoked when the video button is clicked | null */
  onAnswerVideo: _propTypes.default.func,

  /** @prop Callback function invoked when the handset button is clicked | null */
  onAnswerVoice: _propTypes.default.func,

  /** @prop Optional callback function when device is selected | null */
  onDeviceSelect: _propTypes.default.func,

  /** @prop Callback function invoked when the reject button is clicked | null */
  onReject: _propTypes.default.func,

  /** @prop Optional aria-label reject message | 'reject call' */
  rejectAriaLabel: _propTypes.default.string,

  /** @prop Required AlertCall visitibility setting */
  show: _propTypes.default.bool.isRequired,

  /** @prop Optional title of AlertCall | '' */
  title: _propTypes.default.string,

  /** @prop Optional aria-label video | 'answer call with voice and video' */
  videoAriaLabel: _propTypes.default.string,

  /** @prop Optional aria-label voice | 'answer call with voice only' */
  voiceAriaLabel: _propTypes.default.string
};
AlertCall.displayName = 'AlertCall';
var _default = AlertCall;
/**
* @component alert
* @section default
* @react

import {
  AlertCall,
  AlertCallContainer,
  Button
} from '@collabui/react';
import {
  uniqueId,
  reject
} from 'lodash';

export default class AlertCallDefault extends React.PureComponent {
  state = {
    alertList: [],
    caller: {title: 'Jefe Guadelupe', alt: '+ 1 972-555-1212'},
    devices: [
      {name: 'SJC21-Babelfish', value: '1010101', type: 'device'},
      {name: 'Use my computer', value: '2020202'}
    ]
  }

  handleOnReject = key => {
    console.log(`onRejectCall ${key}`);
    this.setState(state => {
      return { alertList: reject(state.alertList, {key}) };
    });
  }

  handleOnAnswerVoice = key => {
    console.log(`onAnswerVoice ${key}`);
    this.setState(state => {
      return { alertList: reject(state.alertList, {key}) };
    });
  }

  handleOnAnswerVideo = key => {
    console.log(`onAnswerVideo ${key}`);
    this.setState(state => {
      return { alertList: reject(state.alertList, {key}) };
    });
  }

  renderPersonCaller = () => {
    const key = uniqueId('call_alert_');
    return (
      <AlertCall
        key={key}
        title='Incoming Call'
        caller={this.state.caller}
        onReject={() => this.handleOnReject(key)}
        onAnswerVoice={() => this.handleOnAnswerVoice(key)}
        onAnswerVideo={() => this.handleOnAnswerVideo(key)}
        onDeviceSelect={() => console.log("onDeviceSelect")}
        show
      />
    );
  };

  render() {
    return (
      <div>
        <div className='row'>
          <Button
            ariaLabel='Click to Open'
            onClick={() => {
              this.setState(state => ({
                alertList: [...state.alertList, this.renderPersonCaller()]
              }));
            }}
            children='Person Caller'
            color='primary'
          />
        </div>
        <AlertCallContainer
          alertList={this.state.alertList}
        />
      </div>
    );
  }
}

**/

/**
* @component alert
* @section device
* @react

import {
  Button,
  AlertCall,
  AlertCallContainer
} from '@collabui/react';
import {
  uniqueId,
  reject
} from 'lodash';

export default class AlertCallDevice extends React.PureComponent {
  state = {
    alertList: [],
    caller: {title: 'Jefe Guadelupe', alt: '+ 1 972-555-1212'},
    devices: [
      {name: 'SJC21-Babelfish', value: '1010101', type: 'device'},
      {name: 'Use my computer', value: '2020202'}
    ]
  }

  handleOnReject = key => {
    console.log(`onRejectCall ${key}`);
    this.setState(state => {
      return { alertList: reject(state.alertList, {key}) };
    });
  }

  handleOnAnswerVoice = key => {
    console.log(`onAnswerVoice ${key}`);
    this.setState(state => {
      return { alertList: reject(state.alertList, {key}) };
    });
  }

  handleOnAnswerVideo = key => {
    console.log(`onAnswerVideo ${key}`);
    this.setState(state => {
      return { alertList: reject(state.alertList, {key}) };
    });
  }

  renderDeviceCaller = () => {
    const key = uniqueId('call_alert_');
    return (
      <AlertCall
        key={key}
        title='Incoming Call'
        caller={{title: 'SJC21-Babelfish', alt: '+ 1 408-555-1212', type: 'device'}}
        onReject={() => this.handleOnReject(key)}
        onAnswerVoice={() => this.handleOnAnswerVoice(key)}
        onAnswerVideo={() => this.handleOnAnswerVideo(key)}
        onDeviceSelect={() => console.log("onDeviceSelect")}
        show
      />
    );
  };

  render() {
    return (
      <div>
        <div className='row'>
          <br />
          <Button
            ariaLabel='Click to Open'
            onClick={() => {
              this.setState(state => ({
                alertList: [...state.alertList, this.renderDeviceCaller()]
              }));
            }}
            children='Device Caller'
            color='primary'
          />
        </div>
        <AlertCallContainer
          alertList={this.state.alertList}
        />
      </div>
    );
  }
}

**/

/**
* @component alert
* @section number
* @react

import {
  Button,
  AlertCall,
  AlertCallContainer
} from '@collabui/react';
import {
  uniqueId,
  reject
} from 'lodash';

export default class AlertCallNumber extends React.PureComponent {
  state = {
    alertList: [],
    caller: {title: 'Jefe Guadelupe', alt: '+ 1 972-555-1212'},
    devices: [
      {name: 'SJC21-Babelfish', value: '1010101', type: 'device'},
      {name: 'Use my computer', value: '2020202'}
    ]
  }
  handleOnReject = key => {
    console.log(`onRejectCall ${key}`);
    this.setState(state => {
      return { alertList: reject(state.alertList, {key}) };
    });
  }

  handleOnAnswerVoice = key => {
    console.log(`onAnswerVoice ${key}`);
    this.setState(state => {
      return { alertList: reject(state.alertList, {key}) };
    });
  }

  handleOnAnswerVideo = key => {
    console.log(`onAnswerVideo ${key}`);
    this.setState(state => {
      return { alertList: reject(state.alertList, {key}) };
    });
  }

  renderNumberOnlyCaller = () => {
    const key = uniqueId('call_alert_');
    return (
      <AlertCall
        key={key}
        title='Incoming Call'
        caller={{title: '+ 1 408-555-1212', type: 'number'}}
        onReject={() => this.handleOnReject(key)}
        onAnswerVoice={() => this.handleOnAnswerVoice(key)}
        onAnswerVideo={() => this.handleOnAnswerVideo(key)}
        onDeviceSelect={() => console.log("onDeviceSelect")}
        show
      />
    );
  };

  render() {
    return (
      <div>
        <div className='row'>
          <br />
          <Button
            ariaLabel='Click to Open'
            onClick={() => {
              this.setState(state => ({
                alertList: [...state.alertList, this.renderNumberOnlyCaller()]
              }));
            }}
            children='Number Only Caller'
            color='primary'
          />
        </div>
        <AlertCallContainer
          alertList={this.state.alertList}
        />
      </div>
    );
  }
}

**/

/**
* @component alert
* @section device-list
* @react

import {
  Button,
  AlertCall,
  AlertCallContainer
} from '@collabui/react';
import {
  uniqueId,
  reject
} from 'lodash';

export default class AlertCallDeviceList extends React.PureComponent {
  state = {
    alertList: [],
    caller: {title: 'Jefe Guadelupe', alt: '+ 1 972-555-1212'},
    devices: [
      {name: 'SJC21-Babelfish', value: '1010101', type: 'device'},
      {name: 'Use my computer', value: '2020202'}
    ]
  }

  render() {
    return (
      <div>
        <div className='row'>
          <br />
          <Button
            ariaLabel='Click to Open'
            onClick={() => {
              this.setState(state => ({
                alertList: [...state.alertList, this.renderCallerWithDevices()]
              }));
            }}
            children='Caller with Device List'
            color='primary'
          />
        </div>
        <AlertCallContainer
          alertList={this.state.alertList}
        />
      </div>
    );
  }
}
**/

exports.default = _default;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(37);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _lodash = __webpack_require__(13);

var _ = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var DeviceListCall =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(DeviceListCall, _React$PureComponent);

  function DeviceListCall() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;
    _this.state = {
      selectedIndex: _this.props.defaultSelected,
      id: _this.props.id || (0, _lodash.uniqueId)('cui-device-list-call-')
    };

    _this.handleSelect = function (e, value, index) {
      var _this$props = _this.props,
          onSelect = _this$props.onSelect,
          devices = _this$props.devices;
      var currentIndex = devices.length < index - 1 ? 0 : index - 1;
      e.preventDefault();
      return _this.setState({
        selectedIndex: currentIndex
      }, function () {
        return onSelect && onSelect(e, currentIndex, value);
      });
    };

    return _this;
  }

  var _proto = DeviceListCall.prototype;

  _proto.render = function render() {
    var _this$props2 = this.props,
        className = _this$props2.className,
        header = _this$props2.header,
        devices = _this$props2.devices;
    var _this$state = this.state,
        selectedIndex = _this$state.selectedIndex,
        id = _this$state.id;

    var getLeftSection = function getLeftSection(deviceType) {
      switch (deviceType) {
        case 'device':
          return _react.default.createElement(_.Icon, {
            name: "spark-board_20"
          });

        default:
          return _react.default.createElement(_.Icon, {
            name: "laptop_20"
          });
      }
    };

    var getRightSection = function getRightSection(device, idx) {
      if (idx === selectedIndex) {
        return _react.default.createElement(_.Icon, {
          name: "check_20",
          color: "blue"
        });
      }
    };

    return _react.default.createElement(_.List, {
      className: className,
      onSelect: this.handleSelect,
      active: selectedIndex
    }, _react.default.createElement(_.ListItemHeader, {
      header: header
    }), devices.map(function (ele, idx) {
      return _react.default.createElement(_.ListItem, {
        key: "device-" + idx,
        id: id,
        value: ele,
        label: ele.name,
        title: ele.title || ele.name
      }, _react.default.createElement(_.ListItemSection, {
        position: "left"
      }, getLeftSection(ele.type)), _react.default.createElement(_.ListItemSection, {
        position: "center"
      }, _react.default.createElement("div", {
        className: "cui-list-item__header"
      }, ele.name)), _react.default.createElement(_.ListItemSection, {
        position: "right"
      }, getRightSection(ele, idx)));
    }));
  };

  return DeviceListCall;
}(_react.default.PureComponent);

DeviceListCall.displayName = 'DeviceListCall';
DeviceListCall.defaultProps = {
  className: '',
  defaultSelected: 0,
  id: null,
  onSelect: null
};
DeviceListCall.propTypes = {
  /** Default Index Value selected */
  defaultSelected: _propTypes.default.number,

  /** required list of devices to show in list */
  devices: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string.isRequired,
    value: _propTypes.default.string,
    type: _propTypes.default.oneOf(['', 'device']),
    title: _propTypes.default.string
  })).isRequired,

  /** HTML Class for associated input */
  className: _propTypes.default.string,

  /** ListItem header */
  header: _propTypes.default.string.isRequired,

  /** HTML ID for associated input */
  id: _propTypes.default.string,

  /** optional function called when list item is selected */
  onSelect: _propTypes.default.func
};
var _default = DeviceListCall;
exports.default = _default;

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlertCallContainer = function AlertCallContainer(props) {
  var alertList = props.alertList;
  return _react.default.createElement("div", {
    className: "cui-alert__container cui-alert__container--call"
  }, alertList);
};

AlertCallContainer.defaultProps = {
  alertList: []
};
AlertCallContainer.propTypes = {
  /** @prop Array of AlertCall components | [] */
  alertList: _propTypes.default.arrayOf(_propTypes.default.node)
};
AlertCallContainer.displayName = 'AlertCallContainer';
var _default = AlertCallContainer;
exports.default = _default;

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(4);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _ = __webpack_require__(8);

var _lodash = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var AlertContainer =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(AlertContainer, _React$Component);

  function AlertContainer() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      alertList: []
    };

    _this.info = function (title, message, onHide, otherProps) {
      _this.handleAlert(title, message, onHide, 'info', otherProps);
    };

    _this.success = function (title, message, onHide, otherProps) {
      _this.handleAlert(title, message, onHide, 'success', otherProps);
    };

    _this.warning = function (title, message, onHide, otherProps) {
      _this.handleAlert(title, message, onHide, 'warning', otherProps);
    };

    _this.error = function (title, message, onHide, otherProps) {
      _this.handleAlert(title, message, onHide, 'error', otherProps);
    };

    _this.handleAlert = function (title, message, onHide, type, otherProps) {
      var orderNewest = _this.props.orderNewest;
      var key = (0, _lodash.uniqueId)('alert_');
      var nextAlert = {
        key: key,
        title: title,
        message: message,
        onHide: (0, _lodash.bind)(_this.handleOnHide, _assertThisInitialized(_assertThisInitialized(_this)), key, onHide),
        type: type,
        show: true,
        closable: true,
        otherProps: otherProps
      };

      _this.setState(function (state) {
        return {
          alertList: orderNewest ? [nextAlert].concat(state.alertList) : [].concat(state.alertList, [nextAlert])
        };
      });
    };

    _this.handleOnHide = function (key, onHide, e) {
      _this.setState(function (state) {
        onHide && onHide(e);
        return {
          alertList: (0, _lodash.reject)(state.alertList, {
            key: key
          })
        };
      });
    };

    return _this;
  }

  var _proto = AlertContainer.prototype;

  _proto.render = function render() {
    var position = this.props.position;
    return _react.default.createElement("div", {
      className: "cui-alert__container cui-alert__container--" + position,
      role: "alert"
    }, this.state.alertList.map(function (alert) {
      return _react.default.createElement(_.Alert, _extends({
        key: alert.key,
        title: alert.title,
        message: alert.message,
        type: alert.type,
        show: alert.show,
        closable: alert.closable,
        onHide: alert.onHide
      }, alert.otherProps));
    }));
  };

  return AlertContainer;
}(_react.default.Component);

AlertContainer.displayName = 'AlertContainer';
AlertContainer.defaultProps = {
  orderNewest: true,
  position: 'bottom-right'
};
AlertContainer.propTypes = {
  /** @prop Display newest alert messages first | true */
  orderNewest: _propTypes.default.bool,

  /** @prop Define alert's position with css class name: 'bottom-right' */
  position: _propTypes.default.oneOf(['top-left', 'top-center', 'top-right', 'bottom-left', 'bottom-center', 'bottom-right'])
};
var _default = AlertContainer;
exports.default = _default;

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(4);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _ = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * @category communication
 * @component meeting-alert
 * @variations collab-ui-react
 */
var AlertMeeting = function AlertMeeting(props) {
  var attendees = props.attendees,
      avatar = props.avatar,
      closeAriaLabel = props.closeAriaLabel,
      message = props.message,
      onClick = props.onClick,
      onHide = props.onHide,
      onSnooze = props.onSnooze,
      remindAriaLabel = props.remindAriaLabel,
      show = props.show,
      status = props.status,
      title = props.title;

  var renderAvatar = function renderAvatar() {
    if (avatar) {
      return avatar;
    } else {
      if (attendees.length >= 2) {
        return _react.default.createElement(_.CompositeAvatar, null, _react.default.createElement(_.Avatar, {
          title: attendees[0].title,
          alt: attendees[0].alt,
          src: attendees[0].src
        }), _react.default.createElement(_.Avatar, {
          title: attendees[1].title,
          alt: attendees[1].alt,
          src: attendees[1].src
        }));
      } else if (attendees.length === 1) {
        return _react.default.createElement(_.Avatar, {
          title: attendees[0].title,
          alt: attendees[0].alt,
          src: attendees[0].src
        });
      } else {
        throw new Error('MeetingAlert needs at least one attendee to render an avatar.');
      }
    }
  };

  var handleKeyDown = function handleKeyDown(e) {
    if (e.which === 32 || e.which === 13 || e.charCode === 32 || e.charCode === 13) {
      onClick && onClick(e);
      e.preventDefault();
    }
  };

  return show && _react.default.createElement("div", _extends({
    className: "cui-alert cui-alert--meeting"
  }, onClick && {
    onClick: onClick,
    onKeyDown: function onKeyDown(e) {
      return handleKeyDown(e);
    },
    role: 'button'
  }), renderAvatar(), _react.default.createElement("div", {
    className: 'cui-alert__content' + ("" + (onSnooze ? '' : ' cui-alert__content--wide'))
  }, _react.default.createElement("div", {
    className: "cui-alert__title",
    title: title
  }, title), _react.default.createElement("div", {
    className: "cui-alert__status"
  }, status), _react.default.createElement("div", {
    className: "cui-alert__message",
    title: message
  }, message)), onSnooze && _react.default.createElement("div", {
    className: "cui-alert__button"
  }, _react.default.createElement(_.Button, {
    children: _react.default.createElement(_.Icon, {
      name: "alarm_16"
    }),
    onClick: onSnooze,
    ariaLabel: remindAriaLabel,
    circle: true,
    size: 44
  })), _react.default.createElement("div", {
    className: "cui-alert__button"
  }, _react.default.createElement(_.Button, {
    children: _react.default.createElement(_.Icon, {
      name: "cancel_16"
    }),
    onClick: onHide,
    ariaLabel: closeAriaLabel,
    circle: true,
    size: 44
  })));
};

AlertMeeting.defaultProps = {
  attendees: [],
  avatar: null,
  closeAriaLabel: 'close',
  message: '',
  onClick: null,
  onHide: null,
  onSnooze: null,
  remindAriaLabel: 'snooze',
  status: '',
  title: ''
};
AlertMeeting.propTypes = {
  /** @prop Optional avatar prop | null */
  avatar: _propTypes.default.node,

  /** @prop Optional attendee array. If more than one attendee, a Composite Avatar with only the first 2 attendees is created. | null */
  attendees: _propTypes.default.arrayOf(_propTypes.default.shape({
    title: _propTypes.default.string.isRequired,
    alt: _propTypes.default.string,
    src: _propTypes.default.string
  })),

  /** @prop Optional aria label for the close button | 'close' */
  closeAriaLabel: _propTypes.default.string,

  /** @prop Optional callback function invoked on click of alert | null */
  onClick: _propTypes.default.func,

  /** @prop Mandatory handler invoked when the user presses on the Alert's close button or hit's the esc key | null */
  onHide: _propTypes.default.func,

  /** @prop Optional callback function invoked when the snooze button is clicked | null */
  onSnooze: _propTypes.default.func,

  /** @prop Optional AlertMeeting Message | '' */
  message: _propTypes.default.string,

  /** @prop Optional aria label for snooze buton | 'snooze' */
  remindAriaLabel: _propTypes.default.string,

  /** @prop Set AlertMeeting visibility */
  show: _propTypes.default.bool.isRequired,

  /** @prop Optional AlertMeeting status | '' */
  status: _propTypes.default.string,

  /** @prop Optional AlertMeeting title | '' */
  title: _propTypes.default.string
};
AlertMeeting.displayName = 'AlertMeeting';
var _default = AlertMeeting;
/**
* @component alert
* @section default
* @react

import {
  Button,
  AlertMeeting,
  AlertMeetingContainer
} from '@collabui/react';
import {
  uniqueId,
  reject
} from 'lodash';

export default class Default extends React.PureComponent {
  state = {
    alertList: []
  }

  handleOnHide = key => {
    console.log(`onHide ${key}`);
    this.setState(state => {
      return { alertList: reject(state.alertList, {key}) };
    });
  }

  handleOnSnooze = key => {
    console.log(`onSnooze ${key}`);
    this.setState(state => {
      return { alertList: reject(state.alertList, {key}) };
    });
  }

  renderSingleAttendeeMeeting = () => {
    const key = uniqueId('meeting_alert_');
    return (
      <AlertMeeting
        key={key}
        title='Important Meeting'
        status='In 5 mins.'
        message='This is important'
        onHide={() => this.handleOnHide(key)}
        onSnooze={() => this.handleOnSnooze(key)}
        attendees={[{title: 'J $'}]}
        show
      />
    );
  }

  render() {
    return (
      <div>
        <div className="row">
          <Button
            ariaLabel="Click to Open"
            onClick={() => {
              this.setState(state => ({
                alertList: [
                  ...state.alertList,
                  this.renderSingleAttendeeMeeting(),
                ],
              }));
            }}
            children="Single Attendee"
            color="primary"
          />
        </div>
        <AlertMeetingContainer alertList={this.state.alertList} />
      </div>
    );
  }
}

**/

/**
* @component alert
* @section multiple
* @react

import {
  Button,
  AlertMeeting,
  AlertMeetingContainer
} from '@collabui/react';
import {
  uniqueId,
  reject
} from 'lodash';

export default class Default extends React.PureComponent {
  state = {
    alertList: []
  }

  handleOnHide = key => {
    console.log(`onHide ${key}`);
    this.setState(state => {
      return { alertList: reject(state.alertList, {key}) };
    });
  }

  handleOnSnooze = key => {
    console.log(`onSnooze ${key}`);
    this.setState(state => {
      return { alertList: reject(state.alertList, {key}) };
    });
  }

  renderMultipleAttendeeMeeting = () => {
    const key = uniqueId('meeting_alert_');
    return (
      <AlertMeeting
        key={key}
        title='Important Meeting'
        status='In 5 mins.'
        message='This is important'
        onHide={() => this.handleOnHide(key)}
        onSnooze={() => this.handleOnSnooze(key)}
        attendees={[{title: 'J $'}, {title: 'Jefe Guadelupe'}]}
        show
      />
    );
  }

  render() {
    return (
      <div>
        <div className='row'>
          <br />
          <Button
            ariaLabel='Click to Open'
            onClick={() => {
              this.setState(state => ({
                alertList: [...state.alertList, this.renderMultipleAttendeeMeeting()]
              }));
            }}
            children='Multiple Attendees'
            color='primary'
          />
        </div>
        <AlertMeetingContainer
          alertList={this.state.alertList}
        />
      </div>
    );
  }
}

**/

exports.default = _default;

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlertMeetingContainer = function AlertMeetingContainer(props) {
  var alertList = props.alertList;
  return _react.default.createElement("div", {
    className: "cui-alert__container cui-alert__container--bottom-right"
  }, alertList);
};

AlertMeetingContainer.defaultProps = {
  alertList: []
};
AlertMeetingContainer.propTypes = {
  /** @prop Array of AlertMeeting components | [] */
  alertList: _propTypes.default.arrayOf(_propTypes.default.node)
};
AlertMeetingContainer.displayName = 'AlertMeetingContainer';
var _default = AlertMeetingContainer;
exports.default = _default;

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(7);

__webpack_require__(4);

__webpack_require__(131);

__webpack_require__(130);

__webpack_require__(66);

__webpack_require__(65);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _ = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var Avatar =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Avatar, _React$Component);

  function Avatar() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      isImageLoaded: false,
      isImageErrored: false
    };

    _this.handleImgChange = function () {
      _this.setState({
        isImageLoaded: false,
        isImageErrored: false
      });
    };

    _this.handleImgError = function () {
      _this.setState({
        isImageErrored: true
      });
    };

    _this.handleImgLoaded = function () {
      _this.setState({
        isImageLoaded: true
      });
    };

    return _this;
  }

  var _proto = Avatar.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var img = this.image;

    if (img && img.complete) {
      this.handleImgLoaded();
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.src !== this.props.src) {
      this.handleImgChange();
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        alt = _this$props.alt,
        backgroundColor = _this$props.backgroundColor,
        buttonClassName = _this$props.buttonClassName,
        className = _this$props.className,
        color = _this$props.color,
        failureBadge = _this$props.failureBadge,
        hasNotification = _this$props.hasNotification,
        hideDefaultTooltip = _this$props.hideDefaultTooltip,
        icon = _this$props.icon,
        isDecrypting = _this$props.isDecrypting,
        isOverview = _this$props.isOverview,
        onClick = _this$props.onClick,
        size = _this$props.size,
        src = _this$props.src,
        theme = _this$props.theme,
        title = _this$props.title,
        type = _this$props.type,
        otherProps = _objectWithoutPropertiesLoose(_this$props, ["alt", "backgroundColor", "buttonClassName", "className", "color", "failureBadge", "hasNotification", "hideDefaultTooltip", "icon", "isDecrypting", "isOverview", "onClick", "size", "src", "theme", "title", "type"]);

    var _this$state = this.state,
        isImageLoaded = _this$state.isImageLoaded,
        isImageErrored = _this$state.isImageErrored;

    var getInitials = function getInitials() {
      if (!title.replace(/\s/g, '').length) return '';
      var letters = [];
      var words = title.trim().split(/ +/);
      var repeatTimes = Math.min(type === 'group' && 1 || 2, words.length);

      for (var i = 0; i < repeatTimes; i++) {
        letters.push(String.fromCodePoint(words[i].codePointAt(0)));
      }

      return letters.join('');
    };

    var getIcon = function getIcon() {
      if (icon.type.displayName === 'Icon') {
        return _react.default.createElement("span", {
          className: 'cui-avatar__icon' + ("" + (isOverview ? ' cui-avatar__icon--overview' : '')),
          style: {
            backgroundColor: backgroundColor,
            color: color
          }
        }, icon);
      }

      throw new Error('Icon prop should be a component of type Icon');
    };

    var getLetter = function getLetter() {
      return _react.default.createElement("span", {
        key: "letter",
        className: 'cui-avatar__letter' + ("" + (isDecrypting && " cui-decrypting" || '')) + ("" + (isImageLoaded && " cui-avatar__img--hidden" || '')),
        style: {
          backgroundColor: backgroundColor,
          color: color
        }
      }, getInitials());
    };

    var getChildren = function getChildren() {
      if (type === 'self') {
        return _react.default.createElement("span", {
          key: "self",
          className: "cui-avatar__self",
          style: {
            backgroundColor: backgroundColor,
            color: color
          }
        }, _react.default.createElement(_.Icon, {
          name: size === 40 || size === 'medium' ? 'chat-active_18' : 'chat-active_16'
        }));
      } else if (src && !isImageErrored) {
        // image src is present and image has not yet errored
        var imgChildren = []; // image is not loaded and title is provided

        if (title && !isImageLoaded) {
          imgChildren.push(getLetter());
        }

        imgChildren.push(_react.default.createElement("img", {
          alt: alt,
          className: "cui-avatar__img" + ("" + (!isImageLoaded && " cui-avatar__img--hidden" || '')),
          draggable: false,
          key: "image-" + imgChildren.length,
          onError: _this2.handleImgError,
          onLoad: _this2.handleImgLoaded,
          src: src,
          ref: function ref(_ref) {
            return _this2.image = _ref;
          }
        }));
        return imgChildren;
      } else if (icon) {
        return getIcon();
      } else if (title) {
        return getLetter();
      }
    };

    var getAvatar = function getAvatar() {
      return _react.default.createElement("div", _extends({
        className: 'cui-avatar' + ("" + (onClick && " cui-avatar--clickable" || '')) + ("" + (type && " cui-avatar--" + type || '')) + ("" + (size && " cui-avatar--" + size || '')) + ("" + (theme && " cui-avatar--" + theme || '')) + ("" + (isDecrypting && " cui-decrypting" || '')) + ("" + (className && " " + className || '')),
        title: !hideDefaultTooltip ? title : ''
      }, !onClick && Object.assign({}, otherProps)), getChildren(), type === 'typing' && _react.default.createElement(_.Loading, null), failureBadge && _react.default.createElement("span", {
        className: "cui-avatar__failure-badge"
      }), hasNotification && _react.default.createElement("span", {
        className: "cui-avatar__notification-badge"
      }));
    };

    return onClick ? _react.default.createElement(_.Button, _extends({
      className: buttonClassName,
      circle: true,
      onClick: onClick,
      removeStyle: true
    }, otherProps), getAvatar()) : getAvatar();
  };

  return Avatar;
}(_react.default.Component);

Avatar.displayName = 'Avatar';
Avatar.propTypes = {
  /** @prop Image alt tag | '' */
  alt: _propTypes.default.string,

  /** @prop Set Avatar background color | '' */
  backgroundColor: _propTypes.default.string,

  /** @prop Optional css class string for button | '' */
  buttonClassName: _propTypes.default.string,

  /** @prop Optional css class string for Avatar component | null */
  className: _propTypes.default.string,

  /** @prop Set Avatar text color | '' */
  color: _propTypes.default.string,

  /** @prop Set existance of a failureBadge on the Avatar | false */
  failureBadge: _propTypes.default.bool,

  /** @prop Set existance of a notification on the Avatar | false */
  hasNotification: _propTypes.default.bool,

  /** @prop Set the visibility of Avatar's default tooltip | false */
  hideDefaultTooltip: _propTypes.default.bool,

  /** @prop Optional icon component for the Avatar | null */
  icon: _propTypes.default.element,

  /** @prop Set if Avatar's content is decrypting | false */
  isDecrypting: _propTypes.default.bool,

  /** @prop Set existance of Avatar's Overview | false */
  isOverview: _propTypes.default.bool,

  /** @prop Handler to be called when the user taps the Avatar | null */
  onClick: _propTypes.default.func,

  /** @prop Set the size of the Avatar from one of the preconfigured options | 'medium' */
  size: _propTypes.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 18, 24, 28, 36, 40, 44, 52, 56, 72, 80, 84]),

  /** @prop Optional image source for the Avatar | null */
  src: _propTypes.default.string,

  /** @prop Optional Avatar color theme | null */
  theme: _propTypes.default.string,

  /** @prop set Avatar title / user's name | null */
  title: _propTypes.default.string,

  /** @prop optional Avatar type | '' */
  type: _propTypes.default.oneOf(['', 'active', 'inactive', 'dnd', 'ooo', 'group', 'typing', 'bot', 'self'])
};
Avatar.defaultProps = {
  alt: '',
  backgroundColor: '',
  buttonClassName: '',
  className: null,
  color: '',
  failureBadge: false,
  hasNotification: false,
  hideDefaultTooltip: false,
  icon: null,
  isDecrypting: false,
  isOverview: false,
  onClick: null,
  size: 'medium',
  src: null,
  theme: null,
  title: null,
  type: ''
};
var _default = Avatar;
/**
* @component avatar
* @section default
* @react

import { Avatar } from '@collabui/react';

 export default class AvatarDefault extends React.PureComponent {
  render() {
    return (
      <Avatar title="Tom Smith"/>
    );
  }
}
**/

/**
* @component avatar
* @section active
* @react

import { Avatar } from '@collabui/react';

 export default class AvatarActive extends React.PureComponent {
  render() {
    return (
      <Avatar title="Tom Smith" type="active"/>
    );
  }
}
**/

/**
* @component avatar
* @section inactive
* @react

import { Avatar } from '@collabui/react';

 export default class AvatarInactive extends React.PureComponent {
  render() {
    return (
      <Avatar title="Tom Smith" type="inactive" />
    );
  }
}
**/

/**
* @component avatar
* @section self
* @react

import { Avatar } from '@collabui/react';

 export default class AvatarSelf extends React.PureComponent {
  render() {
    return (
      <Avatar title="Tom Smith" type="self"/>
    );
  }
}
**/

/**
* @component avatar
* @section status
* @react

import { Avatar } from '@collabui/react';

 export default class AvatarStatus extends React.PureComponent {
  render() {
    return (
      <div className='row'>
        <div className="docs-example docs-example--spacing">
          <Avatar title="Tom Smith" size={36} type="dnd" />
        </div>

        <div className="docs-example docs-example--spacing">
          <Avatar title="Tom Smith" size={36} type="ooo" />
        </div>
      </div>
    );
  }
}
**/

/**
* @component avatar
* @section group
* @react

import { Avatar } from '@collabui/react';

 export default class AvatarGroup extends React.PureComponent {
  render() {
    return (
      <Avatar title="Tom Smith" type="group"/>
    );
  }
}
**/

/**
* @component avatar
* @section bot
* @react

import { Avatar } from '@collabui/react';

 export default class AvatarBot extends React.PureComponent {
  render() {
    return (
      <Avatar title="Tom Smith" type="bot" />
    );
  }
}
**/

/**
* @component avatar
* @section notification
* @react

import { Avatar } from '@collabui/react';

 export default class AvatarNotification extends React.PureComponent {
  render() {
    return (
      <Avatar title="Tom Smith" hasNotification />
    );
  }
}
**/

/**
* @component avatar
* @section failure
* @react

import { Avatar } from '@collabui/react';

 export default class AvatarFailure extends React.PureComponent {
  render() {
    return (
      <Avatar title="Tom Smith" failureBadge />
    );
  }
}
**/

/**
* @component avatar
* @section typing
* @react

import { Avatar } from '@collabui/react';

 export default class AvatarTyping extends React.PureComponent {
  render() {
    return (
      <Avatar title="Tom Smith" type="typing"/>
    );
  }
}
**/

/**
* @component avatar
* @section composite
*
* @react
*
import { Avatar } from '@collabui/react';

 export default class AvatarComposite extends React.PureComponent {
  render() {
    return (
      <CompositeAvatar size={40}>
        <Avatar title="Tom Smith"/>
        <Avatar title="John William"/>
      </CompositeAvatar>
    );
  }
}
**/

exports.default = _default;

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(4);

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(7);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * @category communication
 * @component badge
 * @variations collab-ui-react
 */
var Badge = function Badge(props) {
  var className = props.className,
      rounded = props.rounded,
      color = props.color,
      otherHTMLProps = _objectWithoutPropertiesLoose(props, ["className", "rounded", "color"]);

  return _react.default.createElement("span", _extends({
    className: "cui-badge" + ("" + (rounded && ' cui-badge--round' || '')) + ("" + (color && " cui-badge--" + color || '')) + ("" + (className && " " + className || ''))
  }, otherHTMLProps), props.children);
};

Badge.displayName = 'Badge';
Badge.propTypes = {
  /** @prop Children nodes to render inside Accordion | null */
  children: _propTypes.default.element,

  /** @prop Optional css class string | '' */
  className: _propTypes.default.string,

  /** @prop Optional color prop type | null */
  color: _propTypes.default.string,

  /** @prop Optional rounded corners for the Badge | false */
  rounded: _propTypes.default.bool
};
Badge.defaultProps = {
  children: null,
  className: '',
  rounded: false
};
var _default = Badge;
/**
* @component badge
* @section default
* @react
import { Badge } from '@collabui/react';

export default function BadgeDefault() {
    return (
      <div className="row">
        <div className="example-spacing">
          <Badge>
            <div>Default</div>
          </Badge>
          <br />

          <Badge color="blue">
            <div>Blue</div>
          </Badge>
          <br />

          <Badge color="red">
            <div>Red</div>
          </Badge>
          <br />

          <Badge color="yellow">
            <div>Yellow</div>
          </Badge>
          <br />

          <Badge color="green">
            <div>Green</div>
          </Badge>
          <br />

          <Badge color="mint">
            <div>Mint</div>
          </Badge>
          <br />

          <Badge color="pastel">
            <div>Default</div>
          </Badge>
          <br />

          <Badge color="blue-pastel">
            <div>Blue</div>
          </Badge>
          <br />

          <Badge color="red-pastel">
            <div>Red</div>
          </Badge>
          <br />

          <Badge color="yellow-pastel">
            <div>Yellow</div>
          </Badge>
          <br />

          <Badge color="green-pastel">
            <div>Green</div>
          </Badge>
          <br />

          <Badge color="mint-pastel">
            <div>Mint</div>
          </Badge>
        </div>
      </div>
    );
  }

**/

/**
* @component badge
* @section round
* @react
import { Badge } from '@collabui/react';

export default function BadgeRound() {
    return (
      <div className="row">
        <div className="example-spacing">
          <Badge rounded>
            <div>Default</div>
          </Badge>
          <br />

          <Badge rounded color="blue">
            <div>Blue</div>
          </Badge>
          <br />

          <Badge rounded color="red">
            <div>Red</div>
          </Badge>
          <br />

          <Badge rounded color="yellow">
            <div>Yellow</div>
          </Badge>
          <br />

          <Badge rounded color="green">
            <div>Green</div>
          </Badge>
          <br />

          <Badge rounded color="mint">
            <div>Mint</div>
          </Badge>
          <br />

          <Badge rounded color="pastel">
            <div>Default</div>
          </Badge>
          <br />

          <Badge rounded color="blue-pastel">
            <div>Blue</div>
          </Badge>
          <br />

          <Badge rounded color="red-pastel">
            <div>Red</div>
          </Badge>
          <br />

          <Badge rounded color="yellow-pastel">
            <div>Yellow</div>
          </Badge>
          <br />

          <Badge rounded color="green-pastel">
            <div>Green</div>
          </Badge>
          <br />

          <Badge rounded color="mint-pastel">
            <div>Mint</div>
          </Badge>
        </div>
      </div>
    );
  }
**/

exports.default = _default;

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * @category navigation
 * @component breadcrumbs
 * @variations collab-ui-react
 */
var Breadcrumbs =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(Breadcrumbs, _React$PureComponent);

  function Breadcrumbs() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = Breadcrumbs.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children;

    var items = _react.default.Children.map(children, function (child, idx) {
      if (children.length - 1 === idx || !children.length) {
        return _react.default.cloneElement(child, {
          className: 'current'
        });
      }

      return child;
    });

    return _react.default.createElement("ul", {
      className: 'cui-breadcrumbs' + (" " + className)
    }, items);
  };

  return Breadcrumbs;
}(_react.default.PureComponent);

Breadcrumbs.displayName = 'Breadcrumbs';
Breadcrumbs.propTypes = {
  /** @prop Children nodes to render inside Breadcrumbs | null */
  children: _propTypes.default.node,

  /** @prop Optional css class string | '' */
  className: _propTypes.default.string
};
Breadcrumbs.defaultProps = {
  children: null,
  className: ''
};
var _default = Breadcrumbs;
/**
* @component breadcrumbs
* @section default
* @react

import { Breadcrumbs, ListItem } from '@collabui/react';

export default function DefaultBreadCrumbs() {
    return (
      <div className='row'>
        <div className='columns small-12'>
          <Breadcrumbs>
            <li href='javascript:void(0)'>
              Default
            </li>
          </Breadcrumbs>
        </div>
        <div className='columns small-12'>
          <Breadcrumbs>
            <li href='javascript:void(0)'>
              Default
            </li>
            <li href='javascript:void(0)'>
              Default2
            </li>
          </Breadcrumbs>
        </div>
        <div className='columns small-12'>
          <Breadcrumbs>
            <li href='javascript:void(0)'>
              Default
            </li>
            <li href='javascript:void(0)'>
              Default2
            </li>
            <li href='javascript:void(0)'>
              Default3
            </li>
          </Breadcrumbs>
        </div>
      </div>
    );
  }

**/

exports.default = _default;

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(7);

__webpack_require__(4);

__webpack_require__(19);

__webpack_require__(20);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _ = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * @category controls
 * @component button
 * @variations collab-ui-react
 */
var Button =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Button, _React$Component);

  function Button() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handleKeyDown = function (e) {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          index = _this$props.index;
      var _this$context = _this.context,
          handleKeyDown = _this$context.handleKeyDown,
          handleClick = _this$context.handleClick;

      if (e.which === 32 || e.which === 13 || e.charCode === 32 || e.charCode === 13) {
        handleClick && handleClick(e, index);
        onClick && onClick(e);
        e.preventDefault();
      } else {
        handleKeyDown && handleKeyDown(e, index);
      }
    };

    _this.handleClick = function (e, onClick) {
      var handleClick = _this.context.handleClick;
      var index = _this.props.index;
      onClick && onClick(e);
      handleClick && handleClick(e, index);
    };

    return _this;
  }

  var _proto = Button.prototype;

  _proto.componentDidMount = function componentDidMount() {
    /* eslint-disable no-console */
    var _this$props2 = this.props,
        ariaLabel = _this$props2.ariaLabel,
        ariaLabelledBy = _this$props2.ariaLabelledBy,
        index = _this$props2.index;
    var _this$context2 = this.context,
        focusIndex = _this$context2.focusIndex,
        focusOnLoad = _this$context2.focusOnLoad;
    !ariaLabel && !ariaLabelledBy && console.warn('[@collabui/react] Button: Accessibility could be improved with ariaLabel');
    focusOnLoad && focusIndex === index && this.refs.button.focus();
    /* eslint-enable no-console */
  };

  _proto.componentWillUpdate = function componentWillUpdate() {
    this.prevContext = this.context;
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    var focusIndex = this.context.focusIndex;
    var index = this.props.index;
    typeof index === 'number' && index === focusIndex && focusIndex !== this.prevContext.focusIndex && this.refs.button.focus();
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props3 = this.props,
        active = _this$props3.active,
        ariaLabel = _this$props3.ariaLabel,
        ariaLabelledBy = _this$props3.ariaLabelledBy,
        children = _this$props3.children,
        circle = _this$props3.circle,
        className = _this$props3.className,
        color = _this$props3.color,
        containerLarge = _this$props3.containerLarge,
        disabled = _this$props3.disabled,
        expand = _this$props3.expand,
        href = _this$props3.href,
        index = _this$props3.index,
        label = _this$props3.label,
        loading = _this$props3.loading,
        large = _this$props3.large,
        _onClick = _this$props3.onClick,
        removeStyle = _this$props3.removeStyle,
        size = _this$props3.size,
        style = _this$props3.style,
        tag = _this$props3.tag,
        type = _this$props3.type,
        otherHTMLProps = _objectWithoutPropertiesLoose(_this$props3, ["active", "ariaLabel", "ariaLabelledBy", "children", "circle", "className", "color", "containerLarge", "disabled", "expand", "href", "index", "label", "loading", "large", "onClick", "removeStyle", "size", "style", "tag", "type"]);

    var focusIndex = this.context.focusIndex;

    var getChildren = function getChildren() {
      return [loading && _react.default.createElement("div", {
        key: "child-0"
      }, _react.default.createElement(_.Loading, null)), _react.default.createElement("span", {
        className: "cui-button__children",
        style: {
          opacity: "" + (loading ? 0 : 1)
        },
        key: "child-1"
      }, children)];
    };

    var getColor = function getColor() {
      if (removeStyle) return false;
      return color === 'none' ? 'color-none' : color;
    }; // Method for deprecated large prop


    var getSize = function getSize() {
      if (removeStyle) return false;
      /* eslint-disable no-console */

      var validButtonSize = checkButtonSize();

      if (!circle && !validButtonSize) {
        console.warn('[@collabui/react] Button: selected size is not supported for non-circular button. Size will default to 36');
        return '36';
      } else if (large) {
        console.warn('[@collabui/react] Button: large prop is deprecated and will be removed. Please use size prop.');
        return !circle ? '52' : '44';
      } else {
        return size === 'none' ? 'size-none' : size;
      }
      /* eslint-enable no-console */

    };

    var checkButtonSize = function checkButtonSize() {
      return ['none', '28', '36', '40', '52', 28, 36, 40, 52].includes(size);
    };

    var button = _react.default.createElement(tag, Object.assign({
      ref: 'button',
      className: 'cui-button' + ("" + (circle && " cui-button--circle" || '')) + ("" + (getSize() && " cui-button--" + getSize() || '')) + ("" + (expand && " cui-button--expand" || '')) + ("" + (color && " cui-button--" + getColor() || '')) + ("" + (removeStyle && ' cui-button--none' || '')) + ("" + (active && !disabled && " active" || '')) + ("" + (className && " " + className || '')),
      onClick: function onClick(e) {
        return _this2.handleClick(e, _onClick);
      },
      onKeyDown: this.handleKeyDown,
      style: style,
      disabled: disabled || loading,
      alt: ariaLabel || label,
      href: tag === 'a' && href || undefined,
      type: tag !== 'a' && type || ''
    }, ariaLabel ? {
      'aria-label': ariaLabel
    } : {
      'aria-labelledby': ariaLabelledBy
    }, {
      tabIndex: typeof index !== 'number' || index === focusIndex ? 0 : -1
    }, tag && tag !== 'button' && {
      role: 'button'
    }, otherHTMLProps), getChildren());

    return label ? _react.default.createElement("div", {
      className: "cui-button__container" + (containerLarge ? '' : '--small')
    }, button, _react.default.createElement("div", {
      className: "cui-button__label"
    }, label)) : button;
  };

  return Button;
}(_react.default.Component);

Button.displayName = 'Button';
Button.contextTypes = {
  focusIndex: _propTypes.default.number,
  focusOnLoad: _propTypes.default.bool,
  handleClick: _propTypes.default.func,
  handleKeyDown: _propTypes.default.func
};
Button.propTypes = {
  /** @prop Sets active css styling | false */
  active: _propTypes.default.bool,

  /** @prop Text to display for blindness accessibility features | '' */
  ariaLabel: _propTypes.default.string,

  /** @prop ID to reference for blindness accessibility feature | '' */
  ariaLabelledBy: _propTypes.default.string,

  /** @prop Children Nodes to Render inside Button | null */
  children: _propTypes.default.node.isRequired,

  /** @prop Sets circle css styling | false */
  circle: _propTypes.default.bool,

  /** @prop Optional css class string | '' */
  className: _propTypes.default.string,

  /** @prop Sets optional Button color | '' */
  color: _propTypes.default.string,

  /** @prop Sets containerLarge css styling | false */
  containerLarge: _propTypes.default.bool,

  /** @prop Sets the attribute disabled to Button | false */
  disabled: _propTypes.default.bool,

  /** @prop Sets expand css styling to widen the Button | false */
  expand: _propTypes.default.bool,

  /** @prop Href prop changes element to anchor element | '' */
  href: _propTypes.default.string,

  /** @prop This index is used to control focus of Button within a ButtonGroup | null */
  index: _propTypes.default.number,

  /** @prop Text to display inside the button | '' */
  label: _propTypes.default.string,

  /** @prop Depreciated large css styling, use size instead | false */
  large: _propTypes.default.bool,

  /** @prop Activates the loading animation and sets the button to disabled | false */
  loading: _propTypes.default.bool,

  /** @prop Handler to be called when the user taps the button | null */
  onClick: _propTypes.default.func,

  /** @prop Optional prop to remove Button's default style | false */
  removeStyle: _propTypes.default.bool,

  /** @prop Optional string or number size prop | 36 */
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** @prop Additional css styling applied to the button | {} */
  style: _propTypes.default.object,

  /** @prop Optional tag to define type of element | 'button' */
  tag: _propTypes.default.oneOf(['button', 'input', 'a']),

  /** @prop Optional html type | 'button' */
  type: _propTypes.default.oneOf(['button', 'reset', 'submit'])
};
Button.defaultProps = {
  active: false,
  ariaLabel: '',
  ariaLabelledBy: '',
  children: null,
  circle: false,
  className: '',
  color: '',
  containerLarge: false,
  disabled: false,
  expand: false,
  href: '',
  index: null,
  label: '',
  large: false,
  loading: false,
  onClick: null,
  removeStyle: false,
  size: 36,
  style: {},
  tag: 'button',
  type: 'button'
};
var _default = Button;
/**
* @component button
* @section default
* @react
import { Button } from '@collabui/react';

export default function ButtonDefault() {
  return(
    <Button
      children='Test Me'
      ariaLabel='For the Win'
    />
  );
}
**/

/**
* @component button
* @section tags
* @react
import { Button } from '@collabui/react';

export default function ButtonTags() {
  return(
    <Button
      children='Link'
      onClick={() => { }}
      ariaLabel='For the Win'
      tag='a'
    />
  );
}
**/

/**
* @component button
* @section color
* @react
import { Button } from '@collabui/react';

export default function ButtonColor() {
  return(
    <Button
      children='Test Me'
      onClick={() => { }}
      ariaLabel='For the Win'
      color='blue'
    />
  );
}
**/

/**
* @component button
* @section size
* @react
import { Button } from '@collabui/react';

export default function ButtonSize() {
  return(
    <div className="example-spacing">
      <div>
        <Button
          ariaLabel='For the Win'
          size='none'
        >
          no size
        </Button>
      </div>
      <br />
      <div>
        <Button
          ariaLabel='For the Win'
          size={28}
        >
          size 28
        </Button>
      </div>
      <br />
      <div>
        <Button
          ariaLabel='For the Win'
        >
          size 36
        </Button>
      </div>
      <br />
      <div>
        <Button
          ariaLabel='For the Win'
          size={40}
        >
          size 40
        </Button>
      </div>
      <br />
      <div>
        <Button
          ariaLabel='For the Win'
          size={52}
        >
          size 52
        </Button>
      </div>
      <br />
    </div>
  );
}
**/

/**
* @component button
* @section circle
* @react
import { Button } from '@collabui/react';

export default function ButtonCircle() {
  return(
    <Button
      children={<Icon name='icon-search_12' />}
      onClick={() => { }}
      ariaLabel='For the Win'
      circle
    />
  );
}
**/

/**
* @component button
* @section expanded
* @react
import { Button } from '@collabui/react';

export default function ButtonExpand() {
  return(
    <Button
      children='Test Me'
      onClick={() => { }}
      ariaLabel='For the Win'
      expand
    />
  );
}
**/

/**
* @component button
* @section disabled
* @react
import { Button } from '@collabui/react';

export default function ButtonDisabled() {
  return(
    <Button
      children='Test Me'
      onClick={() => { }}
      ariaLabel='For the Win'
      disabled
    />
  );
}
**/

/**
* @component button
* @section loading
* @react
import { Button } from '@collabui/react';

export default function ButtonLoading() {
  return(
    <Button
      children='Test Me'
      onClick={() => {}}
      ariaLabel='For the Win'
      loading
    />
  );
}
**/

exports.default = _default;

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(4);

__webpack_require__(58);

__webpack_require__(19);

__webpack_require__(20);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var ButtonGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ButtonGroup, _React$Component);

  function ButtonGroup() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      activeIndex: _this.props.activeIndex,
      focusIndex: 0
    };

    _this.getChildContext = function () {
      return {
        handleClick: function handleClick(event, index) {
          return _this.handleClick(event, index);
        },
        handleKeyDown: function handleKeyDown(event, index) {
          return _this.handleKeyDown(event, index);
        },
        focusIndex: _this.state.focusIndex,
        focusOnLoad: _this.props.focusOnLoad
      };
    };

    _this.verifyChildren = function () {
      var children = _this.props.children;

      var status = _react.default.Children.toArray(children).reduce(function (status, child) {
        return status && child.type.displayName === 'Button';
      }, true);

      return status;
    };

    _this.determineInitialActive = function () {
      /* eslint-disable no-console */
      var _this$state = _this.state,
          activeIndex = _this$state.activeIndex,
          children = _this$state.children;

      if (activeIndex < 0 && activeIndex > children.length - 1) {
        console.warn('[@collabui/react] ButtonGroup: activeIndex is out of bound');
        return;
      }

      var initialActive = _this.getNewIndex(activeIndex - 1, 1);

      _this.setActiveIndex(initialActive);
      /* eslint-enable no-console */

    };

    _this.setFocusIndex = function (index) {
      var focusIndex = _this.state.focusIndex;
      return focusIndex !== index && _this.setState({
        focusIndex: index
      });
    };

    _this.setActiveIndex = function (index) {
      var activeIndex = _this.state.activeIndex;
      return activeIndex !== index && _this.setState({
        activeIndex: index
      });
    };

    _this.handleClick = function (event, index) {
      var onSelect = _this.props.onSelect;

      _this.setFocusIndex(index);

      _this.setActiveIndex(index);

      onSelect && onSelect(event, index);
    };

    _this.getNewIndex = function (currentIndex, change) {
      var children = _this.props.children;
      var length = children.length - 1;

      var getPossibleIndex = function getPossibleIndex() {
        if (currentIndex + change < 0) {
          return length;
        } else if (currentIndex + change > length) {
          return 0;
        }

        return currentIndex + change;
      };

      var possibleIndex = getPossibleIndex();

      var potentialTarget = _react.default.Children.toArray(children)[possibleIndex];

      return potentialTarget.props.disabled ? _this.getNewIndex(possibleIndex, change) : possibleIndex;
    };

    _this.getIncludesFirstCharacter = function (str, char) {
      return str.charAt(0).toLowerCase().includes(char);
    };

    _this.setFocusByFirstCharacter = function (char, currentIdx) {
      var children = _this.props.children;
      var length = children.length - 1;

      var newIndex = _react.default.Children.toArray(children).reduce(function (agg, child, idx, arr) {
        var index = currentIdx + idx + 1 > length ? Math.abs(currentIdx + idx - length) : currentIdx + idx + 1;
        var label = typeof arr[index].props.children === 'string' ? arr[index].props.children : '';
        return !agg.length && !arr[index].props.disabled && !arr[index].props.isReadOnly && _this.getIncludesFirstCharacter(label, char) ? agg.concat(index) : agg;
      }, []);

      !isNaN(newIndex[0]) && _this.setFocusIndex(newIndex[0]);
    };

    _this.handleKeyDown = function (e, idx) {
      var newIndex;
      var flag = false;
      var char = e.key;

      var isPrintableCharacter = function isPrintableCharacter(str) {
        return str.length === 1 && str.match(/\S/);
      };

      switch (e.which) {
        case 38:
        case 37:
          newIndex = _this.getNewIndex(idx, -1);

          _this.setFocusIndex(newIndex);

          flag = true;
          break;

        case 39:
        case 40:
          newIndex = _this.getNewIndex(idx, 1);

          _this.setFocusIndex(newIndex);

          flag = true;
          break;

        default:
          if (isPrintableCharacter(char)) {
            _this.setFocusByFirstCharacter(char, idx);

            flag = true;
          }

          break;
      }

      if (flag) {
        e.stopPropagation();
        e.preventDefault();
      }
    };

    return _this;
  }

  var _proto = ButtonGroup.prototype;

  _proto.componentWillMount = function componentWillMount() {
    if (!this.verifyChildren()) {
      throw new Error('ButtonGroup should only contain Buttons as children.');
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    var _this$state2 = this.state,
        focusIndex = _this$state2.focusIndex,
        activeIndex = _this$state2.activeIndex;
    var initialFocus = this.getNewIndex(focusIndex - 1, 1);
    this.setFocusIndex(initialFocus);
    activeIndex !== null && this.determineInitialActive();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        ariaLabel = _this$props.ariaLabel,
        children = _this$props.children,
        className = _this$props.className,
        highlightSelected = _this$props.highlightSelected,
        justified = _this$props.justified,
        pillWidth = _this$props.pillWidth,
        theme = _this$props.theme,
        type = _this$props.type;
    var activeIndex = this.state.activeIndex;

    var setButtons = function setButtons() {
      return _react.default.Children.map(children, function (child, idx) {
        return _react.default.cloneElement(child, {
          active: type === 'pill' ? false : highlightSelected && activeIndex === idx,
          index: idx,
          className: child.props.children.type && child.props.children.type.displayName === 'Icon' ? 'cui-button--icon-group' : '',
          style: Object.assign({}, pillWidth && {
            width: pillWidth
          })
        });
      });
    };

    return _react.default.createElement("div", {
      className: 'cui-button-group' + ("" + (theme && " cui-button-group--" + theme || '')) + ("" + (justified && " cui-button-group--justified" || '')) + ("" + (type && " cui-button-group--" + type || '')) + ("" + (className && " " + className || '')),
      role: "group",
      "aria-label": ariaLabel
    }, setButtons());
  };

  return ButtonGroup;
}(_react.default.Component);

ButtonGroup.displayName = 'ButtonGroup';
ButtonGroup.childContextTypes = {
  handleClick: _propTypes.default.func,
  handleKeyDown: _propTypes.default.func,
  focusIndex: _propTypes.default.number,
  focusOnLoad: _propTypes.default.bool
};
ButtonGroup.propTypes = {
  /** @prop Sets initial active Button by index | null */
  activeIndex: _propTypes.default.number,

  /** @prop Text to display for blindness accessibility features | '' */
  ariaLabel: _propTypes.default.string,

  /** @prop Children nodes to render inside ButtonGroup | null */
  children: _propTypes.default.node,

  /** @prop Optional css class string | '' */
  className: _propTypes.default.string,

  /** @prop Set focus to ButtonGroup when page is loaded | false */
  focusOnLoad: _propTypes.default.bool,

  /** @prop Highlights the selected button within group | true */
  highlightSelected: _propTypes.default.bool,

  /** @prop Optional text-justified css styling | true */
  justified: _propTypes.default.bool,

  /** @prop Handler to be called when the user selects ButtonGroup | null */
  onSelect: _propTypes.default.func,

  /** @prop Sets width of a pill Button | '60px' */
  pillWidth: _propTypes.default.string,

  /** @prop Optional Button color theme for ButtonGroup | '' */
  theme: _propTypes.default.oneOf(['', 'dark']),

  /** @prop Optional Button type for ButtonGroup | '' */
  type: _propTypes.default.oneOf(['', 'pill'])
};
ButtonGroup.defaultProps = {
  activeIndex: null,
  ariaLabel: '',
  children: null,
  className: '',
  focusOnLoad: false,
  highlightSelected: true,
  justified: true,
  onSelect: null,
  pillWidth: '60px',
  theme: '',
  type: ''
};
var _default = ButtonGroup;
/**
* @component button-group
* @section default
* @react
*
 import { Button, ButtonGroup } from '@collabui/react';

 export default class ButtonGroupDefault extends React.PureComponent {

  render() {
    return(
      <ButtonGroup>
        <Button ariaLabel='1'>one</Button>
        <Button ariaLabel='2' disabled>two</Button>
        <Button ariaLabel='3'>three</Button>
      </ButtonGroup>
    );
  }
}
**/

/**
* @component button-group
* @section justified-false
* @react
*
 import { Button, ButtonGroup } from '@collabui/react';

 export default class ButtonGroupJustifiedFalse extends React.PureComponent {

  render() {
    return(
      <ButtonGroup justified={false}>
        <Button ariaLabel='1'>one</Button>
        <Button ariaLabel='2' disabled>two</Button>
        <Button ariaLabel='3'>three</Button>
      </ButtonGroup>
    );
  }
}
**/

/**
* @component button-group
* @section pill
* @react
*
 import { Button, ButtonGroup, Icon } from '@collabui/react';

 export default class ButtonGroupPill extends React.PureComponent {

  render() {
    return(
      <div>
        <div className='columns small-4'>
          <ButtonGroup>
            <Button ariaLabel='left'><Icon name='icon-arrow-left_12' /></Button>
            <Button ariaLabel='right'><Icon name='icon-arrow-right_12' /></Button>
          </ButtonGroup>
        </div>
        <div className='columns small-4'>
          <ButtonGroup type='pill'>
            <Button ariaLabel='left'><Icon name='icon-flag_16' /></Button>
            <Button ariaLabel='right'><Icon name='icon-cancel_16' /></Button>
          </ButtonGroup>
        </div>
        <div className='columns small-4'>
          <ButtonGroup type='pill' pillWidth='60px'>
            <Button ariaLabel='left'><Icon name='icon-flag_16' /></Button>
          </ButtonGroup>
        </div>
      </div>
    );
  }
}
**/

/**
* @component button-group
* @section highlight-false
* @react
*
 import { Button, ButtonGroup, Icon } from '@collabui/react';

 export default class ButtonGroupHiglightFalse extends React.PureComponent {

  render() {
    return(
      <ButtonGroup justified={false} highlightSelected={false}>
        <Button ariaLabel='Left'><Icon name='icon-arrow-left_12' /></Button>
        <Button ariaLabel='Today'>Today</Button>
        <Button ariaLabel='Right'><Icon name='icon-arrow-right_12' /></Button>
      </ButtonGroup>
    );
  }
}
**/

exports.default = _default;

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(4);

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(7);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _ = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * @category controls
 * @component call-control
 * @variations collab-ui-react
 */
var CallControl =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(CallControl, _React$PureComponent);

  function CallControl() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = CallControl.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        active = _this$props.active,
        ariaLabel = _this$props.ariaLabel,
        className = _this$props.className,
        disabled = _this$props.disabled,
        iconColor = _this$props.iconColor,
        iconSize = _this$props.iconSize,
        onClick = _this$props.onClick,
        type = _this$props.type,
        otherHTMLProps = _objectWithoutPropertiesLoose(_this$props, ["active", "ariaLabel", "className", "disabled", "iconColor", "iconSize", "onClick", "type"]);

    return _react.default.createElement(_.Button, _extends({
      ariaLabel: ariaLabel || type,
      circle: true,
      className: 'cui-call-control' + ("" + (type === 'cancel' && " cui-call-control--cancel" || '')) + ("" + (active && " cui-call-control--active" || '')) + ("" + (className && " " + className || '')),
      disabled: disabled,
      onClick: onClick
    }, otherHTMLProps), _react.default.createElement(_.Icon, _extends({
      name: type + "_" + iconSize
    }, iconColor && {
      color: iconColor
    })));
  };

  return CallControl;
}(_react.default.PureComponent);

CallControl.propTypes = {
  /** @prop Sets active css styling | false */
  active: _propTypes.default.bool,

  /** @prop Text to display for blindness accessibility features | '' */
  ariaLabel: _propTypes.default.string,

  /** @prop Optional css class string | '' */
  className: _propTypes.default.string,

  /** @prop Sets the attribute disabled to the CallControl button | false */
  disabled: _propTypes.default.bool,

  /** @prop Optional icon color prop | null */
  iconColor: _propTypes.default.string,

  /** @prop Optional numeric icon size prop | 24 */
  iconSize: _propTypes.default.number,

  /** @prop Handler to be called when the user taps the CallControl button | null */
  onClick: _propTypes.default.func,

  /** @prop Optional numeric size prop for CallControl button | 56 */
  size: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /** @prop Optional predefined CallControl prop type | '' */
  type: _propTypes.default.oneOf(['activities', 'camera', 'camera-muted', 'cancel', 'handset', 'microphone-muted', 'more', 'participant-list', 'share-screen', 'speaker', 'view-list'])
};
CallControl.defaultProps = {
  active: false,
  ariaLabel: '',
  className: '',
  disabled: false,
  iconColor: null,
  iconSize: 24,
  onClick: null,
  size: 56,
  type: ''
};
CallControl.displayName = 'CallControl';
var _default = CallControl;
/**
* @component call-control
* @section default
* @react
import { CallControl } from '@collabui/react';

export default function CallControlDefault() {
  return(
      <div className='row'>
        <div className="docs-example docs-example--spacing">
          <CallControl
            type='microphone-muted'
            ariaLabel='For the Win'
            size={20}
            iconSize={10}
          />
        </div>

        <div className="docs-example docs-example--spacing">
          <CallControl
            type='microphone-muted'
            ariaLabel='For the Win'
            size={40}
            iconSize={16}
          />
        </div>

        <div className="docs-example docs-example--spacing">
          <CallControl
            type='microphone-muted'
            ariaLabel='For the Win'
          />
        </div>
      </div>
  );
}

**/

/**
* @component call-control
* @section active
* @react
import { CallControl } from '@collabui/react';

export default function CallControlActive() {
  return(
    <CallControl
      type='microphone-muted'
      active
      onClick={() => { }}
      ariaLabel='For the Win'
    />
  );
}

**/

/**
* @component call-control
* @section disable
* @react
import { CallControl } from '@collabui/react';

export default function CallControlDisabled() {
  return(
    <CallControl
      type='microphone-muted'
      disabled
      onClick={() => { }}
      ariaLabel='For the Win'
    />
  );
}

**/

/**
* @component call-control
* @section cancel
* @react
import { CallControl } from '@collabui/react';

export default function CallControlCancel() {
  return(
    <CallControl
      type='cancel'
      active
      onClick={() => {}}
      ariaLabel='For the Win'
    />
  );
}

**/

exports.default = _default;

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var Card =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Card, _React$Component);

  function Card() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Card.prototype;

  // constructor (props) {
  // 	super(props);
  //
  // 	this.state = {
  // 		animationClass: ''
  // 	};
  // 	this.closeModal = this.closeModal.bind(this);
  // }
  // componentWillReceiveProps(nextProps){
  //   this.props.show !== nextProps.show
  //   && nextProps.show
  //   && setTimeout(() => {
  //     this.setState({ animationClass: 'in' });
  //   }, 0);
  // }
  //
  // closeModal () {
  // 	this.setState({ animationClass: '' });
  //
  // 	return setTimeout(() => {
  // 		this.props.onHide();
  // 	}, 300);
  // }
  //
  // getModalContent () {
  // 	const {headerLabel, showCloseButton, size} = this.props;
  //
  // 	return (
  // 		<div
  // 			className={`modal-content ${size}`}
  // 		>
  // 			{
  // 				headerLabel
  // 				&&
  // 					<ModalHeader
  // 						showCloseButton={showCloseButton}
  // 						headerLabel={headerLabel}
  // 						onHide={this.closeModal}
  // 					/>
  // 			}
  // 			{this.props.children}
  // 		</div>
  //   );
  // }
  _proto.render = function render() {
    var _this$props = this.props,
        headerLabel = _this$props.headerLabel,
        label = _this$props.label,
        headerBorder = _this$props.headerBorder,
        headerColor = _this$props.headerColor,
        headerAlign = _this$props.headerAlign,
        sizeNum = _this$props.sizeNum,
        nav = _this$props.nav; //
    // const renderModal = () => {
    // 	return show
    // 	&& (
    // 		<AriaModal
    //       onExit={this.closeModal}
    //       getApplicationNode={() => document.querySelector('#app')}
    // 			dialogClass={
    // 				`reveal-modal` +
    // 				` ${size === 'dialog' ? 'dialog' : 'full'}` +
    // 				` ${size === 'dialog' ? 'fade' : 'reveal-bottom'}` +
    // 				` ${className}` +
    // 				` ${this.state.animationClass}`
    // 			}
    // 			dialogStyle={{
    // 				zIndex: 1051,
    // 				display: 'block',
    // 				visibility: 'visible'
    // 			}}
    //       includeDefaultStyles={false}
    //       titleId={htmlId}
    //       key={1}
    //       underlayStyle={
    //         backdrop
    //         ? {
    //             zIndex: 1040,
    //             display: 'block',
    //             visibility: 'visible'
    //           }
    //         : {}
    //       }
    //       underlayClass={
    //         backdrop
    //         ? (
    //             `reveal-modal-bg fade` +
    //             ` ${this.state.animationClass}`
    //           )
    //         : ''
    //       }
    //       underlayClickExits={backdropClickExit}
    //       escapeExits={escapeExits}
    // 		>
    // 			{this.getModalContent()}
    // 		</AriaModal>
    // 	);
    // };

    var getHeader = function getHeader() {
      return _react.default.createElement("header", {
        className: "" + (headerAlign && "align-" + headerAlign || '')
      }, _react.default.createElement("h4", null, headerLabel));
    };

    return _react.default.createElement("div", {
      className: 'cui-card' + ("" + (sizeNum && " cui-card--" + sizeNum || '')) + ("" + (nav && ' cui-card--nav' || '')) + ("" + (headerBorder && ' header-border' || '')) + ("" + (headerColor && " header-background " + headerColor || ''))
    }, _react.default.createElement("article", {
      style: nav && {
        padding: '1rem',
        textAlign: 'center'
      }
    }, headerLabel && getHeader(), _react.default.createElement("h4", null, label)));
  };

  return Card;
}(_react.default.Component);

Card.displayName = 'Card';
Card.defaultProps = {
  header: '',
  headerAlign: null,
  headerBackground: '',
  headerBorder: false,
  headerColor: '',
  headerLabel: '',
  label: '',
  size: '',
  sizeNum: 0,
  nav: false // children: null,
  // show: false,
  // size: 'default',
  // backdrop: true,
  // className: '',
  // showCloseButton: true,
  // headerLabel: '',
  // backdropClickExit: false,
  // escapeExits: true

};
Card.propTypes = {
  // /** Unique HTML ID. Used for tying label to HTML input. Handy hook for automated testing. */
  // htmlId: PropTypes.string.isRequired,
  // /**
  //  * Children components
  //  */
  // children: PropTypes.node,
  // /**
  //  * show/hide modal.
  //  */
  // show: PropTypes.bool.isRequired,
  // /**
  //  * callback function invoked on close of the modal. modal can be closed on click of cross button or esc key.
  //  * onHide is mandatory props, if not passed modal can not be closed.
  //  */
  // onHide: PropTypes.func.isRequired,
  // /**
  //  * css class names
  //  */
  // className: PropTypes.string,
  // /**
  //  *  To show/hide backdrop of the modal.
  //  *  if backdrop is false then modal will become normal popup without backdrop and user can perform any action in parent screen.
  //  */
  // backdrop: PropTypes.bool,

  /** @prop Alignment of header | null */
  headerAlign: _propTypes.default.oneOf(['left', 'center']),

  /** @prop Set visitibility of the header's border | false */
  headerBorder: _propTypes.default.bool,

  /** @prop Set header color | '' */
  headerColor: _propTypes.default.string,

  /** @prop Set header's Text | '' */
  headerLabel: _propTypes.default.string,

  /** @prop Set Card Text | '' */
  label: _propTypes.default.string,

  /** @prop Set size of the card from list of prefined strings | '' */
  size: _propTypes.default.oneOf(['small', 'medium', 'large', 'full']),

  /** @prop Set number to define size | 0 */
  sizeNum: _propTypes.default.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /** @prop Sets of Card is used for nav | false */
  nav: _propTypes.default.bool
};
var _default = Card;
exports.default = _default;

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(4);

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(7);

__webpack_require__(37);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _ = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * @category controls
 * @component checkbox
 * @variations collab-ui-react
 */
var Checkbox = function Checkbox(props) {
  var checked = props.checked,
      children = props.children,
      className = props.className,
      disabled = props.disabled,
      htmlId = props.htmlId,
      indeterminate = props.indeterminate,
      inputRef = props.inputRef,
      label = props.label,
      name = props.name,
      nestedLevel = props.nestedLevel,
      onChange = props.onChange,
      required = props.required,
      value = props.value,
      otherProps = _objectWithoutPropertiesLoose(props, ["checked", "children", "className", "disabled", "htmlId", "indeterminate", "inputRef", "label", "name", "nestedLevel", "onChange", "required", "value"]);

  return _react.default.createElement("div", {
    className: 'cui-input-group cui-checkbox' + ("" + (nestedLevel && " cui-input--nested-" + nestedLevel || '')) + (" " + className)
  }, _react.default.createElement("input", _extends({
    "aria-checked": checked,
    className: "cui-input cui-checkbox__input" + ("" + (indeterminate && ' indeterminate' || '')),
    type: "checkbox",
    ref: inputRef,
    disabled: disabled,
    checked: checked,
    required: required,
    name: name,
    value: value,
    onChange: onChange,
    tabIndex: 0,
    id: htmlId
  }, otherProps)), _react.default.createElement(_.Label, {
    className: "cui-checkbox__label",
    label: label,
    htmlFor: htmlId
  }), children);
};

Checkbox.propTypes = {
  /** @prop Sets Checkbox status as checked | false */
  checked: _propTypes.default.bool,

  /** @prop Child component to display next to the input | null */
  children: _propTypes.default.node,

  /** @prop Optional css class string | ''  */
  className: _propTypes.default.string,

  /** @prop Sets the attribute disabled to the Checkbox | false */
  disabled: _propTypes.default.bool,

  /** @prop Unique HTML ID. Used for tying label to HTML input. Handy hook for automated testing */
  htmlId: _propTypes.default.string.isRequired,

  /** @prop Optional indeterminate capabilities of checkbox | false */
  indeterminate: _propTypes.default.bool,

  /** @prop optional ref attribute for Checkbox input element | null */
  inputRef: _propTypes.default.func,

  /** @prop Required label string for Checkbox */
  label: _propTypes.default.string.isRequired,

  /** @prop Sets the attribute name to the Checkbox input element | '' */
  name: _propTypes.default.string,

  /** @prop Set the level of nested checkboxes | 0 */
  nestedLevel: _propTypes.default.number,

  /** @prop Optional onChange handler invoked when user makes a change within the Checkbox input element | null */
  onChange: _propTypes.default.func,

  /** @prop Optional required setting for Checkbox input | false */
  required: _propTypes.default.bool,

  /** @prop sets value of the Checkbox input element | '' */
  value: _propTypes.default.string
};
Checkbox.defaultProps = {
  autoFocus: false,
  checked: false,
  className: '',
  disabled: false,
  indeterminate: false,
  inputRef: null,
  label: '',
  name: '',
  nestedLevel: 0,
  onChange: function onChange() {},
  required: false,
  value: ''
};
Checkbox.displayName = 'Checkbox';
var _default = Checkbox;
/**
* @component checkbox
* @section default
* @react

import { Checkbox, CheckboxGroup, InputHelper } from '@collabui/react';

export default function CheckboxDefault() {

  return (
    <CheckboxGroup name='CheckboxGroup1'>
      <Checkbox
        value='me'
        label='me'
        htmlId='testCheckbox1'
        onChange={() => { }}
      />
    </CheckboxGroup>
  );
}
**/

/**
* @component checkbox
* @section group
* @react

import { Checkbox, CheckboxGroup, InputHelper } from '@collabui/react';

export default function CheckboxGroupExample() {

  return (
    <CheckboxGroup name='CheckboxGroup1'>
      <Checkbox
        value='me'
        label='me'
        htmlId='testCheckbox1'
        onChange={() => { }}
      />
      <Checkbox
        value='you'
        label='you'
        htmlId='testCheckbox2'
        onChange={() => { }}
      />
      <Checkbox
        value='us'
        label='us'
        htmlId='testCheckbox3'
        onChange={() => { }}
      />
    </CheckboxGroup>
  );
}
**/

/**
* @component checkbox
* @section disabled
* @react
import { Checkbox } from '@collabui/react';

export default function CheckboxDisabled() {
  return (
    <Checkbox
      value='disabledChecked'
      label='Disabled Checkbox'
      htmlId='disabledCheckbox'
      disabled
      onChange={()=>{}}
    />
  );
}
**/

/**
* @component checkbox
* @section indeterminate
* @react
import { Checkbox } from '@collabui/react';

export default function CheckboxIndeterminate() {
  return (
    <Checkbox
      value='indeterminate'
      label='Indeterminate Checkbox'
      htmlId='indeterminateCheckbox'
      onChange={()=>{}}
      indeterminate
    />
  );
}
**/

/**
* @component checkbox
* @section nested
* @react
import { Checkbox } from '@collabui/react';

export default class CheckboxNested extends React.PureComponent {
  state = {
    parent: false,
    child1: false,
    child2: false,
    child3: false,
  }

  render() {
    return (
      <span>
        <Checkbox
          value='parent'
          label='Parent Checkbox Example'
          htmlId='parentCheckbox'
          checked={this.state.parent}
          onChange={() => this.setState({ parent: !this.state.parent })}
          key='child-0'
        />
        <Checkbox
          value='child1'
          label='Child Checkbox Nested 1 Level'
          htmlId='childCheckbox1'
          nestedLevel={1}
          checked={this.state.child1}
          onChange={() => this.setState({ child1: !this.state.child1 })}
          key='child-1'
        />
        <Checkbox
          value='child2'
          label='Child Checkbox Nested 2 Levels'
          htmlId='childCheckbox2'
          nestedLevel={2}
          checked={this.state.child2}
          onChange={() => this.setState({ child2: !this.state.child2 })}
          key='child-2'
        />
        <Checkbox
          value='child3'
          label='Child Checkbox Nested 3 Levels'
          htmlId='childCheckbox3'
          nestedLevel={3}
          checked={this.state.child3}
          onChange={() => this.setState({ child3: !this.state.child3 })}
          key='child-3'
        />
      </span>
    );
  }
}
**/

exports.default = _default;

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(37);

__webpack_require__(19);

__webpack_require__(20);

__webpack_require__(6);

__webpack_require__(5);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * @category controls
 * @component checkbox
 * @variations collab-ui-react
 */
var CheckboxGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CheckboxGroup, _React$Component);

  function CheckboxGroup() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      values: []
    };

    _this.handleToggle = function (value) {
      var newValues;
      var onChange = _this.props.onChange;
      var values = _this.state.values;
      var isActive = values.includes(value);

      if (isActive) {
        newValues = values.filter(function (v) {
          return v !== value;
        });
        onChange(_this.props.values.filter(function (n) {
          return n !== value;
        }));
      } else {
        newValues = values.concat(value);
        onChange([].concat(_this.props.values, [value]));
      }

      _this.setState({
        values: newValues
      });
    };

    return _this;
  }

  var _proto = CheckboxGroup.prototype;

  _proto.componentWillMount = function componentWillMount() {
    if (this.props.values) {
      this.setState({
        values: this.props.values
      });
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        children = _this$props.children,
        name = _this$props.name;
    var values = this.state.values;

    var addHandlersToChildren = function addHandlersToChildren() {
      return _react.default.Children.map(children, function (child) {
        var value = child.props.value;
        return _react.default.cloneElement(child, {
          name: name,
          checked: values.includes(value),
          'aria-checked': values.includes(value),
          onChange: function onChange() {
            return _this2.handleToggle(value);
          }
        });
      });
    };

    return _react.default.createElement("div", {
      className: "cui-checkbox-group"
    }, addHandlersToChildren());
  };

  return CheckboxGroup;
}(_react.default.Component);

CheckboxGroup.displayName = 'CheckboxGroup';
CheckboxGroup.propTypes = {
  /** @prop Children nodes to render inside Accordion | null */
  children: _propTypes.default.node,

  /** @prop Callback fired with the value or array of active values when the user presses a button | null
   * @controllable values
  */
  onChange: _propTypes.default.func,

  /** @prop An array of values, of the active (pressed) buttons | () => {}
   * @controllable onChange
   */
  values: _propTypes.default.array,

  /** @prop An HTML `<input>` name for each child button | '' */
  name: _propTypes.default.string
};
CheckboxGroup.defaultProps = {
  values: [],
  onChange: function onChange() {},
  name: ''
};
var _default = CheckboxGroup;
exports.default = _default;

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _ = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *
 * @category containers
 * @component chip
 * @variations collab-ui-react
 *
 */
var Chip = function Chip(_ref) {
  var className = _ref.className,
      leftContent = _ref.leftContent,
      fileDownloadLink = _ref.fileDownloadLink,
      fileType = _ref.fileType,
      rightContent = _ref.rightContent,
      subTitle = _ref.subTitle,
      title = _ref.title,
      type = _ref.type;
  Chip.displayName = 'Chip'; // This appears to be a false positive
  // See: https://github.com/yannickcr/eslint-plugin-react/issues/1181
  // eslint-disable-next-line react/no-multi-comp

  function buildChipLeft() {
    if (type === 'file') {
      return _react.default.createElement(_.Icon, {
        name: "file-" + fileType + "_32"
      });
    }

    if (type === 'recording') {
      return _react.default.createElement(_.Icon, {
        name: "play-circle_32",
        color: "white"
      });
    }

    if (type === 'unauthorized') {
      return _react.default.createElement(_.Icon, {
        name: "warning_32"
      });
    }

    return leftContent;
  } // eslint-disable-next-line react/no-multi-comp


  function buildChipRight() {
    if (rightContent) {
      return rightContent;
    }

    if (type === 'file' && fileDownloadLink) {
      return _react.default.createElement("a", {
        className: "file-download",
        download: true,
        href: fileDownloadLink
      }, _react.default.createElement("i", {
        className: "icon icon-download_32"
      }));
    }

    return null;
  }

  var chipLeft = buildChipLeft();
  var chipRight = buildChipRight();
  return _react.default.createElement("div", {
    className: 'cui-chip' + ("" + (className && " " + className || ''))
  }, _react.default.createElement("div", {
    className: 'cui-chip-left' + ("" + (type && " " + type || ''))
  }, chipLeft), _react.default.createElement("div", {
    className: "cui-chip-center"
  }, title && _react.default.createElement("div", {
    className: "cui-chip__title lead"
  }, title), subTitle && _react.default.createElement("div", {
    className: "cui-chip__sub-title subheader"
  }, subTitle)), chipRight && _react.default.createElement("div", {
    className: "cui-chip-right"
  }, chipRight));
};

Chip.propTypes = {
  /** @prop Optional css class string | '' */
  className: _propTypes.default.string,

  /** @prop Sets file for anchor element to download | '' */
  fileDownloadLink: _propTypes.default.string,

  /** @prop Sets type of file | null */
  fileType: _propTypes.default.oneOf(['audio', 'graph', 'image', 'locked', 'missing', 'pdf', 'spreadsheet', 'text', 'video', 'zip']),

  /** @prop Node that becomes the content on the left of Chip | null */
  leftContent: _propTypes.default.node,

  /** @prop NOde that becomes the content on the right of Chip | null */
  rightContent: _propTypes.default.node,

  /** @prop Text of the Chip's subtitle | '' */
  subTitle: _propTypes.default.string,

  /** @prop Text of the Chip's title | null */
  title: _propTypes.default.string,

  /** @prop Sets the type of icon for the Chip | null */
  type: _propTypes.default.oneOf(['file', 'recording', 'unauthorized'])
};
Chip.defaultProps = {
  className: '',
  fileDownloadLink: '',
  fileType: null,
  leftContent: null,
  rightContent: null,
  subTitle: '',
  title: null,
  type: null
};
var _default = Chip;
/**
 * @component chip
 * @section recording
 * @react
 import { Chip } from '@collabui/react';

 export default function ChipDefault() {
   return (
      <Chip
        type="unauthorized"
        title="Webex Teams Recording"
        subTitle="18 min"
      />
   );
 }

 **/

/**
 * @component chip
 * @section recording
 * @react
 import { Chip } from '@collabui/react';

 export default function ChipRecording() {
   return (
      <Chip
        type="recording"
        title="Webex Teams Recording"
        subTitle="18 min"
      />
   );
 }

 **/

/**
 * @component chip
 * @section file
 * @react
 import { Chip } from '@collabui/react';

 export default function ChipFile() {
   return (
      <Chip
        type="file"
        fileType="audio"
        title="Filename.mp3"
        subTitle="23kb"
        fileDownloadLink="https://www.google.com"
      />
   );
 }
 **/

exports.default = _default;

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(4);

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(7);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * @component CloseIcon
 * @variations collab-ui-react
 */
var CloseIcon = function CloseIcon(props) {
  var className = props.className,
      onClick = props.onClick,
      otherHTMLProps = _objectWithoutPropertiesLoose(props, ["className", "onClick"]);

  return _react.default.createElement("button", _extends({
    className: "cui-close" + ("" + (className && " " + className || '')),
    onClick: onClick
  }, otherHTMLProps));
};

CloseIcon.defaultProps = {
  onClick: function onClick() {},
  className: ''
};
CloseIcon.propTypes = {
  /** @prop Handler when the user clicks the CloseIcon | () => {} */
  onClick: _propTypes.default.func,

  /** @prop Optional css class string | '' */
  className: _propTypes.default.string
};
CloseIcon.displayName = 'CloseIcon';
var _default = CloseIcon;
exports.default = _default;

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(7);

__webpack_require__(4);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _lodash = __webpack_require__(13);

var _ = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * @category communication
 * @component coachmark
 * @variations collab-ui-react
 */
var Coachmark =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Coachmark, _React$Component);

  function Coachmark() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      isOpen: _this.props.isOpen
    };

    _this.delayedHide = function (e) {
      var onClick = _this.props.onClick;

      if (_this.showTimerId) {
        clearTimeout(_this.showTimerId);
        _this.showTimerId = null;
      }

      var delay = _this.props.hideDelay ? _this.props.hideDelay : _this.props.delay;
      _this.hideTimerId = setTimeout(function () {
        _this.hideTimerId = null;

        _this.setState(function () {
          onClick && onClick(e);
          return {
            isOpen: false
          };
        });
      }, delay);
    };

    _this.delayedShow = function () {
      if (_this.hideTimerId) {
        clearTimeout(_this.hideTimerId);
        _this.hideTimerId = null;
      }

      var delay = _this.props.showDelay ? _this.props.showDelay : _this.props.delay;
      _this.showTimerId = setTimeout(function () {
        _this.showTimerId = null;

        _this.setState({
          isOpen: true
        });
      }, delay);
    };

    _this.handleClose = function () {
      _this.setState({
        isOpen: false
      });
    };

    return _this;
  }

  var _proto = Coachmark.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.props.isOpen && this.delayedShow();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.isOpen !== this.props.isOpen) {
      return this.props.isOpen ? this.delayedShow() : this.delayedHide();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.hideTimerId && clearTimeout(this.hideTimerId);
    this.showTimerId && clearTimeout(this.showTimerId);
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        allowClickAway = _this$props.allowClickAway,
        buttonChildren = _this$props.buttonChildren,
        className = _this$props.className,
        children = _this$props.children,
        closeOnClick = _this$props.closeOnClick,
        contentNode = _this$props.contentNode,
        direction = _this$props.direction,
        header = _this$props.header,
        maxWidth = _this$props.maxWidth,
        onClick = _this$props.onClick,
        subheader = _this$props.subheader,
        props = _objectWithoutPropertiesLoose(_this$props, ["allowClickAway", "buttonChildren", "className", "children", "closeOnClick", "contentNode", "direction", "header", "maxWidth", "onClick", "subheader"]);

    var otherProps = (0, _lodash.omit)(Object.assign({}, props), ['delay', 'hideDelay', 'isOpen', 'showDelay']);

    var anchorWithRef = children && _react.default.cloneElement(children, {
      ref: function ref(ele) {
        return _this2.anchorRef = ele;
      }
    });

    var content = _react.default.createElement("div", {
      className: "cui-coachmark__container"
    }, contentNode ? contentNode : [header && _react.default.createElement("div", {
      className: "cui-coachmark__header",
      key: "content-0"
    }, header), subheader && _react.default.createElement("div", {
      className: "cui-coachmark__subheader",
      key: "content-1"
    }, subheader), onClick && _react.default.createElement(_.Button, _extends({
      onClick: this.delayedHide
    }, otherProps, {
      key: "content-2"
    }), buttonChildren)]);

    return _react.default.createElement("div", {
      className: "cui-coachmark"
    }, anchorWithRef, _react.default.createElement(_.EventOverlay, _extends({
      ref: function ref(_ref) {
        return _this2.overlay = _ref;
      },
      allowClickAway: allowClickAway,
      anchorNode: this.anchorRef,
      isOpen: this.state.isOpen,
      className: className,
      showArrow: true,
      direction: direction,
      close: this.handleClose,
      closeOnClick: closeOnClick
    }, maxWidth && {
      maxWidth: maxWidth
    }), content));
  };

  return Coachmark;
}(_react.default.Component);

Coachmark.displayName = 'Coachmark';
Coachmark.defaultProps = {
  allowClickAway: false,
  buttonChildren: null,
  children: null,
  className: '',
  closeOnClick: false,
  contentNode: null,
  delay: 0,
  direction: 'top-center',
  header: '',
  hideDelay: 0,
  isOpen: false,
  maxWidth: null,
  onClick: null,
  showDelay: 0,
  subheader: ''
};
Coachmark.propTypes = {
  /** @prop Allows user to click outside of element | false */
  allowClickAway: _propTypes.default.bool,

  /** @prop Button nodes within Coachmark | null */
  buttonChildren: _propTypes.default.node,

  /** @prop Optional css class string | '' */
  className: _propTypes.default.string,

  /** @prop Children nodes to render inside Coachmark | null */
  children: _propTypes.default.node.isRequired,

  /** @prop Allows Coachmark to be closed by a click from the user | false */
  closeOnClick: _propTypes.default.bool,

  /** @prop Node with content that populates the Coachmark | null */
  contentNode: _propTypes.default.node,

  /** @prop Sets the time the timer is delayed | 0 */
  delay: _propTypes.default.number,

  /** @prop Sets the direction the Coachmark opens up | 'top-center' */
  direction: _propTypes.default.oneOf(['top-center', 'top-left', 'top-right', 'left-center', 'left-top', 'left-bottom', 'bottom-center', 'bottom-left', 'bottom-right', 'right-center', 'right-top', 'right-bottom']),

  /** @prop Sets the header node of Coachmark | '' */
  header: _propTypes.default.node,

  /** @prop Sets the time delay to hide the Coachmark | 0 */
  hideDelay: _propTypes.default.number,

  /** @prop Sets the initial visibility of Coachmark | false */
  isOpen: _propTypes.default.bool,

  /** @prop Sets the maximum width of Coachmark | null */
  maxWidth: _propTypes.default.number,

  /** @prop Handler to be called when the user clicks the Coachmark | null */
  onClick: _propTypes.default.func,

  /** @prop Shows visibility of the delay value | 0 */
  showDelay: _propTypes.default.number,

  /** @prop Sets the subheader node of the Coachmark | '' */
  subheader: _propTypes.default.node
};
var _default = Coachmark;
/**
* @name Coachmark Default
*
* @category communication
* @component coachmark
* @section default
*
* @js

import {
  Avatar,
  Button,
  Coachmark,
  SpaceListItem,
} from '@collabui/react';

 export default class CoachmarkDefault extends React.Component {

  state = {
    openFirst: true,
    openNext: false,
    openLast: false
  }

  render() {
    const {openFirst, openNext, openLast} = this.state;

    return (
      <div style={{display: 'flex', flexFlow: 'row nowrap', justifyContent: 'space-between'}}>
        <Coachmark
          isOpen={openFirst}
          maxWidth={272}
          onClick={() => this.setState({openFirst: false, openNext: true})}
          buttonChildren={'Got It'}
          header={`Header prop(node)`}
          subheader={`Subheader prop(node)`}
          direction='bottom-center'
          ariaLabel='Open Coachmark 1'
        >
          <Button ariaLabel='test' onClick={() => this.setState({openFirst: true, openNext: false, openLast: false})}>Coachmark Anchor</Button>
        </Coachmark>
        <Coachmark
          isOpen={openNext}
          onClick={() => this.setState({openLast: true, openNext: false})}
          buttonChildren={'Click for next Coachmark'}
          header={`Header prop(node)`}
          direction='top-center'
          ariaLabel='Open Coachmark 2'
        >
          <Button ariaLabel='test' onClick={() => this.setState({openFirst: false, openNext: true, openLast: false})}>2nd Coachmark Anchor</Button>
        </Coachmark>
        <Coachmark isOpen={openLast}
          contentNode={<div>contentNode prop(node)</div>}
          direction='bottom-center'
          ariaLabel='Open Coachmark 3'
        >
          <Button ariaLabel='test' onClick={() => this.setState({openFirst: false, openNext: false, openLast: true})}>3rd Coachmark Anchor</Button>
        </Coachmark>
      </div>
    );
  }
}
**/

exports.default = _default;

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(7);

__webpack_require__(4);

__webpack_require__(19);

__webpack_require__(20);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _ = __webpack_require__(8);

var _lodash = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var ComboBox =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ComboBox, _React$Component);

  function ComboBox() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      filteredOptions: [],
      focus: -1,
      id: _this.props.id || (0, _lodash.uniqueId)('cui-combo-box-'),
      isOpen: false,
      value: ''
    };

    _this.mapOptionsToListItem = function () {
      var options = _this.props.options;
      return options.map(function (option, i) {
        return _react.default.createElement(_.ListItem, {
          key: i,
          label: option
        });
      });
    };

    _this.setFilteredOptions = function (filter) {
      var onChange = _this.props.onChange;
      var filteredOptions = !onChange ? _this.applyFilter(filter) : _this.options;

      _this.setState({
        isOpen: !!filteredOptions.length,
        filteredOptions: filteredOptions
      });
    };

    _this.hidePopover = function () {
      _this.setState({
        isOpen: false
      });
    };

    _this.handleToggle = function () {
      var filteredOptions = _this.state.filteredOptions;
      filteredOptions.length && _this.setState({
        isOpen: true
      });
    };

    _this.applyFilter = function (value) {
      var searchProp = _this.props.searchProp;

      var isSubString = function isSubString(string) {
        return value && string.toLowerCase().includes(value.toLowerCase());
      };

      return _this.options.filter(function (option) {
        return option.props[searchProp] && isSubString(option.props[searchProp]) || ['ListItemHeader'].includes(option.type.displayName);
      });
    };

    _this.handleChange = function (e) {
      var onChange = _this.props.onChange;
      var focus = _this.state.focus;

      _this.setFilteredOptions(e.target.value);

      _this.setState({
        value: e.target.value,
        focus: !onChange ? -1 : focus
      }, function () {
        return onChange && onChange(e, e.target.value);
      });
    };

    _this.handleClick = function (e, selectedOption) {
      var searchProp = _this.props.searchProp;
      var onSelect = _this.props.onSelect;

      _this.setFilteredOptions(selectedOption.props[searchProp]);

      _this.setState({
        value: selectedOption.props[searchProp],
        isOpen: false,
        focus: -1
      }, function () {
        return onSelect && onSelect(e, selectedOption);
      });
    };

    _this.setFocus = function (index) {
      _this.setState({
        focus: index
      });
    };

    _this.handleKeyDown = function (e) {
      var flag = false;
      var newIndex;
      var _this$state = _this.state,
          filteredOptions = _this$state.filteredOptions,
          focus = _this$state.focus,
          isOpen = _this$state.isOpen;
      var length = filteredOptions && filteredOptions.length - 1;

      var getNewIndex = function getNewIndex(currentIndex, change) {
        var getPossibleIndex = function getPossibleIndex() {
          if (currentIndex + change < 0) {
            return length;
          } else if (currentIndex + change > length) {
            return 0;
          }

          return currentIndex + change;
        };

        var possibleIndex = getPossibleIndex();

        var potentialTarget = _react.default.Children.toArray(filteredOptions)[possibleIndex];

        return potentialTarget.props.disabled || potentialTarget.props.isReadOnly ? getNewIndex(possibleIndex, change) : possibleIndex;
      };

      switch (e.which) {
        case 13:
          isOpen && focus !== -1 && _this.handleClick(e, filteredOptions[focus]);
          flag = true;
          break;

        case 38:
          if (isOpen) {
            newIndex = getNewIndex(focus, -1);

            _this.setFocus(newIndex);
          }

          flag = true;
          break;

        case 40:
          if (isOpen) {
            newIndex = getNewIndex(focus, 1);

            _this.setFocus(newIndex);
          }

          flag = true;
          break;

        default:
          break;
      }

      if (flag) {
        e.stopPropagation();
        e.preventDefault();
      }
    };

    return _this;
  }

  var _proto = ComboBox.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var children = this.props.children;
    this.options = children && _react.default.Children.toArray(children) || this.mapOptionsToListItem();
    this.setFilteredOptions();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this$props = this.props,
        options = _this$props.options,
        children = _this$props.children;
    var value = this.state.value;

    if (prevProps.options !== options || prevProps.children !== children) {
      this.options = children && _react.default.Children.toArray(children) || this.mapOptionsToListItem();
      this.setFilteredOptions(value);
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        className = _this$props2.className,
        clear = _this$props2.clear,
        disabled = _this$props2.disabled,
        hasSearchIcon = _this$props2.hasSearchIcon,
        inputProps = _this$props2.inputProps,
        placeholder = _this$props2.placeholder,
        theme = _this$props2.theme,
        props = _objectWithoutPropertiesLoose(_this$props2, ["className", "clear", "disabled", "hasSearchIcon", "inputProps", "placeholder", "theme"]);

    var otherProps = (0, _lodash.omit)(Object.assign({}, props), ['children', 'id', 'onChange', 'onSelect', 'options', 'searchProp']);
    var _this$state2 = this.state,
        filteredOptions = _this$state2.filteredOptions,
        focus = _this$state2.focus,
        id = _this$state2.id,
        isOpen = _this$state2.isOpen,
        value = _this$state2.value;
    var activeDescendant = this.activeChild && this.activeChild.id;
    var InputComp = hasSearchIcon ? _.SearchInput : _.Input;

    var input = _react.default.createElement(InputComp, _extends({
      "aria-autocomplete": "list",
      clear: clear,
      disabled: disabled,
      inputRef: function inputRef(ref) {
        return _this2.anchorNode = ref;
      },
      onChange: this.handleChange,
      onClick: this.handleToggle,
      onKeyDown: this.handleKeyDown,
      placeholder: placeholder,
      theme: theme,
      value: value
    }, activeDescendant && {
      'aria-activedescendant': activeDescendant
    }, inputProps));

    var renderFilteredOption = filteredOptions && filteredOptions.map(function (option, i) {
      return _react.default.cloneElement(option, Object.assign({
        active: i === focus,
        key: i,
        onClick: function onClick(e) {
          return _this2.handleClick(e, option);
        },
        refName: 'option',
        role: 'option'
      }, focus === i && {
        ref: function ref(_ref) {
          return _this2.activeChild = _ref;
        }
      }));
    });

    var dropdownElement = this.anchorNode && _react.default.createElement(_.EventOverlay, _extends({
      allowClickAway: true,
      anchorNode: this.anchorNode,
      close: this.hidePopover,
      isOpen: isOpen
    }, otherProps), _react.default.createElement("div", _extends({
      className: "cui-combo-box__options",
      id: id,
      role: "listbox"
    }, this.anchorNode && {
      style: {
        width: this.anchorNode.getBoundingClientRect().width
      }
    }), renderFilteredOption));

    return _react.default.createElement("div", {
      "aria-controls": id,
      "aria-haspopup": "listbox",
      "aria-expanded": isOpen,
      className: 'cui-combo-box' + ("" + (className && " " + className || '')),
      role: "combobox"
    }, input, dropdownElement);
  };

  return ComboBox;
}(_react.default.Component);

ComboBox.displayName = 'ComboBox';
ComboBox.propTypes = {
  /** @prop Children nodes to render inside ComboBox | null */
  children: _propTypes.default.node,

  /** @prop Optional css class string | '' */
  className: _propTypes.default.string,

  /** @prop Sets the initial input element as empty | false */
  clear: _propTypes.default.bool,

  /** @prop Sets the attribute disabled to the ComboBox | false */
  disabled: _propTypes.default.bool,

  /** @prop Sets the ComboBox to have a search icon | true */
  hasSearchIcon: _propTypes.default.bool,

  /** @prop Sets the ID of the ComboBox */
  id: _propTypes.default.string,

  /** @prop Collection of props unique for Input element | null */
  inputProps: _propTypes.default.shape({}),

  /** @prop Handler invoked when the user presses any key | null */
  onChange: _propTypes.default.func,

  /** @prop Handler invoked when the user selects the ComboBox | null  */
  onSelect: _propTypes.default.func,

  /** @prop Array of options for the ComboBox dropdown | [] */
  options: _propTypes.default.arrayOf(_propTypes.default.string),

  /** @prop Text that initially populates the input field for guidence | ''  */
  placeholder: _propTypes.default.string,

  /** @prop Sets the search prop | 'label' */
  searchProp: _propTypes.default.string,

  /** @prop Sets the target offset | { horizontal: 0, vertical: 4 } */
  targetOffset: _propTypes.default.shape({
    horizontal: _propTypes.default.number,
    vertical: _propTypes.default.number
  }),

  /** @prop Sets the color theme of the ComboBox | '' */
  theme: _propTypes.default.string
};
ComboBox.defaultProps = {
  children: null,
  className: '',
  clear: false,
  disabled: false,
  hasSearchIcon: true,
  id: null,
  inputProps: null,
  onChange: null,
  onSelect: null,
  options: [],
  placeholder: '',
  searchProp: 'label',
  targetOffset: {
    horizontal: 0,
    vertical: 4
  },
  theme: ''
};
var _default = ComboBox;
/**
* @component combo-box
* @section default
* @react
import { ComboBox } from '@collabui/react';

 export default class ComboBoxDefault extends React.PureComponent {
  render() {
    return (
      <ComboBox options={['a', 'ab', 'abc']} />
    );
  }
}

**/

/**
* @component combo-box
* @section clear
* @react
import { ComboBox } from '@collabui/react';

 export default class ComboBoxClear extends React.PureComponent {
  render() {
    return (
      <ComboBox
        options={['a', 'ab', 'abc']}
        clear
      />
    );
  }
}

**/

exports.default = _default;

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CompositeAvatar = function CompositeAvatar(props) {
  var children = props.children,
      size = props.size,
      className = props.className;

  var isAvatar = function isAvatar() {
    return children.reduce(function (prev, child) {
      return prev && child.type.displayName === 'Avatar';
    }, true);
  };

  var getChildren = function getChildren() {
    if (children.length === 2 && isAvatar()) {
      return children;
    }

    throw new Error('Children should have 2 Avatar component');
  };

  return _react.default.createElement("div", {
    className: 'cui-composite-avatar' + ("" + (size && " cui-composite-avatar--" + size || '')) + ("" + (className && " " + className || ''))
  }, getChildren());
};

CompositeAvatar.displayName = 'CompositeAvatar';
CompositeAvatar.propTypes = {
  /** @prop Children nodes to render inside CompositeAvatar | null */
  children: _propTypes.default.node,

  /** @prop Optional css class string | '' */
  className: _propTypes.default.string,

  /** @prop Sets the size of the CompositeAvatar | 'medium' */
  size: _propTypes.default.oneOf(['small', 'medium', 'large', 28, 40, 84, 135])
};
CompositeAvatar.defaultProps = {
  className: '',
  size: 'medium',
  children: null
};
var _default = CompositeAvatar;
exports.default = _default;

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(4);

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(7);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _ = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CollapseButton = function CollapseButton(props) {
  var collapse = props.collapse,
      alignment = props.alignment,
      onClick = props.onClick,
      className = props.className,
      otherProps = _objectWithoutPropertiesLoose(props, ["collapse", "alignment", "onClick", "className"]);

  var handleClick = function handleClick() {
    onClick && onClick();
  };

  var getIconName = function getIconName() {
    return collapse ? 'arrow-right-optical_14' : 'arrow-left-optical_14';
  };

  return _react.default.createElement(_.Button, _extends({
    ariaLabel: collapse ? 'expand' : 'collapse',
    className: 'cui-collapse-button' + (" cui-collapse-button--" + alignment) + ("" + (className && " " + className || '')),
    children: _react.default.createElement(_.Icon, {
      name: getIconName()
    }),
    onClick: function onClick() {
      return handleClick();
    }
  }, otherProps));
};

CollapseButton.displayName = 'CollapseButton';
CollapseButton.defaultProps = {
  collapse: true,
  alignment: 'left',
  onClick: null,
  className: ''
};
CollapseButton.propTypes = {
  /** @prop Sets the collapse css styling | true */
  collapse: _propTypes.default.bool,

  /** @prop Sets the positioning of the CollapseButton | 'left' */
  alignment: _propTypes.default.oneOf(['left', 'right', 'top', 'bottom']),

  /** @prop Handler to be called when the user taps the CollapseButton | null */
  onClick: _propTypes.default.func,

  /** @prop Optional css class string | '' */
  className: _propTypes.default.string
};
var _default = CollapseButton;
exports.default = _default;

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(7);

__webpack_require__(4);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _ChatContent = _interopRequireDefault(__webpack_require__(499));

var _FileContent = _interopRequireDefault(__webpack_require__(500));

var _IconContent = _interopRequireDefault(__webpack_require__(501));

var _lodash = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var ContentItem =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(ContentItem, _React$PureComponent);

  function ContentItem() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = ContentItem.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        actionNode = _this$props.actionNode,
        aspect = _this$props.aspect,
        className = _this$props.className,
        content = _this$props.content,
        failedText = _this$props.failedText,
        fileSize = _this$props.fileSize,
        height = _this$props.height,
        icon = _this$props.icon,
        isProtected = _this$props.isProtected,
        loading = _this$props.loading,
        loadingText = _this$props.loadingText,
        style = _this$props.style,
        subtitle = _this$props.subtitle,
        title = _this$props.title,
        type = _this$props.type,
        width = _this$props.width,
        props = _objectWithoutPropertiesLoose(_this$props, ["actionNode", "aspect", "className", "content", "failedText", "fileSize", "height", "icon", "isProtected", "loading", "loadingText", "style", "subtitle", "title", "type", "width"]);

    var otherProps = (0, _lodash.omit)(Object.assign({}, props), ['gifIcon']);

    var findAspect = function findAspect(width, height) {
      if (width && height) {
        var aspectRatioObj = {
          1: 'oneOne',
          .75: 'threeFour',
          .66: 'twoThree',
          .4: 'tall',
          4.35: 'wide',
          1.33: 'fourThree',
          1.5: 'threeTwo',
          1.78: 'sixteenNine'
        };
        var providedAspectRatio = width / height;
        var closestAspectRatio = Object.keys(aspectRatioObj).reduce(function (prev, curr) {
          return Math.abs(curr - providedAspectRatio) < Math.abs(prev - providedAspectRatio) ? curr : prev;
        });
        return aspectRatioObj[closestAspectRatio];
      }

      return type === 'chat' ? 'sixteenNine' : 'threeTwo';
    };

    var chosenItem = function chosenItem() {
      if (failedText && type === 'chat') {
        return _react.default.createElement("div", {
          className: 'cui-content cui-content--failed' + ("" + (className && " " + className || ''))
        }, _react.default.createElement("div", {
          className: "cui-content--failed-container"
        }, _react.default.createElement("i", {
          className: "icon icon-warning_28 cui-content--failed-warning"
        }), _react.default.createElement("p", {
          className: "cui-content--failed-message"
        }, failedText)));
      } else if (type === 'chat') {
        return _react.default.createElement(_ChatContent.default, _extends({
          actionNode: actionNode,
          aspect: aspect ? aspect : findAspect(width, height),
          className: className,
          content: content,
          fileSize: fileSize,
          height: height,
          isProtected: isProtected,
          loading: loading,
          style: style,
          title: title,
          type: type,
          width: width
        }, props));
      } else if (type === 'file' && !icon) {
        return _react.default.createElement(_FileContent.default, _extends({
          actionNode: actionNode,
          aspect: aspect ? aspect : findAspect(width, height),
          className: className,
          content: content,
          height: height,
          icon: icon,
          isProtected: isProtected,
          loading: loading,
          loadingText: loadingText,
          subtitle: subtitle,
          title: title,
          type: type,
          width: width
        }, props));
      } else if (icon) {
        return _react.default.createElement(_IconContent.default, _extends({
          actionNode: actionNode,
          className: className,
          icon: icon,
          isProtected: isProtected,
          loading: loading,
          subtitle: subtitle,
          title: title
        }, otherProps));
      }
    };

    return _react.default.createElement("div", null, chosenItem());
  };

  return ContentItem;
}(_react.default.PureComponent);

ContentItem.displayName = 'ContentItem';
ContentItem.defaultProps = {
  actionNode: null,
  aspect: null,
  className: '',
  content: null,
  failedText: '',
  fileSize: '',
  icon: '',
  isProtected: false,
  loading: false,
  loadingText: 'Loading',
  style: null,
  subtitle: '',
  title: '',
  type: 'chat'
};
ContentItem.propTypes = {
  /** @prop Node to render buttons inside Content Item | null */
  actionNode: _propTypes.default.node,

  /** @prop Set the Content Item's aspect size | null */
  aspect: _propTypes.default.oneOf(['fourThree', 'nineSixteen', 'oneOne', 'sixteenNine', 'tall', 'threeFour', 'threeTwo', 'twoThree', 'wide']),

  /** @prop Optional css class string | '' */
  className: _propTypes.default.string,

  /** @prop Set the image/gif of the Content Item | '' */
  content: _propTypes.default.string,

  /** @prop Set the failed text to show when content fails to load | '' */
  failedText: _propTypes.default.string,

  /** @prop Show the size of the file | '' */
  fileSize: _propTypes.default.string,

  /** @prop Show icon at top right corner of Content Item */
  gifIcon: _propTypes.default.string,

  /** @prop Height of the image in px */
  height: _propTypes.default.number,

  /** @prop Set the type of icon to show | '' */
  icon: _propTypes.default.string,

  /** @prop Show visibility of action node buttons | false */
  isProtected: _propTypes.default.bool,

  /** @prop Show loading spinner | false */
  loading: _propTypes.default.bool,

  /** @prop Change loading text */
  loadingText: _propTypes.default.string,

  /** @prop Additional css styling applied to the button | null  */
  style: _propTypes.default.object,

  /** @prop Set the subtitle of the Content Item | '' */
  subtitle: _propTypes.default.string,

  /** @prop Set the title of the Content Item | '' */
  title: _propTypes.default.string,

  /** @prop Set the type of Content Item to display */
  type: _propTypes.default.oneOf(['chat', 'file']),

  /** @prop Width of the image in px */
  width: _propTypes.default.number
};
var _default = ContentItem;
/**
* @name Content Item with and without isProtected prop
*
* @category containers
* @component content-item
* @section default
*
* @js
*
import {
  Button,
  ContentItem,
  Icon,
} from '@collabui/react';

 export default class ChatContentItem extends React.PureComponent {

  render() {

    const actionNode =
    (
      <div>
        <Button
          ariaLabel='For the Win'
          style={{backgroundColor:'black'}}
          circle
          size={32}
        >
          <Icon name='open-in-folder_14' color='white' />
        </Button>

        <Button
          ariaLabel='For the Win'
          style={{backgroundColor:'black'}}
          circle
          size={32}
        >
          <Icon name='icon-arrow-tail-down_14' color='white' />
        </Button>
      </div>
    )

    const handleClick = () => {
      alert('Image onClick')
    }

    return(
    <div className='columns large'>
      <div className= 'docs-example docs-example--spacing'>
        <ContentItem
          actionNode={actionNode}
          aspect='sixteenNine'
          content='https://newevolutiondesigns.com/images/freebies/yellow-wallpaper-12.jpg'
          fileSize='24 KB'
          onClick={handleClick}
          type='chat'
          title='Screen Shot 208-11-07 at 10.30.02 AM.png' />
      </div>

      <div className= 'docs-example docs-example--spacing'>
        <ContentItem
          aspect='sixteenNine'
          content= 'https://newevolutiondesigns.com/images/freebies/yellow-wallpaper-12.jpg'
          fileSize='24 KB'
          isProtected={true}
          onClick={handleClick}
          title='Nice seating.png'
          type='chat' />
      </div>

      <div className= 'docs-example docs-example--spacing'>
        <ContentItem
          aspect='sixteenNine'
          content= 'http://upload.wikimedia.org/wikipedia/commons/d/dd/Muybridge_race_horse_animated.gif'
          fileSize='50 KB'
          gifIcon='icon icon-gif_24'
          isProtected={true}
          title='Race Horse.gif'
          type='chat' />
      </div>
    </div>
    );
  }
}
**/

/**
* @name Content Item in File View with and without isProtected Prop
*
* @category containers
* @component content-item
* @section file
*
* @js
*
import {
  Button,
  ContentItem,
  Icon,
} from '@collabui/react';

 export default class FileContentItem extends React.PureComponent {

  render() {

    const actionNode =
    (
      <div>
        <Button
          ariaLabel='For the Win'
          style={{backgroundColor:'black'}}
          circle
          size={32}
        >
          <Icon name='chat_12' color='white' />
        </Button>

        <Button
          ariaLabel='For the Win'
          style={{backgroundColor:'black'}}
          circle
          size={32}
        >
          <Icon name='open-in-folder_12' color='white' />
        </Button>

        <Button
          ariaLabel='For the Win'
          style={{backgroundColor:'black'}}
          circle
          size={32}
        >
          <Icon name='icon-arrow-tail-down_12' color='white' />
        </Button>
      </div>
    )

     const handleClick = () => {
      alert('Image onClick');
    }

    return(
    <div className='columns large'>
      <div className= 'docs-example docs-example--spacing'>
        <ContentItem
          actionNode={actionNode}
          aspect='threeTwo'
          content='https://vmcdn.ca/f/files/sudbury/uploadedImages/news/localNews/2015/06/090615_IKEA_sized.jpg;w=630'
          onClick={handleClick}
          subtitle='Barbara German, 4 days'
          title='Logo.pdf'
          type='file' />
        </div>

      <div className= 'docs-example docs-example--spacing'>
        <ContentItem
          aspect='threeTwo'
          content='https://vmcdn.ca/f/files/sudbury/uploadedImages/news/localNews/2015/06/090615_IKEA_sized.jpg;w=630'
          isProtected={true}
          subtitle='Barbara German, 4 days'
          title='Screen Shot 2018-10-11 at 5.22.32 PM.png'
          type='file' />
      </div>

      <div className= 'docs-example docs-example--spacing'>
        <ContentItem
          actionNode={actionNode}
          aspect='threeTwo'
          content='http://upload.wikimedia.org/wikipedia/commons/d/dd/Muybridge_race_horse_animated.gif'
          gifIcon='icon icon-gif_20'
          onClick={handleClick}
          subtitle='Barbara German, 4 days'
          title='Race Horse.gif'
          type='file' />
      </div>
    </div>
    );
  }
}

**/

/**
* @name Content Item with different size
*
* @category containers
* @component content-item
* @section size
*
* @js
*
import {
  Button,
  ContentItem,
  Icon,
} from '@collabui/react';

 export default class ContentItemSizes extends React.PureComponent {

  render() {
    const actionNode =
    (
      <div>
        <Button
          ariaLabel='For the Win'
          style={{backgroundColor:'black'}}
          circle
          size={32}
        >
          <Icon name='chat_12' color='white' />
        </Button>

        <Button
          ariaLabel='For the Win'
          style={{backgroundColor:'black'}}
          circle
          size={32}
        >
          <Icon name='open-in-folder_12' color='white' />
        </Button>

        <Button
          ariaLabel='For the Win'
          style={{backgroundColor:'black'}}
          circle
          size={32}
        >
          <Icon name='icon-arrow-tail-down_12' color='white' />
        </Button>
      </div>
    )

     const handleClick = () => {
      alert('Image onClick');
    }

    return(
      <div>
        <ContentItem
          aspect='twoThree'
          content='http://www.emertatmassage.com/wp-content/uploads/2014/06/img-16.jpg'
          subtitle='Barbara German, 4 days'
          type='file'
          actionNode={actionNode}
          onClick={handleClick}
          title='2:3' />

        <ContentItem
          aspect='threeFour'
          content='http://www.emertatmassage.com/wp-content/uploads/2014/06/img-16.jpg'
          subtitle='Barbara German, 4 days'
          onClick={handleClick}
          type='file'
          title='3:4' />

        <ContentItem
          aspect='sixteenNine'
          content='http://panoramicvisions.com/images/banner-img11.jpg'
          subtitle='Barbara German, 4 days'
          type='file'
          title='16:9' />

        <ContentItem
          aspect='nineSixteen'
          content='http://www.emertatmassage.com/wp-content/uploads/2014/06/img-16.jpg'
          subtitle='Barbara German, 4 days'
          type='file'
          title='9:16' />

        <ContentItem
          aspect='oneOne'
          content='http://www.emertatmassage.com/wp-content/uploads/2014/06/img-16.jpg'
          subtitle='Barbara German, 4 days'
          type='file'
          title='1:1' />

        <ContentItem
          aspect='fourThree'
          content='http://www.emertatmassage.com/wp-content/uploads/2014/06/img-16.jpg'
          subtitle='Barbara German, 4 days'
          type='file'
          title='4:3' />

        <ContentItem
          aspect='threeTwo'
          content='http://www.emertatmassage.com/wp-content/uploads/2014/06/img-16.jpg'
          subtitle='Barbara German, 4 days'
          type='file'
          title='3:2' />

        <ContentItem
          aspect='oneOne'
          content='https://newevolutiondesigns.com/images/freebies/yellow-wallpaper-12.jpg'
          subtitle='Barbara German, 4 days'
          type='chat'
          onClick={handleClick}
          title='1:1, 3:2 Container' />

        <ContentItem
          aspect='threeFour'
          content='https://newevolutiondesigns.com/images/freebies/yellow-wallpaper-12.jpg'
          subtitle='Barbara German, 4 days'
          type='chat'
          title='3:4, 3:2 container' />

        <ContentItem
          aspect='twoThree'
          content='https://newevolutiondesigns.com/images/freebies/yellow-wallpaper-12.jpg'
          subtitle='Barbara German, 4 days'
          type='chat'
          title='2:3, 3:2 container' />

        <ContentItem
          aspect='tall'
          content='https://newevolutiondesigns.com/images/freebies/yellow-wallpaper-12.jpg'
          subtitle='Barbara German, 4 days'
          type='chat'
          title='Tall, 3:2 container' />

        <ContentItem
          aspect='wide'
          content='https://newevolutiondesigns.com/images/freebies/yellow-wallpaper-12.jpg'
          subtitle='Barbara German, 4 days'
          type='chat'
          title='Wide, 16:9 container' />

        <ContentItem
          aspect='fourThree'
          content='https://newevolutiondesigns.com/images/freebies/yellow-wallpaper-12.jpg'
          subtitle='Barbara German, 4 days'
          type='chat'
          title='4:3' />

        <ContentItem
          aspect='threeTwo'
          content='https://newevolutiondesigns.com/images/freebies/yellow-wallpaper-12.jpg'
          subtitle='Barbara German, 4 days'
          type='chat'
          title='3:2' />

        <ContentItem
          aspect='sixteenNine'
          content='https://newevolutiondesigns.com/images/freebies/yellow-wallpaper-12.jpg'
          subtitle='Barbara German, 4 days'
          type='chat'
          title='16:9' />
      </div>
    );
  }
}
**/

/**
* @name Content Item Loading
*
* @category containers
* @component content-item
* @section spinner
*
* @js
*
import { ContentItem } from '@collabui/react';

 export default class ContentItemLoading extends React.PureComponent {

  render() {
    return(
    <div className='columns large'>

      <div className= 'docs-example docs-example--spacing'>
        <ContentItem
          aspect='threeTwo'
          content= 'https://newevolutiondesigns.com/images/freebies/yellow-wallpaper-12.jpg'
          loading={true}
          loadingText='Loading'
          subtitle='Barbara German, 4 days'
          type='file'
          title='Logo.pdf' />
        </div>

      <div className= 'docs-example docs-example--spacing'>
        <ContentItem
          aspect='sixteenNine'
          content= 'https://newevolutiondesigns.com/images/freebies/yellow-wallpaper-12.jpg'
          loading={true}
          subtitle='Barbara German, 4 days'
          type='chat'
          title='Logo.pdf' />
      </div>

      <div className= 'docs-example docs-example--spacing'>
        <ContentItem
          aspect='sixteenNine'
          loading={true}
          subtitle='Barbara German, 4 days'
          type='chat'
          title='Logo.pdf' />
      </div>
    </div>
    );
  }
}
**/

/**
* @name Finding aspect with image Width and Height Prop
*
* @category containers
* @component content-item
* @section aspect
*
* @js
*
import { ContentItem } from '@collabui/react';

 export default class ContentItemWidthHeight extends React.PureComponent {

  render() {
    return(
    <div className='columns large'>
      <ContentItem
        content='https://newevolutiondesigns.com/images/freebies/yellow-wallpaper-12.jpg'
        fileSize='24 KB'
        height={400}
        title='Nice seating.png'
        type='chat'
        width={300} />
    </div>
    );
  }
}
**/

/**
* @name Failed to Load Content
*
* @category containers
* @component content-item
* @section failed
*
* @js
*
import { ContentItem } from '@collabui/react';

 export default class ContentItemFailed extends React.PureComponent {

  render() {
    return(
    <div className='columns large'>
      <ContentItem
        failedText='Failed to load  preview. Tap to download the file.'
        fileSize='24 KB'
        onDownload={this.alertSomething}
        title='Nice seating.png'
        type='chat'
        showInFolder={this.showInFolder} />
    </div>
    );
  }
}
**/

/**
* @name Icon File View
*
* @category containers
* @component content-item
* @section icon
*
* @js
*
import {
  Button,
  ContentItem,
  Icon,
} from '@collabui/react';

 export default class ContentItemIcon extends React.PureComponent {

  render() {

    const handleClick = () => {
      alert('file onClick');
    }

    const folderClick = e => {
      alert('folder clicked');
      e.stopPropagation();
    }

    const downloadClick = e => {
      alert('download clicked');
      e.stopPropagation();
    }

    const actionNode =
    (
      <div>
        <Button
          ariaLabel='For the Win'
          circle
          onClick={folderClick}
          style={{backgroundColor:'black'}}
          size={32}
        >
          <Icon name='open-in-folder_14' color='white' />
        </Button>

        <Button
          ariaLabel='For the Win'
          circle
          onClick={downloadClick}
          style={{backgroundColor:'black'}}
          size={32}
        >
          <Icon name='icon-arrow-tail-down_14' color='white' />
        </Button>
      </div>
    )

    return(
    <div className='columns large'>
      <ContentItem
        actionNode={actionNode}
        fileSize='24 KB'
        icon='icon-pdf_72'
        onClick={handleClick}
        subtitle='Barbara German, 12/05/18'
        title='Ideas.pdf'
        type='file'/>
    </div>
    );
  }
}
**/

exports.default = _default;

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(7);

__webpack_require__(4);

__webpack_require__(19);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _snakeCase = __webpack_require__(164);

var _ = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ChatContentItem = function ChatContentItem(props) {
  var actionNode = props.actionNode,
      aspect = props.aspect,
      className = props.className,
      content = props.content,
      fileSize = props.fileSize,
      gifIcon = props.gifIcon,
      isProtected = props.isProtected,
      loading = props.loading,
      onClick = props.onClick,
      style = props.style,
      title = props.title,
      otherProps = _objectWithoutPropertiesLoose(props, ["actionNode", "aspect", "className", "content", "fileSize", "gifIcon", "isProtected", "loading", "onClick", "style", "title"]);

  var kebabify = function kebabify(holder, aspect) {
    var cases = ['fourThree', 'sixteenNine', 'threeTwo'];
    var kebab = (0, _snakeCase.snakeCase)(aspect);

    if (holder === 'container') {
      if (cases.includes(aspect)) {
        return " cui-content__chat-" + kebab;
      }
    } else if (holder === 'inner') {
      if (cases.includes(aspect)) {
        return ' cui-content-file--full';
      } else {
        return " cui-content-file--chat-" + kebab;
      }
    }
  };

  var handleKeyDown = function handleKeyDown(e) {
    if (e.which === 32 || e.which === 13 || e.charCode === 32 || e.charCode === 13) {
      onClick && onClick(e);
      e.preventDefault();
    }
  };

  return _react.default.createElement("div", _extends({
    className: 'cui-content__chat-inner-container' + ("" + (aspect === 'wide' && ' cui-content__chat-wide-container' || '')) + ("" + (aspect && kebabify('container', aspect) || ''))
  }, otherProps), _react.default.createElement("div", {
    className: "" + (aspect && kebabify('inner', aspect) || '') + ("" + (!aspect && ' cui-content-file--full' || '')) + ("" + (onClick && ' cui-content-file--clickable' || '')) + ("" + (className && " " + className || '')),
    onClick: onClick,
    onKeyDown: handleKeyDown,
    role: "presentation",
    style: Object.assign({
      backgroundImage: content && "url(" + content + ")"
    }, style)
  }, loading && _react.default.createElement("div", {
    className: "" + (content ? ' cui-content--opacity' : ' cui-content--centered')
  }, _react.default.createElement(_.Spinner, null)), gifIcon && _react.default.createElement("i", {
    className: gifIcon + " cui-content__gif"
  })), !loading && _react.default.createElement("div", {
    className: 'cui-content__hover' + ("" + (aspect === 'wide' && ' cui-content__hover--wide' || ''))
  }, _react.default.createElement("div", {
    className: "cui-content__hover-files"
  }, _react.default.createElement("span", {
    title: title,
    className: "cui-content__hover-files--file-name"
  }, title), _react.default.createElement("span", {
    className: "cui-content__hover-files--file-size"
  }, fileSize)), actionNode && !isProtected && _react.default.createElement("div", {
    className: "cui-content__hover-icons"
  }, actionNode)));
};

ChatContentItem.defaultProps = {
  actionNode: null,
  aspect: null,
  className: '',
  content: '',
  fileSize: '',
  gifIcon: '',
  isProtected: null,
  loading: false,
  onClick: null,
  style: null,
  title: '',
  type: ''
};
ChatContentItem.propTypes = {
  actionNode: _propTypes.default.node,
  aspect: _propTypes.default.oneOf(['oneOne', 'tall', 'threeFour', 'wide', 'fourThree', 'nineSixteen', 'sixteenNine', 'twoThree', 'threeTwo']),
  className: _propTypes.default.string,
  content: _propTypes.default.string,
  fileSize: _propTypes.default.string,
  gifIcon: _propTypes.default.string,
  isProtected: _propTypes.default.bool,
  loading: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  style: _propTypes.default.object,
  title: _propTypes.default.string,
  type: _propTypes.default.string
};
ChatContentItem.displayName = 'ChatContentItem';
var _default = ChatContentItem;
exports.default = _default;

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(7);

__webpack_require__(4);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _snakeCase = __webpack_require__(164);

var _ = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var FileContentItem = function FileContentItem(props) {
  var actionNode = props.actionNode,
      aspect = props.aspect,
      className = props.className,
      content = props.content,
      gifIcon = props.gifIcon,
      isProtected = props.isProtected,
      loading = props.loading,
      loadingText = props.loadingText,
      onClick = props.onClick,
      style = props.style,
      subtitle = props.subtitle,
      title = props.title,
      otherProps = _objectWithoutPropertiesLoose(props, ["actionNode", "aspect", "className", "content", "gifIcon", "isProtected", "loading", "loadingText", "onClick", "style", "subtitle", "title"]);

  var kebabify = function kebabify(aspect) {
    if (aspect === 'wide') {
      aspect = 'sixteenNine';
    }

    if (aspect === 'tall') {
      aspect = 'nineSixteen';
    }

    var kebab = (0, _snakeCase.snakeCase)(aspect);
    return "cui-content-file--" + kebab;
  };

  var handleKeyDown = function handleKeyDown(e) {
    if (e.which === 32 || e.which === 13 || e.charCode === 32 || e.charCode === 13) {
      onClick && onClick(e);
      e.preventDefault();
    }
  };

  return _react.default.createElement("div", _extends({
    className: "cui-content__container"
  }, otherProps), loading ? _react.default.createElement("div", {
    className: "cui-content-file",
    style: {
      backgroundImage: content && "url(" + content + ")"
    }
  }, _react.default.createElement("div", {
    className: "" + (content && ' cui-content--opacity' || '')
  }, _react.default.createElement(_.Spinner, null))) : _react.default.createElement("div", {
    className: 'cui-content-file__block' + ("" + (aspect === 'oneOne' && ' content-file--no-border' || aspect === 'fourThree' && ' content-file--no-border' || ''))
  }, _react.default.createElement("div", {
    className: "" + (aspect && kebabify(aspect) || '') + ("" + (!aspect && ' cui-content-file--full' || '')) + ("" + (onClick && ' cui-content-file--clickable' || '')) + ("" + (className && " " + className || '')),
    onKeyDown: handleKeyDown,
    onClick: onClick,
    role: "presentation",
    style: Object.assign({
      backgroundImage: content && "url(" + content + ")"
    }, style)
  }), !isProtected && actionNode && _react.default.createElement("div", {
    className: "cui-content-file__aspect"
  }, actionNode), gifIcon && _react.default.createElement("i", {
    className: gifIcon + " cui-content__gif" + ("" + (aspect === 'oneOne' && ' cui-content__gif--oneOne' || aspect === 'fourThree' && ' cui-content__gif--fourThree' || ''))
  })), _react.default.createElement("div", {
    className: "cui-content-file__info-container"
  }, title && _react.default.createElement("span", {
    title: title,
    key: "title",
    className: "cui-content-file__title"
  }, loading ? loadingText : title), subtitle && _react.default.createElement("span", {
    key: "subtitle",
    className: "cui-content-file__subtitle"
  }, subtitle)));
};

FileContentItem.defaultProps = {
  actionNode: null,
  aspect: null,
  className: '',
  content: '',
  gifIcon: '',
  icon: '',
  isProtected: null,
  loading: false,
  loadingText: 'Loading',
  onClick: null,
  style: null,
  subtitle: '',
  title: ''
};
FileContentItem.propTypes = {
  actionNode: _propTypes.default.node,
  aspect: _propTypes.default.oneOf(['fourThree', 'nineSixteen', 'oneOne', 'sixteenNine', 'tall', 'threeFour', 'threeTwo', 'twoThree', 'wide']),
  className: _propTypes.default.string,
  content: _propTypes.default.string,
  gifIcon: _propTypes.default.string,
  icon: _propTypes.default.string,
  isProtected: _propTypes.default.bool,
  loading: _propTypes.default.bool,
  loadingText: _propTypes.default.string,
  onClick: _propTypes.default.func,
  style: _propTypes.default.object,
  subtitle: _propTypes.default.string,
  title: _propTypes.default.string
};
FileContentItem.displayName = 'FileContentItem';
var _default = FileContentItem;
exports.default = _default;

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(4);

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(7);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _ = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var IconContent = function IconContent(props) {
  var actionNode = props.actionNode,
      className = props.className,
      icon = props.icon,
      isProtected = props.isProtected,
      loading = props.loading,
      onClick = props.onClick,
      subtitle = props.subtitle,
      title = props.title,
      otherProps = _objectWithoutPropertiesLoose(props, ["actionNode", "className", "icon", "isProtected", "loading", "onClick", "subtitle", "title"]);

  var handleKeyDown = function handleKeyDown(e) {
    if (e.which === 32 || e.which === 13 || e.charCode === 32 || e.charCode === 13) {
      onClick && onClick(e);
      e.preventDefault();
    }
  };

  return _react.default.createElement("div", null, _react.default.createElement("div", _extends({
    className: 'cui-content-file' + ("" + (onClick && ' cui-content-file--clickable' || '')) + ("" + (className && " " + className || '')),
    onClick: onClick,
    onKeyDown: handleKeyDown,
    role: "presentation"
  }, otherProps), !isProtected && actionNode && _react.default.createElement("div", {
    className: "cui-content-file__icon"
  }, actionNode), _react.default.createElement("span", null, _react.default.createElement(_.Icon, {
    name: icon
  }))), _react.default.createElement("div", {
    className: "cui-content-file__info-container"
  }, _react.default.createElement("span", {
    className: "cui-content-file__title"
  }, loading ? 'Loading' : title), _react.default.createElement("span", {
    className: "cui-content-file__subtitle"
  }, " ", subtitle, " ")));
};

IconContent.defaultProps = {
  actionNode: null,
  className: '',
  icon: '',
  isProtected: null,
  loading: false,
  onClick: null,
  subtitle: '',
  title: ''
};
IconContent.propTypes = {
  actionNode: _propTypes.default.node,
  className: _propTypes.default.string,
  icon: _propTypes.default.string,
  isProtected: _propTypes.default.bool,
  loading: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  subtitle: _propTypes.default.string,
  title: _propTypes.default.string
};
IconContent.displayName = 'IconContent';
var _default = IconContent;
exports.default = _default;

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(7);

__webpack_require__(4);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _ = __webpack_require__(8);

var _DatePickerCalendar = _interopRequireDefault(__webpack_require__(503));

var _dateUtils = __webpack_require__(60);

var _moment = _interopRequireDefault(__webpack_require__(1));

var _lodash = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var DatePicker =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(DatePicker, _React$Component);

  function DatePicker() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      anchorNode: null,
      focus: null,
      isOpen: false,
      selected: null
    };

    _this.getChildContext = function () {
      var onMonthChange = _this.props.onMonthChange;
      var _this$state = _this.state,
          focus = _this$state.focus,
          selected = _this$state.selected;
      return {
        handleDayClick: function handleDayClick(event, date) {
          return _this.handleSelect(event, date);
        },
        handleMonthChange: function handleMonthChange(event, date) {
          return onMonthChange && onMonthChange(event, date.toDate());
        },
        focus: focus,
        selected: selected
      };
    };

    _this.setOpen = function (open) {
      _this.setState({
        isOpen: open
      });
    };

    _this.handleSelect = function (event, date) {
      var shouldCloseOnSelect = _this.props.shouldCloseOnSelect;

      _this.setPreSelection(date, event);

      _this.setSelected(date, event);

      shouldCloseOnSelect && _this.setOpen(false);
    };

    _this.setSelected = function (date, event) {
      var onSelect = _this.props.onSelect;
      !(0, _dateUtils.isDayDisabled)(date, _this.props) && _this.setState({
        selected: date
      }, function () {
        return onSelect && onSelect(event, date.toDate());
      });
    };

    _this.setPreSelection = function (date, event) {
      var onChange = _this.props.onChange;
      !(0, _dateUtils.isDayDisabled)(date, _this.props) && _this.setState({
        focus: date
      }, function () {
        return onChange && onChange(event, date.toDate());
      });
    };

    _this.handleInputClick = function () {
      _this.setOpen(true);
    };

    _this.handleInputKeyDown = function (event) {
      var _this$state2 = _this.state,
          focus = _this$state2.focus,
          isOpen = _this$state2.isOpen;
      var flag = false;
      var copy = (0, _moment.default)(focus);

      switch (!event.shiftKey && event.which) {
        case 32:
        case 13:
          if (!isOpen) {
            _this.handleInputClick();
          } else if (_moment.default.isMoment(focus) || _moment.default.isDate(focus)) {
            _this.handleSelect(event, copy);
          }

          flag = true;
          break;

        case 38:
          //up
          _this.setPreSelection((0, _dateUtils.subtractWeeks)(copy, 1));

          flag = true;
          break;

        case 37:
          // left
          _this.setPreSelection((0, _dateUtils.subtractDays)(copy, 1));

          flag = true;
          break;

        case 39:
          //right
          _this.setPreSelection((0, _dateUtils.addDays)(copy, 1));

          flag = true;
          break;

        case 40:
          //bottom
          _this.setPreSelection((0, _dateUtils.addWeeks)(copy, 1));

          flag = true;
          break;

        default:
          break;
      }

      if (flag) {
        event.stopPropagation();
        event.preventDefault();
      }
    };

    return _this;
  }

  var _proto = DatePicker.prototype;

  _proto.componentWillMount = function componentWillMount() {
    var selectedDate = (0, _moment.default)(this.props.selectedDate);
    var isValid = selectedDate.isValid() && !(0, _dateUtils.isDayDisabled)(selectedDate, this.props);
    isValid && this.setPreSelection(selectedDate);
    isValid && this.setSelected(selectedDate);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var selectedDate = (0, _moment.default)(this.props.selectedDate);
    var prevSelectedDate = (0, _moment.default)(prevProps.selectedDate);
    var isValid = selectedDate.isValid() && !(0, _dateUtils.isDayDisabled)(selectedDate, this.props);

    if (isValid && !(0, _dateUtils.isSameDay)(prevSelectedDate, selectedDate)) {
      this.setSelected(selectedDate);
      this.setPreSelection(selectedDate);
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        direction = _this$props.direction,
        isDynamic = _this$props.isDynamic,
        showArrow = _this$props.showArrow,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "className", "direction", "isDynamic", "showArrow"]);

    var _this$state3 = this.state,
        selected = _this$state3.selected,
        focus = _this$state3.focus,
        anchorNode = _this$state3.anchorNode,
        isOpen = _this$state3.isOpen;

    var trigger = _react.default.cloneElement(children, {
      ref: function ref(_ref) {
        return !_this2.state.anchorNode && _this2.setState({
          anchorNode: _ref
        });
      },
      onClick: this.handleInputClick,
      onKeyDown: this.handleInputKeyDown
    });

    var otherProps = (0, _lodash.omit)(Object.assign({}, props), ['onSelect', 'onChange', 'onMonthChange', 'shouldCloseOnSelect']);

    var calendar = _react.default.createElement(_DatePickerCalendar.default, _extends({
      focus: focus,
      selected: selected
    }, otherProps));

    var content = _react.default.createElement(_.EventOverlay, {
      allowClickAway: true,
      isOpen: isOpen,
      anchorNode: anchorNode,
      close: function close() {
        return _this2.setOpen(false);
      },
      direction: direction,
      showArrow: showArrow,
      isDynamic: isDynamic
    }, calendar);

    return _react.default.createElement("div", {
      className: 'cui-datepicker-container' + ("" + (className && " " + className || ''))
    }, trigger, content);
  };

  return DatePicker;
}(_react.default.Component);

DatePicker.propTypes = {
  /** @prop Children nodes to render inside DatePicker | null */
  children: _propTypes.default.element,

  /** @prop Optional css class string | '' */
  className: _propTypes.default.string,

  /** @prop Set the direction in which the DatePicker opens | 'bottom-center' */
  direction: _propTypes.default.string,

  /** @prop Function to filter Dates | null */
  filterDate: _propTypes.default.func,

  /** @prop Sets the DatePicker EventOverlay to be dynamic | true */
  isDynamic: _propTypes.default.bool,

  /** @prop Sets the language of the DatePicker | 'en' */
  locale: _propTypes.default.string,

  /** @prop Sets the last date in which the DatePicker does not disable | null */
  maxDate: _propTypes.default.instanceOf(Date),

  /** @prop Sets the first date in which the DatePicker does not disable | null */
  minDate: _propTypes.default.instanceOf(Date),

  /** @prop Sets the format of the month | 'MMMM YYYY' */
  monthFormat: _propTypes.default.string,

  /** @prop Text to display for blindness accessibility features | 'next' */
  nextArialLabel: _propTypes.default.string,

  /** @prop Handler invoked when user makes a chnage within the DatePicker | null */
  onChange: _propTypes.default.func,

  /** @prop Handler invoked when user makes a change to the selected month within DatePicker | null */
  onMonthChange: _propTypes.default.func,

  /** @prop Handler invoked when user selects a date within DatePicker | null */
  onSelect: _propTypes.default.func,

  /** @prop Text to display for blindness accessibility features | 'previous' */
  previousArialLabel: _propTypes.default.string,

  /** @prop Initial Selected Date for DatePicker | moment().toDate()  */
  selectedDate: _propTypes.default.instanceOf(Date),

  /** @prop Determines if the DatePicker should close when a date is selected | true */
  shouldCloseOnSelect: _propTypes.default.bool,

  /** @prop Determines if the DatePicker should show the open/close arrow | false */
  showArrow: _propTypes.default.bool
};
DatePicker.defaultProps = {
  children: null,
  className: '',
  direction: 'bottom-center',
  filterDate: null,
  isDynamic: true,
  locale: 'en',
  maxDate: null,
  minDate: null,
  monthFormat: 'MMMM YYYY',
  nextArialLabel: 'next',
  onChange: null,
  onMonthChange: null,
  onSelect: null,
  previousArialLabel: 'previous',
  selectedDate: (0, _moment.default)().toDate(),
  shouldCloseOnSelect: true,
  showArrow: false
};
DatePicker.childContextTypes = {
  focus: _propTypes.default.instanceOf(_moment.default),
  handleDayClick: _propTypes.default.func,
  handleMonthChange: _propTypes.default.func,
  selected: _propTypes.default.instanceOf(_moment.default)
};
DatePicker.displayName = 'DatePicker';
var _default = DatePicker;
/**
* @component date-picker
* @section default
* @react

import { Button, DatePicker } from '@collabui/react';

export default class DatePickerDefault extends React.PureComponent {
  state = {
    date: null,
  };
  render() {
    const { date } = this.state;
    return (
      <span>
        <h4 className="columns">Selected Date: {date && date.toDateString()}</h4>
        <DatePicker onSelect={(e, date) => this.setState({ date })}>
          <Button
            children='Pick a Date'
            ariaLabel='DatePicker'
          />
        </DatePicker>
      </span>
    );
  }
}
**/

exports.default = _default;

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(4);

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(7);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _DatePickerMonth = _interopRequireDefault(__webpack_require__(504));

var _ = __webpack_require__(8);

var _dateUtils = __webpack_require__(60);

var _moment = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var DatePickerCalendar =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(DatePickerCalendar, _React$Component);

  function DatePickerCalendar() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      date: null
    };

    _this.setDate = function (date, cb) {
      _this.setState({
        date: date
      }, cb);
    };

    _this.increaseMonth = function (event) {
      var handleMonthChange = _this.context.handleMonthChange;
      var date = _this.state.date;

      _this.setDate((0, _dateUtils.addMonths)(date.clone(), 1), function () {
        return handleMonthChange && handleMonthChange(event, _this.state.date);
      });
    };

    _this.decreaseMonth = function (event) {
      var handleMonthChange = _this.context.handleMonthChange;
      var date = _this.state.date;

      _this.setDate((0, _dateUtils.subtractMonths)(date.clone(), 1), function () {
        return handleMonthChange && handleMonthChange(event, _this.state.date);
      });
    };

    return _this;
  }

  var _proto = DatePickerCalendar.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this$context = this.context,
        focus = _this$context.focus,
        selected = _this$context.selected;
    this.setDate(focus || selected || (0, _dateUtils.now)());
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var focus = prevProps.focus;

    if (focus && !(0, _dateUtils.isSameDay)(this.props.focus, focus)) {
      this.setDate(focus);
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var date = this.state.date;

    var _this$props = this.props,
        locale = _this$props.locale,
        monthFormat = _this$props.monthFormat,
        nextArialLabel = _this$props.nextArialLabel,
        previousArialLabel = _this$props.previousArialLabel,
        otherProps = _objectWithoutPropertiesLoose(_this$props, ["locale", "monthFormat", "nextArialLabel", "previousArialLabel"]);

    var renderMonthName = function renderMonthName() {
      return _react.default.createElement("div", {
        className: "cui-datepicker__navigation--current-month"
      }, (0, _dateUtils.localizeDate)(date, locale).format(monthFormat));
    };

    var renderPreviousMonthButton = function renderPreviousMonthButton() {
      var minDate = _this2.props.minDate;
      var allPrevDaysDisabled = (0, _dateUtils.shouldPrevMonthDisable)(date, minDate);
      return _react.default.createElement(_.Icon, {
        ariaLabel: previousArialLabel,
        disabled: allPrevDaysDisabled,
        onClick: _this2.decreaseMonth,
        name: "arrow-left_16"
      });
    };

    var renderNextMonthButton = function renderNextMonthButton() {
      var maxDate = _this2.props.maxDate;
      var allNextDaysDisabled = (0, _dateUtils.shouldNextMonthDisable)(date, maxDate);
      return _react.default.createElement(_.Icon, {
        ariaLabel: nextArialLabel,
        disabled: allNextDaysDisabled,
        onClick: _this2.increaseMonth,
        name: "arrow-right_16"
      });
    };

    var header = function header() {
      var startOfWeek = (0, _dateUtils.getStartOfWeek)(date.clone());
      var dayNames = [];
      return dayNames.concat([0, 1, 2, 3, 4, 5, 6].map(function (offset) {
        var day = (0, _dateUtils.addDays)((0, _dateUtils.localizeDate)(startOfWeek, locale), offset);
        var localeData = (0, _dateUtils.getLocaleData)(day);
        var weekDayName = (0, _dateUtils.getWeekdayMinInLocale)(localeData, day);
        return _react.default.createElement("div", {
          key: offset,
          className: "cui-datepicker__day--name"
        }, weekDayName);
      }));
    };

    var renderMonth = function renderMonth() {
      return _react.default.createElement("div", {
        className: "cui-datepicker__month-container"
      }, _react.default.createElement("div", {
        className: "cui-datepicker__header"
      }, _react.default.createElement("div", {
        className: "cui-datepicker__navigation"
      }, renderMonthName(), _react.default.createElement("div", {
        className: "cui-datepicker__navigation--buttons"
      }, renderPreviousMonthButton(), renderNextMonthButton())), _react.default.createElement("div", {
        className: "cui-datepicker__day--names"
      }, header())), _react.default.createElement(_DatePickerMonth.default, _extends({
        day: date
      }, otherProps)));
    };

    return _react.default.createElement("div", null, date && renderMonth());
  };

  return DatePickerCalendar;
}(_react.default.Component);

DatePickerCalendar.displayName = 'DatePickerCalendar';
DatePickerCalendar.contextTypes = {
  focus: _propTypes.default.instanceOf(_moment.default),
  handleMonthChange: _propTypes.default.func,
  selected: _propTypes.default.instanceOf(_moment.default)
};
DatePickerCalendar.propTypes = {
  /** @prop Set the focus on the current date being focused | null */
  focus: _propTypes.default.instanceOf(_moment.default),

  /** @prop Sets the language for the DatePickerCalendar | 'en' */
  locale: _propTypes.default.string,

  /** @prop Sets the last date in which the calendar does not disable | null */
  maxDate: _propTypes.default.instanceOf(Date),

  /** @prop Sets the first date in which the calendar does not disable | null */
  minDate: _propTypes.default.instanceOf(Date),

  /** @prop Sets the format in how the Month is displayed | null */
  monthFormat: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array]),

  /** @prop Text to display for blindness accessibility features | 'next' */
  nextArialLabel: _propTypes.default.string,

  /** @prop Text to display for blindness accessibility features | 'previous' */
  previousArialLabel: _propTypes.default.string
};
DatePickerCalendar.defaultProps = {
  focus: null,
  locale: 'en',
  maxDate: null,
  minDate: null,
  monthFormat: 'MMMM YYYY',
  nextArialLabel: 'next',
  previousArialLabel: 'previous'
};
var _default = DatePickerCalendar;
exports.default = _default;

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(4);

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(7);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _DatePickerWeek = _interopRequireDefault(__webpack_require__(505));

var _dateUtils = __webpack_require__(60);

var _moment = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var DatePickerMonth =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(DatePickerMonth, _React$Component);

  function DatePickerMonth() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.renderWeeks = function () {
      var _this$props = _this.props,
          day = _this$props.day,
          otherProps = _objectWithoutPropertiesLoose(_this$props, ["day"]);

      var i = 0;
      var currentWeekStart = (0, _dateUtils.getStartOfWeek)((0, _dateUtils.getStartOfMonth)(day.clone()));
      var weeks = [];
      var month = (0, _dateUtils.getMonth)(day);

      do {
        weeks.push(_react.default.createElement(_DatePickerWeek.default, _extends({
          key: i++,
          day: currentWeekStart,
          month: month
        }, otherProps)));
        currentWeekStart = (0, _dateUtils.addWeeks)(currentWeekStart.clone(), 1);
      } while ((0, _dateUtils.isSameMonth)(currentWeekStart, day));

      return weeks;
    };

    return _this;
  }

  var _proto = DatePickerMonth.prototype;

  _proto.render = function render() {
    return _react.default.createElement("div", {
      className: "cui-datepicker__month"
    }, this.renderWeeks());
  };

  return DatePickerMonth;
}(_react.default.Component);

DatePickerMonth.displayName = 'DatePickerMonth';
DatePickerMonth.propTypes = {
  /** @prop Required day for the DatePickerMonth */
  day: _propTypes.default.instanceOf(_moment.default).isRequired
};
var _default = DatePickerMonth;
exports.default = _default;

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(4);

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(7);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _DatePickerDay = _interopRequireDefault(__webpack_require__(506));

var _dateUtils = __webpack_require__(60);

var _moment = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var DatePickerWeek =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(DatePickerWeek, _React$PureComponent);

  function DatePickerWeek() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = DatePickerWeek.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        day = _this$props.day,
        otherProps = _objectWithoutPropertiesLoose(_this$props, ["day"]);

    var renderDays = function renderDays() {
      var startOfWeek = (0, _dateUtils.getStartOfWeek)(day.clone());
      var days = [0, 1, 2, 3, 4, 5, 6].map(function (offset) {
        var day = (0, _dateUtils.addDays)(startOfWeek.clone(), offset);
        return _react.default.createElement(_DatePickerDay.default, _extends({
          key: offset,
          day: day
        }, otherProps));
      });
      return days;
    };

    return _react.default.createElement("div", {
      className: "cui-datepicker__week"
    }, renderDays());
  };

  return DatePickerWeek;
}(_react.default.PureComponent);

DatePickerWeek.displayName = 'DatePickerWeek';
DatePickerWeek.propTypes = {
  /** Required day for the DatePickerWeek */
  day: _propTypes.default.instanceOf(_moment.default).isRequired
};
var _default = DatePickerWeek;
exports.default = _default;

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _ = __webpack_require__(8);

var _dateUtils = __webpack_require__(60);

var _moment = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var DatePickerDay =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(DatePickerDay, _React$Component);

  function DatePickerDay() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handleClick = function (e) {
      var handleDayClick = _this.context.handleDayClick;
      var day = _this.props.day;
      return handleDayClick && handleDayClick(e, day);
    };

    return _this;
  }

  var _proto = DatePickerDay.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        day = _this$props.day,
        month = _this$props.month;
    var _this$context = this.context,
        selected = _this$context.selected,
        focus = _this$context.focus;
    var isOutsideMonth = month !== (0, _dateUtils.getMonth)(day);
    var isSelected = (0, _dateUtils.isSameDay)(day, selected);
    var isToday = (0, _dateUtils.isSameDay)(day, (0, _dateUtils.now)());
    var disabled = (0, _dateUtils.isDayDisabled)(day, this.props);
    var hasFocus = (0, _dateUtils.isSameDay)(day, focus);
    return _react.default.createElement(_.Button, {
      circle: true,
      size: 28,
      disabled: disabled,
      className: 'cui-datepicker__day' + ("" + (isSelected && " cui-datepicker__day--selected" || '')) + ("" + (hasFocus && " cui-datepicker__day--focus" || '')) + ("" + (isToday && " cui-datepicker__day--today" || '')) + ("" + (isOutsideMonth && " cui-datepicker__day--outside-month" || '')),
      onClick: this.handleClick,
      ariaLabel: "" + (0, _dateUtils.getDate)(day),
      "aria-selected": isSelected,
      tabIndex: -1
    }, (0, _dateUtils.getDate)(day));
  };

  return DatePickerDay;
}(_react.default.Component);

DatePickerDay.displayName = 'DatePickerDay';
DatePickerDay.contextTypes = {
  focus: _propTypes.default.instanceOf(_moment.default),
  handleDayClick: _propTypes.default.func,
  selected: _propTypes.default.instanceOf(_moment.default)
};
DatePickerDay.propTypes = {
  /** @prop Required day that the DatePickerDay displays */
  day: _propTypes.default.instanceOf(_moment.default).isRequired,

  /** @prop Required month that the DatePickerDay displays */
  month: _propTypes.default.number.isRequired
};
var _default = DatePickerDay;
exports.default = _default;

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 165,
	"./af.js": 165,
	"./ar": 166,
	"./ar-dz": 167,
	"./ar-dz.js": 167,
	"./ar-kw": 168,
	"./ar-kw.js": 168,
	"./ar-ly": 169,
	"./ar-ly.js": 169,
	"./ar-ma": 170,
	"./ar-ma.js": 170,
	"./ar-sa": 171,
	"./ar-sa.js": 171,
	"./ar-tn": 172,
	"./ar-tn.js": 172,
	"./ar.js": 166,
	"./az": 173,
	"./az.js": 173,
	"./be": 174,
	"./be.js": 174,
	"./bg": 175,
	"./bg.js": 175,
	"./bm": 176,
	"./bm.js": 176,
	"./bn": 177,
	"./bn.js": 177,
	"./bo": 178,
	"./bo.js": 178,
	"./br": 179,
	"./br.js": 179,
	"./bs": 180,
	"./bs.js": 180,
	"./ca": 181,
	"./ca.js": 181,
	"./cs": 182,
	"./cs.js": 182,
	"./cv": 183,
	"./cv.js": 183,
	"./cy": 184,
	"./cy.js": 184,
	"./da": 185,
	"./da.js": 185,
	"./de": 186,
	"./de-at": 187,
	"./de-at.js": 187,
	"./de-ch": 188,
	"./de-ch.js": 188,
	"./de.js": 186,
	"./dv": 189,
	"./dv.js": 189,
	"./el": 190,
	"./el.js": 190,
	"./en-au": 191,
	"./en-au.js": 191,
	"./en-ca": 192,
	"./en-ca.js": 192,
	"./en-gb": 193,
	"./en-gb.js": 193,
	"./en-ie": 194,
	"./en-ie.js": 194,
	"./en-il": 195,
	"./en-il.js": 195,
	"./en-nz": 196,
	"./en-nz.js": 196,
	"./eo": 197,
	"./eo.js": 197,
	"./es": 198,
	"./es-do": 199,
	"./es-do.js": 199,
	"./es-us": 200,
	"./es-us.js": 200,
	"./es.js": 198,
	"./et": 201,
	"./et.js": 201,
	"./eu": 202,
	"./eu.js": 202,
	"./fa": 203,
	"./fa.js": 203,
	"./fi": 204,
	"./fi.js": 204,
	"./fo": 205,
	"./fo.js": 205,
	"./fr": 206,
	"./fr-ca": 207,
	"./fr-ca.js": 207,
	"./fr-ch": 208,
	"./fr-ch.js": 208,
	"./fr.js": 206,
	"./fy": 209,
	"./fy.js": 209,
	"./gd": 210,
	"./gd.js": 210,
	"./gl": 211,
	"./gl.js": 211,
	"./gom-latn": 212,
	"./gom-latn.js": 212,
	"./gu": 213,
	"./gu.js": 213,
	"./he": 214,
	"./he.js": 214,
	"./hi": 215,
	"./hi.js": 215,
	"./hr": 216,
	"./hr.js": 216,
	"./hu": 217,
	"./hu.js": 217,
	"./hy-am": 218,
	"./hy-am.js": 218,
	"./id": 219,
	"./id.js": 219,
	"./is": 220,
	"./is.js": 220,
	"./it": 221,
	"./it.js": 221,
	"./ja": 222,
	"./ja.js": 222,
	"./jv": 223,
	"./jv.js": 223,
	"./ka": 224,
	"./ka.js": 224,
	"./kk": 225,
	"./kk.js": 225,
	"./km": 226,
	"./km.js": 226,
	"./kn": 227,
	"./kn.js": 227,
	"./ko": 228,
	"./ko.js": 228,
	"./ku": 229,
	"./ku.js": 229,
	"./ky": 230,
	"./ky.js": 230,
	"./lb": 231,
	"./lb.js": 231,
	"./lo": 232,
	"./lo.js": 232,
	"./lt": 233,
	"./lt.js": 233,
	"./lv": 234,
	"./lv.js": 234,
	"./me": 235,
	"./me.js": 235,
	"./mi": 236,
	"./mi.js": 236,
	"./mk": 237,
	"./mk.js": 237,
	"./ml": 238,
	"./ml.js": 238,
	"./mn": 239,
	"./mn.js": 239,
	"./mr": 240,
	"./mr.js": 240,
	"./ms": 241,
	"./ms-my": 242,
	"./ms-my.js": 242,
	"./ms.js": 241,
	"./mt": 243,
	"./mt.js": 243,
	"./my": 244,
	"./my.js": 244,
	"./nb": 245,
	"./nb.js": 245,
	"./ne": 246,
	"./ne.js": 246,
	"./nl": 247,
	"./nl-be": 248,
	"./nl-be.js": 248,
	"./nl.js": 247,
	"./nn": 249,
	"./nn.js": 249,
	"./pa-in": 250,
	"./pa-in.js": 250,
	"./pl": 251,
	"./pl.js": 251,
	"./pt": 252,
	"./pt-br": 253,
	"./pt-br.js": 253,
	"./pt.js": 252,
	"./ro": 254,
	"./ro.js": 254,
	"./ru": 255,
	"./ru.js": 255,
	"./sd": 256,
	"./sd.js": 256,
	"./se": 257,
	"./se.js": 257,
	"./si": 258,
	"./si.js": 258,
	"./sk": 259,
	"./sk.js": 259,
	"./sl": 260,
	"./sl.js": 260,
	"./sq": 261,
	"./sq.js": 261,
	"./sr": 262,
	"./sr-cyrl": 263,
	"./sr-cyrl.js": 263,
	"./sr.js": 262,
	"./ss": 264,
	"./ss.js": 264,
	"./sv": 265,
	"./sv.js": 265,
	"./sw": 266,
	"./sw.js": 266,
	"./ta": 267,
	"./ta.js": 267,
	"./te": 268,
	"./te.js": 268,
	"./tet": 269,
	"./tet.js": 269,
	"./tg": 270,
	"./tg.js": 270,
	"./th": 271,
	"./th.js": 271,
	"./tl-ph": 272,
	"./tl-ph.js": 272,
	"./tlh": 273,
	"./tlh.js": 273,
	"./tr": 274,
	"./tr.js": 274,
	"./tzl": 275,
	"./tzl.js": 275,
	"./tzm": 276,
	"./tzm-latn": 277,
	"./tzm-latn.js": 277,
	"./tzm.js": 276,
	"./ug-cn": 278,
	"./ug-cn.js": 278,
	"./uk": 279,
	"./uk.js": 279,
	"./ur": 280,
	"./ur.js": 280,
	"./uz": 281,
	"./uz-latn": 282,
	"./uz-latn.js": 282,
	"./uz.js": 281,
	"./vi": 283,
	"./vi.js": 283,
	"./x-pseudo": 284,
	"./x-pseudo.js": 284,
	"./yo": 285,
	"./yo.js": 285,
	"./zh-cn": 286,
	"./zh-cn.js": 286,
	"./zh-hk": 287,
	"./zh-hk.js": 287,
	"./zh-tw": 288,
	"./zh-tw.js": 288
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 507;

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(7);

__webpack_require__(4);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _lodash = __webpack_require__(13);

var _ = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * @category controls
 * @component editable-textfield
 * @variations collab-ui-react
 */
var EditableTextfield =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(EditableTextfield, _React$Component);

  function EditableTextfield() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      isEditing: false,
      inputText: _this.props.inputText
    };

    _this.componentDidUpdate = function () {
      if (_this.state.isEditing && _this.editText) {
        _this.editText.focus();
      }
    };

    _this.handleEnter = function (e, value) {
      var handleDoneEditing = _this.props.handleDoneEditing;
      e.persist();

      _this.setState({
        isEditing: false,
        inputText: value
      }, function () {
        return handleDoneEditing && handleDoneEditing(e, {
          value: value
        });
      });

      e.nativeEvent.stopImmediatePropagation();
    };

    _this.handleBlur = function (e, value) {
      var handleDoneEditing = _this.props.handleDoneEditing;
      e.persist();

      _this.setState({
        isEditing: false,
        inputText: value
      }, function () {
        return handleDoneEditing && handleDoneEditing(e, {
          value: value
        });
      });
    };

    _this.handleEsc = function (e) {
      _this.setState({
        isEditing: false
      });

      e.nativeEvent.stopImmediatePropagation();
    };

    _this.handleClick = function () {
      var disabled = _this.props.disabled;

      if (disabled) {
        return;
      } else {
        _this.setState({
          isEditing: true
        });
      }
    };

    _this.handleKey = function () {
      var disabled = _this.props.disabled;

      if (disabled) {
        return;
      } else {
        _this.setState({
          isEditing: true
        });
      }
    };

    _this.handleDoneKeyDown = function (e) {
      if (e.keyCode === 27) {
        _this.handleEsc(e);
      } else if (e.keyCode === 13) {
        _this.handleEnter(e, e.target.value);
      }
    };

    return _this;
  }

  var _proto = EditableTextfield.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        alignment = _this$props.alignment,
        buttonClassName = _this$props.buttonClassName,
        buttonProps = _this$props.buttonProps,
        className = _this$props.className,
        props = _objectWithoutPropertiesLoose(_this$props, ["alignment", "buttonClassName", "buttonProps", "className"]);

    var _this$state = this.state,
        isEditing = _this$state.isEditing,
        inputText = _this$state.inputText;
    var inputProps = (0, _lodash.omit)(Object.assign({}, props), ['disabled', 'handleDoneEditing', 'inputText']);
    return _react.default.createElement("span", {
      className: 'cui-editable-textfield' + ("" + (alignment && " cui-editable-textfield--" + alignment || ''))
    }, isEditing && _react.default.createElement(_.Input, _extends({
      className: 'cui-editable-textfield__editing' + ("" + (className && " " + className || '')),
      inputRef: function inputRef(input) {
        _this2.editText = input;
      },
      onDoneEditing: this.handleBlur,
      onKeyDown: this.handleDoneKeyDown,
      value: inputText
    }, inputProps)), !isEditing && _react.default.createElement("div", _extends({
      role: "button",
      tabIndex: 0,
      className: 'cui-editable-textfield__button' + ("" + (buttonClassName && " " + buttonClassName || '')),
      onClick: this.handleClick,
      onKeyPress: this.handleKey
    }, buttonProps), inputText || "\xA0"));
  };

  return EditableTextfield;
}(_react.default.Component);

EditableTextfield.displayName = 'EditableTextfield';
EditableTextfield.propTypes = {
  /** @prop Alignment css modifier | 'left' */
  alignment: _propTypes.default.oneOf(['center', 'left', 'right']),

  /** @ Optional css class name for internal button | null */
  buttonClassName: _propTypes.default.string,

  /** @prop Optional props for internal button | '' */
  buttonProps: _propTypes.default.shape({}),

  /** @prop Optional css class string | '' */
  className: _propTypes.default.string,

  /** @prop Sets the disable attribute for EditableTextField | false */
  disabled: _propTypes.default.bool,

  /** @prop Optional function for blur | null */
  handleDoneEditing: _propTypes.default.func,

  /** @prop Text to be shown within input field | null */
  inputText: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
EditableTextfield.defaultProps = {
  alignment: 'left',
  buttonClassName: '',
  buttonProps: null,
  className: '',
  disabled: false,
  handleDoneEditing: null,
  inputText: ''
};
var _default = EditableTextfield;
/**
* @component editable-textfield
* @section default
* @react
import { EditableTextfield } from '@collabui/react';

export default class EditableTextFieldDefault extends React.Component {
  valueChange = (value) => {
    newValue = value;
  }

  render() {
    return (
      <EditableTextfield
        handleDoneEditing={(e, data) => console.log(e, data)}
        inputText='Hello World'
      />
    );
  }
}

**/

exports.default = _default;

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(7);

__webpack_require__(4);

__webpack_require__(100);

__webpack_require__(19);

__webpack_require__(20);

__webpack_require__(66);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _reactDom = _interopRequireDefault(__webpack_require__(61));

var _lodash = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var EventOverlay =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(EventOverlay, _React$Component);

  function EventOverlay() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      visibleDirection: _this.props.direction
    };

    _this.componentDidMount = function () {
      _this.addHandlers();
    };

    _this.componentDidUpdate = function (prevProps) {
      if (_this.props.isOpen && prevProps.isOpen !== _this.props.isOpen || prevProps.direction !== _this.props.direction) {
        _this.addKeyHandlers();

        return _this.forceUpdate(function () {
          return _this.isVisible();
        });
      } else if (!_this.props.isOpen && prevProps.isOpen !== _this.props.isOpen) {
        return _this.removeKeyHandlers();
      }
    };

    _this.componentWillUnmount = function () {
      _this.removeHandlers();
    };

    _this.isVisible = function () {
      var _this$props = _this.props,
          direction = _this$props.direction,
          isOpen = _this$props.isOpen,
          anchorNode = _this$props.anchorNode,
          isDynamic = _this$props.isDynamic;
      if (!isOpen) return;
      if (!isDynamic) return _this.setPlacement();

      var element = _reactDom.default.findDOMNode(_this.container);

      var elementAnchor = _reactDom.default.findDOMNode(anchorNode);

      var side = direction.split('-')[0];
      var alignment = direction.split('-')[1];
      var anchor = elementAnchor && elementAnchor.getBoundingClientRect();
      var elementBoundingRect = element.getBoundingClientRect();
      var elementParent = element.parentElement;
      ['top', 'bottom'].includes(side) ? _this.setVerticalClass(alignment, anchor, elementBoundingRect, elementParent) : _this.setHorizontalClass(alignment, anchor, elementBoundingRect, elementParent);
    };

    _this.findParents = function (ele, tempParentArr) {
      if (tempParentArr === void 0) {
        tempParentArr = [];
      }

      return !ele.parentElement ? tempParentArr : _this.findParents(ele.parentElement, tempParentArr.concat(ele));
    };

    _this.findOverflow = function (node, searchProps) {
      return searchProps.reduce(function (agg, prop) {
        var overflowElement = window.getComputedStyle(_reactDom.default.findDOMNode(node))[prop];
        return !overflowElement || agg.includes(overflowElement) ? agg : agg += overflowElement;
      }, '');
    };

    _this.findScrollParent = function (elementParents, searchProps) {
      var overflowElement = null;
      var idx = 0;

      while (!overflowElement && elementParents[idx]) {
        var currentOverflowElement = _this.findOverflow(elementParents[idx], searchProps);

        if (/(auto|scroll|hidden)/.test(currentOverflowElement)) {
          return overflowElement = elementParents[idx];
        }

        idx++;
      }

      return overflowElement ? overflowElement : window;
    };

    _this.setHorizontalClass = function (alignment, anchor, elementBoundingRect, elementParent) {
      var _this$props2 = _this.props,
          showArrow = _this$props2.showArrow,
          checkOverflow = _this$props2.checkOverflow,
          targetOffset = _this$props2.targetOffset;
      var windowRight = window.pageYOffset + window.innerWidth;
      var elementWidth = elementBoundingRect.width;
      var anchorRight = anchor.right;
      var arrowWidth = showArrow ? _reactDom.default.findDOMNode(_this.arrow).getBoundingClientRect().width : 0;
      var offsetWidth = targetOffset.horizontal || 0;
      var totalWidth = anchorRight + elementWidth + arrowWidth + offsetWidth;

      var elementParents = _this.findParents(elementParent);

      var scrollParent = _this.findScrollParent(elementParents, ['overflow', 'overflow-x']);

      var parentRight = checkOverflow && !!scrollParent.getBoundingClientRect && scrollParent.getBoundingClientRect().right || windowRight;
      return totalWidth < parentRight && totalWidth < windowRight ? _this.setState({
        visibleDirection: "right-" + alignment
      }, function () {
        return _this.setPlacement();
      }) : _this.setState({
        visibleDirection: "left-" + alignment
      }, function () {
        return _this.setPlacement();
      });
    };

    _this.setVerticalClass = function (alignment, anchor, elementBoundingRect, elementParent) {
      var _this$props3 = _this.props,
          showArrow = _this$props3.showArrow,
          checkOverflow = _this$props3.checkOverflow,
          targetOffset = _this$props3.targetOffset;
      var windowBottom = window.pageXOffset + window.innerHeight;
      var elementHeight = elementBoundingRect.height;
      var anchorBottom = anchor.bottom;
      var arrowHeight = showArrow ? _reactDom.default.findDOMNode(_this.arrow).getBoundingClientRect().height : 0;
      var offsetHeight = targetOffset.vertical || 0;
      var totalHeight = anchorBottom + elementHeight + arrowHeight + offsetHeight;

      var elementParents = _this.findParents(elementParent);

      var scrollParent = _this.findScrollParent(elementParents, ['overflow', 'overflow-y']);

      var parentBottom = checkOverflow && !!scrollParent.getBoundingClientRect && scrollParent.getBoundingClientRect().bottom || windowBottom;
      return totalHeight < parentBottom && totalHeight < windowBottom ? _this.setState({
        visibleDirection: "bottom-" + alignment
      }, function () {
        return _this.setPlacement();
      }) : _this.setState({
        visibleDirection: "top-" + alignment
      }, function () {
        return _this.setPlacement();
      });
    };

    _this.addHandlers = function () {
      var _this$props4 = _this.props,
          allowClickAway = _this$props4.allowClickAway,
          closeOnClick = _this$props4.closeOnClick;
      _this.handleResize = _this.isVisible;
      _this.handleScroll = _this.isVisible;

      if (allowClickAway) {
        document.addEventListener('click', _this.handleAllowClickAway, true);
      }

      closeOnClick && document.addEventListener('click', _this.handleCloseOnClick, false);
      window.addEventListener('resize', _this.handleResize, true);
      document.addEventListener('scroll', _this.handleScroll, false);

      _this.isVisible();
    };

    _this.addKeyHandlers = function () {
      var _this$props5 = _this.props,
          allowClickAway = _this$props5.allowClickAway,
          checkOverflow = _this$props5.checkOverflow;

      if (allowClickAway) {
        document.addEventListener('keydown', _this.handleKeyDown, false);
      }

      if (checkOverflow) {
        var element = _reactDom.default.findDOMNode(_this.container);

        var elementParent = element.parentElement;

        var elementParents = _this.findParents(elementParent);

        var scrollParent = _this.findScrollParent(elementParents, ['overflow', 'overflow-y', 'overflow-x']);

        scrollParent && scrollParent.addEventListener('scroll', _this.handleScroll, false);
      }
    };

    _this.removeKeyHandlers = function () {
      document.removeEventListener('keydown', _this.handleKeyDown, false);
    };

    _this.removeHandlers = function () {
      document.removeEventListener('click', _this.handleAllowClickAway, true);
      document.removeEventListener('click', _this.handleCloseOnClick, false);
      window.removeEventListener('resize', _this.handleResize, true);
      document.removeEventListener('scroll', _this.handleScroll, false);
    };

    _this.handleCloseOnClick = function (e) {
      if (!_this.props.isOpen) return;
      var closeOnClick = _this.props.closeOnClick;
      return closeOnClick && _this.container && _reactDom.default.findDOMNode(_this.container).contains(e.target) && _this.handleClickAway(e);
    };

    _this.handleKeyDown = function (e) {
      if (!_this.props.isOpen) return;
      if (e.keyCode === 27) return _this.handleClickAway(e);

      var anchorNode = _reactDom.default.findDOMNode(_this.props.anchorNode);

      return _this.container && !anchorNode.contains(document.activeElement) && !_reactDom.default.findDOMNode(_this.container).contains(document.activeElement) && _this.handleClickAway(e);
    };

    _this.handleAllowClickAway = function (e) {
      if (!_this.props.isOpen) return;

      var anchorNode = _reactDom.default.findDOMNode(_this.props.anchorNode);

      return _this.container && !_reactDom.default.findDOMNode(anchorNode).contains(e.target) && !_reactDom.default.findDOMNode(_this.container).contains(e.target) && _this.handleClickAway(e);
    };

    _this.getAnchorPosition = function (node) {
      var rect = node.getBoundingClientRect();
      var anchorPosition = {
        top: rect.top,
        left: rect.left,
        width: node.offsetWidth,
        height: node.offsetHeight
      };
      anchorPosition.right = rect.right || anchorPosition.left + anchorPosition.width;
      anchorPosition.bottom = rect.bottom || anchorPosition.top + anchorPosition.height;
      anchorPosition.middle = anchorPosition.left + (anchorPosition.right - anchorPosition.left) / 2;
      anchorPosition.center = anchorPosition.top + (anchorPosition.bottom - anchorPosition.top) / 2;
      return anchorPosition;
    };

    _this.getTargetPosition = function (targetNode) {
      return {
        top: 0,
        center: targetNode.offsetHeight / 2,
        bottom: targetNode.offsetHeight,
        left: 0,
        middle: targetNode.offsetWidth / 2,
        right: targetNode.offsetWidth
      };
    };

    _this.getOrigin = function () {
      var side = _this.state.visibleDirection.split('-')[0];

      var alignment = _this.props.direction.split('-')[1];

      var origin = {
        anchor: {},
        target: {}
      };

      if (side === 'top' || side === 'bottom') {
        origin.anchor.vertical = side;
        origin.anchor.horizontal = alignment === 'center' ? 'middle' : alignment;
        origin.target.vertical = side === 'top' ? 'bottom' : 'top';
        origin.target.horizontal = alignment === 'center' ? 'middle' : alignment;
      }

      if (side === 'left' || side === 'right') {
        origin.anchor.vertical = alignment;
        origin.anchor.horizontal = side;
        origin.target.vertical = alignment;
        origin.target.horizontal = side === 'left' ? 'right' : 'left';
      }

      return origin;
    };

    _this.setArrowPlacement = function (anchor, container) {
      var arrow = _this.arrow;
      var targetOffset = _this.props.targetOffset;
      var visibleDirection = _this.state.visibleDirection;
      var side = visibleDirection.split('-')[0];
      var verticalOffset = targetOffset.vertical || 0;
      var horizontalOffset = targetOffset.horizontal || 0;
      var isAnchorWider = anchor.width > container.right;
      var isAnchorTaller = anchor.height > container.bottom;
      var arrowLeft = isAnchorWider && !visibleDirection.includes('center') ? visibleDirection.includes('left') ? container.middle + anchor.left : anchor.right - container.middle : anchor.middle;
      var arrowTop = isAnchorTaller && !visibleDirection.includes('center') ? visibleDirection.includes('top') ? container.center + anchor.top : anchor.bottom - container.center : anchor.center;

      switch (side) {
        case 'top':
          arrow.style.left = arrowLeft + "px";
          arrow.style.top = anchor.top - verticalOffset + "px";
          break;

        case 'bottom':
          arrow.style.left = arrowLeft + "px";
          arrow.style.top = anchor.bottom + verticalOffset + "px";
          break;

        case 'left':
          arrow.style.left = anchor.left - horizontalOffset + "px";
          arrow.style.top = arrowTop + "px";
          break;

        case 'right':
          arrow.style.left = anchor.right + horizontalOffset + "px";
          arrow.style.top = arrowTop + "px";
          break;
      }
    };

    _this.setBoundingBox = function (side, targetNode, anchorPosition) {
      var _this$props6 = _this.props,
          checkOverflow = _this$props6.checkOverflow,
          maxHeight = _this$props6.maxHeight,
          maxWidth = _this$props6.maxWidth,
          showArrow = _this$props6.showArrow,
          targetOffset = _this$props6.targetOffset;

      var arrowDims = showArrow && _reactDom.default.findDOMNode(_this.arrow).getBoundingClientRect();

      var element = _reactDom.default.findDOMNode(_this.container);

      var elementParent = element.parentElement;
      var documentScrollTop = document.documentElement.scrollTop;
      var documentBottom = document.documentElement.scrollHeight;
      var windowBottom = window.pageXOffset + window.innerHeight;
      var documentRight = document.documentElement.offsetWidth;
      var arrowHeight = arrowDims && arrowDims.height || 0;
      var arrowWidth = arrowDims && arrowDims.width || 0;
      var offsetHeight = targetOffset.vertical || 0;
      var offsetWidth = targetOffset.horizontal || 0;

      var elementParents = _this.findParents(elementParent);

      var scrollParent = _this.findScrollParent(elementParents, ['overflow', 'overflow-x']);

      var elementDims = element.getBoundingClientRect();
      var elementVerticalHeight = elementDims.height + offsetHeight;
      var elementVerticalWidth = elementDims.width + offsetWidth;

      var getAvailableTopSpace = function getAvailableTopSpace(top) {
        return top + anchorPosition.top - (_this.elementHeight + arrowHeight);
      };

      var parentDims = checkOverflow && !!scrollParent.getBoundingClientRect && scrollParent.getBoundingClientRect();

      if (targetNode && targetNode.style && !targetNode.style.bottom && elementVerticalHeight) {
        _this.elementHeight = elementVerticalHeight;
      }

      if (targetNode && targetNode.style && !targetNode.style.right && elementVerticalWidth) {
        _this.elementWidth = elementVerticalWidth;
        _this.elementLeft = elementDims.left;
        _this.elementRight = elementDims.right;
      }

      switch (side) {
        case 'top':
          if (!parentDims.top) {
            if (getAvailableTopSpace(documentScrollTop) < 0) {
              targetNode.style.top = arrowHeight - documentScrollTop + "px";
            }

            if (arrowHeight + _this.elementHeight > anchorPosition.top) {
              targetNode.style.bottom = windowBottom - anchorPosition.top + arrowHeight + offsetHeight + "px";
            }

            if (_this.elementWidth > documentRight) {
              targetNode.style.right = '0px';
            }

            if (_this.elementLeft < 0) {
              targetNode.style.left = '0px';
            }
          } else {
            if (anchorPosition.top - parentDims.top - _this.elementHeight - arrowHeight < 0) {
              targetNode.style.top = parentDims.top + arrowHeight + "px";
              targetNode.style.bottom = windowBottom - anchorPosition.top + arrowHeight + offsetHeight + "px";
              targetNode.style.maxHeight = (maxHeight || parentDims.height) + "px";
            }

            if (_this.elementWidth > parentDims.width || _this.elementRight > parentDims.right) {
              targetNode.style.right = documentRight - parentDims.right + "px";
            }

            if (_this.elementLeft < parentDims.left) {
              targetNode.style.left = parentDims.left + "px";
            }

            if (arrowDims && (arrowDims.top < parentDims.top || arrowDims.bottom + 1 > parentDims.bottom)) {
              _this.arrow.style.visibility = 'hidden';
            } else if (arrowDims) {
              _this.arrow.style.visibility = 'visible';
            }
          }

          break;

        case 'bottom':
          if (!parentDims.bottom) {
            if (_this.elementHeight + arrowHeight + anchorPosition.bottom + documentScrollTop > documentBottom) {
              targetNode.style.bottom = documentScrollTop + windowBottom - documentBottom + "px";
            }

            if (_this.elementWidth > documentRight) {
              targetNode.style.right = '0px';
            }

            if (elementDims.left < 0) {
              targetNode.style.left = '0px';
            }
          } else {
            if (_this.elementHeight + arrowHeight + anchorPosition.bottom > parentDims.bottom) {
              targetNode.style.bottom = windowBottom - parentDims.bottom + "px";
              targetNode.style.maxHeight = (maxHeight || parentDims.height) + "px";
            }

            if (_this.elementWidth > parentDims.width || _this.elementRight > parentDims.right) {
              targetNode.style.right = documentRight - parentDims.right + "px";
            }

            if (_this.elementLeft < parentDims.left) {
              targetNode.style.left = parentDims.left + "px";
            }

            if (arrowDims && (arrowDims.top < parentDims.top || arrowDims.bottom + 1 > parentDims.bottom)) {
              _this.arrow.style.visibility = 'hidden';
            } else if (arrowDims) {
              _this.arrow.style.visibility = 'visible';
            }
          }

          break;

        case 'left':
          if (!parentDims.left) {
            if (arrowWidth + offsetWidth + elementDims.width + anchorPosition.left > anchorPosition.left) {
              targetNode.style.left = arrowWidth + "px";
              targetNode.style.right = documentRight - anchorPosition.left + arrowWidth + offsetWidth + "px";
            }

            if (getAvailableTopSpace(documentScrollTop) < 0) {
              targetNode.style.top = -documentScrollTop + "px";
            }

            if (_this.elementHeight + arrowHeight + anchorPosition.bottom + documentScrollTop > documentBottom) {
              targetNode.style.bottom = documentScrollTop + windowBottom - documentBottom + "px";
            }
          } else {
            if (anchorPosition.left - parentDims.left < _this.elementWidth + arrowWidth) {
              targetNode.style.left = parentDims.left + arrowWidth + "px";
              targetNode.style.right = documentRight - anchorPosition.left + arrowWidth + offsetWidth + "px";
              targetNode.style.maxWidth = (maxWidth || parentDims.width) + "px";
            }

            if (anchorPosition.top - parentDims.top - _this.elementHeight < 0) {
              targetNode.style.top = parentDims.top + "px";
            }

            if (_this.elementHeight + anchorPosition.bottom > parentDims.bottom) {
              targetNode.style.bottom = windowBottom - parentDims.bottom + "px";
            }

            if (arrowDims && (arrowDims.top < parentDims.top || arrowDims.bottom > parentDims.bottom)) {
              _this.arrow.style.visibility = 'hidden';
            } else if (arrowDims) {
              _this.arrow.style.visibility = 'visible';
            }
          }

          break;

        case 'right':
          if (!parentDims.right) {
            if (arrowWidth + offsetWidth + elementDims.width + anchorPosition.right > documentRight) {
              targetNode.style.right = '0px';
            }

            if (getAvailableTopSpace(documentScrollTop) < 0) {
              targetNode.style.top = -documentScrollTop + "px";
            }

            if (_this.elementHeight + arrowHeight + anchorPosition.bottom + documentScrollTop > documentBottom) {
              targetNode.style.bottom = documentScrollTop + windowBottom - documentBottom + "px";
            }
          } else {
            if (anchorPosition.right + _this.elementWidth + arrowWidth > parentDims.right) {
              targetNode.style.left = anchorPosition.right + offsetWidth + "px";
              targetNode.style.right = documentRight - parentDims.right + "px";
              targetNode.style.maxWidth = (maxWidth || parentDims.width) + "px";
            }

            if (anchorPosition.top - parentDims.top - _this.elementHeight < 0) {
              targetNode.style.top = parentDims.top + "px";
            }

            if (_this.elementHeight + anchorPosition.bottom > parentDims.bottom) {
              targetNode.style.bottom = windowBottom - parentDims.bottom + "px";
            }

            if (arrowDims && (arrowDims.top < parentDims.top || arrowDims.bottom > parentDims.bottom)) {
              _this.arrow.style.visibility = 'hidden';
            } else if (arrowDims) {
              _this.arrow.style.visibility = 'visible';
            }
          }

          break;
      }
    };

    _this.setPlacement = function () {
      var _this$props7 = _this.props,
          anchorNode = _this$props7.anchorNode,
          isOpen = _this$props7.isOpen,
          isContained = _this$props7.isContained,
          showArrow = _this$props7.showArrow,
          targetOffset = _this$props7.targetOffset;
      var visibleDirection = _this.state.visibleDirection;
      if (!isOpen) return;

      var anchorNodeFound = _reactDom.default.findDOMNode(anchorNode);

      var side = visibleDirection.split('-')[0];
      var targetNode = _this.container;
      var verticalOffset = targetOffset.vertical || 0;
      var horizontalOffset = targetOffset.horizontal || 0;
      if (!targetNode || !anchorNodeFound) return;
      anchorNodeFound.link = _this.state.id;

      var anchorPosition = _this.getAnchorPosition(anchorNodeFound);

      var targetPosition = _this.getTargetPosition(targetNode);

      var origin = _this.getOrigin();

      var anchorOrigin = origin.anchor;
      var targetOrigin = origin.target;
      var targetNodePosition = {
        top: anchorPosition[anchorOrigin.vertical] - targetPosition[targetOrigin.vertical] + (side === 'top' ? -verticalOffset : verticalOffset),
        left: anchorPosition[anchorOrigin.horizontal] - targetPosition[targetOrigin.horizontal] + (side === 'left' ? -horizontalOffset : horizontalOffset)
      };
      targetNode.style.top = targetNodePosition.top + "px";
      targetNode.style.left = targetNodePosition.left + "px";
      showArrow && _this.setArrowPlacement(anchorPosition, targetPosition);
      isContained && _this.setBoundingBox(side, targetNode, anchorPosition);
    };

    _this.handleClickAway = function (e) {
      _this.props.close && _this.props.close(e);
    };

    return _this;
  }

  var _proto = EventOverlay.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props8 = this.props,
        children = _this$props8.children,
        className = _this$props8.className,
        isOpen = _this$props8.isOpen,
        maxHeight = _this$props8.maxHeight,
        maxWidth = _this$props8.maxWidth,
        showArrow = _this$props8.showArrow,
        style = _this$props8.style,
        props = _objectWithoutPropertiesLoose(_this$props8, ["children", "className", "isOpen", "maxHeight", "maxWidth", "showArrow", "style"]);

    var side = this.state.visibleDirection.split('-')[0];
    var otherProps = (0, _lodash.omit)(Object.assign({}, props), ['allowClickAway', 'anchorNode', 'checkOverflow', 'close', 'closeOnClick', 'direction', 'isDynamic', 'isContained', 'targetOffset']);

    var contentNodes = _react.default.createElement("div", {
      className: 'cui-event-overlay' + ("" + (showArrow && " cui-event-overlay--arrow" || '')) + ("" + (side && " cui-event-overlay--" + side || '')) + ("" + (className && " " + className || ''))
    }, showArrow && _react.default.createElement("div", {
      ref: function ref(_ref) {
        return _this2.arrow = _ref;
      },
      className: "cui-event-overlay__arrow"
    }), _react.default.createElement("div", _extends({
      className: "cui-event-overlay__children",
      ref: function ref(_ref2) {
        return _this2.container = _ref2;
      },
      style: Object.assign({}, maxWidth && {
        maxWidth: maxWidth + "px"
      }, maxHeight && {
        maxHeight: maxHeight + "px"
      }, style)
    }, otherProps), children));

    return isOpen && contentNodes;
  };

  return EventOverlay;
}(_react.default.Component);

exports.default = EventOverlay;
EventOverlay.displayName = 'EventOverlay';
EventOverlay.defaultProps = {
  allowClickAway: true,
  anchorNode: null,
  children: null,
  checkOverflow: false,
  className: '',
  close: null,
  direction: 'bottom-left',
  isContained: false,
  isDynamic: false,
  isOpen: false,
  maxHeight: null,
  maxWidth: null,
  showArrow: false,
  style: null,
  targetOffset: {
    horizontal: 0,
    vertical: 0
  }
};
EventOverlay.propTypes = {
  /** @prop Allows use to click outside of EventOverlay | true */
  allowClickAway: _propTypes.default.bool,

  /** @prop Node in which the selection begins | null */
  anchorNode: _propTypes.default.object,

  /** @prop Set to Check if children nodes are overflowing the EventOverlay | false */
  checkOverflow: _propTypes.default.bool,

  /** @prop Children nodes to render inside the EventOverlay | null */
  children: _propTypes.default.node,

  /** @prop Optional css class string | '' */
  className: _propTypes.default.string,

  /** @prop Function to close EventOverlay | null */
  close: _propTypes.default.func,

  /** @prop Determines if the EventOverlay should close when clicked on | true */
  closeOnClick: _propTypes.default.bool,

  /** @prop Sets the direction in which the EventOverlay extends | 'bottom-left' */
  direction: _propTypes.default.oneOf(['top-center', 'left-center', 'right-center', 'bottom-center', 'top-left', 'top-right', 'bottom-left', 'bottom-right', 'left-top', 'left-bottom', 'right-top', 'right-bottom']),

  /** @prop Determines if the contents of EventOverlay is contained within Component | false */
  isContained: _propTypes.default.bool,

  /** @prop Sets the EventOverlay to be a dynamic UI component | false */
  isDynamic: _propTypes.default.bool,

  /** @prop Sets the visibility of the EventOverlay | false */
  isOpen: _propTypes.default.bool,

  /** @prop Sets the max height of the EventOverlay | null */
  maxHeight: _propTypes.default.number,

  /** @prop Sets the max width of the EventOverlay | null */
  maxWidth: _propTypes.default.number,

  /** @prop Determines if the EventOverlay should show the open/close arrow | false */
  showArrow: _propTypes.default.bool,

  /** @prop Optional css styling | null */
  style: _propTypes.default.object,

  /** @prop Sets the target offset | { horizontal: 0, vertical: 0 } */
  targetOffset: _propTypes.default.shape({
    horizontal: _propTypes.default.number,
    vertical: _propTypes.default.number
  })
};

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(144);

__webpack_require__(137);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var ErrorBoundary =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ErrorBoundary, _React$Component);

  function ErrorBoundary() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      error: null,
      errorInfo: null
    };
    return _this;
  }

  var _proto = ErrorBoundary.prototype;

  _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    });

    if (this.props.errorCallback) {
      this.props.errorCallback(error, errorInfo);
    }
  };

  _proto.render = function render() {
    var _this$state = this.state,
        error = _this$state.error,
        errorInfo = _this$state.errorInfo;
    var _this$props = this.props,
        children = _this$props.children,
        fallbackComponent = _this$props.fallbackComponent;

    var errorComponent = function errorComponent() {
      return fallbackComponent ? _react.default.cloneElement(fallbackComponent, {
        error: error,
        errorInfo: errorInfo
      }) : _react.default.createElement("div", null, _react.default.createElement("h2", null, "Something went wrong."), _react.default.createElement("details", {
        style: {
          whiteSpace: 'pre-wrap'
        }
      }, error && error.toString(), _react.default.createElement("br", null), errorInfo.componentStack));
    };

    return errorInfo ? errorComponent() : children;
  };

  return ErrorBoundary;
}(_react.default.Component);

ErrorBoundary.propTypes = {
  /** @prop Children nodes to render inside the ErrorBoundary | null */
  children: _propTypes.default.node,

  /** @prop Callback function invoked when an error has occured | null */
  errorCallback: _propTypes.default.func,

  /** @prop Sets a backup Component in the case of a failure | null */
  fallbackComponent: _propTypes.default.node
};
ErrorBoundary.defaultProps = {
  children: null,
  errorCallback: null,
  fallbackComponent: null
};
ErrorBoundary.displayName = 'ErrorBoundary';
var _default = ErrorBoundary;
exports.default = _default;

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var Footer =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Footer, _React$Component);

  function Footer() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Footer.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        color = _this$props.color,
        logo = _this$props.logo,
        copyright = _this$props.copyright,
        social = _this$props.social,
        className = _this$props.className,
        children = _this$props.children;

    var footerTopSection = children && _react.default.createElement("section", {
      className: "cui-footer__top"
    }, children);

    var footerBottomSection = (logo || copyright || social) && _react.default.createElement("section", {
      className: "cui-footer__bottom"
    }, (logo || copyright) && _react.default.createElement("span", {
      className: "cui-footer__bottom--position-left"
    }, _react.default.createElement("span", {
      className: "cui-footer__logo"
    }, logo), copyright), social && _react.default.createElement("span", {
      className: "cui-footer__bottom--position-right"
    }, social));

    return _react.default.createElement("footer", {
      className: "cui-footer" + (" cui-footer--" + color) + (" " + className)
    }, footerTopSection, footerBottomSection);
  };

  return Footer;
}(_react.default.Component);

exports.default = Footer;
Footer.propTypes = {
  /** @prop Children nodes to render inside the Footer | null */
  children: _propTypes.default.node,

  /** @prop Optional css class string | '' */
  className: _propTypes.default.string,

  /** @prop Optional color css styling | 'dark' */
  color: _propTypes.default.string,

  /** @prop Set the copyright within the Footer | '' */
  copyright: _propTypes.default.string,

  /** @prop Set the logo within the Footer | null */
  logo: _propTypes.default.node,

  /** @prop Node containing social media links | null */
  social: _propTypes.default.node
};
Footer.defaultProps = {
  children: null,
  className: '',
  color: 'dark',
  copyright: '',
  logo: null,
  social: null
};
Footer.displayName = 'Footer';
/**
* @name Footer
* @description default footer
*
* @category layout
* @component footer
* @section default
*
* @js
import {
  Icon,
  Footer,
  List,
  ListItem,
  SocialList,
} from '@collabui/react';

export default class DefaultFooter extends React.PureComponent {
  render() {
    const copyright = '2018 Cisco and /or its affiliate';
    const social = (
      <SocialList>
        <List tabType='horizontal' className='social-list'>
          <ListItem link='https://www.facebook.com'>
            <i className='icon icon-facebook-circle_24' />
          </ListItem>
          <ListItem link='https://www.twitter.com'>
            <i className='icon icon-twitter-circle_24' />
          </ListItem>
          <ListItem link='https://www.linkedin.com'>
            <i className='icon icon-linkedin-circle_24' />
          </ListItem>
        </List>
      </SocialList>
    );

    return (
      <div className='row'>
        <Footer
          logo={<i className='icon icon-cisco-logo' />}
          copyright='2018 Cisco and /or its affiliate'
          social={social}
        >
          <div className='columns medium-3'>
            <h5 className='cui-footer__list-item-title'>Connect</h5>
            <List>
              <ListItem label='24/7 Support' />
              <ListItem label='Developer Events' />
              <ListItem label='Contact Sales' />
            </List>
          </div>
          <div className='columns medium-3'>
            <h5 className='cui-footer__list-item-title'>Handy Links</h5>
            <List>
              <ListItem label='Cisco Webex Ambassadors' />
              <ListItem label='Cisco Webex Control Hub' />
              <ListItem label='Cisco Webex Innovation Fund' />
            </List>
          </div>
          <div className='columns medium-3'>
            <h5 className='cui-footer__list-item-title'>Resources</h5>
            <List>
              <ListItem label='Open Source Bot Starter Kits' />
              <ListItem label='Download Cisco Webex Teams' />
              <ListItem label='Devnet Learning Labs' />
            </List>
          </div>
          <div className='columns medium-3'>
            <List>
              <ListItem label='Terms Of Service' />
              <ListItem label='Privacy Policy' />
              <ListItem label='Cookie Policy' />
              <ListItem label='Trademarks' />
            </List>
          </div>
        </Footer>
      </div>
    );
  }
}
**/

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(4);

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(7);

__webpack_require__(37);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * @category controls
 * @component form
 * @variations collab-ui-react
 */
var Form =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(Form, _React$PureComponent);

  function Form() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = Form.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        name = _this$props.name,
        children = _this$props.children,
        props = _objectWithoutPropertiesLoose(_this$props, ["name", "children"]);

    return _react.default.createElement("form", _extends({
      name: name,
      className: "cui-form"
    }, props), children);
  };

  return Form;
}(_react.default.PureComponent);

Form.propTypes = {
  /** @prop Children node to render inside Form | null */
  children: _propTypes.default.node,

  /** @prop Form name */
  name: _propTypes.default.string.isRequired
};
Form.defaultProps = {
  children: null
};
Form.displayName = 'Form';
var _default = Form;
/**
* @name Form
* @description Forms are useful.
*
* @category controls
* @component form
* @section default
*
* @js

import {
  Button,
  Form,
  FormSection,
  FormSubSection,
  Input,
  InputHelper,
  Radio,
  RadioGroup,
} from '@collabui/react';

export default function FormDefault() {
    return (
      <div className='row'>
        <br />
        <Form name='offForm'>
          <FormSection
            title='Section Title'
            description={`Section Description. Curabitur lobortis id lorem id bibendum. Ut id consectetur magna. Quisque volutpat augue enim, pulvinar lobortis nibh lacinia at. Vestibulum nec erat ut mi sollicitudin porttitor id sit amet risus. Nam tempus vel odio vitae aliquam. In imperdiet eros id lacus vestibulum vestibulum. Suspendisse fermentum sem sagittis ante venenatis egestas quis vel justo. Maecenas semper suscipit nunc, sed aliquam sapien convallis eu. Nulla ut turpis in diam dapibus consequat.`}
          >
            <FormSubSection
              label='Subsection Label'
              description='Subsection Description lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse sit amet hendrerit turpis, in accumsan quam.'
            >
              <RadioGroup name='radioGroup2'>
                <Radio
                  value='me2'
                  label='me'
                  htmlId='testRadio1.1'
                  onChange={()=>{}}
                />
                <Radio
                  value='you2'
                  label='you'
                  htmlId='testRadio2.1'
                  onChange={()=>{}}
                />
                <Radio
                  value='us2'
                  label='us'
                  htmlId='testRadio3.1'
                  onChange={()=>{}}
                >
                  <InputHelper message={'I\'m here to help'} />
                </Radio>
              </RadioGroup>
              <Input
                htmlId='testMe2'
                value='testMe2'
                name='testMe2'
                label='First Input'
                disabled
                placeholder='Disabled Input'
                onChange={() => {}}
                inputHelpText='Field Must be Disabled'
                errorArr={[]}
              />
            </FormSubSection>
            <FormSubSection
              label='Subsection Label'
              description='Another One.'
            >
              <Button
                ariaLabel='Click to Do Nothing'
                className='btn--primary'
                onClick={() => {}}
              >
                Click to Do Nothing
              </Button>
            </FormSubSection>
          </FormSection>
        </Form>
      </div>
    );
  }

**/

exports.default = _default;

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * FormContent helps organize the content within a form section and provides a S wrapper;
 **/
var FormContent = function FormContent(props) {
  var children = props.children;
  return _react.default.createElement("div", {
    className: "section__content"
  }, children);
};

FormContent.propTypes = {
  /** @prop Children node to render inside FormContent | null */
  children: _propTypes.default.node
};
FormContent.deafultProps = {
  children: null
};
FormContent.displayName = 'FormContent';
var _default = FormContent;
exports.default = _default;

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * FormInfo is supplemental, organizational component used to help divide form
 **/
var FormInfo = function FormInfo(props) {
  var title = props.title,
      description = props.description;
  return _react.default.createElement("div", {
    className: "section__info"
  }, _react.default.createElement("h4", {
    className: "section__title"
  }, title), description && _react.default.createElement("p", {
    className: "section__description"
  }, description));
};

FormInfo.propTypes = {
  /** @prop Optional FormInfo description text | '' */
  description: _propTypes.default.string,

  /** @prop Optional FormInfo title | '' */
  title: _propTypes.default.string
};
FormInfo.defaultProps = {
  description: '',
  title: ''
};
FormInfo.displayName = 'FormInfo';
var _default = FormInfo;
exports.default = _default;

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _ = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @category controls
 * @component form
 * @variations collab-ui-react
 **/
var FormSection = function FormSection(props) {
  var title = props.title,
      description = props.description,
      children = props.children;
  return _react.default.createElement("div", {
    className: "cui-form__section"
  }, _react.default.createElement(_.FormInfo, {
    title: title,
    description: description
  }), _react.default.createElement(_.FormContent, null, children));
};

FormSection.propTypes = {
  /** @prop Children node to render inside FormSection | null */
  children: _propTypes.default.node,

  /** @prop Optional FormSection description | '' */
  description: _propTypes.default.string,

  /** @prop Optional FormSection title | null */
  title: _propTypes.default.string.isRequired
};
FormSection.defaultProps = {
  children: null,
  description: '',
  title: null
};
FormSection.displayName = 'FormSection';
var _default = FormSection;
/**
* @name Form Section
* @description Forms are useful.
*
* @category controls
* @component form
* @section Form Section
*
* @js

import {
  FormSection,
  Input
} from '@collabui/react';

export default function FormSectionDefault() {
    return (
      <div className='row'>
        <br />
        <FormSection
          title='Section Title'
          description={`Section Description. Curabitur lobortis id lorem id bibendum. Ut id consectetur magna. Quisque volutpat augue enim, pulvinar lobortis nibh lacinia at. Vestibulum nec erat ut mi sollicitudin porttitor id sit amet risus. Nam tempus vel odio vitae aliquam. In imperdiet eros id lacus vestibulum vestibulum. Suspendisse fermentum sem sagittis ante venenatis egestas quis vel justo. Maecenas semper suscipit nunc, sed aliquam sapien convallis eu. Nulla ut turpis in diam dapibus consequat.`}
        >
          <Input
            htmlId='testMe2'
            value='testMe2'
            name='testMe2'
            label='First Input'
            disabled
            placeholder='Disabled Input'
            onChange={() => {}}
            inputHelpText='Field Must be Disabled'
            errorArr={[]}
          />
        </FormSection>
      </div>
    );
  }

**/

exports.default = _default;

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @category controls
 * @component form
 * @variations collab-ui-react
 **/
var FormSubSection = function FormSubSection(props) {
  var label = props.label,
      children = props.children,
      description = props.description;
  return _react.default.createElement("div", {
    className: "sub-section"
  }, label && _react.default.createElement("h5", {
    className: "sub-section__label"
  }, label), description && _react.default.createElement("p", {
    className: "sub-section__description"
  }, description), children);
};

FormSubSection.propTypes = {
  /** @prop Children node to render inside FormSubSection | null */
  children: _propTypes.default.node,

  /** @prop Optional FormSubSection description text | '' */
  description: _propTypes.default.string,

  /** @prop Optional FormSubSection label text | '' */
  label: _propTypes.default.string
};
FormSubSection.defaultProps = {
  children: null,
  description: '',
  label: ''
};
FormSubSection.displayName = 'FormSubSection';
var _default = FormSubSection;
/**
* @name Form Sub Section
* @description Forms are useful.
*
* @category controls
* @component form
* @section Form Sub Section
*
* @js

import {
  FormSubSection,
  Input
} from '@collabui/react';

export default function Default() {
    return (
      <div className='row'>
        <br />
        <FormSubSection
          label='Subsection Label'
          description='Subsection Description lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse sit amet hendrerit turpis, in accumsan quam.'
        >
          <Input
            htmlId='testMe2'
            value='testMe2'
            name='testMe2'
            label='First Input'
            disabled
            placeholder='Disabled Input'
            onChange={() => {}}
            inputHelpText='Field Must be Disabled'
            errorArr={[]}
          />
        </FormSubSection>
      </div>
    );
  }

**/

exports.default = _default;

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(106);

exports.__esModule = true;
exports.default = void 0;

__webpack_require__(5);

__webpack_require__(7);

__webpack_require__(4);

__webpack_require__(65);

__webpack_require__(132);

__webpack_require__(133);

__webpack_require__(157);

__webpack_require__(113);

__webpack_require__(6);

__webpack_require__(66);

__webpack_require__(91);

__webpack_require__(37);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _lodash = __webpack_require__(13);

var _iconsData = _interopRequireDefault(__webpack_require__(518));

var _colors = _interopRequireDefault(__webpack_require__(519));

var _ = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var Icon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(Icon, _React$PureComponent);

  function Icon() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = Icon.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        ariaLabel = _this$props.ariaLabel,
        buttonClassName = _this$props.buttonClassName,
        color = _this$props.color,
        className = _this$props.className,
        description = _this$props.description,
        isAria = _this$props.isAria,
        onClick = _this$props.onClick,
        name = _this$props.name,
        size = _this$props.size,
        title = _this$props.title,
        type = _this$props.type,
        otherProps = _objectWithoutPropertiesLoose(_this$props, ["ariaLabel", "buttonClassName", "color", "className", "description", "isAria", "onClick", "name", "size", "title", "type"]);

    var iconCount = (0, _lodash.uniqueId)();
    var titleId = "icon-title-" + iconCount;
    var descId = description ? "icon-desc-" + iconCount : undefined;

    var consoleHandler = function consoleHandler(message, data) {
      /* eslint-disable no-console */
      switch (message) {
        case 'isAria-warn':
          // TODO(pajeter): remove isAria code with next major release
          console.warn("[@collabui/react] Icon: isAria prop is deprecated and will be removed. Title, description or ariaLabel props should be used to add accessibility.");
          break;

        case 'color-warn':
          console.warn("[@collabui/react] Icon: " + data + " may not exist in the design system," + " please use a color name from http://core.collab-ui.com/styles/colors");
          break;

        case 'color-error':
          console.warn("[@collabui/react] Icon: " + data + " does not exist in the design system," + " please use a color name from http://core.collab-ui.com/styles/colors");
          break;

        case 'name-error':
          console.warn("[@collabui/react] Icon: Icon " + data + " does not exist in the design system." + " Visit http://icons.collab-ui.com for a list of available icons or to request a new icon.");
          break;
      }
      /* eslint-enable no-console */

    };

    var getSize = function getSize() {
      var defaultSize = 16;
      var sizeFromName = Number(name.split('_')[1]);
      return size || sizeFromName || defaultSize;
    };

    var getColorSpec = function getColorSpec(colorObj) {
      return colorObj.hex ? colorObj.hex : colorObj.opacity && isolateRoot(colorObj.variable) === 'white' ? "rgba(255, 255, 255, " + colorObj.opacity / 100 + ")" : "rgba(0, 0, 0, " + colorObj.opacity / 100 + ")";
    };

    var getHexFromJSON = function getHexFromJSON(colorName) {
      for (var _iterator = _colors.default, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var c = _ref;
        var variation = (0, _lodash.find)(c.variations, ['variable', colorName]);
        if (variation) return getColorSpec(variation);
      }

      return consoleHandler('color-error', colorName);
    };

    var isolateRoot = function isolateRoot(str) {
      return (0, _lodash.chain)(str).trimStart('$').split('-').value()[0];
    };

    var formatColor = function formatColor() {
      return color.startsWith('$') ? color : color.endsWith('-base') ? (0, _lodash.trimEnd)(color, '-base') : "$" + color;
    };

    var getColor = function getColor() {
      if (!color) return 'inherit';

      if (color.startsWith('#')) {
        consoleHandler('color-warn', color);
        return color;
      }

      return getHexFromJSON(formatColor());
    };

    var getPaths = function getPaths() {
      var iconName = name.startsWith('icon-') ? name.replace(/^(icon-)/, '') : name;
      return _iconsData.default[iconName] ? _iconsData.default[iconName].map(function (icoPath, index) {
        return _react.default.createElement("path", {
          d: icoPath,
          key: index
        });
      }) : consoleHandler('name-error', iconName);
    };

    var getAriaLabelledBy = function getAriaLabelledBy() {
      if (!isAria) return deprecationWarning(); // TODO(pajeter): remove isAria code with next major release

      if (!ariaLabel) {
        if (title && description) return titleId + " " + descId;
        if (title) return "" + titleId;
        if (description) return "" + descId;
      }

      return null;
    };

    var getAriaLabel = function getAriaLabel() {
      return isAria // TODO(pajeter): remove isAria code with next major release
      && ariaLabel ? ariaLabel : null;
    };

    var deprecationWarning = function deprecationWarning() {
      // TODO(pajeter): remove isAria code with next major release
      consoleHandler('isAria-warn');
    };

    var getIcon = function getIcon() {
      return _react.default.createElement("svg", _extends({
        className: "cui-icon" + ("" + (className && " " + className || '')),
        name: name,
        width: getSize(),
        height: getSize(),
        "aria-labelledby": !onClick ? getAriaLabelledBy() : null,
        "aria-label": !onClick ? getAriaLabel() : null
      }, !onClick && Object.assign({}, otherProps)), isAria // TODO(pajeter): remove isAria code with next major release
      && title && _react.default.createElement("title", {
        id: titleId
      }, title), isAria // TODO(pajeter): remove isAria code with next major release
      && description && _react.default.createElement("desc", {
        id: descId
      }, description), _react.default.createElement("g", {
        fill: getColor(),
        fillRule: "evenodd"
      }, getPaths()));
    };

    return onClick ? _react.default.createElement(_.Button, _extends({
      className: 'cui-button--icon' + ("" + (type && " cui-button--icon-" + type || '')) + ("" + (buttonClassName && " " + buttonClassName || '')),
      ariaLabel: getAriaLabel(),
      ariaLabelledBy: isAria // TODO(pajeter): remove isAria code with next major release
      ? getAriaLabelledBy() : deprecationWarning() // TODO(pajeter): remove isAria code with next major release
      ,
      onClick: onClick
    }, otherProps), getIcon()) : getIcon();
  };

  return Icon;
}(_react.default.PureComponent);

Icon.propTypes = {
  /** @prop Text to display for blindness accessibility features | null */
  ariaLabel: _propTypes.default.string,

  /** @prop Optional Button class name string | '' */
  buttonClassName: _propTypes.default.string,

  /** @prop Optional color css styling | '' */
  color: _propTypes.default.string,

  /** @prop Optional class name string | '' */
  className: _propTypes.default.string,

  /** @prop Icon description text | '' */
  description: _propTypes.default.string,

  /** @prop Depreciated prop that supports accessibility features | true */
  isAria: _propTypes.default.bool,
  // TODO(pajeter): remove isAria code with next major release

  /** @prop Required Icon name */
  name: _propTypes.default.string.isRequired,

  /** @prop Handler invoked by click of the user | null */
  onClick: _propTypes.default.func,

  /** @prop Sets Icon size | null */
  size: _propTypes.default.number,

  /** @prop Sets Icon Title prop | '' */
  title: _propTypes.default.string,

  /** @prop Sets Icon Type | '' */
  type: _propTypes.default.oneOf(['', 'white'])
};
Icon.defaultProps = {
  ariaLabel: null,
  buttonClassName: '',
  color: '',
  className: '',
  description: '',
  isAria: true,
  // TODO(pajeter): remove isAria code with next major release
  onClick: null,
  size: null,
  title: '',
  type: ''
};
Icon.displayName = 'Icon';
var _default = Icon;
/**
* @component icons
* @section default
* @react
*
import { Icon } from '@collabui/react';

export default class IconDefault extends React.PureComponent {

  render() {
    return(
      <div>
        <Icon name='accessories_16' />
        <Icon name='accessories_20' />
        <Icon name='accessories_36' />
        <Icon name='accessories_56' />
      </div>
    );
  }
}
**/

/**
* @component icons
* @section color
* @react
*
import { Icon } from '@collabui/react';

export default class IconColor extends React.PureComponent {

  render() {
    return(
      <div>
        <Icon name='accessories_16' color='blue' />
        <Icon name='accessories_20' color='blue' />
        <Icon name='accessories_36' color='blue' />
        <Icon name='accessories_56' color='blue' />
      </div>
    );
  }
}
**/

/**
* @component icons
* @section white
* @react
*
import { Icon } from '@collabui/react';

export default class Default extends React.PureComponent {

  render() {
    return(
      <div style={{ backgroundColor: 'black', padding: '5px', width: 'fit-content' }}>
        <Icon
          name='clear-active_24'
          ariaLabel='Clear'
          type='white'
          onClick={() => console.log('Icon 36 - clicked')}
        />
      </div>
    );
  }
}
**/

exports.default = _default;

/***/ }),
/* 518 */
/***/ (function(module, exports) {

module.exports = {"4-way-navigation_20":["M10.3535.1465l2.969 2.969c.195.195.195.511 0 .707-.098.097-.226.146-.354.146-.128 0-.256-.049-.353-.146l-2.616-2.615-2.615 2.615c-.195.195-.511.195-.707 0-.195-.196-.195-.512 0-.707l2.969-2.969c.195-.195.512-.195.707 0zm2.2617 16.0312c.195-.195.512-.195.707 0 .195.195.195.512 0 .707l-2.969 2.969c-.097.097-.225.146-.353.146-.128 0-.256-.049-.354-.146l-2.968-2.969c-.196-.195-.196-.512 0-.707.195-.195.511-.195.707 0l2.615 2.615 2.615-2.615zm-8.7929-9.5c.195.195.195.512 0 .707l-2.615 2.615 2.615 2.615c.195.196.195.512 0 .708-.098.097-.226.146-.354.146-.127 0-.255-.049-.353-.146l-2.969-2.969c-.195-.196-.195-.512 0-.707l2.969-2.969c.195-.195.512-.195.707 0zm16.0312 2.9688c.195.195.195.512 0 .707l-2.969 2.969c-.097.097-.225.146-.353.146-.128 0-.256-.049-.354-.146-.195-.196-.195-.512 0-.707l2.615-2.615-2.615-2.616c-.195-.195-.195-.511 0-.707.196-.195.512-.195.707 0l2.969 2.969zM10 10.5c-.07 0-.13-.011-.19-.04-.06-.021-.12-.061-.16-.11-.1-.09-.15-.22-.15-.35 0-.07.01-.13.04-.19.02-.06.06-.121.11-.161.13-.139.35-.189.54-.109.06.02.12.06.16.109.05.04.09.101.11.161.03.06.04.129.04.19 0 .069-.01.13-.04.189-.02.061-.06.121-.11.161-.04.049-.1.089-.16.11-.06.029-.12.04-.19.04z"],"4-way-navigation_24":["M12.3538.1465l3.497 3.497c.195.195.195.512 0 .707-.098.098-.226.147-.353.147-.128 0-.256-.049-.354-.147l-3.144-3.143-3.144 3.143c-.195.195-.511.195-.707 0-.195-.195-.195-.512 0-.707l3.498-3.497c.195-.195.512-.195.707 0zm2.79 19.5029c.195-.195.512-.195.707 0 .195.195.195.512 0 .707l-3.498 3.497c-.195.195-.511.195-.707 0l-3.497-3.497c-.195-.195-.195-.512 0-.707.098-.098.226-.146.354-.146.128 0 .256.048.353.146l3.144 3.144 3.144-3.144zm8.7095-8.0029c.195.195.195.512 0 .707l-3.497 3.497c-.195.195-.512.195-.707 0-.098-.098-.147-.225-.147-.353 0-.128.049-.256.147-.354l3.143-3.143-3.143-3.144c-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0l3.497 3.497zM4.4968 8.5029c0 .128-.049.256-.146.354l-3.144 3.143 3.144 3.144c.195.195.195.511 0 .707-.196.195-.512.195-.708 0l-3.497-3.497c-.195-.196-.195-.512 0-.707l3.497-3.498c.196-.195.512-.195.708 0 .097.098.146.226.146.354zm7.503 3.9971c-.07 0-.13-.011-.19-.04-.06-.021-.12-.061-.16-.11-.1-.09-.15-.21-.15-.35 0-.13.05-.261.15-.351.04-.049.1-.089.16-.109.18-.08.4-.03.55.109.04.04.08.101.1.161.03.06.04.129.04.19 0 .069-.01.13-.04.189-.02.061-.06.121-.1.161-.05.049-.11.089-.17.11-.06.029-.12.04-.19.04z"],"accessibility_16":["M14.584 4.954L10.38 6.016c-.245.062-.405.295-.374.545l.968 7.863c.016.15-.03.292-.129.404-.269.3-.83.144-.9-.269l-.953-5.146c-.044-.237-.259-.409-.5-.409-.241 0-.447.172-.491.409l-.955 5.156c-.065.396-.627.56-.897.259-.099-.112-.145-.254-.129-.397l.968-7.87c.032-.25-.129-.483-.374-.545L2.387 4.949C2.162 4.904 2 4.705 2 4.477c0-.198.11-.317.176-.371.112-.092.261-.126.414-.097l5.373.935-.001-.002c.171.036.348.058.53.058.141 0 .276-.019.409-.041l0 .008 5.502-.958c.005-.001.011-.002.016-.003.139-.029.286.008.398.1.066.054.176.174.176.372 0 .228-.162.426-.409.476M8.492 1c.827 0 1.5.673 1.5 1.5 0 .828-.673 1.5-1.5 1.5-.827 0-1.5-.672-1.5-1.5 0-.827.673-1.5 1.5-1.5m6.959 2.332c-.343-.28-.786-.392-1.221-.308l-3.513.595c.17-.338.275-.714.275-1.119 0-1.38-1.119-2.5-2.5-2.5-1.381 0-2.5 1.12-2.5 2.5 0 .404.105.779.275 1.117l-3.496-.591c-.441-.09-.885.024-1.229.306-.345.283-.542.7-.542 1.146 0 .703.5 1.313 1.166 1.446l3.776.953-.916 7.437c-.047.429.09.859.377 1.181.288.321.701.505 1.132.505.746 0 1.376-.534 1.495-1.259l.467-2.516.464 2.507c.123.735.752 1.268 1.497 1.268.432 0 .844-.184 1.131-.504.288-.322.426-.752.378-1.188l-.915-7.431 3.753-.948c.688-.138 1.188-.749 1.188-1.452 0-.445-.197-.862-.542-1.145"],"accessories_16":["M13 11l0 2c0 .551-.449 1-1 1l-8 0c-.551 0-1-.449-1-1l0-8c0-.551.449-1 1-1l2.592 0c.162 0 .314-.079.408-.211.094-.133.117-.303.063-.456C7.021 3.213 7 3.104 7 3c0-.551.449-1 1-1 .551 0 1 .449 1 1 0 .104-.021.213-.063.333-.054.153-.031.323.063.456.094.132.246.211.408.211L12 4c.551 0 1 .449 1 1l0 2c-.059 0-.115.012-.173.017-.073.006-.146.009-.217.022-.038.008-.073.022-.11.032-.199.051-.384.13-.555.237-.022.014-.047.025-.07.04-.07.048-.131.104-.195.161-.045.04-.089.078-.13.122-.05.053-.094.108-.138.166-.046.061-.088.124-.127.189-.031.054-.062.107-.088.164-.04.084-.071.172-.099.262-.015.048-.033.094-.044.143-.033.144-.054.292-.054.445 0 1.103.897 2 2 2m.333-2.937c.073.026.147.03.218.022.022-.002.04-.01.061-.015.052-.012.1-.03.145-.057.01-.006.022-.006.032-.013.011-.008.016-.022.026-.031.038-.031.069-.068.096-.11.015-.022.029-.042.04-.067.006-.012.016-.02.02-.033.014-.039.013-.078.017-.118.002-.017.012-.032.012-.049L14 5c0-1.103-.897-2-2-2l-2 0c0-1.103-.897-2-2-2-1.103 0-2 .897-2 2L4 3c-1.103 0-2 .897-2 2l0 8c0 1.103.897 2 2 2l8 0c1.103 0 2-.897 2-2l0-2.592c0-.017-.01-.032-.012-.049-.004-.04-.003-.079-.017-.118-.004-.013-.014-.021-.02-.033-.011-.025-.025-.045-.04-.067-.027-.042-.057-.078-.095-.109-.011-.01-.016-.024-.027-.032-.01-.007-.023-.007-.033-.013-.043-.026-.089-.043-.139-.055-.023-.006-.044-.015-.068-.018-.071-.007-.144-.002-.216.023C12.58 10.204 12 9.655 12 9c0-.655.58-1.205 1.333-.937"],"accessories_20":["M16 15c.167 0 .332-.016.495-.043.052-.01.103-.027.155-.039.109-.025.218-.05.324-.087.008-.003.017-.004.026-.007l0 2.676c0 .827-.673 1.5-1.5 1.5l-11 0c-.827 0-1.5-.673-1.5-1.5l0-11C3 5.673 3.673 5 4.5 5l3.511 0c.19 0 .364-.107.448-.277.084-.17.065-.373-.049-.525C8.142 3.844 8 3.429 8 3c0-1.103.897-2 2-2 1.103 0 2 .897 2 2 0 .429-.142.844-.41 1.198-.114.152-.133.355-.049.525.084.17.258.277.448.277L15.5 5c.827 0 1.5.673 1.5 1.5l0 2.676c-.009-.003-.018-.004-.026-.007-.106-.037-.215-.062-.324-.087-.052-.012-.103-.029-.155-.039C16.332 9.016 16.167 9 16 9c-1.654 0-3 1.346-3 3 0 1.654 1.346 3 3 3m0-5c.428 0 .843.142 1.199.411.069.052.147.075.227.087.023.004.044.004.067.004.068.001.133-.011.196-.037.011-.004.023-.001.034-.006.004-.002.005-.006.008-.008.064-.033.122-.077.168-.138.006-.007.007-.018.013-.026.01-.016.015-.033.025-.051.03-.06.047-.123.052-.187.001-.014.011-.024.011-.037L18 6.5C18 5.121 16.878 4 15.5 4l-2.675 0c.115-.319.175-.656.175-1 0-1.654-1.346-3-3-3-1.654 0-3 1.346-3 3 0 .344.06.681.175 1L4.5 4C3.122 4 2 5.121 2 6.5l0 11C2 18.879 3.122 20 4.5 20l11 0c1.378 0 2.5-1.121 2.5-2.5l0-3.512c0-.013-.01-.023-.011-.037-.005-.064-.022-.127-.052-.187-.01-.018-.015-.035-.025-.051-.006-.008-.007-.019-.013-.026-.046-.062-.105-.106-.169-.139-.003-.001-.004-.005-.007-.007-.009-.004-.019-.002-.029-.006-.065-.027-.133-.039-.204-.038-.022 0-.041 0-.062.003-.08.012-.159.036-.229.089-.356.269-.771.411-1.199.411-1.103 0-2-.897-2-2 0-1.103.897-2 2-2"],"accessories_36":["M29.2441 16.5533247l.01 0-.01 0zM6.5001 7.97799002c-1.379 0-2.5 1.12152063-2.5 2.49893188l0 22.0245862c0 1.3774112 1.121 2.4989319 2.5 2.4989319l23 0c1.378 0 2.5-1.1215207 2.5-2.4989319l0-6.9400337c-.632.2848782-1.305.425818-2 .425818-1.51 0-2.924-.6717129-3.879-1.8442117-.954-1.1714993-1.323-2.7078426-1.011-4.2151984.41-1.9841519 2.039-3.5384875 4.053-3.8683465.967-.1559334 1.945-.0379838 2.827.3458521l.01-5.928466c0-1.37741125-1.122-2.49893188-2.5-2.49893188l-6.917 0c-.336 0-.646-.16592908-.829-.44480988-.187-.28487824-.217-.64372486-.08-.96058942.305-.70569837.398-1.49036298.268-2.26603144-.266-1.58032453-1.539-2.90475844-3.095-3.22262258-1.208-.244895322-2.44.04997864-3.375.81365223-.936.76367359-1.472 1.8931908-1.472 3.09867555 0 .54976502.111 1.0825373.329 1.58432282.136.31286627.107.6677146-.078.95059369-.184.27988037-.494.44680903-.831.44680903l-6.92 0zm23 28.02202268l-23 0c-1.93 0-3.5-1.5703288-3.5-3.4985046l0-22.0245862c0-1.92817584 1.57-3.49850464 3.5-3.49850464l6.92 0c-.281-.62673212-.42-1.29444672-.42-1.98215278 0-1.50735572.67-2.91875245 1.839-3.87334444 1.169-.953592409 2.7-1.324433903 4.208-1.017565066 1.983.403827394 3.542 2.026133976 3.881 4.035275226.162.96658685.046 1.94516858-.336 2.8287909l6.908.00899616c1.93 0 3.5 1.5703288 3.5 3.49850464l0 5.9374622c0 .3358564-.167.645724-.446.8286458-.286.1879197-.645.2169073-.963.0789663-.705-.3078685-1.49-.4038274-2.266-.2748826-1.583.2578898-2.914 1.5263476-3.236 3.083682-.25 1.2114822.044 2.4439554.808 3.3815546 1.115 1.3694147 3.097 1.8462109 4.703 1.1415121.314-.1369414.669-.1079538.952.0769671.28.1829219.448.493789.448.830645l0 6.9400337c0 1.9281758-1.57 3.4985046-3.5 3.4985046z"],"accessories_56":["M10 12c-2.206 0-4 1.794-4 4l0 35c0 2.206 1.794 4 4 4l36 0c2.206 0 4-1.794 4-4l0-9.586c-.951.385-1.974.586-3 .586-4.411 0-8-3.589-8-8 0-4.411 3.589-8 8-8 1.026 0 2.049.201 3 .586L50 16c0-2.206-1.794-4-4-4l-11.369 0c-.176 0-.338-.092-.429-.242-.09-.15-.096-.337-.014-.492C34.728 10.248 35 9.149 35 8c0-3.86-3.141-7-7-7-3.86 0-7 3.14-7 7 0 1.149.273 2.248.811 3.266.082.155.077.342-.014.492-.09.15-.253.242-.428.242L10 12zm36 44l-36 0c-2.757 0-5-2.243-5-5l0-35c0-2.757 2.243-5 5-5l10.586 0C20.201 10.049 20 9.026 20 8c0-4.411 3.589-8 8-8 4.411 0 8 3.589 8 8 0 1.026-.201 2.049-.586 3L46 11c2.757 0 5 2.243 5 5l0 11.369c0 .175-.092.338-.242.428-.15.091-.336.097-.491.014C49.263 27.28 48.134 27 47 27c-3.859 0-7 3.141-7 7 0 3.859 3.141 7 7 7 1.134 0 2.263-.28 3.267-.812.155-.081.341-.075.491.014.15.091.242.253.242.429L51 51c0 2.757-2.243 5-5 5z"],"active-speaker_12":["M6.0039 11c-.11 0-.221-.036-.313-.11-.215-.174-.249-.489-.077-.703.894-1.11 1.386-2.597 1.386-4.187 0-1.591-.491-3.078-1.382-4.187-.173-.215-.138-.53.076-.703.217-.172.531-.138.704.077C7.4309 2.473 7.9999 4.182 7.9999 6c0 1.817-.57 3.527-1.606 4.813-.099.123-.244.187-.39.187zM4.5 9.5005c-.106 0-.213-.034-.304-.103-.219-.168-.26-.481-.093-.701.583-.761.892-1.695.897-2.699.005-1.003-.305-1.932-.895-2.687-.169-.217-.13-.532.087-.702.215-.169.532-.132.703.087.728.933 1.111 2.077 1.105 3.307-.006 1.224-.387 2.365-1.103 3.302-.098.129-.247.196-.397.196z"],"active-speaker_16":["M7.4911 14.9995c-.142 0-.283-.06-.382-.177-.178-.211-.152-.526.059-.704 1.8-1.525 2.832-3.755 2.832-6.119 0-2.443-1.001-4.615-2.818-6.114-.213-.176-.243-.491-.068-.704.176-.213.492-.243.704-.068 2.052 1.694 3.182 4.139 3.182 6.886 0 2.658-1.161 5.167-3.186 6.881-.094.08-.209.119-.323.119zm-1.9908-2c-.142 0-.283-.06-.382-.177-.178-.211-.152-.526.059-.704 1.158-.982 1.823-2.483 1.823-4.119 0-1.686-.646-3.147-1.818-4.114-.213-.176-.244-.491-.068-.704.176-.213.491-.243.704-.068 1.407 1.161 2.182 2.896 2.182 4.886 0 1.93-.794 3.709-2.177 4.881-.094.08-.209.119-.323.119z"],"active-speaker_24":["M8.5 19c-.136 0-.271-.056-.37-.164-.186-.204-.17-.521.034-.706C10.02 16.446 11 14.326 11 12c0-2.249-1.009-4.428-2.841-6.134-.202-.188-.213-.505-.025-.707.189-.201.505-.213.707-.025C10.878 7.031 12 9.47 12 12c0 2.616-1.094 4.992-3.164 6.87-.096.087-.216.13-.336.13zm3 3c-.133 0-.266-.053-.364-.157-.19-.201-.18-.518.021-.707C13.636 18.804 15 15.56 15 12c0-3.462-1.403-6.793-3.849-9.14-.199-.19-.206-.506-.014-.706.19-.199.507-.207.706-.014C14.485 4.673 16 8.268 16 12c0 3.838-1.477 7.341-4.157 9.864-.097.091-.22.136-.343.136z"],"active-speaker_32":["M15.115 30c-.128 0-.256-.049-.354-.146-.195-.196-.195-.512 0-.708 3.389-3.388 5.255-8.057 5.254-13.146-.001-5.091-1.866-9.759-5.254-13.146-.195-.196-.195-.512 0-.708.196-.195.512-.195.708 0 3.576 3.577 5.545 8.497 5.546 13.854.001 5.355-1.969 10.275-5.546 13.854-.098.097-.226.146-.354.146zm-3.1148-5c-.128 0-.256-.049-.354-.146-.195-.196-.195-.512 0-.708 4.492-4.492 4.492-11.8 0-16.292-.195-.196-.195-.512 0-.708.196-.195.512-.195.708 0 4.881 4.882 4.881 12.826 0 17.708-.098.097-.226.146-.354.146z"],"active-speaker_48":["M22.5 44.5c-.128 0-.256-.049-.354-.146-.195-.196-.195-.512 0-.708C27.212 38.58 30.001 31.604 30 24c-.001-7.606-2.79-14.583-7.854-19.646-.195-.196-.195-.512 0-.708.196-.195.512-.195.708 0C28.106 8.898 30.999 16.127 31 24c.001 7.87-2.892 15.099-8.146 20.354-.098.097-.226.146-.354.146zm-5.333-6.667c-.119 0-.238-.042-.333-.128-.207-.184-.224-.5-.04-.706 3.338-3.724 5.186-8.342 5.206-13.001.02-4.743-1.827-9.357-5.2-12.991-.187-.202-.175-.519.027-.706.202-.19.518-.177.707.026 3.546 3.82 5.487 8.677 5.466 13.675-.021 4.905-1.96 9.758-5.46 13.665-.1.11-.236.166-.373.166z"],"active-speaker-alert_12":["M1.895 2.6949c.728.934 1.111 2.077 1.105 3.308-.006 1.223-.387 2.364-1.103 3.301-.098.129-.247.196-.397.196-.106 0-.213-.034-.304-.103-.219-.168-.26-.481-.093-.701.583-.761.892-1.694.897-2.699.005-1.003-.305-1.932-.895-2.687-.169-.217-.13-.532.087-.702.215-.169.532-.132.703.087zm8.9491 6.6407c.123.207.164.437.141.664-.015.153-.054.305-.136.444-.08.136-.189.243-.311.331-.19.14-.418.225-.668.225l-5.741 0c-.248 0-.475-.084-.665-.223-.011-.007-.017-.02-.028-.029-.015.021-.026.045-.042.064-.099.124-.244.188-.39.188-.11 0-.221-.036-.313-.11-.215-.174-.249-.489-.077-.703.193-.24.359-.505.514-.778.012-.024.014-.051.028-.074l.111-.187c.471-.931.733-2.01.733-3.148 0-1.591-.491-3.078-1.382-4.188-.173-.214-.138-.529.076-.702.217-.173.531-.138.704.077 1.033 1.286 1.602 2.995 1.602 4.813 0 .094-.019.183-.022.276l1.049-1.76c.123-.207.314-.344.527-.426.142-.055.293-.09.446-.09.152 0 .301.035.442.089.215.082.407.219.53.425.001 0 .001.002.001.002l2.871 4.82zm-6.912.664l6.144 0-3.078-5.164-2.86 4.808c-.063.123-.136.238-.206.356zm2.5689-3.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 1c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-1zm.5 2c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5z"],"active-speaker-locked_24":["M2.8413 5.1348c2.037 1.896 3.159 4.336 3.159 6.865 0 2.616-1.094 4.992-3.164 6.87-.096.087-.216.13-.336.13-.136 0-.271-.055-.37-.164-.186-.204-.17-.521.034-.706 1.856-1.683 2.836-3.804 2.836-6.13 0-2.249-1.009-4.427-2.841-6.134-.202-.188-.213-.504-.025-.707.189-.201.505-.212.707-.024zm2.2959-2.9805c.19-.199.507-.207.706-.014 2.642 2.533 4.157 6.127 4.157 9.86 0 3.838-1.477 7.341-4.157 9.864-.097.091-.22.136-.343.136-.133 0-.266-.053-.364-.157-.19-.201-.18-.518.021-.707 2.479-2.332 3.843-5.576 3.843-9.136 0-3.462-1.403-6.793-3.849-9.14-.199-.19-.206-.507-.014-.706zM20 14c1.1 0 2 .9 2 2l0 4c0 1.1-.9 2-2 2l-6 0c-1.1 0-2-.9-2-2l0-4c0-1.1.9-2 2-2l0-1c0-1.65 1.35-3 3-3 1.65 0 3 1.35 3 3l0 1zm1 6l0-4c0-.552-.448-1-1-1l-1 0-4 0-1 0c-.551 0-1 .448-1 1l0 4c0 .552.449 1 1 1l6 0c.552 0 1-.448 1-1zm-6-7l0 1 4 0 0-1c0-1.103-.897-2-2-2-1.103 0-2 .897-2 2zm2.5 5c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0z"],"active-speaker-muted_12":["M11.8535.1465c-.195-.195-.512-.195-.707 0l-3.499 3.499c-.271-.91-.683-1.752-1.25-2.458-.173-.215-.486-.249-.703-.077-.215.173-.249.488-.076.703.595.741.993 1.66 1.204 2.657l-.872.872c-.11-.976-.46-1.884-1.056-2.647-.171-.219-.487-.256-.702-.087-.218.17-.257.485-.087.702.59.755.899 1.684.894 2.687 0 .107-.012.212-.021.317l-4.832 4.832c-.195.195-.195.512 0 .707.098.098.226.147.353.147.128 0 .256-.049.354-.147l6.125-6.125c.004.091.021.179.021.272 0 1.589-.492 3.076-1.385 4.186-.173.215-.139.53.076.703.093.074.203.111.313.111.146 0 .291-.064.39-.187 1.036-1.287 1.606-2.996 1.606-4.813 0-.408-.038-.807-.093-1.199l3.947-3.948c.195-.195.195-.512 0-.707"],"active-speaker-muted_16":["M14.8535 1.1465c-.195-.195-.512-.195-.707 0l-3.698 3.698c-.525-1.445-1.409-2.723-2.63-3.731-.212-.175-.528-.145-.704.068-.175.213-.146.528.067.704 1.204.993 2.04 2.285 2.474 3.752l-1.689 1.688c-.155-1.705-.903-3.184-2.148-4.212-.213-.175-.528-.145-.704.068-.176.213-.146.528.068.704 1.172.967 1.817 2.428 1.817 4.115 0 .104-.009.205-.015.308l-5.838 5.838c-.195.195-.195.512 0 .707.098.098.226.147.353.147.128 0 .256-.049.354-.147l8.053-8.053c.055.392.093.79.093 1.2 0 2.363-1.032 4.593-2.832 6.118-.21.178-.237.493-.058.704.098.117.239.178.382.178.114 0 .228-.04.323-.12 2.024-1.713 3.185-4.223 3.185-6.88 0-.712-.079-1.403-.227-2.066l4.081-4.081c.195-.195.195-.512 0-.707"],"active-speaker-muted_24":["M21.853 2.1465c-.195-.195-.512-.195-.707 0l-5.765 5.765c-.675-2.189-1.887-4.188-3.539-5.771-.198-.193-.515-.185-.706.014-.192.199-.184.515.014.706 1.659 1.591 2.824 3.64 3.411 5.871l-2.599 2.599c-.18-2.288-1.265-4.467-3.122-6.196-.201-.188-.518-.176-.707.025-.188.202-.176.518.025.707 1.832 1.706 2.841 3.884 2.841 6.134 0 .104-.012.206-.016.309l-8.837 8.837c-.195.195-.195.512 0 .707.098.098.226.147.353.147.128 0 .256-.049.354-.147l11.958-11.958c.115.692.188 1.394.188 2.105 0 3.56-1.364 6.804-3.843 9.136-.2.189-.211.506-.021.707.098.104.231.157.364.157.124 0 .247-.045.343-.136 2.68-2.524 4.157-6.027 4.157-9.864 0-1.004-.118-1.997-.33-2.963l6.184-6.184c.195-.195.195-.512 0-.707"],"activities_14":["M8 7c0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1 .552 0 1 .448 1 1zM4 7c0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1 .552 0 1 .448 1 1zm0 4c0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1 .552 0 1 .448 1 1zm0-8c0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1 .552 0 1 .448 1 1zm4 0c0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1 .552 0 1 .448 1 1zm0 8c0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1 .552 0 1 .448 1 1zm4-4c0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1 .552 0 1 .448 1 1zm0 4c0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1 .552 0 1 .448 1 1zm0-8c0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1 .552 0 1 .448 1 1z"],"activities_16":["M3 12c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm5 0c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm5 0c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zM3 7c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm5 0c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm5 0c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zM3 2c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm5 0c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm5 2c-.552 0-1-.448-1-1 0-.552.448-1 1-1 .552 0 1 .448 1 1 0 .552-.448 1-1 1z"],"activities_18":["M3 2c.552 0 1 .448 1 1 0 .553-.448 1-1 1-.552 0-1-.447-1-1 0-.552.448-1 1-1zm12 2c-.552 0-1-.447-1-1 0-.552.448-1 1-1 .552 0 1 .448 1 1 0 .553-.448 1-1 1zM9 2c.552 0 1 .448 1 1 0 .553-.448 1-1 1-.552 0-1-.447-1-1 0-.552.448-1 1-1zM3 8c.552 0 1 .448 1 1 0 .553-.448 1-1 1-.552 0-1-.447-1-1 0-.552.448-1 1-1zm6 0c.552 0 1 .448 1 1 0 .553-.448 1-1 1-.552 0-1-.447-1-1 0-.552.448-1 1-1zm6 0c.552 0 1 .448 1 1 0 .553-.448 1-1 1-.552 0-1-.447-1-1 0-.552.448-1 1-1zM3 14c.552 0 1 .448 1 1 0 .553-.448 1-1 1-.552 0-1-.447-1-1 0-.552.448-1 1-1zm6 0c.552 0 1 .448 1 1 0 .553-.448 1-1 1-.552 0-1-.447-1-1 0-.552.448-1 1-1zm6 0c.552 0 1 .448 1 1 0 .553-.448 1-1 1-.552 0-1-.447-1-1 0-.552.448-1 1-1z"],"activities_20":["M4 3c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm12 2c-.552 0-1-.448-1-1 0-.552.448-1 1-1 .552 0 1 .448 1 1 0 .552-.448 1-1 1zm-6-2c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zM4 9c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm12 0c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm-6 0c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm-6 6c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm12 0c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm-6 0c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1z"],"activities_24":["M5 6c-.55228475 0-1-.44771525-1-1 0-.55228475.44771525-1 1-1 .55228475 0 1 .44771525 1 1 0 .55228475-.44771525 1-1 1zm14 0c-.5522847 0-1-.44771525-1-1 0-.55228475.4477153-1 1-1 .5522847 0 1 .44771525 1 1 0 .55228475-.4477153 1-1 1zm-7 0c-.55228475 0-1-.44771525-1-1 0-.55228475.44771525-1 1-1 .55228475 0 1 .44771525 1 1 0 .55228475-.44771525 1-1 1zm0 14c-.55228475 0-1-.4477153-1-1 0-.5522847.44771525-1 1-1 .55228475 0 1 .4477153 1 1 0 .5522847-.44771525 1-1 1zm7 0c-.5522847 0-1-.4477153-1-1 0-.5522847.4477153-1 1-1 .5522847 0 1 .4477153 1 1 0 .5522847-.4477153 1-1 1zM5 20c-.55228475 0-1-.4477153-1-1 0-.5522847.44771525-1 1-1 .55228475 0 1 .4477153 1 1 0 .5522847-.44771525 1-1 1zm7-7c-.55228475 0-1-.44771525-1-1 0-.55228475.44771525-1 1-1 .55228475 0 1 .44771525 1 1 0 .55228475-.44771525 1-1 1zm7 0c-.5522847 0-1-.44771525-1-1 0-.55228475.4477153-1 1-1 .5522847 0 1 .44771525 1 1 0 .55228475-.4477153 1-1 1zM5 13c-.55228475 0-1-.44771525-1-1 0-.55228475.44771525-1 1-1 .55228475 0 1 .44771525 1 1 0 .55228475-.44771525 1-1 1z"],"activities_28":["M6 5c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm16 2c-.552 0-1-.448-1-1 0-.552.448-1 1-1 .552 0 1 .448 1 1 0 .552-.448 1-1 1zm-8-2c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm-8 8c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm16 0c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm-8 0c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm-8 8c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm16 0c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm-8 0c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1z"],"add_10":["M4.5 4.5l0-1c0-.27614237.22385763-.5.5-.5.27614237 0 .5.22385763.5.5l0 1 1 0c.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5l-1 0 0 1c0 .27614237-.22385763.5-.5.5-.27614237 0-.5-.22385763-.5-.5l0-1-1 0c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5l1 0zM5 10c-2.76142375 0-5-2.23857625-5-5 0-2.76142375 2.23857625-5 5-5 2.76142375 0 5 2.23857625 5 5 0 2.76142375-2.23857625 5-5 5zm0-1c2.209139 0 4-1.790861 4-4 0-2.209139-1.790861-4-4-4-2.209139 0-4 1.790861-4 4 0 2.209139 1.790861 4 4 4z"],"add_12":["M6.5 5.5l2 0c.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5l-2 0 0 2c0 .27614237-.22385763.5-.5.5-.27614237 0-.5-.22385763-.5-.5l0-2-2 0c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5l2 0 0-2c0-.27614237.22385763-.5.5-.5.27614237 0 .5.22385763.5.5l0 2zM6 12c-3.3137085 0-6-2.6862915-6-6 0-3.3137085 2.6862915-6 6-6 3.3137085 0 6 2.6862915 6 6 0 3.3137085-2.6862915 6-6 6zm0-1c2.76142375 0 5-2.23857625 5-5 0-2.76142375-2.23857625-5-5-5-2.76142375 0-5 2.23857625-5 5 0 2.76142375 2.23857625 5 5 5z"],"add_16":["M7.5 7.5l0-2.99956417C7.5 4.22405275 7.73193359 4 8 4c.27614237 0 .5.23079681.5.50043583L8.5 7.5l2.9995642 0C11.7759472 7.5 12 7.73193359 12 8c0 .27614237-.2307968.5-.5004358.5L8.5 8.5l0 2.9995642C8.5 11.7759472 8.26806641 12 8 12c-.27614237 0-.5-.2307968-.5-.5004358L7.5 8.5l-2.99956417 0C4.22405275 8.5 4 8.26806641 4 8c0-.27614237.23079681-.5.50043583-.5L7.5 7.5zM8 0c4.411 0 8 3.589 8 8 0 4.411-3.589 8-8 8-4.411 0-8-3.589-8-8 0-4.411 3.589-8 8-8zm0 15c3.86 0 7-3.14 7-7 0-3.86-3.14-7-7-7-3.86 0-7 3.14-7 7 0 3.86 3.14 7 7 7z"],"add_20":["M10 0c5.523 0 10 4.477 10 10 0 5.523-4.477 10-10 10-5.523 0-10-4.477-10-10C0 4.477 4.477 0 10 0zm0 19c4.963 0 9-4.037 9-9 0-4.963-4.037-9-9-9-4.963 0-9 4.037-9 9 0 4.963 4.037 9 9 9zm4.4849-9.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-3.985 0 0 4c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-4-4 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l4 0 0-4c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 4 3.985 0z"],"add_24":["M12 0c6.617 0 12 5.383 12 12 0 6.617-5.383 12-12 12-6.617 0-12-5.383-12-12C0 5.383 5.383 0 12 0zm0 23c6.065 0 11-4.935 11-11 0-6.065-4.935-11-11-11C5.935 1 1 5.935 1 12c0 6.065 4.935 11 11 11zm5.5-11.5c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-5 0 0 5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-5-5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l5 0 0-5c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 5 5 0z"],"add-option_12":["M5.7806 4.934c-.189.353-.263.724-.306 1.007L5.4666 6l-.959 0 0-1.5c0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5l0 1.5-.959 0-.009-.059c-.043-.283-.116-.654-.305-1.007-.179-.333-.348-.874-.141-1.557.191-.629.726-1.141 1.362-1.306.18-.047.364-.071.546-.071l.005 0 .002 0c.199.018.369.024.551.071.636.165 1.171.677 1.362 1.306.207.683.038 1.224-.141 1.557zM5.1636 8l-2.312 0-.151-1 2.614 0-.151 1zm-.268 1.296c-.086.408-.455.704-.897.704-.424 0-.794-.296-.88-.707L3.0556 9l1.904 0-.064.296zM10.4986 8l-1.5 0 0-1.5c0-.275-.225-.5-.5-.5-.275 0-.5.225-.5.5l0 1.5-1.5 0c-.135 0-.256.055-.346.142l.311-2.05c.046-.304.107-.515.199-.686.378-.706.455-1.53.216-2.32-.295-.969-1.087-1.729-2.067-1.983-.264-.069-.533-.066-.804-.103-.262.042-.54.034-.804.103-.981.254-1.772 1.015-2.067 1.983-.239.789-.163 1.613.216 2.32.092.171.153.382.199.685l.35 2.301.239 1.109c.182.869.963 1.499 1.875 1.499.895 0 1.677-.63 1.858-1.496l.172-.799c.079.173.252.295.453.295l1.5 0 0 1.5c0 .275.225.5.5.5.275 0 .5-.225.5-.5l0-1.5 1.5 0c.275 0 .5-.225.5-.5 0-.275-.225-.5-.5-.5z"],"add-option_14":["M10.5000774 7.00102571C12.4330347 7.00102571 14 8.5677961 14 10.5005129 14 12.4332296 12.4330347 14 10.5000774 14c-1.63196387 0-2.99093381-1.1218356-3.37892522-2.6326142l-.09199797.4379358-.03199929.1509779C6.75016039 13.1391262 5.68218401 14 4.45821109 14c-1.22397292 0-2.2919493-.8608738-2.53994381-2.0476999l-.86298091-4.1493919c-.07499834-.36794608-.181995973-.65690373-.328992721-.88187076C.0433087581 5.87419085-.166686596 4.62437402.133306767 3.40155322.536297852 1.75679427 1.85426869.463983731 3.49223246.107036043c1.3649698-.294956774 2.76093892.02599619 3.82691534.88487032C8.38712417 1.85178035 8.99811065 3.12859323 8.99811065 4.49739263c0 .90186783-.27599389 1.77773947-.79898232 2.53362869-.16299639.23396571-.27999381.53792116-.35899206.92886387l-.08199818.38994285c.63998584-.81488057 1.62396407-1.34880233 2.74193931-1.34880233zm0 5.99912079c1.3779695 0 2.4999447-1.1208357 2.4999447-2.4996336 0-1.37879798-1.1219752-2.49963372-2.4999447-2.49963372-1.37796949 0-2.49994467 1.12083574-2.49994467 2.49963372 0 1.3787979 1.12197518 2.4996336 2.49994467 2.4996336zM6.85915797 7.7619142c.10799761-.52792263.27699388-.95286035.51798854-1.30080936.40599102-.58691399.62098627-1.26581449.62098627-1.96371221 0-1.06384409-.47598947-2.0586983-1.30597111-2.72660041C6.06517554 1.26586621 5.29119266.999905191 4.4892104.999905191c-.25999424 0-.52198845.027995899-.78398265.084987549-1.24797239.27096029-2.29294928 1.2978098-2.60194244 2.55462561-.297993409 1.21882138.08499812 2.16068335.45998982 2.73559909.2169952.33295121.37199177.7348923.47198956 1.22881992l.28999359 1.39679529 1.68196279 0 0-3.49948714c0-.27595956.22299506-.49992673.49998894-.49992673.27599389 0 .49998893.22396717.49998893.49992673l0 3.49948714 1.59196479 0 .25999424-1.23881845zm-.68198491 3.2385254l.21099533-.9998535-3.85491472 0 .2079954.9998535 3.43592399 0zm-1.71896197 1.9997069c.65798544 0 1.22097299-.4129395 1.45896772-.9998534l-2.91793544 0c.23899471.5879138.80198225.9998534 1.45896772.9998534zm7.04184421-2.9995604c.2749939 0 .4999889.2249671.4999889.4999268 0 .2749597-.224995.4999267-.4999889.4999267l-.4999889 0 0 .4999267c0 .2749597-.2249951.4999268-.499989.4999268-.2749939 0-.4999889-.2249671-.4999889-.4999268l0-.4999267-.49998895 0c-.27499392 0-.49998894-.224967-.49998894-.4999267 0-.2749597.22499502-.4999268.49998894-.4999268l.49998895 0 0-.49992671c0-.27495971.224995-.49992674.4999889-.49992674.2749939 0 .499989.22496703.499989.49992674l0 .49992671.4999889 0z"],"add-option_16":["M11.4984 7c2.485 0 4.5 2.015 4.5 4.5 0 2.485-2.015 4.5-4.5 4.5-2.38 0-4.309-1.854-4.469-4.193l-.032.151c-.247 1.183-1.315 2.044-2.539 2.044-1.224 0-2.292-.861-2.54-2.048l-.863-4.15c-.075-.368-.182-.657-.329-.882-.683-1.047-.893-2.297-.593-3.52.403-1.645 1.721-2.938 3.359-3.295 1.365-.295 2.761.026 3.827.885 1.068.86 1.679 2.137 1.679 3.506 0 .902-.276 1.778-.799 2.534-.163.234-.28.538-.359.929l-.307 1.452C8.2884 7.984 9.7704 7 11.4984 7zm0 8c1.93 0 3.5-1.57 3.5-3.5 0-1.93-1.57-3.5-3.5-3.5-1.93 0-3.5 1.57-3.5 3.5 0 1.93 1.57 3.5 3.5 3.5zm1.5-4c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0 0 1c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-1-1 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0 0-1c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 1 1 0zm-6.139-3.237c.108-.528.277-.953.518-1.301.406-.587.621-1.266.621-1.964 0-1.064-.476-2.059-1.306-2.727C6.0654 1.266 5.2914 1 4.4894 1c-.26 0-.522.028-.784.085-1.248.271-2.293 1.298-2.602 2.555-.298 1.219.085 2.161.46 2.736.217.333.372.735.472 1.229l.29 1.397 1.682 0 0-3.5c0-.276.223-.5.5-.5.276 0 .5.224.5.5l0 3.5 1.592 0 .26-1.239zm-.682 3.239l.211-1-3.855 0 .208 1 3.436 0zm-1.719 2c.658 0 1.221-.413 1.459-1l-2.918 0c.239.588.802 1 1.459 1z"],"add-poll_12":["M1 10l1 0 0-5-1 0 0 5zm1-6c.552 0 1 .447 1 1l0 5c0 .553-.448 1-1 1l-1 0c-.552 0-1-.447-1-1l0-5c0-.553.448-1 1-1l1 0zm3.5 2c.552 0 1 .447 1 1l0 3c0 .553-.448 1-1 1l-1 0c-.552 0-1-.447-1-1l0-3c0-.553.448-1 1-1l1 0zm-1 4l1 0 0-3-1 0 0 3zm7-2c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L10 9l0 1.5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5L9 9 7.5 9c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5L9 8l0-1.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5L10 8l1.5 0zm-4-1c-.275 0-.5-.225-.5-.5l0-1 0-.001L7 2c0-.553.448-1 1-1l1 0c.552 0 1 .447 1 1l0 2.5c0 .275-.226.5-.5.5-.275 0-.5-.225-.5-.5L9 2 8 2l0 4 0 .5c0 .275-.226.5-.5.5z"],"add-poll_14":["M2.5 3C3.3 3 4 3.7 4 4.5v8c0 .8-.7 1.5-1.5 1.5h-1C.7 14 0 13.3 0 12.5v-8C0 3.7.7 3 1.5 3h1zm.5 9.5v-8c0-.3-.2-.5-.5-.5h-1c-.3 0-.5.2-.5.5v8c0 .3.2.5.5.5h1c.3 0 .5-.2.5-.5zM12.5 0c.8 0 1.5.7 1.5 1.5v9c0 1.9-1.6 3.5-3.5 3.5-.7 0-1.3-.2-1.9-.6-.2.4-.6.6-1.1.6h-1c-.8 0-1.5-.7-1.5-1.5v-5C5 6.7 5.7 6 6.5 6h1c.8 0 1.4.6 1.5 1.4.3-.2.7-.3 1-.3V1.5c0-.8.7-1.5 1.5-1.5h1zm.5 8.1V1.5c0-.3-.2-.5-.5-.5h-1c-.3 0-.5.2-.5.5v5.6c.8.1 1.5.4 2 1zM10.5 13c1.4 0 2.5-1.1 2.5-2.5S11.9 8 10.5 8 8 9.1 8 10.5 9.1 13 10.5 13zm-3 0c.2 0 .3-.1.4-.2-.6-.6-.9-1.4-.9-2.3 0-1 .4-1.8 1-2.4v-.6c0-.3-.2-.5-.5-.5h-1c-.3 0-.5.2-.5.5v5c0 .3.2.5.5.5h1zm4-3c.3 0 .5.2.5.5 0 .3-.2.5-.5.5H11v.5c0 .3-.2.5-.5.5-.3 0-.5-.2-.5-.5V11h-.5c-.3 0-.5-.2-.5-.5 0-.3.2-.5.5-.5h.5v-.5c0-.3.2-.5.5-.5.3 0 .5.2.5.5v.5h.5z"],"add-question_12":["M7 4.1401c0 1.399-.763 2.068-1.321 2.557-.099.087-.197.172-.287.26l-.427.41c-.282.273-.458.707-.458 1.133 0 .276-.223.5-.5.5-.276 0-.5-.224-.5-.5 0-.698.286-1.392.764-1.853l.426-.41c.101-.097.211-.194.323-.292.526-.461.98-.859.98-1.805l0-.14c0-1.103-.897-2-2-2-1.103 0-2 .897-2 2 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-1.654 1.346-3 3-3 1.654 0 3 1.346 3 3l0 .14zM4 10c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm6.5-2c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L9 9l0 1.5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5L8 9 6.5 9c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5L8 8l0-1.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5L9 8l1.5 0z"],"add-question_14":["M10.4995 6.9998c1.933 0 3.5 1.567 3.5 3.5 0 1.933-1.567 3.5-3.5 3.5-1.933 0-3.5-1.567-3.5-3.5 0-1.933 1.567-3.5 3.5-3.5zm0 6c1.378 0 2.5-1.121 2.5-2.5 0-1.379-1.122-2.5-2.5-2.5-1.378 0-2.5 1.121-2.5 2.5 0 1.379 1.122 2.5 2.5 2.5zm1-3c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-.5 0 0 .5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-.5-.5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l.5 0 0-.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 .5.5 0zm-7.6997 3.04c.18-.08.4-.03.54.109.1.091.15.221.15.351 0 .14-.05.26-.15.35-.09.1-.22.15-.35.15-.13 0-.26-.05-.36-.15-.09-.09-.14-.22-.14-.35 0-.13.05-.26.14-.351.05-.049.11-.089.17-.109zM4.1035.0013c2.112.061 3.896 1.903 3.896 4.025 0 1.801-.992 2.631-1.79 3.298-.142.118-.28.234-.409.353l-.596.548c-.441.405-.694.983-.694 1.582l0 .693c0 .276-.224.5-.5.5-.277 0-.5-.224-.5-.5l0-.693c0-.878.37-1.723 1.017-2.318l.596-.548c.139-.129.29-.255.444-.384.737-.616 1.432-1.198 1.432-2.531 0-1.595-1.339-2.98-2.924-3.025-.809-.027-1.557.272-2.132.832-.609.591-.944 1.399-.944 2.274 0 .277-.223.5-.5.5-.276 0-.5-.223-.5-.5 0-1.148.443-2.21 1.247-2.991.771-.75 1.783-1.142 2.857-1.115z"],"add-question_16":["M5 12.4984c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5zm-.5-1.5c-.276 0-.5-.224-.5-.5 0-1.406.82-2.707 2.089-3.314 1.356-.649 2.119-2.103 1.827-3.465-.297-1.305-1.331-2.34-2.585-2.626-1.074-.244-2.172-.002-3.012.667C1.481 2.4294 1 3.4274 1 4.4984c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-1.377.618-2.661 1.696-3.52 1.078-.861 2.483-1.172 3.858-.86 1.645.376 2.951 1.681 3.326 3.326.401 1.874-.591 3.796-2.344 4.635C5.597 8.5284 5 9.4754 5 10.4984c0 .276-.224.5-.5.5zM11.5 16C9.01471863 16 7 13.9852814 7 11.5 7 9.01471863 9.01471863 7 11.5 7c2.4852814 0 4.5 2.01471863 4.5 4.5 0 2.4852814-2.0147186 4.5-4.5 4.5zm0-1c1.9329966 0 3.5-1.5670034 3.5-3.5C15 9.56700338 13.4329966 8 11.5 8 9.56700338 8 8 9.56700338 8 11.5c0 1.9329966 1.56700338 3.5 3.5 3.5zm1.5-4c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0 0 1c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-1-1 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0 0-1c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 1 1 0z"],"add-video-marker_12":["M9.5 0c.825 0 1.5.675 1.5 1.5l0 5.959c0 .608-.276 1.184-.75 1.562l-3.313 2.651C6.663 11.891 6.332 12 6 12c-.332 0-.663-.109-.937-.328L1.75 9.021C1.276 8.643 1 8.067 1 7.459L1 1.5C1 .675 1.675 0 2.5 0l7 0zm.5 7.459L10 1.5c0-.271-.229-.5-.5-.5l-7 0c-.271 0-.5.229-.5.5l0 5.959c0 .307.137.591.375.781l3.313 2.651c.113.089.232.109.312.109.08 0 .199-.02.312-.109L9.625 8.24c.238-.19.375-.474.375-.781zM8 4c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L6.5 5l0 1.5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-1.5L4 5c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1.5 0 0-1.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 1.5L8 4z"],"added-to-space_10":["M1.4651213 1.46392567C3.14926073-.219680696 5.80448057-.483775812 7.77864401.841701569c.23001904.153055124.2910241.464167171.13801143.693249681-.15401275.2290825-.4650385.29010448-.69405747.13704936-1.57913073-1.058381187-3.7033066-.848305526-5.05041813.49917978-.7560626.75527202-1.17209704 1.76063411-1.17209704 2.82901889 0 1.06938515.41603444 2.07374688 1.17209704 2.8290189 1.34211112 1.34348386 3.46128657 1.5565606 5.03941722.50718266.23101913-.15405548.5410448-.09103278.69305738.14005044.15401275.22908251.09100754.54019456-.13901151.69224932C6.92657347 9.727902 5.9654939 10 5.00841466 10c-1.29410714 0-2.57921354-.49817942-3.54329336-1.4635271C.520043056 7.59213279 0 6.33668063 0 5.00019928c0-1.33648134.520043056-2.5919335 1.4651213-3.53627361zm2.12234779 3.89010105c-.04600381-.04601658-.08300687-.10203675-.10800894-.16205837-.05100422-.12304431-.05100422-.26009367 0-.38313799.02500207-.06002162.06200513-.11604179.10800894-.16205837l2.0001656-2.00072057c.19501615-.19507026.51104231-.19507026.70705854 0 .19501615.19507026.19501615.51218447 0 .70725472L5.14759826 4.49971903l4.35236034 0c.27602285 0 .5000414.22408071.5000414.50018015 0 .2770998-.22401855.50018014-.5000414.50018014l-4.35236034 0 1.14709497 1.14741325c.19501615.19507025.19501615.51218447 0 .70725472-.09800811.09803531-.22601871.1460526-.35402931.1460526-.1280106 0-.2560212-.04801729-.35302923-.1460526l-2.0001656-2.00072057z"],"added-to-space_12":["M1.75715375 1.76427766c2.20019252-2.196506939 5.66649582-2.361244959 8.0617054-.38638554.21301865.17671897.24302125.49022041.06600578.70288222-.17501532.21366022-.49104297.244611-.70306152.06789204C7.18662883.501286171 4.29837611.640065473 2.46421562 2.47015512c-.94408261.94250116-1.46412811 2.19550853-1.46412811 3.52938729 0 1.33387876.5200455 2.58688612 1.46412811 3.52938728 1.83416049 1.83108811 4.72141312 1.96986741 6.71758779.32248716.21301864-.17572056.52904629-.1467666.7040616.06689362.17601539.21266183.14601279.52616323-.06700586.70288223C8.69976123 11.544724 7.34764292 12 6.00052505 12c-1.53813459 0-3.07126874-.5940553-4.2433713-1.7651928C.624054605 9.10460449 0 7.59999723 0 5.99954241c0-1.59945642.624054605-3.10406368 1.75715375-4.23526475zm2.58910886 4.588503c-.04600403-.04592697-.08300727-.10183805-.10800945-.16174279-.05100447-.1228047-.05100447-.25958718 0-.38239189.02500218-.05990473.06200542-.11581582.10800945-.16174278l2.00017501-1.99682449c.19501707-.19469039.51104472-.19469039.70706187 0 .19501706.19469039.19501706.51118707 0 .70587746L5.90639912 5.5001366l5.58748888 0c.2760242 0 .5000438.22364434.5000438.49920612 0 .2765602-.2240196.49920613-.5000438.49920613l-5.58748888 0 1.14710037 1.14517884c.19501706.19469039.19501706.51118707 0 .70587746-.09800858.0978444-.22601978.14576819-.35403098.14576819-.1280112 0-.2560224-.04792379-.35303089-.14576819L4.34626261 6.35278066z"],"adjust_12":["M8.08535285 9L.5 9C.223857625 9 0 8.77614237 0 8.5c0-.27614237.223857625-.5.5-.5l7.58535285 0C8.29127106 7.41740381 8.84689059 7 9.5 7c.6531094 0 1.2087289.41740381 1.4146471 1L11.5 8c.2761424 0 .5.22385763.5.5 0 .27614237-.2238576.5-.5.5l-.5853529 0c-.2059182.58259619-.7615377 1-1.4146471 1-.65310941 0-1.20872894-.41740381-1.41464715-1zm-7-5L.5 4C.223857625 4 0 3.77614237 0 3.5c0-.27614237.223857625-.5.5-.5l.58535285 0C1.29127106 2.417403814 1.84689059 2 2.5 2c.65310941 0 1.20872894.417403814 1.41464715 1L11.5 3c.2761424 0 .5.22385763.5.5 0 .27614237-.2238576.5-.5.5L3.91464715 4C3.70872894 4.58259619 3.15310941 5 2.5 5c-.65310941 0-1.20872894-.41740381-1.41464715-1zM2.5 4c.27614237 0 .5-.22385763.5-.5 0-.27614237-.22385763-.5-.5-.5-.27614237 0-.5.22385763-.5.5 0 .27614237.22385763.5.5.5zm7 5c.27614237 0 .5-.22385763.5-.5 0-.27614237-.22385763-.5-.5-.5-.27614237 0-.5.22385763-.5.5 0 .27614237.22385763.5.5.5z"],"adjust_14":["M3.50039997 3c.27498953 0 .49998096.225.49998096.5 0 .275-.22499143.5-.49998096.5-.27498952 0-.49998095-.225-.49998095-.5 0-.275.22499143-.5.49998095-.5M.500514249 4c-.276989448 0-.4999809538-.224-.4999809538-.5 0-.276.2229915058-.5.4999809538-.5L2.108453 3c.20799207-.578.74297169-1 1.39194697-1 .65197517 0 1.20195421.419 1.40794637 1L13.500019 3C13.7760085 3 14 3.224 14 3.5c0 .276-.2239915.5-.499981.5L4.90834634 4c-.20599216.581-.7559712 1-1.40794637 1-.64897528 0-1.1839549-.422-1.39194697-1L.500514249 4zm9.998619151 7.0039c.2759894 0 .4999809-.224.4999809-.5 0-.275-.2239915-.5-.4999809-.5-.2749896 0-.49998099.225-.49998099.5 0 .276.22499139.5.49998099.5zm3.0008856-1c.2759895 0 .499981.225.499981.5 0 .277-.2239915.5-.499981.5l-1.6079387 0c-.2079921.578-.7429717 1-1.3929469 1-.6519752 0-1.20095429-.418-1.4079464-1l-8.591672713 0c-.275989486 0-.4999809537-.223-.4999809537-.5 0-.275.2239914677-.5.4999809537-.5l8.591672713 0c.20699211-.581.7559712-1 1.4079464-1 .6499752 0 1.1849548.423 1.3929469 1l1.6079387 0z"],"adjust_16":["M3.5 4c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5m-3 1C.225 5 0 4.775 0 4.5c0-.275.225-.5.5-.5l1.592 0c.206-.581.756-1 1.408-1 .652 0 1.202.419 1.408 1L15.5 4c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L4.908 5c-.206.581-.756 1-1.408 1-.652 0-1.202-.419-1.408-1L.5 5zm12 7c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5 0 .276.224.5.5.5zm3-1c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1.592 0c-.206.581-.756 1-1.408 1-.652 0-1.202-.419-1.408-1L.5 12c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l10.592 0c.206-.581.756-1 1.408-1 .652 0 1.202.419 1.408 1l1.592 0z"],"adjust_20":["M4.49977501 7c-.82695865 0-1.499925-.673-1.499925-1.5 0-.827.67296635-1.5 1.499925-1.5.82695865 0 1.499925.673 1.499925 1.5 0 .827-.67296635 1.5-1.499925 1.5M19.499025 5c.2769862 0 .499975.224.499975.5 0 .276-.2229888.5-.499975.5L6.94865257 6c-.2319884 1.141-1.24093796 2-2.44887756 2-1.2079396 0-2.21688915-.859-2.44887755-2L.499975001 6C.225988701 6 0 5.775 0 5.5c0-.275.225988701-.5.499975001-.5L2.05089746 5c.2319884-1.141 1.24093795-2 2.44887755-2 1.2079396 0 2.21688916.859 2.44887756 2L19.499025 5zM.500974951 15c-.27698615 0-.499975001-.224-.499975001-.5 0-.276.222988851-.5.499975001-.5L13.0513474 14c.2319884-1.141 1.240938-2 2.4488776-2 1.2079396 0 2.2168891.859 2.4488775 2l1.5509225 0c.2739863 0 .499975.225.499975.5 0 .275-.2259887.5-.499975.5l-1.5509225 0c-.2319884 1.141-1.2409379 2-2.4488775 2-1.2079396 0-2.2168892-.859-2.4488776-2L.500974951 15zM15.500225 13c-.8269587 0-1.499925.673-1.499925 1.5 0 .827.6729663 1.5 1.499925 1.5.8269586 0 1.499925-.673 1.499925-1.5 0-.827-.6729664-1.5-1.499925-1.5z"],"adjust_24":["M.5 7C.224 7 0 6.776 0 6.5c0-.276.224-.5.5-.5l2.551 0C3.283 4.86 4.292 4 5.5 4c1.208 0 2.217.86 2.449 2L23.5 6c.276 0 .5.224.5.5 0 .276-.224.5-.5.5L7.949 7C7.717 8.14 6.708 9 5.5 9c-1.208 0-2.217-.86-2.449-2L.5 7zm5-2C4.673 5 4 5.673 4 6.5 4 7.327 4.673 8 5.5 8 6.327 8 7 7.327 7 6.5 7 5.673 6.327 5 5.5 5zm18 12c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-2.551 0c-.232 1.14-1.241 2-2.449 2-1.208 0-2.217-.86-2.449-2L.5 18c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l15.551 0c.232-1.14 1.241-2 2.449-2 1.208 0 2.217.86 2.449 2l2.551 0zm-5 2c.827 0 1.5-.673 1.5-1.5 0-.827-.673-1.5-1.5-1.5-.827 0-1.5.673-1.5 1.5 0 .827.673 1.5 1.5 1.5z"],"adjust-audio_16":["M8.547.0566c.275.114.453.381.453.678l0 14.531c0 .299-.178.563-.453.678-.092.039-.187.056-.282.056-.191 0-.378-.075-.519-.216l-4.481-4.784-1.265 0c-1.102 0-2-.896-2-2l0-2c0-1.101.898-2 2-2l1.265 0 4.47-4.771c.004-.004.007-.009.011-.013.211-.211.525-.274.801-.159zM8 14.5926l0-13.186-4.154 4.435c-.094.102-.226.158-.365.158l-1.481 0c-.551 0-1 .448-1 1l0 2c0 .552.449 1 1 1l1.481 0c.139 0 .271.059.365.158L8 14.5926zm3.5-4.5928c.276 0 .5-.225.5-.5 0-.275-.224-.5-.5-.5-.276 0-.5.225-.5.5 0 .275.224.5.5.5zm.5-1.908c.581.207 1 .756 1 1.408 0 .828-.672 1.5-1.5 1.5-.828 0-1.5-.672-1.5-1.5 0-.652.419-1.201 1-1.408l0-2.592c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 2.592zm2.5-1.092c.276 0 .5-.225.5-.5 0-.275-.224-.5-.5-.5-.276 0-.5.225-.5.5 0 .275.224.5.5.5zm1.5-.5c0 .652-.419 1.201-1 1.408l0 2.592c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-2.592c-.581-.207-1-.756-1-1.408 0-.828.672-1.5 1.5-1.5.828 0 1.5.672 1.5 1.5z"],"adjust-audio_20":["M18.5005248 7.00006301c.2759035 0 .4998251-.224.4998251-.5 0-.276-.2239216-.5-.4998251-.5-.2759034 0-.499825.224-.499825.5 0 .276.2239216.5.499825.5zm1.4994752-.5c0 .652-.4188534 1.202-.9996501 1.408l0 7.59199999c0 .276-.2239216.5-.4998251.5-.2759034 0-.499825-.224-.499825-.5l0-7.59199999c-.5807968-.206-.9996502-.756-.9996502-1.408 0-.829.6707653-1.5 1.4994752-1.5.82871 0 1.4994752.671 1.4994752 1.5zM11.5109712.0609630143c.2988953.1229999997.4918278.4119999997.4918278.7349999997l0 18.405999986c0 .323-.1929325.613-.4918278.736-.0989654.041-.202929.061-.305893.061-.2069276 0-.4098565-.081-.562803-.234l-5.76298295-5.766-2.59909032 0c-1.25556055 0-2.2792022799-1.022-2.28020193-2.279l0-3.44199999c.0009996501-1.255 1.02464138-2.279 2.28020193-2.279l2.59909032 0L10.6432749.232963014c.2279202-.2289999997.5688009-.2949999997.8676963-.1719999997zM11.0031489 18.710963l0-17.42399999-5.56405258 5.566c-.09396712.093-.22092268.146-.3528765.146l-2.80601789 0c-.70575299 0-1.280551808.575-1.280551808 1.281l0 3.43799999c0 .706.574798818 1.281 1.280551808 1.281l2.80601789 0c.13295347 0 .25990903.053.35387615.147l5.56305293 5.565zm3.4987754-4.7109c.2759035 0 .4998251-.224.4998251-.5 0-.276-.2239216-.5-.4998251-.5-.2759034 0-.499825.224-.499825.5 0 .276.2239216.5.499825.5zm.4998251-1.908c.5807967.206.9996501.756.9996501 1.408 0 .829-.6707652 1.5-1.4994752 1.5-.8287099 0-1.4994752-.671-1.4994752-1.5 0-.652.4188534-1.202.9996502-1.408l0-7.59199999c0-.276.2239216-.5.499825-.5.2759035 0 .4998251.224.4998251.5l0 7.59199999z"],"adjust-audio_24":["M16.998 16.4932c0 .271.229.5.5.5.271 0 .5-.229.5-.5 0-.271-.229-.5-.5-.5-.271 0-.5.229-.5.5zm2 0c0 .824-.675 1.5-1.5 1.5-.825 0-1.5-.676-1.5-1.5 0-.649.42-1.2 1-1.407l0-7.593c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 7.593c.58.207 1 .758 1 1.407zm4 1c0 .274-.225.5-.5.5-.275 0-.5-.226-.5-.5l0-7.593c-.58-.208-1-.759-1-1.407 0-.825.675-1.5 1.5-1.5.825 0 1.5.675 1.5 1.5 0 .648-.42 1.199-1 1.407l0 7.593zm-1-9c0 .271.229.5.5.5.271 0 .5-.229.5-.5 0-.271-.229-.5-.5-.5-.271 0-.5.229-.5.5zm-9.521-7.4368c.316.133.521.439.521.78l0 20.319c0 .343-.205.647-.521.78-.105.043-.215.065-.323.065-.22 0-.435-.086-.596-.248l-6.63-6.759-2.428 0c-1.381 0-2.5-1.12-2.5-2.5l0-3c0-1.381 1.119-2.5 2.5-2.5l2.427 0 6.626-6.747.005-.005c.242-.243.602-.315.919-.185zm-.479 20.717l0-19.553-6.502 6.62c-.094.097-.224.153-.358.153l-2.638 0c-.827 0-1.5.673-1.5 1.5l0 3c0 .827.673 1.5 1.5 1.5l2.638 0c.134 0 .262.053.356.149l6.504 6.631z"],"adjust-audio_28":["M14.451 1.0688436903c.333.1382879897.549.4609599657.549.8227133297l0 24.21643158c0 .3627555-.216.6854274-.549.8237154-.11.046096-.226.0681419-.341.0681419-.231 0-.457-.0901878-.628-.2615446L5.968 18.984153l-3.128 0c-1.563 0-2.833-1.2726504-2.833-2.8389122L0 11.8001921c0-1.56626179 1.271-2.8409163 2.833-2.8409163l3.13 0 7.516-7.694023081.003-.003006261c.254-.2555321544.636-.3336949311.969-.1934027677zM14 25.8344189l0-23.67029425-7.47 7.646925c-.093.09620034-.222.15031303-.357.15031303l-3.34 0c-1.011 0-1.833.82371542-1.833 1.83782732l.007 4.3450487c0 1.014112.822 1.8378274 1.833 1.8378274l3.34 0c.134 0 .264.0551148.358.1513151L14 25.8344189zm6-10.8098118c1.141.231482 2 1.2425877 2 2.4541107 0 1.2125252-.859 2.2226287-2 2.4551129l0 1.5532347c0 .2755739-.225.5010434-.5.5010434-.275 0-.5-.2254695-.5-.5010434l0-1.5532347c-1.141-.2324842-2-1.2425877-2-2.4551129 0-1.211523.859-2.2226287 2-2.4541107l0-8.56884496c0-.27557389.225-.50104344.5-.50104344.275 0 .5.22546955.5.50104344l0 8.56884496zm-.199 3.9271785c.695-.1412943 1.199-.760584 1.199-1.4730678 0-.7114816-.504-1.3307713-1.199-1.4720656l-.301-.0611273-.301.0611273c-.695.1412943-1.199.760584-1.199 1.4720656 0 .7124838.504 1.3317735 1.199 1.4730678l.301.0611273.301-.0611273zM26 8.00999889c1.141.23148207 2 1.24258774 2 2.45411078 0 1.21252513-.859 2.22262873-2 2.45511283l0 8.5678429c0 .2755739-.225.5010434-.5.5010434-.275 0-.5-.2254695-.5-.5010434l0-8.5678429c-1.141-.2324841-2-1.2425877-2-2.45511283 0-1.21152304.859-2.22262871 2-2.45411078l0-1.55423675c0-.27557389.225-.50104344.5-.50104344.275 0 .5.22546955.5.50104344l0 1.55423675zm-.199 3.92717851c.695-.1412943 1.199-.760584 1.199-1.47306773 0-.71148169-.504-1.33077138-1.199-1.47206563l-.301-.0611273-.301.0611273c-.695.14129425-1.199.76058394-1.199 1.47206563 0 .71248373.504 1.33177343 1.199 1.47306773l.301.0611273.301-.0611273z"],"adjust-video_14":["M13.4529 4.068c.332.139.547.461.547.821l0 4.224c0 .36-.215.682-.547.821-.109.044-.225.066-.339.066-.23 0-.455-.089-.625-.259l-1.489-1.472 0 2.234c0 .827-.672 1.497-1.497 1.497l-7.006 0c-.827 0-1.497-.671-1.497-1.497l0-7.005c0-.827.671-1.498 1.497-1.498l7.006 0c.826 0 1.497.672 1.497 1.498l0 2.234 1.492-1.474c.249-.252.628-.327.961-.19zm-.45 4.93l0-3.994-1.993 1.997 1.993 1.997zm-3.003 1.505l0-7.005c0-.273-.224-.498-.497-.498l-7.006 0c-.274 0-.497.225-.497.498l0 7.005c0 .274.223.497.497.497l7.006 0c.273 0 .497-.223.497-.497zM8.5 5c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L5.908 6c-.206.581-.756 1-1.408 1C3.671 7 3 6.328 3 5.5 3 4.672 3.671 4 4.5 4c.652 0 1.202.419 1.408 1L8.5 5zm-4 1c.276 0 .5-.225.5-.5 0-.275-.224-.5-.5-.5-.276 0-.5.225-.5.5 0 .275.224.5.5.5zm3 3c.276 0 .5-.225.5-.5 0-.275-.224-.5-.5-.5-.276 0-.5.225-.5.5 0 .275.224.5.5.5zm0-2C8.329 7 9 7.672 9 8.5c0 .828-.671 1.5-1.5 1.5-.652 0-1.202-.419-1.408-1L3.5 9c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l2.592 0c.206-.581.756-1 1.408-1z"],"adjust-video_16":["M7,9.5a0.5,0.5 0 1,0 1,0a0.5,0.5 0 1,0 -1,0"],"adjust-video_24":["M22.3246 7.0879c.419.174.69.579.69 1.032l0 7.76c0 .454-.271.859-.691 1.034-.14.058-.286.086-.431.086-.291 0-.576-.114-.791-.329l-3.102-3.097 0 3.926c0 1.379-1.121 2.5-2.5 2.5l-12 0c-1.378 0-2.5-1.121-2.5-2.5l0-11c0-1.379 1.122-2.5 2.5-2.5l12 0c1.379 0 2.5 1.121 2.5 2.5l0 3.924 3.102-3.096c.322-.321.802-.417 1.223-.24zm-.31 8.792l0-7.76c0-.052-.025-.089-.074-.109-.05-.018-.094-.011-.133.026l-3.808 3.802 0 .322 3.808 3.802c.039.039.084.047.133.027.049-.02.074-.057.074-.11zm-5.015 1.62l0-11c0-.827-.672-1.5-1.5-1.5l-12 0c-.827 0-1.5.673-1.5 1.5l0 11c0 .827.673 1.5 1.5 1.5l12 0c.828 0 1.5-.673 1.5-1.5zM13.5146 15c.271 0 .5-.229.5-.5 0-.271-.229-.5-.5-.5-.271 0-.5.229-.5.5 0 .271.229.5.5.5zm0-2c.825 0 1.5.675 1.5 1.5 0 .825-.675 1.5-1.5 1.5-.649 0-1.2-.42-1.407-1l-7.593 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l7.593 0c.207-.58.758-1 1.407-1zm-8-3c.271 0 .5-.229.5-.5 0-.271-.229-.5-.5-.5-.271 0-.5.229-.5.5 0 .271.229.5.5.5zm9-1c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-7.593 0c-.208.58-.758 1-1.407 1-.825 0-1.5-.675-1.5-1.5 0-.825.675-1.5 1.5-1.5.649 0 1.199.42 1.407 1l7.593 0z"],"admin_12":["M3.582 8c-1.036 0-1.935.676-2.184 1.645L1.049 11 5.5 11c.276 0 .5.224.5.5 0 .276-.224.5-.5.5L.844 12c-.266 0-.51-.119-.671-.328-.157-.204-.211-.463-.146-.712L.43 9.395c.348-1.352 1.555-2.303 2.97-2.38C2.55 6.281 2 5.209 2 4c0-2.206 1.794-4 4-4 2.206 0 4 1.794 4 4 0 2.206-1.794 4-4 4L3.582 8zM3 4c0 1.654 1.346 3 3 3 1.654 0 3-1.346 3-3 0-1.654-1.346-3-3-3-1.654 0-3 1.346-3 3zm6 5.5c0 .276.224.5.5.5.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5zm2.482.567c.239.137.321.445.183.683-.138.238-.444.32-.683.183l-.515-.297c-.137.117-.294.21-.467.271l0 .593c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-.593c-.173-.061-.33-.154-.467-.271l-.515.297c-.239.137-.545.055-.683-.183-.138-.238-.056-.546.183-.683l.509-.295C8.011 9.684 8 9.594 8 9.5c0-.094.012-.184.027-.272l-.509-.295c-.239-.137-.321-.445-.183-.683.138-.238.444-.32.683-.183l.515.297c.137-.117.294-.21.467-.271L9 7.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 .593c.173.061.33.154.467.271l.515-.297c.239-.137.545-.055.683.183.138.238.056.546-.183.683l-.509.295c.015.088.027.178.027.272 0 .094-.011.184-.027.272l.509.295z"],"admin_14":["M7.4999 13c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-6.593 0c-.279 0-.537-.126-.71-.347-.176-.224-.238-.512-.17-.79l.477-1.956C.9209 9.195 2.4169 8 4.1429 8l.064 0c-1.032-.825-1.707-2.079-1.707-3.5 0-2.481 2.019-4.5 4.5-4.5 2.481 0 4.5 2.019 4.5 4.5 0 2.481-2.019 4.5-4.5 4.5l-2.857 0c-1.264 0-2.36.881-2.667 2.143L1.0229 13l6.477 0zm-4-8.5c0 1.93 1.57 3.5 3.5 3.5 1.93 0 3.5-1.57 3.5-3.5 0-1.93-1.57-3.5-3.5-3.5-1.93 0-3.5 1.57-3.5 3.5zm9.915 7.317c.238.138.32.445.183.683-.138.238-.445.32-.683.183l-.489-.283c-.25.255-.57.437-.926.529l0 .571c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-.571c-.356-.092-.676-.274-.926-.529l-.489.283c-.238.137-.545.055-.683-.183-.137-.238-.055-.545.183-.683l.495-.286c-.047-.17-.08-.346-.08-.531 0-.185.033-.361.08-.531l-.495-.286c-.238-.138-.32-.445-.183-.683.138-.238.445-.32.683-.183l.489.283c.25-.255.57-.437.926-.529l0-.571c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 .571c.356.092.676.274.926.529l.489-.283c.238-.137.545-.055.683.183.137.238.055.545-.183.683l-.495.286c.047.17.08.346.08.531 0 .185-.033.361-.08.531l.495.286zm-2.415.183c.551 0 1-.449 1-1 0-.551-.449-1-1-1-.551 0-1 .449-1 1 0 .551.449 1 1 1z"],"admin_16":["M15.7248 12.1183c.164.056.275.209.275.383l0 .002c0 .172-.111.328-.276.383l-.833.275c-.094.227-.14.337-.235.564l.393.782c.078.156.048.344-.075.467l-.001.001c-.078.078-.182.118-.285.118-.062 0-.123-.013-.181-.043l-.785-.391c-.227.095-.336.14-.563.234l-.275.83c-.056.165-.21.277-.384.277l-.001 0c-.174 0-.328-.111-.383-.276l-.277-.83c-.226-.094-.337-.139-.563-.233l-.782.393c-.056.029-.12.043-.18.043-.106 0-.208-.041-.285-.119l-.002-.001c-.122-.123-.154-.31-.077-.465l.392-.788c-.094-.226-.14-.336-.233-.562l-.831-.276c-.165-.055-.278-.209-.278-.383l0-.002c0-.174.113-.328.277-.383l.834-.279c.092-.228.138-.337.232-.564l-.393-.784c-.077-.155-.045-.343.078-.465l.001-.002c.078-.077.179-.118.286-.118.059 0 .123.014.178.043l.785.391c.225-.094.335-.139.562-.233l.276-.831c.055-.165.209-.276.383-.276l.002 0c.174 0 .328.111.383.276l.276.832c.228.094.337.139.564.233l.787-.393c.058-.028.118-.042.181-.042.103 0 .208.04.284.118l.001.001c.123.123.153.311.075.466l-.394.785c.094.227.139.336.233.564l.834.278zm-1.758.66c.043-.103.103-.196.174-.278-.071-.082-.132-.176-.174-.28l-.117-.281-.115-.282c-.042-.103-.068-.21-.075-.318-.108-.007-.215-.032-.319-.074l-.237-.099-.325-.135c-.104-.042-.198-.101-.279-.173-.082.071-.175.13-.277.173l-.564.233c-.102.042-.21.067-.318.074-.007.109-.032.216-.074.319l-.168.407-.065.156c-.043.104-.102.199-.174.281.07.081.128.174.171.277l.119.281.116.281c.043.105.067.213.074.324.107.007.215.031.316.073l.284.116.28.116c.103.043.197.102.278.173.082-.071.175-.13.279-.172l.166-.069.395-.165c.105-.043.212-.067.321-.074.007-.109.033-.217.076-.321l.098-.241.134-.322zM12.5 12c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.275 0-.5-.224-.5-.5 0-.276.225-.5.5-.5zm-4 3c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L.97 16c-.292 0-.566-.134-.75-.367-.195-.244-.264-.561-.193-.869l.551-2.349C1.05 10.405 2.746 9 4.703 9l.324 0C3.804 8.088 3 6.644 3 5c0-2.761 2.238-5 5-5 2.763 0 5 2.239 5 5 0 2.761-2.237 5-5 5l-3.297 0c-1.49 0-2.785 1.087-3.15 2.644l-.551 2.349L8.5 15zM4 5c0 2.206 1.794 4 4 4 2.206 0 4-1.794 4-4 0-2.206-1.794-4-4-4-2.206 0-4 1.794-4 4z"],"admin_24":["M13.4996039 22c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L1.15660386 23c-.355000004 0-.686000004-.162-.907000004-.444-.2229999996-.285-.3019999996-.651-.2149999996-1.004L.806603856 18.42C1.44460386 15.817 3.73860386 14 6.38360386 14l1.024 0c-2.039-1.223-3.408-3.449-3.408-6 0-3.866 3.134-7 7.00000004-7 3.866 0 7 3.134 7 7 0 3.866-3.134 7-7 7l-4.61600004 0c-2.183 0-4.077 1.504-4.607 3.659l-.771 3.132c-.018000004.072.012.125.031.149.022.027.06.06.12.06l11.84300004 0 .5 0zM4.99960386 8c0 3.308 2.692 6 6.00000004 6 3.308 0 6-2.692 6-6 0-3.308-2.692-6-6-6-3.30800004 0-6.00000004 2.692-6.00000004 6zm18.26670004 9.4811c.439.147.734.557.734 1.023 0 .466-.296.876-.738 1.022l-.97.322-.159.383.458.921c.206.414.125.912-.205 1.242-.329.329-.827.411-1.244.202l-.912-.458-.383.157-.324.97c-.147.439-.558.735-1.023.735-.465 0-.876-.296-1.023-.735l-.324-.97-.383-.157-.912.458c-.417.209-.916.127-1.245-.202-.329-.33-.411-.828-.205-1.242l.459-.921-.159-.383-.971-.322c-.441-.146-.738-.556-.738-1.022 0-.466.295-.876.735-1.023l.976-.327.157-.384-.457-.916c-.207-.415-.126-.914.202-1.242.33-.33.83-.41 1.244-.204l.914.458.384-.159.323-.971c.146-.44.556-.736 1.021-.736l.003 0c.465 0 .876.296 1.021.736l.324.971.383.159.914-.458c.415-.206.914-.126 1.245.204.328.328.409.827.202 1.242l-.458.916.158.384.976.327zm-.318 1.096l0-.148-1.192-.4c-.138-.046-.248-.149-.303-.283l-.332-.804c-.056-.134-.05-.285.015-.415l.559-1.12-.104-.104-1.119.559c-.13.065-.281.07-.415.015l-.805-.334c-.134-.055-.237-.166-.283-.303l-.395-1.187-.015 0 0-.002-.119 0 0 .002-.014 0-.396 1.187c-.045.137-.149.248-.283.303l-.805.334c-.134.055-.285.05-.415-.015l-1.118-.559-.105.104.56 1.12c.065.13.07.281.015.415l-.332.804c-.056.134-.166.237-.303.283l-1.192.4 0 .148 1.187.394c.138.046.249.149.304.282l.335.804c.055.135.05.286-.014.416l-.56 1.125.104.104 1.117-.561c.07-.035.147-.053.224-.053.065 0 .13.013.191.038l.805.332c.134.056.238.166.284.304l.396 1.186.149 0 .397-1.186c.046-.138.149-.248.283-.304l.805-.332c.062-.025.126-.038.191-.038.077 0 .154.018.225.053l1.116.561.105-.104-.56-1.125c-.065-.13-.07-.281-.014-.416l.334-.804c.056-.133.167-.236.305-.282l1.187-.394zm-4.4487.4229c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5 0 .276.224.5.5.5zm0-2c.827 0 1.5.673 1.5 1.5 0 .827-.673 1.5-1.5 1.5-.827 0-1.5-.673-1.5-1.5 0-.827.673-1.5 1.5-1.5z"],"admin_32":["M18.4866532 30c.275795 0 .4996285.224.4996285.5 0 .276-.2238335.5-.4996285.5L1.40635423 31c-.433677514 0-.835378807-.196-1.104178926-.539-.2707986324-.347-.3657280424-.792-.259806806-1.22l1.063209392-4.306C1.96893589 21.44 5.05963763 19 8.61899088 19l2.04348042 0c-3.34651148-1.618-5.66578686-5.039-5.66578686-9 0-5.514 4.48266667-10 9.99256946-10 5.5099028 0 9.9925695 4.486 9.9925695 10 0 5.514-4.4826667 10-9.9925695 10l-6.37026302 0c-3.09969505 0-5.78969476 2.128-6.54313449 5.175l-1.0632094 4.306c-.031976218.128-.00399702.26.07694279.363.04496656.058.14689077.156.31676445.156l17.08029897 0zM5.99594139 10c0 4.963 4.03499951 9 8.99331251 9 4.9593122 0 8.9933125-4.037 8.9933125-9 0-4.962-4.0340003-9-8.9933125-9-4.958313 0-8.99331251 4.038-8.99331251 9zM31.1476385 23.8179c.509621.169.8523661.645.8523661 1.184l0 .004c0 .539-.3437444 1.016-.8553639 1.186l-1.330011.44-.2578083.625.6255349 1.249c.2408209.483.1468907 1.063-.2348254 1.443-.3817162.383-.9622845.477-1.4429271.237l-1.2500704-.625-.6245356.258-.4386738 1.325c-.1698737.512-.6465192.856-1.1851187.856-.540598 0-1.0162444-.343-1.1871173-.852l-.4426708-1.327-.6245356-.257-1.2460734.627c-.4816419.241-1.0622102.147-1.4429271-.234-.0239821-.023-.0459658-.052-.0649517-.079-.3167644-.303-.4116938-.881-.1738707-1.362l.6275334-1.26-.2588076-.624-1.3270132-.44c-.5116195-.17-.8553639-.647-.8553639-1.186 0-.541.3417458-1.018.8513669-1.188l1.3330088-.448.2578083-.624-.6255349-1.253c-.2398217-.479-.1468908-1.059.2328269-1.44.0229829-.024.0529606-.047.0799405-.066.3027749-.319.8823439-.414 1.364985-.171l1.2480719.625.6245356-.259.4416716-1.327c.1698737-.512.6465193-.855 1.1841195-.855.5425965 0 1.0182428.344 1.1881165.856l.4416716 1.327.6235363.26 1.256066-.628c.4806426-.242 1.0592124-.148 1.4399293.234.3847139.385.4776448.965.2348253 1.447l-.6285326 1.251.2568091.625 1.3320095.446zm-.1468908 1.188l0-.004c0-.107-.0679495-.202-.1688744-.235l-1.5498476-.519c-.1358989-.047-.2478157-.15-.3017756-.284l-.431679-1.047c-.0559583-.134-.0499628-.285.0149889-.415l.7304568-1.456c.0489636-.097.0299777-.212-.0459658-.288-.0769428-.077-.1908581-.097-.2897845-.049l-1.4589152.73c-.1299034.065-.2797919.071-.4146916.014l-1.0452228-.433c-.1339004-.056-.2368239-.166-.2827897-.304l-.5146173-1.545c-.0689487-.207-.4066976-.201-.474647 0l-.5136181 1.544c-.0459658.138-.1488893.249-.283789.304l-1.046222.432c-.135899.056-.283789.05-.4136924-.014l-1.4519203-.727c-.0989265-.048-.2128418-.03-.2867868.046-.0239821.023-.0529606.047-.0799405.065.0009992.013-.0179867.129.0299777.224l.7264598 1.458c.0649517.13.0709472.281.0149888.414l-.4326782 1.045c-.0539599.135-.1658767.237-.3017756.283l-1.5488483.52c-.1019242.034-.1698737.13-.1698737.237 0 .111.0679495.206.170873.24l1.5428527.513c.1378974.046.248815.149.3047734.283l.4326782 1.044c.0569577.134.0519614.285-.0139896.415l-.727459 1.463c-.0469651.096-.0279792.211.0479643.287.0229829.024.0459658.052.0639524.079.0139896 0 .1299034.018.2248328-.029l1.4509211-.729c.069948-.036.1468908-.053.2248328-.053.0639525 0 .1289042.012.1898589.038l1.046222.432c.1339004.054.2368239.166.283789.303l.5156166 1.542c.0679494.206.408696.201.474647-.001l.5116196-1.541c.0459658-.137.1488892-.249.2827897-.304l1.0442235-.435c.1339004-.055.2847882-.05.4156909.015l1.4559173.727c.0939302.047.209844.028.2867868-.047.0789413-.079.0979272-.194.0489636-.291l-.7274591-1.453c-.0649517-.13-.0709472-.281-.0149888-.416l.4346767-1.047c.0549592-.134.166876-.237.3037742-.283l1.5458505-.512c.1029234-.034.1708729-.129.1708729-.236zM25.005206 23c1.1021804 0 1.9985139.897 1.9985139 2 0 1.103-.8963335 2-1.9985139 2-1.1021804 0-1.9985139-.897-1.9985139-2 0-1.103.8963335-2 1.9985139-2zm0 3c.5515898 0 .999257-.448.999257-1 0-.552-.4476672-1-.999257-1-.5515898 0-.9992569.448-.9992569 1 0 .552.4476671 1 .9992569 1z"],"alarm_16":["M7.9905 1.9905c3.86 0 7 3.14 7 7 0 1.75-.65 3.349-1.716 4.577l1.57 1.569c.195.196.195.512 0 .708-.098.097-.226.146-.354.146-.128 0-.256-.049-.354-.146l-1.569-1.57c-1.228 1.066-2.827 1.716-4.577 1.716-1.757 0-3.361-.656-4.592-1.729-.018.028-.03.058-.054.083l-1.5 1.5c-.098.097-.226.146-.354.146-.128 0-.256-.049-.354-.146-.195-.196-.195-.512 0-.708l1.5-1.5c.025-.024.055-.036.083-.054-1.073-1.231-1.729-2.835-1.729-4.592 0-3.86 3.14-7 7-7zm0 13c3.309 0 6-2.691 6-6 0-3.309-2.691-6-6-6-3.309 0-6 2.691-6 6 0 3.309 2.691 6 6 6zm.5-5.2715l1.362 1.426c.19.2.183.516-.017.707-.096.093-.221.138-.345.138-.132 0-.263-.051-.362-.154l-1.5-1.572c-.089-.092-.138-.216-.138-.345l0-4.429c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 4.229zM1.5383 4.8514c-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147-1.108-1.108-1.108-2.912 0-4.02 1.108-1.108 2.912-1.108 4.02 0 .196.195.196.512 0 .707l-3.313 3.313zm0-3.313c-.348.348-.54.811-.54 1.303 0 .321.082.63.235.902l2.51-2.51c-.272-.153-.581-.235-.902-.235-.492 0-.955.192-1.303.54zM15.1654.8315c1.109 1.108 1.109 2.912 0 4.02-.097.098-.225.147-.353.147-.128 0-.256-.049-.354-.147l-3.314-3.313c-.093-.094-.146-.221-.146-.354 0-.132.053-.259.146-.353 1.108-1.108 2.912-1.109 4.021 0zm-.402 2.911c.393-.702.292-1.608-.305-2.204-.574-.575-1.514-.694-2.205-.305l2.51 2.509z"],"alarm_20":["M9.99960003 3.00084996c4.68662507 0 8.49932007 3.81280936 8.49932007 8.49957504 0 2.1638918-.8189345 4.1347932-2.1558275 5.6367181l2.0098392 2.0088996c.1949844.1949902.1949844.5119744 0 .7069646-.0979922.0979951-.225982.1469927-.3539717.1469927-.1279898 0-.2559795-.0489976-.3529718-.1469927l-2.0098392-2.0088995C14.1342693 19.180041 12.1634269 20 9.99960003 20c-2.16382689 0-4.13466922-.819959-5.63654907-2.1558922l-2.0088393 2.0088995C2.2562195 19.9510024 2.12822974 20 2.00023998 20c-.12798976 0-.25597952-.0489976-.35297176-.1469927-.19598432-.1949902-.19598432-.5119744 0-.7069646l2.00883929-2.0088996c-1.33689305-1.5019249-2.15582753-3.4728263-2.15582753-5.6367181 0-4.68676568 3.81269498-8.49957504 8.49932005-8.49957504zM4.71402288 16.8141593C6.07091433 18.1640918 7.93976482 19.00005 9.99960003 19.00005c2.05983517 0 3.92768577-.8359582 5.28457727-2.1848908.0049996-.0049997.0069994-.0129993.011999-.0179991.0049996-.0049997.012999-.0069996.0179986-.0119994 1.349892-1.3569321 2.1848252-3.2248387 2.1848252-5.2847357 0-4.13579323-3.3637309-7.49962504-7.49940007-7.49962504-4.13566914 0-7.49940005 3.36383181-7.49940005 7.49962504 0 2.059897.83593313 3.9288035 2.18582514 5.2857357.0049996.0049997.01199904.0059997.01699864.0109994.0049996.0049998.00699944.0119994.01099912.0169992zm7.43780502-2.6380681c.1899848.19999.1829853.5169741-.0169987.7069646-.0969922.0919954-.2209823.1379931-.3449724.1379931-.1319894 0-.262979-.0519974-.361971-.1549922l-1.78985684-1.8779061c-.08899288-.0929954-.13798896-.2169892-.13798896-.3449828l0-5.12174387c0-.27698615.22298216-.499975.49996-.499975.2759779 0 .49996.22298885.49996.499975l0 4.92175387 1.6518679 1.7329134zM7.0074394 2.18039098L1.58487321 6.55617219c-.08899288.0719964-.199984.11099445-.31397488.11099445-.01799856 0-.03699704-.00099995-.0549956-.00299985-.13298936-.01499925-.253979684-.08099595-.336973044-.1859907C.303975682 5.75421229 0 4.89725514 0 4.00029999 0 1.79441028 1.79385649.000499975 3.99968003.000499975c1.18890488 0 2.31181505.536973151 3.08075354 1.473926305.0849932.10299485.12499.23498825.11099112.3679816-.01399888.13299335-.0799936.2539873-.18398529.3379831zM.999920006 4.00029999c0 .5039748.129989604.99295035.379969604 1.43692815l4.57563395-3.69281536c-.54295657-.47697615-1.23390129-.7439628-1.95584353-.7439628-1.65386769 0-2.999760024 1.3459327-2.999760024 2.99985001zM16.00032 0C18.2051436 0 20 1.79491025 20 3.99980001c0 .8979551-.3039757 1.75491225-.8799296 2.47887606-.0829934.1039948-.2039837.17099145-.3359731.1859907-.0179986.00099995-.0369971.0019999-.0549956.0019999-.1139909 0-.224982-.0379981-.3139749-.1099945l-5.4225662-4.37578121c-.1039917-.0839958-.1699864-.20598971-.1839853-.33798311-.0139989-.13299335.0259979-.2659867.1109911-.36898155C13.6885049.537973101 14.8114151 0 16.00032 0zm2.6197904 5.43672816c.24998-.44297785.3799696-.9319534.3799696-1.43692815 0-1.6539173-1.3458923-2.999850008-2.99976-2.999850008-.7219423 0-1.412887.266986648-1.9558436.744962748l4.575634 3.69181541z"],"alarm_24":["M11.9995 4.003c5.517 0 10.004 4.485 10.004 9.998 0 2.578-.988 4.922-2.596 6.697l2.449 2.448c.196.196.196.512 0 .708-.097.097-.225.146-.353.146-.128 0-.256-.049-.354-.146l-2.45-2.449c-1.775 1.607-4.121 2.595-6.7 2.595-2.579 0-4.924-.988-6.7-2.595l-2.451 2.449c-.098.097-.225.146-.353.146-.128 0-.256-.049-.354-.146-.195-.196-.195-.512 0-.708l2.45-2.448c-1.607-1.775-2.596-4.119-2.596-6.697 0-5.513 4.488-9.998 10.004-9.998zm0 18.997c4.965 0 9.004-4.037 9.004-8.999 0-4.961-4.039-8.998-9.004-8.998-4.964 0-9.003 4.037-9.003 8.998 0 4.962 4.039 8.999 9.003 8.999zm.5005-8.0273l2.078 2.175c.191.2.183.516-.016.707-.097.093-.222.139-.346.139-.132 0-.263-.052-.362-.155l-2.216-2.321c-.089-.092-.138-.216-.138-.345l0-6.667c0-.277.223-.5.5-.5.276 0 .5.223.5.5l0 6.467zM8.4338 2.0997c-.013.133-.079.254-.183.338l-6.511 5.251c-.089.072-.2.111-.314.111-.018 0-.037-.001-.055-.003-.133-.015-.254-.082-.337-.186-.676-.851-1.034-1.858-1.034-2.911 0-2.592 2.11-4.7 4.702-4.7 1.397 0 2.717.632 3.621 1.732.085.103.125.236.111.368zm-6.905 4.474l5.675-4.577c-.683-.638-1.571-.997-2.502-.997-2.041 0-3.701 1.659-3.701 3.7 0 .661.181 1.3.528 1.874zm17.7689-6.574c2.593 0 4.702 2.108 4.702 4.7 0 1.053-.358 2.06-1.034 2.911-.083.104-.204.171-.337.186-.018.002-.037.003-.055.003-.114 0-.225-.039-.314-.111l-6.511-5.251c-.104-.084-.17-.205-.183-.338-.014-.132.026-.265.111-.368.904-1.1 2.224-1.732 3.621-1.732zm3.173 6.574c.347-.574.529-1.213.529-1.874 0-2.041-1.66-3.7-3.702-3.7-.93 0-1.819.359-2.502.997l5.675 4.577z"],"alert_10":["M8.9997 8l-8 0 0-1.498c0-.131.053-.262.148-.356l1.467-1.45c.244-.242.385-.58.385-.924l0-.772c0-1.103.897-2 2-2 1.103 0 2 .897 2 2l0 .772c0 .347.14.685.385.925l1.468 1.451c.093.095.147.224.147.355l0 1.497zm.558-2.561l-1.469-1.453c-.058-.055-.089-.132-.089-.214l0-.772c0-1.657-1.343-3-3-3-1.657 0-3 1.343-3 3l0 .773c0 .08-.033.158-.089.213L.4447 5.437c-.283.279-.445.667-.445 1.065l0 1.599c0 .496.404.899.9.899l2.686 0c.207.581.756 1 1.408 1 .652 0 1.201-.419 1.408-1l2.698 0c.496 0 .9-.403.9-.899l0-1.598c0-.397-.161-.783-.442-1.064z"],"alert_12":["M9.998 8.99818087l-7.998 0 0-1.8768869c0-.26798386.104-.51896873.293-.70695741l1.12-1.12093245c.378-.37797723.586-.87894704.586-1.41391481l0-.87994698c0-1.10293354.897-1.999879494 2-1.999879494.036 0 .073.000999944.109.002999814C7.152 1.05765933 8 2.03060071 7.999 3.17153196l-.001.70395758c-.001.53496777.207 1.03693752.585 1.41491475l1.122 1.12393227c.189.18798868.293.43897355.293.70595747l0 1.87788684zM7 10.0001205c0 .5519667-.449.9999398-1 .9999398-.551 0-1-.4479731-1-.9999398 0-.00099994 0-.00099994 0-.00199988l1.999 0c0 .00099994.001.00099994.001.00199988zm3.412-4.29274134L9.29 4.58444682c-.188-.18798867-.292-.44197336-.292-.70795734l.001-.70395758C9 1.54762981 7.784.0897176543 6.161.003722836c-.054-.0019998796-.108-.003999759-.162-.003999759-1.657 0-3 1.342919083-3 2.999819243l0 .87994698c0 .26498403-.105.51996867-.293.7069574l-1.12 1.11993252C1.211 6.08135663 1 6.59032596 1 7.12129397l0 1.8768869c0 .55296669.448.99993975 1 .99993975l2 0 0 .00199988C4 11.104054 4.895 12 6 12c1.104 0 2-.895946 2-1.9998795l0-.00199988 1.998 0c.552 0 1-.44697306 1-.99993975l0-1.87788684c0-.52996807-.211-1.03793746-.586-1.41291487z"],"alert_16":["M8 15.0002c-1.099 0-1.992-.891-1.999-1.987l3.998 0c-.007 1.096-.9 1.987-1.999 1.987m0-15c-2.234 0-3.984 1.825-3.984 4.156l0 .483c0 .491-.162.978-.437 1.347l-1.923 2.253c-.423.564-.656 1.265-.656 1.971l0 1.839c0 .532.433.964.964.964l3.037 0c.007 1.648 1.349 2.987 2.999 2.987 1.65 0 2.992-1.339 2.999-2.987l3.037 0c.531 0 .964-.432.964-.964l0-1.839c0-.706-.233-1.407-.656-1.971l-1.856-2.229c-.295-.393-.457-.88-.457-1.371l0-.483c0-2.331-1.77-4.156-4.031-4.156m0 1c1.7 0 3.031 1.386 3.031 3.156l0 .483c0 .706.234 1.406.657 1.971l.015.02.017.019 1.838 2.208c.285.389.442.869.442 1.353l0 1.803-2.995 0-1.006 0-3.998 0-1.006 0-2.995 0 0-1.803c0-.482.156-.96.439-1.348l1.901-2.227.021-.025.02-.027c.41-.549.635-1.24.635-1.944l0-.483c0-1.77 1.311-3.156 2.984-3.156"],"alert_18":["M15.9995249 13.9500504c0 .0400668-.032012.0731219-.0710267.0731219l-13.85619605 0c-.040015 0-.07202701-.0330551-.07202701-.0731219l0-1.5085142c0-.6310517.20807803-1.2560935.61623109-1.8040067L4.2191072 7.93402371c.4911842-.65609349.78529449-1.57362271.78529449-2.44808014l-.00600225-.47779632c0-2.20868114 1.794673-4.0066778 4.00150056-4.0066778 2.2058272 0 4.0015006 1.79799666 4.0015006 4.0066778l.0100037.66911519c.0390146.8163606.3111167 1.6457429.7402776 2.21268781l1.6326122 2.74757925.0290109.0440735c.3781418.5048414.5862199 1.1298831.5862199 1.7599332l0 1.5085142zM8.9999 16.9981306c-1.10041265 0-1.99474803-.8944909-1.99974991-1.9923206l3.99949982 0c-.00600225 1.0978297-.89933726 1.9923206-1.99974991 1.9923206zm7.2297111-6.8954925l-1.6476178-2.76861439c-.3541328-.47178631-.5642116-1.12888147-.5802176-1.77195326l0-.5539232C14.0017757 2.2425379 11.7629361-.0002 8.9999-.0002c-2.76303614 0-5.0018757 2.2427379-5.0018757 5.00834725l0 .55292153c-.01600601.64407346-.22808554 1.30217029-.60922846 1.81702838L1.786194861 10.081603C1.279004664 10.7567282.9999 11.5951255.9999 12.4415362l0 1.5085142c0 .5919867.481180443 1.0747913 1.07240215 1.0747913l3.9274728-.0190317C6.00477683 16.6565613 7.34828064 17.9998 8.9999 17.9998c1.65161936 0 2.9941228-1.3432387 3.000125-2.99399l3.9284732.0190317c.5912217 0 1.0714018-.4828046 1.0714018-1.0747913l0-1.5085142c0-.836394-.272102-1.6657763-.7702889-2.3388981z"],"alert_20":["M10 19.0009c-1.165 0-2.119-.875-2.265-2.001l4.53 0c-.146 1.126-1.1 2.001-2.265 2.001m0-19.001c-2.761 0-5 2.238-5 5l0 .193c0 .716-.237 1.426-.658 1.989l-2.475 3.076c-.559.745-.867 1.669-.867 2.599l0 3.004c0 .628.511 1.139 1.139 1.139l4.596 0c.152 1.678 1.549 3.001 3.265 3.001 1.716 0 3.113-1.323 3.265-3.001l4.596 0c.628 0 1.139-.511 1.139-1.139l0-3.004c0-.93-.308-1.854-.867-2.599l-2.467-3.066c-.429-.573-.666-1.283-.666-1.999l0-.193c0-2.762-2.239-5-5-5m0 1c2.206 0 4 1.795 4 4l0 .193c0 .93.308 1.854.887 2.626l2.446 3.039c.43.573.667 1.283.667 1.999l0 3.004c0 .076-.063.139-.139.139l-4.458 0-1.138 0-4.53 0-1.138 0-4.458 0c-.076 0-.139-.063-.139-.139l0-3.004c0-.716.237-1.426.646-1.972l2.497-3.105c.553-.738.857-1.657.857-2.587l0-.193c0-2.205 1.794-4 4-4"],"alert_24":["M22 19.5c0 .275-.225.5-.5.5l-19 0c-.275 0-.5-.225-.5-.5l0-2.831c0-.891.294-1.773.813-2.465l3.072-3.729C6.604 9.515 7 8.42 7 7.392L7 6c0-2.757 2.243-5 5-5 2.757 0 5 2.243 5 5l0 1.392c0 1.028.396 2.123 1.13 3.101l3.049 3.701c.529.71.821 1.588.821 2.475l0 2.831zM12 23c-1.206 0-2.214-.86-2.443-2l4.886 0c-.229 1.14-1.237 2-2.443 2zm9.972-9.414l-3.056-3.711C18.325 9.087 18 8.205 18 7.392L18 6c0-3.309-2.691-6-6-6-3.309 0-6 2.691-6 6l0 1.392c0 .813-.325 1.695-.901 2.465l-3.071 3.729C1.365 14.469 1 15.563 1 16.669L1 19.5c0 .827.673 1.5 1.5 1.5l6.057 0c.242 1.691 1.686 3 3.443 3 1.757 0 3.201-1.309 3.443-3l6.057 0c.827 0 1.5-.673 1.5-1.5l0-2.831c0-1.106-.365-2.2-1.028-3.083z"],"alert_28":["M26 22.5c0 .276-.224.5-.499.5L2.499 23C2.224 23 2 22.776 2 22.5l0-3.019c0-1.063.351-2.117.961-2.935l3.872-4.345c.766-1.021 1.188-2.288 1.188-3.567l0-1.634c0-3.309 2.688-6 5.993-6l.004 0c3.304 0 5.992 2.691 5.992 6l0 1.59c0 1.278.422 2.545 1.212 3.597l3.79 4.327c.637.85.988 1.904.988 2.967l0 3.019zM14 27c-1.654 0-3-1.346-3-3l6 0c0 1.654-1.346 3-3 3zm11.788-11.116l-3.79-4.326c-.637-.851-.988-1.905-.988-2.968l0-1.59c0-3.86-3.136-7-6.992-7l-.004 0c-3.856 0-6.993 3.14-6.993 7l0 1.634c0 1.064-.351 2.117-.961 2.935l-3.872 4.345C1.422 16.937 1 18.203 1 19.481L1 22.5c0 .827.672 1.5 1.499 1.5L10 24c0 2.206 1.794 4 4 4 2.206 0 4-1.794 4-4l7.501 0c.827 0 1.499-.673 1.499-1.5l0-3.019c0-1.278-.422-2.544-1.212-3.597z"],"alert_36":["M33.9957 29.3218c0 .373-.304.677-.677.677l-30.641 0c-.373 0-.678-.304-.678-.677l0-4.218c0-1.409.467-2.806 1.314-3.938l4.174-5.644c.974-1.298 1.511-2.91 1.511-4.535l0-.99c0-4.961 4.037-8.997 8.997-8.997l0-.009.004.009c4.96 0 8.997 4.036 8.997 8.997l0 .99c0 1.625.537 3.237 1.511 4.535l4.174 5.644c.848 1.132 1.314 2.529 1.314 3.938l0 4.218zm-15.995 5.678l-.001 0 0 .016-.004-.016-.001 0c-2.414 0-4.433-1.72-4.897-3.998l9.801 0c-.465 2.278-2.484 3.998-4.898 3.998zm15.483-14.431l-4.174-5.643c-.848-1.131-1.313-2.529-1.313-3.939l0-.99c0-5.513-4.484-9.997-9.997-9.997l-.004.008 0-.008c-5.512 0-9.997 4.484-9.997 9.997l0 .99c0 1.41-.465 2.808-1.313 3.939l-4.173 5.643c-.976 1.3-1.513 2.911-1.513 4.535l0 4.218c0 .925.752 1.677 1.678 1.677l9.408.003c.479 2.832 2.943 4.998 5.909 4.998l.001 0 .004-.016 0 .016.001 0c2.966 0 5.43-2.166 5.909-4.998l9.409-.003c.925 0 1.677-.752 1.677-1.677l0-4.218c0-1.624-.537-3.235-1.512-4.535z"],"alert-active_10":["M9.5578 5.4395l-1.469-1.453c-.058-.056-.089-.132-.089-.214l0-.772c0-1.657-1.343-3-3-3-1.657 0-3 1.343-3 3l0 .773c0 .08-.033.157-.089.213l-1.466 1.45c-.283.28-.445.668-.445 1.066l0 1.599c0 .496.404.899.9.899l2.686 0c.207.581.756 1 1.408 1 .652 0 1.201-.419 1.408-1l2.698 0c.496 0 .9-.403.9-.899l0-1.598c0-.397-.161-.784-.442-1.064"],"alert-active_12":["M10.412 5.70737916c.375.37497741.586.8829468.586 1.41291487l0 1.87788684c0 .55296669-.448.99993975-1 .99993975l-1.998 0 0 .00199988C8 11.104054 7.104 12 6 12c-1.105 0-2-.895946-2-1.9998795l0-.00199988-2 0c-.552 0-1-.44697306-1-.99993975l0-1.8768869c0-.53096801.211-1.03993734.586-1.41491475l1.12-1.11993252c.188-.18698873.293-.44197337.293-.7069574l0-.87994698c0-1.65690016 1.343-2.999819243 3-2.999819243.054 0 .108.0019998794.162.003999759C7.784.0897176542 9 1.54762981 8.999 3.1725319l-.001.70395758c0 .26598398.104.51996867.292.70795734l1.122 1.12293234zM7 10.0001205c0-.00099994-.001-.00099994-.001-.00199988l-1.999 0c0 .00099994 0 .00099994 0 .00199988 0 .5519667.449.9999398 1 .9999398.551 0 1-.4479731 1-.9999398z"],"alert-active_16":["M8 .0002c2.261 0 4.031 1.825 4.031 4.156l0 .483c0 .491.162.978.457 1.371l1.856 2.229c.423.564.656 1.265.656 1.971l0 1.839c0 .532-.433.964-.964.964l-3.037 0c-.007 1.648-1.349 2.987-2.999 2.987-1.65 0-2.992-1.339-2.999-2.987l-3.037 0c-.531 0-.964-.432-.964-.964l0-1.839c0-.706.233-1.407.656-1.971l1.923-2.253c.275-.369.437-.856.437-1.347l0-.483c0-2.331 1.75-4.156 3.984-4.156zm0 15c1.099 0 1.992-.891 1.999-1.987l-3.998 0c.007 1.096.9 1.987 1.999 1.987z"],"alert-active_18":["M16.2296111 10.1026381c.4981869.6731218.7702889 1.5025041.7702889 2.3388981l0 1.5085142c0 .5919867-.4801801 1.0747913-1.0714018 1.0747913L12.000025 15.00581c-.0060022 1.6507513-1.34850564 2.99399-3.000125 2.99399-1.65161936 0-2.99512317-1.3432387-3.00012505-2.99399l-3.9274728.0190317c-.591221707 0-1.07240215-.4828046-1.07240215-1.0747913l0-1.5085142c0-.8464107.279104664-1.684808.786294861-2.3599332L3.38879584 7.37809716c.38114292-.51485809.59322245-1.17295492.60922846-1.81702838l0-.55292153C3.9980243 2.2425379 6.23686386-.0002 8.9999-.0002c2.7630361 0 5.0018757 2.2427379 5.0018757 5.00834725l0 .5539232c.016006.64307179.2260848 1.30016695.5802176 1.77195326l1.6476178 2.76861439zM8.9999 16.9981306c1.10041265 0 1.99374766-.8944909 1.99974991-1.9923206l-3.99949982 0c.00500188 1.0978297.89933726 1.9923206 1.99974991 1.9923206z"],"alert-active_20":["M15.666 7.1919l2.467 3.066c.559.745.867 1.669.867 2.599l0 3.004c0 .628-.511 1.139-1.139 1.139l-4.596 0c-.152 1.678-1.549 3.001-3.265 3.001-1.716 0-3.113-1.323-3.265-3.001l-4.596 0c-.628 0-1.139-.511-1.139-1.139l0-3.004c0-.93.308-1.854.867-2.599l2.475-3.076c.421-.563.658-1.273.658-1.989l0-.193c0-2.762 2.239-5 5-5 2.761 0 5 2.238 5 5l0 .193c0 .716.237 1.426.666 1.999zm-7.931 9.808c.146 1.126 1.1 2.001 2.265 2.001 1.165 0 2.119-.875 2.265-2.001l-4.53 0z"],"alert-active_24":["M21.972 13.586c.663.883 1.028 1.977 1.028 3.083l0 2.831c0 .827-.673 1.5-1.5 1.5l-6.057 0c-.242 1.691-1.686 3-3.443 3-1.757 0-3.201-1.309-3.443-3L2.5 21c-.827 0-1.5-.673-1.5-1.5l0-2.831c0-1.106.365-2.2 1.028-3.083l3.071-3.729C5.675 9.087 6 8.205 6 7.392L6 6c0-3.309 2.691-6 6-6 3.309 0 6 2.691 6 6l0 1.392c0 .813.325 1.695.916 2.483l3.056 3.711zM12 23c1.206 0 2.214-.86 2.443-2l-4.886 0c.229 1.14 1.237 2 2.443 2z"],"alert-active_36":["M33.4837 20.5688c.975 1.3 1.512 2.911 1.512 4.535l0 4.218c0 .925-.752 1.677-1.677 1.677l-9.409.003c-.479 2.832-2.943 4.998-5.909 4.998l-.001 0 0-.016-.004.016-.001 0c-2.966 0-5.43-2.166-5.909-4.998l-9.408-.003c-.926 0-1.678-.752-1.678-1.677l0-4.218c0-1.624.537-3.235 1.513-4.535l4.173-5.643c.848-1.131 1.313-2.529 1.313-3.939l0-.99c0-5.513 4.485-9.997 9.997-9.997l0 .008.004-.008c5.513 0 9.997 4.484 9.997 9.997l0 .99c0 1.41.465 2.808 1.313 3.939l4.174 5.643zm-15.483 14.431c2.414 0 4.433-1.72 4.898-3.998l-9.801 0c.464 2.278 2.483 3.998 4.897 3.998l.001 0 .004.016 0-.016.001 0z"],"alert-muted_10":["M7.3848 4.6973l1.468 1.451c.093.094.147.223.147.355l0 1.497-6.293 0 4.293-4.293 0 .065c0 .346.14.684.385.925zm-6.385 3.303l0-1.498c0-.132.053-.262.148-.356l1.467-1.45c.244-.243.385-.58.385-.924l0-.772c0-1.103.897-2 2-2 .891 0 1.639.59 1.897 1.396l-5.604 5.604-.293 0zm8.854-7.854c-.196-.195-.512-.195-.707 0l-1.49 1.489c-.498-.967-1.494-1.635-2.657-1.635-1.657 0-3 1.343-3 3l0 .773c0 .08-.033.157-.089.213l-1.466 1.45c-.283.28-.445.668-.445 1.066l0 1.599c0 .324.181.595.439.753l-.292.292c-.196.196-.196.512 0 .707.097.098.225.147.353.147.128 0 .256-.049.354-.147l.853-.853 1.879 0c.207.581.756 1 1.408 1 .652 0 1.201-.419 1.408-1l2.698 0c.496 0 .9-.403.9-.899l0-1.598c0-.397-.161-.784-.442-1.064l-1.469-1.453c-.058-.056-.089-.132-.089-.214l0-.772c0-.091-.019-.177-.027-.266l1.881-1.881c.195-.195.195-.511 0-.707z"],"alert-muted_12":["M8.58289238 5.291l1.12195325 1.124c.18899213.188.29298779.439.29298779.706l0 1.878-6.28973792 0 4.4208158-4.42c.09899587.263.24898962.507.45398108.712zM6 11.001c-.55097704 0-.99995834-.448-.99995834-1l0-.002 1.99891672 0c0 .001.00099996.001.00099996.002 0 .552-.4489813 1-.99995834 1zM2.00016666 8.999l0-1.877c0-.268.10399567-.519.29298779-.707l1.11995334-1.121c.37798425-.378.58597558-.879.58597558-1.414l0-.88c0-1.103.89696263-2 1.99991667-2 .0359985 0 .07299696.001.10899546.003 1.0439565.056 1.89192117 1.028 1.89092121 2.169l0 .122-5.7047623 5.705-.29398775 0zM11.8537561.854c.1949919-.195.1949919-.512 0-.707-.1959918-.195-.5119787-.195-.7079705 0L8.89487938 2.399C8.58089246 1.112 7.51893671.077 6.16099329.004 6.10699554.002 6.05299779 0 5.99900004 0c-1.65693096 0-2.999875 1.343-2.999875 3l0 .88c0 .265-.10499563.52-.2929878.707l-1.11995333 1.12c-.37498438.375-.58597559.884-.58597559 1.415l0 1.877c0 .353.19299196.648.46898046.826L.146243907 11.147c-.1949918758.195-.1949918758.512 0 .707.097995916.098.225990583.146.35398525.146.127994667 0 .255989334-.048.353985251-.146L2.70813716 9.999l1.29194617 0 0 .002C4.00008333 11.105 4.89504604 12 6 12c1.103954 0 1.99991667-.895 1.99991667-1.999l0-.002 1.99791675 0c.55197698 0 .99995838-.447.99995838-1l0-1.878c0-.53-.2109913-1.038-.5859756-1.413L9.28986292 4.585c-.18799216-.188-.29198783-.442-.29198783-.708l0-.168L11.8537561.854z"],"alert-muted_16":["M11.6885 6.6101l.015.021.016.019 1.838 2.208c.286.388.443.868.443 1.352l0 1.803-9.306 0 6.473-6.473c.109.384.28.75.521 1.07zm-3.688 8.39c-1.099 0-1.992-.89-1.999-1.987l3.997 0c-.007 1.097-.9 1.987-1.998 1.987zm-6-2.987l0-1.803c0-.482.155-.96.438-1.348l1.901-2.227.022-.025.019-.026c.41-.55.636-1.241.636-1.945l0-.483c0-1.77 1.31-3.156 2.984-3.156 1.699 0 3.031 1.386 3.031 3.156l0 .106-7.751 7.751-1.28 0zM15.8535.1471c-.195-.196-.512-.196-.707 0l-3.193 3.192c-.358-1.926-1.965-3.339-3.953-3.339-2.234 0-3.984 1.825-3.984 4.156l0 .483c0 .491-.162.978-.437 1.347l-1.923 2.253c-.424.564-.656 1.265-.656 1.971l0 1.839c0 .532.433.964.963.964l.317 0-2.134 2.134c-.195.195-.195.511 0 .707.098.097.226.146.354.146.127 0 .255-.049.353-.146l2.841-2.841 1.307 0c.007 1.648 1.349 2.987 2.999 2.987 1.649 0 2.991-1.339 2.998-2.987l3.038 0c.53 0 .964-.432.964-.964l0-1.839c0-.706-.233-1.407-.657-1.971l-1.856-2.229c-.287-.384-.446-.858-.454-1.337l3.82-3.819c.195-.196.195-.512 0-.707z"],"alert-muted_18":["M13.7498681 7.907l1.6319546 2.743.0289992.044c.3779895.504.5859837 1.128.5859837 1.757l0 1.486c0 .04-.0319991.073-.070998.073l-11.22868808 0 8.31276908-8.312c.0389989.815.3109914 1.642.7399795 2.209zM9 17c-1.09996945 0-1.99394461-.893-1.99894447-1.99l3.99788897 0C10.9929446 16.107 10.0999694 17 9 17zm-6.92480764-2.99c-.03999889 0-.071998-.033-.071998-.073l0-1.486c0-.63.20799422-1.254.61598289-1.801l1.6019555-2.699c.49098636-.656.78497819-1.571.78497819-2.445l0-.511c-.00199994-1.067.41298853-2.07 1.16596761-2.824C6.92605761 1.415 7.92902975 1 9.00399989 1c1.06597041 0 2.06894251.415 2.82292161 1.17.6009833.601.9739729 1.363 1.1059693 2.191l-9.649732 9.649-1.20796644 0zM17.8537541.147c-.1959946-.196-.5119858-.196-.7079804 0l-3.3899058 3.39c-.2349935-.772-.6349824-1.486-1.2219661-2.074C11.591928.519 10.3379628 0 8.99600011 0 7.66203717 0 6.408072.52 5.46509819 1.464c-.9429738.944-1.46095942 2.198-1.45895947 3.542l0 .5c0 .666-.21899392 1.356-.61498292 1.89l-1.6019555 2.698c-.50698592.675-.78597817 1.512-.78597817 2.357l0 1.486c0 .591.48098664 1.073 1.07197023 1.073l.20799422 0-2.136940642 2.136c-.1949945839.196-.1949945839.512 0 .707.097997277.098.225993722.147.353990167.147.127996444 0 .255992889-.049.353990166-.147L3.6971473 15.01l2.303936 0C6.00608316 16.659 7.34904586 18 9 18c1.6509541 0 2.9929169-1.341 2.9989167-2.99l3.9268909 0c.5909836 0 1.0709703-.482 1.0709703-1.073l0-1.486c0-.835-.2719925-1.663-.7689787-2.335L14.579845 7.351c-.3669898-.489-.5859837-1.179-.5859837-1.845l0-.51c0-.088-.0199995-.171-.0249993-.258L17.8537541.854c.1949945-.196.1949945-.512 0-.707z"],"alert-muted_20":["M14.8872 7.8194l2.446 3.039c.43.572.667 1.282.667 1.999l0 3.004c0 .075-.064.139-.139.139l-4.458 0-1.139 0-4.529 0-1.138 0-1.89 0 9.502-9.502c.149.467.374.916.678 1.321zm-4.887 11.182c-1.165 0-2.119-.876-2.265-2.001l4.529 0c-.146 1.125-1.1 2.001-2.264 2.001zm-7.862-3.001c-.075 0-.138-.064-.138-.139l0-3.004c0-.717.237-1.427.646-1.973l2.497-3.104c.553-.738.857-1.657.857-2.587l0-.193c0-2.205 1.794-4 4-4 2.205 0 4 1.795 4 4l0 .193c0 .03.007.062.008.092l-10.715 10.715-1.155 0zM19.8532.1464c-.195-.195-.511-.195-.707 0l-4.211 4.211c-.318-2.454-2.394-4.357-4.935-4.357-2.761 0-5 2.238-5 5l0 .193c0 .716-.237 1.426-.658 1.988l-2.476 3.076c-.559.746-.866 1.669-.866 2.6l0 3.004c0 .628.511 1.139 1.138 1.139l.155 0-2.147 2.146c-.195.195-.195.512 0 .707.098.098.226.147.354.147.128 0 .256-.049.353-.147l2.854-2.853 3.028 0c.152 1.677 1.549 3.001 3.265 3.001 1.716 0 3.113-1.324 3.264-3.001l4.597 0c.628 0 1.139-.511 1.139-1.139l0-3.004c0-.931-.308-1.854-.867-2.6l-2.467-3.065c-.334-.445-.547-.975-.627-1.524l4.814-4.815c.196-.195.196-.512 0-.707z"],"alert-muted_24":["M18.13 10.493l3.049 3.702c.529.71.821 1.588.821 2.474l0 2.831c0 .276-.224.5-.5.5L4.707 20l12.32-12.32c.066.943.437 1.925 1.103 2.813zM12 23c-1.206 0-2.214-.86-2.443-2l4.886 0c-.229 1.14-1.237 2-2.443 2zm-9.5-3c-.275 0-.5-.224-.5-.5l0-2.831c0-.89.294-1.772.814-2.465l3.071-3.729C6.604 9.515 7 8.42 7 7.392L7 6c0-2.757 2.243-5 5-5 2.757 0 5 2.243 5 5l0 .293L3.293 20 2.5 20zM23.854.854c.195-.195.195-.512 0-.707-.196-.196-.512-.196-.707 0l-5.186 5.186C17.627 2.338 15.083 0 12 0 8.692 0 6 2.692 6 6l0 1.392c0 .813-.325 1.695-.901 2.465l-3.071 3.729C1.365 14.469 1 15.564 1 16.669L1 19.5c0 .763.574 1.388 1.312 1.482L.147 23.147c-.196.195-.196.512 0 .707.097.097.225.146.353.146.128 0 .256-.049.354-.146L3.707 21l4.85 0c.242 1.692 1.686 3 3.443 3 1.757 0 3.201-1.308 3.443-3l6.057 0c.827 0 1.5-.673 1.5-1.5l0-2.831c0-1.105-.365-2.2-1.028-3.083l-3.056-3.711C18.325 9.087 18 8.205 18 7.392l0-.685L23.854.854z"],"alert-muted_28":["M21.2222 12.187l3.79 4.327c.637.85.988 1.904.988 2.967l0 3.019c0 .276-.224.5-.499.5l-19.794 0 14.311-14.312c.021 1.245.434 2.474 1.204 3.499zM14.0002 27c-1.654 0-3-1.346-3-3l6 0c0 1.654-1.346 3-3 3zm-11.501-4c-.276 0-.499-.224-.499-.5l0-3.019c0-1.063.351-2.117.961-2.935l3.872-4.345c.766-1.021 1.188-2.288 1.188-3.567l0-1.634c0-3.309 2.688-6 5.993-6l.003 0c3.305 0 5.993 2.691 5.993 6l0 .283L4.2932 23l-1.794 0zM27.8532.854c.196-.196.196-.512 0-.708-.195-.195-.511-.195-.707 0l-6.171 6.171C20.6322 2.777 17.6432 0 14.0172 0l-.003 0c-3.856 0-6.993 3.14-6.993 7l0 1.634c0 1.064-.351 2.117-.961 2.935l-3.873 4.345c-.765 1.023-1.187 2.289-1.187 3.567l0 3.019c0 .827.672 1.5 1.499 1.5l.794 0-3.147 3.146c-.195.196-.195.512 0 .708.098.097.226.146.354.146.128 0 .256-.049.353-.146L4.7072 24l5.293 0c0 2.206 1.794 4 4 4 2.205 0 4-1.794 4-4l7.501 0c.826 0 1.499-.673 1.499-1.5l0-3.019c0-1.278-.422-2.544-1.212-3.597l-3.79-4.326c-.637-.851-.988-1.905-.988-2.968l0-.893 6.843-6.843z"],"alert-muted_36":["M26.99825 9.99725l0 .99c0 1.625.537 3.237 1.509 4.532l4.179 5.656.002.003c.846 1.128 1.312 2.525 1.312 3.935l0 4.218c0 .181-.07.351-.199.478-.127.127-.27.233-.478.198l-9.324-.003 0-.004-1 0c0 .002 0 .003 0 .004l-10-.002 0-.002-1 0 0 .002-5.293-.002 20.278-20.277c.003.091.014.181.014.274zm-8.999 25.003c-2.414 0-4.433-1.72-4.898-3.998l9.797.002c-.466 2.277-2.485 3.996-4.899 3.996zm-15.318-5.001c-.373 0-.677-.304-.677-.677l0-4.218c0-1.409.466-2.806 1.314-3.938l4.174-5.644c.974-1.298 1.511-2.91 1.511-4.535l0-.99c0-4.961 4.037-8.997 8.997-8.997 4.43 0 8.112 3.22 8.853 7.438l-21.56 21.562-2.612-.001zm33.172-29.853c-.195-.195-.512-.195-.707 0l-7.451 7.452c-1.079-4.356-5.01-7.598-9.695-7.598-5.512 0-9.997 4.484-9.997 9.997l0 .99c0 1.41-.465 2.808-1.313 3.939l-4.174 5.643c-.975 1.3-1.512 2.911-1.512 4.535l0 4.218c0 .925.752 1.677 1.677 1.677l1.612.001-4.147 4.146c-.195.196-.195.512 0 .707.098.098.226.147.353.147.128 0 .256-.049.354-.147l4.853-4.853 6.384.002c.479 2.832 2.943 4.998 5.909 4.998 2.966 0 5.429-2.164 5.91-4.996l9.414.003.002 0c.447 0 .867-.174 1.183-.489.317-.318.492-.739.492-1.187l0-4.218c0-1.624-.537-3.234-1.511-4.535l-4.179-5.655c-.846-1.128-1.312-2.526-1.312-3.936l0-.99c0-.409-.032-.812-.081-1.208l7.936-7.936c.195-.195.195-.511 0-.707z"],"alert-muted_8":["M7.00049975 6.002l-2.99050475 0C4.005997 6.002 4.0029985 6 4 6c-.0029985 0-.005997.002-.009995.002l-1.28435782 0 2.67566217-2.678c.023988.075.05897051.146.11494252.202l1.50424788 1.53 0 .946zm-6.0009995 0l0-.951 1.50424788-1.53c.09195402-.094.14392803-.22.14392803-.351l0-.816C2.64767616 1.607 3.25437281 1 4 1c.62068966 0 1.13943028.424 1.29835082.994l-4.005997 4.008-.29285357 0zM7.85607196 4.5L6.35182409 2.971l0-.617 1.50024987-1.5c.19490255-.196.19490255-.512 0-.707-.19590205-.196-.51174412-.196-.70664667 0L6.05697151 1.235C5.65717141.504 4.89055472 0 4 0 2.70364818 0 1.64817591 1.056 1.64817591 2.354l0 .611-1.504247874 1.53C.051974013 4.589 0 4.715 0 4.846l0 1.421c0 .278.16191904.512.390804598.637l-.241879061.243c-.1959020487.195-.1959020487.511 0 .707.096951524.097.224887556.146.352823588.146.127936032 0 .255872064-.049.353823089-.146l.850574716-.852 1.29535232 0C3.00249875 7.553 3.44827586 8 4 8c.55172414 0 .99850075-.447.99950025-.998l2.26586707 0C7.67016492 7.002 8 6.672 8 6.267l0-1.416c0-.131-.05197401-.257-.14392804-.351z"],"alert-muted-active_10":["M7.9727 2.7344l-6.266 6.266-.515.515-.338.338c-.098.098-.226.147-.354.147-.128 0-.256-.049-.353-.147-.195-.195-.195-.512 0-.707l.292-.292c-.258-.159-.439-.43-.439-.753l0-1.599c0-.398.162-.786.445-1.066l1.466-1.45c.056-.056.089-.133.089-.213l0-.773c0-1.657 1.343-3 3-3 1.163 0 2.16.668 2.658 1.635l1.489-1.489c.195-.195.512-.195.707 0 .195.195.195.512 0 .707l-.615.615-1.266 1.266zM3.5859 9l-.465 0 4.991-4.991 1.446 1.43c.281.281.442.667.442 1.064l0 1.598c0 .496-.404.899-.9.899l-2.698 0c-.207.581-.756 1-1.408 1-.652 0-1.201-.419-1.408-1z"],"alert-muted-active_12":["M9.413 4.709l.999.999c.375.375.586.883.586 1.413l0 1.878c0 .553-.448 1-1 1L8 9.999l0 .002C8 11.105 7.104 12 6 12c-1.067 0-1.931-.837-1.988-1.889l1.111-1.112 3.584-3.584.706-.706zM6 11.001c.551 0 1-.448 1-1C7 10 6.999 10 6.999 9.999L5 9.999l0 .002c0 .552.449 1 1 1zM11.8535.147c.195.195.195.512 0 .707l-.458.459-2.397 2.397-.87.869-4.42 4.42-1 1-.297.298-1.557 1.557c-.099.098-.227.146-.355.146-.127 0-.255-.048-.353-.146-.195-.195-.195-.512 0-.707l1.322-1.323c-.275-.177-.469-.472-.469-.825l0-1.877c0-.531.211-1.04.586-1.415l1.121-1.12c.188-.187.293-.442.293-.707l0-.88c0-1.657 1.342-3 3-3 .053 0 .108.002.162.004 1.357.073 2.419 1.107 2.733 2.394l2.251-2.251c.196-.195.513-.195.708 0z"],"alert-muted-active_16":["M7.9995 15.9998c-1.616 0-2.929-1.288-2.988-2.89l7.347-7.347c.046.082.073.172.129.247l1.856 2.229c.424.564.656 1.265.656 1.971l0 1.839c0 .532-.433.964-.963.964l-3.038 0c-.007 1.648-1.349 2.987-2.999 2.987zm1.999-2.987l-3.997 0c.007 1.097.9 1.987 1.998 1.987 1.099 0 1.992-.89 1.999-1.987zM15.8535.1466c.195.195.195.512 0 .707l-1.938 1.938-1.882 1.882-8.339 8.339-.196.196-2.645 2.645c-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147-.195-.195-.195-.512 0-.707l2.134-2.134-.317 0c-.53 0-.964-.431-.964-.964l0-1.839c0-.706.233-1.407.657-1.971l1.923-2.253c.274-.369.437-.856.437-1.347l0-.483c0-2.331 1.75-4.155 3.983-4.155 1.989 0 3.596 1.413 3.954 3.339l3.193-3.193c.195-.195.512-.195.707 0z"],"alert-muted-active_18":["M17.854.147c.195.195.195.511 0 .707l-3.885 3.884 0 .001-5.416 5.415-3.856 3.856-1 1-2.843 2.843C.756 17.951.628 18 .5 18c-.128 0-.256-.049-.354-.147-.195-.195-.195-.511 0-.706l2.137-2.137-.208 0c-.591 0-1.072-.482-1.072-1.072l0-1.487c0-.846.279-1.682.786-2.357l1.602-2.698c.396-.534.615-1.224.615-1.89l0-.5c-.002-1.344.516-2.598 1.459-3.542C6.408.52 7.662 0 8.996 0c1.342 0 2.596.519 3.538 1.463.587.588.987 1.302 1.222 2.074l3.39-3.39c.196-.196.512-.196.708 0zM14.58 7.351l1.648 2.765c.497.672.769 1.5.769 2.335l0 1.486c0 .591-.48 1.073-1.071 1.073l-3.927 0C11.993 16.659 10.651 18 9 18c-1.651 0-2.994-1.341-2.999-2.99l-.89 0 1-1 7.121-7.12.817-.818c.085.474.268.929.531 1.279zM9 17c1.1 0 1.993-.893 1.999-1.99l-3.998 0C7.006 16.107 7.9 17 9 17z"],"alert-muted-active_20":["M15.666 7.1917l2.467 3.066c.559.745.867 1.669.867 2.599l0 3.004c0 .628-.511 1.139-1.139 1.139l-4.596 0c-.152 1.678-1.549 3.001-3.265 3.001-1.716 0-3.113-1.323-3.265-3.001l-1.613 0L15.4 6.7227c.083.16.158.325.266.469zM10 19.0007c1.165 0 2.119-.875 2.265-2.001l-4.53 0c.146 1.126 1.1 2.001 2.265 2.001zM19.8535.1472c.195.195.195.512 0 .707l-1.614 1.614-3.2 3.2-11.332 11.332-.25.25-2.604 2.604c-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147-.195-.195-.195-.512 0-.707l2.147-2.147-.155 0c-.628 0-1.139-.511-1.139-1.139l0-3.004c0-.931.308-1.855.867-2.6l2.476-3.076c.421-.562.657-1.272.657-1.988l0-.193c0-2.761 2.239-5 5-5 2.542 0 4.618 1.903 4.936 4.358l4.211-4.211c.195-.195.512-.195.707 0z"],"alert-muted-active_24":["M23.854.147c.195.195.195.512 0 .707L18 6.707l0 .001-.973.973L4.708 20l-1 1-.001 0-2.853 2.854C.756 23.951.628 24 .5 24c-.128 0-.256-.049-.353-.146-.196-.195-.196-.512 0-.707l2.165-2.165C1.574 20.888 1 20.263 1 19.5l0-2.831c0-1.105.365-2.2 1.028-3.083l3.071-3.729C5.675 9.087 6 8.205 6 7.392L6 6c0-3.308 2.692-6 6-6 3.083 0 5.627 2.338 5.961 5.333L23.147.147c.195-.196.511-.196.707 0zm-4.938 9.728l3.056 3.711c.663.883 1.028 1.978 1.028 3.083l0 2.831c0 .827-.673 1.5-1.5 1.5l-6.057 0c-.242 1.692-1.686 3-3.443 3-1.757 0-3.201-1.308-3.443-3l-3.435 0 1-1L17.274 8.848l.797-.797c.124.616.411 1.245.845 1.824zM12 23c1.206 0 2.214-.86 2.443-2l-4.886 0c.229 1.14 1.237 2 2.443 2z"],"alert-muted-active_36":["M35.8535.1464c.194.196.194.512 0 .707l-17.875 17.875-12.272 12.272-4.853 4.853c-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147-.195-.195-.195-.512 0-.707l4.147-4.146-1.612-.001c-.925 0-1.677-.752-1.677-1.677l0-4.218c0-1.624.536-3.235 1.512-4.535l4.174-5.643c.848-1.131 1.313-2.529 1.313-3.939l0-.99c0-5.513 4.485-9.997 9.996-9.997 4.686 0 8.617 3.242 9.696 7.598l7.451-7.452c.098-.098.226-.146.353-.146.128 0 .256.048.354.146zM29.637 15.365l3.852 5.213C34.463 21.879 35 23.489 35 25.113l0 4.218c0 .448-.175.869-.492 1.188-.316.314-.736.488-1.183.488l-.002 0-9.414-.003C23.428 33.836 20.965 36 17.999 36c-2.966 0-5.43-2.166-5.909-4.998l-4.97-.001 20.878-20.878 0 .864c0 1.41.466 2.808 1.313 3.936l.326.442zM17.999 35c2.414 0 4.434-1.719 4.899-3.996l-9.797-.002C13.566 33.28 15.585 35 17.999 35z"],"alert-muted-active_8":["M7.8555 4.50002c.093.094.145.22.145.351l0 1.416c0 .405-.331.735-.736.735l-2.264 0c-.001.551-.449.998-1 .998-.517 0-.926-.396-.979-.898l1.1-1.1 1.92-1.921.707-.707 1.107 1.126zm-1.5039-2.145l-.97.971-2.675 2.676-1 1-.001 0-.85.852c-.098.097-.226.146-.354.146-.128 0-.255-.049-.352-.146-.196-.196-.196-.512 0-.707l.241-.243c-.228-.125-.391-.359-.391-.637l0-1.421c0-.131.052-.257.145-.351l1.504-1.53 0-.611c0-1.298 1.056-2.354 2.351-2.354.891 0 1.658.504 2.057 1.235l1.088-1.088c.195-.196.512-.196.707 0 .195.195.195.511 0 .707l-1.5 1.5 0 .001z"],"allow-to-annotate_16":["M16 3.8369c0 .534-.208 1.037-.585 1.414l-9.352 9.353c-.073.073-.162.128-.259.162l-3.595 1.199c-.067.023-.141.035-.211.035-.174 0-.343-.069-.471-.196l-1.333-1.333c-.176-.178-.24-.443-.16-.682l1.203-3.591c.032-.096.087-.186.16-.258l9.351-9.354c.378-.378.88-.586 1.414-.586l.001 0c.534 0 1.035.208 1.412.585l1.84 1.838c.377.378.585.88.585 1.414zm-1.293.707c.189-.189.293-.44.293-.707 0-.267-.104-.518-.293-.707l-1.839-1.838c-.191-.191-.435-.292-.705-.292l-.001 0c-.268 0-.518.104-.706.293l-9.052 9.053 3.252 3.251 9.051-9.053zM2.09 14.9509l2.629-.878-2.79-2.789-.88 2.627 1.041 1.04zm13.7635-2.8083c.065.065.101.146.122.229.005.02.009.038.012.059.012.087.008.174-.026.256l0 .001c-.001.002-.003.003-.004.005-.024.056-.057.11-.104.157l-2.002 2.002c-.098.098-.226.146-.353.146-.128 0-.256-.048-.354-.146-.195-.195-.195-.512 0-.707l1.148-1.148-3.793 0c-.276 0-.5-.224-.5-.5 0-.277.224-.5.5-.5l3.793 0-1.144-1.145c-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0l1.998 1.998z"],"analysis_16":["M15.5 14c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-15 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l15 0zM1.944 13c-.52 0-.944-.424-.944-.944l0-6.111C1 5.424 1.424 5 1.944 5l2.112 0c.52 0 .944.424.944.945l0 6.111c0 .52-.424.944-.944.944l-2.112 0zM2 6l0 6 2 0 0-6-2 0zm4.945 7C6.424 13 6 12.576 6 12.056l0-3.112c0-.52.424-.944.945-.944l2.109 0c.521 0 .945.424.945.944l0 3.112c0 .52-.424.944-.945.944l-2.109 0zM7 12l2 0 0-3-2 0 0 3zm4.944 1c-.52 0-.944-.424-.944-.944l0-10.112c0-.52.424-.944.944-.944l2.112 0c.52 0 .944.424.944.944l0 10.112c0 .52-.424.944-.944.944l-2.112 0zM12 12l2 0 0-10-2 0 0 10z"],"analysis_20":["M18.5 17c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-17 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l17 0zM15 15c-.552 0-1-.447-1-1l0-11c0-.553.448-1 1-1l2 0c.552 0 1 .447 1 1l0 11c0 .553-.448 1-1 1l-2 0zm0-1l2 0 0-11-2 0 0 11zm-6 1c-.552 0-1-.447-1-1l0-4c0-.553.448-1 1-1l2 0c.552 0 1 .447 1 1l0 4c0 .553-.448 1-1 1l-2 0zm0-1l2 0 0-4-2 0 0 4zm-6 1c-.552 0-1-.447-1-1l0-7c0-.553.448-1 1-1l2 0c.552 0 1 .447 1 1l0 7c0 .553-.448 1-1 1l-2 0zm0-1l2 0 0-7-2 0 0 7z"],"analysis_24":["M22.5 21l-20 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l20 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5zm-16-3l-2 0c-.827 0-1.5-.673-1.5-1.5l0-8C3 7.673 3.673 7 4.5 7l2 0C7.327 7 8 7.673 8 8.5l0 8c0 .827-.673 1.5-1.5 1.5zm-2-10c-.276 0-.5.225-.5.5l0 8c0 .275.224.5.5.5l2 0c.276 0 .5-.225.5-.5l0-8c0-.275-.224-.5-.5-.5l-2 0zm9 10l-2 0c-.827 0-1.5-.673-1.5-1.5l0-4c0-.827.673-1.5 1.5-1.5l2 0c.827 0 1.5.673 1.5 1.5l0 4c0 .827-.673 1.5-1.5 1.5zm-2-6c-.276 0-.5.225-.5.5l0 4c0 .275.224.5.5.5l2 0c.276 0 .5-.225.5-.5l0-4c0-.275-.224-.5-.5-.5l-2 0zm9 6l-2 0c-.827 0-1.5-.673-1.5-1.5l0-12c0-.827.673-1.5 1.5-1.5l2 0c.827 0 1.5.673 1.5 1.5l0 12c0 .827-.673 1.5-1.5 1.5zm-2-14c-.276 0-.5.225-.5.5l0 12c0 .275.224.5.5.5l2 0c.276 0 .5-.225.5-.5l0-12c0-.275-.224-.5-.5-.5l-2 0z"],"analysis_32":["M29.5 28c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-26 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l26 0zm-24-4c-.827 0-1.5-.673-1.5-1.5l0-10c0-.827.673-1.5 1.5-1.5l4 0c.827 0 1.5.673 1.5 1.5l0 10c0 .827-.673 1.5-1.5 1.5l-4 0zM5 12.5l0 10c0 .275.224.5.5.5l4 0c.276 0 .5-.225.5-.5l0-10c0-.275-.224-.5-.5-.5l-4 0c-.276 0-.5.225-.5.5zM14.5 24c-.827 0-1.5-.673-1.5-1.5l0-7c0-.827.673-1.5 1.5-1.5l4 0c.827 0 1.5.673 1.5 1.5l0 7c0 .827-.673 1.5-1.5 1.5l-4 0zm-.5-8.5l0 7c0 .275.224.5.5.5l4 0c.276 0 .5-.225.5-.5l0-7c0-.275-.224-.5-.5-.5l-4 0c-.276 0-.5.225-.5.5zm9.5 8.5c-.827 0-1.5-.673-1.5-1.5l0-18c0-.827.673-1.5 1.5-1.5l4 0c.827 0 1.5.673 1.5 1.5l0 18c0 .827-.673 1.5-1.5 1.5l-4 0zM23 4.5l0 18c0 .275.224.5.5.5l4 0c.276 0 .5-.225.5-.5l0-18c0-.275-.224-.5-.5-.5l-4 0c-.276 0-.5.225-.5.5z"],"analysis_36":["M4 13.5001c0-.276.225-.5.5-.5l5 0c.275 0 .5.224.5.5l0 12c0 .276-.225.5-.5.5l-5 0c-.275 0-.5-.224-.5-.5l0-12zm.5 13.5c-.828 0-1.5-.671-1.5-1.5l0-12c0-.829.672-1.5 1.5-1.5l5 0c.828 0 1.5.671 1.5 1.5l0 12c0 .829-.672 1.5-1.5 1.5l-5 0zm22 0c-.828 0-1.5-.671-1.5-1.5l0-21c0-.829.672-1.5 1.5-1.5l5 0c.829 0 1.5.671 1.5 1.5l0 21c0 .829-.671 1.5-1.5 1.5l-5 0zm-.5-22.5l0 21c0 .276.225.5.5.5l5 0c.276 0 .5-.224.5-.5l0-21c0-.276-.224-.5-.5-.5l-5 0c-.275 0-.5.224-.5.5zm-10.5 22.5c-.828 0-1.5-.671-1.5-1.5l0-8c0-.829.672-1.5 1.5-1.5l5 0c.829 0 1.5.671 1.5 1.5l0 8c0 .829-.671 1.5-1.5 1.5l-5 0zm-.5-9.5l0 8c0 .276.225.5.5.5l5 0c.275 0 .5-.224.5-.5l0-8c0-.276-.225-.5-.5-.5l-5 0c-.275 0-.5.224-.5.5zm19.5 14.5c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-33 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l33 0z"],"analysis-active_16":["M15.5 14c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-15 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l15 0zM1.944 13c-.52 0-.944-.424-.944-.944l0-6.111C1 5.424 1.424 5 1.944 5l2.112 0c.52 0 .944.424.944.945l0 6.111c0 .52-.424.944-.944.944l-2.112 0zm5.001 0C6.424 13 6 12.576 6 12.056l0-3.112c0-.52.424-.944.945-.944l2.109 0c.521 0 .945.424.945.944l0 3.112c0 .52-.424.944-.945.944l-2.109 0zm4.999 0c-.52 0-.944-.424-.944-.944l0-10.112c0-.52.424-.944.944-.944l2.112 0c.52 0 .944.424.944.944l0 10.112c0 .52-.424.944-.944.944l-2.112 0z"],"analysis-active_20":["M18.5 17c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-17 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l17 0zM15 15c-.552 0-1-.447-1-1l0-11c0-.553.448-1 1-1l2 0c.552 0 1 .447 1 1l0 11c0 .553-.448 1-1 1l-2 0zm-6 0c-.552 0-1-.447-1-1l0-4c0-.553.448-1 1-1l2 0c.552 0 1 .447 1 1l0 4c0 .553-.448 1-1 1l-2 0zm-6 0c-.552 0-1-.447-1-1l0-7c0-.553.448-1 1-1l2 0c.552 0 1 .447 1 1l0 7c0 .553-.448 1-1 1l-2 0z"],"analysis-active_24":["M22.5 21l-20 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l20 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5zm-16-3l-2 0c-.827 0-1.5-.673-1.5-1.5l0-8C3 7.673 3.673 7 4.5 7l2 0C7.327 7 8 7.673 8 8.5l0 8c0 .827-.673 1.5-1.5 1.5zm7 0l-2 0c-.827 0-1.5-.673-1.5-1.5l0-4c0-.827.673-1.5 1.5-1.5l2 0c.827 0 1.5.673 1.5 1.5l0 4c0 .827-.673 1.5-1.5 1.5zm7 0l-2 0c-.827 0-1.5-.673-1.5-1.5l0-12c0-.827.673-1.5 1.5-1.5l2 0c.827 0 1.5.673 1.5 1.5l0 12c0 .827-.673 1.5-1.5 1.5z"],"analysis-active_32":["M29.5 28c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-26 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l26 0zm-24-4c-.827 0-1.5-.673-1.5-1.5l0-10c0-.827.673-1.5 1.5-1.5l4 0c.827 0 1.5.673 1.5 1.5l0 10c0 .827-.673 1.5-1.5 1.5l-4 0zm9 0c-.827 0-1.5-.673-1.5-1.5l0-7c0-.827.673-1.5 1.5-1.5l4 0c.827 0 1.5.673 1.5 1.5l0 7c0 .827-.673 1.5-1.5 1.5l-4 0zm9 0c-.827 0-1.5-.673-1.5-1.5l0-18c0-.827.673-1.5 1.5-1.5l4 0c.827 0 1.5.673 1.5 1.5l0 18c0 .827-.673 1.5-1.5 1.5l-4 0z"],"analysis-active_36":["M4.5 27.0001c-.828 0-1.5-.671-1.5-1.5l0-12c0-.829.672-1.5 1.5-1.5l5 0c.828 0 1.5.671 1.5 1.5l0 12c0 .829-.672 1.5-1.5 1.5l-5 0zm22 0c-.828 0-1.5-.671-1.5-1.5l0-21c0-.829.672-1.5 1.5-1.5l5 0c.829 0 1.5.671 1.5 1.5l0 21c0 .829-.671 1.5-1.5 1.5l-5 0zm-11 0c-.828 0-1.5-.671-1.5-1.5l0-8c0-.829.672-1.5 1.5-1.5l5 0c.829 0 1.5.671 1.5 1.5l0 8c0 .829-.671 1.5-1.5 1.5l-5 0zm19 5c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-33 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l33 0z"],"angellist_16":["M7.8369 9.1152c.224.083.46.148.706.192.247.045.509.074.784.087-.186.122-.364.262-.534.418-.17.157-.331.332-.485.524-.052-.198-.117-.4-.198-.605-.08-.205-.171-.41-.273-.616zm3.101 3.842c-.843.932-1.89 1.399-3.14 1.399-.68 0-1.3-.137-1.86-.409-.562-.272-1.031-.662-1.409-1.168-.251-.327-.441-.653-.572-.976-.132-.324-.197-.617-.197-.88 0-.327.095-.611.283-.851.19-.24.396-.361.62-.361.103 0 .239.076.409.226.17.151.383.39.64.717.224.282.4.535.528.759.128.225.193.385.193.481 0 .083-.048.163-.145.241-.096.076-.205.115-.326.115-.359 0-.75-.292-1.174-.875-.16-.212-.285-.372-.375-.481-.038.038-.065.085-.081.139-.016.055-.024.118-.024.188 0 .378.208.765.625 1.159.417.394.827.591 1.23.591.257 0 .478-.085.664-.255.186-.169.279-.373.279-.61 0-.039-.005-.092-.014-.159-.01-.067-.025-.136-.044-.207.064.02.122.034.173.043.052.01.106.015.164.015.057 0 .11-.01.158-.029.049-.019.098-.051.149-.096l0 .087c0 .519.083.934.246 1.245.163.311.385.476.668.495l.019-.087 0-.067c0-.07-.05-.255-.149-.553-.1-.298-.149-.553-.149-.764 0-.347.116-.713.351-1.102.234-.387.543-.722.928-1.004.179-.128.439-.258.779-.39.34-.131.563-.248.673-.351-.02-.134-.056-.235-.111-.302-.054-.068-.127-.101-.216-.101l-.394 0c-1.09 0-1.879-.098-2.366-.293-.487-.196-.731-.512-.731-.948 0-.186.048-.317.145-.394.096-.077.26-.115.49-.115.827 0 1.62.086 2.38.259.76.173 1.27.369 1.533.587.148.115.254.3.318.553.064.253.096.594.096 1.024 0 1.404-.422 2.572-1.264 3.505zm-5.673-5.183c.163-.17.312-.255.447-.255.166 0 .343.082.528.245.187.164.375.406.568.726.262.43.482.867.659 1.312.176.446.264.73.264.852 0 .115-.045.222-.135.322-.09.099-.189.149-.298.149-.148 0-.346-.106-.596-.318-.25-.211-.516-.506-.798-.884-.269-.346-.484-.673-.644-.981-.16-.307-.24-.538-.24-.692 0-.148.081-.306.245-.476zm.716-4.034c-.225-.73-.336-1.244-.336-1.539 0-.172.041-.31.125-.413.083-.102.192-.153.326-.153.174 0 .334.116.481.35.148.234.356.733.625 1.496l1.038 3c-.262-.026-.452-.042-.567-.049-.115-.006-.192-.009-.231-.009-.122 0-.217.014-.288.043-.071.029-.125.079-.164.149-.448-1.186-.785-2.144-1.009-2.875zm4.375.077c.224-.66.429-1.139.615-1.437.186-.299.369-.448.549-.448.14 0 .251.052.331.154.08.103.121.247.121.433 0 .173-.121.639-.362 1.399-.24.76-.575 1.723-1.004 2.889l-1.211-.211.961-2.779zm2.164 3.885c-.238-.379-.645-.622-1.222-.731.436-1.211.762-2.192.976-2.942.215-.75.323-1.266.323-1.548 0-.372-.099-.669-.294-.89-.195-.221-.457-.344-.783-.331-.917.033-1.462 1.333-2.385 4-.129.365-.228.647-.298.846-.084-.25-.206-.606-.366-1.068-.923-2.692-1.492-4.038-2.288-4.038-.353 0-.632.117-.837.351-.205.234-.308.549-.308.947 0 .288.112.812.337 1.572.225.76.583 1.838 1.077 3.236-.167-.096-.314-.165-.442-.207-.129-.042-.25-.063-.365-.063-.27 0-.557.151-.862.452-.303.302-.456.597-.456.885 0 .083.023.202.068.356.044.153.115.343.211.567-.513.109-.888.314-1.125.615-.238.302-.356.728-.356 1.279 0 .494.115.976.346 1.447.231.471.577.919 1.039 1.342.403.384.886.684 1.447.898.561.215 1.139.323 1.735.323 1.513 0 2.755-.515 3.726-1.543.972-1.029 1.457-2.351 1.457-3.967 0-.814-.119-1.41-.355-1.788z"],"annotation_10":["M7.3 10c-.3 0-.6-.1-.8-.3-1-.8 0-2.1.7-3.2.3-.4.9-1.2.8-1.5-.3-.2-1.3.8-1.9 1.3C5 7.4 3.5 8.7 2.3 7.6c-.8-1.1.3-2.5 1.3-3.9.7-.9 1.7-2.2 1.3-2.6-.1 0-.2-.1-.4-.1-1 .1-2.8 1.9-3.6 3.1-.2.2-.5.2-.7.1C0 4-.1 3.7.1 3.5.4 3.1 2.7.1 4.5 0c.4 0 .8.1 1.1.4 1 1-.1 2.5-1.2 3.9-.7.9-1.7 2.2-1.3 2.6.4.4 1.3-.3 2.4-1.4 1.1-1 2.2-2.1 3.2-1.3.8.8 0 1.9-.7 2.9-.5.7-1.2 1.6-.9 1.8 0 0 .1.1.2 0 .5 0 1.4-.9 1.8-1.4.2-.2.5-.3.7-.1.2.2.3.6.1.8-.2.3-1.4 1.7-2.5 1.8-.1 0-.1 0-.1 0"],"annotation_12":["M9.08223067 10.9819518c-.028 0-.055-.001-.083-.003-.353-.029-.647-.228-.831-.562-.372-.679.175-1.66.867-2.902.368-.662 1.23200003-2.213.919-2.409-.506-.318-1.921 1.344-2.77 2.333-1.123 1.31-2.094 2.441-3 2.485-.312.01-.582-.09-.805-.303-.888-.85.067-2.42 1.174-4.237.708-1.161 1.589-2.608 1.439-3.192-.015-.058-.039-.103-.116-.147-.75-.425999997-3.292 1.645-4.990000004 3.708-.176.213-.491.244-.704.068-.2129999996-.175-.2439999996-.49-.068-.704.172-.208 4.236000004-5.099999997 6.259000004-3.938999997.3.172.503.436.587.765.256.992999997-.623 2.434999997-1.553 3.961999997-.533.876-1.644 2.699-1.337 2.993l.003 0c.542 0 1.588-1.219 2.352-2.11 1.456-1.696 2.829-3.298 4.05900003-2.53 1.119.701.219 2.317-.57600003 3.744-.347.625-.93 1.67-.857 1.948.289.101 1.27500003-.687 2.11400003-1.763.169-.219.483-.259.702-.088.217.17.257.484.087.702-.405.52-1.785 2.181-2.87200003 2.181"],"annotation_14":["M10.3194411 13c-.0628601 0-.1247224-.0040357-.1865847-.012107-.40010943-.0524638-.7223921-.272408-.92993017-.6356186-.52483184-.916098.35022049-2.10763069 1.36496187-3.48884004.6695099-.91206228 1.504651-2.04911338 1.4178442-2.59998285-.0099778-.0655797-.0349222-.13620399-.1446779-.21590855-.641572-.45905789-2.33280774 1.18043459-3.57105169 2.37398512-1.43081533 1.38120935-2.81074392 2.69683902-3.91029657 2.65345552-.37217163-.0090803-.70542987-.16243587-.96585024-.44190628-1.09057263-1.17236324.31729378-3.01162158 1.67926235-4.7903448.90099459-1.17740783 2.02249838-2.64336634 1.88779819-3.37483222-.01995559-.1039186-.07084232-.24214042-.29733819-.37935333-.93791243-.568021091-3.67282513 1.76459837-5.77913696 4.35146527-.174611355.21489963-.489909573.2461761-.702436536.06860645-.2125269633-.17656072-.2434581176-.49437004-.068846763-.71027858C1.24763291 4.40603265 5.10105606-.04127988 7.17943008 1.223903855c.42305836.258283123.67948761.614431336.76230328 1.058355455.21651808 1.17639891-.89899903 2.63428607-2.07937179 4.1779313C4.86059128 7.76875784 3.6143651 9.39715222 4.12123692 9.94095926c.07882455.08575807.15764911.12308805.26540926.12611481l.01496669 0c.718401 0 2.08236512-1.31562966 3.17992221-2.37499403 1.81595809-1.75148243 3.53114052-3.40610869 4.83623562-2.46680561.3063182.2189353.496894.52362867.5537675.8807858.1526602.96856171-.700441 2.12982685-1.6034312 3.35969844-.5597541.76274235-1.4976665 2.03902423-1.301104 2.38104753.058869.1029097.1187357.1301505.1965625.1412486.650552.086767 2.0763784-1.02304331 2.8855774-1.8372405.1945669-.19774802.5108629-.1967391.7054298.00100892.194567.19774801.1935692.51656624-.0009978.71330534C13.48739 11.2343927 11.6654452 13 10.3194411 13"],"annotation_16":["M11.4468 15.0002105c-.024 0-.048 0-.071-.0010005-.469-.0220125-.86-.2451386-1.132-.6433636-.7-1.0235783.288-2.5104185 1.335-4.08430776.875-1.31574344 1.867-2.80558526 1.234-3.23082553-.482-.32618431-2.065 1.18466938-3.111 2.18223304-1.889 1.80301875-3.843 3.66607145-5.235 2.33531955-1.161-1.11062755.194-3.09074639 1.629-5.18793138.948-1.38478245 2.128-3.10875656 1.943-3.91521224-.023-.10305823-.077-.23713399-.287-.3582024-1.056-.599338647-3.812 1.48483899-6.866 5.19693646-.176.21312042-.49.24413795-.704.06803845-.213-.17609951-.243-.49127759-.068-.70439801 2.107-2.56144732 5.968-6.67277037 8.135-5.428067063.404.231130598.668.577326211.765 1.002566483.282 1.23369709-.872 2.91964971-2.093 4.70365774-.975 1.42480507-2.31 3.37590752-1.763 3.8992032.699.67237996 2.45-.99456197 3.854-2.33632011 1.721-1.64192775 3.208-3.06273055 4.359-2.28829297 1.459.98055405.175 2.91164519-.959 4.61560799-.701 1.05459585-1.662 2.49841165-1.343 2.96567575.095.138078.2.200113.353.2081176.927.0260147 2.763-1.7139685 3.692-2.8316.175-.21211985.49-.24113625.704-.0640362.212.1760995.241.4922782.065.704398-.275.3301866-2.702 3.1918035-4.436 3.1918035"],"annotation_18":["M13.3372206 17c-.315 0-.759-.1070663-1.097-.6173823-.619-.9355794.199-2.5856012 1.234-4.6728937.853-1.71806394 2.02-4.07052071 1.287-4.56582743-.932-.63139099-2.912 1.5439561-4.503 3.29003737-1.701 1.86715626-3.303 3.63525116-4.694 3.60022946-.469-.0110068-.89-.2241388-1.217-.6193836-1.095-1.317816.491-3.62524491 2.172-6.06875807 1.219-1.77409861 2.602-3.78634471 2.394-4.77795877-.04-.18911711-.139-.32420076-.322-.43727078-1.476-.912565109-5.484 2.7767195-7.694000005 5.67251273-.168.2191357-.481.26316296-.701.09405824-.2189999997-.16710348-.2609999997-.48129804-.094-.70043374C1.7592206 5.02458417 6.6082206-.26869371 9.1162206 1.279264869c.418.258159867.679.622385415.775 1.082670451.297 1.41187431-1.085 3.42311978-2.549 5.55143775-1.264 1.83813827-2.837 4.12655543-2.226 4.86201083.185.2231382.349.255158.471.2581599l.016 0c.935 0 2.518-1.7380764 3.916-3.27302688 2.134-2.34545243 4.149-4.55982369 5.801-3.44613403 1.459.98460972.234 3.45313837-.95 5.84061681-.636 1.2817938-1.597 3.219994-1.296 3.6752759.103.1560967.156.150093.264.1691048.877-.0020013 2.717-2.2103688 3.743-3.7783398.152-.2311431.462-.2961834.693-.1450898.23.1510935.295.4622862.144.6924288-.462.7064374-2.852 4.2266173-4.578 4.2316204l-.003 0z"],"annotation_20":["M14.456819 19c-.0552161 0-.1084244-.0030049-.1606288-.0080131-.3443481-.0370605-.8182033-.2083403-1.125406-.8133284-.5441303-1.0667424.5411185-2.8927248 1.7990433-5.0081801 1.1013116-1.8550298 2.6112229-4.39517874 1.7709332-4.96010145-1.1444807-.77526627-3.3089546 1.40729859-5.2164223 3.33043975-1.77896467 1.7919268-3.45954414 3.4846916-4.86605061 3.4846916l-.00803144 0c-.45980012-.0020032-.86137227-.1762879-1.1926693-.5168441-1.31916453-1.3582185.3272813-3.88133957 2.07211232-6.5527028 1.26495229-1.9391673 2.69956883-4.1367567 2.44758228-5.25858903-.05320831-.23438282-.1817114-.40766585-.40458394-.54589162C8.04371173 1.208941271 3.96675042 4.79579981.90074702 8.80234383c-.167656375.21935828-.482890517.26343027-.703755202.09515542-.2198607546-.16827485-.2620258309-.48278856-.094369456-.70214684C.79834612 7.28686855 6.9855691-.62104771 10.0997612 1.300090147c.4567883.280458082.7449163.67710594.8573565 1.178925583.3433442 1.53350472-1.08022909 3.7140663-2.58612467 6.02383893C7.0548403 10.51814631 5.4164259 13.0272445 6.179413 13.8115255c.14255811.1472405.28009658.2153517.47987872.2123468.98686357 0 2.66844697-1.6927648 4.15125218-3.18720574 2.2899652-2.30776936 4.658237-4.69066142 6.4914139-3.4576475 1.6263672 1.09478816.0532083 3.74211214-1.4697541 6.30229374-.8694037 1.4633902-2.0610691 3.4676639-1.7679214 4.0436046.1124402.217355.2288961.2584221.3393284.2704417 1.0230051.1121832 3.361159-2.1505125 4.7064257-3.7881874.1756878-.2143501.4909219-.2454008.7057631-.0701145.2148411.1752863.2459629.4908016.0702751.7041501C19.3047989 15.5503656 16.3763339 19 14.456819 19"],"annotation_24":["M17.7560364 22.0003005c-.0750958 0-.1481889-.0039882-.2212821-.0129618-.5597136-.0658062-1.0072841-.3748959-1.2926479-.8943661-.6348093-1.1536027.4806127-3.1098416 1.7722593-5.3751703 1.2265637-2.1536575 2.7545116-4.83276761 1.6641215-5.51276503-1.4568573-.9113162-3.9860816 1.60128426-6.2139218 3.81875383-2.6353597 2.6212804-5.12353168 5.0939983-6.90480253 3.3989901-1.55798619-1.4846278.40551697-4.385086 2.48416693-7.45604215 1.5299504-2.26034335 3.2651626-4.82379405 2.958772-6.13293866-.0660843-.28715434-.2332974-.49853184-.5246689-.66404441C9.57060122 2.0829565801 4.7074014 6.18986185.886530384 10.80925785c-.175223383.21337163-.491626748.24228648-.70389736.0687974-.2142731649-.17548321-.2443114591-.48955827-.0680868-.70193283C1.48729627 8.51501434 8.51225199.33211277 11.9776699 2.305301779c.532679.304104421.8701092.742812441 1.0012764 1.302165161.4045157 1.73289666-1.3006581 4.25048244-3.1049583 6.9166307-1.67413427 2.47271796-3.5705519 5.27446686-2.62134181 6.17780656 1.07637221 1.0239844 3.32724171-1.2174148 5.50501801-3.3840341 2.6143329-2.6003421 5.3187807-5.28543458 7.4525008-3.95834283 1.9034266 1.18650577.2623345 4.06502863-1.32569 6.84982743-.9482089 1.6660934-2.1307164 3.7379917-1.7642492 4.4040303.1311672.2382982.2943753.3559517.5316778.3838695 1.2946505.1505566 4.0531672-2.2663258 5.4769823-3.8287245.1872387-.203401.5036421-.218357.7069012-.0339002.2042604.1854538.2202808.500526.0340434.703927-.398508.438708-3.8589195 4.1617437-6.1137941 4.1617437"],"annotation-legacy_16":["M12 0c1.105 0 2 .895 2 2l0 12c0 1.105-.895 2-2 2l-8 0c-1.105 0-2-.895-2-2L2 2c0-1.105.895-2 2-2l8 0zm1 14l0-12c0-.551-.449-1-1-1L4 1c-.551 0-1 .449-1 1l0 12c0 .551.449 1 1 1l8 0c.551 0 1-.449 1-1zm-5.5-3l3 0c.27614237 0 .5.2238576.5.5 0 .2761424-.22385763.5-.5.5l-3 0c-.27614237 0-.5-.2238576-.5-.5 0-.2761424.22385763-.5.5-.5zm0-3.5l3 0c.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5l-3 0c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5zm0-3.5l3 0c.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5l-3 0c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5zm-2 1c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5zm0 3.5c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5zm0 3.5c-.27614237 0-.5-.2238576-.5-.5 0-.2761424.22385763-.5.5-.5.27614237 0 .5.2238576.5.5 0 .2761424-.22385763.5-.5.5z"],"appearance_16":["M11 12l-1.5 0-1 0-2 0-1 0-2 0-1 0L1 12l0-3c0-.551.449-1 1-1l1.806 0c.484 0 .94-.234 1.221-.627.284-.396.356-.887.199-1.348C4.783 4.726 4.5 3.069 4.5 2.5 4.5 1.673 5.173 1 6 1c.827 0 1.5.673 1.5 1.5 0 .569-.283 2.226-.726 3.525-.157.461-.085.952.199 1.348.281.393.737.627 1.221.627L10 8c.551 0 1 .449 1 1l0 3zm0 2c0 .551-.449 1-1 1l-.5 0 0-2 1.5 0 0 1zm-4.5 1l2 0 0-2-2 0 0 2zm-3 0l2 0 0-2-2 0 0 2zm-1 0L2 15c-.551 0-1-.449-1-1l0-1 1.5 0 0 2zM10 7L8.194 7c-.164 0-.313-.076-.408-.209-.093-.13-.117-.292-.066-.443.46-1.347.78-3.109.78-3.848C8.5 1.122 7.378 0 6 0 4.622 0 3.5 1.122 3.5 2.5c0 .739.32 2.501.78 3.848.051.151.027.313-.066.443-.095.133-.244.209-.408.209L2 7C.897 7 0 7.897 0 9l0 3 0 1 0 1c0 1.103.897 2 2 2l.5 0 1 0 2 0 1 0 2 0 1 0 .5 0c1.103 0 2-.897 2-2l0-1 0-1 0-3c0-1.103-.897-2-2-2zM6 2c-.276 0-.5.224-.5.5 0 .276.224.5.5.5.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5z"],"appearance_20":["M15.5 19l-1.25 0 0-3L17 16l0 1.5c0 .827-.673 1.5-1.5 1.5zM3 17.5L3 16l2.75 0 0 3-1.25 0c-.827 0-1.5-.673-1.5-1.5zm7.5 1.5l2.75 0 0-3-2.75 0 0 3zm-3.75 0l2.75 0 0-3-2.75 0 0 3zM4.5 10l2.646 0c.661 0 1.277-.326 1.647-.871.376-.553.451-1.256.204-1.881C8.354 5.629 8 3.709 8 3c0-1.103.897-2 2-2 1.103 0 2 .897 2 2 0 .709-.354 2.629-.997 4.248-.247.625-.171 1.328.204 1.881.37.545.986.871 1.647.871l2.646 0c.827 0 1.5.673 1.5 1.5l0 3.5-14 0 0-3.5c0-.827.673-1.5 1.5-1.5zm11-1c1.381 0 2.5 1.119 2.5 2.5l0 6c0 1.381-1.119 2.5-2.5 2.5l-11 0C3.119 20 2 18.881 2 17.5l0-6C2 10.119 3.119 9 4.5 9l2.646 0c.713 0 1.184-.72.921-1.383C7.415 5.972 7 3.92 7 3c0-1.657 1.343-3 3-3 1.657 0 3 1.343 3 3 0 .92-.415 2.972-1.067 4.617-.263.663.208 1.383.921 1.383L15.5 9zM10 3.5c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5 0 .276.224.5.5.5z"],"applause_12":["M11.854 4.8198c.195.195.195.513 0 .707l-2.828 2.829c-.195.194-.513.194-.708 0-.194-.195-.194-.513 0-.707l2.829-2.829c.195-.194.513-.194.707 0zm-1.4141-2.1211c.194-.195.513-.195.707 0 .195.194.195.513 0 .707l-3.536 3.536c-.194.194-.512.194-.707 0-.194-.195-.194-.513 0-.707l3.536-3.536zm.3531 5.3033c.196-.195.512-.195.707 0 .196.195.196.512 0 .707L9.379 10.83c-1.559 1.56-4.097 1.56-5.656 0C2.87 9.978 2.5 8.834 2.58 7.716 1.077 7.143 0 5.703 0 4c0-2.206 1.794-4 4-4l3 0c.276 0 .5.224.5.5 0 .176-.036.343-.092.5L10.5 1c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-.776 0-3.173 3.173-.354.354-.692.692c-.195.196-.512.196-.707 0-.195-.195-.195-.511 0-.707l-.368.368c-1.17 1.17-1.17 3.074 0 4.243 1.169 1.17 3.072 1.17 4.242 0l2.121-2.121zM1 4c0 1.217.732 2.259 1.776 2.729.191-.568.495-1.104.947-1.556l2.121-2.121c.195-.196.511-.196.707 0 .124.125.217.268.288.419L8.31 2 4.971 2c-.233 1.14-1.242 2-2.45 2-.276 0-.51-.224-.51-.5 0-.276.213-.5.489-.5.848 0 1.521-.673 1.521-1.5 0-.276.224-.5.5-.5L4 1C2.346 1 1 2.346 1 4z"],"applause_16":["M14.8362 9.871l-3.729 3.729c-.943.943-2.188 1.446-3.531 1.395-1.333-.043-2.554-.621-3.439-1.628-1.652-1.881-1.5-4.801.346-6.646l2.149-2.11c.421.422.421 1.109 0 1.531l-1.119 1.119c-.195.195-.195.511 0 .707.098.097.226.146.354.146.128 0 .256-.049.353-.146l4.81-4.81c.1-.101.232-.15.365-.157l.054 0c.133.007.264.056.365.157.104.105.162.243.162.393 0 .148-.058.287-.162.391l-2.865 2.866c-.001 0-.001.001-.002.002l-.657.658c-.196.195-.196.511 0 .707.195.195.511.195.707 0l4.309-4.31c.218-.218.568-.216.784 0 .103.104.161.243.161.393 0 .149-.058.289-.161.392l-1.118 1.118-3.059 3.059c-.196.195-.196.512 0 .707.195.195.511.195.707 0l.064-.064c.001-.001.001-.001.002-.001l2.993-2.994c.206-.206.576-.208.784 0 .103.104.161.244.161.393 0 .149-.058.289-.161.393l-3.125 3.124c-.195.195-.195.511 0 .707.098.097.226.146.354.146.128 0 .256-.049.353-.146l2.006-2.006.001 0c.206-.206.576-.208.784 0 .217.217.217.568 0 .785zm-13.81-5.403C1.2532 2.523 3.0512 1 5.1192 1l2.878-.002c0 .583-.474 1.003-1.057 1.003l-1.443 0c-.276 0-.5.224-.5.5l0 .997c0 .827-.673 1.5-1.5 1.5-.276 0-.5.224-.5.5 0 .276.224.5.5.5.112 0 .22-.019.328-.033l-.049.049c-.587.586-1.021 1.268-1.318 1.991-1.038-.845-1.591-2.174-1.432-3.537zm8.747-1.467l-1.89 1.89c-.086-.362-.263-.706-.544-.987-.194-.194-.452-.301-.727-.301-.244 0-.467.097-.651.251.017-.118.036-.234.036-.356l0-.497.943 0 2.833 0zm5.77 5.378c-.139-.139-.299-.241-.468-.317l.095-.094c.606-.607.606-1.593 0-2.2-.139-.138-.299-.241-.468-.316l.095-.095c.606-.606.606-1.592 0-2.199-.519-.518-1.312-.586-1.91-.219-.222-.551-.759-.941-1.39-.941-.089 0-.161.001-.228.003l-2.574 0c.188-.31.302-.669.302-1.057 0-.52-.424-.944-.944-.944l-2.934 0c-2.61 0-4.797 1.871-5.086 4.352-.214 1.836.612 3.615 2.107 4.649-.386 1.751.015 3.624 1.246 5.026 1.069 1.217 2.546 1.916 4.158 1.968.061.002.123.003.184.003 1.508 0 2.971-.599 4.048-1.657.003-.003.007-.004.011-.007l3.756-3.756c.606-.606.606-1.593 0-2.199z"],"application_12":["M10.5 1c.827 0 1.5.673 1.5 1.5l0 7c0 .826-.673 1.5-1.5 1.5l-9 0C.673 11 0 10.326 0 9.5l0-7C0 1.673.673 1 1.5 1l9 0zm.5 2l0-.5c0-.275-.224-.5-.5-.5l-9 0c-.276 0-.5.225-.5.5L1 3l10 0zm0 6.5L11 4 1 4l0 5.5c0 .275.224.5.5.5l9 0c.276 0 .5-.225.5-.5zM7.4981 8.4492c-.091 0-.182-.025-.262-.074-.146-.091-.236-.251-.236-.423l0-2.44c0-.202.122-.385.309-.46.333-.136.333-.136 2.175 1.739.112.114.162.273.136.43-.027.158-.127.292-.269.363l-.308.154.263.54c.119.247.015.544-.232.664-.07.034-.143.05-.217.05-.185 0-.363-.104-.449-.281l-.257-.53-.43.215c-.071.035-.147.053-.223.053zm.498-1.749l0 .448.297-.148c-.1-.101-.199-.201-.297-.3z"],"application_16":["M14 2c1.104 0 2 .896 2 2l0 1 0 7c0 1.104-.896 2-2 2L2 14c-1.104 0-2-.896-2-2l0-7 0-1c0-1.104.896-2 2-2l12 0zm1 10l0-7L1 5l0 7c0 .552.449 1 1 1l12 0c.551 0 1-.448 1-1zM2 3c-.551 0-1 .448-1 1l14 0c0-.552-.449-1-1-1L2 3zm7.5 8.0094c-.091 0-.183-.025-.263-.074-.147-.092-.237-.254-.237-.426l0-4c0-.203.124-.386.312-.464.348-.137.346-.145 3.211 2.781.112.113.163.273.137.431-.027.159-.127.293-.27.366l-.783.39.622 1.28c.12.248.016.547-.232.668-.07.034-.145.049-.218.049-.186 0-.364-.103-.45-.282l-.616-1.267-.989.496c-.071.035-.147.052-.224.052zm.5-3.318l0 2.008 1.329-.664c-.44-.448-.929-.942-1.329-1.344z"],"application_20":["M17.5049 2c1.376 0 2.495 1.119 2.495 2.495l0 11.01c0 1.376-1.119 2.495-2.495 2.495l-15.01 0c-1.376 0-2.495-1.119-2.495-2.495l0-11.01C-.0001 3.119 1.1189 2 2.4949 2l15.01 0zm0 15c.824 0 1.495-.671 1.495-1.495l0-9.505-18 0 0 9.505c0 .824.671 1.495 1.495 1.495l15.01 0zM2.4949 3c-.824 0-1.495.671-1.495 1.495l0 .505 18 0 0-.505c0-.824-.671-1.495-1.495-1.495l-15.01 0zM11.31 8.0384c.358-.149.358-.145 3.878 3.381.114.115.166.277.139.436-.026.159-.128.296-.272.367l-1.081.53.753 1.526c.122.248.02.548-.227.67-.071.035-.146.052-.222.052-.183 0-.361-.103-.448-.279l-.755-1.528-1.354.665c-.071.034-.146.051-.221.051-.092 0-.184-.026-.265-.075-.146-.092-.235-.252-.235-.425l0-4.908c0-.203.122-.386.31-.463zm.69 4.568l1.986-.974c-.658-.657-1.423-1.418-1.986-1.97l0 2.944z"],"application_24":["M21.5 3C22.881 3 24 4.119 24 5.5l0 13c0 1.381-1.119 2.5-2.5 2.5l-19 0C1.119 21 0 19.881 0 18.5l0-13C0 4.119 1.119 3 2.5 3l19 0zM23 6l0-.5c0-.827-.673-1.5-1.5-1.5l-19 0C1.673 4 1 4.673 1 5.5L1 6l22 0zm0 12.5L23 7 1 7l0 11.5c0 .827.673 1.5 1.5 1.5l19 0c.827 0 1.5-.673 1.5-1.5zm-7.5-2.4995c-.092 0-.183-.025-.263-.075-.147-.091-.237-.252-.237-.425l0-6c0-.203.122-.385.309-.462.188-.077.402-.035.545.108l3.994 4c.114.114.166.275.139.434-.025.158-.126.295-.269.367l-1.471.736.716 1.614c.112.252-.002.548-.254.66-.066.029-.135.043-.203.043-.192 0-.374-.111-.457-.298l-.697-1.571-1.628.816c-.071.035-.148.053-.224.053zm.5-5.292l0 3.982 2.65-1.327-2.65-2.655z"],"application_36":["M32.5 4C34.433 4 36 5.567 36 7.5l0 21c0 1.933-1.567 3.5-3.5 3.5l-29 0C1.567 32 0 30.433 0 28.5l0-21C0 5.567 1.567 4 3.5 4l29 0zM35 9l0-1.5C35 6.121 33.879 5 32.5 5l-29 0C2.121 5 1 6.121 1 7.5L1 9l34 0zm0 19.5L35 10 1 10l0 18.5C1 29.879 2.121 31 3.5 31l29 0c1.379 0 2.5-1.121 2.5-2.5zm-13.612-3.4122c-.071 0-.142-.018-.204-.057-.114-.071-.184-.195-.184-.331l0-9.277c0-.253.207-.423.424-.423.098 0 .2.036.284.116 1.085 1.037 2.937 2.918 6.162 6.21.087.09.126.214.106.336-.021.123-.098.228-.209.284l-2.507 1.252 1.386 2.861c.093.192.012.425-.181.518-.053.027-.111.038-.168.038-.144 0-.282-.079-.35-.218l-1.382-2.851-3.003 1.502c-.055.027-.115.04-.174.04zm.612-8.288l0 6.911 1.93-.965 0-.001.883-.441 1.755-.877c-1.968-2.009-3.49-3.556-4.568-4.627z"],"application_48":["M43.5 6c2.485 0 4.5 2.015 4.5 4.5l0 27c0 2.485-2.015 4.5-4.5 4.5l-39 0C2.015 42 0 39.985 0 37.5l0-27C0 8.015 2.015 6 4.5 6l39 0zm3.5 7l0-2.5C47 8.567 45.433 7 43.5 7l-39 0C2.567 7 1 8.567 1 10.5L1 13l46 0zm0 24.5L47 14 1 14l0 23.5C1 39.433 2.567 41 4.5 41l39 0c1.933 0 3.5-1.567 3.5-3.5zm-18.5-5.4672c-.091 0-.183-.025-.263-.074-.147-.092-.237-.252-.237-.426l0-12c0-.203.124-.388.313-.465.426-.176.429-.168 8.544 8.115.112.115.163.275.136.433-.026.158-.126.293-.269.365l-3.232 1.615 1.787 3.688c.12.248.016.548-.233.668-.069.034-.144.05-.217.05-.185 0-.364-.103-.451-.282l-1.781-3.676-3.873 1.937c-.071.035-.147.052-.224.052zm.5-11.358l0 10.049 6.663-3.331c-2.285-2.329-5.262-5.343-6.663-6.718z"],"application-panel_16":["M14 2c1.105 0 2 .895 2 2l0 8c0 1.105-.895 2-2 2L2 14c-1.105 0-2-.895-2-2l0-8c0-1.105.895-2 2-2l12 0zm1 10l0-8c0-.551-.449-1-1-1L6 3l0 10 8 0c.551 0 1-.449 1-1zM5 13L5 3 2 3c-.551 0-1 .449-1 1l0 8c0 .551.449 1 1 1l3 0zM2.5 4l1 0c.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5l-1 0c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5zm0 2l1 0c.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5l-1 0c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5zm0 2l1 0c.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5l-1 0c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5z"],"application-panel_20":["M17.505 2C18.881 2 20 3.119 20 4.495l0 11.01C20 16.881 18.881 18 17.505 18l-15.01 0C1.119 18 0 16.881 0 15.505l0-11.01C0 3.119 1.119 2 2.495 2l15.01 0zM19 15.505l0-11.01C19 3.671 18.329 3 17.505 3L8 3l0 14 9.505 0c.824 0 1.495-.671 1.495-1.495zm-18 0C1 16.329 1.671 17 2.495 17L7 17 7 3 2.495 3C1.671 3 1 3.671 1 4.495l0 11.01zM3.5 5l1 0c.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5l-1 0c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5zm0 3l1 0c.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5l-1 0c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5zm0 3l1 0c.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5l-1 0c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5z"],"applications_16":["M7 2c0-.552.449-1 1-1l6 0c.551 0 1 .448 1 1L7 2zm8 4c0 .552-.449 1-1 1l-1 0 0-1c0-1.104-.896-2-2-2L7 4l0-1 8 0 0 3zM4 6c0-.552.449-1 1-1l6 0c.551 0 1 .448 1 1L4 6zm8 4c0 .552-.449 1-1 1l-1 0 0-1c0-1.104-.896-2-2-2L4 8l0-1 8 0 0 3zM1 10c0-.552.449-1 1-1l6 0c.551 0 1 .448 1 1l-8 0zm8 4c0 .552-.449 1-1 1l-6 0c-.551 0-1-.448-1-1l0-3 8 0 0 3zm5-14L8 0C6.896 0 6 .896 6 2l0 2-1 0c-1.104 0-2 .896-2 2l0 2-1 0c-1.104 0-2 .896-2 2l0 1 0 3c0 1.104.896 2 2 2l6 0c1.104 0 2-.896 2-2l0-2 1 0c1.104 0 2-.896 2-2l0-2 1 0c1.104 0 2-.896 2-2l0-4c0-1.104-.896-2-2-2z"],"applications_24":["M23 3L12 3l0-.469C12 1.687 12.687 1 13.531 1l7.938 0C22.313 1 23 1.687 23 2.531L23 3zm0 6.469c0 .844-.687 1.531-1.531 1.531L18 11l0-2.469C18 7.136 16.864 6 15.469 6L12 6l0-2 11 0 0 5.469zM17 9L6 9l0-.469C6 7.687 6.687 7 7.531 7l7.938 0C16.313 7 17 7.687 17 8.531L17 9zm0 6.469c0 .844-.687 1.531-1.531 1.531L13 17l0-2.469C13 13.136 11.864 12 10.469 12L6 12l0-2 11 0 0 5.469zM12 15L1 15l0-.469C1 13.687 1.687 13 2.531 13l7.938 0c.844 0 1.531.687 1.531 1.531L12 15zm0 6.469c0 .844-.687 1.531-1.531 1.531l-7.938 0C1.687 23 1 22.313 1 21.469L1 16l11 0 0 5.469zM21.469 0l-7.938 0C12.136 0 11 1.136 11 2.531L11 6 7.531 6C6.136 6 5 7.136 5 8.531L5 12l-2.469 0C1.136 12 0 13.136 0 14.531l0 6.938C0 22.864 1.136 24 2.531 24l7.938 0C11.864 24 13 22.864 13 21.469L13 18l2.469 0C16.864 18 18 16.864 18 15.469L18 12l3.469 0C22.864 12 24 10.864 24 9.469l0-6.938C24 1.136 22.864 0 21.469 0z"],"approvals_16":["M13.4998 5c.276 0 .5.224.5.5l0 4.5c0 1.103-.897 2-2 2l-8 0c-1.103 0-2-.897-2-2l0-8c0-1.103.897-2 2-2l6.5 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-6.5 0c-.552 0-1 .448-1 1l0 8c0 .552.448 1 1 1l8 0c.552 0 1-.448 1-1l0-4.5c0-.276.224-.5.5-.5zm-1.5 8c1.103 0 2 .897 2 2l0 .5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-.5c0-.552-.448-1-1-1l-8 0c-.552 0-1 .448-1 1l0 .5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-.5c0-1.103.897-2 2-2l8 0zM4.8533 5.1465l2.146 2.146 6.147-6.146c.195-.195.512-.195.707 0 .195.195.195.512 0 .707l-6.5 6.5c-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147l-2.5-2.5c-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0z"],"approvals_32":["M26.8539 3.1465c.195.195.195.512 0 .707l-12 12c-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147l-5-5c-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0l4.646 4.646 11.647-11.646c.195-.195.512-.195.707 0zM24.0004 25.001c1.654 0 3 1.346 3 3l0 2.499c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-2.499c0-1.104-.897-2-2-2l-16-.001c-1.103 0-2 .897-2 2l0 2.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-2.5c0-1.653 1.346-3 3-3l16 .001zM26.5004 9c.276 0 .5.225.5.5l0 10.5c0 .827-.336 1.577-.88 2.121-.543.543-1.293.88-2.12.88l-16 0c-.827 0-1.577-.337-2.12-.88-.544-.544-.88-1.294-.88-2.121l0-16c0-1.654 1.346-3 3-3l13.5 0c.276 0 .5.225.5.5 0 .276-.224.5-.5.5l-13.5 0c-1.103 0-2 .897-2 2l0 16c0 .533.208 1.035.587 1.413.379.379.88.588 1.413.588l16 0c.533 0 1.034-.209 1.413-.587.379-.379.587-.881.587-1.414l0-10.5c0-.275.224-.5.5-.5z"],"archive_12":["M10.5 2c.276 0 .5.224.5.5l0 7.667C11 11.178 10.178 12 9.167 12L2.5 12c-.827 0-1.5-.673-1.5-1.5l0-8c0-.276.224-.5.5-.5l9 0zm-.5 8.167L10 3 2 3l0 7.5c0 .275.224.5.5.5l6.667 0c.459 0 .833-.374.833-.833zM11.5 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L.5 1C.225 1 0 .775 0 .5 0 .225.225 0 .5 0l11 0zM6 7c-1.103 0-2-.897-2-2l0-.5c0-.276.224-.5.5-.5l3 0c.276 0 .5.224.5.5L8 5c0 1.103-.897 2-2 2zm1-2L5 5c0 .552.449 1 1 1 .551 0 1-.448 1-1z","M10.5 2c.276 0 .5.224.5.5l0 7.667C11 11.178 10.178 12 9.167 12L2.5 12c-.827 0-1.5-.673-1.5-1.5l0-8c0-.276.224-.5.5-.5l9 0zm-.5 8.167L10 3 2 3l0 7.5c0 .275.224.5.5.5l6.667 0c.459 0 .833-.374.833-.833zM11.5 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L.5 1C.225 1 0 .775 0 .5 0 .225.225 0 .5 0l11 0zM6 7c-1.103 0-2-.897-2-2l0-.5c0-.276.224-.5.5-.5l3 0c.276 0 .5.224.5.5L8 5c0 1.103-.897 2-2 2zm1-2L5 5c0 .552.449 1 1 1 .551 0 1-.448 1-1z"],"archive_16":["M15.5 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5L.5 1C.224 1 0 .776 0 .5 0 .224.224 0 .5 0l15 0zm-.9982674 2C14.7769181 2 15 2.21990657 15 2.49826741l0 11.49587389C15 15.1019465 14.1029399 16 12.9941413 16l-9.98828264 0C1.89805351 16 1 15.1029399 1 13.9941413L1 2.49826741C1 2.22308192 1.21990657 2 1.49826741 2L14.5017326 2zM14 3L2 3l0 10.9941413C2 14.5502354 2.44991848 15 3.00585866 15l9.98828264 0C13.5502354 15 14 14.5500815 14 13.9941413L14 3zM8.0176 7.029c-1.438 0-2.678-1.025-2.946-2.436-.028-.146.01-.297.106-.412.095-.115.236-.181.385-.181l4.91 0c.276 0 .5.224.5.5 0 .032-.003.067-.009.098-.27 1.409-1.509 2.431-2.946 2.431zM9.7676 5l-3.499 0c.345.62 1.007 1.029 1.749 1.029.742 0 1.404-.409 1.75-1.029z"],"archive_20":["M18.4888 3c.276 0 .5.224.5.5l0 13c0 1.381-1.12 2.5-2.5 2.5l-12.989 0c-1.381 0-2.5-1.119-2.5-2.5l0-13c0-.276.224-.5.5-.5l16.989 0zm-.5 13.5l0-12.5-15.989 0 0 12.5c0 .827.673 1.5 1.5 1.5l12.989 0c.827 0 1.5-.673 1.5-1.5zM10.0003 9c-2.206 0-4-1.557-4-3.471 0-.293.273-.529.61-.529l6.779 0c.337 0 .611.236.611.529 0 1.914-1.795 3.471-4 3.471zm2.945-3l-5.891 0c.268 1.138 1.487 2 2.946 2 1.459 0 2.677-.862 2.945-2zM19.5 1c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L.5 2C.225 2 0 1.775 0 1.5c0-.275.225-.5.5-.5l19 0z"],"archive_8":["M2 3l0 3.833c0 .092.075.167.167.167l3.444 0C5.825 7 6 6.825 6 6.611L6 3 2 3zm3.611 5L2.167 8C1.523 8 1 7.477 1 6.833L1 2.5c0-.276.224-.5.5-.5l5 0c.276 0 .5.224.5.5l0 4.111C7 7.377 6.377 8 5.611 8zM7.5 1l-7 0C.224 1 0 .776 0 .5 0 .224.224 0 .5 0l7 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5zm-3 4c.275 0 .5-.225.5-.5 0-.275-.225-.5-.5-.5l-1 0c-.275 0-.5.225-.5.5 0 .275.225.5.5.5l1 0z"],"area-selector_16":["M12 4l0-1 0-1 2 0 0 2-2 0zm2 10l-2 0 0-1 0-1 1 0 1 0 0 2zm-3-2l0 1-6 0 0-1c0-.553-.447-1-1-1l-1 0 0-6 1 0c.553 0 1-.447 1-1l0-1 6 0 0 1c0 .553.447 1 1 1l1 0 0 6-1 0c-.553 0-1 .447-1 1zm-7 1l0 1-2 0 0-2 1 0 1 0 0 1zM2 2l2 0 0 1 0 1-1 0-1 0 0-2zm13 2l0-2c0-.553-.447-1-1-1l-2 0c-.553 0-1 .447-1 1L5 2c0-.553-.447-1-1-1L2 1c-.553 0-1 .447-1 1l0 2c0 .553.447 1 1 1l0 6c-.553 0-1 .447-1 1l0 2c0 .553.447 1 1 1l2 0c.553 0 1-.447 1-1l6 0c0 .553.447 1 1 1l2 0c.553 0 1-.447 1-1l0-2c0-.553-.447-1-1-1l0-6c.553 0 1-.447 1-1z"],"area-selector_20":["M15.2002 5c-.11 0-.2-.09-.2-.2l0-2.6c0-.11.09-.2.2-.2l2.6 0c.11 0 .2.09.2.2l0 2.6c0 .11-.09.2-.2.2l-2.6 0zm2.6 10c.11 0 .2.09.2.2l0 2.6c0 .11-.09.2-.2.2l-2.6 0c-.11 0-.2-.09-.2-.2l0-2.6c0-.11.09-.2.2-.2l2.6 0zm-11.8 1l0-.8c0-.663-.537-1.2-1.2-1.2l-.8 0 0-8 .8 0c.663 0 1.2-.537 1.2-1.2l0-.8 8 0 0 .8c0 .663.537 1.2 1.2 1.2l.8 0 0 8-.8 0c-.663 0-1.2.537-1.2 1.2l0 .8-8 0zm-1 1.8c0 .11-.09.2-.2.2l-2.6 0c-.11 0-.2-.09-.2-.2l0-2.6c0-.11.09-.2.2-.2l2.6 0c.11 0 .2.09.2.2l0 2.6zM2.2002 5c-.11 0-.2-.09-.2-.2l0-2.6c0-.11.09-.2.2-.2l2.6 0c.11 0 .2.09.2.2l0 2.6c0 .11-.09.2-.2.2l-2.6 0zm15.6 1c.663 0 1.2-.537 1.2-1.2l0-2.6c0-.663-.537-1.2-1.2-1.2l-2.6 0c-.663 0-1.2.537-1.2 1.2l0 .8-8 0 0-.8c0-.663-.537-1.2-1.2-1.2l-2.6 0c-.663 0-1.2.537-1.2 1.2l0 2.6c0 .663.537 1.2 1.2 1.2l.8 0 0 8-.8 0c-.663 0-1.2.537-1.2 1.2l0 2.6c0 .663.537 1.2 1.2 1.2l2.6 0c.663 0 1.2-.537 1.2-1.2l0-.8 8 0 0 .8c0 .663.537 1.2 1.2 1.2l2.6 0c.663 0 1.2-.537 1.2-1.2l0-2.6c0-.663-.537-1.2-1.2-1.2l-.8 0 0-8 .8 0z"],"arrow-circle-down_16":["M8 0c4.418 0 8 3.582 8 8 0 4.418-3.582 8-8 8-4.418 0-8-3.582-8-8 0-4.418 3.582-8 8-8zm0 15c3.859 0 7-3.14 7-7 0-3.86-3.141-7-7-7-3.86 0-7 3.14-7 7 0 3.86 3.14 7 7 7zm3.1436-8.8506c.194-.198.511-.198.707-.006.197.193.199.51.006.707l-3.5 3.561c-.094.095-.222.15-.356.15l-.001 0c-.133 0-.262-.054-.356-.149l-3.5-3.551c-.193-.197-.191-.513.005-.707.199-.194.515-.191.707.005l3.144 3.189 3.144-3.199z"],"arrow-circle-down_20":["M10 0C4.4771525 0 0 4.4771525 0 10c0 5.5228475 4.4771525 10 10 10 5.5228475 0 10-4.4771525 10-10 0-5.5228475-4.4771525-10-10-10zm0 1c4.9705627 0 9 4.0294373 9 9 0 4.97056275-4.0294373 9-9 9-4.97056275 0-9-4.02943725-9-9 0-4.9705627 4.02943725-9 9-9zm4.8574 7.1772c-.099-.11-.235-.167-.373-.167-.118 0-.237.042-.333.127l-4.151 3.703-4.152-3.703c-.207-.183-.522-.165-.706.04-.183.206-.166.522.04.706l4.485 4c.189.169.476.169.666 0l4.484-4c.206-.184.224-.5.04-.706z"],"arrow-circle-down_24":["M12 0C5.372583 0 0 5.372583 0 12c0 6.627417 5.372583 12 12 12 6.627417 0 12-5.372583 12-12 0-6.627417-5.372583-12-12-12zm0 1c6.0751322 0 11 4.9248678 11 11 0 6.07513225-4.9248678 11-11 11-6.07513225 0-11-4.92486775-11-11C1 5.9248678 5.92486775 1 12 1zm0 14.5c.128 0 .256-.049.354-.146l4.5-4.5c.195-.196.195-.512 0-.708-.196-.195-.512-.195-.708 0L12 14.293l-4.146-4.147c-.196-.195-.512-.195-.708 0-.195.196-.195.512 0 .708l4.5 4.5c.098.097.226.146.354.146z"],"arrow-circle-left_16":["M16 8c0 4.418-3.582 8-8 8-4.418 0-8-3.582-8-8 0-4.418 3.582-8 8-8 4.418 0 8 3.582 8 8zM1 8c0 3.859 3.14 7 7 7 3.86 0 7-3.141 7-7 0-3.86-3.14-7-7-7-3.86 0-7 3.14-7 7zm8.8506 3.1436c.198.194.198.511.006.707-.193.197-.51.199-.707.006l-3.561-3.5c-.095-.094-.15-.222-.15-.356l0-.001c0-.133.054-.262.149-.356l3.551-3.5c.197-.193.513-.191.707.005.194.199.191.515-.005.707l-3.189 3.144 3.199 3.144z"],"arrow-circle-left_20":["M20 10c0 5.5228475-4.4771525 10-10 10-5.5228475 0-10-4.4771525-10-10C0 4.4771525 4.4771525 0 10 0c5.5228475 0 10 4.4771525 10 10zm-1 0c0-4.9705627-4.0294373-9-9-9-4.97056275 0-9 4.0294373-9 9 0 4.97056275 4.02943725 9 9 9 4.9705627 0 9-4.02943725 9-9zm-7.1772-4.8574c.11.099.167.235.167.373 0 .118-.042.237-.127.333l-3.703 4.151 3.703 4.152c.183.207.165.522-.04.706-.206.183-.522.166-.706-.04l-4-4.485c-.169-.189-.169-.476 0-.666l4-4.484c.184-.206.5-.224.706-.04z"],"arrow-circle-left_24":["M24 12c0 6.627417-5.372583 12-12 12-6.627417 0-12-5.372583-12-12C0 5.372583 5.372583 0 12 0c6.627417 0 12 5.372583 12 12zm-1 0c0-6.0751322-4.9248678-11-11-11C5.92486775 1 1 5.9248678 1 12c0 6.07513225 4.92486775 11 11 11 6.0751322 0 11-4.92486775 11-11zM8.5 12c0-.128.049-.256.146-.354l4.5-4.5c.196-.195.512-.195.708 0 .195.196.195.512 0 .708L9.707 12l4.147 4.146c.195.196.195.512 0 .708-.196.195-.512.195-.708 0l-4.5-4.5c-.097-.098-.146-.226-.146-.354z"],"arrow-circle-right_16":["M0 8c0 4.418 3.582 8 8 8 4.418 0 8-3.582 8-8 0-4.418-3.582-8-8-8-4.418 0-8 3.582-8 8zm15 0c0 3.859-3.14 7-7 7-3.86 0-7-3.141-7-7 0-3.86 3.14-7 7-7 3.86 0 7 3.14 7 7zm-8.8506 3.1436c-.198.194-.198.511-.006.707.193.197.51.199.707.006l3.561-3.5c.095-.094.15-.222.15-.356l0-.001c0-.133-.054-.262-.149-.356l-3.551-3.5c-.197-.193-.513-.191-.707.005-.194.199-.191.515.005.707l3.189 3.144-3.199 3.144z"],"arrow-circle-right_20":["M0 10C0 4.4771525 4.4771525 0 10 0c5.5228475 0 10 4.4771525 10 10 0 5.5228475-4.4771525 10-10 10-5.5228475 0-10-4.4771525-10-10zm1 0c0 4.9705627 4.0294373 9 9 9 4.97056275 0 9-4.0294373 9-9 0-4.97056275-4.02943725-9-9-9-4.9705627 0-9 4.02943725-9 9zm7.1772 4.8574c-.11-.099-.167-.235-.167-.373 0-.118.042-.237.127-.333l3.703-4.151-3.703-4.152c-.183-.207-.165-.522.04-.706.206-.183.522-.166.706.04l4 4.485c.169.189.169.476 0 .666l-4 4.484c-.184.206-.5.224-.706.04z"],"arrow-circle-right_24":["M0 12c0 6.627417 5.372583 12 12 12 6.627417 0 12-5.372583 12-12 0-6.627417-5.372583-12-12-12C5.372583 0 0 5.372583 0 12zm1 0C1 5.9248678 5.9248678 1 12 1c6.07513225 0 11 4.9248678 11 11 0 6.07513225-4.92486775 11-11 11-6.0751322 0-11-4.92486775-11-11zm14.5 0c0-.128-.049-.256-.146-.354l-4.5-4.5c-.196-.195-.512-.195-.708 0-.195.196-.195.512 0 .708L14.293 12l-4.147 4.146c-.195.196-.195.512 0 .708.196.195.512.195.708 0l4.5-4.5c.097-.098.146-.226.146-.354z"],"arrow-circle-up_16":["M8 16c-4.418 0-8-3.582-8-8 0-4.418 3.582-8 8-8 4.418 0 8 3.582 8 8 0 4.418-3.582 8-8 8zM8 1C4.141 1 1 4.14 1 8c0 3.86 3.141 7 7 7 3.86 0 7-3.14 7-7 0-3.86-3.14-7-7-7zM4.8564 9.8506c-.194.198-.511.198-.707.006-.197-.193-.199-.51-.006-.707l3.5-3.561c.094-.095.222-.15.356-.15l.001 0c.133 0 .262.054.356.149l3.5 3.551c.193.197.191.513-.005.707-.199.194-.515.191-.707-.005l-3.144-3.189-3.144 3.199z"],"arrow-circle-up_20":["M10 20C4.4771525 20 0 15.5228475 0 10 0 4.4771525 4.4771525 0 10 0c5.5228475 0 10 4.4771525 10 10 0 5.5228475-4.4771525 10-10 10zm0-1c4.9705627 0 9-4.0294373 9-9 0-4.97056275-4.0294373-9-9-9-4.97056275 0-9 4.02943725-9 9 0 4.9705627 4.02943725 9 9 9zm4.8574-7.1772c-.099.11-.235.167-.373.167-.118 0-.237-.042-.333-.127l-4.151-3.703-4.152 3.703c-.207.183-.522.165-.706-.04-.183-.206-.166-.522.04-.706l4.485-4c.189-.169.476-.169.666 0l4.484 4c.206.184.224.5.04.706z"],"arrow-circle-up_24":["M12 24C5.372583 24 0 18.627417 0 12 0 5.372583 5.372583 0 12 0c6.627417 0 12 5.372583 12 12 0 6.627417-5.372583 12-12 12zm0-1c6.0751322 0 11-4.9248678 11-11 0-6.07513225-4.9248678-11-11-11C5.92486775 1 1 5.92486775 1 12c0 6.0751322 4.92486775 11 11 11zm0-14.5c.128 0 .256.049.354.146l4.5 4.5c.195.196.195.512 0 .708-.196.195-.512.195-.708 0L12 9.707l-4.146 4.147c-.196.195-.512.195-.708 0-.195-.196-.195-.512 0-.708l4.5-4.5c.098-.097.226-.146.354-.146z"],"arrow-down_12":["M1.00041 3.499748764c0-.137.056-.273.165-.372.206-.1850000001.522-.1680000001.707.037l4.128 4.586999996 4.128-4.586999996c.185-.2050000001.501-.2220000001.707-.037.204.185.221.501.037.706l-4.5 4.999999996c-.096.106-.23.166-.372.166-.142 0-.276-.06-.372-.166l-4.5-4.999999996c-.086-.095-.128-.215-.128-.334"],"arrow-down_16":["M8.5001 11.26336438l6.134-6.60428553c.188-.20253009.505-.21355895.707-.02506561.201.18849335.213.50632522.025.7088553l-6.5 6.997314214c-.095.1022676673-.227.159417246-.366.159417246-.139 0-.271-.0571495787-.366-.159417246L1.6311 5.34286854c-.09-.09725454-.134-.21957469-.134-.34189484 0-.13435165.053-.26870329.159-.36696046.202-.18849334.518-.17746448.706.02506561l6.138 6.60428553z"],"arrow-down_18":["M8.99991862 13.00017013c-.122 0-.245-.045-.341-.134L1.158918617 5.865170126c-.2019999998-.188-.2129999998-.505-.024-.707.188-.2010000002.506-.2120000002.706-.024L8.99991862 11.81617013l7.15899998-6.682000004c.2-.1880000002.518-.1770000002.706.024.189.202.178.519-.024.707L9.34091862 12.86617013c-.096.089-.219.134-.341.134"],"arrow-down_20":["M9.99991862 14.00017013c-.122 0-.245-.045-.341-.134L2.158918617 6.865170126c-.2019999998-.188-.2129999998-.505-.024-.707.188-.2010000002.506-.2120000002.706-.024L9.99991862 12.81617013l7.15899998-6.682000004c.2-.1880000002.518-.1770000002.706.024.189.202.178.519-.024.707l-7.49999998 7.001000004c-.096.089-.219.134-.341.134"],"arrow-down_24":["M1.9999304 7.500007c0 .133.052.265.156.363l9.50000002 9c.193.183.495.183.688 0l9.5-9c.2-.189.21-.506.019-.707-.19-.2-.507-.209-.707-.019l-9.156 8.675-9.15600002-8.675c-.2-.19-.517-.181-.707.019-.092.097-.137.221-.137.344"],"arrow-down_28":["M24.8452307 8.140365149c-.199-.1930000003-.517-.1860000003-.706.015l-10.14 10.567999951L3.860230731 8.155365149c-.19-.2010000003-.507-.2080000003-.706-.015-.1999999998.19-.2059999998.507-.015.706L13.6392307 19.7913651c.094.099.225.155.36.155.136 0 .267-.056.361-.155l10.5-10.944999951c.191-.199.184-.516-.015-.706"],"arrow-down_32":["M3.0001337 9.5c0 .125.046.25.14.347l12.5 13c.093.098.224.153.36.153.136 0 .267-.055.36-.153l12.499999993-13c.1930000001-.201.1840000001-.516-.013-.707-.2-.192-.516-.185-.707.013L16.0001337 21.779l-12.14-12.626c-.191-.198-.507-.205-.707-.013-.101.098-.153.229-.153.36"],"arrow-down_6":["M3 5c.1 0 .2 0 .3-.1l2.5-2c.2-.2.3-.5.1-.7-.2-.2-.5-.3-.7-.1L3 3.9.8 2.1c-.2-.2-.5-.1-.7.1-.2.2-.1.5.1.7l2.5 2c.1.1.2.1.3.1"],"arrow-down_8":["M4.0001 6.00003c.116 0 .232-.04.325-.121l3.5-3c.21-.179.235-.495.054-.704-.18-.211-.495-.234-.704-.054l-3.175 2.72-3.175-2.72c-.209-.18-.526-.157-.704.054-.181.209-.156.525.054.704l3.5 3c.093.081.209.121.325.121"],"arrow-down-optical_10":["M8.14625 3.64625l-3.146 3.147-3.146-3.147c-.196-.195-.512-.195-.708 0-.195.196-.195.512 0 .708l3.5 3.5c.196.195.512.195.708 0l3.5-3.5c.097-.098.146-.226.146-.354 0-.128-.049-.256-.146-.354-.196-.195-.512-.195-.708 0"],"arrow-down-optical_12":["M1.00041 4.499748764c0-.137.056-.273.165-.372.206-.1850000001.522-.1680000001.707.037l4.128 4.586999996 4.128-4.586999996c.185-.2050000001.501-.2220000001.707-.037.204.185.221.501.037.706l-4.5 4.999999996c-.096.106-.23.166-.372.166-.142 0-.276-.06-.372-.166l-4.5-4.999999996c-.086-.095-.128-.215-.128-.334"],"arrow-down-optical_14":["M1 5.4822c0 .136.055.271.163.37l5.5 5.017c.191.174.483.174.674 0l5.5-5.017c.204-.186.219-.503.032-.707-.185-.204-.502-.218-.706-.032L7 9.8232l-5.163-4.71c-.204-.186-.521-.172-.706.032-.088.096-.131.217-.131.337"],"arrow-down-optical_16":["M8.0001 11.76416438l6.134-6.60428553c.188-.20253009.505-.21355895.707-.02506561.201.18849335.213.50632522.025.7088553l-6.5 6.997314214c-.095.1022676673-.227.159417246-.366.159417246-.139 0-.271-.0571495787-.366-.159417246L1.1311 5.84366854c-.09-.09725454-.134-.21957469-.134-.34189484 0-.13435165.053-.26870329.159-.36696046.202-.18849334.518-.17746448.706.02506561l6.138 6.60428553z"],"arrow-down-optical_18":["M9.00008138 14.00017013c.122 0 .245-.045.341-.134l7.500000003-7.001000004c.2019999998-.188.2129999998-.505.024-.707-.188-.2010000002-.506-.2120000002-.706-.024L9.00008138 12.81617013 1.8410814 6.134170126c-.2-.1880000002-.518-.1770000002-.706.024-.189.202-.178.519.024.707l7.49999998 7.001000004c.096.089.219.134.341.134"],"arrow-down-optical_20":["M2.0002952 8.5c0 .134.053.267.159.365l7.50000002 7c.192.18.49.18.682 0l7.499999995-7c.2010000002-.189.2130000002-.507.025-.706-.189-.202-.505-.213-.707-.024l-7.158999995 6.681L2.8412952 8.135c-.202-.189-.518-.178-.707.024-.09.096-.134.219-.134.341"],"arrow-down-optical_24":["M1.9997 9.499888c0 .133.052.265.156.363l9.5 9c.193.183.495.183.688 0l9.5-9c.2-.189.21-.506.019-.707-.19-.2-.507-.209-.707-.019l-9.156 8.675-9.156-8.675c-.2-.19-.517-.181-.707.019-.092.097-.137.221-.137.344"],"arrow-down-optical_28":["M13.9991349 20.777L24.139134862 10.21c.19-.201.506-.206.706-.015.2000000002.19.2080000002.508.014.706L14.3591349 21.845c-.093.099-.224.155-.36.155-.136 0-.267-.056-.36-.155l-10.5-10.944c-.094-.097-.14-.221-.14-.346 0-.132.052-.262.154-.36.2-.191.516-.186.706.015l10.14 10.567z"],"arrow-down-optical_32":["M3.0001337 11.5c0 .125.046.25.14.347l12.5 13c.093.098.224.153.36.153.136 0 .267-.055.36-.153l12.499999993-13c.1930000001-.201.1840000001-.516-.013-.707-.2-.192-.516-.185-.707.013L16.0001337 23.779l-12.14-12.626c-.191-.198-.507-.205-.707-.013-.101.098-.153.229-.153.36"],"arrow-down-optical_8":["M3.999992 7.000122c.116 0 .232-.04.325-.121l3.5-3c.21-.179.235-.495.054-.704-.18-.211-.495-.234-.704-.054l-3.175 2.72-3.175-2.72c-.209-.18-.526-.157-.704.054-.181.209-.156.525.054.704l3.5 3c.093.081.209.121.325.121"],"arrow-filled-down_10":["M1.3 4.5l3.1 3.2c.4.4.9.4 1.3 0l3.1-3.2c.4-.3.4-.9 0-1.3-.2-.1-.5-.2-.7-.2L1.9 3c-.5 0-.9.4-.9.9 0 .2.1.5.3.6"],"arrow-filled-down_12":["M1 4.0742c0 .285.115.558.319.759l3.91 3.852c.426.42 1.116.42 1.542 0l3.91-3.852c.425-.419.425-1.099 0-1.519-.204-.201-.482-.314-.771-.314l-7.82 0c-.602 0-1.09.481-1.09 1.074"],"arrow-filled-down_8":["M3.3833 6.7373c.34.35.893.35 1.233 0l3.129-3.21c.163-.167.255-.395.255-.632 0-.494-.391-.895-.872-.895l-6.256 0c-.232 0-.454.094-.617.261-.17.175-.255.405-.255.634 0 .229.085.458.255.632l3.128 3.21z"],"arrow-filled-up_10":["M1.3 5.5l3.1-3.2c.4-.4.9-.4 1.3 0l3.1 3.2c.4.3.4.9 0 1.3-.2.1-.5.2-.7.2L1.9 7c-.5 0-.9-.4-.9-.9 0-.2.1-.5.3-.6"],"arrow-filled-up_12":["M1 7.9262c0-.285.115-.558.319-.759l3.91-3.852c.426-.42 1.116-.42 1.542 0l3.91 3.852c.425.419.425 1.099 0 1.519-.204.201-.482.314-.771.314l-7.82 0c-.602 0-1.09-.481-1.09-1.074"],"arrow-filled-up_8":["M4.6167 1.2627c-.34-.35-.893-.35-1.233 0l-3.128 3.21c-.164.167-.256.395-.256.632 0 .494.391.895.872.895l6.256 0c.232 0 .454-.094.617-.261.17-.175.255-.405.255-.634 0-.229-.085-.458-.255-.632l-3.128-3.21z"],"arrow-left_12":["M8.500251236 10.99959c.137 0 .273-.056.372-.165.1850000001-.206.1680000001-.522-.037-.707l-4.586999996-4.128 4.586999996-4.128c.2050000001-.185.2220000001-.501.037-.707-.185-.204-.501-.221-.706-.037l-4.999999996 4.5c-.106.096-.166.23-.166.372 0 .142.06.276.166.372l4.999999996 4.5c.095.086.215.128.334.128"],"arrow-left_16":["M5.23663562 7.9999l6.60428553-6.134c.20253009-.188.21355895-.505.02506561-.707-.18849335-.201-.50632522-.213-.7088553-.025l-6.997314214 6.5c-.1022676673.095-.159417246.227-.159417246.366 0 .139.0571495787.271.159417246.366l6.997314214 6.503c.09725454.09.21957469.134.34189484.134.13435165 0 .26870329-.053.36696046-.159.18849334-.202.17746448-.518-.02506561-.706l-6.60428553-6.138z"],"arrow-left_18":["M4.99982987 9.00008138c0 .122.045.245.134.341l7.001000004 7.500000003c.188.2019999998.505.2129999998.707.024.2010000002-.188.2120000002-.506.024-.706L6.18382987 9.00008138l6.682000004-7.15899998c.1880000002-.2.1770000002-.518-.024-.706-.202-.189-.519-.178-.707.024L5.13382987 8.65908138c-.089.096-.134.219-.134.341"],"arrow-left_20":["M13.5 17.9997048c-.134 0-.267-.053-.365-.159l-7-7.50000002c-.18-.192-.18-.49 0-.682l7-7.499999995c.189-.2010000002.507-.2130000002.706-.025.202.189.213.505.024.707L7.184 9.99970478l6.681 7.15900002c.189.202.178.518-.024.707-.096.09-.219.134-.341.134"],"arrow-left_24":["M16.5002 22.0003c-.133 0-.265-.052-.363-.156l-9-9.5c-.183-.193-.183-.495 0-.688l9-9.5c.189-.2.506-.21.707-.019.2.19.209.507.019.707l-8.675 9.156 8.675 9.156c.19.2.181.517-.019.707-.097.092-.221.137-.344.137"],"arrow-left_28":["M9.223 14.0008651L19.79 3.860865138c.201-.19.206-.506.015-.706-.19-.2000000002-.508-.2080000002-.706-.014L8.155 13.6408651c-.099.093-.155.224-.155.36 0 .136.056.267.155.36l10.944 10.5c.097.094.221.14.346.14.132 0 .262-.052.36-.154.191-.2.186-.516-.015-.706l-10.567-10.14z"],"arrow-left_32":["M22.5 28.9998663c-.125 0-.25-.046-.347-.14l-13-12.5c-.098-.093-.153-.224-.153-.36 0-.136.055-.267.153-.36l13-12.499999993c.201-.1930000001.516-.1840000001.707.013.192.2.185.516-.013.707L10.221 15.9998663l12.626 12.14c.198.191.205.507.013.707-.098.101-.229.153-.36.153"],"arrow-left_6":["M1 3c0-.1 0-.2.1-.3l2-2.5c.2-.2.5-.3.7-.1.2.2.3.5.1.7L2.1 3l1.8 2.2c.2.2.1.5-.1.7-.2.2-.5.1-.7-.1l-2-2.5C1 3.2 1 3.1 1 3"],"arrow-left_8":["M2.000078 4.000008c0-.116.04-.232.121-.325l3-3.5c.179-.21.495-.235.704-.054.211.18.234.495.054.704l-2.72 3.175 2.72 3.175c.18.209.157.526-.054.704-.209.181-.525.156-.704-.054l-3-3.5c-.081-.093-.121-.209-.121-.325"],"arrow-left-optical_10":["M6 9c-.128 0-.256-.049-.354-.146l-3.5-3.5c-.195-.196-.195-.512 0-.708l3.5-3.5c.196-.195.512-.195.708 0 .195.196.195.512 0 .708L3.207 5l3.147 3.146c.195.196.195.512 0 .708C6.256 8.951 6.128 9 6 9"],"arrow-left-optical_12":["M7.500251236 10.99959c.137 0 .273-.056.372-.165.1850000001-.206.1680000001-.522-.037-.707l-4.586999996-4.128 4.586999996-4.128c.2050000001-.185.2220000001-.501.037-.707-.185-.204-.501-.221-.706-.037l-4.999999996 4.5c-.106.096-.166.23-.166.372 0 .142.06.276.166.372l4.999999996 4.5c.095.086.215.128.334.128"],"arrow-left-optical_14":["M8.5178 13c-.136 0-.271-.055-.37-.163l-5.017-5.5c-.174-.191-.174-.483 0-.674l5.017-5.5c.186-.204.503-.219.707-.032.204.185.218.502.032.706L4.1768 7l4.71 5.163c.186.204.172.521-.032.706-.096.088-.217.131-.337.131"],"arrow-left-optical_16":["M4.23663562 7.9999l6.60428553-6.134c.20253009-.188.21355895-.505.02506561-.707-.18849335-.201-.50632522-.213-.7088553-.025l-6.997314214 6.5c-.1022676673.095-.159417246.227-.159417246.366 0 .139.0571495787.271.159417246.366l6.997314214 6.503c.09725454.09.21957469.134.34189484.134.13435165 0 .26870329-.053.36696046-.159.18849334-.202.17746448-.518-.02506561-.706l-6.60428553-6.138z"],"arrow-left-optical_18":["M3.99982987 9.00008138c0 .122.045.245.134.341l7.001000004 7.500000003c.188.2019999998.505.2129999998.707.024.2010000002-.188.2120000002-.506.024-.706L5.18382987 9.00008138l6.682000004-7.15899998c.1880000002-.2.1770000002-.518-.024-.706-.202-.189-.519-.178-.707.024L4.13382987 8.65908138c-.089.096-.134.219-.134.341"],"arrow-left-optical_20":["M11.5 17.9997048c-.134 0-.267-.053-.365-.159l-7-7.50000002c-.18-.192-.18-.49 0-.682l7-7.499999995c.189-.2010000002.507-.2130000002.706-.025.202.189.213.505.024.707L5.184 9.99970478l6.681 7.15900002c.189.202.178.518-.024.707-.096.09-.219.134-.341.134"],"arrow-left-optical_24":["M14.5002 22.0003c-.133 0-.265-.052-.363-.156l-9-9.5c-.183-.193-.183-.495 0-.688l9-9.5c.189-.2.506-.21.707-.019.2.19.209.507.019.707l-8.675 9.156 8.675 9.156c.19.2.181.517-.019.707-.097.092-.221.137-.344.137"],"arrow-left-optical_28":["M7.223 14.0008651L17.79 3.860865138c.201-.19.206-.506.015-.706-.19-.2000000002-.508-.2080000002-.706-.014L6.155 13.6408651c-.099.093-.155.224-.155.36 0 .136.056.267.155.36l10.944 10.5c.097.094.221.14.346.14.132 0 .262-.052.36-.154.191-.2.186-.516-.015-.706l-10.567-10.14z"],"arrow-left-optical_32":["M20.5 28.9998663c-.125 0-.25-.046-.347-.14l-13-12.5c-.098-.093-.153-.224-.153-.36 0-.136.055-.267.153-.36l13-12.499999993c.201-.1930000001.516-.1840000001.707.013.192.2.185.516-.013.707L8.221 15.9998663l12.626 12.14c.198.191.205.507.013.707-.098.101-.229.153-.36.153"],"arrow-left-optical_8":["M1.000078 4.000008c0-.116.04-.232.121-.325l3-3.5c.179-.21.495-.235.704-.054.211.18.234.495.054.704l-2.72 3.175 2.72 3.175c.18.209.157.526-.054.704-.209.181-.525.156-.704-.054l-3-3.5c-.081-.093-.121-.209-.121-.325"],"arrow-right_12":["M3.499748764 10.99959c-.137 0-.273-.056-.372-.165-.1850000001-.206-.1680000001-.522.037-.707l4.586999996-4.128-4.586999996-4.128c-.2050000001-.185-.2220000001-.501-.037-.707.185-.204.501-.221.706-.037l4.999999996 4.5c.106.096.166.23.166.372 0 .142-.06.276-.166.372l-4.999999996 4.5c-.095.086-.215.128-.334.128"],"arrow-right_16":["M10.76416438 7.9999l-6.60428553-6.134c-.20253009-.188-.21355895-.505-.02506561-.707.18849335-.201.50632522-.213.7088553-.025l6.997314214 6.5c.1022676673.095.159417246.227.159417246.366 0 .139-.0571495787.271-.159417246.366l-6.997314214 6.503c-.09725454.09-.21957469.134-.34189484.134-.13435165 0-.26870329-.053-.36696046-.159-.18849334-.202-.17746448-.518.02506561-.706l6.60428553-6.138z"],"arrow-right_18":["M13.00017013 8.99991862c0-.122-.045-.245-.134-.341L5.865170126 1.158918617c-.188-.2019999998-.505-.2129999998-.707-.024-.2010000002.188-.2120000002.506-.024.706L11.81617013 8.99991862 5.134170126 16.1589186c-.1880000002.2-.1770000002.518.024.706.202.189.519.178.707-.024l7.001000004-7.49999998c.089-.096.134-.219.134-.341"],"arrow-right_20":["M6.5 17.9997048c.134 0 .267-.053.365-.159l7-7.50000002c.18-.192.18-.49 0-.682l-7-7.499999995c-.189-.2010000002-.507-.2130000002-.706-.025-.202.189-.213.505-.024.707l6.681 7.158999995-6.681 7.15900002c-.189.202-.178.518.024.707.096.09.219.134.341.134"],"arrow-right_24":["M7.499888 22.0003c.133 0 .265-.052.363-.156l9-9.5c.183-.193.183-.495 0-.688l-9-9.5c-.189-.2-.506-.21-.707-.019-.2.19-.209.507-.019.707l8.675 9.156-8.675 9.156c-.19.2-.181.517.019.707.097.092.221.137.344.137"],"arrow-right_28":["M18.777 14.0008651L8.21 3.860865138c-.201-.19-.206-.506-.015-.706.19-.2000000002.508-.2080000002.706-.014L19.845 13.6408651c.099.093.155.224.155.36 0 .136-.056.267-.155.36l-10.944 10.5c-.097.094-.221.14-.346.14-.132 0-.262-.052-.36-.154-.191-.2-.186-.516.015-.706l10.567-10.14z"],"arrow-right_32":["M9.5 28.9998663c.125 0 .25-.046.347-.14l13-12.5c.098-.093.153-.224.153-.36 0-.136-.055-.267-.153-.36l-13-12.499999993c-.201-.1930000001-.516-.1840000001-.707.013-.192.2-.185.516.013.707L21.779 15.9998663l-12.626 12.14c-.198.191-.205.507-.013.707.098.101.229.153.36.153"],"arrow-right_6":["M5 3c0-.1 0-.2-.1-.3L2.9.2c-.2-.2-.5-.3-.7-.1-.2.2-.3.5-.1.7L3.9 3 2.1 5.2c-.2.2-.1.5.1.7.2.2.5.1.7-.1l2-2.5c.1-.1.1-.2.1-.3"],"arrow-right_8":["M6.000122 4.000008c0-.116-.04-.232-.121-.325l-3-3.5c-.179-.21-.495-.235-.704-.054-.211.18-.234.495-.054.704l2.72 3.175-2.72 3.175c-.18.209-.157.526.054.704.209.181.525.156.704-.054l3-3.5c.081-.093.121-.209.121-.325"],"arrow-right-optical_10":["M4.00019442 9.00025c.12798578 0 .25597156-.049.35396067-.146l3.499611158-3.5c.194978336-.196.194978336-.512 0-.708l-3.499611158-3.5c-.19597822-.195-.51194311-.195-.70792134 0-.19497833.196-.19497833.512 0 .708l3.14665037 3.146-3.14665037 3.146c-.19497833.196-.19497833.512 0 .708.09798911.097.22597489.146.35396067.146"],"arrow-right-optical_12":["M4.499748764 10.99959c-.137 0-.273-.056-.372-.165-.1850000001-.206-.1680000001-.522.037-.707l4.586999996-4.128-4.586999996-4.128c-.2050000001-.185-.2220000001-.501-.037-.707.185-.204.501-.221.706-.037l4.999999996 4.5c.106.096.166.23.166.372 0 .142-.06.276-.166.372l-4.999999996 4.5c-.095.086-.215.128-.334.128"],"arrow-right-optical_14":["M5.4822 13c.136 0 .271-.055.37-.163l5.017-5.5c.174-.191.174-.483 0-.674l-5.017-5.5c-.186-.204-.503-.219-.707-.032-.204.185-.218.502-.032.706L9.8232 7l-4.71 5.163c-.186.204-.172.521.032.706.096.088.217.131.337.131"],"arrow-right-optical_16":["M11.76416438 7.9999l-6.60428553-6.134c-.20253009-.188-.21355895-.505-.02506561-.707.18849335-.201.50632522-.213.7088553-.025l6.997314214 6.5c.1022676673.095.159417246.227.159417246.366 0 .139-.0571495787.271-.159417246.366l-6.997314214 6.503c-.09725454.09-.21957469.134-.34189484.134-.13435165 0-.26870329-.053-.36696046-.159-.18849334-.202-.17746448-.518.02506561-.706l6.60428553-6.138z"],"arrow-right-optical_18":["M14.00017013 8.99991862c0-.122-.045-.245-.134-.341L6.865170126 1.158918617c-.188-.2019999998-.505-.2129999998-.707-.024-.2010000002.188-.2120000002.506-.024.706L12.81617013 8.99991862 6.134170126 16.1589186c-.1880000002.2-.1770000002.518.024.706.202.189.519.178.707-.024l7.001000004-7.49999998c.089-.096.134-.219.134-.341"],"arrow-right-optical_20":["M8.5 17.9997048c.134 0 .267-.053.365-.159l7-7.50000002c.18-.192.18-.49 0-.682l-7-7.499999995c-.189-.2010000002-.507-.2130000002-.706-.025-.202.189-.213.505-.024.707l6.681 7.158999995-6.681 7.15900002c-.189.202-.178.518.024.707.096.09.219.134.341.134"],"arrow-right-optical_24":["M9.499888 22.0003c.133 0 .265-.052.363-.156l9-9.5c.183-.193.183-.495 0-.688l-9-9.5c-.189-.2-.506-.21-.707-.019-.2.19-.209.507-.019.707l8.675 9.156-8.675 9.156c-.19.2-.181.517.019.707.097.092.221.137.344.137"],"arrow-right-optical_28":["M20.777 14.0008651L10.21 3.860865138c-.201-.19-.206-.506-.015-.706.19-.2000000002.508-.2080000002.706-.014L21.845 13.6408651c.099.093.155.224.155.36 0 .136-.056.267-.155.36l-10.944 10.5c-.097.094-.221.14-.346.14-.132 0-.262-.052-.36-.154-.191-.2-.186-.516.015-.706l10.567-10.14z"],"arrow-right-optical_32":["M11.5 28.9998663c.125 0 .25-.046.347-.14l13-12.5c.098-.093.153-.224.153-.36 0-.136-.055-.267-.153-.36l-13-12.499999993c-.201-.1930000001-.516-.1840000001-.707.013-.192.2-.185.516.013.707L23.779 15.9998663l-12.626 12.14c-.198.191-.205.507-.013.707.098.101.229.153.36.153"],"arrow-right-optical_8":["M7.000122 4.000008c0-.116-.04-.232-.121-.325l-3-3.5c-.179-.21-.495-.235-.704-.054-.211.18-.234.495-.054.704l2.72 3.175-2.72 3.175c-.18.209-.157.526.054.704.209.181.525.156.704-.054l3-3.5c.081-.093.121-.209.121-.325"],"arrow-tail-down_10":["M8.8535 5.1465c-.195-.195-.512-.195-.707 0l-2.147 2.146 0-5.792c0-.277-.223-.5-.5-.5-.276 0-.5.223-.5.5l0 5.792-2.146-2.146c-.195-.195-.512-.195-.707 0-.195.195-.195.512 0 .707l3 3c.094.094.221.147.353.147.133 0 .26-.053.354-.147l3-3c.195-.195.195-.512 0-.707"],"arrow-tail-down_12":["M6.14101012 3.04527949L6.5 1.5l0 7.793 3.146-3.147c.196-.195.512-.195.708 0 .195.196.195.512 0 .708l-4 4c-.196.195-.512.195-.708 0l-4-4C1.549 6.756 1.5 6.628 1.5 6.5c0-.128.049-.256.146-.354.196-.195.512-.195.708 0L5.5 9.293l0-7.793c0-.276.224-.5.5-.5.276 0 .5.224.5.5"],"arrow-tail-down_14":["M11.8535 7.61388209c-.195-.19617706-.512-.19617706-.707 0l-3.647 3.66800801 0-9.778671991c0-.278672033-.223-.503018109-.5-.503018109-.276 0-.5.224346076-.5.503018109l0 9.778671991-3.646-3.66800801c-.195-.19617706-.512-.19617706-.707 0-.195.19617706-.195.51509055 0 .71126761l4.5 4.527163c.098.0985915.226.1478873.353.1478873.128 0 .256-.0492958.354-.1478873l4.5-4.527163c.195-.19617706.195-.51509055 0-.71126761"],"arrow-tail-down_16":["M8.5 13.29279407l5.146-5.15448982c.195-.19482953.512-.19482953.707 0 .196.19582865.195.51155239.001.70738104l-6 6.007743223C8.26 14.9473463345 8.133 15.0003 8 15.0003c-.133 0-.26-.0529536655-.354-.146871487l-6-6.007743223c-.097-.09791433-.146-.22580243-.146-.35369052 0-.1278881.049-.2557762.147-.35369052.195-.19482953.512-.19482953.707 0L7.5 13.29279407l0-11.79293117c0-.2757587.224-.4995629.5-.4995629.276 0 .5.2238042.5.4995629l0 11.79293117z"],"arrow-tail-down_20":["M10.5.5l0 17.792 6.146-6.143c.196-.195.512-.195.708 0 .195.196.195.512 0 .707l-7 6.997c-.196.195-.512.195-.708 0l-7-6.997c-.097-.097-.146-.225-.146-.353 0-.128.049-.256.146-.354.196-.195.512-.195.708 0L9.5 18.292 9.5.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5"],"arrow-tail-down_24":["M13.0001 1.5l0 19.793 8.146-8.147c.196-.195.512-.195.708 0 .195.196.195.512 0 .708l-9 9c-.196.195-.512.195-.708 0l-9-9c-.097-.098-.146-.226-.146-.354 0-.128.049-.256.146-.354.196-.195.512-.195.708 0l8.146 8.147 0-19.793c0-.276.224-.5.5-.5.276 0 .5.224.5.5"],"arrow-tail-down_28":["M15.00175.50675l0 25.786 10.145-10.14c.195-.195.511-.195.707 0 .195.196.195.512 0 .708l-10.998 10.993c-.196.195-.512.195-.708 0l-11.001-10.993c-.098-.098-.147-.226-.147-.354 0-.128.049-.256.147-.354.195-.195.511-.195.707 0l10.148 10.141 0-25.787c0-.276.224-.5.5-.5.276 0 .5.224.5.5"],"arrow-tail-down_36":["M32.85325 20.854l-14 14c-.046.046-.101.082-.163.107-.122.051-.259.051-.381 0-.062-.025-.117-.061-.163-.107l-14-14c-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0l13.146 13.146 0-31.793c0-.276.224-.5.5-.5.277 0 .5.224.5.5l0 31.793 13.147-13.146c.098-.098.226-.147.353-.147.128 0 .256.049.354.147.195.195.195.512 0 .707"],"arrow-tail-up_10":["M8.85325 4.854c-.195.195-.512.195-.707 0l-2.147-2.146 0 5.792c0 .277-.223.5-.5.5-.276 0-.5-.223-.5-.5l0-5.792-2.146 2.146c-.195.195-.512.195-.707 0-.195-.195-.195-.512 0-.707l3-3c.094-.094.221-.147.353-.147.133 0 .26.053.354.147l3 3c.195.195.195.512 0 .707"],"arrow-tail-up_12":["M6.14101012 8.95472051L6.5 10.5l0-7.793 3.146 3.147c.196.195.512.195.708 0 .195-.196.195-.512 0-.708l-4-4c-.196-.195-.512-.195-.708 0l-4 4c-.097.098-.146.226-.146.354 0 .128.049.256.146.354.196.195.512.195.708 0L5.5 2.707l0 7.793c0 .276.224.5.5.5.276 0 .5-.224.5-.5"],"arrow-tail-up_14":["M11.85325 6.38631791c-.195.19617706-.512.19617706-.707 0l-3.647-3.66800801 0 9.778671991c0 .278672033-.223.503018109-.5.503018109-.276 0-.5-.224346076-.5-.503018109l0-9.778671991-3.646 3.66800801c-.195.19617706-.512.19617706-.707 0-.195-.19617706-.195-.51509055 0-.71126761l4.5-4.527163C6.74425 1.0492958 6.87225 1 6.99925 1c.128 0 .256.0492958.354.1478873l4.5 4.527163c.195.19617706.195.51509055 0 .71126761"],"arrow-tail-up_16":["M8.5 2.70720593l5.146 5.15448982c.195.19482953.512.19482953.707 0 .196-.19582865.195-.51155239.001-.70738104l-6-6.007743223C8.26 1.0526536655 8.133.9997 8 .9997c-.133 0-.26.0529536655-.354.146871487l-6 6.007743223c-.097.09791433-.146.22580243-.146.35369052 0 .1278881.049.2557762.147.35369052.195.19482953.512.19482953.707 0L7.5 2.70720593l0 11.79293117c0 .2757587.224.4995629.5.4995629.276 0 .5-.2238042.5-.4995629l0-11.79293117z"],"arrow-tail-up_20":["M10.5 19.49925l0-17.792 6.146 6.143c.196.195.512.195.708 0 .195-.196.195-.512 0-.707l-7-6.997c-.196-.195-.512-.195-.708 0l-7 6.997c-.097.097-.146.225-.146.353 0 .128.049.256.146.354.196.195.512.195.708 0l6.146-6.143 0 17.792c0 .276.224.5.5.5.276 0 .5-.224.5-.5"],"arrow-tail-up_24":["M13.0001 22.5l0-19.793 8.146 8.147c.196.195.512.195.708 0 .195-.196.195-.512 0-.708l-9-9c-.196-.195-.512-.195-.708 0l-9 9c-.097.098-.146.226-.146.354 0 .128.049.256.146.354.196.195.512.195.708 0l8.146-8.147 0 19.793c0 .276.224.5.5.5.276 0 .5-.224.5-.5"],"arrow-tail-up_28":["M15.00175 27.49325l0-25.786 10.145 10.14c.195.195.511.195.707 0 .195-.196.195-.512 0-.708l-10.998-10.993c-.196-.195-.512-.195-.708 0l-11.001 10.993c-.098.098-.147.226-.147.354 0 .128.049.256.147.354.195.195.511.195.707 0l10.148-10.141 0 25.787c0 .276.224.5.5.5.276 0 .5-.224.5-.5"],"arrow-tail-up_36":["M32.85325 15.14525l-14-14c-.046-.046-.101-.082-.163-.107-.122-.051-.259-.051-.381 0-.062.025-.117.061-.163.107l-14 14c-.195.195-.195.512 0 .707.195.195.512.195.707 0l13.146-13.146 0 31.793c0 .276.224.5.5.5.277 0 .5-.224.5-.5l0-31.793 13.147 13.146c.098.098.226.147.353.147.128 0 .256-.049.354-.147.195-.195.195-.512 0-.707"],"arrow-up_12":["M1.00041 8.500251236c0 .137.056.273.165.372.206.1850000001.522.1680000001.707-.037l4.128-4.586999996 4.128 4.586999996c.185.2050000001.501.2220000001.707.037.204-.185.221-.501.037-.706l-4.5-4.999999996c-.096-.106-.23-.166-.372-.166-.142 0-.276.06-.372.166l-4.5 4.999999996c-.086.095-.128.215-.128.334"],"arrow-up_16":["M8.0001 5.23663562l6.134 6.60428553c.188.20253009.505.21355895.707.02506561.201-.18849335.213-.50632522.025-.7088553l-6.5-6.997314214C8.2711 4.0575495787 8.1391 4.0004 8.0001 4.0004c-.139 0-.271.0571495787-.366.159417246l-6.503 6.997314214c-.09.09725454-.134.21957469-.134.34189484 0 .13435165.053.26870329.159.36696046.202.18849334.518.17746448.706-.02506561l6.138-6.60428553z"],"arrow-up_18":["M8.99991862 4.99982987c-.122 0-.245.045-.341.134l-7.500000003 7.001000004c-.2019999998.188-.2129999998.505-.024.707.188.2010000002.506.2120000002.706.024L8.99991862 6.18382987l7.15899998 6.682000004c.2.1880000002.518.1770000002.706-.024.189-.202.178-.519-.024-.707L9.34091862 5.13382987c-.096-.089-.219-.134-.341-.134"],"arrow-up_20":["M9.99991862 5.99982987c-.122 0-.245.045-.341.134l-7.500000003 7.001000004c-.2019999998.188-.2129999998.505-.024.707.188.2010000002.506.2120000002.706.024L9.99991862 7.18382987l7.15899998 6.682000004c.2.1880000002.518.1770000002.706-.024.189-.202.178-.519-.024-.707L10.34091862 6.13382987c-.096-.089-.219-.134-.341-.134"],"arrow-up_24":["M1.9997 16.5002c0-.133.052-.265.156-.363l9.5-9c.193-.183.495-.183.688 0l9.5 9c.2.189.21.506.019.707-.19.2-.507.209-.707.019l-9.156-8.675-9.156 8.675c-.2.19-.517.181-.707-.019-.092-.097-.137-.221-.137-.344"],"arrow-up_28":["M13.9991349 10.223L24.139134862 20.79c.19.201.506.206.706.015.2000000002-.19.2080000002-.508.014-.706L14.3591349 9.155c-.093-.099-.224-.155-.36-.155-.136 0-.267.056-.36.155l-10.5 10.944c-.094.097-.14.221-.14.346 0 .132.052.262.154.36.2.191.516.186.706-.015l10.14-10.567z"],"arrow-up_32":["M3.0001337 22.5c0-.125.046-.25.14-.347l12.5-13c.093-.098.224-.153.36-.153.136 0 .267.055.36.153l12.499999993 13c.1930000001.201.1840000001.516-.013.707-.2.192-.516.185-.707-.013L16.0001337 10.221l-12.14 12.626c-.191.198-.507.205-.707.013-.101-.098-.153-.229-.153-.36"],"arrow-up_6":["M3 1c.1 0 .2 0 .3.1l2.5 2c.2.2.3.5.1.7-.2.2-.5.3-.7.1L3 2.1.8 3.9c-.2.2-.5.1-.7-.1-.2-.2-.1-.5.1-.7l2.5-2c.1-.1.2-.1.3-.1"],"arrow-up_8":["M3.99988099 2.00019289c.116 0 .232.04.325.121l3.5 3c.21.179.235.495.054.704-.18.211-.495.234-.704.054l-3.175-2.72-3.175 2.72c-.209.18-.526.157-.704-.054-.181-.209-.156-.525.054-.704l3.5-3c.093-.081.209-.121.325-.121"],"arrow-up-optical_12":["M1.00041 7.500251236c0 .137.056.273.165.372.206.1850000001.522.1680000001.707-.037l4.128-4.586999996 4.128 4.586999996c.185.2050000001.501.2220000001.707.037.204-.185.221-.501.037-.706l-4.5-4.999999996c-.096-.106-.23-.166-.372-.166-.142 0-.276.06-.372.166l-4.5 4.999999996c-.086.095-.128.215-.128.334"],"arrow-up-optical_14":["M1 8.5178c0-.136.055-.271.163-.37l5.5-5.017c.191-.174.483-.174.674 0l5.5 5.017c.204.186.219.503.032.707-.185.204-.502.218-.706.032L7 4.1768l-5.163 4.71c-.204.186-.521.172-.706-.032-.088-.096-.131-.217-.131-.337"],"arrow-up-optical_16":["M8.0001 4.23663562l6.134 6.60428553c.188.20253009.505.21355895.707.02506561.201-.18849335.213-.50632522.025-.7088553l-6.5-6.997314214C8.2711 3.0575495787 8.1391 3.0004 8.0001 3.0004c-.139 0-.271.0571495787-.366.159417246l-6.503 6.997314214c-.09.09725454-.134.21957469-.134.34189484 0 .13435165.053.26870329.159.36696046.202.18849334.518.17746448.706-.02506561l6.138-6.60428553z"],"arrow-up-optical_18":["M8.99991862 3.99982987c-.122 0-.245.045-.341.134l-7.500000003 7.001000004c-.2019999998.188-.2129999998.505-.024.707.188.2010000002.506.2120000002.706.024L8.99991862 5.18382987l7.15899998 6.682000004c.2.1880000002.518.1770000002.706-.024.189-.202.178-.519-.024-.707L9.34091862 4.13382987c-.096-.089-.219-.134-.341-.134"],"arrow-up-optical_20":["M2.0002952 11.5c0-.134.053-.267.159-.365l7.50000002-7c.192-.18.49-.18.682 0l7.499999995 7c.2010000002.189.2130000002.507.025.706-.189.202-.505.213-.707.024L10.00029522 5.184 2.8412952 11.865c-.202.189-.518.178-.707-.024-.09-.096-.134-.219-.134-.341"],"arrow-up-optical_24":["M1.9997 14.5002c0-.133.052-.265.156-.363l9.5-9c.193-.183.495-.183.688 0l9.5 9c.2.189.21.506.019.707-.19.2-.507.209-.707.019l-9.156-8.675-9.156 8.675c-.2.19-.517.181-.707-.019-.092-.097-.137-.221-.137-.344"],"arrow-up-optical_28":["M13.9991349 7.223L24.139134862 17.79c.19.201.506.206.706.015.2000000002-.19.2080000002-.508.014-.706L14.3591349 6.155c-.093-.099-.224-.155-.36-.155-.136 0-.267.056-.36.155l-10.5 10.944c-.094.097-.14.221-.14.346 0 .132.052.262.154.36.2.191.516.186.706-.015l10.14-10.567z"],"arrow-up-optical_32":["M3.0001337 20.5c0-.125.046-.25.14-.347l12.5-13c.093-.098.224-.153.36-.153.136 0 .267.055.36.153l12.499999993 13c.1930000001.201.1840000001.516-.013.707-.2.192-.516.185-.707-.013L16.0001337 8.221l-12.14 12.626c-.191.198-.507.205-.707.013-.101-.098-.153-.229-.153-.36"],"arrow-up-optical_8":["M4.000008 1.000078c-.116 0-.232.04-.325.121l-3.5 3c-.21.179-.235.495-.054.704.18.211.495.234.704.054l3.175-2.72 3.175 2.72c.209.18.526.157.704-.054.181-.209.156-.525-.054-.704l-3.5-3c-.093-.081-.209-.121-.325-.121"],"assign-host_24":["M18.5 12c3.038 0 5.5 2.463 5.5 5.5 0 3.037-2.462 5.5-5.5 5.5-.135 0-.268-.011-.4-.021-.034.007-.065.021-.1.021L1.157 23c-.356 0-.687-.161-.907-.442-.224-.287-.302-.653-.215-1.005l.77-3.132C1.446 15.817 3.74 14 6.384 14l1.029 0C5.373 12.775 4 10.548 4 8c0-3.859 3.14-7 7-7 3.86 0 7 3.141 7 7 0 1.669-.589 3.201-1.567 4.405.638-.259 1.336-.405 2.067-.405zm0 10c2.481 0 4.5-2.019 4.5-4.5 0-2.481-2.019-4.5-4.5-4.5-2.481 0-4.5 2.019-4.5 4.5 0 2.481 2.019 4.5 4.5 4.5zM1.157 22l14.187 0C13.928 21.005 13 19.362 13 17.5c0-.901.221-1.749.605-2.5l-7.221 0c-2.183 0-4.077 1.505-4.608 3.659l-.771 3.132c-.017.072.013.125.032.149.021.028.059.06.12.06zM5 8c0 3.309 2.691 6 6 6 3.309 0 6-2.691 6-6 0-3.309-2.691-6-6-6-3.309 0-6 2.691-6 6zm15.6465 7.6465c.195-.195.512-.195.707 0 .195.195.195.512 0 .707l-3 3c-.098.098-.226.147-.353.147-.128 0-.256-.049-.354-.147l-1.5-1.5c-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0l1.147 1.146 2.646-2.646z"],"assign-privilege_20":["M19.967 17.751c.078.294.016.603-.172.847-.196.256-.498.402-.827.402L8.5 19c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l10.468 0-.592-2.342C17.961 14.093 16.464 13 14.737 13L11 13c-3.309 0-6-2.691-6-6 0-3.309 2.691-6 6-6 3.309 0 6 2.691 6 6 0 2.086-1.071 3.925-2.69 5l.427 0c2.18 0 4.075 1.399 4.606 3.402l.624 2.349zM6 7c0 2.757 2.243 5 5 5 2.757 0 5-2.243 5-5 0-2.757-2.243-5-5-5-2.757 0-5 2.243-5 5zm1.8535 8.1465c.195.195.195.512 0 .707l-3 3c-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147-.195-.195-.195-.512 0-.707l2.146-2.146-5.793 0c-.274 0-.5-.225-.5-.5 0-.276.226-.5.5-.5l5.793 0-2.146-2.147c-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0l3 3z"],"attachment_12":["M3.4314857 11.9956c-.87899634 0-1.75799267-.3340028-2.42798988-1.0040084-1.337994426-1.33901113-1.337994426-3.51702929 0-4.85504044l3.06798721-3.06802558c.76599681-.76500638 2.01399161-.76500638 2.78098841 0 .37099845.3720031.5759976.86600722.5759976 1.3910116 0 .52500437-.20499915 1.01900849-.5759976 1.39001158L4.85147978 7.85056545c-.19499919.19600163-.51199787.19600163-.70699705 0-.19499919-.19500163-.19499919-.51100426 0-.7070059l2.00099166-2.00101668c.18199924-.18200152.28299882-.42400353.28299882-.68300569 0-.25800215-.10099958-.50100418-.28299882-.68400571-.37699843-.37700314-.98999588-.37700314-1.36699431 0L1.71049287 6.84355705c-.947996048.94900791-.947996048 2.49202078 0 3.44102865.94899605.9490079 2.49298961.9490079 3.44198566 0l5.13297857-5.13304275c.9489961-.94900792.9489961-2.49202078 0-3.44102869-.94899601-.949007912-2.49298958-.949007912-3.44098563 0-.19599918.19500163-.51199786.19500163-.70699705 0-.19599918-.19500163-.19599918-.51200427 0-.70700589 1.33799442-1.338011159 3.51698534-1.338011159 4.85497978 0 1.3389944 1.33901116 1.3389944 3.51602931 0 4.85504047L5.85947558 10.9915916C5.19047837 11.6605972 4.31048203 11.9956 3.4314857 11.9956"],"attachment_16":["M13.838 2.125c-1.498-1.5-4.111-1.5-5.609 0-.196.195-.196.512 0 .707.195.195.511.195.707 0 1.121-1.121 3.074-1.121 4.195 0 .561.561.869 1.306.869 2.098 0 .792-.308 1.537-.869 2.097l-6.066 6.067c-1.122 1.121-3.075 1.121-4.196 0-.56-.561-.869-1.306-.869-2.098 0-.792.309-1.537.869-2.098l4.026-4.025c.48-.48 1.263-.48 1.744 0 .48.481.48 1.264 0 1.744L6.147 9.109c-.196.196-.196.512 0 .707.195.196.511.196.707 0l2.492-2.492c.871-.871.871-2.287 0-3.158-.871-.871-2.287-.871-3.158 0L2.162 8.191C1.412 8.94 1 9.937 1 10.996c0 1.06.412 2.056 1.162 2.805.749.75 1.745 1.162 2.805 1.162 1.059 0 2.056-.412 2.805-1.162l6.066-6.067C14.588 6.985 15 5.989 15 4.93c0-1.06-.412-2.056-1.162-2.805"],"attachment_20":["M5.49705675 20c-1.2421327 0-2.46922748-.3999433-3.45772049-1.2158676C.804221255 17.7637257.0813982701 16.3263356.0062086392 14.7365862-.0679784632 13.1688888.525518356 11.633267 1.63431478 10.5246523l5.2151528-5.21329561c1.14187986-1.14469979 2.97851191-1.1918109 4.17954092-.11226478.6305904.5693428.9874905 1.34216551 1.0095461 2.18314898.0220557.84198583-.2927383 1.6328511-.8882401 2.22825536L7.87304908 12.8862221c-.19549304.1964633-.51229201.1964633-.70878758 0-.19549304-.195461-.19549304-.5122081 0-.7086714l3.2772654-3.27572586c.3990063-.3989409.6105398-.9291915.5955019-1.49352248-.015038-.56332862-.2546423-1.08155085-.6736991-1.45843975-.80904047-.72972105-2.03914283-.69564067-2.80507454.07016549l-5.21515279 5.2132956c-.90929327.9091442-1.396522081 2.1691159-1.33536785 3.455149.06215676 1.3040757.65565358 2.4848606 1.67021234 3.322837 1.7925208 1.4794893 4.55749415 1.2780142 6.29487589-.4580804l8.57963815-8.57923424c1.7373817-1.73709696 1.9378874-4.50161711.4581555-6.2938441-.8381138-1.01539481-2.0170872-1.60779199-3.3213766-1.66993856-1.2872465-.047111114-2.5464222.42500237-3.456718 1.33615132-.195493.195461-.5132946.195461-.7087876 0-.195493-.19646336-.195493-.51321041 0-.7086714C11.6335332.527072909 13.1744193-.0863739119 14.7373611.0098530403c1.5890076.0751773065 3.0266333.7968794477 4.0462047 2.0317919997 1.8055537 2.18615607 1.5759747 5.54207103-.5213148 7.64102143L9.68161034 18.2619007C8.53171025 19.4116123 7.00285442 20 5.49705675 20"],"audio-and-video-connection_20":["M19.5201098 2.06c.291.121.479.403.479.718l0 4.444c0 .316-.188.598-.479.719-.097.04-.199.059-.299.059-.201 0-.4-.079-.549-.228l-.673-.673 0 .568c0 .735-.599 1.333-1.334 1.333l-5.332 0c-.735 0-1.333-.598-1.333-1.333l0-5.334c0-.735.598-1.333 1.333-1.333l5.332 0c.735 0 1.334.598 1.334 1.333l0 .568.673-.673c.223-.224.557-.29.848-.168zm-.521 4.625l0-3.37-1 1 0 1.37 1 1zm-2 .982l0-5.334c0-.183-.149-.333-.334-.333l-5.332 0c-.184 0-.333.15-.333.333l0 5.334c0 .184.149.333.333.333l5.332 0c.185 0 .334-.149.334-.333zm-.9898 11.3325c-.164 0-.328-.021-.491-.062-3.037-.771-6.50300003-2.938-9.51000003-5.946-3.008-3.007-5.174999998-6.474-5.9469999982-9.511-.151-.596-.02-1.218.3590000002-1.706.383-.492.960999998-.775 1.584999998-.775l1.962 0c.999 0 1.901.593 2.296 1.512l.741 1.723c.349.814.323 1.734-.073 2.526l-.5 1c-.088.175-.065.383.058.542 1.042 1.339 2.622 2.907 4.22600003 4.195.155.125.368.148.543.062l.981-.491c.792-.396 1.713-.422 2.526-.073l1.723.741c.918.395 1.512 1.296 1.512 2.296l0 1.962c0 .624-.283 1.201-.776 1.585-.354.275-.78.42-1.215.42zm-14.00400003-17c-.313 0-.603.142-.796.39-.188.242-.252999998.55-.178.845.728 2.868 2.799 6.166 5.684 9.05 2.884 2.884 6.18200003 4.956 9.04900003 5.684.295.074.604.01.846-.179.248-.192.39-.482.39-.795l0-1.962c0-.6-.356-1.14-.907-1.377l-1.723-.741c-.542-.234-1.156-.216-1.684.048l-.981.491c-.523.26-1.157.191-1.616-.176-1.68600003-1.354-3.28600003-2.943-4.38900003-4.361-.357-.459-.421-1.088-.163-1.604l.499-.999c.264-.528.282-1.142.049-1.684l-.741-1.723c-.237-.551-.778-.907-1.377-.907l-1.962 0z"],"audio-and-video-connection_24":["M21.2038 15.4891c1.092.47 1.797 1.541 1.797 2.729l0 2.423c0 .734-.333 1.414-.912 1.865-.418.324-.919.494-1.431.494-.192 0-.385-.023-.576-.072-3.732-.948-7.994-3.615-11.695-7.315-3.7-3.7-6.366-7.963-7.314-11.694-.179-.701-.025-1.433.422-2.007.451-.579 1.131-.912 1.865-.912l2.423 0c1.187 0 2.259.705 2.728 1.796l.915 2.13c.419.972.388 2.074-.087 3.021l-.617 1.235c-.129.257-.096.561.084.795 1.313 1.686 3.223 3.582 5.24 5.201.226.181.538.217.797.09l1.211-.607c.948-.472 2.049-.505 3.022-.088l0 .001 2.128.915zm.797 5.152l0-2.423c0-.788-.468-1.498-1.193-1.811l-2.127-.914c-.7-.302-1.497-.278-2.179.063l-1.212.606c-.608.301-1.341.222-1.87-.205-2.076-1.665-4.044-3.621-5.403-5.367-.413-.532-.487-1.26-.189-1.856l.617-1.234c.342-.684.365-1.478.063-2.18l-.915-2.129c-.312-.723-1.022-1.191-1.81-1.191l-2.423 0c-.424 0-.815.192-1.076.526-.255.329-.344.746-.242 1.147.905 3.561 3.475 7.656 7.052 11.233 3.578 3.577 7.672 6.148 11.234 7.053.396.099.817.013 1.146-.242.334-.261.527-.653.527-1.076zm.3535-15.5628c.393.16.647.54.647.968l0 3.908c0 .427-.254.807-.647.968-.127.052-.26.077-.392.077-.27 0-.535-.107-.734-.309l-1.228-1.246 0 1.056c0 .825-.675 1.5-1.5 1.5l-4.999 0c-.825 0-1.5-.675-1.5-1.5l0-5c0-.825.675-1.5 1.5-1.5l4.999 0c.828 0 1.5.671 1.5 1.5l0 1.055 1.228-1.246c.295-.3.737-.392 1.126-.231zm-.414 4.91l.061-3.942-1.987 1.92c-.018.018-.018.05 0 .068l1.926 1.954zm-2.94.512l0-5c0-.276-.225-.5-.5-.5l-4.999 0c-.271 0-.5.229-.5.5l0 5c0 .271.229.5.5.5l4.999 0c.271 0 .5-.229.5-.5z"],"audio-broadcast_14":["M2.7573 2.749c-2.339 2.34-2.339 6.146 0 8.485.195.196.195.512 0 .707-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147-2.729-2.728-2.729-7.17 0-9.899.195-.195.512-.195.707 0 .195.195.195.512 0 .707zm9.1924-.707c2.729 2.729 2.729 7.171 0 9.899-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147-.195-.195-.195-.511 0-.707 2.339-2.338 2.339-6.145 0-8.485-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0zm-1.6162 1.2021c1.059.948 1.667 2.314 1.667 3.748 0 1.446-.609 2.813-1.669 3.75-.096.084-.214.125-.331.125-.139 0-.276-.057-.375-.169-.183-.207-.163-.523.043-.706.846-.747 1.332-1.841 1.332-3 0-1.15-.487-2.244-1.334-3.002-.206-.184-.223-.501-.039-.706.184-.206.5-.223.706-.04zm-5.9609.0401c.184.205.167.521-.039.706-.847.758-1.334 1.852-1.334 3.002 0 1.159.486 2.253 1.331 3 .207.183.227.499.044.706-.099.111-.236.169-.375.169-.117 0-.235-.041-.331-.125-1.06-.937-1.669-2.304-1.669-3.75 0-1.434.608-2.8 1.667-3.748.206-.183.522-.166.706.04zM7 4.9922c1.103 0 2 .897 2 2 0 1.103-.897 2-2 2-1.103 0-2-.897-2-2 0-1.103.897-2 2-2zm0 1c-.552 0-1 .448-1 1 0 .552.448 1 1 1 .552 0 1-.448 1-1 0-.552-.448-1-1-1z"],"audio-broadcast_16":["M13.6532485 2.3437c3.1190389 3.119 3.1190389 8.195 0 11.314-.0980013.098-.2260029.147-.3540045.147-.1270016 0-.2550032-.049-.3530044-.147-.1950024-.195-.1950024-.51 0-.707 2.7290341-2.728 2.7290341-7.169 0-9.9-.1950024-.194-.1950024-.512 0-.707.1950025-.194.5120064-.194.7070089 0zm-1.4056368 1.4151c1.1330142 1.134 1.757022 2.641 1.757022 4.242 0 1.603-.6240078 3.111-1.757022 4.242-.0980012.098-.2260028.148-.3540044.148-.1270016 0-.2550032-.05-.3530044-.148-.1950024-.195-.1950024-.51 0-.707.9440118-.944 1.4640183-2.199 1.4640183-3.535 0-1.336-.5200065-2.591-1.4640183-3.535-.1950024-.194-.1950024-.512 0-.707.1950024-.194.5120064-.194.7070088 0zm-9.20061497-.707c-2.729034114 2.729-2.729034114 7.17 0 9.899.19500244.196.19500244.513 0 .707-.19500244.196-.5120064.196-.70700884 0-3.119038986-3.119-3.119038986-8.194 0-11.313.09800123-.099.22600283-.147.35400443-.147.12700158 0 .25500318.048.35300441.147.19500244.194.19500244.511 0 .707zm1.41381767.708c.19500244.195.19500244.511 0 .707-.9440118.943-1.4640183 2.199-1.4640183 3.535 0 1.336.5200065 2.591 1.4640183 3.535.19500244.196.19500244.512 0 .707-.19500244.195-.5120064.195-.70700884 0-1.13301416-1.132-1.75702196-2.64-1.75702196-4.242 0-1.603.6240078-3.11 1.75702196-4.242.09800123-.098.22600283-.146.35400443-.146.12700159 0 .25500319.048.35300441.146zM7.99995864 6c1.1040138 0 2.000025.896 2.000025 2 0 1.104-.8960112 2-2.000025 2-1.1040138 0-2.000025-.896-2.000025-2 0-1.104.8960112-2 2.000025-2zm0 3c.5520069 0 1.0000125-.448 1.0000125-1 0-.552-.4480056-1-1.0000125-1-.5520069 0-1.0000125.448-1.0000125 1 0 .552.4480056 1 1.0000125 1z"],"audio-broadcast_20":["M1 10c0 2.404.936 4.664 2.636 6.364.196.195.196.511 0 .707-.097.097-.225.146-.353.146-.128 0-.256-.049-.354-.146C1.04 15.182 0 12.671 0 10c0-2.671 1.04-5.182 2.929-7.071.196-.195.512-.195.707 0 .196.196.196.512 0 .707C1.936 5.336 1 7.596 1 10zm16.0708-7.0708c1.889 1.889 2.929 4.4 2.929 7.071 0 2.671-1.04 5.182-2.929 7.071-.098.097-.226.146-.354.146-.127 0-.255-.049-.353-.146-.195-.196-.195-.512 0-.707 1.7-1.7 2.636-3.96 2.636-6.364 0-2.404-.936-4.664-2.636-6.364-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0zM5.7573 5.0503c.195.195.195.512 0 .707-2.339 2.339-2.339 6.146 0 8.485.195.196.195.512 0 .707-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147-1.322-1.322-2.05-3.08-2.05-4.949 0-1.87.728-3.628 2.05-4.95.195-.195.512-.195.707 0zm9.1924 0c1.322 1.322 2.05 3.08 2.05 4.95 0 1.869-.728 3.627-2.05 4.949-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147-.195-.195-.195-.511 0-.707 2.339-2.339 2.339-6.146 0-8.485-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0zM10 8c1.103 0 2 .897 2 2 0 1.103-.897 2-2 2-1.103 0-2-.897-2-2 0-1.103.897-2 2-2zm0 3c.551 0 1-.449 1-1 0-.551-.449-1-1-1-.551 0-1 .449-1 1 0 .551.449 1 1 1z"],"audio-broadcast_24":["M12 9.9863c-1.104 0-2 .896-2 2 0 1.104.896 2 2 2 1.104 0 2-.896 2-2 0-1.104-.896-2-2-2m0 1c.551 0 1 .448 1 1 0 .551-.449 1-1 1-.551 0-1-.449-1-1 0-.552.449-1 1-1zm-5.3033 6.8028c-.128 0-.256-.049-.354-.146-1.511-1.511-2.343-3.52-2.343-5.658 0-2.136.832-4.145 2.343-5.656.196-.195.512-.195.708 0 .195.195.195.512 0 .707-1.323 1.322-2.051 3.08-2.051 4.949 0 1.87.728 3.628 2.051 4.95.195.196.195.512 0 .708-.098.097-.226.146-.354.146zm10.6066 0c-.128 0-.256-.049-.354-.146-.195-.196-.195-.512 0-.708 1.323-1.322 2.051-3.08 2.051-4.95 0-1.869-.728-3.627-2.051-4.949-.195-.195-.195-.512 0-.707.196-.195.512-.195.708 0 1.511 1.511 2.343 3.52 2.343 5.656 0 2.138-.832 4.147-2.343 5.658-.098.097-.226.146-.354.146zm-13.435 2.8427c-.128 0-.256-.049-.354-.146-4.678-4.679-4.678-12.292 0-16.971.196-.195.512-.195.708 0 .195.195.195.512 0 .707-4.289 4.289-4.289 11.267 0 15.556.195.196.195.512 0 .708-.098.097-.226.146-.354.146zm16.2634 0c-.128 0-.256-.049-.354-.146-.195-.196-.195-.512 0-.708 4.289-4.289 4.289-11.267 0-15.556-.195-.195-.195-.512 0-.707.196-.195.512-.195.708 0 4.678 4.679 4.678 12.292 0 16.971-.098.097-.226.146-.354.146z"],"audio-call_16":["M1.74123187 1.98952019c-.23022901 0-.4444421.10407953-.5855825.28721948-.1391384.17713537-.186185203.40430897-.13213143.62147493.59659345 2.34679338 2.2962842 5.05085978 4.6626381 7.4166677 2.3663539 2.3668087 5.07004336 4.0651065 7.41938036 4.6625631.2132121.0530405.4414391.0050038.6216183-.132101.1821812-.1421086.2862848-.3552715.2862848-.5854474l0-1.6172359c0-.4583502-.2722708-.8736676-.694691-1.054806l-1.419412-.6104665c-.4234212-.1791369-.8998951-.1671277-1.3143074.0390298l-.80780352.404309c-.46145903.2301759-1.02301764.1691292-1.42741991-.1561193-1.39438705-1.118855-2.7187044-2.43385996-3.6316125-3.60875779-.31531366-.40430897-.37136942-.95973342-.14414339-1.41408062l.41140925-.82463017c.20620512-.41231509.22021906-.89068065.03803783-1.31300338l-.61160839-1.4200852c-.18118022-.42232274-.59459146-.69453075-1.0530475-.69453075l-1.6176091 0zM13.2857156 16.0002269c-.1421414 0-.2842828-.0180137-.4264242-.0540413-2.5185052-.6384879-5.39036197-2.4338599-7.88083934-4.9237626C2.48797469 8.53352101.693189346 5.66132612.0535530758 3.14440273-.0775773645 2.62600658.0355351527 2.0855936.364862747 1.66227011.698194325 1.23394279 1.19869219.988755418 1.74123187.988755418l1.6176091 0c.85985533 0 1.63462602.510390032 1.97296258 1.299993432l.61160839 1.41908444c.29829673.69453075.27627482 1.4801311-.06206174 2.15664808l-.41241024.8236294c-.05705675.11408719-.04204182.24919043.03903884.35326997.85485035 1.09883971 2.15214081 2.38682397 3.46945119 3.44263076.10210156.081062.24023897.0970742.35335149.0410314l.80680252-.404309c.6776741-.3372577 1.4614538-.36027529 2.1561448-.0620474l1.420413.6104665c.7897856.34026 1.3002934 1.114852 1.3002934 1.9735081l0 1.6172359c0 .5414138-.2452439 1.0427969-.6736701 1.3750508-.3073057.2401836-.6766731.3652791-1.0550495.3652791zm2.2129013-8.00711887c-.2612599 0-.480478-.20415601-.4984959-.46835791-.228227-3.48966675-3.0310151-6.29481039-6.52248818-6.52498629C8.201358.981750064 7.99315089.742567285 8.01116881.467356973c.01801793-.276211076.26226088-.4813678533.53252973-.4663563818C12.5336675.264201725 15.7388558 3.47065204 15.9991147 7.45970041c.0180179.27621108-.1911902.51339233-.467465.53140609-.0110109.00100077-.0210209.00200153-.0330328.00200153zm-3.013798-.00580443c-.2512499 0-.468466-.18914454-.4964939-.44534032-.2042031-1.84140718-1.6906817-3.32754286-3.53251388-3.53069811-.27527383-.03002294-.47347098-.2782126-.44244012-.55242215.03002988-.27420955.27126985-.46735715.55254965-.44233803 2.30429215.25519502 4.16113925 2.11261443 4.41739415 4.41537416.0300299.27420955-.1671663.52139845-.4414391.55242215-.0200199.00200153-.0380379.0030023-.0570568.0030023z"],"audio-input_16":["M7.99941932 14c-2.58474612 0-4.7515333-1.661-5.58945099-3.96l1.46985562-1.715c.01299873-.015.01699833-.035.02899716-.052.01899813-.029.03699636-.057.04899518-.088.01199883-.031.01899814-.06.02499755-.091.00599941-.031.01099892-.062.01099892-.094 0-.032-.00499951-.062-.01099892-.094-.00599941-.031-.01299872-.06-.02499755-.091-.01199882-.032-.02999705-.059-.04899518-.088-.01199883-.017-.01599843-.037-.02899716-.052L2.39297 5.939C3.2368871 3.648 5.41867281 2 7.99941932 2c2.57974658 0 4.77053138 1.643 5.61544848 3.932l-1.4948532 1.743c-.0129987.015-.0169983.036-.0279973.053-.019998.028-.0369963.056-.0499951.087-.0119988.031-.0189981.06-.0249975.091-.0059994.032-.0109989.062-.0109989.094 0 .032.0049995.063.0109989.095.0059994.031.0129987.06.0249975.09.0129988.032.0299971.059.0499951.088.010999.017.0149986.037.0279973.052l1.4908536 1.739C12.7659511 12.354 10.5791659 14 7.99941932 14zm5.15849328-6l2.7217327-3.175c.1799823-.209.1549848-.525-.0549946-.705-.0939908-.081-.2099794-.12-.3249681-.12-.1409861 0-.2799725.06-.3799626.175l-.784923.917C13.2299056 2.684 10.8221421 1 7.99941932 1 5.17969628 1 2.76293366 2.675 1.65404257 5.078l-.773923979-.903C.700136269 3.965.384167304 3.941.17518783 4.12c-.2099793751.18-.2349769198.496-.054994598.705L2.8419259 8 .120193232 11.175c-.1799823218.209-.1549847771.525.054994598.705.093990768.081.209979376.12.324968081.12.140986152 0 .280972403-.06.37996268-.175l.781923199-.912C2.76693326 13.319 5.17769647 15 7.99941932 15c2.82672238 0 5.22048728-1.694 6.32137908-4.107l.7989216.932c.1809822.21.4959512.234.7049307.055.2099794-.18.2349769-.496.0549946-.705L13.1579126 8z"],"audio-options_20":["M17.4 13.4l-1.8-.8c-.9-.4-1.8-.3-2.6.1l-1 .5c-.2.1-.4.1-.6-.1-1.7-1.4-3.4-3-4.5-4.4-.2-.2-.2-.4-.1-.6L7.3 7c.4-.8.4-1.8.1-2.7l-.8-1.7C6.2 1.6 5.2 1 4.2 1H2.1c-.7 0-1.3.3-1.7.8C0 2.3-.1 3 .1 3.6c.8 3.2 3.1 6.9 6.3 10.1 3.2 3.2 6.8 5.5 10.1 6.3.2 0 .3.1.5.1.5 0 .9-.2 1.3-.4.5-.4.8-1 .8-1.7v-2.1c-.1-1.1-.7-2.1-1.7-2.5zm.6 4.5c0 .3-.2.7-.4.9-.3.2-.6.2-.9.2-3-.8-6.5-3-9.6-6C4 9.9 1.8 6.4 1 3.3c0-.3 0-.6.2-.9.2-.2.6-.4.9-.4h2.1c.6 0 1.2.4 1.5 1l.8 1.8c.2.6.2 1.2-.1 1.8l-.5 1.1c-.3.5-.2 1.2.1 1.6 1.2 1.5 2.9 3.2 4.6 4.6.5.4 1.1.5 1.7.2l1-.5c.6-.3 1.2-.3 1.8-.1l1.8.8c.6.3 1 .8 1 1.5v2.1z"],"audio-options_24":["M14.3 10c.1 0 .1 0 .2 0h7c.3 0 .5-.2.5-.5 0-.3-.2-.5-.5-.5h-5.8L23.8.9c.2-.2.2-.5 0-.7-.2-.2-.5-.2-.7 0L15 8.3V2.5c0-.3-.2-.5-.5-.5-.3 0-.5.2-.5.5v7c0 .1 0 .1 0 .2.1.1.2.2.3.3z"],"audio-options_28":["M16.1 11.7c0 .1 0 .1 0 0 .1.1.2.2.2.2.1 0 .1 0 .2 0h8c.3 0 .5-.2.5-.5 0-.3-.2-.5-.5-.5h-6.8L27.8.9c.2-.2.2-.5 0-.7-.2-.2-.5-.2-.7 0L17 10.3V3.5c0-.3-.2-.5-.5-.5-.3 0-.5.2-.5.5v8c0 0 0 .1 0 .1 0 0 0 .1.1.1z"],"audio-options_32":["M26.7 22.3l-2.8-1.2c-1.3-.5-2.7-.5-3.9.1l-1.6.8c-.4.2-.9.1-1.2-.1-2.7-2.2-5.3-4.7-7-7-.3-.4-.3-.8-.1-1.2l.8-1.6c.6-1.2.7-2.6.1-3.9L9.7 5.3C9.1 3.9 7.7 3 6.2 3H3c-.9 0-1.8.4-2.4 1.2-.5.7-.7 1.6-.5 2.5 1.3 4.9 4.8 10.6 9.7 15.5 4.9 4.9 10.6 8.5 15.5 9.7.3.1.5.1.7.1.6 0 1.3-.2 1.8-.6.7-.6 1.2-1.4 1.2-2.4v-3.2c0-1.5-.9-2.9-2.3-3.5zM28 29c0 .6-.3 1.2-.8 1.6-.5.4-1.1.5-1.7.4-4.8-1.2-10.3-4.7-15.1-9.4-4.7-4.9-8.1-10.4-9.3-15.2-.2-.5-.1-1.2.3-1.6.4-.5 1-.8 1.6-.8h3.2c1.1 0 2.1.7 2.6 1.7L10 8.5c.4 1 .4 2.1-.1 3l-.8 1.6c-.4.7-.3 1.6.2 2.3 1.8 2.3 4.4 4.9 7.2 7.1.7.5 1.6.6 2.3.3l1.6-.8c1-.5 2.1-.5 3-.1l2.8 1.2c1 .4 1.7 1.4 1.7 2.6V29z"],"back_10":["M4.854 8.85325c.195-.195.195-.512 0-.707l-2.146-2.147 5.792 0c.277 0 .5-.223.5-.5 0-.276-.223-.5-.5-.5l-5.792 0 2.146-2.146c.195-.195.195-.512 0-.707-.195-.195-.512-.195-.707 0l-3 3c-.094.094-.147.221-.147.353 0 .133.053.26.147.354l3 3c.195.195.512.195.707 0"],"back_12":["M8.95472051 5.85898988L10.5 5.5l-7.793 0 3.147-3.146c.195-.196.195-.512 0-.708-.196-.195-.512-.195-.708 0l-4 4c-.195.196-.195.512 0 .708l4 4c.098.097.226.146.354.146.128 0 .256-.049.354-.146.195-.196.195-.512 0-.708L2.707 6.5l7.793 0c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5"],"back_16":["M2.70720593 7.49975l5.15448982-5.146c.19482953-.195.19482953-.512 0-.707-.19582865-.196-.51155239-.195-.70738104-.001l-6.007743223 6c-.0939178215.094-.146871487.221-.146871487.354 0 .133.0529536655.26.146871487.354l6.007743223 6c.09791433.097.22580243.146.35369052.146.1278881 0 .2557762-.049.35369052-.147.19482953-.195.19482953-.512 0-.707l-5.15448982-5.146 11.79293117 0c.2757587 0 .4995629-.224.4995629-.5 0-.276-.2238042-.5-.4995629-.5l-11.79293117 0z"],"back_20":["M19.499 9.5l-17.792 0L7.85 3.354c.195-.196.195-.512 0-.708-.196-.195-.512-.195-.707 0l-6.997 7c-.195.196-.195.512 0 .708l6.997 7c.097.097.225.146.353.146.128 0 .256-.049.354-.146.195-.196.195-.512 0-.708L1.707 10.5l17.792 0c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5"],"back_24":["M22.5 11.9999l-19.793 0 8.147-8.146c.195-.196.195-.512 0-.708-.196-.195-.512-.195-.708 0l-9 9c-.195.196-.195.512 0 .708l9 9c.098.097.226.146.354.146.128 0 .256-.049.354-.146.195-.196.195-.512 0-.708l-8.147-8.146 19.793 0c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5"],"back_28":["M27.49325 13.99825l-25.786 0 10.14-10.145c.195-.195.195-.511 0-.707-.196-.195-.512-.195-.708 0l-10.993 10.998c-.195.196-.195.512 0 .708l10.993 11.001c.098.098.226.147.354.147.128 0 .256-.049.354-.147.195-.195.195-.511 0-.707l-10.141-10.148 25.787 0c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5"],"back_36":["M15.14525 4.14675l-14 14c-.046.046-.082.101-.107.163-.051.122-.051.259 0 .381.025.062.061.117.107.163l14 14c.195.195.512.195.707 0 .195-.195.195-.512 0-.707l-13.146-13.146 31.793 0c.276 0 .5-.224.5-.5 0-.277-.224-.5-.5-.5l-31.793 0 13.146-13.147c.098-.098.147-.226.147-.353 0-.128-.049-.256-.147-.354-.195-.195-.512-.195-.707 0"],"back-to-fullscreen_12":["M11 5c.55 0 1 .45 1 1l0 4c0 .55-.45 1-1 1l-6 0c-.55 0-1-.45-1-1l0-4c0-.55.45-1 1-1l4 0 1 0 1 0zM8.5 1c.829 0 1.5.671 1.5 1.5l0 1c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-1c0-.275-.225-.5-.5-.5l-7 0c-.275 0-.5.225-.5.5l0 5c0 .275.225.5.5.5l1 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0C.671 9 0 8.329 0 7.5l0-5C0 1.671.671 1 1.5 1l7 0z"],"back-to-fullscreen_14":["M12.8545 5.9999c.633 0 1.146.513 1.146 1.146l0 4.708c0 .633-.513 1.146-1.146 1.146l-6.709 0c-.633 0-1.145-.513-1.145-1.146l0-4.708c0-.633.512-1.146 1.145-1.146l6.709 0zM1.5.9999l9 0c.828 0 1.5.672 1.5 1.5l0 2c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-2c0-.275-.225-.5-.5-.5l-9 0c-.275 0-.5.225-.5.5l0 7c0 .275.225.5.5.5l2 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-2 0c-.828 0-1.5-.672-1.5-1.5l0-7c0-.828.672-1.5 1.5-1.5z"],"back-to-fullscreen_16":["M14.7002 7c.715 0 1.3.585 1.3 1.3l0 5.4c0 .715-.585 1.3-1.3 1.3l-7.4 0c-.715 0-1.3-.585-1.3-1.3l0-5.4c0-.715.585-1.3 1.3-1.3l7.4 0zM2 1l10 0c1.104 0 2 .896 2 2l0 2.5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5L13 3c0-.552-.448-1-1-1L2 2c-.552 0-1 .448-1 1l0 8c0 .552.448 1 1 1l2.5 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L2 13c-1.104 0-2-.896-2-2l0-8c0-1.104.896-2 2-2z"],"back-to-fullscreen_20":["M18.252 9.0004c.966 0 1.748.782 1.748 1.747l0 5.505c0 .965-.782 1.748-1.748 1.748l-8.504 0c-.966 0-1.748-.783-1.748-1.748l0-1.252-5.5 0c-1.381 0-2.5-1.12-2.5-2.5l0-8c0-1.381 1.119-2.5 2.5-2.5l12 0c1.381 0 2.5 1.119 2.5 2.5l0 4.5 1.252 0zm.748 7.252l0-5.505c0-.412-.335-.747-.748-.747l-8.504 0c-.413 0-.748.335-.748.747l0 5.505c0 .412.335.748.748.748l8.504 0c.413 0 .748-.336.748-.748zm-16.5-2.252l5.5 0 0-3.253c0-.965.782-1.747 1.748-1.747l6.252 0 0-4.5c0-.828-.673-1.5-1.5-1.5l-12 0c-.827 0-1.5.672-1.5 1.5l0 8c0 .827.673 1.5 1.5 1.5zM7 5.5c0 .275-.225.5-.5.5L4.707 6l2.147 2.146c.195.196.195.512 0 .708C6.756 8.951 6.628 9 6.5 9c-.128 0-.256-.049-.354-.146L4 6.707 4 8.5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-3c0-.275.225-.5.5-.5l3 0c.275 0 .5.225.5.5z"],"back-to-fullscreen_22":["M19.5 10c1.381 0 2.5 1.119 2.5 2.5l0 5c0 1.381-1.119 2.5-2.5 2.5l-8 0C10.119 20 9 18.881 9 17.5l0-.5-6.5 0C1.119 17 0 15.881 0 14.5l0-10C0 3.119 1.119 2 2.5 2l14 0C17.881 2 19 3.119 19 4.5l0 5.5.5 0zm1.5 7.5l0-5c0-.827-.673-1.5-1.5-1.5l-8 0c-.827 0-1.5.673-1.5 1.5l0 5c0 .827.673 1.5 1.5 1.5l8 0c.827 0 1.5-.673 1.5-1.5zm-12-5c0-1.381 1.119-2.5 2.5-2.5l6.5 0 0-5.5c0-.827-.673-1.5-1.5-1.5l-14 0C1.673 3 1 3.673 1 4.5l0 10c0 .827.673 1.5 1.5 1.5L9 16l0-3.5zm-1-7c0 .275-.225.5-.5.5L4.707 6l3.147 3.146c.195.196.195.512 0 .708-.098.097-.226.146-.354.146-.128 0-.256-.049-.354-.146L4 6.707 4 9.5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-4c0-.275.225-.5.5-.5l4 0c.275 0 .5.225.5.5z"],"back-to-fullscreen_24":["M21 12l1 0c1.104 0 2 .896 2 2l0 6c0 1.104-.896 2-2 2l-10 0c-1.104 0-2-.896-2-2l0-1-7.5 0C1.125 19 0 17.875 0 16.5l0-12C0 3.125 1.125 2 2.5 2l16 0C19.875 2 21 3.125 21 4.5l0 7.5zm2 8l0-6c0-.551-.448-1-1-1l-10 0c-.552 0-1 .449-1 1l0 6c0 .551.448 1 1 1l10 0c.552 0 1-.449 1-1zM2.5 18l7.5 0 0-4c0-1.104.896-2 2-2l8 0 0-7.5c0-.827-.673-1.5-1.5-1.5l-16 0C1.673 3 1 3.673 1 4.5l0 12c0 .827.673 1.5 1.5 1.5zM5.207 6.5l4.146 4.146c.196.196.196.512 0 .708-.097.097-.225.146-.353.146-.128 0-.256-.049-.354-.146L4.5 7.207 4.5 10c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-4c0-.275.225-.5.5-.5l4 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-2.793 0z"],"back-to-fullscreen-adr_12":["M10.5 1c.829 0 1.5.671 1.5 1.5l0 7c0 .829-.671 1.5-1.5 1.5l-9 0C.671 11 0 10.329 0 9.5l0-7C0 1.671.671 1 1.5 1l9 0zm.5 8.5l0-7c0-.276-.224-.5-.5-.5l-9 0c-.276 0-.5.224-.5.5l0 7c0 .276.224.5.5.5l9 0c.276 0 .5-.224.5-.5zM4.5 3c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L3 4l0 1.5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-2c0-.275.225-.5.5-.5l2 0zm5 3c.275 0 .5.225.5.5l0 2c0 .275-.225.5-.5.5l-2 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5L9 8l0-1.5c0-.275.225-.5.5-.5z"],"back-to-fullscreen-adr_14":["M12.5 2c.827 0 1.5.673 1.5 1.5l0 7c0 .827-.673 1.5-1.5 1.5l-11 0C.673 12 0 11.327 0 10.5l0-7C0 2.673.673 2 1.5 2l11 0zm.5 8.5l0-7c0-.275-.224-.5-.5-.5l-11 0c-.276 0-.5.225-.5.5l0 7c0 .275.224.5.5.5l11 0c.276 0 .5-.225.5-.5zM4.5 4c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L3 5l0 1.5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-2c0-.275.225-.5.5-.5l2 0zm7 3c.275 0 .5.225.5.5l0 2c0 .275-.225.5-.5.5l-2 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5L11 9l0-1.5c0-.275.225-.5.5-.5z"],"back-to-fullscreen-adr_16":["M14 2c1.104 0 2 .896 2 2l0 8c0 1.104-.896 2-2 2L2 14c-1.104 0-2-.896-2-2l0-8c0-1.104.896-2 2-2l12 0zm1 10l0-8c0-.552-.448-1-1-1L2 3c-.552 0-1 .448-1 1l0 8c0 .552.448 1 1 1l12 0c.552 0 1-.448 1-1zM5.5 4c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L3 5l0 2.5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-3c0-.275.225-.5.5-.5l3 0zm8 4c.275 0 .5.225.5.5l0 3c0 .275-.225.5-.5.5l-3 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l2.5 0 0-2.5c0-.275.225-.5.5-.5z"],"back-to-fullscreen-adr_20":["M17.5 2C18.875 2 20 3.125 20 4.5l0 11c0 1.375-1.125 2.5-2.5 2.5l-15 0C1.127 18 .003 16.877 0 15.504l0-.004 0-11 0-.004C.003 3.123 1.127 2 2.5 2l15 0zM19 15.5l0-11c0-.827-.673-1.5-1.5-1.5l-15 0C1.673 3 1 3.673 1 4.5l0 11c0 .827.673 1.5 1.5 1.5l15 0c.827 0 1.5-.673 1.5-1.5zM16.5 10c.276 0 .5.224.5.5l0 4c0 .276-.224.5-.5.5l-4 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l3.5 0 0-3.5c0-.276.224-.5.5-.5zm-9-5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5L4 6l0 3.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-4c0-.276.224-.5.5-.5l4 0z"],"back-to-fullscreen-adr_22":["M19.5 2C20.881 2 22 3.119 22 4.5l0 13c0 1.381-1.119 2.5-2.5 2.5l-17 0C1.119 20 0 18.881 0 17.5l0-13C0 3.119 1.119 2 2.5 2l17 0zM21 17.5l0-13c0-.827-.673-1.5-1.5-1.5l-17 0C1.673 3 1 3.673 1 4.5l0 13c0 .827.673 1.5 1.5 1.5l17 0c.827 0 1.5-.673 1.5-1.5zM7.5 5c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L4 6l0 3.5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-4c0-.275.225-.5.5-.5l4 0zm11 7c.275 0 .5.225.5.5l0 4c0 .275-.225.5-.5.5l-4 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l3.5 0 0-3.5c0-.275.225-.5.5-.5z"],"back-to-fullscreen-adr_24":["M21.5 3C22.878 3 24 4.121 24 5.5l0 13c0 1.379-1.122 2.5-2.5 2.5l-19 0C1.122 21 0 19.879 0 18.5l0-13C0 4.121 1.122 3 2.5 3l19 0zM23 18.5l0-13c0-.827-.673-1.5-1.5-1.5l-19 0C1.673 4 1 4.673 1 5.5l0 13c0 .827.673 1.5 1.5 1.5l19 0c.827 0 1.5-.673 1.5-1.5zM7.5 6c.276 0 .5.224.5.5 0 .276-.224.5-.5.5L4 7l0 3.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-4c0-.276.224-.5.5-.5l4 0zm14 7c.276 0 .5.224.5.5l0 4c0 .276-.224.5-.5.5l-4 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l3.5 0 0-3.5c0-.276.224-.5.5-.5z"],"back-to-fullscreen-adr_26":["M23.3 2.9998c1.491 0 2.7 1.209 2.7 2.7l0 14.6c0 1.491-1.209 2.7-2.7 2.7l-20.6 0c-1.491 0-2.7-1.209-2.7-2.7l0-14.6c0-1.491 1.209-2.7 2.7-2.7l20.6 0zm1.7 17.3l0-14.6c0-.939-.761-1.7-1.7-1.7l-20.6 0c-.939 0-1.7.761-1.7 1.7l0 14.6c0 .939.761 1.7 1.7 1.7l20.6 0c.939 0 1.7-.761 1.7-1.7zM8.5 6c.276 0 .5.224.5.5 0 .276-.224.5-.5.5L4 7l0 4.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-5c0-.276.224-.5.5-.5l5 0zm14 8c.276 0 .5.224.5.5l0 5c0 .276-.224.5-.5.5l-5 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l4.5 0 0-4.5c0-.276.224-.5.5-.5z"],"back-to-fullscreen-adr_28":["M3 3l22 0c1.6568542 0 3 1.34314575 3 3l0 16c0 1.6568542-1.3431458 3-3 3L3 25c-1.65685425 0-3-1.3431458-3-3L0 6c0-1.65685425 1.34314575-3 3-3zm0 1c-1.1045695 0-2 .8954305-2 2l0 16c0 1.1045695.8954305 2 2 2l22 0c1.1045695 0 2-.8954305 2-2l0-16c0-1.1045695-.8954305-2-2-2L3 4zm5.5 2c.276 0 .5.224.5.5 0 .276-.224.5-.5.5L4 7l0 4.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-5c0-.276.224-.5.5-.5l5 0zm16 10c.276 0 .5.224.5.5l0 5c0 .276-.224.5-.5.5l-5 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l4.5 0 0-4.5c0-.276.224-.5.5-.5z"],"backspace_16":["M14.0002526 2C15.1031133 2 16 2.897 16 4l0 8c0 1.104-.8968867 2-1.9997474 2l-8.46593051 0c-.54393128 0-1.05486674-.24-1.40282278-.659L.232991794 8.629c-.3129604646-.354-.3119605909-.904.010998611-1.27l3.896507765-4.71C4.4814551 2.237 4.98439157 2 5.52032386 2l8.47992874 0zm.9998737 10l0-8c0-.551-.4489433-1-.9998737-1L5.52032386 3c-.23697006 0-.45894202.104-.60892307.287L1.00289453 8.01l3.89950739 4.693c.1559803.189.38695112.297.63192017.297l8.46593051 0c.5509304 0 .9998737-.448.9998737-1zm-2.1544278-6.8536c.1949753.195.1949753.512 0 .707l-2.145729 2.147 2.145729 2.146c.1949753.195.1949753.512 0 .707-.0979876.098-.2259715.147-.3539553.147-.126984 0-.2549678-.049-.3529554-.147l-2.14672884-2.146-2.14572893 2.146c-.09798763.098-.22597146.147-.35395529.147-.12698396 0-.25496779-.049-.35295541-.147-.19497537-.195-.19497537-.512 0-.707l2.14572894-2.146-2.14572894-2.147c-.19497537-.195-.19497537-.512 0-.707.19497537-.195.51193533-.195.7069107 0l2.14572893 2.146 2.14672884-2.146c.1949753-.195.5119353-.195.7069107 0z"],"backspace_20":["M17.4992 3c1.381 0 2.5 1.119 2.5 2.5l0 9c0 1.381-1.119 2.5-2.5 2.5l-10.589 0c-.723 0-1.41-.313-1.885-.858l-4.783-5.491c-.322-.38-.322-.922-.005-1.297l4.788-5.496C5.5002 3.313 6.1872 3 6.9102 3l10.589 0zm1.5 11.5l0-9c0-.827-.673-1.5-1.5-1.5L6.9102 4c-.433 0-.846.187-1.131.515l-4.783 5.491 4.783 5.479c.285.327.698.515 1.131.515l10.589 0c.827 0 1.5-.673 1.5-1.5zm-2.1465-8.3535c.195.195.195.512 0 .707l-3.146 3.147 3.146 3.146c.195.195.195.512 0 .707-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147l-3.147-3.146-3.146 3.146c-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147-.195-.195-.195-.512 0-.707l3.146-3.146-3.146-3.147c-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0l3.146 3.146 3.147-3.146c.195-.195.512-.195.707 0z"],"backspace_24":["M21.4731 3L8.1881 3c-.736 0-1.433.316-1.914.868l-5.964 7.347c-.412.444-.412 1.139-.011 1.57l5.975 7.347c.481.552 1.177.868 1.914.868l13.285 0c1.393 0 2.527-1.121 2.527-2.5l0-13c0-1.378-1.134-2.5-2.527-2.5m0 1c.842 0 1.527.673 1.527 1.5l0 13c0 .827-.685 1.5-1.527 1.5l-13.285 0c-.447 0-.87-.191-1.138-.499l-5.975-7.347-.021-.026-.022-.024c-.043-.045-.047-.146.011-.209l.023-.024.02-.026 5.942-7.321c.29-.333.713-.524 1.16-.524l13.285 0zM19.5 7.5c-.128 0-.256.049-.354.146L15.5 11.292l-3.646-3.646c-.098-.097-.226-.146-.354-.146-.128 0-.256.049-.354.146-.195.195-.195.512 0 .707L14.792 12l-3.646 3.646c-.195.195-.195.512 0 .707.098.098.226.147.353.147.128 0 .256-.049.355-.147l3.646-3.646 3.646 3.646c.099.098.227.147.354.147.128 0 .256-.049.354-.147.195-.195.195-.512 0-.707L16.208 12l3.646-3.647c.195-.195.195-.512 0-.707-.098-.097-.226-.146-.354-.146z"],"backup-data_16":["M0 2C0 .896.896 0 2 0l12 0c1.1 0 2 .9 2 2l0 12c0 1.104-.896 2-2 2L2 16c-1.1 0-2-.9-2-2L0 2zm1 0l0 12c0 .551.449 1 1 1l12 0c.551 0 1-.448 1-1l0-12c0-.552-.449-1-1-1L2 1c-.551 0-1 .448-1 1zm3.5 2c.276 0 .5.224.5.5l0 .866C5.75 4.511 6.833 4 8 4c2.206 0 4 1.794 4 4 0 2.206-1.794 4-4 4-1.533 0-2.951-.895-3.611-2.278-.119-.25-.014-.548.236-.667.249-.12.547-.014.666.235C5.787 10.329 6.85 11 8 11c1.654 0 3-1.346 3-3 0-1.654-1.346-3-3-3-.864 0-1.668.373-2.23 1l.73 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-2 0c-.276 0-.5-.224-.5-.5l0-2c0-.276.224-.5.5-.5z"],"backup-data_24":["M20.5 1C21.879 1 23 2.121 23 3.5l0 17c0 1.379-1.121 2.5-2.5 2.5l-17 0C2.121 23 1 21.879 1 20.5l0-17C1 2.121 2.121 1 3.5 1l17 0zM22 20.5l0-17c0-.827-.673-1.5-1.5-1.5l-17 0C2.673 2 2 2.673 2 3.5l0 17c0 .827.673 1.5 1.5 1.5l17 0c.827 0 1.5-.673 1.5-1.5zM12 6c3.309 0 6 2.691 6 6 0 3.309-2.691 6-6 6-2.675 0-5.049-1.796-5.775-4.367-.075-.266.08-.542.346-.617.265-.075.541.08.617.345C7.792 15.504 9.771 17 12 17c2.757 0 5-2.243 5-5 0-2.757-2.243-5-5-5-1.99 0-3.783 1.21-4.57 3l3.07 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-4 0c-.276 0-.5-.224-.5-.5l0-4c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 2.208C8.093 7.062 9.96 6 12 6z"],"battery_20":["M17.5 2C18.881 2 20 3.119 20 4.5l0 11c0 1.381-1.119 2.5-2.5 2.5l-13 0C3.119 18 2 16.881 2 15.5L2 12l-1 0c-.552 0-1-.448-1-1l0-2c0-.552.448-1 1-1l1 0 0-3.5C2 3.119 3.119 2 4.5 2l13 0zM19 15.5l0-11c0-.827-.673-1.5-1.5-1.5l-13 0C3.673 3 3 3.673 3 4.5L3 9l0 2 0 4.5c0 .827.673 1.5 1.5 1.5l13 0c.827 0 1.5-.673 1.5-1.5zM1 11l1 0 0-2-1 0 0 2zm5.5-5c.275 0 .5.225.5.5l0 7c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-7c0-.275.225-.5.5-.5zm3 0c.275 0 .5.225.5.5l0 7c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-7c0-.275.225-.5.5-.5zm3 0c.275 0 .5.225.5.5l0 7c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-7c0-.275.225-.5.5-.5zm3 0c.275 0 .5.225.5.5l0 7c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-7c0-.275.225-.5.5-.5z"],"battery_24":["M21.5 3C22.881 3 24 4.119 24 5.5l0 13c0 1.381-1.119 2.5-2.5 2.5l-16 0C4.119 21 3 19.881 3 18.5l0-4-1.5 0C.672 14.5 0 13.829 0 13l0-2c0-.829.672-1.5 1.5-1.5l1.5 0 0-4C3 4.119 4.119 3 5.5 3l16 0zM23 18.5l0-13c0-.827-.673-1.5-1.5-1.5l-16 0C4.673 4 4 4.673 4 5.5l0 4 0 5 0 4c0 .827.673 1.5 1.5 1.5l16 0c.827 0 1.5-.673 1.5-1.5zm-21.5-5l1.5 0 0-3-1.5 0c-.275 0-.5.224-.5.5l0 2c0 .276.225.5.5.5zm6-6.5c.275 0 .5.225.5.5l0 9c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-9c0-.275.225-.5.5-.5zm4 0c.275 0 .5.225.5.5l0 9c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-9c0-.275.225-.5.5-.5zm4 0c.275 0 .5.225.5.5l0 9c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-9c0-.275.225-.5.5-.5zm4 0c.275 0 .5.225.5.5l0 9c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-9c0-.275.225-.5.5-.5z"],"blocked_12":["M6 11c-1.198 0-2.284-.441-3.146-1.146l7-7C10.559 3.716 11 4.802 11 6c0 2.757-2.243 5-5 5M6 1c1.198 0 2.284.441 3.146 1.146l-7 7C1.441 8.284 1 7.198 1 6c0-2.757 2.243-5 5-5m0-1C2.687 0 0 2.687 0 6c0 3.313 2.687 6 6 6 3.313 0 6-2.687 6-6 0-3.313-2.687-6-6-6"],"blocked_14":["M13 7c0-1.475-.537-2.824-1.423-3.87L3.13 11.577C4.176 12.463 5.525 13 7 13c3.309 0 6-2.691 6-6M1 7c0 1.475.537 2.824 1.423 3.87l8.447-8.447C9.824 1.537 8.475 1 7 1 3.691 1 1 3.691 1 7m6-7c3.866 0 7 3.134 7 7 0 3.866-3.134 7-7 7-3.866 0-7-3.134-7-7 0-3.866 3.134-7 7-7"],"blocked_16":["M2.716 12.577l9.861-9.861C11.349 1.651 9.75 1 8 1 4.141 1 1 4.14 1 8c0 1.75.651 3.348 1.716 4.577M15 8c0-1.75-.65-3.348-1.716-4.577l-9.861 9.861C4.652 14.35 6.25 15 8 15c3.86 0 7-3.14 7-7M8 0c4.419 0 8 3.582 8 8 0 4.419-3.581 8-8 8-4.418 0-8-3.581-8-8 0-4.418 3.582-8 8-8"],"blocked_18":["M9 17c-2.026 0-3.873-.764-5.284-2.009L14.991 3.716C16.237 5.127 17 6.974 17 9c0 4.411-3.589 8-8 8M1 9c0-4.411 3.589-8 8-8 2.026 0 3.873.763 5.284 2.009L3.009 14.284C1.764 12.873 1 11.026 1 9m8-9C4.029 0 0 4.029 0 9c0 4.971 4.029 9 9 9 4.971 0 9-4.029 9-9 0-4.971-4.029-9-9-9"],"blocked_20":["M3.302 15.99L15.991 3.302C14.398 1.876 12.302 1 10 1c-4.963 0-9 4.037-9 9 0 2.302.876 4.397 2.302 5.99M19 10c0-2.302-.876-4.398-2.302-5.991L4.009 16.697C5.603 18.124 7.698 19 10 19c4.963 0 9-4.038 9-9M10 0c5.523 0 10 4.477 10 10 0 5.523-4.477 10-10 10-5.522 0-10-4.477-10-10C0 4.477 4.478 0 10 0"],"blocked_24":["M3.889 19.404L19.405 3.888C17.448 2.101 14.853 1 12 1 5.935 1 1 5.934 1 12c0 2.853 1.101 5.447 2.889 7.404M23 12c0-2.853-1.101-5.448-2.888-7.405L4.596 20.111C6.553 21.899 9.147 23 12 23c6.066 0 11-4.935 11-11M12 0c6.628 0 12 5.372 12 12 0 6.627-5.372 12-12 12-6.627 0-12-5.373-12-12C0 5.372 5.373 0 12 0"],"blocked_28":["M14 27c-3.404 0-6.498-1.326-8.817-3.476L23.524 5.183C25.674 7.502 27 10.596 27 14c0 7.168-5.832 13-13 13M1 14C1 6.832 6.832 1 14 1c3.404 0 6.498 1.326 8.817 3.476L4.476 22.817C2.326 20.498 1 17.404 1 14M14 0C6.268 0 0 6.268 0 14c0 7.732 6.268 14 14 14 7.732 0 14-6.268 14-14 0-7.732-6.268-14-14-14"],"blocked_32":["M16 31c-3.956 0-7.549-1.551-10.231-4.062L26.938 5.769C29.449 8.451 31 12.044 31 16c0 8.271-6.729 15-15 15M1 16C1 7.729 7.729 1 16 1c3.956 0 7.549 1.551 10.231 4.062L5.062 26.231C2.551 23.549 1 19.956 1 16M16 0C7.163 0 0 7.163 0 16c0 8.837 7.163 16 16 16 8.837 0 16-7.163 16-16 0-8.837-7.163-16-16-16"],"blocked_36":["M18 35c-4.507 0-8.6-1.775-11.645-4.648L30.352 6.355C33.225 9.4 35 13.493 35 18c0 9.374-7.626 17-17 17M5.681 29.681l.638.638c-.218-.208-.43-.42-.638-.638M1 18C1 8.626 8.626 1 18 1c4.507 0 8.6 1.775 11.645 4.648L5.648 29.645C2.775 26.6 1 22.507 1 18M30.319 6.319l-.638-.638c.218.208.43.42.638.638M18 0C8.059 0 0 8.059 0 18c0 9.941 8.059 18 18 18 9.941 0 18-8.059 18-18 0-9.941-8.059-18-18-18"],"blocked_40":["M20 39c-5.144 0-9.809-2.063-13.232-5.394L33.606 6.768C36.937 10.191 39 14.856 39 20c0 10.477-8.523 19-19 19m0-38c4.974 0 9.493 1.937 12.884 5.076L6.076 32.884C2.937 29.493 1 24.974 1 20 1 9.523 9.523 1 20 1m14.32 5.054l.034-.033-.708-.708-.048.049C30.027 2.045 25.258 0 20 0 8.954 0 0 8.954 0 20c0 11.046 8.954 20 20 20 11.046 0 20-8.954 20-20 0-5.428-2.17-10.343-5.68-13.946"],"blocked_48":["M24 47c-6.162 0-11.761-2.44-15.894-6.399L40.601 8.106C44.56 12.239 47 17.838 47 24c0 12.683-10.317 23-23 23M1 24C1 11.317 11.317 1 24 1c6.162 0 11.761 2.44 15.894 6.399L7.399 39.894C3.44 35.761 1 30.162 1 24M41.315 7.392l.039-.038-.708-.708-.038.039C36.297 2.547 30.447 0 24 0 10.745 0 0 10.745 0 24c0 6.447 2.547 12.297 6.685 16.608l-.039.038.708.708.038-.039C11.703 45.453 17.553 48 24 48c13.255 0 24-10.745 24-24 0-6.447-2.547-12.297-6.685-16.608"],"blocked_56":["M28 55c-7.265 0-13.863-2.889-18.721-7.572L47.428 9.279C52.111 14.137 55 20.735 55 28c0 14.888-12.112 27-27 27M1 28C1 13.112 13.112 1 28 1c7.265 0 13.863 2.889 18.721 7.572L8.572 46.721C3.889 41.863 1 35.265 1 28M48.145 8.562l.042-.041-.708-.708-.042.042C42.4 2.995 35.552 0 28 0 12.536 0 0 12.536 0 28c0 7.552 2.995 14.4 7.855 19.438l-.042.041.708.708.042-.042C13.6 53.005 20.448 56 28 56c15.464 0 28-12.536 28-28 0-7.552-2.995-14.4-7.855-19.438"],"blocked_8":["M7 4c0-.647-.211-1.243-.561-1.733L2.267 6.44C2.758 6.79 3.354 7 4 7c1.654 0 3-1.346 3-3M1 4c0 .647.211 1.243.56 1.733L5.732 1.56C5.242 1.21 4.646 1 4 1 2.346 1 1 2.346 1 4m3-4c2.209 0 4 1.791 4 4 0 2.209-1.791 4-4 4-2.209 0-4-1.791-4-4 0-2.209 1.791-4 4-4"],"bloomberg_16":["M8.6924 12l-3 0 0-3 3 0c.892 0 1.615.671 1.615 1.5 0 .829-.723 1.5-1.615 1.5zm-3-8l3.199 0c.61 0 1.109.473 1.109 1.051l0 .083c0 .578-.499 1.051-1.109 1.051l-3.199 0 0-2.185zm5.963 3.534c1.119-.602 1.883-1.728 1.883-3.034 0-1.933-1.653-3.5-3.692-3.5l-7.846 0 0 14 2.769 0 .923 0 3.692 0 .923-.044c2.074-.22 3.693-1.869 3.693-3.893 0-1.557-.961-2.891-2.345-3.529z"],"bloomberg-circle_16":["M8 0c4.4 0 8 3.6 8 8 0 4.4-3.6 8-8 8-4.4 0-8-3.6-8-8 0-4.4 3.6-8 8-8zm1.394 11.478c1.037-.11 1.846-.935 1.846-1.947 0-.778-.48-1.445-1.172-1.764.559-.301.941-.864.941-1.517 0-.967-.826-1.75-1.846-1.75l-3.923 0 0 7 1.385 0 .461 0 1.847 0 .461-.022zm-.1538-4.9111c0 .289-.25.525-.555.525l-1.599 0 0-1.092 1.599 0c.305 0 .555.236.555.525l0 .042zM8.5864 8.5c.446 0 .808.336.808.75 0 .414-.362.75-.808.75l-1.5 0 0-1.5 1.5 0z"],"bluetooth_16":["M8.0001 14.2923l0-5.581 2.792 2.788-2.792 2.793zm0-12.586l2.793 2.793-2.793 2.797 0-5.59zm.707 6.297l3.147-3.15c.195-.196.195-.512 0-.707l-4-4c-.144-.143-.358-.185-.545-.109-.187.077-.309.26-.309.462l0 5.796-2.146-2.149c-.195-.196-.512-.196-.708 0-.195.195-.195.511 0 .707l2.854 2.857 0 .586-2.854 2.85c-.195.195-.195.511 0 .707.195.195.512.195.708 0l2.146-2.144 0 5.79c0 .202.122.385.309.462.062.025.127.038.191.038.13 0 .258-.051.354-.146l4-4c.093-.094.146-.221.146-.354 0-.133-.053-.26-.146-.353l-3.147-3.143z"],"bluetooth_24":["M12.00025 2.707l0 7.586 3.793-3.793-3.793-3.793zm0 11l0 7.586 3.793-3.793-3.793-3.793zm-.5 9.293c-.064 0-.129-.013-.191-.038-.187-.077-.309-.26-.309-.462l0-9.793-4.146 4.146c-.196.196-.512.196-.708 0-.195-.195-.195-.511 0-.707l4.147-4.146-4.147-4.147c-.195-.195-.195-.511 0-.707.196-.195.512-.195.708 0l4.146 4.147 0-9.793c0-.202.122-.385.309-.462.187-.076.401-.034.545.108l5 5c.195.196.195.512 0 .707l-4.854 4.854 0 .586 4.854 4.853c.195.196.195.512 0 .707l-5 5c-.096.096-.224.147-.354.147z"],"bluetooth-container_16":["M8 0c3.44 0 6 2.083 6 8 0 5.854-2.56 8-6 8-3.44 0-6-2.083-6-8 0-5.854 2.56-8 6-8zm0 15c3.364 0 5-2.289 5-7 0-7-3.764-7-5-7-3.364 0-5 2.29-5 7 0 7 3.764 7 5 7zm2.354-9.353c.195.195.195.511 0 .707L8.707 8l1.647 1.647c.195.195.195.511 0 .707l-2.5 2.5c-.017.017-.04.023-.057.038-.034.025-.067.053-.106.069-.061.025-.126.039-.191.039-.065 0-.13-.014-.191-.039-.039-.016-.07-.043-.103-.068-.019-.014-.042-.022-.06-.039-.017-.018-.025-.04-.039-.06-.025-.032-.052-.064-.068-.103-.025-.06-.039-.126-.039-.191l0-2.793-1.146 1.147c-.098.097-.226.146-.354.146-.128 0-.256-.049-.354-.146-.195-.196-.195-.512 0-.707L7 8.293l0-.586-1.854-1.853c-.195-.196-.195-.512 0-.707.196-.196.512-.196.708 0L7 6.293 7 3.5c0-.065.014-.13.039-.191.017-.04.044-.072.069-.105.015-.019.022-.04.038-.057.017-.017.039-.024.057-.038.033-.025.066-.053.106-.07.122-.051.26-.051.382 0 .041.017.075.045.109.072.017.013.038.02.054.036l2.5 2.5zM8 7.293L9.293 6 8 4.707l0 2.586zM9.293 10L8 8.707l0 2.586L9.293 10z"],"bluetooth-container-muted_16":["M13.00025 8.00025c0 4.71-1.636 7-5 7-.844 0-2.864-.004-4.063-2.23l1.917-1.916 1.146-1.147 0 2.793c0 .065.014.13.039.191.016.039.043.07.068.103.015.019.022.042.039.06.018.017.041.024.06.039.033.025.064.052.103.068.061.025.126.039.191.039.065 0 .13-.014.191-.039.04-.016.072-.044.105-.069.019-.015.041-.021.058-.038l2.5-2.5c.195-.196.195-.512 0-.708l-1.647-1.646 1.647-1.646 2.125-2.126c.318.952.521 2.172.521 3.772zm-5-3.293l1.293 1.293-1.293 1.293 0-2.586zm0 4l1.293 1.293-1.293 1.293 0-2.586zm-5-.707c0-4.71 1.636-7 5-7 .844 0 2.864.004 4.063 2.23l-2.063 2.063-2.146-2.147c-.016-.015-.037-.022-.054-.035-.034-.027-.068-.055-.109-.072-.122-.051-.26-.051-.382 0-.04.017-.073.044-.106.07-.018.014-.04.021-.057.037-.016.018-.023.039-.038.058-.025.033-.052.065-.069.105-.025.061-.039.126-.039.191l0 2.793-1.146-1.147c-.196-.195-.512-.195-.708 0-.195.196-.195.512 0 .708l1.854 1.853 0 .586-1.854 1.853-1.625 1.626c-.318-.952-.521-2.172-.521-3.772zm12.854-7.854c-.196-.195-.512-.195-.708 0l-2.353 2.354c-1.073-1.778-2.779-2.5-4.793-2.5-3.44 0-6 2.146-6 8 0 1.895.265 3.392.735 4.558l-2.589 2.588c-.195.196-.195.512 0 .708.098.097.226.146.354.146.128 0 .256-.049.354-.146l2.353-2.354c1.073 1.778 2.78 2.5 4.793 2.5 3.44 0 6-2.146 6-8 0-1.895-.265-3.392-.735-4.558l2.589-2.588c.195-.196.195-.512 0-.708z"],"bookmark_16":["M12.9970009 14.9970006L13 15l-.0029991-13.00021424C12.9970009 1.44890381 12.5481356 1 11.99730081 1L3.99970009 1C3.44786564 1 3 1.44890381 3 1.99978576L3 14.9970006l4.26272118-4.6769977c.38288514-.41291156 1.0906728-.40891242 1.46755974-.0029994l4.26671998 4.6799971zm-9e-7 1.0025168c-.274 0-.541-.1129966-.735-.3249902 0 0 0-.001-.001-.001l-4.265-4.6778589-4.258 4.6778589c-.282.3069908-.713.4079877-1.101.2579923C2.25 15.780524 2 15.4145351 2 14.9995476L2 1.99993968C2 .896972945 2.896 0 4 0l8 0c1.103 0 2 .896972945 2 1.99993968l0 12.99960792c0 .4149875-.251.7809764-.638.9319719-.12.0459986-.243.0679979-.365.0679979z"],"bot_12":["M10.5 5.0001c.276 0 .5-.225.5-.5 0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5 0 .275.224.5.5.5zm1.5-.5c0 .652-.419 1.202-1 1.408l0 3.592c0 .825-.675 1.5-1.5 1.5l-7 0c-.825 0-1.5-.675-1.5-1.5l0-7c0-.825.675-1.5 1.5-1.5l3.592 0c.206-.581.756-1 1.408-1 .829 0 1.5.671 1.5 1.5 0 .828-.671 1.5-1.5 1.5-.652 0-1.202-.419-1.408-1l-3.592 0c-.271 0-.5.229-.5.5l0 7c0 .271.229.5.5.5l7 0c.271 0 .5-.229.5-.5l0-3.592c-.581-.206-1-.756-1-1.408 0-.829.671-1.5 1.5-1.5.829 0 1.5.671 1.5 1.5zm-4.5-3.5c-.276 0-.5.224-.5.5 0 .275.224.5.5.5.276 0 .5-.225.5-.5 0-.276-.224-.5-.5-.5zm-3 4c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm2.5.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5zm-1.5 2.5c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0z"],"bot_14":["M12.5 2.9999c.829 0 1.5.672 1.5 1.5 0 .653-.419 1.202-1 1.408l0 5.392c0 .935-.765 1.7-1.7 1.7l-8.6 0c-.935 0-1.7-.765-1.7-1.7l0-8.6c0-.935.765-1.7 1.7-1.7l5.392 0c.206-.581.756-1 1.408-1 .829 0 1.5.672 1.5 1.5 0 .828-.671 1.5-1.5 1.5-.652 0-1.202-.419-1.408-1l-5.392 0c-.379 0-.7.32-.7.7l0 8.6c0 .379.321.7.7.7l8.6 0c.379 0 .7-.321.7-.7l0-5.392c-.581-.206-1-.755-1-1.408 0-.828.671-1.5 1.5-1.5zm.165 1.966c.167-.059.335-.226.335-.466 0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5 0 .24.168.407.335.466l.165.059.165-.059zm-3.631-3.631l-.058.165.058.165c.059.167.226.335.466.335.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5-.24 0-.407.168-.466.335zM5.5 5.5001c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm2.5.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5zm-2.5 3c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l3 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-3 0z"],"bot_16":["M14.5 6c.271 0 .5-.229.5-.5 0-.271-.229-.5-.5-.5-.271 0-.5.229-.5.5 0 .271.229.5.5.5zm-3-5c-.271 0-.5.229-.5.5 0 .271.229.5.5.5.271 0 .5-.229.5-.5 0-.271-.229-.5-.5-.5zM16 5.5c0 .649-.42 1.199-1 1.407L15 13c0 1.104-.896 2-2 2L3 15c-1.104 0-2-.896-2-2L1 3c0-1.104.896-2 2-2l7.093 0c.208-.58.758-1 1.407-1 .825 0 1.5.675 1.5 1.5 0 .825-.675 1.5-1.5 1.5-.649 0-1.199-.42-1.407-1L3 2c-.552 0-1 .448-1 1l0 10c0 .552.448 1 1 1l10 0c.552 0 1-.448 1-1l0-6.093c-.58-.208-1-.758-1-1.407 0-.825.675-1.5 1.5-1.5.825 0 1.5.675 1.5 1.5zm-6 1c0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5zM5.5 6c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm1 5c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l3 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-3 0z"],"bot_18":["M13.5.0001c.829 0 1.5.671 1.5 1.5 0 .828-.671 1.5-1.5 1.5-.652 0-1.202-.419-1.408-1l-9.092 0c-.551 0-1 .449-1 1l0 12c0 .551.449 1 1 1l12 0c.551 0 1-.449 1-1l0-8.092c-.581-.206-1-.756-1-1.408 0-.829.671-1.5 1.5-1.5.829 0 1.5.671 1.5 1.5 0 .652-.419 1.202-1 1.408l0 8.092c0 1.1-.9 2-2 2l-12 0c-1.1 0-2-.9-2-2l0-12c0-1.1.9-2 2-2l9.092 0c.206-.581.756-1 1.408-1zm3 5c-.276 0-.5.224-.5.5 0 .24.168.407.335.466l.165.058.165-.058c.167-.059.335-.226.335-.466 0-.276-.224-.5-.5-.5zm-3-4c-.24 0-.407.168-.466.335l-.058.165.058.165c.059.167.226.335.466.335.276 0 .5-.225.5-.5 0-.276-.224-.5-.5-.5zm-7 6c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm5 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm-1 4c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-3 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l3 0z"],"bot_20":["M18.5 3.9999c.829 0 1.5.672 1.5 1.5 0 .653-.419 1.202-1 1.408l0 9.592c0 1.375-1.125 2.5-2.5 2.5l-13 0c-1.375 0-2.5-1.125-2.5-2.5l0-13c0-1.375 1.125-2.5 2.5-2.5l9.592 0c.206-.581.756-1 1.408-1 .829 0 1.5.672 1.5 1.5 0 .828-.671 1.5-1.5 1.5-.652 0-1.202-.419-1.408-1l-9.592 0c-.827 0-1.5.673-1.5 1.5l0 13c0 .827.673 1.5 1.5 1.5l13 0c.827 0 1.5-.673 1.5-1.5l0-9.592c-.581-.206-1-.755-1-1.408 0-.828.671-1.5 1.5-1.5zm.165 1.966c.167-.059.335-.226.335-.466 0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5 0 .24.168.407.335.466l.165.059.165-.059zm-4.631-4.631l-.058.165.058.165c.059.167.226.335.466.335.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5-.24 0-.407.168-.466.335zM7.5 8.0001c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm4.5.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5zm-.5 4.5l-3 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l3 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5z"],"bot_24":["M24 7.5c0 1.209-.859 2.218-2 2.449l0 9.551c0 1.381-1.119 2.5-2.5 2.5l-15 0C3.119 22 2 20.881 2 19.5l0-15C2 3.119 3.119 2 4.5 2l9.551 0c.231-1.141 1.24-2 2.449-2C17.881 0 19 1.119 19 2.5 19 3.881 17.881 5 16.5 5c-1.209 0-2.218-.859-2.449-2L4.5 3C3.673 3 3 3.673 3 4.5l0 15c0 .827.673 1.5 1.5 1.5l15 0c.827 0 1.5-.673 1.5-1.5l0-9.551c-1.141-.231-2-1.24-2-2.449C19 6.119 20.119 5 21.5 5 22.881 5 24 6.119 24 7.5zM21.5 9c.827 0 1.5-.673 1.5-1.5 0-.827-.673-1.5-1.5-1.5-.827 0-1.5.673-1.5 1.5 0 .827.673 1.5 1.5 1.5zm-5-8c-.827 0-1.5.673-1.5 1.5 0 .827.673 1.5 1.5 1.5.827 0 1.5-.673 1.5-1.5 0-.827-.673-1.5-1.5-1.5zm-8 9c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm6.5.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5zM9.5 16c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l5 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-5 0z"],"bot_36":["M32.5 8c1.933 0 3.5 1.567 3.5 3.5 0 1.762-1.306 3.205-3 3.45L33 30c0 1.654-1.346 3-3 3L6 33c-1.654 0-3-1.346-3-3L3 6c0-1.654 1.346-3 3-3l15.05 0c.245-1.694 1.688-3 3.45-3C26.433 0 28 1.567 28 3.5 28 5.433 26.433 7 24.5 7c-1.762 0-3.205-1.306-3.45-3L6 4c-1.103 0-2 .897-2 2l0 24c0 1.103.897 2 2 2l24 0c1.103 0 2-.897 2-2l0-15.05c-1.694-.245-3-1.688-3-3.45C29 9.567 30.567 8 32.5 8zm0 6c1.378 0 2.5-1.122 2.5-2.5 0-1.378-1.122-2.5-2.5-2.5-1.378 0-2.5 1.122-2.5 2.5 0 1.378 1.122 2.5 2.5 2.5zm-8-13C23.122 1 22 2.122 22 3.5 22 4.878 23.122 6 24.5 6 25.878 6 27 4.878 27 3.5 27 2.122 25.878 1 24.5 1zM22 16c0-.55.45-1 1-1 .55 0 1 .45 1 1 0 .55-.45 1-1 1-.55 0-1-.45-1-1zm-7.5 8c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l7 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-7 0zM13 15c.55 0 1 .45 1 1 0 .55-.45 1-1 1-.55 0-1-.45-1-1 0-.55.45-1 1-1z"],"bot_56":["M19 25c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm15 1c0-.552.447-1 1-1 .553 0 1 .448 1 1 0 .552-.447 1-1 1-.553 0-1-.448-1-1zM20.5 38c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l13 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-13 0zM56 20.5c0 2.314-1.753 4.198-4 4.45L52 49c0 2.75-2.25 5-5 5L7 54c-2.75 0-5-2.25-5-5L2 9c0-2.75 2.25-5 5-5l24.05 0c.252-2.247 2.136-4 4.45-4C37.985 0 40 2.015 40 4.5 40 6.985 37.985 9 35.5 9c-2.314 0-4.198-1.753-4.45-4L7 5C4.794 5 3 6.794 3 9l0 40c0 2.205 1.794 4 4 4l40 0c2.206 0 4-1.795 4-4l0-24.05c-2.247-.252-4-2.136-4-4.45 0-2.485 2.015-4.5 4.5-4.5 2.485 0 4.5 2.015 4.5 4.5zM51.5 24c1.93 0 3.5-1.57 3.5-3.5 0-1.93-1.57-3.5-3.5-3.5-1.93 0-3.5 1.57-3.5 3.5 0 1.93 1.57 3.5 3.5 3.5zm-16-23C33.57 1 32 2.57 32 4.5 32 6.43 33.57 8 35.5 8 37.43 8 39 6.43 39 4.5 39 2.57 37.43 1 35.5 1z"],"bot-customer-assistant_16":["M11 6.5c0 .275-.224.5-.5.5-.276 0-.5-.225-.5-.5 0-.275.224-.5.5-.5.276 0 .5.225.5.5zm-5 0c0 .275-.224.5-.5.5-.276 0-.5-.225-.5-.5 0-.275.224-.5.5-.5.276 0 .5.225.5.5zm-5-1c0 .271.229.5.5.5.271 0 .5-.229.5-.5 0-.271-.229-.5-.5-.5-.271 0-.5.229-.5.5zm2 0C3 6.325 2.325 7 1.5 7 .675 7 0 6.325 0 5.5c0-.648.42-1.199 1-1.407L1 3c0-1.104.896-2 2-2l10 0c1.104 0 2 .896 2 2l0 4.5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5L14 3c0-.552-.448-1-1-1L3 2c-.552 0-1 .448-1 1l0 1.093c.58.208 1 .759 1 1.407zM14.5 11c.271 0 .5-.229.5-.5 0-.271-.229-.5-.5-.5-.271 0-.5.229-.5.5 0 .271.229.5.5.5zm0-2c.825 0 1.5.675 1.5 1.5 0 .648-.42 1.199-1 1.407L15 13c0 1.104-.896 2-2 2L3 15c-1.104 0-2-.896-2-2l0-4.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5L2 13c0 .552.448 1 1 1l10 0c.552 0 1-.448 1-1l0-1.093c-.58-.208-1-.759-1-1.407 0-.825.675-1.5 1.5-1.5zM8 11c-1.021 0-1.99-.445-2.656-1.221-.18-.21-.156-.525.053-.705.209-.18.525-.157.705.053.953 1.109 2.843 1.109 3.796 0 .18-.209.496-.232.705-.053.209.18.233.495.053.705C9.99 10.555 9.021 11 8 11z"],"bot-customer-assistant_24":["M1 8.4492c0-.827.673-1.5 1.5-1.5.827 0 1.5.673 1.5 1.5 0 .827-.673 1.5-1.5 1.5-.827 0-1.5-.673-1.5-1.5m4 0c0 1.381-1.119 2.5-2.5 2.5-1.381 0-2.5-1.119-2.5-2.5 0-1.209.859-2.218 2-2.449l0-1.5c0-1.381 1.119-2.5 2.5-2.5l15 0c1.381 0 2.5 1.119 2.5 2.5l0 4 0 .5 0 1.5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-1.5 0-.5 0-4c0-.827-.673-1.5-1.5-1.5l-15 0c-.827 0-1.5.673-1.5 1.5l0 1.5c1.141.231 2 1.24 2 2.449zM21.5 13c1.381 0 2.5 1.119 2.5 2.5 0 1.209-.859 2.218-2 2.449l0 1.551c0 1.381-1.119 2.5-2.5 2.5l-15 0C3.119 22 2 20.881 2 19.5l0-2 0-2.979L2 13.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 1.021L3 17.5l0 2c0 .827.673 1.5 1.5 1.5l15 0c.827 0 1.5-.673 1.5-1.5l0-1.551c-1.141-.231-2-1.24-2-2.449 0-1.381 1.119-2.5 2.5-2.5zm0 4c.827 0 1.5-.673 1.5-1.5 0-.827-.673-1.5-1.5-1.5-.827 0-1.5.673-1.5 1.5 0 .827.673 1.5 1.5 1.5zM9 10.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5zm7 0c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5zM12 16c-1.373 0-2.653-.615-3.513-1.687-.173-.215-.138-.531.077-.703.217-.173.532-.136.704.077C9.937 14.521 10.933 15 12 15c1.067 0 2.063-.479 2.732-1.313.173-.213.488-.25.704-.077.215.172.25.488.077.703C14.653 15.385 13.373 16 12 16z"],"bot-customer-assistant_36":["M24 16c0 .55-.45 1-1 1-.55 0-1-.45-1-1 0-.55.45-1 1-1 .55 0 1 .45 1 1zm-10 0c0 .55-.45 1-1 1-.55 0-1-.45-1-1 0-.55.45-1 1-1 .55 0 1 .45 1 1zm4 8c-1.78 0-3.44-.797-4.555-2.188-.172-.214-.137-.53.078-.703.214-.171.529-.136.704.078C15.149 22.339 16.524 23 18 23c1.476 0 2.851-.661 3.773-1.813.176-.214.491-.249.704-.078.215.173.25.489.078.703C21.44 23.203 19.78 24 18 24zM7 13.5C7 15.433 5.433 17 3.5 17 1.567 17 0 15.433 0 13.5c0-1.762 1.306-3.205 3-3.449L3 6c0-1.654 1.346-3 3-3l24 0c1.654 0 3 1.346 3 3l0 10.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5L32 6c0-1.103-.897-2-2-2L6 4c-1.103 0-2 .897-2 2l0 4.051c1.694.244 3 1.687 3 3.449zm-6 0C1 14.879 2.121 16 3.5 16 4.879 16 6 14.879 6 13.5 6 12.121 4.879 11 3.5 11 2.121 11 1 12.121 1 13.5zm35 9c0 1.762-1.306 3.205-3 3.449L33 30c0 1.654-1.346 3-3 3L6 33c-1.654 0-3-1.346-3-3l0-10.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5L4 30c0 1.103.897 2 2 2l24 0c1.103 0 2-.897 2-2l0-4.051c-1.694-.244-3-1.687-3-3.449 0-1.933 1.567-3.5 3.5-3.5 1.933 0 3.5 1.567 3.5 3.5zM32.5 25c1.379 0 2.5-1.121 2.5-2.5 0-1.379-1.121-2.5-2.5-2.5-1.379 0-2.5 1.121-2.5 2.5 0 1.379 1.121 2.5 2.5 2.5z"],"bot-expert-assistant_16":["M14.5 2c.271 0 .5-.229.5-.5 0-.271-.229-.5-.5-.5-.271 0-.5.229-.5.5 0 .271.229.5.5.5zm0-2c.825 0 1.5.675 1.5 1.5 0 .648-.42 1.199-1 1.407L15 13c0 1.104-.896 2-2 2l-4.5 0-.708 0L4.5 15c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l3.292 0 .708 0 4.5 0c.552 0 1-.448 1-1l0-10.093c-.58-.208-1-.759-1-1.407 0-.825.675-1.5 1.5-1.5zm-13 15c.271 0 .5-.229.5-.5 0-.271-.229-.5-.5-.5-.271 0-.5.229-.5.5 0 .271.229.5.5.5zM3 2c-.552 0-1 .448-1 1l0 10.093c.58.208 1 .759 1 1.407 0 .825-.675 1.5-1.5 1.5-.825 0-1.5-.675-1.5-1.5 0-.648.42-1.199 1-1.407L1 3c0-1.104.896-2 2-2l6.5 0L11 1l.5 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L11 2 9.5 2 3 2zm3.5 8l3 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-3 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5zm-1-1.5c-1.104 0-2-.896-2-2 0-1.104.896-2 2-2 .931 0 1.706.639 1.929 1.5l1.142 0c.223-.861.998-1.5 1.929-1.5 1.104 0 2 .896 2 2 0 1.104-.896 2-2 2-.931 0-1.706-.639-1.929-1.5L7.429 7c-.223.861-.998 1.5-1.929 1.5zm0-3c-.552 0-1 .449-1 1 0 .551.448 1 1 1 .552 0 1-.449 1-1 0-.551-.448-1-1-1zm0 1.5c-.276 0-.5-.225-.5-.5 0-.275.224-.5.5-.5.276 0 .5.225.5.5 0 .275-.224.5-.5.5zm5-1.5c-.552 0-1 .449-1 1 0 .551.448 1 1 1 .552 0 1-.449 1-1 0-.551-.448-1-1-1zm0 1.5c-.276 0-.5-.225-.5-.5 0-.275.224-.5.5-.5.276 0 .5.225.5.5 0 .275-.224.5-.5.5z"],"bot-expert-assistant_24":["M10.95 11c-.232 1.141-1.241 2-2.45 2C7.119 13 6 11.881 6 10.5 6 9.119 7.119 8 8.5 8c1.209 0 2.218.859 2.45 2l2.1 0c.232-1.141 1.241-2 2.45-2 1.381 0 2.5 1.119 2.5 2.5 0 1.381-1.119 2.5-2.5 2.5-1.209 0-2.218-.859-2.45-2l-2.1 0zM7 10.5c0 .827.673 1.5 1.5 1.5.827 0 1.5-.673 1.5-1.5C10 9.673 9.327 9 8.5 9 7.673 9 7 9.673 7 10.5zM15.5 9c-.827 0-1.5.673-1.5 1.5 0 .827.673 1.5 1.5 1.5.827 0 1.5-.673 1.5-1.5 0-.827-.673-1.5-1.5-1.5zM9 10.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5zm6.5.5c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5zm-6 4l5 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5zM3 19.051c1.141.231 2 1.24 2 2.449C5 22.881 3.881 24 2.5 24 1.119 24 0 22.881 0 21.5c0-1.209.859-2.218 2-2.449L2 4.5C2 3.121 3.122 2 4.5 2l12 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-12 0C3.673 3 3 3.673 3 4.5l0 14.551zM2.5 23c.827 0 1.5-.673 1.5-1.5 0-.827-.673-1.5-1.5-1.5-.827 0-1.5.673-1.5 1.5 0 .827.673 1.5 1.5 1.5zM24 2.5c0 1.209-.859 2.218-2 2.449L22 19.5c0 1.379-1.122 2.5-2.5 2.5l-12 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l12 0c.827 0 1.5-.673 1.5-1.5l0-14.551c-1.141-.231-2-1.24-2-2.449C19 1.119 20.119 0 21.5 0 22.881 0 24 1.119 24 2.5zM21.5 4c.827 0 1.5-.673 1.5-1.5 0-.827-.673-1.5-1.5-1.5-.827 0-1.5.673-1.5 1.5 0 .827.673 1.5 1.5 1.5z"],"bot-expert-assistant_36":["M14.5 23l7 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-7 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5zM4 29.051c1.694.244 3 1.687 3 3.449C7 34.433 5.433 36 3.5 36 1.567 36 0 34.433 0 32.5c0-1.762 1.306-3.205 3-3.449L3 6c0-1.654 1.346-3 3-3l20.5 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5L6 4c-1.103 0-2 .897-2 2l0 23.051zM3.5 35C4.879 35 6 33.879 6 32.5 6 31.121 4.879 30 3.5 30 2.121 30 1 31.121 1 32.5 1 33.879 2.121 35 3.5 35zM27 16.0005c0 2.209-1.791 4-4 4-2.038 0-3.701-1.53-3.949-3.5l-2.102 0c-.248 1.97-1.911 3.5-3.949 3.5-2.209 0-4-1.791-4-4 0-2.209 1.791-4 4-4 2.038 0 3.701 1.529 3.949 3.5l2.102 0c.248-1.971 1.911-3.5 3.949-3.5 2.209 0 4 1.791 4 4zm-6.998.022c.013 1.644 1.352 2.978 2.998 2.978 1.654 0 3-1.346 3-3 0-1.655-1.346-3-3-3-1.646 0-2.985 1.334-2.998 2.977.001.008.005.015.005.023 0 .007-.004.014-.005.022zM24 16c0 .55-.45 1-1 1-.55 0-1-.45-1-1 0-.55.45-1 1-1 .55 0 1 .45 1 1zm-11 3.0005c1.654 0 3-1.346 3-3 0-1.655-1.346-3-3-3-1.654 0-3 1.345-3 3 0 1.654 1.346 3 3 3zM13 15c.55 0 1 .45 1 1 0 .55-.45 1-1 1-.55 0-1-.45-1-1 0-.55.45-1 1-1zM36 3.5c0 1.766-1.312 3.21-3.01 3.45.002.018.01.032.01.05l0 23c0 1.654-1.346 3-3 3L9.5 33c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5L30 32c1.103 0 2-.897 2-2l0-23c0-.018.008-.032.01-.05C30.312 6.71 29 5.266 29 3.5 29 1.567 30.567 0 32.5 0 34.433 0 36 1.567 36 3.5zM32.5 6C33.879 6 35 4.879 35 3.5 35 2.121 33.879 1 32.5 1 31.121 1 30 2.121 30 3.5 30 4.879 31.121 6 32.5 6z"],"box_24":["M30.695259 10.725l-9.518 6.172c-.147.099-.323.133-.493.098-.176-.037-.327-.143-.43-.307l-2.912-4.388c.169-.051.334-.117.495-.199l10.837-5.839 2.211 3.49c.207.327.12.765-.19.973zm-2.99 4.672c-.018.226-.138.435-.323.559l-10.04 6.797c-.498.335-1.142.335-1.638.001L5.66125904 15.955c-.183-.123-.303-.331-.32-.557l-.122-1.588 6.04199996 3.918c.373.25.818.337 1.255.245.442-.092.82-.355 1.06-.732l2.922-4.406 2.917 4.398c.245.385.623.648 1.064.74.113.024.228.036.341.036.322 0 .637-.095.908-.277l6.101-3.956-.124 1.621zM2.11025904 9.752l2.229-3.519L15.217259 12.106c.144.074.292.134.444.181l-2.924 4.409c-.099.156-.25.262-.426.299-.173.035-.346.001-.499-.102l-9.50599996-6.164c-.315000003-.212-.403000003-.65-.196-.977zm.584-2.889c.01-.039.037-.11.105-.142l.064-.028-.168.266c-.007-.041-.006-.077-.001-.096zM15.064259 1.321c.304-.133.617-.21.934-.26l0 10.276c-.108-.032-.214-.065-.315-.116L5.30425904 5.618 15.064259 1.321zm12.675 4.306l-10.368 5.589c-.119.061-.245.104-.373.138l0-10.296c.325.049.647.126.959.262l9.782 4.307zm2.589 1.236c.005.023.004.07-.011.122l-.196-.308.091.039c.079.037.106.108.116.147zm1.403 2.354l-.833-1.315.177-.226c.231-.297.313-.679.224-1.047-.086-.363-.329-.661-.674-.823l-12.267-5.402c-.592-.259-1.211-.393-1.84-.403l0-.001c-.003 0-.005.001-.007.001-.003 0-.005-.001-.007-.001l0 .001c-.629.01-1.248.144-1.841.404L2.38625904 5.811c-.335.157-.577000003.455-.664000003.818-.089.368-.006.75.226 1.048l.161000003.207-.845000003 1.333c-.494.781-.2759999997 1.832.492 2.347l2.408000003 1.562.18 2.349c.041.536.319 1.014.758 1.309L15.144259 23.583c.418.282.898.422 1.378.422.48 0 .96-.141 1.38-.423l10.04-6.797c.441-.297.718-.775.76-1.311l.181-2.382 2.363-1.533c.761-.51.979-1.561.485-2.342z"],"breakout-session_16":["M10 8c-1.104 0-2-.895-2-2l0-4c0-1.105.896-2 2-2l4 0c1.104 0 2 .895 2 2l0 4c0 1.105-.896 2-2 2l-4 0zM9 2l0 4c0 .551.448 1 1 1l4 0c.552 0 1-.449 1-1l0-4c0-.551-.448-1-1-1l-4 0c-.552 0-1 .449-1 1zm1 14c-1.104 0-2-.895-2-2l0-2c0-1.105.896-2 2-2l2 0c1.104 0 2 .895 2 2l0 2c0 1.105-.896 2-2 2l-2 0zm-1-4l0 2c0 .551.448 1 1 1l2 0c.552 0 1-.449 1-1l0-2c0-.551-.448-1-1-1l-2 0c-.552 0-1 .449-1 1zm-7 4c-1.104 0-2-.895-2-2l0-2c0-1.105.896-2 2-2l2 0c1.104 0 2 .895 2 2l0 2c0 1.105-.896 2-2 2l-2 0zm-1-4l0 2c0 .551.448 1 1 1l2 0c.552 0 1-.449 1-1l0-2c0-.551-.448-1-1-1l-2 0c-.552 0-1 .449-1 1zm1-4C.896 8 0 7.105 0 6l0-2c0-1.105.896-2 2-2l2 0c1.104 0 2 .895 2 2l0 2c0 1.105-.896 2-2 2L2 8zM1 4l0 2c0 .551.448 1 1 1l2 0c.552 0 1-.449 1-1l0-2c0-.551-.448-1-1-1L2 3c-.552 0-1 .449-1 1z"],"breakout-session_20":["M12 10.0001c-1.1 0-2-.9-2-2l0-5c0-1.101.9-2 2-2l5 0c1.1 0 2 .899 2 2l0 5c0 1.1-.9 2-2 2l-5 0zm-1-7l0 5c0 .552.448 1 1 1l5 0c.552 0 1-.448 1-1l0-5c0-.552-.448-1-1-1l-5 0c-.552 0-1 .448-1 1zm-8 16c-1.1 0-2-.9-2-2l0-3c0-1.101.9-2 2-2l3 0c1.1 0 2 .899 2 2l0 3c0 1.1-.9 2-2 2l-3 0zm-1-5l0 3c0 .552.448 1 1 1l3 0c.552 0 1-.448 1-1l0-3c0-.552-.448-1-1-1l-3 0c-.552 0-1 .448-1 1zm10 5c-1.1 0-2-.9-2-2l0-3c0-1.101.9-2 2-2l3 0c1.1 0 2 .899 2 2l0 3c0 1.1-.9 2-2 2l-3 0zm-1-5l0 3c0 .552.448 1 1 1l3 0c.552 0 1-.448 1-1l0-3c0-.552-.448-1-1-1l-3 0c-.552 0-1 .448-1 1zm-8-4c-1.1 0-2-.9-2-2l0-3c0-1.101.9-2 2-2l3 0c1.1 0 2 .899 2 2l0 3c0 1.1-.9 2-2 2l-3 0zm-1-5l0 3c0 .552.448 1 1 1l3 0c.552 0 1-.448 1-1l0-3c0-.552-.448-1-1-1l-3 0c-.552 0-1 .448-1 1z"],"breakout-session_24":["M14.5 12c-1.381 0-2.5-1.119-2.5-2.5l0-7C12 1.119 13.119 0 14.5 0l7 0C22.881 0 24 1.119 24 2.5l0 7c0 1.381-1.119 2.5-2.5 2.5l-7 0zM13 2.5l0 7c0 .827.673 1.5 1.5 1.5l7 0c.827 0 1.5-.673 1.5-1.5l0-7c0-.827-.673-1.5-1.5-1.5l-7 0c-.827 0-1.5.673-1.5 1.5zM14.5 24c-1.381 0-2.5-1.119-2.5-2.5l0-5c0-1.381 1.119-2.5 2.5-2.5l5 0c1.381 0 2.5 1.119 2.5 2.5l0 5c0 1.381-1.119 2.5-2.5 2.5l-5 0zM13 16.5l0 5c0 .827.673 1.5 1.5 1.5l5 0c.827 0 1.5-.673 1.5-1.5l0-5c0-.827-.673-1.5-1.5-1.5l-5 0c-.827 0-1.5.673-1.5 1.5zM2.5 12C1.119 12 0 10.881 0 9.5l0-5C0 3.119 1.119 2 2.5 2l5 0C8.881 2 10 3.119 10 4.5l0 5c0 1.381-1.119 2.5-2.5 2.5l-5 0zM1 4.5l0 5c0 .827.673 1.5 1.5 1.5l5 0c.827 0 1.5-.673 1.5-1.5l0-5C9 3.673 8.327 3 7.5 3l-5 0C1.673 3 1 3.673 1 4.5zM2.5 24C1.119 24 0 22.881 0 21.5l0-5C0 15.119 1.119 14 2.5 14l5 0c1.381 0 2.5 1.119 2.5 2.5l0 5c0 1.381-1.119 2.5-2.5 2.5l-5 0zM1 16.5l0 5c0 .827.673 1.5 1.5 1.5l5 0c.827 0 1.5-.673 1.5-1.5l0-5c0-.827-.673-1.5-1.5-1.5l-5 0c-.827 0-1.5.673-1.5 1.5z"],"brightness_16":["M9 12.9495l0-8.899c2.244.253 4 2.139 4 4.449 0 2.311-1.756 4.198-4 4.45m-5-4.45c0-2.31 1.756-4.196 4-4.449l0 8.899c-2.244-.252-4-2.139-4-4.45m11.5-.5l-1.525 0c-.104-1.138-.558-2.179-1.254-3.013l1.133-1.133c.195-.196.195-.512 0-.707-.196-.196-.512-.196-.708 0l-1.132 1.133c-.834-.697-1.875-1.15-3.014-1.254l0-1.526c0-.275-.225-.5-.5-.5-.275 0-.5.225-.5.5l0 1.526c-1.139.104-2.18.557-3.014 1.254l-1.132-1.133c-.196-.196-.512-.196-.708 0-.195.195-.195.511 0 .707l1.133 1.133c-.696.834-1.15 1.875-1.254 3.013l-1.525 0c-.275 0-.5.225-.5.5 0 .276.225.5.5.5l1.525 0c.104 1.139.558 2.18 1.254 3.014l-1.133 1.133c-.195.195-.195.511 0 .707.098.097.226.146.354.146.128 0 .256-.049.354-.146l1.132-1.133c.834.697 1.875 1.15 3.014 1.254l0 1.525c0 .276.225.5.5.5.275 0 .5-.224.5-.5l0-1.525c1.139-.104 2.18-.557 3.014-1.254l1.132 1.133c.098.097.226.146.354.146.128 0 .256-.049.354-.146.195-.196.195-.512 0-.707l-1.133-1.133c.696-.834 1.15-1.875 1.254-3.014l1.525 0c.275 0 .5-.224.5-.5 0-.275-.225-.5-.5-.5"],"brightness_24":["M13 19.9746l0-7.475 0-7.474c3.902.259 7 3.508 7 7.474 0 3.967-3.098 7.216-7 7.475m-8-7.475c0-3.966 3.098-7.215 7-7.474l0 7.474 0 7.475c-3.902-.259-7-3.508-7-7.475m18.5-.5l-2.525 0c-.116-1.966-.899-3.752-2.131-5.136l2.01-2.01c.195-.195.195-.512 0-.707-.196-.195-.512-.195-.708 0l-2.009 2.01c-1.385-1.233-3.17-2.016-5.137-2.131l0-2.526c0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5l0 2.526c-1.967.115-3.752.898-5.137 2.131l-2.009-2.01c-.196-.195-.512-.195-.708 0-.195.195-.195.512 0 .707l2.01 2.01c-1.232 1.384-2.015 3.17-2.131 5.136l-2.525 0c-.276 0-.5.224-.5.5 0 .277.224.5.5.5l2.525 0c.116 1.967.899 3.752 2.131 5.137l-2.01 2.01c-.195.195-.195.512 0 .707.098.098.226.146.354.146.128 0 .256-.048.354-.146l2.009-2.01c1.385 1.233 3.17 2.016 5.137 2.131l0 2.525c0 .277.224.5.5.5.276 0 .5-.223.5-.5l0-2.525c1.967-.115 3.752-.898 5.137-2.131l2.009 2.01c.098.098.226.146.354.146.128 0 .256-.048.354-.146.195-.195.195-.512 0-.707l-2.01-2.01c1.232-1.385 2.015-3.17 2.131-5.137l2.525 0c.276 0 .5-.223.5-.5 0-.276-.224-.5-.5-.5"],"broadcast-message_16":["M4.99990625 3.00011268c2.75694831 0 4.99990625 2.24291154 4.99990625 4.99980282 0 2.7568913-2.24295794 4.9998028-4.99990625 4.9998028-.80198496 0-1.59597007-.1959922-2.30995669-.5689775l-2.060961354.5519782c-.042999193.0119995-.085998387.0169993-.128997581.0169993-.130997544 0-.257995162-.050998-.353993362-.1459942-.125997638-.126995-.1749967193-.3109878-.1289975817-.482981l.5519896497-2.0609187C.195996325 9.59585256 0 8.80188387 0 7.9999155c0-2.75689128 2.24295794-4.99980282 4.99990625-4.99980282zm0 8.99964512c2.20595864 0 3.999925-1.7939293 3.999925-3.9998423 0-2.205913-1.79396636-3.99984226-3.999925-3.99984226-2.20595864 0-3.999925 1.79392926-3.999925 3.99984226 0 .69697251.18599651 1.3869453.53698993 1.99592129.06699875.11399551.08399843.25099011.04999906.37898501l-.37999287 1.4179441 1.41797341-.379985c.04199921-.0109996.08599839-.0169993.12899758-.0169993.08699837 0 .17399674.0219991.24999532.0669973.60898858.3509862 1.29897564.5369789 1.99596257.5369789zM12.7800604.148625133C14.8560214 2.2465424 16 5.03443245 16 8.00031548c0 2.96488312-1.1439786 5.75277312-3.2199396 7.85069042C12.6820622 15.950002 12.5530646 16 12.425067 16c-.1269976 0-.2549952-.0489981-.3519934-.1449943-.1959963-.1939923-.1979963-.5109798-.0039999-.7069721 1.8899646-1.9089247 2.930945-4.4478246 2.930945-7.14771812 0-2.70089348-1.0409804-5.23979335-2.930945-7.14871807-.1939964-.195992271-.1919964-.51297977.0039999-.706972119.1959964-.1939923498.5129904-.1929923893.7069868.003999842zM10.6565002 2.34343858c1.5109717 1.50994045 2.3429561 3.51986118 2.3429561 5.65677691 0 2.13691571-.8319844 4.14583651-2.3429561 5.65577691-.0979982.0979962-.2259958.1469942-.3539934.1469942-.1269976 0-.2549952-.048998-.35299335-.1469942-.19499635-.1949923-.19499635-.5109798 0-.7069721C11.2714887 11.6280724 11.999475 9.87014174 11.999475 8.00021549c0-1.86992626-.7279863-3.62785693-2.04996155-4.9498048-.19499635-.19499231-.19499635-.5119798 0-.70697211.19499635-.19499231.51199035-.19499231.70698675 0z"],"broken-file_16":["M12 15l-8 0c-.552 0-1-.448-1-1l0-6.125L5.7 9.9c.178.133.422.133.6 0L10 7.125l3 2.25L13 14c0 .552-.448 1-1 1M4 1l8 0c.552 0 1 .448 1 1l0 6.125L10.3 6.1c-.178-.133-.422-.133-.6 0L6 8.875l-3-2.25L3 2c0-.552.448-1 1-1m8-1L4 0C2.895 0 2 .895 2 2l0 12c0 1.105.895 2 2 2l8 0c1.105 0 2-.895 2-2l0-12c0-1.105-.895-2-2-2"],"broken-file_24":["M20 14.293l-5.146-5.146c-.196-.196-.512-.196-.708 0L9.5 13.793l-5.49-5.49c-.003-.003-.007-.004-.01-.007l0-5.657C4 1.735 4.735 1 5.639 1l12.722 0C19.265 1 20 1.735 20 2.639l0 11.654zm0 7.068c0 .904-.735 1.639-1.639 1.639L5.639 23C4.735 23 4 22.265 4 21.361L4 9.707l5.146 5.147c.196.195.512.195.708 0l4.646-4.647 5.5 5.5 0 5.654zM18.361 0L5.639 0C4.184 0 3 1.184 3 2.639l0 18.722C3 22.816 4.184 24 5.639 24l12.722 0C19.816 24 21 22.816 21 21.361l0-18.722C21 1.184 19.816 0 18.361 0z"],"browser_12":["M10.5 1c.827 0 1.5.673 1.5 1.5l0 7c0 .826-.673 1.5-1.5 1.5l-9 0C.673 11 0 10.326 0 9.5l0-7C0 1.673.673 1 1.5 1l9 0zm.5 8.5l0-7c0-.275-.224-.5-.5-.5l-9 0c-.276 0-.5.225-.5.5l0 7c0 .275.224.5.5.5l9 0c.276 0 .5-.225.5-.5zM2.5 3c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm2 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm2 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5z"],"browser_16":["M2 3c-.551 0-1 .449-1 1l0 8c0 .551.449 1 1 1l12 0c.551 0 1-.449 1-1l0-8c0-.551-.449-1-1-1L2 3zm12 11L2 14c-1.103 0-2-.897-2-2l0-8c0-1.103.897-2 2-2l12 0c1.103 0 2 .897 2 2l0 8c0 1.103-.897 2-2 2zM3 4.5c0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5 0 .276.224.5.5.5.276 0 .5-.224.5-.5zm2 0c0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5 0 .276.224.5.5.5.276 0 .5-.224.5-.5zm2 0c0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5 0 .276.224.5.5.5.276 0 .5-.224.5-.5z"],"browser_24":["M21.5 3C22.881 3 24 4.119 24 5.5l0 13c0 1.381-1.119 2.5-2.5 2.5l-19 0C1.119 21 0 19.881 0 18.5l0-13C0 4.119 1.119 3 2.5 3l19 0zM23 18.5l0-13c0-.827-.673-1.5-1.5-1.5l-19 0C1.673 4 1 4.673 1 5.5l0 13c0 .827.673 1.5 1.5 1.5l19 0c.827 0 1.5-.673 1.5-1.5zM3.5 7c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5zm2 0c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5zm2 0c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5z"],"browser_28":["M27 6c0-1.1045695-.8954305-2-2-2L3 4c-1.1045695 0-2 .8954305-2 2l0 16c0 1.1045695.8954305 2 2 2l22 0c1.1045695 0 2-.8954305 2-2l0-16zm1 0l0 16c0 1.6568542-1.3431458 3-3 3L3 25c-1.65685425 0-3-1.3431458-3-3L0 6c0-1.65685425 1.34314575-3 3-3l22 0c1.6568542 0 3 1.34314575 3 3zM4 8c.55228475 0 1-.44771525 1-1 0-.55228475-.44771525-1-1-1-.55228475 0-1 .44771525-1 1 0 .55228475.44771525 1 1 1zm4 0c.55228475 0 1-.44771525 1-1 0-.55228475-.44771525-1-1-1-.55228475 0-1 .44771525-1 1 0 .55228475.44771525 1 1 1zm4 0c.5522847 0 1-.44771525 1-1 0-.55228475-.4477153-1-1-1-.5522847 0-1 .44771525-1 1 0 .55228475.4477153 1 1 1z"],"calendar-add_12":["M10.5 1c.827 0 1.5.673 1.5 1.5l0 8c0 .827-.673 1.5-1.5 1.5l-9 0C.673 12 0 11.327 0 10.5l0-8C0 1.673.673 1 1.5 1l1.499 0 0-.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 .5 4 0 0-.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 .5L10.5 1zm.5 9.5l0-8c0-.276-.224-.5-.5-.5l-9 0c-.276 0-.5.224-.5.5l0 8c0 .276.224.5.5.5l9 0c.276 0 .5-.224.5-.5zM8 6c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L6.5 7l0 1.5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-1.5L4 7c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1.5 0 0-1.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 1.5L8 6z"],"calendar-add_16":["M14 2c1.104 0 2 .895 2 2l0 10c0 1.105-.896 2-2 2L2 16c-1.104 0-2-.895-2-2L0 4c0-1.105.896-2 2-2l2 0L4 .5c0-.275.225-.5.5-.5.275 0 .5.225.5.5L5 2l6 0 0-1.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5L12 2l2 0zm1 12l0-10c0-.551-.448-1-1-1L2 3c-.552 0-1 .449-1 1l0 10c0 .551.448 1 1 1l12 0c.552 0 1-.449 1-1zm-4-5.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-2.5 0 0 2.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-2.5-2.5 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l2.5 0 0-2.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 2.5 2.5 0z"],"calendar-add_20":["M16.5 3C17.881 3 19 4.119 19 5.5l0 11c0 1.381-1.119 2.5-2.5 2.5l-13 0C2.119 19 1 17.881 1 16.5l0-11C1 4.119 2.119 3 3.5 3L5 3l0-1.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5L6 3l8 0 0-1.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5L15 3l1.5 0zM18 16.5l0-11c0-.827-.673-1.5-1.5-1.5l-13 0C2.673 4 2 4.673 2 5.5l0 11c0 .827.673 1.5 1.5 1.5l13 0c.827 0 1.5-.673 1.5-1.5zm-5-6c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-2.5 0 0 2.5c0 .276-.223.5-.5.5-.276 0-.5-.224-.5-.5l0-2.5-2.5 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l2.5 0 0-2.5c0-.276.224-.5.5-.5.277 0 .5.224.5.5l0 2.5 2.5 0z"],"calendar-add_24":["M16 12.5l-3.5 0 0-3.5c0-.275-.225-.5-.5-.5-.275 0-.5.225-.5.5l0 3.5-3.5 0c-.275 0-.5.225-.5.5 0 .275.225.5.5.5l3.5 0 0 3.5c0 .275.225.5.5.5.275 0 .5-.225.5-.5l0-3.5 3.5 0c.275 0 .5-.225.5-.5 0-.275-.225-.5-.5-.5","M20.531 22L3.469 22C2.659 22 2 21.343 2 20.534L2 18l20 0 0 2.534c0 .809-.659 1.466-1.469 1.466M3.469 4l17.062 0C21.341 4 22 4.70753846 22 5.57876923L22 18 2 18 2 5.57876923C2 4.70753846 2.659 4 3.469 4m17.062-1L18 3l0-1.5c0-.276-.224-.5-.5-.5-.277 0-.5.224-.5.5L17 3 7 3l0-1.5c0-.276-.224-.5-.5-.5-.277 0-.5.224-.5.5L6 3 3.469 3C2.107 3 1 4.106 1 5.466l0 15.068C1 21.894 2.107 23 3.469 23l17.062 0C21.892 23 23 21.894 23 20.534l0-15.068C23 4.106 21.892 3 20.531 3"],"calendar-empty_16":["M15 14c0 .551-.448 1-1 1L2 15c-.552 0-1-.449-1-1L1 4c0-.551.448-1 1-1l12 0c.552 0 1 .449 1 1l0 10zM14 2l-2 0 0-1.5c0-.275-.225-.5-.5-.5-.275 0-.5.225-.5.5L11 2 5 2 5 .5c0-.275-.225-.5-.5-.5-.275 0-.5.225-.5.5L4 2 2 2C.896 2 0 2.895 0 4l0 10c0 1.105.896 2 2 2l12 0c1.104 0 2-.895 2-2l0-10c0-1.105-.896-2-2-2z"],"calendar-empty_20":["M18 16.5c0 .827-.673 1.5-1.5 1.5l-13 0c-.827 0-1.5-.673-1.5-1.5l0-11C2 4.673 2.673 4 3.5 4l13 0c.827 0 1.5.673 1.5 1.5l0 11zM16.5 3L15 3l0-1.5c0-.275-.225-.5-.5-.5-.275 0-.5.225-.5.5L14 3 6 3l0-1.5c0-.275-.225-.5-.5-.5-.275 0-.5.225-.5.5L5 3 3.5 3C2.119 3 1 4.119 1 5.5l0 11C1 17.881 2.119 19 3.5 19l13 0c1.381 0 2.5-1.119 2.5-2.5l0-11C19 4.119 17.881 3 16.5 3z"],"calendar-empty_24":["M20.531 22L3.469 22C2.659 22 2 21.343 2 20.534L2 18l20 0 0 2.534c0 .809-.659 1.466-1.469 1.466M3.469 4l17.062 0C21.341 4 22 4.70753846 22 5.57876923L22 18 2 18 2 5.57876923C2 4.70753846 2.659 4 3.469 4m17.062-1L18 3l0-1.5c0-.276-.224-.5-.5-.5-.277 0-.5.224-.5.5L17 3 7 3l0-1.5c0-.276-.224-.5-.5-.5-.277 0-.5.224-.5.5L6 3 3.469 3C2.107 3 1 4.106 1 5.466l0 15.068C1 21.894 2.107 23 3.469 23l17.062 0C21.892 23 23 21.894 23 20.534l0-15.068C23 4.106 21.892 3 20.531 3"],"calendar-empty-active_16":["M14 2l-2 0 0-1.5c0-.275-.225-.5-.5-.5-.275 0-.5.225-.5.5L11 2 5 2 5 .5c0-.275-.225-.5-.5-.5-.275 0-.5.225-.5.5L4 2 2 2C.896 2 0 2.895 0 4l0 10c0 1.105.896 2 2 2l12 0c1.104 0 2-.895 2-2l0-10c0-1.105-.896-2-2-2z"],"calendar-empty-active_20":["M16.5 3L15 3l0-1.5c0-.275-.225-.5-.5-.5-.275 0-.5.225-.5.5L14 3 6 3l0-1.5c0-.275-.225-.5-.5-.5-.275 0-.5.225-.5.5L5 3 3.5 3C2.119 3 1 4.119 1 5.5l0 11C1 17.881 2.119 19 3.5 19l13 0c1.381 0 2.5-1.119 2.5-2.5l0-11C19 4.119 17.881 3 16.5 3z"],"calendar-empty-active_24":["M20.531 3L18 3l0-1.5c0-.276-.224-.5-.5-.5-.277 0-.5.224-.5.5L17 3 7 3l0-1.5c0-.276-.224-.5-.5-.5-.277 0-.5.224-.5.5L6 3 3.469 3C2.107 3 1 4.106 1 5.466l0 15.068C1 21.894 2.107 23 3.469 23l17.062 0C21.892 23 23 21.894 23 20.534l0-15.068C23 4.106 21.892 3 20.531 3"],"calendar-external_12":["M10.5 1c.827 0 1.5.673 1.5 1.5l0 8c0 .827-.673 1.5-1.5 1.5l-9 0C.673 12 0 11.327 0 10.5l0-8C0 1.673.673 1 1.5 1l1.499 0 0-.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 .5 4 0 0-.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 .5L10.5 1zm.5 9.5l0-8c0-.276-.224-.5-.5-.5l-9 0c-.276 0-.5.224-.5.5l0 8c0 .276.224.5.5.5l9 0c.276 0 .5-.224.5-.5zm-4-7c1.104 0 2 .896 2 2 0 1.104-.896 2-2 2 0 1.104-.896 2-2 2-1.104 0-2-.896-2-2 0-1.104.896-2 2-2 0-1.104.896-2 2-2zm0 3c.552 0 1-.449 1-1 0-.551-.448-1-1-1-.552 0-1 .449-1 1 0 .086.028.164.049.244l.543-.543c.195-.195.512-.195.707 0 .195.195.195.512 0 .707l-.543.543c.08.02.158.049.244.049zm-2 2c.552 0 1-.449 1-1 0-.086-.028-.164-.049-.244l-.597.598C5.256 7.951 5.128 8 5 8c-.128 0-.256-.049-.354-.146-.195-.196-.195-.512 0-.708l.598-.597C5.164 6.529 5.086 6.5 5 6.5c-.552 0-1 .449-1 1 0 .551.448 1 1 1z"],"calendar-external_16":["M9.5 5C8.1 5 7 6.1 7 7.5c0 .2 0 .4.1.6-.2-.1-.4-.1-.6-.1C5.1 8 4 9.1 4 10.5S5.1 13 6.5 13 9 11.9 9 10.5c0-.2 0-.4-.1-.6.2.1.4.1.6.1 1.4 0 2.5-1.1 2.5-2.5S10.9 5 9.5 5zm-3 7c-.8 0-1.5-.7-1.5-1.5S5.7 9 6.5 9c.2 0 .4.1.6.2l-1 1c-.2.2-.2.5 0 .7.1.1.3.1.4.1s.3 0 .4-.1l1-1c0 .2.1.4.1.6 0 .8-.7 1.5-1.5 1.5zm3-3c-.2 0-.4-.1-.6-.2l1-1c.2-.2.2-.5 0-.7-.2-.1-.6-.1-.8 0l-1 1c0-.2-.1-.4-.1-.6C8 6.7 8.7 6 9.5 6s1.5.7 1.5 1.5S10.3 9 9.5 9z"],"calendar-external_18":["M10.5 10c-.231 0-.447-.057-.643-.15l.997-.996c.195-.196.195-.512 0-.708-.196-.195-.512-.195-.708 0l-.996.997C9.057 8.947 9 8.731 9 8.5c0-.827.673-1.5 1.5-1.5.827 0 1.5.673 1.5 1.5 0 .827-.673 1.5-1.5 1.5m-3 3c-.827 0-1.5-.673-1.5-1.5 0-.827.673-1.5 1.5-1.5.231 0 .447.057.643.15l-.997.996c-.195.196-.195.512 0 .708.098.097.226.146.354.146.128 0 .256-.049.354-.146l.996-.997c.093.196.15.412.15.643 0 .827-.673 1.5-1.5 1.5m3-7C9.119 6 8 7.119 8 8.5c0 .198.028.388.072.572C7.888 9.029 7.698 9 7.5 9 6.119 9 5 10.119 5 11.5 5 12.881 6.119 14 7.5 14c1.381 0 2.5-1.119 2.5-2.5 0-.198-.028-.388-.072-.572.184.043.374.072.572.072 1.381 0 2.5-1.119 2.5-2.5C13 7.119 11.881 6 10.5 6","M16 15c0 .551-.448 1-1 1L3 16c-.552 0-1-.449-1-1L2 5c0-.551.448-1 1-1l12 0c.552 0 1 .449 1 1l0 10zM15 3l-2 0 0-1.5c0-.275-.225-.5-.5-.5-.275 0-.5.225-.5.5L12 3 6 3l0-1.5c0-.275-.225-.5-.5-.5-.275 0-.5.225-.5.5L5 3 3 3c-1.104 0-2 .896-2 2l0 10c0 1.104.896 2 2 2l12 0c1.104 0 2-.896 2-2l0-10c0-1.104-.896-2-2-2z"],"calendar-external_20":["M12 11c-.37 0-.712-.108-1.01-.283l1.364-1.363c.195-.196.195-.512 0-.708-.196-.195-.512-.195-.708 0l-1.363 1.364C10.107 9.712 10 9.37 10 9c0-1.103.897-2 2-2 1.103 0 2 .897 2 2 0 1.103-.897 2-2 2m-4 4c-1.103 0-2-.897-2-2 0-1.103.897-2 2-2 .37 0 .712.108 1.01.283l-1.364 1.363c-.195.196-.195.512 0 .708.098.097.226.146.354.146.128 0 .256-.049.354-.146l1.363-1.364c.176.298.283.64.283 1.01 0 1.103-.897 2-2 2m4-9c-1.657 0-3 1.343-3 3 0 .475.12.917.316 1.316C8.917 10.12 8.475 10 8 10c-1.657 0-3 1.343-3 3 0 1.657 1.343 3 3 3 1.657 0 3-1.343 3-3 0-.475-.12-.917-.316-1.316.399.196.841.316 1.316.316 1.657 0 3-1.343 3-3 0-1.657-1.343-3-3-3","M18 16.5c0 .827-.673 1.5-1.5 1.5l-13 0c-.827 0-1.5-.673-1.5-1.5l0-11C2 4.673 2.673 4 3.5 4l13 0c.827 0 1.5.673 1.5 1.5l0 11zM16.5 3L15 3l0-1.5c0-.275-.225-.5-.5-.5-.275 0-.5.225-.5.5L14 3 6 3l0-1.5c0-.275-.225-.5-.5-.5-.275 0-.5.225-.5.5L5 3 3.5 3C2.119 3 1 4.119 1 5.5l0 11C1 17.881 2.119 19 3.5 19l13 0c1.381 0 2.5-1.119 2.5-2.5l0-11C19 4.119 17.881 3 16.5 3z"],"calendar-external_24":["M20.531 3C21.892 3 23 4.106 23 5.466l0 15.068C23 21.894 21.892 23 20.531 23L3.469 23C2.107 23 1 21.894 1 20.534L1 5.466C1 4.106 2.107 3 3.469 3L6 3l0-1.5c0-.276.223-.5.5-.5.276 0 .5.224.5.5L7 3l10 0 0-1.5c0-.276.223-.5.5-.5.276 0 .5.224.5.5L18 3l2.531 0zM22 18l0-12.421C22 4.708 21.341 4 20.531 4L3.469 4C2.659 4 2 4.708 2 5.579L2 18l0 2.534C2 21.343 2.659 22 3.469 22l17.062 0c.81 0 1.469-.657 1.469-1.466L22 18zM14.25 7C16.318 7 18 8.682 18 10.75c0 2.068-1.682 3.75-3.75 3.75-.296 0-.581-.043-.857-.108.065.28.107.566.107.858 0 2.068-1.682 3.75-3.75 3.75C7.682 19 6 17.318 6 15.25c0-2.068 1.682-3.75 3.75-3.75.293 0 .579.038.856.103-.064-.275-.106-.559-.106-.853C10.5 8.682 12.182 7 14.25 7zm0 6.5c1.517 0 2.75-1.233 2.75-2.75C17 9.233 15.767 8 14.25 8c-1.517 0-2.75 1.233-2.75 2.75 0 .53.158 1.021.418 1.441.023.038.057.066.082.102l.018-.018 1.628-1.629c.196-.195.512-.195.708 0 .195.196.195.512 0 .708l-1.633 1.632-.016.016c.032.022.058.052.091.073.423.265.919.425 1.454.425zM9.75 18c1.517 0 2.75-1.233 2.75-2.75 0-.514-.144-1.014-.414-1.448-.002-.004-.003-.009-.005-.013-.021-.033-.051-.058-.073-.09l-.02.02-1.634 1.635c-.098.097-.226.146-.354.146-.128 0-.256-.049-.354-.146-.195-.196-.195-.512 0-.708l1.635-1.634.012-.012c-.024-.016-.044-.038-.068-.054-.435-.279-.938-.446-1.475-.446C8.233 12.5 7 13.733 7 15.25 7 16.767 8.233 18 9.75 18z"],"calendar-month_10":["M8.65 1.0004c.743 0 1.35.607 1.35 1.349l0 6.301c0 .742-.607 1.35-1.35 1.35l-7.3 0c-.743 0-1.35-.608-1.35-1.35l0-6.301c0-.742.607-1.349 1.35-1.349l.632 0 0-.5c0-.276.225-.5.5-.5.275 0 .5.224.5.5l0 .5 4 0 0-.5c0-.276.225-.5.5-.5.275 0 .5.224.5.5l0 .5.668 0zm.35 7.65l0-6.301c0-.189-.16-.349-.35-.349l-7.3 0c-.19 0-.35.16-.35.349l0 6.301c0 .189.16.35.35.35l7.3 0c.19 0 .35-.161.35-.35zM2.9817 3.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm4 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm-4 2.9609c.276 0 .5.224.5.5 0 .275-.224.5-.5.5-.276 0-.5-.225-.5-.5 0-.276.224-.5.5-.5zm4 .0391c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zM5 3.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0 2.9609c.276 0 .5.224.5.5 0 .275-.224.5-.5.5-.276 0-.5-.225-.5-.5 0-.276.224-.5.5-.5zM2.9817 5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm4 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zM5 5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5z"],"calendar-month_12":["M10.5 1c.827 0 1.5.673 1.5 1.5l0 8c0 .827-.673 1.5-1.5 1.5l-9 0C.673 12 0 11.327 0 10.5l0-8C0 1.673.673 1 1.5 1l1.499 0 0-.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 .5 4 0 0-.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 .5L10.5 1zm.5 9.5l0-8c0-.276-.224-.5-.5-.5l-9 0c-.276 0-.5.224-.5.5l0 8c0 .276.224.5.5.5l9 0c.276 0 .5-.224.5-.5zM6 7c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5zm2.5 0c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5zm-5 0c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5zM6 9c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5zm2.5 0c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5zm-5 0c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5zM6 5c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5zm2.5 0c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5zm-5 0c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5z"],"calendar-month_16":["M14 2c1.104 0 2 .895 2 2l0 10c0 1.105-.896 2-2 2L2 16c-1.104 0-2-.895-2-2L0 4c0-1.105.896-2 2-2l2 0L4 .5c0-.275.225-.5.5-.5.275 0 .5.225.5.5L5 2l6 0 0-1.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5L12 2l2 0zm1 12l0-10c0-.551-.448-1-1-1L2 3c-.552 0-1 .449-1 1l0 10c0 .551.448 1 1 1l12 0c.552 0 1-.449 1-1zM8 9.5c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5zm-3.5 0c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5zm7 0c-.2761424 0-.5-.22385763-.5-.5 0-.27614237.2238576-.5.5-.5.2761424 0 .5.22385763.5.5 0 .27614237-.2238576.5-.5.5zM8 7c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5zM4.5 7c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5zm7 0c-.2761424 0-.5-.22385763-.5-.5 0-.27614237.2238576-.5.5-.5.2761424 0 .5.22385763.5.5 0 .27614237-.2238576.5-.5.5zM8 12c-.27614237 0-.5-.2238576-.5-.5 0-.2761424.22385763-.5.5-.5.27614237 0 .5.2238576.5.5 0 .2761424-.22385763.5-.5.5zm-3.5 0c-.27614237 0-.5-.2238576-.5-.5 0-.2761424.22385763-.5.5-.5.27614237 0 .5.2238576.5.5 0 .2761424-.22385763.5-.5.5zm7 0c-.2761424 0-.5-.2238576-.5-.5 0-.2761424.2238576-.5.5-.5.2761424 0 .5.2238576.5.5 0 .2761424-.2238576.5-.5.5z"],"calendar-month_20":["M16.5 3C17.881 3 19 4.119 19 5.5l0 11c0 1.381-1.119 2.5-2.5 2.5l-13 0C2.119 19 1 17.881 1 16.5l0-11C1 4.119 2.119 3 3.5 3L5 3l0-1.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5L6 3l8 0 0-1.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5L15 3l1.5 0zM18 16.5l0-11c0-.827-.673-1.5-1.5-1.5l-13 0C2.673 4 2 4.673 2 5.5l0 11c0 .827.673 1.5 1.5 1.5l13 0c.827 0 1.5-.673 1.5-1.5zm-8-5c-.27614237 0-.5-.2238576-.5-.5 0-.27614237.22385763-.5.5-.5.27614237 0 .5.22385763.5.5 0 .2761424-.22385763.5-.5.5zm0 3.5c-.27614237 0-.5-.2238576-.5-.5 0-.2761424.22385763-.5.5-.5.27614237 0 .5.2238576.5.5 0 .2761424-.22385763.5-.5.5zm0-7c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5zm-4.5 3.5c-.27614237 0-.5-.2238576-.5-.5 0-.27614237.22385763-.5.5-.5.27614237 0 .5.22385763.5.5 0 .2761424-.22385763.5-.5.5zm0 3.5c-.27614237 0-.5-.2238576-.5-.5 0-.2761424.22385763-.5.5-.5.27614237 0 .5.2238576.5.5 0 .2761424-.22385763.5-.5.5zm0-7c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5zm9 3.5c-.2761424 0-.5-.2238576-.5-.5 0-.27614237.2238576-.5.5-.5.2761424 0 .5.22385763.5.5 0 .2761424-.2238576.5-.5.5zm0 3.5c-.2761424 0-.5-.2238576-.5-.5 0-.2761424.2238576-.5.5-.5.2761424 0 .5.2238576.5.5 0 .2761424-.2238576.5-.5.5zm0-7c-.2761424 0-.5-.22385763-.5-.5 0-.27614237.2238576-.5.5-.5.2761424 0 .5.22385763.5.5 0 .27614237-.2238576.5-.5.5z"],"calendar-month_24":["M20.5 3C21.881 3 23 4.119 23 5.5l0 15c0 1.381-1.119 2.5-2.5 2.5l-17 0C2.119 23 1 21.881 1 20.5l0-15C1 4.119 2.119 3 3.5 3L6 3l0-1.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5L7 3l10 0 0-1.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5L18 3l2.5 0zM22 20.5l0-15c0-.827-.673-1.5-1.5-1.5l-17 0C2.673 4 2 4.673 2 5.5l0 15c0 .827.673 1.5 1.5 1.5l17 0c.827 0 1.5-.673 1.5-1.5zM12 9c-.2761424 0-.5-.22385763-.5-.5 0-.27614237.2238576-.5.5-.5.2761424 0 .5.22385763.5.5 0 .27614237-.2238576.5-.5.5zm0 4.5c-.2761424 0-.5-.2238576-.5-.5 0-.2761424.2238576-.5.5-.5.2761424 0 .5.2238576.5.5 0 .2761424-.2238576.5-.5.5zm0 4.5c-.2761424 0-.5-.2238576-.5-.5 0-.2761424.2238576-.5.5-.5.2761424 0 .5.2238576.5.5 0 .2761424-.2238576.5-.5.5zM6.5 9c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5zm0 4.5c-.27614237 0-.5-.2238576-.5-.5 0-.2761424.22385763-.5.5-.5.27614237 0 .5.2238576.5.5 0 .2761424-.22385763.5-.5.5zm0 4.5c-.27614237 0-.5-.2238576-.5-.5 0-.2761424.22385763-.5.5-.5.27614237 0 .5.2238576.5.5 0 .2761424-.22385763.5-.5.5zm11-9c-.2761424 0-.5-.22385763-.5-.5 0-.27614237.2238576-.5.5-.5.2761424 0 .5.22385763.5.5 0 .27614237-.2238576.5-.5.5zm0 4.5c-.2761424 0-.5-.2238576-.5-.5 0-.2761424.2238576-.5.5-.5.2761424 0 .5.2238576.5.5 0 .2761424-.2238576.5-.5.5zm0 4.5c-.2761424 0-.5-.2238576-.5-.5 0-.2761424.2238576-.5.5-.5.2761424 0 .5.2238576.5.5 0 .2761424-.2238576.5-.5.5z"],"calendar-month_28":["M24 4c1.657 0 3 1.343 3 3l0 17c0 1.657-1.343 3-3 3L4 27c-1.657 0-3-1.343-3-3L1 7c0-1.657 1.343-3 3-3l3 0 0-2.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5L8 4l12 0 0-2.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5L21 4l3 0zm2 17l0-14c0-1.103-.897-2-2-2L4 5c-1.103 0-2 .897-2 2l0 14 0 3c0 1.103.897 2 2 2l20 0c1.103 0 2-.897 2-2l0-3zm-12-6c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm-6.5-5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zM14 20c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm-6.5 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0-5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm13-5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zM14 10c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm6.5 5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0 5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5z"],"calendar-month_36":["M31.5 5C33.433 5 35 6.566 35 8.5l0 23c0 1.934-1.567 3.5-3.5 3.5l-27 0C2.567 35 1 33.434 1 31.5l0-23C1 6.566 2.567 5 4.5 5L9 5l0-3.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5L10 5l16 0 0-3.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5L27 5l4.5 0zM34 31.5l0-23C34 7.121 32.878 6 31.5 6l-27 0C3.122 6 2 7.121 2 8.5l0 23C2 32.879 3.122 34 4.5 34l27 0c1.378 0 2.5-1.121 2.5-2.5zm-16-11c-.2761424 0-.5-.2238576-.5-.5 0-.2761424.2238576-.5.5-.5.2761424 0 .5.2238576.5.5 0 .2761424-.2238576.5-.5.5zm7.5 0c-.2761424 0-.5-.2238576-.5-.5 0-.2761424.2238576-.5.5-.5.2761424 0 .5.2238576.5.5 0 .2761424-.2238576.5-.5.5zm-15 0c-.27614237 0-.5-.2238576-.5-.5 0-.2761424.22385763-.5.5-.5.27614237 0 .5.2238576.5.5 0 .2761424-.22385763.5-.5.5zM18 14c-.2761424 0-.5-.2238576-.5-.5 0-.2761424.2238576-.5.5-.5.2761424 0 .5.2238576.5.5 0 .2761424-.2238576.5-.5.5zm7.5 0c-.2761424 0-.5-.2238576-.5-.5 0-.2761424.2238576-.5.5-.5.2761424 0 .5.2238576.5.5 0 .2761424-.2238576.5-.5.5zm-15 0c-.27614237 0-.5-.2238576-.5-.5 0-.2761424.22385763-.5.5-.5.27614237 0 .5.2238576.5.5 0 .2761424-.22385763.5-.5.5zM18 27c-.2761424 0-.5-.2238576-.5-.5 0-.2761424.2238576-.5.5-.5.2761424 0 .5.2238576.5.5 0 .2761424-.2238576.5-.5.5zm7.5 0c-.2761424 0-.5-.2238576-.5-.5 0-.2761424.2238576-.5.5-.5.2761424 0 .5.2238576.5.5 0 .2761424-.2238576.5-.5.5zm-15 0c-.27614237 0-.5-.2238576-.5-.5 0-.2761424.22385763-.5.5-.5.27614237 0 .5.2238576.5.5 0 .2761424-.22385763.5-.5.5z"],"calendar-week_16":["M14 2c1.104 0 2 .895 2 2l0 10c0 1.105-.896 2-2 2L2 16c-1.104 0-2-.895-2-2L0 4c0-1.105.896-2 2-2l2 0L4 .5c0-.275.225-.5.5-.5.275 0 .5.225.5.5L5 2l6 0 0-1.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5L12 2l2 0zm1 12l0-10c0-.551-.448-1-1-1L2 3c-.552 0-1 .449-1 1l0 10c0 .551.448 1 1 1l12 0c.552 0 1-.449 1-1zM4.5 11l7 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-7 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5zm0-2.5l7 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-7 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5zm0-2.5l7 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-7 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5z"],"calendar-week_20":["M16.5 3C17.881 3 19 4.119 19 5.5l0 11c0 1.381-1.119 2.5-2.5 2.5l-13 0C2.119 19 1 17.881 1 16.5l0-11C1 4.119 2.119 3 3.5 3L5 3l0-1.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5L6 3l8 0 0-1.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5L15 3l1.5 0zM18 16.5l0-11c0-.827-.673-1.5-1.5-1.5l-13 0C2.673 4 2 4.673 2 5.5l0 11c0 .827.673 1.5 1.5 1.5l13 0c.827 0 1.5-.673 1.5-1.5zM5.5 7l9 0c.2761424 0 .5.22385763.5.5 0 .27614237-.2238576.5-.5.5l-9 0c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5zm0 7l9 0c.2761424 0 .5.2238576.5.5 0 .2761424-.2238576.5-.5.5l-9 0c-.27614237 0-.5-.2238576-.5-.5 0-.2761424.22385763-.5.5-.5zm0-3.5l9 0c.2761424 0 .5.22385763.5.5 0 .2761424-.2238576.5-.5.5l-9 0c-.27614237 0-.5-.2238576-.5-.5 0-.27614237.22385763-.5.5-.5z"],"calendar-week_24":["M20.5 3C21.881 3 23 4.119 23 5.5l0 15c0 1.381-1.119 2.5-2.5 2.5l-17 0C2.119 23 1 21.881 1 20.5l0-15C1 4.119 2.119 3 3.5 3L6 3l0-1.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5L7 3l10 0 0-1.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5L18 3l2.5 0zM22 20.5l0-15c0-.827-.673-1.5-1.5-1.5l-17 0C2.673 4 2 4.673 2 5.5l0 15c0 .827.673 1.5 1.5 1.5l17 0c.827 0 1.5-.673 1.5-1.5zM6.5 8l11 0c.2761424 0 .5.22385763.5.5 0 .27614237-.2238576.5-.5.5l-11 0c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5zm0 4.5l11 0c.2761424 0 .5.2238576.5.5 0 .2761424-.2238576.5-.5.5l-11 0c-.27614237 0-.5-.2238576-.5-.5 0-.2761424.22385763-.5.5-.5zm0 4.5l11 0c.2761424 0 .5.2238576.5.5 0 .2761424-.2238576.5-.5.5l-11 0c-.27614237 0-.5-.2238576-.5-.5 0-.2761424.22385763-.5.5-.5z"],"call-forward_16":["M15.8536 7.1462c-.195-.195-.512-.195-.707 0l-4.665 4.665-8.679-7.811 6.697 0c.277 0 .5-.224.5-.5 0-.277-.223-.5-.5-.5l-8 0c-.004 0-.009.002-.014.002-.035.001-.069.013-.103.021-.029.008-.059.01-.086.021-.024.011-.043.03-.065.045-.033.021-.066.04-.093.069-.003.003-.007.004-.01.008-.016.017-.023.04-.036.06-.021.031-.043.06-.057.096-.013.034-.015.068-.021.103-.004.026-.015.048-.015.075l0 8c0 .276.224.5.5.5.277 0 .5-.224.5-.5l0-6.877 9.166 8.249c.095.086.215.128.334.128.128 0 .257-.049.354-.147l5-5c.195-.195.195-.512 0-.707"],"call-forward_24":["M23.8537515 11.146c-.1949979-.195-.5119946-.195-.7069926 0l-7.6469204 7.647L1.65198279 5 12.4998698 5c.2769971 0 .4999948-.224.4999948-.5 0-.277-.2229977-.5-.4999948-.5L.499994792 4C.223997667 4 0 4.223 0 4.5l0 12c0 .276.223997667.5.499994792.5.276997114 0 .499994791-.224.499994791-.5l0-10.738L15.1468422 19.854c.097999.097.2259977.146.3529963.146.1279987 0 .2559974-.049.3539964-.147l7.9999166-8c.194998-.195.194998-.512 0-.707"],"call-forward_28":["M27.8716 13.1655c-.185-.206-.501-.222-.706-.037l-9.648 8.683-15.811-15.812 12.793 0c.277 0 .5-.223.5-.5 0-.276-.223-.5-.5-.5l-14 0c-.065 0-.129.014-.19.039-.123.05-.221.148-.271.271-.025.061-.039.126-.039.19l0 14c0 .277.224.5.5.5.277 0 .5-.223.5-.5l0-12.792 16.147 16.146c.097.097.225.146.353.146.12 0 .24-.042.335-.128l10-9c.205-.185.222-.501.037-.706"],"call-forward-divert_16":["M.5002 10c-.276 0-.5-.224-.5-.5l0-8c0-.027.011-.049.015-.075.006-.035.008-.069.021-.103.014-.036.036-.065.057-.096.013-.02.02-.043.036-.06.003-.004.007-.005.01-.008.027-.029.06-.048.093-.069.022-.015.041-.034.065-.045.027-.011.057-.013.086-.021.034-.008.068-.02.103-.021.005 0 .01-.002.014-.002l8 0c.277 0 .5.223.5.5 0 .276-.223.5-.5.5l-6.697 0 8.679 7.811 4.665-4.665c.195-.195.512-.195.707 0 .195.195.195.512 0 .707l-5 5c-.097.098-.226.147-.354.147-.119 0-.239-.042-.334-.128l-9.166-8.249 0 6.877c0 .276-.223.5-.5.5zm15 4c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-15 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l15 0z"],"call-handling_16":["M15.9614 12.3091c-.025-.062-.062-.117-.108-.163l-3-3c-.195-.195-.512-.195-.707 0-.195.196-.195.512 0 .707l2.128 2.128c-1.717-.096-3.324-.893-4.554-2.287l-1.495-1.694 1.495-1.694c1.23-1.394 2.837-2.191 4.554-2.287l-2.128 2.127c-.195.196-.195.512 0 .707.098.098.226.147.354.147.128 0 .255-.049.353-.147l3-2.999c.046-.046.083-.102.108-.163.051-.122.051-.26 0-.382-.025-.062-.062-.117-.108-.163l-3-3c-.195-.195-.512-.195-.707 0-.195.196-.195.512 0 .707l2.164 2.164c-1.997.089-3.929 1.029-5.34 2.627l-1.412 1.6-1.411-1.6c-1.483-1.68-3.541-2.644-5.647-2.644-.277 0-.5.224-.5.5 0 .276.223.5.5.5 1.845 0 3.585.819 4.897 2.306l1.495 1.694-1.495 1.694c-1.312 1.487-3.052 2.306-4.897 2.306-.277 0-.5.224-.5.5 0 .276.223.5.5.5 2.106 0 4.164-.964 5.647-2.644l1.412-1.6 1.411 1.599c1.411 1.599 3.343 2.538 5.34 2.627l-2.164 2.164c-.195.196-.195.512 0 .707.098.098.226.147.354.147.128 0 .255-.049.353-.147l3-2.999c.046-.046.083-.102.108-.163.051-.122.051-.26 0-.382"],"call-hold_16":["M14.6300146 10.3603525C15.4620057 10.7183301 16 11.535279 16 12.4402225l0 1.7308918c0 .5689644-.2579972 1.0959315-.7069925 1.4449097C14.970011 15.8680082 14.5810151 16 14.1840194 16c-.1489985 0-.2989969-.0189988-.4469953-.0569964-2.6899713-.6829574-5.7579386-2.6008375-8.41891023-5.2616712C2.65714223 8.02049872.739162677 4.95269046.0561699571 2.26285857-.0818285719 1.71889257.0371701596 1.151928.383166471.706955815.732162751.257983876 1.25915713 0 1.82815107 0l1.73098155 0c.90499035 0 1.72198164.537966377 2.07997782 1.36991438l.65399303 1.51990501c.31499665.73395412.2909969 1.56490219-.06599929 2.27885757l-.4409953.88194488c-.06699929.13399162-.04999947.29298168.04499952.415974.91599023 1.17692644 2.30597542 2.55784013 3.71896035 3.69076936.11899874.094994.281997.1149928.41599557.047997l.86599078-.43297297c.7139924-.35797763 1.5439835-.38197613 2.2779757-.06499594l1.5199838.65295921zm.3699961 3.8107618l0-1.7308918c0-.5049685-.2999968-.96094-.7649919-1.1619274l-1.5199838-.6519592c-.4619951-.1989876-.9849895-.1839885-1.4359847.0409974l-.8659907.4329729c-.47899494.240985-1.06498869.176989-1.48898417-.1619898-1.4919841-1.19792517-2.90696901-2.6038373-3.88195862-3.85775893-.33399644-.42997313-.39099583-.99493782-.1499984-1.4769077l.4409953-.88194488c.2249976-.44997187.23999744-.97393913.04099956-1.43691019l-.65399303-1.51990501c-.19899788-.46497093-.65599301-.764952186-1.16098762-.764952186l-1.73098155 0c-.25799725 0-.4969947.116992686-.65599301.320979936-.15499835.1999875-.208997771.45397163-.14699843.69595651.64099317 2.51984251 2.46297374 5.4206612 4.9999467 7.95750265 2.53797295 2.5368414 5.43794207 4.3597275 7.95791517 4.9996875.2429974.0619961.4959947.0079995.6959926-.1469908.2039978-.1589901.3209966-.3979751.3209966-.655959zM14.500016.0000999938C15.3250072.0000999938 16 .675057809 16 1.50000625l0 4.99968752c0 .82494844-.6749928 1.49990625-1.499984 1.49990625-.8249912 0-1.499984-.67495781-1.499984-1.49990625l0-4.99968752c0-.824948441.6749928-1.4999062562 1.499984-1.4999062562zm.4999947 6.4995937762l0-4.99968752c0-.27098306-.2289976-.49996875-.4999947-.49996875-.2709971 0-.4999947.22898569-.4999947.49996875l0 4.99968752c0 .27098306.2289976.49996875.4999947.49996875.2709971 0 .4999947-.22898569.4999947-.49996875zm-4.4999521 1.49990625c-.82499118 0-1.49998398-.67495781-1.49998398-1.49990625l0-4.99968752c0-.824948441.6749928-1.4999062562 1.49998398-1.4999062562.8249912 0 1.499984.6749578152 1.499984 1.4999062562l0 4.99968752c0 .82494844-.6749928 1.49990625-1.499984 1.49990625zm-.4999946-6.49959377l0 4.99968752c0 .27098306.2289975.49996875.4999946.49996875.2709971 0 .4999947-.22898569.4999947-.49996875l0-4.99968752c0-.27098306-.2289976-.49996875-.4999947-.49996875-.2709971 0-.4999946.22898569-.4999946.49996875z"],"call-hold_20":["M18.3462263 13.113c1.005.433 1.654 1.418 1.654 2.513l0 2.192c0 .679-.308 1.308-.844 1.725-.386.3-.849.457-1.323.457-.177 0-.356-.022-.534-.067-3.383-.86-7.248-3.276-10.60200003-6.63C3.34222627 9.948.926226271 6.084.0672262714 2.7c-.165-.649-.023-1.325.3899999996-1.856C.875226271.308 1.50322627 0 2.18222627 0l2.193 0c1.094 0 2.08.65 2.512 1.655l.828 1.925c.384.893.355 1.904-.08 2.774l-.558 1.117c-.109.217-.081.473.071.669 1.167 1.5 2.93600003 3.257 4.73200003 4.698.192.154.455.183.67.076l1.096-.549c.87-.435 1.881-.464 2.774-.08l1.926.828zm.654 4.705l0-2.192c0-.694-.412-1.32-1.049-1.594l-1.926-.828c-.622-.268-1.326-.247-1.931.056l-1.097.548c-.564.282-1.248.207-1.743-.19-1.88000003-1.509-3.66500003-3.282-4.89600003-4.864-.385-.496-.454-1.175-.176-1.73l.559-1.117c.302-.606.322-1.31.055-1.931l-.828-1.926c-.274-.638-.9-1.05-1.593-1.05l-2.193 0c-.368 0-.709.167-.935.458-.223.285-.298999999.649-.211.996.816 3.214 3.137 6.911 6.368 10.142 3.23100003 3.23 6.92700003 5.551 10.14100003 6.368.348.088.712.012.997-.21.291-.227.458-.568.458-.936zm-2.5-8.8179c-.825 0-1.5-.675-1.5-1.5l0-6c0-.825.675-1.5 1.5-1.5.825 0 1.5.675 1.5 1.5l0 6c0 .825-.675 1.5-1.5 1.5zm-.5-7.5l0 6c0 .271.229.5.5.5.271 0 .5-.229.5-.5l0-6c0-.271-.229-.5-.5-.5-.271 0-.5.229-.5.5zm-3.5 7.5c-.825 0-1.5-.675-1.5-1.5l0-6c0-.825.675-1.5 1.5-1.5.825 0 1.5.675 1.5 1.5l0 6c0 .825-.675 1.5-1.5 1.5zm-.5-7.5l0 6c0 .271.229.5.5.5.271 0 .5-.229.5-.5l0-6c0-.271-.229-.5-.5-.5-.271 0-.5.229-.5.5z"],"call-hold_24":["M22.0610992 15.865c1.178.507 1.939 1.663 1.939 2.945l0 2.654c0 .789-.357 1.52-.98 2.004-.449.35-.987.532-1.538.532-.206 0-.414-.026-.62-.078-4.078-1.036-8.738-3.951-12.78500003-7.998-4.048-4.048-6.964-8.708-7.9989999964-12.786-.1919999996-.754-.026-1.541.4540000004-2.157C1.01709917.358 1.74709917 0 2.53609917 0l2.654 0c1.282 0 2.438.761 2.945 1.939l1.002 2.332c.453 1.052.419 2.244-.094 3.269l-.676 1.352c-.15.299-.112.652.097.921 1.438 1.848 3.53200003 3.928 5.74600003 5.705.264.212.625.252.923.103l1.328-.664c1.024-.512 2.216-.546 3.269-.094l2.331 1.002zm.939 5.599l0-2.654c0-.882-.524-1.677-1.334-2.026l-2.331-1.002c-.782-.336-1.666-.31-2.427.07l-1.327.664c-.645.321-1.429.237-1.997-.218-2.272-1.824-4.42500003-3.964-5.90900003-5.871-.441-.567-.521-1.345-.203-1.983l.676-1.352c.381-.76.407-1.645.07-2.426l-1.002-2.332c-.349-.81-1.144-1.334-2.026-1.334l-2.654 0c-.478 0-.921.217-1.215.595-.289.371-.388999996.844-.274 1.297.993 3.908 3.812 8.401 7.737 12.325 3.92300003 3.924 8.41500003 6.743 12.32400003 7.736.454.116.926.015 1.297-.274.378-.294.595-.736.595-1.215zm-3.5-10.4639c-.825 0-1.5-.675-1.5-1.5l0-7c0-.825.675-1.5 1.5-1.5.825 0 1.5.675 1.5 1.5l0 7c0 .825-.675 1.5-1.5 1.5zm-.5-8.5l0 7c0 .271.229.5.5.5.271 0 .5-.229.5-.5l0-7c0-.271-.229-.5-.5-.5-.271 0-.5.229-.5.5zm-3.5 8.5c-.825 0-1.5-.675-1.5-1.5l0-7c0-.825.675-1.5 1.5-1.5.825 0 1.5.675 1.5 1.5l0 7c0 .825-.675 1.5-1.5 1.5zm-.5-8.5l0 7c0 .271.229.5.5.5.271 0 .5-.229.5-.5l0-7c0-.271-.229-.5-.5-.5-.271 0-.5.229-.5.5z"],"call-incoming_12":["M10.8535 1.1465c-.195-.195-.512-.195-.707 0l-8.147 8.146 0-6.792c0-.277-.223-.5-.5-.5-.276 0-.5.223-.5.5l0 8c0 .276.224.5.5.5l8 0c.276 0 .5-.224.5-.5 0-.277-.224-.5-.5-.5l-6.792 0 8.146-8.147c.195-.195.195-.512 0-.707"],"call-incoming_16":["M2.03875 13.691c.051.122.148.22.271.271.061.025.125.038.191.038l9 0c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5l-7.793 0 10.146-10.146c.195-.196.195-.512 0-.707-.098-.098-.226-.147-.353-.147-.128 0-.256.049-.354.147l-10.146 10.146 0-7.793c0-.276-.224-.5-.5-.5-.277 0-.5.224-.5.5l0 9c0 .065.013.13.038.191"],"call-incoming_24":["M3.49975 21l13.014 0c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5l-11.79 0 16.13-16.146c.195-.196.195-.512 0-.708-.098-.097-.226-.146-.354-.146-.128 0-.256.049-.354.146L3.99975 19.31l0-11.792c0-.277-.224-.5-.5-.5-.276 0-.5.223-.5.5l0 12.982c0 .276.224.5.5.5"],"call-incoming_8":["M7.85373629.146263712c-.19501829-.1950182827-.51204801-.1950182827-.70706629 0L1.00009376 6.29283995l0-4.79244929c0-.27702597-.223020909-.50004688-.500046881-.50004688C.224021002 1.00034378 0 1.22336469 0 1.50039066l0 5.99956246C0 7.775979.224021002 8 .500046879 8L6.49860924 8c.27602588 0 .50004688-.224021.50004688-.50004688 0-.27702597-.224021-.50004688-.50004688-.50004688l-4.79144919 0L7.85373629.85333c.19501828-.195018283.19501828-.512048005 0-.707066288"],"call-log_14":["M1.5624 1.9951c-.175 0-.337.08-.445.218-.105.135-.142.307-.1.471.507 1.999 1.956 4.302 3.974 6.32 2.017 2.018 4.321 3.466 6.32 3.974.163.041.334.005.471-.1.138-.108.218-.27.218-.445l0-1.385c0-.365-.217-.694-.551-.837l-1.217-.523c-.342-.147-.731-.135-1.065.031l-.692.346c-.42.209-.93.155-1.298-.142-1.198-.961-2.337-2.092-3.122-3.102-.287-.368-.339-.874-.131-1.289l.352-.704c.167-.334.179-.723.031-1.065l-.523-1.217c-.144-.335-.472-.551-.837-.551l-1.385 0zm9.886 12c-.128 0-.257-.016-.384-.048-2.168-.551-4.639-2.095-6.78-4.236-2.142-2.141-3.686-4.613-4.237-6.781-.117-.466-.015-.951.281-1.331.298-.384.748-.604 1.234-.604l1.385 0c.764 0 1.454.454 1.756 1.156l.523 1.217c.264.614.244 1.309-.055 1.907l-.353.705c-.036.073-.027.16.026.226.729.938 1.835 2.036 2.959 2.937.064.053.153.063.225.027l.692-.346c.597-.298 1.292-.319 1.907-.055l1.216.523c.703.302 1.157.991 1.157 1.756l0 1.385c0 .486-.22.936-.605 1.234-.276.216-.608.328-.947.328zM10.4985 6c-.128 0-.256-.049-.354-.146l-1-1c-.093-.094-.146-.221-.146-.354l0-2c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 1.793.854.853c.195.196.195.512 0 .708-.098.097-.226.146-.354.146zm1.5004 2.1225c-.146 0-.292-.064-.391-.187-.172-.216-.138-.53.078-.703.834-.669 1.313-1.665 1.313-2.733 0-1.929-1.571-3.5-3.5-3.5-1.068 0-2.064.479-2.733 1.313-.172.216-.486.251-.703.078-.215-.173-.25-.488-.077-.703.859-1.072 2.139-1.688 3.513-1.688 2.481 0 4.5 2.019 4.5 4.5 0 1.373-.616 2.654-1.688 3.513-.092.074-.203.11-.312.11z"],"call-log_16":["M13.7006585 10.6727c.7889799.34 1.298967 1.114 1.298967 1.972l0 1.616c0 .542-.2449938 1.042-.6729829 1.375-.3069922.239-.6769828.364-1.0549732.364-.1419964 0-.2849927-.017-.4259891-.053-2.514936-.639-5.38486301-2.432-7.87179972-4.92C2.48494391 8.5387.691989534 5.6687.0530057942 3.1537c-.1309966666-.518-.0169995674-1.058.3119920608-1.481.331991552-.428.832978805-.673 1.373965035-.673l1.61595888 0c.85797817 0 1.63195847.51 1.97194982 1.299l.60998448 1.419c.29899239.694.27599298 1.48-.06199842 2.155l-.41198952.823c-.05599857.113-.04199893.249.03899901.353.85397827 1.098 2.14994529 2.384 3.4659118 3.44.10199741.083.23799395.098.35199105.041l.80797941-.405c.6759828-.338 1.4609629-.359 2.1539452-.062l1.4189639.61zm.2989924 3.588l0-1.616c0-.458-.2719931-.872-.6939823-1.053l-1.417964-.61-.0009999 0c-.4229893-.182-.9009771-.169-1.3119666.038l-.80797949.404c-.46198824.23-1.02097402.17-1.42496374-.156-1.39296455-1.117-2.71593089-2.432-3.62890765-3.605-.31499199-.405-.37099056-.96-.14399634-1.414l.41098954-.823c.20699474-.412.2199944-.891.03899901-1.313l-.61098445-1.419c-.1809954-.421-.59498486-.694-1.05297321-.694l-1.61595888 0c-.22999414 0-.44298872.105-.58498511.286-.13799649.179-.185995269.405-.13099667.622.59498486 2.346 2.29294165 5.047 4.65788148 7.412 2.36393984 2.364 5.06587111 4.062 7.41081141 4.657.2169945.056.4439887.007.6209842-.131.1829953-.141.2869927-.355.2869927-.585zM10.49974 3c.2759929 0 .4999872.224.4999872.5l0 1.999.8539783.647c.194995.196.194995.512 0 .708-.0979975.097-.2259942.146-.353991.146-.1279967 0-.2559935-.049-.353991-.146l-.9999745-.795c-.0929977-.094-.14599632-.221-.14599632-.353l0-2.206c0-.276.22399432-.5.49998732-.5zm-3.12252058-.7402c-.19899494.192-.5149869.187-.70698201-.013-.19199512-.198-.18599527-.515.01299967-.707 1.02997379-.993 2.38493931-1.54 3.81690292-1.54C13.5320628-.0002 16 2.4678 16 5.4998c0 1.201-.3809903 2.342-1.099972 3.301-.0979975.13-.2489937.199-.3999898.199-.1049974 0-.2099947-.032-.2999924-.1-.2209944-.166-.2649933-.479-.0999975-.7.5889851-.784.8999771-1.717.8999771-2.7 0-2.481-2.0189486-4.5-4.4998854-4.5-1.17097025 0-2.28094201.448-3.12292058 1.26z"],"call-log_24":["M2.44453033 1.99184958c-.45226846 0-.87180697.20531287-1.14951567.56237872-.27274962.35111475-.36697222.79744706-.25886419 1.22592608.94916868 3.73728924 3.64591857 8.03199792 7.39895336 11.78515672 3.75005937 3.7511752 8.04462607 6.4480142 11.78377547 7.3982061.4294566.1071197.8757742.0138859 1.2268774-.2598646.357054-.2777179.5623601-.6962784.5623601-1.1485618l0-2.539135c0-.837121-.4969002-1.5919185-1.2665501-1.9231963l-2.230596-.9591185c-.7438626-.3203675-1.5839314-.2935875-2.3069658.0674457l-1.2705174.6347838c-.6228609.3144163-1.3796171.2311009-1.9290837-.211264-2.1740624-1.7436716-4.23604953-3.7928328-5.65633119-5.6198197-.42648122-.547501-.50384294-1.299323-.19637973-1.91526159l.64666456-1.29337186c.36201313-.7240502.38680855-1.56513864.06645173-2.30803398l-.95908685-2.23066972c-.330275-.76868342-1.08504759-1.26560007-1.92114915-1.26560007l-2.54004284 0zM20.5719661 24c-.1993552 0-.3987104-.0247962-.5970738-.0753806-3.9067664-.9928414-8.3689502-3.7839061-12.24100295-7.6580706C3.85786928 12.3913925 1.06689679 7.92906119.0750799886 4.02414938-.109397937 3.29712364.0492927517 2.53935055.512471199 1.94523265.979616914 1.34516366 1.68380684 1 2.44453033 1l2.54004284 0c1.2338201 0 2.34564674.73198499 2.83262879 1.86566907l.95908685 2.23066971c.43540758 1.01168658.40267762 2.15727285-.09025533 3.14317133l-.64666456 1.29436371c-.13984617.27870973-.10513258.60998748.09124715.86191728 1.37564991 1.7684678 3.37812803 3.7571262 5.49367323 5.4561646.2469624.197378.5881474.2360602.8658561.0972012l1.2705173-.6357756c.9868578-.4929492 2.1314144-.5246884 3.1420757-.0902583l2.230596.9591186c1.1336466.4869981 1.8665992 1.5988615 1.8665992 2.8337142l0 2.539135c0 .7607486-.3451523 1.4649618-.9461932 1.9311311C21.6223001 23.8234508 21.102588 24 20.5719661 24zM18.5 10c-.104 0-.21-.033-.3-.1l-1.599-1.2C16.225 8.419 16 7.97 16 7.5l0-3c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 3c0 .156.075.306.2.399L18.8 9.1c.221.166.265.479.1.7-.098.131-.249.2-.4.2zm3.00025 3c-.128 0-.256-.049-.354-.146-.195-.196-.195-.512 0-.708 1.178-1.178 1.854-2.871 1.854-4.646 0-3.584-2.916-6.5-6.5-6.5-1.775 0-3.468.676-4.646 1.854-.196.195-.512.195-.708 0-.195-.196-.195-.512 0-.708C12.51125.782 14.46225 0 16.50025 0c4.136 0 7.5 3.364 7.5 7.5 0 2.038-.782 3.989-2.146 5.354-.098.097-.226.146-.354.146z"],"call-merge_16":["M7.461 7.80935c.051.122.051.26 0 .382-.025.061-.062.117-.108.163l-3.5 3.499c-.098.098-.225.147-.353.147-.128 0-.256-.049-.354-.147-.195-.195-.195-.511 0-.707l2.647-2.646-5.293 0c-.277 0-.5-.224-.5-.5 0-.276.223-.5.5-.5l5.293 0-2.647-2.647c-.195-.195-.195-.511 0-.707.195-.195.512-.195.707 0l3.5 3.5c.046.046.083.101.108.163zm8.0386-.3091c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-5.293 0 2.647 2.646c.195.196.195.512 0 .708-.098.097-.226.146-.354.146-.128 0-.256-.049-.354-.146l-3.499-3.5c-.046-.046-.083-.102-.108-.163-.051-.122-.051-.26 0-.382.025-.061.062-.117.108-.163l3.499-3.5c.196-.195.512-.195.708 0 .195.196.195.512 0 .708l-2.647 2.646 5.293 0z"],"call-merge_20":["M9.461 9.75335c.051.122.051.26 0 .382-.025.061-.062.117-.108.163l-4.444 4.444c-.098.097-.226.146-.354.146-.128 0-.256-.049-.353-.146-.196-.196-.196-.512 0-.707l3.591-3.591-7.293 0c-.277 0-.5-.224-.5-.5 0-.276.223-.5.5-.5l7.293 0-3.591-3.591c-.196-.195-.196-.512 0-.707.195-.195.511-.195.707 0l4.444 4.444c.046.046.083.101.108.163zm10.0386-.3091c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-7.293 0 3.591 3.591c.195.195.195.512 0 .707-.098.098-.226.146-.354.146-.128 0-.256-.048-.353-.146l-4.444-4.444c-.046-.046-.083-.102-.108-.163-.051-.122-.051-.26 0-.382.025-.061.062-.117.108-.163l4.444-4.444c.195-.195.512-.195.707 0 .195.195.195.512 0 .707l-3.591 3.591 7.293 0z"],"call-merge_24":["M11.451 11.80935c.051.122.051.26 0 .382-.025.061-.062.117-.108.163l-5.5 5.499c-.098.098-.225.147-.353.147-.128 0-.256-.049-.354-.147-.195-.195-.195-.511 0-.707l4.647-4.646-9.283 0c-.277 0-.5-.224-.5-.5 0-.276.223-.5.5-.5l9.283 0-4.647-4.647c-.195-.195-.195-.511 0-.707.195-.195.512-.195.707 0l5.5 5.5c.046.046.083.101.108.163zm12.0283-.3091c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-9.283 0 4.647 4.646c.195.196.195.512 0 .708-.098.097-.226.146-.354.146-.128 0-.256-.049-.353-.146l-5.5-5.5c-.046-.046-.083-.102-.108-.163-.051-.122-.051-.26 0-.382.025-.061.062-.117.108-.163l5.5-5.5c.195-.195.511-.195.707 0 .195.196.195.512 0 .708l-4.647 4.646 9.283 0z"],"call-outgoing_12":["M1.14625 10.854c.195.195.512.195.707 0l8.147-8.146 0 6.792c0 .277.223.5.5.5.276 0 .5-.223.5-.5l0-8c0-.276-.224-.5-.5-.5l-8 0c-.276 0-.5.224-.5.5 0 .277.224.5.5.5l6.792 0-8.146 8.147c-.195.195-.195.512 0 .707"],"call-outgoing_16":["M13.96125 2.309c-.051-.122-.148-.22-.271-.271-.061-.025-.125-.038-.191-.038l-9 0c-.276 0-.5.224-.5.5 0 .276.224.5.5.5l7.793 0-10.146 10.146c-.195.196-.195.512 0 .707.098.098.226.147.353.147.128 0 .256-.049.354-.147l10.146-10.146 0 7.793c0 .276.224.5.5.5.277 0 .5-.224.5-.5l0-9c0-.065-.013-.13-.038-.191"],"call-outgoing_24":["M20.50025 3l-13.014 0c-.276 0-.5.224-.5.5 0 .276.224.5.5.5l11.79 0-16.13 16.146c-.195.196-.195.512 0 .708.098.097.226.146.354.146.128 0 .256-.049.354-.146l16.146-16.164 0 11.792c0 .277.224.5.5.5.276 0 .5-.223.5-.5l0-12.982c0-.276-.224-.5-.5-.5"],"call-outgoing_8":["M.14626371 7.853736288c.19501829.1950182827.51204801.1950182827.70706629 0L6.99990624 1.70716005l0 4.79244929c0 .27702597.223020909.50004688.500046881.50004688C7.775978998 6.99965622 8 6.77663531 8 6.49960934L8 .50004688C8 .224021 7.775978998 0 7.499953121 0L1.50139076 0c-.27602588 0-.50004688.224021-.50004688.50004688 0 .27702597.224021.50004688.50004688.50004688l4.79144919 0L.14626371 7.14667c-.19501828.195018283-.19501828.512048005 0 .707066288"],"call-private_12":["M10.9152 7.6086c.659.283 1.085.931 1.085 1.648l0 1.27c0 .458-.208.883-.57 1.164-.261.203-.574.31-.894.31-.12 0-.242-.015-.362-.046-1.994-.506-4.267-1.925-6.235-3.894-1.968-1.968-3.387-4.24-3.894-6.235-.111-.439-.015-.897.264-1.255.281-.362.706-.57 1.165-.57l1.269 0c.718 0 1.365.425 1.648 1.085l.48 1.114c.246.575.228 1.224-.052 1.784l-.323.647c-.026.051-.019.115.019.164.666.855 1.677 1.859 2.705 2.684.048.038.11.046.162.02l.635-.318c.559-.278 1.209-.298 1.783-.051l1.115.479zm.085 2.918l0-1.27c0-.317-.188-.604-.48-.729l-1.115-.48c-.303-.13-.646-.12-.941.028l-.635.317c-.399.2-.884.148-1.235-.135-1.101-.883-2.147-1.922-2.868-2.85-.273-.351-.322-.831-.125-1.225l.324-.646c.147-.295.157-.639.027-.942l-.48-1.114c-.125-.292-.411-.48-.729-.48l-1.269 0c-.148 0-.285.066-.376.183-.052.067-.132.207-.084.396.464 1.825 1.788 3.93 3.632 5.774 1.844 1.845 3.949 3.168 5.774 3.632.191.049.329-.032.396-.084.117-.091.184-.228.184-.375zm-2-4.5263c-1.657 0-3-1.343-3-3 0-1.657 1.343-3 3-3 1.657 0 3 1.343 3 3 0 1.657-1.343 3-3 3zm0-5c-.929 0-1.706.64-1.929 1.5l3.858 0c-.223-.86-1-1.5-1.929-1.5zm0 4c.929 0 1.706-.64 1.929-1.5l-3.858 0c.223.86 1 1.5 1.929 1.5z"],"call-private_14":["M12.3599847 14c-.1350013 0-.2700025-.017-.4040038-.05-2.34302186-.596-5.01304679-2.264-7.3270684-4.578C2.31389089 7.057.644875307 4.386.0508697607 2.044-.0741314064 1.553.033869602 1.04.345872515.638.661875466.232 1.1368799 0 1.6508847 0l1.500014 0c.81200759 0 1.54301441.481 1.86401741 1.227l.56700529 1.318c.28100263.654.26000243 1.394-.05900055 2.031l-.38200356.764c-.04600043.094-.03400032.204.03200029.29.7920074 1.018 1.99301861 2.21 3.21202999 3.188.08400079.068.19400182.082.2890027.034l.750007-.375c.63600593-.319 1.37601283-.34 2.03101893-.059l1.3180123.567C13.5179955 9.306 14 10.038 14 10.849l0 1.5c0 .514-.2330022.989-.638006 1.305-.2920027.227-.643006.346-1.0020093.346zM1.65086929 1c-.203 0-.391.092-.515.252-.122.157-.164000004.356-.116.546.552 2.173 2.125 4.675 4.316 6.867 2.19 2.19 4.69300001 3.763 6.86600001 4.315.191.049.389.007.546-.116.16-.124.252-.312.252-.515l0-1.5c0-.411-.244-.783-.623-.945l-1.317-.567c-.383-.164-.816-.152-1.18900001.035l-.75.375c-.44.22-.975.163-1.362-.148-1.296-1.04-2.526-2.263-3.375-3.355-.301-.386-.355-.916-.137-1.351l.382-.764c.186-.373.199-.806.034-1.189l-.566-1.318c-.163-.378-.534-.622-.946-.622l-1.5 0zM10.5 0C12.433 0 14 1.566 14 3.5 14 5.434 12.433 7 10.5 7 8.567 7 7 5.434 7 3.5 7 1.566 8.567 0 10.5 0zm0 6c1.209 0 2.218-.859 2.45-2l-4.9 0c.232 1.141 1.241 2 2.45 2zm0-5c-1.209 0-2.218.859-2.45 2l4.9 0c-.232-1.141-1.241-2-2.45-2z"],"call-request_12":["M10.9150104 7.60928789C11.5740041 7.89226933 12 8.53922691 12 9.2561799l0 1.2699167c0 .45797-.207998.8829421-.5699945 1.1649237C11.169008 11.8940069 10.856011 12 10.536014 12c-.1199988 0-.2419976-.014999-.3619965-.045997-1.99398089-.5059668-4.2669591-1.9248738-6.23494024-3.89274475C1.97109612 6.09338728.552109717 3.82053631.0451145763 1.8256671-.0658843599 1.38669589.03011472.929725848.309112046.570749385.590109353.208773118 1.01510528.0007867556 1.47410088.0007867556l1.26898784 0c.71799312 0 1.36498692.4259720704 1.6479842 1.0849288644l.4799954 1.11392696c.24599765.5749623.22799782 1.22491969-.0519995 1.78388304l-.3229969.64695758c-.02599975.05199659-.01899982.11499246.01899982.16398925.66599361.85494394 1.67698392 1.85887812 2.70497407 2.68382403.04799954.03899744.10999895.04699691.16199845.01999868l.63499391-.31697921c.55899465-.27898171 1.20898842-.2989804 1.78298291-.05199659l1.11498932.47996853zm.0849992 2.91680871l0-1.2699167c0-.31697921-.1879982-.6039604-.4799954-.7289522l-1.11498933-.4789686c-.3029971-.13099141-.64599381-.12099206-.94099098.02699823l-.63499392.31797916c-.39899617.19898695-.88399152.14699036-1.23498816-.13499115-1.10098945-.88394205-2.14697942-1.92287393-2.86797251-2.85081308-.27299739-.34997706-.32199692-.83094552-.1249988-1.22391975l.32399689-.64695759c.14699859-.29498065.1569985-.63795817.02699974-.94193823l-.4799954-1.11392697c-.1249988-.29198085-.41099606-.47996853-.72899301-.47996853l-1.26898784 0c-.14799858 0-.28499727.06699561-.3759964.18398794-.0519995.06599567-.131998731.20598649-.08399919.3949741.46399555 1.82488035 1.78798286 3.92974234 3.63196519 5.77462138 1.84398233 1.8438791 3.94896215 3.16779229 5.77394462 3.63076189.1909982.0489968.3289969-.0319979.3959962-.0839944.1169989-.0899941.1839983-.2279851.1839983-.3749755zM7.50004313 2.50072284c-.27599736 0-.49999521-.22398531-.49999521-.49996722 0-.54796407.21399795-1.058930566.60399421-1.436905783.38799628-.377975217.90899129-.578962039 1.44798612-.562963088C10.126018.0308847821 11.0000096.912826956 11.0000096 1.96675785c0 .88894172-.525995 1.31691366-.8749916 1.59889517-.0569995.04699692-.1129989.09199397-.16499845.13899088l-.38399632.33497804c-.03899962.03099797-.09899905.07899482-.11399891.09899351-.07099932.20298669-.25799752.32597863-.46099558.32597863-.05699945 0-.11399891-.00899941-.17099836-.0289981-.2609975-.09199397-.39299623-.38697463-.3019971-.64795752.0929991-.26598256.28399727-.41797259.42399593-.52996525l.34199672-.2989804c.06199941-.05599632.13099875-.11199265.20099808-.16798898.33199682-.2699823.50499519-.42897188.50499519-.82394598 0-.50896663-.44699575-.95093765-.97599068-.96593666-.25799753-.007999479-.52999492.09199396-.72299307.2789817-.19399814.18898761-.30099711.44497083-.30099711.72095273 0 .27598191-.22399786.49996722-.49999521.49996722zm1.49998562 2.49933613c.27599736 0 .49999521.22398531.49999521.49996722 0 .2759819-.22399785.49996721-.49999521.49996721-.27599735 0-.49999521-.22398531-.49999521-.49996721 0-.27598191.22399786-.49996722.49999521-.49996722z"],"call-request_14":["M12.7731 8.9846c.745.321 1.227 1.053 1.227 1.865l0 1.5c0 .514-.233.988-.638 1.305-.292.226-.643.345-1.002.345-.135 0-.27-.017-.404-.049-2.343-.597-5.013-2.265-7.327-4.579-2.315-2.315-3.984-4.986-4.578-7.328-.125-.491-.017-1.004.295-1.406.316-.405.791-.638 1.305-.638l1.5 0c.812 0 1.543.481 1.864 1.227l.567 1.318c.281.655.26 1.395-.059 2.032l-.382.763c-.046.094-.034.204.032.29.792 1.019 1.993 2.21 3.212 3.189.084.067.194.082.289.033l.75-.375c.636-.318 1.376-.34 2.031-.059l1.318.567zm.227 3.365l0-1.5c0-.412-.244-.783-.623-.945l-1.317-.568c-.383-.164-.816-.151-1.189.035l-.75.375c-.44.22-.975.164-1.362-.147-1.296-1.041-2.526-2.264-3.375-3.355-.301-.387-.355-.916-.137-1.352l.382-.764c.186-.373.199-.805.034-1.189l-.566-1.318c-.163-.377-.534-.622-.946-.622l-1.5 0c-.203 0-.391.092-.515.252-.122.158-.164.356-.116.546.552 2.173 2.125 4.675 4.316 6.867 2.19 2.191 4.693 3.763 6.866 4.316.191.049.389.007.546-.116.16-.124.252-.313.252-.515zm-4.499-9.3389c-.276 0-.5-.224-.5-.5 0-.687.27-1.328.758-1.803.488-.474 1.145-.729 1.817-.706 1.347.038 2.443 1.149 2.443 2.476 0 1.185-.703 1.783-1.122 2.034-.206.123-.437.226-.647.306-.106.04-.186.129-.222.243-.066.215-.263.352-.477.352-.049 0-.099-.006-.148-.022-.263-.081-.412-.361-.33-.625.127-.411.427-.734.822-.883.158-.06.334-.137.489-.229.289-.173.635-.519.635-1.176 0-.791-.66-1.453-1.471-1.476-.416-.043-.799.139-1.092.424-.294.285-.455.67-.455 1.085 0 .276-.224.5-.5.5zM10.0001 6.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5z"],"call-room_28":["M16.0976 22c-.157 0-.315-.02-.471-.06-2.862-.725-6.129-2.768-8.964-5.603-2.834-2.834-4.877-6.102-5.604-8.965-.144-.57-.019-1.165.343-1.631.367-.47.919-.741 1.515-.741l1.846 0c.953 0 1.812.565 2.188 1.441l.698 1.622c.333.773.307 1.649-.07 2.402l-.47.94c-.077.156-.057.339.052.48.979 1.259 2.464 2.733 3.972 3.944.137.109.326.132.479.054l.924-.462c.754-.377 1.629-.403 2.402-.068l1.622.697c.875.376 1.44 1.234 1.44 2.187l0 1.847c0 .597-.27 1.148-.741 1.515-.339.263-.746.401-1.161.401zM2.9166 6c-.286 0-.55.129-.726.355-.171.221-.231.501-.162.771.684 2.693 2.631 5.793 5.341 8.504 2.711 2.711 5.811 4.658 8.504 5.342.269.069.55.008.771-.162.226-.176.355-.441.355-.726l0-1.847c0-.552-.328-1.05-.835-1.269l-1.622-.697-.001 0c-.501-.216-1.069-.201-1.559.044l-.923.462c-.502.252-1.111.184-1.552-.168-1.59-1.276-3.097-2.774-4.136-4.111-.348-.447-.408-1.037-.157-1.54l.47-.94c.245-.49.261-1.058.045-1.56l-.697-1.622c-.219-.508-.717-.836-1.27-.836l-1.846 0zm21.0835 21l-17 0c-1.654 0-3-1.346-3-3l0-1.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 1.5c0 1.103.897 2 2 2l17 0c1.103 0 2-.897 2-2l0-20c0-1.103-.897-2-2-2l-12 0c-1.103 0-2 .897-2 2l0 1c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-1c0-1.654 1.346-3 3-3l12 0c1.654 0 3 1.346 3 3l0 20c0 1.654-1.346 3-3 3z"],"call-swap_16":["M15.8525 2.1364l-2-1.991c-.194-.194-.511-.194-.705 0l-2 1.991c-.196.195-.197.512-.002.707.194.195.512.197.707.002l1.147-1.142 0 11.047c0 1.24-1.009 2.25-2.25 2.25-1.24 0-2.25-1.01-2.25-2.25l0-9.5c0-1.792-1.458-3.25-3.25-3.25-1.792 0-3.25 1.458-3.25 3.25l0 11.037-1.147-1.142c-.194-.195-.512-.193-.707.002-.195.196-.194.512.002.707l1.998 1.99.001 0 .001.001c.003.003.007.003.01.006.044.042.094.077.152.101.061.025.126.038.19.038.065 0 .13-.013.191-.038.058-.024.108-.059.152-.101.003-.003.007-.003.01-.006l0-.001.001 0 1.999-1.99c.196-.195.197-.511.002-.707-.195-.196-.512-.197-.707-.002l-1.148 1.142 0-11.037c0-1.241 1.01-2.25 2.25-2.25 1.241 0 2.25 1.009 2.25 2.25l0 9.5c0 1.792 1.458 3.25 3.25 3.25 1.792 0 3.25-1.458 3.25-3.25l0-11.047 1.148 1.142c.097.097.225.145.352.145.129 0 .257-.049.355-.147.195-.195.194-.512-.002-.707"],"call-swap_20":["M19.8535 3.1465l-3-3c-.195-.195-.512-.195-.707 0l-3 3c-.195.195-.195.512 0 .707.195.195.512.195.707 0l2.146-2.146 0 14.543c0 1.516-1.233 2.75-2.75 2.75-1.516 0-2.75-1.234-2.75-2.75l0-12.5c0-2.068-1.682-3.75-3.75-3.75-2.067 0-3.75 1.682-3.75 3.75l0 14.542-2.146-2.146c-.195-.195-.512-.195-.707 0-.195.195-.195.512 0 .707l3 3c.098.098.226.147.353.147.128 0 .256-.049.354-.147l3-3c.195-.195.195-.512 0-.707-.195-.195-.512-.195-.707 0l-2.147 2.146 0-14.542c0-1.517 1.234-2.75 2.75-2.75 1.517 0 2.75 1.233 2.75 2.75l0 12.5c0 2.067 1.683 3.75 3.75 3.75 2.068 0 3.75-1.683 3.75-3.75l0-14.543 2.147 2.146c.098.098.226.147.353.147.128 0 .256-.049.354-.147.195-.195.195-.512 0-.707"],"call-swap_24":["M23.8535 3.1465l-3-3c-.098-.098-.226-.146-.354-.146-.127 0-.255.048-.353.146l-3 3c-.195.195-.195.512 0 .707.195.195.512.195.707 0l2.146-2.146 0 17.543c0 2.067-1.682 3.75-3.75 3.75-2.067 0-3.75-1.683-3.75-3.75l0-14.5c0-2.62-2.13-4.75-4.75-4.75-2.619 0-4.75 2.13-4.75 4.75l0 17.542-2.146-2.146c-.195-.195-.512-.195-.707 0-.195.195-.195.512 0 .707l3 3c.098.098.226.147.353.147.128 0 .256-.049.354-.147l3-3c.195-.195.195-.512 0-.707-.195-.195-.512-.195-.707 0l-2.147 2.146 0-17.542c0-2.068 1.683-3.75 3.75-3.75 2.068 0 3.75 1.682 3.75 3.75l0 14.5c0 2.619 2.131 4.75 4.75 4.75 2.62 0 4.75-2.131 4.75-4.75l0-17.543 2.147 2.146c.195.195.512.195.707 0 .195-.195.195-.512 0-.707"],"call-swap_28":["M27.8535 4.1465l-4-4c-.098-.098-.226-.146-.354-.146-.127 0-.255.048-.353.146l-4 4c-.195.195-.195.512 0 .707.195.195.512.195.707 0l3.146-3.146 0 21.043c0 2.343-1.906 4.25-4.25 4.25-2.343 0-4.25-1.907-4.25-4.25l0-17.5c0-2.896-2.354-5.25-5.25-5.25-2.895 0-5.25 2.354-5.25 5.25l0 21.042-3.146-3.146c-.195-.195-.512-.195-.707 0-.195.195-.195.512 0 .707l4 4c.098.098.226.147.353.147.128 0 .256-.049.354-.147l4-4c.195-.195.195-.512 0-.707-.195-.195-.512-.195-.707 0l-3.147 3.146 0-21.042c0-2.344 1.907-4.25 4.25-4.25 2.344 0 4.25 1.906 4.25 4.25l0 17.5c0 2.895 2.355 5.25 5.25 5.25 2.896 0 5.25-2.355 5.25-5.25l0-21.043 3.147 3.146c.195.195.512.195.707 0 .195-.195.195-.512 0-.707"],"camera_10":["M8.999 6.6855l-1-1 0-1.37 1-1 0 3.37zm-2 .982c0 .184-.149.333-.334.333l-5.332 0c-.184 0-.333-.149-.333-.333l0-5.334c0-.183.149-.333.333-.333l5.332 0c.185 0 .334.15.334.333l0 5.334zm2.521-5.607c-.291-.122-.625-.056-.848.168l-.673.673 0-.568c0-.735-.599-1.333-1.334-1.333l-5.332 0c-.735 0-1.333.598-1.333 1.333l0 5.334c0 .735.598 1.333 1.333 1.333l5.332 0c.735 0 1.334-.598 1.334-1.333l0-.568.673.673c.149.149.348.228.549.228.1 0 .202-.019.299-.059.291-.121.479-.403.479-.719l0-4.444c0-.315-.188-.597-.479-.718z"],"camera_12":["M1.4998 9.00003c-.276 0-.5-.225-.5-.5l0-6c0-.276.224-.5.5-.5l6.002 0c.276 0 .5.224.5.5l0 6c0 .275-.224.5-.5.5l-6.002 0zm6.002-8l-6.002 0c-.827 0-1.5.673-1.5 1.5l0 6c0 .827.673 1.5 1.5 1.5l6.002 0c.827 0 1.5-.673 1.5-1.5l0-1.321 1.577 1.576c.159.16.371.244.588.244.107 0 .216-.02.319-.063.313-.13.515-.433.515-.771l0-5.333c0-.338-.201-.64-.514-.769-.104-.043-.212-.064-.32-.064-.216 0-.429.084-.588.244l-1.577 1.576 0-1.319c0-.827-.673-1.5-1.5-1.5zm3.499 2.234l0 4.53-1.292-1.292-.707-.708 0-.53.707-.707 1.292-1.293z"],"camera_14":["M13.0034 8.9976l-1.993-1.997 1.993-1.997 0 3.994zm-3.003 1.505c0 .274-.224.497-.497.497l-7.006 0c-.274 0-.497-.223-.497-.497l0-7.005c0-.274.223-.498.497-.498l7.006 0c.273 0 .497.224.497.498l0 7.005zm3.453-6.435c-.333-.137-.712-.062-.961.19l-1.492 1.475 0-2.235c0-.826-.671-1.498-1.497-1.498l-7.006 0c-.826 0-1.497.671-1.497 1.498l0 7.005c0 .826.67 1.497 1.497 1.497l7.006 0c.825 0 1.497-.67 1.497-1.497l0-2.234 1.489 1.472c.17.17.395.259.625.259.114 0 .23-.022.339-.067.332-.138.547-.46.547-.82l0-4.224c0-.36-.215-.682-.547-.821z"],"camera_16":["M15.388 4.088c.372.153.612.514.612.915l0 5.994c0 .402-.24.761-.611.914-.123.052-.253.076-.381.076-.256 0-.509-.099-.699-.29l-2.305-2.305L12 9.379l0 2.612C12 13.101 11.098 14 9.992 14l-7.983 0C.899 14 0 13.098 0 11.991l0-7.982C0 2.9.902 2 2.009 2l7.983 0C11.101 2 12 2.902 12 4.009l0 2.602 2.309-2.308c.284-.283.707-.367 1.079-.215zM12.026 8l2.99 2.99L15 5.003 12.026 8zM1 11.9914698C1 12.5469054 1.45267418 13 2.0085302 13l7.9829396 0C10.5469054 13 11 12.5473258 11 11.9914698l0-7.9829396C11 3.45309463 10.5473258 3 9.9914698 3L2.0085302 3C1.45309463 3 1 3.45267418 1 4.0085302l0 7.9829396z"],"camera_18":["M17 12.4264l-.12.05-3.38-3.381 0-.195 3.38-3.381.12.05 0 6.857zm-4.5 1.073c0 .553-.449 1-1 1l-9.5 0c-.551 0-1-.447-1-1l0-9c0-.552.449-1 1-1l9.5 0c.551 0 1 .448 1 1l0 9zm4.839-8.92c-.401-.164-.859-.075-1.166.233L13.5 7.4854l0-2.986c0-1.102-.897-2-2-2l-9.5 0c-1.103 0-2 .898-2 2l0 9c0 1.104.897 2 2 2l9.5 0c1.103 0 2-.896 2-2l0-2.989 2.673 2.673c.205.205.477.314.756.314.137 0 .277-.027.41-.082.402-.167.661-.554.661-.989l0-6.857c0-.435-.259-.823-.661-.99z"],"camera_20":["M19.004 13.855c0 .081-.047.117-.087.134-.049.022-.1.012-.141-.03L15 10.127l0-.255 3.776-3.831c.041-.042.091-.054.141-.031.04.017.087.053.087.134l0 7.711zM14 14.497c0 .826-.677 1.503-1.494 1.503L2.493 16C1.67 16 1 15.327 1 14.497l0-8.994C1 4.677 1.676 4 2.493 4l10.013 0C13.33 4 14 4.673 14 5.503l0 8.994zm5.296-9.412c-.425-.175-.906-.077-1.228.252L15 8.451l0-2.948C15 4.122 13.883 3 12.506 3L2.493 3C1.127 3 0 4.121 0 5.503l0 8.994C0 15.878 1.116 17 2.493 17l10.013 0C13.872 17 15 15.879 15 14.497l0-2.949 3.068 3.114c.216.22.505.337.799.337.145 0 .289-.028.429-.085.428-.176.704-.592.704-1.059l0-7.711c0-.467-.276-.883-.704-1.059z"],"camera_24":["M22.0014897 15.8555c0 .079-.0479477.116-.0879041.133-.0409553.016-.099891.023-.15583-.031l-3.7758808-3.781 0-.353 3.7758808-3.78c.055939-.056.1168725-.047.15583-.031.0399564.016.0879041.053.0879041.132l0 7.711zm-5.0185252 1.622c0 .84-.6832547 1.523-1.5213404 1.523l-11.94197237 0c-.83808573 0-1.52034145-.683-1.52034145-1.523l0-10.955c0-.839.68225572-1.522 1.52034145-1.522l11.94197237 0c.8380857 0 1.5213404.683 1.5213404 1.522l0 10.955zm5.3122048-10.389c-.4255357-.177-.9150018-.081-1.2436433.247l-3.0696512 3.074 0-3.887c0-1.391-1.1307665-2.522-2.5202507-2.522l-11.94197237 0C2.13016753 4.0005 1.0004 5.1315 1.0004 6.5225l0 10.955c0 1.391 1.12976753 2.523 2.51925173 2.523l11.94197237 0c1.3894842 0 2.5202507-1.132 2.5202507-2.523l0-3.887 3.0686523 3.074c.2197603.218.5104432.336.8061206.336.1478388 0 .2966764-.03.4385216-.088.4285326-.178.7052307-.593.7052307-1.057l0-7.711c0-.464-.2766981-.879-.7052307-1.056z"],"camera_26":["M24.002 17.779c0 .129-.086.185-.138.205-.051.023-.15.044-.242-.048l-4.62-4.62 0-.629 4.62-4.621c.093-.091.192-.07.242-.048.052.021.138.076.138.205l0 9.556zm-6 1.556c0 .919-.747 1.667-1.666 1.667l-12.669 0c-.919 0-1.667-.748-1.667-1.667L2 6.667C2 5.748 2.748 5 3.667 5l12.669 0c.919 0 1.666.748 1.666 1.667l0 12.668zm6.245-12.241c-.46-.192-.982-.086-1.332.265l-3.913 3.914 0-4.606C19.002 5.196 17.806 4 16.336 4L3.667 4C2.196 4 1 5.196 1 6.667l0 12.668c0 1.47 1.196 2.667 2.667 2.667l12.669 0c1.47 0 2.666-1.197 2.666-2.667l0-4.605 3.913 3.913c.234.235.546.359.863.359.158 0 .317-.031.469-.094.459-.19.755-.633.755-1.129l0-9.556c0-.496-.296-.939-.755-1.129z"],"camera_28":["M26.002 18.7251c0 .168-.12.235-.171.257-.052.021-.184.057-.303-.061L21 14.3931l0-.781 4.528-4.528c.119-.118.251-.082.303-.061.051.022.171.089.171.257l0 9.445zM20 20.0071c0 1.099-.894 1.993-1.994 1.993l-14.012 0c-1.096 0-1.994-.9-1.994-1.993l0-12.014c0-1.1.895-1.993 1.994-1.993l14.012 0c1.097 0 1.994.9 1.994 1.993l0 12.014zm6.213-11.907c-.479-.198-1.025-.09-1.392.277L21 12.1981l0-4.205c0-1.64-1.341-2.993-2.994-2.993l-14.012 0c-1.65 0-2.994 1.34-2.994 2.993l0 12.014c0 1.64 1.341 2.993 2.994 2.993l14.012 0c1.65 0 2.994-1.34 2.994-2.993l0-4.199 3.821 3.82c.244.245.57.375.902.375.165 0 .331-.032.49-.097.479-.199.789-.662.789-1.181l0-9.445c0-.518-.31-.982-.789-1.18z"],"camera_32":["M29.999 21.6079c0 .241-.184.336-.24.359-.056.023-.253.087-.424-.085L24 16.5699l0-1.141 5.335-5.312c.171-.169.368-.106.424-.084.056.023.24.117.24.359l0 11.216zM23 23.9989c0 1.109-.892 2.001-2.007 2.001l-16.986 0c-1.11 0-2.007-.896-2.007-2.001l0-15.997c0-1.109.892-2.002 2.007-2.002l16.986 0c1.11 0 2.007.896 2.007 2.002l0 15.997zm7.142-14.89c-.529-.218-1.109-.104-1.513.3L24 14.0179l0-6.016c0-1.659-1.346-3.002-3.007-3.002l-16.986 0C2.336 4.9999 1 6.3439 1 8.0019l0 15.997c0 1.658 1.346 3.001 3.007 3.001l16.986 0c1.671 0 3.007-1.344 3.007-3.001l0-6.017 4.628 4.607c.268.27.616.411.973.411.18 0 .363-.037.541-.11.528-.219.857-.71.857-1.282l0-11.216c0-.572-.329-1.064-.857-1.283z"],"camera_36":["M34 24.4971c0 .311-.236.433-.309.463-.072.029-.325.11-.545-.109L27 18.7091l0-1.417 6.146-6.141c.22-.221.473-.139.545-.11.073.03.309.152.309.463l0 12.993zm-8 2c0 1.383-1.121 2.503-2.507 2.503l-18.986 0c-1.382 0-2.507-1.125-2.507-2.503l0-16.995c0-1.382 1.121-2.502 2.507-2.502l18.986 0c1.382 0 2.507 1.124 2.507 2.502l0 16.995zm8.073-16.379c-.573-.237-1.198-.111-1.634.325L27 15.8791l0-6.377c0-1.927-1.57-3.502-3.507-3.502l-18.986 0C2.568 6.0001 1 7.5681 1 9.5021l0 16.995c0 1.928 1.57 3.503 3.507 3.503l18.986 0c1.939 0 3.507-1.568 3.507-3.503l0-6.375 5.439 5.435c.29.291.665.443 1.052.443.195 0 .392-.038.582-.117.572-.237.927-.767.927-1.386l0-12.993c0-.619-.355-1.15-.927-1.386z"],"camera_8":["M7 4.626L6.352 4 7 3.374l0 1.252zM5.009 6C5 6 5 6.001 5 6.009L5 6 1 6l0 .009C1 6.001 1 6 .991 6L1 6l0-4-.009 0C1 2 1 2 1 1.991L1 2l4 0 0-.009C5 2 5 2 5.009 2L5 2l0 4 .009 0zm2.554-3.941c-.268-.115-.578-.058-.79.144l-.774.763 0-.015L6 2.95l0-.959C6 1.451 5.557 1 5.009 1L.991 1C.451 1 0 1.443 0 1.991l0 4.018C0 6.549.443 7 .991 7l4.018 0C5.549 7 6 6.557 6 6.009l0-.959-.001-.001L6 5.05l.774.747c.138.133.319.203.503.203.097 0 .194-.019.286-.059.266-.112.437-.37.437-.656l0-2.57c0-.286-.171-.544-.437-.656z"],"camera-aux_16":["M15.388 4.088c.372.153.612.514.612.915l0 5.994c0 .402-.24.761-.611.914-.123.052-.253.076-.381.076-.256 0-.509-.099-.699-.29l-2.305-2.305L12 9.379l0 2.612C12 13.101 11.098 14 9.992 14l-7.983 0C.899 14 0 13.098 0 11.991l0-7.982C0 2.9.902 2 2.009 2l7.983 0C11.101 2 12 2.902 12 4.009l0 2.602 2.309-2.308c.284-.283.707-.367 1.079-.215zM12.026 8l2.99 2.99L15 5.003 12.026 8zM1 11.9914698C1 12.5469054 1.45267418 13 2.0085302 13l7.9829396 0C10.5469054 13 11 12.5473258 11 11.9914698l0-7.9829396C11 3.45309463 10.5473258 3 9.9914698 3L2.0085302 3C1.45309463 3 1 3.45267418 1 4.0085302l0 7.9829396zM6 11c-1.65685425 0-3-1.34314575-3-3 0-1.65685425 1.34314575-3 3-3 1.65685425 0 3 1.34314575 3 3 0 1.65685425-1.34314575 3-3 3zm0-1c1.1045695 0 2-.8954305 2-2 0-1.1045695-.8954305-2-2-2-1.1045695 0-2 .8954305-2 2 0 1.1045695.8954305 2 2 2z"],"camera-aux_24":["M22.3246 7.0878c.419.174.69.579.69 1.032l0 7.76c0 .454-.271.859-.691 1.034-.14.058-.286.086-.431.086-.291 0-.576-.114-.791-.329l-3.102-3.097 0 3.926c0 1.379-1.121 2.5-2.5 2.5l-12 0c-1.378 0-2.5-1.121-2.5-2.5l0-11c0-1.379 1.122-2.5 2.5-2.5l12 0c1.379 0 2.5 1.121 2.5 2.5l0 3.924 3.102-3.096c.322-.321.802-.417 1.223-.24zm-.31 8.792l0-7.76c0-.052-.025-.089-.074-.109-.05-.018-.094-.011-.133.026l-3.808 3.802 0 .322 3.808 3.802c.039.039.084.047.133.027.049-.02.074-.057.074-.11zm-5.015 1.62l0-11c0-.827-.672-1.5-1.5-1.5l-12 0c-.827 0-1.5.673-1.5 1.5l0 11c0 .827.673 1.5 1.5 1.5l12 0c.828 0 1.5-.673 1.5-1.5zM9.5 7.9999c2.209 0 4 1.791 4 4 0 2.209-1.791 4-4 4-2.209 0-4-1.791-4-4 0-2.209 1.791-4 4-4zm0 1c-1.654 0-3 1.346-3 3 0 1.654 1.346 3 3 3 1.654 0 3-1.346 3-3 0-1.654-1.346-3-3-3z"],"camera-group_16":["M15.388 5.088c.372.153.612.514.612.915l0 5.994c0 .402-.24.761-.611.914-.123.052-.253.076-.381.076-.256 0-.509-.099-.699-.29l-2.305-2.305-.004-.013 0 2.612C12 14.101 11.098 15 9.992 15l-7.983 0C.899 15 0 14.098 0 12.991l0-7.982C0 3.9.902 3 2.009 3l7.983 0C11.101 3 12 3.902 12 5.009l0 2.602 2.309-2.308c.284-.283.707-.367 1.079-.215zM12.026 9l2.99 2.99L15 6.003 12.026 9zM1 12.9914698C1 13.5469054 1.45267418 14 2.0085302 14l7.9829396 0C10.5469054 14 11 13.5473258 11 12.9914698l0-7.9829396C11 4.45309463 10.5473258 4 9.9914698 4L2.0085302 4C1.45309463 4 1 4.45267418 1 5.0085302l0 7.9829396zM8.6859 9.409c.077.124.139.263.162.426l.137 1c.084.609-.302 1.165-.811 1.165l-3.993 0c-.618 0-1.088-.556-.986-1.165l.167-1c.029-.169.109-.312.208-.44-.352-.36-.57-.852-.57-1.395 0-1.104.896-2 2-2 .809 0 1.501.482 1.816 1.172.206-.106.436-.172.684-.172.829 0 1.5.671 1.5 1.5 0 .343-.12.656-.314.909zM7.0029 11l.994 0c0-.009-.001-.019-.002-.028L7.8609 10l-.715 0-.141.972c-.001.009-.002.019-.002.028zm-2.822 0l1.638 0-.168-1-1.302 0-.168 1zm.819-4c-.551 0-1 .449-1 1 0 .551.449 1 1 1 .551 0 1-.449 1-1 0-.551-.449-1-1-1zm2.5 1c-.276 0-.5.224-.5.5 0 .276.224.5.5.5.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5z"],"camera-group_24":["M22.2947693 7.088C22.7233019 7.265 23 7.68 23 8.144l0 7.711c0 .464-.2766981.879-.7052307 1.057-.1418452.058-.2906828.088-.4385216.088-.2956774 0-.5863603-.118-.8061206-.336l-3.0686523-3.074 0 3.887c0 1.391-1.1307665 2.523-2.5202507 2.523L3.51925173 20C2.12976753 20 1 18.868 1 17.477L1 6.522C1 5.131 2.12976753 4 3.51925173 4L15.4612241 4c1.3894842 0 2.5202507 1.131 2.5202507 2.522l0 3.887 3.0696512-3.074c.3286415-.328.8181076-.424 1.2436433-.247zm-.2936796 8.767l0-7.711c0-.079-.0479477-.116-.0879041-.132-.0389575-.016-.099891-.025-.15583.031l-3.7758808 3.78 0 .353 3.7758808 3.781c.055939.054.1148747.047.15583.031.0399564-.017.0879041-.054.0879041-.133zm-5.0185252 1.622l0-10.955c0-.839-.6832547-1.522-1.5213404-1.522L3.51925173 5c-.83808573 0-1.52034145.683-1.52034145 1.522l0 10.955c0 .84.68225572 1.523 1.52034145 1.523l11.94197237 0c.8380857 0 1.5213404-.683 1.5213404-1.523zm-3.3023974-4.427c.5683799.116 1.0248819.548 1.1237741 1.141l.1897929 1.233c.021976.144-.0199782.291-.1138758.401-.0958954.112-.2347439.175-.3795859.175l-4.24836539 0-.0679259 0-5.45005448 0c-.21576462 0-.4175445-.099-.55439521-.27-.14284417-.178-.19578641-.412-.14484199-.638l.25472212-1.24c.17980385-.789.69823829-1.397 1.36151471-1.679-.40256084-.444-.65528514-1.027-.65528514-1.673 0-1.378 1.12077733-2.5 2.4972757-2.5 1.37649836 0 2.4972757 1.122 2.4972757 2.5 0 .646-.25172539 1.229-.65528515 1.673.30566655.13.58036688.326.80512169.58-.09489648-.233-.14983654-.486-.14983654-.753 0-1.103.89602252-2 1.99782058-2 1.101798 0 1.9978205.897 1.9978205 2 0 .386-.1148746.744-.3056665 1.05zM10.93216491 15l2.98574279 0-.099891-.65c-.032964-.201-.2097711-.35-.4185434-.35l-2.67308391 0 .20577552 1zm-5.66681802-.937L5.07355612 15l4.8387214 0-.1937886-.947C9.57764257 13.438 9.08018525 13 8.5118053 13l-2.03777697 0c-.56837995 0-1.06583727.438-1.20868144 1.063zM7.49291682 9c-.8260988 0-1.49836542.673-1.49836542 1.5 0 .827.67226662 1.5 1.49836542 1.5.8260988 0 1.49836542-.673 1.49836542-1.5 0-.827-.67226662-1.5-1.49836542-1.5zm4.49509628 2c-.5503996 0-.9989103.449-.9989103 1 0 .551.4485107 1 .9989103 1 .5503995 0 .9989103-.449.9989103-1 0-.551-.4485108-1-.9989103-1z"],"camera-muted_12":["M11.0004165 7.775L9.23115369 6.004l1.76926281-1.768 0 3.539zM7.4968763 9L2.70587255 9l5.2907955-5.293 0 4.793c0 .275-.2239067.5-.49979175.5zM1.99916701 3.5c0-.276.22490629-.5.49979176-.5l4.79100375 0-5.29079551 5.293 0-4.793zm9.48604749-.436c-.3128696-.13-.6687214-.059-.9076218.181L8.99625156 4.827l0-1.327c0-.231-.05697626-.447-.14993752-.642l1.00358184-1.004c.19491882-.196.19491882-.512 0-.707-.19591837-.196-.51178676-.196-.70670554 0L8.1396085 2.15C7.94369013 2.057 7.72778009 2 7.4968763 2L2.49895877 2C1.67230321 2 .999583507 2.672.999583507 3.5l0 2.5 0 2.5c0 .231.056976263.447.150937113.643L.146938776 10.147c-.1959183678.195-.1959183678.511 0 .707.0969596.097.224906289.146.352852977.146.127946689 0 .255893378-.049.353852562-.146L1.85722616 9.85c.19491878.093.41082882.15.64173261.15l4.99791753 0c.82665556 0 1.49937526-.673 1.49937526-1.5l0-1.317 1.58134114 1.583c.1589337.16.371845.244.5877551.244.1069554 0 .2169096-.02.3198667-.063C11.7980841 8.817 12 8.515 12 8.176l0-4.342c0-.338-.2019159-.641-.5147855-.77z"],"camera-muted_14":["M13.0034 8.9976l-1.993-1.997 1.993-1.997 0 3.994zm-3.5 2.002l-6.796 0 7.293-7.293 0 6.796c0 .274-.224.497-.497.497zm-7.503-7.502c0-.274.223-.498.497-.498l6.796 0-7.293 7.293 0-6.795zm11.453.57c-.333-.137-.712-.062-.961.19l-1.492 1.475 0-2.235c0-.23-.057-.446-.15-.641l1.003-1.003c.195-.195.195-.512 0-.707-.195-.195-.512-.195-.707 0l-1.003 1.003c-.195-.093-.41-.15-.64-.15l-7.006 0c-.826 0-1.497.671-1.497 1.498l0 7.005c0 .23.056.446.149.641l-1.003 1.003c-.195.195-.195.512 0 .707.098.098.226.146.354.146.128 0 .255-.048.353-.146l1.003-1.003c.195.093.41.149.641.149l7.006 0c.825 0 1.497-.67 1.497-1.497l0-2.234 1.489 1.472c.17.17.395.259.625.259.114 0 .23-.022.339-.067.332-.138.547-.46.547-.82l0-4.224c0-.36-.215-.682-.547-.821z"],"camera-muted_16":["M12.0259 8l2.974-2.997.016 5.987-2.99-2.99zm-2.035 5l-7.284 0 8.293-8.293 0 7.284c0 .556-.453 1.009-1.009 1.009zm-8.991-1.009l0-7.982c0-.556.453-1.009 1.009-1.009l7.982 0c.354 0 .651.194.831.471l-9.351 9.351c-.277-.18-.471-.477-.471-.831zm14.388-7.903c-.372-.152-.795-.068-1.079.215l-2.309 2.309 0-2.603c0-.094-.015-.184-.028-.275l.877-.877c.196-.195.196-.511 0-.707-.195-.195-.511-.195-.707 0l-.598.599c-.369-.453-.924-.749-1.553-.749l-7.982 0c-1.107 0-2.009.899-2.009 2.009l0 7.982c0 .628.296 1.184.749 1.553l-.602.602c-.196.196-.196.512 0 .708.097.097.225.146.353.146.128 0 .256-.049.354-.146l.881-.881c.09.011.18.027.274.027l7.982 0c1.107 0 2.009-.899 2.009-2.009l0-2.603 2.309 2.309c.19.191.443.29.699.29.128 0 .258-.024.381-.076.371-.153.611-.513.611-.914l0-5.994c0-.402-.24-.762-.612-.915z"],"camera-muted_20":["M19.0050447 13.855c0 .081-.0459517.117-.0859098.134-.0489486.022-.0998951.012-.141851-.03l-3.7930174-3.852 0-.217 3.7930174-3.849c.0419559-.042.0919035-.054.141851-.031.0399581.017.0859098.053.0859098.134l0 7.711zm-5.0197293.647c0 .828-.6722941 1.5-1.4984266 1.5l-9.7637481 0 11.1183258-11.13c.0899056.192.1438489.405.1438489.63l0 9zM1.60831127 15.704c-.367614-.274-.609360169-.708-.609360169-1.202l0-9c0-.827.671295139-1.5 1.498426649-1.5l9.98951105 0c.2347535 0 .4555217.06.6543129.158L1.60831127 15.704zM19.2967384 5.085c-.4235552-.175-.9040507-.077-1.2267119.252l-3.08576 3.133 0-2.968c0-.504-.1528395-.972-.4095699-1.364l1.2836521-1.284c.1947955-.196.1947955-.512 0-.707-.1957944-.196-.5114629-.196-.7062584 0l-1.2776585 1.278c-.3965835-.266-.8740822-.423-1.387543-.423l-9.98951105 0C1.11782628 3.002 0 4.122 0 5.502l0 9c0 .77.354627641 1.451.902052845 1.909l-.73422906.736c-.1957944158.195-.1957944158.511 0 .707.096898257.097.224763998.146.352629739.146.127865741 0 .255731482-.049.35362869-.146l.952000396-.954c.21577344.06.43654163.102.67129514.102l9.98951105 0c1.3785525 0 2.4973777-1.119 2.4973777-2.5l0-2.972 3.08576 3.132c.2157734.22.5044703.337.7991609.337.1438489 0 .2876979-.028.427551-.085C19.7242895 14.738 20 14.322 20 13.855l0-7.711c0-.467-.2757105-.883-.7032616-1.059z"],"camera-muted_24":["M22.0010532 15.855c0 .079-.0479494.116-.0879073.133-.0409568.016-.0998947.023-.1558357-.031l-3.7760187-3.781 0-.353 3.7760187-3.78c.055941-.056.1168768-.047.1558357-.031.0399579.016.0879073.053.0879073.132l0 7.711zm-5.0187085 1.622c0 .84-.6832796 1.523-1.5213959 1.523L3.51854023 19c-.23675038 0-.45851656-.059-.65830591-.157L16.3719882 5.311c.3676124.278.6103565.715.6103565 1.211l0 10.955zm-14.98420144 0l0-10.955c0-.839.68228064-1.522 1.52039697-1.522L15.269151 5 2.15397896 18.136c-.09689784-.2-.1558357-.422-.1558357-.659zM22.2947436 7.088c-.4255513-.177-.9150352-.081-1.2436887.247l-3.0697634 3.074 0-3.887c0-.772-.3556251-1.456-.9040469-1.919l.7492101-.749c.1947946-.196.1947946-.512 0-.707-.1957935-.196-.5114607-.196-.7062553 0l-.9629847.963c-.2227652-.064-.4525229-.11-.6962659-.11L3.51854023 4C2.12900529 4 .999196499 5.131.999196499 6.522l0 10.955c0 .515.155835691.993.421555531 1.393L.146095964 20.147c-.1947946187.195-.1947946187.511 0 .707.097896783.097.225761968.146.353627154.146.127865186 0 .255730371-.049.353627154-.146l1.273657118-1.277c.39957871.266.87707526.423 1.39153284.423l11.94240857 0c1.3895349 0 2.5203427-1.132 2.5203427-2.523l0-3.887 3.0687644 3.074c.2197683.218.5104618.336.8061501.336.1478441 0 .2966871-.03.4385376-.088C22.7232917 16.734 23 16.319 23 15.855l0-7.711c0-.464-.2767083-.879-.7052564-1.056z"],"camera-muted_28":["M26.002 18.7252c0 .168-.12.235-.171.257-.052.021-.185.057-.303-.061L21 14.3932l0-.781 4.528-4.528c.118-.118.251-.082.303-.061.051.022.171.089.171.257l0 9.445zM20 20.0072c0 1.099-.894 1.993-1.994 1.993l-14.012 0c-.089 0-.174-.015-.261-.027l15.519-15.52c.452.366.748.918.748 1.539l0 12.015zm-18 0l0-12.015c0-1.099.894-1.992 1.994-1.992l14.012 0c.088 0 .173.015.259.026l-15.518 15.52c-.451-.367-.747-.918-.747-1.539zm24.213-11.907c-.479-.198-1.026-.09-1.392.277L21 12.1982l0-4.206c0-.895-.408-1.696-1.041-2.246l1.892-1.893c.196-.195.196-.512 0-.707-.195-.195-.511-.195-.707 0l-2.062 2.063c-.335-.13-.696-.209-1.076-.209l-14.012 0C2.343 5.0002 1 6.3402 1 7.9922l0 12.015c0 .895.408 1.695 1.04 2.246l-1.894 1.893c-.195.196-.195.512 0 .707.196.196.512.196.708 0l2.062-2.063c.336.131.697.21 1.078.21l14.012 0c1.651 0 2.994-1.34 2.994-2.993l0-4.199 3.821 3.82c.244.245.57.375.902.375.165 0 .331-.032.49-.097.479-.199.789-.662.789-1.181l0-9.445c0-.518-.31-.982-.789-1.18z"],"camera-muted_32":["M29.999 21.6079c0 .241-.185.336-.24.359-.057.023-.253.087-.424-.085l-5.336-5.312 0-1.141 5.336-5.312c.171-.169.367-.106.424-.084.055.023.24.117.24.359l0 11.216zm-7 2.391c0 1.109-.892 2.001-2.007 2.001l-16.985 0c-.094 0-.183-.015-.273-.027l18.982-18.982c.176.298.283.64.283 1.011l0 15.997zm-21 0l0-15.997c0-1.109.893-2.002 2.008-2.002l16.985 0c.373 0 .718.108 1.017.284L2.747 25.5459c-.453-.367-.748-.92-.748-1.547zm28.143-14.89c-.53-.218-1.11-.104-1.513.3l-4.63 4.609 0-6.016c0-.648-.21-1.244-.56-1.735l2.414-2.413c.196-.196.196-.512 0-.707-.195-.196-.511-.196-.707 0l-2.414 2.414c-.492-.35-1.089-.561-1.74-.561l-16.985 0c-1.671 0-3.008 1.344-3.008 3.002l0 15.997c0 .903.408 1.704 1.041 2.254l-1.894 1.894c-.195.195-.195.511 0 .707.098.097.226.146.354.146.128 0 .256-.049.353-.146l2.065-2.064c.338.131.703.21 1.089.21l16.985 0c1.671 0 3.007-1.344 3.007-3.001l0-6.017 4.629 4.607c.267.27.615.411.973.411.179 0 .363-.037.541-.11.528-.219.857-.71.857-1.282l0-11.216c0-.572-.329-1.064-.857-1.283z"],"camera-muted_36":["M34.0006 24.498c0 .311-.236.433-.309.463-.072.029-.325.11-.545-.109l-6.146-6.142 0-1.417 6.146-6.141c.22-.221.473-.139.545-.11.073.03.309.152.309.463l0 12.993zm-8 2c0 1.383-1.121 2.503-2.507 2.503l-18.986 0c-.241 0-.47-.045-.691-.109l21.29-21.288c.542.46.894 1.136.894 1.899l0 16.995zm-24 0l0-16.995c0-1.382 1.121-2.502 2.507-2.502l18.986 0c.242 0 .471.045.693.109l-21.29 21.288c-.543-.46-.896-1.136-.896-1.9zm32.073-16.379c-.573-.237-1.198-.111-1.634.325l-5.439 5.436 0-6.377c0-1.038-.464-1.963-1.187-2.606l2.044-2.044c.196-.195.196-.511 0-.707-.195-.195-.511-.195-.707 0l-2.187 2.188c-.448-.209-.943-.333-1.47-.333l-18.986 0c-1.939 0-3.507 1.568-3.507 3.502l0 16.995c0 1.039.465 1.965 1.188 2.607l-2.042 2.043c-.196.195-.196.512 0 .707.097.098.225.146.353.146.128 0 .256-.048.354-.146l2.186-2.186c.448.208.942.332 1.468.332l18.986 0c1.939 0 3.507-1.568 3.507-3.503l0-6.375 5.439 5.435c.29.291.665.443 1.052.443.195 0 .392-.038.582-.117.572-.237.927-.767.927-1.386l0-12.993c0-.619-.355-1.15-.927-1.386z"],"camera-muted_8":["M7 4.626L6.352 4 7 3.374l0 1.252zM5.009 6C5 6 5 6.001 5 6.009L5 6 1.707 6 5 2.707 5 6l.009 0zM.991 2C1 2 1 2 1 1.991L1 2l3.293 0L1 5.293 1 2 .991 2zM1 6.009C1 6.001 1 6 .991 6L1 6l0 .009zm4-4.018C5 2 5 2 5.009 2L5 2l0-.009zm2.563.068c-.268-.115-.578-.058-.79.144l-.774.763 0-.015L6 2.95l0-.959C6 1.451 5.557 1 5.009 1L.991 1C.451 1 0 1.443 0 1.991l0 4.018C0 6.549.443 7 .991 7l4.018 0C5.549 7 6 6.557 6 6.009l0-.959-.001-.001L6 5.05l.774.747c.138.133.319.203.503.203.097 0 .194-.019.286-.059.266-.112.437-.37.437-.656l0-2.57c0-.286-.171-.544-.437-.656z"],"camera-photo_16":["M14 3c1.103 0 2 .897 2 2l0 8c0 1.103-.897 2-2 2L2 15c-1.103 0-2-.897-2-2l0-8c0-1.103.897-2 2-2l1.293 0 1.268-1.268C5.033 1.26 5.66 1 6.328 1l3.344 0c.668 0 1.295.26 1.767.732L12.708 3 14 3zm1 10l0-8c0-.551-.448-1-1-1l-1.292 0c-.267 0-.519-.104-.707-.293l-1.269-1.268C10.453 2.16 10.066 2 9.672 2L6.328 2c-.394 0-.781.16-1.06.439L4 3.707c-.188.189-.44.293-.707.293L2 4c-.552 0-1 .449-1 1l0 8c0 .551.448 1 1 1l12 0c.552 0 1-.449 1-1zM8 5c2.209 0 4 1.791 4 4 0 2.209-1.791 4-4 4-2.209 0-4-1.791-4-4 0-2.209 1.791-4 4-4zm0 7c1.654 0 3-1.346 3-3 0-1.654-1.346-3-3-3-1.654 0-3 1.346-3 3 0 1.654 1.346 3 3 3z"],"camera-photo_20":["M17.6 3.9996c1.323 0 2.4 1.078 2.4 2.401l0 9.199c0 1.323-1.077 2.4-2.4 2.4l-15.2 0c-1.323 0-2.4-1.077-2.4-2.4l0-9.199c0-1.323 1.077-2.401 2.4-2.401l2.186 0c.131 0 .26-.053.353-.146l1.268-1.268c.372-.372.888-.586 1.415-.586l4.756 0c.527 0 1.043.214 1.415.586l1.268 1.268c.093.093.222.146.353.146l2.186 0zm1.4 11.6l0-9.199c0-.773-.628-1.401-1.4-1.401l-2.186 0c-.4 0-.777-.156-1.06-.439l-1.268-1.268c-.186-.186-.444-.293-.708-.293l-4.756 0c-.264 0-.522.107-.708.293l-1.268 1.268c-.283.283-.66.439-1.06.439l-2.186 0c-.772 0-1.4.628-1.4 1.401l0 9.199c0 .772.628 1.4 1.4 1.4l15.2 0c.772 0 1.4-.628 1.4-1.4zM10 7c2.206 0 4 1.795 4 4 0 2.205-1.794 4-4 4-2.206 0-4-1.795-4-4 0-2.205 1.794-4 4-4zm0 7c1.654 0 3-1.346 3-3 0-1.654-1.346-3-3-3-1.654 0-3 1.346-3 3 0 1.654 1.346 3 3 3zm6.5-7c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5z"],"camera-photo_24":["M21.5072077 5.00949525C22.8820932 5.01249375 24 6.13393303 24 7.50824588l0 11.99400302c0 .6666666-.2599783 1.2943528-.731939 1.7661169C22.7961003 21.7401299 22.1681527 22 21.5012082 22l-.0009999 0-19.00141653-.0069965C1.12090659 21.992004 0 20.8715642 0 19.4942529L0 7.50024988c0-1.37831085 1.12090659-2.49875063 2.49979168-2.49875063l2.08482627 0c.13398883 0 .25897842-.05197401.3539705-.14592704l2.13682193-2.127936028C7.54737105 2.258870565 8.17431881 2 8.83926339 2l6.32647281 0c.6679443 0 1.295892.260869565 1.7678527.732633683l2.1248229 2.123938027c.0929922.09295353.2189818.14592704.3519707.14592704l2.0968252.0069965zM23 19.5018323l0-11.99333702c0-.82454192-.670939-1.49816768-1.4948641-1.49916713l-.0009999 0-2.0978093-.00699611c-.3979638-.00099945-.7719298-.15691283-1.0549041-.43875625l-2.1248068-2.1238201C15.9426416 3.15591338 15.5656758 3 15.1657122 3L8.83928734 3c-.39996364 0-.77592946.15591338-1.05890374.43675736L5.64357786 5.56457524c-.28397419.28084397-.65994001.43675735-1.05890374.43675735l-2.08481047 0C1.67293882 6.00133259 1 6.67395891 1 7.50049972L1 19.4938368c0 .8255413.67293882 1.4981676 1.49886374 1.4991671L21.5001364 21l.0009999 0c.3999636 0 .7759294-.1559134 1.0599036-.4387562C22.8440142 20.2784009 23 19.9016102 23 19.5018323zM12 8c2.757 0 5 2.243 5 5 0 2.757-2.243 5-5 5-2.757 0-5-2.243-5-5 0-2.757 2.243-5 5-5zm0 9c2.206 0 4-1.794 4-4 0-2.206-1.794-4-4-4-2.206 0-4 1.794-4 4 0 2.206 1.794 4 4 4zm8-9c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1z"],"camera-photo_32":["M29 6c1.657 0 3 1.343 3 3l0 18c0 1.657-1.343 3-3 3L3 30c-1.657 0-3-1.343-3-3L0 9c0-1.657 1.343-3 3-3l2 .007 1.153 0c.401 0 .777-.156 1.061-.439l2.504-2.505c.674-.674 1.576-1.06 2.475-1.06l7.514 0c.924-.044 1.842.364 2.503 1.025l2.539 2.54c.28.279.666.439 1.061.439l1.19 0L29 6zm2 21l0-18c0-1.103-.897-2-2-2l-3.19.007c-.667 0-1.295-.26-1.768-.732l-2.539-2.54c-.472-.472-1.13-.747-1.791-.732l-7.519 0c-.636 0-1.28.28-1.768.767L7.921 6.275c-.472.472-1.1.732-1.768.732L3 7c-1.103 0-2 .897-2 2l0 18c0 1.103.897 2 2 2l26 0c1.103 0 2-.897 2-2zm-4-15c-.5522847 0-1-.44771525-1-1 0-.55228475.4477153-1 1-1 .5522847 0 1 .44771525 1 1 0 .55228475-.4477153 1-1 1zm-11.0174-.9371c3.85 0 6.981 3.132 6.981 6.982 0 3.849-3.131 6.981-6.981 6.981-3.85 0-6.981-3.132-6.981-6.981 0-3.85 3.131-6.982 6.981-6.982zm0 12.963c3.298 0 5.981-2.684 5.981-5.981 0-3.298-2.683-5.982-5.981-5.982-3.298 0-5.981 2.684-5.981 5.982 0 3.297 2.683 5.981 5.981 5.981z"],"camera-photo_48":["M43.5 9c2.485 0 4.5 2.015 4.5 4.5l0 26c0 2.485-2.015 4.5-4.5 4.5l-39 0C2.015 44 0 41.985 0 39.5l0-26C0 11.015 2.015 9 4.5 9l5.672 0c.53 0 1.039-.211 1.414-.586l2.657-2.657C15.368 4.632 16.894 4 18.485 4l11.03 0c1.591 0 3.117.632 4.242 1.757l2.657 2.657c.375.375.884.586 1.414.586L43.5 9zM47 39.5l0-26c0-1.93-1.57-3.5-3.5-3.5l-5.672 0c-.801 0-1.554-.312-2.121-.879L33.05 6.464C32.106 5.52 30.85 5 29.515 5l-11.03 0c-1.335 0-2.591.52-3.535 1.464l-2.657 2.657c-.567.567-1.32.879-2.121.879L4.5 10C2.57 10 1 11.57 1 13.5l0 26C1 41.43 2.57 43 4.5 43l39 0c1.93 0 3.5-1.57 3.5-3.5zm-7.71-23.2151c.37-.38 1.04-.38 1.41 0 .19.18.3.44.3.7 0 .27-.11.52-.3.71-.181.19-.44.29-.7.29-.271 0-.521-.1-.71-.29-.19-.19-.29-.44-.29-.71 0-.26.1-.52.29-.7zM24 16c5.523 0 10 4.477 10 10 0 5.523-4.477 10-10 10-5.523 0-10-4.477-10-10 0-5.523 4.477-10 10-10zm0 19c4.963 0 9-4.037 9-9 0-4.963-4.037-9-9-9-4.963 0-9 4.037-9 9 0 4.963 4.037 9 9 9z"],"camera-photo-swap_16":["M11.0073 7.9907c0 1.655-1.343 2.996-3 2.996-1.657 0-3-1.341-3-2.996 0-1.655 1.343-2.996 3-2.996 1.657 0 3 1.341 3 2.996zm-5 0c0 1.103.895 1.998 2 1.998 1.104 0 2-.895 2-1.998 0-1.103-.896-1.998-2-1.998-1.105 0-2 .895-2 1.998zM14.5 10c.275 0 .5.225.5.5l0 2.5c0 1.1-.9 2-2 2L3 15c-1.1 0-2-.9-2-2l0-3.293-.146.147c-.196.195-.512.195-.708 0-.195-.196-.195-.512 0-.708l1-1c.196-.195.512-.195.708 0l1 1c.195.196.195.512 0 .708-.098.097-.226.146-.354.146-.128 0-.256-.049-.354-.146L2 9.707 2 13c0 .552.449 1 1 1l10 0c.551 0 1-.448 1-1l0-2.5c0-.275.225-.5.5-.5zm1.3745-3.8521c.195.195.195.512 0 .707l-1 1c-.195.195-.512.195-.707 0l-1-1c-.195-.195-.195-.512 0-.707.098-.098.226-.146.353-.146.128 0 .256.048.354.146l.125.125 0-3.273c0-.551-.448-1-1-1l-10 0c-.551 0-1 .449-1 1l0 2.5c0 .275-.225.5-.5.5-.274 0-.5-.225-.5-.5l0-2.5c0-1.1.9-2 2-2l10 0c1.101 0 2 .9 2 2l0 3.315.168-.167c.195-.195.512-.195.707 0z"],"camera-swap_16":["M11.0073 7.9907c0 1.655-1.343 2.996-3 2.996-1.657 0-3-1.341-3-2.996 0-1.655 1.343-2.996 3-2.996 1.657 0 3 1.341 3 2.996zm-5 0c0 1.103.895 1.998 2 1.998 1.104 0 2-.895 2-1.998 0-1.103-.896-1.998-2-1.998-1.105 0-2 .895-2 1.998zM14.5 10c.275 0 .5.225.5.5l0 2.5c0 1.1-.9 2-2 2L3 15c-1.1 0-2-.9-2-2l0-3.293-.146.147c-.196.195-.512.195-.708 0-.195-.196-.195-.512 0-.708l1-1c.196-.195.512-.195.708 0l1 1c.195.196.195.512 0 .708-.098.097-.226.146-.354.146-.128 0-.256-.049-.354-.146L2 9.707 2 13c0 .552.449 1 1 1l10 0c.551 0 1-.448 1-1l0-2.5c0-.275.225-.5.5-.5zm1.3745-3.8521c.195.195.195.512 0 .707l-1 1c-.195.195-.512.195-.707 0l-1-1c-.195-.195-.195-.512 0-.707.098-.098.226-.146.353-.146.128 0 .256.048.354.146l.125.125 0-3.273c0-.551-.448-1-1-1l-10 0c-.551 0-1 .449-1 1l0 2.5c0 .275-.225.5-.5.5-.274 0-.5-.225-.5-.5l0-2.5c0-1.1.9-2 2-2l10 0c1.101 0 2 .9 2 2l0 3.315.168-.167c.195-.195.512-.195.707 0z"],"camera-swap_20":["M19.8535 7.1465c.195.195.195.512 0 .707l-2 2c-.195.195-.512.195-.707 0l-2-2c-.195-.195-.195-.512 0-.707.098-.098.226-.146.353-.146.128 0 .256.048.354.146l1.146 1.146 0-3.792c0-.828-.672-1.5-1.5-1.5l-11 0c-.827 0-1.5.672-1.5 1.5l0 3 0 .03-.006 0c-.017.261-.229.47-.494.47-.264 0-.476-.209-.493-.47l-.007 0 0-.03 0-3c0-1.381 1.12-2.5 2.5-2.5l11 0c1.381 0 2.5 1.119 2.5 2.5l0 3.792 1.147-1.146c.195-.195.512-.195.707 0zm-2.3534 4.8534c.275 0 .5.225.5.5l0 3c0 1.381-1.119 2.5-2.5 2.5l-11 0c-1.381 0-2.5-1.119-2.5-2.5l0-3.793-1.147 1.147c-.195.195-.511.195-.707 0-.195-.196-.195-.512 0-.707l2-2c.196-.196.512-.196.707 0l2 2c.196.195.196.511 0 .707-.097.097-.225.146-.353.146-.128 0-.256-.049-.354-.146l-1.146-1.147 0 3.793c0 .827.673 1.5 1.5 1.5l11 0c.827 0 1.5-.673 1.5-1.5l0-3c0-.275.225-.5.5-.5zm-15.005-.788l.01 0-.005-.005-.005.005zM14 10c0 2.209-1.791 4-4 4-2.209 0-4-1.791-4-4 0-2.209 1.791-4 4-4 2.209 0 4 1.791 4 4zm-7 0c0 1.654 1.346 3 3 3 1.654 0 3-1.346 3-3 0-1.654-1.346-3-3-3-1.654 0-3 1.346-3 3z"],"camera-swap_24":["M17 12c0 2.762-2.239 5-5 5-2.761 0-5-2.238-5-5 0-2.762 2.239-5 5-5 2.761 0 5 2.238 5 5zm-9 0c0 2.206 1.794 4 4 4 2.206 0 4-1.794 4-4 0-2.206-1.794-4-4-4-2.206 0-4 1.794-4 4zm15.8538-2.8542c.195.195.195.512 0 .708l-1.997 1.997c-.001.001-.001.003-.003.004-.097.096-.225.145-.354.145-.128 0-.257-.049-.354-.145-.001-.001-.001-.003-.002-.004l-1.998-1.997c-.195-.196-.195-.513 0-.708.195-.195.513-.195.707 0l1.147 1.147 0-5.793c0-.827-.673-1.5-1.5-1.5l-15 0c-.827 0-1.5.673-1.5 1.5l0 5c0 .276-.225.5-.5.5-.275 0-.5-.224-.5-.5l0-5c0-1.381 1.119-2.5 2.5-2.5l15 0c1.381 0 2.5 1.119 2.5 2.5l0 5.793 1.147-1.147c.195-.195.513-.195.707 0zM21.5 14c.275 0 .5.225.5.5l0 5c0 1.381-1.119 2.5-2.5 2.5l-15 0C3.119 22 2 20.881 2 19.5l0-5.793-1.147 1.147c-.194.195-.513.195-.707 0-.195-.194-.195-.512 0-.707l1.998-1.998c.001-.001.001-.003.002-.003.097-.097.226-.146.354-.146.128 0 .257.049.354.146.001 0 .001.002.002.003l1.998 1.998c.195.195.195.513 0 .707-.194.195-.513.195-.707 0L3 13.707 3 19.5c0 .827.673 1.5 1.5 1.5l15 0c.827 0 1.5-.673 1.5-1.5l0-5c0-.275.225-.5.5-.5z"],"cancel_12":["M6.707 6l3.146-3.146c.196-.196.196-.512 0-.708-.195-.195-.511-.195-.707 0L6 5.293 2.853 2.146c-.195-.195-.511-.195-.707 0-.195.196-.195.512 0 .708L5.293 6 2.146 9.146c-.195.196-.195.512 0 .708.098.097.226.146.354.146.128 0 .256-.049.353-.146L6 6.707l3.146 3.147c.098.097.226.146.354.146.128 0 .256-.049.353-.146.196-.196.196-.512 0-.708L6.707 6z"],"cancel_14":["M7.707 7l4.146-4.146c.196-.196.196-.512 0-.708-.195-.195-.511-.195-.707 0L7 6.293 2.853 2.146c-.195-.195-.511-.195-.707 0-.195.196-.195.512 0 .708L6.293 7l-4.147 4.146c-.195.196-.195.512 0 .708.098.097.226.146.354.146.128 0 .256-.049.353-.146L7 7.707l4.146 4.147c.098.097.226.146.354.146.128 0 .256-.049.353-.146.196-.196.196-.512 0-.708L7.707 7z"],"cancel_16":["M8.707 8l5.146-5.146c.196-.196.196-.512 0-.708-.195-.195-.511-.195-.707 0L8 7.293 2.853 2.146c-.195-.195-.511-.195-.707 0-.195.196-.195.512 0 .708L7.293 8l-5.147 5.146c-.195.196-.195.512 0 .708.098.097.226.146.354.146.128 0 .256-.049.353-.146L8 8.707l5.146 5.147c.098.097.226.146.354.146.128 0 .256-.049.353-.146.196-.196.196-.512 0-.708L8.707 8z"],"cancel_18":["M9.707 9l6.146-6.146c.196-.196.196-.512 0-.708-.195-.195-.511-.195-.707 0L9 8.293 2.853 2.146c-.195-.195-.511-.195-.707 0-.195.196-.195.512 0 .708L8.293 9l-6.147 6.146c-.195.196-.195.512 0 .708.098.097.226.146.354.146.128 0 .256-.049.353-.146L9 9.707l6.146 6.147c.098.097.226.146.354.146.128 0 .256-.049.353-.146.196-.196.196-.512 0-.708L9.707 9z"],"cancel_20":["M10.70725 10.00025l7.146-7.146c.196-.196.196-.512 0-.708-.195-.195-.511-.195-.707 0l-7.146 7.147-7.147-7.147c-.195-.195-.511-.195-.707 0-.195.196-.195.512 0 .708l7.147 7.146-7.147 7.146c-.195.196-.195.512 0 .708.098.097.226.146.354.146.128 0 .256-.049.353-.146l7.147-7.147 7.146 7.147c.098.097.226.146.354.146.128 0 .256-.049.353-.146.196-.196.196-.512 0-.708l-7.146-7.146z"],"cancel_24":["M12.707 12l8.146-8.146c.196-.196.196-.512 0-.708-.195-.195-.511-.195-.707 0L12 11.293 3.853 3.146c-.195-.195-.511-.195-.707 0-.195.196-.195.512 0 .708L11.293 12l-8.147 8.146c-.195.196-.195.512 0 .708.098.097.226.146.354.146.128 0 .256-.049.353-.146L12 12.707l8.146 8.147c.098.097.226.146.354.146.128 0 .256-.049.353-.146.196-.196.196-.512 0-.708L12.707 12z"],"cancel_28":["M14.707 14L24.853 3.854c.196-.196.196-.512 0-.708-.195-.195-.511-.195-.707 0L14 13.293 3.853 3.146c-.195-.195-.511-.195-.707 0-.195.196-.195.512 0 .708L13.293 14 3.146 24.146c-.195.196-.195.512 0 .708.098.097.226.146.354.146.128 0 .256-.049.353-.146L14 14.707l10.146 10.147c.098.097.226.146.354.146.128 0 .256-.049.353-.146.196-.196.196-.512 0-.708L14.707 14z"],"cancel_36":["M18.70725 18.00025l13.146-13.146c.196-.196.196-.512 0-.708-.195-.195-.511-.195-.707 0l-13.146 13.147-13.147-13.147c-.195-.195-.511-.195-.707 0-.195.196-.195.512 0 .708l13.147 13.146-13.147 13.146c-.195.196-.195.512 0 .708.098.097.226.146.354.146.128 0 .256-.049.353-.146l13.147-13.147 13.146 13.147c.098.097.226.146.354.146.128 0 .256-.049.353-.146.196-.196.196-.512 0-.708l-13.146-13.146z"],"cancel_6":["M3.7 3L5.8.9C6 .8 6 .6 6 .5s0-.3-.1-.4c-.2-.1-.6-.1-.8 0L3 2.3.9.1C.7 0 .3 0 .1.1 0 .3 0 .7.1.9L2.3 3 .1 5.1c-.1.2-.1.6 0 .8.2.1.6.1.8 0L3 3.7l2.1 2.1c.1.2.3.2.4.2.1 0 .3 0 .4-.1.1-.2.1-.6 0-.8L3.7 3z"],"cancel_8":["M4.707 4L7.853.854c.196-.196.196-.512 0-.708-.195-.195-.511-.195-.707 0L4 3.293.853.146C.658-.049.342-.049.146.146c-.195.196-.195.512 0 .708L3.293 4 .146 7.146c-.195.196-.195.512 0 .708C.244 7.951.372 8 .5 8c.128 0 .256-.049.353-.146L4 4.707l3.146 3.147c.098.097.226.146.354.146.128 0 .256-.049.353-.146.196-.196.196-.512 0-.708L4.707 4z"],"certified_16":["M6.2698 13.5058c.258 0 .51.107.688.302l1.041 1.144 1.043-1.144c.244-.266.622-.369.966-.259l1.475.469.33-1.51c.078-.354.356-.632.709-.709l1.511-.33-.47-1.473c-.109-.344-.008-.724.258-.968l1.144-1.041-1.143-1.042c-.267-.242-.368-.623-.259-.967l.47-1.474-1.511-.33c-.354-.078-.631-.356-.709-.708l-.33-1.511-1.474.469c-.345.108-.724.008-.968-.26l-1.042-1.143-1.04 1.143c-.245.268-.624.37-.968.259l-1.473-.469-.33 1.511c-.078.354-.357.632-.709.708l-1.511.331.469 1.474c.109.343.008.722-.258.966l-1.143 1.043 1.142 1.04c.267.245.368.625.259.968l-.469 1.474 1.511.33c.352.077.631.355.709.707l.33 1.512 1.473-.469c.091-.029.185-.043.279-.043zm1.729 2.48c-.26 0-.51-.11-.685-.302l-1.095-1.202-1.473.513c-.245.078-.519.049-.746-.081-.225-.131-.386-.351-.442-.606l-.347-1.587-1.533-.292c-.255-.056-.476-.218-.606-.444-.13-.226-.159-.497-.079-.745l.491-1.548-1.181-1.019c-.193-.177-.303-.427-.303-.688 0-.26.111-.509.303-.684l1.201-1.095-.512-1.474c-.079-.247-.05-.518.08-.744.13-.226.351-.388.606-.444l1.587-.347.293-1.533c.056-.254.217-.475.442-.606.227-.13.499-.16.747-.08l1.546.492 1.02-1.18c.351-.386 1.022-.386 1.372-.001l1.096 1.202 1.474-.513c.247-.08.52-.049.745.08.226.13.387.352.443.607l.346 1.587 1.534.292c.254.056.474.217.605.442.13.226.16.498.081.746l-.493 1.549 1.181 1.019c.193.176.303.426.303.687 0 .261-.11.511-.303.686l-1.201 1.094.513 1.473c.079.25.049.522-.081.747-.131.225-.351.387-.605.442l-1.588.347-.292 1.532c-.056.255-.217.476-.443.606-.226.13-.497.159-.746.081l-1.548-.493-1.021 1.182c-.175.192-.425.302-.686.302zm-1.1646-4.9997c.128 0 .256-.049.354-.146l4.666-4.667c.195-.195.195-.512 0-.707-.196-.195-.512-.195-.707 0l-4.313 4.313-1.98-1.98c-.196-.195-.512-.195-.708 0-.195.196-.195.512 0 .708l2.334 2.333c.098.097.226.146.354.146z"],"certified_24":["M23.6224 12.8554644l-1.843 1.6769301c-.045.0409983-.063.1059956-.044.1639932l.757 2.373901c.098.3089872.061.647973-.101.9279614-.162.2819882-.437.4829798-.754.5529769l-2.435.5309779c-.059.0139994-.106.0609975-.119.119995l-.532 2.4338986c-.069.3169868-.27.5919753-.55.7549685-.282.1629932-.62.1989917-.93.0999959l-2.375-.7549686c-.058-.0159993-.122-.0009999-.164.0429982l-1.679 1.8429232c-.218.2389901-.53.3779843-.854.3779843l-.001 0c-.325 0-.636-.1379943-.855-.3779843l-1.678-1.8419232c-.041-.0459981-.103-.0609975-.162-.0439982l-2.374.7549686c-.31.0989958-.648.0629973-.93-.0999959-.281-.1629932-.482-.4379817-.551-.7549685l-.532-2.4338986c-.013-.0579976-.06-.1049956-.12-.118995l-2.435-.5319779c-.317-.0699971-.592-.2709887-.754-.551977-.162-.2809883-.199-.6199741-.101-.9289613l.756-2.374901c.018-.0579976.001-.1219949-.044-.1639932l-1.841-1.6759301c-.24-.2189909-.377-.5309779-.377-.8549644 0-.3239865.137-.6359735.377-.8539644l1.841-1.67893008c.045-.04199825.062-.10599559.044-.16399317l-.756-2.37390109c-.098-.30898712-.061-.647973.101-.92896129.162-.28098829.437-.48197992.754-.551977l2.435-.53197784c.06-.01299945.106-.0599975.12-.11899504l.532-2.43489854c.069-.3169868.27-.59097538.551-.75496855.282-.16199325.62-.19699179.93-.09999583l2.373.7559685c.058.01799925.122.00199992.164-.04399817l1.677-1.841923249C11.3624.13799425 11.6734 0 11.9984 0l.001 0c.324 0 .635.13799425.854.376984292l1.68 1.842923208c.041.04499813.106.06199742.164.04399817l2.373-.7559685c.311-.09699596.649-.06199742.931.09999583.28.16399317.481.43798175.55.75496855l.532 2.43489854c.013.05899754.06.10599559.119.11899504l2.435.53197784c.318.06999708.593.27198866.755.55297696.161.28098829.198.61997416.099.92896129l-.756 2.37290113c-.019.05799758-.001.12299487.044.16399317l1.843 1.67793008c0 0 0 .001 0 .001.24.2169909.378.5289779.378.8539644 0 .3239865-.138.6359735-.378.8549644zm-2.516.9369609l1.842-1.6769301c.045-.0399983.052-.0899963.052-.1149952 0-.0259989-.007-.0749969-.052-.1159952l-1.842-1.6779301c-.334-.30498727-.46-.77796756-.323-1.20694968l.755-2.37290113c.019-.05799759 0-.10399567-.013-.12599475-.013-.02199909-.044-.06199742-.103-.07499688l-2.434-.53197783c-.44-.095996-.786-.44298155-.882-.88296321l-.531-2.43489855c-.013-.05799758-.052-.08899629-.075-.10099579-.022-.01299946-.07-.03399858-.126-.01399942l-2.374.7559685c-.431.1369943-.903.00899963-1.206-.32298654l-1.68-1.84292321c-.08-.087996333-.151-.088996292-.232.00099996l-1.677 1.84192325c-.304.33198617-.776.45798092-1.205.32298654l-2.374-.7559685c-.059-.02099912-.104.00099996-.126.01399942-.023.0119995-.062.04299821-.075.10099579l-.533 2.43489855c-.096.43998166-.442.78696721-.883.88296321l-2.434.53197783c-.058.01299946-.089.05299779-.102.07499688-.013.02199908-.032.06799716-.013.12599475l.755 2.37390108c.136.42898213.009.90096246-.323 1.20494983l-1.841 1.67893c-.045.0409983-.051.0909962-.051.1159952 0 .0249989.006.0749969.051.1159951l1.841 1.6759302c.332.3049873.459.7769676.323 1.2059498l-.755 2.374901c-.019.0579976 0 .1039957.013.1259948.013.021999.044.0629973.103.0749968l2.434.5319779c.439.095996.786.4429815.883.8819632l.532 2.4348986c.013.0579976.052.0889963.075.1009958.022.0129994.069.0329986.126.0139994l2.373-.7549686c.115-.0369984.232-.0539977.35-.0539977.32 0 .634.1329944.856.3779842l1.677 1.8409233c.08.0879964.15.0899963.231 0l1.681-1.8429232c.303-.3329861.775-.4569809 1.206-.3219866l2.374.7549686c.056.0189992.104-.001.126-.0139994.023-.0119995.062-.0429982.075-.1009958l.531-2.4338986c.095-.4389817.441-.7859673.881-.8839632l2.436-.5309779c.058-.0119995.089-.0529978.102-.0749968.013-.0219991.032-.0679972.014-.1259948l-.757-2.3739011c-.136-.4299821-.009-.9029624.324-1.2069497zM16.146 8.14616058c.195-.19499188.512-.19499188.707 0 .196.19399191.196.51097871.001.70697054l-6.5 6.51572848c-.094.0929962-.221.1459939-.354.1459939-.133 0-.261-.0529977-.354-.1469938l-3.5-3.5158535c-.195-.1949919-.194-.5119787.001-.7069706.195-.1949919.513-.1949919.707.0019999L10 14.3069039l6.146-6.16074332z"],"chat_10":["M5 9c-.697 0-1.387-.186-1.996-.537-.076-.045-.163-.067-.25-.067-.043 0-.087.006-.129.017l-1.418.38.38-1.418c.034-.128.017-.265-.05-.379C1.186 6.387 1 5.697 1 5c0-2.206 1.794-4 4-4 2.206 0 4 1.794 4 4 0 2.206-1.794 4-4 4m0-9C2.243 0 0 2.243 0 5c0 .802.196 1.596.569 2.31L.017 9.371c-.046.172.003.356.129.483.096.095.223.146.354.146.043 0 .086-.005.129-.017l2.061-.552C3.404 9.804 4.198 10 5 10c2.757 0 5-2.243 5-5 0-2.757-2.243-5-5-5"],"chat_12":["M3.2557 10.2617c.087 0 .173.023.25.067.76.439 1.623.671 2.494.671 2.757 0 5-2.243 5-5 0-2.757-2.243-5-5-5-2.757 0-5 2.243-5 5 0 .872.233 1.734.672 2.494.066.115.084.252.05.38l-.515 1.919 1.92-.514c.042-.011.086-.017.129-.017m-2.756 1.738c-.13 0-.258-.051-.353-.146-.127-.127-.176-.311-.13-.483l.687-2.561c-.461-.866-.704-1.833-.704-2.81 0-3.308 2.692-6 6-6 3.309 0 6 2.692 6 6 0 3.309-2.691 6-6 6-.976 0-1.943-.242-2.81-.703l-2.56.686c-.043.012-.086.017-.13.017"],"chat_14":["M.476163329 13.0142456l.006831775-.0018307c-.00231138.0005909-.004590137.0012013-.006831775.0018307zm.696684391-.1866897l2.67048287-.7156059.34781393.1849391C5.05845986 12.7580568 6.02546475 13 7 13c3.3082153 0 6-2.6917847 6-6 0-3.30747705-2.6922132-6-6-6-3.30704858 0-6 2.69295142-6 6 0 .9743154.24245067 1.94130186.70405282 2.80843301l.18530783.34810539-.10217527.3808892-.61433766 2.2901283zM.1715 13.8296667c-.1481666667-.1481667-.2053333333-.3628334-.1516666667-.5635l.8014999997-2.9878334C.2835 9.268 0 8.13983333 0 7c0-3.85933333 3.14066667-7 7-7 3.8605 0 7 3.14066667 7 7 0 3.8605-3.1395 7-7 7-1.13866667 0-2.26683333-.2823333-3.27833333-.8201667L.735 13.9801667C.684833333 13.9941667.634666667 14 .583333333 14c-.151666666 0-.301-.0595-.411833333-.1703333z"],"chat_16":["M.0005309287 7.99973454C.0005309287 3.58173877 3.5822697 0 8.00026546 0 12.4182612 0 16 3.58173877 16 7.99973454c0 4.41799576-3.5817388 7.99973456-7.99973454 7.99973456-1.34626116 0-2.64496283-.3379304-3.80896813-.9713493l-3.561372137.9543112c-.371776528.0996219-.7119780986-.2405797-.6123562348-.6123562l.9543126028-3.5613771C.338627481 10.6449048.0005309287 9.34536678.0005309287 7.99973454zM4.12897878 14.0095737c.12817357-.0343456.26474311-.0163308.37962642.0500764 1.05978191.6125962 2.25211524.9398522 3.49166026.9398522 3.86572934 0 6.99976774-3.1340384 6.99976774-6.99976776 0-3.86572935-3.1340384-6.999767723-6.99976774-6.999767723-3.86572934 0-6.99976771 3.134038373-6.99976771 6.999767723 0 1.23891983.32745838 2.43222856.93985218 3.49166026.06640714.1148833.08442198.2514529.05007637.3796264l-.78281437 2.9213669 2.92136685-.7828144z"],"chat_18":["M4.7588 15.8589c.087 0 .173.023.25.067 1.217.703 2.596 1.074 3.991 1.074 4.411 0 8-3.589 8-8 0-4.411-3.589-8-8-8-4.411 0-8 3.589-8 8 0 1.395.372 2.775 1.074 3.991.067.115.085.252.05.38l-.917 3.422 3.423-.917c.042-.011.086-.017.129-.017m-4.259 2.141c-.131 0-.258-.051-.353-.146-.127-.127-.176-.311-.13-.483l1.089-4.062c-.724-1.323-1.106-2.808-1.106-4.309 0-4.962 4.038-9 9-9 4.963 0 9 4.038 9 9 0 4.963-4.037 9-9 9-1.5 0-2.985-.382-4.308-1.105l-4.062 1.088c-.043.012-.087.017-.13.017"],"chat_20":["M5.2598 17.7246c.087 0 .173.022.25.067 1.368.79 2.921 1.208 4.49 1.208 4.963 0 9-4.037 9-9 0-4.962-4.037-9-9-9-4.962 0-9 4.038-9 9 0 1.57.418 3.122 1.209 4.491.066.115.084.251.05.38l-1.052 3.922 3.924-1.051c.042-.011.086-.017.129-.017m-4.76 2.275c-.131 0-.259-.051-.353-.146-.127-.126-.176-.311-.13-.483l1.223-4.563c-.812-1.475-1.24-3.133-1.24-4.808 0-5.514 4.486-10 10-10 5.514 0 10 4.486 10 10 0 5.514-4.486 10-10 10-1.675 0-3.333-.427-4.808-1.239l-4.562 1.223c-.043.011-.087.016-.13.016"],"chat_24":["M12 22c-1.743 0-3.468-.464-4.989-1.342-.077-.045-.163-.067-.25-.067-.043 0-.087.006-.129.016l-4.425 1.186 1.186-4.425c.034-.128.015-.264-.051-.379C2.464 15.468 2 13.743 2 12 2 6.486 6.486 2 12 2c5.514 0 10 4.486 10 10 0 5.514-4.486 10-10 10m0-21C5.935 1 1 5.935 1 12c0 1.849.475 3.679 1.373 5.308l-1.356 5.063c-.046.172.004.357.129.483.095.094.223.146.354.146.043 0 .087-.006.129-.017l5.063-1.356C8.321 22.525 10.151 23 12 23c6.065 0 11-4.935 11-11 0-6.065-4.935-11-11-11"],"chat_26":["M13 25c-2.092 0-4.163-.557-5.987-1.611-.077-.044-.163-.067-.25-.067-.044 0-.087.006-.13.017l-5.426 1.454 1.454-5.426c.034-.128.017-.265-.05-.38C1.557 17.163 1 15.092 1 13 1 6.383 6.383 1 13 1c6.617 0 12 5.383 12 12 0 6.617-5.383 12-12 12m0-25C5.832 0 0 5.832 0 13c0 2.199.567 4.374 1.642 6.306L.017 25.371c-.046.172.003.356.129.483.095.095.223.146.354.146.043 0 .086-.005.129-.017l6.065-1.625C8.626 25.433 10.801 26 13 26c7.168 0 13-5.832 13-13 0-7.168-5.832-13-13-13"],"chat_28":["M7.763 24.3218c.087 0 .173.023.25.067 1.824 1.054 3.895 1.611 5.987 1.611 6.617 0 12-5.383 12-12 0-6.616-5.383-12-12-12-6.617 0-12 5.384-12 12 0 2.093.557 4.163 1.611 5.987.067.115.085.252.05.38l-1.454 5.426 5.427-1.454c.042-.011.086-.017.129-.017M1.5 26.9998c-.131 0-.258-.051-.353-.146-.127-.126-.176-.311-.13-.483l1.625-6.065C1.567 18.3738 1 16.1988 1 13.9998c0-7.168 5.832-13 13-13 7.168 0 13 5.832 13 13 0 7.168-5.832 13-13 13-2.198 0-4.374-.567-6.305-1.642l-6.066 1.625c-.042.012-.086.017-.129.017"],"chat_32":["M8.7649 28.0532c.087 0 .173.023.25.067 2.129 1.23 4.544 1.88 6.985 1.88 7.72 0 14-6.28 14-14 0-7.72-6.28-14-14-14-7.72 0-14 6.28-14 14 0 2.441.65 4.856 1.88 6.985.066.115.084.251.05.379l-1.723 6.429 6.429-1.723c.042-.011.086-.017.129-.017m-7.265 2.947c-.131 0-.258-.052-.353-.147-.127-.126-.176-.31-.13-.483l1.894-7.066c-1.251-2.236-1.911-4.757-1.911-7.304 0-8.271 6.729-15 15-15 8.271 0 15 6.729 15 15 0 8.271-6.729 15-15 15-2.547 0-5.068-.66-7.304-1.911l-7.066 1.894c-.043.011-.087.017-.13.017"],"chat_36":["M18 34c-2.79 0-5.55-.743-7.983-2.148-.077-.044-.163-.067-.25-.067-.043 0-.087.006-.129.017l-7.431 1.991 1.991-7.431c.034-.128.016-.264-.05-.379C2.743 23.55 2 20.79 2 18 2 9.178 9.178 2 18 2c8.822 0 16 7.178 16 16 0 8.822-7.178 16-16 16m0-33C8.626 1 1 8.626 1 18c0 2.896.753 5.762 2.179 8.302l-2.162 8.069c-.046.172.003.356.129.483.095.095.223.146.354.146.043 0 .087-.005.129-.017l8.069-2.162C12.238 34.247 15.104 35 18 35c9.374 0 17-7.626 17-17 0-9.374-7.626-17-17-17"],"chat_8":["M2.2537 6.5303c.087 0 .173.023.25.067.457.264.974.403 1.496.403 1.655 0 3-1.346 3-3 0-1.655-1.345-3-3-3-1.654 0-3 1.345-3 3 0 .522.14 1.04.403 1.496.067.115.085.252.05.38l-.245.917.917-.246c.042-.011.086-.017.129-.017m-1.754 1.47c-.131 0-.258-.052-.353-.147-.127-.126-.176-.31-.13-.483l.419-1.561c-.286-.561-.436-1.182-.436-1.809 0-2.206 1.795-4 4-4 2.206 0 4 1.794 4 4 0 2.205-1.794 4-4 4-.627 0-1.248-.15-1.809-.435l-1.561.418c-.043.011-.086.017-.13.017"],"chat-active_10":["M5 0C2.243 0 0 2.243 0 5c0 .802.196 1.596.569 2.31L.017 9.371c-.046.172.003.356.129.483.096.095.223.146.354.146.043 0 .086-.005.129-.017l2.061-.552C3.404 9.804 4.198 10 5 10c2.757 0 5-2.243 5-5 0-2.757-2.243-5-5-5"],"chat-active_12":["M.4997 11.9997c-.13 0-.258-.051-.353-.146-.127-.127-.176-.311-.13-.483l.687-2.561c-.461-.866-.704-1.833-.704-2.81 0-3.308 2.692-6 6-6 3.309 0 6 2.692 6 6 0 3.309-2.691 6-6 6-.976 0-1.943-.242-2.81-.703l-2.56.686c-.043.012-.086.017-.13.017"],"chat-active_14":["M.1715 13.8296667c-.1481666667-.1481667-.2053333333-.3628334-.1516666667-.5635l.8014999997-2.9878334C.2835 9.268 0 8.13983333 0 7c0-3.85933333 3.14066667-7 7-7 3.8605 0 7 3.14066667 7 7 0 3.8605-3.1395 7-7 7-1.13866667 0-2.26683333-.2823333-3.27833333-.8201667L.735 13.9801667C.684833333 13.9941667.634666667 14 .583333333 14c-.151666666 0-.301-.0595-.411833333-.1703333z"],"chat-active_16":["M.0005309287 7.99973454C.0005309287 3.58173877 3.5822697 0 8.00026546 0 12.4182612 0 16 3.58173877 16 7.99973454c0 4.41799576-3.5817388 7.99973456-7.99973454 7.99973456-1.34626116 0-2.64496283-.3379304-3.80896813-.9713493l-3.561372137.9543112c-.371776528.0996219-.7119780986-.2405797-.6123562348-.6123562l.9543126028-3.5613771C.338627481 10.6449048.0005309287 9.34536678.0005309287 7.99973454z"],"chat-active_18":["M.4998 17.9999c-.131 0-.258-.051-.353-.146-.127-.127-.176-.311-.13-.483l1.089-4.062c-.724-1.323-1.106-2.808-1.106-4.309 0-4.962 4.038-9 9-9 4.963 0 9 4.038 9 9 0 4.963-4.037 9-9 9-1.5 0-2.985-.382-4.308-1.105l-4.062 1.088c-.043.012-.087.017-.13.017"],"chat-active_20":["M.4998 19.9996c-.131 0-.259-.051-.353-.146-.127-.126-.176-.311-.13-.483l1.223-4.563c-.812-1.475-1.24-3.133-1.24-4.808 0-5.514 4.486-10 10-10 5.514 0 10 4.486 10 10 0 5.514-4.486 10-10 10-1.675 0-3.333-.427-4.808-1.239l-4.562 1.223c-.043.011-.087.016-.13.016"],"chat-active_24":["M12 1C5.935 1 1 5.935 1 12c0 1.849.475 3.679 1.373 5.308l-1.356 5.063c-.046.172.004.357.129.483.095.094.223.146.354.146.043 0 .087-.006.129-.017l5.063-1.356C8.321 22.525 10.151 23 12 23c6.065 0 11-4.935 11-11 0-6.065-4.935-11-11-11"],"chat-active_26":["M13 0C5.832 0 0 5.832 0 13c0 2.199.567 4.374 1.642 6.306L.017 25.371c-.046.172.003.356.129.483.095.095.223.146.354.146.043 0 .086-.005.129-.017l6.065-1.625C8.626 25.433 10.801 26 13 26c7.168 0 13-5.832 13-13 0-7.168-5.832-13-13-13"],"chat-active_28":["M1.5 26.9998c-.131 0-.258-.051-.353-.146-.127-.126-.176-.311-.13-.483l1.625-6.065C1.567 18.3738 1 16.1988 1 13.9998c0-7.168 5.832-13 13-13 7.168 0 13 5.832 13 13 0 7.168-5.832 13-13 13-2.198 0-4.374-.567-6.305-1.642l-6.066 1.625c-.042.012-.086.017-.129.017"],"chat-active_32":["M1.4999 31.0002c-.131 0-.258-.052-.353-.147-.127-.126-.176-.31-.13-.483l1.894-7.066c-1.251-2.236-1.911-4.757-1.911-7.304 0-8.271 6.729-15 15-15 8.271 0 15 6.729 15 15 0 8.271-6.729 15-15 15-2.547 0-5.068-.66-7.304-1.911l-7.066 1.894c-.043.011-.087.017-.13.017"],"chat-active_36":["M18 1C8.626 1 1 8.626 1 18c0 2.896.753 5.762 2.179 8.302l-2.162 8.069c-.046.172.003.356.129.483.095.095.223.146.354.146.043 0 .087-.005.129-.017l8.069-2.162C12.238 34.247 15.104 35 18 35c9.374 0 17-7.626 17-17 0-9.374-7.626-17-17-17"],"chat-active_8":["M.4997 8.0003c-.131 0-.258-.052-.353-.147-.127-.126-.176-.31-.13-.483l.419-1.561c-.286-.561-.436-1.182-.436-1.809 0-2.206 1.795-4 4-4 2.206 0 4 1.794 4 4 0 2.205-1.794 4-4 4-.627 0-1.248-.15-1.809-.435l-1.561.418c-.043.011-.086.017-.13.017"],"chat-group_12":["M10.5821 10.0068l.211.786-.787-.211c-.128-.033-.265-.017-.38.051-.759.437-1.698.459-2.484.116 1.718-.538 3.076-1.899 3.611-3.618.159.35.247.731.247 1.13 0 .477-.127.949-.368 1.366-.067.114-.084.251-.05.38zm-7.327-.61c-.077-.045-.163-.068-.25-.068-.044 0-.087.006-.13.017l-1.668.447.447-1.668c.034-.129.017-.265-.05-.38-.395-.683-.604-1.46-.604-2.245 0-2.481 2.019-4.5 4.5-4.5 2.481 0 4.5 2.019 4.5 4.5 0 2.482-2.019 4.5-4.5 4.5-.785 0-1.562-.209-2.245-.603zm8.344.543c.263-.521.401-1.097.401-1.679 0-.956-.367-1.841-1.012-2.534.004-.075.012-.151.012-.227 0-3.032-2.467-5.5-5.5-5.5-3.033 0-5.5 2.468-5.5 5.5 0 .891.219 1.772.636 2.561l-.619 2.309c-.046.173.003.358.129.484.095.094.223.146.354.146.043 0 .086-.006.129-.016l2.31-.62c.789.416 1.67.636 2.561.636.07 0 .139-.008.209-.011 1.122 1.046 2.858 1.304 4.23.611l1.432.384c.043.01.086.016.129.016.131 0 .259-.052.353-.146.127-.126.176-.311.13-.484l-.384-1.43z"],"chat-group_16":["M14.3457 13.124l.447 1.669-1.669-.447c-.127-.035-.265-.017-.38.05-.683.395-1.459.604-2.244.604-1.064 0-2.068-.369-2.866-1.032 3.355-.303 6.031-2.98 6.334-6.334.663.799 1.032 1.802 1.032 2.866 0 .785-.209 1.561-.604 2.244-.067.115-.084.252-.05.38zm-10.589-.997c-.043 0-.087.006-.129.018l-2.421.648.649-2.42c.034-.128.016-.265-.05-.38C1.2787 9.081.9997 8.046.9997 7c0-3.309 2.692-6 6-6 3.309 0 6 2.691 6 6 0 3.309-2.691 6-6 6-1.046 0-2.081-.278-2.993-.806-.077-.044-.163-.067-.25-.067zm11.607.933c.417-.789.636-1.67.636-2.56 0-1.673-.746-3.223-2.045-4.274C13.5687 2.729 10.5977 0 6.9997 0c-3.86 0-7 3.14-7 7 0 1.151.289 2.291.837 3.31l-.82 3.061c-.046.172.003.356.13.482.095.096.222.147.353.147.043 0 .087-.005.13-.017l3.061-.82c.788.424 1.65.689 2.533.789 1.05 1.3 2.601 2.048 4.276 2.048.89 0 1.771-.219 2.56-.636l2.311.619c.043.012.086.017.129.017.131 0 .259-.051.354-.147.126-.126.176-.31.129-.482l-.619-2.311z"],"chat-group_20":["M18.2366412 16.859l.5039852 1.881-1.8809447-.504c-.0849975-.023-.1719949-.034-.2589924-.034-.1659951 0-.3309903.041-.4789859.122-.8089762.442-1.7199495.676-2.6349226.676-1.2219641 0-2.3349314-.42-3.2489045-1.096 3.9718833-.55 7.1167909-3.695 7.6667747-7.668.6769801.914 1.0949678 2.028 1.0949678 3.251 0 .914-.2339931 1.825-.6749802 2.634-.1229963.225-.1539954.49-.0879974.738m-13.53960206-.962c-.08699744 0-.17399488.012-.25899238.034l-3.23690488.868.86697452-3.238c.06599806-.248.03499898-.513-.08799741-.738C1.3401378 11.65 1.00114776 10.328 1.00114776 9c0-4.412 3.58889453-8 7.9997649-8C13.411783 1 17.0006776 4.588 17.0006776 9c0 4.411-3.5888946 8-7.99976494 8-1.32796097 0-2.65092209-.339-3.82488759-.981-.14799565-.08-.3129908-.122-.47898593-.122m15.30255026-2.41c0-1.844-.7749772-3.504-2.0099409-4.69C17.8816517 3.929 13.8937689 0 9.00091266 0 4.03805851 0 .0011771484 4.037.0011771484 9c0 1.498.3799888326 2.981 1.1009676416 4.302L.0171766782 17.35c-.0469986188.178.0039998824.368.1339960618.498.09799712.098.229993241.152.363989303.152.044998678 0 .089997355-.007.133996062-.018l4.047881035-1.085c1.26096295.689 2.66992154 1.056 4.09887954 1.089C9.98088386 19.223 11.642835 20 13.4867808 20c1.0849681 0 2.1579366-.276 3.1139085-.798l2.9289139.785c.0319991.008.0649981.013.0979972.013.0969971 0 .1919943-.039.2629922-.11.0939973-.093.1309962-.231.0969972-.36l-.784977-2.93c.5219847-.956.7969766-2.029.7969766-3.113"],"chat-group_32":["M27.1684569 28.8256071c-.1267357-.0323768-.2613309-.016679-.3733298.0490556C25.5189285 29.6104979 24.0717841 30 22.6079382 30 20.0280325 30 17.5846869 28.790287 16 26.7642875c5.7433849-1.2401276 10.0612392-6.3478048 10.0612392-12.4483689 0-.1069414-.0137543-.2099583-.0167016-.3159186C29.028229 15.3431445 31 18.3090508 31 21.6193279c0 1.4608781-.389049 2.9070395-1.1258842 4.181506-.0648415.1128281-.083508.2462596-.0501048.3718421l.9726225 3.6242335-3.6281766-.9713024zM7.01276436 24.3881195c-.0760856-.0440514-.16318358-.0660771-.25028157-.0660771-.04304843 0-.08709798.0050058-.13014641.0170198l-5.42510324 1.453696 1.45563759-5.4263307c.03403829-.1281495.01501689-.2643084-.05105744-.3794427C1.55762733 18.1628567 1 16.0924412 1 14 1 7.38328049 6.38305594 2 13.0005006 2 19.6169441 2 25 7.38328049 25 14c0 6.6167195-5.3830559 12-11.9994994 12-2.0923539 0-4.16268306-.5576506-5.98773624-1.6118805zm24.98641854-2.9390337c0-3.9516882-2.4479375-7.4949953-6.1138439-8.9093153C25.1583576 6.05772054 19.6544981 1 12.9866684 1 5.82585123 1 0 6.83044175 0 13.9981316c0 2.1980515.566985522 4.3730815 1.6409581 6.3038836L.0169995659 26.3656746c-.0459988254.1731616.0039998979.3573335.1299966801.4834513.094997575.0960896.222994306.1471373.352990987.1471373.042998902 0 .086997778-.0060056.12999668-.0170159l6.057845307-1.6245162c1.92995072 1.0740024 4.10189528 1.6415321 6.29883918 1.6415321.5649856 0 1.1189714-.0490458 1.6659574-.1191112.0139997.0630589.041999.1241158.0819979.1801682C16.526578 29.5256239 19.4125043 31 22.4574265 31c1.5949593 0 3.173919-.4073802 4.5798831-1.1791005l4.3328893 1.1620846c.041999.0110103.0859979.0170159.1289968.0170159.1309966 0 .2589933-.0510476.3539909-.1471373.1259968-.1261177.1759955-.3102896.1299967-.4834512l-1.1609704-4.337048c.7699804-1.4063125 1.17697-2.9867876 1.17697-4.5832777z"],"chat-persistent_16":["M10.0165681 6.371l.2849704-1.063C10.103559 4.9 9.99956982 4.453 9.99956982 4c0-1.654 1.34586048-3 2.99968898-3 1.6538285 0 2.9996889 1.346 2.9996889 3 0 1.654-1.3458604 3-2.9996889 3-.4529531 0-.9009066-.104-1.3078644-.302l-1.0628898.285c-.0419956.011-.0859911.017-.1289866.017-.1309864 0-.2579733-.052-.3539633-.146-.125987-.126-.17498187-.311-.1289866-.483zM12.9992588 2c-1.1028857 0-1.9997927.897-1.9997927 2 0 .349.0929904.693.2679723.997.0659931.114.0849911.251.0499948.379l-.1109885.417.4159568-.112c.0429956-.011.0859911-.017.1289867-.017.0879908 0 .1739819.023.2509739.067.3039685.176.6479329.269.9968967.269 1.1028856 0 1.9997926-.897 1.9997926-2 0-1.103-.896907-2-1.9997926-2zm2.7597138 11.143l.221977 1.011c.0489949.198.0019998.414-.1299865.582-.1309864.168-.327966.264-.539944.264l-5.1244687 0-.49994812 0-8.87407982 0c-.24997408 0-.480950129-.113-.636933954-.312-.1569837223-.199-.2119780197-.456-.1519842407-.704l.3649621557-1.656C.70653345 11.027 1.79742033 10.115 3.0812872 10.02c-.66293125-.638-1.08088792-1.53-1.08088792-2.52 0-1.93 1.56983722-3.5 3.49963711-3.5 1.9297999 0 3.49963712 1.57 3.49963712 3.5 0 .99-.41795667 1.882-1.08088792 2.52 1.08888709.081 2.034789.75 2.49074171 1.739.0829914-.036.1709823-.06.2579733-.083-.28997-.385-.4679515-.858-.4679515-1.376 0-1.269 1.031893-2.3 2.2997615-2.3 1.2678685 0 2.2997615 1.031 2.2997615 2.3 0 .517-.1779815.99-.4669515 1.375.6899284.186 1.2468707.735 1.426852 1.468zM10.9784683 14l3.9455909 0-.1389856-.631c-.1099886-.448-.5089472-.769-.9668997-.769l-2.6377265 0c-.1719822 0-.3299658.059-.4769506.144l.2749715 1.252c0 .002 0 .002 0 .004zm-1.29186602 0l.2689721 0-.32096671-1.457C9.41363058 11.64 8.61571332 11 7.6978085 11l-4.39554421 0c-.91790482 0-1.71582208.64-1.93979886 1.555L1.04449841 14l8.64210387 0zM3.0002956 7.5c0 1.379 1.12188367 2.5 2.49974079 2.5 1.37785713 0 2.4997408-1.121 2.4997408-2.5 0-1.379-1.12188367-2.5-2.4997408-2.5C4.12217927 5 3.0002956 6.121 3.0002956 7.5zm9.499015 1.5c-.7169256 0-1.2998652.583-1.2998652 1.3 0 .717.5829396 1.3 1.2998652 1.3.7169257 0 1.2998652-.583 1.2998652-1.3 0-.717-.5829395-1.3-1.2998652-1.3z"],"chat-persistent_20":["M13.0154168 7.37l.3519809-1.311c-.2419869-.485-.36898-1.019-.36898-1.559 0-1.93 1.569915-3.5 3.4998104-3.5 1.9298954 0 3.4998103 1.57 3.4998103 3.5 0 1.93-1.5699149 3.5-3.4998103 3.5-.5389708 0-1.0739418-.127-1.5589156-.368l-1.3119289.351c-.0429976.011-.0859953.017-.128993.017-.1309929 0-.2589859-.052-.3539808-.146-.1259932-.126-.1749905-.311-.128993-.484zM16.4982281 2c-1.3779254 0-2.4998646 1.121-2.4998646 2.5 0 .436.1159938.866.3359818 1.247.0659965.115.0839955.251.0499973.38l-.1789903.666.6669639-.179c.0419977-.01.0849954-.016.128993-.016.0869953 0 .1729906.022.2489865.066.3819793.22.8129559.336 1.2479324.336 1.3779253 0 2.4998645-1.121 2.4998645-2.5 0-1.379-1.1219392-2.5-2.4998645-2.5zm3.2063262 14.835l.2759851 1.261c.0509972.213.0009999.444-.1409924.625-.1399924.177-.3479811.279-.572969.279l-5.0287274 0c.0019999-.012 0-.022.0019999-.033-.0509973.008-.0949949.033-.1469921.033L.906573002 19c-.282984665 0-.544970467-.128-.717961093-.35-.1699907877-.219-.2289875906-.5-.1609912754-.769l.4739743144-2.072C.923572081 14.15 2.41949101 13 4.14239765 13l.55996965 0c-1.03094413-.824-1.70390766-2.078-1.70390766-3.5 0-2.485 2.01489081-4.5 4.49975615-4.5 2.48586529 0 4.49975611 2.015 4.49975611 4.5 0 1.422-.6719635 2.676-1.7029077 3.5l.5619696 0c.6009674 0 1.1719365.147 1.6809089.4-.0169991-.132-.0399979-.263-.0399979-.4 0-1.656 1.3439272-3 2.9998375-3 1.6569102 0 2.9998374 1.344 2.9998374 3 0 .783-.3069833 1.49-.7979567 2.024.9629478.119 1.7669042.826 2.0048913 1.811zM14.9758106 18l3.9597854 0-.2049889-.941c-.1499919-.62-.6909626-1.059-1.3129289-1.059l-2.877844 0 .4339765 1.893c.0089995.035-.0019999.072.0019999.107zM1.02556655 18l12.94729835 0-.4509755-1.969C13.2189058 14.84 12.1219652 14 10.8570338 14l-6.71463615 0c-1.2659314 0-2.36287195.84-2.66885537 2.043L1.02556655 18zm2.9728389-8.5c0 1.93 1.57091487 3.5 3.49981034 3.5 1.92989542 0 3.49981031-1.57 3.49981031-3.5 0-1.93-1.56991489-3.5-3.49981031-3.5-1.92889547 0-3.49981034 1.57-3.49981034 3.5zM15.4977823 11c-1.1019403 0-1.9998916.896-1.9998916 2 0 1.104.8979513 2 1.9998916 2 1.1029402 0 1.9998916-.896 1.9998916-2 0-1.104-.8969514-2-1.9998916-2z"],"chat-persistent_24":["M15.0161462 9.37l.4849588-1.81c-.328972-.637-.5019573-1.345-.5019573-2.06 0-2.481 2.0188285-4.5 4.4996177-4.5 2.4807893 0 4.4996178 2.019 4.4996178 4.5 0 2.481-2.0188285 4.5-4.4996178 4.5-.7149392 0-1.4228791-.173-2.059825-.502l-1.8108462.485c-.0429963.011-.0859927.017-.128989.017-.1309889 0-.258978-.052-.3539699-.146-.1259893-.126-.1749852-.311-.1289891-.484zM19.4987654 2c-1.929836 0-3.4997027 1.57-3.4997027 3.5 0 .61.1629862 1.214.4699601 1.746.0669943.114.0839929.251.0499958.38l-.3129735 1.167 1.1679008-.314c.0419965-.01.0849928-.016.1289891-.016.0869926 0 .1729853.022.2499787.067.5319549.308 1.1359035.47 1.7458517.47 1.9298361 0 3.4997027-1.57 3.4997027-3.5 0-1.93-1.5698666-3.5-3.4997027-3.5zm4.108751 18.316l.3699686 1.68c.057995.236.0029997.493-.1539869.692-.1559868.199-.3879671.312-.6379459.312l-7.1853896 0-.0019998 0-14.99772596 0c-.315973163 0-.60594853-.142-.796932306-.388-.1849842861-.239-.2479789348-.543-.1719853903-.834l.5849503093-2.489C1.12242647 17.348 2.91627409 16 4.98309852 16l.36496899 0c-1.41687964-.996-2.34780056-2.641-2.34780056-4.5 0-3.032 2.46679045-5.5 5.49953283-5.5 3.03274242 0 5.49953282 2.468 5.49953282 5.5 0 1.859-.9309209 3.504-2.3478006 4.5l.364969 0c1.5928647 0 3.0177437.807 3.8206755 2.057.0829929-.014.1669858-.024.2519786-.031-.6679433-.637-1.0899074-1.532-1.0899074-2.526 0-1.93 1.5698666-3.5 3.4997027-3.5 1.929836 0 3.4997027 1.57 3.4997027 3.5 0 .99-.4179645 1.882-1.0809082 2.52 1.2838909.095 2.3737983 1.007 2.6897715 2.296zM16.9750798 22l5.9794921 0-.3209728-1.457C22.4126179 19.64 21.6146857 19 20.6967637 19l-4.3956266 0c-.0069994 0-.011999.002-.0189984.002.0309973.093.0729938.18.0979917.275l.5909498 2.513c.0179984.069.0029997.14.0039996.21zm-15.97264313.019L15.9981628 22l-.5879501-2.482C15.0242455 18.04 13.6273642 17 12.016501 17l-7.03340248 0c-1.61086316 0-3.0077445 1.04-3.39671146 2.529l-.58395039 2.49zM4.00018201 11.5c0 2.481 2.01782859 4.5 4.49961777 4.5 2.48078922 0 4.49961772-2.019 4.49961772-4.5 0-2.481-2.0188285-4.5-4.49961772-4.5-2.48178918 0-4.49961777 2.019-4.49961777 4.5zm11.99898069 4c0 1.379 1.1219047 2.5 2.4997877 2.5 1.3778829 0 2.4997876-1.121 2.4997876-2.5 0-1.379-1.1219047-2.5-2.4997876-2.5-1.377883 0-2.4997877 1.121-2.4997877 2.5z"],"check_10":["M8.1462 2.396l-4.146 4.147-2.146-2.147c-.196-.195-.512-.195-.708 0-.195.196-.195.512 0 .708l2.5 2.5c.098.097.226.146.354.146.128 0 .256-.049.354-.146l4.5-4.5c.195-.196.195-.512 0-.708-.196-.195-.512-.195-.708 0"],"check_12":["M4.5024 9.5c-.133 0-.26-.053-.354-.147l-3.002-3.007c-.195-.196-.195-.512.001-.707.194-.195.511-.196.707.001l2.648 2.652 5.642-5.646c.195-.195.511-.195.707 0 .195.195.195.512 0 .708l-5.995 6c-.094.093-.221.146-.354.146"],"check_14":["M5.5001 11.01318c-.133 0-.26-.053-.354-.146l-4-4.006c-.195-.196-.195-.512 0-.707.196-.195.513-.195.708 0l3.646 3.651 6.654-6.659c.196-.195.512-.195.707 0 .196.195.196.512 0 .707l-7.007 7.014c-.094.093-.221.146-.354.146"],"check_16":["M6.0083 12.50195c-.132 0-.26-.053-.354-.146l-4.508-4.507c-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0l4.155 4.153 8.143-8.148c.195-.196.511-.196.707 0 .195.194.195.511 0 .707l-8.496 8.502c-.094.093-.221.146-.354.146"],"check_18":["M6.49537524 14.0068c-.133 0-.26-.053-.354-.146l-4.995999999-5.003c-.194-.196-.194-.512.001-.707.195-.195.512-.195.707 0l4.641999999 4.648 9.64599996-9.652c.196-.196.512-.196.708 0 .195.194.195.511 0 .707l-9.99999996 10.007c-.094.093-.221.146-.354.146"],"check_20":["M6.9971 16.25025c-.133 0-.26-.053-.354-.146l-5.497-5.5c-.195-.196-.195-.512 0-.708.196-.195.512-.195.707 0l5.144 5.147 11.149-11.147c.196-.195.512-.195.707 0 .196.196.196.512 0 .708l-11.502 11.5c-.094.093-.221.146-.354.146"],"check_24":["M8.4956 19.50025c-.133 0-.26-.053-.354-.146l-6.995-7c-.195-.196-.195-.513 0-.708.195-.195.512-.195.707 0l6.642 6.647 13.651-13.647c.195-.195.512-.195.707 0 .195.196.195.512 0 .708l-14.004 14c-.094.093-.221.146-.354.146"],"check_28":["M10 22.25025c-.128 0-.256-.049-.354-.146l-7.5-7.5c-.195-.196-.195-.512 0-.708.196-.195.512-.195.708 0l7.146 7.147 15.151-15.147c.195-.195.512-.195.707 0 .195.196.195.512 0 .708l-15.504 15.5c-.098.097-.226.146-.354.146"],"check_32":["M11.5 25.50025c-.128 0-.256-.049-.354-.146l-9-9c-.195-.196-.195-.512 0-.708.196-.195.512-.195.708 0l8.646 8.647 17.646-17.647c.196-.195.512-.195.708 0 .195.196.195.512 0 .708l-18 18c-.098.097-.226.146-.354.146"],"check_36":["M12.5 29c-.128 0-.256-.049-.354-.146l-10-10c-.195-.196-.195-.512 0-.708.196-.195.512-.195.708 0l9.646 9.647L33.146 7.146c.196-.195.512-.195.708 0 .195.196.195.512 0 .708l-21 21c-.098.097-.226.146-.354.146"],"check_40":["M13.5 32c-.128 0-.256-.049-.354-.146l-11-11c-.195-.196-.195-.512 0-.708.196-.195.512-.195.708 0L13.5 30.793 37.146 7.146c.196-.195.512-.195.708 0 .195.196.195.512 0 .708l-24 24c-.098.097-.226.146-.354.146"],"check_64":["M21.5 52c-.128 0-.256-.049-.354-.146l-18-18c-.195-.196-.195-.512 0-.708.196-.195.512-.195.708 0L21.5 50.793l38.646-38.647c.196-.195.512-.195.708 0 .195.196.195.512 0 .708l-39 39c-.098.097-.226.146-.354.146"],"check_8":["M3 6.5c-.128 0-.256-.049-.354-.146l-2.5-2.5c-.195-.196-.195-.512 0-.708.196-.195.512-.195.708 0L3 5.293l4.146-4.147c.196-.195.512-.195.708 0 .195.196.195.512 0 .708l-4.5 4.5c-.098.097-.226.146-.354.146"],"check_80":["M26.4999 65l-.005 0c-.135-.001-.264-.057-.356-.154l-22-23c-.191-.2-.184-.516.015-.707.2-.191.517-.183.707.015l21.647 22.631 48.638-48.639c.196-.195.512-.195.708 0 .195.196.195.512 0 .708l-49 49c-.094.093-.222.146-.354.146"],"check-circle_100":["M50 0c27.57 0 50 22.43 50 50 0 27.57-22.43 50-50 50-27.57 0-50-22.43-50-50C0 22.43 22.43 0 50 0zm0 99c27.019 0 49-21.982 49-49C99 22.98 77.019 1 50 1 22.981 1 1 22.98 1 50c0 27.018 21.981 49 49 49zm19.6494-62.8565c.197-.193.514-.191.707.006.194.197.191.514-.006.707l-27.5 27c-.097.096-.224.143-.35.143-.125 0-.25-.046-.347-.139l-12.5-12.01c-.199-.191-.205-.508-.014-.707.192-.198.508-.206.707-.014l12.15 11.673 27.153-26.659z"],"check-circle_12":["M6 0c3.313 0 6 2.687 6 6 0 3.313-2.687 6-6 6-3.313 0-6-2.687-6-6 0-3.313 2.687-6 6-6zm0 11c2.757 0 5-2.243 5-5 0-2.757-2.243-5-5-5-2.757 0-5 2.243-5 5 0 2.757 2.243 5 5 5zm2.1465-7.02c.195-.195.512-.195.707 0 .195.195.195.512 0 .707L5.5205 8.02c-.098.098-.226.147-.354.147-.128 0-.256-.049-.353-.147l-1.667-1.666c-.195-.196-.195-.512 0-.707.195-.196.512-.196.707 0l1.313 1.312 2.98-2.979z"],"check-circle_14":["M6.9999 0c3.866 0 7 3.134 7 7 0 3.866-3.134 7-7 7-3.866 0-7-3.134-7-7 0-3.866 3.134-7 7-7zm0 13c3.309 0 6-2.691 6-6 0-3.309-2.691-6-6-6-3.309 0-6 2.691-6 6 0 3.309 2.691 6 6 6zm2.6465-8.3535c.195-.195.512-.195.707 0 .195.195.195.512 0 .707l-4 4c-.098.098-.226.147-.353.147-.128 0-.256-.049-.354-.147l-2-2c-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0l1.647 1.646 3.646-3.646z"],"check-circle_16":["M8 0c4.4 0 8 3.6 8 8 0 4.4-3.6 8-8 8-4.4 0-8-3.6-8-8 0-4.4 3.6-8 8-8zm0 15c3.859 0 7-3.141 7-7 0-3.859-3.141-7-7-7-3.859 0-7 3.141-7 7 0 3.859 3.141 7 7 7zm3.1465-9.35375c.195-.195.512-.195.707 0 .195.195.195.512 0 .707l-4.5 4.5c-.098.098-.226.147-.353.147-.128 0-.256-.049-.354-.147l-2.5-2.5c-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0l2.147 2.146 4.146-4.146z"],"check-circle_24":["M12 0c6.627 0 12 5.373 12 12 0 6.627-5.373 12-12 12-6.627 0-12-5.373-12-12C0 5.373 5.373 0 12 0zm0 23c6.065 0 11-4.935 11-11 0-6.065-4.935-11-11-11C5.935 1 1 5.935 1 12c0 6.065 4.935 11 11 11zm-1.4976-7c-.133 0-.26-.053-.354-.147l-3.002-3.007c-.195-.196-.195-.512.001-.707.194-.195.511-.196.707.001l2.648 2.652 5.642-5.646c.195-.195.511-.195.707 0 .195.195.195.512 0 .708l-5.995 6c-.094.093-.221.146-.354.146z"],"check-circle_40":["M19.9998 0c11.028 0 20 8.972 20 20 0 11.028-8.972 20-20 20-11.028 0-20-8.972-20-20 0-11.028 8.972-20 20-20zm0 39c10.477 0 19-8.523 19-19 0-10.477-8.523-19-19-19-10.477 0-19 8.523-19 19 0 10.477 8.523 19 19 19zm9.1464-25.8536c.195-.195.512-.195.707 0 .195.195.195.512 0 .707l-13 13c-.098.098-.226.147-.353.147-.128 0-.256-.049-.354-.147l-6.001-6c-.196-.195-.196-.512 0-.707.195-.195.511-.195.707 0l5.648 5.646 12.646-12.646z"],"check-circle_44":["M22 44C9.869 44 0 34.131 0 22 0 9.869 9.869 0 22 0c12.131 0 22 9.869 22 22 0 12.131-9.869 22-22 22zm0-43C10.42 1 1 10.42 1 22c0 11.58 9.42 21 21 21 11.58 0 21-9.42 21-21 0-11.58-9.42-21-21-21zm-3.9375 29c-.136 0-.266-.055-.36-.153l-6.563-6.819c-.191-.198-.185-.515.014-.707.199-.191.515-.185.707.014l6.202 6.444 14.077-14.626c.192-.199.508-.205.707-.013.199.191.205.508.014.707l-14.438 15c-.094.098-.224.153-.36.153z"],"check-refresh_16":["M15.5002 10c.276 0 .5.224.5.5l0 5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-3.646c-1.393 2.514-4.08 4.146-7 4.146-4.411 0-8-3.589-8-8 0-4.411 3.589-8 8-8 1.309 0 2.607.323 3.757.935.243.129.336.432.206.676-.13.245-.433.336-.677.206-1.005-.535-2.14-.817-3.286-.817-3.859 0-7 3.141-7 7 0 3.859 3.141 7 7 7 2.694 0 5.152-1.594 6.303-4l-3.803 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l5 0zM4.8537 7.1465l2.646 2.646 6.647-6.646c.195-.195.512-.195.707 0 .195.195.195.512 0 .707l-7 7c-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147l-3-3c-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0z"],"cisco-logo":[null],"clear_12":["M6 0c3.309 0 6 2.691 6 6 0 3.309-2.691 6-6 6-3.309 0-6-2.691-6-6 0-3.309 2.691-6 6-6zm0 11c2.757 0 5-2.243 5-5 0-2.757-2.243-5-5-5-2.757 0-5 2.243-5 5 0 2.757 2.243 5 5 5zm1.8535-6.8535c.195.195.195.512 0 .707l-1.146 1.147 1.146 1.146c.195.195.195.512 0 .707-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147l-1.147-1.146-1.146 1.146c-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147-.195-.195-.195-.512 0-.707l1.146-1.146-1.146-1.147c-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0l1.146 1.146 1.147-1.146c.195-.195.512-.195.707 0z"],"clear_14":["M7 0c3.866 0 7 3.134 7 7 0 3.866-3.134 7-7 7-3.866 0-7-3.134-7-7 0-3.866 3.134-7 7-7zm0 13c3.308 0 6-2.691 6-6 0-3.309-2.692-6-6-6-3.308 0-6 2.691-6 6 0 3.309 2.692 6 6 6zm2.8535-8.8535c.195.195.195.512 0 .707l-2.146 2.147 2.146 2.146c.195.195.195.512 0 .707-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147l-2.147-2.146-2.146 2.146c-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147-.195-.195-.195-.512 0-.707l2.146-2.146-2.146-2.147c-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0l2.146 2.146 2.147-2.146c.195-.195.512-.195.707 0z"],"clear_16":["M8 0c4.411 0 8 3.589 8 8 0 4.411-3.589 8-8 8-4.411 0-8-3.589-8-8 0-4.411 3.589-8 8-8zm0 15c3.859 0 7-3.141 7-7 0-3.859-3.141-7-7-7-3.86 0-7 3.141-7 7 0 3.859 3.14 7 7 7zm2.8535-9.8535c.195.195.195.512 0 .707l-2.175 2.175 2.079 2.122c.194.197.19.514-.008.707-.096.095-.223.143-.349.143-.13 0-.259-.05-.358-.151l-2.071-2.114-2.118 2.118c-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147-.195-.195-.195-.512 0-.707l2.125-2.125-2.128-2.172c-.194-.197-.191-.514.006-.707.198-.192.514-.192.707.008l2.122 2.164 2.168-2.168c.195-.195.512-.195.707 0z"],"clear_18":["M12.4 5.6c-.2-.2-.5-.2-.7 0L9 8.3 6.4 5.6c-.2-.2-.5-.2-.7 0s-.2.5 0 .7L8.3 9l-2.6 2.6c-.2.2-.2.5 0 .7.1.1.2.1.4.1.1 0 .3 0 .4-.1L9 9.7l2.6 2.6c.1.1.2.1.4.1.1 0 .3 0 .4-.1.2-.2.2-.5 0-.7L9.7 9l2.6-2.6c.2-.2.2-.6.1-.8z"],"clear_20":["M10 0c5.514 0 10 4.486 10 10 0 5.514-4.486 10-10 10-5.514 0-10-4.486-10-10C0 4.486 4.486 0 10 0zm0 19c4.963 0 9-4.037 9-9 0-4.963-4.037-9-9-9-4.963 0-9 4.037-9 9 0 4.963 4.037 9 9 9zm3.8535-12.8535c.195.195.195.512 0 .707l-3.146 3.147 3.146 3.146c.195.195.195.512 0 .707-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147l-3.147-3.146-3.146 3.146c-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147-.195-.195-.195-.512 0-.707l3.146-3.146-3.146-3.147c-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0l3.146 3.146 3.147-3.146c.195-.195.512-.195.707 0z"],"clear_24":["M12-.0001c6.627 0 12 5.373 12 12 0 6.627-5.373 12-12 12-6.627 0-12-5.373-12-12 0-6.627 5.373-12 12-12zm0 23c6.065 0 11-4.935 11-11 0-6.065-4.935-11-11-11-6.065 0-11 4.935-11 11 0 6.065 4.935 11 11 11zm3.8904-14.8203c.193.192.193.508 0 .701l-3.155 3.154 3.155 3.155c.193.192.193.508 0 .701-.193.192-.508.192-.701 0l-3.154-3.154-3.155 3.154c-.193.192-.508.192-.701 0-.193-.193-.193-.509 0-.701l3.155-3.155-3.155-3.154c-.193-.193-.193-.509 0-.701.193-.193.508-.193.701 0l3.155 3.154 3.154-3.154c.193-.193.508-.193.701 0z"],"clear_32":["M16 0c8.823 0 16 7.178 16 16 0 8.822-7.177 16-16 16-8.823 0-16-7.178-16-16C0 7.178 7.177 0 16 0zm0 31c8.271 0 15-6.729 15-15 0-8.271-6.729-15-15-15C7.729 1 1 7.729 1 16c0 8.271 6.729 15 15 15zm5.8535-20.8535c.195.195.195.512 0 .707l-5.146 5.147 5.146 5.146c.195.195.195.512 0 .707-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147l-5.147-5.146-5.146 5.146c-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147-.195-.195-.195-.512 0-.707l5.146-5.146-5.146-5.147c-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0l5.146 5.146 5.147-5.146c.195-.195.512-.195.707 0z"],"clear_44":["M22 0c12.131 0 22 9.869 22 22 0 12.131-9.869 22-22 22C9.869 44 0 34.131 0 22 0 9.869 9.869 0 22 0zm0 43c11.579 0 21-9.42 21-21 0-11.58-9.421-21-21-21C10.421 1 1 10.42 1 22c0 11.58 9.421 21 21 21zm7.8535-28.8535c.195.195.195.512 0 .707l-7.146 7.147 7.146 7.146c.195.195.195.512 0 .707-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147l-7.147-7.146-7.146 7.146c-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147-.195-.195-.195-.512 0-.707l7.146-7.146-7.146-7.147c-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0l7.146 7.146 7.147-7.146c.195-.195.512-.195.707 0z"],"clear-active_12":["M6 0c3.309 0 6 2.691 6 6 0 3.309-2.691 6-6 6-3.309 0-6-2.691-6-6 0-3.309 2.691-6 6-6zm1.8535 4.1465c-.195-.195-.512-.195-.707 0l-1.147 1.146-1.146-1.146c-.195-.195-.512-.195-.707 0-.195.195-.195.512 0 .707l1.146 1.147-1.146 1.146c-.195.195-.195.512 0 .707.098.098.226.147.353.147.128 0 .256-.049.354-.147l1.146-1.146 1.147 1.146c.098.098.226.147.353.147.128 0 .256-.049.354-.147.195-.195.195-.512 0-.707l-1.146-1.146 1.146-1.147c.195-.195.195-.512 0-.707z"],"clear-active_14":["M7 0c3.866 0 7 3.134 7 7 0 3.866-3.134 7-7 7-3.866 0-7-3.134-7-7 0-3.866 3.134-7 7-7zm2.8535 4.1465c-.195-.195-.512-.195-.707 0l-2.147 2.146-2.146-2.146c-.195-.195-.512-.195-.707 0-.195.195-.195.512 0 .707l2.146 2.147-2.146 2.146c-.195.195-.195.512 0 .707.098.098.226.147.353.147.128 0 .256-.049.354-.147l2.146-2.146 2.147 2.146c.098.098.226.147.353.147.128 0 .256-.049.354-.147.195-.195.195-.512 0-.707l-2.146-2.146 2.146-2.147c.195-.195.195-.512 0-.707z"],"clear-active_16":["M8 0c4.411 0 8 3.589 8 8 0 4.411-3.589 8-8 8-4.411 0-8-3.589-8-8 0-4.411 3.589-8 8-8zm2.8535 5.1465c-.195-.195-.512-.195-.707 0l-2.168 2.168-2.122-2.164c-.193-.2-.509-.2-.707-.008-.197.193-.2.51-.006.707l2.128 2.172-2.125 2.125c-.195.195-.195.512 0 .707.098.098.226.147.353.147.128 0 .256-.049.354-.147l2.118-2.118 2.071 2.114c.099.101.228.151.358.151.126 0 .253-.048.349-.143.198-.193.202-.51.008-.707l-2.079-2.122 2.175-2.175c.195-.195.195-.512 0-.707z"],"clear-active_18":["M9 0c4.963 0 9 4.038 9 9 0 4.962-4.037 9-9 9-4.963 0-9-4.038-9-9 0-4.962 4.037-9 9-9zm3.3535 5.6465c-.195-.195-.512-.195-.707 0l-2.647 2.646-2.646-2.646c-.195-.195-.512-.195-.707 0-.195.195-.195.512 0 .707l2.646 2.647-2.646 2.646c-.195.195-.195.512 0 .707.098.098.226.147.353.147.128 0 .256-.049.354-.147l2.646-2.646 2.647 2.646c.098.098.226.147.353.147.128 0 .256-.049.354-.147.195-.195.195-.512 0-.707l-2.646-2.646 2.646-2.647c.195-.195.195-.512 0-.707z"],"clear-active_24":["M12-.0001c6.627 0 12 5.373 12 12 0 6.627-5.373 12-12 12-6.627 0-12-5.373-12-12 0-6.627 5.373-12 12-12zm3.8904 8.1797c-.193-.193-.508-.193-.701 0l-3.154 3.154-3.155-3.154c-.193-.193-.508-.193-.701 0-.193.192-.193.508 0 .701l3.155 3.154-3.155 3.155c-.193.192-.193.508 0 .701.193.192.508.192.701 0l3.155-3.154 3.154 3.154c.193.192.508.192.701 0 .193-.193.193-.509 0-.701l-3.155-3.155 3.155-3.154c.193-.193.193-.509 0-.701z"],"clear-active_32":["M16 0c8.823 0 16 7.178 16 16 0 8.822-7.177 16-16 16-8.823 0-16-7.178-16-16C0 7.178 7.177 0 16 0zm5.8535 10.1465c-.195-.195-.512-.195-.707 0l-5.147 5.146-5.146-5.146c-.195-.195-.512-.195-.707 0-.195.195-.195.512 0 .707l5.146 5.147-5.146 5.146c-.195.195-.195.512 0 .707.098.098.226.147.353.147.128 0 .256-.049.354-.147l5.146-5.146 5.147 5.146c.098.098.226.147.353.147.128 0 .256-.049.354-.147.195-.195.195-.512 0-.707l-5.146-5.146 5.146-5.147c.195-.195.195-.512 0-.707z"],"close-space_12":["M10.16 1c1.015 0 1.839.824 1.84 1.838l0 .002 0 4.66 0 .002C11.999 8.328 11.327 9 10.5 9c-.277 0-.5-.224-.5-.5 0-.276.223-.5.5-.5.275 0 .5-.225.5-.5l0-4.66c0-.463-.376-.84-.84-.84L1.84 2c-.463 0-.84.377-.84.84L1 7.5c0 .275.224.5.5.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5C.673 9 0 8.327 0 7.5l0-4.66C0 1.825.825 1 1.84 1l8.32 0zm-6.5137 9.8535c-.195-.195-.195-.512 0-.707l1.646-1.646-1.646-1.647c-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0l1.646 1.646 1.647-1.646c.195-.195.512-.195.707 0 .195.195.195.512 0 .707l-1.646 1.647 1.646 1.646c.195.195.195.512 0 .707-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147l-1.647-1.646-1.646 1.646c-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147z"],"close-space_18":["M12.354 10.1465c.195.195.195.512 0 .707l-2.646 2.647 2.646 2.646c.195.195.195.512 0 .707-.195.195-.512.195-.707 0L9 14.2085l-2.646 2.645c-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147-.195-.195-.195-.512 0-.707l2.646-2.646-2.646-2.647c-.098-.098-.147-.226-.147-.353 0-.127.049-.256.147-.354.195-.195.512-.195.707 0L9 12.7925l2.647-2.646c.195-.195.512-.195.707 0zM16 1c1.103 0 1.999.896 2 1.998l0 10.005C17.999 14.104 17.103 15 16 15l-.5 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l.5 0c.552 0 1-.448 1-1l0-10c0-.551-.448-1-1-1L2 2c-.551 0-1 .449-1 1l0 10c0 .552.449 1 1 1l.5 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5L2 15c-1.103 0-2-.896-2-2L0 3c0-1.103.897-2 2-2l14 0z"],"closed-caption_12":["M10.5002 2c.825 0 1.5.675 1.5 1.5l0 5c0 .829-.672 1.5-1.5 1.5l-9 0c-.825 0-1.5-.675-1.5-1.5l0-5c0-.829.671-1.5 1.5-1.5l9 0zm.5 6.5l0-5c0-.271-.229-.5-.5-.5l-9 0c-.276 0-.5.224-.5.5l0 5c0 .271.229.5.5.5l9 0c.275 0 .5-.224.5-.5zM4.969 6.3711l.008-.116.94 0-.016.139c-.095.794-.609 1.23-1.448 1.23-.903 0-1.463-.625-1.463-1.632 0-1.012.559-1.616 1.496-1.616.751 0 1.286.423 1.394 1.105l.024.144-.919 0-.022-.099c-.061-.291-.218-.432-.477-.432-.363 0-.547.302-.547.898 0 .416.092.911.527.911.326 0 .477-.159.503-.532zm3.2842 0l.008-.116.94 0-.016.139c-.095.794-.609 1.23-1.448 1.23-.903 0-1.463-.625-1.463-1.632 0-1.012.559-1.616 1.496-1.616.751 0 1.286.423 1.394 1.105l.024.144-.919 0-.022-.099c-.061-.291-.218-.432-.477-.432-.363 0-.547.302-.547.898 0 .416.092.911.527.911.326 0 .477-.159.503-.532z"],"closed-caption_16":["M14.5 4c.825 0 1.5.675 1.5 1.5l0 5c0 .829-.672 1.5-1.5 1.5l-13 0C.675 12 0 11.325 0 10.5l0-5C0 4.671.672 4 1.5 4l13 0zm.5 6.5l0-5c0-.271-.229-.5-.5-.5l-13 0c-.276 0-.5.224-.5.5l0 5c0 .271.229.5.5.5l13 0c.276 0 .5-.224.5-.5zM6.9663 8.5332l.006-.105.764 0-.007.118c-.042.735-.674 1.516-1.76 1.516-1.136 0-1.843-.797-1.843-2.079 0-1.283.722-2.079 1.885-2.079.916 0 1.652.599 1.711 1.394l.01.119-.757 0-.013-.096c-.062-.462-.426-.749-.951-.749-.71 0-1.117.514-1.117 1.411 0 .88.406 1.405 1.086 1.405.543 0 .957-.359.986-.855zm4.1382 0l.006-.105.764 0-.007.118c-.042.735-.674 1.516-1.76 1.516-1.137 0-1.843-.797-1.843-2.079 0-1.283.722-2.079 1.885-2.079.916 0 1.652.599 1.711 1.394l.01.119-.757 0-.013-.096c-.062-.462-.426-.749-.951-.749-.71 0-1.117.514-1.117 1.411 0 .88.406 1.405 1.086 1.405.543 0 .957-.359.986-.855z"],"closed-caption_20":["M18 5c1.1 0 2 .9 2 2l0 6c0 1.104-.896 2-2 2L2 15c-1.1 0-2-.9-2-2l0-6c0-1.104.896-2 2-2l16 0zm1 8l0-6c0-.551-.449-1-1-1L2 6c-.551 0-1 .449-1 1l0 6c0 .551.449 1 1 1l16 0c.551 0 1-.449 1-1zM8.8408 10.6187l.007-.118.859 0-.008.133c-.047.827-.757 1.706-1.979 1.706-1.279 0-2.074-.897-2.074-2.34 0-1.443.813-2.339 2.121-2.339 1.03 0 1.858.674 1.925 1.568l.01.135-.851 0-.015-.109c-.069-.519-.479-.842-1.069-.842-.799 0-1.257.579-1.257 1.587 0 .991.456 1.582 1.222 1.582.61 0 1.076-.405 1.109-.963zm4.6553 0l.007-.118.859 0-.008.133c-.047.827-.757 1.706-1.979 1.706-1.279 0-2.074-.897-2.074-2.34 0-1.443.813-2.339 2.121-2.339 1.03 0 1.858.674 1.925 1.568l.01.135-.851 0-.015-.109c-.069-.519-.479-.842-1.069-.842-.799 0-1.257.579-1.257 1.587 0 .991.456 1.582 1.222 1.582.61 0 1.076-.405 1.109-.963z"],"cloud_16":["M7.4998 2.9998c-1.93 0-3.5 1.57-3.5 3.5 0 .249-.178.51-.424.545-1.469.21-2.576 1.48-2.576 2.955 0 1.654 1.346 3 3 3l7.5 0c1.93 0 3.5-1.57 3.5-3.5 0-1.927-1.565-3.494-3.49-3.5-.04.005-.132.014-.147.014-.228 0-.428-.155-.485-.376-.396-1.553-1.785-2.638-3.378-2.638m4 11l-7.5 0c-2.206 0-4-1.794-4-4 0-1.828 1.273-3.422 3.022-3.863.202-2.334 2.133-4.137 4.478-4.137 1.917 0 3.603 1.218 4.231 3.006 2.374.121 4.269 2.091 4.269 4.494 0 2.481-2.019 4.5-4.5 4.5"],"cloud_24":["M11 4C7.967 4 5.5 6.468 5.5 9.5c0 .241-.167.543-.405.587C2.722 10.521 1 12.587 1 15c0 2.757 2.243 5 5 5l11 0c3.309 0 6-2.691 6-6 0-3.309-2.691-6-6-6-.066 0-.13.005-.195.009l-.121.008c-.227.021-.425-.125-.498-.334C15.414 5.48 13.329 4 11 4m6 17L6 21c-3.309 0-6-2.691-6-6 0-2.756 1.872-5.135 4.507-5.808C4.668 5.75 7.519 3 11 3c2.627 0 4.991 1.593 5.995 4L17 7c3.86 0 7 3.141 7 7 0 3.859-3.14 7-7 7"],"cloud_32":["M23.233 27l-15.5 0C4.02 27 1 23.941 1 20.182c0-3.757 3.015-6.814 6.791-6.814l.007 0c.147.013.291-.056.39-.166.099-.109.144-.258.123-.404-.054-.375-.078-.687-.078-.98C8.233 8.059 11.254 5 14.966 5c3.363 0 6.229 2.545 6.668 5.92.018.132.087.252.193.333.106.08.24.118.371.098.395-.053.724-.079 1.035-.079 4.282 0 7.767 3.529 7.767 7.865C31 23.473 27.515 27 23.233 27m0-16.728c-.219 0-.442.011-.686.033C21.842 6.678 18.666 4 14.966 4c-4.264 0-7.733 3.507-7.733 7.818 0 .18.008.365.023.56C3.213 12.627 0 16.032 0 20.182 0 24.493 3.468 28 7.733 28l15.5 0C28.067 28 32 24.024 32 19.137c0-4.888-3.933-8.865-8.767-8.865"],"cloud-upload_16":["M11.5 13L8 13l0-5.293 2.146 2.147c.098.097.226.146.354.146.128 0 .256-.049.354-.146.195-.196.195-.512 0-.708l-3-3c-.196-.195-.512-.195-.708 0l-3 3c-.195.196-.195.512 0 .708.196.195.512.195.708 0L7 7.707 7 13l-3 0c-1.654 0-3-1.346-3-3 0-1.475 1.107-2.745 2.576-2.955C3.822 7.01 4 6.749 4 6.5 4 4.57 5.57 3 7.5 3c1.593 0 2.982 1.085 3.378 2.638.057.221.257.376.485.376.015 0 .107-.009.147-.014C13.435 6.006 15 7.573 15 9.5c0 1.93-1.57 3.5-3.5 3.5m.231-7.994C11.103 3.218 9.417 2 7.5 2 5.155 2 3.224 3.803 3.021 6.137 1.273 6.578.001 8.17 0 9.997l0 .005C.001 12.207 1.795 14 4 14l7.5 0c2.481 0 4.5-2.019 4.5-4.5 0-2.403-1.896-4.373-4.269-4.494"],"cloud-upload_20":["M14 16l-4 0 0-7.293 3.146 3.147c.098.097.226.146.354.146.128 0 .256-.049.354-.146.195-.196.195-.512 0-.708l-4-4c-.196-.195-.512-.195-.708 0l-4 4c-.195.196-.195.512 0 .708.196.195.512.195.708 0L9 8.707 9 16l-4 0c-2.206 0-4-1.794-4-4 0-1.88 1.284-3.482 3.122-3.896.232-.052.396-.261.39-.5-.001-.039-.006-.077-.012-.104C4.5 5.019 6.519 3 9 3c1.795 0 3.417 1.067 4.13 2.719.084.196.316.315.529.298.112-.008.226-.017.341-.017 2.757 0 5 2.243 5 5 0 2.757-2.243 5-5 5m0-11c-.034 0-.068 0-.103.001C12.961 3.167 11.076 2 9 2 6.056 2 3.646 4.325 3.506 7.234 1.422 7.881 0 9.786 0 12c0 2.757 2.243 5 5 5l9 0c3.309 0 6-2.691 6-6 0-3.309-2.691-6-6-6"],"company_16":["M13.9989 4.9998c1.103 0 2 .897 2 2l0 8c0 .552-.449 1-1 1l-9 0-.5 0-4.499 0c-.551 0-1-.448-1-1l0-13c0-1.103.897-2 2-2l4.999 0c1.103 0 2 .897 2 2l0 3 5 0zm1 10l0-8c0-.551-.449-1-1-1l-7 0c-.551 0-1 .449-1 1l0 8 9 0zm-4.5-3c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm-2 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm2-2c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm-2 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm4 2c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0-2c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0-2c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm-2 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm-2 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm-7.499-6l0 13 3.999 0 0-8c0-1.103.897-2 2-2l1 0 0-3c0-.551-.449-1-1-1l-4.999 0c-.551 0-1 .449-1 1zm4.499 2c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5zm-2-1c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5z"],"company_24":["M20.5 8c1.381 0 2.5 1.119 2.5 2.5L23 23c0 .552-.448 1-1 1L3 24c-.552 0-1-.448-1-1L2 2.5C2 1.119 3.119 0 4.5 0l8 0C13.881 0 15 1.119 15 2.5L15 8l5.5 0zM22 23l0-12.5c0-.827-.673-1.5-1.5-1.5l-12 0C7.673 9 7 9.673 7 10.5L7 23l15 0zM6 10.5C6 9.119 7.119 8 8.5 8L14 8l0-5.5c0-.827-.673-1.5-1.5-1.5l-8 0C3.673 1 3 1.673 3 2.5L3 23l3 0 0-12.5zm8.5 1.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm-4 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0-7c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5zm-4-1c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm12 8c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0 4c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0 4c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm-4-4c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0 4c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm-4-4c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0 4c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5z"],"company_32":["M27 11c1.657 0 3 1.343 3 3l0 17c0 .553-.447 1-1 1L3 32c-.552 0-1-.447-1-1L2 3c0-1.657 1.343-3 3-3l11 0c1.657 0 3 1.343 3 3l0 8 8 0zm2 20l0-17c0-1.103-.897-2-2-2l-16 0c-1.103 0-2 .897-2 2l0 17 20 0zM3 31l5 0 0-17c0-1.657 1.343-3 3-3l7 0 0-8c0-1.103-.897-2-2-2L5 1c-1.103 0-2 .897-2 2l0 28zM9 6c0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1 .552 0 1 .448 1 1zm4 1c-.552 0-1-.448-1-1 0-.552.448-1 1-1 .552 0 1 .448 1 1 0 .552-.448 1-1 1zm1 9c.552 0 1 .448 1 1 0 .553-.448 1-1 1-.552 0-1-.447-1-1 0-.552.448-1 1-1zm5 0c.553 0 1 .448 1 1 0 .553-.447 1-1 1-.553 0-1-.447-1-1 0-.552.447-1 1-1zm5 0c.553 0 1 .448 1 1 0 .553-.447 1-1 1-.553 0-1-.447-1-1 0-.552.447-1 1-1zm-10 5c.552 0 1 .447 1 1 0 .553-.448 1-1 1-.552 0-1-.447-1-1 0-.553.448-1 1-1zm5 0c.553 0 1 .447 1 1 0 .553-.447 1-1 1-.553 0-1-.447-1-1 0-.553.447-1 1-1zm5 0c.553 0 1 .447 1 1 0 .553-.447 1-1 1-.553 0-1-.447-1-1 0-.553.447-1 1-1zm-10 5c.552 0 1 .447 1 1 0 .553-.448 1-1 1-.552 0-1-.447-1-1 0-.553.448-1 1-1zm5 0c.553 0 1 .447 1 1 0 .553-.447 1-1 1-.553 0-1-.447-1-1 0-.553.447-1 1-1zm5 0c.553 0 1 .447 1 1 0 .553-.447 1-1 1-.553 0-1-.447-1-1 0-.553.447-1 1-1z"],"computer_16":["M9.5 3c.828 0 1.5.672 1.5 1.5l0 6c0 .828-.672 1.5-1.5 1.5L7 12l0 .5c0 .276-.224.5-.5.5l-2 0c-.276 0-.5-.224-.5-.5l0-.5-2.5 0C.672 12 0 11.328 0 10.5l0-6C0 3.672.672 3 1.5 3l8 0zm.5 6l0-4.5c0-.276-.224-.5-.5-.5l-8 0c-.276 0-.5.224-.5.5L1 9l9 0zm0 1.5l0-.5-9 0 0 .5c0 .276.224.5.5.5l3 0 2 0 3 0c.276 0 .5-.224.5-.5zM14.5 3c.828 0 1.5.672 1.5 1.5l0 7c0 .828-.672 1.5-1.5 1.5l-1 0c-.828 0-1.5-.672-1.5-1.5l0-7c0-.828.672-1.5 1.5-1.5l1 0zm.5 8.5l0-7c0-.276-.224-.5-.5-.5l-1 0c-.276 0-.5.224-.5.5l0 7c0 .276.224.5.5.5l1 0c.276 0 .5-.224.5-.5z"],"computer_24":["M15 4c1.103 0 2 .897 2 2l0 10c0 1.103-.897 2-2 2l-5 0 0 .5c0 .275.224.5.5.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-4 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5-.225.5-.5l0-.5-5 0c-1.103 0-2-.897-2-2L0 6c0-1.103.897-2 2-2l13 0zm1 10l0-8c0-.552-.449-1-1-1L2 5c-.551 0-1 .448-1 1l0 8 15 0zm0 2l0-1-15 0 0 1c0 .552.449 1 1 1l13 0c.551 0 1-.448 1-1zm-8.085 3l1.17 0C9.03 18.844 9 18.675 9 18.5l0-.5-1 0 0 .5c0 .175-.03.344-.085.5zM22 4c1.103 0 2 .897 2 2l0 12c0 1.103-.897 2-2 2l-2 0c-1.103 0-2-.897-2-2l0-12c0-1.103.897-2 2-2l2 0zm1 14l0-12c0-.552-.449-1-1-1l-2 0c-.551 0-1 .448-1 1l0 12c0 .552.449 1 1 1l2 0c.551 0 1-.448 1-1z"],"contact-card_10":["M8.7 1.0002c.718 0 1.3.582 1.3 1.3l0 5.4c0 .718-.582 1.3-1.3 1.3l-7.4 0c-.718 0-1.3-.582-1.3-1.3l0-5.4c0-.718.582-1.3 1.3-1.3l7.4 0zm.3 6.7l0-5.4c0-.165-.135-.3-.3-.3l-7.4 0c-.165 0-.3.135-.3.3l0 5.4c0 .165.135.3.3.3l7.4 0c.165 0 .3-.135.3-.3zM7.5 3.5c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0zm0 2c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0zm-4-.5c.276 0 .5-.225.5-.5 0-.275-.224-.5-.5-.5-.275 0-.5.225-.5.5 0 .275.225.5.5.5zm0-2C4.327 3 5 3.673 5 4.5c0 .344-.12.656-.314.908.106.144.193.308.23.504l.074.393c.032.177-.013.357-.126.494-.107.128-.262.201-.427.201L2.563 7c-.165 0-.321-.074-.427-.202-.113-.137-.158-.317-.125-.494l.073-.391c.037-.197.124-.361.231-.505C2.121 5.156 2 4.844 2 4.5 2 3.673 2.673 3 3.5 3z"],"contact-card_12":["M10.4999 1c.829 0 1.5.672 1.5 1.5l0 7c0 .828-.671 1.5-1.5 1.5l-9 0c-.828 0-1.5-.672-1.5-1.5l0-7c0-.828.672-1.5 1.5-1.5l9 0zm.5 8.5l0-7c0-.276-.224-.5-.5-.5l-9 0c-.276 0-.5.224-.5.5l0 7c0 .276.224.5.5.5l9 0c.276 0 .5-.224.5-.5zM6.6708 6.0724c.558.178.988.617 1.094 1.179l.225 1.134c.03.148-.008.299-.104.415-.094.116-.236.183-.386.183l-5 0c-.15 0-.291-.067-.386-.183-.095-.116-.133-.267-.104-.415l.226-1.139c.104-.551.523-.989 1.072-1.17-.2-.312-.32-.68-.32-1.076 0-1.103.897-2 2-2 1.103 0 2 .897 2 2 0 .395-.119.761-.317 1.072zm-3.562 1.911l3.782 0-.107-.542c-.05-.263-.333-.458-.659-.458l-2.249 0c-.327 0-.61.195-.659.453l-.108.547zm1.879-3.983c-.551 0-1 .448-1 1 0 .522.407.939.918.983l.164 0c.511-.044.918-.461.918-.983 0-.552-.449-1-1-1zM9.4999 3c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0zm0 2.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0z"],"contact-card_16":["M14.006 2.0002c1.101 0 1.994.902 1.994 2.009l0 7.982c0 1.11-.895 2.009-1.994 2.009l-12.012 0c-1.101 0-1.994-.903-1.994-2.009l0-7.982c0-1.111.895-2.009 1.994-2.009l12.012 0zm.994 9.991l0-7.982c0-.558-.448-1.009-.994-1.009l-12.012 0c-.546 0-.994.451-.994 1.009l0 7.982c0 .558.448 1.009.994 1.009l12.012 0c.546 0 .994-.451.994-1.009zM13.5 5c.276 0 .5.225.5.5 0 .275-.224.5-.5.5l-5 0c-.276 0-.5-.225-.5-.5 0-.275.224-.5.5-.5l5 0zM6.6698 8.094c.539.183.949.622 1.052 1.176l.221 1.134c.028.147-.01.299-.105.414-.095.116-.237.182-.386.182l-4.904 0c-.15 0-.291-.066-.386-.182-.095-.115-.134-.267-.105-.414l.222-1.14c.101-.55.512-.987 1.05-1.17-.207-.315-.329-.69-.329-1.094 0-1.104.897-2 2-2 1.103 0 2 .896 2 2 0 .404-.123.779-.33 1.094zM3.1538 10l3.691 0-.106-.545c-.048-.262-.321-.455-.636-.455l-2.206 0c-.315 0-.589.193-.636.45l-.107.55zm1.846-4c-.552 0-1 .449-1 1 0 .551.448 1 1 1 .551 0 1-.449 1-1 0-.551-.449-1-1-1zM13.5 10c.276 0 .5.225.5.5 0 .275-.224.5-.5.5l-3 0c-.276 0-.5-.225-.5-.5 0-.275.224-.5.5-.5l3 0zm0-2.5c.276 0 .5.225.5.5 0 .275-.224.5-.5.5l-4 0c-.276 0-.5-.225-.5-.5 0-.275.224-.5.5-.5l4 0z"],"contact-card_24":["M21.5 3C22.879 3 24 4.122 24 5.5l0 13c0 1.379-1.121 2.5-2.5 2.5l-19 0C1.121 21 0 19.879 0 18.5l0-13C0 4.122 1.121 3 2.5 3l19 0zM23 18.5l0-13c0-.827-.673-1.5-1.5-1.5l-19 0C1.673 4 1 4.673 1 5.5l0 13c0 .827.673 1.5 1.5 1.5l19 0c.827 0 1.5-.673 1.5-1.5zm-2.4839-7c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-6 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l6 0zM21 7.5c0 .276-.224.5-.5.5l-8 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l8 0c.276 0 .5.224.5.5zm-.5 8.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-4 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l4 0zm-8.5161.286c.039.169.007.345-.086.485-.099.145-.249.229-.413.229l-7.969 0c-.164 0-.315-.084-.413-.229-.094-.14-.125-.316-.086-.485l.312-1.343c.224-.964.934-1.677 1.804-1.879-.692-.64-1.133-1.547-1.133-2.564 0-1.933 1.567-3.5 3.5-3.5 1.933 0 3.5 1.567 3.5 3.5 0 1.017-.44 1.924-1.133 2.563.87.203 1.58.916 1.805 1.88l.312 1.343zM4.1099 16l6.78 0-.193-.83c-.159-.689-.706-1.17-1.328-1.17l-.214 0-3.31 0-.213 0c-.623 0-1.169.481-1.329 1.17l-.193.83zm.89-5.5c0 1.378 1.122 2.5 2.5 2.5 1.379 0 2.5-1.122 2.5-2.5 0-1.378-1.121-2.5-2.5-2.5-1.378 0-2.5 1.122-2.5 2.5z"],"content-download_12":["M6 0c3.30771429 0 6 2.69228571 6 6 0 3.30771429-2.69228571 6-6 6-3.30771429 0-6-2.69228571-6-6 0-3.30771429 2.69228571-6 6-6zm0 11c2.7575 0 5-2.2425 5-5 0-2.7575-2.2425-5-5-5-2.7575 0-5 2.2425-5 5 0 2.7575 2.2425 5 5 5zm.4995-4.7066l.645-.645c.195-.195.512-.195.707 0 .195.195.195.512 0 .707l-1.497 1.497c-.047.047-.103.084-.163.109-.062.025-.126.039-.192.039-.065 0-.129-.014-.191-.039-.06-.025-.116-.062-.163-.109l-1.505-1.505c-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0l.652.653 0-1.793c0-.277.224-.5.5-.5.277 0 .5.223.5.5l0 1.793z"],"content-download_14":["M7 0c3.859 0 7 3.141 7 7 0 3.859-3.141 7-7 7-3.859 0-7-3.141-7-7 0-3.859 3.141-7 7-7zm0 13c3.309 0 6-2.691 6-6 0-3.309-2.691-6-6-6-3.309 0-6 2.691-6 6 0 3.309 2.691 6 6 6zm.4995-4.7066l1.645-1.645c.195-.195.512-.195.707 0 .195.195.195.512 0 .707l-2.497 2.497c-.047.047-.103.084-.163.109-.062.025-.126.039-.192.039-.065 0-.129-.014-.191-.039-.06-.025-.116-.062-.163-.109l-2.505-2.505c-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0l1.652 1.653 0-3.793c0-.277.224-.5.5-.5.277 0 .5.223.5.5l0 3.793z"],"copy_10":["M7.667 2C8.401 2 9 2.598 9 3.333l0 5.334C9 9.402 8.401 10 7.666 10l-3.333 0C3.598 10 3 9.402 3 8.667l0-5.334C3 2.598 3.598 2 4.333 2l3.334 0zM8 8.667l0-5.334C8 3.149 7.85 3 7.666 3L4.333 3C4.149 3 4 3.149 4 3.333l0 5.334c0 .184.149.333.333.333l3.333 0C7.85 9 8 8.851 8 8.667zM6.5 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L2.333 1C2.149 1 2 1.149 2 1.333L2 7.5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-6.167C1 .598 1.598 0 2.333 0L6.5 0z"],"copy_12":["M1.5 9c-.276 0-.5-.224-.5-.5l0-7C1 .673 1.673 0 2.5 0l4 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-4 0c-.276 0-.5.225-.5.5l0 7c0 .276-.224.5-.5.5zm8 3l-5 0c-.827 0-1.5-.673-1.5-1.5l0-7C3 2.673 3.673 2 4.5 2l5 0c.827 0 1.5.673 1.5 1.5l0 7c0 .827-.673 1.5-1.5 1.5zm-5-9c-.276 0-.5.225-.5.5l0 7c0 .275.224.5.5.5l5 0c.276 0 .5-.225.5-.5l0-7c0-.275-.224-.5-.5-.5l-5 0z"],"copy_14":["M11 2c.829 0 1.5.671 1.5 1.5l0 9c0 .829-.671 1.5-1.5 1.5l-6 0c-.829 0-1.5-.671-1.5-1.5l0-9C3.5 2.671 4.171 2 5 2l6 0zm.5 10.5l0-9c0-.276-.224-.5-.5-.5L5 3c-.276 0-.5.224-.5.5l0 9c0 .276.224.5.5.5l6 0c.276 0 .5-.224.5-.5zm-3-12c0 .275-.225.5-.5.5L3 1c-.276 0-.5.224-.5.5l0 8c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-8C1.5.671 2.171 0 3 0l5 0c.275 0 .5.225.5.5z"],"copy_16":["M9.5 1L4 1c-.552 0-1 .448-1 1l0 8.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5L2 2c0-1.103.897-2 2-2l5.5 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5zM12 2c1.103 0 2 .897 2 2l0 10c0 1.103-.897 2-2 2l-6 0c-1.103 0-2-.897-2-2L4 4c0-1.103.897-2 2-2l6 0zm1 12l0-10c0-.552-.448-1-1-1L6 3c-.552 0-1 .448-1 1l0 10c0 .552.448 1 1 1l6 0c.552 0 1-.448 1-1z"],"copy_20":["M15.5 4l-7 0C7.119 4 6 5.119 6 6.5l0 11C6 18.881 7.119 20 8.5 20l7 0c1.381 0 2.5-1.119 2.5-2.5l0-11C18 5.119 16.881 4 15.5 4m0 1c.827 0 1.5.673 1.5 1.5l0 11c0 .827-.673 1.5-1.5 1.5l-7 0c-.827 0-1.5-.673-1.5-1.5l0-11C7 5.673 7.673 5 8.5 5l7 0zm-2-5c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-9 0C3.673 1 3 1.673 3 2.5l0 12c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-12C2 1.119 3.119 0 4.5 0l9 0z"],"copy_24":["M18.5 5l-9 0C8.119 5 7 6.119 7 7.5l0 13C7 21.881 8.119 23 9.5 23l9 0c1.381 0 2.5-1.119 2.5-2.5l0-13C21 6.119 19.881 5 18.5 5m0 1c.827 0 1.5.673 1.5 1.5l0 13c0 .827-.673 1.5-1.5 1.5l-9 0c-.827 0-1.5-.673-1.5-1.5l0-13C8 6.673 8.673 6 9.5 6l9 0zm-5-5c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-8 0C4.673 2 4 2.673 4 3.5l0 14c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-14C3 2.119 4.119 1 5.5 1l8 0z"],"crop_16":["M15.5 13c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L4 14c-1.105 0-2-.896-2-2l0-9L.5 3C.225 3 0 2.775 0 2.5c0-.275.225-.5.5-.5L2 2 2 .5c0-.275.225-.5.5-.5.275 0 .5.225.5.5L3 12c0 .552.449 1 1 1l9 0 0-9c0-.552-.449-1-1-1L4 3l0-1 8 0c1.105 0 2 .896 2 2l0 9 1.5 0zM13 15.5l0-.5 1 0 0 .5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5z"],"cucm-connection_24":["M12.0044 2.0898c-.169 0-.34.048-.49.145l-10.092 7.02c-.27.175-.422.456-.422.761l0 10.439c0 .877.713 1.591 1.59 1.591l18.819 0c.877 0 1.591-.714 1.591-1.591l0-10.439c0-.305-.153-.586-.409-.751l-10.12-7.04c-.138-.09-.302-.135-.467-.135m9.405 20.956l-18.819 0c-1.428 0-2.59-1.162-2.59-2.591l0-10.439c0-.646.323-1.24.865-1.591l10.092-7.021c.638-.415 1.446-.414 2.072-.009l10.12 7.04c.527.341.851.935.851 1.581l0 10.439c0 1.429-1.163 2.591-2.591 2.591zM5 18.045l0-5 14 0 0 5-14 0zm14.5 1c.276 0 .5-.224.5-.5l0-6c0-.276-.224-.5-.5-.5l-15 0c-.276 0-.5.224-.5.5l0 6c0 .276.224.5.5.5l15 0zm-5-4.0001c-.275 0-.5.225-.5.5 0 .275.225.5.5.5l2 0c.275 0 .5-.225.5-.5 0-.275-.225-.5-.5-.5l-2 0z"],"data-usage_16":["M13.2842 12.5771l-1.401-1.401c-.011-.011-.024-.014-.035-.023.708-.864 1.152-1.952 1.152-3.153 0-1.201-.444-2.29-1.152-3.153.011-.009.024-.013.035-.023l1.401-1.401c1.065 1.228 1.716 2.826 1.716 4.577 0 1.75-.651 3.348-1.716 4.577m-5.284 2.423c-3.86 0-7-3.14-7-7l2 0c0 2.757 2.243 5 5 5 1.201 0 2.289-.444 3.153-1.152.009.011.012.024.023.035l1.401 1.401c-1.229 1.065-2.827 1.716-4.577 1.716m4-7c0 2.205-1.795 4-4 4-2.206 0-4-1.795-4-4 0-2.206 1.794-4 4-4 2.205 0 4 1.794 4 4m-4-7c1.75 0 3.348.65 4.577 1.716l-1.401 1.401c-.011.01-.014.024-.023.035-.864-.709-1.952-1.152-3.153-1.152-2.415 0-4.434 1.721-4.899 4l-2.021 0c.487-3.387 3.4-6 6.92-6m0-1c-4.411 0-8 3.589-8 8 0 4.411 3.589 8 8 8 4.411 0 8-3.589 8-8 0-4.411-3.589-8-8-8"],"data-usage_18":["M1.0254 9.5l2 0c.255 3.075 2.835 5.5 5.975 5.5 1.474 0 2.824-.537 3.87-1.423l1.413 1.414C12.8724 16.237 11.0254 17 9.0004 17c-4.243 0-7.715-3.322-7.975-7.5M9.0004 1c2.025 0 3.872.763 5.283 2.009l-1.413 1.414C11.8244 3.537 10.4744 3 9.0004 3c-3.14 0-5.72 2.425-5.975 5.5l-2 0c.26-4.178 3.732-7.5 7.975-7.5m5 8c0 2.757-2.243 5-5 5-2.757 0-5-2.243-5-5 0-2.757 2.243-5 5-5 2.757 0 5 2.243 5 5m.99 5.284l-1.413-1.414c.886-1.045 1.423-2.395 1.423-3.87 0-1.475-.537-2.825-1.423-3.87l1.413-1.414c1.246 1.411 2.01 3.258 2.01 5.284 0 2.026-.764 3.873-2.01 5.284M9.0004 0c-4.963 0-9 4.038-9 9 0 4.962 4.037 9 9 9 4.962 0 9-4.038 9-9 0-4.962-4.038-9-9-9"],"data-usage_20":["M1.0254 10.5l2.975 0c.008 0 .016-.005.025-.005.253 3.077 2.833 5.505 5.975 5.505 1.474 0 2.824-.537 3.87-1.423l2.12 2.121c-1.593 1.426-3.689 2.302-5.99 2.302-4.794 0-8.713-3.771-8.975-8.5m8.975-9.5c2.301 0 4.397.876 5.99 2.302l-2.12 2.121C12.8244 4.537 11.4744 4 10.0004 4c-3.142 0-5.722 2.428-5.975 5.505-.009 0-.017-.005-.025-.005l-2.975 0c.262-4.729 4.181-8.5 8.975-8.5m5 9c0 2.757-2.243 5-5 5-2.757 0-5-2.243-5-5 0-2.757 2.243-5 5-5 2.757 0 5 2.243 5 5m1.697 5.991l-2.12-2.121c.886-1.045 1.423-2.395 1.423-3.87 0-1.475-.537-2.825-1.423-3.87l2.12-2.121c1.427 1.594 2.303 3.689 2.303 5.991 0 2.302-.876 4.397-2.303 5.991M10.0004 0c-5.514 0-10 4.486-10 10 0 5.514 4.486 10 10 10 5.514 0 10-4.486 10-10 0-5.514-4.486-10-10-10"],"data-usage_24":["M1.0254 12.5l3 0c.26 4.178 3.732 7.5 7.975 7.5 2.025 0 3.872-.764 5.283-2.009l2.121 2.12c-1.957 1.787-4.551 2.889-7.404 2.889-5.897 0-10.711-4.668-10.975-10.5M12.0004 1c2.853 0 5.447 1.102 7.404 2.889l-2.121 2.12C15.8724 4.764 14.0254 4 12.0004 4c-4.243 0-7.715 3.322-7.975 7.5l-3 0C1.2894 5.668 6.1034 1 12.0004 1m7 11c0 3.859-3.141 7-7 7-3.86 0-7-3.141-7-7 0-3.859 3.14-7 7-7 3.859 0 7 3.141 7 7m1.111 7.404l-2.121-2.12c1.246-1.411 2.01-3.258 2.01-5.284 0-2.026-.764-3.873-2.01-5.284l2.121-2.12c1.788 1.957 2.889 4.55 2.889 7.404 0 2.854-1.101 5.447-2.889 7.404M12.0004 0c-6.617 0-12 5.383-12 12 0 6.617 5.383 12 12 12 6.616 0 12-5.383 12-12 0-6.617-5.384-12-12-12"],"default-app_16":["M15 2.9956l-14 0 0-.996c0-.551.449-1 1-1l12 0c.551 0 1 .449 1 1l0 .996zm0 11.004c0 .552-.449 1-1 1l-12 0c-.551 0-1-.448-1-1l0-10.004 14 0 0 10.004zm-1-14l-12 0c-1.104 0-2 .896-2 2l0 .996 0 1 0 10.004c0 1.105.896 2 2 2l12 0c1.104 0 2-.895 2-2l0-12c0-1.104-.896-2-2-2z"],"delete_10":["M8.1401 3.9999c.237 0 .462.102.618.278.152.174.223.404.193.631l-.812 3.887c-.085.67-.705 1.204-1.436 1.204l-3.406 0c-.724 0-1.339-.523-1.44-1.221l-.802-3.832c-.036-.265.035-.495.187-.669.156-.176.381-.278.618-.278l6.28 0zm-.986 4.629l.758-3.629-5.825 0 .753 3.591c.002.013.004.025.006.038.027.212.221.371.451.371l3.406 0c.23 0 .424-.159.451-.371zM1.5 3c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5L3 2l0-.5C3 .675 3.675 0 4.5 0l1 0C6.325 0 7 .675 7 1.5L7 2l1.5 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-7 0zM4 1.5L4 2l2 0 0-.5c0-.271-.229-.5-.5-.5l-1 0c-.271 0-.5.229-.5.5z"],"delete_12":["M9.1775 4c.244 0 .475.103.631.283.148.17.215.394.184.614l-.815 5.905c-.094.683-.719 1.198-1.454 1.198l-3.447 0c-.735 0-1.36-.515-1.454-1.198l-.815-5.906c-.03-.22.037-.444.185-.613.156-.18.386-.283.63-.283l6.355 0zm-.99 6.665L8.9685 5l-5.938 0 .782 5.665.001.001c.025.187.229.334.463.334l3.447 0c.235 0 .438-.148.464-.335zM2.5 3c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1.525 0C4.015 1.959 4 1.919 4 1.875l0-.687C4 .533 4.533 0 5.187 0l1.625 0C7.468 0 8 .533 8 1.188l0 .687c0 .044-.015.084-.025.125L9.5 2c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-7 0zM5 1.875c0 .044-.015.084-.025.125l2.05 0C7.015 1.959 7 1.919 7 1.875l0-.687C7 1.084 6.916 1 6.812 1L5.187 1C5.084 1 5 1.084 5 1.188l0 .687z"],"delete_14":["M11.08512791 4.00171433c.26398628 0 .51497324.11300323.6889642.30900883.17099111.19500558.25098699.45401298.21898862.71002029l-1.04994544 7.48121375C10.8351409 13.3529815 10.09217951 14 9.21522507 14l-4.43076976 0c-.87495453 0-1.61791593-.6450184-1.72891016-1.5000429L2.0075996051 5.02774365c-.0329982853-.26300751.0469975579-.52201491.2179886729-.71702049.173990959-.1960056.424977917-.30900883.687964251-.30900883l8.171575381 0zM9.95218678 12.3689534l1.03294632-7.36721049-7.97058582 0 1.03194638 7.36121029c0 .0020001 0 .0040001.00099995.0060002.04499766.3590103.36198119.631018.7369617.631018l4.43076976 0c.37498052 0 .69196405-.2720077.73696171-.631018zM2.49997402 2.99908569C2.223988361 2.99908569 2 2.77607932 2 2.4990714c0-.27600788.223988361-.50001428.49997402-.50001428l2.4998701 0 0-.68701963C4.99984412.5880168 5.59081341 0 6.31777563 0l1.36392913 0c.72696223 0 1.31793152.5880168 1.31793152 1.31203749l0 .68701963 2.4998701 0c.27598565 0 .49997402.2240064.49997402.50001428 0 .27700792-.22398837.50001429-.49997402.50001429l-8.99953236 0zm3.49981814-1.6870482l0 .68701963 1.99989608 0 0-.68701963c0-.17200492-.14299257-.31200892-.31798348-.31200892l-1.36392913 0c-.1749909 0-.31798347.140004-.31798347.31200892z"],"delete_16":["M12.4994 2c.277 0 .5.224.5.5 0 .276-.223.5-.5.5l-9 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1.5 0 0-.611c0-.766.623-1.389 1.389-1.389l3.222 0c.766 0 1.389.623 1.389 1.389l0 .611 1.5 0zm-2.5 0l0-.611c0-.214-.175-.389-.389-.389l-3.222 0c-.214 0-.389.175-.389.389l0 .611 4 0zm1.9128 2c.586 0 1.045.5.997 1.083l-.757 9.083c-.087 1.037-.953 1.834-1.994 1.834l-4.318 0c-1.04 0-1.907-.797-1.993-1.834l-.757-9.083C3.0412 4.5 3.5012 4 4.0862 4l7.826 0zm-.757 10.083L11.9122 5l-7.826 0 .757 9.083c.043.515.481.917.997.917l4.318 0c.516 0 .954-.402.997-.917z"],"delete_18":["M13.9335 3.9996c.277 0 .545.122.733.333.201.225.295.529.26.833l-1.265 10.968c-.123 1.064-.977 1.866-1.986 1.866l-5.351 0c-1.009 0-1.863-.802-1.986-1.866l-1.265-10.968c-.035-.304.059-.608.26-.833.188-.211.456-.333.733-.333l9.867 0zm-1.266 12.019l1.266-10.968-9.867-.051 1.266 11.019c.064.56.491.981.992.981l5.351 0c.501 0 .928-.421.992-.981zM3.5 2.9995c-.276 0-.5-.223-.5-.5 0-.276.224-.5.5-.5l2.5 0 0-.437c0-.861.701-1.562 1.562-1.562l2.876 0c.861 0 1.562.701 1.562 1.562l0 .437 2.5 0c.276 0 .5.224.5.5 0 .277-.224.5-.5.5l-11 0zM7 1.5625l0 .437 4 0 0-.437c0-.311-.252-.562-.562-.562l-2.876 0c-.31 0-.562.251-.562.562z"],"delete_20":["M15.859 3.99984c.316 0 .616.13500135.824.37100371.205.23200232.3.54200542.261.84700847L15.442 18.0249802C15.298 19.1529915 14.325 20 13.178 20l-6.355 0c-1.148 0-2.121-.8470085-2.264-1.9700197 0-.002 0-.004-.001-.0050001L3.056 5.21385214c-.039-.30100301.056-.61100611.261-.84300843.208-.23600236.508-.37100371.824-.37100371l11.718 0zm-1.41 13.903139l1.502-12.80712804-.092-.09600096-11.718 0c.001.00200002-.092.09500095-.092.09600096L5.551 17.9059791c.081.6240062.627 1.0940109 1.272 1.0940109l6.355 0c.645 0 1.191-.4720047 1.271-1.097011zM3.5 2.99902999c-.276 0-.5-.22300223-.5-.500005 0-.27600276.224-.500005.5-.500005l3.5 0 0-.31200312C7 .75600756 7.757 0 8.687 0l2.626 0C12.243 0 13 .75600756 13 1.68701687l0 .31200312 3.5 0c.276 0 .5.22400224.5.500005 0 .27700277-.224.500005-.5.500005l-13 0zM8 1.68701687l0 .31200312 4 0 0-.31200312c0-.37900379-.308-.68700687-.687-.68700687l-2.626 0c-.379 0-.687.30800308-.687.68700687z"],"delete_24":["M18.81 6.0001c.337 0 .66.146.884.4.231.261.339.61.296.957l-1.746 14.342c-.16 1.312-1.257 2.301-2.551 2.301l-7.386 0c-1.294 0-2.391-.989-2.551-2.301L4.01 7.3571c-.043-.347.065-.696.296-.957.224-.254.548-.4.884-.4l13.62 0zm-1.558 15.578l1.746-14.342c.011-.087-.028-.146-.053-.173-.025-.028-.069-.063-.135-.063l-13.62 0c-.066 0-.11.035-.135.063-.025.027-.064.086-.053.173l1.746 14.342c.1.811.77 1.422 1.559 1.422l7.386 0c.789 0 1.459-.611 1.559-1.422zM4.5 4c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5L8 3l0-1c0-1.103.872-2 1.943-2l4.114 0C15.128 0 16 .897 16 2l0 1 3.5 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-15 0zM9 2l0 1 6 0 0-1c0-.551-.423-1-.943-1L9.943 1C9.423 1 9 1.449 9 2z"],"deskphone_12":["M1.5 1C2.325 1 3 1.675 3 2.5l0 7c0 .825-.675 1.5-1.5 1.5C.675 11 0 10.325 0 9.5l0-7C0 1.675.675 1 1.5 1zM2 9.5l0-7c0-.271-.229-.5-.5-.5-.271 0-.5.229-.5.5l0 7c0 .271.229.5.5.5.271 0 .5-.229.5-.5zM10.5 1c.825 0 1.5.675 1.5 1.5l0 7c0 .825-.675 1.5-1.5 1.5l-5 0C4.675 11 4 10.325 4 9.5l0-7C4 1.675 4.675 1 5.5 1l5 0zm.5 3l0-1.5c0-.271-.229-.5-.5-.5l-5 0c-.271 0-.5.229-.5.5L5 4l6 0zm0 5.5L11 5 5 5l0 4.5c0 .271.229.5.5.5l5 0c.271 0 .5-.229.5-.5zM7 7c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5zm2 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5zM7 9c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5zm2 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5z"],"deskphone_16":["M2 2.002c1.105 0 2 .895 2 2l0 8c0 1.105-.895 2-2 2-1.105 0-2-.895-2-2l0-8c0-1.105.895-2 2-2zm1 10l0-8c0-.551-.449-1-1-1-.551 0-1 .449-1 1l0 8c0 .551.449 1 1 1 .551 0 1-.449 1-1zM6.99201702 2L14.007983 2C15.1081436 2 16 2.901950359 16 4.0085302l0 7.9829396C16 13.1007504 15.0998238 14 14.007983 14l-7.01596598 0C5.8918564 14 5 13.0980496 5 11.9914698l0-7.9829396C5 2.899249601 5.90017617 2 6.99201702 2zM6 11.9914698C6 12.548743 6.44713164 13 6.99201702 13l7.01596598 0C14.5492058 13 15 12.5467763 15 11.9914698l0-7.9829396C15 3.45125696 14.5528684 3 14.007983 3L6.99201702 3C6.45079424 3 6 3.45322366 6 4.0085302l0 7.9829396zM8.5 10.002c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5zm2 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5zm2 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5zm-4 2c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5zm2 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5zm2 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5zM6 7l9 0 0 1-9 0 0-1z"],"deskphone_20":["M2 2c1.1 0 2 .9 2 2l0 12c0 1.1-.9 2-2 2-1.1 0-2-.9-2-2L0 4c0-1.1.9-2 2-2zm1 14L3 4c0-.551-.449-1-1-1-.551 0-1 .449-1 1l0 12c0 .551.449 1 1 1 .551 0 1-.449 1-1zM17.5 2C18.881 2 20 3.119 20 4.5L20 9l0 1 0 5.5c0 1.381-1.119 2.5-2.5 2.5l-10 0C6.119 18 5 16.881 5 15.5L5 10l0-1 0-4.5C5 3.119 6.119 2 7.5 2l10 0zM6 9l13 0 0-4.5c0-.827-.673-1.5-1.5-1.5l-10 0C6.673 3 6 3.673 6 4.5L6 9zm13 6.5l0-5.5-13 0 0 5.5c0 .827.673 1.5 1.5 1.5l10 0c.827 0 1.5-.673 1.5-1.5zM12.5 13c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5zm0 2c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5zm-3 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5zm0-2c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5zm6 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5zm0 2c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5z"],"deskphone_24":["M21.5 3C22.878 3 24 4.122 24 5.5l0 13c0 1.378-1.122 2.5-2.5 2.5l-13 0C7.122 21 6 19.878 6 18.5l0-13C6 4.122 7.122 3 8.5 3l13 0zm0 17c.827 0 1.5-.673 1.5-1.5l0-7.5-16 0 0 7.5c0 .827.673 1.5 1.5 1.5l13 0zM8.5 4C7.673 4 7 4.673 7 5.5L7 10l16 0 0-4.5c0-.827-.673-1.5-1.5-1.5l-13 0zM15 16.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0-3c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm-3 3c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0-3c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm6 3c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0-3c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zM2.5 3C3.875 3 5 4.125 5 5.5l0 13C5 19.875 3.875 21 2.5 21 1.125 21 0 19.875 0 18.5l0-13C0 4.125 1.125 3 2.5 3zM4 18.5l0-13C4 4.673 3.327 4 2.5 4 1.673 4 1 4.673 1 5.5l0 13c0 .827.673 1.5 1.5 1.5.827 0 1.5-.673 1.5-1.5z"],"deskphone_32":["M3.5 4C5.425 4 7 5.575 7 7.5l0 17C7 26.425 5.425 28 3.5 28 1.575 28 0 26.425 0 24.5l0-17C0 5.575 1.575 4 3.5 4zM6 24.5l0-17C6 6.121 4.878 5 3.5 5 2.122 5 1 6.121 1 7.5l0 17C1 25.878 2.122 27 3.5 27 4.878 27 6 25.878 6 24.5zM12.0068483 4l16.9863034 0C30.6537881 4 32 5.34177063 32 6.99109042l0 18.01781918C32 26.6608432 30.6640085 28 28.9931517 28l-16.9863034 0C10.3462119 28 9 26.6582294 9 25.0089096L9 6.99109042C9 5.33915679 10.3359915 4 12.0068483 4zM10 25.0089096C10 26.1058035 10.8983651 27 12.0068483 27l16.9863034 0C30.1088429 27 31 26.1114269 31 25.0089096l0-18.01781918C31 5.89419647 30.1016349 5 28.9931517 5L12.0068483 5C10.8911571 5 10 5.88857306 10 6.99109042l0 18.01781918zM10 13l21 0 0 1-21 0 0-1zm7.5 4c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm3 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm3 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm-6 3c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm3 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm3 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm-6 3c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm3 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm3 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5z"],"deskphone_48":["M46 19.5002l0 19c0 2.481-2.019 4.5-4.5 4.5l-22 0c-2.481 0-4.5-2.019-4.5-4.5l0-29c0-2.481 2.019-4.5 4.5-4.5l22 0c2.481 0 4.5 2.019 4.5 4.5l0 10zm-4.5 22.5c1.93 0 3.5-1.57 3.5-3.5l0-18.5-29 0 0 18.5c0 1.93 1.57 3.5 3.5 3.5l22 0zm-6.3501-16.8501c.19-.19.52-.19.7 0 .1.09.15.22.15.35 0 .06-.01.13-.04.19-.02.06-.06.12-.11.16-.09.1-.22.15-.35.15-.13 0-.26-.05-.35-.15-.1-.09-.15-.22-.15-.35 0-.13.05-.26.15-.35zm-4.3003 0c.05.04.09.1.11.16.03.06.04.12.04.19 0 .13-.05.26-.15.35-.04.05-.1.09-.16.11-.06.03-.12.04-.19.04-.13 0-.26-.05-.35-.15-.1-.09-.15-.22-.15-.35 0-.13.05-.26.15-.35.04-.05.1-.09.16-.11.12-.05.26-.05.38 0 .06.02.12.06.16.11zm4.8403 4.8901c.06.02.12.06.16.11.1.09.15.22.15.35 0 .13-.05.26-.15.35-.04.05-.1.09-.16.11-.06.03-.13.04-.19.04-.13 0-.26-.05-.35-.15-.1-.09-.15-.22-.15-.35 0-.13.05-.26.15-.35.13-.14.35-.19.54-.11zm-4.8403.1099c.05.04.09.1.11.16.03.06.04.12.04.19 0 .07-.01.13-.04.19-.02.06-.06.12-.11.16-.09.1-.22.15-.35.15-.06 0-.13-.01-.19-.04-.06-.02-.12-.06-.16-.11-.05-.04-.09-.1-.11-.16-.03-.06-.04-.12-.04-.19 0-.13.05-.26.15-.35.04-.05.1-.09.16-.11.12-.05.26-.05.38 0 .06.02.12.06.16.11zm-5-5.002c.05.04.09.1.11.16.03.06.04.12.04.19 0 .13-.05.26-.15.35-.09.1-.22.15-.35.15-.06 0-.13-.01-.19-.04-.06-.02-.12-.06-.16-.11-.1-.09-.15-.22-.15-.35 0-.13.05-.26.15-.35.04-.05.1-.09.16-.11.18-.08.4-.03.54.11zm-.1597 4.8897c.06.02.12.06.16.11.1.09.15.22.15.35 0 .07-.01.13-.04.19-.02.06-.06.12-.11.16-.04.05-.1.09-.16.11-.06.03-.13.04-.19.04-.07 0-.13-.01-.19-.04-.06-.02-.12-.06-.16-.11-.05-.04-.09-.1-.11-.16-.03-.06-.04-.12-.04-.19 0-.07.01-.13.04-.19.02-.06.06-.12.11-.16.04-.05.1-.09.16-.11.12-.05.26-.05.38 0zm10 5.0024c.06.02.12.06.16.11.1.09.15.22.15.35 0 .06-.01.13-.04.19-.02.06-.06.12-.11.16-.04.05-.1.09-.16.11-.06.03-.13.04-.19.04-.13 0-.26-.05-.35-.15-.05-.04-.09-.1-.11-.16-.03-.06-.04-.12-.04-.19 0-.13.05-.26.15-.35.13-.14.36-.19.54-.11zm-5 0c.06.02.12.06.16.11.1.09.15.22.15.35 0 .06-.01.13-.04.19-.02.06-.06.12-.11.16-.04.05-.1.09-.16.11-.06.03-.13.04-.19.04-.13 0-.26-.05-.35-.15-.05-.04-.09-.1-.11-.16-.03-.06-.04-.12-.04-.19 0-.13.05-.26.15-.35.13-.14.36-.19.54-.11zm-5-.002c.06.02.12.06.16.11.1.09.15.22.15.35 0 .06-.01.13-.04.19-.02.06-.06.12-.11.16-.04.05-.1.09-.16.11-.06.03-.13.04-.19.04-.13 0-.26-.05-.35-.15-.05-.04-.09-.1-.11-.16-.03-.06-.04-.12-.04-.19 0-.13.05-.26.15-.35.14-.14.36-.19.54-.11zM19.5 6.0002c-1.93 0-3.5 1.57-3.5 3.5l0 9.5 29 0 0-9.5c0-1.93-1.57-3.5-3.5-3.5l-22 0zm-13-1.0005c2.481 0 4.5 2.019 4.5 4.5l0 29c0 2.481-2.019 4.5-4.5 4.5-2.481 0-4.5-2.019-4.5-4.5l0-29c0-2.481 2.019-4.5 4.5-4.5zm3.5 33.5l0-29c0-1.929-1.57-3.5-3.5-3.5-1.93 0-3.5 1.571-3.5 3.5l0 29c0 1.93 1.57 3.5 3.5 3.5 1.93 0 3.5-1.57 3.5-3.5z"],"device-connection_12":["M1.5 1l9 0c.827 0 1.5.673 1.5 1.5l0 7c0 .827-.673 1.5-1.5 1.5l-4 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l4 0c.276 0 .5-.225.5-.5l0-7c0-.275-.224-.5-.5-.5l-9 0c-.276 0-.5.225-.5.5l0 2c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-2C0 1.673.673 1 1.5 1zm-1 9c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0-2C1.878 8 3 9.121 3 10.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5C2 9.673 1.327 9 .5 9 .224 9 0 8.776 0 8.5c0-.276.224-.5.5-.5zm0-2C2.981 6 5 8.019 5 10.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5C4 8.57 2.43 7 .5 7 .224 7 0 6.776 0 6.5c0-.276.224-.5.5-.5z"],"device-connection_14":["M12.5 12l-6 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l6 0c.276 0 .5-.225.5-.5l0-7c0-.275-.224-.5-.5-.5l-11 0c-.276 0-.5.225-.5.5l0 2c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-2C0 2.673.673 2 1.5 2l11 0c.827 0 1.5.673 1.5 1.5l0 7c0 .827-.673 1.5-1.5 1.5zM1 11.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5zm1.5.5c-.276 0-.5-.224-.5-.5 0-.827-.673-1.5-1.5-1.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5C1.878 9 3 10.121 3 11.5c0 .276-.224.5-.5.5zm2 0c-.276 0-.5-.224-.5-.5C4 9.57 2.43 8 .5 8 .224 8 0 7.776 0 7.5c0-.276.224-.5.5-.5C2.981 7 5 9.019 5 11.5c0 .276-.224.5-.5.5z"],"device-connection_16":["M14 2c1.103 0 2 .897 2 2l0 8c0 1.103-.897 2-2 2l-4.5 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l4.5 0c.551 0 1-.448 1-1l0-8c0-.552-.449-1-1-1L2 3c-.551 0-1 .448-1 1l0 .5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5L0 4c0-1.103.897-2 2-2l12 0zM.5 13c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0-3C2.43 10 4 11.57 4 13.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5C3 12.121 1.878 11 .5 11c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0-3C4.084 7 7 9.916 7 13.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5C6 10.468 3.533 8 .5 8 .224 8 0 7.776 0 7.5c0-.276.224-.5.5-.5z"],"device-connection_18":["M16 2c1.103 0 2 .897 2 2l0 10c0 1.103-.897 2-2 2l-4.5 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l4.5 0c.551 0 1-.449 1-1l0-10c0-.551-.449-1-1-1L2 3c-.551 0-1 .449-1 1l0 .5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5L0 4c0-1.103.897-2 2-2l14 0zM.5 15c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0-4C2.981 11 5 13.019 5 15.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5C4 13.57 2.43 12 .5 12c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0-4C5.187 7 9 10.813 9 15.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5C8 11.364 4.636 8 .5 8 .224 8 0 7.776 0 7.5c0-.276.224-.5.5-.5z"],"device-in-room_100":["M98.4351978 72.106c-.4579971.568-1.1309929.894-1.8449885.894L73.393354 73c-2.0529871-4.796-6.8019575-8-12.1829239-8l-5.6959645 0c6.1089619-2.254 10.4849346-8.118 10.4849346-15 0-1.027-.1059994-2.028-.2919982-3l26.3588355 0c1.135993 0 2.1019869.803 2.3499854 1.955l4.5239718 21c.1649989.765-.0189999 1.549-.5049969 2.151zM74.9663442 82.654c.0819995.323.011.661-.1959987.925-.2079987.267-.5229968.421-.8649946.421l-47.8107018 0c-.3419978 0-.6569959-.154-.8659946-.421-.2059987-.264-.2769982-.602-.1949987-.925l1.8709883-7.438C28.2706356 69.79 33.1576051 66 38.7895699 66l22.4208602 0c5.6319648 0 10.5189343 3.79 11.8849258 9.216l1.8709883 7.438zM3.40979068 73c-.71399555 0-1.38699135-.326-1.84498849-.894-.48599697-.602-.670995817-1.386-.50499685-2.151l4.52297178-21C5.83077557 47.803 6.79776954 47 7.93376245 47L34.291598 47c-.1849988.972-.2919982 1.973-.2919982 3 0 6.882 4.3769727 12.746 10.4859346 15l-5.6959645 0c-5.3809664 0-10.1299368 3.204-12.1829239 8L3.40979068 73zM17.1147052 39.265c.7799951-3.1 3.5729777-5.265 6.7909576-5.265l13.1889177 0c1.9409879 0 3.7119769.801 4.9919689 2.112-3.6999769 2.116-6.4669597 5.665-7.5599529 9.888l-19.2088801 0 1.7969888-6.735zM21.9996747 24.5c0-4.687 3.8129762-8.5 8.499947-8.5 4.6869707 0 8.4999469 3.813 8.4999469 8.5 0 4.686-3.8129762 8.5-8.4999469 8.5-4.6869708 0-8.499947-3.814-8.499947-8.5zM64.9994064 50c0 8.271-6.728958 15-14.9999064 15-8.2709484 0-14.9999064-6.729-14.9999064-15 0-8.272 6.728958-15 14.9999064-15 8.2709484 0 14.9999064 6.728 14.9999064 15zm-2.0939869-16l13.1889177 0c3.2179799 0 6.0099625 2.165 6.7929576 5.272L84.6822836 46l-19.2088801 0c-1.0929932-4.223-3.8609759-7.772-7.5609529-9.889 1.279992-1.31 3.050981-2.111 4.9929689-2.111zm-1.9059881-9.5c0-4.687 3.8129762-8.5 8.4999469-8.5 4.6869708 0 8.499947 3.813 8.499947 8.5 0 4.686-3.8129762 8.5-8.499947 8.5-4.6869707 0-8.4999469-3.814-8.4999469-8.5zm38.9187572 45.244l-4.5239718-21C95.046219 47.128 93.6772275 46 92.0662375 46l-6.3499603 0-1.8609884-6.979C82.9622943 35.476 79.7713143 33 76.0943372 33l-2.3779852 0c3.1259805-1.557 5.2829671-4.778 5.2829671-8.5 0-5.239-4.2609734-9.5-9.4999408-9.5-5.2379673 0-9.4999407 4.261-9.4999407 9.5 0 3.722 2.1579866 6.943 5.283967 8.5l-2.3779851 0c-2.3259855 0-4.4499723 1-5.926963 2.625C54.8664696 34.594 52.5034844 34 49.9995 34c-2.5039844 0-4.8669696.594-6.9789565 1.625C41.5415528 34 39.419566 33 37.0945805 33l-2.3779851 0c3.1259804-1.557 5.282967-4.778 5.282967-8.5 0-5.239-4.2609734-9.5-9.4999407-9.5-5.2379674 0-9.4999408 4.261-9.4999408 9.5 0 3.722 2.1579866 6.943 5.2839671 8.5l-2.3779852 0c-3.6769771 0-6.8679571 2.476-7.7589516 6.014L14.2837228 46l-6.34996035 0c-1.61098995 0-2.97998141 1.128-3.32797924 2.744l-4.5239717713 21c-.2289985717 1.062.0279998253 2.152.7049956013 2.99C1.43580299 73.539 2.39179703 74 3.40979068 74l22.81485762 0c-.1069993.318-.2059987.642-.2899982.972l-1.8709883 7.438c-.156999.625-.0199999 1.275.3759977 1.783.3999975.513 1.0029937.807 1.6549896.807l47.8107018 0c.6519959 0 1.2549921-.294 1.6549896-.807.3959976-.508.5329967-1.158.3759977-1.783l-1.8719883-7.438c-.0829995-.33-.1819989-.654-.2889982-.972l22.8148576 0c1.0179937 0 1.9739877-.461 2.6229837-1.266.6769957-.838.933994-1.928.7049956-2.99z"],"device-in-room_12":["M10.3320947 8.998c-.334-.494-.831-.841-1.40200001-.955.33800001-.426.54800001-.958.54800001-1.543 0-.171-.017-.337-.05-.498l3.074 0 .468 2.996-2.638 0zM4.03709469 11l.192-.937c.143-.626.641-1.063 1.21-1.063l3.078 0c.57000001 0 1.06800001.437 1.20700001 1.053l.196.947-5.88300001 0zm-2.563-5.002l3.055 0c-.033.162-.051.33-.051.502 0 .585.211 1.117.548 1.543-.57.114-1.067.461-1.402.959l-2.614 0 .464-3.004zm1.406-1.996l2.197 0c.261 0 .495.14.63.357-.278.166-.52.382-.715.639l-2.93 0 .09-.41c.085-.345.384-.586.728-.586zm1.098-3.002c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.551 0-1-.448-1-1 0-.552.449-1 1-1zm4.5 5.5c0 .827-.672 1.5-1.5 1.5-.827 0-1.5-.673-1.5-1.5 0-.827.673-1.5 1.5-1.5.828 0 1.5.673 1.5 1.5zm.402-2.498l2.19700001 0c.344 0 .643.241.725.575l.093.425-2.92800001 0c-.195-.259-.438-.476-.717-.643.135-.217.369-.357.63-.357zM9.9780947 1c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.551 0-1.00000001-.448-1.00000001-1 0-.552.44900001-1 1.00000001-1zm3.481 4.653c-.065-.286-.268-.507-.529-.601l-.155-.7c-.146-.6-.579-1.061-1.129-1.253.209-.316.332-.693.332-1.099 0-1.103-.897-2-2-2-1.10200001 0-2.00000001.897-2.00000001 2 0 .406.124.784.333 1.099-.444.155-.792.498-.994.935-.112-.015-.223-.034-.339-.034-.116 0-.227.019-.338.034-.202-.437-.55-.78-.994-.935.209-.316.332-.693.332-1.099 0-1.103-.897-2-2-2-1.102 0-2 .897-2 2 0 .406.124.784.333 1.1-.55.191-.984.655-1.132 1.262l-.155.703c-.249.103-.446.323-.511.619l-.511 3.301c-.057000003.249.003.505.162.704.158.199.395.313.65.313l2.407 0-.223 1.087c-.053.226 0 .46.142.639.137.173.34.272.557.272l6.56300001 0c.216 0 .42-.099.556-.272.143-.179.196-.413.146-.626l-.228-1.104 2.43 0c.254 0 .49-.113.649-.312.16-.197.219-.453.17-.67l-.524-3.363z"],"device-in-room_14":["M11.7546305 11.0019c-.3769885-.503-.9299716-.855-1.5629522-.965.4999847-.536.8119752-1.249.8119752-2.038 0-.351-.0719978-.684-.1839944-.997l3.2788997 0 .9009725 4-3.2449008 0zm-7.18078042 1.997l.21599339-.864c.1669949-.669.76597658-1.136 1.45495551-1.136l3.51689247 0c.68897895 0 1.28796065.467 1.45495555 1.136l.2159934.864-6.85879032 0zm-.32199016-1.997l-3.2509006 0 .89997248-4 3.28589953 0c-.11199657.313-.1829944.646-.1829944.997 0 .789.31199046 1.502.8109752 2.038-.63298064.11-1.18496377.462-1.56295221.965zm-1.54095288-5.357c.10499679-.373.51498425-.645.97397022-.645l2.63691937 0c.23799272 0 .45998594.075.63598055.197-.45498608.171-.85497385.448-1.17496407.803l-3.17190302 0 .09999695-.355zM5.00383693.9999c.82697471 0 1.49995414.673 1.49995414 1.5 0 .827-.67297943 1.5-1.49995414 1.5-.82797469 0-1.49995414-.673-1.49995414-1.5 0-.827.67197945-1.5 1.49995414-1.5zm5.99981657 0c.8269747 0 1.4999541.673 1.4999541 1.5 0 .827-.6729794 1.5-1.4999541 1.5-.8279747 0-1.49995416-.673-1.49995416-1.5 0-.827.67197946-1.5 1.49995416-1.5zm2.2919299 4.645l.0999969.355-3.171903 0c-.31999019-.355-.71897799-.632-1.17496405-.803.17599462-.122.39798783-.197.63598056-.197l2.63691939 0c.4589859 0 .8689734.272.9739702.645zm-7.29177705 2.354c0-1.103.89697258-2 1.99993885-2 1.10296628 0 1.9999389.897 1.9999389 2 0 1.103-.89697262 2-1.9999389 2-1.10296627 0-1.99993885-.897-1.99993885-2zm9.06972265-1.218c-.0759976-.337-.3139904-.595-.619981-.711l-.194994-.695c-.1759947-.627-.6959788-1.099-1.342959-1.284.360989-.433.587982-.984.587982-1.591 0-1.378-1.1219657-2.5-2.4999235-2.5-1.37895786 0-2.49992359 1.122-2.49992359 2.5 0 .607.22599309 1.158.58698206 1.591-.44898627.129-.8339745.394-1.08696677.758-.25399223-.364-.63898046-.629-1.08796673-.758.36098896-.433.58798202-.984.58798202-1.591 0-1.378-1.12196569-2.5-2.49992356-2.5-1.37895784 0-2.49992356 1.122-2.49992356 2.5 0 .607.22599309 1.158.58698205 1.591-.64698022.185-1.16696432.657-1.34295894 1.284l-.19399407.69c-.30999052.115-.55098315.377-.627980796.717l-.899972482 3.998c-.0689978903.299.0019999388.606.19199413.846.19099416.239.475985446.376.78197609.376l2.792914598 0-.26699183 1.065c-.05599829.226-.00699979.46.13599584.643.14299563.184.35898902.289.5919819.289l7.49977064 0c.231993 0 .4479863-.105.590982-.289.1429956-.183.1919941-.417.1359958-.643l-.2669918-1.065 2.7859148 0c.3059906 0 .5909819-.137.7809761-.376.1909942-.239.261992-.547.1949941-.844l-.9019725-4.001z"],"device-in-room_16":["M13.8727846 11.9946c-.4136864-1.167-1.4628909-1.964-2.674972-1.994.4816349-.532.7834061-1.231.7834061-2.004l0-.002 4.1388621 0 .8143825 4-3.0616787 0zm-9.21601285 2l.31076439-1.448c.21783485-.914.98925-1.552 1.87757651-1.552l4.28275305 0c.8883265 0 1.6597416.638 1.8745787 1.541l.3127629 1.459-8.65843555 0zm-3.657227251-1.995l.944284081-4.005 4.04793104 0c0 .001-.00099924.002-.00099924.002 0 .773.30177121 1.472.7844053 2.004-1.21008257.03-2.25728863.824-2.67497196 1.995l-3.100649221.004zm2.260286351-5.228c.09992424-.447.56357272-.772 1.10316363-.772l1.6677356 0c.22083257 0 .42867499.06.60853863.158-.19685076.251-.35373182.531-.46364848.837l-2.96675074 0 .05096136-.223zm1.76765984-3.772c.55158181 0 .99924242.449.99924242 1 0 .552-.44766061 1-.99924242 1-.55058258 0-.99924242-.448-.99924242-1 0-.551.44865984-1 .99924242-1zm5.95448561 4.997c0 1.102-.894322 1.998-1.99548715 1.998-1.1001659 0-1.99648635-.896-1.99648635-1.998 0-1.101.89632045-1.997 1.99648635-1.997 1.10116515 0 1.99548715.896 1.99548715 1.997zm2.0184696-4.992c.5515819 0 .9992425.448.9992425 1 0 .551-.4476606.999-.9992425.999-.5515818 0-.9992424-.448-.9992424-.999 0-.552.4476606-1 .9992424-1zm1.7686591 3.772l.0499621.218-3.0227083 0c-.1049204-.295-.2538075-.567-.4416651-.811.1868583-.112.4076909-.18.6425129-.18l1.6677356 0c.5395909 0 1.0042386.325 1.1041628.773zm2.3252371 1.042c-.1099166-.485-.5375924-.824-1.0392121-.824l-.2128386 0-.0979258-.437c-.1358969-.605-.5785613-1.093-1.1571227-1.352.2548068-.335.4116879-.748.4116879-1.201 0-1.103-.8973197-2-1.9984849-2-1.1021643 0-1.9984848.897-1.9984848 2 0 .41.1249053.791.3367447 1.108-.267797.081-.5206053.2-.7344432.369-.4666462-.302-1.02022649-.482-1.61777345-.482-.58155909 0-1.12214924.174-1.58180075.463-.20984091-.162-.45565454-.276-.71545757-.354.21283863-.318.33674469-.699.33674469-1.109 0-1.103-.89632045-2-1.99848483-2-1.10116515 0-1.99848484.897-1.99848484 2 0 .453.15688106.866.41168788 1.202-.57756212.258-1.02022651.746-1.15612348 1.351l-.098925.442-.24181667 0c-.49362575 0-.93029469.347-1.03921211.825l-.878334086 3.889c-.0709462117.312.0029977273.635.203845453.886.202846211.254.506615906.4.835366663.4l2.78388938 0-.21084015.988c-.05995455.249-.00299773.507.15488257.706.15288409.195.3817106.306.626525.306l9.1330757 0c.2448144 0 .4726417-.111.626525-.306.1578803-.199.2138379-.457.1578803-.696l-.2138379-.998 2.8108689 0c.3287508 0 .6325205-.146.8353667-.4.2008477-.251.2747917-.574.2038455-.886l-.8793334-3.89z"],"device-in-room_18":["M13.5553453 13c-.3695604-1.115-1.2814758-1.887-2.3532011-1.98.4884191-.534.7950544-1.237.7950544-2.016l4.223976.028.7800722 3.968-3.4459015 0zm-8.50188789 2l.28865668-1.457c.1997624-.908.89593437-1.543 1.69198755-1.543l3.95229916 0c.797052 0 1.4922251.635 1.6909887 1.533L12.967045 15l-7.91358759 0zM1.77635518 9l4.22897008 0c0 .781.30663529 1.487.79705199 2.021-1.05874073.1-1.96066799.872-2.33222606 1.979l-3.4498967 0 .75610069-4zm1.3214283-2.089C3.20365756 6.383 3.67010277 6 4.20846245 6l1.61408022 0c.51738462 0 .96085716.359 1.08870509.857-.32361509.317-.56732522.707-.72214108 1.143L2.88004246 8l.21774102-1.089zM5.01550256 3c.55034542 0 .99881201.448.99881201 1 0 .552-.44846659 1-.99881201 1-.55134424 0-.99881202-.448-.99881202-1 0-.552.44746778-1 .99881202-1zm5.98388274 6c0 1.103-.8959343 2-1.99762398 2-1.10168966 0-1.99762404-.897-1.99762404-2 0-1.103.89593438-2 1.99762404-2 1.10168968 0 1.99762398.897 1.99762398 2zm1.2025697-3l1.6140802 0c.5373609 0 1.0048049.384 1.110679.911L15.1434564 8l-3.3300393 0c-.1518194-.429-.3885378-.816-.7061601-1.131.1218551-.505.5713205-.869 1.094698-.869zm.8070401-3c.5503454 0 .998812.448.998812 1 0 .552-.4484666 1-.998812 1-.5513442 0-.998812-.448-.998812-1 0-.552.4474678-1 .998812-1zm4.1920141 5.837C17.1041244 8.352 16.6936127 8 16.224171 8l-.0619263 0-.2566947-1.284c-.1428301-.714-.6392397-1.283-1.2814758-1.55.2377172-.328.382545-.729.382545-1.166 0-1.103-.8959344-2-1.9976241-2-1.1016896 0-1.997624.897-1.997624 2 0 .437.1438289.838.3815462 1.166-.5053989.21-.9169094.607-1.1396445 1.117C9.87172658 6.105 9.45022791 6 9.00176132 6c-.44147492 0-.85797953.102-1.23553047.274-.22373389-.504-.63324682-.899-1.13564926-1.108.23771726-.328.382545-.729.382545-1.166 0-1.103-.89593438-2-1.99762403-2-1.10168966 0-1.99762404.897-1.99762404 2 0 .437.14382893.838.382545 1.166-.64323493.267-1.13964451.835-1.28147581 1.549L1.86125421 8l-.08489903 0c-.46944164 0-.880952195.352-.976838148.837l-.7770757494 3.89c-.0659215931.326.0149821803.657.2217362674.909.189774284.231.464447588.364.755101885.364l3.234153315 0-.19676597.997c-.05493466.25.00699168.517.16380517.713.14882299.185.3655652.29.59629077.29l8.42697698 0c.2307256 0 .4484666-.105.5962908-.29.1578123-.196.2187398-.463.1668016-.704L13.7870697 14l3.2141771 0c.2896554 0 .5653276-.133.7551018-.364.2057553-.252.2866591-.583.2217363-.909l-.7770757-3.89z"],"device-in-room_20":["M20.9595 14.9347449c-.021.0280093-.072.075025-.158.075025l-3.636 0c-.63-1.2124041-1.894-2.0116706-3.325-2.0116706l-.233 0c.836-.7332444 1.375-1.7975992 1.375-2.9949983 0-.3441147-.057-.67222407-.139-.99133044l4.871 0c.093 0 .175.06202067.19.13204401l1.091 5.64188063c.015.0670223-.011.1180393-.036.1490497zm-15.95 3.0650217l.447-1.9566523c.307-1.2034011 1.404-2.0446815 2.669-2.0446815l5.715 0c1.265 0 2.363.8412804 2.666 2.0326775l.451 1.9686563-11.948 0zm-.208-2.987996l-3.603 0c-.087 0-.136-.0470157-.159-.0750251-.024-.03001-.051-.081027-.031-.165055l1.082-5.61487159c.019-.08602868.101-.14804935.194-.14804935l4.839 0c-.083.3201067-.141.6492164-.141.99433144 0 1.1973991.54 2.2617539 1.376 2.9949983l-.233 0c-1.428 0-2.691.7982661-3.324 2.0136713zm-.877-7.78959658c.159-.70723574.882-1.2204068 1.719-1.2204068l1.683 0c.596 0 1.124.26708903 1.442.67222408-.51.3411137-.924.80326775-1.233 1.33444481l-3.787 0 .176-.78626209zm2.565-5.22174058c.827 0 1.5.67322441 1.5 1.50050017 0 .82727576-.673 1.50050017-1.5 1.50050017-.827 0-1.5-.67322441-1.5-1.50050017 0-.82727576.673-1.50050017 1.5-1.50050017zm4.493 5.00166723c1.655 0 3 1.34644881 3 3.00100033 0 1.6365455-1.317 2.9659887-2.946 2.9949983l-.107 0c-1.629-.0290096-2.947-1.3584528-2.947-2.9949983 0-1.65455152 1.346-3.00100033 3-3.00100033zm3.663-1.00033345l1.683 0c.837 0 1.56.51317106 1.719 1.2204068l.177.78926309-3.793 0c-.308-.53117706-.721-.99433144-1.23-1.33444481.317-.40713571.847-.67522508 1.444-.67522508zm.837-4.00133378c.828 0 1.5.67322441 1.5 1.50050017 0 .82727576-.672 1.50050017-1.5 1.50050017-.827 0-1.5-.67322441-1.5-1.50050017 0-.82727576.673-1.50050017 1.5-1.50050017zm6.492 12.58019336l-1.09-5.64088025c-.121-.53817939-.612-.92830944-1.17-.92830944l-.464 0-.228-1.00833611c-.19-.84828276-.849-1.5225075-1.698-1.82560854.405-.44414805.658-1.02934311.658-1.67655885 0-1.37945982-1.121-2.50083361-2.5-2.50083361-1.378 0-2.5 1.12137379-2.5 2.50083361 0 .64921641.255 1.23641214.663 1.68156052-.566.20606869-1.041.57819273-1.352 1.05735245-.413-.14404801-.849-.23807936-1.311-.23807936-.459 0-.894.09403135-1.305.23707903-.311-.47915972-.786-.85128376-1.351-1.05635212.408-.44514838.663-1.03234411.663-1.68156052 0-1.37945982-1.121-2.50083361-2.5-2.50083361-1.379 0-2.5 1.12137379-2.5 2.50083361 0 .64721574.253 1.2324108.658 1.67655885-.848.30310104-1.508.97732578-1.698 1.82560854l-.227 1.00533511-.438 0c-.564 0-1.045.38112704-1.173.94331444L.0295 14.5656218c-.08.3511171.003.7132378.228.9953318.228.2870957.572.4511504.941.4511504l3.24 0-.427 1.8676225c-.07.2690897-.011.5501834.16.7702568.173.2230744.434.3501167.718.3501167l12.187 0c.283 0 .544-.1270423.717-.3491164.171-.219073.23-.5001667.165-.7582527l-.431-1.8826276 3.274 0c.368 0 .711-.1640547.939-.45015.226-.282094.309-.6452151.234-.9793265z"],"device-in-room_24":["M26.8931605 17.808c-.0959974.122-.2389937.192-.3949896.192l-5.2098628 0c-.5959843-1.782-2.1749427-3-3.9918949-3l-.3279914 0c1.2259678-.912 2.0309466-2.358 2.0309466-4l5.4998552 0 .1099971 0c.4599879 0 .8579774.312.9699744.757l1.404963 5.622c.037999.151.0049999.307-.0909976.429zM6.99968431 21l.5509855-2.355C7.91666017 17.088 9.21262605 16 10.7035868 16l6.5928264 0c1.4909608 0 2.7859267 1.088 3.151917 2.645L21.0313149 21 6.99968431 21zm-.28899239-3l-5.20986283 0c-.15499592 0-.29799215-.07-.39398962-.192-.09599748-.122-.128996607-.278-.09099761-.429l1.40496301-5.622c.11199705-.445.50998657-.757.96997446-.757l.113997 0 5.49485533 0c0 1.642.80597877 3.088 2.03194654 4l-.3279914 0c-1.81695217 0-3.3959106 1.218-3.99289488 3zm-2.4459356-8.786C4.40175271 8.511 5.02073642 8 5.73671757 8l2.5369332 0c.54198573 0 1.02697296.294 1.29096601.743-.20299466.395-.37199021.81-.46298781 1.257l-4.98986862 0 .15299597-.786zM7.00468418 3c1.10297096 0 1.99994734.897 1.99994734 2 0 1.103-.89697638 2-1.99994734 2-1.10197099 0-1.99994734-.897-1.99994734-2 0-1.103.89797635-2 1.99994734-2zM13.9995 7c2.2059419 0 3.9998947 1.794 3.9998947 4 0 2.206-1.7939528 4-3.9998947 4-2.2059419 0-3.99989467-1.794-3.99989467-4 0-2.206 1.79395277-4 3.99989467-4zm5.7318491 1l2.5369332 0c.7159812 0 1.3349649.511 1.4719612 1.214l.152996.786-4.9948685 0c-.0899976-.445-.2589932-.858-.4589879-1.252.2629931-.451.7479803-.748 1.291966-.748zm1.2679666-5c1.102971 0 1.9999474.897 1.9999474 2 0 1.103-.8969764 2-1.9999474 2-1.101971 0-1.9999473-.897-1.9999473-2 0-1.103.8979763-2 1.9999473-2zm6.9558169 14.137l-1.405963-5.622c-.1979948-.79-.8469777-1.367-1.631957-1.488l-.1949949-1.004c-.1739954-.89-.8099787-1.592-1.6299571-1.88.5589853-.545.9069761-1.303.9069761-2.143 0-1.654-1.3449646-3-2.999921-3-1.6539564 0-2.999921 1.346-2.999921 3 0 .84.3489908 1.598.9079761 2.143-.4099892.144-.7639799.398-1.0439725.723C16.9454224 6.737 15.5644588 6 13.9995 6c-1.5619589 0-2.9429225.736-3.8598984 1.863-.27999259-.323-.63398327-.576-1.04197252-.72.55898528-.545.90697612-1.303.90697612-2.143 0-1.654-1.34496459-3-2.99992102-3-1.65395645 0-2.99992101 1.346-2.99992101 3 0 .84.34899081 1.598.90797609 2.143-.81997841.288-1.45596167.99-1.62995708 1.88l-.19499487 1.003c-.78697928.12-1.43896211.697-1.6369569 1.489L.0448674271 17.137c-.1119970513.451-.0119996841.921.2739927859 1.287.28599247.366.717981097.576 1.181968877.576l4.93986994 0-.41198915 1.765c-.07199811.308-.00299992.624.19099497.869.18399515.233.45698797.366.74898028.366l14.06262977 0c.2919923 0 .5649851-.133.7489803-.366.1939948-.245.262993-.561.1919949-.869L21.558301 19l4.9398699 0c.4649878 0 .8969764-.21 1.1829689-.576.2859925-.366.3859898-.836.2739928-1.287z"],"device-in-room_32":["M34.8834 23.8203c-.056.067-.18.18-.383.18l-7.244 0-.401-1.076c-.654-1.749-2.348-2.924-4.215-2.924l-1.328 0c1.618-1.075 2.686-2.912 2.686-5 0-.342-.035-.674-.09-1l8.121 0c.725 0 1.345.518 1.475 1.231l1.487 8.179c.037.2-.051.343-.108.41zm-7.509 3.965c-.095.137-.245.215-.411.215l-17.93 0c-.166 0-.316-.078-.411-.215-.094-.137-.115-.304-.056-.46l1.513-4.051c.508-1.36 1.825-2.274 3.278-2.274l9.283 0c1.452 0 2.769.914 3.277 2.274l1.514 4.051c.058.156.038.323-.057.46zm-25.875-3.785c-.203 0-.327-.113-.383-.18-.056-.066-.144-.209-.108-.409l1.487-8.18c.13-.713.75-1.231 1.476-1.231l8.117 0c-.055.326-.09.658-.09 1 0 2.088 1.068 3.925 2.686 5l-1.327 0c-1.868 0-3.562 1.175-4.215 2.924l-.402 1.076-7.241 0zm4.517-11.974c.204-.614.776-1.026 1.423-1.026l2.558 0 2.559 0c.28 0 .548.08.782.224-.426.525-.761 1.125-.991 1.776l-6.656 0 .325-.974zm.982-5.026c0-1.655 1.346-3 3-3 1.654 0 3 1.345 3 3 0 1.654-1.346 3-3 3-1.654 0-3-1.346-3-3zm11 3c2.757 0 5 2.243 5 5 0 2.757-2.243 5-5 5-2.757 0-5-2.243-5-5 0-2.757 2.243-5 5-5zm10.559 1c.646 0 1.219.412 1.423 1.026l.324.974-6.655 0c-.23-.651-.564-1.251-.991-1.777.234-.143.501-.223.782-.223l2.558 0 2.559 0zm-5.559-4c0-1.655 1.346-3 3-3 1.654 0 3 1.345 3 3 0 1.654-1.346 3-3 3-1.654 0-3-1.346-3-3zm12.978 16.231l-1.488-8.179c-.216-1.189-1.251-2.052-2.459-2.052l-.67 0-.43-1.291c-.336-1.004-1.262-1.681-2.316-1.705.842-.733 1.385-1.8 1.385-3.004 0-2.209-1.791-4-4-4-2.209 0-4 1.791-4 4 0 1.204.544 2.272 1.386 3.005-.522.012-1.014.186-1.427.494-1.057-.931-2.44-1.499-3.959-1.499-1.519 0-2.902.569-3.959 1.499-.413-.307-.905-.482-1.427-.494.843-.733 1.386-1.801 1.386-3.005 0-2.209-1.791-4-4-4-2.209 0-4 1.791-4 4 0 1.204.543 2.271 1.385 3.004-1.054.024-1.981.701-2.316 1.705l-.43 1.291-.666 0c-1.209 0-2.243.863-2.46 2.052l-1.487 8.18c-.079.439.039.887.325 1.23.285.341.705.538 1.15.538l6.867 0-.738 1.975c-.172.46-.107.977.173 1.38.28.403.741.645 1.232.645l17.93 0c.491 0 .952-.242 1.233-.645.28-.403.344-.92.172-1.38l-.738-1.975 6.87 0c.445 0 .865-.197 1.151-.539.286-.342.404-.79.325-1.23z"],"device-in-room_48":["M48.7616009 35.568c-.216.27-.541.425-.893.425l-8.496 0c-1.271-2.991-4.235-4.993-7.597-4.993l-2.71 0c2.902-1.495 4.895-4.516 4.895-8 0-.683-.083-1.346-.228-1.986l11.601 0c.527 0 .99.363 1.101.85l2.538 12.792c.072.321-.005.653-.211.912zm-8.814 6.864c.046.185-.032.322-.082.387-.09.115-.226.181-.374.181l-29.061 0c-.148 0-.284-.066-.373-.181-.051-.064-.12900004-.202-.08000004-.399l1.13500004-4.99c.808-3.197 3.701-5.43 7.034-5.43l13.629 0c3.334 0 6.226 2.233 7.031 5.418l1.141 5.014zM2.12960086 35.999c-.35 0-.676-.155-.89-.425-.208-.259-.286-.591-.21-.925l2.532-12.777c.114-.501.578-.864 1.103-.864l11.52600004 0c-.146.642-.23 1.307-.23 1.992 0 3.484 1.993 6.505 4.896 8l-2.71 0c-3.361 0-6.324 2-7.599 4.999l-8.41800004 0zm5.722-18.619c.439-1.956 2.39900004-3.372 4.66100004-3.372l2.392 0c.025.001.048.008.073.008.024 0 .047-.007.072-.008l2.392 0c1.2 0 2.317.409 3.186 1.108-1.919 1.059-3.404 2.8-4.145 4.892l-9.24600004 0 .615-2.628zm3.12600004-8.364c0-2.206 1.793-4 4-4 2.206 0 4 1.794 4 4 0 2.181-1.756 3.953-3.928 3.992l-.072 0-.073 0c-2.172-.039-3.927-1.811-3.927-3.992zm21.983 13.984c0 4.411-3.589 8-8 8-4.411 0-8-3.589-8-8 0-4.411 3.589-8 8-8 4.411 0 8 3.589 8 8zm-.456-9.007l2.393 0c.024 0 .047.007.072.007.025 0 .048-.007.072-.007l2.393 0c2.262 0 4.222 1.416 4.661 3.371l.62 2.65-9.275 0c-.739-2.092-2.224-3.835-4.142-4.895.872-.71 1.996-1.126 3.206-1.126zm-1.535-4.993c0-2.205 1.794-4 4-4 2.206 0 4 1.795 4 4 0 2.181-1.756 3.953-3.928 3.993l-.072 0-.072 0c-2.172-.04-3.928-1.812-3.928-3.993zm18.98 25.449l-2.538-12.792c-.217-.967-1.072-1.643-2.078-1.643l-1.59 0-.672-2.873c-.51-2.263-2.646-3.923-5.169-4.111 1.247-.91 2.067-2.372 2.067-4.03 0-2.757-2.243-5-5-5-2.757 0-5 2.243-5 5 0 1.651.814 3.106 2.051 4.017-1.427.107-2.745.686-3.722 1.632-1.033-.414-2.158-.649-3.338-.649-1.177 0-2.299.234-3.331.647-.975-.936-2.286-1.508-3.704-1.614 1.237-.912 2.052-2.366 2.052-4.017 0-2.757-2.244-5-5-5-2.757 0-5.00000004 2.243-5.00000004 5 0 1.658.82000004 3.119 2.06700004 4.03-2.52300004.188-4.66000004 1.847-5.16900004 4.11l-.667 2.852-1.544 0c-1.005 0-1.859.675-2.081 1.656L.0516008603 34.442c-.14.618.008 1.259.4059999997 1.757.407.508 1.016.8 1.672.8l8.07000004 0c-.019.066-.042.13-.059.197l-1.13500004 4.991c-.11.437-.015.891.263 1.247.28.36.704.566 1.16200004.566l29.061 0c.458 0 .882-.206 1.163-.567.277-.356.373-.81.264-1.235l-1.14-5.013c-.017-.066-.04-.128-.058-.192l8.148 0c.658 0 1.268-.292 1.674-.801.398-.498.545-1.138.407-1.743z"],"device-in-room_56":["M56.7033302 41.508c-.2669949.333-.6669873.524-1.100979.524l-9.4318202 0C44.7325584 38.431 41.1586265 36 37.087704 36l-3.7879278 0c3.3479362-1.618 5.669892-5.038 5.669892-9 0-.683-.0699987-1.351-.2009962-1.996l13.9277346 0c.6599874 0 1.2199767.44 1.3609741 1.057l2.9089445 14.317c.0899983.397-.0059999.809-.262995 1.13zm-9.7688138 7.729c.0629988.241-.0399992.422-.105998.508-.1259976.162-.3189939.255-.5309899.255l-34.686339 0c-.2119959 0-.4049923-.093-.5299899-.254-.0659987-.086-.1699968-.267-.103998-.522l1.3549742-5.824c.9739814-3.768 4.4649149-6.4 8.4888382-6.4l16.26669 0c4.0239234 0 7.5148568 2.632 8.4858383 6.388l1.3609741 5.849zM2.39636511 42.039c-.43299175 0-.83498409-.191-1.10097902-.525-.25599512-.32-.351993295-.732-.25999505-1.138l2.98994303-14.312c.13999733-.618.71298641-1.067 1.363974-1.067l13.78273733 0c-.1319975.647-.2019961 1.317-.2019961 2.003 0 3.962 2.3209558 7.382 5.6698919 9l-3.8189272 0c-4.0699224 0-7.6438543 2.43-9.0838269 6.039l-9.34082199 0zm6.59287436-22.063c.51799013-2.309 2.83194603-3.983 5.50189513-3.983l2.8489457 0c.0489991.001.0959982.007.1449973.007.048999 0 .0959981-.006.1449972-.007l2.5939506 0c1.8049656 0 3.4409344.769 4.4749147 1.978-2.4929525 1.185-4.4259156 3.361-5.2668996 6.026l-11.36278349 0 .91998246-4.021zM12.9851633 10.5c0-2.481 2.0179616-4.5 4.4999143-4.5 2.4809527 0 4.4999142 2.019 4.4999142 4.5 0 2.457-1.9799622 4.453-4.4279156 4.493l-.1449972 0c-2.4469534-.04-4.4269157-2.036-4.4269157-4.493zM28.9698587 18c4.9629055 0 8.9998285 4.038 8.9998285 9 0 4.963-4.036923 9-8.9998285 9-4.9629054 0-8.9998285-4.037-8.9998285-9 0-4.962 4.0369231-9 8.9998285-9zm8.7598331-2.007l2.5949505 0c.0489991.001.0959982.007.1449973.007.0479991 0 .0959982-.006.1439972-.007l2.8499457 0c2.6699492 0 4.9829051 1.674 5.5018952 3.983l.9219824 4.028-11.3937829 0c-.838984-2.659-2.7529475-4.84-5.2399001-6.026 1.0329803-1.212 2.6689491-1.985 4.4759147-1.985zM35.9697253 10.5c0-2.481 2.0179616-4.5 4.4999143-4.5 2.4809527 0 4.4999142 2.019 4.4999142 4.5 0 2.457-1.9809622 4.453-4.4279156 4.493l-.1449972 0c-2.4469534-.04-4.4269157-2.036-4.4269157-4.493zm21.9735813 29.668L55.034362 25.851c-.2469953-1.088-1.2079769-1.847-2.3379554-1.847l-1.783966 0-.9719815-4.249c-.6089884-2.714-3.2569379-4.686-6.3258794-4.75 1.4209729-.996 2.3549551-2.642 2.3549551-4.505 0-3.033-2.467953-5.5-5.4998952-5.5-3.0329422 0-5.4998952 2.467-5.4998952 5.5 0 1.874.942982 3.53 2.3779547 4.523-2.0669606.11-3.9079256 1.089-5.0429039 2.561-1.0449801-.371-2.1649588-.584-3.3349365-.584-1.1659778 0-2.2799565.211-3.3209367.579-1.1359783-1.47-2.9769433-2.446-5.0429039-2.556 1.4349727-.993 2.3789547-2.649 2.3789547-4.523 0-3.033-2.467953-5.5-5.4998952-5.5-3.0319422 0-5.4998952 2.467-5.4998952 5.5 0 1.863.9329822 3.509 2.3539551 4.505-3.0679415.064-5.71689103 2.036-6.32587943 4.75l-.96998151 4.242-1.65396849 0c-1.13097844 0-2.09296011.759-2.33995541 1.855L.0584096595 40.164c-.1579969892.695.0079998476 1.414.4559913105 1.974.456991292.573 1.14297822.901 1.88196414.901l9.00182849 0c-.0119998.042-.0269995.081-.0379993.123l-1.3539742 5.824c-.12399764.479-.01999962.979.2849946 1.372.314994.408.7969848.642 1.3199748.642l34.686339 0c.5229901 0 1.0059809-.234 1.3209749-.642.3049941-.394.4079922-.894.2879945-1.36l-1.3609741-5.848c-.0109998-.04-.0249995-.078-.0359993-.118l9.0928267 0c.7399859 0 1.4249729-.328 1.8819642-.9.4479914-.56.6139883-1.279.4589912-1.964z"],"device-in-room_8":["M6.71556887 5c.173-.296.284-.633.284-1l1.098 0c.344 0 .643.241.725.575l.093.425-2.2 0zm-3.642 2l.091-.414c.085-.345.384-.586.727-.586l2.198 0c.344 0 .643.241.725.575l.094.425-3.835 0zm-1.99-2l.091-.414c.084-.345.383-.586.726-.586l1.099 0c0 .367.112.704.285 1l-2.201 0zm1.926-4c.551 0 1 .449 1 1 0 .108-.03.208-.062.306-.258.16-.475.376-.637.633-.097.031-.194.061-.301.061-.552 0-1-.449-1-1 0-.551.448-1 1-1zm1.99 2c.552 0 1 .449 1 1 0 .551-.448 1-1 1-.551 0-1-.449-1-1 0-.551.449-1 1-1zm2.008-2c.552 0 1 .449 1 1 0 .551-.448 1-1 1-.113 0-.218-.03-.32-.065-.158-.249-.367-.46-.616-.619-.034-.1-.064-.204-.064-.316 0-.551.449-1 1-1zm2.975 4.194l-.187-.845c-.145-.595-.575-1.056-1.119-1.249.208-.316.331-.693.331-1.1 0-1.105-.895-2-2-2-1.101 0-1.994.891-1.999 1.992-.005-1.101-.897-1.992-1.999-1.992-1.105 0-2 .895-2 2 0 .405.122.781.33 1.096C.786568869 3.287.349568869 3.75.200568869 4.36l-.1809999999.822c-.049.198-.005.405.1209999999.566.125.16.313.252.516.252L2.32856887 6c-.056.114-.106.232-.138.36l-.18.822c-.05.198-.006.405.121.566.125.16.313.252.515.252l4.688 0c.202 0 .39-.091.515-.25.126-.161.171-.367.125-.556l-.187-.845c-.03-.124-.079-.238-.132-.349l1.687 0c.202 0 .39-.091.515-.25.126-.161.17100003-.367.125-.556z"],"device-in-room-active_24":["M8.997 14.3096c-1.48.54-2.694 1.759-3.234 3.373l-.01.028-.008.029-.269 1-.062.26-3.913 0c-.464 0-.897-.21-1.183-.576-.285-.366-.385-.836-.273-1.287l1.406-5.622c.197-.792.85-1.368 1.637-1.488l.005-.027 4.997 0c-.055.327-.09.659-.09 1 0 .274.024.541.06.806.009.065.019.128.03.191.043.257.096.51.172.754 0 .003.001.006.002.009.078.257.178.504.289.745.019.042.041.084.06.126.115.235.241.463.384.679zm9.6885-7.0518c.075-.036.142-.087.222-.115-.559-.545-.909-1.303-.909-2.143 0-1.654 1.347-3 3-3 1.656 0 3 1.346 3 3 0 .84-.347 1.598-.907 2.143.813.286 1.442.978 1.623 1.857l-5.063 0c-.226-.637-.552-1.224-.966-1.742zm9.2695 9.8789c.112.451.012.921-.273 1.287-.287.366-.719.576-1.184.576l-3.912 0-.054-.228-.278-1.032-.008-.029-.01-.028c-.539-1.614-1.753-2.833-3.233-3.373 0 0 .001-.001.001-.002.142-.215.267-.442.382-.676.02-.043.042-.085.061-.128.112-.241.211-.487.289-.744.001-.003.002-.007.003-.011.074-.243.128-.495.171-.751.011-.064.021-.128.029-.192.037-.265.061-.532.061-.806 0-.342-.035-.674-.09-1l5.002 0 .005.028c.785.121 1.434.697 1.632 1.487l1.406 5.622zM9.3154 7.2559c-.414.519-.741 1.106-.967 1.744l-5.057 0c.18-.879.809-1.571 1.622-1.857-.56-.545-.909-1.303-.909-2.143 0-1.654 1.346-3 3-3 1.656 0 3 1.346 3 3 0 .84-.348 1.598-.907 2.143.078.028.145.077.219.113l-.001 0zM21.5586 19l.414 1.765c.07.308.002.624-.192.869-.184.233-.457.366-.749.366l-14.063 0c-.292 0-.565-.133-.749-.366-.194-.245-.263-.561-.191-.869L6.4406 19l.27-1c.597-1.782 2.176-3 3.993-3l.324 0c-1.224-.911-2.028-2.356-2.028-4 0-2.762 2.239-5 5-5 2.762 0 5 2.238 5 5 0 1.644-.803 3.089-2.027 4l.324 0c1.817 0 3.396 1.218 3.991 3l.271 1z"],"diagnostics_16":["M5.9487 4.96537c0 .001 0 .001 0 .001l0-.001zm4.104 6.068l.001.001c0-.001-.001-.001-.001-.001zm-.053.966c-.359 0-.681-.199-.842-.52l-3.158-6.409-1.85 3.424c-.153.308-.475.507-.834.507l-2.816 0c-.276 0-.5-.223-.5-.5 0-.276.224-.5.5-.5l2.816 0 1.852-3.494c.153-.307.475-.508.834-.508l.001 0c.359 0 .681.2.842.522l3.157 6.408 1.848-3.421c.154-.308.476-.507.835-.507l2.815 0c.277 0 .5.224.5.5 0 .277-.223.5-.5.5l-2.815 0-1.851 3.491c-.153.308-.475.507-.834.507z"],"diagnostics_24":["M15.3823 19.0029c-.451 0-.855-.255-1.055-.667l-5.56-12.239c-.077-.158-.217-.169-.305.01l-2.592 5.231c-.199.408-.603.663-1.053.663l-4.317 0c-.277 0-.5-.224-.5-.5 0-.276.223-.5.5-.5l4.317 0c.065 0 .125-.04.156-.103l2.592-5.23c.197-.408.601-.663 1.052-.663.452 0 .856.255 1.055.667l5.56 12.239c.077.158.217.169.305-.011l2.578-6.207c.212-.438.616-.693 1.067-.693l4.318 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-4.318 0c-.065 0-.124.039-.155.104l-2.578 6.206c-.212.438-.616.693-1.067.693"],"diagnostics_32":["M20.559 24.996c-.539 0-1.023-.302-1.264-.787l-7.49-15.988c-.099-.198-.287-.22-.363-.221-.076 0-.265.023-.368.231L7.582 15.21c-.239.483-.724.784-1.263.784l-5.819 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l5.819 0c.157 0 .298-.088.367-.229l3.493-6.98c.24-.483.724-.785 1.263-.785.539.001 1.023.302 1.263.787l7.492 15.988c.097.199.286.221.362.221.076 0 .265-.022.367-.23l3.482-7.964c.252-.507.735-.808 1.273-.808l5.819 0c.277 0 .5.224.5.5 0 .276-.223.5-.5.5l-5.819 0c-.156 0-.297.089-.368.231l-3.481 7.962c-.25.507-.734.809-1.273.809"],"diagnostics-circle_100":["M50 0c27.57 0 50 22.43 50 50 0 27.57-22.43 50-50 50-27.57 0-50-22.43-50-50C0 22.43 22.43 0 50 0zm0 99c27.019 0 49-21.981 49-49C99 22.981 77.019 1 50 1 22.981 1 1 22.981 1 50c0 27.019 21.981 49 49 49zm29-50.998c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-10.887 0c-.455 0-.865.274-1.073.717l-6.526 14.978c-.38.81-1.138 1.306-1.985 1.306-.846 0-1.604-.496-1.978-1.294L42.546 35.738c-.213-.454-.614-.722-1.075-.722-.462 0-.863.268-1.074.716L33.852 47.74c-.36.771-1.119 1.266-1.965 1.266l-10.887 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l10.887 0c.455 0 .865-.275 1.073-.717l6.546-12.008c.36-.77 1.118-1.265 1.965-1.265.846 0 1.604.495 1.978 1.293l14.005 28.97c.213.455.614.724 1.075.724.461 0 .863-.269 1.074-.718l6.526-14.978c.379-.81 1.138-1.305 1.984-1.305l10.887 0z"],"dialpad_16":["M4 1c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm4 0c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm4 2c-.552 0-1-.448-1-1 0-.552.448-1 1-1 .552 0 1 .448 1 1 0 .552-.448 1-1 1zM4 5c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm4 0c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm4 0c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zM4 9c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm4 0c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm0 4c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm4-4c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1z"],"dialpad_20":["M5 2c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm5 0c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm5 2c-.552 0-1-.448-1-1 0-.552.448-1 1-1 .552 0 1 .448 1 1 0 .552-.448 1-1 1zM5 7c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm5 0c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm5 0c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zM5 12c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm5 0c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm5 0c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm-5 5c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1z"],"dialpad_24":["M6 2c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm6 0c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm6 2c-.552 0-1-.448-1-1 0-.552.448-1 1-1 .552 0 1 .448 1 1 0 .552-.448 1-1 1zM6 8c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm6 0c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm6 0c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zM6 14c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm6 0c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm0 6c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm6-6c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1z"],"dialpad_28":["M7 3c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm7 0c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm7 2c-.552 0-1-.448-1-1 0-.552.448-1 1-1 .552 0 1 .448 1 1 0 .552-.448 1-1 1zM7 10c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm7 0c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm7 0c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zM7 17c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm7 0c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm7 0c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm-7 7c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1z"],"directory_16":["M12 0c1.104 0 2 .896 2 2l0 12c0 1.104-.896 2-2 2l-8 0c-1.104 0-2-.896-2-2L2 2c0-1.104.896-2 2-2l8 0zm1 14l0-12c0-.552-.449-1-1-1l-1 0 0 14 1 0c.551 0 1-.448 1-1zm-3 1l0-14-6 0c-.551 0-1 .448-1 1l0 12c0 .552.449 1 1 1l6 0zM4.5 5c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5zm0 6c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5z"],"directory_20":["M15.5 0C16.881 0 18 1.119 18 2.5l0 15c0 1.381-1.119 2.5-2.5 2.5l-11 0C3.119 20 2 18.881 2 17.5l0-15C2 1.119 3.119 0 4.5 0l11 0zM17 17.5l0-15c0-.827-.673-1.5-1.5-1.5L14 1l0 18 1.5 0c.827 0 1.5-.673 1.5-1.5zM4.5 19l8.5 0 0-18-8.5 0C3.673 1 3 1.673 3 2.5l0 15c0 .827.673 1.5 1.5 1.5zm1-15c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0 11c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5z"],"directory_24":["M18.5 0C19.878 0 21 1.121 21 2.5l0 19c0 1.379-1.122 2.5-2.5 2.5l-13 0C4.122 24 3 22.879 3 21.5l0-19C3 1.121 4.122 0 5.5 0l13 0zM20 21.5l0-19c0-.827-.673-1.5-1.5-1.5L16 1l0 22 2.5 0c.827 0 1.5-.673 1.5-1.5zm-16 0c0 .827.673 1.5 1.5 1.5l9.5 0 0-22-9.5 0C4.673 1 4 1.673 4 2.5l0 19zm4-17c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5zm0 15c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5z"],"display_16":["M15 9L1 9l0-6c0-.551.449-1 1-1l12 0c.551 0 1 .449 1 1l0 6zm0 2c0 .551-.449 1-1 1L2 12c-.551 0-1-.449-1-1l0-1 14 0 0 1zm-5.875 3L8 14l-1.125 0c.078-.237.125-.529.125-.889L7 13l2 0 0 .111c0 .36.047.652.125.889zM14 1L2 1C.895 1 0 1.895 0 3l0 8c0 1.105.895 2 2 2l4 0 0 .111C6 14 5.675 14 5.5 14c-.276 0-.5.224-.5.5 0 .276.224.5.5.5L8 15l2.5 0c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5-.175 0-.5 0-.5-.889L10 13l4 0c1.105 0 2-.895 2-2l0-8c0-1.105-.895-2-2-2z"],"display_24":["M23 16L1 16 1 4.461C1 3.656 1.686 3 2.529 3l18.942 0C22.313 3 23 3.656 23 4.461L23 16zm-2.206 3L3.206 19c-1.175 0-2.13-.888-2.194-2l21.976 0c-.064 1.112-1.018 2-2.194 2zm-7.295 1.997l-2.998 0c.218-.29.369-.63.444-.997l2.11 0c.075.367.226.707.444.997zM21.471 2L2.529 2C1.135 2 0 3.104 0 4.461l0 12.424C0 18.603 1.438 20 3.206 20l6.703 0c-.208.579-.757.997-1.407.997-.276 0-.5.223-.5.5 0 .276.224.5.5.5l6.996 0c.276 0 .5-.224.5-.5 0-.277-.224-.5-.5-.5-.65 0-1.199-.418-1.407-.997l6.703 0C22.562 20 24 18.603 24 16.885l0-12.424C24 3.104 22.865 2 21.471 2z"],"display_36":["M35 24L1 24 1 6.5C1 5.121 2.121 4 3.5 4l29 0C33.879 4 35 5.121 35 6.5L35 24zm0 2.5c0 1.379-1.121 2.5-2.5 2.5L21 29l-6 0-11.5 0C2.121 29 1 27.879 1 26.5L1 25l34 0 0 1.5zm-14.854 3.635l.014.104.035.099c.252.701.73 1.277 1.331 1.657l-7.052 0c.601-.38 1.079-.956 1.331-1.657l.035-.099.014-.104.019-.135 4.254 0 .019.135zM32.5 3l-29 0C1.567 3 0 4.567 0 6.5l0 20C0 28.433 1.567 30 3.5 30l11.363 0c-.311.868-1.135 1.495-2.11 1.495-.414 0-.75.335-.75.75 0 .414.336.75.75.75l10.494 0c.414 0 .75-.336.75-.75 0-.415-.336-.75-.75-.75-.975 0-1.799-.627-2.11-1.495L32.5 30c1.933 0 3.5-1.567 3.5-3.5l0-20C36 4.567 34.433 3 32.5 3z"],"display-input_24":["M21.4709 2c1.394 0 2.529 1.104 2.529 2.461l0 12.424c0 1.718-1.437 3.115-3.206 3.115l-6.703 0c.208.579.757.997 1.407.997.276 0 .5.223.5.5 0 .276-.224.5-.5.5l-6.996 0c-.276 0-.5-.224-.5-.5 0-.277.224-.5.5-.5.65 0 1.199-.418 1.407-.997l-6.703 0c-1.768 0-3.206-1.397-3.206-3.115l0-4.385c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 3.5 22 0 0-11.539c0-.805-.687-1.461-1.529-1.461L2.5289 3c-.843 0-1.529.656-1.529 1.461l0 2.039c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-2.039C-.0001 3.104 1.1349 2 2.5289 2l18.942 0zm-.677 17c1.176 0 2.13-.888 2.194-2l-21.976 0c.064 1.112 1.019 2 2.194 2l17.588 0zm-10.293 1.997l2.998 0c-.218-.29-.369-.63-.444-.997l-2.11 0c-.075.367-.226.707-.444.997zM0 9.5c0-.276.224-.5.5-.5l11.793 0-3.147-3.146c-.195-.196-.195-.512 0-.708.196-.195.512-.195.708 0l4 4c.195.196.195.512 0 .708l-4 4c-.098.097-.226.146-.354.146-.128 0-.256-.049-.354-.146-.195-.196-.195-.512 0-.708L12.293 10 .5 10c-.276 0-.5-.224-.5-.5z"],"dnd_12":["M4.3228 1c-.073 0-.146.017-.213.053-1.918 1.009-3.11 2.978-3.11 5.139 0 3.204 2.605 5.808 5.807 5.808 2.163 0 4.132-1.191 5.141-3.109.078-.149.068-.33-.026-.47-.087-.129-.234-.202-.386-.202-.013 0-.026 0-.039.001-.197.021-.397.031-.599.031-3.391 0-6.149-2.757-6.149-6.149 0-.202.011-.402.031-.6.016-.167-.061-.33-.201-.425-.077-.051-.166-.077-.256-.077m-.564 1.478c.189 3.644 3.12 6.574 6.763 6.764C9.6188 10.344 8.2658 11 6.8068 11c-2.651 0-4.807-2.157-4.807-4.808 0-1.458.656-2.811 1.759-3.714"],"dnd_120":["M34.5498 0c-.171 0-.343.041-.499.124C13.0458 11.168-.0002 32.736-.0002 56.411c0 35.064 28.527 63.589 63.59 63.589 23.673 0 45.241-13.048 56.287-34.05.183-.347.161-.769-.057-1.097-.205-.302-.558-.473-.91-.473-.028 0-.056.001-.085.004-2.605.252-5.034.377-7.427.377-41.992 0-76.159-34.164-76.159-76.158 0-2.387.125-4.817.375-7.429.04-.392-.14-.772-.468-.992-.178-.121-.386-.182-.596-.182m0 1l.037.011c.024.016.035.039.032.067-.255 2.662-.38 5.123-.38 7.525 0 42.545 34.614 77.158 77.159 77.158 2.416 0 4.877-.125 7.512-.381.036 0 .073.02.078.027.014.023.016.054.004.077C108.1188 106.157 86.8898 119 63.5898 119c-34.512 0-62.59-28.077-62.59-62.589 0-23.304 12.842-44.532 33.517-55.403.011-.005.021-.008.033-.008"],"dnd_124":["M35.7020657 0c-.1770004 0-.3540007.042-.517001.128C13.4800248 11.541 0 33.827 0 58.291 0 94.523 29.4760542 124 65.7101209 124c24.461045 0 46.7480861-13.482 58.1631071-35.186.188-.358.166-.794-.06-1.133-.211001-.312-.576001-.489-.940002-.489-.028 0-.058.002-.087.004-2.692005.261-5.20201.39-7.675014.39-43.3910801 0-78.697145-35.303-78.697145-78.696 0-2.467.1290002-4.978.3880007-7.677.0400001-.405-.1470003-.797-.4850009-1.026C36.1330665.063 35.9180661 0 35.7020657 0M35.702 1c.014 0 .035.003.057.017.034.023.051.059.047.1-.263 2.749-.392 5.291-.392 7.773 0 43.944 35.752 79.696 79.697 79.696 2.494 0 5.036-.129 7.762-.394.048 0 .097.026.108.043.023.035.025.079.007.115C111.746 109.723 89.799 123 65.71 123 30.028 123 1 93.972 1 58.291c0-24.092 13.277-46.04 34.652-57.279.016-.008.032-.012.05-.012"],"dnd_14":["M3.6511797 1.42174781c-1.65508146 1.19302392-2.65113048 3.1070623-2.65113048 5.18310392 0 3.52607067 2.86914121 6.39512827 6.3963148 6.39512827 2.07510213 0 3.98919638-.99702 5.18225508-2.6500532-4.90124125-.049001-8.87843699-4.02708072-8.9274394-8.92817899M7.39636402 14C3.31816331 14 0 10.6829335 0 6.60485173c0-2.7530552 1.51707467-5.2621055 3.96019491-6.5471312653.16400807-.0860017243.35901767-.0750015037.51102515.0270005414.15300753.1030020649.23701166.2810056339.21901078.4640093029-.02500123.258005173-.03900192.519010411-.03900192.782015681 0 4.42208866 3.59717704 8.01916078 8.01839468 8.01916078.2640129 0 .5250258-.0150003.7830385-.0400008.1850091-.01300026.3610178.06600132.4630228.21900439.102005.15300306.1120055.34900699.0270013.51101024C12.658623 12.4829696 10.1504996 14 7.39636402 14"],"dnd_16":["M4.2121814 1.41567757c-2.00108618 1.3840306-3.21213833 3.65808088-3.21213833 6.12713546 0 4.11209087 3.34514405 7.45716487 7.4563211 7.45716487 2.47010633 0 4.74420433-1.2110268 6.12826393-3.212071l-.0430019 0c-5.69524523 0-10.3294448-4.63410247-10.3294448-10.32922838l0-.04300095zM8.45636417 16C3.79316335 16 0 12.2059161 0 7.54281303c0-3.1480696 1.73407468-6.016133 4.52719496-7.4851654789.16400706-.0850018792.36001551-.0760016803.51202205.0270005969.15300659.102002255.23701021.28000619.21900943.464010258-.02900125.299006611-.04600198.602013314-.04600198.910020114 0 5.14411373 4.18518023 9.32920628 9.32940174 9.32920628.3080133 0 .6110263-.0180004.9110393-.0470011.1830078-.0120002.3600155.0670015.4630199.2200049.1020044.1520034.1120048.3490077.0270012.5110113C14.4746233 14.2649616 11.6054998 16 8.45636417 16z"],"dnd_18":["M4.77594167 1.4105795C2.42597037 2.98352456.999987788 5.61843252.999987788 8.48233247c0 4.69683593 3.820953342 8.51770243 8.517895972 8.51770243 2.86396504 0 5.49793284-1.4269501 7.07091364-3.776868-.0579993.0009999-.1159986.0019999-.1749979.0019999-6.41792157 0-11.63885781-5.22081763-11.63885781-11.63859344 0-.05899794 0-.11699592.00099998-.17599386M9.51788376 18C4.26994785 18 0 13.7301492 0 8.48233247 0 4.93845627 1.95297615 1.71056903 5.09593777.0576267662c.16399799-.0859969959.3599956-.0749973802.51199374.027999022.15299814.1019964368.23699711.2799902188.21899733.4629838268-.0329996.340988089-.05199937.687975965-.05199937 1.037963745 0 5.86679506 4.77194173 10.63862834 10.63887003 10.63862834.3509958 0 .6969915-.0189993 1.0389874-.0519982.1799978-.0149994.3599956.0659977.4619943.2189924.1029988.1529946.1129986.3489878.0279997.5109821C16.2898011 16.0470682 13.0618405 18 9.51788376 18"],"dnd_20":["M5.33994131 1.40720436C2.64197096 3.16918499.999989009 6.16315208.999989009 9.42211626c0 5.28094194 4.296952771 9.57789474 9.578894691 9.57789474 3.2589642 0 6.2529313-1.641982 8.0139119-4.3389523-.1019988.0029999-.2039977.0039999-.3069966.0039999-7.1399215 0-12.94985765-5.80993611-12.94985765-12.94985763 0-.10399886.00199998-.20599774.00399996-.30799661M10.5788837 20C4.74594784 20 0 15.2550522 0 9.42211626 0 5.48415955 2.17097614 1.89519899 5.66393775.057219193c.16399819-.0849990657.35999604-.0749991756.51199437.0279996923.15199833.1019988787.23599741.2799969227.21899759.4629949107-.03699959.38399578-.05899935.772991504-.05899935 1.166987174 0 6.58892758 5.36094104 11.94986863 11.94986864 11.94986863.3939957 0 .7829914-.0229997 1.1669872-.0599993.180998-.0099999.359996.0669993.4619949.2199976.1029989.1519983.1129988.3489961.0279997.5109944C18.105801 17.8300239 14.5168404 20 10.5788837 20"],"dnd_24":["M6.47007567 1.40197766C3.07403595 3.5368853 1.0000117 7.25072462 1.0000117 11.2985495c0 6.4527208 5.24806137 11.7014938 11.7001368 11.7014938 4.0480474 0 7.7620908-2.0749103 9.8981158-5.4697634-.1910022.0069997-.3800044.0109995-.5680066.0109995-8.5861005 0-15.57118216-6.9856978-15.57118216-15.57132631 0-.18799187.00400005-.3769837.01100013-.56797543M12.7001485 24C5.69706663 24 0 18.3022465 0 11.2985495 0 6.57075404 2.60603048 2.26294041 6.80107954.0580358004c.1620019-.0869962363.35800419-.0749967554.51100598.0279987887.15300179.1019955869.23700277.2799878869.21900256.4619800129-.04900057.499978368-.07200084.963958298-.07200084 1.421938488 0 8.03465241 6.53607646 14.57136961 14.57117046 14.57136961.4570053 0 .9220107-.023999 1.4210166-.0729969.1810021-.0139994.3610042.0669971.4640054.2189906.1020012.1529933.1130013.3499848.0270003.5119778C21.7362542 21.3941127 17.4282038 24 12.7001485 24"],"dnd_26":["M7.6182 0c-.086 0-.172.021-.25.063C2.8232 2.452.0002 7.118.0002 12.24c0 7.587 6.172 13.76 13.758 13.76 5.122 0 9.79-2.823 12.179-7.367.094-.176.081-.389-.029-.555-.103-.152-.278-.239-.459-.239-.015 0-.029.001-.044.002-.54.053-1.044.079-1.539.079-8.705 0-15.786-7.082-15.786-15.786 0-.496.025-.999.079-1.54.019-.198-.072-.39-.238-.501C7.8302.032 7.7242 0 7.6182 0m-.519 1.365c-.012.259-.019.514-.019.769 0 9.256 7.53 16.786 16.786 16.786.253 0 .509-.007.77-.02-2.315 3.784-6.41 6.1-10.878 6.1-7.035 0-12.758-5.724-12.758-12.76 0-4.465 2.314-8.556 6.099-10.875"],"dnd_28":["M7.60282927 1.396367C3.50792122 3.90533239.999977544 8.33827124.999977544 13.1772045c0 7.6218948 6.200860756 13.8228093 13.822689556 13.8228093 4.8378914 0 9.2707918-2.5079654 11.7797355-6.6029089-.2799937.0139998-.5539876.0199997-.8279814.0199997-10.0307747 0-18.19159148-8.1608874-18.19159148-18.19174904 0-.27199624.00699984-.54799244.01999955-.82898856M14.8226671 28C6.64985067 28 0 21.3500917 0 13.1772045 0 7.6592806 3.04093171 2.63134996 7.93682177.0573854709c.16399631-.0859988136.35999191-.0739989792.5119885.0269996275.15199659.1029985796.2359947.2809961236.2179951.4629936126-.05599874.591991829-.08399811 1.140984259-.08399811 1.677976849 0 9.47986924 7.71182684 17.19176284 17.19161394 17.19176284.5409879 0 1.0899755-.0279996 1.6769623-.0849988.1869958-.0149998.359992.0659991.4629896.217997.1029977.1529979.1139975.3499951.0279994.5119929C25.3674303 24.958042 20.3405432 28 14.8226671 28"],"dnd_32":["M8.73607663 1.39473154C3.94103457 4.2747568 1.00000877 9.427802 1.00000877 15.0558514c0 8.7920771 7.15306275 15.9441398 15.94413983 15.9441398 5.6280494 0 10.7820946-2.9410258 13.6621199-7.7350678-.3700033.0210002-.7300064.0300002-1.0870096.0300002-11.4761006 0-20.81318253-9.3370819-20.81318253-20.81318252 0-.35800314.00900008-.71900631.03000026-1.08700954M16.9441486 32C7.60106667 32 0 24.3989333 0 15.0558514 0 8.74879605 3.47603049 3.00074563 9.07307959.0577198138c.16300143-.0860007544.36000315-.0750006579.51200449.0270002368.15200133.1030009034.23600207.2810024644.21800191.4640040704-.06600058.676005929-.09700085 1.308011469-.09700085 1.933016959 0 10.92509582 8.88807796 19.81317382 19.81317376 19.81317382.6210055 0 1.254011-.0320003 1.932017-.0980009.1790015-.0150001.3610031.0660006.464004.2190019.1020009.1530014.113001.3490031.0270003.5110045C28.9992544 28.5239695 23.253204 32 16.9441486 32"],"dnd_36":["M9.87007696 1.39173016C4.37503411 4.64275551 1.0000078 10.5158013 1.0000078 16.9338513c0 9.9620777 8.10406318 18.0661409 18.0661409 18.0661409 6.41805 0 12.2910958-3.3760263 15.5421211-8.8700692-.4590035.0280003-.904007.0410004-1.3440104.0410004-12.9221008 0-23.43518276-10.512082-23.43518276-23.43418275 0-.44200345.01400011-.88700692.04100032-1.34501049M19.0661487 36C8.55306669 36 0 27.4479333 0 16.9338513 0 9.83479599 3.9120305 3.36974558 10.2090796.0577197575c.1630013-.0860006705.3600028-.0750005848.512004.0270002105.1520012.103000803.2360018.281002191.2180017.46300361-.0740006.769005992-.1100009 1.484011572-.1100009 2.189017072 0 12.37009645 10.0640785 22.43417495 22.435175 22.43417495.7010054 0 1.417011-.0360003 2.188017-.1110009.1810014-.0150001.3600028.0660005.4630036.2190017.1020008.1530012.1130009.3490027.0270002.511004C32.6312544 32.0879695 26.164204 36 19.0661487 36"],"dnd_40":["M11.0049852 1.39012378C4.81099354 5.01111217.999998657 11.605091.999998657 18.8120679c0 11.1319643 9.055987843 20.1879353 20.187972843 20.1879353 7.2079904 0 13.8009815-3.8099878 17.4219767-10.0049679-.5489993.0359999-1.0789986.0529998-1.6019979.0529998-14.3669807 0-26.054965-11.6879625-26.054965-26.05491646 0-.52599832.017-1.05499662.0519999-1.60299486M21.1879715 40C9.50498724 40 0 30.4950305 0 18.8120679 0 10.9240932 4.34799416 3.73811625 11.3459848.0581280469c.1639997-.0869997211.3589995-.0749997596.5119993.0269999134.1519998.1029996697.2359997.2809990987.2179997.4629985157-.0829999.858997244-.1229999 1.656994684-.1229999 2.444992164 0 13.81495566 11.239985 25.05491966 25.0549664 25.05491966.781999 0 1.5809979-.0399999 2.4439967-.1239996.1859998-.0129999.3609995.0669998.4629994.2199993.1029999.1519995.1129998.3489989.027.5109984C36.2619513 35.6530139 29.075961 40 21.1879715 40"],"dnd_48":["M13.2749851 1.38680197C5.67899364 5.7488205.999998881 13.7818546.999998881 22.568892c0 13.4710572 10.959987719 24.4311038 24.431972619 24.4311038 8.7879902 0 16.8199812-4.6790199 21.1809763-12.2740522-.7289991.0510002-1.4269984.0760003-2.1159976.0760003-17.2579807 0-31.297965-14.0400596-31.297965-31.29813294 0-.69200294.025-1.39100591.0759999-2.11700899M25.4319715 48C11.4089872 48 0 36.5919515 0 22.568892 0 13.1018517 5.21799416 4.47581509 13.6179848.0577963211c.1639998-.0870003697.3599996-.0740003144.5109994.0270001147.1529998.1030004372.2369997.2810011942.2189997.4630019672-.0999998 1.037004407-.1489998 2.004008517-.1489998 2.956012557 0 16.70607094 13.5919848 30.29812874 30.2979661 30.29812874.9449989 0 1.9119979-.0490002 2.9549967-.1500007.1779998-.011.3609996.0660003.4629995.218001.1029999.1540006.1129999.3500015.0269999.5120021C43.5249513 42.7829778 34.8999609 48 25.4319715 48"],"dnd_56":["M15.5451913 1.38472625C6.54908058 6.48475181 1.0000123 15.9567993 1.0000123 26.3248513c0 15.8120792 12.8631583 28.6751437 28.6753528 28.6751437 10.3671276 0 19.8392441-5.5500278 24.9393069-14.5450729-.9040111.0670003-1.7710218.1000005-2.6290324.1000005-20.1482479 0-36.5404496-16.3920822-36.5404496-36.54018317 0-.85700429.0330004-1.72500865.1000013-2.63001318M29.6753651 56C13.3121638 56 0 42.6879333 0 26.3248513 0 15.2767959 6.08807491 5.21174543 15.8901955.0577195968c.163002-.0860004311.3600044-.075000376.5110063.0270001353.1530019.1030005159.2370029.2800014039.2190027.4630023209-.1170014 1.219006107-.1750022 2.353011797-.1750022 3.467017377 0 19.59709827 15.9441962 35.54017817 35.5404373 35.54017817 1.1170138 0 2.2500277-.0580003 3.4660427-.1760009.1770022-.0140001.3610044.0670003.4640057.2190011.1020013.1530008.1120014.3500017.0270003.5120026C50.7876249 49.9109695 40.7225011 56 29.6753651 56"],"dnd_8":["M1.99209244 1.46610473c-.62602905.59699043-.99204604 1.4289771-.99204604 2.31996282 0 1.77297158 1.44106687 3.21394848 3.2131491 3.21394848.89104135 0 1.72307996-.36599413 2.32010766-.9919841-2.39111095-.24299611-4.29819945-2.14996554-4.54121072-4.5419272M4.2131955 8C1.8900877 8 0 6.11003029 0 3.78606755 0 2.21809268.864040094.789115584 2.25610469.0581273015c.16200752-.0869986055.35901666-.0749987978.51102371.0269995672.15200706.1029983493.23601095.2799955123.21901016.4629925783-.0130006.130997901-.02000092.264995753-.02000092.398993605 0 2.253963868 1.83308506 4.086934488 4.08718965 4.086934488.13400622 0 .26601235-.00699989.39701843-.01999968.18400853-.02699956.36201679.06499896.46402153.21799651.10300478.15199756.11400529.3489944.0280013.51099181C7.21033458 7.13601385 5.78126827 8 4.2131955 8"],"dock-in_12":["M6.5 2c.276 0 .5.225.5.5l0 1.793 2.146-2.147c.196-.195.512-.195.708 0 .097.098.146.226.146.354 0 .128-.049.256-.146.354L7.707 5 9.5 5c.276 0 .5.225.5.5 0 .276-.224.5-.5.5l-3 0c-.069 0-.135-.014-.195-.04-.119-.05-.215-.146-.266-.266C6.014 5.635 6 5.569 6 5.5l0-3c0-.275.224-.5.5-.5zm4-2c.827 0 1.5.673 1.5 1.5l0 8c0 .827-.673 1.5-1.5 1.5l-4 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l4 0c.276 0 .5-.225.5-.5l0-8c0-.275-.224-.5-.5-.5l-8 0c-.276 0-.5.225-.5.5l0 4c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-4C1 .673 1.673 0 2.5 0l8 0zM4 7c.551 0 1 .448 1 1l0 3c0 .552-.449 1-1 1l-3 0c-.551 0-1-.448-1-1l0-3c0-.552.449-1 1-1l3 0zm-3 4l3 0 0-3-3 0 0 3z"],"dock-in_16":["M12.5 3c.128 0 .256.048.353.146.196.195.196.512 0 .707L9.707 7 12.5 7c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-4 0c-.065 0-.13-.014-.191-.039-.041-.017-.075-.045-.109-.072-.017-.013-.038-.02-.054-.035-.015-.016-.022-.038-.035-.054-.027-.034-.055-.068-.072-.109C8.014 7.631 8 7.565 8 7.5l0-4c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 2.793 3.146-3.147c.098-.098.226-.146.354-.146zM14 0c1.104 0 2 .896 2 2l0 10c0 1.104-.896 2-2 2l-4.5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l4.5 0c.552 0 1-.449 1-1l0-10c0-.551-.448-1-1-1L4 1c-.552 0-1 .449-1 1l0 4.5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5L2 2c0-1.104.896-2 2-2l10 0zM5.5 9c.829 0 1.5.672 1.5 1.5l0 4c0 .828-.671 1.5-1.5 1.5l-4 0C.671 16 0 15.328 0 14.5l0-4C0 9.672.671 9 1.5 9l4 0zm0 1l-4 0c-.276 0-.5.225-.5.5l0 4c0 .275.224.5.5.5l4 0c.276 0 .5-.225.5-.5l0-4c0-.275-.224-.5-.5-.5z"],"dock-out_12":["M6 5.5c0-.128.049-.256.146-.354L8.293 3 6.5 3c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l3 0c.069 0 .135.014.195.04.119.05.215.146.266.266.025.059.039.125.039.194l0 3c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-1.793-2.146 2.147c-.196.195-.512.195-.708 0C6.049 5.756 6 5.628 6 5.5zM10.5 0c.827 0 1.5.673 1.5 1.5l0 8c0 .827-.673 1.5-1.5 1.5l-4 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l4 0c.275 0 .5-.225.5-.5l0-8c0-.275-.225-.5-.5-.5l-8 0c-.275 0-.5.225-.5.5l0 4c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-4C1 .673 1.673 0 2.5 0l8 0zM4 7c.551 0 1 .448 1 1l0 3c0 .552-.449 1-1 1l-3 0c-.551 0-1-.448-1-1l0-3c0-.552.449-1 1-1l3 0zm-3 4l3 0 0-3-3 0 0 3z"],"dock-out_16":["M12.5 3c.065 0 .13.014.191.039.041.017.075.045.109.073.017.012.038.019.054.035.015.016.022.037.035.054.027.034.055.067.072.108.025.061.039.126.039.191l0 4c0 .276-.225.5-.5.5-.275 0-.5-.224-.5-.5l0-2.793-3.146 3.147C8.756 7.952 8.628 8 8.5 8c-.128 0-.256-.048-.353-.146-.196-.195-.196-.511 0-.707L11.293 4 8.5 4c-.275 0-.5-.224-.5-.5 0-.275.225-.5.5-.5l4 0zM14 0c1.104 0 2 .896 2 2l0 10c0 1.104-.896 2-2 2l-4.5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l4.5 0c.552 0 1-.449 1-1l0-10c0-.551-.448-1-1-1L4 1c-.552 0-1 .449-1 1l0 4.5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5L2 2c0-1.104.896-2 2-2l10 0zM5.5 9c.829 0 1.5.672 1.5 1.5l0 4c0 .828-.671 1.5-1.5 1.5l-4 0C.671 16 0 15.328 0 14.5l0-4C0 9.672.671 9 1.5 9l4 0zm0 1l-4 0c-.276 0-.5.225-.5.5l0 4c0 .275.224.5.5.5l4 0c.276 0 .5-.225.5-.5l0-4c0-.275-.224-.5-.5-.5z"],"document_12":["M9.5 11l-7 0c-.276 0-.5-.224-.5-.5l0-9c0-.276.224-.5.5-.5L6 1l0 2.5C6 4.327 6.673 5 7.5 5L10 5l0 5.5c0 .276-.224.5-.5.5zm.427-7L7.5 4c-.275 0-.5-.224-.5-.5l0-2.427L9.927 4zm.832-.583L7.582.24C7.426.085 7.219 0 7 0L6 0 2.5 0C1.673 0 1 .673 1 1.5l0 9c0 .827.673 1.5 1.5 1.5l7 0c.827 0 1.5-.673 1.5-1.5L11 4c0-.22-.085-.426-.241-.583z"],"document_14":["M10.5 13l-7 0c-.275 0-.5-.224-.5-.5l0-11c0-.276.225-.5.5-.5L7 1l0 2.5C7 4.327 7.673 5 8.5 5L11 5l0 7.5c0 .276-.225.5-.5.5zM8 1.366L10.672 4 8.5 4c-.275 0-.5-.224-.5-.5l0-2.134zM11.741 3.7L8.299.257C8.132.091 7.911 0 7.676 0L3.5 0C2.673 0 2 .673 2 1.5l0 11c0 .827.673 1.5 1.5 1.5l7 0c.827 0 1.5-.673 1.5-1.5l0-8.176c0-.236-.092-.458-.259-.624z"],"document_16":["M10 5c-.551 0-1-.449-1-1l0-3 .086 0L13 4.914 13 5l-3 0zm3 9c0 .551-.449 1-1 1l-8 0c-.551 0-1-.449-1-1L3 2c0-.551.449-1 1-1l4 0 0 3c0 1.105.895 2 2 2l3 0 0 8zm.707-9.793L9.793.293C9.605.105 9.351 0 9.086 0L9 0 8 0 4 0C2.895 0 2 .895 2 2l0 12c0 1.105.895 2 2 2l8 0c1.105 0 2-.895 2-2l0-8 0-1 0-.086c0-.265-.105-.519-.293-.707z"],"document_20":["M15.5 19l-11 0c-.827 0-1.5-.673-1.5-1.5l0-15C3 1.673 3.673 1 4.5 1l6.5.032 0 3.469c0 1.381 1.119 2.5 2.5 2.5l3.5 0L17 17.5c0 .827-.673 1.5-1.5 1.5zm1.401-12.999l-3.401 0c-.828 0-1.5-.673-1.5-1.5l0-3.464.002 0 4.899 4.964zm.771-.642c0 0 0 0-.001-.001L12.713.333C12.503.121 12.211 0 11.914 0L4.5 0C3.122 0 2 1.121 2 2.5l0 15C2 18.879 3.122 20 4.5 20l11 0c1.378 0 2.5-1.121 2.5-2.5l0-11.341c0-.301-.117-.585-.328-.8z"],"document_24":["M14.658.342l6 6c.221.22.342.512.342.824L21 21.5c0 1.379-1.121 2.5-2.5 2.5l-13 0C4.121 24 3 22.879 3 21.5l0-19C3 1.121 4.121 0 5.5 0l8.333 0c.308 0 .608.125.825.342zM20 21.5l0-14.334c0-.047-.016-.084-.049-.117l-6-6c-.03-.03-.076-.049-.118-.049L5.5 1C4.673 1 4 1.673 4 2.5l0 19c0 .827.673 1.5 1.5 1.5l13 0c.827 0 1.5-.673 1.5-1.5z","M13 1l0 4.62297222c0 1.30698846 1.1423884 2.36944971 2.5476994 2.36944971L21 8l-.1536332-1.0530052-6.7013327-5.93131802L13 1zm7.7391345 6.04464205l-5.1914351 0c-.842779 0-1.5286196-.63785586-1.5286196-1.42166983l0-4.62193096 6.7200547 6.04360079z"],"document_28":["M22 27L6 27c-1.103 0-2-.897-2-2L4 3c0-1.103.897-2 2-2l9 0 0 6c0 1.657 1.343 3 3 3l6 0 0 15c0 1.103-.897 2-2 2M16.879 1.293l6.828 6.828c.186.187.293.444.293.707L24 9l-6 0c-1.103 0-2-.897-2-2l0-6 .172 0c.263 0 .52.106.707.293m7.535 6.121L17.586.586C17.211.211 16.702 0 16.172 0L6 0C4.343 0 3 1.343 3 3l0 22c0 1.657 1.343 3 3 3l16 0c1.657 0 3-1.343 3-3l0-16.172c0-.53-.211-1.039-.586-1.414"],"document_32":["M27 29c0 1.103-.896 2-2 2L7 31c-1.103 0-2-.897-2-2l0-14.238L5 3c0-1.104.896-2 2-2l10.758 0c.084 0 .166.014.248.024l0 5.976c0 1.657 1.343 3 3 3l5.97 0c.01.081.024.161.024.243L27 29zm-.586-20.171c.053.052.095.113.141.171l-5.549 0c-1.103 0-2-.897-2-2l0-5.55c.056.045.115.085.166.136l7.242 7.243zm.707-.708L19.879.879C19.316.317 18.555.001 17.761 0c-.001 0-.002 0-.003 0L7 0c-.001 0-.002 0-.003 0C5.341.002 4 1.344 4 3l0 11.762L4 29c0 1.657 1.343 3 3 3l18 0c1.657 0 3-1.343 3-3l0-18.757c0-.796-.316-1.559-.879-2.122z"],"document_36":["M30 31.5c0 1.379-1.121 2.5-2.5 2.5l-19 0C7.122 34 6 32.879 6 31.5l0-27C6 3.122 7.122 2 8.5 2L20 2l0 6.5c0 1.93 1.57 3.5 3.5 3.5l6.5 0 0 19.5zM21 2.023c.078.02.152.054.211.112l8.653 8.654c.059.058.092.132.113.211L23.5 11C22.121 11 21 9.878 21 8.5l0-6.477zm9.572 8.059l-8.654-8.654C21.641 1.152 21.274 1 20.885 1L8.5 1C6.57 1 5 2.57 5 4.5l0 27C5 33.43 6.57 35 8.5 35l19 0c1.93 0 3.5-1.57 3.5-3.5l0-20.385c0-.384-.155-.761-.428-1.033z"],"document_40":["M31.168 39L8.834 39c-1.563 0-2.835-1.271-2.835-2.833l0-32.334C5.999 2.271 7.271 1 8.834 1L22 1l0 8.303C22 11.342 23.658 13 25.697 13l8.305 0 0 23.167c0 1.562-1.272 2.833-2.834 2.833M23.82 1.179l10.002 10c.117.115.18.269.18.432l0 .389-8.305 0C24.21 12 23 10.79 23 9.303L23 1l.388 0c.163 0 .317.063.432.179m10.707 9.293L24.526.471C24.222.167 23.817 0 23.388 0L8.834 0C6.72 0 5 1.72 5 3.833l0 32.334C5 38.28 6.72 40 8.834 40l22.332 0C33.28 40 35 38.28 35 36.167l0-24.556c0-.43-.168-.835-.473-1.139"],"document_44":["M35 43L9 43c-1.654 0-3-1.346-3-3L6 4c0-1.654 1.346-3 3-3l16 0 0 9c0 2.206 1.794 4 4 4l9 0 0 26c0 1.654-1.346 3-3 3zm2.775-30.395c.107.108.165.249.196.395L29 13c-1.654 0-3-1.346-3-3l0-8.962c.131.034.256.091.352.187l11.423 11.38zm.706-.707L27.058.517C26.725.184 26.281 0 25.809 0L9 0C6.794 0 5 1.794 5 4l0 36c0 2.206 1.794 4 4 4l26 0c2.206 0 4-1.794 4-4l0-26.852c0-.464-.189-.92-.519-1.25z"],"document_72":["M56.5 70l-41 0c-3.033 0-5.5-2.467-5.5-5.5l0-57C10 4.467 12.467 2 15.5 2L41 2l0 14.5c0 3.584 2.916 6.5 6.5 6.5L62 23l0 41.5c0 3.033-2.467 5.5-5.5 5.5M43.204 2.449l18.348 18.266c.289.288.448.671.448 1.079L62 22l-14.5 0c-3.033 0-5.5-2.467-5.5-5.5L42 2l.117 0c.41 0 .796.159 1.087.449m19.053 17.557L43.909 1.74C43.43 1.263 42.793 1 42.117 1L15.5 1C11.916 1 9 3.916 9 7.5l0 57c0 3.584 2.916 6.5 6.5 6.5l41 0c3.584 0 6.5-2.916 6.5-6.5l0-42.706c0-.676-.264-1.311-.743-1.788"],"document-create_16":["M13.707 4.207c.188.188.293.442.293.707L14 5l0 1 0 8c0 1.105-.895 2-2 2l-8 0c-1.105 0-2-.895-2-2L2 2c0-1.105.895-2 2-2l4 0 1 0 .086 0c.265 0 .519.105.707.293l3.914 3.914zM13 5l0-.086L9.086 1 9 1l0 3c0 .551.449 1 1 1l3 0zm0 9l0-8-3 0c-1.105 0-2-.895-2-2l0-3-4 0c-.551 0-1 .449-1 1l0 12c0 .551.449 1 1 1l8 0c.551 0 1-.449 1-1zm-4.5-4l1.5 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1.5 0 0 1.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-1.5L6 11c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1.5 0 0-1.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 1.5z"],"document-move_16":["M13.707 4.207c.188.188.293.442.293.707L14 5l0 1 0 8c0 1.105-.895 2-2 2l-8 0c-1.105 0-2-.895-2-2L2 2c0-1.105.895-2 2-2l4 0 1 0 .086 0c.265 0 .519.105.707.293l3.914 3.914zM10 5l3 0 0-.086L9.086 1 9 1l0 3c0 .551.449 1 1 1zm3 9l0-8-3 0c-1.105 0-2-.895-2-2l0-3-4 0c-.551 0-1 .449-1 1l0 12c0 .551.449 1 1 1l8 0c.551 0 1-.449 1-1zm-2.5-3.49972c0 .066-.013.131-.039.193-.005.013-.016.022-.022.034-.023.044-.047.089-.085.127-.001.001-.003.001-.004.003l-1.997 1.997c-.195.195-.513.195-.707 0-.195-.194-.195-.512 0-.708l1.147-1.146-2.793 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l2.793 0-1.147-1.147c-.195-.195-.195-.513 0-.707.194-.195.512-.195.707 0l1.997 1.997c.001.001.003.002.004.003.043.042.073.092.096.145.003.006.008.01.011.016.025.061.039.127.039.193z"],"document-share_16":["M13.707 4.207c.188.188.293.442.293.707L14 5l0 1 0 8c0 1.105-.895 2-2 2l-8 0c-1.105 0-2-.895-2-2L2 2c0-1.105.895-2 2-2l4 0 1 0 .086 0c.265 0 .519.105.707.293l3.914 3.914zM10 5l3 0 0-.086L9.086 1 9 1l0 3c0 .551.449 1 1 1zm3 9l0-8-3 0c-1.105 0-2-.895-2-2l0-3-4 0c-.551 0-1 .449-1 1l0 12c0 .551.449 1 1 1l8 0c.551 0 1-.449 1-1zM8.00025 7.00028c.066 0 .131.013.193.039.013.005.022.016.034.022.044.023.089.047.127.085.001.001.001.003.003.004l1.997 1.997c.195.195.195.513 0 .707-.194.195-.512.195-.708 0l-1.146-1.147 0 2.793c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-2.793-1.147 1.147c-.195.195-.513.195-.707 0-.195-.194-.195-.512 0-.707l1.997-1.997c.001-.001.002-.003.003-.004.042-.043.092-.073.145-.096.006-.003.01-.008.016-.011.061-.025.127-.039.193-.039zM5.49468994 13l5.02819824 0c.27614238 0 .5.2238576.5.5 0 .2761424-.22385762.5-.5.5l-5.02819824 0c-.27614237 0-.5-.2238576-.5-.5 0-.2761424.22385763-.5.5-.5z"],"download_12":["M5.65225 8.854l-3.006-3.006c-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0l2.153 2.152 0-5.793c0-.276.223-.5.5-.5.276 0 .5.224.5.5l0 5.793 2.167-2.168c.196-.195.512-.195.708 0 .195.196.195.512 0 .708l-3.022 3.021c-.098.098-.226.146-.353.146-.128 0-.256-.048-.354-.146zM1.5 10l9 0c.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5l-9 0c-.276142375 0-.5-.22385763-.5-.5 0-.27614237.223857625-.5.5-.5z"],"download_14":["M6.64725 10.854l-4.001-4.002c-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0l3.147 3.147 0-7.792c0-.276.223-.5.5-.5.275 0 .5.224.5.5l0 7.794 3.147-3.148c.195-.195.511-.195.707 0 .195.195.195.512 0 .707l-3.999 4.001c-.098.098-.227.146-.354.146-.128 0-.256-.048-.354-.146zm5.8057913 1.1455c.3010932 0 .5454587.224.5454587.5 0 .276-.2443655.5-.5454587.5l-10.90808262 0c-.30109319 0-.54545868-.224-.54545868-.5 0-.276.24436549-.5.54545868-.5l10.90808262 0z"],"download_16":["M7.646 11.8529l-3.999-3.999c-.196-.196-.196-.512 0-.707.195-.196.511-.196.707 0l3.146 3.146 0-8.793c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 8.793 3.147-3.146c.195-.196.511-.196.707 0 .195.195.195.511 0 .707l-4 3.999c-.046.046-.101.083-.163.109-.061.025-.126.038-.191.038-.065 0-.13-.013-.191-.038-.061-.026-.117-.063-.163-.109zM1.538461538 14L14.4615385 14C14.7587692 14 15 14.224 15 14.5c0 .276-.2412308.5-.5384615.5L1.538461538 15C1.241230769 15 1 14.776 1 14.5c0-.276.241230769-.5.538461538-.5z"],"download_18":["M8.64425 12.8516l-4.998-4.999c-.195-.195-.195-.512 0-.707.196-.195.512-.195.707 0l4.146 4.146 0-8.792c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 8.793 4.149-4.147c.195-.195.512-.195.707 0 .195.195.195.512 0 .707l-5.001 4.999c-.046.047-.103.084-.165.11-.03.012-.062.013-.093.019-.033.007-.062.019-.097.019-.034 0-.064-.012-.096-.019-.031-.006-.063-.007-.093-.019-.063-.026-.119-.063-.166-.11zM16.4666667 15c.2944 0 .5333333.224.5333333.5 0 .276-.2389333.5-.5333333.5L1.533333333 16C1.238933333 16 1 15.776 1 15.5c0-.276.238933333-.5.533333333-.5L16.4666667 15z"],"download_20":["M5.35325 9.12154045l4.146 4.16385655 0-10.783243534C9.49925 2.224964753 9.72325 2 9.99925 2c.277 0 .5.224964753.5.502153466l0 10.783243534 4.147-4.16385655c.098-.09842208.226-.14662881.353-.14662881.128 0 .256.04820673.354.14662881.195.19583985.195.51420515 0 .710045l-4.999 5.02053035c-.047.0472024-.102.0843618-.164.1094695-.122.0512196-.259.0512196-.381 0-.062-.0251077-.117-.0622671-.164-.1094695l-4.999-5.02053035c-.195-.19583985-.195-.51420515 0-.710045.195-.19583985.512-.19583985.707 0zM17.4666667 16.99975c.2944 0 .5333333.224.5333333.5 0 .276-.2389333.5-.5333333.5l-14.933333367 0c-.2944 0-.533333333-.224-.533333333-.5 0-.276.238933333-.5.533333333-.5l14.933333367 0z"],"download_24":["M11.64179772 17.8529l-5.99489823-5.999c-.19586599-.196-.19586599-.512 0-.707.19486667-.196.51065061-.196.70651659 0l5.14248146 5.146 0-13.793c0-.276.22384685-.5.49965813-.5.27581133 0 .49965813.224.49965813.5l0 13.793 5.1434808-5.146c.1948666-.196.5106506-.196.7065166 0 .1948666.195.1948666.511 0 .707l-5.9958976 5.999c-.0459685.046-.1009309.083-.1628885.109-.0609583.025-.1259139.038-.19086943.038-.06495555 0-.12991111-.013-.1908694-.038-.06095829-.026-.11692-.063-.16288855-.109zM21.4739441 21c.2903276 0 .5259559.224.5259559.5 0 .276-.2356283.5-.5259559.5L2.525855925 22C2.235528254 22 1.9999 21.776 1.9999 21.5c0-.276.235628254-.5.525955925-.5L21.4739441 21z"],"download_28":["M7.35325 13.145l6.146 6.146-.002-15.791c0-.276.223-.5.5-.5.276 0 .5.224.5.5l.002 15.792 6.147-6.147c.098-.098.226-.146.353-.146.128 0 .256.048.354.146.195.195.195.512 0 .707l-6.999 6.999c-.047.047-.102.084-.164.109-.122.051-.259.051-.381 0-.062-.025-.117-.062-.164-.109l-6.999-6.999c-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0zm17.1229405 10.85275c.2891428 0 .5238095.224.5238095.5 0 .276-.2346667.5-.5238095.5l-20.952380976 0C3.234666667 24.99775 3 24.77375 3 24.49775c0-.276.234666667-.5.523809524-.5l20.952380976 0z"],"download_32":["M15.64625 23.8535l-8-8c-.195-.195-.195-.512 0-.707.196-.195.512-.195.707 0l7.147 7.146 0-18.793c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 18.793 7.146-7.146c.196-.195.512-.195.707 0 .196.195.196.512 0 .707l-7.999 8c-.047.046-.102.082-.163.107-.061.026-.126.039-.191.039-.065 0-.13-.013-.191-.039-.061-.024-.117-.061-.163-.107zM29.4814815 28C29.7677037 28 30 28.224 30 28.5c0 .276-.2322963.5-.5185185.5L2.518518519 29C2.232296296 29 2 28.776 2 28.5c0-.276.232296296-.5.518518519-.5L29.4814815 28z"],"download-circle_100":["M50 0c27.57 0 50 22.43 50 50 0 27.57-22.43 50-50 50-27.57 0-50-22.43-50-50C0 22.43 22.43 0 50 0zm0 99c27.019 0 49-21.981 49-49C99 22.981 77.019 1 50 1 22.981 1 1 22.981 1 50c0 27.019 21.981 49 49 49zm20.5-30c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-41 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l41 0zm-20.853-7.1465l-13-13c-.196-.195-.196-.512 0-.707.195-.195.511-.195.707 0l12.147 12.146 0-29.793c0-.276.223-.5.5-.5.276 0 .5.224.5.5l0 29.793 12.146-12.146c.195-.195.512-.195.707 0 .195.195.195.512 0 .707l-12.999 13c-.047.046-.102.082-.164.107-.061.026-.126.039-.19.039-.065 0-.13-.013-.191-.039-.062-.024-.117-.061-.163-.107z"],"drag_16":["M15.8882 7.7004c-.013-.018-.02-.038-.036-.054l-2.5-2.5c-.195-.196-.512-.196-.707 0-.195.195-.195.511 0 .707l1.647 1.646-5.792 0 0-5.793 1.646 1.647c.097.097.225.146.354.146.128 0 .255-.049.353-.146.195-.196.195-.512 0-.707l-2.5-2.5c-.016-.016-.036-.022-.054-.036-.035-.026-.067-.055-.108-.072-.122-.051-.261-.051-.384 0-.04.017-.073.046-.107.072-.018.014-.039.02-.054.036l-2.5 2.5c-.196.195-.196.511 0 .707.195.195.512.195.707 0l1.647-1.647 0 5.793-5.794 0 1.646-1.646c.098-.098.147-.226.147-.354 0-.128-.049-.256-.147-.353-.195-.196-.512-.196-.707 0l-2.5 2.5c-.016.016-.022.036-.036.054-.026.034-.054.067-.071.108-.051.122-.051.26 0 .383.016.04.044.072.07.106.014.018.02.04.037.056l2.5 2.5c.195.195.512.195.707 0 .195-.196.195-.512 0-.707l-1.646-1.647 5.794 0 0 5.793-1.647-1.646c-.098-.098-.225-.147-.353-.147-.129 0-.257.049-.354.147-.196.195-.196.511 0 .707l2.5 2.5c.016.017.038.024.056.038.035.025.066.053.105.07.123.05.262.05.384 0 .04-.017.071-.045.105-.07.019-.014.04-.021.057-.038l2.5-2.5c.195-.196.195-.512 0-.707-.195-.196-.512-.196-.707 0l-1.646 1.646 0-5.793 5.792 0-1.647 1.647c-.098.097-.146.225-.146.353 0 .128.048.256.146.354.195.195.512.195.707 0l2.5-2.5c.017-.016.024-.038.038-.056.025-.034.053-.066.07-.106.051-.123.051-.261 0-.383-.017-.041-.045-.074-.072-.108"],"dx70_16":["M7.5 2c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0zM12 3c1.103 0 2 .897 2 2l0 5 0 1 0 2c0 1.103-.897 2-2 2l-8 0c-1.103 0-2-.897-2-2l0-8c0-1.103.897-2 2-2l8 0zm-9 7l10 0 0-5c0-.551-.448-1-1-1L4 4c-.552 0-1 .449-1 1l0 5zm10 3l0-2-10 0 0 2c0 .551.448 1 1 1l8 0c.552 0 1-.449 1-1z"],"dx70_20":["M15.4996 3c1.375 0 2.5 1.125 2.5 2.5l0 11c0 1.375-1.125 2.5-2.5 2.5l-11 0c-1.375 0-2.5-1.125-2.5-2.5l0-11c0-1.375 1.125-2.5 2.5-2.5l11 0zm0 15c.827 0 1.5-.673 1.5-1.5l0-1.5-14 0 0 1.5c0 .827.673 1.5 1.5 1.5l11 0zm-11-14c-.827 0-1.5.673-1.5 1.5l0 8.5 14 0 0-8.5c0-.827-.673-1.5-1.5-1.5l-11 0zm5-2c-.274 0-.5-.225-.5-.5 0-.275.226-.5.5-.5l1 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0z"],"dx80_16":["M7.5 1C7.224 1 7 .776 7 .5c0-.276.224-.5.5-.5l1 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0zm6 1C14.879 2 16 3.122 16 4.5l0 6.5 0 1 0 3c0 .551-.448 1-1 1l-2 0c-.133 0-.26-.053-.354-.146L11.793 15l-7.586 0-.853.854C3.26 15.947 3.133 16 3 16l-2 0c-.552 0-1-.449-1-1l0-3 0-1 0-6.5C0 3.122 1.121 2 2.5 2l11 0zM1 11l14 0 0-6.5c0-.827-.673-1.5-1.5-1.5l-11 0C1.673 3 1 3.673 1 4.5L1 11zm14.001 4L15 15l0-3-14 0 0 3 1.793 0 .853-.854C3.74 14.053 3.867 14 4 14l8 0c.133 0 .26.053.354.146l.853.854L15 15l0 .5.001-.5z"],"dx80_20":["M17.4996 2c1.381 0 2.5 1.119 2.5 2.5l0 9.5 0 1 0 3.5c0 .829-.671 1.5-1.5 1.5l-2.086 0c-.265 0-.519-.105-.707-.293l-.707-.707-10 0-.707.707c-.188.188-.441.293-.707.293l-2.086 0c-.828 0-1.5-.671-1.5-1.5l0-3.5 0-1 0-9.5c0-1.381 1.119-2.5 2.5-2.5l15 0zm-16.5 12l18 0 0-9.5c0-.827-.673-1.5-1.5-1.5l-15 0c-.827 0-1.5.673-1.5 1.5l0 9.5zm18 4.5l0-3.5-18 0 0 3.5c0 .276.225.5.5.5l2.086 0 .707-.707c.187-.188.442-.293.707-.293l10 0c.266 0 .52.105.707.293l.707.707 2.086 0c.276 0 .5-.224.5-.5zm-9-17.5c-.275 0-.5-.224-.5-.5 0-.276.225-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5z"],"edit_10":["M1.4547 7.46198l-.301 1.384 1.384-.301 6.239-6.238c.144-.145.224-.337.224-.542 0-.205-.08-.397-.224-.542-.289-.289-.794-.289-1.083 0l-6.239 6.239zm-.955 2.538c-.131 0-.259-.052-.353-.146-.121-.121-.171-.294-.135-.46l.497-2.288c.02-.093.067-.179.135-.247l6.343-6.343c.688-.688 1.808-.688 2.497 0 .689.689.689 1.809 0 2.498l-6.343 6.343c-.068.067-.154.114-.247.135l-2.287.497c-.036.007-.071.011-.107.011z"],"edit_12":["M1.5649 8.9529l-.411 1.892 1.891-.412 7.648-7.647c.198-.198.307-.46.307-.74 0-.28-.109-.543-.307-.74-.395-.396-1.085-.396-1.48 0l-7.648 7.647zm-1.065 3.046c-.131 0-.259-.052-.353-.147-.121-.12-.172-.293-.135-.46l.607-2.795c.02-.093.067-.179.135-.247l7.752-7.751c.798-.798 2.097-.798 2.894 0 .387.386.6.9.6 1.447 0 .547-.213 1.06-.6 1.447l-7.751 7.752c-.068.067-.154.114-.248.135l-2.795.608c-.035.007-.071.011-.106.011z"],"edit_14":["M1.67533718 10.4453751l-.521 2.4 2.399-.522 9.05800002-9.05700005c.518-.518.518-1.36 0-1.878-.518-.517999998-1.361-.517999998-1.879 0L1.67533718 10.4453751zm-1.175000001 3.554c-.132 0-.259-.052-.354-.146-.1200000004-.12-.1710000004-.294-.1350000004-.46l.7180000004-3.303c.02-.09400005.067-.18000005.135-.24800005L10.0253372.681375052c.907-.909 2.385-.908 3.293 0 .907.907999998.907 2.384999998 0 3.291999998L4.15633718 13.1343751c-.067.068-.153.115-.247.136l-3.303000001.718c-.035.007-.071.011-.106.011z"],"edit_16":["M1.7858 11.9318705l-.632 2.9114582 2.907-.6329692 10.467-10.48205068c.305-.30446621.472-.70908579.472-1.13974524 0-.43065944-.167-.83527902-.472-1.13974523-.607-.609933961-1.668-.609933961-2.275 0L1.7858 11.9318705zM.4998 16.0001c-.131 0-.259-.0520797-.354-.1472254-.12-.1201841-.171-.2944509-.134-.4607055l.829-3.8168445c.02-.0941442.067-.1802761.134-.2483804L11.5458.740734096c.984-.987512128 2.705-.987512128 3.689 0 .493.492754534.765 1.149760574.765 1.847829484 0 .69806892-.272 1.35407343-.765 1.84782949L4.6648 15.0226032c-.067.0671028-.153.1141748-.247.135207l-3.812.8302714c-.035.0080123-.071.0120184-.106.0120184z"],"edit_18":["M1.89633718 13.4285l-.743 3.417 3.417-.743L16.4463372 4.2265c.737-.737.737-1.937 0-2.674-.737-.737-1.937-.737-2.674 0L1.89633718 13.4285zm-1.396000001 4.57c-.132 0-.259-.051-.354-.146-.1200000004-.12-.1710000004-.294-.1350000004-.46l.9390000004-4.32c.02-.093.067000001-.179.135000001-.247L13.0653372.8455c1.127-1.127 2.961-1.127 4.088 0 1.127 1.127 1.127 2.961 0 4.088l-11.98000002 11.98c-.068.068-.153.115-.247.135l-4.320000001.939c-.035.007-.071.011-.106.011z"],"edit_20":["M2.89633718 14.4285l-.743 3.417 3.417-.743L17.4463372 5.2265c.737-.737.737-1.937 0-2.674-.737-.737-1.937-.737-2.674 0L2.89633718 14.4285zm-1.396000001 4.57c-.132 0-.259-.051-.354-.146-.1200000004-.12-.1710000004-.294-.1350000004-.46l.9390000004-4.32c.02-.093.067000001-.179.135000001-.247l11.98000002-11.98c1.127-1.127 2.961-1.127 4.088 0 1.127 1.127 1.127 2.961 0 4.088l-11.98000002 11.98c-.068.068-.153.115-.247.135l-4.320000001.939c-.035.007-.071.011-.106.011z"],"edit_24":["M3.11733718 17.4115l-.964 4.433 4.433-.964L21.2813372 6.1865c.957-.957.957-2.513 0-3.47-.956-.956-2.513-.956-3.469 0L3.11733718 17.4115zm-1.617000001 5.587c-.132 0-.259-.052-.354-.147-.1200000004-.12-.1710000004-.293-.1350000004-.46l1.1600000014-5.336c.02-.093.067-.179.135-.247L17.1053372 2.0095c1.346-1.346 3.537-1.346 4.883 0 1.347 1.347 1.347 3.537 0 4.884L7.19033718 21.6915c-.068.068-.154.115-.248.136l-5.336000001 1.16c-.035.007-.071.011-.106.011z"],"edit_56":["M5.775 40.7859l-2.621 12.057 12.057-2.621 35.835-35.836c2.602-2.601 2.602-6.834 0-9.435-2.602-2.602-6.834-2.602-9.436 0L5.775 40.7859zM2.5 53.9959c-.131 0-.259-.051-.353-.146-.121-.12-.172-.293-.136-.46l2.818-12.96c.02-.093.067-.179.135-.247l35.939-35.939c2.992-2.992 7.859-2.992 10.85 0 2.991 2.991 2.991 7.858 0 10.849l-35.939 35.94c-.068.067-.154.114-.247.135l-12.96 2.817c-.036.008-.072.011-.107.011z"],"email_12":["M10.5 10l-9 0c-.276 0-.5-.225-.5-.5l0-5.848 3.888 2.973c.328.25.721.375 1.113.375.394 0 .787-.125 1.114-.375L11 3.654 11 9.5c0 .275-.224.5-.5.5m-9-8l9 0c.244 0 .437.179.481.409L6.508 5.83c-.298.228-.715.228-1.012 0L1.019 2.406C1.064 2.178 1.257 2 1.5 2m9-1l-9 0C.673 1 0 1.673 0 2.5l0 7c0 .827.673 1.5 1.5 1.5l9 0c.827 0 1.5-.673 1.5-1.5l0-7c0-.827-.673-1.5-1.5-1.5"],"email_16":["M14 13L2 13c-.551 0-1-.449-1-1l0-7.762 5.616 4.294C7.023 8.844 7.512 9 8 9c.488 0 .977-.156 1.384-.468L15 4.238 15 12c0 .551-.449 1-1 1zm0-10c.249 0 .469.101.645.251L8.776 7.738c-.457.35-1.095.35-1.552 0L1.355 3.251C1.531 3.101 1.751 3 2 3l12 0zm0-1L2 2C.897 2 0 2.897 0 4l0 8c0 1.103.897 2 2 2l12 0c1.103 0 2-.897 2-2l0-8c0-1.103-.897-2-2-2z"],"email_20":["M17.5 17l-15 0c-.828 0-1.5-.672-1.5-1.5L1 4.823l7.346 5.618C8.833 10.814 9.417 11 10 11c.583 0 1.167-.186 1.654-.559L19 4.824 19 15.5c0 .828-.672 1.5-1.5 1.5M2.5 3l15 0c.546 0 1.02.295 1.282.732l-7.736 5.915c-.616.471-1.476.471-2.092 0L1.218 3.732C1.48 3.295 1.954 3 2.5 3m15-1l-15 0C1.119 2 0 3.119 0 4.5l0 11C0 16.881 1.119 18 2.5 18l15 0c1.381 0 2.5-1.119 2.5-2.5l0-11C20 3.119 18.881 2 17.5 2"],"email_56":["M50.1001 48l-44.2 0c-2.151 0-3.9-1.75-3.9-3.9l0-31.24 21.916 16.761c1.203.919 2.643 1.379 4.084 1.379 1.441 0 2.881-.46 4.083-1.379l21.917-16.761 0 31.24c0 2.15-1.75 3.9-3.9 3.9m-44.2-40l44.2 0c2.056 0 3.727 1.604 3.872 3.624l-22.496 17.203c-2.047 1.564-4.905 1.564-6.952 0L2.0281 11.624C2.1731 9.604 3.8441 8 5.9001 8m44.2-1l-44.2 0c-2.702 0-4.9 2.198-4.9 4.9l0 32.2c0 2.702 2.198 4.9 4.9 4.9l44.2 0c2.702 0 4.9-2.198 4.9-4.9l0-32.2c0-2.702-2.198-4.9-4.9-4.9"],"email-circle_24":["M17 15l0-5.516-3.655 3.047c-.39.324-.867.487-1.345.487-.478 0-.955-.163-1.345-.488L7 9.484 7 15c0 .553.448 1 1 1l8 0c.552 0 1-.447 1-1zM8 8c-.313 0-.581.153-.765.378l4.061 3.384c.408.342 1 .341 1.408.001l4.061-3.385C16.582 8.153 16.313 8 16 8L8 8zm4-8c6.627 0 12 5.372 12 12 0 6.628-5.373 12-12 12-6.627 0-12-5.372-12-12C0 5.372 5.373 0 12 0z"],"email-circle_32":["M24 20.5l0-9c0-.113-.015-.223-.039-.328l-6.275 5.229c-.489.408-1.087.611-1.686.611-.599 0-1.197-.203-1.686-.611l-6.275-5.229c-.024.105-.039.215-.039.328l0 9c0 .828.671 1.5 1.5 1.5l13 0c.829 0 1.5-.672 1.5-1.5zM9.5 10c-.348 0-.664.123-.918.322l6.373 5.311c.605.505 1.485.505 2.09 0l6.373-5.311c-.254-.199-.57-.322-.918-.322l-13 0zM16 0c8.836 0 16 7.163 16 16 0 8.837-7.164 16-16 16-8.837 0-16-7.163-16-16C0 7.163 7.163 0 16 0z"],"email-circle_40":["M30 26l0-12c0-.115-.015-.226-.034-.335l-7.939 6.616c-.587.489-1.307.734-2.027.734-.72 0-1.44-.245-2.027-.734l-7.939-6.616c-.019.109-.034.22-.034.335l0 12c0 1.104.896 2 2 2l16 0c1.104 0 2-.896 2-2zM12 12c-.618 0-1.163.286-1.53.726l8.143 6.786c.803.67 1.97.67 2.774 0l8.143-6.786c-.367-.44-.912-.726-1.53-.726l-16 0zm8-12c11.045 0 20 8.954 20 20 0 11.046-8.955 20-20 20C8.954 40 0 31.046 0 20 0 8.954 8.954 0 20 0z"],"email-invite_100":["M89.5 97l-79 0C6.364 97 3 93.636 3 89.5l0-55.412 39.907 30.517C44.995 66.202 47.498 67 50 67c2.502 0 5.005-.798 7.093-2.395L97 34.088 97 89.5c0 4.136-3.364 7.5-7.5 7.5zm-79-72l2.5 0 0 15.476-10-7.648 0-.328c0-4.136 3.364-7.5 7.5-7.5zm11-22l57 0c4.136 0 7.5 3.364 7.5 7.5l0 30.74-29.515 22.571c-3.818 2.919-9.152 2.919-12.97 0L14 41.24l0-30.74C14 6.364 17.364 3 21.5 3zm68 22c4.136 0 7.5 3.364 7.5 7.5l0 .328-10 7.648L87 25l2.5 0zm0-1L87 24l0-13.5C87 5.813 83.187 2 78.5 2l-57 0C16.813 2 13 5.813 13 10.5L13 24l-2.5 0C5.813 24 2 27.813 2 32.5l0 57c0 4.687 3.813 8.5 8.5 8.5l79 0c4.687 0 8.5-3.813 8.5-8.5l0-57c0-4.687-3.813-8.5-8.5-8.5z"],"email-invite_16":["M15 5.9746l-1 .765 0-1.74c.552 0 1 .393 1 .875l0 .1zm0 8.15c0 .483-.448.875-1 .875l-12 0c-.552 0-1-.392-1-.875l0-6.891 5.624 4.301c.405.31.891.464 1.376.464.485 0 .971-.154 1.376-.464L15 7.2336l0 6.891zm-14-8.25c0-.482.448-.875 1-.875l0 1.74-1-.765 0-.1zm3-4.875l8 0c.552 0 1 .449 1 1l0 5.505-4.231 3.236c-.454.345-1.085.345-1.538 0L3 7.5046l0-5.505c0-.551.448-1 1-1zm10 3l0-2c0-1.103-.897-2-2-2l-8 0c-1.103 0-2 .897-2 2l0 2c-1.103 0-2 .842-2 1.875l0 8.25c0 1.034.897 1.875 2 1.875l12 0c1.103 0 2-.841 2-1.875l0-8.25c0-1.033-.897-1.875-2-1.875z"],"email-invite_24":["M21.5 23l-19 0c-.827 0-1.5-.673-1.5-1.5L1 9.4l9.076 6.941c.567.432 1.245.649 1.924.649.679 0 1.357-.217 1.924-.649L23 9.4l0 12.1c0 .827-.673 1.5-1.5 1.5zM2.5 6l.518 0 0 3.683L1 8.141 1 7.5C1 6.673 1.673 6 2.5 6zm3-5l13 0c.827 0 1.5.673 1.5 1.5l0 7.935-6.684 5.111c-.775.594-1.857.594-2.632 0L4 10.435 4 2.5C4 1.673 4.673 1 5.5 1zm16 5c.827 0 1.5.673 1.5 1.5l0 .641-2 1.529L21 6l.5 0zm0-1L21 5l0-2.5C21 1.121 19.879 0 18.5 0L5.518 0c-1.379 0-2.5 1.121-2.5 2.5l0 2.5L2.5 5C1.121 5 0 6.121 0 7.5l0 14C0 22.879 1.121 24 2.5 24l19 0c1.379 0 2.5-1.121 2.5-2.5l0-14C24 6.121 22.879 5 21.5 5z"],"email-invite_32":["M28.5 31l-25 0C2.122 31 1 29.879 1 28.5l0-15.808 12.267 9.38c.804.615 1.769.923 2.733.923.964 0 1.929-.308 2.733-.923L31 12.691 31 28.5c0 1.379-1.121 2.5-2.5 2.5zM3.5 9L4 9l0 4.727-2.994-2.289C1.04 10.089 2.143 9 3.5 9zm4-8l17 0C25.879 1 27 2.122 27 3.5l0 10.992-8.874 6.785c-1.252.957-3 .957-4.252 0L5 14.492 5 3.5C5 2.122 6.122 1 7.5 1zm21 8c1.357 0 2.46 1.088 2.494 2.438L28 13.727 28 9l.5 0zm0-1L28 8l0-4.5C28 1.567 26.433 0 24.5 0l-17 0C5.567 0 4 1.567 4 3.5L4 8l-.5 0C1.567 8 0 9.567 0 11.5l0 17C0 30.433 1.567 32 3.5 32l25 0c1.933 0 3.5-1.567 3.5-3.5l0-17C32 9.567 30.433 8 28.5 8z"],"email-read_16":["M14 14.998999l-12 0c-.551 0-1-.4484484-1-1.001001L.978 6.22322322l5.647 4.32232228c.404.3103104.89.4654655 1.375.4654655.485 0 .971-.1551551 1.375-.4654655L15 6.24024024l0 7.75775776c0 .5525526-.449 1.001001-1 1.001001zM7.232 1.26026026c.226-.17217217.497-.25825826.768-.25825826.271 0 .542.08608609.768.25825826l5.545 4.24624625-5.545 4.24424424c-.452.34634635-1.084.34634635-1.536 0L1.687 5.50650651l5.545-4.24624625zm8.398 3.99399399L9.375.465465465c-.809-.62062062-1.941-.62062062-2.75 0L.37 5.25425425C.138 5.43043043 0 5.71071071 0 6.003003l0 7.994995C0 15.1031031.897 16 2 16l12 0c1.103 0 2-.8968969 2-2.002002l0-7.994995c0-.29229229-.138-.57257257-.37-.74874875z"],"email-read_20":["M17.5 19.0000635l-15 0c-.827 0-1.5-.6729572-1.5-1.4999047L1 6.83383638 8.338 12.44448c.49.3739762 1.076.5609643 1.662.5609643.586 0 1.172-.1869881 1.661-.5609643L19 6.83283644l0 10.66732236c0 .8269475-.673 1.4999047-1.5 1.4999047zM8.946 1.35818422c.307-.23498507.676-.35397752 1.047-.35397752.378 0 .759.12299219 1.083.37097644l7.104 4.82669338-7.126 5.44865388c-.62.4749698-1.488.4749698-2.108 0L1.819 6.20187652l7.127-4.8436923zm10.638 4.58970844c-.007-.00599962-.015-.0109993-.022-.01699892L11.661.564234653c-.977-.748952422-2.345-.749952359-3.3-.01699892L.415 5.94789266c-.26.19898736-.415.51296741-.415.84094658L0 17.5001588C0 18.8780713 1.122 20 2.5 20l15 0c1.378 0 2.5-1.1219287 2.5-2.4998412l0-10.71131956c0-.32697923-.155-.64195922-.416-.84094658z"],"email-read_24":["M23 21.5c0 .827-.673 1.5-1.5 1.5l-19 0c-.827 0-1.5-.673-1.5-1.5L1 9.619l.026-.214 9.49 7.109c.447.335.973.502 1.499.502.516 0 1.032-.162 1.475-.485L23 9.587 23 21.5zM1.4 8.2l8.8-6.6c.524-.393 1.146-.6 1.8-.6.654 0 1.276.207 1.8.6l8.8 6.6c.097.073.166.173.229.275l-9.929 7.25c-.535.39-1.253.387-1.784-.012L1.279 8.345c.041-.048.07-.107.121-.145zm21.8-.8L14.4.8C13.689.267 12.844 0 12 0c-.844 0-1.689.267-2.4.8L.8 7.4C.296 7.777 0 8.37 0 9l0 12.5C0 22.875 1.125 24 2.5 24l19 0c1.375 0 2.5-1.125 2.5-2.5L24 9c0-.63-.296-1.223-.8-1.6z"],"emoticons_12":["M6 0c3.309 0 6 2.691 6 6 0 3.309-2.691 6-6 6-3.309 0-6-2.691-6-6 0-3.309 2.691-6 6-6zm0 11c2.757 0 5-2.243 5-5 0-2.757-2.243-5-5-5-2.757 0-5 2.243-5 5 0 2.757 2.243 5 5 5zm2.0322-3.8438c.191-.198.508-.202.707-.01.197.192.202.509.01.707-.727.749-1.703 1.162-2.749 1.162-1.039 0-2.012-.408-2.739-1.15-.193-.197-.189-.514.008-.707.198-.192.514-.189.707.008 1.076 1.097 2.982 1.097 4.056-.01zM4 6c-.552 0-1-.448-1-1 0-.552.448-1 1-1 .552 0 1 .448 1 1 0 .552-.448 1-1 1zm4-2c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1z"],"emoticons_16":["M8 0c4.411 0 8 3.589 8 8 0 4.411-3.589 8-8 8-4.411 0-8-3.589-8-8 0-4.411 3.589-8 8-8zm0 15c3.86 0 7-3.14 7-7 0-3.86-3.14-7-7-7-3.86 0-7 3.14-7 7 0 3.86 3.14 7 7 7zm3.3262-4.7773c.153-.229.464-.292.694-.138.229.155.29.465.137.694-.931 1.391-2.485 2.221-4.157 2.221-1.671 0-3.225-.83-4.156-2.219-.154-.23-.093-.54.136-.694.23-.154.54-.093.694.137.746 1.112 1.989 1.776 3.326 1.776 1.337 0 2.581-.664 3.326-1.777zM5.0044 7.9805c-.263 0-.519-.106-.705-.292-.186-.186-.293-.442-.293-.705 0-.263.107-.519.293-.704.369-.372 1.037-.373 1.41 0 .185.185.291.442.291.704 0 .262-.106.518-.291.705-.187.186-.444.292-.705.292zm5.9936 0c-.263 0-.52-.106-.705-.292-.187-.186-.293-.442-.293-.705 0-.263.106-.519.293-.704.369-.372 1.037-.373 1.409 0 .186.185.292.442.292.704 0 .262-.106.518-.292.705-.186.186-.443.292-.704.292z"],"emoticons_20":["M10 0c5.514 0 10 4.486 10 10 0 5.514-4.486 10-10 10-5.514 0-10-4.486-10-10C0 4.486 4.486 0 10 0zm0 19c4.963 0 9-4.037 9-9 0-4.963-4.037-9-9-9-4.963 0-9 4.037-9 9 0 4.963 4.037 9 9 9zm-3-9c-.553 0-1-.447-1-1 0-.553.447-1 1-1 .553 0 1 .447 1 1 0 .553-.447 1-1 1zm6 0c-.553 0-1-.447-1-1 0-.553.447-1 1-1 .553 0 1 .447 1 1 0 .553-.447 1-1 1zm.8545 3.1865c.176-.214.491-.242.703-.066.213.175.243.491.067.703-1.145 1.384-2.831 2.176-4.624 2.176-1.797 0-3.485-.795-4.629-2.182-.176-.213-.146-.528.067-.704.213-.177.528-.147.704.067.954 1.156 2.359 1.819 3.858 1.819 1.495 0 2.9-.661 3.854-1.813z"],"emoticons_24":["M12 1C5.935 1 1 5.935 1 12c0 6.065 4.935 11 11 11 6.065 0 11-4.935 11-11 0-6.065-4.935-11-11-11m0 23C5.383 24 0 18.617 0 12 0 5.383 5.383 0 12 0c6.617 0 12 5.383 12 12 0 6.617-5.383 12-12 12zm5-14c0-.552-.448-1-1-1-.552 0-1 .448-1 1 0 .552.448 1 1 1 .552 0 1-.448 1-1zm-8 0c0-.552-.448-1-1-1-.552 0-1 .448-1 1 0 .552.448 1 1 1 .552 0 1-.448 1-1zm3 9c2.393 0 4.595-1.207 5.892-3.229.149-.232.081-.542-.152-.691-.229-.148-.541-.082-.69.151C15.938 16.965 14.051 18 12 18c-2.051 0-3.938-1.035-5.05-2.769-.15-.234-.461-.3-.69-.151-.233.149-.301.459-.152.691C7.405 17.793 9.607 19 12 19z"],"endpoint_10":["M8.7 2c.718 0 1.3.582 1.3 1.3l0 5.4c0 .718-.582 1.3-1.3 1.3l-7.4 0C.582 10 0 9.418 0 8.7l0-5.4C0 2.582.582 2 1.3 2l7.4 0zM9 7l0-3.7c0-.165-.135-.3-.3-.3L1.3 3c-.165 0-.3.135-.3.3L1 7l8 0zm0 1.7L9 8 1 8l0 .7c0 .165.135.3.3.3l7.4 0c.165 0 .3-.135.3-.3zM4.5 1C4.224 1 4 .776 4 .5c0-.276.224-.5.5-.5l1 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0z"],"endpoint_12":["M10.5 3c.827 0 1.5.673 1.5 1.5l0 6c0 .827-.673 1.5-1.5 1.5l-9 0C.673 12 0 11.327 0 10.5l0-6C0 3.673.673 3 1.5 3l9 0zm0 8c.275 0 .5-.225.5-.5l0-.5-10 0 0 .5c0 .275.224.5.5.5l9 0zm-9-7c-.276 0-.5.224-.5.5L1 9l10 0 0-4.5c0-.276-.225-.5-.5-.5l-9 0zm4-2c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0z"],"endpoint_14":["M12.3 3c.939 0 1.7.761 1.7 1.7l0 7.6c0 .939-.761 1.7-1.7 1.7L1.7 14C.761 14 0 13.239 0 12.3l0-7.6C0 3.761.761 3 1.7 3l10.6 0zm.7 7l0-5.3c0-.386-.314-.7-.7-.7L1.7 4c-.386 0-.7.314-.7.7L1 10l12 0zm0 2.3l0-1.3-12 0 0 1.3c0 .386.314.7.7.7l10.6 0c.386 0 .7-.314.7-.7zM6.5 2c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0z"],"endpoint_16":["M7.5 2c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0zM1.99406028 3L14.0059397 3C15.1072288 3 16 3.90195036 16 5.0085302l0 7.9829396C16 14.1007504 15.1054862 15 14.0059397 15L1.99406028 15C.892771196 15 0 14.0980496 0 12.9914698l0-7.9829396C0 3.8992496.894513756 3 1.99406028 3zM1 12.9914698C1 13.5485158 1.44781571 14 1.99406028 14l12.01187942 0C14.5523144 14 15 13.5493378 15 12.9914698l0-7.9829396C15 4.45148424 14.5521843 4 14.0059397 4L1.99406028 4C1.44768556 4 1 4.45066217 1 5.0085302l0 7.9829396zM1 11l14 0 0 1-14 0 0-1z"],"endpoint_20":["M9 2.5c0-.276142375.21403503-.5.50468445-.5l.99063115 0C10.7740451 2 11 2.231933594 11 2.5c0 .276142375-.214035.5-.5046844.5l-.99063115 0C9.22595492 3 9 2.768066406 9 2.5zM2.49257535 4L17.5074247 4C18.884036 4 20 5.12743795 20 6.49378313l0 10.01243377C20 17.8834953 18.8818578 19 17.5074247 19L2.49257535 19C1.115964 19 0 17.8725621 0 16.5062169L0 6.49378313C0 5.11650474 1.1181422 4 2.49257535 4zM1 16.5062169C1 17.3248371 1.6727984 18 2.49257535 18l15.01484935 0C18.330352 18 19 17.3304317 19 16.5062169l0-10.01243377C19 5.67516286 18.3272016 5 17.5074247 5L2.49257535 5C1.66964802 5 1 5.66956833 1 6.49378313L1 16.5062169zM1 14l18 0 0 1-18 0 0-1z"],"endpoint_24":["M11.5 3c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0zM2.50050165 4L21.4994984 4C22.8804873 4 24 5.12598062 24 6.50282288l0 12.99435422C24 20.879448 22.8746206 22 21.4994984 22L2.50050165 22C1.11951272 22 0 20.8740194 0 19.4971771L0 6.50282288C0 5.12055197 1.12537944 4 2.50050165 4zM1 19.4971771C1 20.3241517 1.67421141 21 2.50050165 21l18.99899675 0C22.3245167 21 23 20.3249836 23 19.4971771l0-12.99435422C23 5.67584834 22.3257886 5 21.4994984 5L2.50050165 5C1.67548327 5 1 5.67501637 1 6.50282288L1 19.4971771zM1 17l22 0 0 1-22 0 0-1z"],"endpoint_28":["M25 4c1.657 0 3 1.344 3 3l0 16c0 1.656-1.343 3-3 3L3 26c-1.657 0-3-1.344-3-3L0 7c0-1.656 1.343-3 3-3l22 0zm2 16l0-13c0-1.104-.896-2-2-2L3 5c-1.104 0-2 .896-2 2l0 13 26 0zm0 3l0-2-26 0 0 2c0 1.104.896 2 2 2l22 0c1.104 0 2-.896 2-2zM14 3c-.5522847 0-1-.44771525-1-1 0-.55228475.4477153-1 1-1 .5522847 0 1 .44771525 1 1 0 .55228475-.4477153 1-1 1z"],"endpoint_32":["M16 4c-.552 0-1-.448-1-1 0-.552.448-1 1-1 .552 0 1 .448 1 1 0 .552-.448 1-1 1zM3 6l26 0c1.657 0 3 1.343 3 3l0 18c0 1.657-1.343 3-3 3L3 30c-1.657 0-3-1.343-3-3L0 9c0-1.657 1.343-3 3-3zm28 18l0-15c0-1.104-.896-2-2-2L3 7c-1.104 0-2 .896-2 2l0 15 30 0zm0 3l0-2-30 0 0 2c0 1.104.896 2 2 2l26 0c1.104 0 2-.896 2-2z"],"endpoint_48":["M23.9997 5c-.552 0-1-.448-1-1 0-.552.448-1 1-1 .552 0 1 .448 1 1 0 .552-.448 1-1 1zM4.49415034 8L43.5058497 8C45.9879004 8 48 10.01555653 48 12.49993564l0 28.00012876C48 42.9853102 45.9834105 45 43.5058497 45L4.49415034 45C2.01209964 45 0 42.9844435 0 40.5000644l0-28.00012876C0 10.01468981 2.01658947 8 4.49415034 8zM1 40.5000644C1 42.4327756 2.56500133 44 4.49415034 44l39.01169936 0C45.4325428 44 47 42.4316074 47 40.5000644l0-28.00012876C47 10.56722443 45.4349987 9 43.5058497 9L4.49415034 9C2.56745716 9 1 10.56839263 1 12.49993564L1 40.5000644zM1 36l46 0 0 1-46 0 0-1z"],"endpoint_56":["M29 5c0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1 .552 0 1 .448 1 1zM4.99424261 10l46.01151479 0C53.7640014 10 56 12.24325385 56 15.0036561l0 31.9926878C56 49.7597868 53.7701762 52 51.0057574 52L4.99424261 52C2.23599858 52 0 49.7567461 0 46.9963439l0-31.9926878C0 12.24021316 2.22982375 10 4.99424261 10zM1 46.9963439C1 49.2060264 2.78984723 51 4.99424261 51l46.01151479 0C53.2151452 51 55 49.2102524 55 46.9963439l0-31.9926878C55 12.7939736 53.2101528 11 51.0057574 11L4.99424261 11C2.78485485 11 1 12.78974757 1 15.0036561l0 31.9926878zM1 42l54 0 0 1-54 0 0-1z"],"endpoint_8":["M1 5.72376432c.00008596.71261793 0 1.28545771 0 1.28545771C1 6.99903378 7.00296986 7 7.00296986 7 6.9993984 7 7 2.99077797 7 2.99077797 7 3.00096622.997030139 3 .997030139 3 .999251604 3 .999858555 4.55112674 1 5.72376432L1 6l6 0 0-1-6 0 0 .7237643zM.997030139 2L7.00296986 2C7.5536144 2 8 2.45097518 8 2.99077797l0 4.01844406C8 7.55641359 7.54696369 8 7.00296986 8L.997030139 8C.446385598 8 0 7.54902482 0 7.00922203l0-4.01844406C0 2.44358641.453036308 2 .997030139 2zM4.5 1l-1 0C3.225 1 3 .775 3 .5c0-.275.225-.5.5-.5l1 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5z"],"endpoint-g2_16":["M14 2c1.103 0 2 .897 2 2l0 8c0 1.103-.897 2-2 2L2 14c-1.103 0-2-.897-2-2l0-8c0-1.103.897-2 2-2l12 0zm1 10l0-8c0-.551-.448-1-1-1L2 3c-.552 0-1 .449-1 1l0 8c0 .551.448 1 1 1l12 0c.552 0 1-.449 1-1zM8.5 4c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0z"],"endpoint-g2_20":["M17.4996 1.9999c1.375 0 2.5 1.125 2.5 2.5l0 11c0 1.375-1.125 2.5-2.5 2.5l-15 0c-1.375 0-2.5-1.125-2.5-2.5l0-11c0-1.375 1.125-2.5 2.5-2.5l15 0zm1.5 13.5l0-11c0-.827-.673-1.5-1.5-1.5l-15 0c-.827 0-1.5.673-1.5 1.5l0 11c0 .827.673 1.5 1.5 1.5l15 0c.827 0 1.5-.673 1.5-1.5zm-8.5-10.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0c-.275 0-.5-.224-.5-.5 0-.276.225-.5.5-.5l1 0z"],"endpoint-g2-70_16":["M14 0c1.103 0 2 .897 2 2l0 9 0 1 0 3.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-3.5-14 0 0 3.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5L0 12l0-1 0-9C0 .897.897 0 2 0l12 0zM1 11l14 0 0-9c0-.551-.448-1-1-1L2 1c-.552 0-1 .449-1 1l0 9zm7.5-9c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0z"],"endpoint-g2-70_20":["M17.5 0C18.875 0 20 1.125 20 2.5l0 17c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-4.5-18 0 0 4.5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-17C0 1.125 1.125 0 2.5 0l15 0zM19 4l0-1.5c0-.827-.673-1.5-1.5-1.5l-15 0C1.673 1 1 1.673 1 2.5L1 4l0 1 0 9 18 0 0-9 0-1zm-8.5-2c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0z"],"endpoint-g2-70-dual_16":["M14 1c1.103 0 2 .897 2 2l0 2 0 1 0 4 0 1 0 3.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-3.5-13 0 0 3.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5L1 11l0-1 0-4 0-1 0-2c0-1.103.897-2 2-2l11 0zM2 5l13 0 0-2c0-.551-.448-1-1-1L3 2c-.552 0-1 .449-1 1l0 2zm7.5-2c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-2 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l2 0zM9 10l6 0 0-4-6 0 0 4zm-7 0l6 0 0-4-6 0 0 4z"],"endpoint-g2-70-dual_20":["M17.5 0C18.875 0 20 1.125 20 2.5l0 17c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-6.5-8.5 0-1 0L1 13l0 6.5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-17C0 1.125 1.125 0 2.5 0l15 0zM19 4l0-1.5c0-.827-.673-1.5-1.5-1.5l-15 0C1.673 1 1 1.673 1 2.5L1 4l8.5 0 1 0L19 4zm-8.5 8l8.5 0 0-7-8.5 0 0 7zM1 12l8.5 0 0-7L1 5l0 7zm9.5-10c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0z"],"endpoint-g2-stand_16":["M14.5 1c.827 0 1.5.673 1.5 1.5l0 8c0 .827-.673 1.5-1.5 1.5L9 12l0 3 2 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l2 0 0-3-5.5 0c-.827 0-1.5-.673-1.5-1.5l0-8C1 1.673 1.673 1 2.5 1l12 0zm.5 9.5l0-8c0-.276-.225-.5-.5-.5l-12 0c-.275 0-.5.224-.5.5l0 8c0 .276.225.5.5.5l12 0c.275 0 .5-.224.5-.5zM8.5 3c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5z"],"endpoint-g2-stand_20":["M17.405.9998c1.434 0 2.595 1.162 2.595 2.594l0 9.812c0 1.433-1.161 2.594-2.595 2.594l-6.905 0 0 2 3 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-7 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l3 0 0-2-6.905 0c-1.434 0-2.595-1.161-2.595-2.594l0-9.812C0 2.1618 1.161.9998 2.595.9998l14.81 0zM19 13.4058l0-9.812c0-.878-.715-1.594-1.595-1.594l-14.81 0c-.88 0-1.595.716-1.595 1.594l0 9.812c0 .879.715 1.594 1.595 1.594l14.81 0c.88 0 1.595-.715 1.595-1.594zM10 4c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5z"],"endpoint-mx800_16":["M14 0c1.103 0 2 .897 2 2l0 2 0 1 0 6 0 1 0 3.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-3.5-14 0 0 3.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5L0 12l0-1 0-6 0-1 0-2C0 .897.897 0 2 0l12 0zM1 4l14 0 0-2c0-.551-.448-1-1-1L2 1c-.552 0-1 .449-1 1l0 2zm5.5-2c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0zm4 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0zM1 11l14 0 0-6L1 5l0 6z"],"endpoint-mx800_20":["M17.5 0C18.875 0 20 1.125 20 2.5l0 17c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-4.5-18 0 0 4.5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-17C0 1.125 1.125 0 2.5 0l15 0zM1 14l18 0 0-9L1 5l0 9zM1 4l18 0 0-1.5c0-.827-.673-1.5-1.5-1.5l-15 0C1.673 1 1 1.673 1 2.5L1 4zm6.4997-2c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0c-.274 0-.5-.225-.5-.5 0-.275.226-.5.5-.5l1 0zm6 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0c-.274 0-.5-.225-.5-.5 0-.275.226-.5.5-.5l1 0z"],"endpoint-mx800-dual_16":["M14 1c1.103 0 2 .897 2 2l0 2 0 1 0 4 0 1 0 3.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-3.5-13 0 0 3.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5L1 11l0-1 0-4 0-1 0-2c0-1.103.897-2 2-2l11 0zM2 5l13 0 0-2c0-.551-.448-1-1-1L3 2c-.552 0-1 .449-1 1l0 2zm4.5-2c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0zm5 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0zM9 10l6 0 0-4-6 0 0 4zm-7 0l6 0 0-4-6 0 0 4z"],"endpoint-mx800-dual_20":["M17.5 0C18.875 0 20 1.125 20 2.5l0 17c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-6.5-8.5 0-1 0L1 13l0 6.5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-17C0 1.125 1.125 0 2.5 0l15 0zM19 4l0-1.5c0-.827-.673-1.5-1.5-1.5l-15 0C1.673 1 1 1.673 1 2.5L1 4l8.5 0 1 0L19 4zm-8.5 8l8.5 0 0-7-8.5 0 0 7zM1 12l8.5 0 0-7L1 5l0 7zM7.5 2c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0zm6 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0z"],"endpoint-stand_16":["M8.5 1C8.224 1 8 .776 8 .5c0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5zm6 1c.827 0 1.5.673 1.5 1.5l0 6.5 0 1 0 .5c0 .827-.673 1.5-1.5 1.5L9 13l0 2 2 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l2 0 0-2-5.5 0c-.827 0-1.5-.673-1.5-1.5l0-8C1 2.673 1.673 2 2.5 2l12 0zM2 10l13 0 0-6.5c0-.276-.225-.5-.5-.5l-12 0c-.275 0-.5.224-.5.5L2 10zm13 1.5l0-.5-13 0 0 .5c0 .276.225.5.5.5l12 0c.275 0 .5-.224.5-.5z"],"endpoint-stand_20":["M17.4056 2c1.433 0 2.594 1.162 2.594 2.594l0 9.812c0 1.432-1.161 2.594-2.594 2.594l-6.906 0 0 2 3 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-7 0c-.274 0-.5-.225-.5-.5 0-.275.226-.5.5-.5l3 0 0-2-6.905 0c-1.433 0-2.595-1.162-2.595-2.594l0-9.812C-.0004 3.162 1.1616 2 2.5946 2l14.811 0zm1.594 11l0-8.406c0-.879-.715-1.594-1.594-1.594L2.5946 3c-.879 0-1.595.715-1.595 1.594l0 8.406 18 0zm0 1.406l0-.406-18 0 0 .406c0 .879.716 1.594 1.595 1.594l14.811 0c.879 0 1.594-.715 1.594-1.594zM9.9996 1c-.275 0-.5-.224-.5-.5 0-.276.225-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5z"],"enter_16":["M15.8537523 7.63896531L9.86384588 1.646314716c-.19499696-.195086288-.51099202-.195086288-.70698896 0-.19499695.196086731-.19499695.512226564 0 .707312854l5.15291948 5.15528022-7.82087779 0C2.91095452 7.50890779 0 10.42119591 0 13.9997787 0 14.2769013.2239965 14.5.499992188 14.5c.276995672 0 .499992187-.2230987.499992187-.5002213 0-3.02733897 2.461961535-5.49042841 5.488914235-5.49042841l7.78787829 0-5.12291993 5.12526691c-.19499695.1950863-.19499695.5112262 0 .7073129.09799847.0970429.22599647.1460646.35399447.1460646.127998 0 .255996-.0490217.35299448-.1460646l5.99290638-5.99565194c.1949969-.19508629.1949969-.51222656 0-.70731285"],"enter-room_10":["M6.5 7.99996c.276 0 .5.224.5.5l0 .166c0 .735-.599 1.333-1.334 1.333l-4.333 0c-.735 0-1.333-.598-1.333-1.333l0-7.333c0-.735.598-1.333 1.333-1.333l4.333 0c.735 0 1.334.598 1.334 1.333l0 .167c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-.167c0-.183-.149-.333-.334-.333l-4.333 0c-.184 0-.333.15-.333.333l0 7.333c0 .184.149.333.333.333l4.333 0c.185 0 .334-.149.334-.333l0-.166c0-.276.224-.5.5-.5zm3-3.5005c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-3.793 0 1.147 1.146c.195.196.195.512 0 .708-.098.097-.226.146-.354.146-.127 0-.255-.049-.353-.146l-2.001-2c-.018-.019-.025-.042-.04-.061-.024-.033-.051-.064-.067-.102-.025-.061-.039-.126-.039-.191 0 0 0-.001 0-.001 0-.065.014-.13.039-.19.017-.04.044-.073.07-.106.014-.019.021-.04.037-.057l2-2c.195-.195.512-.195.707 0 .195.196.195.512 0 .708l-1.146 1.146 3.793 0z"],"enter-room_12":["M6.0374 5.8086c.025-.062.062-.116.109-.162l1.999-2c.098-.098.226-.147.354-.147.128 0 .256.049.353.147.196.195.196.512 0 .706l-1.146 1.147 2.793 0c.276 0 .5.224.5.5 0 .277-.224.5-.5.5l-2.793 0 1.146 1.147c.196.195.196.512 0 .706-.195.196-.511.196-.707 0l-1.999-1.999c-.047-.046-.084-.102-.109-.162-.05-.122-.05-.261 0-.383zM8.5 9.5c.275 0 .5.225.5.5l0 .5c0 .001 0 .002 0 .003C8.998 11.328 8.326 12 7.5 12l-5 0c-.827 0-1.5-.673-1.5-1.5l0-9C1 .673 1.673 0 2.5 0l5 0C8.327 0 9 .673 9 1.5L9 2c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-.5c0-.276-.225-.5-.5-.5l-5 0c-.275 0-.5.224-.5.5l0 9c0 .276.225.5.5.5l5 0c.275 0 .5-.224.5-.5 0-.001 0-.001 0-.002L8 10c0-.275.225-.5.5-.5z"],"enter-room_16":["M12 14c0 1.103-.897 2-2 2l-7 0c-1.103 0-2-.897-2-2L1 2c0-1.104.897-2 2-2l7 0c1.103 0 2 .896 2 2l0 1c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-1c0-.552-.448-1-1-1L3 1c-.552 0-1 .448-1 1l.026 12.128c.066.489.468.872.974.872l7 0c.552 0 1-.448 1-1l0-1c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 1zm-.1634-3.3232c.195.195.195.513 0 .707-.196.195-.512.195-.707 0l-2.983-2.981c-.094-.094-.147-.221-.147-.355 0-.133.053-.26.147-.353l3.031-3.031c.098-.097.226-.145.354-.145.128 0 .256.048.353.145.196.196.196.512 0 .707l-2.177 2.177 4.812 0c.276 0 .5.225.5.5 0 .276-.224.5-.5.5l-4.812 0 2.129 2.129z"],"enter-room_20":["M15 2.5C15 1.119 13.881 0 12.5 0l-9 0C2.119 0 1 1.119 1 2.5l0 15C1 18.881 2.119 20 3.5 20l9 0c1.381 0 2.5-1.119 2.5-2.5l0-1.5c0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5l0 1.5c0 .827-.673 1.5-1.5 1.5l-9 0c-.827 0-1.5-.673-1.5-1.5l0-15C2 1.673 2.673 1 3.5 1l9 0c.827 0 1.5.673 1.5 1.5L14 4c0 .276.224.5.5.5.276 0 .5-.224.5-.5l0-1.5zm-.146 11.854c.195-.196.195-.512 0-.708L11.707 10.5l6.793 0c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5l-6.793 0 3.147-3.146c.195-.196.195-.512 0-.708-.196-.195-.512-.195-.708 0l-3.999 4c-.046.046-.083.102-.109.163-.05.122-.05.26 0 .382.026.061.063.117.109.163l3.999 4c.098.097.226.146.354.146.128 0 .256-.049.354-.146z"],"enter-room_24":["M17.854 7.6494c.195.196.195.512 0 .707l-3.145 3.141 6.791 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-6.797 0 3.151 3.146c.195.195.195.512 0 .708-.098.097-.226.146-.354.146-.128 0-.256-.049-.354-.146l-4-3.995c-.098-.098-.146-.227-.146-.356l0-.003c0-.065.013-.13.039-.192.023-.056.058-.106.099-.149.004-.004.005-.009.008-.013l4-3.995c.196-.194.512-.194.708.001zM18 21.5c0 1.378-1.121 2.5-2.5 2.5l-11 0C3.121 24 2 22.878 2 21.5l0-19C2 1.122 3.121 0 4.5 0l11 0C16.879 0 18 1.122 18 2.5l0 2c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-2c0-.827-.673-1.5-1.5-1.5l-11 0C3.673 1 3 1.673 3 2.5l0 19c0 .827.673 1.5 1.5 1.5l11 0c.827 0 1.5-.673 1.5-1.5l0-2c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 2z"],"enter-room_28":["M5 27c-1.654 0-3-1.346-3-3L2 4c0-1.654 1.346-3 3-3l12 0c1.654 0 3 1.346 3 3l0 1.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5L19 4c0-1.103-.897-2-2-2L5 2c-1.103 0-2 .897-2 2l0 20c0 1.103.897 2 2 2l12 0c1.103 0 2-.897 2-2l0-1.481c0-.277.224-.5.5-.5.276 0 .5.223.5.5L20 24c0 1.654-1.346 3-3 3L5 27zM19.853 8.3496l-5.147 5.15 10.794 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-10.794 0 5.147 5.151c.195.196.195.512 0 .707-.098.098-.226.147-.353.147-.128 0-.256-.049-.354-.147l-5.999-6.004c-.047-.046-.084-.101-.109-.163-.051-.122-.051-.26 0-.382.025-.061.062-.117.109-.163l5.999-6.003c.195-.196.512-.196.707 0 .195.195.195.511 0 .707z"],"enter-room_8":["M5.4999 6c.275 0 .5.225.5.5l0 .333c0 .644-.523 1.167-1.167 1.167l-3.666 0c-.644 0-1.167-.523-1.167-1.167l0-5.666C-.0001.523.5229 0 1.1669 0l3.666 0c.644 0 1.167.523 1.167 1.167l0 .333c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-.333c0-.092-.075-.167-.167-.167l-3.666 0c-.092 0-.167.075-.167.167l0 5.666c0 .092.075.167.167.167l3.666 0c.092 0 .167-.075.167-.167l0-.333c0-.275.225-.5.5-.5zm2-2.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-3.793 0 .647.646c.195.196.195.512 0 .708-.098.097-.226.146-.354.146-.128 0-.256-.049-.354-.146l-1.5-1.5c-.195-.196-.195-.512 0-.708l1.5-1.5c.196-.195.512-.195.708 0 .195.196.195.512 0 .708l-.647.646 3.793 0z"],"eraser_12":["M10.6743 4.9587l-4.193 4.209-3.659-3.631 4.192-4.208c.435-.438 1.147-.438 1.586-.005l2.069 2.053c.213.211.33.492.331.791 0 .298-.115.579-.326.791zm-5.688 5.71c-.436.436-1.148.438-1.587.004l0 .001-2.069-2.053c-.212-.211-.329-.492-.33-.791-.001-.298.115-.579.325-.791l.791-.794 3.66 3.631-.79.793zm6.387-8.001L9.3043.6137c-.829-.821-2.174-.819-2.999.01l-5.688 5.71c-.4.401-.619.934-.617 1.499.001.566.224 1.098.626 1.497l2.069 2.053 0 .001c.413.409.954.614 1.495.614.546 0 1.09-.208 1.504-.624l5.688-5.71c.4-.401.619-.934.618-1.499-.002-.566-.224-1.098-.627-1.497z"],"eraser_14":["M12.5879905 5.83491029L7.56899903 10.8759396 3.11500661 6.45492994 8.13399807 1.4139006c.54999907-.552126997 1.44899754-.556120683 2.00299663-.00599053l2.4449958 2.4281607c.2689995.26558008.4169993.62101807.4179993.99842134.001.37640484-.1449998.73184284-.4119993 1.00041818zM5.86600193 12.5862354c-.54999907.5511286-1.44999753.5551222-2.00299659.0059905L1.4180095 10.1640652c-.26799955-.26558006-.4169993-.62101806-.41799929-.99842132-.001000002-.37740327.14599975-.73184284.4119993-1.00041818l.9979983-1.00241503 4.45399242 4.42100973-.9979983 1.002415zm7.42098737-9.45804536L10.8419935.700029346c-.94499843-.937517637-2.47799582-.932525531-3.41699422.009984213L.703010712 7.46133865C.248011486 7.9176172-.001988089 8.52465738.0000119077 9.16863914c.0019999966.64498019.2549995663 1.25002356.7129987873 1.70330676l2.444995845 2.4281607C3.62900573 13.7673678 4.24500469 14 4.86100364 14c.62199894 0 1.24299788-.2366259 1.71399708-.7098776l6.72198858-6.75132506c.4549992-.45627856.7049988-1.06331873.7029988-1.70730049-.002-.64498019-.2549996-1.25002352-.7129988-1.70330681z"],"eraser_16":["M14.5020107 6.70776137L8.97001068 12.2617614l-5.227-5.22700003 5.51-5.532c.665-.667999996 1.75100002-.670999996 2.42000002-.007l2.822 2.8c.324.321.503.748.505 1.204.001.456-.176.885-.498 1.208zM6.74601068 14.4947614c-.664.669-1.75.671-2.42.007l-2.822-2.8c-.324-.321-.503-.748-.504-1.204-.002000002-.456.175-.88500003.497-1.20800003l1.54-1.546 5.227 5.22700003-1.518 1.524zM15.1990107 3.58576137l-2.822-2.799999996c-1.06-1.052-2.77800002-1.047-3.83300002.011L.788010678 8.58376137c-.511.513-.7899999996 1.194-.7879999996 1.91700003.002.723.2859999996 1.402.7999999996 1.911l2.822000002 2.8c.527.524 1.219.786 1.91.786.697 0 1.393-.266 1.923-.797l7.75600002-7.78700003c.511-.513.791-1.194.789-1.917-.003-.723-.287-1.402-.801-1.911z"],"eraser_18":["M16.417 7.5826l-6.672 6.699-6.043-5.995 6.672-6.698c.391-.393.906-.589 1.422-.589.512 0 1.023.193 1.414.581l3.199 3.173c.38.377.59.879.591 1.414.001.534-.206 1.036-.583 1.415zm-8.791 8.826c-.779.782-2.051.786-2.836.008l-3.199-3.173c-.38-.377-.59-.879-.591-1.414-.001-.534.206-1.036.583-1.415l1.414-1.42 6.043 5.995-1.414 1.419zm9.487-12.364L13.915.8716c-1.176-1.166-3.081-1.162-4.25.012l-8.79 8.826c-.567.567-.877 1.321-.875 2.123.002.802.317 1.556.887 2.12l3.198 3.173c.586.581 1.353.872 2.119.872.773-.001 1.545-.295 2.131-.884l8.79-8.826c.567-.567.877-1.321.875-2.123-.002-.802-.317-1.556-.887-2.12z"],"error_12":["M7.8535 4.1465c-.195-.195-.512-.195-.707 0l-1.147 1.146-1.146-1.146c-.195-.195-.512-.195-.707 0-.195.195-.195.512 0 .707l1.146 1.147-1.146 1.146c-.195.195-.195.512 0 .707.098.098.226.147.353.147.128 0 .256-.049.354-.147l1.146-1.146 1.147 1.146c.098.098.226.147.353.147.128 0 .256-.049.354-.147.195-.195.195-.512 0-.707l-1.146-1.146 1.146-1.147c.195-.195.195-.512 0-.707M6 11c2.76142375 0 5-2.23857625 5-5 0-2.76142375-2.23857625-5-5-5-2.76142375 0-5 2.23857625-5 5 0 2.76142375 2.23857625 5 5 5zm0 1c-3.3137085 0-6-2.6862915-6-6 0-3.3137085 2.6862915-6 6-6 3.3137085 0 6 2.6862915 6 6 0 3.3137085-2.6862915 6-6 6z"],"error_16":["M10.8535 5.1465c-.195-.195-.512-.195-.707 0l-2.147 2.146-2.146-2.146c-.195-.195-.512-.195-.707 0-.195.195-.195.512 0 .707l2.146 2.147-2.146 2.146c-.195.195-.195.512 0 .707.098.098.226.147.353.147.128 0 .256-.049.354-.147l2.146-2.146 2.147 2.146c.098.098.226.147.353.147.128 0 .256-.049.354-.147.195-.195.195-.512 0-.707l-2.146-2.146 2.146-2.147c.195-.195.195-.512 0-.707M8 15c3.8659932 0 7-3.1340068 7-7 0-3.86599325-3.1340068-7-7-7-3.86599325 0-7 3.13400675-7 7 0 3.8659932 3.13400675 7 7 7zm0 1c-4.418278 0-8-3.581722-8-8 0-4.418278 3.581722-8 8-8 4.418278 0 8 3.581722 8 8 0 4.418278-3.581722 8-8 8z"],"error_20":["M13.8535 6.1465c-.195-.195-.512-.195-.707 0l-3.147 3.146-3.146-3.146c-.195-.195-.512-.195-.707 0-.195.195-.195.512 0 .707l3.146 3.147-3.146 3.146c-.195.195-.195.512 0 .707.098.098.226.147.353.147.128 0 .256-.049.354-.147l3.146-3.146 3.147 3.146c.098.098.226.147.353.147.128 0 .256-.049.354-.147.195-.195.195-.512 0-.707l-3.146-3.146 3.146-3.147c.195-.195.195-.512 0-.707M10 19c4.9705627 0 9-4.0294373 9-9 0-4.97056275-4.0294373-9-9-9-4.97056275 0-9 4.02943725-9 9 0 4.9705627 4.02943725 9 9 9zm0 1C4.4771525 20 0 15.5228475 0 10 0 4.4771525 4.4771525 0 10 0c5.5228475 0 10 4.4771525 10 10 0 5.5228475-4.4771525 10-10 10z"],"error_24":["M15.8901 8.1797c-.193-.193-.508-.193-.701 0l-3.154 3.154-3.155-3.154c-.193-.193-.508-.193-.701 0-.192.192-.192.508 0 .701l3.155 3.154-3.155 3.155c-.192.192-.192.508 0 .701.193.192.508.192.701 0l3.155-3.154 3.154 3.154c.193.192.508.192.701 0 .193-.193.193-.509 0-.701l-3.154-3.155 3.154-3.154c.193-.193.193-.509 0-.701M12 23c6.0751322 0 11-4.9248678 11-11 0-6.07513225-4.9248678-11-11-11C5.92486775 1 1 5.92486775 1 12c0 6.0751322 4.92486775 11 11 11zm0 1C5.372583 24 0 18.627417 0 12 0 5.372583 5.372583 0 12 0c6.627417 0 12 5.372583 12 12 0 6.627417-5.372583 12-12 12z"],"error_40":["M20 0c11.046 0 20 8.954 20 20 0 11.046-8.954 20-20 20C8.954 40 0 31.046 0 20 0 8.954 8.954 0 20 0zm0 39c10.477 0 19-8.523 19-19C39 9.523 30.477 1 20 1 9.523 1 1 9.523 1 20c0 10.477 8.523 19 19 19zm6.8535-25.8535c.195.195.195.512 0 .707l-6.146 6.147 6.146 6.146c.195.195.195.512 0 .707-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147l-6.147-6.146-6.146 6.146c-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147-.195-.195-.195-.512 0-.707l6.146-6.146-6.146-6.147c-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0l6.146 6.146 6.147-6.146c.195-.195.512-.195.707 0z"],"error_8":["M4.0002 3.2934l-1.146-1.146c-.196-.196-.512-.196-.708 0-.195.195-.195.511 0 .707l1.147 1.146-1.147 1.147c-.195.195-.195.511 0 .707.098.097.226.146.354.146.128 0 .256-.049.354-.146l1.146-1.147 1.146 1.147c.098.097.226.146.354.146.128 0 .256-.049.354-.146.195-.196.195-.512 0-.707l-1.147-1.147 1.147-1.146c.195-.196.195-.512 0-.707-.196-.196-.512-.196-.708 0l-1.146 1.146zM4 7c1.65685425 0 3-1.34314575 3-3 0-1.65685425-1.34314575-3-3-3-1.65685425 0-3 1.34314575-3 3 0 1.65685425 1.34314575 3 3 3zm0 1C1.790861 8 0 6.209139 0 4c0-2.209139 1.790861-4 4-4 2.209139 0 4 1.790861 4 4 0 2.209139-1.790861 4-4 4z"],"error_80":["M53.8535 26.1467c-.195-.195-.512-.195-.707 0l-13.147 13.146-13.146-13.146c-.195-.195-.512-.195-.707 0-.195.195-.195.512 0 .707l13.146 13.147-13.146 13.146c-.195.195-.195.512 0 .707.098.098.226.147.353.147.128 0 .256-.049.354-.147l13.146-13.146 13.147 13.146c.098.098.226.147.353.147.128 0 .256-.049.354-.147.195-.195.195-.512 0-.707l-13.146-13.146 13.146-13.147c.195-.195.195-.512 0-.707M40 79c21.5391052 0 39-17.4608948 39-39C79 18.4608948 61.5391052 1 40 1 18.4608948 1 1 18.4608948 1 40c0 21.5391052 17.4608948 39 39 39zm0 1C17.90861 80 0 62.09139 0 40 0 17.90861 17.90861 0 40 0c22.09139 0 40 17.90861 40 40 0 22.09139-17.90861 40-40 40z"],"error-legacy_12":["M11.569 2.8411c.279.279.431.648.431 1.04l0 4.238c0 .387-.157.766-.431 1.039l-2.411 2.411c-.273.274-.652.431-1.039.431l-4.238 0c-.386 0-.765-.157-1.039-.43L.431 9.1581C.157 8.8861 0 8.5071 0 8.1191l0-4.238c0-.393.153-.762.431-1.04l2.41-2.41c.278-.278.647-.431 1.04-.431l4.238 0c.388 0 .767.157 1.04.431l2.41 2.41zM11 8.1191l0-4.238c0-.125-.049-.244-.139-.333l-2.41-2.41c-.088-.088-.208-.138-.332-.138l-4.238 0c-.126 0-.244.049-.333.138l-2.41 2.41c-.088.088-.138.209-.138.333l0 4.238c0 .124.05.244.137.331l2.411 2.412c.088.087.209.138.333.138l4.238 0c.123 0 .244-.05.332-.138l2.411-2.411c.088-.088.138-.209.138-.332zM7.8535 4.1465c.195.195.195.512 0 .707l-1.146 1.147 1.146 1.146c.195.195.195.512 0 .707-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147l-1.147-1.146-1.146 1.146c-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147-.195-.195-.195-.512 0-.707l1.146-1.146-1.146-1.147c-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0l1.146 1.146 1.147-1.146c.195-.195.512-.195.707 0z"],"error-legacy_16":["M15.466 3.8216c.339.339.534.809.534 1.289l0 5.779c0 .479-.195.949-.534 1.289l-3.287 3.287c-.34.34-.81.534-1.29.534l-5.778 0c-.48 0-.95-.194-1.29-.534l-3.287-3.287c-.339-.34-.534-.81-.534-1.289l0-5.779c0-.48.195-.95.534-1.289L3.821.5346c.34-.34.81-.535 1.29-.535l5.778 0c.48 0 .95.195 1.29.535l3.287 3.287zM15 10.8896l0-5.779c0-.217-.088-.429-.241-.582l-3.287-3.287c-.154-.154-.366-.242-.583-.242l-5.778 0c-.217 0-.429.088-.583.242l-3.287 3.287c-.153.153-.241.365-.241.582l0 5.779c0 .217.088.429.241.582l3.287 3.287c.154.153.366.241.583.241l5.778 0c.217 0 .429-.088.583-.241l3.287-3.287c.153-.153.241-.365.241-.582zm-4.1465-5.7431c.195.195.195.512 0 .707l-2.146 2.147 2.146 2.146c.195.195.195.512 0 .707-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147l-2.147-2.146-2.146 2.146c-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147-.195-.195-.195-.512 0-.707l2.146-2.146-2.146-2.147c-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0l2.146 2.146 2.147-2.146c.195-.195.512-.195.707 0z"],"error-legacy_20":["M19.362 4.8022c.406.403.638.964.638 1.538l0 7.32c0 .573-.232 1.135-.639 1.539l-4.163 4.163c-.403.405-.965.638-1.538.638l-7.32 0c-.573 0-1.135-.233-1.539-.639l-4.163-4.163c-.406-.403-.638-.965-.638-1.538l0-7.32c0-.574.232-1.135.639-1.539L4.802.6382c.403-.406.965-.638 1.538-.638l7.32 0c.573 0 1.135.232 1.539.639l4.163 4.163zM19 13.6602l0-7.32c0-.31-.125-.613-.344-.83l-4.165-4.165c-.219-.22-.521-.345-.831-.345l-7.32 0c-.31 0-.612.125-.83.344l-4.165 4.165c-.22.218-.345.521-.345.831l0 7.32c0 .31.125.612.344.83l4.165 4.165c.219.22.521.345.831.345l7.32 0c.31 0 .612-.125.83-.344l4.165-4.165c.22-.219.345-.521.345-.831zm-5.1465-7.5137c.195.195.195.512 0 .707l-3.146 3.147 3.146 3.146c.195.195.195.512 0 .707-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147l-3.147-3.146-3.146 3.146c-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147-.195-.195-.195-.512 0-.707l3.146-3.146-3.146-3.147c-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0l3.146 3.146 3.147-3.146c.195-.195.512-.195.707 0z"],"error-legacy_24":["M23.259 5.7817c.478.478.741 1.113.741 1.788l0 8.861c0 .675-.263 1.31-.74 1.788l-5.041 5.04c-.47.471-1.122.741-1.789.741l-8.86 0c-.667 0-1.319-.27-1.789-.741l-5.04-5.04c-.478-.478-.741-1.113-.741-1.788l0-8.861c0-.675.263-1.31.74-1.788l5.041-5.04c.47-.471 1.122-.742 1.789-.742l8.86 0c.667 0 1.319.271 1.789.742l5.04 5.04zM23 16.4307l0-8.861c0-.409-.159-.792-.448-1.081l-5.04-5.04c-.285-.286-.679-.449-1.082-.449l-8.86 0c-.403 0-.797.163-1.081.449l-5.041 5.04c-.289.289-.448.672-.448 1.081l0 8.861c0 .408.159.792.448 1.081l5.04 5.04c.285.285.679.448 1.082.448l8.86 0c.403 0 .797-.163 1.081-.448l5.041-5.04c.289-.289.448-.673.448-1.081zm-7.1099-8.251c.193.192.193.508 0 .701l-3.154 3.154 3.154 3.155c.193.192.193.508 0 .701-.193.192-.508.192-.701 0l-3.154-3.154-3.155 3.154c-.193.192-.508.192-.701 0-.192-.193-.192-.509 0-.701l3.155-3.155-3.155-3.154c-.192-.193-.192-.509 0-.701.193-.193.508-.193.701 0l3.155 3.154 3.154-3.154c.193-.193.508-.193.701 0z"],"error-legacy_8":["M7.673 1.862c.208.21.327.498.327.79l0 2.697c0 .292-.119.58-.325.789L6.139 7.673c-.21.208-.498.327-.79.327L2.652 8c-.292 0-.581-.119-.79-.325L.327 6.139C.119 5.93 0 5.642 0 5.349l0-2.697c0-.293.119-.581.326-.789L1.862.328C2.071.12 2.36 0 2.652 0l2.697 0c.292 0 .58.12.789.326l1.535 1.536zm-.707 3.57L7 2.652 5.349 1 2.652 1 1.034 2.569 1 5.349l1.569 1.617L5.349 7l1.617-1.568zM4.0002 3.2934l1.146-1.146c.196-.196.512-.196.708 0 .195.195.195.511 0 .707l-1.147 1.146 1.147 1.147c.195.195.195.511 0 .707-.098.097-.226.146-.354.146-.128 0-.256-.049-.354-.146l-1.146-1.147-1.146 1.147c-.098.097-.226.146-.354.146-.128 0-.256-.049-.354-.146-.195-.196-.195-.512 0-.707l1.147-1.147-1.147-1.146c-.195-.196-.195-.512 0-.707.196-.196.512-.196.708 0l1.146 1.146z"],"error-legacy_80":["M77.812 19.501C79.223 20.912 80 22.788 80 24.783l0 30.434c0 1.995-.777 3.871-2.188 5.283L60.5 77.812C59.088 79.223 57.212 80 55.217 80l-30.434 0c-1.995 0-3.871-.777-5.283-2.188L2.188 60.5C.777 59.088 0 57.212 0 55.217l0-30.434c0-1.995.777-3.871 2.188-5.282L19.5 2.188C20.912.777 22.788 0 24.783 0l30.434 0c1.995 0 3.871.777 5.283 2.188l17.312 17.313zM79 55.217l0-30.434c0-1.728-.673-3.353-1.895-4.575L59.792 2.895C58.57 1.673 56.945 1 55.217 1L24.783 1c-1.728 0-3.353.673-4.575 1.895L2.895 20.208C1.673 21.43 1 23.055 1 24.783l0 30.434c0 1.728.673 3.353 1.895 4.576l17.313 17.312C21.43 78.327 23.055 79 24.783 79l30.434 0c1.728 0 3.353-.673 4.575-1.895l17.313-17.312C78.327 58.57 79 56.945 79 55.217zM53.8535 26.1467c.195.195.195.512 0 .707l-13.146 13.147 13.146 13.146c.195.195.195.512 0 .707-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147l-13.147-13.146-13.146 13.146c-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147-.195-.195-.195-.512 0-.707l13.146-13.146-13.146-13.147c-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0l13.146 13.146 13.147-13.146c.195-.195.512-.195.707 0z"],"ethernet_16":["M15.0002 14.7498c0 .138-.112.25-.25.25l-2.5 0c-.138 0-.25-.112-.25-.25l0-2.5c0-.138.112-.25.25-.25l2.5 0c.138 0 .25.112.25.25l0 2.5zM4 12.2498l0 2.5c0 .138-.112.25-.25.25l-2.5 0c-.138 0-.25-.112-.25-.25l0-2.5c0-.138.112-.25.25-.25l2.5 0c.138 0 .25.112.25.25zM6.5 3.75l0-2.5c0-.138.112-.25.25-.25l2.5 0c.138 0 .25.112.25.25l0 2.5c0 .138-.112.25-.25.25l-2.5 0c-.138 0-.25-.112-.25-.25zm7.5002 7.2498l0-2.52354268 1.5 0c.275 0 .5-.225.5-.5 0-.275-.225-.5-.5-.5l-6.98692485 0 0-2.47645732.75 0c.69 0 1.24999995-.56 1.24999995-1.25l0-2.5c0-.69-.55999995-1.25-1.24999995-1.25l-2.5 0c-.69 0-1.25.56-1.25 1.25l0 2.5c0 .69.56 1.25 1.25 1.25l.75 0 0 2.47645732-7.01307515 0c-.275 0-.5.225-.5.5 0 .275.225.5.5.5l1.5 0 0 2.52354268-.75 0c-.69 0-1.25.56-1.25 1.25l0 2.5c0 .69.56 1.25 1.25 1.25l2.5 0c.69 0 1.25-.56 1.25-1.25l0-2.5c0-.69-.56-1.25-1.25-1.25l-.75 0 0-2.52354268 10 0 0 2.52354268-.75 0c-.69 0-1.25.56-1.25 1.25l0 2.5c0 .69.56 1.25 1.25 1.25l2.5 0c.69 0 1.25-.56 1.25-1.25l0-2.5c0-.69-.56-1.25-1.25-1.25l-.75 0z"],"ethernet_24":["M22 21c0 .552-.449 1-1 1l-3 0c-.551 0-1-.448-1-1l0-3c0-.552.449-1 1-1l1 0 1 0 1 0c.551 0 1 .448 1 1l0 3zM10.5 7c-.551 0-1-.448-1-1l0-3c0-.552.449-1 1-1l3 0c.551 0 1 .448 1 1l0 3c0 .552-.449 1-1 1l-3 0zM6 17c.551 0 1 .448 1 1l0 3c0 .552-.449 1-1 1l-3 0c-.551 0-1-.448-1-1l0-3c0-.552.449-1 1-1l1 0 1 0 1 0zm15-1l-1 0 0-3.5 2.5 0c.275 0 .5-.225.5-.5 0-.275-.225-.5-.5-.5l-10 0 0-3.5 1 0c1.103 0 2-.897 2-2l0-3c0-1.104-.897-2-2-2l-3 0c-1.103 0-2 .896-2 2l0 3c0 1.103.897 2 2 2l1 0 0 3.5-10 0c-.275 0-.5.225-.5.5 0 .275.225.5.5.5l2.5 0L4 16l-1 0c-1.103 0-2 .897-2 2l0 3c0 1.103.897 2 2 2l3 0c1.103 0 2-.897 2-2l0-3c0-1.103-.897-2-2-2l-1 0 0-3.5 14 0 0 3.5-1 0c-1.103 0-2 .897-2 2l0 3c0 1.103.897 2 2 2l3 0c1.103 0 2-.897 2-2l0-3c0-1.103-.897-2-2-2z"],"exit-room_12":["M10.9619 6.6909c-.025.062-.062.117-.109.163l-1.999 2c-.098.097-.226.146-.354.146-.128 0-.256-.049-.353-.146-.196-.196-.196-.512 0-.707l1.146-1.147-2.793 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l2.793 0-1.146-1.146c-.196-.196-.196-.512 0-.707.195-.196.511-.196.707 0l1.999 1.999c.047.046.084.102.109.163.05.122.05.26 0 .382zM8.5 10c.276 0 .5.224.5.5 0 .827-.673 1.5-1.5 1.5l-5 0c-.827 0-1.5-.673-1.5-1.5l0-9C1 .673 1.673 0 2.5 0l5 0C8.327 0 9 .673 9 1.5l0 1c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-1c0-.276-.225-.5-.5-.5l-5 0c-.275 0-.5.224-.5.5l0 9c0 .276.225.5.5.5l5 0c.275 0 .5-.224.5-.5 0-.276.224-.5.5-.5z"],"exit-room_16":["M12 3.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5L11 2c0-.552-.448-1-1-1L3 1c-.552 0-1 .448-1 1l.026 12.128c.066.489.468.872.974.872l7 0c.552 0 1-.448 1-1l0-.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 .5c0 1.103-.897 2-2 2l-7 0c-1.103 0-2-.897-2-2L1 2c0-1.103.897-2 2-2l7 0c1.103 0 2 .897 2 2l0 1.5zm1.3115 4.5005l-2.129-2.129c-.195-.195-.195-.512 0-.707.196-.195.512-.195.707 0l2.983 2.982c.094.094.147.221.147.354 0 .133-.053.26-.147.354l-3.031 3.03c-.098.098-.226.146-.354.146-.128 0-.256-.048-.353-.146-.196-.195-.196-.512 0-.707l2.177-2.177-4.812 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l4.812 0z"],"exit-room_20":["M15 2.5C15 1.119 13.881 0 12.5 0l-9 0C2.119 0 1 1.119 1 2.5l0 15C1 18.881 2.119 20 3.5 20l9 0c1.381 0 2.5-1.119 2.5-2.5l0-1.5c0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5l0 1.5c0 .827-.673 1.5-1.5 1.5l-9 0c-.827 0-1.5-.673-1.5-1.5l0-15C2 1.673 2.673 1 3.5 1l9 0c.827 0 1.5.673 1.5 1.5L14 4c0 .276.224.5.5.5.276 0 .5-.224.5-.5l0-1.5zm-.8535 3.1455c-.195.196-.195.513 0 .708l3.147 3.146-6.793 0c-.276 0-.5.224-.5.5 0 .276.224.5.5.5l6.793 0-3.147 3.146c-.195.196-.195.513 0 .708.196.195.512.195.708 0l3.999-4c.046-.046.083-.102.109-.163.05-.122.05-.26 0-.382-.026-.06-.063-.117-.109-.163l-3.999-4c-.098-.097-.226-.146-.354-.146-.128 0-.256.049-.354.146z"],"exit-room_24":["M17.146 16.3506c-.195-.195-.195-.512 0-.707l3.145-3.141-6.791 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l6.797 0-3.151-3.146c-.195-.194-.195-.512 0-.708.098-.097.226-.146.354-.146.128 0 .256.049.354.146l4 3.995c.098.099.146.228.146.356l0 .003c0 .065-.013.13-.039.192-.023.056-.058.106-.099.149-.004.004-.005.009-.008.013l-4 3.995c-.196.194-.512.194-.708-.001zM18 21.5c0 1.378-1.121 2.5-2.5 2.5l-11 0C3.121 24 2 22.878 2 21.5l0-19C2 1.122 3.121 0 4.5 0l11 0C16.879 0 18 1.122 18 2.5l0 2c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-2c0-.827-.673-1.5-1.5-1.5l-11 0C3.673 1 3 1.673 3 2.5l0 19c0 .827.673 1.5 1.5 1.5l11 0c.827 0 1.5-.673 1.5-1.5l0-2c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 2z"],"exit-room_28":["M5 27c-1.654 0-3-1.346-3-3L2 4c0-1.654 1.346-3 3-3l12 0c1.654 0 3 1.346 3 3l0 1.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5L19 4c0-1.104-.897-2-2-2L5 2c-1.103 0-2 .896-2 2l0 20c0 1.103.897 2 2 2l12 0c1.103 0 2-.897 2-2l0-1.481c0-.277.224-.5.5-.5.276 0 .5.223.5.5L20 24c0 1.654-1.346 3-3 3L5 27zm14.1465-7.3496l5.147-5.149-10.794 0c-.276 0-.5-.225-.5-.5 0-.277.224-.5.5-.5l10.794 0-5.147-5.152c-.195-.196-.195-.512 0-.707.098-.097.226-.147.353-.147.128 0 .256.05.354.147l5.999 6.004c.047.046.084.101.109.163.051.122.051.26 0 .382-.025.062-.062.117-.109.163l-5.999 6.003c-.195.196-.512.196-.707 0-.195-.195-.195-.511 0-.707z"],"explore_16":["M8 0c4.418 0 8 3.582 8 8 0 4.418-3.582 8-8 8-4.418 0-8-3.582-8-8 0-4.418 3.582-8 8-8zm0 15c3.86 0 7-3.14 7-7 0-3.86-3.14-7-7-7-3.86 0-7 3.14-7 7 0 3.86 3.14 7 7 7zm3.5008-11.0001c.13 0 .257.05.353.147.135.134.181.336.119.516l-1.497 4.326c-.214.637-.854 1.276-1.49 1.488l-4.323 1.496c-.052.018-.108.027-.163.027-.131 0-.259-.051-.353-.146-.136-.136-.182-.337-.119-.518l1.5-4.325c.212-.631.852-1.271 1.488-1.484l4.32-1.5c.054-.018.109-.027.165-.027zm-1.973 4.671l1.163-3.361-3.347 1.162c-.347.116-.755.523-.868.857l-1.166 3.362 3.349-1.159c.347-.116.756-.525.869-.861zm-1.8784-.3213c-.05-.04-.09-.1-.109-.16-.031-.06-.04-.12-.04-.19 0-.129.049-.259.149-.35.181-.19.521-.19.7 0 .101.091.151.221.151.35 0 .07-.01.13-.04.19-.021.06-.061.12-.111.16-.09.101-.22.15-.349.15-.13 0-.26-.049-.351-.15z"],"export_16":["M4.3545 5.853c-.196.196-.512.196-.707 0-.196-.195-.196-.511 0-.707l3.999-3.999c.046-.046.102-.083.163-.108.061-.026.126-.039.191-.039.065 0 .13.013.191.039.062.025.117.062.163.108l4 3.999c.195.196.195.512 0 .707-.196.196-.512.196-.707 0l-3.147-3.146 0 8.793c0 .277-.224.5-.5.5-.276 0-.5-.223-.5-.5l0-8.793-3.146 3.146zM15.501 7.0005c.275 0 .5.226.5.5l0 5.501c0 1.105-.896 2-2 2l-12 0c-1.104 0-2-.895-2-2L0 7.5005c0-.274.225-.5.5-.5.275 0 .5.226.5.5l.001 5.501c0 .551.448 1 1 1l12.001 0c.552 0 1-.449 1-1l0-5.501c0-.274.224-.5.499-.5z"],"export_24":["M12.34925 2.1464l5.995 6c.196.195.196.512 0 .707-.195.195-.511.195-.707 0l-5.146-5.146 0 13.793c0 .276-.22.5-.496.5-.276 0-.496-.224-.496-.5l0-13.793-5.147 5.146c-.195.195-.511.195-.706 0-.195-.195-.195-.512 0-.707l5.995-6c.046-.046.101-.082.163-.108.061-.026.126-.038.191-.038.065 0 .13.012.191.038.061.026.117.062.163.108zM22 11.4999c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 7.875c0 1.447-1.177 2.625-2.625 2.625l-16.75 0c-1.448 0-2.625-1.178-2.625-2.625l0-7.875c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 7.926c0 .868.707 1.574 1.575 1.574l16.85 0c.868 0 1.575-.706 1.575-1.574l0-7.926z"],"extension-mobility_16":["M11.7308 5.0058c2.374.12 4.269 2.09 4.269 4.494 0 2.481-2.019 4.5-4.5 4.5l-7.5 0c-2.206 0-4-1.794-4-4 0-1.829 1.273-3.422 3.022-3.864.202-2.334 2.133-4.136 4.478-4.136 1.917 0 3.603 1.217 4.231 3.006zm-.231 7.994c1.93 0 3.5-1.57 3.5-3.5 0-1.927-1.565-3.495-3.49-3.5-.04.004-.132.013-.147.014-.228 0-.428-.155-.485-.377-.396-1.553-1.785-2.637-3.378-2.637-1.93 0-3.5 1.57-3.5 3.5 0 .249-.178.51-.424.545-1.469.209-2.576 1.48-2.576 2.955 0 1.654 1.346 3 3 3l7.5 0zm-2.5-5c0 .433-.278.793-.663.932l.652 1.805c.047.13-.058.263-.206.263l-1.566 0c-.148 0-.252-.133-.205-.263l.652-1.805c-.385-.139-.664-.499-.664-.932 0-.552.448-1 1-1 .553 0 1 .448 1 1z"],"extension-mobility_24":["M16.9920667 7.0449c3.8581986 0 6.9967333 3.141 6.9967333 7 0 3.859-3.1385347 7-6.9967333 7l-10.9948667 0c-3.3074558 0-5.9972-2.691-5.9972-6 0-2.923 2.158992-5.432 4.99766667-5.913 0-.029 0-.058 0-.087 0-3.309 2.6897442-6 5.99720003-6 2.5478104 0 4.8157516 1.629 5.6533605 4.009.1139468-.006.2278936-.009.3438395-.009zm0 13c3.3074558 0 5.9972-2.691 5.9972-6 0-3.309-2.6897442-6-5.9972-6-.2198974 0-.4367961.014-.6486972.036-.2468847.02-.4707802-.128-.5347503-.364-.5947223-2.162-2.5747979-3.672-4.8137525-3.672-2.75571343 0-4.9976667 2.243-4.9976667 5 0 .161.0089958.32.0239888.477.01299393.132-.02798693.264-.1139468.367-.08496033.102-.20790293.166-.34084087.177-2.5608044.22-4.566867797 2.407-4.566867797 4.979 0 2.757 2.241953267 5 4.997666667 5l10.9948667 0zM12.3115 13.7583l.662 1.583c.109.324-.132.659-.474.659l-1.999 0c-.341 0-.582-.334-.475-.658l.657-1.587c-.41-.268-.683-.729-.683-1.255 0-.829.672-1.5 1.5-1.5.829 0 1.5.671 1.5 1.5 0 .529-.274.991-.688 1.258z"],"external-user_10":["M9.88261121 8.628c.17599999.272.18999999.605.035.889-.164.299-.484.485-.837.485l-4.133 0c-.056 0-.108-.013-.16-.022-.001.007-.002.013-.003.02L.781611213 10c-.242 0-.466-.109-.615-.3-.1490000001-.19-.2020000001-.434-.1430000001-.67L.353611213 7.707c.277-1.107 1.199999997-1.906 2.306999997-2.052-.601-.6-.973-1.428-.973-2.342 0-1.828 1.486-3.313 3.313-3.313 1.826 0 3.312 1.485 3.312 3.313 0 .74-.256 1.416-.669 1.967.058.05.129.082.172.149l2.067 3.199zm-4.816.415l3.868-.039-1.931-2.987-1.937 3.026zm1.5937-1.3935c.05-.05.1-.09.16-.109.19-.08.41-.031.549.109.091.09.141.22.141.351 0 .059-.01.129-.03.189-.031.061-.07.12-.111.16-.049.05-.1.09-.17.111-.06.029-.119.04-.189.04-.061 0-.13-.011-.19-.04-.06-.021-.11-.061-.16-.111-.09-.09-.15-.22-.15-.349 0-.071.019-.131.04-.191.03-.059.059-.12.11-.16zm-2.5157.9785l1.295-2.003-2.418 0c-.805 0-1.502.545-1.697 1.325l-.263 1.05 2.954 0c.016-.129.055-.257.129-.372zm.856-7.628c-1.276 0-2.313 1.037-2.313 2.313 0 1.274 1.037 2.312 2.313 2.312 1.275 0 2.312-1.038 2.312-2.312 0-1.276-1.037-2.313-2.312-2.313z"],"external-user_12":["M11.853135 10.485c.189.305.199.675.023.991-.18.323-.527.524-.906.524l-4.94 0c-.034 0-.067-.01-.101-.013l0 .013-5.083999998 0c-.266 0-.51-.119-.67-.326-.1580000001-.204-.2130000001-.464-.1490000001-.712L.431135002 9.396c.348-1.353 1.555999998-2.304 2.969999998-2.381-.85-.734-1.4-1.806-1.4-3.015 0-2.205 1.794-4 4-4 2.205 0 4 1.795 4 4 0 .866-.305 1.644-.781 2.292.061.056.117.118.162.192l0 .001 2.471 4zm-5.854.525l4.971-.01-2.438-3.989c-.006-.008-.023-.011-.031-.011l-2.502 4.01zm2.002-2.5098c0-.276.223-.5.5-.5.275 0 .5.224.5.5l0 .999c0 .276-.225.5-.5.5-.277 0-.5-.224-.5-.5l0-.999zm.8496 1.6396c.05.05.09.11.109.17.031.06.041.12.041.19 0 .13-.05.26-.15.35-.04.05-.1.09-.16.11-.061.031-.12.04-.19.04-.13 0-.26-.049-.35-.15-.101-.09-.15-.22-.15-.35 0-.07.01-.13.039-.19.021-.06.061-.12.111-.17.18-.18.51-.18.7 0zm-3.7016.3442L6.683135 8l-3.1 0c-1.037 0-1.935.677-2.184 1.646l-.349 1.354 3.953 0c0-.177.047-.356.146-.516zM3.001135 4c0 1.655 1.346 3 3 3 .584 0 1.125-.174 1.586-.464l.031-.051c.123-.198.315-.324.527-.393.528-.541.856-1.277.856-2.092 0-1.654-1.346-3-3-3-1.654 0-3 1.346-3 3z"],"external-user_16":["M17.8106809 13.897c.127.221.19.463.19.706-.001.242-.065.484-.194.705-.25.435-.695.692-1.191.692l-6.321 0-1.91200001 0-7.414000001 0c-.291 0-.564-.133-.749-.367-.194-.244-.264-.56-.192-.869l.551-2.349C1.04868089 10.406 2.74668089 9 4.70368089 9l.329 0c-1.226-.912-2.032-2.359-2.032-4.001 0-2.755 2.243-4.999 5-4.999 2.75500001 0 4.99800001 2.244 4.99800001 4.999 0 .377-.055.739-.135 1.089.338.084.644.286.83.61l0 .001 4.117 7.198zm-.868.91c.075-.129.075-.283.001-.413l-4.117-7.198c-.101-.177-.263-.196-.326-.196-.066 0-.228.019-.329.196l-4.11600001 7.197c-.075.132-.074.285 0 .415.033.057.132.184.318.189l1.92100001.001 0 .002 6.321 0c.193 0 .294-.133.327-.193zm-9.88200001.189c-.108-.365-.068-.757.129-1.099l2.227-3.897-4.713 0c-1.491 0-2.786 1.087-3.151 2.644l-.55 2.35 6.058.002zm-3.06-9.997c0 2.206 1.794 4 4 4 .955 0 1.822-.349 2.50900001-.911l.795-1.389c.118-.206.288-.36.481-.468.127-.391.213-.8.213-1.232 0-2.205-1.793-3.999-3.99800001-3.999-2.206 0-4 1.794-4 3.999zm8.49870001 4.0014c.276 0 .5.225.5.5l0 2c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-2c0-.275.224-.5.5-.5zm0 4c.276 0 .5.225.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.275.224-.5.5-.5z"],"external-user_20":["M19.807902 15.912c.127.217.192.457.192.697 0 .239-.063.479-.188.698-.25.435-.698.693-1.197.693l-7.674 0-.559 0-9.35099999 0c-.328 0-.629-.147-.826-.402-.1879999996-.244-.2499999996-.553-.1719999996-.847L.65590201 14.403c.532-2.003 2.426-3.403 4.607-3.403l.427 0c-1.619-1.075-2.69-2.914-2.69-5 0-3.307 2.691-6 6-6C12.306902 0 14.999902 2.693 14.999902 6c0 .764-.15 1.492-.41 2.163.439.027.869.234 1.102.637.001 0 .001 0 .001.001l4.115 7.111zm-.863.896c.034-.06.104-.217-.001-.396l-4.116-7.11c-.101-.172-.264-.19-.328-.19-.067 0-.23.018-.329.191l-4.117 7.109c-.10299999.179-.035.336-.002.396.035.059.133.192.33.192l8.233 0c.198 0 .296-.133.33-.192zm-9.88499999.196c-.107-.363-.068-.754.129-1.093L11.452902 12l-6.18999999 0c-1.728 0-3.224 1.094-3.64 2.66l-.623 2.348 8.06-.004zm-5.06-11.004c0 2.757 2.243 5 5 5C11.756902 11 13.999902 8.757 13.999902 6c0-2.755-2.243-5-4.99999999-5-2.757 0-5 2.245-5 5zM14.848202 15.1508c.05.04.091.1.11.16.03.06.04.13.04.19 0 .129-.049.26-.15.35-.09.1-.22.15-.35.15-.059 0-.129-.01-.19-.04-.06-.02-.119-.06-.16-.11-.1-.09-.15-.221-.15-.35 0-.06.01-.13.04-.19.02-.06.06-.12.11-.16.041-.05.1-.09.16-.11.12-.05.26-.05.381 0 .059.02.119.06.159.11zm-.3496-4.1504c.276 0 .5.225.5.5l0 2c0 .276-.224.5-.5.5-.275 0-.5-.224-.5-.5l0-2c0-.275.225-.5.5-.5z"],"facebook_16":["M6.2207 3.6924l0 1.885-1.466 0 0 2.393 1.466 0 0 7.03 2.819 0 0-7.059 1.967 0 .21-2.364-2.177 0 0-1.346c0-.558.112-.778.651-.778l1.526 0 0-2.453-1.952 0c-2.098 0-3.044.924-3.044 2.692"],"facebook-blue_12":["M11.3379 0L.6619 0c-.366 0-.662.296-.662.662l0 10.676c0 .365.296.662.662.662l5.747 0 0-4.647-1.563 0 0-1.811 1.563 0 0-1.336c0-1.55.948-2.394 2.33-2.394.662 0 1.232.05 1.398.072l0 1.619-.959.001c-.752 0-.899.357-.899.882l0 1.156 1.794 0-.233 1.811-1.561 0 0 4.647 3.059 0c.365 0 .662-.297.662-.662l0-10.676c0-.366-.297-.662-.662-.662"],"facebook-circle_24":["M15.083 7.695l0-2.349-1.869 0c-2.008 0-2.914.885-2.914 2.578l0 1.804-1.404 0 0 2.292 1.404 0 0 6.73 2.699 0 0-6.759 1.883 0 .201-2.263-2.084 0 0-1.289c0-.533.107-.744.623-.744l1.461 0zM12 0c6.628 0 12 5.372 12 12 0 6.627-5.372 12-12 12-6.627 0-12-5.373-12-12C0 5.372 5.373 0 12 0z"],"facebook-circle_32":["M20.11 10.26l0-3.132-2.492 0c-2.678 0-3.885 1.18-3.885 3.437l0 2.406-1.872 0 0 3.055 1.872 0 0 8.974 3.599 0 0-9.011 2.51 0 .268-3.018-2.778 0 0-1.718c0-.712.142-.993.83-.993l1.948 0zM16 0c8.837 0 16 7.163 16 16 0 8.837-7.163 16-16 16-8.837 0-16-7.163-16-16C0 7.163 7.163 0 16 0z"],"facebook-circle_40":["M25.137 12.825l0-3.915-3.115 0c-3.347 0-4.856 1.475-4.856 4.297l0 3.007-2.341 0 0 3.819 2.341 0 0 11.217 4.498 0 0-11.264 3.139 0 .334-3.772-3.473 0 0-2.148c0-.889.179-1.241 1.038-1.241l2.435 0zM20 0c11.045 0 20 8.953 20 20 0 11.046-8.955 20-20 20C8.954 40 0 31.046 0 20 0 8.953 8.954 0 20 0z"],"facebook-logo_12":["M11.3379 0L.6619 0c-.366 0-.662.296-.662.662l0 10.676c0 .365.296.662.662.662l5.747 0 0-4.647-1.563 0 0-1.811 1.563 0 0-1.336c0-1.55.948-2.394 2.33-2.394.662 0 1.232.05 1.398.072l0 1.619-.959.001c-.752 0-.899.357-.899.882l0 1.156 1.794 0-.233 1.811-1.561 0 0 4.647 3.059 0c.365 0 .662-.297.662-.662l0-10.676c0-.366-.297-.662-.662-.662"],"favorite_10":["M6.69915676 5.54060462c-.26499132.20298552-.37598768.55396047-.27499099.87293771l.62897939 2.01285637-1.56594868-1.20391409c-.14299531-.11099208-.31498968-.16498823-.48698404-.16498823-.17199436 0-.34398873.05399615-.48798401.16498823L2.94727972 8.4263987l.62897939-2.01285637c.09999672-.31897724-.01099964-.67095212-.27599096-.87293771L1.69132089 4.30169303l1.9619357 0c.34398872 0 .65797843-.23798301.76397496-.57795875l.58298089-1.86486693.58298089 1.86486693c.10599653.33997574.41998624.57795875.762975.57795875l1.96293566 0-1.60994723 1.23891159zm2.64591328-2.23884023l-2.84590673 0L5.60619258.446968105C5.52419527.180987085 5.28020326.0009999286 5.00121241 0l-.00099997 0c-.27899086 0-.52298286.179987156-.60598014.445968176L3.50126157 3.30176439l-2.844906763 0c-.282990725 0-.532982531.17698737-.6229795816.4399686-.087997116.25898152.0019999344.54896083.2229926916.71794877L2.58029175 6.24855411l-.90197044 2.88479414c-.08699715.27998002.01499951.57995861.25599161.7469467.11499623.07899436.24899184.11899151.38198748.11899151.14299532 0 .28599063-.04499679.40498673-.13799016l2.27892531-1.75287491L7.27713781 9.8612963c.23399233.1769874.54898201.1859867.78897415.01899865.23999213-.16698809.34298875-.46796661.25499164-.7469467l-.90097047-2.88479414 2.32392383-1.78887235c.22099276-.16898794.30998984-.45896725.22299269-.71794877-.08999705-.26298123-.33998885-.4399686-.62197961-.4399686z"],"favorite_12":["M8.44915294 7.14479629l.00999862 0-.00999862 0zm-6.8200581-2.1079399l2.22669248 1.71195119c.28696037.2209937.4069438.60098286.29895871.94597303l-.87387931 2.79592029 2.19069745-1.68595194c.31095705-.23799322.74589698-.23799322 1.05685404 0l2.19069745 1.68495194-.87387931-2.79492029c-.10798509-.34599014.01199834-.7259793.29895871-.94597303l2.22669244-1.71195119-2.72562353 0c-.37094877 0-.71190169-.25899262-.82688581-.62998204l-.81788704-2.61692539-.81888691 2.61692539c-.11498412.37098942-.45593703.62998204-.8268858.62998204l-2.72562357 0zm7.8309185 6.02282831l.00099986.0009999c0 0-.00099986-.0009999-.00099986-.0009999zm-.17897529.9399732c-.15197901 0-.30395802-.0479987-.43094048-.1469958L5.99949126 9.66072455 3.14788508 11.853662c-.24196658.1869947-.57692032.1959944-.82988538.0199995-.25396493-.175995-.36294988-.492986-.27096258-.7879776l1.12584451-3.60089731L.271282361 5.25285023c-.2369672728-.18199481-.3289545687-.47798637-.2349675489-.75497847C.130301832 4.22187963.394265377 4.0368849.692224227 4.0368849l3.557508683 0L5.36557881.466986685C5.45256679.18799464 5.70753158 0 6.00049112 0c.29195968 0 .54692447.18799464.63391245.466986685L7.75024947 4.0368849l3.55750873 0c.2979588 0 .5619223.18499473.6559094.46098686.093987.2769921.0019997.57298366-.2339677.75497847L8.82710075 7.48478659 9.9519454 11.084684c.0929872.2949915-.01599779.6129825-.26996272.7889775-.12098329.0839976-.26096396.1259964-.40094463.1259964z"],"favorite_14":["M9.6063952 7.9445c-.006.004-.012.008-.018.012-.306.238-.436.646-.321 1.018l1.119 3.578-2.818-2.167c-.332-.255-.8-.256-1.138 0l-2.817 2.168 1.119-3.58c.115-.371-.015-.779-.339-1.029l-2.764-1.946 3.426 0c.4 0 .766-.281.894-.689l1.051-3.543 1.05 3.545c.126.401.493.681.892.681l3.427 0-2.763 1.952zm4.354-2.468c-.098-.289-.375-.484-.689-.484l-4.264.028-1.344-4.534c-.092-.291-.359-.486-.663-.486-.305 0-.572.195-.666.494l-1.279 4.504-4.329999998 0c-.313 0-.59.194-.6879999999.483-.098.29-.001.6.2629999999.803L3.7773952 8.6755l-1.363 4.363c-.096.31.018.642.284.827.265.185.618.177.876-.02l3.386-2.667 3.466 2.666c.133.103.292.155.451.155.149 0 .296-.044.425-.134.266-.186.38-.519.283-.829l-1.348-4.314 3.476-2.455c.248-.191.345-.501.247-.791z"],"favorite_16":["M8.0036 11.0361c.201 0 .399.064.566.192l2.805 2.286-1.106-3.54c-.117-.372.013-.782.322-1.018.006-.005.012-.009.018-.013l2.757-1.93-3.421 0c-.399 0-.765-.281-.891-.681l-1.053-3.562-1.052 3.557c-.128.408-.494.688-.893.688l-3.421 0 2.758 1.927c.327.251.456.661.34 1.032l-1.106 3.54 2.794-2.277c.174-.135.379-.201.583-.201zm3.627 3.297l.01 0-.01 0zm.248.667c-.16 0-.318-.052-.452-.154l-3.426-2.791-3.415 2.782c-.269.206-.621.214-.887.029-.266-.185-.381-.519-.284-.829l1.363-4.361-3.476-2.372c-.266-.205-.362-.515-.264-.804.098-.29.375-.485.689-.485l4.329 0 1.279-4.52c.094-.3.36-.495.666-.495.305 0 .572.195.663.487l1.347 4.554 4.264-.028c.313 0 .59.194.688.484.099.289.002.6-.246.79l-3.479 2.436 1.348 4.313c.097.312-.018.645-.284.83-.128.089-.276.134-.423.134z"],"favorite_20":["M10.0006701 14.8450424c.2439932 0 .4869865.0777279.6899809.2331838l4.6968701 3.6651719-1.8529488-5.9730942c-.1409961-.4484305.0159996-.943697.3919892-1.2306925l.0039999-.0029896L18.607432 8.040857l-5.7658405 0c-.4839866 0-.9289743-.34180369-1.0819701-.83109118L9.9996701 1.51071251l-1.75895135 5.6980568c-.15399574.490284-.59898344.83208769-1.08297005.83208769l-5.76584053 0 4.67687065 3.4957648c.37998949.2899851.53698515.7852516.39598905 1.2356752l-1.85194878 5.9711011 4.6928702-3.6621824c.20499433-.1574489.44998756-.2361733.69498081-.2361733zm5.5258471 4.3467862l.0099998 0-.0099998 0zM15.6675133 20c-.1829949 0-.3659898-.0597907-.5199856-.1773792l-5.0698598-3.9571499c-.0449987-.0338815-.11199686-.0318884-.15999553.0029895l-5.06285998 3.9511709c-.29899173.2311908-.70398053.2381664-1.00997206.0269058-.30699151-.2132536-.43798789-.5949178-.32599099-.9516691l1.99094494-6.4185352c.01699953-.0548081-.00099997-.1116093-.04499876-.1444942L.32993754 8.49227703c-.2879920344-.22222222-.3989889645-.57299452-.2869920621-.89985052.1129968751-.33283508.4219883291-.54808172.7869782341-.54808172l6.327824988 0c.03499903 0 .10399712-.05480817.12699649-.1305431L9.24969084.550074738C9.35368796.220229198 9.65367967 0 9.9996701 0c.3459904 0 .6469821.220229198.7499793.549078226L12.714595 6.91479821c.0229994.07473841.0919975.12954658.1269965.12954658l6.327825 0c.3649899 0 .6739813.21524664.7879782.54808172.1109969.326856.001.6776283-.2819922.89486796l-5.1418578 3.84554063c-.0429988.0328849-.0609983.0896861-.0449988.1415047l1.9929449 6.4225212c.110997.3547583-.0199994.737419-.3269909.9496761-.146996.1016443-.3169913.1534629-.4869866.1534629z"],"favorite_24":["M11.9997047 17.465c.259 0 .518.083.733.25l5.322 4.093-2.097-6.709c-.149-.479.017-1.005.414-1.311.004-.003.009-.007.014-.01l5.267-3.778-6.511 0c-.512 0-.983-.364-1.147-.885l-1.995-6.656-1.99400001 6.651c-.163.526-.634.89-1.147.89l-6.511 0 5.267 3.778c.411.316.577.842.428 1.321l-2.097 6.709 5.32300001-4.094c.214-.166.473-.249.731-.249zm6.159 4.678l.011 0-.011 0zm-12.42300001.856c-.177 0-.355-.054-.508-.161-.321-.223-.457-.622-.341-.994l2.201-7.044c.025-.08-.002-.168-.068-.219l-5.667000005-4.064c-.3089999998-.236-.4239999998-.603-.3089999998-.944C1.161704685 9.225 1.483704685 9 1.864704685 9L8.85870469 9c.064 0 .159-.078.191-.182l2.17100001-7.241c.109-.348.435-.538.781-.577.357.001.67.231.776.571l2.173 7.251c.031.1.127.178.191.178l6.994 0c.38 0 .702.225.82.572.116.341.001.708-.294.935l-5.685 4.078c-.063.051-.089.137-.064.215l2.201 7.044c.116.372-.02.771-.341.994-.318.224-.741.214-1.05-.024l-5.6-4.307c-.072-.057-.174-.056-.244-.001l-5.60100001 4.308c-.16.123-.35.185-.542.185z"],"favorite_28":["M13.8719 1.9151c.001.001.001.001.001.002l-.001-.002zm5.685 14.685l.01 0-.01 0zm-17.368-5.601l6.546 5.21c.435.335.619.92.453 1.451l-2.621 8.386 6.61-5.169c.478-.367 1.147-.368 1.626 0l6.666 5.128-2.677-8.345c-.164-.532.019-1.115.458-1.453l6.64-5.271-8.15.063c-.567 0-1.091-.405-1.273-.985l-2.476-7.728-2.458 7.729c-.18.578-.703.984-1.272.984l-8.072 0zm19.259 15.999c-.207 0-.414-.066-.588-.2l-6.666-5.128c-.119-.092-.288-.091-.407 0l-6.667 5.128c-.334.258-.793.268-1.139.026-.347-.241-.494-.674-.369-1.077l2.621-8.386c.042-.133-.004-.279-.114-.364l-6.76-5.38c-.311-.239-.436-.634-.312-1 .128-.375.476-.618.888-.618l8.326 0c.126 0 .269-.128.318-.284l2.577-8.103c.113-.365.449-.612.835-.612.385 0 .721.247.835.614l2.595 8.097c.049.16.193.288.319.288l8.326 0c.412 0 .76.243.888.618.124.366-.001.761-.319 1.005l-6.767 5.37c-.002.002-.004.003-.006.005-.11.085-.156.231-.115.365l2.621 8.385c.125.403-.023.836-.369 1.077-.166.116-.36.174-.551.174z"],"favorite_8":["M5.2534 4.28976c-.243.187-.344.508-.253.801l.384 1.229-.936-.719c-.132-.104-.291-.156-.45-.156-.158 0-.315.052-.446.154l-.939.721.385-1.229c.091-.293-.011-.614-.27-.813l-.895-.632 1.119 0c.315 0 .603-.217.702-.535l.354-1.194.338 1.081c.097.312.386.528.7.528l1.2 0-.993.764zm2.714-1.347c-.085-.249-.322-.417-.59-.417l-2.13 0-.671-2.145c-.16-.505-.992-.513-1.157.008l-.67 2.257-2.128 0c-.267 0-.504.167-.589.416-.085.247-.001.521.226.697l1.727 1.218-.676 2.164c-.081.263.015.545.241.704.226.156.525.149.745-.018l1.704-1.31 1.705 1.31c.113.087.248.131.383.131.125 0 .251-.038.36-.113.226-.159.323-.441.241-.705l-.678-2.17 1.745-1.344c.21-.16.295-.435.212-.683z"],"favorite-active_12":["M8.44915294 7.14479629l.00999862 0-.00999862 0zm1.0108604 3.91488841l.00099986.0009999c0 0-.00099986-.0009999-.00099986-.0009999zm-.17897529.9399732c-.15197901 0-.30395802-.0479987-.43094048-.1469958L5.99949126 9.66072455 3.14788508 11.853662c-.24196658.1869947-.57692032.1959944-.82988538.0199995-.25396493-.175995-.36294988-.492986-.27096258-.7879776l1.12584451-3.60089731L.271282361 5.25285023c-.2369672728-.18199481-.3289545687-.47798637-.2349675489-.75497847C.130301832 4.22187963.394265377 4.0368849.692224227 4.0368849l3.557508683 0L5.36557881.466986685C5.45256679.18799464 5.70753158 0 6.00049112 0c.29195968 0 .54692447.18799464.63391245.466986685L7.75024947 4.0368849l3.55750873 0c.2979588 0 .5619223.18499473.6559094.46098686.093987.2769921.0019997.57298366-.2339677.75497847L8.82710075 7.48478659 9.9519454 11.084684c.0929872.2949915-.01599779.6129825-.26996272.7889775-.12098329.0839976-.26096396.1259964-.40094463.1259964z"],"favorite-active_14":["M13.9603952 5.4765c-.098-.289-.375-.484-.689-.484l-4.264.028-1.344-4.534c-.092-.291-.359-.486-.663-.486-.305 0-.572.195-.666.494l-1.279 4.504-4.329999998 0c-.313 0-.59.194-.6879999999.483-.098.29-.001.6.2629999999.803L3.7773952 8.6755l-1.363 4.363c-.096.31.018.642.284.827.265.185.618.177.876-.02l3.386-2.667 3.466 2.666c.133.103.292.155.451.155.149 0 .296-.044.425-.134.266-.186.38-.519.283-.829l-1.348-4.314 3.476-2.455c.248-.191.345-.501.247-.791z"],"favorite-active_16":["M11.8786 15.0001c-.16 0-.318-.052-.452-.154l-3.426-2.791-3.415 2.782c-.269.206-.621.214-.887.029-.266-.185-.381-.519-.284-.829l1.363-4.361-3.476-2.372c-.266-.205-.362-.515-.264-.804.098-.29.375-.485.689-.485l4.329 0 1.279-4.52c.094-.3.36-.495.666-.495.305 0 .572.195.663.487l1.347 4.554 4.264-.028c.313 0 .59.194.688.484.099.289.002.6-.246.79l-3.479 2.436 1.348 4.313c.097.312-.018.645-.284.83-.128.089-.276.134-.423.134z"],"favorite-active_20":["M15.6675133 20c-.1829949 0-.3659898-.0597907-.5199856-.1773792l-5.0698598-3.9571499c-.0449987-.0338815-.11199686-.0318884-.15999553.0029895l-5.06285998 3.9511709c-.29899173.2311908-.70398053.2381664-1.00997206.0269058-.30699151-.2132536-.43798789-.5949178-.32599099-.9516691l1.99094494-6.4185352c.01699953-.0548081-.00099997-.1116093-.04499876-.1444942L.32993754 8.49227703c-.2879920344-.22222222-.3989889645-.57299452-.2869920621-.89985052.1129968751-.33283508.4219883291-.54808172.7869782341-.54808172l6.327824988 0c.03499903 0 .10399712-.05480817.12699649-.1305431L9.24969084.550074738C9.35368796.220229198 9.65367967 0 9.9996701 0c.3459904 0 .6469821.220229198.7499793.549078226L12.714595 6.91479821c.0229994.07473841.0919975.12954658.1269965.12954658l6.327825 0c.3649899 0 .6739813.21524664.7879782.54808172.1109969.326856.001.6776283-.2819922.89486796l-5.1418578 3.84554063c-.0429988.0328849-.0609983.0896861-.0449988.1415047l1.9929449 6.4225212c.110997.3547583-.0199994.737419-.3269909.9496761-.146996.1016443-.3169913.1534629-.4869866.1534629z"],"favorite-active_24":["M5.73570469 22.999c-.177 0-.355-.054-.508-.161-.321-.223-.457-.622-.341-.994l2.201-7.044c.025-.08-.002-.168-.068-.219l-5.667000005-4.064c-.3089999998-.236-.4239999998-.603-.3089999998-.944C1.161704685 9.225 1.483704685 9 1.864704685 9L8.85870469 9c.064 0 .159-.078.191-.182l2.17100001-7.241c.109-.348.435-.538.781-.577.357.001.67.231.776.571l2.173 7.251c.031.1.127.178.191.178l6.994 0c.38 0 .702.225.82.572.116.341.001.708-.294.935l-5.685 4.078c-.063.051-.089.137-.064.215l2.201 7.044c.116.372-.02.771-.341.994-.318.224-.741.214-1.05-.024l-5.6-4.307c-.072-.057-.174-.056-.244-.001l-5.60100001 4.308c-.16.123-.35.185-.542.185z"],"favorite-active_28":["M21.4479 26.9981c-.207 0-.414-.066-.588-.2l-6.666-5.128c-.119-.092-.288-.091-.407 0l-6.667 5.128c-.334.258-.793.268-1.139.026-.347-.241-.494-.674-.369-1.077l2.621-8.386c.042-.133-.004-.279-.114-.364l-6.76-5.38c-.311-.239-.436-.634-.312-1 .128-.375.476-.618.888-.618l8.326 0c.126 0 .269-.128.318-.284l2.577-8.103c.113-.365.449-.612.835-.612.385 0 .721.247.835.614l2.595 8.097c.049.16.193.288.319.288l8.326 0c.412 0 .76.243.888.618.124.366-.001.761-.319 1.005l-6.767 5.37c-.002.002-.004.003-.006.005-.11.085-.156.231-.115.365l2.621 8.385c.125.403-.023.836-.369 1.077-.166.116-.36.174-.551.174z"],"favorite-active_8":["M7.9674 2.94276c-.085-.249-.322-.417-.59-.417l-2.13 0-.671-2.145c-.16-.505-.992-.513-1.157.008l-.67 2.257-2.128 0c-.267 0-.504.167-.589.416-.085.247-.001.521.226.697l1.727 1.218-.676 2.164c-.081.263.015.545.241.704.226.156.525.149.745-.018l1.704-1.31 1.705 1.31c.113.087.248.131.383.131.125 0 .251-.038.36-.113.226-.159.323-.441.241-.705l-.678-2.17 1.745-1.344c.21-.16.295-.435.212-.683z"],"favorite-filled_12":["M8.44915294 7.14479629l.00999862 0-.00999862 0zm1.0108604 3.91488841l.00099986.0009999c0 0-.00099986-.0009999-.00099986-.0009999zm-.17897529.9399732c-.15197901 0-.30395802-.0479987-.43094048-.1469958L5.99949126 9.66072455 3.14788508 11.853662c-.24196658.1869947-.57692032.1959944-.82988538.0199995-.25396493-.175995-.36294988-.492986-.27096258-.7879776l1.12584451-3.60089731L.271282361 5.25285023c-.2369672728-.18199481-.3289545687-.47798637-.2349675489-.75497847C.130301832 4.22187963.394265377 4.0368849.692224227 4.0368849l3.557508683 0L5.36557881.466986685C5.45256679.18799464 5.70753158 0 6.00049112 0c.29195968 0 .54692447.18799464.63391245.466986685L7.75024947 4.0368849l3.55750873 0c.2979588 0 .5619223.18499473.6559094.46098686.093987.2769921.0019997.57298366-.2339677.75497847L8.82710075 7.48478659 9.9519454 11.084684c.0929872.2949915-.01599779.6129825-.26996272.7889775-.12098329.0839976-.26096396.1259964-.40094463.1259964z"],"favorite-filled_14":["M13.9603952 5.4765c-.098-.289-.375-.484-.689-.484l-4.264.028-1.344-4.534c-.092-.291-.359-.486-.663-.486-.305 0-.572.195-.666.494l-1.279 4.504-4.329999998 0c-.313 0-.59.194-.6879999999.483-.098.29-.001.6.2629999999.803L3.7773952 8.6755l-1.363 4.363c-.096.31.018.642.284.827.265.185.618.177.876-.02l3.386-2.667 3.466 2.666c.133.103.292.155.451.155.149 0 .296-.044.425-.134.266-.186.38-.519.283-.829l-1.348-4.314 3.476-2.455c.248-.191.345-.501.247-.791z"],"favorite-filled_16":["M11.8786 15.0001c-.16 0-.318-.052-.452-.154l-3.426-2.791-3.415 2.782c-.269.206-.621.214-.887.029-.266-.185-.381-.519-.284-.829l1.363-4.361-3.476-2.372c-.266-.205-.362-.515-.264-.804.098-.29.375-.485.689-.485l4.329 0 1.279-4.52c.094-.3.36-.495.666-.495.305 0 .572.195.663.487l1.347 4.554 4.264-.028c.313 0 .59.194.688.484.099.289.002.6-.246.79l-3.479 2.436 1.348 4.313c.097.312-.018.645-.284.83-.128.089-.276.134-.423.134z"],"favorite-filled_20":["M15.6675133 20c-.1829949 0-.3659898-.0597907-.5199856-.1773792l-5.0698598-3.9571499c-.0449987-.0338815-.11199686-.0318884-.15999553.0029895l-5.06285998 3.9511709c-.29899173.2311908-.70398053.2381664-1.00997206.0269058-.30699151-.2132536-.43798789-.5949178-.32599099-.9516691l1.99094494-6.4185352c.01699953-.0548081-.00099997-.1116093-.04499876-.1444942L.32993754 8.49227703c-.2879920344-.22222222-.3989889645-.57299452-.2869920621-.89985052.1129968751-.33283508.4219883291-.54808172.7869782341-.54808172l6.327824988 0c.03499903 0 .10399712-.05480817.12699649-.1305431L9.24969084.550074738C9.35368796.220229198 9.65367967 0 9.9996701 0c.3459904 0 .6469821.220229198.7499793.549078226L12.714595 6.91479821c.0229994.07473841.0919975.12954658.1269965.12954658l6.327825 0c.3649899 0 .6739813.21524664.7879782.54808172.1109969.326856.001.6776283-.2819922.89486796l-5.1418578 3.84554063c-.0429988.0328849-.0609983.0896861-.0449988.1415047l1.9929449 6.4225212c.110997.3547583-.0199994.737419-.3269909.9496761-.146996.1016443-.3169913.1534629-.4869866.1534629z"],"favorite-filled_24":["M5.73570469 22.999c-.177 0-.355-.054-.508-.161-.321-.223-.457-.622-.341-.994l2.201-7.044c.025-.08-.002-.168-.068-.219l-5.667000005-4.064c-.3089999998-.236-.4239999998-.603-.3089999998-.944C1.161704685 9.225 1.483704685 9 1.864704685 9L8.85870469 9c.064 0 .159-.078.191-.182l2.17100001-7.241c.109-.348.435-.538.781-.577.357.001.67.231.776.571l2.173 7.251c.031.1.127.178.191.178l6.994 0c.38 0 .702.225.82.572.116.341.001.708-.294.935l-5.685 4.078c-.063.051-.089.137-.064.215l2.201 7.044c.116.372-.02.771-.341.994-.318.224-.741.214-1.05-.024l-5.6-4.307c-.072-.057-.174-.056-.244-.001l-5.60100001 4.308c-.16.123-.35.185-.542.185z"],"favorite-filled_28":["M21.4479 26.9981c-.207 0-.414-.066-.588-.2l-6.666-5.128c-.119-.092-.288-.091-.407 0l-6.667 5.128c-.334.258-.793.268-1.139.026-.347-.241-.494-.674-.369-1.077l2.621-8.386c.042-.133-.004-.279-.114-.364l-6.76-5.38c-.311-.239-.436-.634-.312-1 .128-.375.476-.618.888-.618l8.326 0c.126 0 .269-.128.318-.284l2.577-8.103c.113-.365.449-.612.835-.612.385 0 .721.247.835.614l2.595 8.097c.049.16.193.288.319.288l8.326 0c.412 0 .76.243.888.618.124.366-.001.761-.319 1.005l-6.767 5.37c-.002.002-.004.003-.006.005-.11.085-.156.231-.115.365l2.621 8.385c.125.403-.023.836-.369 1.077-.166.116-.36.174-.551.174z"],"favorite-filled_8":["M7.9674 2.94276c-.085-.249-.322-.417-.59-.417l-2.13 0-.671-2.145c-.16-.505-.992-.513-1.157.008l-.67 2.257-2.128 0c-.267 0-.504.167-.589.416-.085.247-.001.521.226.697l1.727 1.218-.676 2.164c-.081.263.015.545.241.704.226.156.525.149.745-.018l1.704-1.31 1.705 1.31c.113.087.248.131.383.131.125 0 .251-.038.36-.113.226-.159.323-.441.241-.705l-.678-2.17 1.745-1.344c.21-.16.295-.435.212-.683z"],"fbw_16":["M2.2656 7.5576l6.971-3.467c.238-.126.442-.033.518.013.076.046.255.182.255.451l0 .02-4.21 2.094c-.498.266-.807.782-.807 1.346 0 .565.309 1.081.82 1.354l4.197 2.078 0 .015c0 .268-.179.405-.255.45-.048.029-.144.076-.269.076-.078 0-.167-.018-.262-.069l-6.945-3.44c-.175-.093-.279-.266-.279-.464 0-.197.104-.371.266-.457zm8.742-2.363l2.221-1.104c.238-.126.442-.033.518.013.077.046.255.182.255.451l0 6.907c0 .268-.178.405-.255.45-.047.029-.144.076-.269.076-.078 0-.167-.018-.262-.069l-2.208-1.094-.998-.494-3.739-1.852c-.174-.093-.278-.266-.278-.464 0-.197.104-.371.265-.457l3.752-1.866.998-.497zm-9.187 4.174l6.945 3.439c.478.253 1.039.24 1.503-.038.332-.198.561-.507.668-.864l1.822.902c.477.253 1.038.24 1.503-.038.463-.278.738-.767.738-1.308l0-6.907c0-.541-.275-1.031-.738-1.309-.246-.147-.517-.22-.788-.22-.242 0-.483.058-.703.176l-1.833.911c-.106-.358-.336-.668-.669-.867-.245-.147-.517-.22-.787-.22-.242 0-.484.058-.703.176l-6.971 3.467c-.498.266-.808.782-.808 1.346 0 .565.31 1.081.821 1.354z"],"fbw_24":["M2.6255 10.9902l11.684-6.854c.362-.193.789-.181 1.14.032.345.207.551.569.551.968l0 .368-7.862 4.612c-.702.372-1.138 1.094-1.138 1.885 0 .791.436 1.512 1.119 1.874l7.881 4.619 0 .368c0 .399-.206.761-.551.968-.188.113-.397.17-.604.17-.179 0-.357-.043-.517-.127l-11.722-6.872c-.38-.2-.606-.574-.606-1 0-.426.226-.8.625-1.011zm17.684-6.854c.362-.193.789-.181 1.14.032.345.207.551.569.551.968l0 13.726c0 .399-.206.761-.551.968-.188.113-.397.17-.604.17-.179 0-.357-.043-.517-.127l-11.722-6.872c-.38-.2-.606-.574-.606-1 0-.426.226-.8.625-1.011l11.684-6.854zm-18.19 9.739l11.723 6.872c.675.355 1.47.335 2.123-.061.588-.353.944-.952 1.008-1.621l2.869 1.682c.675.355 1.47.335 2.123-.061.648-.389 1.035-1.072 1.035-1.824l0-13.726c0-.752-.387-1.435-1.035-1.825-.342-.207-.723-.311-1.108-.311-.35 0-.704.087-1.035.261l-2.849 1.672c-.064-.669-.42-1.268-1.008-1.622-.342-.207-.723-.311-1.108-.311-.35 0-.704.087-1.035.261l-11.684 6.855c-.702.372-1.138 1.094-1.138 1.885 0 .791.436 1.512 1.119 1.874z"],"feedback_12":["M11 8.4902c0 .165-.071.315-.195.413-.064.051-.202.127-.381.085L3 7.2162l0-3.608 7.426-1.595c.176-.041.316.035.38.086.123.097.194.247.194.412l0 5.979zm-7.011 1.145c.039.117-.007.207-.038.251-.062.085-.417.162-.495-.09l-.503-1.563.619.148.417 1.254zM1 5.4032c0-.555.288-1.234 1-1.525l0 3.049c-.714-.295-1-.972-1-1.524zm10.425-4.09c-.353-.277-.8-.375-1.222-.275l-8.201 1.762C.805 3.0892 0 4.1352 0 5.4022c0 1.197.721 2.189 1.81 2.54l.692 2.152c.165.542.656.907 1.224.907.41 0 .796-.198 1.037-.532.239-.332.304-.762.175-1.151l-.22-.664 5.472 1.307c.113.027.227.04.34.04.32 0 .633-.108.894-.312.366-.289.576-.725.576-1.199l0-5.979c0-.473-.21-.91-.575-1.198z"],"feedback_14":["M13 9.3636c0 .192-.088.373-.24.494-.158.124-.363.17-.559.125L3 7.8926l0-3.994 9.204-1.881c.196-.044.399.001.556.125.152.121.24.302.24.494l0 6.727zm-8.023 2.1c.042.126.021.259-.056.367-.185.256-.627.192-.727-.135l-.923-2.716.893.203.813 2.281zM1 5.8886c0-.587.28-1.312 1-1.694l0 3.389c-.723-.384-1-1.109-1-1.695zm12.383-4.528c-.396-.314-.906-.43-1.391-.32l-9.691 1.98C.712 3.3856.001 4.7236 0 5.8886c0 1.118.663 2.387 2.12 2.812l1.122 3.302c.182.596.723.998 1.347.998.452 0 .879-.219 1.143-.586.268-.371.338-.833.19-1.278l-.604-1.692 6.661 1.513c.125.028.25.043.376.043.371 0 .731-.124 1.028-.361.392-.312.617-.777.617-1.276l0-6.727c0-.499-.225-.964-.617-1.276z"],"feedback_16":["M15 11.2399c0 .224-.101.429-.284.575-.204.163-.466.226-.736.166L4 9.7979l0-4.809 9.982-1.965c.266-.058.532.003.735.166.182.148.283.352.283.575l0 7.475zm-9.02 2.055c.056.166.029.342-.074.484-.24.334-.83.238-.954-.165l-.895-2.78 1.178.258.745 2.203zM1 7.3799c0-.81.477-1.862 1.805-2.156L3 5.1859l0 4.393-.188-.041C1.475 9.2409 1 8.1899 1 7.3799zm14.343-4.969c-.441-.355-1.017-.49-1.565-.365L2.6 4.2459c-1.795.396-2.599 1.86-2.6 3.134 0 1.273.803 2.736 2.597 3.134l.331.073 1.07 3.327c.2.651.791 1.089 1.472 1.089.5 0 .955-.233 1.248-.639.292-.405.37-.911.212-1.386l-.546-1.635 7.382 1.615c.137.03.276.046.414.046.421 0 .829-.142 1.162-.409.418-.335.658-.83.658-1.355l0-7.475c0-.525-.239-1.018-.657-1.354z"],"feedback_20":["M19 13.878c0 .332-.153.646-.42.859-.288.232-.663.315-1.034.233L3.987 12.036l0-6.08 13.564-2.924c.365-.083.741.003 1.029.234.267.213.42.526.42.858l0 9.754zm-12.059 2.05c.084.252.043.519-.111.734-.368.509-1.259.36-1.441-.238l-1.001-3.277 1.753.378.8 2.403zM1 8.995c0-1.003.54-2.267 1.987-2.781l0 5.562C1.538 11.261 1 9.997 1 8.995zm18.205-6.511103921c-.526-.4200028124-1.209-.5790038773-1.869-.428002866L3.187 5.10591364C.986 5.59991695.001 7.4149291 0 8.99393968c0 1.58001058.984 3.39602272 3.184 3.89202602l.086.0180002 1.163 3.8110255c.234.7690051.932 1.2860086 1.735 1.2860086.591 0 1.127-.2740018 1.473-.754005.345-.4780033.436-1.0750072.249-1.636011l-.614-1.8400123 10.055 2.1740145c.165.0380003.331.0560004.496.0560004.498 0 .982-.1660011 1.377-.4820032.506-.4050027.796-1.0030067.796-1.641011l0-9.75406534c0-.63800427-.29-1.235008268-.795-1.640010981z"],"feedback_72":["M70 50.3205c0 1.725-.773 3.327-2.123 4.397-1.344 1.067-3.072 1.455-4.748 1.064l-51.175-11.476 0-24.719 51.184-11.44c1.669-.389 3.398 0 4.742 1.068 1.347 1.07 2.12 2.672 2.12 4.395l0 36.711zm-44.939 8.039c.441 1.324.226 2.732-.59 3.863-.814 1.129-2.077 1.776-3.466 1.776-1.894 0-3.537-1.219-4.089-3.033l-4.748-15.586 9.266 2.078 3.627 10.902zM2 31.9405c.002-4.452 2.378-10.159 8.954-12.085l0 24.181c-6.583-1.932-8.956-7.642-8.954-12.096zm66.501-23.51c-1.583-1.256-3.622-1.713-5.585-1.259l-51.374 11.481C5.141 20.1415 1.002 25.3575 1 31.9405c-.002 6.419 3.934 11.53 10.062 13.167l4.897 16.149c.682 2.238 2.709 3.742 5.046 3.742 1.714 0 3.273-.798 4.277-2.191 1.006-1.394 1.271-3.132.728-4.764l-3.437-10.33 40.333 9.044c.502.117 1.008.173 1.51.173 1.469 0 2.902-.492 4.083-1.429 1.589-1.261 2.501-3.15 2.501-5.181l0-36.711c0-2.03-.911-3.917-2.499-5.179z"],"feedback_8":["M7.00000306 5.89178431c0 .04809618-.02399992.07715428-.04399986.09418834-.02099994.01503006-.05399984.03206412-.06299981.03206412L3.00001532 4.77455023l0-2.48296505 3.86898814-1.2875747c.03599989.001002.0679998.01102204.08699974.02505009.01999994.01703406.04399986.04509017.04399986.09318634l0 4.7695374zM1.00102144 3.54709576c-.001-.28356704.14299956-.63727433.5539983-.77354682l.44499864-.14929855 0 1.82965867-.43599867-.1392785c-.41199873-.13126248-.56099828-.48396777-.56299827-.7675348zM7.57800129.243489707C7.30900212.0300629281 6.96300318-.048093357 6.6280042.0290609244L1.23902071 1.82164546c-.756997682.25150292-1.2429961931.9318634-1.2389962054 1.73146232C.0050244893 4.3537087.500022973 5.02805716 1.26002065 5.27154405l.92699716.29559108.84999739 2.11923773C3.11501496 7.88176357 3.30201439 8 3.50001378 8c.06199981 0 .12599962-.01102204.18699943-.03607213.25599922-.10220437.37999884-.39378744.27699915-.65130238l-.54099834-1.35070092L6.62600421 6.9849703c.08599974.01903807.17199947.0290581.25799921.0290581.24899924 0 .49199849-.0831663.69299788-.24248488C7.84600047 6.55711474 8 6.23747557 8 5.89178431l0-4.7695374c0-.344689255-.15299953-.663326418-.42199871-.878757203z"],"feedback-active_12":["M1 5.4032c0-.555.288-1.234 1-1.525l0 3.049c-.714-.295-1-.972-1-1.524zm10.425-4.09c-.353-.277-.8-.375-1.222-.275l-8.201 1.762C.805 3.0892 0 4.1352 0 5.4022c0 1.197.721 2.189 1.81 2.54l.692 2.152c.165.542.656.907 1.224.907.41 0 .796-.198 1.037-.532.239-.332.304-.762.175-1.151l-.22-.664 5.472 1.307c.113.027.227.04.34.04.32 0 .633-.108.894-.312.366-.289.576-.725.576-1.199l0-5.979c0-.473-.21-.91-.575-1.198z"],"feedback-active_14":["M1 5.8886c0-.587.28-1.312 1-1.694l0 3.389c-.723-.384-1-1.109-1-1.695zm12.383-4.528c-.396-.314-.906-.43-1.391-.32l-9.691 1.98C.712 3.3856.001 4.7236 0 5.8886c0 1.118.663 2.387 2.12 2.812l1.122 3.302c.182.596.723.998 1.347.998.452 0 .879-.219 1.143-.586.268-.371.338-.833.19-1.278l-.604-1.692 6.661 1.513c.125.028.25.043.376.043.371 0 .731-.124 1.028-.361.392-.312.617-.777.617-1.276l0-6.727c0-.499-.225-.964-.617-1.276z"],"feedback-active_16":["M1 7.3799c0-.81.477-1.862 1.805-2.156L3 5.1859l0 4.393-.188-.041C1.475 9.2409 1 8.1899 1 7.3799zm14.343-4.969c-.441-.355-1.017-.49-1.565-.365L2.6 4.2459c-1.795.396-2.599 1.86-2.6 3.134 0 1.273.803 2.736 2.597 3.134l.331.073 1.07 3.327c.2.651.791 1.089 1.472 1.089.5 0 .955-.233 1.248-.639.292-.405.37-.911.212-1.386l-.546-1.635 7.382 1.615c.137.03.276.046.414.046.421 0 .829-.142 1.162-.409.418-.335.658-.83.658-1.355l0-7.475c0-.525-.239-1.018-.657-1.354z"],"feedback-active_20":["M1 8.995c0-1.003.54-2.267 1.987-2.781l0 5.562C1.538 11.261 1 9.997 1 8.995zm18.205-6.511c-.526-.42-1.209-.579-1.869-.428L3.187 5.106C.986 5.6.001 7.415 0 8.994c0 1.58.984 3.396 3.184 3.892l.086.018 1.163 3.811c.234.769.932 1.286 1.735 1.286.591 0 1.127-.274 1.473-.754.345-.478.436-1.075.249-1.636l-.614-1.84 10.055 2.174c.165.038.331.056.496.056.498 0 .982-.166 1.377-.482.506-.405.796-1.003.796-1.641l0-9.754c0-.638-.29-1.235-.795-1.64z"],"feedback-active_8":["M1.00102144 3.54709576c-.001-.28356704.14299956-.63727433.5539983-.77354682l.44499864-.14929855 0 1.82965867-.43599867-.1392785c-.41199873-.13126248-.56099828-.48396777-.56299827-.7675348zM7.57800129.243489707C7.30900212.0300629281 6.96300318-.048093357 6.6280042.0290609244L1.23902071 1.82164546c-.756997682.25150292-1.2429961931.9318634-1.2389962054 1.73146232C.0050244893 4.3537087.500022973 5.02805716 1.26002065 5.27154405l.92699716.29559108.84999739 2.11923773C3.11501496 7.88176357 3.30201439 8 3.50001378 8c.06199981 0 .12599962-.01102204.18699943-.03607213.25599922-.10220437.37999884-.39378744.27699915-.65130238l-.54099834-1.35070092L6.62600421 6.9849703c.08599974.01903807.17199947.0290581.25799921.0290581.24899924 0 .49199849-.0831663.69299788-.24248488C7.84600047 6.55711474 8 6.23747557 8 5.89178431l0-4.7695374c0-.344689255-.15299953-.663326418-.42199871-.878757203z"],"ffw_16":["M13.7344 8.4561l-6.971 3.467c-.238.126-.442.033-.518-.013-.076-.046-.255-.182-.255-.451l0-.02 4.21-2.094c.498-.266.807-.782.807-1.346 0-.565-.309-1.081-.82-1.354l-4.197-2.078 0-.015c0-.268.179-.405.255-.45.048-.029.144-.076.269-.076.078 0 .167.018.262.069l6.945 3.44c.175.093.279.266.279.464 0 .197-.104.371-.266.457zm-8.742 2.362l-2.221 1.105c-.238.126-.442.033-.518-.013-.077-.046-.255-.182-.255-.451l0-6.907c0-.268.178-.405.255-.45.047-.029.144-.076.269-.076.078 0 .167.018.262.069l2.208 1.094.998.494 3.739 1.852c.174.093.278.266.278.464 0 .197-.104.371-.265.457l-3.752 1.866-.998.496zm9.187-4.173l-6.945-3.439c-.478-.253-1.039-.24-1.503.038-.332.198-.561.507-.668.863l-1.822-.901c-.477-.253-1.038-.24-1.503.038-.463.278-.738.767-.738 1.308l0 6.907c0 .541.275 1.031.738 1.309.246.147.517.22.788.22.242 0 .483-.058.703-.176l1.832-.911c.107.358.337.667.67.867.245.147.517.22.787.22.242 0 .484-.058.703-.176l6.971-3.467c.498-.266.808-.782.808-1.346 0-.565-.31-1.081-.821-1.354z"],"ffw_24":["M21.3745 13.0088l-11.684 6.854c-.362.193-.789.181-1.14-.032-.345-.207-.551-.569-.551-.968l0-.368 7.862-4.612c.702-.372 1.138-1.094 1.138-1.885 0-.791-.436-1.512-1.119-1.874l-7.881-4.619 0-.368c0-.399.206-.761.551-.968.188-.113.397-.17.604-.17.179 0 .357.043.517.127l11.722 6.872c.38.2.606.574.606 1 0 .426-.226.8-.625 1.011zm-17.684 6.854c-.362.193-.789.181-1.14-.032-.345-.207-.551-.569-.551-.968l0-13.726c0-.399.206-.761.551-.968.188-.113.397-.17.604-.17.179 0 .357.043.517.127l11.722 6.872c.38.2.606.574.606 1 0 .426-.226.8-.625 1.011l-11.684 6.854zm18.19-9.739l-11.723-6.872c-.675-.355-1.47-.335-2.123.061-.588.353-.944.952-1.009 1.621l-2.868-1.682c-.675-.355-1.47-.335-2.123.061-.648.389-1.035 1.072-1.035 1.824l0 13.726c0 .752.387 1.435 1.035 1.825.342.207.723.311 1.108.311.35 0 .704-.087 1.035-.261l2.848-1.672c.064.669.421 1.268 1.009 1.622.342.207.723.311 1.108.311.35 0 .704-.087 1.035-.261l11.684-6.855c.702-.372 1.138-1.094 1.138-1.885 0-.791-.436-1.512-1.119-1.874z"],"file-audio_12":["M10 8c-.381 0-.587-.281-.918-.777C8.719 6.678 8.267 6 7.333 6c-.957 0-1.417.71-1.753 1.228-.349.537-.541.772-.915.772-.38 0-.585-.28-.916-.777C3.386 6.678 2.935 6 2 6l0-4.5c0-.275.225-.5.5-.5l4.428 0L10 4.072 10 8zm0 2.5c0 .275-.225.5-.5.5l-7 0c-.275 0-.5-.225-.5-.5L2 7c.381 0 .586.281.917.777C3.28 8.322 3.731 9 4.665 9c.957 0 1.417-.71 1.753-1.228.349-.537.541-.772.915-.772.38 0 .586.281.917.777C8.613 8.322 9.065 9 10 9l0 1.5zm.759-7.083L7.582.24C7.426.085 7.219 0 7 0L2.5 0C1.673 0 1 .673 1 1.5l0 9c0 .827.673 1.5 1.5 1.5l7 0c.827 0 1.5-.673 1.5-1.5L11 4c0-.22-.085-.426-.241-.583z"],"file-audio_16":["M12 15l-8 0c-.551 0-1-.448-1-1l0-4.846c.321.196.58.573.906 1.107.473.774 1.062 1.739 2.26 1.739 1.225 0 1.8-.967 2.263-1.744C8.892 9.478 9.208 9 9.833 9c.605 0 .929.479 1.407 1.261.402.657.891 1.445 1.76 1.671L13 14c0 .552-.449 1-1 1zM4 1l5.086 0L13 4.914l0 5.932c-.321-.196-.581-.573-.907-1.107C11.62 8.965 11.03 8 9.833 8c-1.226 0-1.801.967-2.264 1.744C7.106 10.522 6.791 11 6.166 11c-.606 0-.929-.479-1.407-1.261-.401-.657-.89-1.445-1.759-1.671L3 2c0-.552.449-1 1-1zm10 10.5l0-.001 0-6.585c0-.266-.105-.519-.293-.707L9.793.293C9.605.105 9.351 0 9.086 0L4 0C2.895 0 2 .895 2 2l0 12c0 1.105.895 2 2 2l8 0c1.105 0 2-.895 2-2l0-2.499 0-.001z"],"file-audio_24":["M18.5 23l-13 0c-.827 0-1.5-.673-1.5-1.5l0-9.388c.8.333 1.329 1.434 1.88 2.601C6.607 16.254 7.431 18 9.164 18c1.733 0 2.559-1.746 3.286-3.287.659-1.395 1.281-2.713 2.382-2.713 1.101 0 1.723 1.318 2.382 2.713.653 1.383 1.39 2.92 2.786 3.223l0 3.564c0 .827-.673 1.5-1.5 1.5M5.5 1l8.333 0c.042 0 .088.019.118.049l6 6c.033.033.049.07.049.117l0 9.723c-.801-.333-1.33-1.435-1.882-2.602C17.391 12.746 16.565 11 14.832 11c-1.733 0-2.559 1.746-3.286 3.287C10.887 15.682 10.265 17 9.164 17c-1.1 0-1.722-1.318-2.38-2.713-.653-1.383-1.389-2.92-2.784-3.223L4 2.5C4 1.673 4.673 1 5.5 1m15.158 5.342l-6-6C14.441.125 14.141 0 13.833 0L5.5 0C4.121 0 3 1.121 3 2.5l0 19C3 22.879 4.121 24 5.5 24l13 0c1.379 0 2.5-1.121 2.5-2.5l0-14.334c0-.312-.121-.603-.342-.824"],"file-audio_28":["M22 27L6 27c-1.103 0-2-.897-2-2l0-10c1.392 0 2.14 1.333 2.933 2.745C7.79 19.271 8.76 21 10.738 21c2.027 0 2.974-1.732 3.809-3.26.805-1.47 1.499-2.74 2.933-2.74 1.393 0 2.142 1.333 2.935 2.745.823 1.464 1.762 3.101 3.585 3.231L24 25c0 1.103-.897 2-2 2zM4 3c0-1.103.897-2 2-2l10.172 0c.263 0 .52.107.707.293l6.828 6.828c.186.187.293.444.293.707l0 11.145c-1.249-.138-1.964-1.386-2.713-2.718C20.43 15.729 19.458 14 17.48 14c-2.027 0-2.974 1.732-3.81 3.26-.804 1.47-1.498 2.74-2.932 2.74-1.392 0-2.141-1.333-2.933-2.745C6.948 15.729 5.977 14 4 14L4 3zm20.414 4.414L17.586.586C17.211.211 16.702 0 16.172 0L6 0C4.343 0 3 1.343 3 3l0 22c0 1.657 1.343 3 3 3l16 0c1.657 0 3-1.343 3-3l0-16.172c0-.53-.211-1.039-.586-1.414z"],"file-audio_32":["M27.0003 23.9374c-1.315-.302-2.103-1.927-2.925-3.652-1.005-2.106-2.043-4.285-4.264-4.285-2.223 0-3.261 2.179-4.265 4.285-.911 1.91-1.773 3.714-3.362 3.714-1.59 0-2.451-1.804-3.361-3.714-.931-1.959-1.907-3.956-3.823-4.23l0-13.055c0-1.105.896-2 2-2l10.757 0c.53 0 1.039.21 1.414.585l7.243 7.243c.375.375.586.884.586 1.414l0 13.695zm0 5.062c0 .024-.007.045-.007.068-.032.934-.702 1.71-1.591 1.892-.13.027-.264.04-.402.04l-18 0c-.139 0-.273-.013-.403-.04-.889-.182-1.559-.958-1.59-1.892-.001-.023-.007-.044-.007-.068l0-11.936c1.313.302 2.1 1.927 2.922 3.651 1.003 2.107 2.041 4.285 4.262 4.285 2.221 0 3.259-2.178 4.263-4.285.911-1.909 1.773-3.714 3.364-3.714 1.589 0 2.451 1.805 3.362 3.714.932 1.96 1.909 3.956 3.827 4.231l0 4.054zm.121-20.878l-7.243-7.243c-.562-.562-1.323-.877-2.118-.878-.001 0-.002 0-.003 0l-10.757 0c-.001 0-.002 0-.003 0-1.656.001-2.997 1.344-2.997 3l0 25.999c0 1.658 1.343 3.001 3 3.001l18 0c1.656 0 3-1.343 3-3.001l0-18.757c0-.795-.316-1.558-.879-2.121z"],"file-audio_36":["M30 26c-1.691 0-2.596-1.809-3.554-3.724C25.395 20.174 24.308 18 21.998 18c-2.367 0-3.426 2.177-4.45 4.281C16.617 24.193 15.737 26 13.996 26c-1.69 0-2.594-1.809-3.551-3.724C9.395 20.174 8.309 18 6 18L6 4.5C6 3.122 7.121 2 8.5 2l11.748 0c.534 0 1.036.208 1.414.586l7.752 7.752c.378.378.586.88.586 1.414L30 26zm0 5.5c0 1.379-1.121 2.5-2.5 2.5l-19 0C7.121 34 6 32.879 6 31.5L6 19c1.689 0 2.594 1.809 3.551 3.724C10.602 24.826 11.688 27 13.996 27c2.367 0 3.426-2.177 4.45-4.281.931-1.912 1.811-3.719 3.552-3.719 1.691 0 2.596 1.809 3.554 3.724C26.604 24.826 27.69 27 30 27l0 4.5zm.121-21.869l-7.752-7.752C21.807 1.316 21.043 1 20.248 1L8.5 1C6.567 1 5 2.567 5 4.5l0 27C5 33.433 6.567 35 8.5 35l19 0c1.933 0 3.5-1.567 3.5-3.5l0-19.748c0-.795-.316-1.559-.879-2.121z"],"file-audio_40":["M31.166 39L8.833 39c-1.562 0-2.835-1.271-2.835-2.833l0-15.112c1.816.274 2.85 2.165 3.927 4.181C11.178 27.578 12.473 30 15.179 30c2.776 0 4.038-2.424 5.259-4.769C21.571 23.055 22.642 21 24.811 21c2.108 0 3.209 2.058 4.375 4.236 1.18 2.206 2.414 4.456 4.813 4.713l0 6.218c0 1.562-1.271 2.833-2.833 2.833M8.833 1l14.554 0c.163 0 .317.063.432.179l10.001 10c.116.115.179.269.179.432l0 17.334c-1.818-.273-2.853-2.164-3.932-4.181C28.814 22.422 27.518 20 24.811 20c-2.776 0-4.039 2.424-5.26 4.769C18.418 26.945 17.348 29 15.179 29c-2.107 0-3.207-2.058-4.372-4.236-1.179-2.205-2.412-4.455-4.809-4.713l0-16.218C5.998 2.271 7.271 1 8.833 1m25.693 9.472L24.525.471C24.221.167 23.816 0 23.387 0L8.833 0C6.72 0 5 1.72 5 3.833l0 32.334C5 38.28 6.72 40 8.833 40l22.332 0c2.113 0 3.833-1.72 3.833-3.833l0-24.556c0-.43-.167-.835-.472-1.139"],"file-audio_44":["M38 40c0 1.654-1.346 3-3 3L9 43c-1.654 0-3-1.346-3-3l0-17c2.366 0 3.592 2.3 4.89 4.735C12.27 30.323 13.696 33 16.662 33c3.042 0 4.433-2.679 5.778-5.27 1.263-2.432 2.456-4.73 4.891-4.73 2.367 0 3.594 2.3 4.894 4.735C33.605 30.323 35.033 33 38 33l0 7zM6 4c0-1.654 1.346-3 3-3l16.809 0c.202 0 .4.082.543.225l11.423 11.381c.143.143.225.341.225.542L38 32c-2.367 0-3.594-2.3-4.894-4.735C31.726 24.677 30.298 22 27.331 22c-3.042 0-4.434 2.679-5.778 5.27C20.29 29.702 19.097 32 16.662 32c-2.366 0-3.592-2.3-4.89-4.735C10.393 24.677 8.966 22 6 22L6 4zm32.481 7.898L27.058.517C26.725.184 26.281 0 25.809 0L9 0C6.794 0 5 1.794 5 4l0 36c0 2.206 1.794 4 4 4l26 0c2.206 0 4-1.794 4-4l0-26.852c0-.464-.189-.92-.519-1.25z"],"file-audio_72":["M62 64.5c0 3.033-2.467 5.5-5.5 5.5l-41 0c-3.033 0-5.5-2.467-5.5-5.5L10 37c4.025 0 6.061 3.996 8.217 8.227C20.415 49.54 22.687 54 27.325 54c4.761 0 6.975-4.463 9.117-8.778C38.541 40.994 40.522 37 44.663 37c4.028 0 6.066 3.997 8.223 8.228C55.085 49.54 57.359 54 62 54l0 10.5zm-52-57C10 4.467 12.467 2 15.5 2l26.617 0c.41 0 .796.159 1.087.449l18.348 18.266c.289.288.448.671.448 1.079L62 53c-4.027 0-6.065-3.996-8.223-8.227C51.578 40.46 49.303 36 44.663 36c-4.761 0-6.975 4.462-9.117 8.777C33.448 49.006 31.466 53 27.325 53c-4.025 0-6.061-3.996-8.217-8.227C16.91 40.46 14.638 36 10 36l0-28.5zm52.258 12.506c0 0 0 0-.001 0L43.909 1.74C43.43 1.263 42.793 1 42.117 1L15.5 1C11.916 1 9 3.916 9 7.5l0 57c0 3.584 2.916 6.5 6.5 6.5l41 0c3.584 0 6.5-2.916 6.5-6.5l0-42.706c0-.676-.264-1.311-.742-1.788z"],"file-graph_12":["M10.759 3.417c.156.157.241.363.241.583l0 6.5c0 .827-.673 1.5-1.5 1.5l-7 0c-.827 0-1.5-.673-1.5-1.5l0-9C1 .673 1.673 0 2.5 0L6 0l1 0c.219 0 .426.085.582.24l3.177 3.177zM10 10.5l0-6.428L6.928 1 6 1 2.5 1c-.275 0-.5.225-.5.5l0 9c0 .275.225.5.5.5l7 0c.275 0 .5-.225.5-.5zm-6.4998-3c0-1.381 1.119-2.5 2.5-2.5 1.381 0 2.5 1.119 2.5 2.5 0 1.381-1.119 2.5-2.5 2.5-1.381 0-2.5-1.119-2.5-2.5zm3.908-.5c-.151-.424-.484-.757-.908-.908l0 .908.908 0zm-1.408 2c.651 0 1.201-.419 1.408-1l-1.408 0c-.277 0-.5-.224-.5-.5l0-1.408c-.581.207-1 .757-1 1.408 0 .827.673 1.5 1.5 1.5z"],"file-graph_16":["M13.707 4.207c.188.188.293.441.293.707L14 14c0 1.105-.895 2-2 2l-8 0c-1.105 0-2-.895-2-2L2 2c0-1.105.895-2 2-2l5.086 0c.265 0 .519.105.707.293l3.914 3.914zM13 14l0-9.086L9.086 1 4 1c-.551 0-1 .448-1 1l0 12c0 .552.449 1 1 1l8 0c.551 0 1-.448 1-1zM8.0161 6.503c.005.001.011-.003.017-.002 1.853.123 3.343 1.612 3.466 3.466 0 .006-.003.011-.003.016.001.006.004.011.004.017 0 .032-.013.061-.019.091-.005.03-.007.06-.017.089-.016.041-.041.074-.067.108-.012.018-.018.038-.032.054-.002.002-.005.003-.007.005-.037.039-.084.068-.133.092-.01.006-.018.016-.028.02-.06.026-.127.041-.197.041l-.051 0c-.239 1.416-1.466 2.5-2.949 2.5-1.654 0-3-1.346-3-3 0-1.483 1.084-2.71 2.5-2.949l0-.051c0-.07.015-.137.041-.197.005-.013.017-.022.023-.034.025-.046.052-.091.089-.127.002-.002.003-.005.005-.007.022-.02.049-.03.073-.045.028-.019.052-.04.083-.053.037-.016.077-.017.117-.023.023-.003.044-.014.069-.014.005 0 .01.003.016.003zm2.396 2.997c-.253-.927-.985-1.659-1.912-1.912l0 1.912 1.912 0zM8.0001 12c.929 0 1.705-.641 1.929-1.5l-1.929 0c-.276 0-.5-.224-.5-.5l0-1.929c-.86.224-1.5 1-1.5 1.929 0 1.103.897 2 2 2z"],"file-graph_24":["M20.658 6.342c.22.22.342.512.342.824L21 21.5c0 1.379-1.122 2.5-2.5 2.5l-13 0C4.122 24 3 22.879 3 21.5l0-19C3 1.121 4.122 0 5.5 0l8.333 0c.312 0 .605.121.825.342l6 6zM20 21.5L20 7l-6-6-8.5 0C4.673 1 4 1.673 4 2.5l0 19c0 .827.673 1.5 1.5 1.5l13 0c.827 0 1.5-.673 1.5-1.5zM12.486 9.021c.013 0 .027.001.04.002 2.894.251 5.2 2.557 5.451 5.451.025.285-.217.526-.503.526L17 15c0 2.761-2.239 5-5 5-2.761 0-5-2.239-5-5 0-2.761 2.239-5 5-5l0-.474c0-.273.219-.505.486-.505zM16 15l-3 0c-.552 0-1-.448-1-1l0-3c-2.206 0-4 1.794-4 4 0 2.206 1.794 4 4 4 2.206 0 4-1.794 4-4zm-3-4.901L13 14l3.901 0c-.397-1.967-1.934-3.504-3.901-3.901z"],"file-graph_28":["M24.414 7.414c.375.375.586.884.586 1.414L25 25c0 1.657-1.343 3-3 3L6 28c-1.657 0-3-1.343-3-3L3 3c0-1.657 1.343-3 3-3l10.172 0c.53 0 1.039.211 1.414.586l6.828 6.828zM24 25l0-16.172c0-.263-.107-.52-.293-.707l-6.828-6.828c-.187-.187-.444-.293-.707-.293L6 1c-1.103 0-2 .897-2 2l0 22c0 1.103.897 2 2 2l16 0c1.104 0 2-.897 2-2zm-9.5-15c3.584 0 6.5 2.916 6.5 6.5 0 .276-.224.5-.5.5l-.5 0c0 3.309-2.691 6-6 6-3.309 0-6-2.691-6-6 0-3.309 2.691-6 6-6l0-.5c0-.276.224-.5.5-.5zm.5 6l4.978 0c-.239-2.635-2.343-4.739-4.978-4.978L15 16zm-1 6c2.757 0 5-2.243 5-5l-4.5 0c-.276 0-.5-.224-.5-.5l0-4.5c-2.757 0-5 2.243-5 5 0 2.757 2.243 5 5 5z"],"file-graph_32":["M16.5169 12.029c.005 0 .01-.003.016-.003 3.979.263 7.178 3.462 7.441 7.441 0 .006-.003.011-.003.017.001.005.004.01.004.016 0 .032-.013.061-.019.091-.005.031-.007.061-.018.089-.015.04-.04.072-.064.106-.013.018-.019.04-.034.056-.002.002-.005.003-.007.005-.038.039-.085.069-.135.094-.009.005-.016.014-.026.018-.061.026-.127.041-.197.041l-.475 0c0 3.859-3.14 7-7 7-3.86 0-7-3.141-7-7 0-3.86 3.14-7 7-7l0-.475c0-.07.015-.136.041-.197.005-.011.015-.02.021-.031.025-.048.053-.093.091-.13.003-.002.003-.005.005-.007.014-.013.033-.018.049-.029.037-.027.073-.054.117-.07.023-.009.047-.009.071-.014.035-.008.068-.022.105-.022.006 0 .011.004.017.004zM22.9199 19c-.439-3.054-2.866-5.48-5.92-5.92l0 5.92 5.92 0zm-6.92 7c3.309 0 6-2.691 6-6l-5.5 0c-.276 0-.5-.224-.5-.5l0-5.5c-3.309 0-6 2.691-6 6 0 3.309 2.691 6 6 6zM6.9996 1c-1.1045695 0-2 .8954305-2 2l0 26c0 1.1045695.8954305 2 2 2l18 0c1.1045695 0 2-.8954305 2-2l0-18.7573593c0-.53043299-.2107137-1.03914082-.5857864-1.41421358l-7.2426407-7.24264068C18.7961001 1.21071368 18.2873923 1 17.7569593 1L6.9996 1zm0-1l10.7573593 0c.7956495 0 1.5587112.316070521 2.1213204.878679656l7.2426406 7.242640684c.5626092.56260914.8786797 1.32567088.8786797 2.12132036L27.9996 29c0 1.6568542-1.3431458 3-3 3l-18 0c-1.65685425 0-3-1.3431458-3-3l0-26c0-1.65685425 1.34314575-3 3-3z"],"file-graph_36":["M30.121 9.631c.563.562.879 1.326.879 2.121L31 31.5c0 1.933-1.567 3.5-3.5 3.5l-19 0C6.567 35 5 33.433 5 31.5l0-27C5 2.567 6.567 1 8.5 1l11.748 0c.795 0 1.559.316 2.121.879l7.752 7.752zM30 31.5l0-19.748c0-.534-.208-1.036-.586-1.414l-7.752-7.752c-.378-.378-.88-.586-1.414-.586L8.5 2C7.121 2 6 3.122 6 4.5l0 27C6 32.879 7.121 34 8.5 34l19 0c1.379 0 2.5-1.121 2.5-2.5zm-3.001-10.033c0 .006-.003.011-.002.016 0 .006.003.011.003.017 0 .032-.013.06-.019.09-.004.031-.006.061-.017.09-.016.04-.04.072-.065.106-.012.018-.018.039-.034.056-.002.002-.005.003-.007.005-.037.038-.083.067-.13.091-.011.006-.019.016-.031.021-.06.026-.127.041-.197.041l-.5 0c0 4.411-3.589 8-8 8-4.411 0-8-3.589-8-8 0-4.411 3.589-8 8-8l0-.5c0-.07.015-.137.041-.197.004-.01.013-.017.018-.027.025-.049.054-.096.094-.134.002-.002.003-.005.005-.007.017-.016.038-.022.057-.034.033-.025.065-.049.104-.065.022-.008.046-.008.069-.014.037-.008.072-.022.112-.022.006 0 .011.003.017.003.005 0 .01-.002.016-.002 4.527.299 8.166 3.939 8.466 8.466zM19 21l6.948 0c-.48-3.603-3.346-6.468-6.948-6.948L19 21zm-1 8c3.859 0 7-3.141 7-7l-6.5 0c-.276 0-.5-.224-.5-.5l0-6.5c-3.859 0-7 3.14-7 7 0 3.859 3.141 7 7 7z"],"file-graph_40":["M34.526 10.472c.305.304.433.709.433 1.139l0 24.555c0 2.114-1.681 3.833-3.794 3.833l-22.332 0C6.72 39.999 5 38.28 5 36.166L5 3.833C5 1.72 6.72 0 8.833 0l14.554 0c.429 0 .834.167 1.138.471l10.001 10.001zM34 36.166l0-24.555c0-.163-.063-.317-.179-.432l-10.002-10C23.704 1.063 23.55 1 23.387 1L8.833 1C7.271 1 5.959 2.271 5.959 3.833l0 32.333C5.959 37.728 7.271 39 8.833 39l22.333 0C32.728 39 34 37.728 34 36.166zM20.4595 15c5.238 0 9.5 4.262 9.5 9.5 0 .276-.224.5-.5.5l-.5 0c0 4.962-4.038 9-9 9-4.962 0-9-4.038-9-9 0-4.962 4.038-9 9-9l0-.5c0-.276.224-.5.5-.5zm.5 9l7.985 0c-.25-4.29-3.695-7.735-7.985-7.985l0 7.985zm-1 9c4.411 0 8-3.589 8-8l-7.5 0c-.276 0-.5-.224-.5-.5l0-7.5c-4.411 0-8 3.589-8 8 0 4.411 3.589 8 8 8z"],"file-graph_72":["M62.257 20.006c.479.477.743 1.112.743 1.788L63 64.5c0 3.584-2.916 6.5-6.5 6.5l-41 0C11.916 71 9 68.084 9 64.5l0-57C9 3.916 11.916 1 15.5 1l26.617 0c.676 0 1.313.263 1.792.74l18.348 18.266zM62 64.5l0-42.706c0-.408-.159-.791-.448-1.079L43.204 2.449c-.291-.29-.677-.449-1.087-.449L15.5 2C12.467 2 10 4.467 10 7.5l0 57c0 3.033 2.467 5.5 5.5 5.5l41 0c3.033 0 5.5-2.467 5.5-5.5zM36.5 27C45.598 27 53 34.402 53 43.5c0 .276-.224.5-.5.5l-.5 0c0 8.822-7.178 16-16 16-8.822 0-16-7.178-16-16 0-8.822 7.178-16 16-16l0-.5c0-.276.224-.5.5-.5zm.5 16l14.992 0C51.732 34.85 45.15 28.268 37 28.008L37 43zm-1 16c8.271 0 15-6.729 15-15l-14.5 0c-.276 0-.5-.224-.5-.5L36 29c-8.271 0-15 6.729-15 15 0 8.271 6.729 15 15 15z"],"file-image_12":["M10.759 3.417c.156.157.241.363.241.583l0 6.5c0 .827-.673 1.5-1.5 1.5l-7 0c-.827 0-1.5-.673-1.5-1.5l0-9C1 .673 1.673 0 2.5 0L6 0l1 0c.219 0 .426.085.582.24l3.177 3.177zM2 10.5c0 .275.225.5.5.5l6.79 0-3.617-3.766c-.32-.32-.91-.326-1.244.008l-2.35 2.35c-.023.022-.053.034-.079.052l0 .856zM2.5 1c-.275 0-.5.225-.5.5l0 6.756 1.722-1.721c.713-.713 1.954-.713 2.665 0L10 10.296l0-6.224L6.928 1 6 1 2.5 1zM8 6c-.553 0-1-.447-1-1 0-.553.447-1 1-1 .553 0 1 .447 1 1 0 .553-.447 1-1 1z"],"file-image_16":["M13.707 4.207c.188.188.293.442.293.707L14 14c0 1.105-.895 2-2 2l-8 0c-1.105 0-2-.895-2-2L2 2c0-1.105.895-2 2-2l5.086 0c.265 0 .519.105.707.293l3.914 3.914zM12 15c.337 0 .621-.179.802-.435L7.599 9.361c-.485-.485-1.275-.485-1.761 0L3 12.2 3 14c0 .552.449 1 1 1l8 0zM4 1c-.551 0-1 .448-1 1l0 8.786 2.131-2.132c.848-.848 2.327-.848 3.175 0L13 13.349l0-8.435L9.086 1 4 1zm6.5 7C9.671 8 9 7.329 9 6.5c0-.829.671-1.5 1.5-1.5.829 0 1.5.671 1.5 1.5 0 .829-.671 1.5-1.5 1.5zm0-2c-.276 0-.5.224-.5.5 0 .276.224.5.5.5.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5z"],"file-image_24":["M20.658 6.342c.221.221.342.512.342.824L21 21.5c0 1.379-1.121 2.5-2.5 2.5l-13 0C4.121 24 3 22.879 3 21.5l0-19C3 1.121 4.121 0 5.5 0l8.333 0c.308 0 .608.125.825.342l6 6zM18.5 23c.827 0 1.5-.673 1.5-1.5l0-.385-8.102-8.443c-.885-.885-2.339-.885-3.233.008L4 17.343 4 21.5c0 .827.673 1.5 1.5 1.5l13 0zM5.5 1C4.673 1 4 1.673 4 2.5l0 13.429 3.958-3.956c1.283-1.284 3.371-1.284 4.654 0L20 19.671l0-12.505c0-.047-.016-.084-.049-.117l-6-6c-.03-.03-.076-.049-.118-.049L5.5 1zM17 13c-1.103 0-2-.897-2-2 0-1.103.897-2 2-2 1.103 0 2 .897 2 2 0 1.103-.897 2-2 2zm0-3c-.551 0-1 .449-1 1 0 .551.449 1 1 1 .551 0 1-.449 1-1 0-.551-.449-1-1-1z"],"file-image_28":["M24.414 7.4146c.375.375.586.883.586 1.414l0 16.171c0 1.658-1.343 3-3 3l-16 0c-1.657 0-3-1.342-3-3l0-22c0-1.657 1.343-3 3-3l10.172 0c.53 0 1.039.211 1.414.586l6.828 6.829zM24 24.1646l0-15.336c0-.264-.107-.521-.293-.707l-6.828-6.829c-.187-.186-.444-.293-.707-.293L6 .9996c-1.103 0-2 .898-2 2l0 15.978 4.832-4.831c.765-.764 1.769-1.147 2.773-1.147 1.004 0 2.008.383 2.772 1.147L24 24.1646zm-2 2.835c.92 0 1.689-.627 1.921-1.475l-10.257-10.678c-.565-.564-1.31-.848-2.057-.848-.748 0-1.498.285-2.068.855L4 20.3906l0 4.609c0 1.103.897 2 2 2l16 0zM19.5 10c1.379 0 2.5 1.121 2.5 2.5 0 1.379-1.121 2.5-2.5 2.5-1.379 0-2.5-1.121-2.5-2.5 0-1.379 1.121-2.5 2.5-2.5zm0 4c.827 0 1.5-.673 1.5-1.5 0-.827-.673-1.5-1.5-1.5-.827 0-1.5.673-1.5 1.5 0 .827.673 1.5 1.5 1.5z"],"file-image_32":["M27.1215 8.1215c.562.562.878 1.326.878 2.121l0 17.695 0 1.063c0 .117-.021.228-.034.342-.173 1.493-1.426 2.658-2.966 2.658l-18 0c-1.657 0-3-1.344-3-3l0-26c0-1.657 1.343-3 3-3l10.758 0c.795 0 1.559.316 2.121.878l7.243 7.243zm-10.436 8.068l10.314 10.71 0-16.657c0-.531-.21-1.039-.585-1.414l-7.243-7.243c-.375-.375-.883-.585-1.414-.585l-10.758 0c-1.104 0-2 .895-2 2l0 19.129 5.942-5.94c1.585-1.586 4.16-1.582 5.744 0zM22.5088 17c-1.379 0-2.5-1.123-2.5-2.5 0-1.379 1.121-2.5 2.5-2.5 1.379 0 2.5 1.121 2.5 2.5 0 1.377-1.121 2.5-2.5 2.5zm0-4c-.827 0-1.5.672-1.5 1.5 0 .826.673 1.5 1.5 1.5.827 0 1.5-.674 1.5-1.5 0-.828-.673-1.5-1.5-1.5zm4.4907 16.0005l0-.661-11.029-11.449c-1.187-1.186-3.129-1.188-4.322.006l-6.649 6.647 0 5.457c0 1.104.896 2 2 2l18 0c1.105 0 2-.896 2-2z"],"file-image_36":["M30.121 9.63c.563.563.879 1.326.879 2.122L31 31.5c0 1.932-1.567 3.5-3.5 3.5l-19 0C6.567 35 5 33.432 5 31.5l0-27C5 2.566 6.567 1 8.5 1l11.748 0c.795 0 1.559.315 2.121.878l7.752 7.752zM30 29.105l0-17.353c0-.534-.208-1.037-.586-1.415l-7.752-7.752c-.378-.377-.88-.585-1.414-.585L8.5 2C7.121 2 6 3.121 6 4.5l0 19.018 6.157-6.155c.879-.88 2.048-1.363 3.291-1.363 1.243 0 2.412.483 3.291 1.363L30 29.105zm-5.5-16.1055c1.379 0 2.5 1.122 2.5 2.5 0 1.378-1.121 2.5-2.5 2.5-1.379 0-2.5-1.122-2.5-2.5 0-1.378 1.121-2.5 2.5-2.5zm0 4c.827 0 1.5-.673 1.5-1.5 0-.827-.673-1.5-1.5-1.5-.827 0-1.5.673-1.5 1.5 0 .827.673 1.5 1.5 1.5zM30 31.5l0-.951-11.976-12.486c-1.365-1.367-3.779-1.374-5.16.007L6 24.932 6 31.5C6 32.878 7.121 34 8.5 34l19 0c1.379 0 2.5-1.122 2.5-2.5z"],"file-image_40":["M34.528 10.472c.305.304.472.709.472 1.14l0 24.555C35 38.28 33.28 40 31.167 40L8.833 40C6.719 40 5 38.28 5 36.167L5 3.834C5 1.72 6.719 0 8.833 0l14.553 0c.429 0 .834.168 1.138.472l10.004 10zM31.168 39c1.562 0 2.834-1.271 2.834-2.833l0-1.181-14.18-14.761c-1.638-1.637-4.314-1.637-5.959.007l-7.865 7.864 0 8.071C5.998 37.729 7.271 39 8.833 39l22.335 0zM8.833 1C7.271 1 5.998 2.271 5.998 3.834l0 22.848 7.158-7.157c2.034-2.035 5.345-2.034 7.38 0l13.466 14.018 0-21.931c0-.164-.063-.317-.179-.433l-10.005-10c-.115-.115-.269-.179-.432-.179L8.833 1zm18.1666 19.0005c-1.654 0-3-1.346-3-3 0-1.654 1.346-3 3-3 1.654 0 3 1.346 3 3 0 1.654-1.346 3-3 3zm0-5c-1.103 0-2 .897-2 2 0 1.103.897 2 2 2 1.103 0 2-.897 2-2 0-1.103-.897-2-2-2z"],"file-image_44":["M38.48 11.898c.331.33.52.785.52 1.25L39 40c0 2.206-1.794 4-4 4L9 44c-2.206 0-4-1.794-4-4L5 4c0-2.206 1.794-4 4-4l16.809 0c.471 0 .915.184 1.249.516L38.48 11.898zM35 43c1.654 0 3-1.346 3-3l0-1.049c-.029-.019-.061-.033-.086-.059L22.115 22.419c-.882-.883-2.063-1.373-3.32-1.373-1.256 0-2.438.49-3.327 1.381L6 31.905 6 40c0 1.654 1.346 3 3 3l26 0zM9 1C7.346 1 6 2.346 6 4l0 26.49 8.761-8.77c1.077-1.079 2.51-1.674 4.034-1.674 1.524 0 2.958.595 4.035 1.674L38 37.536l0-24.388c0-.204-.08-.396-.225-.541L26.353 1.225C26.207 1.08 26.014 1 25.809 1L9 1zm21.5 21c-1.933 0-3.5-1.567-3.5-3.5 0-1.933 1.567-3.5 3.5-3.5 1.933 0 3.5 1.567 3.5 3.5 0 1.933-1.567 3.5-3.5 3.5zm0-6c-1.379 0-2.5 1.121-2.5 2.5 0 1.379 1.121 2.5 2.5 2.5 1.379 0 2.5-1.121 2.5-2.5 0-1.379-1.121-2.5-2.5-2.5z"],"file-image_72":["M62.258 20.006c.478.478.742 1.113.742 1.788L63 64.5c0 3.584-2.916 6.5-6.5 6.5l-41 0C11.916 71 9 68.084 9 64.5l0-57C9 3.916 11.916 1 15.5 1l26.617 0c.677 0 1.314.263 1.792.74l18.348 18.266c0 0 0 0 .001 0zM56.5 70c3.032 0 5.5-2.467 5.5-5.5l0-1.483-25.573-26.622c-3.186-3.186-8.381-3.185-11.574.007L10.101 51.15c-.03.03-.067.046-.101.067L10 64.5c0 3.033 2.468 5.5 5.5 5.5l41 0zm-41-68C12.468 2 10 4.467 10 7.5l0 42.337 14.146-14.142c3.582-3.583 9.411-3.583 12.995 0L62 61.574l0-39.78c0-.401-.163-.795-.448-1.079L43.204 2.449c-.291-.29-.677-.449-1.087-.449L15.5 2zm34 34c-3.037 0-5.5-2.462-5.5-5.5 0-3.038 2.463-5.5 5.5-5.5 3.037 0 5.5 2.462 5.5 5.5 0 3.038-2.463 5.5-5.5 5.5zm0-10c-2.481 0-4.5 2.019-4.5 4.5 0 2.481 2.019 4.5 4.5 4.5 2.481 0 4.5-2.019 4.5-4.5 0-2.481-2.019-4.5-4.5-4.5z"],"file-locked_12":["M10.759 3.417c.156.157.241.363.241.583l0 6.5c0 .827-.673 1.5-1.5 1.5l-7 0c-.827 0-1.5-.673-1.5-1.5l0-9C1 .673 1.673 0 2.5 0L6 0l1 0c.219 0 .426.085.582.24l3.177 3.177zM10 10.5L10 5 7.5 5C6.673 5 6 4.327 6 3.5L6 1 2.5 1c-.276 0-.5.224-.5.5l0 9c0 .276.224.5.5.5l7 0c.276 0 .5-.224.5-.5zM7 1.073L7 3.5c0 .276.225.5.5.5l2.427 0L7 1.073zM6 5c.275 0 .5.225.5.5l0 2c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-2c0-.275.225-.5.5-.5zm0 4c.275 0 .5.225.5.5 0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5z"],"file-locked_24":["M20.658 6.342c.221.22.342.512.342.824L21 21.5c0 1.379-1.121 2.5-2.5 2.5l-13 0C4.121 24 3 22.879 3 21.5l0-19C3 1.121 4.121 0 5.5 0l8.333 0c.308 0 .608.125.825.342l6 6zM20 21.5l0-13.501-4.452-.007C14.143 7.992 13 6.93 13 5.623L13 1 5.5 1C4.673 1 4 1.673 4 2.5l0 19c0 .827.673 1.5 1.5 1.5l13 0c.827 0 1.5-.673 1.5-1.5zM12 12c.27614237 0 .5.2238576.5.5l0 3c0 .2761424-.22385763.5-.5.5-.27614237 0-.5-.2238576-.5-.5l0-3c0-.2761424.22385763-.5.5-.5zm0 7c-.27614237 0-.5-.2238576-.5-.5 0-.2761424.22385763-.5.5-.5.27614237 0 .5.2238576.5.5 0 .2761424-.22385763.5-.5.5zm2.02-17.883l0 4.506c0 .784.685 1.421 1.528 1.421l4.398 0-5.926-5.927z"],"file-locked_32":["M27.121 8.121c.563.563.879 1.326.879 2.122L28 29c0 1.657-1.343 3-3 3L7 32c-1.657 0-3-1.343-3-3l0-14.238L4 3C4 1.344 5.341.002 6.997 0 6.998 0 6.999 0 7 0l10.758 0c.001 0 .002 0 .003 0 .794.001 1.555.317 2.118.879l7.242 7.242zM27 29l0-18.757c0-.082-.014-.162-.024-.243l-5.97 0c-1.657 0-3-1.343-3-3l0-5.976c-.082-.01-.164-.024-.248-.024L7 1c-1.104 0-2 .896-2 2l0 11.762L5 29c0 1.103.897 2 2 2l18 0c1.104 0 2-.897 2-2zm-.586-20.171l-7.242-7.243c-.051-.051-.11-.091-.166-.136l0 5.55c0 1.103.897 2 2 2l5.549 0c-.046-.058-.088-.119-.141-.171zM16 16c.2761424 0 .5.2238576.5.5l0 5c0 .2761424-.2238576.5-.5.5-.2761424 0-.5-.2238576-.5-.5l0-5c0-.2761424.2238576-.5.5-.5zm0 9c-.2761424 0-.5-.2238576-.5-.5 0-.2761424.2238576-.5.5-.5.2761424 0 .5.2238576.5.5 0 .2761424-.2238576.5-.5.5z"],"file-locked_36":["M30.572 10.082c.273.272.428.649.428 1.033L31 31.5c0 1.93-1.57 3.5-3.5 3.5l-19 0C6.57 35 5 33.43 5 31.5l0-27C5 2.57 6.57 1 8.5 1l12.385 0c.389 0 .756.152 1.033.428l8.654 8.654zM30 31.5L30 12l-6.5 0c-1.93 0-3.5-1.57-3.5-3.5L20 2 8.5 2C7.122 2 6 3.122 6 4.5l0 27C6 32.879 7.122 34 8.5 34l19 0c1.379 0 2.5-1.121 2.5-2.5zM21 2.023L21 8.5c0 1.378 1.121 2.5 2.5 2.5l6.477 0c-.021-.079-.054-.153-.113-.211l-8.653-8.654c-.059-.058-.133-.092-.211-.112zM17.999974 23c-.2759856 0-.499974-.224-.499974-.5l0-6c0-.276.2239884-.5.499974-.5.2759857 0 .4999741.224.4999741.5l0 6c0 .276-.2239884.5-.4999741.5zm0 2.9979679c-.1299932 0-.2599865-.05-.3509817-.14-.0989949-.099-.1489923-.219-.1489923-.36 0-.13.0499974-.26.1489923-.35.0399979-.049.1009947-.08.1609916-.11.1799907-.08.3999792-.029.539972.11.0999948.09.1499922.22.1499922.35 0 .141-.0499974.261-.1499922.36-.039998.04-.0999948.08-.1609917.1-.0589969.03-.1199937.04-.1889902.04z"],"file-locked_40":["M34.527 10.472c.305.304.473.709.473 1.139l0 24.556C35 38.28 33.28 40 31.166 40L8.834 40C6.72 40 5 38.28 5 36.167L5 3.833C5 1.72 6.72 0 8.834 0l14.554 0c.429 0 .834.167 1.138.471l10.001 10.001zM31.168 39c1.562 0 2.834-1.271 2.834-2.833l0-23.163-8.276 0c-2.039 0-3.698-1.658-3.698-3.696l0-8.308L8.834 1C7.272 1 5.999 2.271 5.999 3.833l0 32.334C5.999 37.729 7.272 39 8.834 39l22.334 0zM23.82 1.179c-.115-.116-.269-.179-.432-.179l-.36 0 0 8.308c0 1.486 1.21 2.696 2.698 2.696l8.276 0 0-.393c0-.163-.063-.317-.18-.432l-10.002-10zM20 18.0005c.275 0 .5.225.5.5l0 9c0 .274-.225.5-.5.5-.275 0-.5-.226-.5-.5l0-9c0-.275.225-.5.5-.5zM20 31c.275 0 .5.225.5.5 0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5z"],"file-missing_16":["M13.707 4.207c.188.188.293.442.293.707L14 5l0 1 0 8c0 1.105-.895 2-2 2l-8 0c-1.105 0-2-.895-2-2L2 2c0-1.105.895-2 2-2l4 0 1 0 .086 0c.265 0 .519.105.707.293l3.914 3.914zM13 5l0-.086L9.086 1 9 1l0 3c0 .551.449 1 1 1l3 0zm0 9l0-8-3 0c-1.105 0-2-.895-2-2l0-3-4 0c-.551 0-1 .449-1 1l0 12c0 .551.449 1 1 1l8 0c.551 0 1-.449 1-1zm-4.9902-1c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm.5112-5.9492c.952.191 1.728.956 1.93 1.902.169.834-.221 1.697-.961 2.179l-1.207.787c-.084.055-.179.081-.273.081-.163 0-.323-.08-.419-.226-.151-.232-.086-.542.146-.693l1.207-.787c.401-.261.615-.708.534-1.112-.123-.573-.596-1.038-1.154-1.151-.461-.093-.909.017-1.264.308-.35.287-.55.71-.55 1.161 0 .277-.224.5-.5.5-.277 0-.5-.223-.5-.5 0-.752.334-1.457.916-1.934.582-.476 1.345-.666 2.095-.515z"],"file-missing_24":["M20.658 6.342c.221.221.342.512.342.824L21 8l0 5 0 8.5c0 1.379-1.121 2.5-2.5 2.5l-13 0C4.121 24 3 22.879 3 21.5l0-19C3 1.121 4.121 0 5.5 0L8 0l5.833 0c.308 0 .608.125.825.342l6 6zM20 13l0-5.001-4.452-.007C14.143 7.992 13 6.93 13 5.623L13 1 8 1 5.5 1C4.673 1 4 1.673 4 2.5l0 19c0 .827.673 1.5 1.5 1.5l13 0c.827 0 1.5-.673 1.5-1.5l0-8.5zM14.019 1.117l0 4.506c0 .784.686 1.422 1.529 1.422l4.399 0-5.928-5.928zM11.4912 19c.276 0 .5.224.5.5 0 .275-.224.5-.5.5-.276 0-.5-.225-.5-.5 0-.276.224-.5.5-.5zm.0996-9.999c1.88.054 3.409 1.634 3.409 3.521 0 1.578-.866 2.301-1.561 2.882-.12.102-.238.2-.348.301l-.51.469c-.364.335-.572.809-.572 1.305 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.774.326-1.517.895-2.041l.51-.469c.121-.113.251-.22.384-.331.618-.517 1.202-1.005 1.202-2.116 0-1.33-1.116-2.484-2.437-2.521-.689-.03-1.341.226-1.82.689-.479.467-.743 1.109-.743 1.81 0 .275-.223.5-.5.5-.276 0-.5-.225-.5-.5 0-.975.371-1.87 1.046-2.525.674-.657 1.585-.995 2.545-.974z"],"file-missing_36":["M30.572 10.082c.273.272.428.648.428 1.033L31 31.5c0 1.93-1.57 3.5-3.5 3.5l-19 0C6.57 35 5 33.43 5 31.5l0-27C5 2.57 6.57 1 8.5 1l12.385 0c.389 0 .756.152 1.033.428l8.654 8.654zM30 31.5L30 12l-6.5 0c-1.93 0-3.5-1.57-3.5-3.5L20 2 8.5 2C7.122 2 6 3.122 6 4.5l0 27C6 32.879 7.122 34 8.5 34l19 0c1.379 0 2.5-1.121 2.5-2.5zM21 2.023L21 8.5c0 1.378 1.121 2.5 2.5 2.5l6.477 0c-.021-.079-.054-.153-.113-.211l-8.653-8.654c-.059-.058-.133-.092-.211-.112zm-2.8447 11.979c2.64.076 4.871 2.38 4.871 5.032 0 2.249-1.248 3.293-2.252 4.132-.183.153-.364.304-.531.457l-.802.744c-.599.55-.941 1.33-.941 2.141 0 .276-.224.5-.5.5-.277 0-.5-.224-.5-.5 0-1.09.46-2.138 1.262-2.876l.803-.743c.179-.165.371-.326.568-.491.973-.813 1.893-1.583 1.893-3.364 0-2.125-1.786-3.971-3.899-4.032-1.078-.026-2.077.364-2.845 1.11-.81.788-1.256 1.864-1.256 3.028 0 .276-.224.5-.5.5-.277 0-.5-.224-.5-.5 0-1.437.553-2.767 1.559-3.744.963-.937 2.233-1.433 3.57-1.394zM18 29c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5z"],"file-pdf_12":["M10.759 3.417c.156.157.241.363.241.583l0 6.5c0 .827-.673 1.5-1.5 1.5l-7 0c-.827 0-1.5-.673-1.5-1.5l0-9C1 .673 1.673 0 2.5 0L6 0l1 0c.219 0 .426.085.582.24l3.177 3.177zM10 10.5l0-6.428L6.928 1 6 1 2.5 1c-.275 0-.5.225-.5.5l0 9c0 .275.225.5.5.5l7 0c.275 0 .5-.225.5-.5zM6.9072 6.3369c-.002.003-.003.007-.005.01l-.335.779c.025.048.051.096.078.144.325-.092.604-.153.775-.153.552 0 .969.417.969.971 0 .535-.435.971-.97.971-.562 0-.87-.281-1.054-.492-.036-.041-.074-.085-.113-.131-.101.035-.204.072-.31.11l-.404.885c-.161.346-.511.569-.894.569-.574 0-1.014-.438-1.014-.976 0-.42.268-.791.668-.925.184-.075.521-.206.911-.35l.264-.611-.357-.781c-.055-.134-.079-.258-.079-.386 0-.535.435-.971.971-.971.535 0 .97.436.97.971 0 .125-.024.248-.071.366z"],"file-pdf_16":["M13.707 4.207c.188.188.293.441.293.707L14 14c0 1.105-.895 2-2 2l-8 0c-1.105 0-2-.895-2-2L2 2c0-1.105.895-2 2-2l5.086 0c.265 0 .519.105.707.293l3.914 3.914zM13 14l0-9.086L9.086 1 4 1c-.551 0-1 .448-1 1l0 12c0 .552.449 1 1 1l8 0c.551 0 1-.448 1-1zM9.041 8.0761c-.001.003-.002.006-.003.008l-.481 1.158c.064.138.136.273.217.407.466-.141.868-.237 1.101-.237.652 0 1.125.482 1.125 1.146 0 .633-.505 1.148-1.126 1.148-.682 0-1.058-.352-1.282-.616-.074-.089-.145-.176-.212-.261-.188.065-.385.136-.588.21l-.566 1.281c-.187.414-.595.68-1.041.68-.673 0-1.185-.519-1.185-1.155 0-.495.311-.934.772-1.093.192-.079.687-.28 1.276-.503l.423-.999-.511-1.156c-.062-.155-.089-.298-.089-.447 0-.632.505-1.147 1.126-1.147.621 0 1.126.515 1.126 1.147 0 .148-.028.291-.082.429zm.834 2.336c-.09 0-.252.033-.467.091.144.152.265.203.466.203.069 0 .126-.066.126-.148 0-.146-.072-.146-.125-.146zm-1.763-2.706c.007-.019.011-.038.011-.059 0-.081-.057-.147-.126-.147-.069 0-.126.066-.126.147l.135.314.106-.255zm-1.8 4.207l.163-.367c-.118.047-.235.094-.35.141-.085.031-.125.091-.125.158 0 .191.269.164.312.068z"],"file-pdf_24":["M20.658 6.342c.221.22.342.512.342.824L21 21.5c0 1.379-1.121 2.5-2.5 2.5l-13 0C4.121 24 3 22.879 3 21.5l0-19C3 1.121 4.121 0 5.5 0l8.333 0c.308 0 .608.125.825.342l6 6zM20 21.5l0-14.334c0-.047-.016-.084-.049-.117l-6-6c-.03-.03-.076-.049-.118-.049L5.5 1C4.673 1 4 1.673 4 2.5l0 19c0 .827.673 1.5 1.5 1.5l13 0c.827 0 1.5-.673 1.5-1.5zm-4.4951-6.4966c.827 0 1.5.673 1.5 1.5 0 .827-.673 1.5-1.5 1.5-.91 0-1.753-.411-2.313-1.127l-.411-.527c-.443.088-.886.208-1.318.358l-.249.086c-.309.758-.632 1.509-.969 2.249-.266.584-.852.961-1.493.961l-.117 0c-.904 0-1.64-.736-1.64-1.64 0-.729.489-1.377 1.19-1.577l2.271-.788c.27-.677.526-1.36.772-2.046l-1-1.695c-.141-.209-.227-.476-.238-.754l-.001 0 0-.028 0-.028.001 0c.03-.801.691-1.444 1.499-1.444.833 0 1.506.673 1.506 1.5 0 .242-.028.408-.084.567-.185.594-.382 1.186-.586 1.775l.866 1.405.217-.043c.687-.135 1.393-.204 2.097-.204zm-.002 2c.276 0 .502-.224.502-.5 0-.276-.225-.5-.5-.5-.543 0-1.087.045-1.62.134l.097.123c.368.472.922.743 1.521.743zm-3.813-1.417c.143-.041.289-.08.433-.115l-.238-.404c-.065.174-.129.347-.195.519zm-.617-3.861l.581.984c.104-.31.203-.622.301-.933.031-.088.04-.144.04-.201 0-.348-.224-.572-.5-.572-.271 0-.49.209-.505.472.005.09.034.175.083.25zm-1.738 6.903c.21-.462.415-.927.613-1.396l-1.462.507c-.299.087-.491.34-.491.624 0 .353.287.64.64.64l.117 0c.25 0 .48-.147.583-.375z"],"file-pdf_28":["M24.414 7.414c.375.375.586.884.586 1.414L25 25c0 1.657-1.343 3-3 3L6 28c-1.657 0-3-1.343-3-3L3 3c0-1.657 1.343-3 3-3l10.172 0c.53 0 1.039.211 1.414.586l6.828 6.828zM24 25l0-16.172c0-.263-.107-.52-.293-.707l-6.828-6.828c-.187-.186-.444-.293-.707-.293L6 1c-1.103 0-2 .897-2 2l0 22c0 1.103.897 2 2 2l16 0c1.103 0 2-.897 2-2zm-5.8647-8.1764c1.23 0 1.874.902 1.874 1.794 0 .989-.841 1.794-1.876 1.794-.969 0-1.671-.311-2.347-1.039-.262-.282-.5-.552-.716-.817-.641.197-1.317.419-1.979.641l-1.342 2.759c-.315.636-.995 1.044-1.733 1.044-1.149 0-2.007-.812-2.007-1.81 0-.781.526-1.471 1.309-1.717.29-.109 1.555-.578 3.058-1.092l1.113-2.386-1.211-2.493c-.104-.238-.152-.469-.152-.708 0-.989.842-1.794 1.877-1.794 1.035 0 1.877.805 1.877 1.794 0 .239-.049.472-.144.691-.002.003-.003.006-.004.009l-1.142 2.499c.231.481.506.938.848 1.407 1.155-.336 2.166-.576 2.697-.576zm-.002 2.588c.483 0 .876-.356.876-.794 0-.384-.229-.794-.874-.794-.378 0-1.117.167-2.019.421.127.146.261.295.402.448.401.431.829.719 1.615.719zm-4.434-1.473c.244-.079.488-.157.73-.233-.13-.19-.251-.379-.362-.569l-.368.802zm-.513-4.854l.842 1.731.792-1.734c.04-.091.06-.189.06-.288 0-.438-.394-.794-.877-.794-.484 0-.877.356-.877.794 0 .101.021.199.06.291zm-2.334 8.43l.904-1.859c-.849.298-1.6.57-2.113.762-.389.123-.634.43-.634.772 0 .447.41.81.913.81.455 0 .783-.19.93-.485z"],"file-pdf_32":["M19.0996 21.2197c.621-.146 1.261-.22 1.9-.22.552 0 1 .449 1 1 0 .552-.449 1-1.001 1-.806 0-1.572-.35-2.098-.962-.182-.211-.358-.427-.527-.647l.726-.171zm-12.1-20.22c-1.1045695 0-2 .8954305-2 2l0 26c0 1.1045695.8954305 2 2 2l18 0c1.1045695 0 2-.8954305 2-2l0-18.7573593c0-.53043299-.2107137-1.03914082-.5857864-1.41421358l-7.2426407-7.24264068C18.7961001 1.21041368 18.2873923.9997 17.7569593.9997L6.9996.9997zm0-1l10.7573593 0c.7956495 0 1.5587112.316070521 2.1213204.878679656l7.2426406 7.242640684c.5626092.56260914.8786797 1.32567088.8786797 2.12132036l0 18.7573593c0 1.6568542-1.3431458 3-3 3l-18 0c-1.65685425 0-3-1.3431458-3-3l0-26c0-1.65685425 1.34314575-3 3-3zm8.82 20.964l-.451.153.662-1.599c.211.422.44.834.689 1.234l-.9.212zm-.748-6.382c-.047-.117-.072-.242-.072-.371l0-.211c0-.551.449-1 1-1 .552 0 1 .449 1 1l0 .259c0 .129-.024.255-.073.375l-.921 2.277-.934-2.329zm-2.733 10.737c-.189.412-.605.678-1.06.678l-.112 0c-.643 0-1.167-.523-1.167-1.167 0-.501.319-.945.792-1.105l2.7-.917-1.153 2.511zm4.205-7.073l1.311-3.237c.097-.24.145-.492.145-.75l0-.259c0-1.103-.897-2-2-2-1.102 0-2 .897-2 2l0 .211c0 .257.048.508.144.744l1.321 3.294-.893 2.209-.506 1.101-3.594 1.219c-.881.298-1.472 1.123-1.472 2.052 0 1.196.972 2.167 2.167 2.167l.112 0c.844 0 1.617-.495 1.968-1.261l1.548-3.37 1.299-.441 1.219-.286c.261.361.538.713.83 1.052.717.832 1.759 1.309 2.857 1.309 1.103 0 2-.897 2-2 0-1.102-.897-2-2-2-.716 0-1.433.083-2.129.246l-1.12.264c-.467-.716-.871-1.472-1.207-2.264z"],"file-pdf_36":["M30.121 9.631c.563.562.879 1.326.879 2.121L31 31.5c0 1.933-1.567 3.5-3.5 3.5l-19 0C6.567 35 5 33.433 5 31.5l0-27C5 2.567 6.567 1 8.5 1l11.748 0c.795 0 1.559.316 2.121.879l7.752 7.752zM30 31.5l0-19.748c0-.534-.208-1.036-.586-1.414l-7.752-7.752c-.378-.378-.88-.586-1.414-.586L8.5 2C7.121 2 6 3.122 6 4.5l0 27C6 32.879 7.121 34 8.5 34l19 0c1.379 0 2.5-1.121 2.5-2.5zm-6.374-10.0289c1.631 0 2.374 1.234 2.374 2.381 0 1.261-.978 2.142-2.377 2.142-1.272 0-2.193-.434-3.078-1.451-.318-.365-.625-.718-.919-1.072-.963.313-1.995.671-2.999 1.033l-1.867 4.094c-.397.852-1.262 1.402-2.205 1.402l-.129 0c-1.338 0-2.426-1.079-2.426-2.405 0-1.033.662-1.949 1.648-2.28.162-.064 2.014-.8 4.245-1.61l.536-1.177 1.068-2.493-1.7-3.734c-.125-.307-.184-.609-.184-.919 0-1.313 1.067-2.382 2.378-2.382 1.311 0 2.377 1.069 2.377 2.382 0 .312-.059.616-.177.904-.001.002-.002.005-.003.007l-1.602 3.741c.389.863.86 1.586 1.392 2.276 1.572-.489 2.943-.839 3.648-.839zm-.003 3.523c.635 0 1.377-.299 1.377-1.142 0-.637-.359-1.381-1.374-1.381-.549 0-1.644.27-2.967.673.207.245.421.491.64.743.579.665 1.195 1.107 2.324 1.107zm-6.418-1.759c.587-.206 1.182-.409 1.764-.6-.325-.439-.625-.895-.901-1.395l-.863 1.995zm-.49-7.329l1.314 2.886 1.238-2.888c.067-.166.101-.341.101-.522 0-.762-.618-1.382-1.377-1.382-.76 0-1.378.62-1.378 1.382 0 .18.034.357.102.524zm-2.863 12.273l1.457-3.195c-1.336.494-2.53.956-3.317 1.27-.603.203-.992.738-.992 1.341 0 .774.64 1.405 1.426 1.405l.129 0c.555 0 1.064-.322 1.297-.821z"],"file-pdf_40":["M8.833 1C7.271 1 5.999 2.271 5.999 3.833l0 32.334C5.999 37.729 7.271 39 8.833 39l22.333 0c1.562 0 2.833-1.271 2.833-2.833l0-24.556c0-.163-.063-.317-.179-.432l-10.002-10c-.115-.116-.269-.179-.432-.179L8.833 1zm22.331 39L8.833 40C6.719 40 5 38.28 5 36.167L5 3.833C5 1.72 6.719 0 8.833 0l14.553 0c.43 0 .834.167 1.139.471l10 10.001c.305.304.473.709.473 1.139l0 24.556c0 2.113-1.72 3.833-3.834 3.833zm-9.1953-22.4165l.01 0-.01 0zm-1.969-2.583c.897 0 1.627.778 1.627 1.735 0 .229-.041.452-.122.662l-1.459 3.569-1.551-3.568c-.081-.21-.123-.433-.123-.663 0-.957.73-1.735 1.628-1.735zm.073 8.539c.309.635.661 1.257 1.073 1.89-.719.248-1.455.513-2.179.78l1.106-2.67zm2.657 2.413c1.63-.531 2.992-.894 3.656-.894 1.199 0 1.624.935 1.624 1.735 0 .957-.73 1.736-1.627 1.736-1.298 0-2.009-.535-2.677-1.338-.355-.427-.679-.838-.976-1.239zm-5.627 2.033l-1.738 3.994c-.275.62-.874 1.021-1.526 1.021l-.146 0c-.928 0-1.683-.792-1.683-1.764 0-.758.461-1.429 1.174-1.681.924-.385 2.341-.959 3.919-1.57zm-3.264 6.015c1.047 0 2.005-.635 2.442-1.619l2.13-4.895c1.11-.419 2.252-.835 3.323-1.201.36.498.758 1.01 1.203 1.545.699.84 1.654 1.699 3.446 1.699 1.448 0 2.627-1.227 2.627-2.736 0-1.317-.821-2.735-2.624-2.735-.817 0-2.426.437-4.259 1.04-.635-.948-1.127-1.863-1.531-2.836l1.836-4.49c.001-.002.002-.005.003-.007.127-.328.192-.674.192-1.03 0-1.508-1.179-2.735-2.627-2.735-1.449 0-2.628 1.227-2.628 2.735 0 .355.065.7.199 1.044l1.946 4.479-1.231 3.01-.622 1.43c-2.54.967-4.654 1.846-4.838 1.924-1.086.381-1.816 1.432-1.816 2.614 0 1.524 1.204 2.764 2.683 2.764l.146 0z"],"file-pdf_44":["M38.481 11.898c.33.33.519.786.519 1.25L39 40c0 2.206-1.794 4-4 4L9 44c-2.206 0-4-1.794-4-4L5 4c0-2.206 1.794-4 4-4l16.809 0c.472 0 .916.184 1.249.517l11.423 11.381zM38 40l0-26.852c0-.201-.082-.399-.225-.542L26.352 1.225c-.143-.143-.341-.225-.543-.225L9 1C7.346 1 6 2.346 6 4l0 36c0 1.654 1.346 3 3 3l26 0c1.654 0 3-1.346 3-3zm-8.9878-14.0054c.81 0 1.562.309 2.117.871.578.585.892 1.376.883 2.228 0 1.61-1.336 2.924-2.977 2.924-1.977 0-3.032-.938-3.804-1.857-.512-.61-.969-1.198-1.383-1.781-1.169.409-2.415.872-3.627 1.34l-2.433 5.525c-.478 1.068-1.527 1.755-2.674 1.755l-.162 0c-1.622 0-2.94-1.346-2.94-3.001 0-1.285.8-2.426 1.991-2.841.205-.088 2.608-1.112 5.471-2.224l2.075-4.792c-.011-.027-.021-.054-.032-.08l-2.283-4.912c-.151-.383-.222-.757-.222-1.143-.004-.803.306-1.56.873-2.131.567-.568 1.32-.881 2.123-.881 1.65 0 2.994 1.341 2.997 2.99 0 .407-.072.784-.212 1.141l-2.16 5.027c.451 1.072.97 2.053 1.612 3.033 2.048-.69 3.85-1.191 4.767-1.191zm.023 5.023c1.071 0 1.977-.884 1.977-1.93.006-.588-.205-1.126-.594-1.519-.372-.376-.858-.574-1.406-.574-.759 0-2.318.427-4.175 1.047.352.483.736.971 1.16 1.476.756.9 1.562 1.5 3.038 1.5zm-8.247-2.588c.825-.311 1.664-.62 2.482-.908-.443-.694-.829-1.392-1.174-2.119l-1.308 3.027zm-.635-9.674l1.928 4.148 1.787-4.158c.089-.226.137-.48.137-.741-.002-1.117-.898-2.01-1.997-2.01-.535 0-1.037.209-1.415.587-.377.38-.584.883-.581 1.419l0 .004c0 .26.047.513.141.751zm-3.278 16.083l2.027-4.605c-1.828.721-3.478 1.403-4.538 1.856-.822.287-1.352 1.05-1.352 1.909 0 1.104.87 2.001 1.94 2.001l.162 0c.753 0 1.444-.456 1.761-1.161z"],"file-pdf_72":["M62.257 20.006c.479.477.743 1.112.743 1.788L63 64.5c0 3.584-2.916 6.5-6.5 6.5l-41 0C11.916 71 9 68.084 9 64.5l0-57C9 3.916 11.916 1 15.5 1l26.617 0c.676 0 1.313.263 1.792.74l18.348 18.266zM62 64.5l0-42.706c0-.408-.159-.791-.448-1.079L43.204 2.449c-.291-.29-.677-.449-1.087-.449L15.5 2C12.467 2 10 4.467 10 7.5l0 57c0 3.033 2.467 5.5 5.5 5.5l41 0c3.033 0 5.5-2.467 5.5-5.5zM48.3966 43.5286c3.176 0 4.623 2.394 4.623 4.618 0 2.547-2.071 4.618-4.618 4.618-2.619 0-4.508-.888-6.33-2.968-.943-1.077-1.779-2.101-2.525-3.098-2.278.734-4.705 1.578-6.99 2.399l-4.212 9.182c-.772 1.654-2.462 2.72-4.306 2.72l-.282 0c-2.612 0-4.737-2.094-4.737-4.669 0-2.003 1.293-3.779 3.218-4.421.372-.148 4.583-1.811 9.588-3.617l1.283-2.798 2.564-5.442c-.056-.133-.112-.266-.166-.399l-4.145-7.816c-.248-.599-.364-1.186-.364-1.791 0-2.801 2.246-5.047 5.006-5.047 2.754 0 5 2.242 5.005 4.996 0 0 .001.051.001.051 0 .606-.116 1.196-.345 1.753l-3.896 8.27c.832 1.873 1.846 3.63 3.16 5.457 3.651-1.153 6.871-1.998 8.468-1.998zm-.007 8.236c2.007 0 3.63-1.623 3.63-3.618 0-1.8-1.12-3.618-3.623-3.618-1.452 0-4.418.773-7.84 1.848.678.89 1.429 1.804 2.267 2.761 1.634 1.866 3.247 2.627 5.566 2.627zm-15.248-3.943c1.908-.679 3.889-1.361 5.786-1.975-1.09-1.542-1.973-3.039-2.715-4.595l-3.071 6.57zm-.876-16.408l3.959 7.465 3.525-7.482c.169-.412.26-.872.26-1.345l-.001-.045c-.004-2.213-1.801-4.007-4.005-4.007-2.209 0-4.006 1.797-4.006 4.006 0 .515.091.975.268 1.408zm-4.829 26.446l3.8-8.284c-4.737 1.725-8.568 3.237-8.657 3.272-1.542.516-2.56 1.912-2.56 3.483 0 2.023 1.677 3.669 3.737 3.669l.282 0c1.457 0 2.791-.84 3.398-2.14z"],"file-spreadsheet_12":["M10.759 3.417c.156.157.241.363.241.583l0 6.5c0 .827-.673 1.5-1.5 1.5l-7 0c-.827 0-1.5-.673-1.5-1.5l0-9C1 .673 1.673 0 2.5 0L6 0l1 0c.219 0 .426.085.582.24l3.177 3.177zM10 10.5l0-6.428L6.928 1 6 1 2.5 1c-.275 0-.5.225-.5.5l0 9c0 .275.225.5.5.5l7 0c.275 0 .5-.225.5-.5zM5 6c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L4 7c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0zm1.5.5c0-.275.225-.5.5-.5l1 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L7 7c-.275 0-.5-.225-.5-.5zM5 8c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L4 9c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0zm3 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L7 9c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0z"],"file-spreadsheet_16":["M13.707 4.2072c.188.188.293.441.293.707l0 9.086c0 1.104-.895 2-2 2l-8 0c-1.105 0-2-.896-2-2l0-12c0-1.105.895-2 2-2l5.086 0c.265 0 .519.104.707.293l3.914 3.914zM13 14.0002l0-9.086-3.914-3.914-5.086 0c-.551 0-1 .448-1 1l0 12c0 .551.449 1 1 1l8 0c.551 0 1-.449 1-1zm-7-7c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-.5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l.5 0zm2.25 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-.5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l.5 0zm1.75 1c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l.5 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-.5 0zm-4 1.5c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-.5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l.5 0zm2.25 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-.5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l.5 0zm1.75 1c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l.5 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-.5 0zm-4 1.5c.275 0 .5.225.5.5 0 .274-.225.5-.5.5l-.5 0c-.275 0-.5-.226-.5-.5 0-.275.225-.5.5-.5l.5 0zm2.25 0c.275 0 .5.225.5.5 0 .274-.225.5-.5.5l-.5 0c-.275 0-.5-.226-.5-.5 0-.275.225-.5.5-.5l.5 0zm1.75 1c-.275 0-.5-.226-.5-.5 0-.275.225-.5.5-.5l.5 0c.275 0 .5.225.5.5 0 .274-.225.5-.5.5l-.5 0z"],"file-spreadsheet_24":["M20.658 6.342c.22.22.342.512.342.824L21 21.5c0 1.379-1.122 2.5-2.5 2.5l-13 0C4.122 24 3 22.879 3 21.5l0-19C3 1.121 4.122 0 5.5 0l8.333 0c.312 0 .605.121.825.342l6 6zM20 21.5L20 7l-6-6-8.5 0C4.673 1 4 1.673 4 2.5l0 19c0 .827.673 1.5 1.5 1.5l13 0c.827 0 1.5-.673 1.5-1.5zM8.5 19c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0zm7 1c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0zm-3-1c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0zm-4-4c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0zm7 1c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0zm-3-1c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0zm-4-4c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0zm7 1c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0zm-3-1c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0z"],"file-spreadsheet_28":["M24.414 7.414c.375.375.586.884.586 1.414L25 25c0 1.657-1.343 3-3 3L6 28c-1.657 0-3-1.343-3-3L3 3c0-1.657 1.343-3 3-3l10.172 0c.53 0 1.039.211 1.414.586l6.828 6.828zM24 25l0-16.172c0-.263-.107-.52-.293-.707l-6.828-6.828c-.187-.187-.444-.293-.707-.293L6 1c-1.103 0-2 .897-2 2l0 22c0 1.103.897 2 2 2l16 0c1.103 0 2-.897 2-2zM9.5 12.0107c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0zm5 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0zm5 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0zm-10 5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0zm5 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0zm5 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0zm-10 5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0zm5 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0zm5 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0z"],"file-spreadsheet_32":["M6.9996 1c-1.1045695 0-2 .8954305-2 2l0 26c0 1.1045695.8954305 2 2 2l18 0c1.1045695 0 2-.8954305 2-2l0-18.7573593c0-.53043299-.2107137-1.03914082-.5857864-1.41421358l-7.2426407-7.24264068C18.7961001 1.21071368 18.2873923 1 17.7569593 1L6.9996 1zm0-1l10.7573593 0c.7956495 0 1.5587112.316070521 2.1213204.878679656l7.2426406 7.242640684c.5626092.56260914.8786797 1.32567088.8786797 2.12132036L27.9996 29c0 1.6568542-1.3431458 3-3 3l-18 0c-1.65685425 0-3-1.3431458-3-3l0-26c0-1.65685425 1.34314575-3 3-3zM10.5 26l-1 0c-.276 0-.5.224-.5.5 0 .276.224.5.5.5l1 0c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5zm0-6l-1 0c-.276 0-.5.224-.5.5 0 .276.224.5.5.5l1 0c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5zm0-6l-1 0c-.276 0-.5.224-.5.5 0 .276.224.5.5.5l1 0c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5zm11 13l1 0c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5l-1 0c-.276 0-.5.224-.5.5 0 .276.224.5.5.5zm0-6l1 0c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5l-1 0c-.276 0-.5.224-.5.5 0 .276.224.5.5.5zm0-6l1 0c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5l-1 0c-.276 0-.5.224-.5.5 0 .276.224.5.5.5zm-5 11l-1 0c-.276 0-.5.224-.5.5 0 .276.224.5.5.5l1 0c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5zm0-6l-1 0c-.276 0-.5.224-.5.5 0 .276.224.5.5.5l1 0c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5zm0-6l-1 0c-.276 0-.5.224-.5.5 0 .276.224.5.5.5l1 0c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5z"],"file-spreadsheet_36":["M30.121 9.631c.563.562.879 1.326.879 2.121L31 31.5c0 1.933-1.567 3.5-3.5 3.5l-19 0C6.567 35 5 33.433 5 31.5l0-27C5 2.567 6.567 1 8.5 1l11.748 0c.795 0 1.559.316 2.121.879l7.752 7.752zM30 31.5l0-19.748c0-.534-.208-1.036-.586-1.414l-7.752-7.752c-.378-.378-.88-.586-1.414-.586L8.5 2C7.121 2 6 3.122 6 4.5l0 27C6 32.879 7.121 34 8.5 34l19 0c1.379 0 2.5-1.121 2.5-2.5zM12.5 27c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0zm12 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0zm-6 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0zm-6-6c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0zm12 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0zm-6 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0zm-6-6c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0zm12 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0zm-6 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0z"],"file-spreadsheet_40":["M34.526 10.472c.305.304.472.709.472 1.14l0 24.555c0 2.114-1.72 3.833-3.833 3.833L8.833 40C6.72 40 5 38.281 5 36.167L5 3.834C5 1.72 6.72 0 8.833 0l14.554 0c.429 0 .834.168 1.138.472l10.001 10zM34 36.167l0-24.555c0-.164-.063-.317-.179-.433l-10.002-10C23.704 1.064 23.55 1 23.387 1L8.833 1C7.271 1 5.998 2.271 5.998 3.834l0 32.333C5.998 37.729 7.271 39 8.833 39l22.333 0C32.729 39 34 37.729 34 36.167zM12.5 19l1 0c.27614237 0 .5.2238576.5.5 0 .2761424-.22385763.5-.5.5l-1 0c-.27614237 0-.5-.2238576-.5-.5 0-.2761424.22385763-.5.5-.5zm14 0l1 0c.2761424 0 .5.2238576.5.5 0 .2761424-.2238576.5-.5.5l-1 0c-.2761424 0-.5-.2238576-.5-.5 0-.2761424.2238576-.5.5-.5zm-14 6l1 0c.27614237 0 .5.2238576.5.5 0 .2761424-.22385763.5-.5.5l-1 0c-.27614237 0-.5-.2238576-.5-.5 0-.2761424.22385763-.5.5-.5zm14 0l1 0c.2761424 0 .5.2238576.5.5 0 .2761424-.2238576.5-.5.5l-1 0c-.2761424 0-.5-.2238576-.5-.5 0-.2761424.2238576-.5.5-.5zm-7 0l1 0c.2761424 0 .5.2238576.5.5 0 .2761424-.2238576.5-.5.5l-1 0c-.2761424 0-.5-.2238576-.5-.5 0-.2761424.2238576-.5.5-.5zm0-6l1 0c.2761424 0 .5.2238576.5.5 0 .2761424-.2238576.5-.5.5l-1 0c-.2761424 0-.5-.2238576-.5-.5 0-.2761424.2238576-.5.5-.5zm0 12l1 0c.2761424 0 .5.2238576.5.5 0 .2761424-.2238576.5-.5.5l-1 0c-.2761424 0-.5-.2238576-.5-.5 0-.2761424.2238576-.5.5-.5zm-7 0l1 0c.27614237 0 .5.2238576.5.5 0 .2761424-.22385763.5-.5.5l-1 0c-.27614237 0-.5-.2238576-.5-.5 0-.2761424.22385763-.5.5-.5zm14 0l1 0c.2761424 0 .5.2238576.5.5 0 .2761424-.2238576.5-.5.5l-1 0c-.2761424 0-.5-.2238576-.5-.5 0-.2761424.2238576-.5.5-.5z"],"file-spreadsheet_44":["M38.481 11.898c.33.33.519.786.519 1.25L39 40c0 2.206-1.794 4-4 4L9 44c-2.206 0-4-1.794-4-4L5 4c0-2.206 1.794-4 4-4l16.809 0c.472 0 .916.184 1.249.517l11.423 11.381zM38 40l0-26.852c0-.201-.082-.399-.225-.543L26.352 1.225c-.143-.143-.341-.225-.543-.225L9 1C7.346 1 6 2.346 6 4l0 36c0 1.654 1.346 3 3 3l26 0c1.654 0 3-1.346 3-3zM16.5 20l-3 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l3 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5zm14 0l-3 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l3 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5zm-7 0l-3 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l3 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5zm-7 8l-3 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l3 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5zm14 0l-3 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l3 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5zm-7 0l-3 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l3 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5zm-7 8l-3 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l3 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5zm14 0l-3 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l3 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5zm-7 0l-3 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l3 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5z"],"file-spreadsheet_72":["M62.257 20.006c.479.477.743 1.112.743 1.788L63 64.5c0 3.584-2.916 6.5-6.5 6.5l-41 0C11.916 71 9 68.084 9 64.5l0-57C9 3.916 11.916 1 15.5 1l26.617 0c.676 0 1.313.263 1.792.74l18.348 18.266zM62 64.5l0-42.706c0-.408-.159-.791-.448-1.079L43.204 2.449c-.291-.29-.677-.449-1.087-.449L15.5 2C12.467 2 10 4.467 10 7.5l0 57c0 3.033 2.467 5.5 5.5 5.5l41 0c3.033 0 5.5-2.467 5.5-5.5zM27.5 33l-5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l5 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5zm22 0l-5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l5 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5zm-11 0l-5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l5 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5zm-11 12l-5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l5 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5zm22 0l-5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l5 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5zm-11 0l-5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l5 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5zm-11 12l-5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l5 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5zm22 0l-5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l5 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5zm-11 0l-5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l5 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5z"],"file-text_12":["M10.759 3.417c.156.157.241.363.241.583l0 6.5c0 .827-.673 1.5-1.5 1.5l-7 0c-.827 0-1.5-.673-1.5-1.5l0-9C1 .673 1.673 0 2.5 0L6 0l1 0c.219 0 .426.085.582.24l3.177 3.177zM10 10.5l0-6.428L6.928 1 6 1 2.5 1c-.275 0-.5.225-.5.5l0 9c0 .275.225.5.5.5l7 0c.275 0 .5-.225.5-.5zm-6-4c0-.275.225-.5.5-.5l3 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-3 0c-.275 0-.5-.225-.5-.5zM5.5 8c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0z"],"file-text_16":["M13.707 4.207c.188.188.293.441.293.707L14 14c0 1.105-.895 2-2 2l-8 0c-1.105 0-2-.895-2-2L2 2c0-1.105.895-2 2-2l5.086 0c.265 0 .519.105.707.293l3.914 3.914zM13 14l0-9.086L9.086 1 4 1c-.551 0-1 .448-1 1l0 12c0 .552.449 1 1 1l8 0c.551 0 1-.448 1-1zM5 7.5c0-.275.225-.5.5-.5l5 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-5 0c-.275 0-.5-.225-.5-.5zm5.5 2c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l5 0zm-3 2.5c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-2 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l2 0z"],"file-text_20":["M17.672 5.359c.211.215.328.499.328.8L18 17.5c0 1.379-1.122 2.5-2.5 2.5l-11 0C3.122 20 2 18.879 2 17.5l0-15C2 1.121 3.122 0 4.5 0l7.414 0c.297 0 .589.121.799.333l4.958 5.025.001.001zM17 17.5l0-11.341c0-.038-.014-.071-.042-.099l-4.957-5.025c-.02-.02-.056-.035-.087-.035L4.5 1C3.673 1 3 1.673 3 2.5l0 15c0 .827.673 1.5 1.5 1.5l11 0c.827 0 1.5-.673 1.5-1.5zM13.5 9c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-7 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l7 0zm0 3c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-7 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l7 0zm-4 3c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-3 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l3 0z"],"file-text_24":["M20.658 6.342c.22.22.342.512.342.824L21 21.5c0 1.379-1.122 2.5-2.5 2.5l-13 0C4.122 24 3 22.879 3 21.5l0-19C3 1.121 4.122 0 5.5 0l8.333 0c.312 0 .605.121.825.342l6 6zM20 21.5L20 7l-6-6-8.5 0C4.673 1 4 1.673 4 2.5l0 19c0 .827.673 1.5 1.5 1.5l13 0c.827 0 1.5-.673 1.5-1.5zM7.5 11l9 0c.2761424 0 .5.2238576.5.5 0 .2761424-.2238576.5-.5.5l-9 0c-.27614237 0-.5-.2238576-.5-.5 0-.2761424.22385763-.5.5-.5zm0 4l9 0c.2761424 0 .5.2238576.5.5 0 .2761424-.2238576.5-.5.5l-9 0c-.27614237 0-.5-.2238576-.5-.5 0-.2761424.22385763-.5.5-.5zm0 4l5 0c.27614237 0 .5.2238576.5.5 0 .2761424-.22385763.5-.5.5l-5 0c-.27614237 0-.5-.2238576-.5-.5 0-.2761424.22385763-.5.5-.5z"],"file-text_28":["M24.414 7.414c.375.375.586.884.586 1.414L25 25c0 1.657-1.343 3-3 3L6 28c-1.657 0-3-1.343-3-3L3 3c0-1.657 1.343-3 3-3l10.172 0c.53 0 1.039.211 1.414.586l6.828 6.828zM24 25l0-16.172c0-.263-.107-.52-.293-.707l-6.828-6.828c-.187-.187-.444-.293-.707-.293L6 1c-1.103 0-2 .897-2 2l0 22c0 1.103.897 2 2 2l16 0c1.103 0 2-.897 2-2zm-4.5-12.9893c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-11 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l11 0zm0 5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-11 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l11 0zm-6 5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-5 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l5 0z"],"file-text_32":["M15.5 26c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-6 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l6 0zm7-6c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-13 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l13 0zM9 14.5c0-.276.224-.5.5-.5l13 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-13 0c-.276 0-.5-.224-.5-.5zM6.9996 1c-1.1045695 0-2 .8954305-2 2l0 26c0 1.1045695.8954305 2 2 2l18 0c1.1045695 0 2-.8954305 2-2l0-18.7573593c0-.53043299-.2107137-1.03914082-.5857864-1.41421358l-7.2426407-7.24264068C18.7961001 1.21071368 18.2873923 1 17.7569593 1L6.9996 1zm0-1l10.7573593 0c.7956495 0 1.5587112.316070521 2.1213204.878679656l7.2426406 7.242640684c.5626092.56260914.8786797 1.32567088.8786797 2.12132036L27.9996 29c0 1.6568542-1.3431458 3-3 3l-18 0c-1.65685425 0-3-1.3431458-3-3l0-26c0-1.65685425 1.34314575-3 3-3z"],"file-text_36":["M30.121 9.631c.563.562.879 1.326.879 2.121L31 31.5c0 1.933-1.567 3.5-3.5 3.5l-19 0C6.567 35 5 33.433 5 31.5l0-27C5 2.567 6.567 1 8.5 1l11.748 0c.795 0 1.559.316 2.121.879l7.752 7.752zM30 31.5l0-19.748c0-.534-.208-1.036-.586-1.414l-7.752-7.752c-.378-.378-.88-.586-1.414-.586L8.5 2C7.121 2 6 3.122 6 4.5l0 27C6 32.879 7.121 34 8.5 34l19 0c1.379 0 2.5-1.121 2.5-2.5zM17.5 27c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-6 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l6 0zm7-6c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-13 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l13 0zm0-6c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-13 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l13 0z"],"file-text_40":["M34.526 10.472c.305.304.472.709.472 1.14l0 24.555c0 2.114-1.72 3.833-3.833 3.833L8.833 40C6.72 40 5 38.281 5 36.167L5 3.834C5 1.72 6.72 0 8.833 0l14.554 0c.429 0 .834.168 1.138.472l10.001 10zM34 36.167l0-24.555c0-.164-.063-.317-.179-.433l-10.002-10C23.704 1.064 23.55 1 23.387 1L8.833 1C7.271 1 5.998 2.271 5.998 3.834l0 32.333C5.998 37.729 7.271 39 8.833 39l22.333 0C32.729 39 34 37.729 34 36.167zM12.5 19l15 0c.2761424 0 .5.2238576.5.5 0 .2761424-.2238576.5-.5.5l-15 0c-.27614237 0-.5-.2238576-.5-.5 0-.2761424.22385763-.5.5-.5zm0 6l15 0c.2761424 0 .5.2238576.5.5 0 .2761424-.2238576.5-.5.5l-15 0c-.27614237 0-.5-.2238576-.5-.5 0-.2761424.22385763-.5.5-.5zm0 6l8 0c.2761424 0 .5.2238576.5.5 0 .2761424-.2238576.5-.5.5l-8 0c-.27614237 0-.5-.2238576-.5-.5 0-.2761424.22385763-.5.5-.5z"],"file-text_44":["M38.481 11.898c.33.33.519.786.519 1.25L39 40c0 2.206-1.794 4-4 4L9 44c-2.206 0-4-1.794-4-4L5 4c0-2.206 1.794-4 4-4l16.809 0c.472 0 .916.184 1.249.517l11.423 11.381zM38 40l0-26.852c0-.201-.082-.399-.225-.543L26.352 1.225c-.143-.143-.341-.225-.543-.225L9 1C7.346 1 6 2.346 6 4l0 36c0 1.654 1.346 3 3 3l26 0c1.654 0 3-1.346 3-3zm-7.5-20l-17 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l17 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5zm-9 16l-8 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l8 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5zm9-8l-17 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l17 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5z"],"file-text_72":["M62.257 20.006c.479.477.743 1.112.743 1.788L63 64.5c0 3.584-2.916 6.5-6.5 6.5l-41 0C11.916 71 9 68.084 9 64.5l0-57C9 3.916 11.916 1 15.5 1l26.617 0c.676 0 1.313.263 1.792.74l18.348 18.266zM62 64.5l0-42.706c0-.408-.159-.791-.448-1.079L43.204 2.449c-.291-.29-.677-.449-1.087-.449L15.5 2C12.467 2 10 4.467 10 7.5l0 57c0 3.033 2.467 5.5 5.5 5.5l41 0c3.033 0 5.5-2.467 5.5-5.5zM49.5 33l-27 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l27 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5zm0 12l-27 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l27 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5zm-14 11c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-13 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l13 0z"],"file-video_12":["M10.759 3.417c.156.157.241.363.241.583l0 6.5c0 .827-.673 1.5-1.5 1.5l-7 0c-.827 0-1.5-.673-1.5-1.5l0-9C1 .673 1.673 0 2.5 0L6 0l1 0c.219 0 .426.085.582.24l3.177 3.177zM10 10.5l0-6.428L6.928 1 6 1 2.5 1c-.275 0-.5.225-.5.5l0 9c0 .275.225.5.5.5l7 0c.275 0 .5-.225.5-.5zM4.39 5.1303c.256-.16.574-.172.84-.04l2.314 1.181c.279.138.456.418.456.729 0 .31-.177.591-.462.731l-2.302 1.176c-.126.062-.259.093-.392.093-.158 0-.315-.043-.454-.13-.244-.152-.39-.41-.39-.692l0-2.357c0-.281.146-.54.39-.691zM5 7.9053l1.771-.905L5 6.0943l0 1.811z"],"file-video_16":["M13.707 4.207c.188.188.293.442.293.707L14 14c0 1.105-.895 2-2 2l-8 0c-1.105 0-2-.895-2-2L2 2c0-1.105.895-2 2-2l5.086 0c.265 0 .519.105.707.293l3.914 3.914zM13 14l0-9.086L9.086 1 4 1c-.551 0-1 .448-1 1l0 12c0 .552.449 1 1 1l8 0c.551 0 1-.448 1-1zM6.077 6.9958c.168 0 .336.038.492.117l3.853 1.966c.355.177.578.53.578.919 0 .39-.224.742-.583.92l-3.841 1.961c-.161.079-.332.119-.502.119-.202 0-.403-.056-.582-.167-.308-.191-.492-.516-.492-.87l0-3.928c0-.352.184-.677.491-.869.18-.111.383-.168.586-.168zM6 12.0498l3.967-2.025L6 7.9428l0 4.107z"],"file-video_24":["M13.833 0L5.5 0C4.121 0 3 1.121 3 2.5l0 19C3 22.879 4.121 24 5.5 24l13 0c1.379 0 2.5-1.121 2.5-2.5l0-14.334c0-.312-.121-.604-.342-.824l-6-6C14.441.125 14.141 0 13.833 0m0 1c.042 0 .088.019.118.049l6 6c.033.033.049.07.049.117L20 21.5c0 .827-.673 1.5-1.5 1.5l-13 0c-.827 0-1.5-.673-1.5-1.5l0-19C4 1.673 4.673 1 5.5 1l8.333 0zM9.3057 11.9995c.053 0 .104.012.152.035l5.391 2.752c.129.064.148.161.148.213 0 .053-.019.15-.154.217l-5.379 2.746c-.111.055-.241.049-.345-.015-.045-.029-.122-.092-.122-.198l0-5.499c0-.106.077-.169.122-.198.058-.035.123-.053.187-.053zm-.004 7.001c.207 0 .416-.048.611-.145l5.379-2.746c.436-.215.705-.641.705-1.11 0-.468-.269-.894-.699-1.106l-5.39-2.752c-.422-.211-.915-.187-1.316.062-.372.231-.595.622-.595 1.047l0 5.499c0 .425.223.816.595 1.047.218.136.463.204.71.204z"],"file-video_28":["M24.414 7.4136c.375.375.586.885.586 1.414l0 16.172c0 1.657-1.343 3-3 3l-16 0c-1.657 0-3-1.343-3-3l0-22c0-1.656 1.343-3 3-3l10.172 0c.53 0 1.039.212 1.414.587l6.828 6.827zM24 24.9996l0-16.172c0-.263-.107-.52-.293-.707l-6.828-6.827c-.187-.187-.444-.294-.707-.294L6 .9996c-1.103 0-2 .897-2 2l0 22c0 1.104.897 2 2 2l16 0c1.103 0 2-.896 2-2zm-5.8223-9.1268c.505.25.822.748.822 1.296 0 .548-.317 1.046-.827 1.299l-6.918 3.532c-.23.113-.476.17-.719.17-.292 0-.582-.081-.839-.242-.436-.27-.697-.728-.697-1.224l0-7.07c0-.497.261-.955.697-1.225.471-.294 1.052-.321 1.552-.074l6.929 3.538zm-.455 1.701c.178-.088.277-.235.277-.405 0-.17-.099-.318-.272-.403l-6.928-3.538c-.082-.04-.171-.06-.261-.06-.108 0-.218.03-.315.09-.084.052-.224.17-.224.376l0 7.07c0 .206.14.323.224.376.176.109.394.119.582.026l6.917-3.532z"],"file-video_32":["M6.9996 0l10.7573593 0c.7956495 0 1.5587112.316070521 2.1213204.878679656l7.2426406 7.242640684c.5626092.56260914.8786797 1.32567088.8786797 2.12132036L27.9996 29c0 1.6568542-1.3431458 3-3 3l-18 0c-1.65685425 0-3-1.3431458-3-3l0-26c0-1.65685425 1.34314575-3 3-3zm0 1c-1.1045695 0-2 .8954305-2 2l0 26c0 1.1045695.8954305 2 2 2l18 0c1.1045695 0 2-.8954305 2-2l0-18.7573593c0-.53043299-.2107137-1.03914082-.5857864-1.41421358l-7.2426407-7.24264068C18.7961001 1.21071368 18.2873923 1 17.7569593 1L6.9996 1zm4.6964 14.24c.472-.294 1.053-.321 1.553-.073l6.929 3.537c.505.25.822.748.822 1.296 0 .548-.317 1.046-.828 1.299l-6.917 3.532c-.231.113-.476.17-.72.17-.292 0-.582-.081-.84-.241-.435-.271-.695-.729-.695-1.225l0-7.07c0-.496.261-.954.696-1.225zM20 20c0-.17-.099-.317-.271-.402L12.8 16.06c-.082-.04-.171-.061-.261-.061-.109 0-.219.03-.315.09-.083.053-.224.17-.224.376l0 7.07c0 .206.14.323.224.376.176.11.396.118.582.027l6.917-3.533c.178-.088.277-.235.277-.405z"],"file-video_36":["M30.121 9.631c.563.562.879 1.326.879 2.121L31 31.5c0 1.933-1.567 3.5-3.5 3.5l-19 0C6.567 35 5 33.433 5 31.5l0-27C5 2.567 6.567 1 8.5 1l11.748 0c.795 0 1.559.316 2.121.879l7.752 7.752zM30 31.5l0-19.748c0-.534-.208-1.036-.586-1.414l-7.752-7.752c-.378-.378-.88-.586-1.414-.586L8.5 2C7.121 2 6 3.122 6 4.5l0 27C6 32.879 7.121 34 8.5 34l19 0c1.379 0 2.5-1.121 2.5-2.5zm-6.9444-10.9853c.58.288.944.858.944 1.485 0 .627-.364 1.198-.949 1.489l-8.457 4.316c-.264.131-.548.196-.829.196-.336 0-.669-.093-.966-.277-.5-.311-.799-.835-.799-1.403l0-8.641c0-.568.299-1.093.799-1.403.544-.339 1.214-.369 1.789-.085l8.468 4.323zm-.455 2.08c.252-.125.399-.347.399-.595 0-.248-.147-.469-.394-.592l-8.467-4.322c-.116-.058-.243-.087-.369-.087-.153 0-.308.043-.443.127-.207.129-.327.331-.327.554l0 8.641c0 .223.12.425.327.553.248.155.555.167.818.037l8.456-4.316z"],"file-video_40":["M34.527 10.475c.305.304.473.709.473 1.14l0 24.551C35 38.28 33.28 40 31.166 40L8.834 40C6.72 40 5 38.28 5 36.166L5 3.835C5 1.721 6.72 0 8.834 0l14.554 0c.429 0 .834.168 1.138.472l10.001 10.003zm-.525 25.691l0-24.551c0-.164-.063-.317-.18-.433L23.82 1.18c-.115-.116-.269-.189-.432-.189l-14.554 0c-1.562 0-2.835 1.281-2.835 2.844l0 32.331c0 1.563 1.273 2.835 2.835 2.835l22.334 0c1.563 0 2.834-1.272 2.834-2.835zm-8.0551-13.4262c.648.345 1.053 1.021 1.053 1.761 0 .74-.405 1.416-1.058 1.764l-9.996 5.495c-.301.161-.626.24-.949.24-.355 0-.709-.095-1.026-.286-.608-.365-.971-1.006-.971-1.715l0-10.997c0-.709.363-1.349.971-1.714.607-.365 1.344-.383 1.97-.05l10.006 5.502zm-.482 2.646c.337-.18.535-.51.535-.885 0-.376-.198-.706-.529-.882l-10.007-5.502c-.145-.077-.304-.116-.464-.116-.177 0-.354.049-.514.144-.304.183-.486.503-.486.857l0 10.997c0 .354.182.675.486.857.303.182.671.192.984.025l9.995-5.495z"],"file-video_44":["M38.48 11.898c.331.33.52.785.52 1.25L39 40c0 2.206-1.794 4-4 4L9 44c-2.206 0-4-1.794-4-4L5 4c0-2.206 1.794-4 4-4l16.809 0c.471 0 .915.184 1.249.516L38.48 11.898zM38 40l0-26.852c0-.204-.08-.396-.225-.541L26.353 1.225C26.207 1.08 26.014 1 25.809 1L9 1C7.346 1 6 2.346 6 4l0 36c0 1.654 1.346 3 3 3l26 0c1.654 0 3-1.346 3-3zm-9.1886-14.8633c.732.362 1.189 1.077 1.189 1.863 0 .786-.457 1.501-1.195 1.867l-11.533 5.887c-.334.166-.691.248-1.047.248-.425 0-.847-.118-1.222-.35-.628-.391-1.003-1.048-1.003-1.76l0-11.783c0-.712.375-1.369 1.003-1.76.689-.428 1.536-.466 2.264-.105l11.544 5.893zm-.455 2.836c.405-.201.644-.563.644-.973 0-.409-.239-.771-.638-.969l-11.545-5.894c-.186-.093-.387-.139-.588-.139-.242 0-.484.068-.699.201-.337.21-.53.541-.53.91l0 11.783c0 .369.193.7.53.91.392.243.875.265 1.292.059l11.534-5.888z"],"file-video_72":["M62.258 20.006c.478.478.742 1.113.742 1.788L63 64.5c0 3.584-2.916 6.5-6.5 6.5l-41 0C11.916 71 9 68.084 9 64.5l0-57C9 3.916 11.916 1 15.5 1l26.617 0c.677 0 1.314.263 1.792.74l18.348 18.266c0 0 0 0 .001 0zM62 64.5l0-42.706c0-.401-.163-.795-.448-1.079L43.204 2.449c-.291-.29-.677-.449-1.087-.449L15.5 2C12.468 2 10 4.467 10 7.5l0 57c0 3.033 2.468 5.5 5.5 5.5l41 0c3.032 0 5.5-2.467 5.5-5.5zM47.2001 41.1915c1.125.558 1.8 1.608 1.8 2.809 0 1.2-.675 2.25-1.806 2.811l-19.225 9.815c-.508.251-1.051.376-1.591.376-.648 0-1.291-.18-1.862-.535-.95-.589-1.516-1.579-1.516-2.649l0-19.637c0-1.07.566-2.06 1.516-2.649 1.048-.651 2.336-.711 3.447-.162l19.237 9.821zm-.455 4.726c.788-.39 1.255-1.106 1.255-1.917 0-.812-.467-1.528-1.249-1.915l-19.237-9.821c-.36-.178-.747-.267-1.132-.267-.465 0-.928.129-1.339.384-.663.411-1.043 1.068-1.043 1.8l0 19.637c0 .732.38 1.389 1.043 1.8.752.467 1.677.51 2.476.114l19.226-9.815z"],"file-zip_12":["M10.759 3.417c.156.157.241.363.241.583l0 6.5c0 .827-.673 1.5-1.5 1.5l-7 0c-.827 0-1.5-.673-1.5-1.5l0-9C1 .673 1.673 0 2.5 0L6 0l1 0c.219 0 .426.085.582.24l3.177 3.177zM10 10.5l0-6.428L6.928 1 6 1 4 1l0 1.5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5L3 1l-.5 0c-.275 0-.5.225-.5.5l0 9c0 .275.225.5.5.5l7 0c.275 0 .5-.225.5-.5zM3.5 4c.275 0 .5.225.5.5l0 1c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-1c0-.275.225-.5.5-.5zm0 3c.275 0 .5.225.5.5l0 1c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-1c0-.275.225-.5.5-.5z"],"file-zip_16":["M13.707 4.207c.188.188.293.441.293.707L14 5l0 1 0 8c0 1.105-.895 2-2 2l-8 0c-1.105 0-2-.895-2-2L2 2c0-1.105.895-2 2-2l4 0 1 0 .086 0c.266 0 .519.105.707.293l3.914 3.914zM13 5l0-.086L9.086 1 9 1 8 1 6 1l0 1.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5L5 1 4 1c-.552 0-1 .448-1 1l0 12c0 .552.448 1 1 1l8 0c.552 0 1-.448 1-1l0-8 0-1zM5.5 4c.276 0 .5.224.5.5l0 1c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-1c0-.276.224-.5.5-.5zm0 3c.276 0 .5.224.5.5l0 1c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-1c0-.276.224-.5.5-.5zm0 3c.276 0 .5.224.5.5l0 1c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-1c0-.276.224-.5.5-.5z"],"file-zip_24":["M20.658 6.342c.22.22.342.512.342.824L21 21.5c0 1.379-1.122 2.5-2.5 2.5l-13 0C4.122 24 3 22.879 3 21.5l0-19C3 1.121 4.122 0 5.5 0l8.333 0c.312 0 .605.121.825.342l6 6zM20 21.5L20 7l-6-6-6 0 0 1.498c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5L7 1 5.5 1C4.673 1 4 1.673 4 2.5l0 19c0 .827.673 1.5 1.5 1.5l13 0c.827 0 1.5-.673 1.5-1.5zM7.5002 5c.276 0 .5.224.5.5l0 1.998c0 .276-.224.5-.5.5-.277 0-.501-.224-.501-.5l0-1.998c0-.276.224-.5.501-.5zm0 5.0022c.276 0 .5.224.5.5l0 1.998c0 .276-.224.5-.5.5-.277 0-.501-.224-.501-.5l0-1.998c0-.276.224-.5.501-.5zM7.5 15.0032c.276 0 .5.224.5.5l0 1.997c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-1.997c0-.276.224-.5.5-.5z"],"file-zip_28":["M24.414 7.414c.375.375.586.884.586 1.414L25 25c0 1.657-1.343 3-3 3L6 28c-1.657 0-3-1.343-3-3L3 3c0-1.657 1.343-3 3-3l10.172 0c.53 0 1.039.211 1.414.586l6.828 6.828zM24 25l0-16.172c0-.263-.107-.52-.293-.707l-6.828-6.828c-.187-.187-.444-.293-.707-.293L8 1l0 3.5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5L7 1 6 1c-1.103 0-2 .897-2 2l0 22c0 1.103.897 2 2 2l16 0c1.103 0 2-.897 2-2zM7.5 7c.275 0 .5.225.5.5l0 3c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-3c0-.275.225-.5.5-.5zm0 6c.275 0 .5.225.5.5l0 3c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-3c0-.275.225-.5.5-.5zm0 6c.275 0 .5.225.5.5l0 3c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-3c0-.275.225-.5.5-.5z"],"file-zip_32":["M6.9996 0l10.7573593 0c.7956495 0 1.5587112.316070521 2.1213204.878679656l7.2426406 7.242640684c.5626092.56260914.8786797 1.32567088.8786797 2.12132036L27.9996 29c0 1.6568542-1.3431458 3-3 3l-18 0c-1.65685425 0-3-1.3431458-3-3l0-26c0-1.65685425 1.34314575-3 3-3zm0 1c-1.1045695 0-2 .8954305-2 2l0 26c0 1.1045695.8954305 2 2 2l18 0c1.1045695 0 2-.8954305 2-2l0-18.7573593c0-.53043299-.2107137-1.03914082-.5857864-1.41421358l-7.2426407-7.24264068C18.7961001 1.21071368 18.2873923 1 17.7569593 1L6.9996 1zM9.5 8c.276 0 .5.224.5.5l0 4c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-4c0-.276.224-.5.5-.5zm0 8c.276 0 .5.224.5.5l0 4c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-4c0-.276.224-.5.5-.5zm0 8c.276 0 .5.224.5.5l0 4c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-4c0-.276.224-.5.5-.5zM9 1l1 0 0 3.5c0 .27614237-.22385763.5-.5.5-.27614237 0-.5-.22385763-.5-.5L9 1z"],"file-zip_36":["M30.121 9.631c.563.562.879 1.326.879 2.121L31 31.5c0 1.933-1.567 3.5-3.5 3.5l-19 0C6.567 35 5 33.433 5 31.5l0-27C5 2.567 6.567 1 8.5 1l11.748 0c.795 0 1.559.316 2.121.879l7.752 7.752zM30 31.5l0-19.748c0-.534-.208-1.036-.586-1.414l-7.752-7.752c-.378-.378-.88-.586-1.414-.586L11 2l0 4.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5L10 2 8.5 2C7.121 2 6 3.122 6 4.5l0 27C6 32.879 7.121 34 8.5 34l19 0c1.379 0 2.5-1.121 2.5-2.5zM10.5 10c.276 0 .5.224.5.5l0 4c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-4c0-.276.224-.5.5-.5zm0 8c.276 0 .5.224.5.5l0 4c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-4c0-.276.224-.5.5-.5zm0 8c.276 0 .5.224.5.5l0 4c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-4c0-.276.224-.5.5-.5z"],"file-zip_40":["M34.526 10.49c.305.304.472.709.472 1.14l0 24.545c0 2.114-1.72 3.833-3.833 3.833l-22.332 0C6.72 40.008 5 38.289 5 36.175L5 3.852C5 1.738 6.72.018 8.833.018l2.576 0c.03-.005.058-.018.091-.018.032 0 .06.013.09.018l11.797 0c.429 0 .834.168 1.138.471L34.526 10.49zM34 36.175l0-24.545c0-.164-.063-.317-.179-.433l-10.002-10c-.115-.115-.269-.188-.432-.188L12 1.009l0 5.493c0 .277-.224.5-.5.5-.277 0-.5-.223-.5-.5l0-5.493-2.167 0c-1.562 0-2.834 1.28-2.834 2.843l0 32.323c0 1.562 1.272 2.834 2.834 2.834l22.333 0c1.563 0 2.834-1.272 2.834-2.834zm-22.5004-9.168c.276 0 .5.224.5.5l0 6.002c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-6.002c0-.276.224-.5.5-.5zm0-9.0058c.276 0 .5.224.5.5l0 6.002c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-6.002c0-.276.224-.5.5-.5zm0-8.9951c.276 0 .5.224.5.5l0 6.001c0 .277-.224.5-.5.5-.276 0-.5-.223-.5-.5l0-6.001c0-.276.224-.5.5-.5z"],"file-zip_44":["M38.481 11.898c.33.33.519.786.519 1.25L39 40c0 2.206-1.794 4-4 4L9 44c-2.206 0-4-1.794-4-4L5 4c0-2.206 1.794-4 4-4l16.809 0c.472 0 .916.184 1.249.517l11.423 11.381zM38 40l0-26.852c0-.201-.082-.399-.225-.542L26.352 1.225c-.143-.143-.341-.225-.543-.225L13 1l0 5.5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5L12 1 9 1C7.346 1 6 2.346 6 4l0 36c0 1.654 1.346 3 3 3l26 0c1.654 0 3-1.346 3-3zM12.5 30c.275 0 .5.225.5.5l0 6c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-6c0-.275.225-.5.5-.5zm0-20c.275 0 .5.225.5.5l0 6c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-6c0-.275.225-.5.5-.5zm0 10c.275 0 .5.225.5.5l0 6c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-6c0-.275.225-.5.5-.5z"],"file-zip_72":["M62.257 20.006c.479.477.743 1.112.743 1.788L63 64.5c0 3.584-2.916 6.5-6.5 6.5l-41 0C11.916 71 9 68.084 9 64.5l0-57C9 3.916 11.916 1 15.5 1l26.617 0c.676 0 1.313.263 1.792.74l18.348 18.266zM62 64.5l0-42.706c0-.408-.159-.791-.448-1.079L43.204 2.449c-.291-.29-.677-.449-1.087-.449L21 2l0 9.5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5L20 2l-4.5 0C12.467 2 10 4.467 10 7.5l0 57c0 3.033 2.467 5.5 5.5 5.5l41 0c3.033 0 5.5-2.467 5.5-5.5zM20.5 16c.275 0 .5.225.5.5l0 10c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-10c0-.275.225-.5.5-.5zm0 16c.275 0 .5.225.5.5l0 10c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-10c0-.275.225-.5.5-.5zm0 16c.275 0 .5.225.5.5l0 10c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-10c0-.275.225-.5.5-.5z"],"files_10":["M8.66713329 8L1.33286671 8c-.1839816 0-.3329667-.149-.3329667-.333l0-3.668 8.00019998 0 0 3.668c0 .184-.1489851.333-.3329667.333M1.33286671 1l1.88381162 0c.0529947 0 .1039896.021.1409859.059l.59294071.593c.2279772.226.5289471.35.84791521.35l3.86861314 0c.1839816 0 .3329667.149.3329667.333l0 .664-8.00019998 0 0-1.666c0-.184.1489851-.333.3329667-.333m7.33426658.002l-3.86861314 0c-.0539946 0-.1049895-.021-.1419858-.058L4.06559344.352C3.84261574.128 3.53264674 0 3.21667833 0L1.33286671 0C.597940206 0 0 .598 0 1.333l0 6.334C0 8.402.597940206 9 1.33286671 9l7.33426658 0C9.40205979 9 10 8.402 10 7.667l0-5.332c0-.735-.59794021-1.333-1.33286671-1.333"],"files_12":["M10.5 2c.828 0 1.5.673 1.5 1.5l0 6c0 .828-.672 1.5-1.5 1.5l-9 0C.673 11 0 10.328 0 9.5l0-7C0 1.673.673 1 1.5 1l2.419 0c.4 0 .777.157 1.061.44l.415.414c.093.094.222.146.353.146L10.5 2zm.5 2.999l0-.001-10-.009L1 9.5c0 .276.225.5.5.5l9 0c.276 0 .5-.224.5-.5l0-4.501zM1 2.5l0 1.489.001 0L11 3.998l0-.498c0-.275-.224-.5-.5-.5L5.748 3c-.4 0-.777-.156-1.06-.439l-.415-.414C4.179 2.053 4.053 2 3.919 2L1.5 2c-.275 0-.5.225-.5.5z"],"files_14":["M12.333 12.001l-10.662 0c-.368 0-.667-.299-.667-.667l0-5.334L13 6l0 5.334c0 .368-.299.667-.667.667zM1.004 2.667c0-.368.299-.667.667-.667l3.112 0c.175 0 .347.071.462.186l.304.32c.003.004.006.007.009.01.315.315.734.488 1.179.488l5.596 0c.368 0 .667.299.667.666L13 5 1.004 5l0-2.333zm11.329-.663l-5.596 0c-.176 0-.342-.068-.468-.191l-.308-.325C5.651 1.178 5.221 1 4.783 1L1.671 1C.752 1 .005 1.748.005 2.667L.005 5 0 5l0 1 .005 0 0 5.334c0 .919.747 1.667 1.666 1.667l10.662 0c.919 0 1.667-.748 1.667-1.667l0-7.664c0-.919-.748-1.666-1.667-1.666z"],"files_16":["M15 6L1 6l0-3c0-.551.449-1 1-1l2.627 0c.132 0 .261.053.354.146l.415.415c.283.283.66.439 1.06.439L14 3c.551 0 1 .449 1 1l0 2zm0 7c0 .551-.449 1-1 1L2 14c-.551 0-1-.449-1-1l0-6 14 0 0 6zM14 2L6.456 2c-.133 0-.259-.052-.354-.146l-.414-.415C5.405 1.156 5.028 1 4.627 1L2 1C.897 1 0 1.897 0 3l0 10c0 1.103.897 2 2 2l12 0c1.103 0 2-.897 2-2l0-9c0-1.103-.897-2-2-2z"],"files_20":["M17.5 17.9971l-15 0c-.827 0-1.5-.673-1.5-1.5l0-8.5 18 0 0 8.5c0 .827-.673 1.5-1.5 1.5m-15-15.997l4.044 0c.4 0 .777.156 1.06.439l.825.824c.472.472 1.1.733 1.767.733l7.304 0c.827 0 1.5.672 1.5 1.5l0 1.501-18 0 0-3.497c0-.827.673-1.5 1.5-1.5m15 .99591109l-7.304 0c-.4 0-.777-.15700087-1.06-.44000244l-.824-.824004583C7.84 1.260001445 7.212 1 6.544 1L2.5 1C1.122 1 0 2.12200623 0 3.50001389L0 16.4970861C0 17.8750938 1.122 18.9971 2.5 18.9971l15 0c1.378 0 2.5-1.1220062 2.5-2.5000139l0-11.00106112c0-1.37900766-1.122-2.50001389-2.5-2.50001389"],"files_24":["M21.5008331 21L2.49916694 21c-.82672442 0-1.499500162-.673-1.499500162-1.5l0-9.499 22.000666422 0 0 9.499c0 .827-.6727757 1.5-1.4995001 1.5M2.49916694 3l5.34021993 0c.39486838 0 .78073975.16 1.06064645.44l.82772409.828C10.1996001 4.74 10.8273909 5 11.4951683 5l10.0056648 0c.8267244 0 1.4995001.673 1.4995001 1.501l0 2.5-22.000666422 0 0-4.501c0-.827.672775742-1.5 1.499500162-1.5M21.5008331 4L11.4951683 4c-.3948684 0-.7817394-.16-1.0606465-.439l-.82772407-.828C9.13395535 2.26 8.50616461 2 7.83938687 2L2.49916694 2C1.12162612 2 0 3.122 0 4.5l0 15C0 20.878 1.12162612 22 2.49916694 22l19.00166616 0C22.8783739 22 24 20.878 24 19.5l0-12.999C24 5.122 22.8783739 4 21.5008331 4"],"files_26":["M23.333 23L2.667 23C1.748 23 1 22.252 1 21.333l0-10.332 24 0 0 10.332c0 .919-.748 1.667-1.667 1.667M2.667 3l5.744 0c.505 0 .986.188 1.358.53l.729.675c.556.512 1.278.795 2.035.795l10.8 0C24.252 5 25 5.748 25 6.667l0 3.334-24 0 0-5.334C1 3.748 1.748 3 2.667 3m20.666 1l-10.8 0c-.505 0-.986-.188-1.357-.53l-.73-.675C9.891 2.283 9.168 2 8.411 2L2.667 2C1.196 2 0 3.196 0 4.667l0 16.666C0 22.804 1.196 24 2.667 24l20.666 0C24.804 24 26 22.804 26 21.333l0-14.666C26 5.196 24.804 4 23.333 4"],"files_28":["M27 9.9167l0 .083-26 0 0-5c0-1.102.897-2 2-2l5.172 0c.394 0 .781.16 1.06.439l.824.824c.472.472 1.099.732 1.767.733L25 4.9997c1.103 0 2 .898 2 2l0 2.917zm0 13.083c0 1.103-.897 2-2 2l-22 0c-1.103 0-2-.897-2-2l0-12 26 0 0 12zm-2-19l-13.177-.004c-.4-.001-.777-.157-1.06-.44l-.824-.824c-.472-.472-1.1-.732-1.767-.732l-5.172 0c-1.657 0-3 1.343-3 3l0 18c0 1.657 1.343 3 3 3l22 0c1.657 0 3-1.343 3-3l0-16c0-1.657-1.343-3-3-3z"],"files_32":["M31 12L1 12l0-7c0-1.103.897-2 2-2l6.757 0c.535 0 1.037.208 1.415.586l1.674 1.674c.477.477 1.112.74 1.786.74L29 6c1.103 0 2 .897 2 2l0 4zm0 15c0 1.103-.897 2-2 2L3 29c-1.103 0-2-.897-2-2l0-14 30 0 0 14zM29 5L14.632 5c-.405 0-.793-.161-1.079-.447l-1.674-1.674C11.316 2.316 10.553 2 9.757 2L3 2C1.343 2 0 3.343 0 5l0 22c0 1.657 1.343 3 3 3l26 0c1.657 0 3-1.343 3-3l0-19c0-1.657-1.343-3-3-3z"],"files_36":["M31.5 31.999l-27 0c-1.378 0-2.5-1.122-2.5-2.5L2 15l32 0 0 14.499c0 1.378-1.122 2.5-2.5 2.5M4.5 4l7.258 0c.668 0 1.296.26 1.768.732l1.242 1.243C15.429 6.636 16.308 7 17.243 7L31.5 7C32.878 7 34 8.122 34 9.5l0 4.5-32 0 0-7.5C2 5.122 3.122 4 4.5 4m27 2L17.243 6c-.668 0-1.296-.26-1.768-.732l-1.242-1.243C13.572 3.364 12.693 3 11.758 3L4.5 3C2.57 3 1 4.57 1 6.5l0 22.999c0 1.93 1.57 3.5 3.5 3.5l27 0c1.93 0 3.5-1.57 3.5-3.5L35 9.5C35 7.57 33.43 6 31.5 6"],"files_8":["M7.00049975 2.99949975l-5.9990005 0-.001999.008004 0-1.84092046c0-.09104552.07496252-.16608304.16691654-.16608304l1.984008 0 .71664168.71735868c.18890554.19009505.43978011.29414707.70864567.29414707l.003998 0 2.25387307-.0110055c.05997001 0 .09895052.03101551.11794103.04902451.017991.01800901.04897551.05802902.04897551.11705853l0 .83241621zm0 3.83391696c0 .09104552-.07496252.16608304-.16691654.16608304l-5.66716642 0c-.09195402 0-.16691654-.07503752-.16691654-.16608304L.99950025 4l6.0009995 0 0 2.83341671zm.65567216-5.49274637c-.21989005-.21910956-.51174412-.34017009-.8225887-.34017009-.0009995 0-.003998-.0010005-.0049975 0l-2.25387307.0110055-.71764118-.719359677C3.66816592.104052026 3.41729135 0 3.15042479 0l-1.984008 0C.523738131 0 0 .523261631 0 1.16658329l0 5.66683342C0 7.47673837.523738131 8 1.16641679 8l5.66716642 0C7.47726137 8 8 7.47673837 8 6.83341671l0-4.66633317c0-.31215608-.12193903-.60530265-.34382809-.8264132z"],"filter-circle_12":["M6 0c3.313 0 6 2.687 6 6 0 3.313-2.687 6-6 6-3.313 0-6-2.687-6-6 0-3.313 2.687-6 6-6zm0 11c2.757 0 5-2.243 5-5 0-2.757-2.243-5-5-5-2.757 0-5 2.243-5 5 0 2.757 2.243 5 5 5zm2.5-7c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l5 0zm-1 2c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-3 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l3 0zm-1 2c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0z"],"filter-circle_16":["M8 0c4.418 0 8 3.582 8 8 0 4.418-3.582 8-8 8-4.418 0-8-3.582-8-8 0-4.418 3.582-8 8-8zm0 15c3.86 0 7-3.14 7-7 0-3.86-3.14-7-7-7-3.86 0-7 3.14-7 7 0 3.86 3.14 7 7 7zm3.5-9c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-7 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l7 0zm-1 2c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l5 0zm-1 2c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-3 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l3 0z"],"filter-circle_20":["M10 20C4.4771525 20 0 15.5228475 0 10 0 4.4771525 4.4771525 0 10 0c5.5228475 0 10 4.4771525 10 10 0 5.5228475-4.4771525 10-10 10zm0-1c4.9705627 0 9-4.0294373 9-9 0-4.97056275-4.0294373-9-9-9-4.97056275 0-9 4.02943725-9 9 0 4.9705627 4.02943725 9 9 9zM5 7.5c0-.27614237.22765279-.5.50964952-.5l8.98070098 0C14.7718221 7 15 7.23193359 15 7.5c0 .27614237-.2276528.5-.5096495.5L5.50964952 8C5.22817786 8 5 7.76806641 5 7.5zm1 3c0-.2761424.23079681-.5.50043583-.5l6.99912837 0C13.7759472 10 14 10.2319336 14 10.5c0 .2761424-.2307968.5-.5004358.5l-6.99912837 0C6.22405275 11 6 10.7680664 6 10.5zm1 3c0-.2761424.22788048-.5.49100518-.5l5.01798962 0C12.7801695 13 13 13.2319336 13 13.5c0 .2761424-.2278805.5-.4910052.5l-5.01798962 0C7.21983051 14 7 13.7680664 7 13.5z"],"filter-circle-active_20":["M10 20C4.4771525 20 0 15.5228475 0 10 0 4.4771525 4.4771525 0 10 0c5.5228475 0 10 4.4771525 10 10 0 5.5228475-4.4771525 10-10 10zM5 7.5c0 .26806641.22817786.5.50964952.5l8.98070098 0C14.7723472 8 15 7.77614237 15 7.5c0-.26806641-.2281779-.5-.5096495-.5L5.50964952 7C5.22765279 7 5 7.22385763 5 7.5zm1 3c0 .2680664.22405275.5.50043583.5l6.99912837 0C13.7692032 11 14 10.7761424 14 10.5c0-.2680664-.2240528-.5-.5004358-.5l-6.99912837 0C6.23079681 10 6 10.2238576 6 10.5zm1 3c0 .2680664.21983051.5.49100518.5l5.01798962 0C12.7721195 14 13 13.7761424 13 13.5c0-.2680664-.2198305-.5-.4910052-.5l-5.01798962 0C7.22788048 13 7 13.2238576 7 13.5z"],"fit-to-width_12":["M.5 1c.275 0 .5.225.5.5l0 9c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-9c0-.275.225-.5.5-.5zm11 0c.275 0 .5.225.5.5l0 9c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-9c0-.275.225-.5.5-.5zM7.8604 3.6465l2 2c.195.195.195.512 0 .707l-2 2c-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147-.195-.195-.195-.512 0-.707l1.146-1.146-4.585 0 1.146 1.146c.195.195.195.512 0 .707-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147l-2-2c-.195-.195-.195-.512 0-.707l2-2c.195-.195.512-.195.707 0 .195.195.195.512 0 .707l-1.146 1.147 4.585 0-1.146-1.147c-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0z"],"fit-to-window_12":["M10.5 1c.276 0 .5.224.5.5l0 3c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-1.793-2.146 2.147c-.196.195-.512.195-.708 0-.195-.196-.195-.512 0-.708L9.293 2 7.5 2c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l3 0zM5 1.5c0 .276-.224.5-.5.5L2.707 2l2.147 2.146c.195.196.195.512 0 .708C4.756 4.951 4.628 5 4.5 5c-.128 0-.256-.049-.354-.146L2 2.707 2 4.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-3c0-.276.224-.5.5-.5l3 0c.276 0 .5.224.5.5zM10.5 7c.276 0 .5.224.5.5l0 3c0 .276-.224.5-.5.5l-3 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1.793 0-2.147-2.146c-.195-.196-.195-.512 0-.708.196-.195.512-.195.708 0L10 9.293 10 7.5c0-.276.224-.5.5-.5zM5 7.5c0 .128-.049.256-.146.354L2.707 10 4.5 10c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-3 0c-.276 0-.5-.224-.5-.5l0-3c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 1.793 2.146-2.147c.196-.195.512-.195.708 0 .097.098.146.226.146.354z"],"fit-to-window_16":["M5.4995 14c.276 0 .5.225.5.5 0 .275-.224.5-.5.5l-4 0c-.275 0-.5-.225-.5-.5l0-4c0-.275.225-.5.5-.5.276 0 .5.225.5.5l0 2.793 3.147-3.147c.195-.195.512-.195.707 0 .195.196.195.512 0 .708L2.7075 14l2.792 0zm5.001-12c-.276 0-.5-.225-.5-.5 0-.275.224-.5.5-.5l4 0c.275 0 .5.225.5.5l0 4c0 .275-.225.5-.5.5-.276 0-.5-.225-.5-.5l0-2.793-3.147 3.147c-.195.195-.512.195-.707 0-.195-.196-.195-.512 0-.708L13.2925 2l-2.792 0zM14 10.5c0-.275.224-.5.5-.5.276 0 .5.225.5.5l0 4c0 .275-.224.5-.5.5l-4 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l2.793 0-3.147-3.146c-.195-.196-.195-.512 0-.708.196-.195.512-.195.708 0L14 13.293l0-2.793zm-12-5c0 .275-.224.5-.5.5-.276 0-.5-.225-.5-.5l0-4c0-.275.224-.5.5-.5l4 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L2.707 2l3.147 3.146c.195.196.195.512 0 .708-.196.195-.512.195-.708 0L2 2.707 2 5.5z"],"fit-to-window-exit_12":["M7.49975 5.00025c-.276 0-.5-.224-.5-.5l0-3c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 1.793 2.146-2.147c.196-.195.512-.195.708 0 .195.196.195.512 0 .708l-2.147 2.146 1.793 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-3 0zM1.00025 4.5c0-.276.224-.5.5-.5l1.793 0-2.147-2.146c-.195-.196-.195-.512 0-.708.098-.097.226-.146.354-.146.128 0 .256.049.354.146l2.146 2.147 0-1.793c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 3c0 .276-.224.5-.5.5l-3 0c-.276 0-.5-.224-.5-.5zm6.4995 6.49975c-.276 0-.5-.224-.5-.5l0-3c0-.276.224-.5.5-.5l3 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1.793 0 2.147 2.146c.195.196.195.512 0 .708-.196.195-.512.195-.708 0l-2.146-2.147 0 1.793c0 .276-.224.5-.5.5zM1 10.49975c0-.128.049-.256.146-.354l2.147-2.146-1.793 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l3 0c.276 0 .5.224.5.5l0 3c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-1.793-2.146 2.147c-.196.195-.512.195-.708 0-.097-.098-.146-.226-.146-.354z"],"fit-to-window-exit_16":["M1.5005 11c-.276 0-.5-.224-.5-.5 0-.275.224-.5.5-.5l4 0c.275 0 .5.225.5.5l0 4c0 .275-.225.5-.5.5-.276 0-.5-.225-.5-.5l0-2.793-3.147 3.147c-.195.195-.512.195-.707 0-.195-.196-.195-.512 0-.708L4.2925 11l-2.792 0zm12.999-6c.276 0 .5.224.5.5 0 .275-.224.5-.5.5l-4 0c-.275 0-.5-.225-.5-.5l0-4c0-.275.225-.5.5-.5.276 0 .5.225.5.5l0 2.793 3.147-3.147c.195-.195.512-.195.707 0 .195.196.195.512 0 .708L11.7075 5l2.792 0zM11 14.5c0 .275-.224.5-.5.5-.276 0-.5-.225-.5-.5l0-4c0-.275.224-.5.5-.5l4 0c.275 0 .5.225.5.5 0 .276-.225.5-.5.5l-2.793 0 3.147 3.146c.195.196.195.512 0 .708-.196.195-.512.195-.708 0L11 11.707l0 2.793zm-6-13c0-.275.224-.5.5-.5.276 0 .5.225.5.5l0 4c0 .275-.224.5-.5.5l-4 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l2.793 0-3.147-3.146c-.195-.196-.195-.512 0-.708.196-.195.512-.195.708 0L5 4.293 5 1.5z"],"flag_10":["M2 9.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-9c0-.276.224-.5.5-.5l6.854 0c.252 0 .476.141.584.366.106.223.076.481-.08.673L7.164 3l1.684 1.948c.166.205.196.463.09.686-.108.225-.332.366-.584.366L2 6l0 3.5zM2 1l0 4 5.571 0-1.373-1.588c-.199-.243-.199-.581-.007-.814L7.571 1 2 1z"],"flag_12":["M3 5.99051502L3 .99841917l6.67 0-1.553 2.0886929c-.188.24161744-.187.5780847-.006.80572427L9.67 5.99051502l-6.67 0zm7.865-.06689409L9.059 3.49446709l1.799-2.42116648c.157-.201680675.186-.470255432.072-.699891841C10.818.14377236 10.589 0 10.332 0L2.5 0c-.276 0-.5.223645894-.5.499209585L2 11.5007904C2 11.7773525 2.224 12 2.5 12c.276 0 .5-.2226475.5-.4992096l0-4.51185621 7.332 0c.257 0 .486-.14377236.598-.37340877.114-.22963641.086-.49920959-.065-.69190449z"],"flag_14":["M3 7l0-6 7.712 0-1.847 2.581c-.185.247-.185.591-.007.829L10.712 7 3 7zm8.867-.104L9.794 4l2.064-2.885c.162-.212.187-.493.069-.732C11.809.146 11.574 0 11.312 0L2.5 0c-.276 0-.5.224-.5.5l0 13c0 .276.224.5.5.5.276 0 .5-.224.5-.5L3 8l8.312 0c.262 0 .497-.146.615-.383.118-.239.093-.52-.06-.721z"],"flag_16":["M2.999868492 9l0-7L12.7245894 2l-2.26870156 3.056c-.20297331.261-.20297331.627-.00699908.878L12.7245894 9 2.999868492 9zM13.8524411 8.844L11.37176738 5.5l2.47567442-3.334c.1699776-.22.1989738-.512.0769898-.761-.1219839-.25-.3709512-.405-.6489146-.405L2.499934246 1C2.223970542 1 2 1.224 2 1.5l0 13c0 .276.223970542.5.499934246.5.275963704 0 .499934246-.224.499934246-.5l0-4.5L13.275517 10c.2789633 0 .5269307-.155.6499145-.405.121984-.25.0919879-.541-.0729904-.751z"],"flag_20":["M4.0415 11c-.015 0-.027.007-.042.008l0-9.008 11.763 0-3.111 4.027c-.216.279-.216.667 0 .945L15.7625 11l-11.721 0zm12.796-.243L13.5495 6.5l3.287-4.255c.183-.234.215-.545.085-.812-.13-.267-.396-.433-.693-.433L3.4995 1c-.276 0-.5.224-.5.5l0 17c0 .276.224.5.5.5.277 0 .5-.224.5-.5l0-6.508c.015.001.027.008.042.008l12.187 0c.297 0 .563-.166.693-.433.13-.267.098-.578-.084-.81z"],"flag_24":["M4 13L4 2l15.84 0-3.662 4.988c-.236.302-.236.722-.009 1.012l3.671 5L4 13zm16.835-.334L17.042 7.5l3.786-5.156c.196-.253.231-.59.089-.878-.141-.287-.427-.466-.748-.466L3.5 1c-.276 0-.5.224-.5.5l0 21c0 .276.224.5.5.5.276 0 .5-.224.5-.5L4 14l16.169 0c.321 0 .607-.179.748-.466.142-.288.107-.625-.082-.868z"],"flag_64":["M52.9531 34.7764c-.033.067-.134.224-.351.224l-41.602 0 0-31.5c0-.276.224-.5.5-.5l41.102 0c.217 0 .318.156.351.223.028.057.108.257-.046.46l-10.618 14.451c-.387.51-.387 1.222-.004 1.725l10.626 14.464c.15.197.07.396.042.453m.759-1.052l-10.627-14.464c-.116-.153-.116-.367.005-.527l10.617-14.451c.331-.436.386-1.012.142-1.503-.239-.481-.716-.779-1.247-.779l-41.102 0c-.827 0-1.5.672-1.5 1.5l0 58c0 .276.224.5.5.5.276 0 .5-.224.5-.5l0-25.5 41.602 0c.531 0 1.008-.299 1.247-.78.244-.491.189-1.067-.137-1.496"],"flag_8":["M5.141 2.152c-.195.195-.195.512 0 .707l1.144 1.144-4.285 0L2 1l4.293 0-1.152 1.152zM7.962.308C7.885.121 7.703 0 7.5 0l-6 0c-.276 0-.5.223-.5.5l0 7c0 .276.224.5.5.5.277 0 .5-.224.5-.5l0-2.497 5.492 0c.202 0 .384-.122.462-.309.077-.187.034-.402-.109-.545L6.202 2.506 7.854.853c.142-.143.185-.358.108-.545z"],"flag-active_10":["M2 9.5L2 6l6.354 0c.252 0 .476-.141.584-.366.106-.223.076-.481-.09-.686L7.164 3l1.694-1.961c.156-.192.186-.45.08-.673C8.83.141 8.606 0 8.354 0L1.5 0c-.276 0-.5.224-.5.5l0 9c0 .276.224.5.5.5.276 0 .5-.224.5-.5z"],"flag-active_12":["M10.865 5.92362093L9.059 3.49446709l1.799-2.42116648c.157-.201680675.186-.470255432.072-.699891841C10.818.14377236 10.589 0 10.332 0L2.5 0c-.276 0-.5.223645894-.5.499209585L2 11.5007904C2 11.7773525 2.224 12 2.5 12c.276 0 .5-.2226475.5-.4992096l0-4.51185621 7.332 0c.257 0 .486-.14377236.598-.37340877.114-.22963641.086-.49920959-.065-.69190449z"],"flag-active_14":["M11.867 6.896L9.794 4l2.064-2.885c.162-.212.187-.493.069-.732C11.809.146 11.574 0 11.312 0L2.5 0c-.276 0-.5.224-.5.5l0 13c0 .276.224.5.5.5.276 0 .5-.224.5-.5L3 8l8.312 0c.262 0 .497-.146.615-.383.118-.239.093-.52-.06-.721z"],"flag-active_16":["M13.8524411 8.844L11.37176738 5.5l2.47567442-3.334c.1699776-.22.1989738-.512.0769898-.761-.1219839-.25-.3709512-.405-.6489146-.405L2.499934246 1C2.223970542 1 2 1.224 2 1.5l0 13c0 .276.223970542.5.499934246.5.275963704 0 .499934246-.224.499934246-.5l0-4.5L13.275517 10c.2789633 0 .5269307-.155.6499145-.405.121984-.25.0919879-.541-.0729904-.751z"],"flag-active_20":["M16.8375 10.757L13.5495 6.5l3.287-4.255c.183-.234.215-.545.085-.812-.13-.267-.396-.433-.693-.433L3.4995 1c-.276 0-.5.224-.5.5l0 17c0 .276.224.5.5.5.277 0 .5-.224.5-.5l0-6.508c.015.001.027.008.042.008l12.187 0c.297 0 .563-.166.693-.433.13-.267.098-.578-.084-.81z"],"flag-active_24":["M20.835 12.666L17.042 7.5l3.786-5.156c.196-.253.231-.59.089-.878-.141-.287-.427-.466-.748-.466L3.5 1c-.276 0-.5.224-.5.5l0 21c0 .276.224.5.5.5.276 0 .5-.224.5-.5L4 14l16.169 0c.321 0 .607-.179.748-.466.142-.288.107-.625-.082-.868z"],"flag-active_8":["M7.962.308C7.885.121 7.703 0 7.5 0l-6 0c-.276 0-.5.223-.5.5l0 7c0 .276.224.5.5.5.277 0 .5-.224.5-.5l0-2.497 5.492 0c.202 0 .384-.122.462-.309.077-.187.034-.402-.109-.545L6.202 2.506 7.854.853c.142-.143.185-.358.108-.545z"],"flag-circle_16":["M8 0c4.411 0 8 3.589 8 8 0 4.411-3.589 8-8 8-4.411 0-8-3.589-8-8 0-4.411 3.589-8 8-8zm0 15c3.859 0 7-3.14 7-7 0-3.86-3.141-7-7-7-3.859 0-7 3.14-7 7 0 3.86 3.141 7 7 7zm3.9616-10.6917c.077.187.034.402-.108.545l-1.652 1.653 1.643 1.643c.143.143.186.358.109.545-.078.187-.26.309-.462.309l-5.492 0 0 2.497c0 .276-.223.5-.5.5-.276 0-.5-.224-.5-.5l0-7c0-.277.224-.5.5-.5l6 0c.203 0 .385.121.462.308zm-2.821 1.844l1.152-1.152-4.293 0 0 3.003 4.285 0-1.144-1.144c-.195-.195-.195-.512 0-.707z"],"flow_32":["M22.0762 11.0103l-4.173 0c-.506.001-.915.412-.914.917l0 1.083-1.774 0c-.868 0-1.631.554-1.903 1.379l-2.486 7.621-1.826 0 0-1.093c.001-.506-.408-.917-.914-.918l-4.172 0c-.506.001-.915.412-.914.918l0 1.378 0 1.528 0 1.259c-.001.506.408.916.914.917l4.172 0c.506-.001.915-.411.914-.917l0-1.072 1.826 0c.867 0 1.632-.554 1.902-1.379l2.487-7.621 1.775 0 0 1.083c-.002.505.407.916.913.917l4.172 0c.506-.001.915-.412.914-.917l0-4.166c.001-.505-.407-.916-.913-.917m-14.576 10.489l0 .511 0 1.5 0 .5 0 .489-3 0 0-.676 0-1.528 0-.796 3 0zM26 6.0001c1.657 0 3 1.343 3 3l0 11c0 1.657-1.343 3-3 3l-9 0 0-1 9 0c1.103 0 2-.897 2-2l0-11c0-1.103-.897-2-2-2l-20 0c-1.103 0-2 .897-2 2l0 9-1 0 0-9c0-1.657 1.343-3 3-3l20 0z"],"focus-3-day_24":["M21.5 3C22.881 3 24 4.119 24 5.5l0 13c0 1.381-1.119 2.5-2.5 2.5l-19 0C1.119 21 0 19.881 0 18.5l0-13C0 4.119 1.119 3 2.5 3l19 0zM23 18.5l0-13c0-.827-.673-1.5-1.5-1.5L17 4l0 16 4.5 0c.827 0 1.5-.673 1.5-1.5zM8 20l8 0 0-16-8 0 0 16zm-1 0L7 4 2.5 4C1.673 4 1 4.673 1 5.5l0 13c0 .827.673 1.5 1.5 1.5L7 20z"],"focus-day_24":["M23 18.5c0 .827-.673 1.5-1.5 1.5l-19 0c-.827 0-1.5-.673-1.5-1.5l0-13C1 4.673 1.673 4 2.5 4l19 0c.827 0 1.5.673 1.5 1.5l0 13zM21.5 3l-19 0C1.119 3 0 4.119 0 5.5l0 13C0 19.881 1.119 21 2.5 21l19 0c1.381 0 2.5-1.119 2.5-2.5l0-13C24 4.119 22.881 3 21.5 3z"],"focus-month_24":["M21.5 3C22.881 3 24 4.119 24 5.5l0 13c0 1.381-1.119 2.5-2.5 2.5l-19 0C1.119 21 0 19.881 0 18.5l0-13C0 4.119 1.119 3 2.5 3l19 0zm1.5 8.5l0-6c0-.827-.673-1.5-1.5-1.5L17 4l0 7.5 6 0zm0 7l0-6-6 0 0 7.5 4.5 0c.827 0 1.5-.673 1.5-1.5zm-15-7l8 0L16 4 8 4l0 7.5zM8 20l8 0 0-7.5-8 0L8 20zm-1-8.5L7 4 2.5 4C1.673 4 1 4.673 1 5.5l0 6 6 0zM7 20l0-7.5-6 0 0 6c0 .827.673 1.5 1.5 1.5L7 20z"],"focus-upcoming_24":["M1 7.00585866l0 9.98828264C1 17.5503373 1.44961209 18 2.00494659 18l19.99010681 0C22.5503257 18 23 17.5500251 23 16.9941413l0-9.98828264C23 6.44966274 22.5503879 6 21.9950534 6L2.00494659 6C1.44967435 6 1 6.44997486 1 7.00585866zm-1 0C0 5.89805351.897026226 5 2.00494659 5L21.9950534 5C23.1023548 5 24 5.89706013 24 7.00585866l0 9.98828264C24 18.1019465 23.1029738 19 21.9950534 19L2.00494659 19C.897645164 19 0 18.1029399 0 16.9941413l0-9.98828264zM0 3.5c0-.276142375.222265363-.5.501274109-.5L23.4987259 3C23.7755719 3 24 3.231933594 24 3.5c0 .276142375-.2222654.5-.5012741.5L.501274109 4C.224428063 4 0 3.768066406 0 3.5zm0 17c0-.2761424.222265363-.5.501274109-.5L23.4987259 20C23.7755719 20 24 20.2319336 24 20.5c0 .2761424-.2222654.5-.5012741.5L.501274109 21C.224428063 21 0 20.7680664 0 20.5z"],"focus-week_24":["M21.5 3C22.881 3 24 4.119 24 5.5l0 13c0 1.381-1.119 2.5-2.5 2.5l-19 0C1.119 21 0 19.881 0 18.5l0-13C0 4.119 1.119 3 2.5 3l19 0zM23 18.5l0-13c0-.827-.673-1.5-1.5-1.5L17 4l0 16 4.5 0c.827 0 1.5-.673 1.5-1.5zM8 20l8 0 0-16-8 0 0 16zm-1 0L7 4 2.5 4C1.673 4 1 4.673 1 5.5l0 13c0 .827.673 1.5 1.5 1.5L7 20z"],"fullscreen_12":["M10.5 1c.828 0 1.5.672 1.5 1.5l0 2c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-.859 0-.141 0-1c0-.276-.224-.5-.5-.5l-2 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l2 0zm-7 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-2 0c-.276 0-.5.224-.5.5l0 2c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-2C0 1.672.672 1 1.5 1l2 0zm8 6c.275 0 .5.225.5.5l0 2c0 .828-.672 1.5-1.5 1.5l-2 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l2 0c.276 0 .5-.224.5-.5l0-2c0-.275.225-.5.5-.5zm-8 3c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-2 0C.672 11 0 10.328 0 9.5l0-2c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 2c0 .276.224.5.5.5l2 0z"],"fullscreen_16":["M.5001 7.0001c-.276 0-.5-.224-.5-.5l0-2.5c0-1.103.897-2 2-2l2.5 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-2.5 0c-.551 0-1 .449-1 1l0 2.5c0 .276-.224.5-.5.5zm4.5 6.5005c0 .276-.224.5-.5.5l-2.5 0c-1.103 0-2-.897-2-2l0-2.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 2.5c0 .551.449 1 1 1l2.5 0c.276 0 .5.224.5.5zm10.5005-4.5c.276 0 .5.224.5.5l0 2.5c0 1.103-.897 2-2 2l-2.5 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l2.5 0c.551 0 1-.449 1-1l0-2.5c0-.276.224-.5.5-.5zm-4.5-6.5005c0-.276.224-.5.5-.5l2.5 0c1.103 0 2 .897 2 2l0 2.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-2.5c0-.551-.449-1-1-1l-2.5 0c-.276 0-.5-.224-.5-.5z"],"fullscreen-c-native-macOS_14":["M10 7.6641c0 .299-.361.448-.573.236l-3.328-3.328c-.211-.211-.062-.572.237-.572l3.329 0c.185 0 .335.15.335.336l0 3.328zm-2.336 2.336l-3.329 0c-.185 0-.335-.15-.335-.336l0-3.328c0-.299.361-.448.573-.236l3.328 3.328c.211.211.062.572-.237.572zM7 .0001c-3.866 0-7 3.134-7 7 0 3.866 3.134 7 7 7 3.866 0 7-3.134 7-7 0-3.866-3.134-7-7-7z"],"fullscreen-exit_12":["M9.5 5C8.672 5 8 4.328 8 3.5l0-2c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 .859L9 2.5l0 1c0 .276.224.5.5.5l2 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-2 0zm-9 0C.225 5 0 4.775 0 4.5c0-.275.225-.5.5-.5l2 0c.276 0 .5-.224.5-.5l0-2c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 2C4 4.328 3.328 5 2.5 5l-2 0zm8 6c-.275 0-.5-.225-.5-.5l0-2C8 7.672 8.672 7 9.5 7l2 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-2 0c-.276 0-.5.224-.5.5l0 2c0 .275-.225.5-.5.5zm-8-3C.225 8 0 7.775 0 7.5c0-.275.225-.5.5-.5l2 0C3.328 7 4 7.672 4 8.5l0 2c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-2c0-.276-.224-.5-.5-.5l-2 0z"],"fullscreen-exit_16":["M4.5001 2.0021c.276 0 .5.224.5.5l0 2.5c0 1.103-.897 2-2 2l-2.5 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l2.5 0c.551 0 1-.449 1-1l0-2.5c0-.276.224-.5.5-.5zm-4.5 7.5004c0-.276.224-.5.5-.5l2.5 0c1.103 0 2 .897 2 2l0 2.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-2.5c0-.551-.449-1-1-1l-2.5 0c-.276 0-.5-.224-.5-.5zm11.5005 4.5c-.276 0-.5-.224-.5-.5l0-2.5c0-1.103.897-2 2-2l2.5 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-2.5 0c-.551 0-1 .449-1 1l0 2.5c0 .276-.224.5-.5.5zm4.5-7.5004c0 .276-.224.5-.5.5l-2.5 0c-1.103 0-2-.897-2-2l0-2.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 2.5c0 .551.449 1 1 1l2.5 0c.276 0 .5.224.5.5z"],"generic-device_12":["M10.5 1c.827 0 1.5.673 1.5 1.5l0 7c0 .827-.673 1.5-1.5 1.5l-9 0C.673 11 0 10.327 0 9.5l0-7C0 1.673.673 1 1.5 1l9 0zm.5 8.5l0-7c0-.275-.225-.5-.5-.5l-9 0c-.276 0-.5.225-.5.5l0 7c0 .275.224.5.5.5l9 0c.275 0 .5-.225.5-.5zM9.8 3c.111 0 .2.089.2.2l0 5.6c0 .111-.089.2-.2.2L2.2 9c-.111 0-.2-.089-.2-.2l0-5.6c0-.111.089-.2.2-.2l7.6 0zM3 8l6 0 0-4-6 0 0 4z"],"generic-device_14":["M12.3 1.9998c.939 0 1.7.761 1.7 1.7l0 7.6c0 .939-.761 1.7-1.7 1.7l-10.6 0c-.939 0-1.7-.761-1.7-1.7l0-7.6c0-.939.761-1.7 1.7-1.7l10.6 0zm.7 9.3l0-7.6c0-.386-.314-.7-.7-.7l-10.6 0c-.386 0-.7.314-.7.7l0 7.6c0 .386.314.7.7.7l10.6 0c.386 0 .7-.314.7-.7zM2.30000001 4L11.7 4c.1656854 0 .3.13431458.3.30000001l0 6.39999998C12 10.86568542 11.8656854 11 11.7 11l-9.39999999 0C2.13431458 11 2 10.86568542 2 10.69999999l0-6.39999998C2 4.13431458 2.13431458 4 2.30000001 4zM3 5l0 5 8 0 0-5-8 0z"],"generic-device_16":["M14.006 2C15.107 2 16 2.902 16 4.009l0 7.982C16 13.1 15.105 14 14.006 14L1.994 14C.893 14 0 13.097 0 11.991l0-7.982C0 2.899.895 2 1.994 2l12.012 0zM15 11.991l0-7.982C15 3.451 14.553 3 14.006 3L1.994 3C1.447 3 1 3.451 1 4.009l0 7.982c0 .558.447 1.009.994 1.009l12.012 0c.547 0 .994-.451.994-1.009zM2.30000001 4L13.7 4c.1656854 0 .3.13431458.3.30000001l0 7.39999998C14 11.86568542 13.8656854 12 13.7 12L2.30000001 12C2.13431458 12 2 11.86568542 2 11.69999999l0-7.39999998C2 4.13431458 2.13431458 4 2.30000001 4zM3 5l0 6 10 0 0-6L3 5z"],"generic-device_20":["M19.572 3.104c.27.398.428.878.428 1.396l0 11c0 1.379-1.121 2.5-2.5 2.5l-15 0c-.862 0-1.623-.437-2.072-1.104C.158 16.498 0 16.018 0 15.5l0-11C0 3.121 1.121 2 2.5 2l15 0c.862 0 1.623.437 2.072 1.104zM19 15.5l0-11c0-.207-.042-.404-.118-.584-.152-.358-.44-.646-.799-.798C17.904 3.042 17.707 3 17.5 3l-15 0C1.673 3 1 3.673 1 4.5l0 11c0 .207.042.404.118.584.152.358.44.646.799.798.179.076.376.118.583.118l15 0c.827 0 1.5-.673 1.5-1.5zM2.75 4l14.5 0c.4142136 0 .75.33578644.75.75l0 10.5c0 .4142136-.3357864.75-.75.75l-14.5 0c-.41421356 0-.75-.3357864-.75-.75l0-10.5c0-.41421356.33578644-.75.75-.75zM3 5l0 10 14 0 0-10L3 5z"],"generic-device_24":["M0 5.50282288C0 4.12055197 1.12537944 3 2.50050165 3L21.4994984 3C22.8804873 3 24 4.12598062 24 5.50282288l0 12.99435422C24 19.879448 22.8746206 21 21.4994984 21L2.50050165 21C1.11951272 21 0 19.8740194 0 18.4971771L0 5.50282288zm1 0L1 18.4971771C1 19.3241517 1.67421141 20 2.50050165 20l18.99899675 0C22.3245167 20 23 19.3249836 23 18.4971771l0-12.99435422C23 4.67584834 22.3257886 4 21.4994984 4L2.50050165 4C1.67548327 4 1 4.67501637 1 5.50282288zM2.75 5l18.5 0c.4142136 0 .75.33578644.75.75l0 12.5c0 .4142136-.3357864.75-.75.75l-18.5 0c-.41421356 0-.75-.3357864-.75-.75l0-12.5c0-.41421356.33578644-.75.75-.75zM3 6l0 12 18 0 0-12L3 6z"],"generic-device_28":["M25 3c1.657 0 3 1.343 3 3l0 16c0 1.657-1.343 3-3 3L3 25c-1.658 0-3-1.343-3-3L0 6c0-1.657 1.342-3 3-3l22 0zm0 1L3 4c-1.104 0-2 .897-2 2l0 16c0 1.103.896 2 2 2l22 0c1.103 0 2-.897 2-2l0-16c0-1.103-.897-2-2-2zM3.5 6l21 0c.2761424 0 .5.22385763.5.5l0 15c0 .2761424-.2238576.5-.5.5l-21 0c-.27614237 0-.5-.2238576-.5-.5l0-15c0-.27614237.22385763-.5.5-.5zM4 7l0 14 20 0 0-14L4 7z"],"generic-device_32":["M3 4l26 0c1.6568542 0 3 1.34314575 3 3l0 18c0 1.6568542-1.3431458 3-3 3L3 28c-1.65685425 0-3-1.3431458-3-3L0 7c0-1.65685425 1.34314575-3 3-3zm0 1c-1.1045695 0-2 .8954305-2 2l0 18c0 1.1045695.8954305 2 2 2l26 0c1.1045695 0 2-.8954305 2-2l0-18c0-1.1045695-.8954305-2-2-2L3 5zm.75 2l24.5 0c.4142136 0 .75.33578644.75.75l0 16.5c0 .4142136-.3357864.75-.75.75l-24.5 0c-.41421356 0-.75-.3357864-.75-.75l0-16.5c0-.41421356.33578644-.75.75-.75zM4 8l0 16 24 0 0-16L4 8z"],"generic-device_48":["M4.5 6l39 0c2.4852814 0 4.5 2.01471863 4.5 4.5l0 27c0 2.4852814-2.0147186 4.5-4.5 4.5l-39 0C2.01471863 42 0 39.9852814 0 37.5l0-27C0 8.01471863 2.01471863 6 4.5 6zm0 1C2.56700338 7 1 8.56700338 1 10.5l0 27C1 39.4329966 2.56700338 41 4.5 41l39 0c1.9329966 0 3.5-1.5670034 3.5-3.5l0-27C47 8.56700338 45.4329966 7 43.5 7l-39 0zm.5 4l0 26 38 0 0-26-38 0zm0-1l38 0c.5522847 0 1 .44771525 1 1l0 26c0 .5522847-.4477153 1-1 1L5 38c-.55228475 0-1-.4477153-1-1l0-26c0-.55228475.44771525-1 1-1z"],"gif_16":["M14 2c1.104 0 2 .896 2 2l0 8c0 1.104-.896 2-2 2L2 14c-1.104 0-2-.896-2-2l0-8c0-1.104.896-2 2-2l12 0zm1 10l0-8c0-.552-.448-1-1-1L2 3c-.551 0-1 .448-1 1l0 8c0 .552.449 1 1 1l12 0c.552 0 1-.448 1-1zM5 6c-.552 0-1 .447-1 1l0 2c0 .553.448 1 1 1l1 0 0-1-.5 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5L6 8l.5 0c.276 0 .5.224.5.5l0 2c0 .276-.224.5-.5.5L5 11c-1.1 0-2-.9-2-2l0-2c0-1.1.9-2 2-2l1.5 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5L5 6zm3.5-1c.275 0 .5.225.5.5l0 5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-5c0-.275.225-.5.5-.5zm4 1L11 6l0 2 1.5 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L11 9l0 1.5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-5c0-.275.225-.5.5-.5l2 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5z"],"gif_20":["M2.5 17C1.119 17 0 15.881 0 14.5l0-9C0 4.119 1.119 3 2.5 3l15 0C18.881 3 20 4.119 20 5.5l0 9c0 1.381-1.119 2.5-2.5 2.5l-15 0zM1 5.5l0 9c0 .827.673 1.5 1.5 1.5l15 0c.827 0 1.5-.673 1.5-1.5l0-9c0-.827-.673-1.5-1.5-1.5l-15 0C1.673 4 1 4.673 1 5.5zM16.5 7L14 7l0 2 2.5 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L14 10l0 3.5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-7c0-.275.225-.5.5-.5l3 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5zM5 7c-.552 0-1 .448-1 1l0 4c0 .552.448 1 1 1l2 0 0-2-1.5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l2 0c.275 0 .5.225.5.5l0 3c0 .275-.225.5-.5.5L5 14c-1.104 0-2-.896-2-2l0-4c0-1.104.896-2 2-2l2.5 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L5 7zm5.5-1c.275 0 .5.225.5.5l0 7c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-7c0-.275.225-.5.5-.5z"],"gif_24":["M21.5 3C22.881 3 24 4.119 24 5.5l0 13c0 1.381-1.119 2.5-2.5 2.5l-19 0C1.119 21 0 19.881 0 18.5l0-13C0 4.119 1.119 3 2.5 3l19 0zM23 18.5l0-13c0-.827-.673-1.5-1.5-1.5l-19 0C1.673 4 1 4.673 1 5.5l0 13c0 .827.673 1.5 1.5 1.5l19 0c.827 0 1.5-.673 1.5-1.5zM6 8c-.552 0-1 .448-1 1l0 6c0 .552.448 1 1 1l3 0 0-3-1.5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l2 0c.275 0 .5.225.5.5l0 4c0 .275-.225.5-.5.5L6 17c-1.104 0-2-.896-2-2l0-6c0-1.104.896-2 2-2l3.5 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L6 8zm6.5-1c.275 0 .5.225.5.5l0 9c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-9c0-.275.225-.5.5-.5zm7 1L16 8l0 3 3.5 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L16 12l0 4.5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-9c0-.275.225-.5.5-.5l4 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5z"],"github-circle_24":["M11.9988634 0C5.37271234 0-.0004 5.37237569-.0004 12.0007366c0 5.3009209 3.43793738 9.7981584 8.20699816 11.3848988.60036832.1104972.81915285-.2593002.81915285-.5782689 0-.2850829-.01031307-1.0394107-.01620626-2.0412523-3.33775322.7255985-4.04198895-1.6081032-4.04198895-1.6081032-.54585635-1.386372-1.33259668-1.7546961-1.33259668-1.7546961-1.08950277-.7447514.0825046-.7300184.0825046-.7300184 1.20441989.0854512 1.83793738 1.2368324 1.83793738 1.2368324 1.07034991 1.8335175 2.80810314 1.3038674 3.49244936.9974217.10902394-.7756906.41841621-1.304604.76169429-1.6044198-2.66445672-.3027625-5.46593002-1.3325967-5.46593002-5.9307551 0-1.3097606.46777164-2.38084715 1.23535912-3.21988951-.12375691-.30349908-.53554328-1.52338858.11712707-3.17569061 0 0 1.00773481-.32265193 3.30018416 1.23020258.95690608-.26666667 1.98379372-.39926335 3.00405152-.40441989 1.0187846.00515654 2.0456722.13775322 3.0040516.40441989 2.2909761-1.55285451 3.2965009-1.23020258 3.2965009-1.23020258.6548803 1.65230203.243094 2.87219153.1193371 3.17569061.7690607.83904236 1.2338858 1.91012891 1.2338858 3.21988951 0 4.6099447-2.8058932 5.6243094-5.4791897 5.9211786.4309392.3705341.8147329 1.1027625.8147329 2.2224678 0 1.6036832-.0147329 2.8987109-.0147329 3.2913444 0 .320442.2158379.6939226.825046.5775322C20.5638726 21.7944751 23.9996 17.3001842 23.9996 12.0007366 23.9996 5.37237569 18.6264877 0 11.9988634 0"],"github-circle_32":["M15.9990178 0C7.16414979 0 0 7.16316759 0 16.0009822c0 7.0678944 4.58391651 13.0642112 10.9426642 15.1798649.8004911.1473297 1.0922038-.3457335 1.0922038-.7710251 0-.3801105-.0137508-1.3858809-.0216083-2.7216698-4.45033766.9674647-5.38931863-2.1441375-5.38931863-2.1441375-.72780847-1.848496-1.77679558-2.3395948-1.77679558-2.3395948-1.45267035-.9930019.11000614-.9733579.11000614-.9733579 1.60589318.1139349 2.45058318 1.6491099 2.45058318 1.6491099 1.42713321 2.44469 3.74413749 1.7384899 4.65659909 1.3298956.1453653-1.0342541.5578883-1.739472 1.0155924-2.1392265-3.55260893-.4036832-7.28790666-1.7767956-7.28790666-7.9076734 0-1.7463475.62369552-3.1744629 1.64714549-4.293186-.16500921-.4046655-.7140577-2.03118479.15616943-4.23425416 0 0 1.34364641-.43020258 4.40024554 1.6402701 1.2758748-.35555555 2.6450583-.53235113 4.0054021-.53922651 1.3583794.00687538 2.7275629.18367096 4.0054021.53922651 3.0546347-2.07047268 4.3953345-1.6402701 4.3953345-1.6402701.8731738 2.20306937.3241253 3.82958866.1591161 4.23425416 1.0254143 1.1187231 1.6451811 2.5468385 1.6451811 4.293186 0 6.146593-3.741191 7.4990792-7.3055863 7.8949048.5745856.4940455 1.0863106 1.4703499 1.0863106 2.9632904 0 2.1382443-.0196439 3.8649478-.0196439 4.3884592 0 .427256.2877839.9252302 1.1000614.7700429C27.4190301 29.0593002 32 23.0669122 32 16.0009822 32 7.16316759 24.8358502 0 15.9990178 0"],"github-circle_40":["M19.9987723 0C8.95518723 0 0 8.95395948 0 20.0012277c0 8.8348681 5.72989564 16.330264 13.6783303 18.9748312 1.0006138.1841621 1.3652547-.4321669 1.3652547-.9637814 0-.4751382-.0171884-1.7323512-.0270104-3.4020872-5.56292205 1.2093309-6.73664826-2.6801719-6.73664826-2.6801719-.90976059-2.31062-2.22099448-2.9244935-2.22099448-2.9244935-1.81583794-1.2412523.13750767-1.2166974.13750767-1.2166974 2.00736649.1424187 3.06322898 2.0613874 3.06322898 2.0613874 1.78391649 3.0558624 4.68017189 2.1731123 5.82074889 1.6623695.1817066-1.2928177.6973604-2.1743401 1.2694905-2.6740331-4.4407612-.5046041-9.10988335-2.2209945-9.10988335-9.8845918 0-2.1829343.7796194-3.9680786 2.05893186-5.3664825-.20626151-.5058318-.89257213-2.538981.19521179-5.2928177 0 0 1.679558-.53775322 5.5003069 2.0503376 1.5948435-.44444441 3.3063229-.66543889 5.0067526-.67403312 1.6979743.00859423 3.4094537.22958871 5.0067527.67403312 3.8182934-2.58809082 5.4941682-2.0503376 5.4941682-2.0503376 1.0914671 2.7538367.4051565 4.7869859.198895 5.2928177 1.2817679 1.3984039 2.0564764 3.1835482 2.0564764 5.3664825 0 7.6832412-4.6764887 9.373849-9.1319829 9.868631.7182321.6175568 1.3578883 1.8379374 1.3578883 3.704113 0 2.6728054-.0245549 4.8311848-.0245549 5.485574 0 .53407.3597299 1.1565377 1.3750767.9625537C34.2737876 36.3241252 40 28.8336403 40 20.0012277 40 8.95395948 31.0448128 0 19.9987723 0"],"guest-issuer_36":["M27.6968639 17.165c4.158.794 7.303 4.444 7.303 8.835 0 4.971-4.029 9-9 9L2.53086388 35c-.482 0-.927-.216-1.218-.593-.2840000001-.365-.3800000001-.83-.2660000001-1.274L2.25786388 28.435c.976-3.789 4.467-6.435 8.488-6.435l2.69800002 0c-3.79600002-1.736-6.44400002-5.561-6.44400002-10 0-6.065 4.93500002-11 11.00000002-11 6.065 0 11 4.935 11 11 0 1.868-.477 3.623-1.303 5.165zm-1.697 16.835c4.411 0 8-3.589 8-8 0-4.411-3.589-8-8-8-4.411 0-8 3.589-8 8 0 4.411 3.589 8 8 8zm5.5898-9.8256c.264.264.409.615.409.988 0 .373-.145.724-.409.988l-5.439 5.44c-.262.263-.613.409-.988.409-.375 0-.725-.146-.989-.41l-.481-.481c-.183-.182-.197-.47-.036-.669.224-.276.342-.6.342-.94 0-.827-.673-1.5-1.5-1.5-.339 0-.664.118-.938.342-.199.163-.488.147-.67-.034l-.483-.484c-.263-.264-.409-.615-.409-.986 0-.374.146-.726.41-.99l5.439-5.44c.545-.545 1.431-.545 1.976 0l.483.484c.181.181.196.47.034.669-.223.276-.342.6-.342.939 0 .827.673 1.5 1.5 1.5.428 0 .748-.186.941-.342.197-.161.486-.147.669.035l.481.482zm-.707 1.269c.076-.076.116-.173.116-.281 0-.108-.04-.205-.116-.281l-.191-.192c-.367.204-.772.31-1.193.31-1.378 0-2.5-1.12-2.5-2.5 0-.421.107-.826.31-1.192l-.192-.193c-.155-.155-.407-.153-.562 0l-1.867 1.868.666.664c.194.195.194.511 0 .707-.099.097-.227.146-.355.146-.128 0-.256-.049-.352-.146l-.666-.664-2.866 2.866c-.075.075-.116.175-.116.282 0 .106.04.203.117.279l.193.193c.365-.204.77-.31 1.19-.31 1.379 0 2.5 1.122 2.5 2.5 0 .422-.106.826-.309 1.192l.191.192c.149.149.414.15.562.001l2.868-2.867-.664-.664c-.197-.196-.197-.512 0-.707.194-.196.51-.196.707 0l.664.664 1.865-1.867zm-4.5302-.7969l1 1c.195.194.195.512 0 .707-.098.098-.226.147-.354.147-.126 0-.254-.049-.353-.147l-1-1c-.194-.195-.194-.513 0-.707.195-.195.513-.195.707 0zM2.53086388 34l19.35800002 0c-2.901-1.494-4.889-4.513-4.889-8 0-1.054.19-2.061.523-3l-6.77700002 0c-3.564 0-6.656 2.338-7.519 5.685l-1.211 4.698c-.051.195.033.342.087.411.1.131.257.206.428.206zm5.469-22c0 5.496 4.45800002 9.969 9.94700002 9.997 1.475-2.959 4.522-4.997 8.053-4.997.215 0 .425.017.636.032.866-1.479 1.364-3.198 1.364-5.032 0-5.514-4.486-10-10-10-5.514 0-10.00000002 4.486-10.00000002 10z"],"guest-issuer_56":["M42.0006286 26C49.720282 26 56 32.28 56 40c0 7.72-6.279718 14-13.9993714 14L2.06342184 54c-.63497149 0-1.223945042-.288-1.617927351-.79-.3999820403-.511-.5389757992-1.166-.3829828036-1.798L1.89742929 43.975C3.34636424 38.102 8.53313134 34 14.509863 34l5.389758 0c-6.3437152-2.301-10.89751072-8.371-10.89751072-15.5 0-9.098 7.40166762-16.5 16.49925912-16.5 9.0975915 0 16.4992592 7.402 16.4992592 16.5 0 2.67-.6529707 5.294-1.8809155 7.642.6159723-.083 1.2409442-.142 1.8809155-.142zm0 27c7.1676782 0 12.9994163-5.832 12.9994163-13 0-7.168-5.8317381-13-12.9994163-13-7.1676782 0-12.9994163 5.832-12.9994163 13 0 7.168 5.8317381 13 12.9994163 13zm7.2004767-16.7771l1.3689385 1.37c.2769876.277.4299807.645.4299807 1.038 0 .393-.1529931.761-.4299807 1.038l-8.9006003 8.901c-.2859872.287-.6619703.429-1.0379534.429-.3759831 0-.7519663-.142-1.0389534-.429l-1.3689385-1.37c-.1949913-.195-.1949913-.511 0-.707l.2199901-.22c.3839828-.383.5879736-.914.5609748-1.455-.0269988-.548-.2789874-1.044-.7079682-1.396-.7519662-.612-1.9219137-.512-2.6658803.232l-.1229945.123c-.0939957.094-.22099.147-.3539841.147-.132994 0-.2599883-.053-.3529841-.147l-1.3699385-1.37c-.2769876-.277-.4299807-.645-.4299807-1.038 0-.392.1529931-.761.4299807-1.038l8.9006003-8.901c.5729743-.572 1.5039325-.572 2.0769068 0l1.3689385 1.37c.0939958.094.1469934.222.1469934.354 0 .132-.0539976.26-.1469934.354l-.1439935.143c-.7439666.744-.8449621 1.915-.2309896 2.665.3509842.429.8469619.681 1.3949373.709.5509753.036 1.0719519-.177 1.4549347-.56l.2409892-.242c.1879915-.187.5199766-.189.7079682 0zm.6619703 2.739c.088996-.089.1369938-.206.1369938-.331 0-.125-.0479978-.242-.1369938-.331l-1.0189543-1.02c-.5709744.513-1.3229406.77-2.0969058.744-.8219631-.041-1.5939285-.433-2.1189049-1.075-.8749607-1.07-.8169633-2.68.0979956-3.786l-1.024954-1.026c-.1839917-.183-.4809784-.182-.6629702 0l-2.5958834 2.596 1.3909375 1.393c.1949912.195.1949912.512 0 .707-.0979956.098-.2259899.147-.3539841.147-.1279943 0-.2559885-.049-.3529842-.147l-1.3909375-1.392-5.5977487 5.597c-.087996.089-.1369938.206-.1369938.331 0 .125.0489978.242.1369938.331l1.0279539 1.029c1.1049504-.898 2.7008787-.952 3.762831-.08.6429712.524 1.0339536 1.297 1.0749518 2.12.0369983.76-.22399 1.505-.7229676 2.074l1.0199542 1.02c.1819919.181.4799785.181.6619703 0l5.5967487-5.597-1.4119366-1.412c-.1959912-.196-.1959912-.512 0-.707.1949912-.196.5109771-.196.7069683 0l1.4119366 1.412 2.5968834-2.597zM2.06342184 53l34.77043876 0c-5.166768-2.062-8.8326034-7.105-8.8326034-13 0-1.764.3409847-3.444.9389578-5l-14.430352 0c-5.51575236 0-10.30353738 3.789-11.64247726 9.215l-1.83491761 7.437c-.08099636.331-.00899959.674.19999102.941.20299089.259.50597728.407.83096269.407zm7.93864356-34.5c0 8.547 6.9526878 15.5 15.499304 15.5 1.404937 0 2.7978744-.189 4.1408141-.561 1.8819155-3.533 5.2357649-6.16 9.2365853-7.076.0089996-.024.0109995-.05.0249988-.073 1.3719384-2.354 2.0969059-5.048 2.0969059-7.79 0-8.547-6.9526878-15.5-15.4993041-15.5-8.5466162 0-15.499304 6.953-15.499304 15.5zm33.3520024 19.1465l.9999551 1c.1949913.195.1949913.512 0 .707-.0979956.098-.2259898.147-.3539841.147-.1269943 0-.2549885-.049-.3529841-.147l-.9999551-1c-.1949913-.195-.1949913-.512 0-.707.1949912-.195.511977-.195.7069682 0z"],"handset_10":["M9.00040922 8.7035c0 .093-.042.179-.115.235-.043.033-.13.082-.246.053-1.478-.375-3.184-1.45-4.682-2.948-1.499-1.498-2.573-3.204-2.948-4.682-.029999996-.117.02-.204.053-.246.056-.073.142-.115.235-.115l1.038 0c.224 0 .425.132.513.338l.393.912c.096.223.089.476-.02.693l-.265.53c-.177.353-.133.784.111 1.098.596.765 1.456 1.621 2.362 2.348.315.253.75.299 1.108.12l.52-.26c.216-.108.468-.116.693-.02 0 .001 0 .001 0 .001l.912.392c.206.088.338.289.338.512l0 1.039zm.057-2.47l-.912-.392c-.495-.213-1.054-.197-1.536.044l-.554.255c-.835-.671-1.657-1.487-2.204-2.22l.264-.529c.241-.482.257-1.042.045-1.536l-.393-.913c-.246-.572-.809-.942-1.432-.942l-1.038 0c-.402999996 0-.776999996.182-1.024999996.501-.2460000003.316-.3310000003.72-.2320000003 1.106C.464409224 3.2795 1.60440922 5.1055 3.25040922 6.7505c1.645 1.646 3.471 2.786 5.143 3.21.106.027.212.04.318.04.282 0 .558-.093.788-.272.318-.248.50099998-.622.50099998-1.025l0-1.039c0-.623-.36999998-1.185-.94299998-1.431z"],"handset_12":["M1.4738 1c-.147 0-.285.067-.375.184-.052.066-.132.207-.084.396.463 1.825 1.787 3.93 3.631 5.774 1.845 1.844 3.949 3.168 5.774 3.632.19.047.329-.032.397-.084.116-.091.183-.228.183-.376l0-1.269c0-.318-.188-.604-.479-.729l-1.115-.48c-.304-.131-.648-.12-.942.028l-.635.317c-.401.201-.886.146-1.235-.135-1.101-.884-2.147-1.923-2.868-2.85-.273-.351-.321-.831-.125-1.225l.324-.647c.148-.295.157-.638.027-.941l-.479-1.115c-.125-.292-.412-.48-.729-.48l-1.27 0zm9.062 11c-.121 0-.242-.015-.362-.045-1.994-.507-4.267-1.926-6.235-3.894C1.9708 6.093.5518 3.82.0458 1.826-.0662 1.387.0298.929.3088.57c.282-.362.707-.57 1.165-.57l1.27 0c.717 0 1.364.426 1.647 1.085l.48 1.116c.247.573.228 1.223-.051 1.782l-.324.647c-.026.052-.019.115.02.164.665.855 1.676 1.859 2.704 2.685.049.038.11.045.162.02l.635-.318c.56-.278 1.209-.299 1.783-.052l1.115.48c.66.284 1.085.93 1.085 1.648l0 1.269c0 .459-.208.884-.569 1.165-.262.203-.575.309-.895.309z"],"handset_120":["M15.9727 7c-2.793 0-5.38 1.266-7.096 3.472-1.692 2.176-2.276 4.947-1.601 7.604 4.696 18.493 17.989 39.699 36.469 58.18 18.478 18.478 39.684 31.771 58.179 36.469 2.657.674 5.428.091 7.604-1.601 2.207-1.717 3.472-4.303 3.472-7.097l0-12.346c0-4.835-2.869-9.192-7.31-11.102l-10.845-4.662c-4.131-1.777-8.806-1.642-12.828.369l-6.175 3.088c-2.368 1.184-5.244.869-7.329-.805-10.46-8.396-20.372-18.241-27.192-27.01-1.649-2.121-1.936-4.911-.75-7.284l3.145-6.29c2.011-4.021 2.146-8.697.37-12.828l-4.665-10.846C37.5117 9.87 33.1537 7 28.3197 7l-12.347 0zm88.136 107c-.809 0-1.625-.101-2.431-.306-18.665-4.741-40.038-18.129-58.64-36.731-18.604-18.605-31.992-39.979-36.732-58.641-.75-2.958-.101-6.043 1.782-8.464C9.9947 7.406 12.8687 6 15.9727 6l12.347 0c5.234 0 9.953 3.107 12.02 7.916l4.664 10.846c1.893 4.402 1.75 9.385-.394 13.671l-3.145 6.29c-1.012 2.024-.765 4.408.645 6.222 6.775 8.71 16.627 18.495 27.029 26.844 1.781 1.43 4.236 1.701 6.256.69l6.175-3.087c4.286-2.144 9.268-2.288 13.67-.394l10.845 4.662c4.808 2.068 7.915 6.786 7.915 12.021l0 12.346c0 3.104-1.406 5.979-3.858 7.886-1.761 1.37-3.874 2.087-6.033 2.087z"],"handset_124":["M16.3269 7c-2.904 0-5.592 1.315-7.376 3.609-1.759 2.262-2.366 5.143-1.665 7.904 4.873 19.188 18.664 41.19 37.838 60.363 19.172 19.173 41.173 32.964 60.362 37.838 2.761.701 5.643.095 7.905-1.665 2.294-1.784 3.609-4.472 3.609-7.376l0-12.808c0-5.023-2.981-9.55-7.595-11.533l-11.25-4.838c-4.289-1.844-9.146-1.705-13.323.384l-6.407 3.204c-2.449 1.224-5.426.897-7.582-.833-10.851-8.71-21.132-18.921-28.206-28.017-1.706-2.194-2.004-5.082-.776-7.536l3.263-6.526c2.088-4.176 2.228-9.032.384-13.322l-4.839-11.253C38.6849 9.981 34.1579 7 29.1359 7l-12.809 0zm91.431 111c-.838 0-1.683-.104-2.518-.317-19.358-4.916-41.528-18.803-60.823-38.1-19.298-19.297-33.184-41.466-38.1-60.824-.778-3.062-.105-6.257 1.844-8.764C10.1359 7.456 13.1129 6 16.3269 6l12.809 0c5.422 0 10.31 3.219 12.452 8.2l4.838 11.252c1.962 4.562 1.813 9.725-.408 14.166l-3.263 6.525c-1.053 2.107-.796 4.588.671 6.475 7.029 9.037 17.25 19.188 28.043 27.851 1.853 1.488 4.408 1.769 6.509.718l6.407-3.204c4.441-2.22 9.604-2.369 14.165-.408l11.25 4.838c4.981 2.142 8.2 7.029 8.2 12.452l0 12.808c0 3.215-1.456 6.191-3.995 8.166-1.824 1.418-4.011 2.161-6.247 2.161z"],"handset_14":["M1.65086929 1c-.203 0-.391.092-.515.252-.122.157-.164000004.356-.116.546.552 2.173 2.125 4.675 4.316 6.867 2.19 2.19 4.69300001 3.763 6.86600001 4.315.191.049.389.007.546-.116.16-.124.252-.312.252-.515l0-1.5c0-.411-.244-.783-.623-.945l-1.317-.567c-.383-.164-.816-.152-1.18900001.035l-.75.375c-.44.22-.975.163-1.362-.148-1.296-1.04-2.526-2.263-3.375-3.355-.301-.386-.355-.916-.137-1.351l.382-.764c.186-.373.199-.806.034-1.189l-.566-1.318c-.163-.378-.534-.622-.946-.622l-1.5 0zM12.3598693 14c-.135 0-.27-.017-.404-.05-2.34300001-.596-5.01300001-2.264-7.32700001-4.578-2.315-2.315-3.984000004-4.986-4.5780000042-7.328-.125-.491-.017-1.004.2950000002-1.406.316-.406.791000004-.638 1.305000004-.638l1.5 0c.812 0 1.543.481 1.864 1.227l.567 1.318c.281.654.26 1.394-.059 2.031l-.382.764c-.046.094-.034.204.032.29.792 1.018 1.993 2.21 3.212 3.188.084.068.194.082.289.034l.75-.375c.63600001-.319 1.37600001-.34 2.03100001-.059l1.318.567c.745.321 1.227 1.053 1.227 1.864l0 1.5c0 .514-.233.989-.638 1.305-.292.227-.643.346-1.002.346z"],"handset_16":["M2.65186929 2c-.203 0-.392.092-.517.252-.121.157-.163000004.356-.115.546.552 2.173 2.125 4.676 4.317 6.867 2.19 2.19 4.69200001 3.763 6.86500001 4.315.191.047.39.006.547-.116.16-.124.252-.312.252-.515l0-1.5c0-.412-.245-.783-.622-.945l-1.318-.567c-.382-.164-.817-.152-1.18900001.035l-.75.375c-.442.219-.978.162-1.363-.149-1.295-1.039-2.525-2.262-3.375-3.354-.299-.385-.354-.915-.137-1.35l.383-.766c.186-.372.199-.805.034-1.188l-.567-1.318c-.163-.378-.534-.622-.945-.622l-1.5 0zM13.3598693 15c-.135 0-.27-.017-.404-.05-2.34300001-.596-5.01300001-2.264-7.32600001-4.578-2.316-2.315-3.984000004-4.985-4.5790000042-7.328-.125-.491-.017-1.003.2950000002-1.405.316-.406.792000004-.639 1.306000004-.639l1.5 0c.812 0 1.543.482 1.863 1.228l.567 1.317c.282.654.26 1.394-.058 2.031l-.383.765c-.046.093-.034.203.032.288.792 1.019 1.994 2.211 3.212 3.189.085.069.197.081.289.034l.75-.375c.63700001-.317 1.37600001-.339 2.03200001-.059l1.317.567c.746.32 1.228 1.052 1.228 1.864l0 1.5c0 .514-.233.989-.638 1.305-.293.227-.644.346-1.003.346z"],"handset_18":["M2.0052 1c-.313 0-.603.142-.796.39-.188.242-.253.55-.178.845.728 2.868 2.799 6.166 5.684 9.05 2.884 2.884 6.182 4.956 9.049 5.684.295.074.604.01.846-.179.248-.192.39-.482.39-.795l0-1.962c0-.6-.356-1.14-.907-1.377l-1.723-.741c-.542-.234-1.156-.216-1.684.048l-.981.491c-.523.26-1.157.191-1.616-.176-1.686-1.354-3.286-2.943-4.389-4.361-.357-.459-.421-1.088-.163-1.604l.499-.999c.264-.528.282-1.142.049-1.684l-.741-1.723C5.1072 1.356 4.5662 1 3.9672 1l-1.962 0zm14.004 17c-.164 0-.328-.021-.491-.062-3.037-.771-6.503-2.938-9.51-5.946C3.0002 8.985.8332 5.518.0612 2.481c-.151-.596-.02-1.218.359-1.706C.8032.283 1.3812 0 2.0052 0l1.962 0c.999 0 1.901.593 2.296 1.512l.741 1.723c.349.814.323 1.734-.073 2.526l-.5 1c-.088.175-.065.383.058.542 1.042 1.339 2.622 2.907 4.226 4.195.155.125.368.148.543.062l.981-.491c.792-.396 1.713-.422 2.526-.073l1.723.741c.918.395 1.512 1.296 1.512 2.296l0 1.962c0 .624-.283 1.201-.776 1.585-.354.275-.78.42-1.215.42z"],"handset_20":["M2.1781932.999950002c-.36599603 0-.70399237.164991748-.92798994.453977298-.22699754.29298535-.303996702.66796661-.2119977 1.02894856C1.86119664 5.68971551 4.1801715 9.37753112 7.40113658 12.59937c3.21996512 3.219839 6.90792512 5.539723 10.11589032 6.3616819.3599961.0909955.734992.0159992 1.0289889-.2119894.2879968-.2239888.453995-.5629718.453995-.9279536l0-2.1918904c0-.6939653-.4119955-1.319934-1.0499886-1.5949202l-1.9249791-.8279586c-.6219933-.2659867-1.3269856-.2479876-1.9329791.0569971l-1.0969881.5479726c-.5609939.2819859-1.2409865.2119894-1.7249813-.1759912-1.88997947-1.5149242-3.68196005-3.2928353-4.91494668-4.87975598-.38499583-.49497525-.45399508-1.17494125-.17599809-1.73091345l.55899394-1.11694416c.30199673-.60496975.3229965-1.3079346.0549994-1.93090345l-.82799102-1.92690365C5.69115512 1.4119294 5.06516191.999950002 4.37016944.999950002l-2.19197624 0zM17.8210236 20c-.183998 0-.368996-.0229989-.551994-.0699965-3.3769634-.8669567-7.2319216-3.280836-10.57488535-6.6236688C3.34918051 9.96150192.935206677 6.10669467.0702160547 2.73086346-.0997821024 2.06789661.0422163582 1.379931.460211827.840957952.874207339.306984651 1.50120054 0 2.1781932 0l2.19197624 0C5.46515757 0 6.45114688.648967552 6.8831422 1.65491725l.82799102 1.92690366c.38499583.8939553.35599614 1.9039048-.07899914 2.77286136l-.55799395 1.1179441c-.10899882.2159892-.08199911.47297635.06999924.6699665 1.1709873 1.50292485 2.94696803 3.26583673 4.75194853 4.71176443.179998.1469926.4359952.1689915.6519929.0619969l1.0969881-.5479726c.8689906-.4359782 1.8799796-.4649768 2.7739699-.079996l1.9259791.8279586C19.351007 13.5483226 20 14.5342733 20 15.6292185l0 2.1918904c0 .6769662-.3059967 1.3029349-.8409909 1.7179141-.3889958.3029849-.8579907.460977-1.3379855.460977z"],"handset_24":["M3.359 2c-.424 0-.815.192-1.076.526-.255.329-.344.746-.242 1.147.905 3.561 3.475 7.656 7.052 11.233 3.578 3.577 7.672 6.148 11.234 7.053.396.099.817.013 1.146-.242.334-.261.527-.653.527-1.076l0-2.423c0-.788-.468-1.498-1.193-1.811l-2.127-.914c-.7-.302-1.497-.278-2.179.063l-1.212.606c-.608.301-1.341.222-1.87-.205-2.076-1.665-4.044-3.621-5.403-5.367-.413-.532-.487-1.26-.189-1.856L8.444 7.5c.342-.684.365-1.478.063-2.18l-.915-2.129C7.28 2.468 6.57 2 5.782 2L3.359 2zm17.298 21c-.192 0-.385-.023-.576-.072-3.732-.948-7.994-3.615-11.695-7.315-3.7-3.7-6.366-7.963-7.314-11.694-.179-.701-.025-1.433.422-2.007C1.945 1.333 2.625 1 3.359 1l2.423 0c1.187 0 2.259.705 2.728 1.796l.915 2.13c.419.972.388 2.074-.087 3.021l-.617 1.235c-.129.257-.096.561.084.795 1.313 1.686 3.223 3.582 5.24 5.201.226.181.538.217.797.09l1.211-.607c.948-.472 2.049-.505 3.022-.088l0 .001 2.128.915c1.092.47 1.797 1.541 1.797 2.729l0 2.423c0 .734-.333 1.414-.912 1.865-.418.324-.919.494-1.431.494z"],"handset_26":["M25.0004207 23.287c0 .534-.242 1.028-.664 1.355-.413.323-.94.435-1.446.306-4.256-1.081-9.146-4.15-13.41699996-8.42-4.27-4.271-7.34-9.161-8.42-13.417-.128999997-.506-.017-1.033.305-1.448.328-.421.822-.663 1.355-.663l2.885 0c.976 0 1.856.58 2.242 1.476l1.089 2.535c.371.861.343 1.836-.076 2.674l-.735 1.47c-.339.677-.254 1.505.215 2.109 1.612 2.071 3.94999996 4.395 6.41599996 6.374.604.484 1.438.575 2.124.232l1.442-.722c.838-.419 1.814-.448 2.675-.077l2.533 1.09c.897.385 1.477 1.265 1.477 2.241l0 2.885zm-1.082-6.045l-2.533-1.09c-1.133-.486-2.413-.449-3.517.102l-1.443.721c-.337.171-.749.125-1.05-.117-2.408-1.932-4.687-4.196-6.25199996-6.209-.239-.306-.281-.707-.111-1.047l.735-1.469c.55099996-1.102.58799996-2.384.101-3.517l-1.089-2.535c-.544-1.264-1.785-2.081-3.161-2.081l-2.885 0c-.844 0-1.626.383-2.144999997 1.05-.5129999999.659-.69 1.5-.4849999999 2.307C1.20742074 7.782 4.37242074 12.841 8.76642074 17.235c4.39399996 4.394 9.45199996 7.558 13.87799996 8.682.219.056.442.083.663.083.588 0 1.164-.195 1.644-.568.667-.519 1.049-1.301 1.049-2.145l0-2.885c0-1.376-.817-2.616-2.082-3.16z"],"handset_28":["M3.7134 2c-.534 0-1.028.242-1.356.663-.322.415-.433.942-.305 1.447 1.081 4.256 4.15 9.147 8.421 13.417 4.27 4.27 9.16 7.339 13.416 8.421.505.128 1.033.017 1.447-.306.422-.328.664-.822.664-1.355l0-2.885c0-.976-.58-1.856-1.477-2.242l-2.533-1.089c-.861-.37-1.836-.342-2.675.077l-1.443.721c-.686.343-1.52.253-2.123-.232-2.466-1.979-4.805-4.302-6.416-6.374-.47-.604-.554-1.431-.216-2.108l.735-1.47c.419-.839.447-1.813.077-2.675l-1.09-2.534C8.4544 2.58 7.5744 2 6.5984 2l-2.885 0zm20.593 25c-.22 0-.443-.027-.663-.083-4.426-1.124-9.484-4.289-13.877-8.683-4.395-4.394-7.559-9.452-8.683-13.878-.205-.806-.028-1.647.485-2.307C2.0874 1.383 2.8694 1 3.7134 1l2.885 0c1.376 0 2.616.817 3.16 2.081l1.09 2.534c.487 1.133.45 2.415-.101 3.517l-.735 1.47c-.17.34-.128.741.11 1.047 1.566 2.013 3.845 4.276 6.253 6.208.299.241.712.288 1.05.118l1.443-.722c1.102-.551 2.384-.588 3.517-.101l2.533 1.09c1.265.543 2.082 1.784 2.082 3.16l0 2.885c0 .844-.383 1.626-1.05 2.145-.479.373-1.055.568-1.644.568z"],"handset_32":["M4.0673 2c-.644 0-1.24.292-1.635.8-.389.501-.524 1.137-.369 1.748 1.257 4.95 4.825 10.636 9.789 15.6 4.963 4.963 10.649 8.531 15.6 9.789.61.154 1.247.02 1.747-.369.509-.395.801-.992.801-1.635l0-3.347c0-1.164-.692-2.214-1.761-2.673l-2.939-1.265c-1.021-.438-2.176-.405-3.17.092l-1.674.837c-.768.384-1.701.282-2.377-.26-2.857-2.293-5.565-4.983-7.43-7.381-.526-.676-.62-1.603-.241-2.361l.852-1.705c.497-.994.53-2.149.091-3.169l-1.263-2.94C9.6273 2.691 8.5783 2 7.4133 2l-3.346 0zm23.888 29c-.249 0-.501-.031-.749-.094-5.12-1.301-10.974-4.964-16.061-10.051-5.088-5.087-8.751-10.941-10.051-16.061-.232-.912-.032-1.862.548-2.608C2.2293 1.432 3.1123 1 4.0673 1l3.346 0c1.565 0 2.975.929 3.593 2.366l1.264 2.94c.556 1.291.514 2.754-.115 4.012l-.853 1.704c-.211.422-.159.92.137 1.3 1.819 2.339 4.467 4.969 7.266 7.215.372.298.883.356 1.304.145l1.674-.837c1.257-.629 2.72-.671 4.012-.115l2.939 1.264c1.437.618 2.366 2.028 2.366 3.592l0 3.347c0 .954-.433 1.838-1.187 2.425-.542.421-1.193.642-1.858.642z"],"handset_36":["M4.42169507 2c-.754 0-1.453.342-1.916.937-.456.586-.613000004 1.334-.432 2.048 1.435 5.646 5.501 12.128 11.15800003 17.784 5.655 5.656 12.137 9.722 17.783 11.157.717.178 1.462.024 2.048-.432.595-.463.937-1.162.937-1.916l0-3.807c0-1.353-.803-2.573-2.045-3.107l-3.345-1.437c-1.179-.507-2.514-.47-3.665.105l-1.905.952c-.852.427-1.884.313-2.632-.288-3.246-2.606-6.323-5.663-8.442-8.388-.582-.748-.687-1.773-.268-2.612l.97-1.94c.575-1.15.613-2.485.107-3.665l-1.439-3.346C10.80169507 2.803 9.58169507 2 8.22969507 2l-3.808 0zM31.6046951 35c-.279 0-.559-.035-.836-.105-5.816-1.477-12.465-5.639-18.244-11.419-5.78100003-5.78-9.94300003-12.429-11.419000034-18.245-.259-1.016-.0369999998-2.076.611-2.908C2.36969507 1.482 3.35669507 1 4.42169507 1l3.808 0c1.753 0 3.33300003 1.04 4.02400003 2.65l1.439 3.346c.625 1.451.577 3.094-.13 4.507l-.97 1.94c-.252.504-.19 1.099.162 1.552 2.073 2.665 5.091 5.662 8.28 8.222.444.355 1.055.426 1.558.173l1.905-.953c1.415-.708 3.059-.753 4.507-.128l3.345 1.437c1.61.691 2.65 2.272 2.65 4.025l0 3.807c0 1.066-.482 2.052-1.323 2.705-.606.471-1.33.717-2.072.717z"],"handset_40":["M4.7756 2c-.864 0-1.665.392-2.196 1.074-.522.673-.703 1.529-.494 2.349 1.609 6.339 6.175 13.617 12.525 19.967 6.349 6.35 13.627 10.915 19.967 12.526.821.208 1.676.027 2.348-.496.683-.531 1.074-1.331 1.074-2.195l0-4.27c0-1.54-.914-2.93-2.33-3.538l-3.75-1.612c-1.339-.577-2.856-.533-4.16.119l-2.135 1.068c-.933.467-2.065.343-2.886-.315-3.636-2.92-7.083-6.344-9.456-9.395-.639-.821-.754-1.946-.294-2.865l1.088-2.176c.652-1.304.696-2.821.12-4.16l-1.613-3.75C11.9746 2.915 10.5856 2 9.0456 2l-4.27 0zm30.478 37c-.307 0-.616-.038-.922-.116-6.51-1.653-13.955-6.314-20.428-12.787-6.474-6.473-11.135-13.919-12.788-20.428-.285-1.122-.038-2.291.675-3.209.722-.928 1.81-1.46 2.985-1.46l4.27 0c1.94 0 3.69 1.152 4.456 2.935l1.613 3.751c.693 1.611.64 3.434-.144 5.002l-1.087 2.176c-.294.586-.222 1.278.188 1.804 2.328 2.993 5.715 6.356 9.293 9.228.517.415 1.228.496 1.812.202l2.136-1.068c1.568-.784 3.391-.837 5.002-.144l3.75 1.612c1.783.767 2.935 2.517 2.935 4.457l0 4.27c0 1.175-.532 2.263-1.46 2.985-.668.519-1.468.79-2.286.79z"],"handset_48":["M6.3066 3c-1.03 0-1.983.466-2.615 1.28-.624.801-.839 1.821-.59 2.799 1.874 7.381 7.187 15.852 14.577 23.242 7.39 7.39 15.861 12.703 23.243 14.578.977.247 1.997.033 2.798-.59.814-.633 1.28-1.586 1.28-2.616l0-4.962c0-1.823-1.082-3.466-2.757-4.186l-4.358-1.874c-1.578-.678-3.366-.628-4.903.141l-2.482 1.241c-1.056.528-2.338.387-3.266-.357-4.221-3.388-8.222-7.363-10.977-10.904-.734-.944-.861-2.188-.333-3.245l1.264-2.528c.769-1.537.821-3.324.142-4.903l-1.875-4.359C14.7346 4.082 13.0916 3 11.2686 3l-4.962 0zm35.42 43c-.35 0-.703-.043-1.052-.132-7.55-1.918-16.19-7.326-23.703-14.84-7.513-7.513-12.922-16.153-14.84-23.703-.324-1.279-.044-2.613.77-3.659C3.7246 2.607 4.9666 2 6.3066 2l4.962 0c2.223 0 4.227 1.32 5.105 3.362l1.874 4.359c.796 1.85.736 3.944-.165 5.745l-1.264 2.528c-.355.71-.268 1.547.228 2.183 2.708 3.483 6.65 7.397 10.813 10.739.624.501 1.486.596 2.193.243l2.482-1.241c1.801-.902 3.895-.961 5.745-.166l4.358 1.874c2.043.878 3.362 2.882 3.362 5.105l0 4.962c0 1.341-.607 2.582-1.666 3.405-.761.592-1.674.902-2.607.902z"],"handset_56":["M7.014683 3c-1.25 0-2.407.566-3.176 1.554-.756.973-1.017 2.212-.716 3.399 2.227 8.771 8.538 18.834 17.314 27.61 8.775 8.775 18.838 15.086 27.609 17.314 1.187.3 2.427.04 3.4-.716.987-.768 1.554-1.926 1.554-3.176l0-5.885c0-2.199-1.306-4.182-3.326-5.051l-5.169-2.222c-1.898-.817-4.046-.755-5.894.17l-2.943 1.471c-1.221.611-2.702.448-3.774-.414-5.001-4.013-9.741-8.721-13.004-12.917-.849-1.091-.996-2.527-.385-3.749l1.499-2.998c.924-1.848.986-3.996.17-5.894l-2.223-5.17c-.869-2.02-2.852-3.326-5.051-3.326l-5.885 0zm42.01 51c-.408 0-.819-.051-1.225-.154-8.94-2.271-19.171-8.677-28.07-17.576-8.9-8.899-15.306-19.131-17.576-28.071-.378-1.489-.051-3.041.896-4.259.959-1.233 2.404-1.94 3.965-1.94l5.885 0c2.6 0 4.943 1.543 5.969 3.931l2.223 5.17c.933 2.17.863 4.625-.193 6.736l-1.499 2.998c-.438.874-.331 1.904.279 2.688 3.218 4.137 7.898 8.785 12.841 12.751.768.618 1.828.736 2.7.3l2.944-1.472c2.111-1.056 4.566-1.127 6.736-.194l5.169 2.222c2.388 1.027 3.931 3.37 3.931 5.97l0 5.885c0 1.561-.707 3.006-1.941 3.965-.885.689-1.948 1.05-3.034 1.05z"],"handset_64":["M8.5459 4c-1.415 0-2.726.642-3.595 1.759-.857 1.102-1.153 2.506-.812 3.85 2.492 9.812 9.551 21.069 19.367 30.885 9.815 9.816 21.072 16.874 30.884 19.366 1.345.341 2.748.046 3.85-.81 1.119-.87 1.76-2.181 1.76-3.596l0-6.577c0-2.481-1.473-4.719-3.753-5.7l-5.777-2.484c-2.138-.918-4.556-.848-6.637.192l-3.29 1.645c-1.342.669-2.972.492-4.154-.456-5.587-4.484-10.88-9.743-14.524-14.428-.934-1.201-1.097-2.782-.424-4.127l1.675-3.351c1.041-2.081 1.11-4.5.191-6.637l-2.484-5.778C19.8419 5.474 17.6049 4 15.1239 4l-6.578 0zm46.952 57c-.45 0-.905-.057-1.354-.171-9.981-2.535-21.406-9.688-31.345-19.628-9.94-9.939-17.094-21.364-19.629-31.346-.418-1.646-.057-3.363.991-4.709C5.2219 3.782 6.8199 3 8.5459 3l6.578 0c2.881 0 5.479 1.711 6.617 4.358l2.485 5.779c1.036 2.407.957 5.134-.215 7.478l-1.676 3.351c-.499.998-.377 2.173.319 3.067 3.598 4.626 8.832 9.823 14.361 14.262.877.704 2.087.838 3.081.341l3.29-1.646c2.345-1.172 5.071-1.252 7.479-.215l5.777 2.484c2.647 1.138 4.358 3.736 4.358 6.618l0 6.577c0 1.727-.782 3.324-2.146 4.385-.98.762-2.155 1.161-3.356 1.161z"],"handset_8":["M1.1196 1c-.051 0-.082.029-.095.047.158.729.514 1.487 1.019 2.224l.475-.925c.068-.135.073-.297.011-.441l-.306-.709c-.05-.119-.167-.196-.296-.196l-.808 0zm3.619 4.969c.722.501 1.451.858 2.119 1.028.113-.035.142-.065.142-.117l0-.807c0-.13-.076-.246-.195-.297l-.71-.305c-.143-.062-.306-.057-.445.012l-.911.486zM6.8866 8c-.092 0-.184-.011-.275-.034-1.32-.336-2.758-1.233-4.052-2.526-1.293-1.294-2.19-2.732-2.525-4.052-.085-.334-.012-.682.2-.955C.4496.158.7716 0 1.1196 0l.808 0c.529 0 1.006.314 1.215.801l.306.709c.178.415.165.884-.037 1.288l-.693 1.346c.173.2.356.397.548.589.198.198.401.386.606.563l1.318-.701c.414-.207.884-.221 1.299-.043l.71.305c.486.209.8.686.8 1.216l0 .807c0 .349-.157.671-.432.885-.199.154-.437.235-.681.235z"],"handset-active_10":["M9.05740922 6.2335l-.912-.392c-.495-.213-1.054-.197-1.536.044l-.554.255c-.835-.671-1.657-1.487-2.204-2.22l.264-.529c.241-.482.257-1.042.045-1.536l-.393-.913c-.246-.572-.809-.942-1.432-.942l-1.038 0c-.402999996 0-.776999996.182-1.024999996.501-.2460000003.316-.3310000003.72-.2320000003 1.106C.464409224 3.2795 1.60440922 5.1055 3.25040922 6.7505c1.645 1.646 3.471 2.786 5.143 3.21.106.027.212.04.318.04.282 0 .558-.093.788-.272.318-.248.50099998-.622.50099998-1.025l0-1.039c0-.623-.36999998-1.185-.94299998-1.431z"],"handset-active_12":["M10.5358 12c-.121 0-.242-.015-.362-.045-1.994-.507-4.267-1.926-6.235-3.894C1.9708 6.093.5518 3.82.0458 1.826-.0662 1.387.0298.929.3088.57c.282-.362.707-.57 1.165-.57l1.27 0c.717 0 1.364.426 1.647 1.085l.48 1.116c.247.573.228 1.223-.051 1.782l-.324.647c-.026.052-.019.115.02.164.665.855 1.676 1.859 2.704 2.685.049.038.11.045.162.02l.635-.318c.56-.278 1.209-.299 1.783-.052l1.115.48c.66.284 1.085.93 1.085 1.648l0 1.269c0 .459-.208.884-.569 1.165-.262.203-.575.309-.895.309z"],"handset-active_14":["M12.3598693 14c-.135 0-.27-.017-.404-.05-2.34300001-.596-5.01300001-2.264-7.32700001-4.578-2.315-2.315-3.984000004-4.986-4.5780000042-7.328-.125-.491-.017-1.004.2950000002-1.406.316-.406.791000004-.638 1.305000004-.638l1.5 0c.812 0 1.543.481 1.864 1.227l.567 1.318c.281.654.26 1.394-.059 2.031l-.382.764c-.046.094-.034.204.032.29.792 1.018 1.993 2.21 3.212 3.188.084.068.194.082.289.034l.75-.375c.63600001-.319 1.37600001-.34 2.03100001-.059l1.318.567c.745.321 1.227 1.053 1.227 1.864l0 1.5c0 .514-.233.989-.638 1.305-.292.227-.643.346-1.002.346z"],"handset-active_16":["M13.3598693 15c-.135 0-.27-.017-.404-.05-2.34300001-.596-5.01300001-2.264-7.32600001-4.578-2.316-2.315-3.984000004-4.985-4.5790000042-7.328-.125-.491-.017-1.003.2950000002-1.405.316-.406.792000004-.639 1.306000004-.639l1.5 0c.812 0 1.543.482 1.863 1.228l.567 1.317c.282.654.26 1.394-.058 2.031l-.383.765c-.046.093-.034.203.032.288.792 1.019 1.994 2.211 3.212 3.189.085.069.197.081.289.034l.75-.375c.63700001-.317 1.37600001-.339 2.03200001-.059l1.317.567c.746.32 1.228 1.052 1.228 1.864l0 1.5c0 .514-.233.989-.638 1.305-.293.227-.644.346-1.003.346z"],"handset-active_18":["M16.0092 18c-.164 0-.328-.021-.491-.062-3.037-.771-6.503-2.938-9.51-5.946C3.0002 8.985.8332 5.518.0612 2.481c-.151-.596-.02-1.218.359-1.706C.8032.283 1.3812 0 2.0052 0l1.962 0c.999 0 1.901.593 2.296 1.512l.741 1.723c.349.814.323 1.734-.073 2.526l-.5 1c-.088.175-.065.383.058.542 1.042 1.339 2.622 2.907 4.226 4.195.155.125.368.148.543.062l.981-.491c.792-.396 1.713-.422 2.526-.073l1.723.741c.918.395 1.512 1.296 1.512 2.296l0 1.962c0 .624-.283 1.201-.776 1.585-.354.275-.78.42-1.215.42z"],"handset-active_20":["M17.8210236 20c-.183998 0-.368996-.0229989-.551994-.0699965-3.3769634-.8669567-7.2319216-3.280836-10.57488535-6.6236688C3.34918051 9.96150192.935206677 6.10669467.0702160547 2.73086346-.0997821024 2.06789661.0422163582 1.379931.460211827.840957952.874207339.306984651 1.50120054 0 2.1781932 0l2.19197624 0C5.46515757 0 6.45114688.648967552 6.8831422 1.65491725l.82799102 1.92690366c.38499583.8939553.35599614 1.9039048-.07899914 2.77286136l-.55799395 1.1179441c-.10899882.2159892-.08199911.47297635.06999924.6699665 1.1709873 1.50292485 2.94696803 3.26583673 4.75194853 4.71176443.179998.1469926.4359952.1689915.6519929.0619969l1.0969881-.5479726c.8689906-.4359782 1.8799796-.4649768 2.7739699-.079996l1.9259791.8279586C19.351007 13.5483226 20 14.5342733 20 15.6292185l0 2.1918904c0 .6769662-.3059967 1.3029349-.8409909 1.7179141-.3889958.3029849-.8579907.460977-1.3379855.460977z"],"handset-active_24":["M20.657 23c-.192 0-.385-.023-.576-.072-3.732-.948-7.994-3.615-11.695-7.315-3.7-3.7-6.366-7.963-7.314-11.694-.179-.701-.025-1.433.422-2.007C1.945 1.333 2.625 1 3.359 1l2.423 0c1.187 0 2.259.705 2.728 1.796l.915 2.13c.419.972.388 2.074-.087 3.021l-.617 1.235c-.129.257-.096.561.084.795 1.313 1.686 3.223 3.582 5.24 5.201.226.181.538.217.797.09l1.211-.607c.948-.472 2.049-.505 3.022-.088l0 .001 2.128.915c1.092.47 1.797 1.541 1.797 2.729l0 2.423c0 .734-.333 1.414-.912 1.865-.418.324-.919.494-1.431.494z"],"handset-active_26":["M23.9184207 17.242l-2.533-1.09c-1.133-.486-2.413-.449-3.517.102l-1.443.721c-.337.171-.749.125-1.05-.117-2.408-1.932-4.687-4.196-6.25199996-6.209-.239-.306-.281-.707-.111-1.047l.735-1.469c.55099996-1.102.58799996-2.384.101-3.517l-1.089-2.535c-.544-1.264-1.785-2.081-3.161-2.081l-2.885 0c-.844 0-1.626.383-2.144999997 1.05-.5129999999.659-.69 1.5-.4849999999 2.307C1.20742074 7.782 4.37242074 12.841 8.76642074 17.235c4.39399996 4.394 9.45199996 7.558 13.87799996 8.682.219.056.442.083.663.083.588 0 1.164-.195 1.644-.568.667-.519 1.049-1.301 1.049-2.145l0-2.885c0-1.376-.817-2.616-2.082-3.16z"],"handset-active_28":["M24.3064 27c-.22 0-.443-.027-.663-.083-4.426-1.124-9.484-4.289-13.877-8.683-4.395-4.394-7.559-9.452-8.683-13.878-.205-.806-.028-1.647.485-2.307C2.0874 1.383 2.8694 1 3.7134 1l2.885 0c1.376 0 2.616.817 3.16 2.081l1.09 2.534c.487 1.133.45 2.415-.101 3.517l-.735 1.47c-.17.34-.128.741.11 1.047 1.566 2.013 3.845 4.276 6.253 6.208.299.241.712.288 1.05.118l1.443-.722c1.102-.551 2.384-.588 3.517-.101l2.533 1.09c1.265.543 2.082 1.784 2.082 3.16l0 2.885c0 .844-.383 1.626-1.05 2.145-.479.373-1.055.568-1.644.568z"],"handset-active_32":["M27.9553 31c-.249 0-.501-.031-.749-.094-5.12-1.301-10.974-4.964-16.061-10.051-5.088-5.087-8.751-10.941-10.051-16.061-.232-.912-.032-1.862.548-2.608C2.2293 1.432 3.1123 1 4.0673 1l3.346 0c1.565 0 2.975.929 3.593 2.366l1.264 2.94c.556 1.291.514 2.754-.115 4.012l-.853 1.704c-.211.422-.159.92.137 1.3 1.819 2.339 4.467 4.969 7.266 7.215.372.298.883.356 1.304.145l1.674-.837c1.257-.629 2.72-.671 4.012-.115l2.939 1.264c1.437.618 2.366 2.028 2.366 3.592l0 3.347c0 .954-.433 1.838-1.187 2.425-.542.421-1.193.642-1.858.642z"],"handset-active_36":["M31.6046951 35c-.279 0-.559-.035-.836-.105-5.816-1.477-12.465-5.639-18.244-11.419-5.78100003-5.78-9.94300003-12.429-11.419000034-18.245-.259-1.016-.0369999998-2.076.611-2.908C2.36969507 1.482 3.35669507 1 4.42169507 1l3.808 0c1.753 0 3.33300003 1.04 4.02400003 2.65l1.439 3.346c.625 1.451.577 3.094-.13 4.507l-.97 1.94c-.252.504-.19 1.099.162 1.552 2.073 2.665 5.091 5.662 8.28 8.222.444.355 1.055.426 1.558.173l1.905-.953c1.415-.708 3.059-.753 4.507-.128l3.345 1.437c1.61.691 2.65 2.272 2.65 4.025l0 3.807c0 1.066-.482 2.052-1.323 2.705-.606.471-1.33.717-2.072.717z"],"handset-active_40":["M35.2536 39c-.307 0-.616-.038-.922-.116-6.51-1.653-13.955-6.314-20.428-12.787-6.474-6.473-11.135-13.919-12.788-20.428-.285-1.122-.038-2.291.675-3.209.722-.928 1.81-1.46 2.985-1.46l4.27 0c1.94 0 3.69 1.152 4.456 2.935l1.613 3.751c.693 1.611.64 3.434-.144 5.002l-1.087 2.176c-.294.586-.222 1.278.188 1.804 2.328 2.993 5.715 6.356 9.293 9.228.517.415 1.228.496 1.812.202l2.136-1.068c1.568-.784 3.391-.837 5.002-.144l3.75 1.612c1.783.767 2.935 2.517 2.935 4.457l0 4.27c0 1.175-.532 2.263-1.46 2.985-.668.519-1.468.79-2.286.79z"],"handset-active_48":["M41.7266 46c-.35 0-.703-.043-1.052-.132-7.55-1.918-16.19-7.326-23.703-14.84-7.513-7.513-12.922-16.153-14.84-23.703-.324-1.279-.044-2.613.77-3.659C3.7246 2.607 4.9666 2 6.3066 2l4.962 0c2.223 0 4.227 1.32 5.105 3.362l1.874 4.359c.796 1.85.736 3.944-.165 5.745l-1.264 2.528c-.355.71-.268 1.547.228 2.183 2.708 3.483 6.65 7.397 10.813 10.739.624.501 1.486.596 2.193.243l2.482-1.241c1.801-.902 3.895-.961 5.745-.166l4.358 1.874c2.043.878 3.362 2.882 3.362 5.105l0 4.962c0 1.341-.607 2.582-1.666 3.405-.761.592-1.674.902-2.607.902z"],"handset-active_56":["M49.024683 54c-.408 0-.819-.051-1.225-.154-8.94-2.271-19.171-8.677-28.07-17.576-8.9-8.899-15.306-19.131-17.576-28.071-.378-1.489-.051-3.041.896-4.259.959-1.233 2.404-1.94 3.965-1.94l5.885 0c2.6 0 4.943 1.543 5.969 3.931l2.223 5.17c.933 2.17.863 4.625-.193 6.736l-1.499 2.998c-.438.874-.331 1.904.279 2.688 3.218 4.137 7.898 8.785 12.841 12.751.768.618 1.828.736 2.7.3l2.944-1.472c2.111-1.056 4.566-1.127 6.736-.194l5.169 2.222c2.388 1.027 3.931 3.37 3.931 5.97l0 5.885c0 1.561-.707 3.006-1.941 3.965-.885.689-1.948 1.05-3.034 1.05z"],"handset-active_64":["M55.4979 61c-.45 0-.905-.057-1.354-.171-9.981-2.535-21.406-9.688-31.345-19.628-9.94-9.939-17.094-21.364-19.629-31.346-.418-1.646-.057-3.363.991-4.709C5.2219 3.782 6.8199 3 8.5459 3l6.578 0c2.881 0 5.479 1.711 6.617 4.358l2.485 5.779c1.036 2.407.957 5.134-.215 7.478l-1.676 3.351c-.499.998-.377 2.173.319 3.067 3.598 4.626 8.832 9.823 14.361 14.262.877.704 2.087.838 3.081.341l3.29-1.646c2.345-1.172 5.071-1.252 7.479-.215l5.777 2.484c2.647 1.138 4.358 3.736 4.358 6.618l0 6.577c0 1.727-.782 3.324-2.146 4.385-.98.762-2.155 1.161-3.356 1.161z"],"handset-active_8":["M6.8866 8c-.092 0-.184-.011-.275-.034-1.32-.336-2.758-1.233-4.052-2.526-1.293-1.294-2.19-2.732-2.525-4.052-.085-.334-.012-.682.2-.955C.4496.158.7716 0 1.1196 0l.808 0c.529 0 1.006.314 1.215.801l.306.709c.178.415.165.884-.037 1.288l-.693 1.346c.173.2.356.397.548.589.198.198.401.386.606.563l1.318-.701c.414-.207.884-.221 1.299-.043l.71.305c.486.209.8.686.8 1.216l0 .807c0 .349-.157.671-.432.885-.199.154-.437.235-.681.235z"],"handset-muted_12":["M11 10.5259c0 .148-.067.285-.183.376-.068.052-.207.131-.397.084-1.707-.434-3.656-1.627-5.411-3.288l.441-.441c.368.345.749.684 1.144 1.001.349.281.834.336 1.235.135l.635-.317c.294-.148.638-.159.942-.028l1.115.48c.292.125.479.411.479.729l0 1.269zm-9.985-8.946c-.048-.189.032-.33.084-.396.09-.117.228-.184.375-.184l1.27 0c.317 0 .604.188.729.48l.479 1.115c.13.303.121.646-.027.941l-.324.647c-.196.394-.148.874.125 1.225.288.37.637.759 1.011 1.147l-.435.436c-1.661-1.754-2.854-3.704-3.287-5.411zm9.9 6.029l-1.115-.48c-.574-.247-1.223-.226-1.783.052l-.635.318c-.052.025-.113.018-.162-.02-.363-.291-.718-.608-1.062-.93l5.696-5.695c.195-.196.195-.512 0-.707-.196-.196-.512-.196-.708 0l-5.701 5.7c-.345-.36-.669-.718-.929-1.053-.039-.049-.046-.112-.02-.164l.324-.647c.279-.559.298-1.209.051-1.782l-.48-1.116c-.283-.659-.93-1.085-1.647-1.085l-1.27 0c-.458 0-.883.208-1.165.57-.279.359-.375.817-.263 1.256.475 1.874 1.764 3.991 3.549 5.872l-3.449 3.449c-.195.195-.195.511 0 .707.098.097.226.146.354.146.128 0 .256-.049.354-.146l3.448-3.449c1.882 1.786 3.999 3.074 5.872 3.55.12.03.241.045.362.045.32 0 .633-.106.895-.309.361-.281.569-.706.569-1.165l0-1.269c0-.718-.425-1.364-1.085-1.648z"],"handset-muted_16":["M8.7576 10.5977c.385.311.921.367 1.363.148l.75-.375c.372-.186.807-.199 1.189-.035l1.318.568c.377.162.622.533.622.945l0 1.5c0 .202-.092.391-.252.515-.157.122-.356.163-.547.116-2.055-.523-4.401-1.965-6.502-3.972l.649-.648c.453.426.922.846 1.41 1.238m-6.738-7.801c-.048-.189-.006-.388.115-.545.124-.16.314-.253.517-.253l1.5 0c.411 0 .782.245.945.622l.566 1.319c.165.383.152.816-.034 1.187l-.382.767c-.218.434-.163.965.136 1.35.355.456.787.936 1.252 1.415l-.643.642c-2.008-2.101-3.451-4.449-3.972-6.504m13.834-2.65c-.195-.195-.512-.195-.707 0l-7.804 7.804c-.437-.453-.845-.902-1.171-1.322-.066-.086-.078-.195-.032-.289l.383-.764c.318-.637.34-1.377.058-2.031l-.567-1.317c-.32-.746-1.051-1.229-1.862-1.229l-1.5 0c-.514 0-.99.234-1.306.64-.312.401-.42.914-.295 1.404.564 2.223 2.102 4.737 4.234 6.965l-5.138 5.139c-.195.195-.195.512 0 .707.098.098.226.146.353.146.128 0 .256-.048.354-.146l5.138-5.139c2.227 2.131 4.74 3.669 6.963 4.235.134.033.269.049.404.049.359 0 .71-.118 1.003-.345.405-.316.638-.791.638-1.305l0-1.5c0-.813-.482-1.544-1.228-1.864l-1.317-.567c-.656-.281-1.395-.258-2.032.059l-.75.375c-.092.047-.204.035-.289-.034-.454-.365-.898-.763-1.327-1.167l7.797-7.797c.195-.195.195-.512 0-.707"],"handset-muted_20":["M18.9995369 17.8213c0 .365-.1659958.704-.4539886.928-.2939927.228-.6689833.303-1.0289743.212-3.0899228-.792-6.6198345-2.982-9.7527562-6.018l1.2759681-1.276c.70898228.678 1.4559636 1.347 2.2299443 1.968.4839879.388 1.1639709.458 1.7249568.176l1.0969726-.548c.6059849-.305 1.3109672-.323 1.9329517-.057l1.9249519.828c.637984.275 1.0499737.901 1.0499737 1.595l0 2.192zM1.03798595 2.4833c-.091997701-.361-.01499963-.736.2119947-1.029.2239944-.289.56198595-.454.9279768-.454l2.1919452 0c.69498263 0 1.32096698.412 1.59496013 1.05l.8279793 1.926c.2679933.623.24699382 1.326-.05499863 1.931l-.55898602 1.117c-.27799305.556-.20899478 1.236.1759956 1.731.55398615.713 1.2319692 1.464 1.96895077 2.213l-1.26696832 1.268c-3.03692408-3.135-5.22586936-6.665-6.01884953-9.753zm17.30656735 10.633l-1.9259519-.828c-.8939776-.385-1.9049523-.356-2.7739306.08l-1.0969726.548c-.2159946.107-.4719882.085-.6519837-.062-.7369816-.591-1.4589635-1.239-2.14694632-1.896L19.8535156.8533c.1949951-.195.1949951-.511 0-.707-.1959951-.195-.5119872-.195-.7079823 0L9.03378605 10.2593c-.7119822-.723-1.36696582-1.446-1.88995275-2.117-.1519962-.196-.17899552-.454-.06999825-.67l.55798605-1.118c.43498913-.868.4639884-1.879.07899803-2.772l-.8279793-1.928C6.45085063.6493 5.46487528.0003 4.36990265.0003l-2.1919452 0c-.67698308 0-1.303967401.307-1.717957051.841-.4179895505.539-.5599860006 1.227-.3899902504 1.89C.904989274 5.9863 3.1879322 9.6833 6.34985315 12.9433l-6.203844901 6.203c-.1949951255.196-.1949951255.512 0 .707.09799755.098.22599435.147.35399115.147.1279968 0 .2559936-.049.35399115-.147l6.202844931-6.203c3.25791852 3.159 6.95482612 5.443 10.21174472 6.28.1829954.047.3679908.07.5519862.07.479988 0 .9489763-.158 1.3379665-.461.5349867-.415.840979-1.041.840979-1.718l0-2.192c0-1.095-.6489838-2.081-1.6549586-2.513z"],"handset-muted_24":["M13.4189 15.957c.529.427 1.262.506 1.87.205l1.212-.606c.682-.341 1.479-.365 2.179-.063l2.127.914c.725.313 1.193 1.023 1.193 1.811l0 2.423c0 .423-.193.815-.527 1.076-.329.255-.75.342-1.146.242-3.443-.875-7.38-3.316-10.87-6.708l1.62-1.62 2.342 2.326zM2.0409 3.673c-.102-.402-.013-.818.242-1.148.261-.334.652-.525 1.076-.525l2.423 0c.788 0 1.498.468 1.81 1.191l.915 2.129c.302.701.279 1.496-.063 2.18l-.617 1.234c-.298.596-.224 1.325.189 1.856l2.351 2.336-1.618 1.618c-3.392-3.49-5.833-7.429-6.708-10.871zM23.8539.146c-.196-.195-.512-.195-.707 0l-12.216 12.215c-.797-.807-1.529-1.617-2.126-2.384-.18-.234-.213-.538-.084-.795l.617-1.235c.475-.947.506-2.049.087-3.021l-.915-2.13C8.0409 1.705 6.9689 1 5.7819 1l-2.423 0c-.734 0-1.414.333-1.865.912-.447.574-.601 1.306-.422 2.007.918 3.611 3.454 7.717 6.971 11.331l-7.896 7.896c-.196.196-.196.512 0 .707.097.098.225.147.353.147.128 0 .256-.049.354-.147l7.896-7.896c3.615 3.517 7.719 6.054 11.331 6.971.191.049.384.072.576.072.512 0 1.013-.17 1.431-.494.579-.451.912-1.131.912-1.865l0-2.423c0-1.188-.705-2.259-1.797-2.729l-2.128-.915 0-.001c-.973-.417-2.074-.384-3.022.088l-1.211.607c-.259.127-.571.091-.797-.09-.834-.669-1.636-1.389-2.398-2.117L23.8539.853c.195-.195.195-.511 0-.707z"],"handset-muted_64":["M60 55.4541c0 1.415-.642 2.726-1.76 3.596-1.101.856-2.505 1.151-3.849.81-9.694-2.462-20.796-9.386-30.527-19.017l5.233-5.233c2.289 2.23 4.755 4.428 7.292 6.464 1.181.948 2.812 1.125 4.154.456l3.29-1.645c2.081-1.04 4.5-1.11 6.637-.192l5.777 2.484c2.28.981 3.753 3.218 3.753 5.7l0 6.577zM4.14 9.6091c-.342-1.344-.046-2.748.811-3.85.869-1.118 2.18-1.759 3.595-1.759l6.578 0c2.481 0 4.718 1.474 5.699 3.753l2.485 5.778c.919 2.137.849 4.556-.192 6.637l-1.676 3.35c-.672 1.346-.509 2.927.425 4.128 1.817 2.336 4.044 4.815 6.513 7.269l-5.221 5.221c-9.632-9.732-16.556-20.833-19.017-30.527zm52.502 32.65l-5.777-2.484c-2.408-1.037-5.134-.957-7.479.215l-3.289 1.646c-.995.497-2.204.363-3.082-.341-2.51-2.015-4.949-4.188-7.212-6.391l31.051-31.051c.195-.195.195-.511 0-.707-.196-.195-.512-.195-.708 0l-31.061 31.062c-2.439-2.424-4.638-4.87-6.431-7.175-.696-.894-.818-2.069-.319-3.067l1.676-3.351c1.172-2.345 1.251-5.071.215-7.478l-2.485-5.779c-1.138-2.647-3.736-4.358-6.617-4.358l-6.578 0c-1.726 0-3.324.782-4.385 2.145-1.048 1.347-1.409 3.064-.991 4.71 2.505 9.863 9.525 21.132 19.28 30.988L3.146 60.1461c-.195.196-.195.512 0 .707.098.098.226.147.354.147.128 0 .256-.049.354-.147l19.303-19.303c9.855 9.755 21.125 16.774 30.988 19.279.449.114.903.171 1.354.171 1.2 0 2.376-.4 3.355-1.161 1.364-1.061 2.146-2.658 2.146-4.385l0-6.577c0-2.882-1.711-5.48-4.358-6.618z"],"hd-badge_28":["M26.0092 4c1.099 0 1.991.902 1.991 2.009l0 15.983c0 1.109-.9 2.008-1.991 2.008l-24.018 0c-1.1 0-1.991-.902-1.991-2.008l0-15.983c0-1.11.9-2.009 1.991-2.009l24.018 0zm.991 18l0-16c0-.552-.448-1-1-1l-24 0c-.552 0-1 .448-1 1l0 16c0 .552.448 1 1 1l24 0c.552 0 1-.448 1-1zM7.1013 12.8808l6.769 0-1.563 6.769-1.692 0 1.172-5.077-5.077 0-1.172 5.077-1.692 0 2.538-11 1.693 0-.976 4.231zm7.7446-4.2309l-.585 2.539-1.693 0 .586-2.539 1.692 0zm4.231.0307c3.371.157 5.077 1.921 5.077 5.332 0 1.697-.515 3.061-1.544 4.091-.907.909-2.085 1.416-3.533 1.523-.195.015-.394.023-.598.023l-3.21 0-1.269 0 1.563-6.769 1.692 0-1.173 5.079 2.644-.002c.123 0 .233-.019.351-.027 1.005-.063 1.813-.384 2.4-.991.657-.678.984-1.64.984-2.884 0-2.372-1.136-3.595-3.384-3.694-.098-.004-.186-.019-.288-.019l-.948 0-.196.846-1.692 0 .585-2.539 1.058 0 1 0c.171 0 .318.024.481.031z"],"headset_12":["M9.875 7.946C9.951 7.638 10 7.323 10 7l0-1.908c.58.207 1 .757 1 1.408 0 .697-.48 1.279-1.125 1.446zM6.5 11c-.276 0-.5-.225-.5-.5 0-.276.224-.5.5-.5.275 0 .5.224.5.5 0 .275-.225.5-.5.5zM2 7.914c-.583-.206-1-.762-1-1.414 0-.651.416-1.206 1-1.413l0 2.827zm8-3.864L10 4c0-2.206-1.795-4-4-4-2.206 0-4 1.794-4 4l0 .05C.86 4.282 0 5.293 0 6.5 0 7.879 1.121 9 2.5 9c.276 0 .5-.224.5-.5l0-3.946c.001-.017.002-.036.002-.054 0-.019-.001-.036-.002-.054L3 4c0-1.655 1.345-3 3-3 1.654 0 3 1.345 3 3l0 .485c0 .005-.003.01-.003.015 0 .005.003.009.003.014L9 7c0 1.015-.531 1.965-1.377 2.515C7.348 9.202 6.949 9 6.5 9 5.671 9 5 9.672 5 10.5c0 .828.671 1.5 1.5 1.5.828 0 1.5-.672 1.5-1.5 0-.016-.005-.032-.005-.047.612-.358 1.111-.863 1.458-1.463.016.002.03.01.047.01C10.878 9 12 7.879 12 6.5c0-1.206-.859-2.215-2-2.45z"],"headset_14":["M11.7974 8.832c.122-.43.203-.873.203-1.332l0-2.222c.594.347 1 .986 1 1.722 0 .818-.496 1.523-1.203 1.832zM7.0004 13c-.552 0-1-.448-1-1 0-.552.448-1 1-1 .551 0 1 .448 1 1 0 .552-.449 1-1 1zm-5-4.27c-.604-.35-1-1.004-1-1.73 0-.726.396-1.38 1-1.731l0 3.461zm12-1.73c0-1.333-.88-2.453-2.085-2.842C11.5114 1.803 9.4684 0 7.0004 0c-2.467 0-4.522 1.795-4.928 4.147C.8544 4.545.0004 5.696.0004 7c0 1.418 1.008 2.653 2.399 2.939.147.029.3-.007.416-.102.116-.095.184-.236.185-.387l0-4.45c0-2.206 1.794-4 4-4 2.205 0 4 1.794 4 4l0 2.5c0 1.529-.906 2.906-2.239 3.573-.336-.635-.995-1.073-1.761-1.073-1.103 0-2 .897-2 2 0 1.103.897 2 2 2 1.076 0 1.95-.857 1.992-1.923.993-.438 1.81-1.186 2.341-2.11 1.496-.169 2.667-1.427 2.667-2.967z"],"headset_16":["M13 10.0029985l0-3.998001c1.103 0 2 .89655173 2 1.9990005 0 1.10244878-.897 1.9990005-2 1.9990005zm-5 4.9975013c-.552 0-1-.4477762-1-.9995003 0-.5517241.448-.9995002 1-.9995002.552 0 1 .4477761 1 .9995002 0 .5517241-.448.9995003-1 .9995003zm-5-4.9975013c-1.103 0-2-.89655172-2-1.9990005 0-1.10244877.897-1.9990005 2-1.9990005l0 3.998001zm10-4.99750125l0-.007996C13 2.24187906 10.757 0 8 0 5.243 0 3 2.24187906 3 4.99750125l0 .007996c-1.654 0-3 1.34532734-3 2.99850075 0 1.65317341 1.346 2.9985008 3 2.9985008l.5 0c.276 0 .5-.2238881.5-.4997502l0-5.50524735c0-2.20489755 1.794-3.998001 4-3.998001 2.206 0 4 1.79310345 4 3.998001l0 4.60469765c-.038 1.5292354-.943 2.8325837-2.24 3.4682659-.335-.6316842-.993-1.0684658-1.76-1.0684658-1.104 0-2 .8955522-2 1.9990005C6 15.1044478 6.896 16 8 16c1.087 0 1.967-.8675662 1.995-1.9470265 1.312-.5727136 2.333-1.6781609 2.772-3.0504747l.233 0c1.654 0 3-1.34532739 3-2.9985008 0-1.65317341-1.346-2.99850075-3-2.99850075z"],"headset_18":["M14.9141 11.458c.056-.327.086-.661.086-1l0-3.907c1.14.232 2 1.242 2 2.449 0 1.237-.905 2.26-2.086 2.458zM9.0001 17c-.551 0-1-.448-1-1 0-.552.449-1 1-1 .551 0 1 .448 1 1 0 .552-.449 1-1 1zm-6-5.55c-1.14-.232-2-1.243-2-2.45 0-1.207.86-2.218 2-2.45l0 4.9zm15-2.45c0-1.767-1.32-3.217-3.023-3.451C14.7451 2.451 12.1561 0 9.0001 0c-3.156 0-5.745 2.451-5.977 5.549C1.3201 5.783.0001 7.233.0001 9c0 1.93 1.57 3.5 3.5 3.5.276 0 .5-.224.5-.5l0-6c0-2.757 2.243-5 5-5 2.757 0 5 2.243 5 5l0 4.458c0 2.077-1.307 3.922-3.217 4.654-.328-.656-1-1.112-1.783-1.112-1.103 0-2 .897-2 2 0 1.103.897 2 2 2 1.068 0 1.936-.845 1.99-1.9 1.715-.606 3.043-1.948 3.646-3.614 1.866-.073 3.364-1.603 3.364-3.486z"],"headset_20":["M17 12.9497l0-.45 0-.906 0-3.543c1.14.232 2 1.242 2 2.449 0 1.208-.86 2.218-2 2.45zm-7 6.05c-.551 0-1-.448-1-1 0-.551.449-1 1-1 .551 0 1 .449 1 1 0 .552-.449 1-1 1zm-7-6.05c-1.14-.232-2-1.242-2-2.45 0-1.207.86-2.217 2-2.449l0 4.899zm17-2.45c0-1.76-1.306-3.221-3-3.464l0-.036c0-3.86-3.14-7-7-7-3.86 0-7 3.14-7 7l0 .036c-1.694.243-3 1.704-3 3.464 0 1.93 1.57 3.5 3.5 3.5.276 0 .5-.223.5-.5l0-6.5c0-3.308 2.691-6 6-6 3.309 0 6 2.692 6 6l0 4.594 0 .906c0 2.449-1.772 4.483-4.099 4.909-.254-.814-1.004-1.409-1.901-1.409-1.104 0-2 .896-2 2 0 1.105.896 2 2 2 .961 0 1.763-.679 1.955-1.583 2.37-.382 4.274-2.151 4.856-4.448 1.782-.16 3.189-1.645 3.189-3.469z"],"headset_24":["M19.979 15.861c.01-.133.021-.266.021-.401l0-7.315c1.721.445 3 1.995 3 3.855 0 1.866-1.289 3.425-3.021 3.861zM12 23c-1.104 0-2-.898-2-2 0-1.103.896-2 2-2 1.103 0 2 .897 2 2 0 1.102-.897 2-2 2zm-8-7.15c-1.745-.447-3-2.014-3-3.85 0-1.865 1.255-3.446 3-3.884l0 7.734zM24 12c0-2.43-1.75-4.432-4.051-4.877C19.51 3.123 16.114 0 12 0 7.912 0 4.49 3.08 4.036 7.084 1.708 7.527 0 9.572 0 12c0 2.535 1.91 4.662 4.444 4.946.14.014.283-.03.389-.124.106-.095.167-.231.167-.373l0-8.913C5.235 3.87 8.307 1 12 1c3.859 0 7 3.14 7 7l0 7.46c0 2.383-1.855 4.324-4.195 4.505C14.382 18.82 13.291 18 12 18c-1.657 0-3 1.343-3 3 0 1.656 1.343 3 3 3 1.656 0 3-1.344 3-3 0-.01-.003-.018-.003-.028 2.317-.224 4.216-1.883 4.807-4.076C22.175 16.508 24 14.479 24 12z"],"headset_32":["M25.7903759 20.997c.132-.648.208-1.315.208-1.997l0-8c1.406 0 2.755.597 3.701 1.638.96 1.054 1.413 2.423 1.276 3.854-.24 2.52-2.515 4.491-5.185 4.505zm-9.795 10.003c-1.379 0-2.5-1.121-2.5-2.5 0-1.379 1.121-2.5 2.5-2.5 1.379 0 2.501 1.121 2.501 2.5 0 1.379-1.122 2.5-2.501 2.5zM5.99337588 20.994c-2.576-.116-4.735-2.052-4.969-4.502-.136999997-1.431.317-2.8 1.276-3.854.944-1.039 2.29-1.636 3.693-1.638l0 9.994zm24.44700002-9.029c-1.136-1.249-2.755-1.965-4.442-1.965 0-5.514-4.488-10-10.003-10-5.515 0-10.00200002 4.486-10.00200002 10-1.684.003-3.299.719-4.433 1.965C.408375883 13.23-.134624117 14.872.0283758833 16.588.318375883 19.622 3.04537588 22 6.23837588 22l.255 0c.276 0 .5-.224.5-.5l0-11.5c0-4.963 4.03800002-9 9.00200002-9 4.964 0 9.003 4.037 9.003 9l0 9c0 3.722-2.276 7.023-5.705 8.371-.473-1.374-1.765-2.371-3.298-2.371-1.93 0-3.501 1.57-3.501 3.5 0 1.93 1.571 3.5 3.501 3.5 1.931 0 3.501-1.57 3.501-3.5 0-.045-.012-.088-.013-.133 2.942-1.094 5.144-3.467 6.053-6.367l.225 0c3.193 0 5.92-2.378 6.21-5.412.164-1.715-.38-3.357-1.531-4.623z"],"headset_48":["M39.5093 32c.321-1.262.491-2.574.491-3.916l0-11.059c3.902.259 7 3.508 7 7.475 0 4.133-3.36 7.494-7.491 7.5zm-15.509 15c-2.206 0-4-1.794-4-4 0-2.206 1.794-4 4-4 2.205 0 4 1.794 4 4 0 2.206-1.795 4-4 4zm-16-15.017c-3.904-.257-7-3.515-7-7.483 0-3.968 3.096-7.226 7-7.483l0 14.966zm32-15.958l0-.025c0-8.822-7.178-16-16-16-8.823 0-16 7.178-16 16l0 .015c-4.455.259-8 3.966-8 8.485 0 4.687 3.813 8.5 8.5 8.5.276 0 .5-.224.5-.5l0-16.5c0-8.271 6.729-15 15-15 8.271 0 15 6.729 15 15l0 12.084c0 6.389-4.105 12.084-10.076 14.161-.368-2.397-2.426-4.245-4.924-4.245-2.757 0-5 2.243-5 5 0 2.757 2.243 5 5 5 2.66 0 4.822-2.095 4.971-4.719 4.917-1.607 8.684-5.497 10.241-10.281l.288 0c4.687 0 8.5-3.813 8.5-8.5 0-4.518-3.546-8.214-8-8.475z"],"headset-alert_12":["M5.9997 11.0001c.271 0 .5-.229.5-.5 0-.271-.229-.5-.5-.5-.271 0-.5.229-.5.5 0 .271.229.5.5.5zm9.842-.661c.205.339.211.749.016 1.095-.197.349-.572.566-.977.566l-5.763 0c-.405 0-.78-.217-.977-.566-.195-.345-.189-.755.015-1.095-.213.139-.437.264-.677.361-.099.731-.723 1.3-1.479 1.3-.825 0-1.5-.675-1.5-1.5 0-.825.675-1.5 1.5-1.5.535 0 1.003.286 1.269.711 1.035-.491 1.731-1.551 1.731-2.711l0-3c0-1.654-1.346-3-3-3-1.654 0-3 1.346-3 3l0 4.5c0 .276-.223.5-.5.5-1.379 0-2.5-1.121-2.5-2.5 0-1.207.86-2.217 2-2.45l0-.05c0-2.205 1.794-3.999 3.999-4l.001 0 .002 0c2.204.001 3.998 1.795 3.998 4l0 .055c.642.135 1.174.53 1.529 1.054.145-.066.303-.109.47-.109l.001 0c.398 0 .757.202.96.539.001 0 .001.001.001.001l2.881 4.799zm-.961.661c.064 0 .094-.036.106-.058l-2.884-4.888c-.029-.048-.116-.066-.104-.054-.026 0-.076.007-.104.055l-2.881 4.799c.01.11.04.146.104.146l5.763 0zm-4.881-4c0 .103-.013.204-.022.306l.854-1.424c-.167-.358-.457-.647-.832-.785l0 1.903zm-8 .915l0-2.829c-.582.206-1 .762-1 1.414 0 .652.418 1.208 1 1.415zm9.5002-.415c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 1c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-1zm.5 2c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5z"],"headset-muted_12":["M9.875 7.9458c.076-.308.125-.623.125-.946l0-1.908c.58.207 1 .757 1 1.408 0 .697-.48 1.279-1.125 1.446zM6.5 10.9998c-.276 0-.5-.225-.5-.5 0-.276.224-.5.5-.5.275 0 .5.224.5.5 0 .275-.225.5-.5.5zM3 8.2928l0-3.739c.001-.017.002-.036.002-.054 0-.019-.001-.036-.002-.054l0-.446c0-1.655 1.345-3 3-3 1.16 0 2.158.669 2.657 1.636L3 8.2928zm-1-.379c-.583-.206-1-.762-1-1.414 0-.651.416-1.206 1-1.413l0 2.827zm8-3.864l0-.05c0-.389-.073-.759-.178-1.115l2.032-2.031c.195-.196.195-.512 0-.707-.196-.196-.512-.196-.708 0l-1.755 1.756C8.685.7648 7.434-.0002 6-.0002c-2.206 0-4 1.794-4 4l0 .05c-1.14.232-2 1.243-2 2.45 0 1.315 1.022 2.383 2.312 2.481l-2.166 2.166c-.195.195-.195.511 0 .707.098.097.226.146.354.146.128 0 .256-.049.354-.146l8.119-8.12c.008.089.027.175.027.266l0 .485c0 .005-.003.01-.003.015 0 .005.003.009.003.014l0 2.486c0 1.015-.531 1.965-1.377 2.515-.275-.313-.674-.515-1.123-.515-.829 0-1.5.672-1.5 1.5 0 .828.671 1.5 1.5 1.5.828 0 1.5-.672 1.5-1.5 0-.016-.005-.032-.005-.047.612-.358 1.111-.863 1.458-1.463.016.002.03.01.047.01 1.378 0 2.5-1.121 2.5-2.5 0-1.206-.859-2.215-2-2.45z"],"headset-muted_16":["M12.9949239 10.0029985l0-3.998001c1.1025693 0 1.999219.89755123 1.999219 1.9990005 0 1.10344828-.8966497 1.9990005-1.999219 1.9990005zm-4.99804768 4.9975013c-.55178446 0-.99960953-.4467767-.99960953-.9995003 0-.5507246.44782507-.9995002.99960953-.9995002.55178446 0 .99960953.4487756.99960953.9995002 0 .5527236-.44782507.9995003-.99960953.9995003zm-4.99804764-4.9975013c-1.10256931 0-1.999219052-.89555222-1.999219052-1.9990005 0-1.10144927.896649742-1.9990005 1.999219052-1.9990005l0 3.998001zm9.99609532-4.99750125l0-.007996c0-.3918041-.0559782-.76861569-.1419446-1.13643178L15.8538071.861569215c.1949239-.195902049.1949239-.511744128 0-.707646177-.1949239-.1949025482-.5118001-.1949025482-.7067239 0L12.4761265 2.82458771C11.6644436 1.15942029 9.97010543 0 7.99687622 0 5.24095275 0 2.99882858 2.24287856 2.99882858 4.99750125l0 .007996C1.34547442 5.00549725 0 6.35082459 0 8.003998c0 1.65317341 1.34547442 2.9985008 2.99882858 2.9985008l.49980477 0c.27589223 0 .49980476-.2228886.49980476-.4997502l0-5.50524735c0-2.20389805 1.79329949-3.998001 3.99843811-3.998001 1.70333464 0 3.15076928 1.07546227 3.72554468 2.57871064L.152940258 15.1464268c-.1949238582.195902-.1949238582.5117441 0 .7076462C.249902382 15.9510245.377852401 16 .505802421 16c.127950019 0 .255900039-.0489755.353861773-.145927L11.9693245 4.74462769c.0059976.08495752.0259898.16691654.0259898.25287356l0 4.60569715c-.0379851 1.5292354-.9426318 2.8325837-2.23912531 3.4682659-.33486919-.6316842-.99261226-1.0694653-1.75931277-1.0694653-1.10356892 0-1.99921905.8955522-1.99921905 1.9990005C5.99765717 15.1054473 6.8933073 16 7.99687622 16c1.08657556 0 1.96623194-.8665667 1.99422101-1.946027 1.31148767-.5737131 2.33208907-1.6781609 2.77091757-3.0514742l.2329091 0c1.6533541 0 2.9988285-1.34532739 2.9988285-2.9985008 0-1.65317341-1.3454744-2.99850075-2.9988285-2.99850075z"],"headset-muted_24":["M19.9785 15.8608c.011-.133.021-.266.021-.401l0-7.315c1.721.445 3 1.995 3 3.855 0 1.866-1.289 3.425-3.021 3.861zm-7.979 7.139c-1.103 0-2-.898-2-2 0-1.103.897-2 2-2 1.104 0 2 .897 2 2 0 1.102-.896 2-2 2zm-8-7.15c-1.745-.447-3-2.014-3-3.85 0-1.865 1.255-3.446 3-3.884l0 7.734zm15.95-8.727c-.074-.664-.235-1.3-.46-1.905l4.364-4.364c.195-.196.195-.512 0-.707-.195-.196-.512-.196-.707 0l-4.094 4.093c-1.347-2.52-4.001-4.24-7.053-4.24-4.087 0-7.509 3.08-7.963 7.084-2.329.443-4.037 2.488-4.037 4.916 0 2.535 1.911 4.662 4.445 4.946.139.014.282-.03.388-.124.107-.095.167-.231.167-.373l0-8.913c.236-3.666 3.307-6.536 7-6.536 2.78 0 5.179 1.632 6.308 3.986L.1465 23.1468c-.195.195-.195.511 0 .707.098.097.226.146.353.146.128 0 .256-.049.354-.146l17.852-17.852c.189.633.294 1.303.294 1.998l0 7.46c0 2.383-1.855 4.324-4.195 4.505-.423-1.145-1.513-1.965-2.805-1.965-1.657 0-3 1.343-3 3 0 1.656 1.343 3 3 3 1.657 0 3-1.344 3-3 0-.01-.002-.018-.002-.028 2.317-.224 4.215-1.883 4.806-4.076 2.371-.388 4.196-2.417 4.196-4.896 0-2.43-1.75-4.432-4.05-4.877z"],"headset-muted_32":["M25.7903743 20.99725c.132-.648.208-1.315.208-1.997l0-8c1.406 0 2.755.597 3.701 1.638.96 1.054 1.413 2.423 1.277 3.854-.241 2.52-2.516 4.491-5.186 4.505zm-9.795 10.003c-1.379 0-2.5-1.121-2.5-2.5 0-1.379 1.121-2.5 2.5-2.5 1.379 0 2.501 1.121 2.501 2.5 0 1.379-1.122 2.5-2.501 2.5zm-10.00199999-10.006c-2.576-.116-4.734-2.052-4.969-4.502-.136000002-1.431.318-2.8 1.277-3.854.943-1.039 2.29-1.636 3.692-1.638l0 9.994zm20.00499999-10.994c0-.997-.15-1.958-.424-2.867l6.279-6.28c.196-.195.196-.511 0-.707-.195-.195-.511-.195-.707 0l-5.945 5.946c-1.525-3.578-5.077-6.092-9.206-6.092-5.515 0-10.00199999 4.486-10.00199999 10-1.683.003-3.299.719-4.432 1.965-1.153000002 1.265-1.696000002 2.907-1.5330000024 4.623.2900000004 3.034 3.0170000024 5.412 6.2100000024 5.412l.255 0c.276 0 .5-.224.5-.5l0-11.5c0-4.963 4.03799999-9 9.00199999-9 3.861 0 7.153 2.447 8.43 5.868L.146374308 31.14625c-.1950000004.196-.1950000004.512 0 .707.098.098.226.147.354.147.128 0 .256-.049.353-.147l23.900999992-23.9c.154.658.244 1.342.244 2.047l0 9c0 3.722-2.275 7.023-5.705 8.371-.473-1.374-1.765-2.371-3.298-2.371-1.93 0-3.501 1.57-3.501 3.5 0 1.93 1.571 3.5 3.501 3.5 1.932 0 3.501-1.57 3.501-3.5 0-.045-.012-.088-.013-.133 2.943-1.094 5.144-3.467 6.053-6.367l.226 0c3.192 0 5.92-2.378 6.21-5.412.164-1.715-.38-3.357-1.532-4.623-1.135-1.249-2.754-1.965-4.442-1.965z"],"headset-muted_48":["M39.5093 32c.321-1.262.491-2.574.491-3.916l0-11.059c3.902.259 7 3.508 7 7.475 0 4.133-3.36 7.494-7.491 7.5zm-15.509 15c-2.206 0-4-1.794-4-4 0-2.206 1.794-4 4-4 2.205 0 4 1.794 4 4 0 2.206-1.795 4-4 4zm-16-15.017c-3.904-.257-7-3.515-7-7.483 0-3.968 3.096-7.226 7-7.483l0 14.966zm32-15.958l0-.025c0-2.154-.434-4.207-1.209-6.084l9.062-9.062c.196-.196.196-.512 0-.708-.195-.195-.511-.195-.707 0l-8.804 8.805C35.7293 3.658 30.2913 0 24.0003 0c-8.823 0-16 7.178-16 16l0 .015c-4.455.259-8 3.966-8 8.485 0 4.687 3.813 8.5 8.5 8.5.276 0 .5-.224.5-.5l0-16.5c0-8.271 6.729-15 15-15 6.019 0 11.207 3.571 13.593 8.699L.1463 47.146c-.195.196-.195.512 0 .708.098.097.226.146.354.146.128 0 .256-.049.353-.146l37.159-37.16c.628 1.653.988 3.436.988 5.306l0 12.084c0 6.389-4.105 12.084-10.076 14.161-.368-2.397-2.426-4.245-4.924-4.245-2.757 0-5 2.243-5 5 0 2.757 2.243 5 5 5 2.66 0 4.822-2.095 4.971-4.719 4.917-1.607 8.684-5.497 10.241-10.281l.288 0c4.687 0 8.5-3.813 8.5-8.5 0-4.518-3.546-8.214-8-8.475z"],"headset-muted-alert_12":["M5.9999 11.0001c.271 0 .5-.229.5-.5 0-.271-.229-.5-.5-.5-.271 0-.5.229-.5.5 0 .271.229.5.5.5zm9.842-.661c.205.339.211.749.016 1.095-.197.349-.572.566-.977.566l-5.763 0c-.405 0-.78-.217-.977-.566-.195-.345-.189-.755.015-1.095-.213.139-.437.264-.677.361-.099.731-.723 1.3-1.479 1.3-.825 0-1.5-.675-1.5-1.5 0-.825.675-1.5 1.5-1.5.535 0 1.003.286 1.269.711 1.035-.491 1.731-1.551 1.731-2.711l0-3c0-.091-.018-.177-.027-.266l-8.119 8.12c-.098.097-.226.146-.354.146-.128 0-.256-.049-.353-.146-.196-.196-.196-.512 0-.708l2.165-2.165c-1.29-.098-2.312-1.167-2.312-2.481 0-1.207.86-2.217 2-2.45l0-.05c0-2.205 1.794-3.999 3.999-4l.001 0 .002 0c1.433 0 2.683.766 3.389 1.902l1.756-1.756c.195-.195.511-.195.707 0 .195.196.195.512 0 .708l-2.032 2.031c.105.356.178.725.178 1.115l0 .055c.642.135 1.174.53 1.529 1.054.145-.066.303-.109.47-.109l.001 0c.398 0 .757.202.96.539.001 0 .001.001.001.001l2.881 4.799zm-.961.661c.064 0 .094-.036.106-.058l-2.884-4.888c-.029-.048-.116-.066-.104-.054-.026 0-.076.007-.104.055l-2.881 4.799c.01.11.04.146.104.146l5.763 0zM12 9.5001c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm-2.0001-2.5c0 .103-.013.204-.022.306l.854-1.424c-.167-.358-.457-.647-.832-.785l0 1.903zm-7 1.293l5.657-5.657c-.499-.967-1.496-1.636-2.657-1.636-1.654 0-3 1.346-3 3l0 4.293zm-1-.378l0-2.829c-.582.206-1 .762-1 1.414 0 .652.418 1.208 1 1.415zm9.5001-.415c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 1c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-1z"],"headset-muted-private_12":["M10.0508 8c.232-1.14 1.242-2 2.449-2 1.207 0 2.218.86 2.449 2l-4.898 0zm2.449 3c-1.207 0-2.217-.86-2.449-2l4.898 0c-.231 1.14-1.242 2-2.449 2zm-2.5-5.903c.25.092.458.256.622.458-.225.144-.435.31-.622.501l0-.959zm-4 5.903c-.271 0-.5-.229-.5-.5 0-.271.229-.5.5-.5.271 0 .5.229.5.5 0 .271-.229.5-.5.5zm-3-2.707l0-4.293c0-1.654 1.346-3 3-3 1.161 0 2.158.669 2.657 1.636l-5.657 5.657zm-1-.378c-.582-.207-1-.763-1-1.415 0-.652.418-1.208 1-1.414l0 2.829zM12.4998 5c-.329 0-.641.06-.943.145-.354-.544-.9-.952-1.557-1.09l0-.055c0-.39-.073-.759-.178-1.115l2.032-2.031c.195-.196.195-.512 0-.708-.196-.195-.512-.195-.707 0l-1.756 1.756C8.6848.766 7.4348 0 6.0018 0l-.003 0c-2.205.001-3.999 1.795-3.999 4l0 .05c-1.139.233-2 1.243-2 2.45 0 1.314 1.022 2.383 2.312 2.481l-2.165 2.165c-.196.196-.196.512 0 .708.097.097.225.146.353.146.128 0 .256-.049.354-.146l8.119-8.12c.009.089.027.175.027.266l0 3c0 1.16-.696 2.22-1.731 2.711-.266-.425-.734-.711-1.269-.711-.824 0-1.5.675-1.5 1.5 0 .825.676 1.5 1.5 1.5.756 0 1.38-.569 1.479-1.3.668-.27 1.233-.717 1.662-1.27.41 1.478 1.75 2.57 3.359 2.57 1.933 0 3.5-1.567 3.5-3.5 0-1.933-1.567-3.5-3.5-3.5z"],"headset-private_12":["M10.0507 8c.232-1.14 1.242-2 2.449-2 1.207 0 2.218.86 2.449 2l-4.898 0zm2.449 3c-1.207 0-2.217-.86-2.449-2l4.898 0c-.231 1.14-1.242 2-2.449 2zm-2.5-4.944l0-.959c.25.092.458.256.622.458-.225.144-.435.31-.622.501zm-4 4.944c-.271 0-.5-.229-.5-.5 0-.271.229-.5.5-.5.271 0 .5.229.5.5 0 .271-.229.5-.5.5zm-4-3.085c-.582-.207-1-.763-1-1.415 0-.652.418-1.208 1-1.414l0 2.829zM12.4997 5c-.329 0-.641.06-.943.145-.354-.544-.9-.952-1.557-1.09l0-.055c0-2.205-1.794-3.999-3.998-4l-.003 0c-2.205.001-3.999 1.795-3.999 4l0 .05c-1.139.233-2 1.243-2 2.45 0 1.379 1.121 2.5 2.5 2.5.277 0 .5-.224.5-.5l0-4.5c0-1.654 1.346-3 3-3 1.655 0 3 1.346 3 3l0 3c0 1.16-.696 2.22-1.731 2.711-.266-.425-.734-.711-1.269-.711-.824 0-1.5.675-1.5 1.5 0 .825.676 1.5 1.5 1.5.756 0 1.38-.569 1.479-1.3.668-.27 1.233-.717 1.662-1.27.41 1.478 1.75 2.57 3.359 2.57 1.933 0 3.5-1.567 3.5-3.5 0-1.933-1.567-3.5-3.5-3.5z"],"help_10":["M5 0c1.654 0 3 1.346 3 3l0 .14c0 1.399-.763 2.068-1.321 2.557-.099.087-.197.172-.287.26l-.427.41c-.282.273-.458.707-.458 1.133 0 .276-.223.5-.5.5-.276 0-.5-.224-.5-.5 0-.698.286-1.392.764-1.853l.426-.41c.101-.097.211-.194.323-.292.526-.461.98-.859.98-1.805L7 3c0-1.103-.897-2-2-2-1.103 0-2 .897-2 2 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-1.654 1.346-3 3-3zm0 9c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5z"],"help_12":["M6 0c2.206 0 4 1.794 4 4-.007 1.205-.659 2.322-1.743 3.012l-.646.41C6.918 7.881 6.5 8.652 6.5 9.479c0 .276-.224.51-.5.51-.276 0-.5-.213-.5-.489l0-.021c0-1.163.586-2.246 1.567-2.896l.653-.415C8.504 5.669 8.995 4.845 9 4.019 9 2.346 7.654 1 6 1 4.346 1 3 2.346 3 4c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-2.206 1.794-4 4-4zm0 11c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5z"],"help_16":["M8 14.999c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm4.9155-10.9331c.105.578.112 1.159.022 1.726-.207 1.295-1.041 2.465-2.288 3.209l-.248.148c-1.173.699-1.902 1.982-1.902 3.349 0 .276-.223.501-.5.501-.276 0-.5-.224-.5-.5 0-1.717.916-3.33 2.39-4.209l.248-.148c.992-.592 1.653-1.506 1.813-2.507.072-.456.066-.923-.019-1.39-.284-1.565-1.516-2.833-3.065-3.155-1.214-.252-2.449.04-3.388.804-.939.764-1.479 1.896-1.479 3.105 0 .276-.223.5-.5.5-.276 0-.5-.224-.5-.5 0-1.512.674-2.926 1.848-3.881 1.174-.954 2.712-1.323 4.223-1.007 1.944.404 3.489 1.994 3.845 3.955z"],"help_24":["M12 2c3.309 0 6 2.691 6 6 0 3.011-1.708 4.621-2.955 5.796l-1.347 1.3c-.761.739-1.198 1.791-1.198 2.886 0 .277-.224.5-.5.5-.276 0-.5-.223-.5-.5 0-1.364.547-2.677 1.501-3.603l1.358-1.312C15.598 11.901 17 10.58 17 8c0-2.757-2.243-5-5-5-2.757 0-5 2.243-5 5l0 .499c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5L6 8c0-3.309 2.691-6 6-6zm0 18.999c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5z"],"help_8":["M3.99359665 6.33183321c-.27538508 0-.49888602-.22389579-.49888602-.4997674 0-.56273808.23746974-1.10448594.65054737-1.48530869l.34024026-.31385393c.08481062-.07796371.17660565-.15492789.27039622-.2328916.41706871-.34683858.74633348-.62071111.74633348-1.27940453 0-.80162691-.67150058-1.49730312-1.46572712-1.51929289-.4030999-.003998135-.7812555.13793581-1.06861385.41980462-.29134943.28686648-.45897513.67668505-.46995062 1.09848873-.00798218.2758716-.24046306.49776833-.51285483.48577391-.275385082-.00699675-.491901614-.23688975-.48491721-.51276135.018957669-.68268226.291349435-1.31638732.76828447-1.785169134.48391943-.474779025 1.14344675-.727661327 1.79598966-.7056715617C5.40743962.0407612411 6.5 1.17023555 6.5 2.52060706c0 1.1264757-.63957187 1.65922775-1.10553142 2.04804678-.08081953.06696883-.15964352.13293813-.23347865.19990696l-.34024027.31385392c-.20853435.19191068-.328267.46478368-.328267.74965109 0 .27587161-.22350093.4997674-.49888601.4997674zm.49888601 1.16885598c0 .27587161-.22350093.4997674-.49888601.4997674-.27538508 0-.49888602-.22389579-.49888602-.4997674 0-.2758716.22350094-.49976739.49888602-.49976739.27538508 0 .49888601.22389579.49888601.49976739z"],"help-circle_12":["M6 0c3.314 0 6 2.687 6 6 0 3.313-2.686 6-6 6-3.314 0-6-2.687-6-6 0-3.313 2.686-6 6-6zm0 11c2.757 0 5-2.243 5-5 0-2.757-2.243-5-5-5-2.757 0-5 2.243-5 5 0 2.757 2.243 5 5 5zm0-3c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm.0522-5.4883c1.074.031 1.948.933 1.948 2.011 0 .905-.524 1.343-.87 1.632-.057.048-.113.095-.165.143l-.256.235c-.13.119-.205.29-.205.468 0 .276-.223.5-.5.5-.276 0-.5-.224-.5-.5 0-.457.193-.896.528-1.204l.256-.235c.062-.058.131-.115.201-.174.326-.273.511-.448.511-.865 0-.533-.448-.996-.976-1.011-.263-.012-.515.089-.706.275-.205.2-.318.474-.318.771 0 .276-.224.5-.5.5-.277 0-.5-.224-.5-.5 0-.57.22-1.098.621-1.488.387-.375.909-.58 1.431-.558z"],"help-circle_16":["M8 0c4.418 0 8 3.582 8 8 0 4.418-3.582 8-8 8-4.418 0-8-3.582-8-8 0-4.418 3.582-8 8-8zm0 15c3.86 0 7-3.14 7-7 0-3.86-3.14-7-7-7-3.86 0-7 3.14-7 7 0 3.86 3.14 7 7 7zm-.3301-2.8574c.18-.19.52-.19.7 0 .1.09.15.22.15.35 0 .07-.01.13-.04.19-.02.06-.06.12-.11.16-.04.05-.1.09-.16.11-.06.03-.13.04-.19.04-.13 0-.26-.05-.35-.15-.05-.04-.09-.1-.11-.16-.03-.06-.04-.12-.04-.19 0-.13.05-.26.15-.35zm.4082-9.127c1.611.046 2.922 1.4 2.922 3.018 0 1.353-.769 1.996-1.33 2.465-.1.083-.197.164-.287.248l-.426.391c-.286.263-.457.637-.457 1.025l0 .337c0 .277-.224.5-.5.5-.276 0-.5-.223-.5-.5l0-.337c0-.667.289-1.309.781-1.761l.424-.391c.102-.093.211-.185.323-.279.522-.436.972-.813.972-1.698 0-1.064-.893-1.988-1.95-2.018-.548-.026-1.036.181-1.419.554-.407.395-.631.936-.631 1.522 0 .277-.224.5-.5.5-.276 0-.5-.223-.5-.5 0-.859.331-1.654.934-2.239.578-.563 1.343-.858 2.144-.837z"],"help-circle_20":["M10 0c5.523 0 10 4.477 10 10 0 5.523-4.477 10-10 10-5.523 0-10-4.477-10-10C0 4.477 4.477 0 10 0zm0 19c4.963 0 9-4.037 9-9 0-4.963-4.037-9-9-9-4.963 0-9 4.037-9 9 0 4.963 4.037 9 9 9zm0-14c1.654 0 3 1.346 3 3l0 .14c0 1.399-.763 2.068-1.321 2.557-.099.087-.197.172-.287.26l-.427.41c-.282.273-.458.707-.458 1.133 0 .276-.223.5-.5.5-.276 0-.5-.224-.5-.5 0-.698.286-1.392.764-1.853l.426-.41c.101-.097.211-.194.323-.292.526-.461.98-.859.98-1.805L12 8c0-1.103-.897-2-2-2-1.103 0-2 .897-2 2 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-1.654 1.346-3 3-3zm0 9c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5z"],"help-circle_24":["M12 0c6.617 0 12 5.383 12 12 0 6.617-5.383 12-12 12-6.617 0-12-5.383-12-12C0 5.383 5.383 0 12 0m0 23c6.065 0 11-4.935 11-11 0-6.065-4.935-11-11-11C5.935 1 1 5.935 1 12c0 6.065 4.935 11 11 11m.122-17.999c2.136.062 3.941 1.925 3.941 4.07 0 1.823-1.005 2.662-1.812 3.338-.144.119-.284.237-.415.357l-.602.554c-.449.412-.706.999-.706 1.609 0 .277-.224.5-.5.5-.277 0-.5-.223-.5-.5 0-.888.375-1.742 1.029-2.345l.602-.554c.142-.131.294-.259.45-.388.748-.625 1.454-1.217 1.454-2.571 0-1.617-1.36-3.024-2.969-3.07-.816-.026-1.58.276-2.164.845-.618.599-.958 1.421-.958 2.308 0 .278-.224.5-.5.5-.276 0-.5-.222-.5-.5 0-1.16.448-2.236 1.261-3.026.78-.757 1.813-1.155 2.889-1.127M11.65 17.15c.19-.19.52-.19.71 0 .09.09.15.22.15.35 0 .13-.06.26-.15.35-.09.1-.22.15-.35.15-.07 0-.13-.01-.19-.04-.06-.02-.12-.06-.17-.11-.09-.09-.14-.22-.14-.35 0-.13.05-.26.14-.35"],"help-circle_36":["M18 0c9.941 0 18 8.059 18 18 0 9.941-8.059 18-18 18-9.941 0-18-8.059-18-18C0 8.059 8.059 0 18 0zm0 35c9.374 0 17-7.626 17-17 0-9.374-7.626-17-17-17C8.626 1 1 8.626 1 18c0 9.374 7.626 17 17 17zm0-27c3.309 0 6 2.691 6 6 0 3.011-1.708 4.621-2.955 5.796l-1.347 1.3c-.761.739-1.198 1.791-1.198 2.886 0 .277-.224.5-.5.5-.276 0-.5-.223-.5-.5 0-1.364.547-2.677 1.501-3.603l1.358-1.312C21.598 17.901 23 16.58 23 14c0-2.757-2.243-5-5-5-2.757 0-5 2.243-5 5l0 .499c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5L12 14c0-3.309 2.691-6 6-6zm-.5 19.499c0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5z"],"help-circle_44":["M22 0c12.131 0 22 9.869 22 22 0 12.131-9.869 22-22 22C9.869 44 0 34.131 0 22 0 9.869 9.869 0 22 0zm0 43c11.58 0 21-9.42 21-21 0-11.58-9.42-21-21-21C10.42 1 1 10.42 1 22c0 11.58 9.42 21 21 21zm.1802-32.9976c3.697.104 6.82 3.287 6.82 6.95 0 3.103-1.76 4.553-3.174 5.718-.269.222-.532.438-.776.66l-1.105 1.002c-.907.821-1.427 1.987-1.427 3.198 0 .277-.223.5-.5.5-.276 0-.5-.223-.5-.5 0-1.493.64-2.929 1.755-3.94l1.105-1.001c.255-.232.53-.459.812-.691 1.381-1.138 2.81-2.315 2.81-4.946 0-3.136-2.678-5.861-5.848-5.95-1.618-.052-3.148.549-4.305 1.674-1.191 1.158-1.847 2.73-1.847 4.426 0 .276-.224.5-.5.5-.277 0-.5-.224-.5-.5 0-1.969.763-3.795 2.15-5.143 1.352-1.315 3.136-2.005 5.03-1.957zM21.8101 33.04c.18-.08.41-.03.54.11.1.09.15.22.15.35 0 .13-.05.26-.15.35-.09.1-.22.15-.35.15-.07 0-.13-.01-.19-.04-.06-.02-.12-.06-.16-.11-.1-.09-.15-.22-.15-.35 0-.13.05-.26.15-.35.04-.05.1-.09.16-.11z"],"help-circle_72":["M36 0c19.882 0 36 16.118 36 36 0 19.882-16.118 36-36 36C16.118 72 0 55.882 0 36 0 16.118 16.118 0 36 0zm0 71c19.299 0 35-15.701 35-35C71 16.701 55.299 1 36 1 16.701 1 1 16.701 1 36c0 19.299 15.701 35 35 35zm.2832-53.998c5.809.167 10.717 5.238 10.717 11.074 0 4.925-2.67 7.151-5.026 9.114-.445.371-.879.733-1.282 1.104l-1.785 1.643c-1.643 1.51-2.407 3.129-2.407 5.096l0 .467c0 .276-.224.5-.5.5-.277 0-.5-.224-.5-.5l0-.467c0-2.235.892-4.143 2.729-5.832l1.785-1.642c.415-.382.862-.755 1.32-1.137 2.294-1.912 4.666-3.89 4.666-8.346 0-5.309-4.463-9.923-9.746-10.074-2.617-.079-5.121.881-7.032 2.694-2.007 1.903-3.15 4.516-3.219 7.356-.007.276-.208.485-.512.488-.276-.007-.495-.236-.488-.512.076-3.108 1.33-5.97 3.531-8.058 2.105-1.996 4.869-3.046 7.749-2.968zm-.4727 37.0278c.18-.07.399-.03.539.11.101.09.15.22.15.36 0 .13-.049.26-.15.35-.09.09-.22.15-.35.15-.07 0-.129-.02-.189-.04-.061-.03-.12-.07-.16-.11-.101-.09-.151-.22-.151-.35 0-.14.05-.27.151-.36.04-.04.099-.08.16-.11z"],"help-circle-active_12":["M6 0c3.314 0 6 2.687 6 6 0 3.313-2.686 6-6 6-3.314 0-6-2.687-6-6 0-3.313 2.686-6 6-6zm0 8c-.276 0-.5.224-.5.5 0 .276.224.5.5.5.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5zm.0522-5.4883c-.522-.022-1.044.183-1.431.558-.401.39-.621.918-.621 1.488 0 .276.223.5.5.5.276 0 .5-.224.5-.5 0-.297.113-.571.318-.771.191-.186.443-.287.706-.275.528.015.976.478.976 1.011 0 .417-.185.592-.511.865-.07.059-.139.116-.201.174l-.256.235c-.335.308-.528.747-.528 1.204 0 .276.224.5.5.5.277 0 .5-.224.5-.5 0-.178.075-.349.205-.468l.256-.235c.052-.048.108-.095.165-.143.346-.289.87-.727.87-1.632 0-1.078-.874-1.98-1.948-2.011z"],"help-circle-active_16":["M8 0c4.418 0 8 3.582 8 8 0 4.418-3.582 8-8 8-4.418 0-8-3.582-8-8 0-4.418 3.582-8 8-8zm-.3301 12.1426c-.1.09-.15.22-.15.35 0 .07.01.13.04.19.02.06.06.12.11.16.09.1.22.15.35.15.06 0 .13-.01.19-.04.06-.02.12-.06.16-.11.05-.04.09-.1.11-.16.03-.06.04-.12.04-.19 0-.13-.05-.26-.15-.35-.18-.19-.52-.19-.7 0zm.4082-9.127c-.801-.021-1.566.274-2.144.837-.603.585-.934 1.38-.934 2.239 0 .277.224.5.5.5.276 0 .5-.223.5-.5 0-.586.224-1.127.631-1.522.383-.373.871-.58 1.419-.554 1.057.03 1.95.954 1.95 2.018 0 .885-.45 1.262-.972 1.698-.112.094-.221.186-.323.279l-.424.391c-.492.452-.781 1.094-.781 1.761l0 .337c0 .277.224.5.5.5.276 0 .5-.223.5-.5l0-.337c0-.388.171-.762.457-1.025l.426-.391c.09-.084.187-.165.287-.248.561-.469 1.33-1.112 1.33-2.465 0-1.618-1.311-2.972-2.922-3.018z"],"help-circle-active_20":["M10 0c5.523 0 10 4.477 10 10 0 5.523-4.477 10-10 10-5.523 0-10-4.477-10-10C0 4.477 4.477 0 10 0zm0 5C8.346 5 7 6.346 7 8c0 .276.224.5.5.5.276 0 .5-.224.5-.5 0-1.103.897-2 2-2 1.103 0 2 .897 2 2l0 .14c0 .946-.454 1.344-.98 1.805-.112.098-.222.195-.323.292l-.426.41c-.478.461-.764 1.155-.764 1.853 0 .276.224.5.5.5.277 0 .5-.224.5-.5 0-.426.176-.86.458-1.133l.427-.41c.09-.088.188-.173.287-.26C12.237 10.208 13 9.539 13 8.14L13 8c0-1.654-1.346-3-3-3zm0 9c-.276 0-.5.224-.5.5 0 .276.224.5.5.5.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5z"],"help-circle-active_24":["M12 0c6.617 0 12 5.383 12 12 0 6.617-5.383 12-12 12-6.617 0-12-5.383-12-12C0 5.383 5.383 0 12 0m.122 5.001c2.136.062 3.941 1.925 3.941 4.07 0 1.823-1.005 2.662-1.812 3.338-.144.119-.284.237-.415.357l-.602.554c-.449.412-.706.999-.706 1.609 0 .277-.224.5-.5.5-.277 0-.5-.223-.5-.5 0-.888.375-1.742 1.029-2.345l.602-.554c.142-.131.294-.259.45-.388.748-.625 1.454-1.217 1.454-2.571 0-1.617-1.36-3.024-2.969-3.07-.816-.026-1.58.276-2.164.845-.618.599-.958 1.421-.958 2.308 0 .278-.224.5-.5.5-.276 0-.5-.222-.5-.5 0-1.16.448-2.236 1.261-3.026.78-.757 1.813-1.155 2.889-1.127M11.65 17.15c.19-.19.52-.19.71 0 .09.09.15.22.15.35 0 .13-.06.26-.15.35-.09.1-.22.15-.35.15-.07 0-.13-.01-.19-.04-.06-.02-.12-.06-.17-.11-.09-.09-.14-.22-.14-.35 0-.13.05-.26.14-.35"],"help-circle-active_36":["M18 0c9.941 0 18 8.059 18 18 0 9.941-8.059 18-18 18-9.941 0-18-8.059-18-18C0 8.059 8.059 0 18 0zm0 8c-3.309 0-6 2.691-6 6l0 .499c0 .276.224.5.5.5.276 0 .5-.224.5-.5L13 14c0-2.757 2.243-5 5-5 2.757 0 5 2.243 5 5 0 2.58-1.402 3.901-2.641 5.067l-1.358 1.312c-.954.926-1.501 2.239-1.501 3.603 0 .277.224.5.5.5.276 0 .5-.223.5-.5 0-1.095.437-2.147 1.198-2.886l1.347-1.3C22.292 18.621 24 17.011 24 14c0-3.309-2.691-6-6-6zm-.5 19.499c0 .276.224.5.5.5.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5z"],"help-circle-active_44":["M22 0c12.131 0 22 9.869 22 22 0 12.131-9.869 22-22 22C9.869 44 0 34.131 0 22 0 9.869 9.869 0 22 0zm.1802 10.0024c-1.894-.048-3.678.642-5.03 1.957-1.387 1.348-2.15 3.174-2.15 5.143 0 .276.223.5.5.5.276 0 .5-.224.5-.5 0-1.696.656-3.268 1.847-4.426 1.157-1.125 2.687-1.726 4.305-1.674 3.17.089 5.848 2.814 5.848 5.95 0 2.631-1.429 3.808-2.81 4.946-.282.232-.557.459-.812.691l-1.105 1.001c-1.115 1.011-1.755 2.447-1.755 3.94 0 .277.224.5.5.5.277 0 .5-.223.5-.5 0-1.211.52-2.377 1.427-3.198l1.105-1.002c.244-.222.507-.438.776-.66 1.414-1.165 3.174-2.615 3.174-5.718 0-3.663-3.123-6.846-6.82-6.95zM21.8101 33.04c-.06.02-.12.06-.16.11-.1.09-.15.22-.15.35 0 .13.05.26.15.35.04.05.1.09.16.11.06.03.12.04.19.04.13 0 .26-.05.35-.15.1-.09.15-.22.15-.35 0-.13-.05-.26-.15-.35-.13-.14-.36-.19-.54-.11z"],"help-circle-active_72":["M36 0c19.882 0 36 16.118 36 36 0 19.882-16.118 36-36 36C16.118 72 0 55.882 0 36 0 16.118 16.118 0 36 0zm.2832 17.002c-2.88-.078-5.644.972-7.749 2.968-2.201 2.088-3.455 4.95-3.531 8.058-.007.276.212.505.488.512.304-.003.505-.212.512-.488.069-2.84 1.212-5.453 3.219-7.356 1.911-1.813 4.415-2.773 7.032-2.694 5.283.151 9.746 4.765 9.746 10.074 0 4.456-2.372 6.434-4.666 8.346-.458.382-.905.755-1.32 1.137l-1.785 1.642c-1.837 1.689-2.729 3.597-2.729 5.832l0 .467c0 .276.223.5.5.5.276 0 .5-.224.5-.5l0-.467c0-1.967.764-3.586 2.407-5.096l1.785-1.643c.403-.371.837-.733 1.282-1.104 2.356-1.963 5.026-4.189 5.026-9.114 0-5.836-4.908-10.907-10.717-11.074zm-.4727 37.0278c-.061.03-.12.07-.16.11-.101.09-.151.22-.151.36 0 .13.05.26.151.35.04.04.099.08.16.11.06.02.119.04.189.04.13 0 .26-.06.35-.15.101-.09.15-.22.15-.35 0-.14-.049-.27-.15-.36-.14-.14-.359-.18-.539-.11z"],"hide_12":["M6 9.0000625c-.7079705 0-1.343944-.14999688-1.91292029-.37999208l4.75280196-4.75290099c1.07595517.68598571 1.80892463 1.6079665 2.16190993 2.12095582C10.3968168 6.89410637 8.69788759 9.0000625 6 9.0000625M.998208408 6.01212475C1.60418316 5.10614362 3.30211241 3.0001875 6 3.0001875c.7079705 0 1.343944.14999687 1.91292029.37999208L3.16011833 8.13308056C2.08416316 7.44709485 1.3511937 6.52511406.998208408 6.01212475M9.56185159 3.14518448L11.8537561.854232203c.1949919-.195995916.1949919-.511989333 0-.70798525-.1959918-.1949959374-.5119787-.1949959374-.7079705 0L8.663889 2.62919523C7.89692096 2.26020291 7.01895754 2.00020833 6 2.00020833c-3.15686846 0-5.102787384 2.36195079-5.832756968 3.455928-.2229907092.33199308-.2229907092.75598425 0 1.08797733.3959835.59298765 1.161951588 1.55096769 2.270905378 2.30995188L.146243907 11.1460178c-.1949918758.1959959-.1949918758.5119893 0 .7079852C.244239823 11.951001.37223449 12 .500229157 12c.127994667 0 .255989334-.048999.353985251-.145997L3.336111 9.37005479c.76696804.36999229 1.64493146.62998691 2.663889.62998691 3.15686846 0 5.1027874-2.36195083 5.832757-3.45592804.2229907-.33199308.2229907-.75598425 0-1.08797733-.3959835-.59298765-1.1619516-1.55096769-2.27090541-2.31095185"],"hide_16":["M8 2c4.21 0 6.803 3.543 7.778 5.184.296.498.296 1.134 0 1.632C14.803 10.457 12.21 14 8 14 3.79 14 1.197 10.457.222 8.816c-.296-.498-.296-1.134 0-1.632C1.197 5.543 3.79 2 8 2zm0 1C4.273 3 1.92 6.283 1.082 7.695c-.109.182-.109.428 0 .61C1.92 9.717 4.273 13 8 13c3.727 0 6.08-3.283 6.918-4.695.109-.182.109-.428 0-.61C14.08 6.283 11.727 3 8 3z","M.853553391 15.8535534L15.8535534.853553391c.1952621-.195262146.1952621-.511844636 0-.707106782-.1952622-.1952621455-.5118446-.1952621455-.7071068 0L.146446609 15.1464466c-.1952621455.1952622-.1952621455.5118446 0 .7071068.195262146.1952621.511844636.1952621.707106782 0z"],"hide_20":["M18.8905555 10.35125c-1.7229139 2.577-4.6637668 5.649-8.8905555 5.649-1.5759212 0-2.97385131-.428-4.19579021-1.097l9.26353681-9.264c1.6289186 1.116 2.9018549 2.631 3.8228089 4.01.1449927.217.1449927.485 0 .702m-17.78111097 0c-.144992753-.217-.144992753-.485 0-.702C2.83135843 7.07225 5.77121144 4.00025 10 4.00025c1.5769212 0 2.9738513.428 4.1957902 1.097l-9.26353681 9.264c-1.62791861-1.116-2.90185491-2.632-3.82280886-4.01m14.67726617-5.431l4.0657967-4.067c.1959902-.195.1959902-.511 0-.707-.1949903-.195-.5109745-.195-.7069647 0l-4.2207889 4.222c-1.3769312-.803-3.0158492-1.368-4.9247538-1.368-5.26273686 0-8.50357482 4.27-9.722513874 6.093-.3699815012.553-.3699815012 1.26 0 1.814.680965951 1.018 1.992900354 2.798 3.935803214 4.173l-4.066796665 4.066c-.1949902501.196-.1949902501.512 0 .707.097995101.098.225988701.147.353982301.147.127993601 0 .255987201-.049.352982351-.147l4.221788913-4.221c1.37693115.802 3.01584921 1.368 4.92475376 1.368 5.2627369 0 8.5035748-4.271 9.7225139-6.093.3699815-.554.3699815-1.261 0-1.814-.680966-1.018-1.9939003-2.799-3.9358032-4.173"],"hide_24":["M6.17624635 18.5308604l-5.322692959 5.322693c-.195262146.1952621-.511844636.1952621-.707106782 0-.1952621455-.1952622-.1952621455-.5118446 0-.7071068l5.136138681-5.1361387C2.82584197 16.4540062 1.17598021 14.3492107.333 13.0882c-.444-.664-.444-1.512 0-2.176C1.795 8.7242 5.684 4.0002 12 4.0002c2.2489224 0 4.1901399.59892798 5.8236525 1.46904075L23.1464466.146446609c.1952622-.1952621455.5118446-.1952621455.7071068 0 .1952621.195262146.1952621.511844636 0 .707106782L18.7173597 5.98974711C21.1741334 7.54587413 22.8240135 9.65060324 23.667 10.9122c.444.664.444 1.512 0 2.176-1.462 2.187-5.351 6.912-11.667 6.912-2.24896888 0-4.1902201-.5990795-5.82375365-1.4693396zm.74713968-.7471396C8.37192603 18.5103312 10.0657697 19.0002 12 19.0002c5.878 0 9.536-4.524 10.836-6.468.219-.328.219-.736 0-1.064-.7792628-1.1658971-2.4058019-3.25812073-4.8498936-4.74719966L6.92338603 17.7837208zm-.90956173-.5046519L17.0764927 6.21640049C15.6279795 5.48993319 13.9341763 5.0002 12 5.0002c-5.878 0-9.536 4.523-10.836 6.468-.219.328-.219.736 0 1.064.77925547 1.1652866 2.40577114 3.257601 4.8498243 4.7468689z"],"home_16":["M7.998 0c.425 0 .85.146 1.187.438l5.932 5.116c.561.484.883 1.188.883 1.928l0 7.268c0 .69-.56 1.25-1.25 1.25l-3.5 0c-.69 0-1.25-.56-1.25-1.25l0-4.39c0-.199-.161-.36-.36-.36l-3.28 0c-.199 0-.36.161-.36.36l0 4.39C6 15.44 5.44 16 4.75 16l-3.463 0c-.688 0-1.247-.556-1.25-1.243L0 7.491c-.004-.745.319-1.453.882-1.94L6.809.438C7.148.146 7.573 0 7.998 0zm0 1c-.199 0-.39.069-.536.196L1.536 6.309c-.343.295-.538.724-.536 1.177l.037 7.265c.001.138.113.249.25.249l3.463 0c.138 0 .25-.112.25-.25l0-4.39C5 9.61 5.61 9 6.36 9l3.28 0c.75 0 1.36.61 1.36 1.36l0 4.39c0 .138.112.25.25.25l3.5 0c.138 0 .25-.112.25-.25l0-7.268c0-.45-.195-.877-.536-1.17L8.533 1.196C8.386 1.069 8.197 1 7.998 1z"],"home_20":["M9.9974 0c-.531 0-1.062.183-1.485.548l-7.41 6.391c-.704.608-1.107 1.494-1.102 2.424l.045 8.946c.005.935.765 1.691 1.7 1.691l4.555 0c.938 0 1.7-.762 1.7-1.7l0-5.05c0-.139.112-.25.25-.25l3.5 0c.138 0 .25.111.25.25l0 5.05c0 .938.761 1.7 1.7 1.7l4.6 0c.938 0 1.7-.762 1.7-1.7l0-8.947c0-.927-.403-1.806-1.105-2.412L11.4824.548C11.0594.183 10.5284 0 9.9974 0m0 1c.308 0 .604.108.832.305l7.413 6.394c.482.414.758 1.018.758 1.654l0 8.947c0 .386-.314.7-.7.7l-4.6 0c-.386 0-.7-.314-.7-.7l0-5.05c0-.689-.561-1.25-1.25-1.25l-3.5 0c-.69 0-1.25.561-1.25 1.25l0 5.05c0 .386-.314.7-.7.7l-4.555 0c-.384 0-.698-.313-.7-.696l-.045-8.947c-.003-.638.272-1.244.756-1.661l7.409-6.391c.228-.197.523-.305.832-.305"],"home_24":["M11.9971.9999c.584 0 1.168.201 1.633.603l8.156 7.034c.771.665 1.214 1.633 1.214 2.651l0 10.212c0 .828-.671 1.5-1.5 1.5l-6.003 0c-.828 0-1.5-.672-1.5-1.5l0-5.983c0-.276-.225-.5-.5-.5l-3.001 0c-.275 0-.499.224-.499.499l0 5.984c0 .828-.672 1.5-1.5 1.5l-5.945 0c-.826 0-1.496-.667-1.5-1.492l-.052-10.208c-.005-1.024.438-1.998 1.213-2.667l8.15-7.03c.466-.402 1.05-.603 1.634-.603zm0 1c-.363 0-.712.128-.981.36l-8.149 7.03c-.555.479-.871 1.173-.867 1.905l.052 10.208c.001.274.226.497.5.497l5.945 0c.275 0 .5-.225.5-.5l0-5.984c0-.827.672-1.499 1.499-1.499l3.001 0c.828 0 1.5.672 1.5 1.5l0 5.983c0 .275.225.5.5.5l6.003 0c.276 0 .5-.225.5-.5l0-10.212c0-.728-.316-1.418-.868-1.894l-8.155-7.034c-.269-.232-.617-.36-.98-.36z"],"home_32":["M15.9961 1c.797 0 1.593.274 2.228.822l11.12 9.592c1.051.907 1.656 2.227 1.656 3.615l0 13.971c0 1.104-.896 2-2 2l-8 0c-1.105 0-2-.896-2-2l0-8.318c0-.375-.307-.682-.682-.682l-4.636 0c-.375 0-.682.307-.682.682l0 8.318c0 1.104-.896 2-2 2l-7.929 0c-1.1 0-1.994-.89-2-1.99l-.071-13.965c-.007-1.396.598-2.725 1.654-3.636l11.113-9.587c.635-.548 1.432-.822 2.229-.822zm0 1c-.583 0-1.143.206-1.576.58l-11.112 9.586c-.837.722-1.314 1.769-1.308 2.874l.071 13.965c.003.549.451.995 1 .995l7.929 0c.552 0 1-.448 1-1l0-8.318c0-.928.754-1.682 1.682-1.682l4.636 0c.927 0 1.682.754 1.682 1.682l0 8.318c0 .552.448 1 1 1l8 0c.552 0 1-.448 1-1l0-13.971c0-1.098-.478-2.14-1.31-2.858l-11.12-9.592c-.432-.373-.991-.579-1.574-.579z"],"home-active_16":["M7.99803672 0c-.425 0-.85.146-1.189.438L.882036717 5.551c-.563.487-.8859999998 1.195-.8819999998 1.94l.037 7.266c.003.687.5619999998 1.243 1.2500000028 1.243l3.463 0c.69 0 1.25-.56 1.25-1.25l0-4.39c0-.199.161-.36.36-.36l3.28 0c.199 0 .35999998.161.35999998.36l0 4.39c0 .69.56 1.25 1.25 1.25l3.5 0c.69 0 1.25-.56 1.25-1.25l0-7.268c0-.74-.322-1.444-.883-1.928L9.18503672.438c-.337-.292-.762-.438-1.187-.438"],"home-active_20":["M9.9974 0c-.531 0-1.062.183-1.485.548l-7.41 6.391c-.704.608-1.107 1.494-1.102 2.424l.045 8.946c.005.935.765 1.691 1.7 1.691l4.555 0c.938 0 1.7-.762 1.7-1.7l0-5.05c0-.139.112-.25.25-.25l3.5 0c.138 0 .25.111.25.25l0 5.05c0 .938.761 1.7 1.7 1.7l4.6 0c.938 0 1.7-.762 1.7-1.7l0-8.947c0-.927-.403-1.806-1.105-2.412L11.4824.548C11.0594.183 10.5284 0 9.9974 0"],"home-active_24":["M13.63006 1.603c-.93-.804-2.335-.804-3.26799996 0l-8.149 7.03c-.775000005.669-1.2190000047 1.643-1.2130000047 2.667l.052 10.208c.004.825.6739999997 1.492 1.4990000047 1.492l5.945 0c.828 0 1.5-.672 1.5-1.5l0-5.984c0-.275.225-.499.5-.499l3.00099996 0c.275 0 .5.224.5.5l0 5.983c0 .828.672 1.5 1.5 1.5l6.003 0c.828 0 1.5-.672 1.5-1.5l0-10.212c0-1.018-.444-1.986-1.215-2.651l-8.155-7.034z"],"home-active_32":["M15.9960601 1c-.797 0-1.594.274-2.229.822L2.65406008 11.409c-1.056000001.911-1.6610000008 2.24-1.6540000008 3.636l.071 13.965c.006 1.1.8999999998 1.99 2.0000000008 1.99l7.92900002 0c1.104 0 2-.896 2-2l0-8.318c0-.375.307-.682.682-.682l4.636 0c.375 0 .682.307.682.682l0 8.318c0 1.104.895 2 2 2l8 0c1.104 0 2-.896 2-2l0-13.971c0-1.388-.605-2.708-1.656-3.615l-11.12-9.592c-.635-.548-1.431-.822-2.228-.822"],"house_16":["M14 14.0001256c0 .5509654-.449.9999372-1 .9999372l-2 0 0-6.49859199c0-.27598267-.224-.49996861-.5-.49996861l-5 0c-.276 0-.5.22398594-.5.49996861l0 6.49859199-2 0c-.551 0-1-.4489718-1-.9999372l0-6.83857066c0-.2309855.096-.45097169.271-.61896114L8.005.996941991 13.729 6.5425938l.001 0c.174.16798945.27.38797564.27.61896114l0 6.83857066zm-8 .9999372l4 0 0-5.99862338-4 0 0 5.99862338zm8.425-9.17642386L8.695.272987446c-.388-.3649770846-1-.3649770846-1.397.005999623L1.575 5.82363894C1.204 6.1826164 1 6.65758658 1 7.16155494l0 6.83857066C1 15.1030563 1.897 16 3 16l10 0c1.103 0 2-.8969437 2-1.9998744l0-6.83857066c0-.50396836-.204-.97893854-.575-1.337916z"],"house_24":["M20 20.4907c0 .806-.656 1.461-1.461 1.461l-2.539 0 0-9.5c0-.276-.224-.5-.5-.5l-7 0c-.276 0-.5.224-.5.5l0 9.5-2.539 0c-.805 0-1.461-.655-1.461-1.461l0-9.711c0-.382.146-.743.412-1.017l7.479-7.727c.031-.031.071-.046.111-.046.038 0 .075.014.101.04l7.486 7.734c.265.273.411.634.411 1.016l0 9.711zm-11 1.461l6 0 0-9-6 0 0 9zM20.307 9.0675735l-7.491-7.739070507c-.436-.436003972-1.191-.442004027-1.638.006000055L3.693 9.0675735C3.246 9.5285777 3 10.13658324 3 10.7795891l0 9.7110885C3 21.8476899 4.104 22.9517 5.461 22.9517l13.078 0c1.357 0 2.461-1.1040101 2.461-2.4610224l0-9.7110885c0-.64300586-.246-1.2510114-.693-1.7120156z"],"house_32":["M28 28.3976258c0 1.434-1.178 2.601-2.625 2.601l-4.375 0 0-14.505c0-.277-.224-.5-.5-.5l-9 0c-.276 0-.5.223-.5.5l0 14.505-4.375 0c-1.447 0-2.625-1.167-2.625-2.601l0-14.846c0-.588.227-1.144.632-1.56L15.697 1.12362577c.083-.083.193-.124000002.303-.124000002.109 0 .22.042000002.304.125000002L27.36 11.9836258c.413.424.64.98.64 1.568l0 14.846zm-16 2.601l8 0 0-14.005-8 0 0 14.005zm16.069-19.72L17.007.412625768c-.556-.549-1.459-.551-2.012-.001L3.924 11.2866258c-.596.611-.924 1.416-.924 2.265l0 14.846c0 1.985 1.626 3.601 3.625 3.601l18.75 0c1.999 0 3.625-1.616 3.625-3.601l0-14.846c0-.849-.328-1.654-.931-2.273z"],"hunt-group_16":["M15 14c0 .551-.449 1-1 1l-7 0c-.551 0-1-.449-1-1l0-3 3 0c1.103 0 2-.897 2-2l0-3 3 0c.551 0 1 .449 1 1l0 7zm-5-8l0 3c0 .551-.449 1-1 1l-3 0 0-3c0-.551.449-1 1-1l3 0zM5 7l0 3-3 0c-.551 0-1-.449-1-1l0-7c0-.551.449-1 1-1l7 0c.551 0 1 .449 1 1l0 3-3 0c-1.103 0-2 .897-2 2zm9-2l-3 0 0-3c0-1.103-.897-2-2-2L2 0C.897 0 0 .897 0 2l0 7c0 1.103.897 2 2 2l3 0 0 3c0 1.103.897 2 2 2l7 0c1.103 0 2-.897 2-2l0-7c0-1.103-.897-2-2-2z"],"import_16":["M14 7.499c0-.274.225-.5.5-.5.275 0 .5.226.5.5L15 13c0 1.105-.896 2-2 2l-9.999 0c-1.104 0-2-.895-2-2L1 7.499c0-.274.225-.5.5-.5.275 0 .499.226.499.5L2 13c0 .551.448 1 1 1l10 0c.552 0 1-.449 1-1l0-5.501zm-6.35375 4.3545l-4-4c-.195-.195-.195-.512 0-.707.196-.195.512-.195.707 0l3.147 3.146 0-8.793c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 8.793 3.146-3.146c.196-.195.512-.195.707 0 .196.195.196.512 0 .707l-3.999 4c-.046.045-.102.082-.163.108-.061.026-.126.038-.191.038-.065 0-.13-.012-.191-.038-.062-.026-.117-.063-.163-.108z"],"import_24":["M5.647 11.8534c-.196-.195-.196-.512 0-.707.195-.195.511-.195.707 0l5.146 5.146 0-13.793c0-.276.22-.5.496-.5.276 0 .499.224.499.5l0 13.793 5.144-5.146c.195-.195.511-.195.706 0 .195.195.195.512 0 .707l-5.995 6c-.046.046-.102.082-.163.108-.061.026-.126.038-.191.038-.065 0-.13-.012-.191-.038-.061-.026-.117-.062-.163-.108l-5.995-6zM22 11.4999c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 7.875c0 1.447-1.177 2.625-2.625 2.625l-16.75 0c-1.448 0-2.625-1.178-2.625-2.625l0-7.875c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 7.926c0 .868.707 1.574 1.575 1.574l16.85 0c.868 0 1.575-.706 1.575-1.574l0-7.926z"],"incoming-call-legacy_16":["M13.701 10.6729c.789.34 1.299 1.114 1.299 1.972l0 1.616c0 .542-.245 1.042-.673 1.375-.307.239-.678.364-1.056.364-.141 0-.285-.017-.425-.053-2.515-.639-5.385-2.432-7.872-4.92C2.485 8.5389.692 5.6689.053 3.1539c-.131-.518-.017-1.058.312-1.481.332-.428.833-.673 1.374-.673l1.616 0c.858 0 1.632.51 1.972 1.299l.61 1.419c.299.694.276 1.48-.062 2.155l-.412.823c-.056.113-.042.249.039.353.853 1.098 2.15 2.384 3.466 3.44.102.083.238.098.352.041l.808-.405c.676-.338 1.461-.359 2.154-.062l1.419.61zm.299 3.588l0-1.616c0-.458-.272-.872-.694-1.053l-1.418-.61-.001 0c-.423-.182-.901-.169-1.312.038l-.808.404c-.462.23-1.021.17-1.425-.156-1.393-1.117-2.716-2.432-3.629-3.605-.315-.405-.371-.96-.144-1.414l.411-.823c.207-.412.22-.891.039-1.313l-.611-1.419c-.181-.421-.595-.694-1.053-.694l-1.616 0c-.23 0-.443.105-.585.286-.138.179-.186.405-.131.622.595 2.346 2.293 5.047 4.658 7.412 2.364 2.364 5.066 4.062 7.411 4.657.217.056.444.007.621-.131.183-.141.287-.356.287-.585zM9.5 7.0002c-.275 0-.5-.225-.5-.5l0-6c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 4.793 5.146-5.147c.098-.097.226-.146.354-.146.128 0 .256.049.354.146.195.196.195.512 0 .708l-5.147 5.146 4.793 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-.998 0-.002 0-.005 0-4.995 0z"],"incoming-call-legacy_20":["M18.346 13.1129c1.005.433 1.654 1.418 1.654 2.513l0 2.192c0 .679-.308 1.308-.844 1.725-.386.3-.849.457-1.323.457-.177 0-.356-.022-.534-.067-3.383-.86-7.248-3.276-10.602-6.63C3.342 9.9479.926 6.0839.067 2.6999c-.165-.649-.023-1.325.39-1.856.418-.536 1.046-.844 1.725-.844l2.193 0c1.094 0 2.08.65 2.512 1.655l.828 1.925c.384.893.355 1.904-.08 2.774l-.558 1.117c-.109.217-.081.473.071.669 1.167 1.5 2.936 3.257 4.732 4.698.191.153.455.183.67.076l1.096-.549c.87-.435 1.881-.464 2.774-.08l1.926.828zm.654 4.705l0-2.192c0-.694-.412-1.32-1.049-1.594l-1.926-.828c-.622-.268-1.325-.247-1.931.056l-1.097.548c-.563.282-1.248.207-1.743-.19-1.88-1.509-3.665-3.282-4.896-4.864-.385-.496-.454-1.175-.176-1.73l.559-1.117c.302-.606.322-1.31.055-1.931l-.828-1.926c-.274-.638-.9-1.05-1.593-1.05l-2.193 0c-.368 0-.709.167-.935.458-.223.285-.299.649-.211.996.816 3.214 3.137 6.911 6.368 10.142 3.231 3.23 6.927 5.551 10.141 6.368.348.088.712.012.997-.21.291-.227.458-.568.458-.936zM12.5 8c-.275 0-.5-.225-.5-.5l0-6c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 4.793L19.146.146C19.244.049 19.372 0 19.5 0c.128 0 .256.049.354.146.195.196.195.512 0 .708L13.707 7 18.5 7c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-6 0z"],"info_12":["M6.0001 0c3.313 0 6 2.687 6 6 0 3.313-2.687 6-6 6-3.314 0-6-2.687-6-6 0-3.313 2.686-6 6-6zm0 11c2.757 0 5-2.243 5-5 0-2.757-2.243-5-5-5-2.757 0-5 2.243-5 5 0 2.757 2.243 5 5 5zm0-8c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0 2c.275 0 .5.225.5.5l0 3c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-3c0-.275.225-.5.5-.5z"],"info_16":["M7.9999 0c4.418 0 8 3.582 8 8 0 4.418-3.582 8-8 8-4.418 0-8-3.582-8-8 0-4.418 3.582-8 8-8zm0 15c3.86 0 7-3.14 7-7 0-3.86-3.14-7-7-7-3.86 0-7 3.14-7 7 0 3.86 3.14 7 7 7zm0-10.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0 2c.275 0 .5.225.5.5l0 4c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-4c0-.275.225-.5.5-.5z"],"info_18":["M9.0001 0c4.97 0 9 4.029 9 9 0 4.971-4.03 9-9 9-4.971 0-9-4.029-9-9 0-4.971 4.029-9 9-9zm0 17c4.411 0 8-3.589 8-8 0-4.411-3.589-8-8-8-4.411 0-8 3.589-8 8 0 4.411 3.589 8 8 8zm0-12c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0 3c.275 0 .5.225.5.5l0 4c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-4c0-.275.225-.5.5-.5z"],"info_20":["M9.9999 0c5.523 0 10 4.477 10 10 0 5.523-4.477 10-10 10-5.523 0-10-4.477-10-10 0-5.523 4.477-10 10-10zm0 19c4.963 0 9-4.037 9-9 0-4.963-4.037-9-9-9-4.962 0-9 4.037-9 9 0 4.963 4.038 9 9 9zm0-13c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0 3c.275 0 .5.225.5.5l0 4c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-4c0-.275.225-.5.5-.5z"],"info_24":["M12.0002 0c6.627 0 12 5.373 12 12 0 6.627-5.373 12-12 12-6.627 0-12-5.373-12-12 0-6.627 5.373-12 12-12zm0 23c6.065 0 11-4.935 11-11 0-6.065-4.935-11-11-11-6.065 0-11 4.935-11 11 0 6.065 4.935 11 11 11zm0-16c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0 3c.275 0 .5.225.5.5l0 6c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-6c0-.275.225-.5.5-.5z"],"info_28":["M13.9998 0c7.732 0 14 6.268 14 14 0 7.732-6.268 14-14 14-7.732 0-14-6.268-14-14 0-7.732 6.268-14 14-14zm0 27c7.168 0 13-5.832 13-13 0-7.168-5.832-13-13-13-7.168 0-13 5.832-13 13 0 7.168 5.832 13 13 13zm0-19c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0 3c.275 0 .5.225.5.5l0 8c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-8c0-.275.225-.5.5-.5z"],"info_32":["M15.9996 0c8.837 0 16 7.164 16 16 0 8.836-7.163 16-16 16-8.836 0-16-7.164-16-16 0-8.836 7.164-16 16-16zm0 31c8.271 0 15-6.729 15-15 0-8.271-6.729-15-15-15-8.271 0-15 6.729-15 15 0 8.271 6.729 15 15 15zm.0009-22c.275 0 .5.224.5.5 0 .276-.225.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0 4c.274 0 .5.225.5.5l0 9c0 .275-.226.5-.5.5-.275 0-.5-.225-.5-.5l0-9c0-.275.225-.5.5-.5z"],"info_40":["M20 0C8.972 0 0 8.972 0 20c0 11.028 8.972 20 20 20 11.028 0 20-8.972 20-20C40 8.972 31.028 0 20 0zm0 39C9.523 39 1 30.477 1 20 1 9.523 9.523 1 20 1c10.477 0 19 8.523 19 19 0 10.477-8.523 19-19 19zm0-23c-.276 0-.5.224-.5.5l0 12c0 .276.224.5.5.5.276 0 .5-.224.5-.5l0-12c0-.276-.224-.5-.5-.5zm0-4.9976c-.13 0-.26.05-.35.15-.1.09-.15.22-.15.35 0 .13.05.26.15.36.04.04.1.08.16.1.12.05.26.05.38 0 .06-.02.12-.06.16-.1.1-.1.15-.23.15-.36 0-.13-.05-.26-.15-.35-.04-.05-.1-.09-.16-.11-.06-.03-.12-.04-.19-.04z"],"info_44":["M22 44C9.869 44 0 34.131 0 22 0 9.869 9.869 0 22 0c12.131 0 22 9.869 22 22 0 12.131-9.869 22-22 22zm0-43C10.42 1 1 10.42 1 22c0 11.58 9.42 21 21 21 11.58 0 21-9.42 21-21 0-11.58-9.42-21-21-21zm.5 12.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5zM22 31c-.276 0-.5-.224-.5-.5l0-13c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 13c0 .276-.224.5-.5.5z"],"info_72":["M36.0004 0c19.882 0 36 16.118 36 36 0 19.882-16.118 36-36 36-19.883 0-36-16.118-36-36 0-19.882 16.117-36 36-36zm0 71c19.299 0 35-15.701 35-35 0-19.299-15.701-35-35-35-19.3 0-35 15.701-35 35 0 19.299 15.7 35 35 35zm0-50c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0 7c.274 0 .5.225.5.5l0 22c0 .275-.226.5-.5.5-.275 0-.5-.225-.5-.5l0-22c0-.275.225-.5.5-.5z"],"info-active_12":["M6.0001 0c3.313 0 6 2.687 6 6 0 3.313-2.687 6-6 6-3.314 0-6-2.687-6-6 0-3.313 2.686-6 6-6zm0 3c-.276 0-.5.224-.5.5 0 .276.224.5.5.5.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5zm0 2c-.275 0-.5.225-.5.5l0 3c0 .275.225.5.5.5.275 0 .5-.225.5-.5l0-3c0-.275-.225-.5-.5-.5z"],"info-active_16":["M7.9999 0c4.418 0 8 3.582 8 8 0 4.418-3.582 8-8 8-4.418 0-8-3.582-8-8 0-4.418 3.582-8 8-8zm0 4.5c-.276 0-.5.224-.5.5 0 .276.224.5.5.5.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5zm0 2c-.275 0-.5.225-.5.5l0 4c0 .275.225.5.5.5.275 0 .5-.225.5-.5l0-4c0-.275-.225-.5-.5-.5z"],"info-active_18":["M9.0001 0c4.97 0 9 4.029 9 9 0 4.971-4.03 9-9 9-4.971 0-9-4.029-9-9 0-4.971 4.029-9 9-9zm0 5c-.276 0-.5.224-.5.5 0 .276.224.5.5.5.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5zm0 3c-.275 0-.5.225-.5.5l0 4c0 .275.225.5.5.5.275 0 .5-.225.5-.5l0-4c0-.275-.225-.5-.5-.5z"],"info-active_20":["M9.9999 0c5.523 0 10 4.477 10 10 0 5.523-4.477 10-10 10-5.523 0-10-4.477-10-10 0-5.523 4.477-10 10-10zm0 6c-.276 0-.5.224-.5.5 0 .276.224.5.5.5.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5zm0 3c-.275 0-.5.225-.5.5l0 4c0 .275.225.5.5.5.275 0 .5-.225.5-.5l0-4c0-.275-.225-.5-.5-.5z"],"info-active_24":["M12.0002 0c6.627 0 12 5.373 12 12 0 6.627-5.373 12-12 12-6.627 0-12-5.373-12-12 0-6.627 5.373-12 12-12zm0 7c-.276 0-.5.224-.5.5 0 .276.224.5.5.5.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5zm0 3c-.275 0-.5.225-.5.5l0 6c0 .275.225.5.5.5.275 0 .5-.225.5-.5l0-6c0-.275-.225-.5-.5-.5z"],"info-active_28":["M13.9998 0c7.732 0 14 6.268 14 14 0 7.732-6.268 14-14 14-7.732 0-14-6.268-14-14 0-7.732 6.268-14 14-14zm0 8c-.276 0-.5.224-.5.5 0 .276.224.5.5.5.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5zm0 3c-.275 0-.5.225-.5.5l0 8c0 .275.225.5.5.5.275 0 .5-.225.5-.5l0-8c0-.275-.225-.5-.5-.5z"],"info-active_32":["M15.9996 0c8.837 0 16 7.164 16 16 0 8.836-7.163 16-16 16-8.836 0-16-7.164-16-16 0-8.836 7.164-16 16-16zm.0009 9c-.276 0-.5.224-.5.5 0 .276.224.5.5.5.275 0 .5-.224.5-.5 0-.276-.225-.5-.5-.5zm0 4c-.275 0-.5.225-.5.5l0 9c0 .275.225.5.5.5.274 0 .5-.225.5-.5l0-9c0-.275-.226-.5-.5-.5z"],"info-active_40":["M20 0C8.972 0 0 8.972 0 20c0 11.028 8.972 20 20 20 11.028 0 20-8.972 20-20C40 8.972 31.028 0 20 0zm0 16c.276 0 .5.224.5.5l0 12c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-12c0-.276.224-.5.5-.5zm0-4.9976c.07 0 .13.01.19.04.06.02.12.06.16.11.1.09.15.22.15.35 0 .13-.05.26-.15.36-.04.04-.1.08-.16.1-.12.05-.26.05-.38 0-.06-.02-.12-.06-.16-.1-.1-.1-.15-.23-.15-.36 0-.13.05-.26.15-.35.09-.1.22-.15.35-.15z"],"info-active_44":["M22 44C9.869 44 0 34.131 0 22 0 9.869 9.869 0 22 0c12.131 0 22 9.869 22 22 0 12.131-9.869 22-22 22zm.5-30.5c0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5 0 .276.224.5.5.5.276 0 .5-.224.5-.5zM22 31c.276 0 .5-.224.5-.5l0-13c0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5l0 13c0 .276.224.5.5.5z"],"info-active_72":["M36.0004 0c19.882 0 36 16.118 36 36 0 19.882-16.118 36-36 36-19.883 0-36-16.118-36-36 0-19.882 16.117-36 36-36zm0 21c-.276 0-.5.224-.5.5 0 .276.224.5.5.5.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5zm0 7c-.275 0-.5.225-.5.5l0 22c0 .275.225.5.5.5.274 0 .5-.225.5-.5l0-22c0-.275-.226-.5-.5-.5z"],"info-i_10":["M5 3c.27614237 0 .5.22385763.5.5l0 5c0 .27614237-.22385763.5-.5.5-.276142375 0-.5-.22385763-.5-.5l0-5c0-.27614237.223857625-.5.5-.5zm0-1c-.276142375 0-.5-.223857625-.5-.5 0-.276142375.223857625-.5.5-.5.27614237 0 .5.223857625.5.5 0 .276142375-.22385763.5-.5.5z"],"info-i_12":["M5.5 2c0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5zm0 2.00342274C5.5 3.72539004 5.731933594 3.5 6 3.5c.27614237 0 .5.23290253.5.50342274l0 5.99315452C6.5 10.27460996 6.26806641 10.5 6 10.5c-.276142375 0-.5-.23290253-.5-.50342274l0-5.99315452z"],"info-i_8":["M4 1c-.276142375 0-.5-.223857625-.5-.5 0-.276142375.223857625-.5.5-.5.27614237 0 .5.223857625.5.5 0 .276142375-.22385763.5-.5.5zm0 1c.27614237 0 .5.22385763.5.5l0 5c0 .27614237-.22385763.5-.5.5-.276142375 0-.5-.22385763-.5-.5l0-5c0-.27614237.223857625-.5.5-.5z"],"input_10":["M5 9C2.966 9 1.3 7.468 1.051 5.5l4.234 0-1.126 1.124c-.196.194-.196.511-.001.707.097.098.225.147.354.147.128 0 .255-.049.353-.147l1.982-1.977c.094-.093.147-.221.147-.354 0-.133-.053-.26-.146-.354L4.865 2.664c-.195-.195-.511-.195-.707 0-.195.195-.195.512 0 .707L5.287 4.5l-4.236 0C1.3 2.532 2.966 1 5 1c2.206 0 4 1.794 4 4 0 2.206-1.794 4-4 4m0-9C2.243 0 0 2.243 0 5c0 2.757 2.243 5 5 5 2.757 0 5-2.243 5-5 0-2.757-2.243-5-5-5"],"input_12":["M6 11c-2.586 0-4.694-1.98-4.949-4.5l5.742 0-1.647 1.646c-.195.196-.195.512 0 .708.098.097.226.146.354.146.128 0 .256-.049.354-.146l2.5-2.5c.195-.196.195-.512 0-.708l-2.5-2.5c-.196-.195-.512-.195-.708 0-.195.196-.195.512 0 .708L6.793 5.5l-5.742 0C1.306 2.98 3.414 1 6 1c2.757 0 5 2.243 5 5 0 2.757-2.243 5-5 5M6 0C2.691 0 0 2.691 0 6c0 3.309 2.691 6 6 6 3.309 0 6-2.691 6-6 0-3.309-2.691-6-6-6"],"input_14":["M7 13c-3.14 0-5.719-2.425-5.975-5.5l7.259 0-2.125 2.121c-.196.194-.196.512-.001.707.097.098.226.147.354.147.128 0 .255-.049.353-.147l2.98-2.974c.094-.094.147-.221.147-.354 0-.133-.053-.26-.146-.354l-2.981-2.98c-.195-.195-.511-.195-.707 0-.195.195-.195.512 0 .707L8.285 6.5l-7.26 0C1.281 3.425 3.86 1 7 1c3.309 0 6 2.691 6 6 0 3.309-2.691 6-6 6M7 0C3.14 0 0 3.14 0 7c0 3.86 3.14 7 7 7 3.86 0 7-3.14 7-7 0-3.86-3.14-7-7-7"],"input_16":["M8 15c-3.691 0-6.716-2.874-6.975-6.5l7.768 0-2.646 2.646c-.195.196-.195.512 0 .708.098.097.226.146.353.146.128 0 .256-.049.354-.146l3.5-3.5c.195-.196.195-.512 0-.708l-3.5-3.503c-.195-.196-.512-.196-.708 0-.195.195-.195.511 0 .707L8.793 7.5l-7.768 0C1.284 3.874 4.309 1 8 1c3.86 0 7 3.141 7 7 0 3.859-3.14 7-7 7M8 0C3.589 0 0 3.588 0 8c0 4.411 3.589 8 8 8 4.411 0 8-3.589 8-8 0-4.412-3.589-8-8-8"],"input_24":["M12 23C6.104 23 1.289 18.333 1.025 12.5l12.768 0-4.647 4.646c-.195.196-.195.512 0 .708.098.097.226.146.354.146.128 0 .256-.049.354-.146l5.5-5.5c.195-.196.195-.512 0-.708l-5.5-5.5c-.196-.195-.512-.195-.708 0-.195.196-.195.512 0 .708l4.647 4.646-12.768 0C1.289 5.667 6.104 1 12 1c6.065 0 11 4.935 11 11 0 6.065-4.935 11-11 11m0-23C5.383 0 0 5.383 0 12c0 6.617 5.383 12 12 12 6.617 0 12-5.383 12-12 0-6.617-5.383-12-12-12"],"input_26":["M13 25C6.552 25 1.29 19.884 1.025 13.5l14.273 0-5.105 5.104c-.195.196-.195.512 0 .708.098.097.226.146.354.146.128 0 .256-.049.353-.146l5.958-5.958c.196-.196.196-.512 0-.708L10.9 6.688c-.195-.195-.511-.195-.707 0-.195.196-.195.512 0 .708l5.105 5.104-14.273 0C1.29 6.116 6.552 1 13 1c6.617 0 12 5.383 12 12 0 6.617-5.383 12-12 12m0-25C5.832 0 0 5.831 0 13c0 7.168 5.832 13 13 13 7.168 0 13-5.832 13-13 0-7.169-5.832-13-13-13"],"input_28":["M15.293 13L.856 13 1 14l14.293 0-4.147 4.146c-.195.196-.195.512 0 .708.098.097.226.146.354.146.128 0 .256-.049.354-.146l5-5c.195-.196.195-.512 0-.708l-5-5C11.756 8.049 11.628 8 11.5 8c-.128 0-.256.049-.354.146-.195.196-.195.512 0 .708L15.293 13z","M14 0C6.268 0 0 6.268 0 14c0 7.732 6.268 14 14 14 7.732 0 14-6.268 14-14 0-7.732-6.268-14-14-14m0 1c7.168 0 13 5.832 13 13 0 7.168-5.832 13-13 13-7.168 0-13-5.832-13-13C1 6.832 6.832 1 14 1"],"input_36":["M18 34C9.347 34 2.293 27.09 2.025 18.5l20.767 0-6.645 6.632c-.195.194-.195.512 0 .707.098.098.226.146.354.146.128 0 .256-.048.353-.146l7.5-7.485c.093-.094.146-.221.146-.354 0-.133-.053-.26-.146-.354l-7.5-7.5c-.196-.195-.512-.195-.708 0-.195.196-.195.512 0 .708l6.647 6.646-20.768 0C2.293 8.91 9.347 2 18 2c8.822 0 16 7.178 16 16 0 8.822-7.178 16-16 16m0-33C8.626 1 1 8.625 1 18c0 9.374 7.626 17 17 17 9.374 0 17-7.626 17-17 0-9.375-7.626-17-17-17"],"input_8":["M4 7C2.517 7 1.29 5.916 1.051 4.5l2.741 0-.648.646c-.196.195-.196.511-.001.708.097.097.226.146.354.146.128 0 .255-.049.353-.146l1.503-1.5C5.447 4.26 5.5 4.133 5.5 4c0-.133-.053-.26-.146-.354L3.85 2.143c-.195-.196-.512-.196-.707 0-.195.195-.195.511 0 .707l.65.65-2.742 0C1.29 2.084 2.517 1 4 1c1.654 0 3 1.346 3 3 0 1.654-1.346 3-3 3m0-7C1.794 0 0 1.794 0 4c0 2.206 1.794 4 4 4 2.206 0 4-1.794 4-4 0-2.206-1.794-4-4-4"],"jabber_16":["M8 13c-.136 0-.266.055-.36.153-.686.713-1.713 1.245-3.122 1.616.334-.605.634-1.193.9-1.761.004-.006.01-.008.014-.014.036-.069.05-.143.052-.216 0-.002-.001-.005-.001-.007.001-.061-.007-.121-.028-.177-.004-.015-.015-.026-.021-.04-.02-.043-.041-.085-.072-.121-.021-.023-.049-.04-.074-.059-.023-.018-.041-.041-.067-.055-1.151-.603-2.038-1.546-2.59-2.663.413.212.874.344 1.37.344.851 0 1.666-.153 2.42-.433.023-.006.048-.016.07-.026 2.622-1.005 4.488-3.549 4.488-6.521 0-.421-.026-.842-.066-1.261C12.752 2.785 14 4.748 14 7c0 3.309-2.691 6-6 6M4 5c1.103 0 2 .897 2 2 0 .603-.049 1.153-.153 1.708C5.266 8.897 4.645 9 4.001 9c-1.094 0-1.983-.874-1.998-1.959 0-.011-.002-.022-.002-.033C2.004 5.919 2.918 5 4 5M10.448.45c-.014-.004-.025-.011-.039-.014C9.657.159 8.848 0 8 0 6.131 0 4.372.728 3.05 2.05c-.196.196-.196.512 0 .707.195.196.512.196.707 0C4.891 1.624 6.397 1 8 1c.645 0 1.265.105 1.847.294.082.571.132 1.15.132 1.727 0 2.233-1.23 4.184-3.048 5.211C6.978 7.833 7 7.429 7 7c0-1.654-1.346-3-2.999-3C2.36 4 1.026 5.331 1.004 6.98c0 .007-.004.013-.004.02 0 .004.001.008.001.012 0 .003-.001.005-.001.008 0 .014.004.027.004.041.021 2.422 1.285 4.622 3.328 5.883-.36.739-.768 1.506-1.241 2.3-.101.169-.093.381.019.542.094.135.248.214.411.214.03 0 .06-.002.089-.008 2.088-.383 3.595-1.036 4.599-1.995C11.973 13.886 15 10.79 15 7c0-2.998-1.898-5.554-4.552-6.55"],"jabber-hub_16":["M12 0c1.105 0 2 .895 2 2l0 12c0 1.104-.895 1.999-1.999 2L12 16l-8 0-.001 0C2.895 15.999 2 15.104 2 14L2 2c0-1.105.895-2 2-2l8 0zm1 5l0-3c0-.551-.449-1-1-1L4 1c-.551 0-1 .449-1 1l0 3 10 0zm0 9l0-8L3 6l0 8c0 .551.449 1 1 1l8 0c.551 0 1-.449 1-1zM11.001 2.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5L7.5 3.5c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l3.501 0zM5 2.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5z"],"keyboard_16":["M2 4c-.55228475 0-1 .44771525-1 1l0 6c0 .55228475.44771525 1 1 1l12 0c.5522847 0 1-.44771525 1-1l0-6c0-.55228475-.4477153-1-1-1L2 4zm0-1l12 0c1.1045695 0 2 .8954305 2 2l0 6c0 1.1045695-.8954305 2-2 2L2 13c-1.1045695 0-2-.8954305-2-2l0-6c0-1.1045695.8954305-2 2-2zm1.5 4c.27614237 0 .5-.22385763.5-.5 0-.27614237-.22385763-.5-.5-.5-.27614237 0-.5.22385763-.5.5 0 .27614237.22385763.5.5.5zm3 0c.27614237 0 .5-.22385763.5-.5 0-.27614237-.22385763-.5-.5-.5-.27614237 0-.5.22385763-.5.5 0 .27614237.22385763.5.5.5zm3 0c.27614237 0 .5-.22385763.5-.5 0-.27614237-.22385763-.5-.5-.5-.27614237 0-.5.22385763-.5.5 0 .27614237.22385763.5.5.5zm3 0c.2761424 0 .5-.22385763.5-.5 0-.27614237-.2238576-.5-.5-.5-.2761424 0-.5.22385763-.5.5 0 .27614237.2238576.5.5.5zm-9 3c.27614237 0 .5-.22385763.5-.5 0-.27614237-.22385763-.5-.5-.5-.27614237 0-.5.22385763-.5.5 0 .27614237.22385763.5.5.5zm9 0c.2761424 0 .5-.22385763.5-.5 0-.27614237-.2238576-.5-.5-.5-.2761424 0-.5.22385763-.5.5 0 .27614237.2238576.5.5.5zm-6-1l3 0c.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5l-3 0c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5z"],"keyboard_20":["M17.5 4C18.881 4 20 5.119 20 6.5l0 8c0 1.381-1.119 2.5-2.5 2.5l-15 0C1.119 17 0 15.881 0 14.5l0-8C0 5.119 1.119 4 2.5 4l15 0zM19 14.5l0-8c0-.829-.671-1.5-1.5-1.5l-15 0C1.671 5 1 5.671 1 6.5l0 8c0 .828.671 1.5 1.5 1.5l15 0c.829 0 1.5-.672 1.5-1.5zM3.5 10c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0-3c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0 6c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm4.3335-2c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5zm4.333 2c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-4.333 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l4.333 0zm-4.333-5c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5zm4.333-1c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zM16.5 10c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0-3c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm-4.3335 3c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zM16.5 13c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5z"],"keyboard_24":["M21.5 4C22.878 4 24 5.121 24 6.5l0 11c0 1.379-1.122 2.5-2.5 2.5l-19 0C1.122 20 0 18.879 0 17.5l0-11C0 5.121 1.122 4 2.5 4l19 0zM23 17.5l0-11c0-.827-.673-1.5-1.5-1.5l-19 0C1.673 5 1 5.673 1 6.5l0 11c0 .827.673 1.5 1.5 1.5l19 0c.827 0 1.5-.673 1.5-1.5zm-12.5-5c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5zM7.5 9c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5zm-3 6c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm3-2.5c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5zm6-3.5c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5zm-3 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5zm3 3.5c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5zM4.5 8c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm15 7c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0-7c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm-15 3.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm15 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm-3-3.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0 7c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-9 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l9 0zm0-3.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5z"],"keyboard_28":["M25 5c1.657 0 3 1.343 3 3l0 12c0 1.657-1.343 3-3 3L3 23c-1.657 0-3-1.343-3-3L0 8c0-1.657 1.343-3 3-3l22 0zm2 15l0-12c0-1.104-.896-2-2-2L3 6c-1.104 0-2 .896-2 2l0 12c0 1.104.896 2 2 2l22 0c1.104 0 2-.896 2-2zM5.5 18c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm8.5-8c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5zm-8.5 3.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm4.25 1c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5zm4.25 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5zM5.5 9c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm4.25 1c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5zm12.75 8c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0-9c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0 4.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zM18.25 9c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0 9c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-8.5 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l8.5 0zm0-4.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5z"],"keyboard-close_16":["M2 2c-.55228475 0-1 .44771525-1 1l0 6c0 .55228475.44771525 1 1 1l12 0c.5522847 0 1-.44771525 1-1l0-6c0-.55228475-.4477153-1-1-1L2 2zm0-1l12 0c1.1045695 0 2 .8954305 2 2l0 6c0 1.1045695-.8954305 2-2 2L2 11c-1.1045695 0-2-.8954305-2-2l0-6c0-1.1045695.8954305-2 2-2zm1.5 4c.27614237 0 .5-.22385763.5-.5 0-.27614237-.22385763-.5-.5-.5-.27614237 0-.5.22385763-.5.5 0 .27614237.22385763.5.5.5zm3 0c.27614237 0 .5-.22385763.5-.5 0-.27614237-.22385763-.5-.5-.5-.27614237 0-.5.22385763-.5.5 0 .27614237.22385763.5.5.5zm3 0c.27614237 0 .5-.22385763.5-.5 0-.27614237-.22385763-.5-.5-.5-.27614237 0-.5.22385763-.5.5 0 .27614237.22385763.5.5.5zm3 0c.2761424 0 .5-.22385763.5-.5 0-.27614237-.2238576-.5-.5-.5-.2761424 0-.5.22385763-.5.5 0 .27614237.2238576.5.5.5zm-9 3c.27614237 0 .5-.22385763.5-.5 0-.27614237-.22385763-.5-.5-.5-.27614237 0-.5.22385763-.5.5 0 .27614237.22385763.5.5.5zm9 0c.2761424 0 .5-.22385763.5-.5 0-.27614237-.2238576-.5-.5-.5-.2761424 0-.5.22385763-.5.5 0 .27614237.2238576.5.5.5zm-6-1l3 0c.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5l-3 0c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5zm1.4999421 8.0000205c-.111 0-.221-.036-.312-.109l-2.5-2c-.216-.173-.251-.488-.078-.704.172-.214.487-.249.702-.078l2.188 1.75 2.181-1.749c.215-.173.53-.138.703.077.173.215.138.531-.077.703l-2.494 2c-.092.073-.202.11-.313.11z"],"keyboard-close_24":["M14.646 19.146c.196-.195.512-.195.708 0 .195.196.195.512 0 .708l-3 3c-.098.097-.226.146-.354.146-.128 0-.256-.049-.354-.146l-3-3c-.195-.196-.195-.512 0-.708.196-.195.512-.195.708 0L12 21.793l2.646-2.647zM21.5 1C22.878 1 24 2.121 24 3.5l0 11c0 1.379-1.122 2.5-2.5 2.5l-19 0C1.122 17 0 15.879 0 14.5l0-11C0 2.121 1.122 1 2.5 1l19 0zM23 14.5l0-11c0-.827-.673-1.5-1.5-1.5l-19 0C1.673 2 1 2.673 1 3.5l0 11c0 .827.673 1.5 1.5 1.5l19 0c.827 0 1.5-.673 1.5-1.5zM7.5 6c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5zm3 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5zm0 3.5c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5zm-3 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5zm6-3.5c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5zm0 3.5c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5zm-9 2.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0-3.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm15 3.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm-3-7c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm3 3.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0-3.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm-3 3.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zM4.5 5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm12 7c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-9 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l9 0z"],"language_16":["M11.1035 14.2646c1.077-1.368 1.79-3.43 1.881-5.765l1.99 0c-.18 2.531-1.708 4.689-3.871 5.765zm-10.078-5.765l1.99 0c.091 2.335.804 4.397 1.881 5.765-2.163-1.076-3.691-3.234-3.871-5.765zm3.871-6.764c-1.077 1.368-1.79 3.429-1.881 5.764l-1.99 0c.18-2.53 1.708-4.688 3.871-5.764zm3.603 5.764l0-6.436c1.849.426 3.345 3.157 3.486 6.436l-3.486 0zm0 7.437l0-6.437 3.486 0c-.141 3.28-1.637 6.011-3.486 6.437zm-1-6.437l0 6.437c-1.848-.426-3.344-3.157-3.485-6.437l3.485 0zm0-7.436l0 6.436-3.485 0c.141-3.279 1.637-6.01 3.485-6.436zm7.475 6.436l-1.99 0c-.091-2.335-.804-4.396-1.881-5.764 2.163 1.076 3.691 3.234 3.871 5.764zm-6.975-7.5c-4.417 0-8 3.582-8 8 0 4.418 3.583 8 8 8 4.418 0 8-3.582 8-8 0-4.418-3.582-8-8-8z"],"language_24":["M15.4442 22.44c2.041-1.984 3.438-5.673 3.541-9.94l3.989 0c-.21 4.642-3.301 8.541-7.53 9.94zM1.0252 12.5l3.989 0c.103 4.267 1.5 7.956 3.542 9.94-4.23-1.399-7.321-5.298-7.531-9.94zm7.531-10.94c-2.042 1.984-3.439 5.673-3.542 9.94l-3.989 0c.21-4.642 3.301-8.54 7.531-9.94zm3.944 9.94l0-10.452c2.938.47 5.344 5.018 5.485 10.452l-5.485 0zm0 11.452l0-10.452 5.485 0c-.141 5.434-2.547 9.982-5.485 10.452zm-1-10.452l0 10.452c-2.939-.47-5.345-5.018-5.486-10.452l5.486 0zm0-11.452l0 10.452-5.486 0c.141-5.434 2.547-9.982 5.486-10.452zM22.9742 11.5l-3.989 0c-.103-4.267-1.5-7.956-3.541-9.94 4.229 1.4 7.32 5.298 7.53 9.94zM12.0002 0c-6.627 0-12 5.373-12 12 0 6.627 5.373 12 12 12 6.627 0 12-5.373 12-12 0-6.627-5.373-12-12-12z"],"language_40":["M24.1172 38.5381c3.952-2.905 6.758-9.859 6.869-18.038l7.988 0c-.231 8.838-6.513 16.185-14.857 18.038zm-23.092-18.038l7.988 0c.112 8.179 2.917 15.133 6.87 18.038-8.344-1.853-14.626-9.2-14.858-18.038zm14.858-19.038c-3.953 2.905-6.758 9.859-6.87 18.038l-7.988 0c.232-8.838 6.514-16.186 14.858-18.038zm4.617 18.038l0-18.45c5.11.509 9.345 8.691 9.486 18.45l-9.486 0zm0 1l9.486 0c-.141 9.759-4.376 17.941-9.486 18.45l0-18.45zm-1 0l0 18.45c-5.111-.509-9.345-8.691-9.487-18.45l9.487 0zm0-1l-9.487 0c.142-9.759 4.376-17.941 9.487-18.45l0 18.45zm19.474 0l-7.988 0c-.111-8.179-2.917-15.133-6.869-18.038 8.344 1.852 14.626 9.2 14.857 18.038zm-18.974-19.5c-11.046 0-20 8.954-20 20 0 11.046 8.954 20 20 20 11.046 0 20-8.954 20-20 0-11.046-8.954-20-20-20z"],"laptop_12":["M10 10l-8 0c-.551 0-1-.448-1-1l10 0c0 .552-.449 1-1 1zM2 2.5c0-.275.224-.5.5-.5l7 0c.276 0 .5.225.5.5L10 8 2 8l0-5.5zM11.5 8L11 8l0-5.5c0-.827-.673-1.5-1.5-1.5l-7 0C1.673 1 1 1.673 1 2.5L1 8 .5 8c-.276 0-.5.224-.5.5L0 9c0 1.103.897 2 2 2l8 0c1.103 0 2-.897 2-2l0-.5c0-.276-.224-.5-.5-.5z"],"laptop_16":["M14 13L2 13c-.551 0-1-.449-1-1l14 0c0 .551-.449 1-1 1zM2 4c0-.551.449-1 1-1l10 0c.551 0 1 .449 1 1l0 7-12 0 0-7zm13.5 7l-.5 0 0-7c0-1.105-.895-2-2-2L3 2c-1.105 0-2 .895-2 2l0 7-.5 0c-.276 0-.5.224-.5.5l0 .5c0 1.105.895 2 2 2l12 0c1.105 0 2-.895 2-2l0-.5c0-.276-.224-.5-.5-.5z"],"laptop_20":["M18.9998 15.2778c0 .95-.771 1.722-1.723 1.722l-14.555 0c-.95 0-1.722-.772-1.722-1.722l0-.278 18 0 0 .278zm-17-11.11c0-.644.523-1.168 1.167-1.168l13.666 0c.645 0 1.167.524 1.167 1.168l0 7.832 0 2-16 0 0-9.832zm18 10.331c-.001-.275-.225-.499-.5-.499l-.5 0 0-2 0-7.832c0-.922-.58-1.705-1.391-2.018-.217-.092-.47-.15-.609-.15l-14 0c-.139 0-.393.058-.609.15-.812.313-1.391 1.096-1.391 2.018l0 9.832-.5 0c-.276 0-.5.224-.5.5l0 .778c0 1.501 1.221 2.722 2.722 2.722l14.555 0c1.5 0 2.722-1.22 2.723-2.719l0-.003 0-.778 0-.001z"],"laptop_24":["M23 17.5c0 1.379-1.122 2.5-2.5 2.5l-17 0C2.122 20 1 18.879 1 17.5l0-.5 22 0 0 .5zM3 5.5C3 4.673 3.673 4 4.5 4l15 0c.827 0 1.5.673 1.5 1.5L21 16 3 16 3 5.5zM23.5 16L22 16l0-10.5C22 4.121 20.878 3 19.5 3l-15 0C3.122 3 2 4.121 2 5.5L2 16 .5 16c-.276 0-.5.224-.5.5l0 1C0 19.43 1.57 21 3.5 21l17 0c1.93 0 3.5-1.57 3.5-3.5l0-1c0-.276-.224-.5-.5-.5z"],"laptop_48":["M47 35.5c0 3.032-2.467 5.5-5.5 5.5l-35 0C3.467 41 1 38.532 1 35.5L1 34l46 0 0 1.5zm-42-25C5 8.57 6.57 7 8.5 7l31 0c1.93 0 3.5 1.57 3.5 3.5L43 33 5 33l0-22.5zM47.5 33L44 33l0-22.5C44 8.019 41.981 6 39.5 6l-31 0C6.019 6 4 8.019 4 10.5L4 33 .5 33c-.276 0-.5.224-.5.5l0 2C0 39.084 2.916 42 6.5 42l35 0c3.584 0 6.5-2.916 6.5-6.5l0-2c0-.276-.224-.5-.5-.5z"],"laser-pointer_16":["M8-.0004c4.412 0 8 3.59 8 8 0 4.412-3.588 8-8 8-4.412 0-8-3.588-8-8 0-4.41 3.588-8 8-8zm.5 14.975c3.626-.258 6.5-3.284 6.5-6.975 0-3.859-3.14-7-7-7-3.86 0-7 3.141-7 7 0 3.691 2.874 6.717 6.5 6.975l0-6.474c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 6.474zm-3-6.4741c0 .276-.224.5-.5.5l-2 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l2 0c.276 0 .5.224.5.5zM5.3535 5.147l1 1c.195.195.195.512 0 .707-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147l-1-1c-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0zM8 3.0005c.276 0 .5.224.5.5l0 2c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-2c0-.276.224-.5.5-.5zM5.6465 10.147c.195-.195.512-.195.707 0 .195.195.195.512 0 .707l-1 1c-.098.098-.226.147-.353.147-.128 0-.256-.049-.354-.147-.195-.195-.195-.512 0-.707l1-1zM13 8.0005c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-2 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l2 0zm-2.6465 2.1465l1 1c.195.195.195.512 0 .707-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147l-1-1c-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0zM10 7.0005c-.128 0-.256-.049-.354-.146-.195-.196-.195-.512 0-.708l1-1c.196-.195.512-.195.708 0 .195.196.195.512 0 .708l-1 1c-.098.097-.226.146-.354.146z"],"launch_20":["M18.5032.0053c.812.025 1.467.68 1.492 1.491l0 .001c.113 3.834-1.555 7.858-4.462 10.765-.218.218-.445.425-.675.628l.491 1.332c.466 1.263-.096 2.66-1.306 3.25l-4.537 2.373c-.211.103-.433.151-.652.151-.542 0-1.06-.298-1.313-.811-.279-.563-.168-1.239.276-1.683l1.53-1.558c-.423.125-.852.236-1.288.321-.102.02-.203.03-.304.03-.411 0-.809-.161-1.104-.456l-2.491-2.491c-.367-.366-.526-.893-.426-1.408.085-.436.197-.864.321-1.288l-1.56 1.533c-.279.279-.652.426-1.031.426-.22 0-.442-.049-.649-.152-.719-.356-1.018-1.232-.667-1.952l2.372-4.553c.583-1.197 1.98-1.759 3.243-1.295l1.378.449c.194-.218.389-.434.597-.641 2.907-2.908 6.955-4.571 10.765-4.462zm-3.677 11.55c2.716-2.716 4.274-6.465 4.169-10.029-.008-.279-.243-.513-.522-.521-.113-.004-.227-.006-.34-.006-3.46 0-7.059 1.545-9.688 4.175-1.929 1.928-3.218 4.334-3.729 6.958-.037.187.02.378.151.508l2.491 2.492c.132.132.322.188.51.152 2.624-.512 5.03-1.801 6.958-3.729zm-.416 3.013l-.37-1.006c-.76.581-1.57 1.078-2.419 1.495l-3.094 3.149c-.143.143-.179.357-.09.536.112.227.39.322.618.21l4.537-2.373c.759-.37 1.106-1.232.818-2.011zm-12.619-3.093l3.152-3.096c.421-.858.925-1.676 1.513-2.442l-1.02-.333c-.799-.293-1.659.053-2.023.8l-2.372 4.553c-.105.216-.01.493.217.605.179.09.392.054.533-.087zM12.543 4.6276c.781-.779 2.049-.779 2.829 0 .779.78.779 2.049 0 2.829-.39.39-.902.585-1.414.585-.512 0-1.024-.195-1.415-.585-.779-.78-.779-2.049 0-2.829zm2.122 2.122c.39-.39.39-1.024 0-1.415-.195-.194-.451-.292-.707-.292-.256 0-.513.098-.708.292-.39.391-.39 1.025 0 1.415.39.389 1.024.39 1.415 0zm-10.3115 8.897c.195.195.195.512 0 .707l-3.5 3.5c-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147-.195-.195-.195-.512 0-.707l3.5-3.5c.195-.195.512-.195.707 0zm-3 .707c-.098.098-.226.146-.354.146-.127 0-.255-.048-.353-.146-.195-.195-.195-.512 0-.707l1.5-1.5c.195-.195.512-.195.707 0 .195.195.195.512 0 .707l-1.5 1.5zm3.793.793c.195-.195.512-.195.707 0 .195.195.195.512 0 .707l-1.5 1.5c-.098.098-.226.147-.353.147-.128 0-.256-.049-.354-.147-.195-.195-.195-.512 0-.707l1.5-1.5z"],"launch_32":["M30.99195 3.03000643c.171 5.78-2.345 11.84999997-6.733 16.23699997-.372.373-.758.728-1.151 1.071l.809 2.198c.664 1.8-.136 3.791-1.861 4.632l-6.933 3.626c-.281.138-.579.203-.872.203-.729 0-1.427-.403-1.768-1.093-.375-.758-.226-1.668.372-2.267l3.076-3.131c-.958.333-1.941.604-2.944.799-.137.027-.276.04-.414.04-.558 0-1.097-.218-1.498-.618l-3.801-3.802c-.499-.499-.715-1.213-.58-1.913.196-1.002.467-1.983.799-2.941l-3.133 3.078c-.376.376-.878.574-1.388.574-.297 0-.596-.067-.875-.205-.967-.479-1.37-1.658-.898-2.628l3.618-6.94299997c.835-1.713 2.829-2.512 4.626-1.851l2.272.74c.327-.374.664-.741 1.019-1.095 4.386-4.387 10.475-6.902000004 16.236-6.7330000035 1.101.033 1.99.9199999995 2.022 2.0220000035zm-18.196 21.29399997c4.057-.791 7.776-2.784 10.756-5.764 4.196-4.196 6.604-9.99099997 6.44-15.50099997-.016-.563-.488-1.035-1.051-1.051-.175-.005-.352-.008-.528-.008-5.35 0-10.911 2.386-14.972 6.448-2.981 2.97999997-4.974 6.69899997-5.764 10.75599997-.073.371.041.751.304 1.014l3.801 3.802c.264.263.639.376 1.014.304zm10.184-1.442l-.692-1.879c-1.24.98-2.569 1.816-3.971 2.5l-4.752 4.838c-.297.297-.372.746-.186 1.118.235.476.814.677 1.294.443l6.933-3.626c1.273-.622 1.859-2.078 1.374-3.394zm-19.324-4.444l4.841-4.755c.694-1.419 1.542-2.76399997 2.537-4.01699997l-1.919-.625c-1.333-.49-2.791.094-3.405 1.356l-3.618 6.94299997c-.227.465-.028 1.046.448 1.281.375.184.821.111 1.116-.183zm16.2632-10.60019997c1.169-1.168 3.072-1.17 4.243 0 .566.567.879 1.321.879 2.122 0 .801-.313 1.55499997-.879 2.12099997-.585.585-1.353.877-2.121.877-.769 0-1.537-.292-2.122-.877-1.169-1.16899997-1.169-3.07299997 0-4.24299997zm3.536 3.53599997c.378-.37799997.586-.87999997.586-1.41399997 0-.534-.208-1.037-.586-1.415-.39-.389-.902-.584-1.414-.584-.513 0-1.025.195-1.415.584-.779.78-.779 2.049 0 2.82899997.78.781 2.051.78 2.829 0zm-15.9629 13.1343c.195.195.195.512 0 .707l-5.639 5.639c-.097.097-.225.146-.353.146-.128 0-.256-.049-.354-.146-.195-.196-.195-.512 0-.707l5.639-5.639c.195-.195.512-.195.707 0zm-4.833 1.1094c-.098.098-.226.146-.354.146-.127 0-.255-.048-.353-.146-.195-.195-.195-.512 0-.707l2.819-2.819c.196-.196.512-.196.707 0 .196.195.196.511 0 .707l-2.819 2.819zm6.5429.9043c.195-.195.512-.195.707 0 .195.195.195.512 0 .707l-2.819 2.819c-.098.098-.226.147-.354.147-.128 0-.256-.049-.353-.147-.196-.195-.196-.511 0-.707l2.819-2.819z"],"layout-equal-dual_12":["M11 9.5c0 .276-.224.5-.5.5l-4 0 0-8 4 0c.276 0 .5.224.5.5l0 7zm-10 0l0-7c0-.276.224-.5.5-.5l4 0 0 8-4 0c-.276 0-.5-.224-.5-.5zM10.5 1l-9 0C.672 1 0 1.672 0 2.5l0 7c0 .828.672 1.5 1.5 1.5l9 0c.828 0 1.5-.672 1.5-1.5l0-7c0-.828-.672-1.5-1.5-1.5z"],"layout-equal-dual_16":["M15 12c0 .551-.449 1-1 1l-5.5 0 0-10L14 3c.551 0 1 .449 1 1l0 8zM1 12l0-8c0-.551.449-1 1-1l5.5 0 0 10L2 13c-.551 0-1-.449-1-1zM14 2L2 2C.895 2 0 2.895 0 4l0 8c0 1.105.895 2 2 2l12 0c1.105 0 2-.895 2-2l0-8c0-1.105-.895-2-2-2z"],"layout-equal-dual_20":["M19 15.5c0 .827-.673 1.5-1.5 1.5l-7 0 0-14 7 0c.827 0 1.5.673 1.5 1.5l0 11zm-18 0l0-11C1 3.673 1.673 3 2.5 3l7 0 0 14-7 0c-.827 0-1.5-.673-1.5-1.5zM17.5 2l-15 0C1.127 2 .003 3.123 0 4.496L0 4.5l0 11 0 .004C.003 16.877 1.127 18 2.5 18l15 0c1.375 0 2.5-1.125 2.5-2.5l0-11C20 3.125 18.875 2 17.5 2z"],"layout-equal-dual_24":["M23 18.5c0 .827-.673 1.5-1.5 1.5l-9 0 0-16 9 0c.827 0 1.5.673 1.5 1.5l0 13zm-22 0l0-13C1 4.673 1.673 4 2.5 4l9 0 0 16-9 0c-.827 0-1.5-.673-1.5-1.5zM21.5 3l-19 0C1.122 3 0 4.121 0 5.5l0 13C0 19.879 1.122 21 2.5 21l19 0c1.378 0 2.5-1.121 2.5-2.5l0-13C24 4.121 22.878 3 21.5 3z"],"layout-side-by-side-horizonal_16":["M15 9L1 9l0-5c0-.551.449-1 1-1l12 0c.551 0 1 .449 1 1l0 5zm0 3c0 .551-.449 1-1 1l-5.5 0 0-3 6.5 0 0 2zM2 13c-.551 0-1-.449-1-1l0-2 6.5 0 0 3L2 13zM14 2L2 2C.895 2 0 2.895 0 4l0 8c0 1.105.895 2 2 2l12 0c1.105 0 2-.895 2-2l0-8c0-1.105-.895-2-2-2z"],"layout-side-by-side-vertical_16":["M15 7.5l-4 0L11 3l3 0c.551 0 1 .449 1 1l0 3.5zm0 4.5c0 .551-.449 1-1 1l-3 0 0-4.5 4 0 0 3.5zM2 13c-.551 0-1-.449-1-1l0-8c0-.551.449-1 1-1l8 0 0 10-8 0zM14 2L2 2C.895 2 0 2.895 0 4l0 8c0 1.105.895 2 2 2l12 0c1.105 0 2-.895 2-2l0-8c0-1.105-.895-2-2-2z"],"layout-stacked_16":["M15 7.5l-14 0L1 4c0-.551.449-1 1-1l12 0c.551 0 1 .449 1 1l0 3.5zm0 4.5c0 .551-.449 1-1 1L2 13c-.551 0-1-.449-1-1l0-3.5 14 0 0 3.5zM14 2L2 2C.895 2 0 2.895 0 4l0 8c0 1.105.895 2 2 2l12 0c1.105 0 2-.895 2-2l0-8c0-1.105-.895-2-2-2z"],"like_16":["M14.2690607 12.4932694c-.2413751 1.4528884-1.482163 2.5068074-2.9513596 2.5068074l-6.82932048 0 0-4.7026387c0-.468964.09176244-.92492897.27030025-1.35089625l3.48398078-7.9443897c.5455876.20398433.85877682.76794101.74806343 1.32089853l-.99442566 4.0586882c-.03690446.14898856-.00299225.3059765.09176245.4269672.09375728.12099071.23838288.19198526.39198524.19198526l5.52469779 0c.2942383 0 .5715205.12899009.7610299.3539728.1895094.2239828.2712977.51996006.2234216.80993778l-.7201357 4.32866748zm-10.778098 2.5068074l-1.49612687 0c-.54957727 0-.997417915-.4489655-.997417915-.9999232l0-4.00969194c0-.55095768.447840645-.99992319.997417915-.99992319l1.49612687 0 0 6.00953833zm12.035842-8.29236296c-.3800162-.44896551-.9345806-.70694569-1.5220598-.70694569l-4.88834516 0 .84780523-3.45973422C10.176655 1.48211528 9.59915001.441195244 8.58976308.065224126c-.51267281-.190985328-1.08319585.050996082-1.29365103.548957828L4.08741861 7.99061529l-2.09258278 0C.894683869 7.99061529 0 8.88754639 0 9.99046166l0 4.00969194C0 15.1030689.894683869 16 1.99483583 16l1.49612687 0 .49870896 0 7.32802944 0c1.9579313 0 3.6136451-1.405892 3.9348136-3.3427432l.7201358-4.32866747c.0967495-.57995545-.0658296-1.17091005-.4458458-1.62087549z"],"link_10":["M2.6479 7.35351c-.195-.195-.195-.512 0-.707l4-4c.195-.195.512-.195.707 0 .195.195.195.512 0 .707l-4 4c-.098.098-.226.146-.353.146-.128 0-.256-.048-.354-.146zm2.8082-1.2983c.274-.025.52.171.549.446.088.859-.21 1.7-.816 2.306l-.319.347c-.563.565-1.299.845-2.032.845-.728 0-1.453-.277-2.006-.83-1.109-1.109-1.109-2.914 0-4.024l.324-.307c.597-.597 1.437-.893 2.297-.806.274.028.474.273.446.548-.028.275-.272.475-.549.447-.558-.058-1.103.134-1.497.528l-.324.307c-.709.71-.709 1.88.01 2.6.72.72 1.89.721 2.61 0l.319-.346c.407-.409.599-.954.542-1.512-.028-.275.172-.521.446-.549zM9.1694.83011c1.109 1.109 1.109 2.915 0 4.024l-.324.307c-.597.598-1.437.893-2.297.807-.274-.029-.474-.274-.446-.549.028-.275.272-.475.549-.446.558.057 1.103-.135 1.497-.528l.324-.307c.709-.711.709-1.881-.01-2.601-.72-.72-1.89-.721-2.61 0l-.319.347c-.407.408-.599.953-.542 1.511.028.275-.172.521-.446.549-.274.025-.52-.171-.549-.446-.088-.859.21-1.7.816-2.306l.319-.347c.563-.564 1.299-.845 2.032-.845.728 0 1.453.277 2.006.83z"],"link_12":["M3.1465 8.8213c-.195-.195-.195-.512 0-.707l5-5c.195-.195.512-.195.707 0 .195.195.195.512 0 .707l-5 5c-.098.098-.226.146-.353.146-.128 0-.256-.048-.354-.146zm3.521-1.5176c.263-.03.52.172.548.447.104 1.016-.248 2.011-.965 2.728l-.507.506c-.633.634-1.479.983-2.38.983-.902 0-1.747-.349-2.381-.983-.633-.633-.982-1.479-.982-2.38 0-.902.349-1.747.982-2.381l.507-.506c.717-.718 1.713-1.067 2.728-.966.275.029.474.274.447.549-.028.274-.278.472-.549.446-.719-.077-1.416.174-1.919.678l-.507.506c-.444.445-.689 1.04-.689 1.674 0 .634.245 1.228.689 1.673.89.89 2.457.89 3.347 0l.507-.506c.504-.504.75-1.204.677-1.92-.028-.274.172-.52.447-.548zm4.3496-6.353c.634.633.983 1.479.983 2.38 0 .902-.349 1.747-.983 2.381l-.506.507c-.635.634-1.486.982-2.378.982-.116 0-.233-.005-.35-.017-.275-.028-.475-.274-.447-.548.028-.275.281-.469.548-.447.718.073 1.416-.175 1.92-.677l.506-.507c.445-.445.69-1.039.69-1.674 0-.634-.245-1.228-.69-1.673-.89-.89-2.457-.89-3.347 0l-.507.506c-.503.504-.75 1.204-.677 1.92.028.274-.172.52-.447.548-.272.022-.52-.172-.548-.447-.104-1.016.248-2.01.965-2.728l.507-.506c1.267-1.268 3.494-1.268 4.761 0z"],"link_16":["M5.1484 10.8165c-.195-.195-.195-.512 0-.707l5-5c.195-.195.512-.195.707 0 .195.195.195.512 0 .707l-5 5c-.098.098-.226.146-.353.146-.128 0-.256-.048-.354-.146zm3.6514-1.1846c.268-.022.52.171.548.447.121 1.174-.285 2.322-1.113 3.151l-.6.599c-.731.731-1.708 1.134-2.749 1.134-1.041 0-2.018-.403-2.749-1.135-1.516-1.515-1.516-3.982 0-5.498l.599-.599c.829-.828 1.978-1.236 3.15-1.114.275.028.475.274.446.548-.028.276-.276.469-.548.447-.872-.09-1.726.211-2.341.826l-.599.599c-1.126 1.126-1.126 2.958 0 4.084 1.086 1.086 2.998 1.086 4.084 0l.6-.599c.614-.614.915-1.468.826-2.342-.029-.274.172-.52.446-.548zm5.0674-7.5341c1.516 1.516 1.516 3.982 0 5.498l-.599.599c-.733.733-1.715 1.135-2.745 1.135-.135 0-.269-.007-.405-.021-.275-.028-.475-.274-.446-.548.028-.276.276-.473.548-.447.875.094 1.726-.211 2.341-.826l.599-.599c1.126-1.126 1.126-2.958 0-4.084-1.086-1.086-2.998-1.086-4.084 0l-.6.599c-.614.614-.915 1.468-.826 2.342.029.274-.172.52-.446.548-.271.025-.52-.171-.548-.446-.121-1.174.285-2.323 1.113-3.151l.6-.599c1.463-1.463 4.035-1.464 5.498 0z"],"link_24":["M6.5034 18c-.128 0-.256-.049-.354-.146-.195-.196-.195-.512 0-.708l11-11c.196-.195.512-.195.708 0 .195.196.195.512 0 .708l-11 11c-.098.097-.226.146-.354.146zm.5117 5c-1.611 0-3.123-.624-4.256-1.756-2.346-2.347-2.346-6.165 0-8.512l.976-.976c1.282-1.282 3.065-1.912 4.878-1.724.275.028.474.274.446.549-.028.275-.292.464-.548.446-1.511-.156-3 .368-4.069 1.436l-.976.976c-1.956 1.957-1.956 5.141 0 7.098.944.943 2.204 1.463 3.549 1.463 1.346 0 2.605-.52 3.549-1.463l.976-.976c1.069-1.068 1.592-2.552 1.437-4.069-.028-.275.171-.52.446-.549.25-.022.52.171.548.447.187 1.818-.441 3.596-1.724 4.878l-.976.976C10.1391 22.376 8.6271 23 7.0151 23zm9.0078-8.9995c-.209 0-.419-.011-.629-.032-.275-.029-.475-.274-.446-.549.028-.275.289-.473.548-.446 1.511.157 3-.368 4.069-1.437l.976-.975c1.956-1.957 1.956-5.141 0-7.098-.944-.944-2.205-1.463-3.549-1.463-1.346 0-2.606.519-3.549 1.463l-.977.975c-1.068 1.069-1.591 2.552-1.436 4.069.028.275-.171.521-.446.549-.254.019-.52-.171-.548-.446-.187-1.818.441-3.596 1.723-4.879l.977-.975c1.132-1.133 2.643-1.756 4.256-1.756 1.611 0 3.123.623 4.256 1.756 2.345 2.347 2.345 6.165 0 8.512l-.976.975c-1.134 1.134-2.655 1.757-4.249 1.757z"],"linkedin_16":["M1.277 15.006l0-9.337 2.891 0 0 9.337-2.891 0zm10.3246-9.6217c1.98 0 3.398 1.209 3.398 3.71l0 5.913-2.877 0 0-4.902c0-1.344-.51-2.095-1.573-2.095-1.157 0-1.761.782-1.761 2.095l0 4.902-2.772 0 0-9.338 2.772 0 0 1.257c0 0 .834-1.542 2.813-1.542zM2.709 1c.944 0 1.709.772 1.709 1.723 0 .951-.765 1.723-1.709 1.723C1.766 4.446 1 3.674 1 2.723 1 1.772 1.766 1 2.709 1z"],"linkedin-circle_24":["M17.794 17.05l0-4.694c0-1.985-1.125-2.945-2.697-2.945-1.573 0-2.235 1.224-2.235 1.224l0-.998-2.201 0 0 7.413 2.201 0 0-3.891c0-1.043.48-1.663 1.399-1.663.844 0 1.249.596 1.249 1.663l0 3.891 2.284 0zM8.036 8.666c.75 0 1.357-.613 1.357-1.368 0-.755-.607-1.368-1.357-1.368-.749 0-1.357.613-1.357 1.368 0 .755.608 1.368 1.357 1.368zM6.9 17.05l2.294 0 0-7.413-2.294 0 0 7.413zM12 0c6.627 0 12 5.372 12 12 0 6.627-5.373 12-12 12-6.628 0-12-5.373-12-12C0 5.372 5.372 0 12 0z"],"linkedin-circle_32":["M23.726 22.734l0-6.258c0-2.648-1.501-3.928-3.597-3.928-2.096 0-2.978 1.633-2.978 1.633l0-1.331-2.935 0 0 9.884 2.935 0 0-5.188c0-1.39.639-2.218 1.864-2.218 1.125 0 1.666.795 1.666 2.218l0 5.188 3.045 0zM10.715 11.555c1 0 1.809-.817 1.809-1.824 0-1.007-.809-1.824-1.809-1.824-.999 0-1.809.817-1.809 1.824 0 1.007.81 1.824 1.809 1.824zM9.2 22.734l3.06 0 0-9.884-3.06 0 0 9.884zM16 0c8.836 0 16 7.163 16 16 0 8.837-7.164 16-16 16-8.837 0-16-7.163-16-16C0 7.163 7.163 0 16 0z"],"linkedin-circle_40":["M29.657 28.417l0-7.823c0-3.31-1.875-4.909-4.496-4.909-2.62 0-3.723 2.041-3.723 2.041l0-1.664-3.669 0 0 12.355 3.669 0 0-6.486c0-1.737.8-2.772 2.331-2.772 1.406 0 2.081.994 2.081 2.772l0 6.486 3.807 0zM13.394 14.444c1.249 0 2.262-1.022 2.262-2.281 0-1.259-1.013-2.279-2.262-2.279-1.249 0-2.261 1.02-2.261 2.279 0 1.259 1.012 2.281 2.261 2.281zM11.5 28.417l3.824 0 0-12.355-3.824 0 0 12.355zM20 0c11.045 0 20 8.953 20 20 0 11.045-8.955 20-20 20C8.954 40 0 31.045 0 20 0 8.953 8.954 0 20 0z"],"list-menu_12":["M10.5 9c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-9 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l9 0zm0-3.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-9 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l9 0zm0-3.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-9 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l9 0z"],"list-menu_16":["M1.498 3C1.223 3 1 2.768 1 2.5c0-.276.22-.5.498-.5l13.004 0c.275 0 .498.231.498.5 0 .276-.22.5-.498.5L1.498 3zm13.004 4.5c.275 0 .498.231.498.5 0 .276-.22.5-.498.5l-13.004 0C1.223 8.5 1 8.268 1 8c0-.276.22-.5.498-.5l13.004 0zm0 5.5c.275 0 .498.232.498.5 0 .276-.22.5-.498.5L1.498 14C1.223 14 1 13.768 1 13.5c0-.276.22-.5.498-.5l13.004 0z"],"list-menu_18":["M1.5 14l15 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-15 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5m0-5.5l15 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-15 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5m0-5.5l15 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-15 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5"],"list-menu_20":["M17.501 9.5c.275 0 .499.231.499.5 0 .276-.224.5-.499.5l-15.002 0C2.224 10.5 2 10.268 2 10c0-.276.224-.5.499-.5l15.002 0zm0-6.5c.275 0 .499.231.499.5 0 .276-.224.5-.499.5L2.499 4C2.224 4 2 3.768 2 3.5c0-.276.224-.5.499-.5l15.002 0zm0 13c.275 0 .499.232.499.5 0 .276-.224.5-.499.5L2.499 17C2.224 17 2 16.768 2 16.5c0-.276.224-.5.499-.5l15.002 0z"],"list-menu_24":["M2.5 12.4999c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l19 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-19 0zm0-7.5c-.276 0-.5-.224-.5-.5 0-.275.224-.5.5-.5l19 0c.276 0 .5.225.5.5 0 .276-.224.5-.5.5l-19 0zm0 15c-.276 0-.5-.225-.5-.5 0-.276.224-.5.5-.5l19 0c.276 0 .5.224.5.5 0 .275-.224.5-.5.5l-19 0z"],"list-menu_28":["M24.5015 21c.275 0 .499.232.499.5 0 .276-.222.5-.499.5l-21.003 0c-.275 0-.498-.232-.498-.5 0-.276.221-.5.498-.5l21.003 0zm0-7.5c.275 0 .499.232.499.5 0 .276-.222.5-.499.5l-21.003 0c-.275 0-.498-.232-.498-.5 0-.276.221-.5.498-.5l21.003 0zm0-7.5c.275 0 .499.231.499.5 0 .276-.222.5-.499.5L3.4985 7c-.275 0-.498-.232-.498-.5 0-.276.221-.5.498-.5l21.003 0z"],"location_10":["M5.0001.0001c1.881 0 3.412 1.57 3.412 3.5 0 2.394-2.894 6.148-3.017 6.307-.095.122-.251.201-.395.193-.152 0-.295-.068-.39-.186-.123-.155-3.022-3.792-3.022-6.314 0-1.93 1.531-3.5 3.412-3.5zm-.006 8.668c.916-1.286 2.418-3.702 2.418-5.168 0-1.379-1.082-2.5-2.412-2.5-1.33 0-2.412 1.121-2.412 2.5 0 1.549 1.491 3.916 2.406 5.168zM5 3.0002c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5z"],"location_16":["M8 0c2.757 0 5 2.243 5 5 0 4.614-4.412 10.55-4.6 10.8-.094.126-.243.2-.4.2-.158 0-.306-.074-.4-.2C7.412 15.549 3 9.598 3 5c0-2.757 2.243-5 5-5zm0 14.636C9.086 13.06 12 8.5 12 5c0-2.206-1.794-4-4-4-2.206 0-4 1.794-4 4 0 3.489 2.915 8.057 4 9.636zM8 6c-.55228475 0-1-.44771525-1-1 0-.55228475.44771525-1 1-1 .55228475 0 1 .44771525 1 1 0 .55228475-.44771525 1-1 1z"],"location_18":["M9 0c3.308 0 6 2.7236877 6 6.07230375C15 10.3708109 9.627 17.4989936 9.398 17.800959c-.093.1239857-.245.2139754-.398.1969774-.153 0-.299-.069992-.394-.191978C8.378 17.5139919 3 10.6037842 3 6.07230375 3 2.7236877 5.691 0 9 0zm-.006 16.6590899C10.236 14.9252887 14 9.39692255 14 6.07230375 14 3.27562442 11.757.999885354 9 .999885354c-2.757 0-5 2.275739066-5 5.072418396C4 9.58190134 7.745 14.9632843 8.994 16.6590899zm.0059-11.65396379c.553 0 1 .44794864 1 .99988536 0 .55193671-.447.99988535-1 .99988535-.553 0-1-.44794864-1-.99988535 0-.55193672.447-.99988536 1-.99988536z"],"location_20":["M10 .0005c3.859 0 7 3.095 7 6.9 0 4.716-5.959 12.392-6.212 12.716-.188.24-.475.381-.78.384l-.008 0c-.302 0-.588-.137-.778-.372C8.968 19.3135 3 11.8685 3 6.9005c0-3.805 3.14-6.9 7-6.9zm0 19c2.075-2.654 6-8.601 6-12.1 0-3.254-2.691-5.9-6-5.9-3.309 0-6 2.646-6 5.9 0 3.693 3.925 9.53 6 12.1zm0-12.9941c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1z"],"location_24":["M12.0001.9997c3.86 0 7 3.313 7 7.385 0 5.265-6.326 14.038-6.595 14.409-.095.129-.277.228-.405.206-.157 0-.306-.074-.4-.2-.27-.359-6.6-8.863-6.6-14.415 0-4.072 3.14-7.385 7-7.385zm-.006 20.638c1.4-2.033 6.006-9.042 6.006-13.253 0-3.52-2.692-6.385-6-6.385-3.309 0-6 2.865-6 6.385 0 4.442 4.585 11.263 5.994 13.253zM12 9c-.55228475 0-1-.44771525-1-1 0-.55228475.44771525-1 1-1 .55228475 0 1 .44771525 1 1 0 .55228475-.44771525 1-1 1z"],"location_28":["M13.99863376 0c4.96300004 0 9.00000004 4.262 9.00000004 9.5 0 6.839-8.25 17.837-8.601 18.302-.093.124-.239.197-.395.198l-.00400004 0c-.153 0-.299-.071-.394-.192-.351-.45-8.605999998-11.094-8.605999998-18.308 0-5.238 4.037999998-9.5 8.999999998-9.5zm-.006 26.662C15.6526338 24.359 21.9986338 15.183 21.9986338 9.5c0-4.687-3.589-8.5-8.00000004-8.5-4.411 0-8 3.813-8 8.5 0 5.993 6.324 14.911 7.994 17.162zm.0063-18.6621c.55200004 0 1.00000004.448 1.00000004 1 0 .552-.448 1-1.00000004 1-.552 0-1-.448-1-1 0-.552.448-1 1-1z"],"location_32":["M16 0c6.065 0 11 4.859 11 10.833 0 .297-.019.602-.047.913-.015.166-.034.335-.058.503-.019.149-.043.299-.069.45l-.018.108c-.017.102-.034.204-.056.303-1.548 7.79-10.005 18.263-10.364 18.705-.095.116-.267.168-.388.185-.147 0-.288-.066-.383-.179-.392-.467-9.627-11.536-10.538-19.738l-.028-.255C5.02 11.491 5 11.157 5 10.833 5 4.859 9.935 0 16 0zm9.957 11.658c.026-.283.043-.558.043-.825C26 5.411 21.514 1 16 1 10.486 1 6 5.411 6 10.833c0 .295.019.597.047.902l.025.234c.775 6.973 8.135 16.507 9.922 18.732 1.691-2.167 8.461-11.162 9.779-17.797.021-.093.035-.177.048-.26l.02-.114c.022-.137.045-.276.064-.415.02-.151.039-.303.052-.457zm-9.247-1.3682c.09.1.16.2.21.33.05.12.08.25.08.38 0 .269-.101.519-.29.71-.19.189-.44.29-.71.29-.13 0-.26-.03-.38-.08-.12-.05-.23-.12-.33-.21-.19-.191-.29-.441-.29-.71 0-.26.109-.521.29-.71.1-.09.2-.16.33-.21.18-.08.38-.101.569-.061.071.011.13.031.191.061.059.02.12.05.18.09.049.03.1.08.15.12z"],"markdown_16":["M13.056.9997c1.074 0 1.944.871 1.944 1.945l0 10.111c0 1.074-.87 1.944-1.944 1.944l-10.112 0c-1.074 0-1.944-.87-1.944-1.944l0-10.056c0-1.104.896-2 2-2l10.056 0zM14 13.0557l0-10.111c0-.521-.424-.945-.944-.945L3 1.9997c-.552 0-1 .449-1 1l0 10.056c0 .521.424.944.944.944l10.112 0c.52 0 .944-.423.944-.944zm-2.8535-3.9092c.195-.195.512-.195.707 0 .195.195.195.512 0 .707l-1 1c-.017.017-.039.024-.058.038-.033.026-.065.053-.104.069-.062.026-.126.04-.191.04-.066 0-.13-.014-.192-.04-.039-.016-.071-.043-.104-.069-.019-.014-.041-.021-.058-.038l-1-1c-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0l.147.146 0-2.585-1.647 1.646c-.098.098-.226.147-.353.147-.128 0-.256-.049-.354-.147l-1.646-1.646 0 3.793c0 .274-.225.5-.5.5-.276 0-.5-.226-.5-.5l0-5c0-.066.013-.131.039-.192.016-.04.045-.074.071-.108.014-.017.02-.038.036-.054.016-.016.036-.022.054-.036.034-.026.067-.055.108-.071.122-.051.261-.051.383 0 .041.016.074.045.108.071.018.014.038.02.054.036l2.147 2.146 2.146-2.146c.016-.016.036-.022.054-.036.034-.026.067-.055.108-.071.122-.051.261-.051.383 0 .041.016.074.045.108.071.018.014.038.02.054.036.016.016.022.037.036.054.027.034.055.068.071.108.026.061.04.126.04.192l0 3.792.146-.146z"],"markdown_20":["M16.5 1C17.881 1 19 2.119 19 3.5l0 13c0 1.381-1.119 2.5-2.5 2.5l-13 0C2.119 19 1 17.881 1 16.5l0-13C1 2.119 2.119 1 3.5 1l13 0zM18 16.5l0-13c0-.827-.673-1.5-1.5-1.5l-13 0C2.673 2 2 2.673 2 3.5l0 13c0 .827.673 1.5 1.5 1.5l13 0c.827 0 1.5-.673 1.5-1.5zm-2.8535-5.3535c.195-.195.512-.195.707 0 .195.195.195.512 0 .707l-2 2c-.017.017-.039.024-.058.038-.033.026-.065.053-.104.069-.062.026-.126.04-.191.04-.066 0-.13-.014-.192-.04-.039-.016-.071-.043-.104-.069-.019-.014-.041-.021-.058-.038l-2-2c-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0l1.147 1.146 0-4.585-2.647 2.646c-.098.098-.226.147-.353.147-.128 0-.256-.049-.354-.147l-2.646-2.646 0 5.793c0 .274-.225.5-.5.5-.276 0-.5-.226-.5-.5l0-7c0-.066.013-.131.039-.192.016-.04.044-.074.071-.108.014-.017.02-.038.036-.054.016-.016.036-.022.054-.036.034-.026.067-.055.108-.071.122-.051.261-.051.383 0 .041.016.074.045.108.071.018.014.038.02.054.036l3.147 3.146 3.146-3.146c.016-.016.036-.022.054-.036.034-.026.067-.055.108-.071.122-.051.261-.051.383 0 .041.016.074.045.108.071.018.014.038.02.054.036.016.016.022.037.036.054.027.034.055.068.071.108.026.061.04.126.04.192l0 5.792 1.146-1.146z"],"marker_12":["M10.8544137 3.23165348L4.24979904 9.83790087 2.1635525 7.75276968l6.6046147-6.6062474c.1949296-.194918781.51181515-.194918781.70674475 0l1.37950175 1.37842566c.0949657.09496043.1459473.21990837.1459473.35285298 0 .13394419-.0509816.25889212-.1459473.35385256zM1.63374385 10.9284465l-.56179711-.5627655.57479241-1.71628492 1.70538409 1.70528942-1.71837939.573761zm9.92741465-9.1102041L10.1816567.439816743C9.89875888.155935027 9.52289462 0 9.12303904 0L9.1220394 0c-.40085523.0009995835-.77771913.156934611-1.06061695.439816743L1.04795541 7.45489379c-.053980505.05397751-.094965703.12094961-.119956677.1939192L.0263243788 10.341691c-.0609779774.179925-.0139949456.3778425.1199566772.5117867l.999638974.9995835c.09596534.09596.22291949.1469388.3538722.1469388.05198122 0 .10596173-.0079967.15794295-.0259892l2.69502667-.8996251c.07397329-.0249896.1409491-.0659725.1949296-.1209496l7.01346705-7.0140775C11.8440563 3.65547688 12 3.2786339 12 2.87780092c0-.39983341-.1559437-.77667639-.4388415-1.05955852z"],"marker_14":["M12.78 3.8883l-7.896 7.898-2.668-2.668 7.895-7.898c.145-.144.328-.22.53-.22l.001 0c.202 0 .385.076.53.22l1.608 1.608c.144.143.22.327.22.53 0 .203-.076.386-.22.53zm-10.919 9.051l-.801-.801.694-2.068 2.177 2.178-2.07.691zm11.626-10.818L11.878.5133c-.33-.331-.769-.513-1.236-.513l-.001 0c-.466 0-.906.182-1.237.513l-8.182 8.184c-.063.064-.111.142-.139.227L.03 12.0653c-.07.21-.016.441.141.598l1.166 1.166c.111.111.259.171.412.171.061 0 .124-.01.184-.03l3.145-1.05c.087-.029.164-.077.227-.141l8.182-8.184c.33-.33.513-.77.513-1.237 0-.467-.183-.907-.513-1.237z"],"marker_16":["M14.7069378 4.544l-9.05043572 9.053-3.25215656-3.251 9.05143568-9.053c.1880091-.189.4390212-.293.706034-.293l.0010001 0c.270013 0 .5140247.101.7050339.292l1.8390886 1.838c.1890091.189.2930141.44.2930141.707 0 .267-.104005.518-.2930141.707zM2.08933036 14.951l-1.04105012-1.04.88004237-2.627 2.79013431 2.789-2.62912656.878zM15.4149718 2.423L13.5748833.585C13.1978651.208 12.696841 0 12.1628153 0l-.0010001 0c-.5340257 0-1.0360498.208-1.414068.586L1.39729704 9.939c-.07300351.073-.12800616.162-.1600077.259L.0342314279 13.789c-.0800038513.239-.0170008184.504.1600077021.682l1.33306417 1.333c.12800616.127.2970143.196.47102268.196.07000337 0 .14300688-.012.21101015-.035l3.59417302-1.2c.09800472-.033.18700901-.088.26001252-.161l9.35145013-9.353C15.79199 4.874 16 4.371 16 3.837c0-.534-.20801-1.036-.5850282-1.414z"],"marker_18":["M16.6340059 5.201L6.27305095 15.565 2.43806761 11.73 12.7990226 1.367c.235999-.237.5499976-.367.8829962-.367l.002 0c.3319985 0 .6449971.13.8819961.366l2.067991 2.068c.235999.236.3659984.55.3659984.883 0 .334-.1299994.648-.3659984.884zM2.31706814 16.963l-1.27999444-1.28.9889957-2.951 3.2449859 3.245-2.95398716.986zM17.3410029 2.727L15.2730118.659C14.8480137.234 14.2840161 0 13.6840188 0l-.002 0c-.6009974 0-1.164995.235-1.5899931.659L1.57207137 11.181c-.08199964.082-.14299938.183-.17899922.292l-1.353994117 4.04c-.0909996046.269-.0199999131.566.180999214.768L1.71907073 17.78c.14399938.143.33399855.22.5299977.22.07899966 0 .15899931-.013.23799897-.039l4.04298243-1.35c.11099952-.037.20999909-.099.29199873-.181L17.3410029 5.908C17.766001 5.483 18 4.918 18 4.317c0-.6-.233999-1.166-.6589971-1.59z"],"maximize_12":["M2 10l3.5 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-4 0c-.276 0-.5-.224-.5-.5l0-4c0-.276.224-.5.5-.5.276 0 .5.224.5.5L2 10zm4.5-9l4 0c.276 0 .5.224.5.5l0 4c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5L10 2 6.5 2c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5z"],"maximize_14":["M2 12l4.5 0c.3 0 .5.2.5.5 0 .3-.2.5-.5.5l-5 0c-.3 0-.5-.2-.5-.5l0-5c0-.3.2-.5.5-.5.3 0 .5.2.5.5L2 12zM7.5 1l5 0c.3 0 .5.2.5.5l0 5c0 .3-.2.5-.5.5-.3 0-.5-.2-.5-.5L12 2 7.5 2c-.3 0-.5-.2-.5-.5 0-.3.2-.5.5-.5z"],"maximize_16":["M6.5 14c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-5 0c-.276 0-.5-.224-.5-.5l0-5c0-.276.224-.5.5-.5.276 0 .5.224.5.5L2 14l4.5 0zm8-13c.276 0 .5.224.5.5l0 5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5L14 2 9.5 2c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l5 0z"],"maximize_20":["M17.5 9c-.276 0-.5-.224-.5-.5L17 3l-5.5 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l6 0c.276 0 .5.224.5.5l0 6c0 .276-.224.5-.5.5zm-9 9l-6 0c-.276 0-.5-.224-.5-.5l0-6c0-.276.224-.5.5-.5.276 0 .5.224.5.5L3 17l5.5 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5z"],"maximize_24":["M21.5003 10.999c-.276 0-.5-.224-.5-.5l0-7.499-7.5 0c-.277 0-.5-.224-.5-.5 0-.277.223-.5.5-.5l8 0c.276 0 .5.223.5.5l0 7.999c0 .276-.224.5-.5.5zM10.469 21.9996l-7.969 0c-.276 0-.5-.224-.5-.5l0-8c0-.276.224-.5.5-.5.277 0 .5.224.5.5l0 7.5 7.469 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5z"],"maximize_28":["M23.5 4c.276 0 .5.224.5.5l0 10c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5L23 5l-9.5 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l10 0zm-9 19c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-10 0c-.276 0-.5-.224-.5-.5l0-10c0-.276.224-.5.5-.5.276 0 .5.224.5.5L5 23l9.5 0z"],"meet_12":["M11.5254293 8c-.356-.251-.769-.415-1.213-.471.436-.443.747-1.008.874-1.64l2.072 0c.688 0 1.286.488 1.455 1.188l.222.923-3.41 0zm-7.469 3l.269-1.115c.197-.816.894-1.385 1.697-1.385l3.957 0c.802 0 1.5.569 1.696 1.385l.269 1.115-7.888 0zm-2.769-3.923c.169-.7.767-1.188 1.454-1.188l2.074 0c.127.632.437 1.197.873 1.64-.444.056-.856.22-1.213.471l-3.41 0 .222-.923zm3.213-6.077c.902 0 1.653.62 1.87 1.455-.852.499-1.449 1.367-1.579 2.39-.097.015-.189.044-.291.044-1.072 0-1.944-.872-1.944-1.945 0-1.072.872-1.944 1.944-1.944zm5.75 4.25c0 1.241-1.009 2.25-2.25 2.25-1.241 0-2.25-1.009-2.25-2.25 0-1.241 1.009-2.25 2.25-2.25 1.241 0 2.25 1.009 2.25 2.25zm1.25-4.25c1.072 0 1.944.872 1.944 1.944 0 1.073-.872 1.945-1.944 1.945-.101 0-.194-.026-.29-.042-.129-1.023-.727-1.893-1.58-2.392.217-.835.968-1.455 1.87-1.455zm4.478 7.061l-.293-1.218c-.244-1.012-1.047-1.755-2.02-1.919.479-.524.779-1.215.779-1.98 0-1.623-1.32-2.944-2.944-2.944-1.321 0-2.424.881-2.793 2.083-.228-.051-.464-.083-.707-.083-.243 0-.478.032-.707.083-.369-1.202-1.472-2.083-2.793-2.083-1.623 0-2.944 1.321-2.944 2.944 0 .765.3 1.456.78 1.98-.974.164-1.775999999.906-2.019999999 1.919L.0214293008 8.062c-.055.23-.003.468.1430000002.653.143.181.357.285.586.285L3.6064293 9c-.106.204-.197.418-.253.65l-.331 1.371c-.057.241-.003.489.149.682.149.189.372.297.61.297l8.438 0c.239 0 .461-.108.61-.297.152-.193.206-.441.149-.682l-.331-1.371c-.056-.232-.146-.446-.252-.65l2.855 0c.23 0 .443-.104.587-.286.145-.185.197-.423.141-.653z"],"meet_120":["M144.6302 87.2344c-.375.486-.958.766-1.601.766l-29.538 0c-4.528-5.546-11.601-9-19.389-9l-12.968 0c9.748-2.433 17.807-9.13 22.072-18l20.158 0c8.853 0 16.534 5.661 18.678 13.767l2.899 10.961c.137.522.024 1.069-.311 1.506zm-24.205 22.873c.176.664.031 1.364-.397 1.92-.476.618-1.216.973-2.031.973l-89.996 0c-.814 0-1.555-.355-2.031-.973-.428-.556-.572-1.256-.397-1.92l3.524-13.31c2.618-9.89 11.993-16.797 22.8-16.797l42.205 0c10.806 0 20.181 6.907 22.799 16.797l3.524 13.31zM2.9692 88.0004c-.643 0-1.226-.28-1.601-.766-.335-.437-.448-.984-.31-1.506l2.898-10.961c2.145-8.106 9.825-13.767 18.678-13.767l20.158 0c4.266 8.87 12.324 15.567 22.072 18l-12.967 0c-7.788 0-14.862 3.454-19.39 9l-29.538 0zm11.03-54.5c0-14.613 11.888-26.5 26.5-26.5 7.719 0 14.665 3.328 19.513 8.612-12.051 5.073-20.513 16.991-20.513 30.888 0 4.776 1.006 9.315 2.808 13.426-.598.043-1.199.074-1.808.074-14.612 0-26.5-11.888-26.5-26.5zm91.5 13c0 17.921-14.579 32.5-32.5 32.5-17.921 0-32.5-14.579-32.5-32.5 0-17.921 14.579-32.5 32.5-32.5 17.921 0 32.5 14.579 32.5 32.5zm0-39.5c14.612 0 26.5 11.887 26.5 26.5 0 14.612-11.888 26.5-26.5 26.5-.608 0-1.21-.031-1.807-.074 1.801-4.111 2.807-8.65 2.807-13.426 0-13.897-8.462-25.816-20.514-30.889 4.848-5.284 11.795-8.611 19.514-8.611zm40.408 78.472l-2.898-10.961c-2.26-8.544-10.338-14.511-19.645-14.511l-10.52 0c11.62-3.214 20.155-13.858 20.155-26.5 0-15.188-12.312-27.5-27.5-27.5-8.163 0-15.483 3.566-20.52 9.214-3.721-1.425-7.757-2.214-11.98-2.214-4.223 0-8.26.789-11.981 2.214-5.036-5.647-12.356-9.214-20.519-9.214-15.187 0-27.5 12.312-27.5 27.5 0 12.642 8.535 23.286 20.155 26.5l-10.52 0c-9.307 0-17.385 5.967-19.645 14.511l-2.898 10.961c-.218.824-.041 1.688.485 2.371.566.736 1.438 1.157 2.393 1.157l28.78 0c-1.636 2.241-2.887 4.774-3.619 7.541l-3.523 13.31c-.256.967-.048 1.983.571 2.785.667.867 1.696 1.364 2.823 1.364l89.996 0c1.127 0 2.156-.497 2.823-1.364.62-.802.828-1.818.572-2.785l-3.524-13.31c-.732-2.767-1.983-5.3-3.619-7.541l28.78 0c.955 0 1.828-.421 2.393-1.157.526-.683.703-1.547.485-2.371z"],"meet_124":["M146.6133 90.1857c-.391.507-.998.798-1.666.798l-29.405 0c-4.674-5.563-11.868-9.017-19.781-9.017l-13.456 0c10.319-2.511 18.847-9.593 23.315-18.983l1.182 0c.232.007.463.016.698.016.22 0 .438-.011.658-.016l16.469 0c9.155 0 17.098 5.869 19.316 14.272l2.996 11.353c.144.546.026 1.121-.326 1.577zm-23.69 23.785c.182.688.033 1.411-.41 1.986-.494.642-1.262 1.01-2.109 1.01l-92.809 0c-.846 0-1.615-.368-2.109-1.01-.442-.575-.592-1.298-.409-1.986l3.634-13.702c2.701-10.187 12.376-17.302 23.527-17.302l43.523 0c11.152 0 20.827 7.115 23.528 17.302l3.634 13.702zM3.0523 90.9837c-.668 0-1.275-.291-1.666-.798-.351-.456-.469-1.031-.326-1.577l2.996-11.353c2.218-8.403 10.161-14.272 19.317-14.272l16.469 0c.219.005.437.016.658.016.234 0 .466-.009.697-.016l1.183 0c4.467 9.39 12.996 16.472 23.314 18.983l-13.456 0c-7.912 0-15.106 3.454-19.78 9.017l-29.406 0zm9.948-56.484c0-15.163 12.336-27.5 27.5-27.5 7.88 0 14.988 3.338 20.007 8.666-12.631 5.283-21.507 17.754-21.507 32.301 0 4.969 1.042 9.693 2.908 13.974-.338.016-.675.037-1.016.043l-1.05 0c-14.86-.352-26.842-12.54-26.842-27.484zm95 13.467c0 18.748-15.252 34-34 34-18.748 0-34-15.252-34-34 0-18.748 15.252-34 34-34 18.748 0 34 15.252 34 34zm-.5-40.967c15.164 0 27.5 12.337 27.5 27.5 0 14.944-11.983 27.132-26.843 27.484l-1.05 0c-.341-.006-.678-.027-1.015-.043 1.866-4.281 2.908-9.005 2.908-13.974 0-14.547-8.876-27.018-21.507-32.301 5.018-5.328 12.127-8.666 20.007-8.666zm40.406 81.353l-2.996-11.353c-2.334-8.841-10.675-15.016-20.283-15.016l-9.584 0c12.078-3.308 20.957-14.356 20.957-27.484 0-15.74-12.76-28.5-28.5-28.5-8.325 0-15.813 3.574-21.024 9.265-3.877-1.479-8.08-2.298-12.476-2.298-4.397 0-8.6.819-12.477 2.298-5.211-5.691-12.698-9.265-21.023-9.265-15.741 0-28.5 12.76-28.5 28.5 0 13.128 8.879 24.176 20.957 27.484l-9.584 0c-9.609 0-17.949 6.175-20.283 15.016l-2.997 11.353c-.223.849-.041 1.739.501 2.443.582.755 1.478 1.188 2.458 1.188l28.627 0c-1.786 2.371-3.15 5.069-3.935 8.029l-3.634 13.702c-.263.99-.05 2.029.583 2.852.686.89 1.743 1.4 2.902 1.4l92.809 0c1.159 0 2.217-.51 2.902-1.4.633-.823.846-1.862.583-2.852l-3.633-13.702c-.786-2.96-2.15-5.658-3.936-8.029l28.627 0c.98 0 1.876-.433 2.458-1.188.542-.704.725-1.594.501-2.443z"],"meet_16":["M15.5074996 11c-.623-.894-1.64-1.468-2.773-1.499l-.028 0c.489-.408.891-.914 1.157-1.501l2.647 0c.997 0 1.861.675 2.102 1.641l.34 1.359-3.445 0zM4.53549956 14l.401-1.606c.279-1.115 1.276-1.894 2.425-1.894l5.27600004 0c1.149 0 2.146.779 2.426 1.894l.401 1.606-10.92900004 0zm-3.489-3l.339-1.359c.242-.966 1.107-1.641 2.103-1.641l2.647 0c.267.587.668 1.093 1.157 1.501l-.027 0c-1.134.031-2.152.605-2.773 1.499l-3.446 0zm1.453-6.5c0-1.378 1.122-2.5 2.5-2.5.884 0 1.654.466 2.097 1.161-.825.775-1.347 1.868-1.347 3.089 0 .205.032.401.061.599-.256.089-.525.151-.811.151-1.378 0-2.5-1.122-2.5-2.5zM13.2494996 6.25c0 1.792-1.458 3.25-3.25000004 3.25-1.792 0-3.25-1.458-3.25-3.25 0-1.792 1.458-3.25 3.25-3.25 1.79200004 0 3.25000004 1.458 3.25000004 3.25zm1.75-4.25c1.379 0 2.5 1.122 2.5 2.5 0 1.378-1.121 2.5-2.5 2.5-.285 0-.556-.052-.811-.141.029-.2.061-.4.061-.609 0-1.222-.522-2.314-1.347-3.09.443-.694 1.213-1.16 2.097-1.16zm4.975 8.965l-.391-1.566c-.287-1.146-1.176-2.001-2.278-2.287.726-.642 1.194-1.569 1.194-2.612 0-1.93-1.57-3.5-3.5-3.5-1.215 0-2.27.634-2.896 1.578-.623-.358-1.334-.578-2.10400004-.578-.769 0-1.481.22-2.104.578-.626-.944-1.681-1.578-2.896-1.578-1.93 0-3.5 1.57-3.5 3.5 0 1.043.468 1.97 1.194 2.612-1.101.286-1.991000005 1.141-2.277000005 2.287l-.3909999996 1.565c-.063.251-.008.512.1509999996.715.159.204.398.321.657.321l3.185000005 0c-.015.051-.038.099-.052.151l-.44 1.761c-.066.263-.009.537.158.751.167.214.419.337.691.337l11.24900004 0c.271 0 .523-.123.69-.336.167-.214.225-.488.159-.751l-.441-1.762c-.013-.052-.036-.1-.051-.151l3.185 0c.258 0 .498-.117.656-.321.16-.203.215-.464.152-.714z"],"meet_18":["M16.7538326 12c-.7159792-.622-1.6549519-1-2.6759222-1l-.1089968 0c.6939798-.517 1.2549635-1.199 1.6069533-2l2.8419173 0c1.0359698 0 1.9339437.676 2.1829364 1.645L20.9507105 12l-4.1968779 0zM4.52618837 16l.48598586-1.848C5.34416457 12.885 6.54112974 12 7.92308953 12l6.15482087 0c1.3819598 0 2.578925.885 2.9119153 2.152L17.4738116 16 4.52618837 16zm-3.12690901-5.355C1.64927208 9.676 2.54624598 9 3.58321581 9l2.84091734 0c.35198975.801.91297343 1.483 1.60695324 2l-.10799686 0c-1.02197026 0-1.96094294.378-2.67692211 1l-4.19687788 0 .34998982-1.355zM3.00123274 5c0-1.654 1.34496087-3 2.99891274-3 .83997556 0 1.58395391.362 2.12793809.92C6.8451209 3.827 6.00014548 5.314 6.00014548 7c0 .339.03599896.67.10099706.991-.03499898.002-.06599808.009-.10099706.009-1.65395187 0-2.99891274-1.346-2.99891274-3zM14.9998836 7c0 2.206-1.7939478 4-3.9998836 4-2.20493584 0-3.99988361-1.794-3.99988361-4 0-2.206 1.79494777-4 3.99988361-4 2.2059358 0 3.9998836 1.794 3.9998836 4zm.9999709-5c1.6539519 0 2.9999127 1.346 2.9999127 3 0 1.654-1.3459608 3-2.9999127 3-.034999 0-.0659981-.01-.0999971-.011.0639982-.32.0999971-.65.0999971-.989 0-1.688-.8469753-3.178-2.1319379-4.083C14.4129007 2.358 15.159879 2 15.9998545 2zm5.9738262 9.961l-.4039883-1.566c-.3489898-1.352-1.5569546-2.303-2.9709135-2.38.8499753-.734 1.4009592-1.807 1.4009592-3.015 0-2.206-1.7949477-4-3.9998836-4-1.2149646 0-2.3039329.545-3.0379116 1.403C12.3589605 2.145 11.6959797 2 11 2c-.6999796 0-1.36496028.147-1.97094265.408C8.29607868 1.55 7.21511013 1 6.00014548 1 3.79520964 1 2.00126184 2.794 2.00126184 5c0 1.208.549984 2.281 1.39995927 3.015-1.41395886.077-2.621923714 1.028-2.970913559 2.38l-.403988245 1.566c-.0639981378.249-.009999709.509.147995694.712.160995315.208.405988186.327.669980505.327l3.580895805 0c-.15999534.28-.29599139.576-.37998894.898l-.51498502 1.957c-.07099793.272-.01299962.557.15999535.78.17899479.232.45098687.365.74797823.365l13.12361817 0c.2969913 0 .5689834-.133.7479782-.364.172995-.224.2309933-.509.1599953-.781l-.513985-1.957c-.0839976-.322-.2209936-.618-.3809889-.898l3.5808958 0c.2649923 0 .5089852-.119.6699805-.327.1579954-.203.2119938-.463.1479957-.712z"],"meet_20":["M17.9641894 13c-.7349847-.628-1.6659653-1-2.6669444-1l-.144997 0c.7309848-.514 1.3299723-1.2 1.7399638-2l3.3849294 0c1.0969772 0 2.0449574.679 2.306952 1.65l.3639924 1.35-4.9838962 0zM5.00145948 17.993l.54998855-2.349C5.91644042 14.087 7.21241342 13 8.70238238 13l6.59486262 0c1.4909689 0 2.7859419 1.087 3.1509343 2.644L19.0311672 18l-14.02970772-.007zM1.41653417 11.65C1.67752873 10.679 2.62650896 10 3.72248613 10l3.38492948 0c.40999146.8 1.00897898 1.486 1.73996375 2l-.14499698 0c-1.00097914 0-1.93095977.372-2.66694444 1l-4.98389617 0 .3649924-1.35zm1.583967-6.15c0-1.93 1.56996729-3.5 3.49992709-3.5.9069811 0 1.74396366.357 2.38895023.968-1.44096998.993-2.38895023 2.653-2.38895023 4.532 0 .513.07499843 1.008.20799566 1.479C6.6374254 8.983 6.5704268 9 6.50042826 9c-1.9299598 0-3.49992709-1.57-3.49992709-3.5zm13.49971873 2c0 2.481-2.0189579 4.5-4.4999062 4.5-2.48194832 0-4.49990628-2.019-4.49990628-4.5 0-2.481 2.01795796-4.5 4.49990628-4.5 2.4809483 0 4.4999062 2.019 4.4999062 4.5zm.9999792-5.5c1.9289598 0 3.4999271 1.57 3.4999271 3.5 0 1.93-1.5709673 3.5-3.4999271 3.5-.0699985 0-.1379971-.019-.2079957-.022.1319973-.472.2079957-.966.2079957-1.478 0-1.879-.9489802-3.539-2.3899502-4.531C15.7552354 2.357 16.592218 2 17.5001991 2zm6.471801 10.956l-.42299-1.566c-.3769912-1.403-1.7159597-2.383-3.2569235-2.389 1.0319758-.825 1.7079599-2.08 1.7079599-3.501 0-2.481-2.0189526-4.5-4.4998942-4.5-1.27597 0-2.4589422.529-3.3089222 1.458C13.5192459 2.165 12.7782633 2 12.0002816 2c-.7789817 0-1.5189643.165-2.19094853.458C8.95835308 1.529 7.77538089 1 6.50041086 1 4.01846921 1 2.00051665 3.019 2.00051665 5.5c0 1.421.67498413 2.676 1.70795985 3.501-1.54096377.006-2.879932297.986-3.257923411 2.389l-.4229900556 1.566c-.064998472.246-.0139996709.504.1419966616.708.161996192.211.419990127.336.689983779.336l4.310898656 0c-.26699372.423-.47098893.898-.59198608 1.416L4.027469 17.765c-.07199831.308-.00199995.624.19199549.869.18499565.233.45798923.366.74898239.366l14.06266942 0c.2909931 0 .5639867-.133.7489824-.366.1939954-.245.2639938-.561.1919955-.869l-.5499871-2.349c-.1219971-.518-.3259924-.993-.5929861-1.416l4.3108987 0c.2709936 0 .5289875-.125.6899838-.336.1559963-.204.2079951-.462.1419966-.708z"],"meet_24":["M22.3085804 17c-.971-1.226-2.468-2-4.128-2l-.728 0c1.142-.719 2.046-1.778 2.564-3.04.163.014.324.04.487.04l2.162 0c1.758 0 3.28 1.094 3.702 2.66l.592 2.34-4.651 0zm.601 5L5.09858036 22l-.092-.102.697-2.74c.474-1.859 2.169-3.158 4.124-3.158l8.35300004 0c1.954 0 3.65 1.299 4.124 3.158l.697 2.74-.092.102zM.998580361 17.009l.633999999-2.349c.422-1.566 1.944-2.66 3.7-2.66l2.163 0c.167 0 .33-.026.495-.041.518 1.262 1.423 2.322 2.56500004 3.041l-.72800004 0c-1.661 0-3.158.774-4.128 2l-4.700999999.009zM2.99558036 6.5c0-2.481 2.019-4.5 4.5-4.5 1.405 0 2.69100004.637 3.54000004 1.724C8.94158036 4.805 7.50358036 6.986 7.50358036 9.5c0 .511.066 1.007.178 1.484-.062.003-.123.016-.186.016-2.481 0-4.5-2.019-4.5-4.5zm16.50800004 3c0 3.033-2.467 5.5-5.5 5.5-3.032 0-5.50000004-2.467-5.50000004-5.5 0-3.033 2.46800004-5.5 5.50000004-5.5 3.033 0 5.5 2.467 5.5 5.5zm1-7.5c2.482 0 4.5 2.019 4.5 4.5 0 2.481-2.018 4.5-4.5 4.5-.06 0-.118-.012-.177-.015.112-.478.177-.973.177-1.485 0-2.517-1.441-4.7-3.538-5.779.849-1.086 2.135-1.721 3.538-1.721zm7.462 14.749l-.633-2.349c-.466-1.731-1.965-3.005-3.789-3.32 1.481-.987 2.46-2.671 2.46-4.58 0-3.033-2.467-5.5-5.5-5.5-1.807 0-3.447.867-4.479 2.326-.636-.209-1.315-.326-2.021-.326-.708 0-1.389.118-2.028.328C10.9445804 1.868 9.30358036 1 7.49558036 1c-3.033 0-5.5 2.467-5.5 5.5 0 1.909.979 3.593 2.46 4.58-1.824.315-3.323 1.589-3.788999999 3.319l-.6330000002 2.35c-.079.293-.017.601.1690000002.845.195.254.508.406.835999999.406l4.03 0c-.136.29-.253.592-.334.912l-.697 2.74c-.083.324-.012.661.193.926.209.268.525.422.868.422l17.81100004 0c.342 0 .658-.154.867-.422.205-.265.276-.602.194-.926l-.698-2.741c-.081-.319-.197-.621-.333-.911l4.02 0c.329 0 .642-.152.838-.407.186-.244.247-.551.168-.844z"],"meet_26":["M23.8007436 16.9961c-.92099-.623-2.0129783-.996-3.1849657-.996l-.8899904 0c1.5399834-.887 2.7339706-2.303 3.3369641-4l4.2349544 0c1.4899839 0 2.78597 1.087 3.149966 2.644l.5829938 2.356-7.2299222-.004zm2.1939764 6.795c.0169998.072-.0119999.125-.0309997.149-.0219997.028-.0599993.06-.1209987.06l-19.68578791 0c-.06099935 0-.09899894-.032-.11999871-.06-.0189998-.024-.04899947-.077-.03099967-.149l.76999171-3.132c.52999429-2.154 2.42497388-3.659 4.60795038-3.659l9.2319005 0c2.1829765 0 4.0779561 1.505 4.6079504 3.659l.7709917 3.132zm-24.4437367-9.147c.36499607-1.557 1.66098211-2.644 3.15196605-2.644l4.23495438 0c.60199352 1.697 1.79598067 3.113 3.33696407 4l-.8909904 0c-1.1719874 0-2.26397563.373-3.18496571.997l-7.19792247-.004.54999408-2.349zm1.948979-8.144c0-2.482 2.01897826-4.5 4.49995153-4.5 1.36698528 0 2.58397217.618 3.40596327 1.585-1.76498094 1.373-2.90596865 3.511-2.90596865 5.915 0 .492.05099945.972.14199847 1.437-.20999774.035-.42199546.063-.64199309.063-2.48097327 0-4.49995153-2.019-4.49995153-4.5zm18.9997954 3c0 3.584-2.9159686 6.5-6.49993 6.5-3.5839614 0-6.49993002-2.916-6.49993002-6.5 0-3.584 2.91596862-6.5 6.49993002-6.5 3.5839614 0 6.49993 2.916 6.49993 6.5zm1.4999838-7.5c2.4819733 0 4.4999515 2.018 4.4999515 4.5 0 2.481-2.0179782 4.5-4.4999515 4.5-.2199976 0-.4319954-.025-.6419931-.06.090999-.466.1419985-.947.1419985-1.44 0-2.404-1.1409877-4.541-2.9049687-5.915.8249911-.965 2.038978-1.585 3.4049633-1.585zm7.9729141 14.765l-.550994-2.349c-.470995-2.011-2.1669767-3.416-4.1239556-3.416l-.1449985 0c1.4169848-.996 2.3469748-2.641 2.3469748-4.5 0-3.032-2.4669735-5.5-5.4999408-5.5-1.7099816 0-3.2329652.791-4.2419543 2.019-1.1059881-.644-2.3879743-1.019-3.7579595-1.019-1.3689853 0-2.6509715.375-3.7569596 1.018-1.0069891-1.229-2.5319727-2.018-4.24295427-2.018-3.03196734 0-5.49994075 2.468-5.49994075 5.5 0 1.859.93098997 3.504 2.3479747 4.5l-.14499843 0c-1.95797891 0-3.65396065 1.404-4.124955572 3.416l-.5499940762 2.349c-.0719992244.307-.0019999784.625.1919979322.869.184998007.232.456995077.366.748991932.366l6.091934384 0c-.5849937.68-1.02898892 1.497-1.25598647 2.421l-.76999171 3.132c-.08699906.352-.0089999.718.21499768 1.005.21999763.281.55099407.442.90699024.442l19.68578791 0c.3559962 0 .6869926-.161.9079903-.442.2229976-.287.3009967-.653.2149976-1.005l-.7709916-3.132c-.2269976-.924-.6699928-1.741-1.2549865-2.421l6.0909344 0c.2919968 0 .5649939-.134.7489919-.366.1949979-.244.2649971-.562.1929979-.869z"],"meet_32":["M36.9681 22.9053c-.045.06-.126.095-.218.095l-6.577 0c-1.214-1.83-3.328-3-5.683-3l-1.391 0c1.726-.89 3.125-2.321 3.979-4.068.305.04.612.068.922.068l2.727 0c2.569 0 4.785 1.51 5.389 3.674l.875 3.132c.003.014.014.05-.023.099zm-6.023 5.986c-.054.069-.138.109-.232.109l-23.436 0c-.094 0-.179-.04-.232-.109-.032-.042-.065-.109-.042-.197l.917-3.523c.639-2.456 2.934-4.171 5.579-4.171l10.991 0c2.646 0 4.94 1.715 5.58 4.171l.917 3.523c.023.088-.01.155-.042.197zm-29.7-5.891c-.091 0-.173-.036-.218-.095-.037-.049-.027-.085-.023-.099l.874-3.132c.604-2.164 2.82-3.674 5.39-3.674l2.727 0c.307 0 .614-.028.917-.068.854 1.748 2.252 3.178 3.979 4.068l-1.392 0c-2.354 0-4.468 1.17-5.682 3l-6.572 0zm2.75-14c0-3.309 2.691-6 6-6 1.476 0 2.901.55 3.994 1.525-2.406 1.617-3.994 4.363-3.994 7.475 0 1.035.184 2.026.508 2.953-.17.014-.337.047-.508.047-3.309 0-6-2.692-6-6zm23 3c0 4.411-3.589 8-8 8-4.411 0-8-3.589-8-8 0-4.411 3.589-8 8-8 4.411 0 8 3.589 8 8zm1.005-9c3.308 0 6 2.691 6 6 0 3.308-2.692 6-6 6-.175 0-.348-.012-.52-.027.327-.933.515-1.93.515-2.973 0-3.11-1.587-5.856-3.992-7.473 1.094-.976 2.52-1.527 3.997-1.527zm9.954 19.537l-.875-3.132c-.661-2.37-2.904-4.069-5.586-4.348 2.092-1.212 3.507-3.47 3.507-6.057 0-3.86-3.14-7-7-7-1.831 0-3.588.731-4.89 2.005-1.235-.638-2.632-1.005-4.115-1.005-1.482 0-2.878.366-4.112 1.004-1.303-1.274-3.059-2.004-4.888-2.004-3.86 0-7 3.14-7 7 0 2.587 1.414 4.845 3.507 6.057-2.682.279-4.926 1.978-5.587 4.348l-.874 3.132c-.094.336-.025.691.189.973.234.307.613.49 1.015.49l6.034 0c-.128.296-.244.6-.327.919l-.917 3.523c-.096.369-.017.755.218 1.06.245.317.618.498 1.024.498l23.436 0c.406 0 .779-.181 1.024-.498.234-.305.314-.691.218-1.06l-.918-3.523c-.083-.319-.198-.623-.326-.919l6.039 0c.402 0 .781-.183 1.014-.49.214-.282.284-.637.19-.973z"],"meet_48":["M56.9092 34.7593c-.114.151-.311.241-.525.241l-9.895 0c-1.782-3.033-5.151-5-8.923-5l-3.484 0c2.875-1.172 5.257-3.303 6.742-6l6.524 0c3.966 0 7.389 2.342 8.326 5.695l1.311 4.698c.045.161-.016.288-.076.366zm-8.937 8.417c.068.259-.042.452-.114.545-.137.178-.35.279-.585.279l-36.561 0c-.234 0-.447-.101-.584-.279-.072-.093-.181-.286-.114-.545l1.431-5.48c1.03-3.943 4.721-6.696 8.976-6.696l17.145 0c4.255 0 7.946 2.753 8.975 6.696l1.431 5.48zm-46.355-8.176c-.215 0-.412-.09-.526-.241-.059-.078-.121-.205-.076-.366l1.311-4.698c.937-3.353 4.36-5.695 8.326-5.695l6.51 0c1.485 2.697 3.867 4.828 6.743 6l-3.484 0c-3.773 0-7.142 1.967-8.924 5l-9.88 0zm4.383-21.5c0-5.239 4.262-9.5 9.5-9.5 2.232 0 4.381.807 6.079 2.224-3.664 2.414-6.086 6.56-6.086 11.276 0 1.931.412 3.763 1.143 5.424-.378.045-.757.076-1.136.076-5.238 0-9.5-4.262-9.5-9.5zm35.493 4c0 6.893-5.607 12.5-12.5 12.5-6.893 0-12.5-5.607-12.5-12.5 0-6.892 5.607-12.5 12.5-12.5 6.893 0 12.5 5.608 12.5 12.5zm1.007-13.5c5.238 0 9.5 4.261 9.5 9.5 0 5.238-4.262 9.5-9.5 9.5-.384 0-.767-.031-1.149-.078.73-1.66 1.142-3.492 1.142-5.422 0-4.713-2.418-8.856-6.078-11.271 1.699-1.42 3.849-2.229 6.085-2.229zm15.448 30.123l-1.311-4.698c-1.056-3.782-4.876-6.425-9.289-6.425l-.406 0c3.572-1.678 6.058-5.3 6.058-9.5 0-5.79-4.711-10.5-10.5-10.5-2.584 0-5.063.981-6.976 2.688-1.936-1.073-4.161-1.688-6.531-1.688-2.367 0-4.589.613-6.522 1.683-1.914-1.704-4.39-2.683-6.971-2.683-5.79 0-10.5 4.71-10.5 10.5 0 4.2 2.485 7.822 6.057 9.5l-.405 0c-4.413 0-8.233 2.643-9.288 6.425l-1.312 4.698c-.12.428-.031.88.242 1.241.302.398.797.636 1.323.636l9.368 0c-.203.463-.377.944-.508 1.444l-1.431 5.48c-.128.49-.022 1.004.291 1.408.327.425.829.668 1.375.668l36.561 0c.547 0 1.048-.243 1.376-.668.313-.405.419-.918.29-1.408l-1.431-5.48c-.131-.5-.304-.981-.508-1.444l9.384 0c.525 0 1.019-.238 1.322-.636.273-.361.361-.813.242-1.241z"],"meet_56":["M146.6133 90.1857c-.391.507-.998.798-1.666.798l-29.405 0c-4.674-5.563-11.868-9.017-19.781-9.017l-13.456 0c10.319-2.511 18.847-9.593 23.315-18.983l1.182 0c.232.007.463.016.698.016.22 0 .438-.011.658-.016l16.469 0c9.155 0 17.098 5.869 19.316 14.272l2.996 11.353c.144.546.026 1.121-.326 1.577zm-23.69 23.785c.182.688.033 1.411-.41 1.986-.494.642-1.262 1.01-2.109 1.01l-92.809 0c-.846 0-1.615-.368-2.109-1.01-.442-.575-.592-1.298-.409-1.986l3.634-13.702c2.701-10.187 12.376-17.302 23.527-17.302l43.523 0c11.152 0 20.827 7.115 23.528 17.302l3.634 13.702zM3.0523 90.9837c-.668 0-1.275-.291-1.666-.798-.351-.456-.469-1.031-.326-1.577l2.996-11.353c2.218-8.403 10.161-14.272 19.317-14.272l16.469 0c.219.005.437.016.658.016.234 0 .466-.009.697-.016l1.183 0c4.467 9.39 12.996 16.472 23.314 18.983l-13.456 0c-7.912 0-15.106 3.454-19.78 9.017l-29.406 0zm9.948-56.484c0-15.163 12.336-27.5 27.5-27.5 7.88 0 14.988 3.338 20.007 8.666-12.631 5.283-21.507 17.754-21.507 32.301 0 4.969 1.042 9.693 2.908 13.974-.338.016-.675.037-1.016.043l-1.05 0c-14.86-.352-26.842-12.54-26.842-27.484zm95 13.467c0 18.748-15.252 34-34 34-18.748 0-34-15.252-34-34 0-18.748 15.252-34 34-34 18.748 0 34 15.252 34 34zm-.5-40.967c15.164 0 27.5 12.337 27.5 27.5 0 14.944-11.983 27.132-26.843 27.484l-1.05 0c-.341-.006-.678-.027-1.015-.043 1.866-4.281 2.908-9.005 2.908-13.974 0-14.547-8.876-27.018-21.507-32.301 5.018-5.328 12.127-8.666 20.007-8.666zm40.406 81.353l-2.996-11.353c-2.334-8.841-10.675-15.016-20.283-15.016l-9.584 0c12.078-3.308 20.957-14.356 20.957-27.484 0-15.74-12.76-28.5-28.5-28.5-8.325 0-15.813 3.574-21.024 9.265-3.877-1.479-8.08-2.298-12.476-2.298-4.397 0-8.6.819-12.477 2.298-5.211-5.691-12.698-9.265-21.023-9.265-15.741 0-28.5 12.76-28.5 28.5 0 13.128 8.879 24.176 20.957 27.484l-9.584 0c-9.609 0-17.949 6.175-20.283 15.016l-2.997 11.353c-.223.849-.041 1.739.501 2.443.582.755 1.478 1.188 2.458 1.188l28.627 0c-1.786 2.371-3.15 5.069-3.935 8.029l-3.634 13.702c-.263.99-.05 2.029.583 2.852.686.89 1.743 1.4 2.902 1.4l92.809 0c1.159 0 2.217-.51 2.902-1.4.633-.823.846-1.862.583-2.852l-3.633-13.702c-.786-2.96-2.15-5.658-3.936-8.029l28.627 0c.98 0 1.876-.433 2.458-1.188.542-.704.725-1.594.501-2.443z"],"meetings_10":["M8.667 9L1.333 9C1.152 9 1 8.86 1 8.695L1 8l8 0 0 .695C9 8.863 8.851 9 8.667 9M1.333 2l7.334 0c.181 0 .333.14.333.305L9 7 1 7l0-4.695C1 2.137 1.149 2 1.333 2m7.334-1L8 1l0-.5c0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5L7 1 3 1l0-.499c0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5L2 1l-.667 0C.598 1 0 1.585 0 2.305l0 6.39C0 9.415.598 10 1.333 10l7.334 0C9.402 10 10 9.415 10 8.695l0-6.39C10 1.585 9.402 1 8.667 1"],"meetings_12":["M10.375 11l-8.75 0C1.28 11 1 10.72 1 10.375L1 9l10 0 0 1.375c0 .345-.28.625-.625.625m-8.75-8.998l8.75 0c.345 0 .625.28.625.625L11 8 1 8l0-5.373c0-.345.28-.625.625-.625m8.75-1L9 1.002 9 .5c0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5l0 .502-4 0L4 .5c0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5l0 .502-1.375 0C.729 1.002 0 1.731 0 2.627l0 7.748C0 11.271.729 12 1.625 12l8.75 0c.896 0 1.625-.729 1.625-1.625l0-7.748c0-.896-.729-1.625-1.625-1.625"],"meetings_14":["M12.281 13L1.718 13C1.322 13 1 12.696 1 12.323L1 11l12 0 0 1.323c0 .373-.323.677-.719.677M1.718 3l10.563 0c.396 0 .719.304.719.677L13 10 1 10l0-6.323C1 3.304 1.322 3 1.718 3m10.563-1l-1.307 0 0-1.5c0-.276-.223-.5-.5-.5-.276 0-.5.224-.5.5l0 1.5-6 0 0-1.5c0-.276-.223-.5-.5-.5-.276 0-.5.224-.5.5l0 1.5-1.256 0C.77 2 0 2.752 0 3.677l0 8.646C0 13.248.77 14 1.718 14l10.563 0c.947 0 1.719-.752 1.719-1.677l0-8.646C14 2.752 13.228 2 12.281 2"],"meetings_16":["M15 11L1 11l0-7c0-.551.448-1 1-1l12 0c.552 0 1 .449 1 1l0 7zm0 3c0 .551-.448 1-1 1L2 15c-.552 0-1-.449-1-1l0-2 14 0 0 2zM14 2l-2 0 0-1.5c0-.275-.225-.5-.5-.5-.275 0-.5.225-.5.5L11 2 5 2 5 .5c0-.275-.225-.5-.5-.5-.275 0-.5.225-.5.5L4 2 2 2C.896 2 0 2.895 0 4l0 10c0 1.105.896 2 2 2l12 0c1.104 0 2-.895 2-2l0-10c0-1.105-.896-2-2-2z"],"meetings_18":["M15 16L3 16c-.552 0-1-.449-1-1l0-2 14 0 0 2c0 .551-.448 1-1 1M3 4l12 0c.552 0 1 .449 1 1l0 7-14 0 0-7c0-.551.448-1 1-1m12-1l-2 0 0-1.5c0-.275-.225-.5-.5-.5-.275 0-.5.225-.5.5L12 3 6 3l0-1.5c0-.275-.225-.5-.5-.5-.275 0-.5.225-.5.5L5 3 3 3c-1.104 0-2 .896-2 2l0 10c0 1.104.896 2 2 2l12 0c1.104 0 2-.896 2-2l0-10c0-1.104-.896-2-2-2"],"meetings_20":["M16.5 18l-13 0c-.827 0-1.5-.673-1.5-1.5L2 15l16 0 0 1.5c0 .827-.673 1.5-1.5 1.5M3.5 4l13 0c.827 0 1.5.673 1.5 1.5l0 8.5-16 0 0-8.5C2 4.673 2.673 4 3.5 4m13-1L15 3l0-1.5c0-.275-.225-.5-.5-.5-.275 0-.5.225-.5.5L14 3 6 3l0-1.5c0-.275-.225-.5-.5-.5-.275 0-.5.225-.5.5L5 3 3.5 3C2.119 3 1 4.119 1 5.5l0 11C1 17.881 2.119 19 3.5 19l13 0c1.381 0 2.5-1.119 2.5-2.5l0-11C19 4.119 17.881 3 16.5 3"],"meetings_24":["M20.531 22L3.469 22C2.659 22 2 21.343 2 20.534L2 18l20 0 0 2.534c0 .809-.659 1.466-1.469 1.466M3.469 4l17.062 0C21.341 4 22 4.657 22 5.466L22 17 2 17 2 5.466C2 4.657 2.659 4 3.469 4m17.062-1L18 3l0-1.5c0-.276-.224-.5-.5-.5-.277 0-.5.224-.5.5L17 3 7 3l0-1.5c0-.276-.224-.5-.5-.5-.277 0-.5.224-.5.5L6 3 3.469 3C2.107 3 1 4.106 1 5.466l0 15.068C1 21.894 2.107 23 3.469 23l17.062 0C21.892 23 23 21.894 23 20.534l0-15.068C23 4.106 21.892 3 20.531 3"],"meetings_26":["M23.156 25L2.844 25C1.827 25 1 24.209 1 23.236L1 20l24 0 0 3.236c0 .973-.827 1.764-1.844 1.764M2.844 4l20.312 0C24.173 4 25 4.791 25 5.764L25 19 1 19 1 5.764C1 4.791 1.827 4 2.844 4m20.312-1L20 3l0-2.5c0-.276-.224-.5-.5-.5-.277 0-.5.224-.5.5L19 3 7 3 7 .5c0-.276-.224-.5-.5-.5-.277 0-.5.224-.5.5L6 3 2.844 3C1.275 3 0 4.24 0 5.764l0 17.472C0 24.76 1.275 26 2.844 26l20.312 0C24.724 26 26 24.76 26 23.236l0-17.472C26 4.24 24.724 3 23.156 3"],"meetings_28":["M24 26L4 26c-1.103 0-2-.897-2-2l0-3 24 0 0 3c0 1.103-.897 2-2 2M4 5l20 0c1.103 0 2 .897 2 2l0 13-24 0L2 7c0-1.103.897-2 2-2m20-1l-3 0 0-2.5c0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5L20 4 8 4l0-2.5c0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5L7 4 4 4C2.343 4 1 5.343 1 7l0 17c0 1.657 1.343 3 3 3l20 0c1.657 0 3-1.343 3-3l0-17c0-1.657-1.343-3-3-3"],"meetings_32":["M2 28.0073661C2 29.1078656 2.8945246 30 4.00001915 30l23.99996175 0C29.1025997 30 30 29.1056664 30 28.0073661l0-21.01473216C30 5.89213435 29.1054754 5 27.9999809 5L4.00001915 5C2.89740027 5 2 5.89433364 2 6.99263394L2 28.0073661zM4.00001915 4L27.9999809 4C29.6568457 4 31 5.3389342 31 6.99263394l0 21.01473216C31 29.6601521 29.6526814 31 27.9999809 31L4.00001915 31C2.34315432 31 1 29.6610658 1 28.0073661L1 6.99263394C1 5.33984785 2.34731857 4 4.00001915 4zM9 1.495388985C9 1.221793203 9.23193359 1 9.5 1c.27614237 0 .5.215752602.5.495388985L10 4 9 4l0-2.504611015zm13 0C22 1.221793203 22.2319336 1 22.5 1c.2761424 0 .5.215752602.5.495388985L23 4l-1 0 0-2.504611015zM2 23l0 1 28 0 0-1-28 0z"],"meetings_36":["M34 26L2 26 2 8.488C2 7.116 3.164 6 4.594 6l26.812 0C32.836 6 34 7.116 34 8.488L34 26zm0 5.512C34 32.884 32.836 34 31.406 34L4.594 34C3.164 34 2 32.884 2 31.512L2 27l32 0 0 4.512zM31.406 5L27 5l0-3.5c0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5L26 5 10 5l0-3.5c0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5L9 5 4.594 5C2.612 5 1 6.565 1 8.488l0 23.024C1 33.435 2.612 35 4.594 35l26.812 0C33.388 35 35 33.435 35 31.512l0-23.024C35 6.565 33.388 5 31.406 5z"],"meetings_8":["M6.8333 7l-5.667 0c-.09 0-.166-.066-.166-.144l0-.856 6 0 0 .856c0 .08-.075.144-.167.144m-5.667-5l5.667 0c.09 0 .167.066.167.144l0 2.856-6 0 0-2.856c0-.08.074-.144.166-.144m5.667-1l-.833 0 0-.5c0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5l0 .5-2 0 0-.5c0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5l0 .5-.834 0c-.643 0-1.166.513-1.166 1.144l0 4.712C.0003 7.487.5233 8 1.1663 8l5.667 0c.643 0 1.167-.513 1.167-1.144l0-4.712c0-.631-.524-1.144-1.167-1.144"],"meetings-active_10":["M10 2.3052l0 4.695-10 0 0-4.695c0-.72.598-1.305 1.333-1.305l.667 0 0-.499c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 .499 4 0 0-.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 .5.667 0c.735 0 1.333.585 1.333 1.305zM0 8.6948l0-.695 10 0 0 .695c0 .72-.598 1.305-1.333 1.305l-7.334 0C.598 9.9998 0 9.4148 0 8.6948z"],"meetings-active_12":["M12 8L0 8l0-5.373c0-.896.729-1.625 1.625-1.625l1.375 0L3 .5c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 .502 4 0L8 .5c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 .502 1.375 0c.896 0 1.625.729 1.625 1.625L12 8zm0 1l0 1.375c0 .896-.729 1.625-1.625 1.625l-8.75 0C.729 12 0 11.271 0 10.375L0 9l12 0z"],"meetings-active_14":["M14 10L0 10l0-6.323C0 2.752.77 2 1.718 2l1.256 0 0-1.5c0-.276.224-.5.5-.5.277 0 .5.224.5.5l0 1.5 6 0 0-1.5c0-.276.224-.5.5-.5.277 0 .5.224.5.5l0 1.5 1.307 0C13.228 2 14 2.752 14 3.677L14 10zm0 1l0 1.323c0 .925-.772 1.677-1.719 1.677L1.718 14C.77 14 0 13.248 0 12.323L0 11l14 0z"],"meetings-active_16":["M16 11L0 11l0-7c0-1.105.896-2 2-2l2 0L4 .5c0-.275.225-.5.5-.5.275 0 .5.225.5.5L5 2l6 0 0-1.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5L12 2l2 0c1.104 0 2 .895 2 2l0 7zm0 1l0 2c0 1.105-.896 2-2 2L2 16c-1.104 0-2-.895-2-2l0-2 16 0z"],"meetings-active_18":["M17 12L1 12l0-7c0-1.104.896-2 2-2l2 0 0-1.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5L6 3l6 0 0-1.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5L13 3l2 0c1.104 0 2 .896 2 2l0 7zm0 1l0 2c0 1.104-.896 2-2 2L3 17c-1.104 0-2-.896-2-2l0-2 16 0z"],"meetings-active_20":["M19 14L1 14l0-8.5C1 4.119 2.119 3 3.5 3L5 3l0-1.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5L6 3l8 0 0-1.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5L15 3l1.5 0C17.881 3 19 4.119 19 5.5l0 8.5zm0 1l0 1.5c0 1.381-1.119 2.5-2.5 2.5l-13 0C2.119 19 1 17.881 1 16.5L1 15l18 0z"],"meetings-active_24":["M23 17L1 17 1 5.466C1 4.106 2.107 3 3.469 3L6 3l0-1.5c0-.276.223-.5.5-.5.276 0 .5.224.5.5L7 3l10 0 0-1.5c0-.276.223-.5.5-.5.276 0 .5.224.5.5L18 3l2.531 0C21.892 3 23 4.106 23 5.466L23 17zm0 1l0 2.534C23 21.894 21.892 23 20.531 23L3.469 23C2.107 23 1 21.894 1 20.534L1 18l22 0z"],"meetings-active_26":["M26 19L0 19 0 5.764C0 4.24 1.275 3 2.844 3L6 3 6 .5c0-.276.223-.5.5-.5.276 0 .5.224.5.5L7 3l12 0 0-2.5c0-.276.223-.5.5-.5.276 0 .5.224.5.5L20 3l3.156 0C24.724 3 26 4.24 26 5.764L26 19zm0 1l0 3.236C26 24.76 24.724 26 23.156 26L2.844 26C1.275 26 0 24.76 0 23.236L0 20l26 0z"],"meetings-active_28":["M27 20L1 20 1 7c0-1.657 1.343-3 3-3l3 0 0-2.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5L8 4l12 0 0-2.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5L21 4l3 0c1.657 0 3 1.343 3 3l0 13zm0 1l0 3c0 1.657-1.343 3-3 3L4 27c-1.657 0-3-1.343-3-3l0-3 26 0z"],"meetings-active_32":["M31 23L1 23 1 6.99263394C1 5.33984785 2.34731857 4 4.00001915 4L9 4l0-2.504611015C9 1.221793203 9.23193359 1 9.5 1c.27614237 0 .5.215752602.5.495388985L10 4l12 0 0-2.504611015C22 1.221793203 22.2319336 1 22.5 1c.2761424 0 .5.215752602.5.495388985L23 4l4.9999809 0C29.6568457 4 31 5.3389342 31 6.99263394L31 23zm0 1l0 4.0073661C31 29.6601521 29.6526814 31 27.9999809 31L4.00001915 31C2.34315432 31 1 29.6610658 1 28.0073661L1 24l30 0z"],"meetings-active_36":["M35 26L1 26 1 8.488C1 6.565 2.612 5 4.594 5L9 5l0-3.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5L10 5l16 0 0-3.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5L27 5l4.406 0C33.388 5 35 6.565 35 8.488L35 26zm0 1l0 4.512C35 33.435 33.388 35 31.406 35L4.594 35C2.612 35 1 33.435 1 31.512L1 27l34 0z"],"meetings-active_8":["M.0003 6L8 6l0-1L.0003 5l0-2.856C.0003 1.513.5233 1 1.1663 1l.834 0 0-.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 .5 2 0 0-.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 .5.833 0c.643 0 1.167.513 1.167 1.144l0 4.712c0 .631-.524 1.144-1.167 1.144l-5.667 0c-.643 0-1.166-.513-1.166-1.144l0-.856z"],"mention_10":["M5 6c-.551 0-1-.448-1-1 0-.552.449-1 1-1 .551 0 1 .448 1 1 0 .552-.449 1-1 1m0-6C2.243 0 0 2.243 0 5c0 2.757 2.243 5 5 5 1.333 0 2.586-.518 3.529-1.459.196-.194.196-.511.001-.707-.195-.195-.511-.195-.707 0C7.069 8.586 6.066 9 5 9 2.794 9 1 7.206 1 5c0-2.206 1.794-4 4-4 2.206 0 4 1.794 4 4 0 .552-.449 1-1 1-.551 0-1-.448-1-1l0-1.5c0-.276-.224-.5-.5-.5-.206 0-.381.124-.458.301C5.738 3.113 5.383 3 5 3c-1.103 0-2 .897-2 2 0 1.103.897 2 2 2 .6 0 1.133-.271 1.5-.691.367.42.9.691 1.5.691 1.104 0 2-.897 2-2 0-2.757-2.243-5-5-5"],"mention_12":["M6 8c-1.103 0-2-.897-2-2 0-1.103.897-2 2-2 1.103 0 2 .897 2 2 0 1.103-.897 2-2 2m0-8C2.691 0 0 2.691 0 6c0 3.309 2.691 6 6 6 1.236 0 2.427-.378 3.441-1.092.226-.159.28-.471.122-.697-.16-.226-.47-.28-.698-.121-.844.596-1.836.91-2.865.91-2.757 0-5-2.243-5-5 0-2.757 2.243-5 5-5 2.757 0 5 2.243 5 5l0 1c0 .552-.448 1-1 1-.552 0-1-.448-1-1l0-3.5c0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5l0 .28C7.468 3.301 6.771 3 6 3 4.346 3 3 4.346 3 6c0 1.654 1.346 3 3 3 .903 0 1.705-.409 2.255-1.043C8.596 8.575 9.246 9 10 9c1.103 0 2-.897 2-2l0-1c0-3.309-2.691-6-6-6"],"mention_14":["M7 9.00052322c-1.103 0-2-.89690613-2-1.99979071 0-1.10288458.897-1.99979071 2-1.99979071 1.103 0 2 .89690613 2 1.99979071 0 1.10288458-.897 1.99979071-2 1.99979071M7.215.004464703c-1.92-.0679928843-3.72.642932714-5.09 1.973793437C.755 3.30811896 0 5.09193227 0 7.00073251 0 10.8593287 3.14 14 7 14c1.865 0 3.62-.7249241 4.941-2.0407864.196-.1949796.197-.5119464.002-.706926-.196-.1969794-.512-.1969794-.708-.0019998-1.132 1.1288818-2.637 1.7498168-4.235 1.7498168-3.309 0-6-2.6907184-6-5.99937209 0-1.6368287.647-3.1656687 1.822-4.3055494C3.997 1.5563023 5.558.972363407 7.185 1.00436006 10.392 1.10035001 13 3.91205575 13 7.27270405l0 .22797614c0 .82691346-.673 1.49984303-1.5 1.49984303-.827 0-1.5-.67292957-1.5-1.49984303l0-2.99968607c0-.27597112-.224-.49994768-.5-.49994768-.276 0-.5.22397656-.5.49994768l0 .2799707c-.532-.47894988-1.229-.77991838-2-.77991838-1.654 0-3 1.34585915-3 2.99968607 0 1.65382692 1.346 2.99968609 3 2.99968609.973 0 1.83-.47295053 2.379-1.19287518.441.71292539 1.223 1.19287518 2.121 1.19287518 1.378 0 2.5-1.12088272 2.5-2.49973841l0-.22797614C14 3.37711174 10.957.116452983 7.215.004464703"],"mention_16":["M8 11c-1.654 0-3-1.346-3-3 0-1.654 1.346-3 3-3 1.654 0 3 1.346 3 3 0 1.654-1.346 3-3 3M8 0C3.589 0 0 3.589 0 8c0 4.411 3.589 8 8 8 1.748 0 3.408-.554 4.801-1.601.22-.166.264-.479.098-.7-.165-.221-.48-.265-.7-.098C10.982 14.516 9.53 15 8 15c-3.86 0-7-3.141-7-7 0-3.86 3.14-7 7-7 3.859 0 7 3.14 7 7l0 1.5c0 .827-.673 1.5-1.5 1.5-.827 0-1.5-.673-1.5-1.5l0-5c0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5l0 .882C10.267 4.542 9.2 4 8 4 5.794 4 4 5.794 4 8c0 2.206 1.794 4 4 4 1.3 0 2.444-.632 3.176-1.595C11.54 11.336 12.441 12 13.5 12c1.379 0 2.5-1.121 2.5-2.5L16 8c0-4.411-3.589-8-8-8"],"mention_18":["M9 13c-2.206 0-4-1.794-4-4 0-2.206 1.794-4 4-4 2.206 0 4 1.794 4 4 0 2.206-1.794 4-4 4M9 0C4.038 0 0 4.038 0 9c0 4.962 4.038 9 9 9 1.835 0 3.601-.549 5.106-1.588.227-.156.285-.468.128-.695-.157-.228-.468-.287-.696-.127C12.201 16.513 10.631 17 9 17c-4.411 0-8-3.589-8-8 0-4.411 3.589-8 8-8 4.411 0 8 3.589 8 8l0 2.5c0 .827-.673 1.5-1.5 1.5-.827 0-1.5-.673-1.5-1.5l0-7c0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5l0 1.531C12.088 4.806 10.641 4 9 4 6.243 4 4 6.243 4 9c0 2.757 2.243 5 5 5 1.665 0 3.133-.827 4.042-2.082C13.243 13.097 14.265 14 15.5 14c1.378 0 2.5-1.122 2.5-2.5L18 9c0-4.962-4.038-9-9-9"],"mention_20":["M10 14c-2.206 0-4-1.794-4-4 0-2.206 1.794-4 4-4 2.206 0 4 1.794 4 4 0 2.206-1.794 4-4 4m0-14C4.486 0 0 4.486 0 10c0 5.514 4.486 10 10 10 2.081 0 4.077-.634 5.771-1.832.226-.159.279-.472.12-.697-.162-.227-.474-.28-.698-.119C13.669 18.43 11.873 19 10 19c-4.962 0-9-4.037-9-9 0-4.962 4.038-9 9-9 4.963 0 9 4.038 9 9l0 2c0 1.103-.897 2-2 2-1.103 0-2-.897-2-2l0-6.5c0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5l0 1.531C13.088 5.806 11.642 5 10 5c-2.757 0-5 2.243-5 5 0 2.757 2.243 5 5 5 1.713 0 3.226-.867 4.127-2.185C14.484 14.072 15.63 15 17 15c1.654 0 3-1.346 3-3l0-2c0-5.514-4.486-10-10-10"],"mention_24":["M12 17c-2.757 0-5-2.243-5-5 0-2.757 2.243-5 5-5 2.757 0 5 2.243 5 5 0 2.757-2.243 5-5 5m0-17C5.383 0 0 5.383 0 12c0 6.617 5.383 12 12 12 2.429 0 4.767-.722 6.764-2.086.227-.156.286-.468.131-.695-.157-.229-.468-.284-.696-.131C16.37 22.339 14.226 23 12 23 5.935 23 1 18.065 1 12 1 5.935 5.935 1 12 1c6.065 0 11 4.935 11 11l0 2.5c0 1.379-1.121 2.5-2.5 2.5-1.379 0-2.5-1.121-2.5-2.5l0-8c0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5l0 2.19C15.925 7.071 14.086 6 12 6c-3.309 0-6 2.691-6 6 0 3.309 2.691 6 6 6 2.134 0 4.006-1.123 5.07-2.806C17.394 16.792 18.808 18 20.5 18c1.93 0 3.5-1.57 3.5-3.5l0-2.5c0-6.617-5.383-12-12-12"],"mention_8":["M4.0005 5c-.552 0-1-.449-1-1 0-.551.448-1 1-1 .552 0 1 .449 1 1 0 .551-.448 1-1 1m0-5c-2.206 0-4 1.794-4 4 0 2.206 1.794 4 4 4 .733 0 1.451-.2 2.075-.58.237-.143.311-.451.167-.687-.143-.237-.452-.31-.686-.167-.467.284-1.005.434-1.556.434-1.654 0-3-1.346-3-3 0-1.654 1.346-3 3-3 1.654 0 3 1.346 3 3l0 .5c0 .276-.225.5-.5.5-.275 0-.5-.224-.5-.5l0-2c0-.276-.224-.5-.5-.5-.205 0-.381.124-.458.301-.305-.187-.659-.301-1.042-.301-1.103 0-2 .897-2 2 0 1.103.897 2 2 2 .525 0 1-.208 1.357-.54.276.327.683.54 1.143.54.827 0 1.5-.673 1.5-1.5l0-.5c0-2.206-1.794-4-4-4"],"microphone_10":["M6.5 6.5C6.5 7.327 5.827 8 5 8c-.827 0-1.5-.673-1.5-1.5l0-4C3.5 1.673 4.173 1 5 1c.827 0 1.5.673 1.5 1.5l0 4zm-4-4l0 4c0 1.208.86 2.217 2 2.449L4.5 9 3.45384339 9c-.276 0-.499999999.224-.499999999.5 0 .276.223999999.5.499999999.5L4.5 10l1 0 1.01872306 0c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5L5.5 9l0-.051c1.14-.232 2-1.241 2-2.449l0-4C7.5 1.122 6.378 0 5 0 3.622 0 2.5 1.122 2.5 2.5z"],"microphone_12":["M4.5 7.5l0-5C4.5 1.673 5.173 1 6 1c.827 0 1.5.673 1.5 1.5l0 5C7.5 8.327 6.827 9 6 9c-.827 0-1.5-.673-1.5-1.5m4 0l0-5C8.5 1.125 7.375 0 6 0 4.625 0 3.5 1.125 3.5 2.5l0 5c0 1.204.862 2.216 2 2.449L5.5 11l.001 0L4.5 11c-.275 0-.5.226-.5.5 0 .275.225.5.5.5l3 0c.275 0 .5-.225.5-.5 0-.274-.225-.5-.5-.5l-1 0 0-1.051c1.138-.233 2-1.245 2-2.449"],"microphone_14":["M9 9c0 1.103-.897 2-2 2-1.103 0-2-.897-2-2l0-6c0-1.103.897-2 2-2 1.103 0 2 .897 2 2l0 6zM7 0C5.343 0 4 1.343 4 3l0 6c0 1.485 1.083 2.71 2.5 2.95l0 1.05-1 0c-.275 0-.5.225-.5.5 0 .275.225.5.5.5l3 0c.275 0 .5-.225.5-.5 0-.275-.225-.5-.5-.5l-1 0 0-1.05C8.917 11.71 10 10.485 10 9l0-6c0-1.657-1.343-3-3-3z"],"microphone_16":["M8.5 13.9645556L8.5 15l1.97511574 0c.27614238 0 .5.2238576.5.5 0 .2761424-.22385762.5-.5.5l-4.98485725 0c-.27614238 0-.500000002-.2238576-.500000002-.5 0-.2761424.223857622-.5.500000002-.5L7.5 15l0-1.0354444c-1.69614707-.2426149-3-1.7013196-3-3.4645556l0-7C4.5 1.56700338 6.06700338 0 8 0c1.93299662 0 3.5 1.56700338 3.5 3.5l0 7c0 1.763236-1.30385293 3.2219407-3 3.4645556zM5.5 3.5l0 7C5.5 11.8807119 6.61928813 13 8 13c1.38071187 0 2.5-1.1192881 2.5-2.5l0-7C10.5 2.11928813 9.38071187 1 8 1 6.61928813 1 5.5 2.11928813 5.5 3.5z"],"microphone_18":["M6 11.5L6 4c0-1.654 1.346-3 3-3 1.654 0 3 1.346 3 3l0 7.5c0 1.654-1.346 3-3 3-1.654 0-3-1.346-3-3m7 0L13 4c0-2.206-1.794-4-4-4-2.206 0-4 1.794-4 4l0 7.5c0 2.035 1.532 3.7 3.5 3.949L8.5 17l-2 0c-.276 0-.5.224-.5.5 0 .276.224.5.5.5l5 0c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5l-2 0 0-1.551C11.468 15.2 13 13.535 13 11.5"],"microphone_20":["M13.5 12.5c0 1.93-1.57 3.5-3.5 3.5-1.93 0-3.5-1.57-3.5-3.5l0-8C6.5 2.57 8.07 1 10 1c1.93 0 3.5 1.57 3.5 3.5l0 8zm-8-8l0 8c0 2.315 1.755 4.199 4.003 4.45 0 .004-.001.6873333-.003 2.05l-2 0c-.275 0-.5.224-.5.5 0 .276.225.5.5.5l5 0c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5l-2 0 0-2.033c2.245-.268 4-2.152 4-4.467l0-8C14.5 2.015 12.485 0 10 0 7.515 0 5.5 2.015 5.5 4.5z"],"microphone_24":["M7.5 15.504L7.5 5.5C7.5 3.019 9.519 1 12 1c2.481 0 4.5 2.019 4.5 4.5l0 10.004c0 2.481-2.019 4.5-4.5 4.5-2.481 0-4.5-2.019-4.5-4.5M17.5 5.5C17.5 2.468 15.033 0 12 0 8.967 0 6.5 2.468 6.5 5.5l0 10.004c0 2.864 2.201 5.221 5 5.475l0 2.021-3 0c-.276 0-.5.224-.5.5 0 .276.224.5.5.5l7 0c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5l-3 0 0-2.021c2.799-.254 5-2.611 5-5.475l0-10.004z"],"microphone_28":["M9.5 18.480979l0-11.96931972c0-2.4862594 2.019-4.50953941 4.5-4.50953941 2.481 0 4.5 2.02328001 4.5 4.50953941l0 11.96931972c0 2.4862594-2.019 4.5095394-4.5 4.5095394-2.481 0-4.5-2.02328-4.5-4.5095394m10-11.96931972C19.5 3.47323184 17.033 1 14 1c-3.033 0-5.5 2.47323184-5.5 5.51165928l0 11.96931972c0 2.8700713 2.201 5.2320678 5 5.4866063l0 2.0302948-4.025075605 0c-.276 0-.5.2234728-.5.50106 0 .276585.224.5010599.5.5010599L18.5 27c.276 0 .5-.2244749.5-.5010599 0-.2775872-.224-.50106-.5-.50106l-4 0 0-2.0302948c2.799-.2545385 5-2.616535 5-5.4866063l0-11.96931972z"],"microphone_36":["M18 30.0259c-3.584 0-6.5-2.913-6.5-6.494l0-15.039c0-3.581 2.916-6.494 6.5-6.494 3.584 0 6.5 2.913 6.5 6.494l0 15.039c0 3.581-2.916 6.494-6.5 6.494m7.5-21.533c0-4.132-3.364-7.493-7.5-7.493-4.136 0-7.5 3.361-7.5 7.493l0 15.039c0 3.964 3.098 7.209 7 7.468l0 3-5 0c-.276 0-.5.224-.5.5 0 .276.224.499.5.499l11.0143127 0c.276 0 .5-.223.5-.499 0-.276-.224-.5-.5-.5l-5.0143127 0 0-3c3.902-.259 7-3.504 7-7.468l0-15.039z"],"microphone-muted_10":["M6.49991667 6.50034997c0 .8269173-.67296261 1.49985001-1.49991667 1.49985001-.76295761 0-1.38792289-.57494251-1.48091773-1.31286871l2.9808344-2.98070193 0 2.79372063zM3.50008333 2.50074993c0-.82691731.67296261-1.49985002 1.49991667-1.49985002.76195767 0 1.38692295.57394261 1.48091773 1.31086891l-2.9808344 2.98070193 0-2.79172082zM9.35375812.146985301c-.19598911-.1959804015-.51197155-.1959804015-.70796066 0L7.28887284 1.50384962C6.90289428.620937906 6.02294317.0009999 5 .0009999c-1.37792345 0-2.49986112 1.12188781-2.49986112 2.49975003l0 3.79162083L.646241875 8.14618538c-.1949891668.1949805-.1949891668.51094891 0 .70692931.097994556.0969903.225987446.1459854.353980335.1459854.127992889 0 .255985778-.0489951.353980334-.1459854L2.71412699 7.49225077c.32098217.73692631.97994556 1.29287072 1.78590079 1.45685432l0 .0509949-1.0459419 0c-.27598466 0-.49997222.2239776-.49997222.49995001 0 .2759724.22398756.49995.49997222.49995l1.0459419 0 .99994444 0 1.0189434 0c.27598466 0 .49997222-.2239776.49997222-.49995 0-.27597241-.22398756-.49995001-.49997222-.49995001l-1.0189434 0 0-.0509949c1.13993667-.2319768 1.9998889-1.24087591 1.9998889-2.44875512l0-3.79362064 1.853897-1.852814721c.19498917-.195980402.19498917-.511948806 0-.706929308z"],"microphone-muted_12":["M7.50025 7.501c0 .827-.673 1.5-1.5 1.5-.827 0-1.5-.673-1.5-1.5l0-.294 3-3 0 3.294zm-3-5c0-.827.673-1.5 1.5-1.5.827 0 1.5.673 1.5 1.5l0 .292-3 3 0-3.292zm6.354-2.354c-.196-.196-.512-.196-.708 0l-1.734 1.734c-.279-1.076-1.252-1.88-2.412-1.88-1.375 0-2.5 1.125-2.5 2.5l0 4.292-2.354 2.354c-.195.195-.195.511 0 .707.098.097.226.146.354.146.128 0 .256-.049.354-.146l1.733-1.734c.238.918.978 1.639 1.913 1.83l0 1.051-1 0c-.275 0-.5.226-.5.5 0 .275.225.5.5.5l3 0c.275 0 .5-.225.5-.5 0-.274-.225-.5-.5-.5l-1 0 0-1.051c1.138-.233 2-1.245 2-2.449l0-4.294 2.354-2.353c.195-.196.195-.512 0-.707z"],"microphone-muted_14":["M8.98925 9.00025c0 1.103-.897 2-2 2-1.103 0-2-.897-2-2l0-.293 4-4 0 4.293zm-4-6c0-1.103.897-2 2-2 1.103 0 2 .897 2 2l0 .293-4 4 0-4.293zm7.854-2.854c-.195-.195-.512-.195-.707 0l-2.218 2.218c-.292-1.351-1.491-2.364-2.929-2.364-1.657 0-3 1.343-3 3l0 5.293-2.843 2.843c-.195.195-.195.511 0 .707.098.097.226.146.354.146.128 0 .256-.049.353-.146l2.21-2.21c.258 1.188 1.217 2.113 2.426 2.317l0 1.05-1 0c-.275 0-.5.225-.5.5 0 .275.225.5.5.5l3 0c.275 0 .5-.225.5-.5 0-.275-.225-.5-.5-.5l-1 0 0-1.05c1.417-.24 2.5-1.465 2.5-2.95l0-5.293 2.854-2.854c.195-.195.195-.512 0-.707z"],"microphone-muted_16":["M10.48925 10.54125c0 1.381-1.119 2.5-2.5 2.5-1.381 0-2.5-1.119-2.5-2.5l0-.293 5-5 0 5.293zm-5-7c0-1.38 1.119-2.5 2.5-2.5 1.381 0 2.5 1.12 2.5 2.5l0 .293-5 5 0-5.293zm7.688-2.395l-1.753 1.753c-.302-1.626-1.722-2.858-3.435-2.858-1.933 0-3.5 1.567-3.5 3.5l0 6.293-2.343 2.343c-.195.195-.195.511 0 .707.098.097.226.146.354.146.128 0 .256-.049.353-.146l1.696-1.696c.273 1.463 1.457 2.605 2.94 2.818l0 1.035-1.5 0c-.276 0-.5.224-.5.5 0 .276.224.5.5.5l4 0c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5l-1.5 0 0-1.035c1.696-.243 3-1.702 3-3.465l0-6.293 2.395-2.395c.195-.195.195-.512 0-.707-.195-.195-.512-.195-.707 0z"],"microphone-muted_18":["M12 11.4999c0 1.654-1.346 3-3 3-1.59 0-2.882-1.247-2.981-2.813L12 5.7059l0 5.794zm-6-1.457l0-6.043c0-1.654 1.346-3 3-3 1.654 0 3 1.346 3 3l0 .043 0 .249-6 6 0-.249zm9.854-8.897c-.196-.196-.512-.196-.708 0l-2.227 2.227-.017-.232C12.507 1.3479 10.911-.0001 9-.0001c-2.206 0-4 1.794-4 4l0 7.043.018.231-2.872 2.872c-.195.195-.195.511 0 .707.098.097.226.146.354.146.128 0 .256-.049.354-.146l2.306-2.307c.422 1.534 1.725 2.699 3.34 2.903l0 1.551-2.5 0c-.276 0-.5.224-.5.5 0 .276.224.5.5.5l6 0c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5l-2.5 0 0-1.551c1.968-.249 3.5-1.914 3.5-3.949l0-6.794 2.854-2.853c.195-.196.195-.512 0-.707z"],"microphone-muted_20":["M13.51525 12.51525c0 1.93-1.57 3.5-3.5 3.5-1.866 0-3.381-1.471-3.481-3.312l6.981-6.981 0 6.793zm-7-8c0-1.93 1.57-3.5 3.5-3.5 1.866 0 3.381 1.471 3.481 3.312l-6.981 6.981 0-6.793zm11.869-4.369c-.195-.195-.512-.195-.707 0l-3.303 3.303c-.481-1.968-2.243-3.434-4.359-3.434-2.485 0-4.5 2.015-4.5 4.5l0 7.793-3.869 3.869c-.195.195-.195.511 0 .707.098.097.226.146.354.146.128 0 .256-.049.353-.146l3.305-3.305c.444 1.805 1.97 3.175 3.86 3.386 0 .004-.001.687-.003 2.05l-2 0c-.275 0-.5.224-.5.5 0 .276.225.5.5.5l5 0c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5l-2 0 0-2.033c2.245-.268 4-2.152 4-4.467l0-7.793 3.869-3.869c.195-.195.195-.512 0-.707z"],"microphone-muted_24":["M16 16c0 2.045-1.548 3.745-3.602 3.954l-.398.041-.398-.041C9.548 19.745 8 18.045 8 16l0-.793 8-8L16 16zM8 5c0-2.206 1.794-4 4-4 2.206 0 4 1.794 4 4l0 .793-8 8L8 5zm12.846-3.346c-.196-.195-.512-.195-.707 0l-3.158 3.158C16.879 2.15 14.686 0 12 0 9.25 0 7 2.25 7 5l0 9.793-3.846 3.846c-.195.195-.195.511 0 .707.098.097.226.146.354.146.128 0 .256-.049.353-.146l3.157-3.157c.096 2.491 2.031 4.51 4.482 4.76l0 2.051-3 0c-.275 0-.5.225-.5.5 0 .275.225.5.5.5l7 0c.275 0 .5-.225.5-.5 0-.275-.225-.5-.5-.5l-3 0 0-2.051c2.514-.256 4.5-2.37 4.5-4.949l0-9.793 3.846-3.846c.195-.195.195-.511 0-.707z"],"microphone-muted_28":["M18.5088 18.4814c0 2.485-2.019 4.509-4.5 4.509-2.48 0-4.5-2.024-4.5-4.509l0-.778 9-9 0 9.778zm-9-11.97c0-2.486 2.02-4.509 4.5-4.509 2.481 0 4.5 2.023 4.5 4.509l0 .778-9 9 0-9.778zm13.868-3.383c-.195-.195-.512-.195-.707 0l-3.171 3.171c-.113-2.939-2.528-5.299-5.49-5.299-3.033 0-5.5 2.473-5.5 5.511l0 10.778-3.886 3.886c-.195.196-.195.512 0 .707.098.098.226.147.354.147.128 0 .256-.049.353-.147l3.199-3.198c.103 2.776 2.249 5.034 4.98 5.283l0 2.031-4.025 0c-.276 0-.5.223-.5.501 0 .276.224.501.5.501l9.025 0c.276 0 .5-.225.5-.501 0-.278-.224-.501-.5-.501l-4 0 0-2.031c2.799-.255 5-2.616 5-5.486l0-10.778 3.868-3.868c.195-.195.195-.511 0-.707z"],"microphone-muted_36":["M24.4932 8.7959l-13 13.006 0-13.309c0-3.581 2.916-6.494 6.5-6.494 3.584 0 6.5 2.913 6.5 6.494l0 .303zm0 14.736c0 3.581-2.916 6.494-6.5 6.494-3.584 0-6.5-2.913-6.5-6.494l0-.316 13-13.006 0 13.322zm6.354-20.386c-.196-.196-.512-.196-.708 0l-4.68 4.683c-.338-3.821-3.554-6.829-7.466-6.829-4.136 0-7.5 3.361-7.5 7.493l0 14.309-5.347 5.35c-.195.196-.195.512 0 .707.098.098.226.147.354.147.128 0 .256-.049.353-.147l4.672-4.674c.318 3.662 3.283 6.571 6.968 6.815l0 3-5 0c-.276 0-.5.224-.5.5 0 .276.224.499.5.499l11.014 0c.277 0 .5-.223.5-.499 0-.276-.223-.5-.5-.5l-5.014 0 0-3c3.902-.259 7-3.504 7-7.468l0-14.322 5.354-5.357c.195-.196.195-.512 0-.707z"],"mind-map_24":["M19.5 22c-1.378 0-2.5-1.122-2.5-2.5 0-1.378 1.122-2.5 2.5-2.5 1.378 0 2.5 1.122 2.5 2.5 0 1.378-1.122 2.5-2.5 2.5M9.5 4.5C9.5 3.122 10.622 2 12 2c1.378 0 2.5 1.122 2.5 2.5C14.5 5.878 13.378 7 12 7c-1.378 0-2.5-1.122-2.5-2.5M4.5 22C3.122 22 2 20.878 2 19.5 2 18.122 3.122 17 4.5 17 5.878 17 7 18.122 7 19.5 7 20.878 5.878 22 4.5 22m15-6c-.875 0-1.665.333-2.279.863L12.5 12.771l0-4.821c1.694-.245 3-1.688 3-3.45C15.5 2.567 13.933 1 12 1c-1.933 0-3.5 1.567-3.5 3.5 0 1.762 1.306 3.205 3 3.45l0 4.821-4.721 4.092C6.165 16.333 5.375 16 4.5 16 2.567 16 1 17.567 1 19.5 1 21.433 2.567 23 4.5 23 6.433 23 8 21.433 8 19.5c0-.696-.209-1.341-.56-1.887L12 13.662l4.56 3.951c-.351.546-.56 1.191-.56 1.887 0 1.933 1.567 3.5 3.5 3.5 1.933 0 3.5-1.567 3.5-3.5 0-1.933-1.567-3.5-3.5-3.5"],"minimize_12":["M8 4l3.5 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-4 0c-.276 0-.5-.224-.5-.5l0-4c0-.276.224-.5.5-.5.276 0 .5.224.5.5L8 4zM.5 7l4 0c.276 0 .5.224.5.5l0 4c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5L4 8 .5 8C.224 8 0 7.776 0 7.5c0-.276.224-.5.5-.5z"],"minimize_14":["M9 5l4.5 0c.3 0 .5.2.5.5 0 .3-.2.5-.5.5l-5 0c-.3 0-.5-.2-.5-.5l0-5c0-.3.2-.5.5-.5.3 0 .5.2.5.5L9 5zM.5 8l5 0c.3 0 .5.2.5.5l0 5c0 .3-.2.5-.5.5-.3 0-.5-.2-.5-.5L5 9 .5 9C.2 9 0 8.8 0 8.5c0-.3.2-.5.5-.5z"],"minimize_16":["M.5 11c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l5 0c.276 0 .5.224.5.5l0 5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5L5 11 .5 11zm10-5c-.276 0-.5-.224-.5-.5l0-5c0-.276.224-.5.5-.5.276 0 .5.224.5.5L11 5l4.5 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-5 0z"],"minimize_20":["M19.5 7l-6 0c-.276 0-.5-.224-.5-.5l0-6c0-.276.224-.5.5-.5.276 0 .5.224.5.5L14 6l5.5 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5zm-13 13c-.276 0-.5-.224-.5-.5L6 14 .5 14c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l6 0c.276 0 .5.224.5.5l0 6c0 .276-.224.5-.5.5z"],"minimize_24":["M15.5003 0c.276 0 .5.224.5.5l0 7.499 7.5 0c.277 0 .5.224.5.5 0 .277-.223.5-.5.5l-8 0c-.276 0-.5-.223-.5-.5l0-7.999c0-.276.224-.5.5-.5zM.501728175 14.9996l7.996543655 0c.27695395 0 .50172817.224.50172817.5l0 8c0 .276-.22477422.5-.50172817.5-.27795741 0-.50172818-.224-.50172818-.5l0-7.5-7.494815475 0C.224774222 15.9996 0 15.7756 0 15.4996c0-.276.224774222-.5.501728175-.5z"],"minimize_28":["M26.5 11c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-10 0c-.276 0-.5-.224-.5-.5l0-10c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 9.5 9.5 0zm-15 5c.276 0 .5.224.5.5l0 10c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-9.5-9.5 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l10 0z"],"minus_12":["M.545454545 5.5C.244363636 5.5 0 5.724 0 6c0 .276.244363636.5.545454545.5l10.909090955 0C11.7556364 6.5 12 6.276 12 6c0-.276-.2443636-.5-.5454545-.5L.545454545 5.5z"],"minus_14":["M.5,6.5h13A.5.5,0,0,1,14,7h0a.5.5,0,0,1-.5.5H.5A.5.5,0,0,1,0,7H0A.5.5,0,0,1,.5,6.5Z"],"minus_16":["M.5,7.5h15A.5.5,0,0,1,16,8h0a.5.5,0,0,1-.5.5H.5A.5.5,0,0,1,0,8H0A.5.5,0,0,1,.5,7.5Z"],"minus_18":["M.5,8.5h17A.5.5,0,0,1,18,9h0a.5.5,0,0,1-.5.5H.5A.5.5,0,0,1,0,9H0A.5.5,0,0,1,.5,8.5Z"],"minus_20":["M.526315789 9.5C.235789474 9.5 0 9.724 0 10c0 .276.235789474.5.526315789.5l18.947368411 0C19.7642105 10.5 20 10.276 20 10c0-.276-.2357895-.5-.5263158-.5L.526315789 9.5z"],"minus_24":["M1.523809524 11.5C1.234666667 11.5 1 11.724 1 12c0 .276.234666667.5.523809524.5l20.952380976 0C22.7653333 12.5 23 12.276 23 12c0-.276-.2346667-.5-.5238095-.5l-20.952380976 0z"],"minus_28":["M2.5,13.5h23a.5.5,0,0,1,.5.5h0a.5.5,0,0,1-.5.5H2.5A.5.5,0,0,1,2,14H2A.5.5,0,0,1,2.5,13.5Z"],"minus_8":["M.5,3.5h7A.5.5,0,0,1,8,4H8a.5.5,0,0,1-.5.5H.5A.5.5,0,0,1,0,4H0A.5.5,0,0,1,.5,3.5Z"],"more_12":["M3 6c0 .553-.447 1-1 1-.553 0-1-.447-1-1 0-.553.447-1 1-1 .553 0 1 .447 1 1zm4 0c0 .553-.447 1-1 1-.553 0-1-.447-1-1 0-.553.447-1 1-1 .553 0 1 .447 1 1zm4 0c0 .553-.447 1-1 1-.553 0-1-.447-1-1 0-.553.447-1 1-1 .553 0 1 .447 1 1z"],"more_14":["M3 7c0 .553-.447 1-1 1-.553 0-1-.447-1-1 0-.553.447-1 1-1 .553 0 1 .447 1 1zm5 0c0 .553-.447 1-1 1-.553 0-1-.447-1-1 0-.553.447-1 1-1 .553 0 1 .447 1 1zm5 0c0 .553-.447 1-1 1-.553 0-1-.447-1-1 0-.553.447-1 1-1 .553 0 1 .447 1 1z"],"more_16":["M2 7c.552 0 1 .447 1 1 0 .553-.448 1-1 1-.552 0-1-.447-1-1 0-.553.448-1 1-1zm6 0c.552 0 1 .447 1 1 0 .553-.448 1-1 1-.552 0-1-.447-1-1 0-.553.448-1 1-1zm6 0c.552 0 1 .447 1 1 0 .553-.448 1-1 1-.552 0-1-.447-1-1 0-.553.448-1 1-1z"],"more_20":["M5 10c0 .553-.448 1-1 1-.552 0-1-.447-1-1 0-.553.448-1 1-1 .552 0 1 .447 1 1zm6.0007 0c0 .553-.448 1-1 1-.552 0-1-.447-1-1 0-.553.448-1 1-1 .552 0 1 .447 1 1zm6.0037 0c0 .553-.448 1-1 1-.552 0-1-.447-1-1 0-.553.448-1 1-1 .552 0 1 .447 1 1z"],"more_24":["M12 13c-.55228475 0-1-.44771525-1-1 0-.55228475.44771525-1 1-1 .55228475 0 1 .44771525 1 1 0 .55228475-.44771525 1-1 1zm7 0c-.5522847 0-1-.44771525-1-1 0-.55228475.4477153-1 1-1 .5522847 0 1 .44771525 1 1 0 .55228475-.4477153 1-1 1zM5 13c-.55228475 0-1-.44771525-1-1 0-.55228475.44771525-1 1-1 .55228475 0 1 .44771525 1 1 0 .55228475-.44771525 1-1 1z"],"more_28":["M7 13c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm7 0c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm7 0c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1z"],"more-adr_12":["M6 3c-.553 0-1-.447-1-1 0-.553.447-1 1-1 .553 0 1 .447 1 1 0 .553-.447 1-1 1zm0 4c-.553 0-1-.447-1-1 0-.553.447-1 1-1 .553 0 1 .447 1 1 0 .553-.447 1-1 1zm0 4c-.553 0-1-.447-1-1 0-.553.447-1 1-1 .553 0 1 .447 1 1 0 .553-.447 1-1 1z"],"more-adr_16":["M9 2c0 .552-.447 1-1 1-.553 0-1-.448-1-1 0-.552.447-1 1-1 .553 0 1 .448 1 1zm0 6c0 .552-.447 1-1 1-.553 0-1-.448-1-1 0-.552.447-1 1-1 .553 0 1 .448 1 1zm0 6c0 .552-.447 1-1 1-.553 0-1-.448-1-1 0-.552.447-1 1-1 .553 0 1 .448 1 1z"],"more-adr_20":["M10.0022 4.9978c-.553 0-1-.448-1-1 0-.552.447-1 1-1 .553 0 1 .448 1 1 0 .552-.447 1-1 1zm0 6.0007c-.553 0-1-.448-1-1 0-.552.447-1 1-1 .553 0 1 .448 1 1 0 .552-.447 1-1 1zm0 6.0037c-.553 0-1-.448-1-1 0-.552.447-1 1-1 .553 0 1 .448 1 1 0 .552-.447 1-1 1z"],"more-adr_24":["M12 7c-.552 0-1-.448-1-1 0-.552.448-1 1-1 .552 0 1 .448 1 1 0 .552-.448 1-1 1zm0 6c-.552 0-1-.448-1-1 0-.552.448-1 1-1 .552 0 1 .448 1 1 0 .552-.448 1-1 1zm0 6c-.552 0-1-.447-1-1 0-.553.448-1 1-1 .552 0 1 .447 1 1 0 .553-.448 1-1 1z"],"more-adr_28":["M13 14c0-.55228475.44771525-1 1-1 .55228475 0 1 .44771525 1 1 0 .55228475-.44771525 1-1 1-.55228475 0-1-.44771525-1-1zm0 7c0-.5522847.44771525-1 1-1 .55228475 0 1 .4477153 1 1 0 .5522847-.44771525 1-1 1-.55228475 0-1-.4477153-1-1zm0-14c0-.55228475.44771525-1 1-1 .55228475 0 1 .44771525 1 1 0 .55228475-.44771525 1-1 1-.55228475 0-1-.44771525-1-1z"],"more-android_12":["M6 3c-.553 0-1-.447-1-1 0-.553.447-1 1-1 .553 0 1 .447 1 1 0 .553-.447 1-1 1zm0 4c-.553 0-1-.447-1-1 0-.553.447-1 1-1 .553 0 1 .447 1 1 0 .553-.447 1-1 1zm0 4c-.553 0-1-.447-1-1 0-.553.447-1 1-1 .553 0 1 .447 1 1 0 .553-.447 1-1 1z"],"more-android_16":["M9 2c0 .552-.447 1-1 1-.553 0-1-.448-1-1 0-.552.447-1 1-1 .553 0 1 .448 1 1zm0 6c0 .552-.447 1-1 1-.553 0-1-.448-1-1 0-.552.447-1 1-1 .553 0 1 .448 1 1zm0 6c0 .552-.447 1-1 1-.553 0-1-.448-1-1 0-.552.447-1 1-1 .553 0 1 .448 1 1z"],"more-android_20":["M10.0022 4.9978c-.553 0-1-.448-1-1 0-.552.447-1 1-1 .553 0 1 .448 1 1 0 .552-.447 1-1 1zm0 6.0007c-.553 0-1-.448-1-1 0-.552.447-1 1-1 .553 0 1 .448 1 1 0 .552-.447 1-1 1zm0 6.0037c-.553 0-1-.448-1-1 0-.552.447-1 1-1 .553 0 1 .448 1 1 0 .552-.447 1-1 1z"],"more-android_24":["M12 7c-.552 0-1-.448-1-1 0-.552.448-1 1-1 .552 0 1 .448 1 1 0 .552-.448 1-1 1zm0 6c-.552 0-1-.448-1-1 0-.552.448-1 1-1 .552 0 1 .448 1 1 0 .552-.448 1-1 1zm0 6c-.552 0-1-.447-1-1 0-.553.448-1 1-1 .552 0 1 .447 1 1 0 .553-.448 1-1 1z"],"more-android_28":["M13 14c0-.55228475.44771525-1 1-1 .55228475 0 1 .44771525 1 1 0 .55228475-.44771525 1-1 1-.55228475 0-1-.44771525-1-1zm0 7c0-.5522847.44771525-1 1-1 .55228475 0 1 .4477153 1 1 0 .5522847-.44771525 1-1 1-.55228475 0-1-.4477153-1-1zm0-14c0-.55228475.44771525-1 1-1 .55228475 0 1 .44771525 1 1 0 .55228475-.44771525 1-1 1-.55228475 0-1-.44771525-1-1z"],"more-circle_12":["M6 0c3.309 0 6 2.691 6 6 0 3.309-2.691 6-6 6-3.309 0-6-2.691-6-6 0-3.309 2.691-6 6-6zm0 11c2.757 0 5-2.243 5-5 0-2.757-2.243-5-5-5-2.757 0-5 2.243-5 5 0 2.757 2.243 5 5 5zM3 5c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm3 0c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm3 0c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1z"],"more-circle_16":["M8 15c3.8659932 0 7-3.1340068 7-7 0-3.86599325-3.1340068-7-7-7-3.86599325 0-7 3.13400675-7 7 0 3.8659932 3.13400675 7 7 7zm0 1c-4.418278 0-8-3.581722-8-8 0-4.418278 3.581722-8 8-8 4.418278 0 8 3.581722 8 8 0 4.418278-3.581722 8-8 8zM4 9c.55228475 0 1-.44771525 1-1 0-.55228475-.44771525-1-1-1-.55228475 0-1 .44771525-1 1 0 .55228475.44771525 1 1 1zm4 0c.55228475 0 1-.44771525 1-1 0-.55228475-.44771525-1-1-1-.55228475 0-1 .44771525-1 1 0 .55228475.44771525 1 1 1zm4 0c.5522847 0 1-.44771525 1-1 0-.55228475-.4477153-1-1-1-.5522847 0-1 .44771525-1 1 0 .55228475.4477153 1 1 1z"],"mouse-cursor_16":["M7.4736 9.7387c-.019.003-.033.016-.051.02-.028.007-.056.007-.084.019-.015.007-.024.02-.039.028-.011.007-.024.007-.035.014l-3.222 2.202.41-9.41 6.958 6.543-3.937.584zm5.375-.604l-8.506-7.999c-.142-.133-.35-.173-.531-.098-.181.073-.303.246-.311.441l-.5 11.498c-.008.189.091.366.256.458.076.043.16.064.243.064.099 0 .198-.03.283-.087l3.557-2.432 1.706 3.727c.084.183.265.292.455.292.069 0 .14-.015.207-.045.251-.115.362-.412.247-.663l-1.676-3.661 4.3-.637c.19-.027.347-.162.404-.345.058-.182.005-.383-.134-.513z"],"move-call-in-adr_12":["M10.4995 5.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-2.793 0 1.146 1.147c.196.195.196.511 0 .707-.097.097-.225.146-.353.146-.128 0-.256-.049-.354-.146l-1.999-2c-.047-.046-.084-.101-.109-.163-.05-.122-.05-.26 0-.382.025-.061.062-.117.109-.163l1.999-1.999c.196-.196.512-.196.707 0 .196.195.196.511 0 .707L7.7065 5.5l2.793 0zM8.5 10c.275 0 .5.225.5.5 0 .827-.673 1.5-1.5 1.5l-5 0c-.827 0-1.5-.673-1.5-1.5l0-9C1 .673 1.673 0 2.5 0l5 0C8.327 0 9 .673 9 1.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276-.224-.5-.5-.5l-5 0c-.276 0-.5.224-.5.5L2 9l0 1 0 .5c0 .276.224.5.5.5l5 0c.276 0 .5-.224.5-.5 0-.275.225-.5.5-.5zm-4-8l1 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5z"],"move-call-in-adr_16":["M13.5 7.5c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-4.793 0 2.147 2.146c.195.196.195.512 0 .708-.098.097-.226.146-.354.146-.128 0-.256-.049-.354-.146l-3-3c-.195-.196-.195-.512 0-.708l3-3c.196-.195.512-.195.708 0 .195.196.195.512 0 .708L8.707 7.5l4.793 0zM5.5 2l1 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm2.5.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5zm3.5.5c-.275 0-.5-.225-.5-.5l0-.5c0-.552-.448-1-1-1L4 1c-.552 0-1 .448-1 1l0 12c0 .552.448 1 1 1l6 0c.552 0 1-.448 1-1l0-.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 .5c0 1.104-.896 2-2 2l-6 0c-1.104 0-2-.896-2-2L2 2c0-1.104.896-2 2-2l6 0c1.104 0 2 .896 2 2l0 .5c0 .275-.225.5-.5.5z"],"move-call-in-adr_18":["M16.5 8.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-5.793 0 2.146 2.147c.196.195.196.511 0 .707-.097.097-.225.146-.353.146-.128 0-.256-.049-.354-.146l-2.999-3c-.047-.046-.084-.101-.109-.163-.05-.122-.05-.26 0-.382.025-.061.062-.117.109-.163l2.999-2.999c.196-.196.512-.196.707 0 .196.195.196.511 0 .707L10.707 8.5l5.793 0zm-4 5.5c.275 0 .5.225.5.5l0 .542 0 .458 0 .427C13 17.07 12.07 18 10.927 18l-7.854 0C1.93 18 1 17.07 1 15.927L1 2.073C1 .93 1.93 0 3.073 0l7.854 0C12.07 0 13 .93 13 2.073L13 3.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-1.427C12 1.481 11.519 1 10.927 1L3.073 1C2.481 1 2 1.481 2 2.073L2 13l0 1 0 1.927C2 16.519 2.481 17 3.073 17l7.854 0c.592 0 1.073-.481 1.073-1.073l0-.427 0-.458 0-.542c0-.275.225-.5.5-.5zM5 3l2 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L5 4c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5zm3.5.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5 0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5z"],"move-call-in-adr_20":["M18.5 9.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-6.793 0 3.147 3.146c.195.196.195.512 0 .708-.196.195-.512.195-.708 0l-3.999-4c-.046-.046-.083-.102-.109-.163-.05-.122-.05-.26 0-.382.026-.061.063-.117.109-.163l3.999-4c.098-.097.226-.146.354-.146.128 0 .256.049.354.146.195.196.195.512 0 .708L11.707 9.5l6.793 0zm-4 6.5c.275 0 .5.225.5.5l0 1c0 1.381-1.119 2.5-2.5 2.5l-9 0C2.119 20 1 18.881 1 17.5l0-15C1 1.119 2.119 0 3.5 0l9 0C13.881 0 15 1.119 15 2.5l0 1c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-1c0-.827-.673-1.5-1.5-1.5l-9 0C2.673 1 2 1.673 2 2.5l0 15c0 .827.673 1.5 1.5 1.5l9 0c.827 0 1.5-.673 1.5-1.5l0-1c0-.275.225-.5.5-.5zm-9-13l3 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-3 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5zm4.5.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5 0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5z"],"move-call-in-adr_24":["M21.5 11.4971c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-8.797 0 4.151 4.146c.195.195.195.512 0 .708-.098.097-.226.146-.354.146-.128 0-.256-.049-.354-.146l-5-4.995c-.098-.098-.146-.227-.146-.356l0-.003c0-.065.014-.13.039-.192.023-.056.059-.106.1-.149.004-.004.005-.009.007-.013l5-4.995c.196-.194.512-.194.708.001.195.196.195.512 0 .707l-4.145 4.141 8.791 0zM6.5 3l4 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-4 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5zm6.5.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5 0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5zM17.5 20c.275 0 .5.225.5.5l0 1c0 1.381-1.119 2.5-2.5 2.5l-11 0C3.119 24 2 22.881 2 21.5l0-19C2 1.119 3.119 0 4.5 0l11 0C16.881 0 18 1.119 18 2.5l0 1c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-1c0-.829-.672-1.5-1.5-1.5l-11 0C3.672 1 3 1.671 3 2.5L3 19l0 1 0 1.5c0 .827.673 1.5 1.5 1.5l11 0c.827 0 1.5-.673 1.5-1.5l0-1c0-.275.225-.5.5-.5z"],"move-call-in-adr_28":["M25.5 13.4995c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-10.794 0 5.148 5.151c.194.196.194.512 0 .707-.099.098-.227.147-.354.147-.128 0-.256-.049-.354-.147l-5.999-6.004c-.047-.046-.084-.101-.109-.163-.051-.122-.051-.26 0-.382.025-.061.062-.117.109-.163l5.999-6.003c.195-.196.512-.196.708 0 .194.195.194.511 0 .707l-5.148 5.15 10.794 0zM19.5 23c.275 0 .5.225.5.5l0 .5c0 1.654-1.346 3-3 3L5 27c-1.654 0-3-1.346-3-3L2 4c0-1.654 1.346-3 3-3l12 0c1.654 0 3 1.346 3 3l0 .5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-.5c0-1.103-.897-2-2-2L5 2c-1.103 0-2 .897-2 2l0 20c0 1.103.897 2 2 2l12 0c1.103 0 2-.897 2-2l0-.5c0-.275.225-.5.5-.5zM7.5 5l4 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-4 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5zm6.5.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5 0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5z"],"move-call-in-iph_12":["M10.4995 4.9998c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-2.793 0 1.146 1.147c.196.195.196.511 0 .707-.097.097-.225.146-.353.146-.128 0-.256-.049-.354-.146l-1.999-2c-.047-.046-.084-.101-.109-.163-.05-.122-.05-.26 0-.382.025-.061.062-.117.109-.163l1.999-1.999c.196-.196.512-.196.707 0 .196.195.196.511 0 .707l-1.146 1.146 2.793 0zm-1.9995 4c.276 0 .5.224.5.5l0 1c0 .827-.673 1.5-1.5 1.5l-5 0c-.827 0-1.5-.673-1.5-1.5l0-9c0-.827.673-1.5 1.5-1.5l5 0c.827 0 1.5.673 1.5 1.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276-.224-.5-.5-.5l-5 0c-.276 0-.5.224-.5.5l0 7.5 6.5 0zm-.5 1.5l0-.5-6 0 0 .5c0 .276.224.5.5.5l5 0c.276 0 .5-.224.5-.5z"],"move-call-in-iph_16":["M13.5 6c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L8.707 7l2.147 2.146c.195.196.195.512 0 .708-.098.097-.226.146-.354.146-.128 0-.256-.049-.354-.146l-3-3c-.195-.196-.195-.512 0-.708l3-3c.196-.195.512-.195.708 0 .195.196.195.512 0 .708L8.707 6 13.5 6zM10 16l-6 0c-1.103 0-2-.897-2-2L2 2c0-1.103.897-2 2-2l6 0c.845 0 1.603.537 1.886 1.335.092.26-.044.546-.304.638-.26.091-.546-.044-.639-.304C10.801 1.269 10.422 1 10 1L4 1c-.551 0-1 .449-1 1l0 9 8.5 0c.276 0 .5.224.5.5l0 2.5c0 1.103-.897 2-2 2zm-7-4l0 2c0 .551.449 1 1 1l6 0c.551 0 1-.449 1-1l0-2-8 0zm3.5 2c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0z"],"move-call-in-iph_18":["M13.5 12.9996c.276 0 .5.224.5.5l0 2.427c0 1.143-.93 2.073-2.073 2.073l-7.854 0c-1.143 0-2.073-.93-2.073-2.073l0-13.854c0-1.143.93-2.073 2.073-2.073l7.854 0c1.143 0 2.073.93 2.073 2.073l0 1.427c0 .277-.224.5-.5.5-.276 0-.5-.223-.5-.5l0-1.427c0-.591-.481-1.073-1.073-1.073l-7.854 0C3.481.9996 3 1.4816 3 2.0726l0 10.927 10.5 0zm-.5 2.927l0-1.927-10 0 0 1.927c0 .592.481 1.073 1.073 1.073l7.854 0c.592 0 1.073-.481 1.073-1.073zm-1.293-7.9268l3.793 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-3.793 0 2.146 2.147c.196.195.196.511 0 .707-.097.097-.225.146-.353.146-.128 0-.256-.049-.354-.146l-2.999-3c-.047-.046-.084-.101-.109-.163-.05-.122-.05-.26 0-.382.025-.061.062-.117.109-.163l2.999-2.999c.196-.196.512-.196.707 0 .196.195.196.511 0 .707l-2.146 2.146zm-4.207 8c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0z"],"move-call-in-iph_20":["M14.5 14.9998c.275 0 .5.225.5.5l0 1 0 1c0 1.381-1.119 2.5-2.5 2.5l-9 0c-1.381 0-2.5-1.119-2.5-2.5l0-15c0-1.381 1.119-2.5 2.5-2.5l9 0c1.381 0 2.5 1.119 2.5 2.5l0 1c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-1c0-.827-.673-1.5-1.5-1.5l-9 0c-.827 0-1.5.673-1.5 1.5l0 12.5 12.5 0zm-.5 1.5l0-.5-12 0 0 1.5c0 .827.673 1.5 1.5 1.5l9 0c.827 0 1.5-.673 1.5-1.5l0-1zm4.5-7.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-6.793 0 3.147 3.146c.195.196.195.512 0 .708-.196.195-.512.195-.708 0l-3.999-4c-.046-.046-.083-.102-.109-.163-.05-.122-.05-.26 0-.382.026-.061.063-.117.109-.163l3.999-4c.098-.097.226-.146.354-.146.128 0 .256.049.354.146.195.196.195.512 0 .708l-3.147 3.146 6.793 0zm-11 9c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0z"],"move-call-in-iph_24":["M21.5 10.9998c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-8.797 0 4.151 4.146c.195.195.195.512 0 .708-.098.097-.226.146-.354.146-.128 0-.256-.049-.354-.146l-5-4.995c-.098-.098-.146-.227-.146-.356l0-.003c0-.065.014-.13.039-.192.023-.056.059-.106.1-.149.004-.004.005-.009.007-.013l5-4.995c.196-.194.512-.194.708.001.195.196.195.512 0 .707l-4.145 4.141 8.791 0zm-4 8c.276 0 .5.224.5.5l0 2c0 1.381-1.119 2.5-2.5 2.5l-11 0c-1.381 0-2.5-1.119-2.5-2.5l0-19c0-1.38 1.119-2.5 2.5-2.5l11 0c1.381 0 2.5 1.12 2.5 2.5l0 1c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-1c0-.828-.672-1.5-1.5-1.5l-11 0c-.828 0-1.5.672-1.5 1.5l0 16.5 14.5 0zm-.5 2.5l0-1.5-14 0 0 1.5c0 .827.673 1.5 1.5 1.5l11 0c.827 0 1.5-.673 1.5-1.5zm-7.5.5c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0z"],"move-call-in-iph_28":["M25.5 12.0039c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-10.794 0 5.148 5.151c.194.196.194.512 0 .707-.099.098-.227.147-.354.147-.128 0-.256-.049-.354-.147l-5.999-6.004c-.047-.046-.084-.101-.109-.163-.051-.122-.051-.26 0-.382.025-.061.062-.117.109-.163l5.999-6.003c.195-.196.512-.196.708 0 .194.195.194.511 0 .707l-5.148 5.15 10.794 0zM19.5 21c.276 0 .5.224.5.5l0 2.5c0 1.654-1.346 3-3 3L5 27c-1.654 0-3-1.346-3-3L2 4c0-1.654 1.346-3 3-3l12 0c1.418 0 2.653 1.009 2.939 2.399.055.27-.119.535-.389.59-.268.053-.535-.118-.591-.389C18.77 2.673 17.945 2 17 2L5 2c-1.103 0-2 .897-2 2l0 17 16.5 0zm-.5 3l0-2-16 0 0 2c0 1.103.897 2 2 2l12 0c1.103 0 2-.897 2-2zm-8.5.5c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0z"],"move-call-in-laptop_12":["M11.5002 7.991c.276 0 .5.224.5.5l0 .5c0 1.103-.897 2-2 2l-8 0c-1.104 0-2-.897-2-2l0-.5c0-.276.224-.5.5-.5l.5 0 0-5.5c0-.827.673-1.5 1.5-1.5l7 0c.827 0 1.5.673 1.5 1.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.275-.224-.5-.5-.5l-7 0c-.276 0-.5.225-.5.5l0 5.5 8 0 0-.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 .5.5 0zm-1.5 2c.551 0 1-.448 1-1l-10 0c0 .552.449 1 1 1l8 0zM8.844 3.345L7.706 4.483l3.794 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-3.794 0 1.151 1.152c.196.194.196.51 0 .707-.097.096-.225.145-.353.145-.128 0-.256-.049-.354-.145L6.146 5.337c-.047-.046-.084-.101-.109-.163-.049-.122-.049-.26 0-.382.025-.061.062-.117.109-.163l1.991-1.991c.196-.196.512-.196.707 0 .196.195.196.511 0 .707z"],"move-call-in-laptop_16":["M15.4998 11c.276 0 .5.224.5.5l0 .5c0 1.105-.895 2-2 2l-12 0c-1.104 0-2-.895-2-2l0-.5c0-.276.224-.5.5-.5l.5 0 0-7c0-1.105.896-2 2-2l10 0c1.105 0 2 .895 2 2l0 .5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-.5c0-.551-.449-1-1-1l-10 0c-.551 0-1 .449-1 1l0 7 12 0 0-1.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 1.5.5 0zm-1.5 2c.551 0 1-.449 1-1l-14 0c0 .551.449 1 1 1l12 0zm-1.6465-8.1465l-1.646 1.646 4.792 0c.277 0 .5.224.5.5 0 .277-.223.5-.5.5l-4.792 0 1.646 1.647c.195.195.195.512 0 .707-.098.098-.226.146-.354.146-.127 0-.255-.048-.353-.146l-2.5-2.5c-.195-.195-.195-.512 0-.707l2.5-2.5c.195-.195.512-.195.707 0 .195.195.195.512 0 .707z"],"move-call-in-laptop_18":["M17.5002972 12c.2760016 0 .5000028.224.5000028.5l0 1c0 1.378-1.1220062 2.5-2.5000139 2.5L2.50021389 16C1.12120623 16 .0002 14.878.0002 13.5l0-1c0-.276.224001244-.5.500002778-.5l.500002782 0 0-8c0-1.054.82000455-1.91 1.8550103-1.985.05500031-.009.10500058-.015.14500081-.015L14.5002806 2l.5000027 0c.0400003 0 .0900005.006.1450008.015 1.0340058.075 1.8550103.931 1.8550103 1.985l0 .5 0 .5 0 .5c0 .276-.2240012.5-.5000027.5-.2760016 0-.5000028-.224-.5000028-.5l0-.5 0-.5 0-.5c0-.551-.4490025-1-1.0000056-1l-.5000027 0L3.00021667 3c-.55200307 0-1.00000556.449-1.00000556 1l0 8 14.00007779 0 0-2.5c0-.276.2240012-.5.5000028-.5.2760015 0 .5000027.224.5000027.5l0 2.5.5000028 0zM17.0002 13.5l0-.5-16 0 0 .5c0 .827.673 1.5 1.5 1.5l13 0c.827 0 1.5-.673 1.5-1.5zm-3.1469-8.6465l-2.147 2.146 5.794 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-5.794 0 2.147 2.146c.195.196.195.512 0 .708-.196.195-.512.195-.708 0l-2.999-3c-.046-.046-.083-.102-.109-.163-.05-.122-.05-.26 0-.382.026-.06.063-.117.109-.163l2.999-3c.098-.097.226-.146.354-.146.128 0 .256.049.354.146.195.196.195.512 0 .708z"],"move-call-in-laptop_20":["M14.8538 4.8445l-3.145 3.141 7.791 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-7.797 0 3.151 3.146c.195.195.195.512 0 .708-.098.097-.226.146-.354.146-.127 0-.256-.049-.354-.146l-4-3.995c-.098-.098-.146-.227-.146-.356l0-.003c0-.065.013-.13.04-.192.022-.056.057-.106.098-.149.004-.004.005-.009.008-.013l4-3.995c.196-.194.512-.194.708.001.195.196.195.512 0 .707zm4.6464 9.1463c.276 0 .5.224.5.5l0 .778c0 1.501-1.222 2.722-2.723 2.722l-14.555 0c-1.501 0-2.722-1.221-2.722-2.722l0-.778c0-.276.224-.5.5-.5l.5 0 0-9.833c0-.921.579-1.704 1.391-2.017.216-.092.47-.15.609-.15l14 0c.139 0 .392.058.609.15.811.313 1.391 1.096 1.391 2.017l0 1.333 0 1c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-1 0-1.333c0-.643-.523-1.167-1.167-1.167l-13.666 0c-.644 0-1.167.524-1.167 1.167l0 9.833 16 0 0-2 0-1.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 1.5 0 2 .5 0zm-.5 1.278l0-.278-18 0 0 .278c0 .95.772 1.722 1.722 1.722l14.555 0c.951 0 1.723-.772 1.723-1.722z"],"move-call-in-laptop_24":["M23.5002 15.991c.275 0 .5.224.5.5l0 1c0 1.93-1.57 3.5-3.5 3.5l-17 0c-1.931 0-3.5-1.57-3.5-3.5l0-1c0-.276.224-.5.5-.5l1.5 0 0-10.5c0-1.378 1.121-2.499 2.498-2.5l.001 0 15.001 0 .002 0c.002 0 .007.001.01.001 1.372.007 2.488 1.124 2.488 2.499l0 .999 0 .001 0 1c0 .275-.226.5-.5.5-.275 0-.5-.225-.5-.5l0-.646 0-1.354c0-.827-.674-1.5-1.5-1.5l-15 0c-.827 0-1.5.673-1.5 1.5l0 10.5 18 0 0-2.812 0-.688c0-.275.225-.5.5-.5.274 0 .5.225.5.5l0 2 0 .001 0 1.499 1.5 0zm-.5 1.5l0-.5-22 0 0 .5c0 1.379 1.122 2.5 2.5 2.5l17 0c1.378 0 2.5-1.121 2.5-2.5zM16.8528 6.3406l-3.146 3.15 9.793 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-9.793 0 3.146 3.151c.195.196.195.512 0 .707-.098.098-.226.147-.353.147-.127 0-.255-.049-.354-.147l-3.998-4.004c-.048-.046-.085-.101-.109-.163-.051-.122-.051-.26 0-.382.024-.061.061-.117.109-.163l3.998-4.003c.195-.196.513-.196.707 0 .195.195.195.511 0 .707z"],"move-call-in-laptop_28":["M27.5002 19.9907c.276 0 .5.224.5.5l0 .889c0 1.991-1.62 3.611-3.611 3.611l-20.778 0c-1.991 0-3.611-1.62-3.611-3.611l0-.889c0-.276.224-.5.5-.5l1.5 0 0-14.166c0-1.563 1.271-2.834 2.834-2.834l18.332 0c1.563 0 2.834 1.271 2.834 2.834l0 2.666 0 1 0 .042-.009 0c-.022.255-.231.458-.491.458-.261 0-.47-.203-.492-.458l-.008 0 0-.042 0-1 0-2.666c0-1.011-.822-1.834-1.834-1.834l-18.332 0c-1.012 0-1.834.823-1.834 1.834l0 14.166 22 0 0-3.5 0-1.729 0-.271c0-.275.225-.5.5-.5.274 0 .5.225.5.5l0 .271 0 1.729 0 3.5 1.5 0zm-.5 1.389l0-.389-26 0 0 .389c0 1.44 1.172 2.611 2.611 2.611l20.778 0c1.439 0 2.611-1.171 2.611-2.611zM19.8538 6.3406l-5.147 5.15 12.793 0c.277 0 .5.224.5.5 0 .276-.223.5-.5.5l-12.793 0 5.147 5.151c.194.196.194.512 0 .707-.099.098-.227.147-.354.147-.127 0-.255-.049-.353-.147l-5.999-6.004c-.048-.046-.085-.101-.109-.163-.051-.122-.051-.26 0-.382.024-.061.061-.117.109-.163l5.999-6.003c.194-.196.512-.196.707 0 .194.195.194.511 0 .707z"],"move-call-in-tablet_12":["M11.4998 4.9998c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-2.793 0 1.146 1.147c.196.195.196.511 0 .707-.097.097-.225.146-.353.146-.128 0-.256-.049-.354-.146l-1.999-2c-.047-.046-.084-.101-.109-.163-.05-.122-.05-.26 0-.382.025-.061.062-.117.109-.163l1.999-1.999c.196-.196.512-.196.707 0 .196.195.196.511 0 .707l-1.146 1.146 2.793 0zm-1.9996 4c.276 0 .5.224.5.5l0 1c0 .827-.673 1.5-1.5 1.5l-7 0c-.827 0-1.5-.673-1.5-1.5l0-9c0-.827.673-1.5 1.5-1.5l7 0c.827 0 1.5.673 1.5 1.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276-.224-.5-.5-.5l-7 0c-.276 0-.5.224-.5.5l0 7.5 8.5 0zm-.5 1.5l0-.5-8 0 0 .5c0 .276.224.5.5.5l7 0c.276 0 .5-.224.5-.5z"],"move-call-in-tablet_18":["M13 15.927c0 .592-.481 1.073-1.073 1.073l-9.854 0C1.481 17 1 16.519 1 15.927L1 14l12 0 0 1.927zM13.5 13c.276 0 .5.224.5.5l0 2.427C14 17.07 13.07 18 11.927 18l-9.854 0C.93 18 0 17.07 0 15.927L0 2.073C0 .93.93 0 2.073 0l9.854 0C13.07 0 14 .93 14 2.073L14 3.5c0 .277-.224.5-.5.5-.276 0-.5-.223-.5-.5l0-1.427C13 1.482 12.519 1 11.927 1L2.073 1C1.481 1 1 1.482 1 2.073L1 13l12.5 0zm-1.793-4.9997l5.793 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-5.793 0 2.146 2.147c.196.195.196.511 0 .707-.097.097-.225.146-.353.146-.128 0-.256-.049-.354-.146l-2.999-3c-.047-.046-.084-.101-.109-.163-.05-.122-.05-.26 0-.382.025-.061.062-.117.109-.163l2.999-2.999c.196-.196.512-.196.707 0 .196.195.196.511 0 .707l-2.146 2.146zm-5.207 8l1 0c.275 0 .5-.225.5-.5 0-.275-.225-.5-.5-.5l-1 0c-.275 0-.5.225-.5.5 0 .275.225.5.5.5z"],"move-call-in-tablet_20":["M15.0002 16.4998l0 1c0 .827-.673 1.5-1.5 1.5l-11 0c-.827 0-1.5-.673-1.5-1.5l0-1.5 14 0 0 .5zm.5-1.5c.275 0 .5.225.5.5l0 1 0 1c0 1.381-1.119 2.5-2.5 2.5l-11 0c-1.381 0-2.5-1.119-2.5-2.5l0-15c0-1.381 1.119-2.5 2.5-2.5l11 0c1.381 0 2.5 1.119 2.5 2.5l0 1c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-1c0-.827-.673-1.5-1.5-1.5l-11 0c-.827 0-1.5.673-1.5 1.5l0 12.5 14.5 0zm4-6c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-6.793 0 3.147 3.146c.195.196.195.512 0 .708-.196.195-.512.195-.708 0l-3.999-4c-.046-.046-.083-.102-.109-.163-.05-.122-.05-.26 0-.382.026-.061.063-.117.109-.163l3.999-4c.098-.097.226-.146.354-.146.128 0 .256.049.354.146.195.196.195.512 0 .708l-3.147 3.146 6.793 0zm-12 9l1 0c.275 0 .5-.225.5-.5 0-.275-.225-.5-.5-.5l-1 0c-.275 0-.5.225-.5.5 0 .275.225.5.5.5z"],"move-call-in-tablet_24":["M22.5002 10.9998c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-8.797 0 4.151 4.146c.195.195.195.512 0 .708-.098.097-.226.146-.354.146-.128 0-.256-.049-.354-.146l-5-4.995c-.098-.098-.146-.227-.146-.356l0-.003c0-.065.014-.13.039-.192.023-.056.059-.106.1-.149.004-.004.005-.009.007-.013l5-4.995c.196-.194.512-.194.708.001.195.196.195.512 0 .707l-4.145 4.141 8.791 0zm-4 8c.276 0 .5.224.5.5l0 2c0 1.381-1.119 2.5-2.5 2.5l-13 0c-1.381 0-2.5-1.119-2.5-2.5l0-19c0-1.381 1.119-2.5 2.5-2.5l13 0c1.381 0 2.5 1.119 2.5 2.5l0 1c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-1c0-.828-.672-1.5-1.5-1.5l-13 0c-.828 0-1.5.672-1.5 1.5l0 16.5 16.5 0zm-.5 2.5l0-1.5-16 0 0 1.5c0 .827.673 1.5 1.5 1.5l13 0c.827 0 1.5-.673 1.5-1.5zm-8.5.5c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0z"],"move-call-in-tablet_28":["M26.5002 12.0037c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-10.794 0 5.148 5.151c.194.196.194.512 0 .707-.099.098-.227.147-.354.147-.128 0-.256-.049-.354-.147l-5.999-6.004c-.047-.046-.084-.101-.109-.163-.051-.122-.051-.26 0-.382.025-.061.062-.117.109-.163l5.999-6.003c.195-.196.512-.196.708 0 .194.195.194.511 0 .707l-5.148 5.15 10.794 0zm-6 8.9961c.276 0 .5.224.5.5l0 2.5c0 1.654-1.346 3-3 3l-14 0c-1.654 0-3-1.346-3-3l0-20c0-1.654 1.346-3 3-3l14 0c1.418 0 2.653 1.009 2.939 2.399.055.27-.119.535-.389.59-.268.053-.535-.118-.591-.389-.189-.927-1.014-1.6-1.959-1.6l-14 0c-1.103 0-2 .897-2 2l0 17 18.5 0zm-.5 3l0-2-18 0 0 2c0 1.103.897 2 2 2l14 0c1.103 0 2-.897 2-2zm-9.5.5c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0z"],"move-call-out-adr_12":["M10.9619 5.8091c.05.122.05.26 0 .382-.025.061-.062.117-.109.163l-1.999 1.999c-.196.196-.512.196-.707 0-.196-.195-.196-.511 0-.707l1.146-1.146-2.793 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l2.793 0-1.146-1.147c-.196-.195-.196-.511 0-.707.097-.097.225-.146.353-.146.128 0 .256.049.354.146l1.999 2c.047.046.084.101.109.163zM8.5 10c.275 0 .5.225.5.5 0 .827-.673 1.5-1.5 1.5l-5 0c-.827 0-1.5-.673-1.5-1.5l0-9C1 .673 1.673 0 2.5 0l5 0C8.327 0 9 .673 9 1.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276-.224-.5-.5-.5l-5 0c-.276 0-.5.224-.5.5L2 9l0 1 0 .5c0 .276.224.5.5.5l5 0c.276 0 .5-.224.5-.5 0-.275.225-.5.5-.5zm-4-8l1 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5z"],"move-call-out-adr_16":["M7.5 8.5c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l4.793 0-2.147-2.146c-.195-.196-.195-.512 0-.708.098-.097.226-.146.354-.146.128 0 .256.049.354.146l3 3c.195.196.195.512 0 .708l-3 3c-.196.195-.512.195-.708 0-.195-.196-.195-.512 0-.708L12.293 8.5 7.5 8.5zM5.5 2l1 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm2.5.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5zm3.5.5c-.275 0-.5-.225-.5-.5l0-.5c0-.552-.448-1-1-1L4 1c-.552 0-1 .448-1 1l0 12c0 .552.448 1 1 1l6 0c.552 0 1-.448 1-1l0-.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 .5c0 1.104-.896 2-2 2l-6 0c-1.104 0-2-.896-2-2L2 2c0-1.104.896-2 2-2l6 0c1.104 0 2 .896 2 2l0 .5c0 .275-.225.5-.5.5z"],"move-call-out-adr_18":["M16.9624 8.8091c.05.122.05.26 0 .382-.025.061-.062.117-.109.163l-2.999 2.999c-.196.196-.512.196-.707 0-.196-.195-.196-.511 0-.707l2.146-2.146-5.793 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l5.793 0-2.146-2.147c-.196-.195-.196-.511 0-.707.097-.097.225-.146.353-.146.128 0 .256.049.354.146l2.999 3c.047.046.084.101.109.163zM12.5 14c.275 0 .5.225.5.5l0 .542 0 .458 0 .427C13 17.07 12.07 18 10.927 18l-7.854 0C1.93 18 1 17.07 1 15.927L1 2.073C1 .93 1.93 0 3.073 0l7.854 0C12.07 0 13 .93 13 2.073L13 3.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-1.427C12 1.481 11.519 1 10.927 1L3.073 1C2.481 1 2 1.481 2 2.073L2 13l0 1 0 1.927C2 16.519 2.481 17 3.073 17l7.854 0c.592 0 1.073-.481 1.073-1.073l0-.427 0-.458 0-.542c0-.275.225-.5.5-.5zM5 3l2 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L5 4c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5zm3.5.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5 0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5z"],"move-call-out-adr_20":["M18.9624 9.8091c.05.122.05.26 0 .382-.026.061-.063.117-.109.163l-3.999 4c-.098.097-.226.146-.354.146-.128 0-.256-.049-.354-.146-.195-.196-.195-.512 0-.708l3.147-3.146-6.793 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l6.793 0-3.147-3.146c-.195-.196-.195-.512 0-.708.196-.195.512-.195.708 0l3.999 4c.046.046.083.102.109.163zM14.5 16c.275 0 .5.225.5.5l0 1c0 1.381-1.119 2.5-2.5 2.5l-9 0C2.119 20 1 18.881 1 17.5l0-15C1 1.119 2.119 0 3.5 0l9 0C13.881 0 15 1.119 15 2.5l0 1c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-1c0-.827-.673-1.5-1.5-1.5l-9 0C2.673 1 2 1.673 2 2.5l0 15c0 .827.673 1.5 1.5 1.5l9 0c.827 0 1.5-.673 1.5-1.5l0-1c0-.275.225-.5.5-.5zm-9-13l3 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-3 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5zm4.5.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5 0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5z"],"move-call-out-adr_24":["M21.8545 11.6441c.098.098.146.227.146.356l0 .003c0 .065-.013.13-.04.192-.022.056-.057.106-.098.149-.004.004-.005.009-.008.013l-5 4.995c-.196.194-.513.194-.708-.001-.195-.196-.195-.512 0-.707l4.145-4.141-8.791 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l8.796 0-4.15-4.146c-.195-.195-.195-.512 0-.708.098-.097.226-.146.354-.146.127 0 .255.049.354.146l5 4.995zM6.5 3l4 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-4 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5zm6.5.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5 0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5zM17.5 20c.275 0 .5.225.5.5l0 1c0 1.381-1.119 2.5-2.5 2.5l-11 0C3.119 24 2 22.881 2 21.5l0-19C2 1.12 3.119 0 4.5 0l11 0C16.881 0 18 1.12 18 2.5l0 1c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-1c0-.828-.672-1.5-1.5-1.5l-11 0C3.672 1 3 1.672 3 2.5L3 19l0 1 0 1.5c0 .827.673 1.5 1.5 1.5l11 0c.827 0 1.5-.673 1.5-1.5l0-1c0-.275.225-.5.5-.5z"],"move-call-out-adr_28":["M25.9619 13.8096c.051.122.051.26 0 .382-.025.061-.062.117-.109.163l-5.999 6.003c-.195.196-.512.196-.707 0-.195-.195-.195-.511 0-.707l5.147-5.15-10.794 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l10.794 0-5.147-5.151c-.195-.196-.195-.512 0-.707.098-.098.226-.147.353-.147.128 0 .256.049.354.147l5.999 6.004c.047.046.084.101.109.163zM19.5 23c.275 0 .5.225.5.5l0 .5c0 1.654-1.346 3-3 3L5 27c-1.654 0-3-1.346-3-3L2 4c0-1.654 1.346-3 3-3l12 0c1.654 0 3 1.346 3 3l0 .5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-.5c0-1.103-.897-2-2-2L5 2c-1.103 0-2 .897-2 2l0 20c0 1.103.897 2 2 2l12 0c1.103 0 2-.897 2-2l0-.5c0-.275.225-.5.5-.5zM7.5 5l4 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-4 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5zm6.5.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5 0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5z"],"move-call-out-iph_12":["M10.9619 5.3091c.05.122.05.26 0 .382-.025.061-.062.117-.109.163l-1.999 1.999c-.196.196-.512.196-.707 0-.196-.195-.196-.511 0-.707l1.146-1.146-2.793 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l2.793 0-1.146-1.147c-.196-.195-.196-.511 0-.707.097-.097.225-.146.353-.146.128 0 .256.049.354.146l1.999 2c.047.046.084.101.109.163zM8.5 9.0001c.276 0 .5.224.5.5l0 1c0 .827-.673 1.5-1.5 1.5l-5 0c-.827 0-1.5-.673-1.5-1.5l0-9c0-.827.673-1.5 1.5-1.5l5 0c.827 0 1.5.673 1.5 1.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276-.224-.5-.5-.5l-5 0c-.276 0-.5.224-.5.5l0 7.5 6.5 0zm-.5 1.5l0-.5-6 0 0 .5c0 .276.224.5.5.5l5 0c.276 0 .5-.224.5-.5z"],"move-call-out-iph_16":["M13.8535 6.1465c.195.195.195.512 0 .707l-3 3c-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147-.195-.195-.195-.512 0-.707l2.146-2.146-4.793 0c-.274 0-.5-.226-.5-.5 0-.275.226-.5.5-.5l4.793 0-2.146-2.147c-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0l3 3zM10 16l-6 0c-1.103 0-2-.897-2-2L2 2c0-1.103.897-2 2-2l6 0c.845 0 1.603.537 1.886 1.335.092.26-.044.546-.304.638-.26.091-.546-.044-.639-.304C10.801 1.269 10.422 1 10 1L4 1c-.551 0-1 .449-1 1l0 9 8.5 0c.276 0 .5.224.5.5l0 2.5c0 1.103-.897 2-2 2zm-7-4l0 2c0 .551.449 1 1 1l6 0c.551 0 1-.449 1-1l0-2-8 0zm3.5 2c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0z"],"move-call-out-iph_18":["M13 15.9268c0 .592-.481 1.073-1.073 1.073l-7.854 0c-.592 0-1.073-.481-1.073-1.073l0-1.927 10 0 0 1.927zm.5-2.927c.276 0 .5.224.5.5l0 2.427c0 1.143-.93 2.073-2.073 2.073l-7.854 0c-1.143 0-2.073-.93-2.073-2.073l0-13.854c0-1.143.93-2.073 2.073-2.073l7.854 0c1.143 0 2.073.93 2.073 2.073l0 1.427c0 .277-.224.5-.5.5-.276 0-.5-.223-.5-.5l0-1.427c0-.591-.481-1.073-1.073-1.073l-7.854 0C3.481.9998 3 1.4818 3 2.0728l0 10.927 10.5 0zm2.4624-4.6907c.05.122.05.26 0 .382-.025.061-.062.117-.109.163l-2.999 2.999c-.196.196-.512.196-.707 0-.196-.195-.196-.511 0-.707l2.146-2.146-4.793 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l4.793 0-2.146-2.147c-.196-.195-.196-.511 0-.707.097-.097.225-.146.353-.146.128 0 .256.049.354.146l2.999 3c.047.046.084.101.109.163zM7.5 16.0001l1 0c.275 0 .5-.225.5-.5 0-.275-.225-.5-.5-.5l-1 0c-.275 0-.5.225-.5.5 0 .275.225.5.5.5z"],"move-call-out-iph_20":["M14 16.5001l0 1c0 .827-.673 1.5-1.5 1.5l-9 0c-.827 0-1.5-.673-1.5-1.5l0-1.5 12 0 0 .5zm.5-1.5c.275 0 .5.225.5.5l0 1 0 1c0 1.381-1.119 2.5-2.5 2.5l-9 0c-1.381 0-2.5-1.119-2.5-2.5l0-15c0-1.381 1.119-2.5 2.5-2.5l9 0c1.381 0 2.5 1.119 2.5 2.5l0 1c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-1c0-.827-.673-1.5-1.5-1.5l-9 0c-.827 0-1.5.673-1.5 1.5l0 12.5 12.5 0zm4.4624-5.691c.05.122.05.26 0 .382-.026.061-.063.117-.109.163l-3.999 4c-.098.097-.226.146-.354.146-.128 0-.256-.049-.354-.146-.195-.196-.195-.512 0-.708l3.147-3.146-6.793 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l6.793 0-3.147-3.146c-.195-.196-.195-.512 0-.708.196-.195.512-.195.708 0l3.999 4c.046.046.083.102.109.163zM7.5 18.0001l1 0c.275 0 .5-.225.5-.5 0-.275-.225-.5-.5-.5l-1 0c-.275 0-.5.225-.5.5 0 .275.225.5.5.5z"],"move-call-out-iph_24":["M21.8545 11.1465c.098.098.146.227.146.356l0 .003c0 .065-.013.13-.04.192-.022.056-.057.106-.098.149-.004.004-.005.009-.008.013l-5 4.995c-.196.194-.513.194-.708-.001-.195-.196-.195-.512 0-.707l4.145-4.141-8.791 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l8.796 0-4.15-4.146c-.195-.195-.195-.512 0-.708.098-.097.226-.146.354-.146.127 0 .255.049.354.146l5 4.995zM17.5 19.0001c.276 0 .5.224.5.5l0 2c0 1.38-1.119 2.5-2.5 2.5l-11 0c-1.381 0-2.5-1.12-2.5-2.5l0-19c0-1.381 1.119-2.5 2.5-2.5l11 0c1.381 0 2.5 1.119 2.5 2.5l0 1c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-1c0-.829-.672-1.5-1.5-1.5l-11 0c-.828 0-1.5.671-1.5 1.5l0 16.5 14.5 0zm-.5 2.5l0-1.5-14 0 0 1.5c0 .827.673 1.5 1.5 1.5l11 0c.827 0 1.5-.673 1.5-1.5zm-7.5.5c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0z"],"move-call-out-iph_28":["M25.9619 12.314c.051.122.051.26 0 .382-.025.061-.062.117-.109.163l-5.999 6.003c-.195.196-.512.196-.707 0-.195-.195-.195-.511 0-.707l5.147-5.15-10.794 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l10.794 0-5.147-5.151c-.195-.196-.195-.512 0-.707.098-.098.226-.147.353-.147.128 0 .256.049.354.147l5.999 6.004c.047.046.084.101.109.163zM19.5 21.0001c.276 0 .5.224.5.5l0 2.5c0 1.654-1.346 3-3 3l-12 0c-1.654 0-3-1.346-3-3l0-20c0-1.654 1.346-3 3-3l12 0c1.418 0 2.653 1.009 2.939 2.399.055.27-.119.535-.389.59-.268.053-.535-.118-.591-.389-.189-.927-1.014-1.6-1.959-1.6l-12 0c-1.103 0-2 .897-2 2l0 17 16.5 0zm-.5 3l0-2-16 0 0 2c0 1.103.897 2 2 2l12 0c1.103 0 2-.897 2-2zm-8.5.5c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0z"],"move-call-out-laptop_12":["M9.4958 2.491c.128 0 .256.049.354.146l2.004 2.004c.047.046.084.101.109.163.05.123.05.26 0 .382-.025.062-.062.118-.109.163L9.8628 7.34c-.196.196-.512.196-.707 0-.196-.195-.196-.511 0-.707l1.138-1.138-2.794 0c-.276 0-.5-.224-.5-.5 0-.275.224-.5.5-.5l2.794 0-1.151-1.151c-.196-.195-.196-.511 0-.707.097-.097.225-.146.353-.146zm2.0044958 5.5c.2760023 0 .5000042.224.5000042.5l0 .5c0 1.103-.8970075 2-2.0000167 2l-8.00006663 0C.896207467 10.991.0002 10.094.0002 8.991l0-.5c0-.276.224001867-.5.500004167-.5l.500004163 0 0-5.5c0-.827.67300561-1.5 1.5000125-1.5l6.00005 0 1.00000834 0c.27500229 0 .50000413.225.50000413.5 0 .275-.22500184.5-.50000413.5l-1.00000834 0-6.00005 0c-.2760023 0-.50000416.225-.50000416.5l0 5.5 8.00006663 0 1.0000084 0 .5000041 0zm-1.5000958 2c.551 0 1-.448 1-1l-10 0c0 .552.449 1 1 1l8 0z"],"move-call-out-laptop_16":["M14.0001 13l-12 0c-.551 0-1-.449-1-1l14 0c0 .551-.449 1-1 1m1.5-2c.276 0 .5.224.5.5l0 .5c0 1.105-.895 2-2 2l-12 0c-1.105 0-2-.895-2-2l0-.5c0-.276.224-.5.5-.5l.5 0 0-7c0-1.105.895-2 2-2l10 0c.565 0 1.107.243 1.487.666.185.206.168.521-.038.706-.095.086-.215.128-.334.128-.136 0-.273-.056-.372-.166-.19-.212-.462-.334-.743-.334l-10 0c-.551 0-1 .449-1 1l0 7 12 0 0-.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 .5.5 0zm-2.5-7c.128 0 .256.049.354.146l2.5 2.5c.195.196.195.512 0 .708l-2.5 2.5c-.196.195-.512.195-.708 0-.195-.196-.195-.512 0-.708l1.647-1.646-4.793 0c-.277 0-.5-.224-.5-.5 0-.276.223-.5.5-.5l4.793 0-1.647-1.646c-.195-.196-.195-.512 0-.708.098-.097.226-.146.354-.146z"],"move-call-out-laptop_18":["M17.0002 13.491c0 .827-.673 1.5-1.5 1.5l-13 0c-.827 0-1.5-.673-1.5-1.5l0-.5 16 0 0 .5zm.5-1.5c.276 0 .5.224.5.5l0 1c0 1.378-1.122 2.5-2.5 2.5l-13 0c-1.379 0-2.5-1.122-2.5-2.5l0-1c0-.276.224-.5.5-.5l.5 0 0-8c0-1.054.82-1.91 1.855-1.985.055-.009.105-.015.145-.015l11.459 0 .5 0 .041 0c.014 0 .026.007.04.008.022.003.04.003.064.007.813.059 1.493.6 1.748 1.34.108.315-.134.645-.467.645-.208 0-.411-.119-.477-.315-.133-.398-.508-.685-.949-.685l-.5 0-11.459 0c-.552 0-1 .449-1 1l0 8 14 0 0-.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 .5.5 0zm-3.3535-7.854c.196-.195.512-.195.708 0l2.999 3c.046.046.083.102.109.163.05.122.05.26 0 .382-.026.061-.063.117-.109.163l-2.999 3c-.098.097-.226.146-.354.146-.128 0-.256-.049-.354-.146-.195-.196-.195-.512 0-.708l2.147-2.146-4.793 0c-.277 0-.5-.224-.5-.5 0-.276.223-.5.5-.5l4.793 0-2.147-2.146c-.195-.196-.195-.512 0-.708z"],"move-call-out-laptop_20":["M19.8538 8.1321c.098.098.146.227.146.356l0 .003c0 .065-.013.13-.039.192-.023.056-.058.106-.099.149-.004.004-.005.009-.008.013l-4 3.995c-.196.194-.512.194-.708-.001-.195-.196-.195-.512 0-.707l3.146-3.141-6.792 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l6.797 0-3.151-3.146c-.195-.195-.195-.512 0-.708.098-.097.227-.146.354-.146.128 0 .256.049.354.146l4 3.995zm-.3536 5.8587c.276 0 .5.224.5.5l0 .778c0 1.501-1.222 2.722-2.723 2.722l-14.555 0c-1.501 0-2.722-1.221-2.722-2.722l0-.778c0-.276.224-.5.5-.5l.5 0 0-9.833c0-.921.579-1.704 1.391-2.017.216-.092.47-.15.609-.15l14 0c.139 0 .392.058.609.15.811.313 1.391 1.096 1.391 2.017l0 .333c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-.333c0-.643-.523-1.167-1.167-1.167l-13.666 0c-.644 0-1.167.524-1.167 1.167l0 9.833 16 0 0-1.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 1.5.5 0zm-.5 1.278l0-.278-18 0 0 .278c0 .95.772 1.722 1.722 1.722l14.555 0c.951 0 1.723-.772 1.723-1.722z"],"move-call-out-laptop_24":["M23.0002 17.491c0 1.379-1.122 2.5-2.5 2.5l-17 0c-1.378 0-2.5-1.121-2.5-2.5l0-.5 22 0 0 .5zm.5-1.5c.275 0 .5.224.5.5l0 1c0 1.93-1.57 3.5-3.5 3.5l-17 0c-1.931 0-3.5-1.57-3.5-3.5l0-1c0-.276.224-.5.5-.5l1.5 0 0-10.5c0-1.378 1.121-2.499 2.498-2.5l.001 0 15.001 0 .002 0c.002 0 .007.001.01.001 1.372.007 2.488 1.124 2.488 2.499 0 .275-.226.5-.5.5-.275 0-.5-.225-.5-.5 0-.827-.674-1.5-1.5-1.5l-15 0c-.827 0-1.5.673-1.5 1.5l0 10.5 18 0 0 .188 0-.688c0-.275.225-.5.5-.5.274 0 .5.225.5.5l0 .5 1.5 0zm-4-10c.127 0 .256.049.354.147l3.999 4.004c.046.046.084.101.108.163.052.122.052.26 0 .382-.024.061-.062.117-.108.163l-3.999 4.003c-.196.196-.512.196-.708 0-.195-.195-.195-.511 0-.707l3.147-3.15-7.793 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l7.793 0-3.147-3.151c-.195-.196-.195-.512 0-.707.098-.098.226-.147.354-.147z"],"move-call-out-laptop_28":["M27.0002 21.3797c0 1.44-1.172 2.611-2.611 2.611l-20.778 0c-1.439 0-2.611-1.171-2.611-2.611l0-.389 26 0 0 .389zm.5002455-1.389c.2760025 0 .5000045.224.5000045.5l0 .889c0 1.991-1.6200145 3.611-3.6110322 3.611l-20.77818556 0C1.62021446 24.9907.0002 23.3707.0002 21.3797l0-.889c0-.276.224002-.5.500004464-.5l1.500013396 0 0-14.166c0-1.563 1.27101135-2.834 2.8340253-2.834l18.33216364 0c1.563014 0 2.8340253 1.271 2.8340253 2.834l0 .666 0 .042-.009 0c-.0220002.255-.2310021.458-.4910044.458-.2610024 0-.4700042-.203-.4920044-.458l-.0080001 0 0-.042 0-.666c0-1.011-.8220073-1.834-1.8340164-1.834l-18.33216364 0c-1.01200903 0-1.83401637.823-1.83401637 1.834l0 14.166 22.00019641 0 0-2.5c0-.275.225002-.5.5000045-.5.2740024 0 .5000044.225.5000044.5l0 2.5 1.5000134 0zM21.5002 5.4866c.128 0 .256.049.354.147l5.999 6.004c.046.046.084.101.109.163.051.122.051.26 0 .382-.025.061-.063.117-.109.163l-5.999 6.003c-.196.196-.512.196-.708 0-.195-.195-.195-.511 0-.707l5.148-5.15-10.794 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l10.794 0-5.148-5.151c-.195-.196-.195-.512 0-.707.098-.098.227-.147.354-.147z"],"move-call-out-tablet_12":["M11.9622 5.3094c.05.122.05.26 0 .382-.025.061-.062.117-.109.163l-1.999 1.999c-.196.196-.512.196-.707 0-.196-.195-.196-.511 0-.707l1.146-1.146-2.793 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l2.793 0-1.146-1.147c-.196-.195-.196-.511 0-.707.097-.097.225-.146.353-.146.128 0 .256.049.354.146l1.999 2c.047.046.084.101.109.163zm-2.462 3.6909c.276 0 .5.224.5.5l0 1c0 .827-.673 1.5-1.5 1.5l-7 0c-.827 0-1.5-.673-1.5-1.5l0-9c0-.827.673-1.5 1.5-1.5l7 0c.827 0 1.5.673 1.5 1.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276-.224-.5-.5-.5l-7 0c-.276 0-.5.224-.5.5l0 7.5 8.5 0zm-.5 1.5l0-.5-8 0 0 .5c0 .276.224.5.5.5l7 0c.276 0 .5-.224.5-.5z"],"move-call-out-tablet_18":["M13.5002 13c.276 0 .5.224.5.5l0 2.427c0 1.143-.93 2.073-2.073 2.073l-9.854 0c-1.143 0-2.073-.93-2.073-2.073l0-13.854C.0002.93.9302 0 2.0732 0l9.854 0c1.143 0 2.073.93 2.073 2.073l0 1.427c0 .277-.224.5-.5.5-.276 0-.5-.223-.5-.5l0-1.427c0-.591-.481-1.073-1.073-1.073l-9.854 0c-.592 0-1.073.482-1.073 1.073l0 10.927 12.5 0zm-.5 2.927l0-1.927-12 0 0 1.927c0 .592.481 1.073 1.073 1.073l9.854 0c.592 0 1.073-.481 1.073-1.073zm4.9624-7.6176c.05.122.05.26 0 .382-.025.061-.062.117-.109.163l-2.999 2.999c-.196.196-.512.196-.707 0-.196-.195-.196-.511 0-.707l2.146-2.146-4.793 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l4.793 0-2.146-2.147c-.196-.195-.196-.511 0-.707.097-.097.225-.146.353-.146.128 0 .256.049.354.146l2.999 3c.047.046.084.101.109.163zM6.5002 16.0003c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0z"],"move-call-out-tablet_20":["M15.5002 15.0003c.275 0 .5.225.5.5l0 1 0 1c0 1.381-1.119 2.5-2.5 2.5l-11 0c-1.381 0-2.5-1.119-2.5-2.5l0-15c0-1.381 1.119-2.5 2.5-2.5l11 0c1.381 0 2.5 1.119 2.5 2.5l0 1c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-1c0-.827-.673-1.5-1.5-1.5l-11 0c-.827 0-1.5.673-1.5 1.5l0 12.5 14.5 0zm-.5 1.5l0-.5-14 0 0 1.5c0 .827.673 1.5 1.5 1.5l11 0c.827 0 1.5-.673 1.5-1.5l0-1zm4.9624-7.1909c.05.122.05.26 0 .382-.026.061-.063.117-.109.163l-3.999 4c-.098.097-.226.146-.354.146-.128 0-.256-.049-.354-.146-.195-.196-.195-.512 0-.708l3.147-3.146-6.793 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l6.793 0-3.147-3.146c-.195-.196-.195-.512 0-.708.196-.195.512-.195.708 0l3.999 4c.046.046.083.102.109.163zM7.5002 18.0003c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0z"],"move-call-out-tablet_24":["M22.8547 11.1468c.098.098.146.227.146.356l0 .003c0 .065-.013.13-.04.192-.022.056-.057.106-.098.149-.004.004-.005.009-.008.013l-5 4.995c-.196.194-.513.194-.708-.001-.195-.196-.195-.512 0-.707l4.145-4.141-8.791 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l8.796 0-4.15-4.146c-.195-.195-.195-.512 0-.708.098-.097.226-.146.354-.146.127 0 .255.049.354.146l5 4.995zm-4.3545 7.8535c.276 0 .5.224.5.5l0 2c0 1.38-1.119 2.5-2.5 2.5l-13 0c-1.381 0-2.5-1.12-2.5-2.5l0-19c0-1.381 1.119-2.5 2.5-2.5l13 0c1.381 0 2.5 1.119 2.5 2.5l0 1c0 .274-.225.5-.5.5-.275 0-.5-.226-.5-.5l0-1c0-.829-.672-1.5-1.5-1.5l-13 0c-.828 0-1.5.671-1.5 1.5l0 16.5 16.5 0zm-.5 2.5l0-1.5-16 0 0 1.5c0 .827.673 1.5 1.5 1.5l13 0c.827 0 1.5-.673 1.5-1.5zm-8.5.5c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0z"],"move-call-out-tablet_28":["M26.9622 12.3138c.051.122.051.26 0 .382-.025.061-.062.117-.109.163l-5.999 6.003c-.195.196-.512.196-.707 0-.195-.195-.195-.511 0-.707l5.147-5.15-10.794 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l10.794 0-5.147-5.151c-.195-.196-.195-.512 0-.707.098-.098.226-.147.353-.147.128 0 .256.049.354.147l5.999 6.004c.047.046.084.101.109.163zm-6.462 8.6865c.276 0 .5.224.5.5l0 2.5c0 1.654-1.346 3-3 3l-14 0c-1.654 0-3-1.346-3-3l0-20c0-1.654 1.346-3 3-3l14 0c1.418 0 2.653 1.009 2.939 2.399.055.27-.119.535-.389.59-.268.053-.535-.118-.591-.389-.189-.927-1.014-1.6-1.959-1.6l-14 0c-1.103 0-2 .897-2 2l0 17 18.5 0zm-.5 3l0-2-18 0 0 2c0 1.103.897 2 2 2l14 0c1.103 0 2-.897 2-2zm-9.5.5c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0z"],"multimedia_16":["M15 7.5c0 .276-.224.5-.5.5L8 8l0 6.5c0 .276-.224.5-.5.5C3.364 15 0 11.636 0 7.5 0 3.364 3.364 0 7.5 0 11.636 0 15 3.364 15 7.5zM8 7l5.981 0C13.737 3.813 11.187 1.263 8 1.019L8 7zm-1 6.981L7 1.019C3.648 1.275 1 4.084 1 7.5c0 3.416 2.648 6.225 6 6.481zM15.5 9c.275 0 .5.225.5.5l0 6c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-.5-5 0 0 .5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-6c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 .5 1 0 1 0 3 0 0-.5c0-.275.225-.5.5-.5zM14 12l1 0 0-1-1 0 0 1zm0 2l1 0 0-1-1 0 0 1zm-2 0l1 0 0-3-1 0 0 3zm-2 0l1 0 0-1-1 0 0 1zm0-2l1 0 0-1-1 0 0 1z"],"multimedia_20":["M19 9.5c0 .276-.224.5-.5.5L10 10l0 8.5c0 .276-.224.5-.5.5C4.262 19 0 14.738 0 9.5 0 4.262 4.262 0 9.5 0 14.738 0 19 4.262 19 9.5zM10 9l7.985 0C17.735 4.711 14.29 1.265 10 1.015L10 9zm-1 8.985l0-16.97C4.545 1.274 1 4.981 1 9.5c0 4.519 3.545 8.226 8 8.485zM19.5 11c.275 0 .5.225.5.5l0 .5 0 1 0 2 0 1 0 2 0 1 0 .5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-.5-1 0-1 0-3 0-1 0-1 0 0 .5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-.5 0-1 0-2 0-1 0-2 0-1 0-.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 .5 1 0 1 0 3 0 1 0 1 0 0-.5c0-.275.225-.5.5-.5zM18 15l1 0 0-2-1 0 0 2zm0 3l1 0 0-2-1 0 0 2zm-4 0l3 0 0-2 0-1 0-2-3 0 0 2 0 1 0 2zm-2 0l1 0 0-2-1 0 0 2zm0-3l1 0 0-2-1 0 0 2z"],"multiple-devices_28":["M25 2c1.657 0 3 1.343 3 3l0 10c0 1.657-1.343 3-3 3l-4 0 0 5c0 1.657-1.343 3-3 3L3 26c-1.657 0-3-1.343-3-3l0-10c0-1.657 1.343-3 3-3l4 0 0-5c0-1.657 1.343-3 3-3l15 0zm2 13l0-10c0-1.104-.897-2-2-2L10 3c-1.103 0-2 .896-2 2l0 5 10 0c1.657 0 3 1.343 3 3l0 4 4 0c1.103 0 2-.896 2-2zm-7 8l0-10c0-1.104-.897-2-2-2L3 11c-1.103 0-2 .896-2 2l0 10c0 1.104.897 2 2 2l15 0c1.103 0 2-.896 2-2zm-9.5-10c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm7-8c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5z"],"multiple-devices_64":["M57.5 4c3.59 0 6.5 2.91 6.5 6.5l0 25c0 3.59-2.91 6.5-6.5 6.5L48 42l0 11.5c0 3.59-2.91 6.5-6.5 6.5l-35 0C2.91 60 0 57.09 0 53.5l0-24C0 25.91 2.91 23 6.5 23l9.5 0 0-12.5C16 6.91 18.91 4 22.5 4l35 0zM63 35.5l0-25C63 7.467 60.533 5 57.5 5l-35 0C19.467 5 17 7.467 17 10.5L17 23l24.5 0c3.59 0 6.5 2.91 6.5 6.5L48 41l9.5 0c3.033 0 5.5-2.467 5.5-5.5zm-16 18l0-24c0-3.033-2.467-5.5-5.5-5.5l-35 0C3.467 24 1 26.467 1 29.5l0 24C1 56.533 3.467 59 6.5 59l35 0c3.033 0 5.5-2.467 5.5-5.5zM24 28c.552 0 1 .447 1 1 0 .553-.448 1-1 1-.552 0-1-.447-1-1 0-.553.448-1 1-1zM40 9c.552 0 1 .447 1 1 0 .553-.448 1-1 1-.552 0-1-.447-1-1 0-.553.448-1 1-1z"],"mute-on-entry_16":["M10.8545 2.1469c.195.195.195.511 0 .707l-1.854 1.853 0 5.796c0 1.76-1.309 3.202-3 3.447l0 1.05 1.502 0c.275 0 .498.232.498.5 0 .276-.215.5-.498.5l-4.004 0c-.275 0-.498-.232-.498-.5 0-.276.215-.5.498-.5l1.502 0 0-1.05c-1.346-.194-2.433-1.146-2.827-2.415l-1.319 1.319c-.196.195-.512.195-.708 0-.195-.196-.195-.512 0-.707l1.854-1.854 0-6.796c0-1.931 1.57-3.496 3.499-3.497l.002 0c1.87.001 3.382 1.468 3.48 3.313l1.165-1.166c.196-.196.512-.196.708 0zm-2.854 2.146l0-.796c0-1.379-1.119-2.497-2.5-2.497-1.378 0-2.5 1.12-2.5 2.497l0 5.796 5-5zm0 6.21l0-4.796-4.981 4.982c.096 1.29 1.163 2.311 2.481 2.311 1.379 0 2.5-1.119 2.5-2.497zm7.5-3.003c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-3.793 0 1.147 1.146c.195.196.195.512 0 .708-.098.097-.226.146-.354.146-.128 0-.256-.049-.354-.146l-2-2c-.195-.196-.195-.512 0-.708l2-2c.196-.195.512-.195.708 0 .195.196.195.512 0 .708l-1.147 1.146 3.793 0z"],"new-whiteboard_12":["M7.5 4c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5L9 3l0-1.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5L10 3l1.5 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L10 4l0 1.5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5L9 4 7.5 4zm4 2c.275 0 .5.225.5.5l0 3c0 .827-.673 1.5-1.5 1.5l-9 0C.673 11 0 10.327 0 9.5l0-7C0 1.673.673 1 1.5 1l5 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-5 0c-.276 0-.5.225-.5.5l0 7c0 .275.224.5.5.5l9 0c.275 0 .5-.225.5-.5l0-3c0-.275.225-.5.5-.5z"],"new-whiteboard_16":["M11.5 5c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5L13 4l0-1.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5L14 4l1.5 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L14 5l0 1.5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5L13 5l-1.5 0zm4 2c.275 0 .5.225.5.5l0 4.491C16 13.1 15.105 14 14.006 14L1.994 14C.893 14 0 13.097 0 11.991l0-7.982C0 2.898.895 2 1.994 2L10.5 2c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L1.994 3C1.447 3 1 3.451 1 4.009l0 7.982c0 .558.447 1.009.994 1.009l12.012 0c.547 0 .994-.451.994-1.009L15 7.5c0-.275.225-.5.5-.5z"],"next_10":["M5.146 8.35325c-.195-.195-.195-.512 0-.707l2.146-2.147-5.792 0c-.277 0-.5-.223-.5-.5 0-.276.223-.5.5-.5l5.792 0-2.146-2.146c-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0l3 3c.094.094.147.221.147.353 0 .133-.053.26-.147.354l-3 3c-.195.195-.512.195-.707 0"],"next_12":["M3.04527949 5.85898988L1.5 5.5l7.793 0-3.147-3.146c-.195-.196-.195-.512 0-.708.196-.195.512-.195.708 0l4 4c.195.196.195.512 0 .708l-4 4c-.098.097-.226.146-.354.146-.128 0-.256-.049-.354-.146-.195-.196-.195-.512 0-.708L9.293 6.5 1.5 6.5c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5"],"next_16":["M13.29279407 7.49975l-5.15448982-5.146c-.19482953-.195-.19482953-.512 0-.707.19582865-.196.51155239-.195.70738104-.001l6.007743223 6c.0939178215.094.146871487.221.146871487.354 0 .133-.0529536655.26-.146871487.354l-6.007743223 6c-.09791433.097-.22580243.146-.35369052.146-.1278881 0-.2557762-.049-.35369052-.147-.19482953-.195-.19482953-.512 0-.707l5.15448982-5.146-11.79293117 0c-.2757587 0-.4995629-.224-.4995629-.5 0-.276.2238042-.5.4995629-.5l11.79293117 0z"],"next_18":["M11.864 2.64625c-.196-.195-.512-.195-.707 0-.196.196-.196.512 0 .707l5.136 5.137-15.793 0c-.274 0-.5.225-.5.5 0 .274.226.5.5.5l15.793 0-5.136 5.136c-.196.195-.196.511 0 .707.097.097.225.146.353.146.128 0 .256-.049.354-.146l5.99-5.99c.195-.195.195-.512 0-.707l-5.99-5.99z"],"next_20":["M.501 9.5l17.792 0-6.143-6.146c-.195-.196-.195-.512 0-.708.196-.195.512-.195.707 0l6.997 7c.195.196.195.512 0 .708l-6.997 7c-.097.097-.225.146-.353.146-.128 0-.256-.049-.354-.146-.195-.196-.195-.512 0-.708l6.143-6.146-17.792 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5"],"next_24":["M1.5 11.9999l19.793 0-8.147-8.146c-.195-.196-.195-.512 0-.708.196-.195.512-.195.708 0l9 9c.195.196.195.512 0 .708l-9 9c-.098.097-.226.146-.354.146-.128 0-.256-.049-.354-.146-.195-.196-.195-.512 0-.708l8.147-8.146-19.793 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5"],"next_28":["M.50675 13.99825l25.786 0-10.14-10.145c-.195-.195-.195-.511 0-.707.196-.195.512-.195.708 0l10.993 10.998c.195.196.195.512 0 .708l-10.993 11.001c-.098.098-.226.147-.354.147-.128 0-.256-.049-.354-.147-.195-.195-.195-.511 0-.707l10.141-10.148-25.787 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5"],"next_36":["M20.85475 4.14675l14 14c.046.046.082.101.107.163.051.122.051.259 0 .381-.025.062-.061.117-.107.163l-14 14c-.195.195-.512.195-.707 0-.195-.195-.195-.512 0-.707l13.146-13.146-31.793 0c-.276 0-.5-.224-.5-.5 0-.277.224-.5.5-.5l31.793 0-13.146-13.147c-.098-.098-.147-.226-.147-.353 0-.128.049-.256.147-.354.195-.195.512-.195.707 0"],"note_16":["M14.0937-.0001c1.051 0 1.906.856 1.906 1.906l0 8.907c0 .258-.1.502-.283.684l-4.219 4.219c-.181.181-.43.284-.685.284l-8.906 0c-1.051 0-1.907-.855-1.907-1.906l0-12.188c0-1.05.856-1.906 1.907-1.906l12.187 0zm-3.09 14.796l3.792-3.792-2.929 0c-.476 0-.863.387-.863.862l0 2.93zm-10.004-.702c0 .5.407.906.907.906l8.097 0 0-3.134c0-1.027.835-1.862 1.863-1.862l3.142 0-.009-8.098c0-.5-.406-.906-.906-.906l-12.187 0c-.5 0-.907.406-.907.906l0 12.188zM4.5 5c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l7 0c.277 0 .5.224.5.5 0 .276-.223.5-.5.5l-7 0zm0 3.002c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l7 0c.277 0 .5.224.5.5 0 .276-.223.5-.5.5l-7 0zm2.9983 2.0019c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-2.998 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l2.998 0z"],"note_20":["M16.5.9999c1.381 0 2.5 1.119 2.5 2.5l0 9.48c0 .149-.059.292-.165.397l-5.46 5.458c-.105.106-.249.165-.398.165l-9.477 0c-1.381 0-2.5-1.119-2.5-2.5l0-13c0-1.381 1.119-2.5 2.5-2.5l13 0zM13 17.7959l4.798-4.796-3.298 0c-.827 0-1.5.673-1.5 1.5l0 3.296zm-11-1.296c0 .827.673 1.5 1.5 1.5l8.5 0 0-3.5c0-1.381 1.119-2.5 2.5-2.5l3.5 0 0-8.5c0-.827-.673-1.5-1.5-1.5l-13 0c-.827 0-1.5.673-1.5 1.5l0 13zM5.5 7c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l9 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-9 0zm0 3c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l9 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-9 0zm3.7187 2c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-3.719 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l3.719 0z"],"note-ppt_16":["M14.0936-.0001c1.051 0 1.906.856 1.906 1.906l0 8.907c0 .257-.1.502-.283.684l-4.219 4.219c-.181.181-.43.284-.685.284l-8.905 0c-1.051 0-1.906-.853-1.907-1.903 0-.001-.001-.002-.001-.003l0-12.188c0-.002.001-.002.001-.004.001-1.047.856-1.902 1.907-1.902l12.186 0zm-2.16 10.004l3.075 0-.009-8.098c0-.5-.406-.906-.906-.906l-12.186 0c-.5 0-.908.406-.908.906l0 12.188c0 .5.408.906.908.906l8.096 0 0-3.135c0-.781.486-1.449 1.17-1.724l0-3.451-1.262 0 0-.703 3.301 0 0 .703-1.279 0 0 3.314zm-.93 4.792l3.792-3.792-2.928 0c-.476 0-.864.387-.864.861l0 2.931zM4.135 5.9871c1.016 0 1.6.491 1.6 1.347 0 .851-.576 1.32-1.622 1.32l-.566 0 0 1.359-.759 0 0-4.026 1.347 0zm-.011 2.008c.732 0 .83-.334.83-.661 0-.568-.44-.689-.809-.689l-.598 0 0 1.35.577 0zm3.7708-2.008c1.016 0 1.6.491 1.6 1.347 0 .851-.576 1.32-1.622 1.32l-.566 0 0 1.359-.759 0 0-4.026 1.347 0zm-.011 2.008c.732 0 .831-.334.831-.661 0-.568-.441-.689-.81-.689l-.598 0 0 1.35.577 0z"],"note-ppt_20":["M16.5 1C17.881 1 19 2.119 19 3.5l0 9.48c0 .149-.059.291-.165.397l-5.46 5.458c-.105.106-.249.165-.398.165L3.5 19C2.119 19 1 17.881 1 16.5l0-13C1 2.119 2.119 1 3.5 1l13 0zM18 12l0-8.5c0-.827-.673-1.5-1.5-1.5l-13 0C2.673 2 2 2.673 2 3.5l0 13c0 .827.673 1.5 1.5 1.5l8.5 0 0-3.5c0-1.24.906-2.263 2.091-2.459l0-3.529-1.433 0 0-.795 3.746 0 0 .795-1.451 0 0 3.488L18 12zm-5 5.796L17.798 13 14.5 13c-.827 0-1.5.673-1.5 1.5l0 3.296zM6.1033 7.7171c1.154 0 1.816.556 1.816 1.527 0 .967-.653 1.498-1.84 1.498l-.642 0 0 1.541-.862 0 0-4.566 1.528 0zm-.012 2.277c.831 0 .942-.379.942-.75 0-.645-.499-.781-.918-.781l-.678 0 0 1.531.654 0zm4.2781-2.277c1.154 0 1.816.556 1.816 1.527 0 .967-.653 1.498-1.84 1.498l-.642 0 0 1.541-.862 0 0-4.566 1.528 0zm-.012 2.277c.831 0 .942-.379.942-.75 0-.645-.499-.781-.918-.781l-.678 0 0 1.531.654 0z"],"notepad_16":["M12 1c1.105 0 2 .896 2 2l0 11c0 1.105-.895 2-2 2l-8 0c-1.105 0-2-.895-2-2L2 3c0-1.104.895-2 2-2l1 0 0-.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5L6 1l4 0 0-.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 .5 1 0zm1 13l0-11c0-.55-.449-1-1-1L4 2c-.551 0-1 .45-1 1l0 11c0 .551.449 1 1 1l8 0c.551 0 1-.449 1-1zm-2.5-8.9995c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l5 0zm0 3c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l5 0zm-5 3l5 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5z"],"notes_10":["M7.666 0C8.401 0 9 .598 9 1.333l0 7.333c0 .735-.599 1.333-1.334 1.333l-5.333 0C1.598 9.999 1 9.401 1 8.666l0-7.333C1 .598 1.598 0 2.333 0l5.333 0zM8 8.666l0-7.333C8 1.15 7.851 1 7.666 1L2.333 1C2.149 1 2 1.15 2 1.333l0 7.333c0 .184.149.333.333.333l5.333 0c.185 0 .334-.149.334-.333zM6.4981 2.999c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-2.999 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l2.999 0zm0 2.0015c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-2.999 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l2.999 0zm-2.001 2.001c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-.998 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l.998 0z"],"notes_12":["M9.349-.0003c.912 0 1.651.74 1.651 1.652l0 8.697c0 .912-.739 1.651-1.651 1.651l-6.697 0c-.912 0-1.652-.739-1.652-1.651l0-8.697c0-.912.74-1.652 1.652-1.652l6.697 0zM10 10.3487l0-8.697c0-.36-.292-.652-.651-.652l-6.697 0c-.36 0-.652.292-.652.652l0 8.697c0 .359.292.651.652.651l6.697 0c.359 0 .651-.292.651-.651zM7.4849 5.5001c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-2.984 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l2.984 0zm.0156-2.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-2.984 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l2.984 0zm-1.5 5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1.5 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1.5 0z"],"notes_14":["M11.333.0001c.919 0 1.667.748 1.667 1.667l0 10.666c0 .919-.748 1.667-1.667 1.667l-8.666 0c-.919 0-1.667-.748-1.667-1.667l0-10.666c0-.919.748-1.667 1.667-1.667l8.666 0zM12 12.3331l0-10.666c0-.368-.299-.667-.667-.667l-8.666 0c-.368 0-.667.299-.667.667l0 10.666c0 .368.299.667.667.667l8.666 0c.368 0 .667-.299.667-.667zm-5.4995-3.334c.276 0 .5.225.5.5 0 .276-.224.5-.5.5l-1.944 0c-.276 0-.5-.224-.5-.5 0-.275.224-.5.5-.5l1.944 0zM9.5 6.5001c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-4.999 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l4.999 0zm0-2.5c.276 0 .5.224.5.5 0 .275-.224.5-.5.5l-4.999 0c-.276 0-.5-.225-.5-.5 0-.276.224-.5.5-.5l4.999 0z"],"notes_16":["M12 .0001c1.105 0 2 .895 2 2l0 12c0 1.104-.895 2-2 2l-8 0c-1.105 0-2-.896-2-2l0-12c0-1.105.895-2 2-2l8 0zm1 14l0-12c0-.551-.449-1-1-1l-8 0c-.551 0-1 .449-1 1l0 12c0 .551.449 1 1 1l8 0c.551 0 1-.449 1-1zm-2.5-6.5c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l5 0zm-3 3.5c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-2 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l2 0zm3-7c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l5 0z"],"notes_20":["M15.5 0C16.881 0 18 1.119 18 2.5l0 15c0 1.381-1.119 2.5-2.5 2.5l-11 0C3.119 20 2 18.881 2 17.5l0-15C2 1.119 3.119 0 4.5 0l11 0zM17 17.5l0-15c0-.827-.673-1.5-1.5-1.5l-11 0C3.673 1 3 1.673 3 2.5l0 15c0 .827.673 1.5 1.5 1.5l11 0c.827 0 1.5-.673 1.5-1.5zM13.5 5c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-7 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l7 0zm0 4.5c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-7 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l7 0zm-4 4.5c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-3 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l3 0z"],"notes_24":["M18.5.0001c1.381 0 2.5 1.119 2.5 2.5l0 19c0 1.381-1.119 2.5-2.5 2.5l-13 0c-1.381 0-2.5-1.119-2.5-2.5l0-19c0-1.381 1.119-2.5 2.5-2.5l13 0zm1.5 21.5l0-19c0-.827-.673-1.5-1.5-1.5l-13 0c-.827 0-1.5.673-1.5 1.5l0 19c0 .827.673 1.5 1.5 1.5l13 0c.827 0 1.5-.673 1.5-1.5zm-8.5-4.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-4 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l4 0zm5-5.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-9 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l9 0zm0-5.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-9 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l9 0z"],"notes_26":["M20.333 1.0001c1.471 0 2.667 1.196 2.667 2.667l0 18.666c0 1.471-1.196 2.667-2.667 2.667l-14.667 0c-1.47 0-2.666-1.196-2.666-2.667l0-18.666c0-1.471 1.196-2.667 2.666-2.667l14.667 0zM22 22.3331l0-18.666c0-.919-.748-1.667-1.667-1.667l-14.667 0c-.919 0-1.666.748-1.666 1.667l0 18.666c0 .919.747 1.667 1.666 1.667l14.667 0c.919 0 1.667-.748 1.667-1.667zm-9.5-4.3321c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-4 0c-.277 0-.5-.224-.5-.5 0-.276.223-.5.5-.5l4 0zm5-11.0009c.275 0 .5.224.5.5 0 .276-.225.5-.5.5l-9 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l9 0zm-.001 5.5c.275 0 .5.224.5.5 0 .276-.225.5-.5.5l-8.999 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l8.999 0z"],"notes_36":["M27.498 1c1.93 0 3.5 1.57 3.5 3.5l0 27.001c0 1.93-1.57 3.5-3.5 3.5l-18.998 0c-1.929 0-3.5-1.57-3.5-3.5L5 4.5C5 2.57 6.571 1 8.5 1l18.998 0zm2.5 30.501l0-27.001c0-1.379-1.122-2.5-2.5-2.5L8.5 2C7.122 2 6 3.121 6 4.5l0 27.001c0 1.378 1.122 2.5 2.5 2.5l18.998 0c1.378 0 2.5-1.122 2.5-2.5zm-5.4988-21.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-13 0c-.277 0-.5-.224-.5-.5 0-.276.223-.5.5-.5l13 0zm0 8c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-13 0c-.277 0-.5-.224-.5-.5 0-.276.223-.5.5-.5l13 0zm-7 8c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-6 0c-.277 0-.5-.224-.5-.5 0-.276.223-.5.5-.5l6 0z"],"notes_8":["M5.833 0C6.477 0 7 .523 7 1.167l0 5.666C7 7.477 6.477 8 5.833 8L2.167 8C1.523 8 1 7.477 1 6.833l0-5.666C1 .523 1.523 0 2.167 0l3.666 0zM6 6.833l0-5.666C6 1.075 5.925 1 5.833 1L2.167 1C2.075 1 2 1.075 2 1.167l0 5.666c0 .092.075.167.167.167l3.666 0C5.925 7 6 6.925 6 6.833zM4.5 2c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0zm0 2c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0z"],"open-in-folder_10":["M7.5006345 8L1.30806429 8l1.49892776-3 6.1925702 0L7.5006345 8zM.999285171 6.382l0-4.082c0-.165.133904209-.3.299785549-.3l1.99157535 0 .70649461.707c.18586705.187.44268334.293.70649462.293l1.99157535 0c.16488205 0 .29978555.135.29978555.3l0 .7-4.18800415 0c-.38072765 0-.72348247.212-.89436023.553L.999285171 6.382zM9.84995393 4.475C9.66608546 4.178 9.34831278 4 8.99956225 4L7.99428137 4l0-.7c0-.717-.58258326-1.3-1.29907072-1.3L4.7036353 2l-.70649462-.707C3.81127364 1.106 3.55345807 1 3.29064607 1L1.29907072 1C.582583255 1 0 1.583 0 2.3l0 5.4C0 8.417.582583255 9 1.29907072 9l6.32447585 0c.30578126 0 .57858612-.17.71548818-.442l1.55488773-3.111c.15588852-.312.13890062-.676-.04396855-.972z"],"open-in-folder_12":["M9.1104 9.6875c-.076.189-.259.312-.464.312l-7.145 0c-.139 0-.264-.056-.355-.147l1.759-4.533c.075-.194.259-.319.468-.319l7.626 0-1.889 4.687zm-8.11-7.187c0-.276.225-.5.501-.5l2.43 0c.136 0 .263.053.358.149l.391.401c.281.285.672.45 1.073.45l2.751 0c.275 0 .5.224.5.5l0 .5-5.631 0c-.625 0-1.174.375-1.4.957l-.973 2.505 0-4.962zm10.829 1.94c-.187-.275-.497-.44-.83-.44l-.994 0 0-.5c0-.828-.674-1.5-1.501-1.5l-2.751 0c-.134 0-.264-.055-.358-.15l-.392-.401c-.286-.29-.665-.45-1.072-.45l-2.43 0c-.829 0-1.501.673-1.501 1.501l0 7c0 .827.672 1.499 1.501 1.499l7.145 0c.615 0 1.162-.368 1.393-.939l1.888-4.686c.124-.309.088-.658-.098-.934z"],"open-in-folder_14":["M1.4951 3c-.274 0-.498.225-.498.5l0 6.646 1.775-4.229c.236-.557.777-.917 1.379-.917l4.822 0 0-.5c0-.275-.225-.5-.499-.5l-2.579 0c-.392 0-.778-.16-1.056-.439l-.413-.415c-.095-.094-.219-.146-.353-.146l-2.578 0zm-.181 8.966c.057.022.117.034.181.034l8.615 0c.199 0 .38-.119.458-.303L13.0021 6l-8.851 0c-.201 0-.382.12-.46.306l-2.377 5.66zM10.1101 13l-8.615 0c-.824 0-1.495-.673-1.495-1.5l0-8c0-.827.671-1.5 1.495-1.5l2.578 0c.4 0 .776.156 1.058.439l.413.415c.092.092.221.146.351.146l2.579 0c.825 0 1.496.673 1.496 1.5l0 .5 3.033 0c.336 0 .646.168.831.449.186.282.218.635.085.946l-2.434 5.696c-.235.552-.775.909-1.375.909z"],"open-pages_14":["M12 10.5996c0 .221-.18.4-.4.4l-.6 0 0-4.586c0-.265-.105-.519-.293-.707l-3.414-3.414c-.188-.187-.442-.293-.707-.293l-2.586 0 0-.599c0-.221.18-.401.4-.401l4.186 0L12 4.4136l0 6.186zm-5-7.186l2.586 2.586-2.186 0c-.22 0-.4-.179-.4-.4l0-2.186zm2.6 9.586l-7.2 0c-.22 0-.4-.179-.4-.4l0-9.199c0-.221.18-.401.4-.401l3.6 0 0 2.6c0 .772.628 1.4 1.4 1.4l2.6 0 0 5.6c0 .221-.18.4-.4.4zm3.107-9.293L9.293.2926c-.188-.187-.442-.293-.707-.293l-4.186 0c-.773 0-1.4.627-1.4 1.401l0 .599-.6 0c-.773 0-1.4.627-1.4 1.401l0 9.199c0 .773.627 1.4 1.4 1.4l7.2 0c.773 0 1.4-.627 1.4-1.4l0-.6.6 0c.773 0 1.4-.627 1.4-1.4l0-6.186c0-.265-.105-.519-.293-.707z"],"open-pages_16":["M14 12c0 .552-.448 1-1 1l-1 0 0-6.891c0-.265-.105-.519-.293-.707L8.598 2.293C8.41 2.105 8.156 2 7.891 2L5 2c0-.551.449-1 1-1l4.891 0L14 4.109 14 12zM8 3.109L10.891 6 9 6c-.551 0-1-.449-1-1l0-1.891zM10 15l-7 0c-.551 0-1-.448-1-1L2 4c0-.551.449-1 1-1l4 0 0 2c0 1.105.895 2 2 2l2 0 0 7c0 .552-.448 1-1 1zm4.707-11.598L11.598.293C11.409.105 11.155 0 10.891 0L6 0C4.895 0 4 .895 4 2L3 2c-1.105 0-2 .895-2 2l0 10c0 1.105.895 2 2 2l7 0c1.105 0 2-.895 2-2l1 0c1.105 0 2-.895 2-2l0-7.891c0-.265-.105-.519-.293-.707z"],"open-pages_24":["M21 18.5c0 .827-.673 1.5-1.5 1.5l-.5 0 0-10.841c0-.301-.117-.585-.328-.8l-.001-.001-4.958-5.025c-.21-.212-.502-.333-.799-.333L6 3l0-.5C6 1.673 6.673 1 7.5 1L16 1l5 5.001L21 18.5zM13 7.501l0-3.464.002 0 4.899 4.964-3.401 0c-.828 0-1.5-.673-1.5-1.5zM18 21.5c0 .827-.673 1.5-1.5 1.5l-12 0c-.827 0-1.5-.673-1.5-1.5l0-16C3 4.673 3.673 4 4.5 4l7.5.032 0 3.469c0 1.381 1.119 2.5 2.5 2.5l3.5 0L18 21.5zm3.672-16.141l-.001-.001L16.713.333C16.503.121 16.211 0 15.914 0L7.5 0C6.122 0 5 1.121 5 2.5L5 3l-.5 0C3.122 3 2 4.121 2 5.5l0 16C2 22.879 3.122 24 4.5 24l12 0c1.378 0 2.5-1.121 2.5-2.5l0-.5.5 0c1.378 0 2.5-1.121 2.5-2.5l0-12.341c0-.301-.117-.585-.328-.8z"],"open-pages_36":["M31 28.5c0 1.378-1.122 2.5-2.5 2.5l-.5 0 0-16.885c0-.384-.155-.761-.428-1.033l-8.654-8.654C18.641 4.152 18.274 4 17.885 4L9 4l0-.5C9 2.122 10.122 1 11.5 1l10.385 0c.125 0 .238.047.326.135l8.655 8.655c.084.084.134.205.134.325L31 28.5zm-13-17l0-6.477c.078.02.152.054.211.112l8.653 8.654c.059.058.092.132.113.211L20.5 14c-1.379 0-2.5-1.122-2.5-2.5zm9 21c0 1.379-1.121 2.5-2.5 2.5l-17 0C6.122 35 5 33.879 5 32.5l0-25C5 6.122 6.122 5 7.5 5L17 5l0 6.5c0 1.93 1.57 3.5 3.5 3.5l6.5 0 0 17.5zm4.572-23.418L22.918.428C22.641.152 22.274 0 21.885 0L11.5 0C9.57 0 8 1.57 8 3.5L8 4l-.5 0C5.57 4 4 5.57 4 7.5l0 25C4 34.43 5.57 36 7.5 36l17 0c1.93 0 3.5-1.57 3.5-3.5l0-.5.5 0c1.93 0 3.5-1.57 3.5-3.5l0-18.385c0-.384-.155-.761-.428-1.033z"],"other-number_12":["M11.9903 3.132c.048.378-.08.747-.351 1.015l-.669.664c-.414.409-1.031.535-1.575.322l-.841-.333c-.469-.184-.828-.563-.988-1.037l-.171-.507c-.786-.086-1.838-.083-2.805.023l-.156.484c-.16.474-.52.852-.988 1.037l-.841.332c-.175.07-.359.103-.541.103-.38 0-.754-.147-1.034-.424l-.669-.663c-.271-.269-.399-.639-.352-1.016.047-.375.261-.7.587-.892C1.9533 1.44 3.8733 1 6.0003 1c2.128 0 4.047.44 5.404 1.241.326.191.539.516.586.891zm-1.055.305c.066-.065.068-.141.063-.181-.005-.038-.024-.109-.102-.154C9.7083 2.402 7.9243 2 6.0003 2c-1.923 0-3.708.401-4.897 1.102-.077.045-.097.116-.102.154-.004.039-.003.116.064.181l.669.663c.132.13.33.17.505.102l.84-.331c.193-.077.342-.232.407-.427l.168-.498c.121-.361.447-.621.829-.661 1.055-.116 2.164-.119 3.043-.01.377.047.697.307.817.662l.171.507c.066.195.213.35.407.427l.841.332c.174.068.372.027.504-.103l.669-.663zM6.0002 8c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm-2 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm4 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm-2-2c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm-2 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm4 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm-2 4c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm-2 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm4 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5z"],"other-number_16":["M15.9894 3.749c.056.458-.099.907-.427 1.232l-.913.904c-.514.51-1.28.665-1.953.399l-1.147-.452c-.589-.233-1.041-.708-1.241-1.304l-.233-.691c-.019-.057-.072-.098-.138-.107-1.094-.135-2.544-.13-3.879.015-.066.007-.119.047-.138.105l-.228.678c-.201.596-.653 1.071-1.241 1.304l-1.147.452c-.218.086-.445.128-.67.128-.472 0-.935-.183-1.282-.526l-.914-.905c-.328-.325-.483-.774-.427-1.232.057-.455.316-.85.712-1.082C2.5214 1.607 5.1734 1 8.0004 1c2.829 0 5.481.607 7.277 1.667.396.232.655.627.712 1.082zm-1.132.522c.107-.106.158-.251.139-.398-.01-.085-.054-.244-.226-.345C13.1234 2.557 10.6554 2 8.0004 2c-2.654 0-5.121.557-6.77 1.528-.172.101-.216.26-.226.345-.019.147.032.292.139.398l.912.904c.231.229.577.297.882.179l1.146-.452c.314-.124.555-.377.662-.693l.227-.678c.144-.426.528-.732.978-.781 1.428-.154 2.927-.158 4.11-.012.443.054.822.361.963.78l.233.691c.106.316.347.569.661.693l1.146.452c.304.119.65.05.882-.179l.912-.904zM8 8c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0 3c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0 3c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm3-6c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0 3c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0 3c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zM5 8c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0 3c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0 3c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5z"],"outgoing-call-legacy_16":["M13.7006 10.6729c.789.34 1.299 1.114 1.299 1.972l0 1.616c0 .542-.245 1.042-.673 1.375-.307.239-.677.364-1.055.364-.142 0-.285-.017-.426-.053-2.515-.639-5.385-2.432-7.872-4.92-2.489-2.488-4.282-5.358-4.921-7.873-.131-.518-.016-1.058.313-1.481.331-.428.833-.673 1.373-.673l1.616 0c.858 0 1.632.51 1.972 1.299l.61 1.419c.299.694.276 1.48-.062 2.155l-.412.823c-.056.113-.042.249.039.353.854 1.098 2.15 2.384 3.466 3.44.102.083.238.098.352.041l.808-.405c.676-.338 1.461-.359 2.154-.062l1.419.61zm.299 3.588l0-1.616c0-.458-.272-.872-.694-1.053l-1.418-.61-.001 0c-.423-.182-.901-.169-1.312.038l-.808.404c-.462.23-1.021.17-1.425-.156-1.393-1.117-2.716-2.432-3.629-3.605-.315-.405-.371-.96-.144-1.414l.411-.823c.207-.412.22-.891.04-1.313l-.612-1.419c-.18-.421-.595-.694-1.053-.694l-1.616 0c-.23 0-.443.105-.585.286-.137.179-.186.405-.131.622.596 2.346 2.293 5.047 4.658 7.412 2.364 2.364 5.066 4.062 7.411 4.657.217.056.444.007.621-.131.183-.141.287-.356.287-.585zM15.5001.0002c.275 0 .5.225.5.5l0 6c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-4.793-5.146 5.147c-.098.097-.226.146-.354.146-.128 0-.256-.049-.354-.146-.195-.196-.195-.512 0-.708l5.147-5.146-4.793 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l.998 0 .002 0 .005 0 4.995 0z"],"outgoing-call-legacy_20":["M18.346 13.1129c1.005.433 1.654 1.418 1.654 2.513l0 2.192c0 .679-.308 1.308-.844 1.725-.386.3-.849.457-1.323.457-.177 0-.356-.022-.534-.067-3.383-.86-7.248-3.276-10.602-6.63C3.342 9.9479.926 6.0839.067 2.6999c-.165-.649-.023-1.325.39-1.856.418-.536 1.046-.844 1.725-.844l2.193 0c1.094 0 2.08.65 2.512 1.655l.828 1.925c.384.893.355 1.904-.08 2.774l-.558 1.117c-.109.217-.081.473.071.669 1.167 1.5 2.936 3.257 4.732 4.698.191.153.455.183.67.076l1.096-.549c.87-.435 1.881-.464 2.774-.08l1.926.828zm.654 4.705l0-2.192c0-.694-.412-1.32-1.049-1.594l-1.926-.828c-.622-.268-1.325-.247-1.931.056l-1.097.548c-.563.282-1.248.207-1.743-.19-1.88-1.509-3.665-3.282-4.896-4.864-.385-.496-.454-1.175-.176-1.73l.559-1.117c.302-.606.322-1.31.055-1.931l-.828-1.926c-.274-.638-.9-1.05-1.593-1.05l-2.193 0c-.368 0-.709.167-.935.458-.223.285-.299.649-.211.996.816 3.214 3.137 6.911 6.368 10.142 3.231 3.23 6.927 5.551 10.141 6.368.348.088.712.012.997-.21.291-.227.458-.568.458-.936zM19.5 0c.275 0 .5.225.5.5l0 6c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-4.793-6.146 6.147c-.098.097-.226.146-.354.146-.128 0-.256-.049-.354-.146-.195-.196-.195-.512 0-.708L18.293 1 13.5 1c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l6 0z"],"paired-camera_16":["M15.388 4.088c.372.153.612.514.612.915l0 5.994c0 .402-.24.761-.611.914-.123.052-.253.076-.381.076-.256 0-.509-.099-.699-.29l-2.305-2.305L12 9.379l0 2.612C12 13.101 11.098 14 9.992 14l-7.983 0C.899 14 0 13.098 0 11.991l0-7.982C0 2.9.902 2 2.009 2l7.983 0C11.101 2 12 2.902 12 4.009l0 2.602 2.309-2.308c.284-.283.707-.367 1.079-.215zM12.026 8l2.99 2.99L15 5.003 12.026 8zM1 11.9914698C1 12.5469054 1.45267418 13 2.0085302 13l7.9829396 0C10.5469054 13 11 12.5473258 11 11.9914698l0-7.9829396C11 3.45309463 10.5473258 3 9.9914698 3L2.0085302 3C1.45309463 3 1 3.45267418 1 4.0085302l0 7.9829396zM7 5.5c1.381 0 2.5 1.119 2.5 2.5 0 1.381-1.119 2.5-2.5 2.5-.356 0-.693-.077-1-.211-.307.134-.644.211-1 .211-1.381 0-2.5-1.119-2.5-2.5 0-1.381 1.119-2.5 2.5-2.5.356 0 .693.077 1 .211.307-.134.644-.211 1-.211zm0 4c.827 0 1.5-.673 1.5-1.5 0-.827-.673-1.5-1.5-1.5-.004 0-.007.001-.011.001.317.419.511.935.511 1.499 0 .564-.194 1.08-.511 1.499.004 0 .007.001.011.001zM3.5 8c0 .827.673 1.5 1.5 1.5.004 0 .007-.001.011-.001C4.694 9.08 4.5 8.564 4.5 8c0-.564.194-1.08.511-1.499-.004 0-.007-.001-.011-.001-.827 0-1.5.673-1.5 1.5zm3 0c0-.441-.195-.835-.5-1.109-.305.274-.5.668-.5 1.109 0 .441.195.835.5 1.109.305-.274.5-.668.5-1.109z"],"paired-camera_24":["M22.0014897 15.8555c0 .079-.0479477.116-.0879041.133-.0409553.016-.099891.023-.15583-.031l-3.7758808-3.781 0-.353 3.7758808-3.78c.055939-.056.1168725-.047.15583-.031.0399564.016.0879041.053.0879041.132l0 7.711zm-5.0185252 1.622c0 .84-.6832547 1.523-1.5213404 1.523l-11.94197237 0c-.83808573 0-1.52034145-.683-1.52034145-1.523l0-10.955c0-.839.68225572-1.522 1.52034145-1.522l11.94197237 0c.8380857 0 1.5213404.683 1.5213404 1.522l0 10.955zm5.3122048-10.389c-.4255357-.177-.9150018-.081-1.2436433.247l-3.0696512 3.074 0-3.887c0-1.391-1.1307665-2.522-2.5202507-2.522l-11.94197237 0C2.13016753 4.0005 1.0004 5.1315 1.0004 6.5225l0 10.955c0 1.391 1.12976753 2.523 2.51925173 2.523l11.94197237 0c1.3894842 0 2.5202507-1.132 2.5202507-2.523l0-3.887 3.0686523 3.074c.2197603.218.5104432.336.8061206.336.1478388 0 .2966764-.03.4385216-.088.4285326-.178.7052307-.593.7052307-1.057l0-7.711c0-.464-.2766981-.879-.7052307-1.056z","M10 12c0-1.1045695-.8954305-2-2-2-1.1045695 0-2 .8954305-2 2 0 1.1045695.8954305 2 2 2 1.1045695 0 2-.8954305 2-2zm-5 0c0-1.65685425 1.34314575-3 3-3 1.65685425 0 3 1.34314575 3 3 0 1.65685425-1.34314575 3-3 3-1.65685425 0-3-1.34314575-3-3z","M13 12c0-1.1045695-.8954305-2-2-2-1.1045695 0-2 .8954305-2 2 0 1.1045695.8954305 2 2 2 1.1045695 0 2-.8954305 2-2zm-5 0c0-1.65685425 1.34314575-3 3-3 1.6568542 0 3 1.34314575 3 3 0 1.65685425-1.3431458 3-3 3-1.65685425 0-3-1.34314575-3-3z"],"paired-camera_28":["M26.21 8.0956c.478.199.788.662.788 1.181l0 9.448c0 .519-.31.982-.788 1.181-.159.066-.326.097-.49.097-.332.001-.657-.129-.903-.374L21 15.8116l0 4.188c0 1.658-1.343 3-3 3l-14 0c-1.657 0-3-1.342-3-3l0-12c0-1.656 1.343-3 3-3l14 0c1.657 0 3 1.344 3 3l0 4.191 3.817-3.818c.368-.367.913-.477 1.393-.277zM26 18.7246l0-9.448c0-.168-.122-.236-.173-.257-.05-.021-.183-.058-.303.06L21 13.6046l0 .792 4.524 4.525c.119.118.251.08.303.06.051-.022.173-.089.173-.257zm-6 1.275l0-12c0-1.102-.897-2-2-2l-14 0c-1.103 0-2 .898-2 2l0 12c0 1.103.897 2 2 2l14 0c1.103 0 2-.897 2-2zM13 10c2.209 0 4 1.791 4 4 0 2.209-1.791 4-4 4-.732 0-1.41-.211-2-.555-.59.344-1.268.555-2 .555-2.209 0-4-1.791-4-4 0-2.209 1.791-4 4-4 .732 0 1.41.211 2 .555.59-.344 1.268-.555 2-.555zm0 7c1.654 0 3-1.346 3-3 0-1.654-1.346-3-3-3-.399 0-.779.082-1.128.224C12.567 11.944 13 12.92 13 14c0 1.08-.433 2.056-1.128 2.775.349.143.729.225 1.128.225zm-7-3c0 1.654 1.346 3 3 3 .399 0 .779-.082 1.128-.225C9.433 16.056 9 15.08 9 14c0-1.08.433-2.056 1.128-2.776C9.779 11.082 9.399 11 9 11c-1.654 0-3 1.346-3 3zm6 0c0-.883-.391-1.67-1-2.22-.609.55-1 1.337-1 2.22 0 .883.391 1.67 1 2.22.609-.55 1-1.337 1-2.22z"],"paired-device_16":["M8 11c-1.104 0-2 .896-2 2 0 1.104.896 2 2 2 1.104 0 2-.896 2-2 0-1.104-.896-2-2-2m0 1c.551 0 1 .448 1 1 0 .552-.449 1-1 1-.551 0-1-.448-1-1 0-.552.449-1 1-1zm2.4746-.9746c-.128 0-.256-.049-.354-.146-1.131-1.132-3.108-1.134-4.242 0-.196.195-.512.195-.707 0-.196-.196-.196-.512 0-.708.756-.755 1.76-1.171 2.828-1.171 1.07 0 2.075.416 2.829 1.171.195.196.195.513 0 .708-.098.097-.226.146-.354.146zM4.2241 9.501c-.133 0-.265-.053-.363-.156-.19-.201-.181-.518.02-.707C4.9991 7.582 6.4621 7 8.0001 7c1.532 0 2.99.577 4.106 1.626.202.189.212.505.023.706-.191.203-.508.211-.706.023C10.4921 8.481 9.2761 8 8.0001 8c-1.282 0-2.501.484-3.433 1.364-.096.092-.22.137-.343.137zM14 2c1.104 0 2 .896 2 2l0 8c0 1.104-.896 2-2 2l-1.5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1.5 0c.552 0 1-.448 1-1l0-8c0-.551-.448-1-1-1L2 3c-.551 0-1 .449-1 1l0 8c0 .552.449 1 1 1l1.5 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L2 14c-1.104 0-2-.896-2-2l0-8c0-1.104.896-2 2-2l12 0z"],"paired-handset_16":["M2.65186929 2c-.203 0-.392.092-.517.252-.121.157-.163000004.356-.115.546.552 2.173 2.125 4.676 4.317 6.867 2.19 2.19 4.69200001 3.763 6.86500001 4.315.191.047.39.006.547-.116.16-.124.252-.312.252-.515l0-1.5c0-.412-.245-.783-.622-.945l-1.318-.567c-.382-.164-.817-.152-1.18900001.035l-.75.375c-.442.219-.978.162-1.363-.149-1.295-1.039-2.525-2.262-3.375-3.354-.299-.385-.354-.915-.137-1.35l.383-.766c.186-.372.199-.805.034-1.188l-.567-1.318c-.163-.378-.534-.622-.945-.622l-1.5 0zM13.3598693 15c-.135 0-.27-.017-.404-.05-2.34300001-.596-5.01300001-2.264-7.32600001-4.578-2.316-2.315-3.984000004-4.985-4.5790000042-7.328-.125-.491-.017-1.003.2950000002-1.405.316-.406.792000004-.639 1.306000004-.639l1.5 0c.812 0 1.543.482 1.863 1.228l.567 1.317c.282.654.26 1.394-.058 2.031l-.383.765c-.046.093-.034.203.032.288.792 1.019 1.994 2.211 3.212 3.189.085.069.197.081.289.034l.75-.375c.63700001-.317 1.37600001-.339 2.03200001-.059l1.317.567c.746.32 1.228 1.052 1.228 1.864l0 1.5c0 .514-.233.989-.638 1.305-.293.227-.644.346-1.003.346zM13.5 2C14.881 2 16 3.119 16 4.5 16 5.881 14.881 7 13.5 7c-.356 0-.693-.077-1-.211-.307.134-.644.211-1 .211C10.119 7 9 5.881 9 4.5 9 3.119 10.119 2 11.5 2c.356 0 .693.077 1 .211.307-.134.644-.211 1-.211zm0 4c.827 0 1.5-.673 1.5-1.5 0-.827-.673-1.5-1.5-1.5-.004 0-.007.001-.011.001.317.419.511.935.511 1.499 0 .564-.194 1.08-.511 1.499.004 0 .007.001.011.001zM10 4.5c0 .827.673 1.5 1.5 1.5.004 0 .007-.001.011-.001C11.194 5.58 11 5.064 11 4.5c0-.564.194-1.08.511-1.499-.004 0-.007-.001-.011-.001-.827 0-1.5.673-1.5 1.5zm3 0c0-.441-.195-.835-.5-1.109-.305.274-.5.668-.5 1.109 0 .441.195.835.5 1.109.305-.274.5-.668.5-1.109z"],"paired-handset_24":["M21.1324 16.1772423c1.135.4879849 1.868 1.6009504 1.868 2.8359122l0 2.5389213c0 .7619764-.345 1.4669546-.947 1.9349401-.433.3359896-.952.5129841-1.483.5129841-.199 0-.4-.0249992-.598-.0759976-3.906-.9919693-8.368-3.7818829-12.241-7.6557629-3.874-3.87388-6.665-8.33574176-7.656-12.23962083-.185-.72697748-.025-1.48595397.438-2.081935505C.9804 1.344701813 1.6864.9997125 2.4474.9997125l2.539 0c1.236 0 2.349.733977263 2.836 1.86794214l.959 2.22993092c.436 1.01396859.403 2.15993309-.09 3.14490257l-.647 1.29395992c-.139.27799139-.104.6069812.091.85797342 1.374 1.76694523 3.376 3.75388373 5.492 5.45283113.246.1979938.581.2369926.86.096997l1.27-.6349804c.988-.4939847 2.135-.5249837 3.145-.0909972l2.23.9589703zm.868 5.3748335l0-2.5389213c0-.8349742-.496-1.5869509-1.263-1.9179406l-2.229-.9579703c-.745-.3199901-1.582-.2939909-2.304.0659979l-1.269.6349804c-.625.3129903-1.383.2299928-1.933-.2109935-2.175-1.744946-4.236-3.7938825-5.656-5.6188259-.434-.55898273-.509-1.29295999-.197-1.9189406l.648-1.29395992c.36-.72197763.385-1.56095164.066-2.30292866l-.959-2.22993092c-.33-.76697624-1.083-1.262960877-1.918-1.262960877l-2.539 0c-.451 0-.868.204993647-1.145.560982627-.273.34998915-.366.79497537-.258 1.22196214.948 3.7348843 3.644 8.02775131 7.394 11.77863511 3.75 3.7498839 8.043 6.4448004 11.78 7.393771.426.1089966.87.0139995 1.221-.2569921.357-.2779914.561-.6949784.561-1.1459645zm-5.5-10.55917287c-1.933 0-3.5-1.56695146-3.5-3.49989158 0-1.93294012 1.567-3.49989158 3.5-3.49989158.745 0 1.433.23699266 2 .63298039.567-.39598773 1.255-.63298039 2-.63298039 1.933 0 3.5 1.56695146 3.5 3.49989158 0 1.93294012-1.567 3.49989158-3.5 3.49989158-.745 0-1.433-.23699266-2-.63298039-.567.39598773-1.255.63298039-2 .63298039zm0-5.99981414c-1.378 0-2.5 1.12096528-2.5 2.49992256 0 1.37795732 1.122 2.49992256 2.5 2.49992256.46 0 .886-.13399585 1.256-.35098913-.466-.59498157-.756-1.33495864-.756-2.14893343 0-.81397478.29-1.55395186.756-2.14893343-.37-.21699328-.796-.35098913-1.256-.35098913zm6.5 2.49992256c0-1.37895728-1.122-2.49992256-2.5-2.49992256-.46 0-.886.13399585-1.256.35098913.466.59498157.756 1.33495865.756 2.14893343 0 .81397479-.29 1.55395186-.756 2.14893343.37.21699328.796.35098913 1.256.35098913 1.378 0 2.5-1.12196524 2.5-2.49992256zm-4.5-1.484954c-.31.41698708-.5.92697129-.5 1.484954 0 .55798272.19 1.06796692.5 1.484954.31-.41698708.5-.92697128.5-1.484954 0-.55798271-.19-1.06796692-.5-1.484954z"],"pairing_14":["M9 11c-.31 0-.607-.043-.897-.11C9.25 9.973 10 8.579 10 7c0-1.579-.75-2.973-1.897-3.89C8.393 3.043 8.69 3 9 3c2.206 0 4 1.794 4 4 0 2.206-1.794 4-4 4m0-4c0 1.474-.811 2.75-2 3.444C5.811 9.75 5 8.474 5 7c0-1.474.811-2.75 2-3.444C8.189 4.25 9 5.526 9 7m-4 4c-2.206 0-4-1.794-4-4 0-2.206 1.794-4 4-4 .31 0 .607.043.897.11C4.75 4.027 4 5.421 4 7c0 1.579.75 2.973 1.897 3.89-.29.067-.587.11-.897.11m4-9c-.712 0-1.387.154-2 .424C6.387 2.154 5.712 2 5 2 2.243 2 0 4.243 0 7c0 2.757 2.243 5 5 5 .712 0 1.387-.154 2-.424.613.27 1.288.424 2 .424 2.757 0 5-2.243 5-5 0-2.757-2.243-5-5-5"],"pairing_16":["M10 13c-.206 0-.401-.037-.602-.061C10.968 11.856 12 10.047 12 8c0-2.047-1.032-3.856-2.602-4.939C9.599 3.037 9.794 3 10 3c2.757 0 5 2.243 5 5 0 2.757-2.243 5-5 5M8 3.424c1.763.774 3 2.531 3 4.576 0 2.045-1.237 3.802-3 4.576C6.237 11.802 5 10.045 5 8c0-2.045 1.237-3.802 3-4.576M6 13c-2.757 0-5-2.243-5-5 0-2.757 2.243-5 5-5 .206 0 .401.037.602.061C5.032 4.144 4 5.953 4 8c0 2.047 1.032 3.856 2.602 4.939-.201.024-.396.061-.602.061m4-11c-.702 0-1.373.127-2 .35C7.373 2.127 6.702 2 6 2 2.691 2 0 4.691 0 8c0 3.309 2.691 6 6 6 .702 0 1.373-.127 2-.35.627.223 1.298.35 2 .35 3.309 0 6-2.691 6-6 0-3.309-2.691-6-6-6"],"pairing_20":["M13 16c-.673 0-1.318-.116-1.923-.322C12.844 14.406 14 12.338 14 10c0-2.338-1.156-4.406-2.923-5.678C11.682 4.116 12.327 4 13 4c3.309 0 6 2.691 6 6 0 3.309-2.691 6-6 6M10 4.812c1.79 1.039 3 2.973 3 5.188 0 2.215-1.21 4.149-3 5.188C8.21 14.149 7 12.215 7 10c0-2.215 1.21-4.149 3-5.188M7 16c-3.309 0-6-2.691-6-6 0-3.309 2.691-6 6-6 .673 0 1.318.116 1.922.322C7.156 5.594 6 7.662 6 10c0 2.338 1.156 4.406 2.923 5.678C8.318 15.884 7.673 16 7 16m6-13c-1.075 0-2.089.251-3 .685C9.089 3.251 8.074 3 7 3c-3.86 0-7 3.14-7 7 0 3.859 3.14 7 7 7 1.074 0 2.089-.251 3-.685.911.434 1.925.685 3 .685 3.859 0 7-3.141 7-7 0-3.86-3.141-7-7-7"],"pairing_24":["M23 12.084C23 15.897 19.897 19 16.084 19l-.168 0c-1.065 0-2.07-.249-2.972-.681C14.8 16.869 16 14.616 16 12.084l0-.167c0-2.533-1.2-4.786-3.056-6.236.902-.432 1.907-.681 2.972-.681l.168 0C19.897 5 23 8.103 23 11.917l0 .167zM12 6.222c1.81 1.248 3 3.334 3 5.695l0 .167c0 2.36-1.19 4.446-3 5.694-1.81-1.248-3-3.334-3-5.694l0-.167c0-2.361 1.19-4.447 3-5.695zM8.084 19l-.168 0C4.103 19 1 15.897 1 12.084l0-.167C1 8.103 4.103 5 7.916 5l.168 0c1.065 0 2.07.249 2.972.681C9.2 7.131 8 9.384 8 11.917l0 .167c0 2.532 1.2 4.785 3.056 6.235-.902.432-1.907.681-2.972.681zm8-15l-.168 0c-1.425 0-2.76.384-3.916 1.045C10.844 4.384 9.509 4 8.084 4l-.168 0C3.551 4 0 7.551 0 11.917l0 .167C0 16.449 3.551 20 7.916 20l.168 0c1.425 0 2.76-.384 3.916-1.045 1.156.661 2.491 1.045 3.916 1.045l.168 0C20.449 20 24 16.449 24 12.084l0-.167C24 7.551 20.449 4 16.084 4z"],"pairing_28":["M19 22c-1.523 0-2.943-.436-4.156-1.178C16.77 19.169 18 16.723 18 14c0-2.723-1.23-5.169-3.156-6.822C16.057 6.436 17.477 6 19 6c4.411 0 8 3.589 8 8 0 4.411-3.589 8-8 8m-2-8c0 2.52-1.174 4.768-3 6.235-1.826-1.467-3-3.715-3-6.235 0-2.52 1.174-4.768 3-6.235 1.826 1.467 3 3.715 3 6.235m-8 8c-4.411 0-8-3.589-8-8 0-4.411 3.589-8 8-8 1.523 0 2.943.436 4.156 1.178C11.23 8.832 10 11.277 10 14c0 2.723 1.23 5.168 3.156 6.822C11.943 21.564 10.523 22 9 22M19 5c-1.847 0-3.567.565-5 1.529C12.567 5.565 10.847 5 9 5c-4.95 0-9 4.05-9 9 0 4.95 4.05 9 9 9 1.847 0 3.567-.565 5-1.529 1.433.964 3.153 1.529 5 1.529 4.95 0 9-4.05 9-9 0-4.95-4.05-9-9-9"],"pairing_56":["M54 28.0317c0 8.805-7.163 15.968-15.969 15.968l-.062 0c-3.404 0-6.554-1.078-9.147-2.898 3.767-3.119 6.178-7.826 6.178-13.07l0-.063c0-5.244-2.411-9.951-6.178-13.07 2.593-1.821 5.744-2.899 9.147-2.899l.062 0c8.806 0 15.969 7.163 15.969 15.969l0 .063zm-26-12.518c3.652 2.929 6 7.42 6 12.455l0 .063c0 5.035-2.348 9.526-6 12.455-3.652-2.929-6-7.42-6-12.455l0-.063c0-5.035 2.348-9.526 6-12.455zm-9.968 28.486l-.064 0C9.163 43.9997 2 36.8367 2 28.0317l0-.063c0-8.806 7.163-15.969 15.968-15.969l.064 0c3.402 0 6.552 1.078 9.146 2.899-3.767 3.119-6.178 7.826-6.178 13.07l0 .063c0 5.244 2.411 9.951 6.178 13.07-2.594 1.82-5.744 2.898-9.146 2.898zm19.999-33l-.062 0c-3.723 0-7.163 1.229-9.969 3.282-2.806-2.053-6.246-3.282-9.968-3.282l-.064 0C8.636 10.9997 1 18.6357 1 27.9687l0 .063c0 9.333 7.636 16.968 16.968 16.968l.064 0c3.722 0 7.162-1.228 9.968-3.281 2.806 2.053 6.246 3.281 9.969 3.281l.062 0c9.333 0 16.969-7.635 16.969-16.968l0-.063c0-9.333-7.636-16.969-16.969-16.969z"],"panel-control-bar_36":["M2,16H34a2,2,0,0,1,2,2h0a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2H0A2,2,0,0,1,2,16Z"],"panel-control-down_12":["M12 5.19449015c0-.19322613-.04705577-.3904363-.14717444-.5717103-.31837737-.57967838-1.04824247-.79282473-1.62993193-.47609324L5.99488224 6.4434879 1.77688272 4.15863874c-.58269066-.31473946-1.31255575-.10159312-1.62993193.47808527-.31837737.57868237-.10212105 1.30577037.48157079 1.62150585l4.79368187 2.59660058c.35842484.19422214.79193867.19322613 1.15036351-.00099601l4.80169136-2.60954873C11.77373181 6.02715531 12 5.61779481 12 5.19449015"],"panel-control-down_24":["M12 16.0000219c-.2519794 0-.5039589-.048-.7429394-.143l-9.99918386-4c-1.025916266-.411-1.524875543-1.574-1.113909085-2.6.40996654-1.025000002 1.570871795-1.523000002 2.599787815-1.114000002L12 11.8460219l9.2562445-3.703000002c1.0289161-.408 2.1898213.089 2.5997878 1.114000002.4109665 1.026-.0879928 2.189-1.113909 2.6l-9.9991839 4c-.2389805.095-.49096.143-.7429394.143"],"panel-control-down_28":["M14.0002 19.0007c-.207 0-.413-.064-.588-.191l-11-8c-.447-.325-.546-.951-.221-1.397.325-.446.951-.546 1.397-.221l10.412 7.573 10.412-7.573c.446-.326 1.071-.226 1.397.221.325.446.226 1.072-.221 1.397l-11 8c-.175.127-.381.191-.588.191"],"panel-control-down_36":["M17.5005651 23.0009794c-.252 0-.504-.04799999-.743-.14299999l-15.00000004-6c-1.026000004-.41-1.524000004-1.574-1.114000004-2.6.411000004-1.026000004 1.574000004-1.525000004 2.600000004-1.114000004L17.5235651 18.85597941l15.275-5.728000004c1.035-.388 2.186.137 2.575 1.171000004.388 1.034-.137 2.187-1.171 2.575l-16 6c-.226.085-.464.12699999-.702.12699999"],"panel-control-down-iph_12":["M12 5.19449015c0-.19322613-.04705577-.3904363-.14717444-.5717103-.31837737-.57967838-1.04824247-.79282473-1.62993193-.47609324L5.99488224 6.4434879 1.77688272 4.15863874c-.58269066-.31473946-1.31255575-.10159312-1.62993193.47808527-.31837737.57868237-.10212105 1.30577037.48157079 1.62150585l4.79368187 2.59660058c.35842484.19422214.79193867.19322613 1.15036351-.00099601l4.80169136-2.60954873C11.77373181 6.02715531 12 5.61779481 12 5.19449015"],"panel-control-down-iph_24":["M12 16.0000219c-.2519794 0-.5039589-.048-.7429394-.143l-9.99918386-4c-1.025916266-.411-1.524875543-1.574-1.113909085-2.6.40996654-1.025000002 1.570871795-1.523000002 2.599787815-1.114000002L12 11.8460219l9.2562445-3.703000002c1.0289161-.408 2.1898213.089 2.5997878 1.114000002.4109665 1.026-.0879928 2.189-1.113909 2.6l-9.9991839 4c-.2389805.095-.49096.143-.7429394.143"],"panel-control-down-iph_36":["M17.5005651 23.0009794c-.252 0-.504-.04799999-.743-.14299999l-15.00000004-6c-1.026000004-.41-1.524000004-1.574-1.114000004-2.6.411000004-1.026000004 1.574000004-1.525000004 2.600000004-1.114000004L17.5235651 18.85597941l15.275-5.728000004c1.035-.388 2.186.137 2.575 1.171000004.388 1.034-.137 2.187-1.171 2.575l-16 6c-.226.085-.464.12699999-.702.12699999"],"panel-control-dragger_14":["M5.5 0c.276142375 0 .5.223857625.5.5l0 1c0 .27614237-.223857625.5-.5.5-.276142375 0-.5-.22385763-.5-.5l0-1c0-.276142375.223857625-.5.5-.5zm0 8c.276142375 0 .5.22385763.5.5l0 1c0 .27614237-.223857625.5-.5.5-.276142375 0-.5-.22385763-.5-.5l0-1c0-.27614237.223857625-.5.5-.5zm0-4c.276142375 0 .5.22385763.5.5l0 1c0 .27614237-.223857625.5-.5.5-.276142375 0-.5-.22385763-.5-.5l0-1c0-.27614237.223857625-.5.5-.5zm0 8c.276142375 0 .5.2238576.5.5l0 1c0 .2761424-.223857625.5-.5.5-.276142375 0-.5-.2238576-.5-.5l0-1c0-.2761424.223857625-.5.5-.5zm3-12c.27614237 0 .5.223857625.5.5l0 1c0 .27614237-.22385763.5-.5.5-.27614237 0-.5-.22385763-.5-.5l0-1c0-.276142375.22385763-.5.5-.5zm0 8c.27614237 0 .5.22385763.5.5l0 1c0 .27614237-.22385763.5-.5.5-.27614237 0-.5-.22385763-.5-.5l0-1c0-.27614237.22385763-.5.5-.5zm0-4c.27614237 0 .5.22385763.5.5l0 1c0 .27614237-.22385763.5-.5.5-.27614237 0-.5-.22385763-.5-.5l0-1c0-.27614237.22385763-.5.5-.5zm0 8c.27614237 0 .5.2238576.5.5l0 1c0 .2761424-.22385763.5-.5.5-.27614237 0-.5-.2238576-.5-.5l0-1c0-.2761424.22385763-.5.5-.5z"],"panel-control-left_12":["M6.80533595 11.9998234c.19322612 0 .390436294-.0470558.57171029-.1471745.5796783819-.3183773.792824728-1.0482424.476093241-1.6299319L5.5563382 5.99470563l2.28484915-4.21799952c.314739465-.58269065.1015931183-1.312555751-.478085264-1.629931932C6.78441972-.171603189 6.05733171.0446531359 5.74159623.628344976L3.14499565 5.42202684c-.19422214.35842484-.19322613.79193867.00099601 1.15036351l2.60954873 4.80169135c.21713039.3994735.6264909.6257417 1.04979556.6257417"],"panel-control-left_16":["M9.6573-.0001c.207 0 .417.047.614.146.679.339.954 1.165.615 1.844l-3.005 6.01 3.005 6.01c.339.679.064 1.505-.615 1.845-.679.339-1.505.064-1.845-.615l-3.312-6.625c-.194-.387-.194-.843 0-1.23l3.312-6.624c.241-.482.727-.761 1.231-.761"],"panel-control-left_24":["M7.9999781 12c0-.2519794.048-.5039589.143-.7429394l4-9.99918386c.411-1.025916266 1.574-1.524875543 2.6-1.113909085 1.025000002.40996654 1.523000002 1.570871795 1.114000002 2.599787815L12.1539781 12l3.703000002 9.2562445c.408 1.0289161-.089 2.1898213-1.114000002 2.5997878-1.026.4109665-2.189-.0879928-2.6-1.113909l-4-9.9991839c-.095-.2389805-.143-.49096-.143-.7429394"],"panel-control-left_36":["M13.0000006 17.5005651c0-.252.04799999-.504.14299999-.743l6-15.00000004c.41-1.026000004 1.574-1.524000004 2.6-1.114000004 1.026000004.411000004 1.525000004 1.574000004 1.114000004 2.600000004L17.14500059 17.5235651l5.728000004 15.275c.388 1.035-.137 2.186-1.171000004 2.575-1.034.388-2.187-.137-2.575-1.171l-6-16c-.085-.226-.12699999-.464-.12699999-.702"],"panel-control-left-iph_12":["M6.80533595 11.9998234c.19322612 0 .390436294-.0470558.57171029-.1471745.5796783819-.3183773.792824728-1.0482424.476093241-1.6299319L5.5563382 5.99470563l2.28484915-4.21799952c.314739465-.58269065.1015931183-1.312555751-.478085264-1.629931932C6.78441972-.171603189 6.05733171.0446531359 5.74159623.628344976L3.14499565 5.42202684c-.19422214.35842484-.19322613.79193867.00099601 1.15036351l2.60954873 4.80169135c.21713039.3994735.6264909.6257417 1.04979556.6257417"],"panel-control-left-iph_24":["M7.9999781 12c0-.2519794.048-.5039589.143-.7429394l4-9.99918386c.411-1.025916266 1.574-1.524875543 2.6-1.113909085 1.025000002.40996654 1.523000002 1.570871795 1.114000002 2.599787815L12.1539781 12l3.703000002 9.2562445c.408 1.0289161-.089 2.1898213-1.114000002 2.5997878-1.026.4109665-2.189-.0879928-2.6-1.113909l-4-9.9991839c-.095-.2389805-.143-.49096-.143-.7429394"],"panel-control-left-iph_36":["M13.0000006 17.5005651c0-.252.04799999-.504.14299999-.743l6-15.00000004c.41-1.026000004 1.574-1.524000004 2.6-1.114000004 1.026000004.411000004 1.525000004 1.574000004 1.114000004 2.600000004L17.14500059 17.5235651l5.728000004 15.275c.388 1.035-.137 2.186-1.171000004 2.575-1.034.388-2.187-.137-2.575-1.171l-6-16c-.085-.226-.12699999-.464-.12699999-.702"],"panel-control-right_12":["M5.19431605 11.9998234c-.19322612 0-.390436294-.0470558-.57171029-.1471745-.5796783819-.3183773-.792824728-1.0482424-.476093241-1.6299319L6.4433138 5.99470563 4.15846465 1.77670611c-.314739465-.58269065-.1015931183-1.312555751.478085264-1.629931932C5.21523228-.171603189 5.94232029.0446531359 6.25805577.628344976L8.85465635 5.42202684c.19422214.35842484.19322613.79193867-.00099601 1.15036351L6.24411161 11.3740817c-.21713039.3994735-.6264909.6257417-1.04979556.6257417"],"panel-control-right_16":["M6.3428 16.0002084c-.207 0-.417-.0469983-.614-.1459947-.679-.3389878-.954-1.1649579-.615-1.8439334l3.005-6.00978263-3.005-6.01078264c-.339-.67897545-.064-1.504945576.615-1.843933318.679-.339987705 1.505-.0639976855 1.845.614977761l3.312 6.624760437c.194.38598604.194.84296951 0 1.22895555l-3.312 6.62476044c-.241.4819826-.727.7609725-1.231.7609725"],"panel-control-right_24":["M16.0000219 12c0-.2519794-.048-.5039589-.143-.7429394l-4-9.99918386c-.411-1.025916266-1.574-1.524875543-2.6-1.113909085C8.232021898.553934195 7.734021898 1.71483945 8.143021898 2.74375547L11.8460219 12l-3.703000002 9.2562445c-.408 1.0289161.089 2.1898213 1.114000002 2.5997878 1.026.4109665 2.189-.0879928 2.6-1.113909l4-9.9991839c.095-.2389805.143-.49096.143-.7429394"],"panel-control-right_36":["M22.9999994 17.5005651c0-.252-.04799999-.504-.14299999-.743l-6-15.00000004c-.41-1.026000004-1.574-1.524000004-2.6-1.114000004-1.026000004.411000004-1.525000004 1.574000004-1.114000004 2.600000004L18.85499941 17.5235651l-5.728000004 15.275c-.388 1.035.137 2.186 1.171000004 2.575 1.034.388 2.187-.137 2.575-1.171l6-16c.085-.226.12699999-.464.12699999-.702"],"panel-control-right-iph_12":["M5.19431605 11.9998234c-.19322612 0-.390436294-.0470558-.57171029-.1471745-.5796783819-.3183773-.792824728-1.0482424-.476093241-1.6299319L6.4433138 5.99470563 4.15846465 1.77670611c-.314739465-.58269065-.1015931183-1.312555751.478085264-1.629931932C5.21523228-.171603189 5.94232029.0446531359 6.25805577.628344976L8.85465635 5.42202684c.19422214.35842484.19322613.79193867-.00099601 1.15036351L6.24411161 11.3740817c-.21713039.3994735-.6264909.6257417-1.04979556.6257417"],"panel-control-right-iph_24":["M16.0000219 12c0-.2519794-.048-.5039589-.143-.7429394l-4-9.99918386c-.411-1.025916266-1.574-1.524875543-2.6-1.113909085C8.232021898.553934195 7.734021898 1.71483945 8.143021898 2.74375547L11.8460219 12l-3.703000002 9.2562445c-.408 1.0289161.089 2.1898213 1.114000002 2.5997878 1.026.4109665 2.189-.0879928 2.6-1.113909l4-9.9991839c.095-.2389805.143-.49096.143-.7429394"],"panel-control-right-iph_36":["M22.9999994 17.5005651c0-.252-.04799999-.504-.14299999-.743l-6-15.00000004c-.41-1.026000004-1.574-1.524000004-2.6-1.114000004-1.026000004.411000004-1.525000004 1.574000004-1.114000004 2.600000004L18.85499941 17.5235651l-5.728000004 15.275c-.388 1.035.137 2.186 1.171000004 2.575 1.034.388 2.187-.137 2.575-1.171l6-16c.085-.226.12699999-.464.12699999-.702"],"panel-control-thin-down_12":["M5.99987227 8.82999992c-.193 0-.387-.05596521-.555-.16789565L.444872268 5.33117451c-.4590000005-.30580993-.583-.92642421-.277-1.386138487.306-.4587149.926000002-.583637258 1.387000002-.276827946l4.445 2.961159583 4.44500003-2.961159583c.46-.306809312 1.08-.181886954 1.387.276827946.306.459714277.182 1.080328557-.277 1.386138487L6.55487227 8.66210427c-.168.11193044-.362.16789565-.555.16789565"],"panel-control-thin-down_24":["M11.99987227 16.00053c-.193 0-.387-.056-.555-.168l-9.000000002-6c-.4590000005-.306-.583-.927-.277-1.387.306-.46.926000002-.584 1.387000002-.277l8.445 5.63 8.44500003-5.63c.459-.307 1.08-.183 1.387.277.306.46.182 1.081-.277 1.387l-9 6c-.168.112-.362.168-.55500003.168"],"panel-control-thin-down_28":["M14.0002 19.0007c-.207 0-.413-.064-.588-.191l-11-8c-.447-.325-.546-.951-.221-1.397.325-.446.951-.546 1.397-.221l10.412 7.573 10.412-7.573c.446-.326 1.071-.226 1.397.221.325.446.226 1.072-.221 1.397l-11 8c-.175.127-.381.191-.588.191"],"panel-control-thin-left_12":["M2.99999977 5.99987196c0-.193.05596522-.387.16789565-.555l3.33092976-5c.30580994-.459.92642421-.583 1.38613849-.277.4587149.306.58363726.926.27682795 1.387l-2.96115958 4.445 2.96115958 4.445c.30680931.46.18188695 1.08-.27682795 1.387-.45971428.306-1.08032855.182-1.38613849-.277l-3.33092976-5c-.11193043-.168-.16789565-.362-.16789565-.555"],"panel-control-thin-left_24":["M7.999735 12.00013727c0-.193.056-.387.168-.555l6-9.000000002c.306-.4590000005.927-.583 1.387-.277.46.306.584.926000002.277 1.387000002l-5.63 8.445 5.63 8.44500003c.307.459.183 1.08-.277 1.387-.46.306-1.081.182-1.387-.277l-6-9c-.112-.168-.168-.362-.168-.55500003"],"panel-control-thin-right_12":["M9.00000023 5.99987204c0-.193-.05596522-.387-.16789565-.555l-3.33092976-5c-.30580994-.459-.92642421-.583-1.38613849-.277-.4587149.306-.58363726.926-.27682795 1.387l2.96115958 4.445-2.96115958 4.445c-.30680931.46-.18188695 1.08.27682795 1.387.45971428.306 1.08032855.182 1.38613849-.277l3.33092976-5c.11193043-.168.16789565-.362.16789565-.555"],"panel-control-thin-right_24":["M16.00053 11.99987227c0-.193-.056-.387-.168-.555l-6-9.000000002c-.306-.4590000005-.927-.583-1.387-.277-.46.306-.584.926000002-.277 1.387000002l5.63 8.445-5.63 8.44500003c-.307.459-.183 1.08.277 1.387.46.306 1.081.182 1.387-.277l6-9c.112-.168.168-.362.168-.55500003"],"panel-control-thin-up_12":["M5.99987227 3.17000008c-.193 0-.387.05596521-.555.16789565L.444872268 6.66882549c-.4590000005.30580993-.583.92642421-.277 1.386138487.306.4587149.926000002.583637258 1.387000002.276827946l4.445-2.961159583 4.44500003 2.961159583c.46.306809312 1.08.181886954 1.387-.276827946.306-.459714277.182-1.080328557-.277-1.386138487L6.55487227 3.33789573c-.168-.11193044-.362-.16789565-.555-.16789565"],"panel-control-thin-up_24":["M11.99987227 8c-.193 0-.387.056-.555.168l-9.000000002 6c-.4590000005.306-.583.927-.277 1.387.306.46.926000002.584 1.387000002.277l8.445-5.63 8.44500003 5.63c.459.307 1.08.183 1.387-.277.306-.46.182-1.081-.277-1.387l-9-6c-.168-.112-.362-.168-.55500003-.168"],"panel-control-thin-up_28":["M14.0002 8.999916c-.207 0-.413.064-.588.191l-11 8c-.447.325-.546.951-.221 1.397.325.446.951.546 1.397.221l10.412-7.573 10.412 7.573c.446.326 1.071.226 1.397-.221.325-.446.226-1.072-.221-1.397l-11-8c-.175-.127-.381-.191-.588-.191"],"panel-control-thinner-left_24":["M15.0005 21.5c-.162 0-.32-.078-.417-.223l-6-9c-.111-.167-.111-.385 0-.553l5.937-8.969c.152-.23.462-.294.693-.141.23.153.293.463.141.693l-5.754 8.692 5.816 8.724c.153.23.091.54-.139.693-.086.057-.182.084-.277.084"],"panel-control-thinner-right_24":["M9.00016 21.5c.162 0 .32-.078.417-.223l6-9c.111-.167.111-.385 0-.553l-5.937-8.969c-.152-.23-.462-.294-.693-.141-.23.153-.293.463-.141.693l5.754 8.692-5.816 8.724c-.153.23-.091.54.139.693.086.057.182.084.277.084"],"panel-control-up_12":["M12 6.80550985c0 .19322613-.04705577.3904363-.14717444.5717103-.31837737.57967838-1.04824247.79282473-1.62993193.47609324L5.99488224 5.5565121 1.77688272 7.84136126c-.58269066.31473946-1.31255575.10159312-1.62993193-.47808527-.31837737-.57868237-.10212105-1.30577037.48157079-1.62150585l4.79368187-2.59660058c.35842484-.19422214.79193867-.19322613 1.15036351.00099601l4.80169136 2.60954873C11.77373181 5.97284469 12 6.38220519 12 6.80550985"],"panel-control-up_24":["M12 8.0000001c-.2519794 0-.5039589.048-.7429394.143l-9.99918386 4c-1.025916266.411-1.524875543 1.574-1.113909085 2.6.40996654 1.025000002 1.570871795 1.523000002 2.599787815 1.114000002L12 12.1540001l9.2562445 3.703000002c1.0289161.408 2.1898213-.089 2.5997878-1.114000002.4109665-1.026-.0879928-2.189-1.113909-2.6l-9.9991839-4c-.2389805-.095-.49096-.143-.7429394-.143"],"panel-control-up_28":["M14.0002 8.999916c-.207 0-.413.064-.588.191l-11 8c-.447.325-.546.951-.221 1.397.325.446.951.546 1.397.221l10.412-7.573 10.412 7.573c.446.326 1.071.226 1.397-.221.325-.446.226-1.072-.221-1.397l-11-8c-.175-.127-.381-.191-.588-.191"],"panel-control-up_36":["M17.5005651 12.9990206c-.252 0-.504.04799999-.743.14299999l-15.00000004 6c-1.026000004.41-1.524000004 1.574-1.114000004 2.6.411000004 1.026000004 1.574000004 1.525000004 2.600000004 1.114000004L17.5235651 17.14402059l15.275 5.728000004c1.035.388 2.186-.137 2.575-1.171000004.388-1.034-.137-2.187-1.171-2.575l-16-6c-.226-.085-.464-.12699999-.702-.12699999"],"panel-control-up-iph_12":["M12 6.80550985c0 .19322613-.04705577.3904363-.14717444.5717103-.31837737.57967838-1.04824247.79282473-1.62993193.47609324L5.99488224 5.5565121 1.77688272 7.84136126c-.58269066.31473946-1.31255575.10159312-1.62993193-.47808527-.31837737-.57868237-.10212105-1.30577037.48157079-1.62150585l4.79368187-2.59660058c.35842484-.19422214.79193867-.19322613 1.15036351.00099601l4.80169136 2.60954873C11.77373181 5.97284469 12 6.38220519 12 6.80550985"],"panel-control-up-iph_24":["M12 8.0000001c-.2519794 0-.5039589.048-.7429394.143l-9.99918386 4c-1.025916266.411-1.524875543 1.574-1.113909085 2.6.40996654 1.025000002 1.570871795 1.523000002 2.599787815 1.114000002L12 12.1540001l9.2562445 3.703000002c1.0289161.408 2.1898213-.089 2.5997878-1.114000002.4109665-1.026-.0879928-2.189-1.113909-2.6l-9.9991839-4c-.2389805-.095-.49096-.143-.7429394-.143"],"panel-control-up-iph_36":["M17.5005651 12.9990206c-.252 0-.504.04799999-.743.14299999l-15.00000004 6c-1.026000004.41-1.524000004 1.574-1.114000004 2.6.411000004 1.026000004 1.574000004 1.525000004 2.600000004 1.114000004L17.5235651 17.14402059l15.275 5.728000004c1.035.388 2.186-.137 2.575-1.171000004.388-1.034-.137-2.187-1.171-2.575l-16-6c-.226-.085-.464-.12699999-.702-.12699999"],"parked_16":["M8.0002 4.99999c-2.654 0-5.121.557-6.77 1.528-.172.101-.216.26-.226.345-.019.147.032.292.139.398l.912.904c.231.229.577.297.882.179l1.146-.452c.314-.124.555-.377.662-.693l.227-.678c.144-.426.528-.732.978-.781 1.428-.154 2.927-.158 4.11-.012.443.054.822.361.963.78l.233.691c.106.316.347.569.661.693l1.146.452c.304.119.65.05.882-.179l.912-.904c.107-.106.158-.251.139-.398-.01-.085-.054-.244-.226-.345-1.647-.971-4.115-1.528-6.77-1.528m-5.366 4.412c-.472 0-.935-.183-1.282-.526l-.914-.905c-.328-.325-.483-.774-.427-1.232.057-.455.316-.85.712-1.082 1.798-1.06 4.45-1.667 7.277-1.667 2.829 0 5.481.607 7.277 1.667.396.232.655.627.712 1.082.056.458-.099.907-.427 1.232l-.913.904c-.514.51-1.28.665-1.953.399l-1.147-.452c-.589-.233-1.041-.708-1.241-1.304l-.233-.691c-.019-.057-.072-.098-.138-.107-1.094-.135-2.544-.13-3.879.015-.066.007-.119.047-.138.105l-.228.678c-.201.596-.653 1.071-1.241 1.304l-1.147.452c-.218.086-.445.128-.67.128zm10.866 2.5841l-11 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l11 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5z"],"parked_20":["M19.9864683 8.37405468c.0669975.54061102-.1169955 1.07119216-.5029808 1.45433392l-1.155956 1.1484223c-.6119767.60881426-1.5269418.7953702-2.3309112.47842571l-1.4519447-.57571564c-.708973-.28083689-1.2539522-.85454655-1.4949431-1.57469258l-.2949887-.87761529c-.0409985-.12236465-.1499943-.20962469-.2849892-.22567251-1.3979467-.17452007-3.2468763-.16749915-4.94481163.0180538-.13199498.01504483-.24499067.10230487-.28498915.22366653l-.28998895.86156747c-.24099082.72014603-.78597007 1.29385569-1.49494306 1.57469258l-1.4519447.57471265c-.2599901.10330785-.53197974.1534573-.8009695.1534573-.56297855 0-1.11495753-.21865158-1.52894176-.62987703L.516209915 9.8283886c-.385985299-.38314176-.5689783291-.9137229-.5029808428-1.45433392.0669974482-.53559607.3719858318-1.00098293.8369681218-1.27580189C3.10711123 5.764277547 6.44198422 5 9.9998487 5c3.5588645 0 6.8937374.764277547 9.1506515 2.09825279.4639823.27481896.7689707.74020582.8359681 1.27580189zm-1.206954.74221179c.1649937-.16348719.2429908-.38915969.2139919-.61784116-.026999-.22567251-.1549941-.42125534-.3509867-.53659907-2.1069197-1.24571222-5.2567998-1.95883733-8.6426708-1.95883733-3.38487107 0-6.5347511.71312511-8.64167085 1.95883733-.19599254.11534373-.32398766.31092656-.3519866.53659907-.028998893.22868147.04899814.45435397.21399185.61784116l1.15595597 1.14942529c.32998744.32797737.82496858.43028224 1.25895205.25576217l1.45294466-.57471264c.43398347-.17251409.76697079-.52255722.91396519-.96086337l.28998896-.86257046c.16399375-.49046158.60597692-.84451666 1.12495715-.90068404.92496477-.10029889 1.87392863-.15145133 2.77989412-.15145133.8549674 0 1.6719363.0451345 2.3959087.13540351.5119805.0631883.946964.41724338 1.1099578.90068403l.2949887.8776153c.1469944.43930914.4799818.79035526.9139652.96186636l1.4519447.57571563c.4359834.1715111.9299646.07121221 1.260952-.25776815l1.154956-1.1484223zm-2.2797132 4.88074462c.2749896 0 .499981.22567251.499981.50149446 0 .27582195-.2249914.50149445-.499981.50149445L3.50029626 15c-.27498953 0-.49998096-.2256725-.49998096-.50149445 0-.27582195.22499143-.50149446.49998096-.50149446l12.99950484 0z"],"parked_24":["M19.4995054 16.9999333c.2749928 0 .499987.225015.499987.5000334 0 .2750183-.2249942.5000333-.499987.5000333L4.49989466 18c-.27499286 0-.49998702-.225015-.49998702-.5000333 0-.2750184.22499416-.5000334.49998702-.5000334l14.99961074 0zm4.4836836-6.90466028c.0799979.6360424-.1279967 1.260084-.5709852 1.71411427l-1.3999637 1.43509568c-.4829874.49403293-1.1269707.75705047-1.7829537.75705047-.3149918 0-.6329836-.060004-.9369757-.18501234l-1.7579543-.71804787c-.8279786-.33802253-1.463962-1.02806854-1.7449548-1.89212614l-.3569907-1.09607307c-.0639983-.1980132-.229994-.3360224-.4319888-.36202414-1.6989559-.2190146-3.9438976-.210014-6.00584409.02200147-.19999481.02200147-.37099038.16301087-.43498871.360024l-.34999092 1.07607174c-.28099271.8640576-.9169762 1.55310354-1.74495471 1.89212614l-1.7569544.71804787c-.9399756.38302554-2.00694791.1590106-2.72092938-.57203813L.587796201 11.80938729c-.442988502-.45403027-.6509831039-1.07807187-.5709851802-1.71411427.0779979756-.6240416.4259889432-1.16607774.9539752402-1.48809921C3.68771574 6.950063338 7.70761141 6 11.9995 6c4.2928886 0 8.3127843.950063338 11.0297137 2.60817388.5269864.3210214.8749773.86305754.9539753 1.48709914zm-1.2869666 1.01606774c.228994-.23501567.3359913-.56003734.2939924-.89105941-.039999-.32002133-.2159944-.59603973-.4819875-.7590506C19.9442938 7.89712648 16.1133932 7.00006667 11.9995 7.00006667c-4.11389321 0-7.94379381.89705981-10.50872724 2.46116408-.26599309.1620108-.44198852.43902927-.48198749.7590506-.041998906.33202214.06499832.65604374.29399237.89105941l1.39996367 1.43509567c.42798889.43902927 1.06597233.57403827 1.62695777.34402293l1.7569544-.71804787c.55498559-.22701513.98197451-.69104607 1.17196958-1.275085l.34999092-1.07707181c.1849952-.56803787.68498222-.9780652 1.27396693-1.0440696 1.11597104-.12500833 2.26094129-.18801254 3.35391299-.18801254 1.0309732 0 2.0169476.05600374 2.8909249.16801121.5809849.07400493 1.0739722.48403226 1.2569674 1.04506967l.3559908 1.09607307c.189995.58403893.616984 1.04806987 1.1719695 1.275085l1.7579544.71804787c.5609855.23001534 1.1979689.09500634 1.6259578-.34402293l1.3999637-1.43509567z"],"participant-add_12":["M6.49950724 11c.276 0 .5.224.5.5 0 .276-.224.5-.5.5L.843507238 12c-.264 0-.509-.119-.67-.327-.1580000001-.204-.2110000001-.463-.1470000001-.712L.429507238 9.395c.349-1.352 1.556000002-2.303 2.970000002-2.38-.85-.734-1.4-1.806-1.4-3.015 0-2.206 1.794-4 4-4 2.206 0 4 1.794 4 4 0 2.205-1.793 4-3.999 4l-.001 0-2.418 0c-1.035 0-1.934.676-2.184 1.645l-.349 1.355 5.451 0zm-3.5-7c0 1.654 1.346 3 3 3 1.654 0 3-1.346 3-3 0-1.654-1.346-3-3-3-1.654 0-3 1.346-3 3zm8.49999996 5c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1.49999996 0 0 1.5c0 .275-.225.5-.5.5-.274 0-.5-.225-.5-.5l0-1.5-1.5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1.5 0 0-1.5c0-.275.226-.5.5-.5.275 0 .5.225.5.5l0 1.5 1.49999996 0z"],"participant-add_16":["M9.50023807 15c.276 0 .50000003.224.50000003.5 0 .276-.22400003.5-.50000003.5L.969238071 16c-.291 0-.565-.134-.749-.366-.1949999998-.244-.2639999998-.562-.1929999998-.869l.5509999998-2.349C1.04923807 10.405 2.74523807 9 4.70323807 9l.328 0c-1.225-.912-2.031-2.358-2.031-4 0-2.757 2.243-5 5-5 2.75700003 0 5.00000003 2.243 5.00000003 5 0 2.757-2.243 5-5.00000003 5l-3.297 0c-1.491 0-2.787 1.087-3.151 2.645l-.551 2.348 8.499.007zm-5.5-10c0 2.206 1.795 4 4 4 2.20600003 0 4.00000003-1.794 4.00000003-4 0-2.206-1.794-4-4.00000003-4-2.205 0-4 1.794-4 4zm11.50000003 7c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-2.5 0 0 2.5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-2.5-2.50000003 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l2.50000003 0 0-2.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 2.5 2.5 0z"],"participant-add_20":["M11.4997307 18c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-9.46899995 0c-.329000001 0-.630000001-.146-.826000001-.402-.1869999999-.244-.2499999999-.553-.1719999999-.848l.6229999999-2.348C2.18873075 13.398 4.08273075 12 6.26273075 12l.427 0c-1.62-1.075-2.69-2.914-2.69-5 0-3.309 2.691-6 6-6 3.30899995 0 5.99999995 2.691 5.99999995 6 0 3.309-2.691 6-5.99999995 6l-3.737 0c-1.727 0-3.224 1.094-3.64 2.659l-.623000001 2.348L11.4997307 18zM4.99973075 7c0 2.757 2.243 5 5 5 2.75699995 0 4.99999995-2.243 4.99999995-5 0-2.757-2.243-5-4.99999995-5-2.757 0-5 2.243-5 5zm13.49999995 8c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-2.5 0 0 2.5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-2.5-2.5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l2.5 0 0-2.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 2.5 2.5 0z"],"participant-add_24":["M13.5007609 22c.276 0 .5.224.5.5 0 .276-.224.5-.5.5L2.15676087 23c-.354999996 0-.685999996-.161-.906999996-.443-.2239999996-.286-.3019999996-.652-.2149999996-1.004l.7719999996-3.132C2.44576087 15.817 4.73976087 14 7.38476087 14l1.029 0c-2.04-1.225-3.413-3.452-3.413-6 0-3.859 3.141-7 7.00000003-7 3.859 0 7 3.141 7 7 0 3.859-3.141 7-7 7l-4.61600003 0c-2.183 0-4.077 1.505-4.608 3.659l-.771 3.132c-.017999996.072.012.125.031.149.022.028.06.06.12.06l11.34400003 0zM6.00076087 8c0 3.309 2.691 6 6.00000003 6 3.309 0 6-2.691 6-6 0-3.309-2.691-6-6-6-3.30900003 0-6.00000003 2.691-6.00000003 6zM22.5007609 18c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-3.5 0 0 3.5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-3.5-3.5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l3.5 0 0-3.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 3.5 3.5 0z"],"participant-add_28":["M17.5003116 26c.276 0 .5.224.5.5 0 .276-.224.5-.5.5L2.28131158 27c-.405000005 0-.778000005-.182-1.022000005-.497-.236-.305-.316-.691-.219-1.061l.918-3.523C2.71231158 19.022 5.40431158 17 8.50531158 17l1.504 0c-2.68-1.432-4.509-4.256-4.509-7.5 0-4.687 3.813-8.5 8.50000002-8.5 4.687 0 8.5 3.813 8.5 8.5 0 4.687-3.813 8.5-8.5 8.5l-5.49500002 0c-2.646 0-4.941 1.715-5.58 4.171l-.918 3.523c-.023000005.088.011.156.043.197.054.069.138.109.231.109l15.21900002 0zM6.50031158 9.5c0 4.136 3.364 7.5 7.50000002 7.5 4.136 0 7.5-3.364 7.5-7.5 0-4.136-3.364-7.5-7.5-7.5-4.13600002 0-7.50000002 3.364-7.50000002 7.5zM26.5003116 21c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-3.5 0 0 3.5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-3.5-3.5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l3.5 0 0-3.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 3.5 3.5 0z"],"participant-add_56":["M34.499995 53c.276 0 .5.224.5.5 0 .276-.224.5-.5.5L4.09499503 54c-.653 0-1.255000005-.294-1.655000005-.807-.3959999997-.508-.5339999997-1.159-.3759999997-1.783L3.93499503 43.973c1.477-5.872 6.763-9.973 12.85499997-9.973l5.608 0c-6.344-2.301-10.89799997-8.371-10.89799997-15.5 0-9.098 7.40199997-16.5 16.49999997-16.5 9.098 0 16.5 7.402 16.5 16.5 0 9.098-7.402 16.5-16.5 16.5l-11.21 0c-5.63299997 0-10.51899997 3.79-11.88499997 9.217l-1.871 7.437c-.082000005.324-.011.66.195.924.208.269.524.422.866.422L34.499995 53zm-22-34.5c0 8.547 6.953 15.5 15.5 15.5 8.547 0 15.5-6.953 15.5-15.5 0-8.547-6.953-15.5-15.5-15.5-8.547 0-15.5 6.953-15.5 15.5zm41 25.5c.275 0 .5.225.5.5 0 .274-.225.5-.5.5l-8.5 0 0 8.5c0 .274-.225.5-.5.5-.275 0-.5-.226-.5-.5l0-8.5-8.5 0c-.275 0-.5-.226-.5-.5 0-.275.225-.5.5-.5l8.5 0 0-8.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 8.5 8.5 0z"],"participant-list_16":["M8.5002 15c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-7.531 0c-.292 0-.565-.134-.749-.366-.195-.244-.264-.562-.193-.869l.551-2.349C1.0492 10.405 2.7452 9 4.7032 9l.328 0c-1.225-.912-2.031-2.358-2.031-4 0-2.757 2.243-5 5-5 2.757 0 5 2.243 5 5 0 2.757-2.243 5-5 5l-3.297 0c-1.491 0-2.787 1.087-3.151 2.645l-.551 2.348 7.499.007zm-4.5-10c0 2.206 1.794 4 4 4 2.206 0 4-1.794 4-4 0-2.206-1.794-4-4-4-2.206 0-4 1.794-4 4zm11.5 8c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l5 0zm0 2c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l5 0zm-5.5-3.5c0-.275.225-.5.5-.5l5 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-5 0c-.275 0-.5-.225-.5-.5z"],"participant-list_18":["M9.5 17c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-8.469 0c-.329 0-.63-.146-.827-.402-.187-.244-.249-.553-.171-.848l.624-2.348C1.188 12.399 3.083 11 5.263 11l.427 0C4.071 9.925 3 8.086 3 6c0-3.309 2.691-6 6-6 3.309 0 6 2.691 6 6 0 3.309-2.691 6-6 6l-3.737 0c-1.727 0-3.224 1.093-3.639 2.658L1 17.007 9.5 17zM4 6c0 2.757 2.243 5 5 5 2.757 0 5-2.243 5-5 0-2.757-2.243-5-5-5-2.757 0-5 2.243-5 5zm13.5 9c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-6 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l6 0zM11 13.5c0-.275.225-.5.5-.5l6 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-6 0c-.275 0-.5-.225-.5-.5zm6.5 3.5c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-6 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l6 0z"],"participant-list_20":["M19.5002 16.5c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-7 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l7 0zm-7.5-2c0-.275.225-.5.5-.5l7 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-7 0c-.275 0-.5-.225-.5-.5zm7.5 4.5c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-7 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l7 0zm-13.676-6c-1.955 0-3.651 1.299-4.124 3.158l-.698 2.74.092.102 8.406 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-8.406 0c-.342 0-.658-.154-.867-.423-.205-.264-.276-.601-.193-.925l.697-2.74c.586-2.304 2.68-3.912 5.093-3.912l.728 0c-1.83-1.151-3.052-3.184-3.052-5.5 0-3.584 2.916-6.5 6.5-6.5 3.584 0 6.5 2.916 6.5 6.5 0 3.584-2.916 6.5-6.5 6.5l-4.176 0zm-1.324-6.5c0 3.032 2.467 5.5 5.5 5.5 3.033 0 5.5-2.468 5.5-5.5 0-3.032-2.467-5.5-5.5-5.5-3.033 0-5.5 2.468-5.5 5.5z"],"participant-list_22":["M6.3839 14.0001c-2.183 0-4.077 1.505-4.608 3.659l-.771 3.132c-.017.072.013.125.032.149.021.028.059.06.12.06l9.343 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-9.343 0c-.356 0-.687-.161-.907-.442-.224-.287-.302-.653-.215-1.005l.77-3.132c.641-2.604 2.935-4.421 5.579-4.421l1.029 0c-2.04-1.225-3.413-3.452-3.413-6 0-3.859 3.14-7 7-7 3.86 0 7 3.141 7 7 0 3.859-3.14 7-7 7l-4.616 0zm-1.384-7c0 3.309 2.691 6 6 6 3.309 0 6-2.691 6-6 0-3.309-2.691-6-6-6-3.309 0-6 2.691-6 6zm16.5 14c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-8 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l8 0zm0-3c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-8 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l8 0zm-8.5-2.5c0-.275.225-.5.5-.5l8 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-8 0c-.275 0-.5-.225-.5-.5z"],"participant-list_24":["M12.4998 23.0001c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-11.281 0c-.387 0-.755-.179-.983-.477-.217-.283-.289-.641-.197-.982l.844-3.131c.7-2.597 3.193-4.41 6.061-4.41l1.192 0c-2.463-1.365-4.136-3.99-4.136-7 0-4.411 3.589-8 8-8 4.411 0 8 3.589 8 8 0 4.411-3.589 8-8 8l-5.056 0c-2.417 0-4.513 1.509-5.095 3.67l-.844 3.132c-.005.015-.016.059.025.113.04.054.111.085.189.085l11.281 0zm-7.5-15c0 3.859 3.14 7 7 7 3.86 0 7-3.141 7-7 0-3.859-3.14-7-7-7-3.86 0-7 3.141-7 7zm18.5004 15c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-8 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l8 0zm0-3c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-8 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l8 0zm-8.5-2.5c0-.275.225-.5.5-.5l8 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-8 0c-.275 0-.5-.225-.5-.5z"],"participant-list_26":["M13.4998 25c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-12.218 0c-.407 0-.78-.182-1.024-.498-.235-.305-.314-.69-.218-1.06l.918-3.523C1.7108 18.022 4.4038 16 7.5038 16l1.505 0c-2.68-1.432-4.509-4.256-4.509-7.5 0-4.687 3.813-8.5 8.5-8.5 4.687 0 8.5 3.813 8.5 8.5 0 4.687-3.813 8.5-8.5 8.5l-5.496 0c-2.645 0-4.94 1.715-5.579 4.171l-.917 3.523c-.023.088.01.156.042.197.054.069.138.109.232.109l12.218 0zm-8-16.5c0 4.136 3.364 7.5 7.5 7.5 4.136 0 7.5-3.364 7.5-7.5 0-4.136-3.364-7.5-7.5-7.5-4.136 0-7.5 3.364-7.5 7.5zm20 13c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-8 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l8 0zm0 3.5c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-8 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l8 0zm-8.5-6.5c0-.275.225-.5.5-.5l8 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-8 0c-.275 0-.5-.225-.5-.5z"],"participant-list_28":["M14.4998 26c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-12.218 0c-.407 0-.78-.182-1.024-.498-.235-.305-.314-.69-.218-1.06l.918-3.523C2.7108 19.022 5.4038 17 8.5038 17l1.505 0c-2.68-1.432-4.509-4.256-4.509-7.5 0-4.687 3.813-8.5 8.5-8.5 4.687 0 8.5 3.813 8.5 8.5 0 4.687-3.813 8.5-8.5 8.5l-5.496 0c-2.645 0-4.94 1.715-5.579 4.171l-.917 3.523c-.023.088.01.156.042.197.054.069.138.109.232.109l12.218 0zm-8-16.5c0 4.136 3.364 7.5 7.5 7.5 4.136 0 7.5-3.364 7.5-7.5 0-4.136-3.364-7.5-7.5-7.5-4.136 0-7.5 3.364-7.5 7.5zm20 13c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-8 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l8 0zm0 3.5c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-8 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l8 0zm-8.5-6.5c0-.275.225-.5.5-.5l8 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-8 0c-.275 0-.5-.225-.5-.5z"],"participant-list_32":["M30.5006 30.0001c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-10 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l10 0zm0-4.5c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-10 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l10 0zm-10.5-4c0-.275.225-.5.5-.5l10 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-10 0c-.275 0-.5-.225-.5-.5zm-3.5005 8.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-14.093 0c-.433 0-.836-.196-1.104-.539-.272-.347-.366-.792-.261-1.22l1.064-4.306c.864-3.495 3.957-5.935 7.519-5.935l2.158 0c-3.125-1.558-5.283-4.777-5.283-8.5 0-5.238 4.262-9.5 9.5-9.5 5.238 0 9.5 4.262 9.5 9.5 0 5.238-4.262 9.5-9.5 9.5l-6.375 0c-3.102 0-5.794 2.128-6.548 5.175l-1.064 4.306c-.032.128-.003.26.077.363.046.058.147.156.317.156l14.093 0zm-9-19.5c0 4.687 3.813 8.5 8.5 8.5 4.687 0 8.5-3.813 8.5-8.5 0-4.687-3.813-8.5-8.5-8.5-4.687 0-8.5 3.813-8.5 8.5z"],"participant-list_56":["M4.9043 44.216l-1.871 7.438c-.082.324-.011.66.196.925.208.268.524.421.865.421l22.406 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-22.406 0c-.652 0-1.254-.294-1.654-.807-.397-.508-.534-1.159-.377-1.783l1.872-7.438C5.4123 38.101 10.6983 34 16.7893 34l5.609 0c-6.344-2.301-10.898-8.371-10.898-15.5 0-9.098 7.401-16.5 16.5-16.5 9.098 0 16.5 7.402 16.5 16.5 0 9.098-7.402 16.5-16.5 16.5l-11.211 0c-5.632 0-10.519 3.79-11.885 9.216zm7.596-25.716c0 8.547 6.953 15.5 15.5 15.5 8.547 0 15.5-6.953 15.5-15.5 0-8.547-6.953-15.5-15.5-15.5-8.547 0-15.5 6.953-15.5 15.5zm41 27.5c.274 0 .5.225.5.5 0 .274-.226.5-.5.5l-18 0c-.275 0-.5-.226-.5-.5 0-.275.225-.5.5-.5l18 0zm0 7c.274 0 .5.225.5.5 0 .274-.226.5-.5.5l-18 0c-.275 0-.5-.226-.5-.5 0-.275.225-.5.5-.5l18 0zm-18.5-13.5c0-.275.225-.5.5-.5l18 0c.274 0 .5.225.5.5 0 .274-.226.5-.5.5l-18 0c-.275 0-.5-.226-.5-.5z"],"participant-list_64":["M32.5002 60c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-27.218 0c-.694 0-1.342-.317-1.777-.871-.451-.573-.609-1.312-.437-2.025l2.092-8.613C6.8042 42.726 12.6882 38 19.4712 38l6.666 0c-7.051-2.439-12.137-9.13-12.137-17 0-9.925 8.075-18 18-18 9.926 0 18 8.075 18 18 0 9.925-8.074 18-18 18l-12.529 0c-6.32 0-11.805 4.411-13.339 10.728l-2.092 8.612c-.101.414-.009.841.251 1.171.244.31.605.489.991.489l27.218 0zm-17.5-39c0 9.374 7.626 17 17 17 9.374 0 17-7.626 17-17 0-9.374-7.626-17-17-17-9.374 0-17 7.626-17 17zm45.5 30c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-21 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l21 0zm-21.5-8.5c0-.275.225-.5.5-.5l21 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-21 0c-.275 0-.5-.225-.5-.5zm21.5 17.5c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-21 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l21 0z"],"participant-list_80":["M42.5 75c.276 0 .5.224.5.5 0 .276-.224.5-.5.5L6.72 76c-.857 0-1.645-.383-2.163-1.051-.504-.648-.677-1.474-.474-2.265l2.605-10.179C8.725 54.554 16.004 49 24.393 49l8.901 0C23.873 46.123 17 37.351 17 27 17 14.317 27.317 4 40 4c12.682 0 23 10.317 23 23 0 12.683-10.318 23-23 23l-15.607 0c-7.932 0-14.814 5.244-16.736 12.753L5.052 72.932c-.126.489-.019 1.001.295 1.404.327.422.828.664 1.373.664l35.78 0zM18 27c0 12.131 9.869 22 22 22 12.131 0 22-9.869 22-22 0-12.131-9.869-22-22-22-12.131 0-22 9.869-22 22zm57.5 37c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-25 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l25 0zM50 53.5c0-.275.225-.5.5-.5l25 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-25 0c-.275 0-.5-.225-.5-.5zM75.5 75c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-25 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l25 0z"],"participant-list-legacy_16":["M11.569944 11.395l.4039869 1.566c.0639979.249.0109996.508-.1479952.712-.1599948.208-.4049869.327-.6699782.327L.844292629 14c-.264991387 0-.508983456-.119-.669978223-.327-.1579948646-.204-.2119931094-.463-.1479951897-.712l.4039868687-1.566c.348988656-1.352 1.555949425-2.303 2.970903435-2.38C2.55023718 8.281 2.00025505 7.209 2.00025505 6c0-2.206 1.79494166-4 3.99986999-4 2.2059283 0 3.99986999 1.794 3.99986999 4 0 1.209-.54998213 2.281-1.3999545 3.015 1.41295407.077 2.62091477 1.028 2.96990347 2.38zM1.04928597 13l9.90167813 0-.3489886-1.355C10.3519836 10.676 9.45401277 10 8.41804645 10l-4.83584282 0c-1.03596632 0-1.93393713.676-2.18292904 1.645L1.04928597 13zm1.95093658-7c0 1.654 1.34595625 3 2.99990249 3 1.65394624 0 2.99990249-1.346 2.99990249-3 0-1.654-1.34595625-3-2.99990249-3C4.3461788 3 3.00022255 4.346 3.00022255 6zm8.49992375-1c-.2749911 0-.4999838-.225-.4999838-.5 0-.275.2249927-.5.4999838-.5l3.99987 0C15.7750073 4 16 4.225 16 4.5c0 .275-.2249927.5-.4999837.5l-3.99987 0zm3.99987 1C15.7750073 6 16 6.225 16 6.5c0 .275-.2249927.5-.4999837.5l-3.99987 0c-.2749911 0-.4999838-.225-.4999838-.5 0-.275.2249927-.5.4999838-.5l3.99987 0zm0 2C15.7750073 8 16 8.225 16 8.5c0 .275-.2249927.5-.4999837.5l-3.99987 0c-.2749911 0-.4999838-.225-.4999838-.5 0-.275.2249927-.5.4999838-.5l3.99987 0z"],"participant-list-legacy_20":["M14.4566 14.8853l.514 1.958c.071.272.013.557-.16.781-.179.231-.451.364-.748.364l-13.124 0c-.297 0-.57-.133-.749-.364-.173-.225-.231-.509-.16-.781l.515-1.958c.439-1.676 1.99-2.85 3.787-2.889-1.412-.996-2.338-2.637-2.338-4.496 0-3.037 2.463-5.5 5.5-5.5 3.038 0 5.5 2.463 5.5 5.5 0 1.859-.925 3.499-2.336 4.495 1.802.034 3.358 1.21 3.799 2.89zm-13.431 2.103l12.949 0-.485-1.849c-.333-1.266-1.53-2.151-2.912-2.151l-2.851 0c-.078.003-.155.012-.233.012-.078 0-.155-.009-.232-.012l-2.839 0c-1.382 0-2.579.885-2.912 2.151l-.485 1.849zm1.968-9.488c0 2.441 1.958 4.425 4.385 4.488l.231 0c2.427-.063 4.384-2.047 4.384-4.488 0-2.482-2.018-4.5-4.5-4.5-2.481 0-4.5 2.018-4.5 4.5zM14.4938 7c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l5 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-5 0zm5 1c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l5 0zm0 2c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l5 0z"],"participant-list-legacy_24":["M17.9677 19.7503c.078.295.015.603-.172.847-.196.256-.498.403-.827.403l-15.937 0c-.329 0-.631-.147-.827-.403-.187-.244-.25-.552-.172-.847l.624-2.349c.532-2.002 2.426-3.401 4.607-3.401l.427 0c-1.62-1.076-2.691-2.914-2.691-5 0-3.309 2.692-6 6-6 3.309 0 6 2.691 6 6 0 2.086-1.07 3.924-2.69 5l.427 0c2.181 0 4.075 1.399 4.607 3.401l.624 2.349zm-16.968.257l15.969-.007-.592-2.342c-.415-1.565-1.912-2.658-3.64-2.658l-7.473 0c-1.728 0-3.225 1.093-3.64 2.658l-.624 2.349zm3-11.007c0 2.757 2.244 5 5 5 2.757 0 5-2.243 5-5 0-2.757-2.243-5-5-5-2.756 0-5 2.243-5 5zM23.5002 7l-7 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l7 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5zm0 3l-7 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l7 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5zm0 3l-7 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l7 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5z"],"participant-list-legacy_28":["M19.5000811 8c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l7 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-7 0zm7 2c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-7 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l7 0zm-7.192 9.918l.661 2.74c.08.33.006.672-.203.937-.203.259-.505.405-.829.405L2.06308112 24c-.323999999 0-.625999999-.146-.828999999-.405-.2090000004-.265-.2820000004-.607-.2030000004-.937l.6610000004-2.74C2.24908112 17.611 4.24408112 16 6.54308112 16l.509 0c-1.829-1.151-3.052-3.184-3.052-5.5 0-3.584 2.916-6.5 6.5-6.5 3.58399998 0 6.49999998 2.916 6.49999998 6.5 0 2.316-1.222 4.349-3.052 5.5l.509 0c2.3 0 4.295 1.611 4.851 3.918zm-.371 3.082l.06-.107-.661-2.741c-.447-1.856-2.043-3.152-3.879-3.152l-7.91399998 0c-1.835 0-3.432 1.296-3.878 3.152l-.662 2.741.06.107 16.87399998 0zM5.00008112 10.5c0 3.032 2.467 5.5 5.5 5.5 3.03299998 0 5.49999998-2.468 5.49999998-5.5 0-3.032-2.467-5.5-5.49999998-5.5-3.033 0-5.5 2.468-5.5 5.5zM26.5000811 13c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-7 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l7 0z"],"participant-list-legacy_32":["M22.1944 22.4204l.771 3.132c.087.353.009.719-.215 1.005-.221.281-.551.443-.907.443l-19.687 0c-.356 0-.686-.162-.907-.443-.223-.286-.302-.652-.215-1.005l.771-3.132c.64-2.603 2.934-4.42 5.578-4.42l1.03 0c-2.04-1.225-3.413-3.453-3.413-6 0-3.86 3.14-7 7-7 3.859 0 7 3.14 7 7 0 2.547-1.373 4.775-3.413 6l1.029 0c2.644 0 4.938 1.817 5.578 4.42zm-.231 3.52c.019-.024.049-.077.031-.149l-.77-3.132c-.531-2.155-2.426-3.659-4.608-3.659l-9.233 0c-2.182 0-4.077 1.504-4.607 3.659l-.771 3.132c-.018.072.012.125.031.149.022.027.06.06.12.06l19.687 0c.06 0 .099-.033.12-.06zm-15.963-13.94c0 3.308 2.691 6 6 6 3.308 0 6-2.692 6-6 0-3.309-2.692-6-6-6-3.309 0-6 2.691-6 6zM22.5 9c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l8 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-8 0zm8 3c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-8 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l8 0zm0 4c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-8 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l8 0z"],"participant-list-legacy_56":["M39.500371 15.9997c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l15 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-15 0zm15 5c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-15 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l15 0zm0 6c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-15 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l15 0zm-15.9445 12.9593l1.395 5.873c.128.54.007 1.096-.333 1.527-.322.407-.798.641-1.306.641L2.68787101 48c-.507 0-.982999996-.234-1.304999996-.641-.3400000002-.431-.4610000002-.987-.3330000002-1.528L2.44487101 39.959c1.113-4.687 5.102-7.959 9.70199999-7.959l3.459 0c-4.466-1.908-7.60599999-6.344-7.60599999-11.5 0-6.893 5.60799999-12.5 12.49999999-12.5 6.893 0 12.5 5.607 12.5 12.5 0 5.156-3.139 9.592-7.605 11.5l3.459 0c4.6 0 8.589 3.272 9.702 7.959zm.277 6.78c.149-.188.202-.436.145-.676l-1.395-5.874c-1.005-4.233-4.595-7.189-8.729-7.189l-16.707 0c-4.13399999 0-7.72399999 2.956-8.72999999 7.189l-1.394 5.873c-.056999996.241-.004.489.145.677.077.098.247.261.52.261L38.311871 47c.274 0 .444-.163.521-.261zM8.99987101 20.5c0 6.341 5.15899999 11.5 11.49999999 11.5 6.342 0 11.5-5.159 11.5-11.5 0-6.341-5.158-11.5-11.5-11.5-6.341 0-11.49999999 5.159-11.49999999 11.5z"],"participant-list-legacy_64":["M44.3300087 45.967l1.615 6.654c.141.587.01 1.193-.36 1.664-.357.454-.89.715-1.461.715L2.87600871 55c-.571 0-1.102999998-.261-1.460999998-.715-.37-.471-.501-1.077-.359-1.664l1.613999998-6.654c1.282-5.28 5.87-8.967 11.15799999-8.967l4.419 0c-5.403-2.11-9.24699999-7.359-9.24699999-13.5 0-7.995 6.50499999-14.5 14.49999999-14.5 7.995 0 14.5 6.505 14.5 14.5 0 6.141-3.844 11.39-9.247 13.5l4.419 0c5.288 0 9.876 3.687 11.158 8.967zm.469 7.699c.18-.228.242-.522.173-.809l-1.614-6.654c-1.172-4.83-5.361-8.203-10.186-8.203l-19.344 0c-4.82499999 0-9.01299999 3.373-10.18499999 8.203l-1.615 6.654c-.068999998.287-.006.581.173.809.167.213.413.334.675.334l41.24799999 0c.262 0 .508-.121.675-.334zM10.00000871 23.5c0 7.444 6.05599999 13.5 13.49999999 13.5 7.445 0 13.5-6.056 13.5-13.5 0-7.444-6.055-13.5-13.5-13.5-7.444 0-13.49999999 6.056-13.49999999 13.5zM45.5001087 18c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l17 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-17 0zm16.9883 6c.281 0 .512.23.512.512 0 .281-.231.51-.512.51l-17.007 0c-.281 0-.512-.229-.512-.51 0-.282.231-.512.512-.512l17.007 0zm.0117 7c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-17 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l17 0z"],"participant-list-legacy_80":["M54.9908103 56.48l1.946 7.829c.162.654.017 1.334-.398 1.864-.411.526-1.029.827-1.695.827L5.15781033 67c-.666 0-1.284-.301-1.695-.827-.414999999-.53-.559999999-1.21-.397999999-1.864L5.01081033 56.48c1.533-6.17 7.018-10.48 13.33999997-10.48l5.951 0c-6.581-2.345-11.301-8.613-11.301-16 0-9.388 7.611-17 17-17 9.389 0 17 7.612 17 17 0 7.387-4.72 13.655-11.301 16l5.951 0c6.322 0 11.807 4.31 13.34 10.48zm.761 9.077c.224-.286.302-.653.214-1.008l-1.945-7.829c-1.422-5.723-6.508-9.72-12.37-9.72l-23.3 0c-5.862 0-10.94799997 3.997-12.36999997 9.72l-1.945 7.829c-.088.355-.01.722.214 1.008.221.281.552.443.908.443l49.68599997 0c.356 0 .687-.162.908-.443zM14.0008103 30c0 8.823 7.178 16 16 16 8.822 0 16-7.177 16-16 0-8.822-7.178-16-16-16-8.822 0-16 7.178-16 16zm41.5-6.9996c-.275 0-.5-.226-.5-.5 0-.275.225-.5.5-.5l21 0c.275 0 .5.225.5.5 0 .274-.225.5-.5.5l-21 0zm21 8c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-21 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l21 0zm0 9c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-21 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l21 0z"],"participant-list-legacy-optical_16":["M3.04928597 14l.34998862-1.355C3.6482665 11.676 4.54623731 11 5.58220363 11l4.83584282 0c1.03596632 0 1.93393715.676 2.18392905 1.645L12.9509641 14l-9.90167813 0zm1.95093658-7c0-1.654 1.34595625-3 2.99990249-3 1.65394624 0 2.99990249 1.346 2.99990249 3 0 1.654-1.34595625 3-2.99990249 3-1.65394624 0-2.99990249-1.346-2.99990249-3zm8.56972145 5.395l.4039869 1.566c.0639979.249.0109996.508-.1479952.712-.1599948.208-.4049869.327-.6699782.327L2.844292629 15c-.264991387 0-.508983456-.119-.669978223-.327-.1579948646-.204-.2119931094-.463-.1479951897-.712l.4039868687-1.566c.348988656-1.352 1.555949425-2.303 2.970903435-2.38C4.55023718 9.281 4.00025505 8.209 4.00025505 7c0-2.206 1.79494166-4 3.99986999-4 2.2059283 0 3.99986999 1.794 3.99986999 4 0 1.209-.54998213 2.281-1.3999545 3.015 1.41295407.077 2.62091477 1.028 2.96990347 2.38zM13.5001463 6c-.2749911 0-.4999838-.225-.4999838-.5 0-.275.2249927-.5.4999838-.5l3.99987 0C17.7750073 5 18 5.225 18 5.5c0 .275-.2249927.5-.4999837.5l-3.99987 0zm3.99987 1C17.7750073 7 18 7.225 18 7.5c0 .275-.2249927.5-.4999837.5l-3.99987 0c-.2749911 0-.4999838-.225-.4999838-.5 0-.275.2249927-.5.4999838-.5l3.99987 0zm0 2C17.7750073 9 18 9.225 18 9.5c0 .275-.2249927.5-.4999837.5l-3.99987 0c-.2749911 0-.4999838-.225-.4999838-.5 0-.275.2249927-.5.4999838-.5l3.99987 0z"],"participant-list-legacy-optical_20":["M15.4942 6.0058c-.275 0-.5-.226-.5-.5 0-.275.225-.5.5-.5l4 0c.274 0 .5.225.5.5 0 .274-.226.5-.5.5l-4 0zm4 1c.274 0 .5.225.5.5 0 .274-.226.5-.5.5l-4 0c-.275 0-.5-.226-.5-.5 0-.275.225-.5.5-.5l4 0zm-5.0367 6.8853l.513 1.957c.071.273.013.558-.16.782-.179.231-.451.364-.748.364l-11.124 0c-.297 0-.569-.133-.749-.364-.173-.225-.23-.509-.16-.782l.516-1.957c.392-1.499 1.675-2.589 3.226-2.833-1.072-.822-1.774-2.102-1.774-3.558 0-2.485 2.014-4.5 4.5-4.5 2.485 0 4.5 2.015 4.5 4.5 0 1.454-.702 2.733-1.773 3.557 1.554.242 2.838 1.333 3.233 2.834zm-11.432 2.103l10.949 0-.484-1.849c-.334-1.266-1.531-2.151-2.912-2.151l-2.023 0c-.02 0-.038.006-.058.006-.021 0-.039-.006-.06-.006l-2.015 0c-1.381 0-2.579.885-2.912 2.151l-.485 1.849zm1.972-8.494c0 1.93 1.569 3.5 3.5 3.5 1.929 0 3.5-1.57 3.5-3.5 0-1.93-1.571-3.5-3.5-3.5-1.931 0-3.5 1.57-3.5 3.5zm14.4967 1.5057c.274 0 .5.225.5.5 0 .274-.226.5-.5.5l-4 0c-.275 0-.5-.226-.5-.5 0-.275.225-.5.5-.5l4 0z"],"participant-list-legacy-optical_22":["M21.5 8.9937c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l5 0zm0-2c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l5 0zm0-2c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l5 0zm-4.5275 12.7705c.072.308.002.625-.192.869-.185.233-.458.367-.75.367l-14.061 0c-.292 0-.565-.134-.75-.367-.194-.244-.264-.561-.192-.869l.551-2.349c.471-2.01 2.168-3.415 4.125-3.415l.329 0c-1.226-.912-2.032-2.359-2.032-4.001 0-2.756 2.243-4.999 5-4.999 2.756 0 4.999 2.243 4.999 4.999 0 1.642-.806 3.089-2.032 4.001l.329 0c1.957 0 3.654 1.405 4.125 3.415l.551 2.349zm-14.971.229l14.029.007-.582-2.356c-.365-1.557-1.661-2.644-3.152-2.644l-6.593 0c-1.491 0-2.786 1.087-3.151 2.644l-.551 2.349zm2.999-9.994c0 2.206 1.794 4 4 4 2.205 0 3.999-1.794 3.999-4 0-2.205-1.794-3.999-3.999-3.999-2.206 0-4 1.794-4 3.999z"],"participant-list-legacy-optical_26":["M2.9989 21.0073l.624-2.349c.416-1.565 1.913-2.658 3.64-2.658l7.474 0c1.727 0 3.224 1.093 3.64 2.658l.592 2.342-15.97.007zm3.001-11.007c0-2.757 2.243-5 5-5 2.757 0 5 2.243 5 5 0 2.757-2.243 5-5 5-2.757 0-5-2.243-5-5zm13.343 8.401l.624 2.349c.078.295.015.604-.172.848-.196.255-.498.402-.826.402l-15.938 0c-.328 0-.63-.147-.826-.402-.187-.244-.25-.553-.172-.848l.624-2.349c.531-2.002 2.426-3.401 4.606-3.401l.427 0c-1.619-1.076-2.69-2.914-2.69-5 0-3.309 2.691-6 6-6 3.309 0 6 2.691 6 6 0 2.086-1.071 3.924-2.69 5l.427 0c2.18 0 4.075 1.399 4.606 3.401zM25.4999 10c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-6 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l6 0zm0 3c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-6 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l6 0zm-6-5c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l6 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-6 0z"],"participant-list-legacy-optical_28":["M22.5 9c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l7 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-7 0zm7 2c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-7 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l7 0zm-8.192 9.918l.661 2.74c.08.33.006.672-.203.937-.203.259-.505.405-.829.405L4.063 25c-.324 0-.626-.146-.829-.405-.209-.265-.282-.607-.203-.937l.661-2.74C4.249 18.611 6.244 17 8.543 17l.509 0C7.223 15.849 6 13.816 6 11.5 6 7.916 8.916 5 12.5 5c3.584 0 6.5 2.916 6.5 6.5 0 2.316-1.222 4.349-3.052 5.5l.509 0c2.3 0 4.295 1.611 4.851 3.918zM20.937 24l.06-.107-.661-2.741C19.889 19.296 18.293 18 16.457 18l-7.914 0c-1.835 0-3.432 1.296-3.878 3.152l-.662 2.741.06.107 16.874 0zM7 11.5c0 3.032 2.467 5.5 5.5 5.5 3.033 0 5.5-2.468 5.5-5.5C18 8.468 15.533 6 12.5 6 9.467 6 7 8.468 7 11.5zM29.5 14c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-7 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l7 0z"],"participant-list-legacy-optical_32":["M23.9634 26.9404c-.021.027-.06.06-.12.06l-19.687 0c-.06 0-.098-.033-.12-.06-.019-.024-.049-.077-.031-.149l.771-3.132c.53-2.155 2.425-3.659 4.607-3.659l9.233 0c2.182 0 4.077 1.504 4.608 3.659l.77 3.132c.018.072-.012.125-.031.149zm-15.963-13.94c0-3.309 2.691-6 6-6 3.308 0 6 2.691 6 6 0 3.308-2.692 6-6 6-3.309 0-6-2.692-6-6zm16.194 10.42l.771 3.132c.087.353.009.719-.215 1.005-.221.281-.551.443-.907.443l-19.687 0c-.356 0-.686-.162-.907-.443-.223-.286-.302-.652-.215-1.005l.771-3.132c.64-2.603 2.934-4.42 5.578-4.42l1.03 0c-2.04-1.225-3.413-3.453-3.413-6 0-3.86 3.14-7 7-7 3.859 0 7 3.14 7 7 0 2.547-1.373 4.775-3.413 6l1.029 0c2.644 0 4.938 1.817 5.578 4.42zM25.5 10c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l8 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-8 0zm8 3c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-8 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l8 0zm0 4c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-8 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l8 0z"],"participant-list-legacy-optical_56":["M42.8345 48.7407c-.077.098-.246.26-.52.26l-35.629 0c-.273 0-.443-.162-.519-.259-.15-.189-.203-.438-.146-.679l1.392-5.866c1.003-4.229 4.586-7.184 8.711-7.184l16.753 0c4.125 0 7.708 2.956 8.711 7.184l1.392 5.866c.057.241.004.489-.145.678zm-29.852-26.252c0-6.335 5.148-11.489 11.476-11.489 6.328 0 11.475 5.154 11.475 11.489 0 6.335-5.147 11.489-11.475 11.489-6.328 0-11.476-5.154-11.476-11.489zm29.576 19.478l1.392 5.867c.128.539.007 1.095-.333 1.526-.321.407-.796.64-1.303.64l-35.629 0c-.507 0-.981-.233-1.302-.639-.34-.432-.462-.987-.334-1.527l1.392-5.867c1.111-4.683 5.092-7.953 9.682-7.953l3.539 0c-4.504-1.885-7.678-6.339-7.678-11.525 0-6.887 5.596-12.489 12.474-12.489 6.877 0 12.473 5.602 12.473 12.489 0 5.186-3.174 9.64-7.677 11.525l3.622 0c4.59 0 8.571 3.27 9.682 7.953zM44.5 17.9819c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l15 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-15 0zm15 5c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-15 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l15 0zm0 6c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-15 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l15 0z"],"participant-list-legacy-optical_64":["M48.8 55.7c-.2.2-.4.3-.7.3L6.9 56c-.3 0-.5-.1-.7-.3-.2-.3-.2-.6-.2-.8l1.6-6.7C8.8 43.4 13 40 17.8 40l19.3 0c4.8 0 9 3.4 10.2 8.2l1.6 6.7c.1.2.1.5-.1.8zM14 25.5C14 18.1 20.1 12 27.5 12 34.9 12 41 18.1 41 25.5S34.9 39 27.5 39C20.1 39 14 32.9 14 25.5zM48.3 48l1.6 6.7c.1.6 0 1.2-.4 1.7-.4.5-.9.7-1.5.7l-41.1 0c-.6 0-1.1-.3-1.5-.7-.4-.5-.5-1.1-.4-1.7L6.7 48c1.3-5.3 5.9-9 11.2-9l4.4 0c-5.5-2.1-9.3-7.4-9.3-13.5 0-8 6.5-14.5 14.5-14.5S42 17.5 42 25.5c0 6.1-3.8 11.4-9.2 13.5l4.4 0c5.3 0 9.8 3.7 11.1 9zm2.2-28c-.3 0-.5-.2-.5-.5s.2-.5.5-.5l17 0c.3 0 .5.2.5.5s-.2.5-.5.5l-17 0zm17 6c.3 0 .5.2.5.5 0 .3-.2.5-.5.5l-17 0c-.3 0-.5-.2-.5-.5 0-.3.2-.5.5-.5l17 0zm0 7c.3 0 .5.2.5.5s-.2.5-.5.5l-17 0c-.3 0-.5-.2-.5-.5s.2-.5.5-.5l17 0z"],"participant-list-legacy-optical_80":["M57.8 65.6c-.2.3-.6.4-.9.4L7.2 66c-.4 0-.7-.2-.9-.4-.2-.3-.3-.7-.2-1L8 56.7C9.4 51 14.5 47 20.4 47l23.3 0c5.9 0 10.9 4 12.4 9.7l1.9 7.8c.1.4 0 .8-.2 1.1zM16 30c0-8.8 7.2-16 16-16s16 7.2 16 16c0 8.8-7.2 16-16 16s-16-7.2-16-16zm41 26.5l1.9 7.8c.2.7 0 1.3-.4 1.9-.4.5-1 .8-1.7.8L7.2 67c-.7 0-1.3-.3-1.7-.8-.5-.6-.6-1.2-.4-1.9L7 56.5C8.5 50.3 14 46 20.4 46l6 0C19.7 43.7 15 37.4 15 30c0-9.4 7.6-17 17-17s17 7.6 17 17c0 7.4-4.7 13.7-11.3 16l6 0C50 46 55.5 50.3 57 56.5zM58.5 23c-.3 0-.5-.2-.5-.5 0-.3.2-.5.5-.5l21 0c.3 0 .5.2.5.5 0 .3-.2.5-.5.5l-21 0zm21 8c.3 0 .5.2.5.5s-.2.5-.5.5l-21 0c-.3 0-.5-.2-.5-.5s.2-.5.5-.5l21 0zm0 9c.3 0 .5.2.5.5s-.2.5-.5.5l-21 0c-.3 0-.5-.2-.5-.5s.2-.5.5-.5l21 0z"],"participant-remove_12":["M6.49950724 11c.276 0 .5.224.5.5 0 .276-.224.5-.5.5L.843507238 12c-.264 0-.509-.119-.67-.327-.1580000001-.204-.2110000001-.463-.1470000001-.712L.429507238 9.395c.349-1.352 1.556000002-2.302 2.970000002-2.38-.85-.734-1.4-1.806-1.4-3.015 0-2.206 1.794-4 4-4 2.206 0 4 1.794 4 4 0 2.206-1.793 3.999-3.999 4l-.001 0-2.418 0c-1.035 0-1.934.676-2.184 1.645l-.349 1.355 5.451 0zm-3.5-7c0 1.654 1.346 3 3 3 1.654 0 3-1.346 3-3 0-1.654-1.346-3-3-3-1.654 0-3 1.346-3 3zm8.49999996 5c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-3.99999996 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l3.99999996 0z"],"participant-remove_16":["M15.5002381 12c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-6.00000003 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l6.00000003 0zm-6.00000003 3c.276 0 .50000003.224.50000003.5 0 .276-.22400003.5-.50000003.5L.969238071 16c-.291 0-.565-.134-.749-.366-.1949999998-.244-.2639999998-.562-.1929999998-.869l.5509999998-2.349C1.04923807 10.405 2.74523807 9 4.70323807 9l.328 0c-1.225-.912-2.031-2.358-2.031-4 0-2.757 2.243-5 5-5 2.75700003 0 5.00000003 2.243 5.00000003 5 0 2.757-2.243 5-5.00000003 5l-3.297 0c-1.491 0-2.787 1.087-3.151 2.645l-.551 2.348 8.499.007zm-5.5-10c0 2.206 1.795 4 4 4 2.20500003 0 4.00000003-1.794 4.00000003-4 0-2.206-1.795-4-4.00000003-4-2.205 0-4 1.794-4 4z"],"participant-remove_20":["M11.4997307 18c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-9.46899995 0c-.329000001 0-.630000001-.146-.826000001-.402-.1869999999-.244-.2499999999-.553-.1719999999-.848l.6229999999-2.348C2.18873075 13.398 4.08273075 12 6.26273075 12l.427 0c-1.62-1.075-2.69-2.914-2.69-5 0-3.309 2.691-6 6-6 3.30899995 0 5.99999995 2.691 5.99999995 6 0 3.309-2.691 6-5.99999995 6l-3.737 0c-1.727 0-3.224 1.094-3.64 2.659l-.623000001 2.348L11.4997307 18zM4.99973075 7c0 2.757 2.243 5 5 5 2.75699995 0 4.99999995-2.243 4.99999995-5 0-2.757-2.243-5-4.99999995-5-2.757 0-5 2.243-5 5zm13.49999995 8c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-6 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l6 0z"],"participant-remove_24":["M13.5007609 22c.276 0 .5.224.5.5 0 .276-.224.5-.5.5L2.15676087 23c-.354999996 0-.685999996-.161-.906999996-.443-.2239999996-.286-.3019999996-.652-.2149999996-1.004l.7719999996-3.132C2.44576087 15.817 4.73976087 14 7.38476087 14l1.03 0c-2.041-1.225-3.414-3.452-3.414-6 0-3.859 3.141-7 7.00000003-7 3.859 0 7 3.141 7 7 0 3.859-3.141 7-7 7l-4.61600003 0c-2.183 0-4.077 1.505-4.608 3.659l-.771 3.132c-.017999996.072.012.125.031.149.022.028.06.06.12.06l11.34400003 0zM6.00076087 8c0 3.309 2.691 6 6.00000003 6 3.309 0 6-2.691 6-6 0-3.309-2.691-6-6-6-3.30900003 0-6.00000003 2.691-6.00000003 6zM22.5007609 18c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-8 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l8 0z"],"participant-remove_28":["M17.5003116 26c.276 0 .5.224.5.5 0 .276-.224.5-.5.5L2.28131158 27c-.405000005 0-.778000005-.182-1.022000005-.497-.236-.305-.316-.691-.219-1.061l.918-3.523C2.71231158 19.022 5.40431158 17 8.50531158 17l1.504 0c-2.68-1.432-4.509-4.256-4.509-7.5 0-4.687 3.813-8.5 8.50000002-8.5 4.687 0 8.5 3.813 8.5 8.5 0 4.687-3.813 8.5-8.5 8.5l-5.49500002 0c-2.646 0-4.941 1.715-5.58 4.171l-.918 3.523c-.023000005.088.011.156.043.197.054.069.138.109.231.109l15.21900002 0zM6.50031158 9.5c0 4.136 3.364 7.5 7.50000002 7.5 4.136 0 7.5-3.364 7.5-7.5 0-4.136-3.364-7.5-7.5-7.5-4.13600002 0-7.50000002 3.364-7.50000002 7.5zM26.5003116 21c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-8 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l8 0z"],"participant-remove_56":["M34.499995 53c.276 0 .5.224.5.5 0 .276-.224.5-.5.5L4.09499503 54c-.653 0-1.255000005-.294-1.655000005-.807-.3959999997-.508-.5339999997-1.159-.3759999997-1.783L3.93499503 43.973c1.477-5.872 6.763-9.973 12.85499997-9.973l5.608 0c-6.344-2.301-10.89799997-8.371-10.89799997-15.5 0-9.098 7.40199997-16.5 16.49999997-16.5 9.098 0 16.5 7.402 16.5 16.5 0 9.098-7.402 16.5-16.5 16.5l-11.21 0c-5.63299997 0-10.51899997 3.79-11.88499997 9.217l-1.871 7.437c-.082000005.324-.011.66.195.924.208.269.524.422.866.422L34.499995 53zm-22-34.5c0 8.547 6.953 15.5 15.5 15.5 8.547 0 15.5-6.953 15.5-15.5 0-8.547-6.953-15.5-15.5-15.5-8.547 0-15.5 6.953-15.5 15.5zm41 25.5c.275 0 .5.225.5.5 0 .274-.225.5-.5.5l-18 0c-.275 0-.5-.226-.5-.5 0-.275.225-.5.5-.5l18 0z"],"pass-mouse_12":["M6.0034 4c1.654 0 3 1.346 3 3l0 2c0 1.654-1.346 3-3 3-1.654 0-3-1.346-3-3l0-1-.003 0 .003-.006 0-.994c0-1.654 1.346-3 3-3zm0 7c1.103 0 2-.897 2-2l0-1.014-.003.014-3.997 0 0 1c0 1.103.897 2 2 2zm-.503-5.928c-.859.225-1.497 1-1.497 1.928l1.497 0 0-1.928zm1-.002l0 1.93 1.503 0c0-.93-.641-1.707-1.503-1.93zm4.8531-2.9235c.195.195.195.512 0 .707-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147-1.195-1.195-2.846-1.853-4.647-1.853-1.8 0-3.45.658-4.646 1.853-.195.195-.512.195-.707 0-.195-.195-.195-.512 0-.707 1.385-1.384 3.286-2.146 5.353-2.146 2.069 0 3.97.762 5.354 2.146zM6.002 2.0049c1.378.007 2.739.549 3.832 1.528.205.184.223.5.039.706-.099.111-.236.166-.373.166-.119 0-.238-.042-.333-.128-.911-.815-2.037-1.267-3.169-1.272l-.017 0c-1.146 0-2.261.449-3.141 1.267-.202.188-.52.175-.706-.027-.188-.202-.176-.518.026-.706 1.071-.995 2.442-1.544 3.842-1.534z"],"pass-mouse_16":["M8.50200977 8.9983l0-2.95c1.414.24 2.496 1.467 2.496 2.95l-2.496 0zm2.496 3.001c0 1.654-1.344 3.001-2.995 3.001-1.651 0-2.995-1.347-2.995-3.001l0-2.001 5.99 0 0 2.001zm-3.494-5.951l0 2.95-2.496 0c0-1.483 1.082-2.71 2.496-2.95zm.499-1.051c2.202 0 3.99300003 1.795 3.99300003 4.001l0 3.001c0 2.206-1.79100003 4.001-3.99300003 4.001-2.202 0-3.993-1.795-3.993-4.001l0-3.001c0-2.206 1.791-4.001 3.993-4.001zM8 2.4973c1.733 0 3.362.677 4.588 1.904.195.196.195.512 0 .707-.098.098-.225.147-.353.147-.128 0-.256-.049-.353-.147-1.037-1.039-2.415-1.611-3.882-1.611-1.467 0-2.845.572-3.882 1.611-.195.196-.512.196-.706 0-.195-.195-.195-.511 0-.707C4.638 3.1743 6.267 2.4973 8 2.4973zm6.3535.1358c.195.195.195.512 0 .707-.098.098-.225.147-.353.147-.127 0-.255-.049-.353-.147-3.113-3.12-8.182-3.12-11.295 0-.195.195-.512.195-.706 0-.195-.195-.195-.512 0-.707 3.504-3.511 9.203-3.511 12.707 0z"],"pass-mouse_20":["M10.0003 5.9966c2.757 0 5 2.244 5 5.001l0 4.001c0 2.758-2.243 5.001-5 5.001-2.757 0-5-2.243-5-5.001l0-4.001c0-2.757 2.243-5.001 5-5.001zm.489 5.001l3.511 0c0-2.039-1.537-3.707-3.511-3.951l0 3.951zm3.511 4.001l0-3.001-8 0 0 3.001c0 2.207 1.794 4.001 4 4.001 2.206 0 4-1.794 4-4.001zm-4.511-7.95c-1.963.254-3.489 1.918-3.489 3.949l3.489 0 0-3.949zm8.3633-3.8313c.196.195.196.512 0 .707-.099.099-.229.147-.357.147-.129 0-.258-.048-.357-.147-3.935-3.899-10.342-3.899-14.277 0-.197.196-.517.196-.714 0-.196-.195-.196-.512 0-.707 4.33-4.29 11.375-4.29 15.705 0zM4.3428 5.3394c3.119-3.12 8.195-3.12 11.314 0 .196.195.196.512 0 .707-.097.098-.225.147-.353.147-.128 0-.256-.049-.354-.147-2.73-2.729-7.169-2.729-9.9 0-.195.195-.512.195-.707 0-.195-.195-.195-.512 0-.707z"],"pause_10":["M7.5 8.5c0 .276-.224.5-.5.5-.275 0-.5-.224-.5-.5l0-7c0-.276.225-.5.5-.5.276 0 .5.224.5.5l0 7zM7 0c.829 0 1.5.671 1.5 1.5l0 7c0 .829-.671 1.5-1.5 1.5-.828 0-1.5-.671-1.5-1.5l0-7C5.5.671 6.172 0 7 0zM3 0c.829 0 1.5.671 1.5 1.5l0 7c0 .829-.671 1.5-1.5 1.5-.828 0-1.5-.671-1.5-1.5l0-7C1.5.671 2.172 0 3 0zm.5 8.5l0-7c0-.276-.224-.5-.5-.5-.275 0-.5.224-.5.5l0 7c0 .276.225.5.5.5.276 0 .5-.224.5-.5z"],"pause_12":["M4 2c-.276 0-.5.224-.5.5l0 7c0 .276.224.5.5.5.276 0 .5-.224.5-.5l0-7c0-.276-.224-.5-.5-.5m0 9c-.827 0-1.5-.673-1.5-1.5l0-7C2.5 1.673 3.173 1 4 1c.827 0 1.5.673 1.5 1.5l0 7c0 .827-.673 1.5-1.5 1.5zm4 0c-.827 0-1.5-.673-1.5-1.5l0-7C6.5 1.673 7.173 1 8 1c.827 0 1.5.673 1.5 1.5l0 7c0 .827-.673 1.5-1.5 1.5zm0-9c-.276 0-.5.224-.5.5l0 7c0 .276.224.5.5.5.276 0 .5-.224.5-.5l0-7c0-.276-.224-.5-.5-.5z"],"pause_16":["M6 13c0 .551-.449 1-1 1-.552 0-1-.449-1-1L4 3c0-.551.448-1 1-1 .551 0 1 .449 1 1l0 10zM5 1c1.1 0 2 .9 2 2l0 10c0 1.1-.9 2-2 2-1.1 0-2-.9-2-2L3 3c0-1.1.9-2 2-2zm6 0c1.1 0 2 .9 2 2l0 10c0 1.1-.9 2-2 2-1.1 0-2-.9-2-2L9 3c0-1.1.9-2 2-2zm1 12l0-10c0-.551-.449-1-1-1-.552 0-1 .449-1 1l0 10c0 .551.448 1 1 1 .551 0 1-.449 1-1z"],"pause_20":["M7 2c-1.104 0-2 .896-2 2l0 12c0 1.104.896 2 2 2 1.104 0 2-.896 2-2L9 4c0-1.104-.896-2-2-2m0 1c.552 0 1 .449 1 1l0 12c0 .551-.448 1-1 1-.552 0-1-.449-1-1L6 4c0-.551.448-1 1-1zm6-1c1.104 0 2 .896 2 2l0 12c0 1.104-.896 2-2 2-1.104 0-2-.896-2-2l0-12c0-1.104.896-2 2-2zm0 1c-.552 0-1 .449-1 1l0 12c0 .551.448 1 1 1 .552 0 1-.449 1-1l0-12c0-.551-.448-1-1-1z"],"pause_24":["M8.5 3C9.875 3 11 4.125 11 5.5l0 13c0 1.375-1.125 2.5-2.5 2.5C7.125 21 6 19.875 6 18.5l0-13C6 4.125 7.125 3 8.5 3zM10 18.5l0-13C10 4.673 9.327 4 8.5 4 7.673 4 7 4.673 7 5.5l0 13c0 .827.673 1.5 1.5 1.5.827 0 1.5-.673 1.5-1.5zM15.5 3C16.875 3 18 4.125 18 5.5l0 13c0 1.375-1.125 2.5-2.5 2.5-1.375 0-2.5-1.125-2.5-2.5l0-13C13 4.125 14.125 3 15.5 3zM17 18.5l0-13c0-.827-.673-1.5-1.5-1.5-.827 0-1.5.673-1.5 1.5l0 13c0 .827.673 1.5 1.5 1.5.827 0 1.5-.673 1.5-1.5z"],"pause_32":["M10.5 2C8.575 2 7 3.575 7 5.5l0 21c0 1.925 1.575 3.5 3.5 3.5 1.925 0 3.5-1.575 3.5-3.5l0-21C14 3.575 12.425 2 10.5 2m0 1C11.878 3 13 4.122 13 5.5l0 21c0 1.378-1.122 2.5-2.5 2.5C9.122 29 8 27.878 8 26.5l0-21C8 4.122 9.122 3 10.5 3zm11-1C23.425 2 25 3.575 25 5.5l0 21c0 1.925-1.575 3.5-3.5 3.5-1.925 0-3.5-1.575-3.5-3.5l0-21C18 3.575 19.575 2 21.5 2zm0 1C20.122 3 19 4.122 19 5.5l0 21c0 1.378 1.122 2.5 2.5 2.5 1.378 0 2.5-1.122 2.5-2.5l0-21C24 4.122 22.879 3 21.5 3z"],"pause_8":["M6.5 6.5c0 .276-.225.5-.5.5-.275 0-.5-.224-.5-.5l0-5c0-.276.225-.5.5-.5.275 0 .5.224.5.5l0 5zM6 0c.828 0 1.5.671 1.5 1.5l0 5C7.5 7.329 6.828 8 6 8c-.828 0-1.5-.671-1.5-1.5l0-5C4.5.671 5.172 0 6 0zM2 0c.828 0 1.5.671 1.5 1.5l0 5C3.5 7.329 2.828 8 2 8 1.172 8 .5 7.329.5 6.5l0-5C.5.671 1.172 0 2 0zm.5 6.5l0-5c0-.276-.225-.5-.5-.5-.275 0-.5.224-.5.5l0 5c0 .276.225.5.5.5.275 0 .5-.224.5-.5z"],"pause-circle_16":["M8 0c4.418 0 8 3.582 8 8 0 4.418-3.582 8-8 8-4.418 0-8-3.582-8-8 0-4.418 3.582-8 8-8zm0 15c3.86 0 7-3.14 7-7 0-3.86-3.14-7-7-7-3.86 0-7 3.14-7 7 0 3.86 3.14 7 7 7zM6.5 5c.275 0 .5.225.5.5l0 5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-5c0-.275.225-.5.5-.5zm3 0c.275 0 .5.225.5.5l0 5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-5c0-.275.225-.5.5-.5z"],"pause-circle_20":["M10.0002-.0001c5.522 0 10 4.478 10 10 0 5.523-4.478 10-10 10-5.523 0-10-4.477-10-10 0-5.522 4.477-10 10-10zm0 19c4.962 0 9-4.037 9-9 0-4.963-4.038-9-9-9-4.963 0-9 4.037-9 9 0 4.963 4.037 9 9 9zm-2-13c.825 0 1.5.675 1.5 1.5l0 5c0 .825-.675 1.5-1.5 1.5-.825 0-1.5-.675-1.5-1.5l0-5c0-.825.675-1.5 1.5-1.5zm.5 6.5l0-5c0-.271-.229-.5-.5-.5-.271 0-.5.229-.5.5l0 5c0 .271.229.5.5.5.271 0 .5-.229.5-.5zm3.5-6.5c.825 0 1.5.675 1.5 1.5l0 5c0 .825-.675 1.5-1.5 1.5-.825 0-1.5-.675-1.5-1.5l0-5c0-.825.675-1.5 1.5-1.5zm.5 6.5l0-5c0-.271-.229-.5-.5-.5-.271 0-.5.229-.5.5l0 5c0 .271.229.5.5.5.271 0 .5-.229.5-.5z"],"pause-circle_24":["M12 0c6.617 0 12 5.383 12 12 0 6.617-5.383 12-12 12-6.617 0-12-5.383-12-12C0 5.383 5.383 0 12 0zm0 23c6.065 0 11-4.935 11-11 0-6.065-4.935-11-11-11C5.935 1 1 5.935 1 12c0 6.065 4.935 11 11 11zM9.498 7c.825 0 1.5.675 1.5 1.5l0 7c0 .825-.675 1.5-1.5 1.5-.825 0-1.5-.675-1.5-1.5l0-7c0-.825.675-1.5 1.5-1.5zm.5 8.5l0-7c0-.271-.229-.5-.5-.5-.271 0-.5.229-.5.5l0 7c0 .271.229.5.5.5.271 0 .5-.229.5-.5zm4.5-8.5c.825 0 1.5.675 1.5 1.5l0 7c0 .825-.675 1.5-1.5 1.5-.825 0-1.5-.675-1.5-1.5l0-7c0-.825.675-1.5 1.5-1.5zm.5 8.5l0-7c0-.271-.229-.5-.5-.5-.271 0-.5.229-.5.5l0 7c0 .271.229.5.5.5.271 0 .5-.229.5-.5z"],"pdf_12":["M10 10.5c0 .275-.225.5-.5.5l-7 0c-.275 0-.5-.225-.5-.5l0-9c0-.275.225-.5.5-.5L6 1l.928 0L10 4.072l0 6.428zm.759-7.083c.156.157.241.363.241.583l0 6.5c0 .827-.673 1.5-1.5 1.5l-7 0c-.827 0-1.5-.673-1.5-1.5l0-9C1 .673 1.673 0 2.5 0L6 0l1 0c.219 0 .426.085.582.24l3.177 3.177zM6.9072 6.3369c.047-.118.071-.241.071-.366 0-.535-.435-.971-.97-.971-.536 0-.971.436-.971.971 0 .128.024.252.079.386l.357.781-.264.611c-.39.144-.727.275-.911.35-.4.134-.668.505-.668.925 0 .538.44.976 1.014.976.383 0 .733-.223.894-.569l.404-.885c.106-.038.209-.075.31-.11.039.046.077.09.113.131.184.211.492.492 1.054.492.535 0 .97-.436.97-.971 0-.554-.417-.971-.969-.971-.171 0-.45.061-.775.153-.027-.048-.053-.096-.078-.144l.335-.779c.002-.003.003-.007.005-.01z"],"pdf_28":["M24 25c0 1.103-.897 2-2 2L6 27c-1.103 0-2-.897-2-2L4 3c0-1.103.897-2 2-2l10.172 0c.263 0 .52.107.707.293l6.828 6.828c.186.187.293.444.293.707L24 25zm.414-17.586c.375.375.586.884.586 1.414L25 25c0 1.657-1.343 3-3 3L6 28c-1.657 0-3-1.343-3-3L3 3c0-1.657 1.343-3 3-3l10.172 0c.53 0 1.039.211 1.414.586l6.828 6.828zm-6.2807 11.9976c-.786 0-1.214-.288-1.615-.719-.141-.153-.275-.302-.402-.448.902-.254 1.641-.421 2.019-.421.645 0 .874.41.874.794 0 .438-.393.794-.876.794zm-4.434-1.473l.368-.802c.111.19.232.379.362.569-.242.076-.486.154-.73.233zm-.513-4.854c-.039-.092-.06-.19-.06-.291 0-.438.393-.794.877-.794.483 0 .877.356.877.794 0 .099-.02.197-.06.288l-.792 1.734-.842-1.731zm-2.334 8.43c-.147.295-.475.485-.93.485-.503 0-.913-.363-.913-.81 0-.342.245-.649.634-.772.513-.192 1.264-.464 2.113-.762l-.904 1.859zm7.283-4.691c-.531 0-1.542.24-2.697.576-.342-.469-.617-.926-.848-1.407l1.142-2.499c.001-.003.002-.006.004-.009.095-.219.144-.452.144-.691 0-.989-.842-1.794-1.877-1.794-1.035 0-1.877.805-1.877 1.794 0 .239.048.47.152.708l1.211 2.493-1.113 2.386c-1.503.514-2.768.983-3.058 1.092-.783.246-1.309.936-1.309 1.717 0 .998.858 1.81 2.007 1.81.738 0 1.418-.408 1.733-1.044l1.342-2.759c.662-.222 1.338-.444 1.979-.641.216.265.454.535.716.817.676.728 1.378 1.039 2.347 1.039 1.035 0 1.876-.805 1.876-1.794 0-.892-.644-1.794-1.874-1.794z"],"pdf_44":["M38 40c0 1.654-1.346 3-3 3L9 43c-1.654 0-3-1.346-3-3L6 4c0-1.654 1.346-3 3-3l16.809 0c.202 0 .4.082.543.225l11.423 11.381c.143.143.225.341.225.542L38 40zm.481-28.102c.33.33.519.786.519 1.25L39 40c0 2.206-1.794 4-4 4L9 44c-2.206 0-4-1.794-4-4L5 4c0-2.206 1.794-4 4-4l16.809 0c.472 0 .916.184 1.249.517l11.423 11.381zm-9.4458 19.1196c-1.476 0-2.282-.6-3.038-1.5-.424-.505-.808-.993-1.16-1.476 1.857-.62 3.416-1.047 4.175-1.047.548 0 1.034.198 1.406.574.389.393.6.931.594 1.519 0 1.046-.906 1.93-1.977 1.93zm-8.247-2.588l1.308-3.027c.345.727.731 1.425 1.174 2.119-.818.288-1.657.597-2.482.908zm-.635-9.674c-.094-.238-.141-.491-.141-.751l0-.004c-.003-.536.204-1.039.581-1.419.378-.378.88-.587 1.415-.587 1.099 0 1.995.893 1.997 2.01 0 .261-.048.515-.137.741l-1.787 4.158-1.928-4.148zm-3.278 16.083c-.317.705-1.008 1.161-1.761 1.161l-.162 0c-1.07 0-1.94-.897-1.94-2.001 0-.859.53-1.622 1.352-1.909 1.06-.453 2.71-1.135 4.538-1.856l-2.027 4.605zm12.137-8.844c-.917 0-2.719.501-4.767 1.191-.642-.98-1.161-1.961-1.612-3.033l2.16-5.027c.14-.357.212-.734.212-1.141-.003-1.649-1.347-2.99-2.997-2.99-.803 0-1.556.313-2.123.881-.567.571-.877 1.328-.873 2.131 0 .386.071.76.222 1.143l2.283 4.912c.011.026.021.053.032.08l-2.075 4.792c-2.863 1.112-5.266 2.136-5.471 2.224-1.191.415-1.991 1.556-1.991 2.841 0 1.655 1.318 3.001 2.94 3.001l.162 0c1.147 0 2.196-.687 2.674-1.755l2.433-5.525c1.212-.468 2.458-.931 3.627-1.34.414.583.871 1.171 1.383 1.781.772.919 1.827 1.857 3.804 1.857 1.641 0 2.977-1.314 2.977-2.924.009-.852-.305-1.643-.883-2.228-.555-.562-1.307-.871-2.117-.871z"],"pdf_72":["M62 64.5c0 3.033-2.467 5.5-5.5 5.5l-41 0c-3.033 0-5.5-2.467-5.5-5.5l0-57C10 4.467 12.467 2 15.5 2l26.617 0c.41 0 .796.159 1.087.449l18.348 18.266c.289.288.448.671.448 1.079L62 64.5zm.257-44.494c.479.477.743 1.112.743 1.788L63 64.5c0 3.584-2.916 6.5-6.5 6.5l-41 0C11.916 71 9 68.084 9 64.5l0-57C9 3.916 11.916 1 15.5 1l26.617 0c.676 0 1.313.263 1.792.74l18.348 18.266zM48.3896 51.7646c-2.319 0-3.932-.761-5.566-2.627-.838-.957-1.589-1.871-2.267-2.761 3.422-1.075 6.388-1.848 7.84-1.848 2.503 0 3.623 1.818 3.623 3.618 0 1.995-1.623 3.618-3.63 3.618zm-15.248-3.943l3.071-6.57c.742 1.556 1.625 3.053 2.715 4.595-1.897.614-3.878 1.296-5.786 1.975zm-.876-16.408c-.177-.433-.268-.893-.268-1.408 0-2.209 1.797-4.006 4.006-4.006 2.204 0 4.001 1.794 4.005 4.007l.001.045c0 .473-.091.933-.26 1.345l-3.525 7.482-3.959-7.465zm-4.829 26.446c-.607 1.3-1.941 2.14-3.398 2.14l-.282 0c-2.06 0-3.737-1.646-3.737-3.669 0-1.571 1.018-2.967 2.56-3.483.089-.035 3.92-1.547 8.657-3.272l-3.8 8.284zm20.96-14.331c-1.597 0-4.817.845-8.468 1.998-1.314-1.827-2.328-3.584-3.16-5.457l3.896-8.27c.229-.557.345-1.147.345-1.753 0 0-.001-.051-.001-.051-.005-2.754-2.251-4.996-5.005-4.996-2.76 0-5.006 2.246-5.006 5.047 0 .605.116 1.192.364 1.791l4.145 7.816c.054.133.11.266.166.399l-2.564 5.442-1.283 2.798c-5.005 1.806-9.216 3.469-9.588 3.617-1.925.642-3.218 2.418-3.218 4.421 0 2.575 2.125 4.669 4.737 4.669l.282 0c1.844 0 3.534-1.066 4.306-2.72l4.212-9.182c2.285-.821 4.712-1.665 6.99-2.399.746.997 1.582 2.021 2.525 3.098 1.822 2.08 3.711 2.968 6.33 2.968 2.547 0 4.618-2.071 4.618-4.618 0-2.224-1.447-4.618-4.623-4.618z"],"pen_12":["M10.6931 2.7859l-7.398 7.397-1.481-1.48 7.399-7.397c.408-.408 1.072-.408 1.48 0 .198.197.307.46.307.74 0 .28-.109.542-.307.74zm-9.54 8.059l.248-1.141.893.893-1.141.248zM11.4001.5979c-.799-.797-2.096-.797-2.895 0l-7.751 7.752c-.068.068-.115.154-.135.248l-.608 2.795c-.036.166.015.339.135.459.095.095.223.147.354.147.035 0 .071-.004.106-.011l2.795-.608c.094-.021.18-.068.247-.136l7.752-7.751c.387-.387.6-.9.6-1.447 0-.547-.213-1.061-.6-1.448z"],"pen_14":["M12.611 3.2449l-8.818 8.818-1.879-1.878 8.818-8.818c.502-.502 1.377-.502 1.879 0 .518.518.518 1.36 0 1.878zm-11.104 7.948l1.277 1.277-1.631.354.354-1.631zM13.318.6599c-.879-.88-2.414-.88-3.293 0L.864 9.8209c-.067.068-.114.153-.135.247l-.718 3.304c-.036.166.015.339.135.459.095.095.223.147.354.147.035 0 .071-.004.106-.011l3.304-.719c.094-.02.18-.067.247-.135l9.161-9.161c.907-.908.907-2.384 0-3.292z"],"pen_16":["M14.5285 3.72796678L4.3355 13.9367585l-2.276-2.2785246 10.194-10.20879172c.607-.610945052 1.668-.610945052 2.275 0 .305.30346943.472.70909689.472 1.13876152 0 .43066619-.167.8352921-.472 1.13976308zM1.6315 12.6447599l1.718 1.7216632-2.196.477739.478-2.1994022zM15.2355.741346848c-.984-.988529131-2.705-.988529131-3.689 0L.9755 11.3277226c-.068.0671038-.115.1532371-.135.2473827l-.829 3.8169043c-.036.1672587.015.3405267.135.4607127.095.0951471.222.1472277.354.1472277.035 0 .07-.0040062.106-.0120186l3.812-.8302843c.093-.020031.179-.0671038.247-.1352092l10.57-10.58637579c.493-.49276224.765-1.14877701.765-1.84785841 0-.69807984-.272-1.35409461-.765-1.846856852z"],"pen_18":["M16.446 4.226l-11.6 11.6-2.673-2.674 11.599-11.6c.737-.736 1.938-.736 2.674 0 .737.737.737 1.937 0 2.674zm-14.703 9.91l2.119 2.119-2.708.589.589-2.708zM17.153.845c-1.127-1.127-2.961-1.127-4.088 0L1.086 12.825c-.068.067-.115.153-.135.247l-.94 4.32c-.036.166.015.34.135.46.095.095.223.146.354.146.035 0 .071-.003.106-.011l4.32-.94c.094-.02.18-.067.248-.134l11.979-11.98c1.127-1.127 1.127-2.961 0-4.088z"],"pen_8":["M6.858 1.82649l-4.173 4.173-.685-.686 4.172-4.173c.189-.187.498-.188.686 0 .189.189.189.498 0 .686zm-5.532 4.228l.619.619-.791.172.172-.791zm6.239-5.621c-.579-.578-1.52-.579-2.099 0l-4.933 4.933c-.068.067-.114.153-.135.247l-.387 1.779c-.036.166.015.34.136.46.094.095.222.147.353.147.035 0 .071-.004.107-.012l1.778-.387c.094-.02.18-.067.247-.134l4.934-4.933c.578-.579.578-1.52-.001-2.1z"],"people_10":["M1.0615 9l.262-1.05c.196-.78.894-1.325 1.698-1.325l3.957 0c.804 0 1.502.545 1.698 1.326L8.9385 9l-7.877 0zm3.938-8c1.275 0 2.313 1.037 2.313 2.313 0 1.275-1.038 2.312-2.313 2.312-1.274 0-2.312-1.037-2.312-2.312C2.6875 2.037 3.7255 1 4.9995 1zm4.977 8.029l-.331-1.321c-.276-1.107-1.199-1.907-2.306-2.053.601-.599.973-1.428.973-2.342C8.3125 1.486 6.8265 0 4.9995 0c-1.826 0-3.312 1.486-3.312 3.313 0 .914.373 1.743.974 2.342-1.107.146-2.03.946-2.308 2.052L.0225 9.03c-.058.236-.005.48.144.67.149.191.373.3.615.3l8.437 0c.242 0 .466-.109.615-.3.149-.19.202-.434.143-.671z"],"people_12":["M1.0492 11l.349-1.355C1.6482 8.676 2.5462 8 3.5822 8l4.836 0c1.036 0 1.934.676 2.184 1.645l.349 1.355-9.902 0zm1.951-7c0-1.654 1.346-3 3-3 1.654 0 3 1.346 3 3 0 1.654-1.346 3-3 3-1.654 0-3-1.346-3-3zm8.974 6.961l-.404-1.566c-.349-1.352-1.557-2.303-2.97-2.38.85-.734 1.4-1.807 1.4-3.015 0-2.206-1.795-4-4-4-2.206 0-4 1.794-4 4 0 1.208.55 2.281 1.4 3.015-1.413.077-2.621 1.028-2.97 2.38l-.404 1.566c-.064.249-.01.509.148.712.161.208.405.327.67.327l10.312 0c.265 0 .509-.119.67-.327.158-.203.212-.463.148-.712z"],"people_14":["M1.0226 13.0002l.453-1.856c.307-1.263 1.404-2.144 2.667-2.144l5.715 0c1.263 0 2.36.881 2.667 2.143l.453 1.857-11.955 0zm2.478-8.5c0-1.93 1.57-3.5 3.5-3.5 1.929 0 3.5 1.57 3.5 3.5 0 1.93-1.571 3.5-3.5 3.5-1.93 0-3.5-1.57-3.5-3.5zm10.473 8.364l-.477-1.958c-.417-1.711-1.913-2.906-3.639-2.906l-.064 0c1.032-.825 1.707-2.079 1.707-3.5 0-2.481-2.019-4.5-4.5-4.5-2.482 0-4.5 2.019-4.5 4.5 0 1.421.674 2.675 1.706 3.5l-.064 0c-1.725 0-3.222 1.195-3.639 2.906l-.477 1.958c-.067.278-.005.566.17.789.174.221.432.347.71.347l12.187 0c.278 0 .536-.126.71-.347.176-.223.238-.511.17-.789z"],"people_16":["M1.00159564 14.993l.55095311-2.349C1.91751769 11.087 3.21240748 10 4.70328059 10l6.59343881 0c1.4908731 0 2.7867628 1.087 3.1517318 2.644L15.0304016 15l-14.02880596-.007zm2.99874478-9.994C4.00034042 2.794 5.79418774 1 8 1c2.2058123 0 3.9996596 1.794 3.9996596 3.999 0 2.206-1.7938473 4-3.9996596 4-2.20581226 0-3.99965958-1.794-3.99965958-4zm11.97198108 9.765l-.5509531-2.349c-.47096-2.01-2.1678155-3.415-4.124649-3.415l-.328972 0c1.2258957-.912 2.0318271-2.359 2.0318271-4.001C12.9995745 2.243 10.7567654 0 8 0 5.24323463 0 3.00042552 2.243 3.00042552 4.999c0 1.642.80593141 3.089 2.03182707 4.001l-.328972 0C2.74644714 9 1.04959156 10.405.578631641 12.415l-.5509531078 2.349c-.0719938725.308-.0019998297.625.1919836598.869.184984256.233.457961023.367.749936172.367L15.0304016 16c.2919752 0 .564952-.134.7499362-.367.1939835-.244.2639775-.561.1919837-.869z"],"people_20":["M1.999730749 18.007l.623000001-2.348c.416-1.565 1.913-2.659 3.64-2.659l7.47399995 0c1.727 0 3.224 1.094 3.64 2.658l.592 2.342-15.968999951.007zM4.99973075 7c0-2.757 2.243-5 5-5 2.75699995 0 4.99999995 2.243 4.99999995 5 0 2.757-2.243 5-4.99999995 5-2.757 0-5-2.243-5-5zM18.9667307 17.751l-.623-2.349c-.533-2.003-2.427-3.402-4.607-3.402l-.427 0c1.619-1.075 2.69-2.914 2.69-5 0-3.308-2.691-6-5.99999995-6-3.309 0-6 2.692-6 6 0 2.086 1.071 3.925 2.69 5l-.427 0c-2.18 0-4.074 1.399-4.607000001 3.403l-.6229999999 2.347c-.078.295-.015.605.1719999999.848.196.256.497.402.826000001.402l15.93799995 0c.329 0 .63-.146.826-.402.187-.243.25-.553.172-.847z"],"people_24":["M21.9633034 21.94c-.0209987.027-.0599962.06-.1199925.06L2.15653211 22c-.05999628 0-.09799392-.033-.11999255-.06-.01899882-.024-.048996964-.077-.03099808-.149l.77195211-3.132C3.30746072 16.504 5.20134323 15 7.38420782 15l9.23142738 0c2.1828646 0 4.0767471 1.504 4.6077141 3.659l.7709522 3.132c.0179989.072-.0109993.125-.0309981.149M6.00029367 8c0-3.309 2.69183302-6 5.99962783-6 3.3087947 0 5.9996278 2.691 5.9996278 6 0 3.308-2.6908331 6-5.9996278 6-3.30779481 0-5.99962783-2.692-5.99962783-6M22.9652413 21.552l-.7719521-3.132c-.6389604-2.603-2.9328181-4.42-5.577654-4.42l-1.0289362 0c2.0398735-1.225 3.4127883-3.453 3.4127883-6 0-3.86-3.1398052-7-6.9995658-7-3.85876063 0-6.9995658 3.14-6.9995658 7 0 2.547 1.37291484 4.775 3.41378823 6l-1.02993611 0c-2.64483593 0-4.93869363 1.817-5.577653997 4.42l-.7719521131 3.132c-.0869946034.353-.0079995037.719.2149866641 1.004.220986291.282.551965759.444.906943736.444l19.68677879 0c.354978 0 .6859574-.162.9069437-.444.2239861-.285.3019813-.651.2149867-1.004"],"people_26":["M23.9702 23.915c-.041.054-.111.085-.189.085l-21.562 0c-.078 0-.149-.031-.189-.085-.041-.054-.03-.098-.025-.113l.844-3.132c.582-2.161 2.677-3.67 5.095-3.67l10.111 0c2.418 0 4.514 1.509 5.096 3.67l.844 3.133c.004.014.016.058-.025.112M6.0002 9c0-3.859 3.14-7 7-7 3.86 0 7 3.141 7 7 0 3.859-3.14 7-7 7-3.86 0-7-3.141-7-7m18.961 14.542l-.844-3.132c-.7-2.597-3.193-4.41-6.062-4.41l-1.191 0c2.463-1.365 4.136-3.99 4.136-7 0-4.411-3.589-8-8-8-4.411 0-8 3.589-8 8 0 3.01 1.672 5.635 4.136 7l-1.192 0c-2.869 0-5.361 1.813-6.061 4.41l-.844 3.131c-.092.341-.02.699.197.982.228.298.596.477.983.477l21.562 0c.387 0 .754-.179.983-.477.217-.283.289-.641.197-.981"],"people_28":["M25.9501 25.8906c-.054.069-.138.109-.232.109l-23.436 0c-.094 0-.179-.04-.232-.109-.032-.041-.065-.108-.042-.196l.917-3.524c.639-2.456 2.934-4.171 5.58-4.171l10.99 0c2.646 0 4.94 1.715 5.58 4.171l.917 3.524c.023.088-.01.155-.042.196m-19.45-16.391c0-4.135 3.364-7.5 7.5-7.5 4.136 0 7.5 3.365 7.5 7.5 0 4.136-3.364 7.5-7.5 7.5-4.136 0-7.5-3.364-7.5-7.5m20.46 15.943l-.918-3.524c-.754-2.896-3.446-4.919-6.547-4.919l-1.504 0c2.68-1.431 4.509-4.255 4.509-7.5 0-4.686-3.813-8.5-8.5-8.5-4.687 0-8.5 3.814-8.5 8.5 0 3.245 1.829 6.069 4.509 7.5l-1.504 0c-3.101 0-5.794 2.023-6.548 4.919l-.917 3.524c-.096.369-.017.755.218 1.059.244.317.617.498 1.024.498l23.436 0c.406 0 .779-.181 1.024-.498.235-.304.314-.69.218-1.059"],"people_32":["M29.9106 29.8437c-.045.059-.147.156-.317.156l-27.186 0c-.17 0-.272-.097-.317-.156-.081-.103-.109-.234-.077-.362l1.064-4.307c.753-3.047 3.446-5.175 6.548-5.175l12.749 0c3.102 0 5.795 2.128 6.549 5.175l1.064 4.307c.032.128.004.259-.077.362m-22.41-19.344c0-4.686 3.813-8.5 8.5-8.5 4.687 0 8.5 3.814 8.5 8.5 0 4.687-3.813 8.5-8.5 8.5-4.687 0-8.5-3.813-8.5-8.5m23.458 18.741l-1.065-4.306c-.863-3.494-3.956-5.935-7.519-5.935l-2.157 0c3.126-1.556 5.283-4.777 5.283-8.5 0-5.238-4.262-9.5-9.5-9.5-5.238 0-9.5 4.262-9.5 9.5 0 3.723 2.157 6.944 5.283 8.5l-2.158 0c-3.563 0-6.655 2.441-7.519 5.935l-1.064 4.306c-.106.428-.011.874.26 1.22.269.343.671.539 1.105.539l27.186 0c.434 0 .836-.196 1.105-.539.271-.346.366-.792.26-1.22"],"people_36":["M33.8973187 33.794c-.101.131-.258.206-.429.206L2.53131871 34c-.171 0-.328-.075-.429-.206-.054-.07-.137-.216-.087-.412l1.211-4.698c.863-3.347 3.955-5.684 7.52-5.684l14.50699999 0c3.565 0 6.657 2.337 7.52 5.684l1.211 4.697c.05.197-.033.343-.087.413M8.00031871 12c0-5.515 4.48599999-10 9.99999999-10 5.513 0 10 4.485 10 10 0 5.514-4.487 10-10 10-5.514 0-9.99999999-4.486-9.99999999-10M34.9523187 33.132l-1.211-4.698c-.977-3.788-4.467-6.434-8.488-6.434l-2.698 0c3.796-1.737 6.445-5.561 6.445-10 0-6.066-4.935-11-11-11-6.066 0-10.99999999 4.934-10.99999999 11 0 4.439 2.648 8.263 6.44399999 10l-2.69799999 0c-4.021 0-7.511 2.646-8.488 6.434l-1.2110000001 4.698c-.115.445-.018.91.2650000001 1.275.292.376.736.593 1.219.593l30.93699999 0c.483 0 .927-.217 1.22-.593.282-.365.379-.83.264-1.275"],"people_8":["M1.07886834 7l.169-.678c.14-.558.639-.947 1.213-.947l3.077 0c.575 0 1.074.389 1.213.947l.17.678-5.842 0zm2.921-6c.931 0 1.687.757 1.687 1.688 0 .93-.756 1.687-1.687 1.687-.931 0-1.688-.757-1.688-1.687 0-.931.757-1.688 1.688-1.688zm3.978 6.107l-.257-1.027c-.21-.842-.877-1.464-1.696-1.645.407-.472.662-1.078.662-1.747 0-1.483-1.205-2.688-2.687-2.688-1.482 0-2.688 1.205-2.688 2.688 0 .669.256 1.275.663 1.747-.819.181-1.486000002.803-1.696000002 1.645L.0218683378 7.106c-.054.216-.007.441.1300000002.618.137.175.344.276.567.276L7.28086834 8c.223 0 .429-.101.567-.276.137-.177.184-.402.13-.617z"],"people-circle_16":["M8 0c4.418 0 8 3.582 8 8 0 4.418-3.582 8-8 8-4.418 0-8-3.582-8-8 0-4.418 3.582-8 8-8zm0 15c3.859 0 7-3.141 7-7 0-3.859-3.141-7-7-7-3.86 0-7 3.141-7 7 0 3.859 3.14 7 7 7zm1.6698-6.906c.539.183.949.622 1.052 1.176l.221 1.134c.028.147-.01.299-.105.414-.095.116-.237.182-.386.182l-4.904 0c-.15 0-.291-.066-.386-.182-.095-.115-.134-.267-.105-.414l.222-1.14c.101-.55.512-.987 1.05-1.17-.207-.315-.329-.69-.329-1.094 0-1.104.897-2 2-2 1.103 0 2 .896 2 2 0 .404-.123.779-.33 1.094zM6.1538 10l3.691 0-.106-.545c-.048-.262-.321-.455-.636-.455l-2.206 0c-.315 0-.589.193-.636.45l-.107.55zm1.846-4c-.552 0-1 .449-1 1 0 .551.448 1 1 1 .551 0 1-.449 1-1 0-.551-.449-1-1-1z"],"people-circle_20":["M10 0c5.523 0 10 4.477 10 10 0 5.523-4.477 10-10 10-5.523 0-10-4.477-10-10C0 4.477 4.477 0 10 0zm0 19c4.963 0 9-4.037 9-9 0-4.963-4.037-9-9-9-4.962 0-9 4.037-9 9 0 4.963 4.038 9 9 9zm2.1416-8.901c.771.237 1.388.91 1.584 1.808l.257 1.176c.051.227-.006.47-.15.649-.136.17-.337.268-.55.268l-6.565 0c-.213 0-.414-.098-.551-.268-.144-.179-.2-.422-.15-.65l.257-1.174c.197-.898.814-1.572 1.585-1.809-.53-.542-.86-1.282-.86-2.098C6.9986 6.347 8.3456 5 9.9996 5c1.655 0 3.002 1.347 3.002 3.001 0 .816-.33 1.556-.86 2.098zM7.0586 13l5.883 0-.192-.879c-.145-.66-.642-1.121-1.21-1.121l-1.511 0c-.01 0-.019.003-.029.003-.009 0-.019-.003-.029-.003l-1.51 0c-.568 0-1.066.461-1.21 1.122l-.192.878zm2.941-7c-1.103 0-2.001.897-2.001 2.001 0 1.094.882 1.983 1.973 1.999l.057 0c1.09-.016 1.973-.905 1.973-1.999 0-1.104-.898-2.001-2.002-2.001z"],"people-circle_24":["M12 0c6.627 0 12 5.373 12 12 0 6.627-5.373 12-12 12-6.627 0-12-5.373-12-12C0 5.373 5.373 0 12 0zm0 23c6.065 0 11-4.935 11-11 0-6.065-4.935-11-11-11C5.935 1 1 5.935 1 12c0 6.065 4.935 11 11 11zm5.5698-7.605l.404 1.566c.064.249.011.508-.148.712-.16.208-.405.327-.67.327l-10.312 0c-.265 0-.509-.119-.67-.327-.158-.204-.212-.463-.148-.712l.404-1.566c.349-1.352 1.556-2.303 2.971-2.38-.851-.734-1.401-1.806-1.401-3.015 0-2.206 1.795-4 4-4 2.206 0 4 1.794 4 4 0 1.209-.55 2.281-1.4 3.015 1.414.077 2.621 1.028 2.97 2.38zM7.0488 17l9.902 0-.349-1.355c-.25-.969-1.148-1.645-2.184-1.645l-4.836 0c-1.036 0-1.934.676-2.183 1.645L7.0488 17zm1.951-7c0 1.654 1.346 3 3 3 1.654 0 3-1.346 3-3 0-1.654-1.346-3-3-3-1.654 0-3 1.346-3 3z"],"phone-adr_12":["M3.5 1c-.27614237 0-.5.22385763-.5.5l0 9c0 .2761424.22385763.5.5.5l5 0c.27614237 0 .5-.2238576.5-.5l0-9c0-.27614237-.22385763-.5-.5-.5l-5 0zm0-1l5 0c.82842712 0 1.5.671572875 1.5 1.5l0 9c0 .8284271-.67157288 1.5-1.5 1.5l-5 0c-.828427125 0-1.5-.6715729-1.5-1.5l0-9C2 .671572875 2.671572875 0 3.5 0zm2 2c-.27614237 0-.5.22385763-.5.5 0 .27614237.22385763.5.5.5l1 0c.27614237 0 .5-.22385763.5-.5 0-.27614237-.22385763-.5-.5-.5l-1 0z"],"phone-adr_16":["M6.5 2l1 0c.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5l-1 0c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5zm3 0c.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5zM5 1c-.55228475 0-1 .44771525-1 1l0 12c0 .5522847.44771525 1 1 1l6 0c.55228475 0 1-.4477153 1-1l0-12c0-.55228475-.44771525-1-1-1L5 1zm0-1l6 0c1.1045695 0 2 .8954305 2 2l0 12c0 1.1045695-.8954305 2-2 2l-6 0c-1.1045695 0-2-.8954305-2-2L3 2c0-1.1045695.8954305-2 2-2z"],"phone-adr_20":["M5.5 1C4.67157288 1 4 1.67157288 4 2.5l0 15c0 .8284271.67157288 1.5 1.5 1.5l9 0c.8284271 0 1.5-.6715729 1.5-1.5l0-15c0-.82842712-.6715729-1.5-1.5-1.5l-9 0zm0-1l9 0C15.8807119 0 17 1.11928813 17 2.5l0 15c0 1.3807119-1.1192881 2.5-2.5 2.5l-9 0C4.11928813 20 3 18.8807119 3 17.5l0-15C3 1.11928813 4.11928813 0 5.5 0zm2 3c-.27614237 0-.5.22385763-.5.5 0 .27614237.22385763.5.5.5l3 0c.27614237 0 .5-.22385763.5-.5 0-.27614237-.22385763-.5-.5-.5l-3 0zm5 1c.27614237 0 .5-.22385763.5-.5 0-.27614237-.22385763-.5-.5-.5-.27614237 0-.5.22385763-.5.5 0 .27614237.22385763.5.5.5z"],"phone-adr_24":["M6.5 0l11 0C18.8807119 0 20 1.11928813 20 2.5l0 19c0 1.3807119-1.1192881 2.5-2.5 2.5l-11 0C5.11928813 24 4 22.8807119 4 21.5l0-19C4 1.11928813 5.11928813 0 6.5 0zm0 1C5.67157288 1 5 1.67157288 5 2.5l0 19c0 .8284271.67157288 1.5 1.5 1.5l11 0c.8284271 0 1.5-.6715729 1.5-1.5l0-19c0-.82842712-.6715729-1.5-1.5-1.5l-11 0zm2 2l4 0c.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5l-4 0c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5zm7 1c-.2761424 0-.5-.22385763-.5-.5 0-.27614237.2238576-.5.5-.5.2761424 0 .5.22385763.5.5 0 .27614237-.2238576.5-.5.5z"],"phone-android_12":["M3.5 1c-.27614237 0-.5.22385763-.5.5l0 9c0 .2761424.22385763.5.5.5l5 0c.27614237 0 .5-.2238576.5-.5l0-9c0-.27614237-.22385763-.5-.5-.5l-5 0zm0-1l5 0c.82842712 0 1.5.671572875 1.5 1.5l0 9c0 .8284271-.67157288 1.5-1.5 1.5l-5 0c-.828427125 0-1.5-.6715729-1.5-1.5l0-9C2 .671572875 2.671572875 0 3.5 0zm2 2c-.27614237 0-.5.22385763-.5.5 0 .27614237.22385763.5.5.5l1 0c.27614237 0 .5-.22385763.5-.5 0-.27614237-.22385763-.5-.5-.5l-1 0z"],"phone-android_16":["M6.5 2l1 0c.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5l-1 0c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5zm3 0c.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5zM5 1c-.55228475 0-1 .44771525-1 1l0 12c0 .5522847.44771525 1 1 1l6 0c.55228475 0 1-.4477153 1-1l0-12c0-.55228475-.44771525-1-1-1L5 1zm0-1l6 0c1.1045695 0 2 .8954305 2 2l0 12c0 1.1045695-.8954305 2-2 2l-6 0c-1.1045695 0-2-.8954305-2-2L3 2c0-1.1045695.8954305-2 2-2z"],"phone-android_24":["M6.5 0l11 0C18.8807119 0 20 1.11928813 20 2.5l0 19c0 1.3807119-1.1192881 2.5-2.5 2.5l-11 0C5.11928813 24 4 22.8807119 4 21.5l0-19C4 1.11928813 5.11928813 0 6.5 0zm0 1C5.67157288 1 5 1.67157288 5 2.5l0 19c0 .8284271.67157288 1.5 1.5 1.5l11 0c.8284271 0 1.5-.6715729 1.5-1.5l0-19c0-.82842712-.6715729-1.5-1.5-1.5l-11 0zm2 2l4 0c.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5l-4 0c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5zm7 1c-.2761424 0-.5-.22385763-.5-.5 0-.27614237.2238576-.5.5-.5.2761424 0 .5.22385763.5.5 0 .27614237-.2238576.5-.5.5z"],"phone-ios_12":["M3.5 1c-.27614237 0-.5.22385763-.5.5l0 9c0 .2761424.22385763.5.5.5l5 0c.27614237 0 .5-.2238576.5-.5l0-9c0-.27614237-.22385763-.5-.5-.5l-5 0zm0-1l5 0c.82842712 0 1.5.671572875 1.5 1.5l0 9c0 .8284271-.67157288 1.5-1.5 1.5l-5 0c-.828427125 0-1.5-.6715729-1.5-1.5l0-9C2 .671572875 2.671572875 0 3.5 0zM3 9l0 1 6 0 0-1-6 0z"],"phone-ios_16":["M11 0c1.104 0 2 .896 2 2l0 12c0 1.104-.896 2-2 2l-6 0c-1.104 0-2-.896-2-2L3 2c0-1.104.896-2 2-2l6 0zm1 11l0-9c0-.551-.449-1-1-1L5 1c-.551 0-1 .449-1 1l0 9 8 0zm0 3l0-2-8 0 0 2c0 .552.449 1 1 1l6 0c.551 0 1-.448 1-1zm-4.5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0z"],"phone-ios_24":["M18.9998 19l-14 0 0-16.5c0-.827.673-1.5 1.5-1.5l11 0c.827 0 1.5.673 1.5 1.5l0 16.5zm0 2.5c0 .827-.673 1.5-1.5 1.5l-11 0c-.827 0-1.5-.673-1.5-1.5l0-1.5 14 0 0 1.5zm-1.5-21.5c1.378 0 2.5 1.121 2.5 2.5l0 19c0 1.379-1.122 2.5-2.5 2.5l-11 0c-1.378 0-2.5-1.121-2.5-2.5l0-19c0-1.379 1.122-2.5 2.5-2.5l11 0zm-6 22l1 0c.275 0 .5-.225.5-.5 0-.275-.225-.5-.5-.5l-1 0c-.275 0-.5.225-.5.5 0 .275.225.5.5.5z"],"phone-ios-muted_12":["M9 9L3.707 9 9 3.707 9 9zm0 1.5c0 .276-.224.5-.5.5l-5 0c-.276 0-.5-.224-.5-.5l0-.5 6 0 0 .5zm-6-9c0-.276.224-.5.5-.5l5 0c.276 0 .5.224.5.5l0 .793-6 6L3 1.5zM11.854.146c-.196-.195-.512-.195-.708 0L9.981 1.312C9.888.573 9.264 0 8.5 0l-5 0C2.671 0 2 .671 2 1.5l0 7.793-1.854 1.853c-.195.196-.195.512 0 .708.098.097.226.146.354.146.128 0 .256-.049.354-.146l1.165-1.166C2.112 11.427 2.736 12 3.5 12l5 0c.829 0 1.5-.671 1.5-1.5l0-7.793L11.854.854c.195-.196.195-.512 0-.708z"],"phone-iph_12":["M3.5 1c-.27614237 0-.5.22385763-.5.5l0 9c0 .2761424.22385763.5.5.5l5 0c.27614237 0 .5-.2238576.5-.5l0-9c0-.27614237-.22385763-.5-.5-.5l-5 0zm0-1l5 0c.82842712 0 1.5.671572875 1.5 1.5l0 9c0 .8284271-.67157288 1.5-1.5 1.5l-5 0c-.828427125 0-1.5-.6715729-1.5-1.5l0-9C2 .671572875 2.671572875 0 3.5 0zM3 9l0 1 6 0 0-1-6 0z"],"phone-iph_16":["M11 0c1.104 0 2 .896 2 2l0 12c0 1.104-.896 2-2 2l-6 0c-1.104 0-2-.896-2-2L3 2c0-1.104.896-2 2-2l6 0zm1 11l0-9c0-.551-.449-1-1-1L5 1c-.551 0-1 .449-1 1l0 9 8 0zm0 3l0-2-8 0 0 2c0 .552.449 1 1 1l6 0c.551 0 1-.448 1-1zm-4.5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0z"],"phone-iph_20":["M17 17.5c0 1.381-1.119 2.5-2.5 2.5l-9 0C4.119 20 3 18.881 3 17.5l0-15C3 1.119 4.119 0 5.5 0l9 0C15.881 0 17 1.119 17 2.5l0 15zM16 15l0-12.5c0-.827-.673-1.5-1.5-1.5l-9 0C4.673 1 4 1.673 4 2.5L4 15l12 0zm0 2.5l0-1.5-12 0 0 1.5c0 .827.673 1.5 1.5 1.5l9 0c.827 0 1.5-.673 1.5-1.5zm-6.5.5c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0z"],"phone-iph_24":["M17.4998 0c1.378 0 2.5 1.121 2.5 2.5l0 19c0 1.379-1.122 2.5-2.5 2.5l-11 0c-1.378 0-2.5-1.121-2.5-2.5l0-19c0-1.379 1.122-2.5 2.5-2.5l11 0zm1.5 19l0-16.5c0-.827-.673-1.5-1.5-1.5l-11 0c-.827 0-1.5.673-1.5 1.5l0 16.5 14 0zm0 2.5l0-1.5-14 0 0 1.5c0 .827.673 1.5 1.5 1.5l11 0c.827 0 1.5-.673 1.5-1.5zm-7.5.5c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0z"],"phone-iph-alert_12":["M15.8415 10.3309c.205.341.211.752.017 1.1-.198.351-.572.569-.978.569l-5.599 0-.162 0-5.619 0c-.826 0-1.5-.675-1.5-1.5l0-9c0-.825.674-1.5 1.5-1.5l5 0c.824 0 1.5.675 1.5 1.5l0 5.748 1.038-1.738c.204-.34.583-.51.962-.51.378 0 .756.17.96.509 0 0 .001 0 .001.001l2.88 4.821zm-.941.669c.077 0 .124-.083.085-.149l-2.863-4.781c-.057-.094-.194-.094-.25 0l-2.858 4.781c-.04.066.008.149.084.149l5.802 0zm-2.9004-4c.275 0 .5.225.5.5l0 1c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-1c0-.275.225-.5.5-.5zm0 2.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm-8.9996 1c0 .271.229.5.5.5l4.514 0c-.023-.229.019-.462.144-.67l.198-.33-5.356 0 0 .5zm0-9l0 7.5 5.953 0 .047-.078 0-7.422c0-.271-.229-.5-.5-.5l-5 0c-.271 0-.5.229-.5.5z"],"phone-iph-muted_12":["M9 9L3.707 9 9 3.707 9 9zm0 1.5c0 .276-.224.5-.5.5l-5 0c-.276 0-.5-.224-.5-.5l0-.5 6 0 0 .5zm-6-9c0-.276.224-.5.5-.5l5 0c.276 0 .5.224.5.5l0 .793-6 6L3 1.5zM11.854.146c-.196-.195-.512-.195-.708 0L9.981 1.312C9.888.573 9.264 0 8.5 0l-5 0C2.671 0 2 .671 2 1.5l0 7.793-1.854 1.853c-.195.196-.195.512 0 .708.098.097.226.146.354.146.128 0 .256-.049.354-.146l1.165-1.166C2.112 11.427 2.736 12 3.5 12l5 0c.829 0 1.5-.671 1.5-1.5l0-7.793L11.854.854c.195-.196.195-.512 0-.708z"],"phone-iph-muted-alert_12":["M15.8414 10.3308c.205.341.211.752.017 1.1-.198.351-.572.569-.978.569l-5.514 0-5.866 0c-.765 0-1.389-.573-1.481-1.312l-1.165 1.166c-.099.097-.226.146-.354.146-.128 0-.256-.049-.354-.146-.098-.097-.146-.225-.146-.353l0-.002c0-.128.048-.255.146-.353l1.854-1.853 0-7.793c0-.829.671-1.5 1.5-1.5l5 0c.764 0 1.388.573 1.481 1.312l1.165-1.166c.097-.097.225-.145.352-.146l.003 0c.128.001.255.049.353.146.097.098.145.225.146.353l0 .002c-.001.128-.049.256-.146.353l-1.854 1.853 0 4.541 1.038-1.738c.204-.34.583-.51.962-.51.378 0 .757.17.961.509l0 .001 2.88 4.821zm-.941.669c.077 0 .124-.084.085-.149l-2.863-4.781c-.057-.094-.194-.094-.25 0l-2.858 4.781c-.04.066.008.149.085.149l5.801 0zm-2.9004-4c.275 0 .5.225.5.5l0 1c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-1c0-.275.225-.5.5-.5zm0 2.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm-8.9996 1c0 .276.224.5.5.5l4.514 0c-.023-.229.019-.462.145-.67l.197-.33-5.356 0 0 .5zm0-9l0 6.793 6-6 0-.793c0-.276-.225-.5-.5-.5l-5 0c-.276 0-.5.224-.5.5zm5.953 7.5l.047-.078 0-5.215-5.293 5.293 5.246 0z"],"phone-iph-private_12":["M9.0509 7.9999c.232-1.14 1.242-2 2.449-2 1.207 0 2.217.86 2.449 2l-4.898 0zm2.449 3c-1.207 0-2.217-.86-2.449-2l4.898 0c-.232 1.14-1.242 2-2.449 2zm-3 0l-5 0c-.271 0-.5-.229-.5-.5l0-.5 5.35 0c.14.294.321.563.534.804-.092.116-.228.196-.384.196zm-5.5-9.5c0-.271.229-.5.5-.5l5 0c.271 0 .5.229.5.5l0 4.556c-.617.631-1 1.492-1 2.444 0 .171.027.335.051.5l-5.051 0 0-7.5zm8.5 3.5c-.539 0-1.044.132-1.5.35l0-3.85c0-.825-.675-1.5-1.5-1.5l-5 0c-.825 0-1.5.675-1.5 1.5l0 9c0 .825.675 1.5 1.5 1.5l5 0c.459 0 .856-.223 1.131-.55.542.344 1.18.55 1.869.55 1.933 0 3.5-1.567 3.5-3.5 0-1.933-1.567-3.5-3.5-3.5z"],"picker_14":["M7.32511871 13.8790448c-.093.081-.209.121-.325.121-.116 0-.232-.04-.325-.121l-3.500000002-3c-.21-.179-.235-.495-.054-.704.178-.21099999.495-.23399999.704-.054l3.175000002 2.72 3.175-2.72c.209-.17999999.524-.15699999.704.054.181.209.156.525-.054.704l-3.5 3zM7.00011871 0c.116 0 .232.04.325.121l3.5 3c.21.179.235.495.054.704-.18.211-.495.234-.704.054l-3.175-2.72-3.175000002 2.72c-.209.18-.526.157-.704-.054-.181-.209-.156-.525.054-.704l3.500000002-3c.093-.081.209-.121.325-.121z"],"picker_16":["M4.8535 5.3535c-.195.195-.512.195-.707 0-.195-.195-.195-.512 0-.707l3.5-3.5c.195-.195.512-.195.707 0l3.5 3.5c.195.195.195.512 0 .707-.098.098-.226.146-.354.146-.127 0-.255-.048-.353-.146l-3.147-3.146-3.146 3.146zm6.293 5.293c.195-.195.512-.195.707 0 .195.195.195.512 0 .707l-3.5 3.5c-.098.098-.226.147-.353.147-.128 0-.256-.049-.354-.147l-3.5-3.5c-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0l3.147 3.146 3.146-3.146z"],"picker_18":["M9.32511871 15.8790448c-.093.081-.209.121-.325.121-.116 0-.232-.04-.325-.121l-3.500000002-3c-.21-.179-.235-.495-.054-.704.178-.21099999.495-.23399999.704-.054l3.175000002 2.72 3.175-2.72c.209-.17999999.524-.15699999.704.054.181.209.156.525-.054.704l-3.5 3zM9.00011871 2c.116 0 .232.04.325.121l3.5 3c.21.179.235.495.054.704-.18.211-.495.234-.704.054l-3.175-2.72-3.175000002 2.72c-.209.18-.526.157-.704-.054-.181-.209-.156-.525.054-.704l3.500000002-3c.093-.081.209-.121.325-.121z"],"picture-in-picture_12":["M1.5 2c-.27614237 0-.5.22385763-.5.5l0 7c0 .27614237.22385763.5.5.5l9 0c.2761424 0 .5-.22385763.5-.5l0-7c0-.27614237-.2238576-.5-.5-.5l-9 0zm0-1l9 0c.8284271 0 1.5.671572875 1.5 1.5l0 7c0 .82842712-.6715729 1.5-1.5 1.5l-9 0C.671572875 11 0 10.32842712 0 9.5l0-7C0 1.671572875.671572875 1 1.5 1zM7 7l2 0 0 1-2 0 0-1zm-.5-1c-.27614237 0-.5.22385763-.5.5l0 2c0 .27614237.22385763.5.5.5l3 0c.27614237 0 .5-.22385763.5-.5l0-2c0-.27614237-.22385763-.5-.5-.5l-3 0z"],"picture-in-picture_16":["M14 2c1.105 0 2 .895 2 2l0 8c0 1.105-.895 2-2 2L2 14c-1.105 0-2-.895-2-2l0-8c0-1.105.895-2 2-2l12 0zm1 10l0-8c0-.551-.449-1-1-1L2 3c-.551 0-1 .449-1 1l0 8c0 .551.449 1 1 1l12 0c.551 0 1-.449 1-1zm-1.5-4c.276 0 .5.224.5.5l0 3c0 .276-.224.5-.5.5l-4 0c-.276 0-.5-.224-.5-.5l0-3c0-.276.224-.5.5-.5l4 0zM10 11l3 0 0-2-3 0 0 2z"],"picture-in-picture_20":["M17.5 2C18.875 2 20 3.125 20 4.5l0 11c0 1.375-1.125 2.5-2.5 2.5l-15 0C1.127 18 .003 16.877 0 15.504l0-.004 0-11 0-.004C.003 3.123 1.127 2 2.5 2l15 0zM19 15.5l0-11c0-.827-.673-1.5-1.5-1.5l-15 0C1.673 3 1 3.673 1 4.5l0 11c0 .827.673 1.5 1.5 1.5l15 0c.827 0 1.5-.673 1.5-1.5zm-3.208-5.4995c.667 0 1.208.54 1.208 1.207l0 2.585c0 .667-.541 1.208-1.208 1.208l-4.584 0c-.667 0-1.208-.541-1.208-1.208l0-2.585c0-.667.541-1.207 1.208-1.207l4.584 0zm.208 3.792l0-2.585c0-.114-.093-.207-.208-.207l-4.584 0c-.115 0-.208.093-.208.207l0 2.585c0 .114.093.208.208.208l4.584 0c.115 0 .208-.094.208-.208z"],"picture-in-picture_24":["M21.5 3C22.878 3 24 4.121 24 5.5l0 13c0 1.379-1.122 2.5-2.5 2.5l-19 0C1.122 21 0 19.879 0 18.5l0-13C0 4.121 1.122 3 2.5 3l19 0zM23 18.5l0-13c0-.827-.673-1.5-1.5-1.5l-19 0C1.673 4 1 4.673 1 5.5l0 13c0 .827.673 1.5 1.5 1.5l19 0c.827 0 1.5-.673 1.5-1.5zm-3.414-6.5001c.781 0 1.414.633 1.414 1.414l0 3.172c0 .781-.633 1.414-1.414 1.414l-5.172 0c-.781 0-1.414-.633-1.414-1.414l0-3.172c0-.781.633-1.414 1.414-1.414l5.172 0zm.414 4.586l0-3.172c0-.228-.186-.414-.414-.414l-5.172 0c-.228 0-.414.186-.414.414l0 3.172c0 .228.186.414.414.414l5.172 0c.228 0 .414-.186.414-.414z"],"pin_10":["M4.5542 8.7383c-.529-.745-.696-1.698-.43-2.591.052-.176.004-.366-.126-.496l-2.471-2.471 1.653-1.654 2.472 2.471c.13.13.321.179.495.126.893-.264 1.847-.099 2.591.431l-4.184 4.184zm5.299.408l-2.146-2.146 2.121-2.122c.195-.195.195-.512 0-.707-.966-.966-2.349-1.366-3.67-1.082L3.8812.8123c.16-.196.155-.483-.028-.666-.195-.195-.511-.195-.707 0l-3 3c-.195.196-.195.512 0 .707.098.098.226.147.354.147.112 0 .221-.045.313-.12l2.276 2.275c-.285 1.323.116 2.707 1.082 3.673.098.097.226.146.354.146.128 0 .256-.049.353-.146l2.122-2.121 2.146 2.146c.098.098.226.147.354.147.128 0 .256-.049.353-.147.196-.195.196-.511 0-.707z"],"pin_12":["M5.3569 10.9248c-.723-.929-.991-2.116-.736-3.282.037-.166-.014-.34-.135-.46l-2.918-2.919 2.696-2.695 2.919 2.918c.12.12.293.172.46.134 1.167-.256 2.354.014 3.283.736l-5.569 5.568zm6.496.221l-2.656-2.647 2.558-2.557c.165-.166.254-.397.244-.63-.01-.239-.121-.463-.304-.618-1.098-.927-2.572-1.329-3.992-1.101L4.9709.8618l.008-.008c.195-.196.195-.512 0-.707-.196-.196-.512-.196-.707 0l-4.125 4.125c-.196.195-.196.511 0 .707.097.097.225.146.353.146.128 0 .256-.049.354-.146l.007-.008 2.732 2.732c-.227 1.42.175 2.894 1.099 3.991.155.183.379.294.618.305.012.001.025.001.037.001.222 0 .437-.088.595-.246l2.548-2.547 2.657 2.648c.098.096.226.145.353.145.128 0 .256-.049.354-.147.195-.196.194-.512-.001-.707z"],"pin_14":["M6.2314 12.957c-.905-1.117-1.259-2.618-.95-4.035.037-.166-.014-.34-.134-.46l-3.514-3.514 3.315-3.314 3.513 3.513c.121.121.293.173.461.135 1.438-.315 2.904.032 4.035.949l-6.726 6.726zm7.622.188l-3.204-3.192 3.085-3.085c.179-.179.275-.425.265-.677-.011-.256-.13-.5-.328-.666-1.29-1.088-3.027-1.553-4.69-1.272L5.6554.927l.073-.074c.195-.195.195-.511 0-.707-.195-.195-.512-.195-.707 0L.1464 5.021c-.195.196-.195.512 0 .707.098.098.226.147.354.147.127 0 .255-.049.353-.147l.073-.073 3.326 3.326c-.281 1.666.186 3.402 1.273 4.692.167.197.41.316.666.326.013.001.024.001.037.001.239 0 .47-.096.639-.265l3.074-3.074 3.206 3.193c.097.097.225.146.353.146.128 0 .256-.049.354-.147.195-.196.194-.512-.001-.708z"],"pin_16":["M7.1216 15.0039c-1.125-1.334-1.555-3.085-1.179-4.803.036-.166-.014-.34-.135-.46l-4.108-4.108 3.933-3.934 4.108 4.109c.121.12.294.172.461.134 1.716-.372 3.468.055 4.809 1.143l-3.95 3.965c-.005.005-.011.006-.016.011-.005.005-.006.011-.011.016l-3.912 3.927zm8.731.142l-3.751-3.739 3.615-3.615c.191-.189.294-.452.282-.722-.011-.274-.138-.534-.35-.712-1.504-1.268-3.453-1.785-5.389-1.446l-3.92-3.92.139-.138c.195-.196.195-.512 0-.707-.195-.196-.512-.196-.707 0l-5.625 5.625c-.195.195-.195.511 0 .707.098.097.225.146.353.146.128 0 .256-.049.354-.146l.139-.139 3.92 3.92c-.334 1.913.196 3.908 1.444 5.389.178.21.437.338.711.35.014.001.028.001.042.001.255 0 .502-.101.683-.282l3.602-3.603 3.752 3.74c.098.096.226.145.353.145.129 0 .257-.049.354-.147.196-.196.195-.512-.001-.707z"],"pin_18":["M7.9536 16.9805c-1.289-1.528-1.781-3.533-1.351-5.5.037-.166-.014-.34-.134-.46l-4.704-4.703 4.552-4.552 4.703 4.702c.121.121.294.171.461.135 1.969-.429 3.973.063 5.512 1.408l-9.039 8.97zm9.899.165l-4.298-4.283 4.145-4.145c.203-.203.312-.484.299-.77-.012-.292-.149-.569-.374-.758-1.696-1.432-3.901-2.014-6.087-1.618l-4.514-4.513.205-.205c.195-.195.195-.512 0-.707-.195-.195-.512-.195-.707 0l-6.375 6.375c-.195.195-.195.512 0 .707.098.098.225.147.353.147.128 0 .256-.049.354-.147l.204-.204 4.514 4.514c-.396 2.185.186 4.389 1.617 6.087.19.225.467.361.759.374.014 0 .029.001.043.001.272 0 .534-.109.727-.301l4.13-4.129 4.299 4.284c.098.097.226.146.353.146.129 0 .257-.049.354-.148.196-.195.195-.512-.001-.707z"],"pin_20":["M8.9536 17.9805c-1.289-1.528-1.781-3.533-1.351-5.5.037-.166-.014-.34-.134-.46l-4.704-4.703 4.552-4.552 4.703 4.702c.121.121.294.171.461.135 1.969-.429 3.973.063 5.512 1.408l-9.039 8.97zm9.899.165l-4.298-4.283 4.145-4.145c.203-.203.312-.484.299-.77-.012-.292-.149-.569-.374-.758-1.696-1.432-3.901-2.014-6.087-1.618l-4.514-4.513.205-.205c.195-.195.195-.512 0-.707-.195-.195-.512-.195-.707 0l-6.375 6.375c-.195.195-.195.512 0 .707.098.098.225.147.353.147.128 0 .256-.049.354-.147l.204-.204 4.514 4.514c-.396 2.185.186 4.389 1.617 6.087.19.225.467.361.759.374.014 0 .029.001.043.001.272 0 .534-.109.727-.301l4.13-4.129 4.299 4.284c.098.097.226.146.353.146.129 0 .257-.049.354-.148.196-.195.195-.512-.001-.707z"],"pin_24":["M10.7852 22.9385c-.055.055-.127.059-.158.062-.068-.003-.132-.036-.178-.089-1.779-2.11-2.459-4.877-1.864-7.592.036-.167-.015-.341-.135-.461l-6.488-6.488 6.408-6.409 6.488 6.489c.12.12.29.171.461.134 2.714-.593 5.483.085 7.592 1.865.054.046.086.11.089.177.002.042-.008.105-.063.16l-12.152 12.152zm13.067.207l-5.94-5.92 5.731-5.731c.244-.243.37-.566.356-.909-.015-.346-.176-.674-.443-.9-2.246-1.894-5.285-2.679-8.181-2.133l-6.298-6.298.401-.401c.196-.195.196-.512 0-.707-.195-.195-.511-.195-.707 0l-8.625 8.625c-.195.195-.195.512 0 .707.098.098.226.147.354.147.128 0 .256-.049.353-.147l.402-.401 6.298 6.298c-.549 2.897.239 5.936 2.132 8.18.226.268.554.429.901.444.017.001.034.001.052.001.324 0 .626-.125.855-.356l5.712-5.712 5.942 5.922c.098.097.225.146.353.146.128 0 .257-.049.354-.148.195-.195.195-.512-.002-.707z"],"pin-muted_10":["M4.5542 8.7383c-.426-.599-.604-1.333-.523-2.062l2.646-2.646c.729-.079 1.462.098 2.061.524l-4.184 4.184zm-3.027-5.558l1.653-1.654 2.293 2.293-1.653 1.654-2.293-2.293zm6.18 3.82l2.121-2.122c.195-.195.195-.512 0-.707-.602-.601-1.365-.983-2.175-1.117l2.2-2.201c.196-.195.196-.511 0-.707-.195-.195-.511-.195-.707 0l-2.934 2.935c-.018.004-.036.004-.054.008L3.8812.8123c.16-.196.155-.483-.028-.666-.195-.195-.511-.195-.707 0l-3 3c-.195.196-.195.512 0 .707.098.098.226.147.354.147.112 0 .221-.045.313-.12l2.276 2.275c-.004.019-.005.038-.008.057l-2.935 2.934c-.195.196-.195.512 0 .707.098.098.226.147.354.147.128 0 .256-.049.353-.147l2.201-2.2c.134.81.516 1.573 1.117 2.175.098.097.226.146.354.146.128 0 .256-.049.353-.146l2.122-2.121 2.146 2.146c.098.098.226.147.354.147.128 0 .256-.049.353-.147.196-.195.196-.511 0-.707l-2.146-2.146z"],"pin-muted_12":["M5.357 10.925c-.62-.797-.882-1.784-.79-2.785L8.14 4.567c1.001-.093 1.989.171 2.786.79l-5.569 5.568zM1.568 4.264l2.696-2.695 2.731 2.73-2.697 2.695-2.73-2.73zm7.629 4.235l2.558-2.557c.165-.166.254-.397.244-.63-.01-.239-.121-.463-.304-.618-.731-.617-1.629-.996-2.566-1.117L11.854.854c.195-.196.195-.512 0-.707-.196-.196-.512-.196-.707 0L7.702 3.592 4.971.862l.008-.008c.195-.196.195-.512 0-.707-.196-.196-.512-.196-.707 0L.147 4.272c-.196.195-.196.511 0 .707.097.097.225.146.353.146.128 0 .256-.049.354-.146l.007-.008 2.73 2.73-3.444 3.446c-.196.195-.196.511 0 .707.097.097.225.146.353.146.128 0 .256-.049.354-.146l2.724-2.725c.121.937.499 1.835 1.114 2.565.155.183.379.294.618.305.012.001.025.001.037.001.222 0 .437-.088.595-.246L8.49 9.207l2.657 2.648c.098.096.226.145.353.145.128 0 .256-.049.354-.147.195-.196.194-.512-.001-.707L9.197 8.499z"],"pin-muted_14":["M6.23125 12.95725c-.78-.963-1.148-2.211-1.038-3.444l4.321-4.321c1.241-.116 2.467.248 3.443 1.039l-6.726 6.726zm-4.598-8.009l3.315-3.314 3.355 3.355-3.314 3.315-3.356-3.356zm9.016 5.005l3.085-3.085c.179-.179.275-.425.265-.677-.011-.256-.13-.5-.328-.666-.898-.757-2.015-1.206-3.172-1.318l3.354-3.354c.195-.195.195-.511 0-.707-.195-.195-.512-.195-.707 0l-4.099 4.099c-.022.004-.044.004-.066.008l-3.326-3.326.073-.074c.195-.195.195-.511 0-.707-.195-.195-.512-.195-.707 0l-4.875 4.875c-.195.196-.195.512 0 .707.098.098.226.147.354.147.127 0 .255-.049.353-.147l.073-.073 3.326 3.326c-.004.023-.004.044-.007.067l-4.099 4.098c-.195.196-.195.512 0 .707.098.098.226.147.354.147.127 0 .255-.049.353-.147l3.354-3.354c.112 1.158.56 2.274 1.318 3.174.167.197.41.316.666.326.013.001.024.001.037.001.239 0 .47-.096.639-.265l3.074-3.074 3.206 3.193c.097.097.225.146.353.146.128 0 .256-.049.354-.147.195-.196.194-.512-.001-.708l-3.204-3.192z"],"pin-muted_16":["M7.12125 15.004c-.979-1.161-1.431-2.639-1.284-4.135l5.03-5.029c1.496-.147 2.976.298 4.143 1.245l-3.95 3.965c-.005.005-.011.006-.016.011-.005.005-.006.011-.011.016l-3.912 3.927zm-5.422-9.371l3.933-3.934 3.981 3.981-3.934 3.933-3.98-3.98zm10.402 5.774l3.615-3.615c.191-.189.294-.452.282-.722-.011-.274-.138-.534-.35-.712-1.084-.914-2.4-1.431-3.774-1.525l3.979-3.979c.195-.196.195-.512 0-.707-.195-.196-.512-.196-.707 0l-4.749 4.749c-.046.006-.092.008-.138.016l-3.92-3.92.139-.138c.195-.196.195-.512 0-.707-.195-.196-.512-.196-.707 0l-5.625 5.625c-.195.195-.195.511 0 .707.098.097.225.146.353.146.128 0 .256-.049.354-.146l.139-.139 3.92 3.92c-.008.046-.01.092-.017.138l-4.749 4.749c-.195.195-.195.511 0 .707.098.097.225.146.353.146.128 0 .256-.049.354-.146l3.985-3.985c.099 1.378.619 2.713 1.518 3.78.178.21.437.338.711.35.014.001.028.001.042.001.255 0 .502-.101.683-.282l3.602-3.603 3.752 3.74c.098.096.226.145.353.145.129 0 .257-.049.354-.147.196-.196.195-.512-.001-.707l-3.751-3.739z"],"pin-muted_18":["M7.95325 16.98025c-1.126-1.336-1.645-3.037-1.469-4.758l5.738-5.738c1.722-.174 3.424.35 4.77 1.526l-9.039 8.97zm-6.189-10.663l4.552-4.552 4.606 4.605-4.552 4.552-4.606-4.605zm11.79 6.545l4.145-4.145c.203-.203.312-.484.299-.77-.012-.292-.149-.569-.374-.758-1.253-1.058-2.784-1.648-4.379-1.728l4.608-4.608c.195-.195.195-.512 0-.707-.195-.195-.512-.195-.707 0l-5.399 5.398c-.069.011-.139.014-.21.027l-4.514-4.513.205-.205c.195-.195.195-.512 0-.707-.195-.195-.512-.195-.707 0l-6.375 6.375c-.195.195-.195.512 0 .707.098.098.225.147.353.147.128 0 .256-.049.354-.147l.204-.204 4.514 4.514c-.013.069-.015.139-.026.209l-5.399 5.399c-.195.195-.195.512 0 .707.098.098.225.147.353.147.128 0 .256-.049.354-.147l4.609-4.609c.078 1.595.669 3.127 1.726 4.381.19.225.467.361.759.374.014 0 .029.001.043.001.272 0 .534-.109.727-.301l4.13-4.129 4.299 4.284c.098.097.226.146.353.146.129 0 .257-.049.354-.148.196-.195.195-.512-.001-.707l-4.298-4.283z"],"pin-muted_20":["M8.95325 17.98025c-1.126-1.336-1.645-3.037-1.469-4.758l5.738-5.738c1.722-.174 3.424.35 4.77 1.526l-9.039 8.97zm-6.189-10.663l4.552-4.552 4.606 4.605-4.552 4.552-4.606-4.605zm11.79 6.545l4.145-4.145c.203-.203.312-.484.299-.77-.012-.292-.149-.569-.374-.758-1.253-1.058-2.784-1.648-4.379-1.728l4.608-4.608c.195-.195.195-.512 0-.707-.195-.195-.512-.195-.707 0l-5.399 5.398c-.069.011-.139.014-.21.027l-4.514-4.513.205-.205c.195-.195.195-.512 0-.707-.195-.195-.512-.195-.707 0l-6.375 6.375c-.195.195-.195.512 0 .707.098.098.225.147.353.147.128 0 .256-.049.354-.147l.204-.204 4.514 4.514c-.013.069-.015.139-.026.209l-5.399 5.399c-.195.195-.195.512 0 .707.098.098.225.147.353.147.128 0 .256-.049.354-.147l4.609-4.609c.078 1.595.669 3.127 1.726 4.381.19.225.467.361.759.374.014 0 .029.001.043.001.272 0 .534-.109.727-.301l4.13-4.129 4.299 4.284c.098.097.226.146.353.146.129 0 .257-.049.354-.148.196-.195.195-.512-.001-.707l-4.298-4.283z"],"pin-muted_24":["M10.78525 22.93825c-.055.055-.127.059-.158.062-.068-.003-.132-.036-.178-.089-1.57-1.863-2.281-4.238-2.018-6.636l7.844-7.844c2.399-.264 4.774.447 6.636 2.018.054.046.086.11.089.177.002.042-.008.105-.063.16l-12.152 12.152zm-8.823-14.568l6.408-6.409 6.48 6.481-6.408 6.408-6.48-6.48zm15.95 8.855l5.731-5.731c.244-.243.37-.566.356-.909-.015-.346-.176-.674-.443-.9-1.748-1.475-3.976-2.266-6.244-2.291l6.541-6.541c.196-.195.196-.512 0-.707-.195-.195-.511-.195-.707 0l-7.351 7.352c-.14.019-.281.028-.42.054l-6.298-6.298.401-.401c.196-.195.196-.512 0-.707-.195-.195-.511-.195-.707 0l-8.625 8.625c-.195.195-.195.512 0 .707.098.098.226.147.354.147.128 0 .256-.049.353-.147l.402-.401 6.298 6.298c-.027.139-.036.28-.056.42l-7.351 7.351c-.195.195-.195.512 0 .707.098.098.226.147.354.147.128 0 .256-.049.353-.147l6.539-6.539c.027 2.268.82 4.495 2.293 6.241.226.268.554.429.901.444.017.001.034.001.052.001.324 0 .626-.125.855-.356l5.712-5.712 5.942 5.922c.098.097.225.146.353.146.128 0 .257-.049.354-.148.195-.195.195-.512-.002-.707l-5.94-5.92z"],"play_12":["M2.5381 2.0009c-.108 0-.217.03-.314.09-.083.052-.224.17-.224.376l0 7.07c0 .206.14.324.224.376.176.109.394.119.581.026l6.918-3.532c.178-.088.277-.235.277-.405 0-.17-.099-.317-.272-.402l-6.929-3.538c-.082-.04-.171-.061-.261-.061m-.003 9.001c-.292 0-.581-.08-.839-.24-.436-.271-.696-.729-.696-1.225l0-7.07c0-.497.26-.955.697-1.226.471-.294 1.051-.32 1.552-.073l6.929 3.538c.505.25.822.748.822 1.296 0 .548-.317 1.046-.828 1.299l-6.918 3.532c-.23.113-.475.169-.719.169"],"play_16":["M3.0591 2.002c-.19 0-.38.052-.55.155-.319.194-.509.533-.509.906l0 9.876c0 .373.19.711.509.905.317.193.705.207 1.037.037l10.03-5.179c.266-.138.425-.398.425-.698 0-.299-.158-.56-.424-.697l-10.03-5.185c-.155-.08-.321-.12-.488-.12m0 12.999c-.371 0-.74-.101-1.071-.303-.618-.377-.988-1.034-.988-1.759l0-9.876c0-.725.37-1.383.989-1.76.62-.377 1.373-.402 2.017-.07l10.03 5.186c.596.308.965.915.965 1.585 0 .671-.37 1.279-.966 1.586l-10.03 5.18c-.3.154-.623.231-.946.231"],"play_20":["M4.2324 1.9996c-.201 0-.402.054-.59.163-.402.236-.642.67-.642 1.161l0 13.353c0 .491.24.925.642 1.16.368.216.789.217 1.157.011l11.535-6.673c.419-.236.666-.674.666-1.174 0-.501-.247-.939-.662-1.171l-11.544-6.681c-.178-.099-.37-.149-.562-.149m-.004 16.999c-.376 0-.751-.1-1.091-.299-.712-.417-1.137-1.173-1.137-2.023l0-13.353c0-.849.424-1.606 1.137-2.023.67-.394 1.475-.401 2.153-.021l11.544 6.681c.728.408 1.166 1.172 1.166 2.04 0 .867-.438 1.631-1.171 2.043l-11.535 6.672c-.335.189-.702.283-1.066.283"],"play_24":["M3.5879 3.0542c-.28 0-.558.076-.807.227-.456.276-.728.753-.728 1.277l0 14.881c0 .525.272 1.003.728 1.279.473.287 1.048.302 1.537.046l14.827-7.445c.499-.261.802-.757.802-1.319.001-.563-.302-1.059-.811-1.326l-14.81-7.435c-.235-.123-.487-.185-.738-.185m.003 18.946c-.467 0-.935-.128-1.354-.382-.775-.467-1.237-1.282-1.237-2.179l0-14.881c0-.895.462-1.709 1.236-2.177.792-.478 1.752-.508 2.571-.079l14.81 7.436c.869.456 1.384 1.3 1.383 2.262 0 .961-.514 1.805-1.375 2.255l-14.826 7.445c-.381.2-.794.3-1.208.3"],"play_28":["M5.9233 3.0009c-.333 0-.667.09-.969.269-.597.356-.954.99-.954 1.697l0 18.066c0 .706.357 1.341.954 1.697.579.343 1.277.357 1.87.037l16.149-9.03c.645-.35 1.027-.998 1.027-1.737 0-.739-.382-1.388-1.021-1.734l-16.161-9.036c-.281-.153-.588-.229-.895-.229m-.003 22.998c-.51 0-1.018-.137-1.477-.41-.904-.538-1.443-1.494-1.443-2.556l0-18.066c0-1.063.539-2.018 1.443-2.556.885-.527 1.953-.548 2.857-.057l16.161 9.036c.961.521 1.539 1.498 1.539 2.61 0 1.112-.578 2.088-1.545 2.613l-16.149 9.03c-.438.238-.913.356-1.386.356"],"play_32":["M8.3853 3.0003c-.424 0-.847.114-1.228.343-.725.435-1.157 1.199-1.157 2.044l0 21.15c0 .845.432 1.609 1.157 2.045.725.435 1.603.457 2.349.059l19.226-10.572c.796-.424 1.268-1.211 1.268-2.107 0-.895-.472-1.682-1.262-2.103L9.5013 3.2803c-.352-.187-.734-.28-1.116-.28m-.004 26.925c-.601 0-1.2-.163-1.738-.486-1.029-.618-1.643-1.702-1.643-2.902l0-21.15c0-1.2.614-2.284 1.643-2.902 1.029-.616 2.276-.647 3.334-.084l19.237 10.578c1.116.596 1.786 1.712 1.786 2.984 0 1.271-.67 2.387-1.792 2.985l-19.226 10.572c-.507.271-1.055.405-1.601.405"],"play-circle_16":["M8 0c4.411 0 8 3.589 8 8 0 4.411-3.589 8-8 8-4.411 0-8-3.589-8-8 0-4.411 3.589-8 8-8zm0 15c3.86 0 7-3.14 7-7 0-3.86-3.14-7-7-7-3.86 0-7 3.14-7 7 0 3.86 3.14 7 7 7zm2.463-7.88157953c.331.171.537.51.537.883 0 .373-.206.712-.538.883L6.605 10.8774205c-.16.082-.333.123-.505.123-.198 0-.395-.054-.572-.161-.33-.202-.528-.553-.528-.94000003l0-3.799c0-.387.198-.738.528-.939.332-.201.734-.215 1.077-.038l3.858 1.995zM6.146 9.976l3.857-1.992L6.146 6 6 6.088l0 3.799.146.089z"],"play-circle_20":["M9.9998-.0002c5.523 0 10 4.478 10 10 0 5.523-4.477 10-10 10-5.522 0-10-4.477-10-10 0-5.522 4.478-10 10-10zm0 19c4.963 0 9-4.037 9-9 0-4.963-4.037-9-9-9-4.963 0-9 4.037-9 9 0 4.963 4.037 9 9 9zm3.7997-10.1023c.43.213.7.637.7 1.107 0 .469-.27.894-.706 1.11l-5.379 2.746c-.195.096-.403.144-.61.144-.247 0-.492-.068-.71-.203-.372-.231-.595-.623-.595-1.048l0-5.499c0-.425.223-.816.595-1.048.4-.249.894-.27 1.314-.061l5.391 2.752zm-.455 1.323c.136-.067.155-.164.155-.216 0-.053-.019-.149-.149-.214l-5.391-2.752c-.047-.023-.099-.035-.152-.035-.064 0-.129.018-.186.053-.046.028-.122.092-.122.198l0 5.499c0 .107.076.17.122.198.104.065.233.071.344.015l5.379-2.746z"],"play-circle_24":["M12 0c6.617 0 12 5.383 12 12 0 6.617-5.383 12-12 12-6.617 0-12-5.383-12-12C0 5.383 5.383 0 12 0zm0 23c6.065 0 11-4.935 11-11 0-6.065-4.935-11-11-11C5.935 1 1 5.935 1 12c0 6.065 4.935 11 11 11zm5.1736-12.3633c.514.273.826.794.826 1.363 0 .57-.312 1.09-.814 1.358l-6.935 3.465c-.222.119-.465.178-.71.178-.273 0-.547-.074-.793-.221-.468-.281-.748-.774-.748-1.32l0-6.92c0-.546.28-1.039.748-1.319.468-.281 1.034-.294 1.515-.038l6.911 3.454zm-.447 1.832c.167-.089.273-.267.273-.469 0-.202-.106-.38-.285-.474l-6.911-3.454c-.097-.052-.188-.071-.267-.071-.128 0-.227.048-.275.077-.079.047-.262.187-.262.462l0 6.92c0 .276.183.415.262.462.078.046.286.144.53.013l6.935-3.466z"],"play-circle_28":["M14 0c7.732 0 14 6.268 14 14 0 7.732-6.268 14-14 14-7.732 0-14-6.268-14-14C0 6.268 6.268 0 14 0zm0 27c7.168 0 13-5.832 13-13 0-7.168-5.832-13-13-13C6.832 1 1 6.832 1 14c0 7.168 5.832 13 13 13zm6.0515-14.5671c.59.314.949.913.949 1.567 0 .654-.359 1.253-.937 1.562l-8.474 4.234c-.256.137-.537.205-.818.205-.314 0-.629-.085-.913-.255-.537-.322-.858-.889-.858-1.516l0-8.459c0-.627.321-1.195.858-1.517.538-.321 1.19-.339 1.743-.044l8.45 4.223zm-.447 2.24c.243-.13.396-.384.396-.673 0-.289-.153-.543-.408-.679l-8.45-4.222c-.123-.066-.251-.099-.378-.099-.135 0-.268.038-.391.111-.237.143-.373.383-.373.66l0 8.459c0 .276.136.516.373.659.238.142.514.15.757.018l8.474-4.234z"],"play-circle_32":["M16 0c8.822 0 16 7.178 16 16 0 8.822-7.178 16-16 16-8.822 0-16-7.178-16-16C0 7.178 7.178 0 16 0zm0 31c8.271 0 15-6.729 15-15 0-8.271-6.729-15-15-15C7.729 1 1 7.729 1 16c0 8.271 6.729 15 15 15zm6.9294-16.77c.665.354 1.071 1.03 1.071 1.77 0 .74-.406 1.416-1.059 1.765l-10.012 5.004c-.291.155-.609.232-.927.232-.355 0-.711-.096-1.031-.288-.608-.364-.971-1.006-.971-1.715l0-9.996c0-.709.363-1.351.971-1.715.608-.365 1.345-.384 1.969-.049l9.989 4.992zm-.447 2.646c.32-.17.518-.5.518-.876 0-.375-.198-.706-.53-.882l-9.988-4.992c-.156-.083-.322-.124-.486-.124-.178 0-.353.048-.511.143-.304.182-.485.502-.485.857l0 9.996c0 .355.181.675.485.857.305.183.672.191.985.025l10.012-5.004z"],"plug-ac_24":["M12.0001 18c-4.411 0-7.999-3.588-8-7.998l0-2.002c0-.552.448-1 1-1l14 0c.551 0 1 .448 1 1l0 2c0 4.411-3.589 8-8 8zm9-10c0-1.104-.896-2-2-2l-2 0 0-4.5c0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5l0 4.5-8 0 0-4.5c0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5l0 4.5-2 0c-1.104 0-2 .896-2 2l0 2c0 4.803 3.766 8.716 8.504 8.975l-.004 0 0 3.525c0 .276.224.5.5.5.276 0 .5-.224.5-.5l0-3.525-.004 0c4.738-.259 8.504-4.171 8.504-8.975l0-2z"],"plus_12":["M5.5 5.5l0-5c0-.276142375.22385763-.5.5-.5.27614237 0 .5.223857625.5.5l0 5 5 0c.2761424 0 .5.22385763.5.5 0 .27614237-.2238576.5-.5.5l-5 0 0 5c0 .2761424-.22385763.5-.5.5-.27614237 0-.5-.2238576-.5-.5l0-5-5 0C.223857625 6.5 0 6.27614237 0 6c0-.27614237.223857625-.5.5-.5l5 0z"],"plus_14":["M7.5 6.5l6 0c.2761424 0 .5.22385763.5.5 0 .27614237-.2238576.5-.5.5l-6 0 0 6c0 .2761424-.22385763.5-.5.5-.27614237 0-.5-.2238576-.5-.5l0-6-6 0C.223857625 7.5 0 7.27614237 0 7c0-.27614237.223857625-.5.5-.5l6 0 0-6c0-.276142375.22385763-.5.5-.5.27614237 0 .5.223857625.5.5l0 6z"],"plus_16":["M8.5 7.5l7.0036068 0C15.7777572 7.5 16 7.73193359 16 8c0 .27614237-.226181.5-.4963932.5L8.5 8.5l0 7.0036068C8.5 15.7777572 8.26806641 16 8 16c-.27614237 0-.5-.226181-.5-.4963932L7.5 8.5l-7.003606796 0C.222242807 8.5 0 8.26806641 0 8c0-.27614237.22618103-.5.496393204-.5L7.5 7.5l0-7.003606796C7.5.222242807 7.73193359 0 8 0c.27614237 0 .5.22618103.5.496393204L8.5 7.5z"],"plus_18":["M9.5 8.5l8 0c.2761424 0 .5.22385763.5.5 0 .27614237-.2238576.5-.5.5l-8 0 0 8c0 .2761424-.22385763.5-.5.5-.27614237 0-.5-.2238576-.5-.5l0-8-8 0C.223857625 9.5 0 9.27614237 0 9c0-.27614237.223857625-.5.5-.5l8 0 0-8c0-.276142375.22385763-.5.5-.5.27614237 0 .5.223857625.5.5l0 8z"],"plus_20":["M10.5 9.5l9 0c.2761424 0 .5.22385763.5.5 0 .2761424-.2238576.5-.5.5l-9 0 0 9c0 .2761424-.2238576.5-.5.5-.27614237 0-.5-.2238576-.5-.5l0-9-9 0c-.276142375 0-.5-.2238576-.5-.5 0-.27614237.223857625-.5.5-.5l9 0 0-9c0-.276142375.22385763-.5.5-.5.2761424 0 .5.223857625.5.5l0 9z"],"plus_24":["M12.5 11.5l10 0c.2761424 0 .5.2238576.5.5 0 .2761424-.2238576.5-.5.5l-10 0 0 10c0 .2761424-.2238576.5-.5.5-.2761424 0-.5-.2238576-.5-.5l0-10-10 0c-.276142375 0-.5-.2238576-.5-.5 0-.2761424.223857625-.5.5-.5l10 0 0-10c0-.276142375.2238576-.5.5-.5.2761424 0 .5.223857625.5.5l0 10z"],"plus_28":["M13.5 13.5l0-10.998725891C13.5 2.224428063 13.7319336 2 14 2c.2761424 0 .5.222265363.5.501274109L14.5 13.5l10.9987259 0C25.7755719 13.5 26 13.7319336 26 14c0 .2761424-.2222654.5-.5012741.5L14.5 14.5l0 10.9987259C14.5 25.7755719 14.2680664 26 14 26c-.2761424 0-.5-.2222654-.5-.5012741L13.5 14.5l-10.998725891 0C2.224428063 14.5 2 14.2680664 2 14c0-.2761424.222265363-.5.501274109-.5L13.5 13.5z"],"plus_8":["M4.5 3.5l3 0c.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5l-3 0 0 3c0 .27614237-.22385763.5-.5.5-.27614237 0-.5-.22385763-.5-.5l0-3-3 0C.223857625 4.5 0 4.27614237 0 4c0-.27614237.223857625-.5.5-.5l3 0 0-3c0-.276142375.22385763-.5.5-.5.27614237 0 .5.223857625.5.5l0 3z"],"pmr_10":["M8.656.00027c.741 0 1.344.603 1.344 1.343l0 7.31c0 .741-.603 1.344-1.344 1.344l-7.312 0c-.741 0-1.344-.603-1.344-1.344l0-7.31c0-.74.603-1.343 1.344-1.343l7.312 0zM9 8.65327l0-7.31c0-.186-.157-.343-.344-.343l-7.312 0c-.19 0-.344.154-.344.343l0 7.31c0 .187.157.344.344.344l7.312 0c.19 0 .344-.155.344-.344zm-1.2011-2.2602l.183.783c.047.204.001.412-.128.574-.125.157-.311.247-.51.247l-4.688 0c-.199 0-.386-.091-.511-.249-.128-.162-.174-.371-.127-.573l.184-.782c.145-.621.579-1.098 1.131-1.295-.209-.316-.333-.694-.333-1.101 0-1.103.897-2 2-2 1.103 0 2 .897 2 2 0 .407-.123.785-.333 1.101.552.197.986.674 1.132 1.295zm-4.712.604l3.826 0-.088-.376c-.086-.367-.384-.624-.726-.624l-2.198 0c-.341 0-.64.257-.726.624l-.088.376zm1.913-4c-.551 0-1 .449-1 1 0 .551.449 1 1 1 .551 0 1-.449 1-1 0-.551-.449-1-1-1z"],"pmr_12":["M12 1.499l0 .001 0 9 0 .001c-.001.828-.672 1.499-1.5 1.499l-9 0c-.828 0-1.499-.671-1.5-1.499l0-.001 0-9 0-.001C.001.671.672 0 1.5 0l9 0c.828 0 1.499.671 1.5 1.499zM11 10.5l0-9c0-.276-.225-.5-.5-.5l-9 0c-.276 0-.5.224-.5.5l0 9c0 .276.224.5.5.5l9 0c.275 0 .5-.224.5-.5zM8.7804 7.396l.184.783c.047.201.001.41-.127.572-.125.158-.312.249-.511.249l-4.688 0c-.2 0-.386-.091-.511-.249-.128-.162-.174-.371-.127-.573l.183-.782c.145-.619.576-1.095 1.125-1.294-.212-.319-.336-.7-.336-1.11 0-1.107.901-2.009 2.008-2.009 1.108 0 2.009.902 2.009 2.009 0 .41-.125.791-.337 1.109.551.199.983.675 1.128 1.295zM4.0694 8l3.826 0-.089-.376c-.086-.367-.383-.624-.725-.624l-2.199 0c-.34 0-.639.257-.725.623L4.0694 8zm1.911-4.017c-.556 0-1.008.453-1.008 1.009 0 .556.452 1.008 1.008 1.008.557 0 1.009-.452 1.009-1.008 0-.556-.452-1.009-1.009-1.009z"],"pmr_14":["M12.281.0003c.948 0 1.719.771 1.719 1.718l0 10.559c0 .947-.771 1.719-1.719 1.719l-10.562 0c-.948 0-1.719-.772-1.719-1.719l0-10.559C0 .7713.771.0003 1.719.0003l10.562 0zM13 12.2773l0-10.559c0-.396-.322-.718-.719-.718l-10.562 0c-.397 0-.719.322-.719.718l0 10.559c0 .396.322.719.719.719l10.562 0c.397 0 .719-.323.719-.719zM8.9511 7.0401c.859.176 1.562.893 1.774 1.864l.256 1.175c.051.226-.004.469-.148.648-.137.171-.338.269-.552.269l-6.562 0c-.214 0-.414-.098-.551-.268-.144-.179-.2-.422-.15-.65l.257-1.174c.213-.971.915-1.687 1.774-1.864-.338-.426-.549-.959-.549-1.544 0-1.378 1.122-2.5 2.5-2.5 1.379 0 2.5 1.122 2.5 2.5 0 .585-.211 1.118-.549 1.544zm-4.891 2.956l5.879 0-.191-.879c-.145-.66-.642-1.121-1.209-1.121l-3.078 0c-.567 0-1.065.461-1.209 1.121l-.192.879zm2.94-6c-.827 0-1.5.673-1.5 1.5 0 .827.673 1.5 1.5 1.5.827 0 1.5-.673 1.5-1.5 0-.827-.673-1.5-1.5-1.5z"],"pmr_16":["M13.283 1C14.231 1 15 1.772 15 2.717l0 10.566c0 .948-.772 1.717-1.717 1.717L2.717 15C1.769 15 1 14.227 1 13.283L1 2.717C1 1.768 1.772 1 2.717 1l10.566 0zM14 13.283l0-10.566c0-.394-.322-.717-.717-.717L2.717 2C2.323 2 2 2.322 2 2.717l0 10.566c0 .394.322.717.717.717l10.566 0c.394 0 .717-.322.717-.717zm-2.28-3.1249l.257.984c.055.212.009.434-.124.608-.138.177-.346.279-.572.279l-6.562 0c-.227 0-.435-.102-.571-.279-.135-.174-.18-.396-.125-.608l.256-.983c.21-.804.867-1.399 1.673-1.579-.428-.485-.696-1.113-.696-1.808 0-1.513 1.231-2.743 2.744-2.743 1.513 0 2.743 1.23 2.743 2.743 0 .695-.267 1.323-.695 1.808.806.18 1.462.775 1.672 1.578zm-6.634.871l5.828 0-.162-.618c-.138-.527-.637-.895-1.214-.895l-3.077 0c-.577 0-1.076.368-1.214.896l-.161.617zm2.914-6c-.962 0-1.744.782-1.744 1.743 0 .962.782 1.744 1.744 1.744.961 0 1.743-.782 1.743-1.744 0-.961-.782-1.743-1.743-1.743z"],"pmr_18":["M15.0943 16.995l-12.188 0c-1.051 0-1.906-.855-1.906-1.906l0-12.183c0-1.051.855-1.906 1.906-1.906l12.188 0c1.05 0 1.906.855 1.906 1.906l0 12.183c0 1.051-.856 1.906-1.906 1.906zM2.9063 2c-.5 0-.906.406-.906.906l0 12.183c0 .5.406.906.906.906l12.188 0c.5 0 .906-.406.906-.906l0-12.183c0-.5-.406-.906-.906-.906L2.9063 2zm11.0702 11.029c.059.237.006.481-.143.671-.149.191-.373.3-.615.3l-8.437 0c-.242 0-.466-.109-.616-.3-.148-.19-.201-.434-.143-.67l.331-1.323c.278-1.106 1.201-1.906 2.308-2.052-.601-.599-.974-1.428-.974-2.342C5.6875 5.486 7.1735 4 8.9995 4c1.827 0 3.313 1.486 3.313 3.313 0 .914-.372 1.743-.973 2.342 1.107.146 2.03.946 2.306 2.053l.331 1.321zM5.0615 13l7.877 0-.262-1.049c-.196-.781-.894-1.326-1.698-1.326l-3.957 0c-.804 0-1.502.545-1.698 1.325L5.0615 13zm3.938-8c-1.274 0-2.312 1.037-2.312 2.313 0 1.275 1.038 2.312 2.312 2.312 1.275 0 2.313-1.037 2.313-2.312 0-1.276-1.038-2.313-2.313-2.313z"],"pmr_20":["M16.5 1C17.875 1 19 2.125 19 3.5l0 13c0 1.381-1.119 2.5-2.5 2.5l-13 0C2.125 19 1 17.875 1 16.5l0-13C1 2.119 2.119 1 3.5 1l13 0zM18 16.5l0-13c0-.827-.673-1.5-1.5-1.5l-13 0C2.673 2 2 2.673 2 3.5l0 13c0 .827.673 1.5 1.5 1.5l13 0c.827 0 1.5-.673 1.5-1.5zm-2.4301-3.111l.404 1.566c.064.249.011.511-.15.717-.16.208-.404.328-.668.328l-10.312 0c-.264 0-.508-.12-.669-.328-.159-.206-.213-.468-.148-.718l.403-1.565c.347-1.35 1.553-2.299 2.964-2.379-.847-.735-1.394-1.804-1.394-3.01 0-2.206 1.794-4 4-4 2.206 0 4 1.794 4 4 0 1.206-.547 2.275-1.393 3.01 1.411.08 2.616 1.029 2.963 2.379zM5.0479 15l9.904 0-.35-1.361c-.249-.969-1.148-1.645-2.184-1.645l-4.836 0c-1.036 0-1.934.676-2.183 1.645L5.0479 15zm1.952-7c0 1.635 1.316 2.962 2.944 2.994l.114 0c1.627-.032 2.942-1.359 2.942-2.994 0-1.654-1.346-3-3-3-1.654 0-3 1.346-3 3z"],"pmr_24":["M20.531 1C21.893 1 23 2.107 23 3.468l0 17.062c0 1.361-1.107 2.47-2.469 2.47L3.469 23C2.107 23 1 21.891 1 20.53L1 3.468C1 2.107 2.107 1 3.469 1l17.062 0zM22 20.53l0-17.062C22 2.659 21.341 2 20.531 2L3.469 2C2.659 2 2 2.659 2 3.468L2 20.53c0 .811.659 1.47 1.469 1.47l17.062 0c.81 0 1.469-.659 1.469-1.47zm-4.4301-5.1353l.404 1.566c.064.247.011.507-.147.711-.162.209-.406.328-.673.328l-10.31 0c-.265 0-.509-.119-.67-.326-.158-.204-.212-.463-.148-.712l.404-1.567c.349-1.359 1.568-2.314 2.993-2.382-.863-.735-1.423-1.815-1.423-3.034 0-2.207 1.794-4 4-4 2.206 0 4 1.793 4 4 0 1.219-.56 2.299-1.422 3.034 1.422.068 2.641 1.023 2.992 2.382zm-10.522 1.605l9.903 0-.349-1.355c-.25-.968-1.149-1.645-2.184-1.645l-4.836 0c-1.036 0-1.934.676-2.183 1.645l-.351 1.355zm1.952-7.021c0 1.655 1.346 3 3 3 1.654 0 3-1.345 3-3 0-1.654-1.346-3-3-3-1.654 0-3 1.346-3 3z"],"poll_12":["M2 10l1 0 0-5-1 0 0 5zm1-6c.552 0 1 .447 1 1l0 5c0 .553-.448 1-1 1l-1 0c-.552 0-1-.447-1-1l0-5c0-.553.448-1 1-1l1 0zm3.5 2c.552 0 1 .447 1 1l0 3c0 .553-.448 1-1 1l-1 0c-.552 0-1-.447-1-1l0-3c0-.553.448-1 1-1l1 0zm-1 4l1 0 0-3-1 0 0 3zM10 1c.552 0 1 .447 1 1l0 8c0 .553-.448 1-1 1l-1 0c-.552 0-1-.447-1-1l0-8c0-.553.448-1 1-1l1 0zm-1 9l1 0 0-8-1 0 0 8z"],"poll_16":["M3.5 4C4.328 4 5 4.672 5 5.5l0 8c0 .828-.672 1.5-1.5 1.5l-1 0c-.828 0-1.5-.672-1.5-1.5l0-8C1 4.672 1.672 4 2.5 4l1 0zm.5 9.5l0-8c0-.275-.224-.5-.5-.5l-1 0c-.276 0-.5.225-.5.5l0 8c0 .275.224.5.5.5l1 0c.276 0 .5-.225.5-.5zM8.5 7c.828 0 1.5.672 1.5 1.5l0 5c0 .828-.672 1.5-1.5 1.5l-1 0c-.828 0-1.5-.672-1.5-1.5l0-5C6 7.672 6.672 7 7.5 7l1 0zm.5 6.5l0-5c0-.275-.224-.5-.5-.5l-1 0c-.276 0-.5.225-.5.5l0 5c0 .275.224.5.5.5l1 0c.276 0 .5-.225.5-.5zM13.5 1c.828 0 1.5.672 1.5 1.5l0 11c0 .828-.672 1.5-1.5 1.5l-1 0c-.828 0-1.5-.672-1.5-1.5l0-11c0-.828.672-1.5 1.5-1.5l1 0zm.5 12.5l0-11c0-.275-.224-.5-.5-.5l-1 0c-.276 0-.5.225-.5.5l0 11c0 .275.224.5.5.5l1 0c.276 0 .5-.225.5-.5z"],"poll_20":["M17.25 2l-1.5 0C14.783 2 14 2.783 14 3.75l0 12.5c0 .967.783 1.75 1.75 1.75l1.5 0c.967 0 1.75-.783 1.75-1.75l0-12.5C19 2.783 18.217 2 17.25 2m0 1c.414 0 .75.336.75.75l0 12.5c0 .414-.336.75-.75.75l-1.5 0c-.414 0-.75-.336-.75-.75l0-12.5c0-.414.336-.75.75-.75l1.5 0zm-6.5 7c.967 0 1.75.783 1.75 1.75l0 4.5c0 .967-.783 1.75-1.75 1.75l-1.5 0c-.967 0-1.75-.783-1.75-1.75l0-4.5c0-.967.783-1.75 1.75-1.75l1.5 0zm0 1l-1.5 0c-.414 0-.75.336-.75.75l0 4.5c0 .414.336.75.75.75l1.5 0c.414 0 .75-.336.75-.75l0-4.5c0-.414-.336-.75-.75-.75zm-6.5-5C5.217 6 6 6.783 6 7.75l0 8.5C6 17.217 5.217 18 4.25 18l-1.5 0C1.783 18 1 17.217 1 16.25l0-8.5C1 6.783 1.783 6 2.75 6l1.5 0zm0 1l-1.5 0c-.414 0-.75.336-.75.75l0 8.5c0 .414.336.75.75.75l1.5 0c.414 0 .75-.336.75-.75l0-8.5C5 7.336 4.664 7 4.25 7z"],"poll_24":["M5.25 7l-2.5 0C1.784 7 1 7.783 1 8.75l0 11.5c0 .967.784 1.75 1.75 1.75l2.5 0C6.216 22 7 21.217 7 20.25l0-11.5C7 7.783 6.216 7 5.25 7m0 1c.414 0 .75.336.75.75l0 11.5c0 .414-.336.75-.75.75l-2.5 0c-.414 0-.75-.336-.75-.75l0-11.5c0-.414.336-.75.75-.75l2.5 0zm16-6c.966 0 1.75.783 1.75 1.75l0 16.5c0 .967-.784 1.75-1.75 1.75l-2.5 0c-.966 0-1.75-.783-1.75-1.75l0-16.5c0-.967.784-1.75 1.75-1.75l2.5 0zm0 1l-2.5 0c-.414 0-.75.336-.75.75l0 16.5c0 .414.336.75.75.75l2.5 0c.414 0 .75-.336.75-.75l0-16.5c0-.414-.336-.75-.75-.75zm-8 9c.966 0 1.75.783 1.75 1.75l0 6.5c0 .967-.784 1.75-1.75 1.75l-2.5 0C9.784 22 9 21.217 9 20.25l0-6.5c0-.967.784-1.75 1.75-1.75l2.5 0zm0 1l-2.5 0c-.414 0-.75.336-.75.75l0 6.5c0 .414.336.75.75.75l2.5 0c.414 0 .75-.336.75-.75l0-6.5c0-.414-.336-.75-.75-.75z"],"poll_36":["M7.5002 9.9999l-4 0c-1.381 0-2.5 1.119-2.5 2.5l0 18c0 1.381 1.119 2.5 2.5 2.5l4 0c1.38 0 2.5-1.119 2.5-2.5l0-18c0-1.381-1.12-2.5-2.5-2.5m0 1c.827 0 1.5.673 1.5 1.5l0 18c0 .827-.673 1.5-1.5 1.5l-4 0c-.827 0-1.5-.673-1.5-1.5l0-18c0-.827.673-1.5 1.5-1.5l4 0zm12.5 7c1.38 0 2.5 1.119 2.5 2.5l0 10c0 1.381-1.12 2.5-2.5 2.5l-4 0c-1.381 0-2.5-1.119-2.5-2.5l0-10c0-1.381 1.119-2.5 2.5-2.5l4 0zm0 1l-4 0c-.827 0-1.5.673-1.5 1.5l0 10c0 .827.673 1.5 1.5 1.5l4 0c.827 0 1.5-.673 1.5-1.5l0-10c0-.827-.673-1.5-1.5-1.5zm12.5-16c1.38 0 2.5 1.119 2.5 2.5l0 25c0 1.381-1.12 2.5-2.5 2.5l-4 0c-1.381 0-2.5-1.119-2.5-2.5l0-25c0-1.381 1.119-2.5 2.5-2.5l4 0zm0 1l-4 0c-.827 0-1.5.673-1.5 1.5l0 25c0 .827.673 1.5 1.5 1.5l4 0c.827 0 1.5-.673 1.5-1.5l0-25c0-.827-.673-1.5-1.5-1.5z"],"pop-in_12":["M.5 5C.224 5 0 4.776 0 4.5l0-3C0 .673.673 0 1.5 0l9 0c.827 0 1.5.673 1.5 1.5l0 9c0 .827-.673 1.5-1.5 1.5l-3 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l3 0c.275 0 .5-.224.5-.5l0-9c0-.276-.225-.5-.5-.5l-9 0c-.275 0-.5.224-.5.5l0 3c0 .276-.224.5-.5.5zm0 7c-.276 0-.5-.224-.5-.5l0-4c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 2.793 4.146-4.147C5.244 6.049 5.372 6 5.5 6c.128 0 .256.049.354.146.195.196.195.512 0 .708L1.707 11 4.5 11c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-4 0z"],"pop-in_16":["M1.0391 14.6914c-.025-.061-.039-.126-.039-.191l0-4c0-.276.225-.5.5-.5.275 0 .5.224.5.5l0 2.793 5.646-5.647c.098-.098.226-.146.354-.146.128 0 .256.048.353.146.196.195.196.512 0 .707l-5.646 5.647 2.793 0c.275 0 .5.224.5.5 0 .275-.225.5-.5.5l-4 0c-.065 0-.13-.014-.191-.039-.041-.017-.075-.045-.109-.073-.017-.012-.038-.019-.054-.035-.015-.016-.022-.037-.035-.054-.027-.034-.055-.067-.072-.108zM1.5 8c-.275 0-.5-.225-.5-.5L1 3c0-1.104.896-2 2-2l10 0c1.104 0 2 .896 2 2l0 10c0 1.104-.896 2-2 2l-4.5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l4.5 0c.552 0 1-.449 1-1l0-10c0-.551-.448-1-1-1L3 2c-.552 0-1 .449-1 1l0 4.5c0 .275-.225.5-.5.5z"],"pop-in_20":["M9.498 10.002c.129 0 .257.049.354.146.196.196.196.511 0 .708L2.707 18 8.5 18c.276 0 .5.224.5.5 0 .275-.224.5-.5.5l-7 0c-.065 0-.13-.014-.19-.038-.124-.052-.22-.149-.271-.272-.025-.06-.039-.125-.039-.19l0-6.996c0-.277.224-.5.5-.5.276 0 .5.223.5.5l0 5.789 7.145-7.145c.097-.097.225-.146.353-.146zM1.5 8c-.275 0-.5-.225-.5-.5l0-4C1 2.119 2.119 1 3.5 1l13 0C17.881 1 19 2.119 19 3.5l0 13c0 1.381-1.119 2.5-2.5 2.5l-4 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l4 0c.827 0 1.5-.673 1.5-1.5l0-13c0-.827-.673-1.5-1.5-1.5l-13 0C2.673 2 2 2.673 2 3.5l0 4c0 .275-.225.5-.5.5z"],"pop-in_24":["M11.997 22.4996c0 .276.224.5.5.5l8.035 0c1.361 0 2.468-1.107 2.468-2.469l0-17.062c0-1.362-1.107-2.469-2.468-2.469l-17.056 0c-1.361 0-2.469 1.107-2.469 2.469L1 11.4996c0 .276.224.5.5.5.276 0 .5-.224.5-.5l.007-8.031c0-.81.659-1.469 1.469-1.469l17.056 0c.81 0 1.468.659 1.468 1.469l0 17.062c0 .81-.658 1.469-1.468 1.469l-8.035 0c-.276 0-.5.224-.5.5zm-10.6875.4615c.061.025.126.038.191.038l6.996 0c.277 0 .5-.223.5-.5 0-.276-.223-.5-.5-.5l-5.789 0 9.144-9.145c.098-.097.147-.225.147-.353 0-.128-.049-.256-.147-.354-.195-.195-.511-.195-.707 0l-9.144 9.145 0-5.793c0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5l0 7c0 .066.013.13.038.191.051.123.149.22.271.271z"],"pop-in_8":["M.5 8C.225 8 0 7.775 0 7.5l0-3c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 1.793 3.15-3.149c.097-.098.225-.147.353-.147.128 0 .256.049.354.147.195.195.195.511 0 .707L1.707 7 3.5 7c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-3 0zm0-6C.225 2 0 1.775 0 1.5l0-.509C0 .443.451 0 .991 0l6.018 0C7.557 0 8 .451 8 .991l0 6.018C8 7.557 7.549 8 7.009 8L6.5 8c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l.509 0L7 1l0-.009L1 1 .991 1 1 1.5c0 .275-.225.5-.5.5z"],"pop-out_12":["M11.5 7c.276 0 .5.224.5.5l0 3c0 .827-.673 1.5-1.5 1.5l-9 0C.673 12 0 11.327 0 10.5l0-9C0 .673.673 0 1.5 0l3 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-3 0c-.275 0-.5.224-.5.5l0 9c0 .276.225.5.5.5l9 0c.275 0 .5-.224.5-.5l0-3c0-.276.224-.5.5-.5zm0-7c.276 0 .5.224.5.5l0 4c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-2.793-4.146 4.147C6.756 5.951 6.628 6 6.5 6c-.128 0-.256-.049-.354-.146-.195-.196-.195-.512 0-.708L10.293 1 7.5 1C7.224 1 7 .776 7 .5c0-.276.224-.5.5-.5l4 0z"],"pop-out_16":["M14.9609 1.3086c.025.061.039.126.039.191l0 4c0 .276-.225.5-.5.5-.275 0-.5-.224-.5-.5l0-2.793-5.646 5.647c-.098.098-.226.146-.354.146-.128 0-.256-.048-.353-.146-.196-.195-.196-.512 0-.707l5.646-5.647-2.793 0c-.275 0-.5-.224-.5-.5 0-.275.225-.5.5-.5l4 0c.065 0 .13.014.191.039.041.017.075.045.109.073.017.012.038.019.054.035.015.016.022.037.035.054.027.034.055.067.072.108zM14.5 8c.275 0 .5.225.5.5l0 4.5c0 1.104-.896 2-2 2L3 15c-1.104 0-2-.896-2-2L1 3c0-1.104.896-2 2-2l4.5 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L3 2c-.552 0-1 .449-1 1l0 10c0 .551.448 1 1 1l10 0c.552 0 1-.449 1-1l0-4.5c0-.275.225-.5.5-.5z"],"pop-out_20":["M10.502 9.998c-.129 0-.257-.049-.354-.146-.196-.196-.196-.511 0-.708L17.293 2 11.5 2c-.276 0-.5-.224-.5-.5 0-.275.224-.5.5-.5l7 0c.065 0 .13.014.19.038.124.052.22.149.271.272.025.06.039.125.039.19l0 6.996c0 .277-.224.5-.5.5-.276 0-.5-.223-.5-.5l0-5.789-7.145 7.145c-.097.097-.225.146-.353.146zM18.5 12c.275 0 .5.225.5.5l0 4c0 1.381-1.119 2.5-2.5 2.5l-13 0C2.119 19 1 17.881 1 16.5l0-13C1 2.119 2.119 1 3.5 1l4 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-4 0C2.673 2 2 2.673 2 3.5l0 13c0 .827.673 1.5 1.5 1.5l13 0c.827 0 1.5-.673 1.5-1.5l0-4c0-.275.225-.5.5-.5z"],"pop-out_24":["M22.5 11.9966c.276 0 .5.224.5.5l0 8.035c0 1.361-1.107 2.468-2.469 2.468l-17.062 0c-1.362 0-2.469-1.107-2.469-2.468l0-17.056c0-1.361 1.107-2.469 2.469-2.469L11.5.9996c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-8.031.007c-.81 0-1.469.659-1.469 1.469l0 17.056c0 .81.659 1.468 1.469 1.468l17.062 0c.81 0 1.469-.658 1.469-1.468l0-8.035c0-.276.224-.5.5-.5zm.4615-10.6875c.025.061.038.126.038.191l0 6.996c0 .277-.223.5-.5.5-.276 0-.5-.223-.5-.5l0-5.789-9.145 9.144c-.097.098-.225.147-.353.147-.128 0-.256-.049-.354-.147-.195-.195-.195-.511 0-.707l9.145-9.144-5.793 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l7 0c.066 0 .13.013.191.038.123.051.22.149.271.271z"],"pop-out_8":["M7.5 0c.275 0 .5.225.5.5l0 3c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-1.793-3.15 3.149c-.097.098-.225.147-.353.147-.128 0-.256-.049-.354-.147-.195-.195-.195-.511 0-.707L6.293 1 4.5 1C4.225 1 4 .775 4 .5c0-.275.225-.5.5-.5l3 0zm0 6c.275 0 .5.225.5.5l0 .509C8 7.557 7.549 8 7.009 8L.991 8C.443 8 0 7.549 0 7.009L0 .991C0 .443.451 0 .991 0L1.5 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L.991 1 1 7l0 .009L7 7l.009 0L7 6.5c0-.275.225-.5.5-.5z"],"pop-up_12":["M10.5 7L10 7l0-1.5C10 4.673 9.327 4 8.5 4L3 4l0-1 8 0 0 3.5c0 .275-.225.5-.5.5m-2 4l-7 0c-.276 0-.5-.225-.5-.5L1 7l8 0 0 3.5c0 .275-.225.5-.5.5m-7-6l7 0c.275 0 .5.224.5.5L9 6 1 6l0-.5c0-.276.224-.5.5-.5m2-4l7 0c.275 0 .5.224.5.5l0 .5-8 0 0-.5c0-.276.224-.5.5-.5m7-1l-7 0C2.673 0 2 .673 2 1.5L2 4l-.5 0C.673 4 0 4.673 0 5.5l0 5c0 .827.673 1.5 1.5 1.5l7 0c.827 0 1.5-.673 1.5-1.5L10 8l.5 0c.827 0 1.5-.673 1.5-1.5l0-5c0-.827-.673-1.5-1.5-1.5"],"pop-up_24":["M23 4L8 4l0-.5C8 2.673 8.673 2 9.5 2l12 0c.827 0 1.5.673 1.5 1.5l0 .5zm0 8.5c0 .827-.673 1.5-1.5 1.5L17 14l0-2.5c0-1.381-1.119-2.5-2.5-2.5L8 9l0-4 15 0 0 7.5zm-7-.5L1 12l0-.5c0-.827.673-1.5 1.5-1.5l12 0c.827 0 1.5.673 1.5 1.5l0 .5zm0 8.5c0 .827-.673 1.5-1.5 1.5l-12 0c-.827 0-1.5-.673-1.5-1.5L1 13l15 0 0 7.5zM21.5 1l-12 0C8.119 1 7 2.119 7 3.5L7 9 2.5 9C1.119 9 0 10.119 0 11.5l0 9C0 21.881 1.119 23 2.5 23l12 0c1.381 0 2.5-1.119 2.5-2.5l0-5.5 4.5 0c1.381 0 2.5-1.119 2.5-2.5l0-9C24 2.119 22.881 1 21.5 1z"],"power-ac_16":["M8 1C4.14 1 1 4.141 1 8c0 3.859 3.14 7 7 7 3.86 0 7-3.141 7-7 0-3.859-3.14-7-7-7m0 15c-4.411 0-8-3.589-8-8 0-4.411 3.589-8 8-8 4.411 0 8 3.589 8 8 0 4.411-3.589 8-8 8zm1.4248-7.001c.571 0 1.141-.178 1.618-.532l.755-.56c.222-.164.268-.477.104-.699-.165-.222-.477-.269-.7-.104l-.755.56c-.576.426-1.367.45-1.967.053l-.409-.269c-.949-.625-2.2-.592-3.114.085l-.755.56c-.221.164-.268.477-.104.699.165.221.477.268.7.103l.755-.559c.576-.426 1.367-.45 1.968-.053l.409.269c.453.299.974.447 1.495.447z"],"power-apps_32":["M29 4c1.654 0 3 1.346 3 3l0 14c0 1.654-1.346 3-3 3-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5 1.103 0 2-.897 2-2l0-14c0-1.103-.897-2-2-2L3 5c-1.103 0-2 .897-2 2l0 14c0 1.103.897 2 2 2 .276 0 .5.224.5.5 0 .276-.224.5-.5.5-1.654 0-3-1.346-3-3L0 7c0-1.654 1.346-3 3-3l26 0zM18.7174 19.8167c.377.378.377.989 0 1.366l-6.534 6.535c-.188.188-.436.282-.683.282-.247 0-.495-.094-.683-.282l-6.534-6.535c-.377-.377-.377-.988 0-1.366l6.534-6.534c.188-.189.436-.283.683-.283.247 0 .495.094.683.283l6.534 6.534zm-7.193 7.193l6.486-6.534-6.509-6.462-6.511 6.51 6.534 6.486zM20.5 19.0011c-.234 0-.47-.09-.649-.269l-2.081-2.081c-.359-.359-.359-.94 0-1.299l2.081-2.082c.179-.179.415-.269.649-.269.235 0 .471.09.649.269l2.082 2.082c.359.359.359.94 0 1.299l-2.082 2.081c-.178.179-.414.269-.649.269zm0-4.966l-1.966 1.966 1.966 1.967 1.967-1.967-1.967-1.966zm.649 8.2356l2.082 2.081c.359.359.359.941 0 1.299l-2.082 2.082c-.178.179-.414.269-.649.269-.234 0-.47-.09-.649-.269l-2.081-2.082c-.359-.358-.359-.94 0-1.299l2.081-2.081c.179-.179.415-.269.649-.269.235 0 .471.09.649.269zm-.649 4.697l1.967-1.966-1.967-1.966-1.966 1.966 1.966 1.966zm5.148-9.1984l2.081 2.081c.36.359.36.94 0 1.299l-2.081 2.082c-.179.179-.415.269-.649.269-.235 0-.471-.09-.649-.269l-2.082-2.082c-.359-.359-.359-.94 0-1.299l2.082-2.081c.178-.179.414-.269.649-.269.234 0 .47.09.649.269zm-.649 4.697l1.966-1.966-1.966-1.967-1.967 1.967 1.967 1.966zM10.8772 17.758c.172-.172.397-.258.623-.258.225 0 .452.086.624.258l2.118 2.118c.345.345.345.903 0 1.248l-2.118 2.118c-.172.172-.399.258-.624.258-.226 0-.451-.086-.623-.258l-2.118-2.118c-.345-.345-.345-.903 0-1.248l2.118-2.118zm2.574 2.742l-1.951-1.951-1.95 1.951 1.95 1.951 1.951-1.951z"],"presentation_16":["M14.5 14c.276 0 .5.224.5.5 0 .276-.224.5-.5.5L3 15c-1.103 0-2-.897-2-2L1 1.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5L2 13c0 .552.448 1 1 1l11.5 0zm-11-4c-.117 0-.234-.041-.329-.124-.208-.182-.229-.497-.047-.705l3.5-4c.189-.217.563-.217.752 0L10.5 8.74l3.124-3.569c.182-.208.497-.228.705-.047.208.182.229.497.047.705l-3.5 4c-.189.217-.563.217-.752 0L7 6.26 3.876 9.829c-.099.113-.237.171-.376.171z"],"presentation_24":["M22.5 22c.276 0 .5.224.5.5 0 .276-.224.5-.5.5L3.469 23C2.107 23 1 21.893 1 20.531L1 1.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 19.031C2 21.341 2.659 22 3.469 22L22.5 22zM5.8584 14.8535c-.195.195-.512.195-.707 0-.195-.195-.195-.512 0-.707l4.995-5c.188-.187.52-.188.707 0l4.647 4.646 4.646-4.646c.195-.195.512-.195.707 0 .195.195.195.512 0 .707l-5 5c-.098.098-.225.146-.353.146-.128 0-.256-.048-.354-.146l-4.646-4.646-4.642 4.646z"],"print_16":["M14 3c1.103 0 2 .897 2 2l0 5.5c0 1.103-.897 2-2 2l-1 0 0 1.5c0 1.103-.897 2-2 2l-6 0c-1.103 0-2-.897-2-2l0-1.5-1 0c-1.103 0-2-.897-2-2L0 5c0-1.103.897-2 2-2l1 0 0-1c0-1.103.897-2 2-2l6 0c1.103 0 2 .897 2 2l0 1 1 0zm1 7.5L15 5c0-.552-.448-1-1-1L2 4c-.552 0-1 .448-1 1l0 5.5c0 .552.448 1 1 1l1 0 0-2c0-.276.224-.5.5-.5l9 0c.276 0 .5.224.5.5l0 2 1 0c.552 0 1-.448 1-1zm-1.3101-5.46c.06.02.12.06.16.109.1.09.15.221.15.351 0 .13-.05.26-.15.35-.09.1-.22.15-.35.15-.13 0-.26-.05-.35-.15-.05-.04-.09-.1-.11-.161-.03-.059-.04-.12-.04-.189 0-.13.05-.261.15-.351.04-.049.1-.089.16-.109.12-.051.26-.051.38 0zM12 14l0-4-8 0 0 4c0 .552.448 1 1 1l6 0c.552 0 1-.448 1-1zm-6.5 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l5 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-5 0zm0-2c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l5 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-5 0zM4 2l0 1 8 0 0-1c0-.552-.448-1-1-1L5 1c-.552 0-1 .448-1 1z"],"priority_12":["M6.0001 12c3.313 0 6-2.687 6-6 0-3.313-2.687-6-6-6-3.314 0-6 2.687-6 6 0 3.313 2.686 6 6 6zm0-11c2.757 0 5 2.243 5 5 0 2.757-2.243 5-5 5-2.757 0-5-2.243-5-5 0-2.757 2.243-5 5-5zm0 8c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5 0 .276.224.5.5.5zm0-2c.275 0 .5-.225.5-.5l0-3c0-.275-.225-.5-.5-.5-.275 0-.5.225-.5.5l0 3c0 .275.225.5.5.5z"],"priority_16":["M7.9999 16c4.418 0 8-3.582 8-8 0-4.418-3.582-8-8-8-4.418 0-8 3.582-8 8 0 4.418 3.582 8 8 8zm0-15c3.86 0 7 3.14 7 7 0 3.86-3.14 7-7 7-3.86 0-7-3.14-7-7 0-3.86 3.14-7 7-7zm0 10.5c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5 0 .276.224.5.5.5zm0-2c.275 0 .5-.225.5-.5l0-4c0-.275-.225-.5-.5-.5-.275 0-.5.225-.5.5l0 4c0 .275.225.5.5.5z"],"priority_18":["M9.0001 18c4.97 0 9-4.029 9-9 0-4.971-4.03-9-9-9-4.971 0-9 4.029-9 9 0 4.971 4.029 9 9 9zm0-17c4.411 0 8 3.589 8 8 0 4.411-3.589 8-8 8-4.411 0-8-3.589-8-8 0-4.411 3.589-8 8-8zm0 12c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5 0 .276.224.5.5.5zm0-3c.275 0 .5-.225.5-.5l0-4c0-.275-.225-.5-.5-.5-.275 0-.5.225-.5.5l0 4c0 .275.225.5.5.5z"],"priority_20":["M9.9999 20c5.523 0 10-4.477 10-10 0-5.523-4.477-10-10-10-5.523 0-10 4.477-10 10 0 5.523 4.477 10 10 10zm0-19c4.963 0 9 4.037 9 9 0 4.963-4.037 9-9 9-4.962 0-9-4.037-9-9 0-4.963 4.038-9 9-9zm0 13c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5 0 .276.224.5.5.5zm0-3c.275 0 .5-.225.5-.5l0-4c0-.275-.225-.5-.5-.5-.275 0-.5.225-.5.5l0 4c0 .275.225.5.5.5z"],"priority_24":["M12.0002 24c6.627 0 12-5.373 12-12 0-6.627-5.373-12-12-12-6.627 0-12 5.373-12 12 0 6.627 5.373 12 12 12zm0-23c6.065 0 11 4.935 11 11 0 6.065-4.935 11-11 11-6.065 0-11-4.935-11-11 0-6.065 4.935-11 11-11zm0 16c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5 0 .276.224.5.5.5zm0-3c.275 0 .5-.225.5-.5l0-6c0-.275-.225-.5-.5-.5-.275 0-.5.225-.5.5l0 6c0 .275.225.5.5.5z"],"priority_28":["M13.9998 28c7.732 0 14-6.268 14-14 0-7.732-6.268-14-14-14-7.732 0-14 6.268-14 14 0 7.732 6.268 14 14 14zm0-27c7.168 0 13 5.832 13 13 0 7.168-5.832 13-13 13-7.168 0-13-5.832-13-13 0-7.168 5.832-13 13-13zm0 19c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5 0 .276.224.5.5.5zm0-3c.275 0 .5-.225.5-.5l0-8c0-.275-.225-.5-.5-.5-.275 0-.5.225-.5.5l0 8c0 .275.225.5.5.5z"],"priority_32":["M15.9996 32c8.837 0 16-7.164 16-16 0-8.836-7.163-16-16-16-8.836 0-16 7.164-16 16 0 8.836 7.164 16 16 16zm0-31c8.271 0 15 6.729 15 15 0 8.271-6.729 15-15 15-8.271 0-15-6.729-15-15 0-8.271 6.729-15 15-15zm.0009 22c.275 0 .5-.224.5-.5 0-.276-.225-.5-.5-.5-.276 0-.5.224-.5.5 0 .276.224.5.5.5zm0-4c.274 0 .5-.225.5-.5l0-9c0-.275-.226-.5-.5-.5-.275 0-.5.225-.5.5l0 9c0 .275.225.5.5.5z"],"priority_40":["M20 40C8.972 40 0 31.028 0 20 0 8.972 8.972 0 20 0c11.028 0 20 8.972 20 20 0 11.028-8.972 20-20 20zm0-39C9.523 1 1 9.523 1 20c0 10.477 8.523 19 19 19 10.477 0 19-8.523 19-19C39 9.523 30.477 1 20 1zm0 23c-.276 0-.5-.224-.5-.5l0-12c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 12c0 .276-.224.5-.5.5zm0 4.9976c-.13 0-.26-.05-.35-.15-.1-.09-.15-.22-.15-.35 0-.13.05-.26.15-.36.04-.04.1-.08.16-.1.12-.05.26-.05.38 0 .06.02.12.06.16.1.1.1.15.23.15.36 0 .13-.05.26-.15.35-.04.05-.1.09-.16.11-.06.03-.12.04-.19.04z"],"priority_44":["M22 43C10.42 43 1 33.58 1 22 1 10.42 10.42 1 22 1c11.58 0 21 9.42 21 21 0 11.58-9.42 21-21 21m0-43C9.869 0 0 9.869 0 22c0 12.131 9.869 22 22 22 12.131 0 22-9.869 22-22C44 9.869 34.131 0 22 0zm.5 30.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5zM22 13c.276 0 .5.224.5.5l0 13c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-13c0-.276.224-.5.5-.5z"],"priority_72":["M36.0004 72c19.882 0 36-16.118 36-36 0-19.882-16.118-36-36-36-19.883 0-36 16.118-36 36 0 19.882 16.117 36 36 36zm0-71c19.299 0 35 15.701 35 35 0 19.299-15.701 35-35 35-19.3 0-35-15.701-35-35 0-19.299 15.7-35 35-35zm0 50c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5 0 .276.224.5.5.5zm0-7c.274 0 .5-.225.5-.5l0-22c0-.275-.226-.5-.5-.5-.275 0-.5.225-.5.5l0 22c0 .275.225.5.5.5z"],"private_10":["M6.75 4c-.827 0-1.5-.673-1.5-1.5 0-.827.673-1.5 1.5-1.5.827 0 1.5.673 1.5 1.5 0 .827-.673 1.5-1.5 1.5zM3.543 8l-.793.793L1.957 8l.793-.793.793.793zM6.75 0c-1.378 0-2.5 1.121-2.5 2.5 0 .509.154.981.417 1.377L.896 7.646c-.195.196-.195.512 0 .708l1.5 1.5c.098.097.226.146.354.146.128 0 .256-.049.354-.146l1.5-1.5c.195-.196.195-.512 0-.708L3.457 6.5l1.917-1.916c.395.262.867.416 1.376.416 1.378 0 2.5-1.121 2.5-2.5 0-1.379-1.122-2.5-2.5-2.5z"],"private_12":["M8.4996 5.00002c-.827 0-1.5-.673-1.5-1.5 0-.827.673-1.5 1.5-1.5.827 0 1.5.673 1.5 1.5 0 .827-.673 1.5-1.5 1.5zm-5.018 4.798l-.269-.258.304-.307.269.265-.304.3zm5.018-8.798c-1.38 0-2.5 1.119-2.5 2.5 0 .51.155.983.417 1.378l-4.272 4.32c-.094.096-.146.225-.145.359.002.133.058.261.155.354l.987.945c.097.093.221.139.346.139.127 0 .254-.048.351-.144l1.01-.998c.095-.094.149-.223.149-.357 0-.134-.055-.262-.15-.355l-.628-.619 2.905-2.937c.395.261.867.415 1.375.415 1.381 0 2.5-1.119 2.5-2.5 0-1.381-1.119-2.5-2.5-2.5z"],"private_14":["M10.0042 6c-1.103 0-2-.897-2-2 0-1.103.897-2 2-2 1.103 0 2 .897 2 2 0 1.103-.897 2-2 2zm-4.211 5.5l-1.29 1.29-1.297-1.315 1.284-1.277 1.303 1.302zM10.0042 1c-1.657 0-3 1.343-3 3 0 .647.21 1.243.559 1.733l-5.415 5.383c-.196.195-.198.51-.004.705l2 2.03c.093.095.218.166.356.149.133 0 .26-.053.354-.146l2-2c.093-.094.146-.221.146-.354 0-.133-.053-.26-.146-.354l-1.655-1.653 3.071-3.053c.49.35 1.087.56 1.734.56 1.657 0 3-1.343 3-3 0-1.657-1.343-3-3-3z"],"private_16":["M10.5 7.0002c-1.379 0-2.5-1.122-2.5-2.5 0-1.378 1.121-2.5 2.5-2.5 1.378 0 2.5 1.122 2.5 2.5 0 1.378-1.122 2.5-2.5 2.5zm-4.092 5.188l-1.6 1.601-1.601-1.601 1.601-1.6 1.6 1.6zM10.5 1.0002c-1.93 0-3.5 1.569-3.5 3.5 0 .704.213 1.358.572 1.907l-5.426 5.428c-.195.195-.195.512 0 .707l2.308 2.308c.098.097.226.146.354.146.128 0 .255-.049.353-.146l2.308-2.308c.195-.195.195-.512 0-.707l-1.954-1.954 2.727-2.729c.612.521 1.394.848 2.258.848 1.93 0 3.5-1.57 3.5-3.5 0-1.931-1.57-3.5-3.5-3.5z"],"private_20":["M13.5 9C11.57 9 10 7.43 10 5.5 10 3.57 11.57 2 13.5 2 15.43 2 17 3.57 17 5.5 17 7.43 15.43 9 13.5 9zm-6.687 6.979L5 17.793l-1.784-1.784 1.857-1.77 1.74 1.74zM13.5 1C11.019 1 9 3.019 9 5.5c0 1.026.359 1.963.939 2.721l-5.17 4.926c-.015.012-.029.025-.042.039-.008.007-.015.015-.023.023l-2.549 2.429c-.097.092-.153.221-.155.356-.002.135.051.264.146.36l2.5 2.5c.098.097.226.146.354.146.128 0 .256-.049.354-.146l2.52-2.521c.195-.195.195-.512 0-.707l-2.077-2.077 4.838-4.609c.78.652 1.771 1.06 2.865 1.06 2.481 0 4.5-2.019 4.5-4.5C18 3.019 15.981 1 13.5 1z"],"private_24":["M15.5 12.0004c-2.481 0-4.5-2.02-4.5-4.5 0-2.481 2.019-4.5 4.5-4.5 2.481 0 4.5 2.019 4.5 4.5 0 2.48-2.019 4.5-4.5 4.5zm-6.707 7.5L6.5 21.7934l-2.293-2.293 2.293-2.293 2.293 2.293zm6.707-17.5c-3.037 0-5.5 2.462-5.5 5.5 0 1.339.479 2.564 1.274 3.519l-8.128 8.127c-.195.196-.195.512 0 .708l3 3c.098.097.226.146.354.146.128 0 .256-.049.354-.146l3-3c.195-.196.195-.512 0-.708l-2.647-2.646 4.774-4.774c.955.795 2.18 1.274 3.519 1.274 3.037 0 5.5-2.463 5.5-5.5 0-3.038-2.463-5.5-5.5-5.5z"],"private_28":["M18.5 12C16.019 12 14 9.981 14 7.5 14 5.019 16.019 3 18.5 3 20.981 3 23 5.019 23 7.5c0 2.481-2.019 4.5-4.5 4.5zm-6.712 9.503L8.5 24.793 5.207 21.5l3.262-3.262 3.319 3.265zM18.5 2C15.462 2 13 4.462 13 7.5c0 1.339.479 2.565 1.274 3.519L4.146 21.146c-.195.196-.195.512 0 .708l4 4c.094.093.222.146.354.146.133 0 .26-.053.354-.146l3.997-4c.094-.095.147-.223.147-.356-.001-.133-.055-.261-.15-.354l-3.672-3.613 5.805-5.805c.954.795 2.18 1.274 3.519 1.274 3.038 0 5.5-2.462 5.5-5.5C24 4.462 21.538 2 18.5 2z"],"private_8":["M5.5001 3c-.551 0-1-.449-1-1 0-.551.449-1 1-1 .551 0 1 .449 1 1 0 .551-.449 1-1 1zm-3.501 3.793l-.292-.293.293-.293.292.293-.293.293zM5.5001 0c-1.103 0-2 .897-2 2 0 .37.107.712.283 1.01L.6461 6.146c-.195.196-.195.512 0 .707l.998 1c.094.094.221.147.354.147.132 0 .259-.053.353-.146l1.002-1c.094-.094.147-.221.147-.354 0-.132-.053-.26-.146-.354l-.647-.646 1.783-1.783c.298.175.64.283 1.01.283 1.103 0 2-.897 2-2 0-1.103-.897-2-2-2z"],"private-circle_100":["M50 0c27.57 0 50 22.43 50 50 0 27.57-22.43 50-50 50-27.57 0-50-22.43-50-50C0 22.43 22.43 0 50 0zm0 99c27.019 0 49-21.981 49-49C99 22.981 77.019 1 50 1 22.981 1 1 22.981 1 50c0 27.019 21.981 49 49 49zm11.5-76C68.393 23 74 28.607 74 35.5 74 42.393 68.393 48 61.5 48c-3.244 0-6.194-1.253-8.418-3.287L39.673 58.072l5.92 5.921c.283.282.439.659.439 1.061 0 .4-.156.777-.438 1.06l-8.401 8.401c-.293.293-.677.438-1.061.438-.384 0-.768-.145-1.061-.438l-5.584-5.585c-.284-.284-.44-.661-.439-1.063 0-.401.157-.777.441-1.06L52.37 44.01C50.286 41.775 49 38.789 49 35.5 49 28.607 54.607 23 61.5 23zm0 24C67.841 47 73 41.841 73 35.5 73 29.159 67.841 24 61.5 24 55.159 24 50 29.159 50 35.5 50 41.841 55.159 47 61.5 47zM44.886 64.7l-5.922-5.922-8.769 8.738c-.095.093-.147.219-.147.352-.001.135.052.26.146.355l5.584 5.585c.196.195.513.195.708 0l8.4-8.401c.094-.095.146-.22.146-.353 0-.134-.052-.259-.146-.354z"],"private-circle_16":["M8 0C3.582 0 0 3.582 0 8c0 4.418 3.582 8 8 8 4.418 0 8-3.582 8-8 0-4.418-3.582-8-8-8m0 1c3.859 0 7 3.141 7 7 0 3.859-3.141 7-7 7-3.859 0-7-3.141-7-7 0-3.859 3.141-7 7-7","M9.24225 4.25c1.101 0 1.992.891 1.992 1.992 0 1.1-.891 1.992-1.992 1.992-.364 0-.701-.104-.995-.275l-1.286 1.286.644.654c.193.195.192.51-.003.704l-1.001 1c-.093.094-.22.147-.353.147-.133 0-.26-.053-.354-.147l-.998-1c-.195-.195-.195-.512 0-.707l2.639-2.641c-.177-.297-.285-.641-.285-1.013 0-1.101.891-1.992 1.992-1.992zm0 2.984c.547 0 .992-.445.992-.992 0-.547-.445-.992-.992-.992-.547 0-.992.445-.992.992 0 .547.445.992.992.992zm-2.993 3.309l.295-.296-.29-.294-.297.297.292.293z"],"private-circle_20":["M10 0c5.5136842 0 10 4.48631579 10 10 0 5.5136842-4.4863158 10-10 10-5.51368421 0-10-4.4863158-10-10C0 4.48631579 4.48631579 0 10 0zm0 19c4.9627059 0 9-4.0372941 9-9 0-4.96270588-4.0372941-9-9-9-4.96270588 0-9 4.03729412-9 9 0 4.9627059 4.03729412 9 9 9z","M12.00025 4.75c1.378 0 2.5 1.121 2.5 2.5 0 1.379-1.122 2.5-2.5 2.5-.509 0-.981-.155-1.376-.417l-2.417 2.417 1.131 1.131c.195.195.195.512 0 .707l-1.5 1.5c-.098.098-.226.146-.354.146-.128 0-.255-.048-.353-.146l-1.485-1.484c-.195-.196-.195-.512 0-.708l4.271-4.27c-.263-.395-.417-.867-.417-1.376 0-1.379 1.122-2.5 2.5-2.5zm0 4c.827 0 1.5-.673 1.5-1.5 0-.827-.673-1.5-1.5-1.5-.827 0-1.5.673-1.5 1.5 0 .827.673 1.5 1.5 1.5zm-3.723 4.484l-.777-.777-.793.793.777.777.793-.793z"],"private-circle_24":["M12 0c6.616 0 12 5.383 12 12 0 6.617-5.384 12-12 12-6.617 0-12-5.383-12-12C0 5.383 5.383 0 12 0zm0 23c6.065 0 11-4.935 11-11 0-6.065-4.935-11-11-11C5.935 1 1 5.935 1 12c0 6.065 4.935 11 11 11z","M14.469 5.5c1.654 0 3 1.346 3 3 0 1.654-1.346 3-3 3-.647 0-1.243-.21-1.733-.561l-3.029 3.03 1.647 1.646c.195.196.195.512 0 .707l-2 2c-.098.098-.226.147-.354.147-.128 0-.256-.049-.353-.147l-2-2c-.196-.195-.196-.511 0-.707l5.382-5.383c-.35-.489-.56-1.086-.56-1.732 0-1.654 1.346-3 3-3zm0 5c1.103 0 2-.897 2-2 0-1.104-.897-2-2-2-1.103 0-2 .896-2 2 0 1.103.897 2 2 2zm-4.176 5.469L9 14.676l-1.293 1.293L9 17.262l1.293-1.293z"],"private-circle_48":["M24 0c13.233 0 24 10.767 24 24 0 13.233-10.767 24-24 24C10.767 48 0 37.233 0 24 0 10.767 10.767 0 24 0zm0 47c12.683 0 23-10.317 23-23C47 11.318 36.683 1 24 1 11.318 1 1 11.318 1 24c0 12.683 10.318 23 23 23zm5-35c3.313 0 6 2.687 6 6 0 3.313-2.687 6-6 6-1.477 0-2.827-.536-3.872-1.421L18.707 29l3.147 3.146c.094.095.146.223.146.357 0 .133-.055.261-.15.354l-4.083 4c-.094.092-.22.143-.35.143l-.006 0c-.133-.002-.26-.056-.352-.15l-3.417-3.5c-.191-.197-.189-.51.004-.704l10.775-10.774C23.536 20.827 23 19.477 23 18c0-3.313 2.687-6 6-6zm0 11c2.757 0 5-2.243 5-5 0-2.757-2.243-5-5-5-2.757 0-5 2.243-5 5 0 2.757 2.243 5 5 5zm-8.211 9.496L18 29.707l-3.297 3.297 2.721 2.788 3.365-3.296z"],"private-circle_56":["M28 0c15.464 0 28 12.536 28 28 0 15.464-12.536 28-28 28C12.536 56 0 43.464 0 28 0 12.536 12.536 0 28 0zm0 55c14.888 0 27-12.112 27-27C55 13.112 42.888 1 28 1 13.112 1 1 13.112 1 28c0 14.888 12.112 27 27 27zm5-41c3.866 0 7 3.134 7 7 0 3.866-3.134 7-7 7-1.753 0-3.352-.648-4.579-1.714L21.207 33.5l3.647 3.646c.195.196.195.512 0 .708l-5 5c-.094.093-.221.146-.354.146-.148-.016-.263-.054-.357-.15l-3.961-4.039c-.192-.196-.191-.509.004-.704l12.528-12.528C26.648 24.351 26 22.753 26 21c0-3.866 3.134-7 7-7zm0 13c3.309 0 6-2.691 6-6 0-3.309-2.691-6-6-6-3.309 0-6 2.691-6 6 0 3.309 2.691 6 6 6zm-9.207 10.5L20.5 34.207l-4.257 4.258 3.261 3.324 4.289-4.289z"],"private-circle-active_16":["M8 0c4.418 0 8 3.582 8 8 0 4.418-3.582 8-8 8-4.418 0-8-3.582-8-8 0-4.418 3.582-8 8-8zm1.24225 7.234c-.547 0-.992-.445-.992-.992 0-.547.445-.992.992-.992.547 0 .992.445.992.992 0 .547-.445.992-.992.992zm-2.993 3.309l-.292-.293.297-.297.29.294-.295.296zm2.993-6.293c-1.101 0-1.992.891-1.992 1.992 0 .372.108.716.285 1.013l-2.639 2.641c-.195.195-.195.512 0 .707l.998 1c.094.094.221.147.354.147.133 0 .26-.053.353-.147l1.001-1c.195-.194.196-.509.003-.704l-.644-.654 1.286-1.286c.294.171.631.275.995.275 1.101 0 1.992-.892 1.992-1.992 0-1.101-.891-1.992-1.992-1.992z"],"private-circle-active_20":["M10 0c5.5136842 0 10 4.48631579 10 10 0 5.5136842-4.4863158 10-10 10-5.51368421 0-10-4.4863158-10-10C0 4.48631579 4.48631579 0 10 0zm2.00025 8.75c-.827 0-1.5-.673-1.5-1.5 0-.827.673-1.5 1.5-1.5.827 0 1.5.673 1.5 1.5 0 .827-.673 1.5-1.5 1.5zm-3.723 4.484l-.793.793-.777-.777.793-.793.777.777zm3.723-8.484c-1.378 0-2.5 1.121-2.5 2.5 0 .509.154.981.417 1.376l-4.271 4.27c-.195.196-.195.512 0 .708l1.485 1.484c.098.098.225.146.353.146.128 0 .256-.048.354-.146l1.5-1.5c.195-.195.195-.512 0-.707l-1.131-1.131 2.417-2.417c.395.262.867.417 1.376.417 1.378 0 2.5-1.121 2.5-2.5 0-1.379-1.122-2.5-2.5-2.5z"],"private-circle-active_24":["M12 0c6.616 0 12 5.383 12 12 0 6.617-5.384 12-12 12-6.617 0-12-5.383-12-12C0 5.383 5.383 0 12 0zm2.469 10.5c-1.103 0-2-.897-2-2 0-1.104.897-2 2-2 1.103 0 2 .896 2 2 0 1.103-.897 2-2 2zm-4.176 5.469L9 17.262l-1.293-1.293L9 14.676l1.293 1.293zM14.469 5.5c-1.654 0-3 1.346-3 3 0 .646.21 1.243.56 1.732l-5.382 5.383c-.196.196-.196.512 0 .707l2 2c.097.098.225.147.353.147.128 0 .256-.049.354-.147l2-2c.195-.195.195-.511 0-.707l-1.647-1.646 3.029-3.03c.49.351 1.086.561 1.733.561 1.654 0 3-1.346 3-3 0-1.654-1.346-3-3-3z"],"pro-badge_28":["M0 10.0085302C0 8.899249601.899897516 8 1.99124431 8L26.0087557 8C27.1084896 8 28 8.901950359 28 10.0085302l0 7.9829396C28 19.1007504 27.1001025 20 26.0087557 20L1.99124431 20C.891510444 20 0 19.0980496 0 17.9914698l0-7.9829396zM2 9c-.55228475 0-1 .44771525-1 1l0 8c0 .5522847.44771525 1 1 1l24 0c.5522847 0 1-.4477153 1-1l0-8c0-.55228475-.4477153-1-1-1L2 9zm7.963 2.0002c1.519 0 2.366.673 2.366 1.92 0 1.198-.813 1.879-2.399 1.879l-1.074 0 0 2.109-.856 0 0-5.908 1.963 0zm-1.107.681l0 2.437 1.091 0c1.065 0 1.493-.427 1.493-1.198 0-.78-.512-1.239-1.46-1.239l-1.124 0zm9.2084.8364c1.192 0 2.148.723 2.148 2.257 0 1.494-.923 2.257-2.156 2.257-1.217 0-2.148-.78-2.148-2.257 0-1.534.974-2.257 2.156-2.257zm.009 3.874c.772 0 1.3-.558 1.3-1.617 0-1.083-.562-1.616-1.309-1.616-.746 0-1.317.55-1.317 1.616 0 1.059.571 1.617 1.326 1.617zm-4.8182.5169l0-4.267.663 0 .109.632c.243-.493.621-.755 1.107-.755.21 0 .378.032.479.057l0 .788c-.159-.041-.319-.074-.512-.074-.554 0-1.041.402-1.041 1.477l0 2.142-.805 0z"],"proximity_12":["M5.9995 3.98729c1.129-.005 2.256.343 3.142 1.058.214.174.249.487.075.703-.175.215-.488.248-.703.074-.714-.576-1.614-.838-2.514-.836l0-.001 0 .001c-.9-.002-1.799.26-2.513.836-.215.174-.529.141-.703-.074-.174-.216-.139-.529.075-.703.885-.715 2.013-1.063 3.141-1.058zm4.7998-1.3897c.222.166.266.479.101.699-.166.221-.48.266-.701.1-1.219-.915-2.71-1.361-4.2-1.353l0-.002 0 .002c-1.49-.008-2.979.438-4.2 1.353-.221.166-.533.121-.699-.1-.165-.22-.121-.533.099-.699 1.393-1.045 3.052-1.598 4.798-1.598l.002 0 0 .002 0-.002.003 0c1.745 0 3.404.553 4.797 1.598zm-4.7998 4.4004c1.104 0 2 .896 2 2 0 1.104-.896 2-2 2-1.104 0-2-.896-2-2 0-1.104.896-2 2-2zm0 3c.552 0 1-.449 1-1 0-.551-.448-1-1-1-.552 0-1 .449-1 1 0 .551.448 1 1 1z"],"proximity_16":["M8 9c-1.657 0-3 1.343-3 3 0 1.657 1.343 3 3 3 1.657 0 3-1.343 3-3 0-1.657-1.343-3-3-3m0 1c1.103 0 2 .897 2 2 0 1.103-.897 2-2 2-1.103 0-2-.897-2-2 0-1.103.897-2 2-2zm4.1618837-2.14798006c-2.29482459-2.420481-6.02894281-2.42151539-8.32474855 0-.19131715.20170675-.50233015.20170675-.69364729 0-.19131715-.20274115-.19131715-.52960952 0-.73235066 2.6764778-2.82182571 7.03458424-2.82182571 9.71302424 0 .1913172.20274114.1913172.52960951 0 .73235066-.0961491.10033618-.2217316.15102146-.3473142.15102146-.1255825 0-.251165-.05068528-.3473142-.15102146zm3.3334343-2.85206532c-.1292236 0-.2584472-.04809521-.357384-.1433041-1.9060479-1.85411937-4.4410512-2.874915645-7.137584-2.874915645-2.69653279 0-5.23153611 1.020796275-7.138593558 2.874915645-.196864056.19139931-.516894343.19139931-.7137584 0-.1968640561-.19238083-.1968640561-.50254585 0-.69492669C2.24485263 2.12209436 5.03426488 1.0002 8.00035 1.0002c2.9670947 0 5.7544878 1.12189436 7.852352 3.16152383.196864.19238084.196864.50254586 0 .69492669-.0989369.09520889-.2281604.1433041-.357384.1433041z"],"proximity_20":["M9.9878 11c2.209 0 4 1.791 4 4 0 2.209-1.791 4-4 4-2.209 0-4-1.791-4-4 0-2.209 1.791-4 4-4zm0 7c1.654 0 3-1.346 3-3 0-1.654-1.346-3-3-3-1.654 0-3 1.346-3 3 0 1.654 1.346 3 3 3zm9.3564-13.2617c.2.19.208.507.018.707-.098.104-.23.155-.362.155-.124 0-.248-.046-.344-.137-2.35-2.234-5.424-3.463-8.657-3.463-3.232 0-6.305 1.229-8.655 3.462-.2.191-.516.182-.707-.018-.19-.2-.182-.517.019-.707 2.535-2.41 5.854-3.737 9.343-3.737 3.491 0 6.809 1.327 9.345 3.738zM9.9995 6c2.363 0 4.584.927 6.255 2.608.195.197.194.513-.002.707-.098.097-.225.146-.353.146-.128 0-.256-.049-.355-.148C14.0635 7.821 12.0935 7 9.9995 7c-2.094 0-4.064.821-5.545 2.313-.196.198-.512.198-.708.002-.196-.194-.197-.51-.002-.707C5.4155 6.927 7.6365 6 9.9995 6z"],"proximity_24":["M12 13c2.757 0 5 2.243 5 5 0 2.757-2.243 5-5 5-2.757 0-5-2.243-5-5 0-2.757 2.243-5 5-5zm0 9c2.206 0 4-1.794 4-4 0-2.206-1.794-4-4-4-2.206 0-4 1.794-4 4 0 2.206 1.794 4 4 4zM23.855253 6.1215498c.192996.20058289.192996.52665867 0 .72724156C23.759255 6.94959712 23.6332576 7 23.5062603 7c-.1259974 0-.2519948-.05040288-.3479928-.15120864C20.1773296 3.74027087 16.2154122 2.02863021 12.0005 2.02863021c-4.21591218 0-8.17782964 1.71164066-11.158767536 4.82016115-.191996.20058289-.5039895.20058289-.69698548 0-.1929959788-.20058289-.1929959788-.52665867 0-.72724156C3.31068103 2.81861821 7.5215933 1 12.0005 1c4.4779067 0 8.688819 1.81861821 11.854753 5.1215498zM4.14763873 10.1608426c4.32972649-4.2144568 11.37499607-4.2144568 15.70472257 0 .1968516.19161088.1968516.50310139 0 .69471227C19.7534307 10.95185162 19.6242153 11 19.4949998 11c-.1292154 0-.2584308-.04814838-.3563519-.14444513-3.9370327-3.83025241-10.34127259-3.83025241-14.27729581 0-.19685163.19161093-.51686173.19161093-.71371336 0-.19685164-.19161088-.19685164-.50310139 0-.69471227z"],"proximity_28":["M13.9795 15.0029c2.757 0 5 2.243 5 5 0 2.757-2.243 5-5 5-2.757 0-5-2.243-5-5 0-2.757 2.243-5 5-5zm0 9c2.206 0 4-1.794 4-4 0-2.206-1.794-4-4-4-2.206 0-4 1.794-4 4 0 2.206 1.794 4 4 4zM25.252 7.125c.211.179.236.494.059.705-.1.116-.241.177-.382.177-.114 0-.23-.039-.323-.118-2.963-2.51-6.732-3.892-10.612-3.892-3.874 0-7.638 1.379-10.599 3.882-.212.178-.527.151-.705-.059-.179-.211-.152-.526.058-.705C5.891 4.46 9.884 2.997 13.994 2.997c4.116 0 8.114 1.466 11.258 4.128zM13.9942 9.0088c2.959 0 5.746 1.113 7.848 3.134.199.191.205.508.013.707-.19.199-.508.206-.707.013-1.914-1.84-4.455-2.854-7.154-2.854-2.688 0-5.228 1.017-7.153 2.863-.097.094-.221.14-.346.14-.132 0-.263-.052-.36-.154-.192-.2-.185-.516.014-.706 2.113-2.027 4.899-3.143 7.845-3.143z"],"proximity-muted_12":["M7 9c0 .551-.449 1-1 1-.551 0-1-.449-1-1 0-.551.449-1 1-1 .551 0 1 .449 1 1m3.37349729-6.66753299l.47896154-.478808473c.19598427-.195921632.19598427-.511795282 0-.706717313-.19498434-.1959216318-.51095897-.1959216318-.70694323 0l-.66694645.666733306c-1.07691352-.523790484-2.25381901-.8116753297-3.48072049-.8116753297-1.7458598 0-3.40472659.5527788887-4.797614739 1.5973610597-.2209822549.16593362-.2649787219.47880847-.099991971.69972011.165986671.22091163.478961539.26589364.699943794.09996001C3.77802692 1.914634146 6.46381125 1.656737305 8.71063082 2.58236705L7.11975857 4.17273091c-1.46888204-.31887245-3.07975269-.01799281-4.26065786.93562575-.21498274.17393043-.24898001.48780488-.07499398.70271891.17398603.21491403.48796082.24890044.70294356.07497001.77993736-.6297481 1.78085699-.90163934 2.76277814-.84266293l-5.103590173 5.10295881c-.1949843426.19592163-.1949843426.51179529 0 .70671732C1.244230388 10.95101959 1.37222011 11 1.500209832 11c.127989722 0 .255979445-.04898041.352971656-.14694122L4.0310066 8.67692923c-.01799855.10495802-.03299735.21191523-.03299735.32187125 0 1.10355858.89592806 1.99920032 1.99983941 1.99920032 1.10391136 0 1.99983941-.89564174 1.99983941-1.99920032 0-1.10355858-.89592805-1.99920032-1.99983941-1.99920032-.11099108 0-.21698257.014994-.32297406.03298681l1.74885956-1.75029988c.38896877.14394242.75993898.34086365 1.08791264.60575769C8.60363941 5.96301479 8.7146305 6 8.82562159 6c.14598827 0 .28997671-.06397441.38896876-.18592563.17398603-.21491403.13998876-.52878848-.07399406-.70271891-.29497631-.23890444-.62394989-.42283087-.96392259-.5817673l1.4718818-1.47241103c.18598507.11195522.37696973.21391443.55195568.34486205.08899286.06797282.19498434.09996002.29897599.09996002.1519878 0 .30197575-.06797281.39996788-.19892043.16598665-.22091164.12199025-.53378649-.09899205-.69972011-.13598908-.10195922-.28597703-.17792883-.42696571-.27089165"],"proximity-muted_16":["M8 8.9994c1.657 0 3 1.343 3 3 0 1.657-1.343 3-3 3-1.657 0-3-1.343-3-3 0-1.657 1.343-3 3-3zm0 5c1.104 0 2-.897 2-2 0-1.103-.896-2-2-2-1.104 0-2 .897-2 2 0 1.103.896 2 2 2zm7.8525-9.8384c.197.192.197.502 0 .695-.099.095-.228.143-.357.143-.129 0-.258-.048-.358-.143-.747-.727-1.594-1.321-2.507-1.78l-2.345 2.345c.938.348 1.822.908 2.571 1.698.191.203.191.53 0 .732-.096.101-.222.151-.348.151-.125 0-.251-.05-.346-.151-.772-.813-1.706-1.347-2.694-1.613l-8.615 8.615c-.098.098-.226.146-.354.146-.127 0-.255-.048-.353-.146-.195-.195-.195-.512 0-.707l8.098-8.098c-1.588-.069-3.198.527-4.408 1.803-.191.202-.502.202-.693 0-.191-.202-.191-.529 0-.732 1.639-1.728 3.906-2.392 6.034-2.004l2.468-2.468c-1.147-.432-2.377-.666-3.646-.666-2.696 0-5.231 1.021-7.138 2.875-.197.191-.517.191-.713 0-.197-.193-.197-.503 0-.695 2.097-2.04 4.886-3.162 7.851-3.162 1.542 0 3.034.31 4.407.887l1.739-1.74c.195-.195.512-.195.707 0 .195.196.195.512 0 .707l-1.489 1.49c.901.485 1.741 1.09 2.489 1.818z"],"proximity-muted_24":["M11.99975 14.0049c2.206 0 4 1.794 4 4 0 2.206-1.794 4-4 4-2.206 0-4-1.794-4-4 0-.598.141-1.16.377-1.67l1.953-1.953c.51-.236 1.072-.377 1.67-.377m11.855-7.878c-.881-.92-1.85-1.711-2.876-2.393l1.879-1.88c.196-.196.196-.512 0-.707-.195-.196-.511-.196-.707 0l-2.042 2.042c-2.455-1.42-5.224-2.184-8.109-2.184-4.479 0-8.689 1.819-11.855 5.122-.193.2-.193.526 0 .727.193.2.505.2.697 0 2.981-3.109 6.943-4.82 11.158-4.82 2.611 0 5.123.659 7.366 1.898l-3.691 3.691c-3.902-1.326-8.415-.487-11.527 2.543-.197.191-.197.503 0 .695.196.191.517.191.713 0 2.712-2.64 6.596-3.459 10.037-2.461l-13.752 13.751c-.195.196-.195.512 0 .708.098.097.226.146.354.146.128 0 .256-.049.354-.146l5.165-5.166c-.007.104-.019.206-.019.312 0 2.757 2.243 5 5 5 2.757 0 5-2.243 5-5 0-2.757-2.243-5-5-5-.106 0-.208.012-.312.019l4.254-4.254c1.162.478 2.251 1.171 3.197 2.091.098.096.227.144.356.144.129 0 .258-.048.357-.144.197-.192.197-.504 0-.695-.943-.918-2.019-1.624-3.164-2.142l3.553-3.553c1.044.67 2.029 1.456 2.917 2.383.096.101.222.151.348.151.127 0 .253-.05.349-.151.193-.201.193-.527 0-.727"],"proximity-muted_28":["M13.99975 16.005c2.206 0 4 1.794 4 4 0 2.206-1.794 4-4 4-2.206 0-4-1.794-4-4 0-.598.141-1.16.377-1.67l1.953-1.953c.51-.236 1.072-.377 1.67-.377m11.855-7.878c-.881-.92-1.85-1.711-2.876-2.393l1.879-1.88c.196-.196.196-.512 0-.707-.195-.196-.511-.196-.707 0l-2.042 2.042c-2.455-1.42-5.224-2.184-8.109-2.184-4.479 0-8.689 1.819-11.855 5.122-.193.2-.193.526 0 .727.193.2.505.2.697 0 2.981-3.109 6.943-4.82 11.158-4.82 2.611 0 5.123.659 7.366 1.898l-3.691 3.691c-3.902-1.326-8.415-.487-11.527 2.543-.197.191-.197.503 0 .695.196.191.517.191.713 0 2.712-2.64 6.596-3.459 10.037-2.461l-13.752 13.751c-.195.196-.195.512 0 .708.098.097.226.146.354.146.128 0 .256-.049.354-.146l5.165-5.166c-.007.104-.019.206-.019.312 0 2.757 2.243 5 5 5 2.757 0 5-2.243 5-5 0-2.757-2.243-5-5-5-.106 0-.208.012-.312.019l4.254-4.254c1.162.478 2.251 1.171 3.197 2.091.098.096.227.144.356.144.129 0 .258-.048.357-.144.197-.192.197-.504 0-.695-.943-.918-2.019-1.624-3.164-2.142l3.553-3.553c1.044.67 2.029 1.456 2.917 2.383.096.101.222.151.348.151.127 0 .253-.05.349-.151.193-.201.193-.527 0-.727"],"pto_12":["M10.817 3.67166l-2.544 1.307c-.138.07-.235.202-.263.354l-.795 4.356-.126.065-.63-3.13c-.031-.152-.131-.281-.27-.349-.07-.036-.145-.052-.221-.052-.075 0-.151.017-.221.052l-2.24 1.104c-.537.277-1.167.173-1.621-.278l-.527-.478.012-.006 1.09.395c.13.048.274.039.399-.026l7.668-3.936c.079-.039.173-.046.261-.016.056.02.132.062.175.155l0 .001c.083.177.016.398-.147.482zm-6.663-.471l.33-.182 1.859 1.056-1.019.523-1.17-1.397zm7.718-.432c-.149-.322-.418-.564-.758-.68-.343-.118-.723-.092-1.043.072l-2.665 1.368-2.506-1.424c-.261-.14-.572-.14-.836.004l-.925.51c-.131.073-.222.199-.25.346-.027.146.013.299.109.413l1.414 1.689-1.815.931-.967-.351c-.212-.075-.448-.06-.655.047l-.713.386c-.143.077-.239.219-.258.38-.02.161.04.321.16.43l1.033.934c.739.738 1.851.918 2.76.449l1.65-.814.632 3.14c.031.153.132.284.273.351.069.034.143.05.217.05.078 0 .157-.018.228-.055l.791-.406c.231-.12.39-.338.437-.596l.764-4.188 2.325-1.193c.637-.328.905-1.131.598-1.793z"],"pto_120":["M114.4673 43.4192l-28.16 13.228c-.145.067-.248.201-.278.358l-8.574 44.873c-.174.907-.769 1.69-1.593 2.094l-7.786 3.817-7.932-37.624c-.031-.151-.132-.279-.271-.347-.069-.033-.143-.049-.218-.049-.076 0-.152.017-.222.051l-24.84 12.31c-7.481 3.669-16.57 2.267-22.633-3.502l-10.575-9.153 6.895-3.566c.694-.339 1.51-.389 2.239-.136l12.42 4.297c.126.043.263.034.383-.023l83.663-41.031c2.036-.997 4.461-1.138 6.654-.383 2.04.703 3.653 2.098 4.541 3.928 1.954 4.026.284 8.898-3.713 10.858zm-82.441-9.973l10.216-5.037c1.044-.542 2.292-.546 3.328-.017l28.648 15.581-22.247 10.91-19.945-21.437zm87.054-1.321c-1.006-2.072-2.822-3.647-5.116-4.437-2.444-.841-5.147-.685-7.419.431l-31.225 15.313-29.284-15.925c-1.335-.681-2.924-.675-4.245.01l-10.81 5.329c-.141.07-.242.203-.27.358-.029.155.018.316.125.431l20.197 21.708-27.964 13.714-12.223-4.23c-.979-.34-2.074-.271-3.015.189l-7.561 3.909c-.147.076-.247.221-.267.386-.019.164.044.328.17.436l11.115 9.621c6.346 6.04 15.888 7.509 23.748 3.659l24.263-12.024 7.932 37.621c.032.15.132.278.27.346.069.034.144.051.219.051.075 0 .15-.017.22-.051l8.361-4.1c1.105-.542 1.904-1.59 2.137-2.805l8.525-44.623 27.937-13.122c4.498-2.205 6.373-7.675 4.18-12.195z"],"pto_124":["M118.3057 44.022l-29.107 13.713c-.145.068-.248.201-.279.358l-8.861 46.524c-.181.946-.8 1.762-1.657 2.184l-8.066 3.966-8.203-39.028c-.032-.152-.132-.28-.271-.348-.069-.033-.143-.05-.218-.05-.076 0-.152.018-.223.053l-25.674 12.763c-7.74 3.803-17.142 2.35-23.412-3.635l-10.951-9.507 7.152-3.71c.719-.354 1.567-.408 2.325-.142l12.838 4.456c.125.044.264.033.384-.025l86.476-42.538c2.102-1.036 4.609-1.183 6.88-.401 2.117.729 3.79 2.179 4.712 4.084 2.024 4.184.296 9.247-3.845 11.283zm-85.249-10.363l10.582-5.233c1.084-.563 2.378-.568 3.454-.017l29.644 16.17-23.038 11.333-20.642-22.253zm89.994-1.355c-1.038-2.147-2.916-3.779-5.287-4.594-2.52-.868-5.306-.704-7.646.448L77.8337 44.04l-30.274-16.515c-1.374-.704-3.012-.699-4.373.01l-11.174 5.525c-.142.069-.242.202-.27.358-.029.155.018.314.125.43l20.894 22.525-28.933 14.232-12.64-4.388c-1.009-.348-2.137-.279-3.103.196l-7.816 4.052c-.147.078-.247.221-.266.386-.02.164.044.327.169.437l11.489 9.973c6.555 6.258 16.41 7.782 24.529 3.791l25.096-12.475 8.204 39.025c.031.151.131.279.27.347.069.034.144.051.219.051.075 0 .151-.018.221-.052l8.642-4.25c1.137-.559 1.959-1.641 2.198-2.894l8.814-46.273 28.885-13.609c4.639-2.281 6.574-7.942 4.311-12.618z"],"pto_14":["M12.7432958 4.86914123l-3.00699999 1.469c-.141.069-.242.201-.271.355l-.945 4.927-.302.148-.766-3.621c-.032-.15-.13-.276-.267-.344-.069-.035-.146-.053-.222-.053-.073 0-.145.016-.213.048l-2.646 1.241c-.667.329-1.479.202-2.037-.326l-.68-.587.132-.068 1.336.461c.125.044.263.036.383-.023l9.06299999-4.429c.121-.06.268-.067.402-.021.066.023.187.08.251.21.11.227.016.502-.211.613zm-8.05299999-.607l.491-.272999997 2.373 1.284999997-1.38.674-1.484-1.686zm9.16199999-.442999997c-.163-.337-.456-.592-.823-.719-.386-.133-.809-.106-1.168.069L8.65829581 4.73414123l-3.013-1.630999997c-.276-.139-.603-.138-.881.006l-1.093.574c-.136.072-.231.201-.259.351999997-.027.151.016.306.117.421l1.713 1.948-2.257 1.102-1.187-.409c-.223-.078-.464-.063-.684.045l-.842999999.435c-.148.076-.2480000003.221-.2680000003.386-.019.164.045.328.1700000003.437l1.222999999 1.054c.842.798 2.105.992 3.14.487l2.068-.97.768 3.632c.032.151.131.278.27.346.069.033.144.05.219.05.075 0 .151-.017.22-.05l.931-.455c.249-.122.428-.357.48-.628l.90799999-4.739 2.782-1.36c.721-.352 1.022-1.226.67-1.947999997z"],"pto_16":["M14.6505044 5.27838896l-3.469 1.796c-.138.071-.235.202-.262.355L9.83850438 13.499389l-.484.251-.907-4.54200004c-.03-.153-.13-.283-.27-.351-.069-.034-.145-.051-.22-.051-.077 0-.153.017-.223.052l-3.053 1.518c-.802.416-1.744.26-2.412-.411l-.93-.849.298-.173 1.597.584c.131.047.277.038.402-.026l10.45600002-5.413c.15-.077.329-.088999997.493-.033.158.054.281.164.349.311.153.335.024.753-.284.912zm-9.45500002-.871l.733-.412999997 2.928 1.678999997-1.824.944-1.837-2.21zm10.64700002-.458999997c-.183-.397-.513-.695-.932-.839-.422-.1439999998-.886-.1119999998-1.278.091L9.91250438 5.12638896l-3.499-2.005999997c-.303-.1619999998-.662-.1609999998-.969.006l-1.26.703c-.13.072-.221.198999997-.248.344999997-.027.146.012.296.107.411l2.08 2.503-2.752 1.424-1.39-.508c-.243-.089-.512-.071-.749.052l-.972.531c-.142.078-.237.219-.257.379-.019.16.04.32.159.429l1.415 1.292c.95.956 2.383 1.188 3.557.58l2.46-1.223.909 4.55300004c.031.154.132.285.273.353.069.033.143.049.217.049.079 0 .158-.018.23-.056l1.07400002-.556c.263-.135.451-.393.503-.688l1.059-5.85000004 3.251-1.683c.78-.404 1.109-1.399.732-2.217999997z"],"pto_18":["M16.9579333 6.03299544c-.0649974.19277937-.199992.34883887-.3799848.43859858L12.6461052 8.4279477c-.1419943.06935977-.2419903.20399934-.2719891.36107883l-1.2489502 6.63711857-.6429744.319259-1.04195844-5.01736383c-.03199872-.15299951-.12999481-.28253909-.26698935-.35087887-.06899725-.03569988-.14599418-.05405982-.22199115-.05405982-.07299709 0-.14499422.01631994-.21199155.04793984l-3.4588621 1.65239466c-.92896296.46205851-2.06091783.28763907-2.83188709-.45593853l-1.05995774-.93125699.43298274-.22745926 1.80892788.63545794c.12599497.04487986.26398947.03671989.38198477-.02345992L15.862977 5.12417837c.1869925-.0907797.4109836-.10913964.6179754-.04385985.2019919.06323979.3589856.19379937.4419823.36821881l0 .00101999c.0879965.18257941.099996.39065874.0349986.58343812zM5.75637994 5.50259715l.93896256-.47837845 3.3638659 1.85333401-2.17791318 1.0842565-2.12491528-2.45921206zm12.06551896-.50081838c-.2059918-.431458606-.577977-.749697577-1.0479582-.896577103-.4449823-.140759545-.9379626-.103019667-1.3489462.103019667L11.1641643 6.32777449 7.159324 4.120501618c-.31698736-.1621794763-.69397233-.1611594796-1.01195965.00611998l-1.42794307.764997528c-.13599458.072419766-.23099079.205019334-.25898967.358018844-.02799889.1550395.0149994.31313899.11699533.43043861l2.37190543 2.74481113-3.18887286 1.58609487-1.61493561-.56609817c-.25398987-.08873971-.52497907-.07241976-.77196922.05201983l-1.101956066.57833814c-.147994099.07751975-.2489900727.22541927-.2679893152.39371872-.0199992027.16829946.0439982458.33557892.1699932222.44573856l1.604936009 1.40963545c1.05395798 1.01693671 2.63789483 1.26479591 3.9328432.619138l2.88088514-1.37597556 1.04495834 5.02756375c.03199872.1540195.13099478.2845791.26998923.3529189C9.97621169 16.9826601 10.0512087 17 10.1262057 17c.074997 0 .149994-.0173399.2189913-.0520198l1.2189514-.6058781c.2809888-.1397395.4839807-.4110586.5429783-.7241976l1.2019521-6.3851794 3.7068522-1.84517404c.4199833-.20807933.7349707-.57017816.8879646-1.0220367.151994-.45083854.1229951-.93533697-.0819967-1.36373559z"],"pto_20":["M17.5287442 6.68188787l-4.164 2.123c-.139.07-.236.201-.265.355l-1.345 7.23700003-.704.359-1.113-5.49200003c-.031-.152-.13-.281-.269-.35-.07-.034-.146-.051-.221-.051-.075 0-.15.017-.22.05l-3.662 1.793c-.989.506-2.193.311-3.015-.5l-1.187-1.069.538-.288 1.916.69c.13.047.273.038.397-.025l12.546-6.397c.207-.105.458-.121000002.68-.043.213.073.381.22.472.416.207.443.035.978-.384 1.192zm-11.539-1.132l.974-.535c.036-.020000002.078-.020000002.102-.006l3.656 2.065-2.411 1.229-2.321-2.753zm12.829-.484c-.207-.443000002-.581-.776000002-1.053-.938000002-.481-.165-1.012-.13-1.459.098l-4.514 2.302000002-4.247-2.397000002c-.331-.176-.727-.175-1.06.006l-1.513.83c-.132.072000002-.223.200000002-.251.347000002-.027.147.013.3.11.414l2.565 3.041-3.444 1.756-1.714-.617c-.262-.093-.555-.075-.809.056l-1.167000001.628c-.143.077-.24.219-.259.381-.02.161.041.322.162.431l1.700000001 1.529c1.108 1.09800003 2.778 1.36600003 4.147.667l3.074-1.504 1.115 5.50300003c.031.154.132.284.272.352.07.033.144.049.218.049.078 0 .156-.018.228-.054l1.288-.657c.288-.146.495-.426.554-.749l1.278-6.95700003 3.944-2.01c.893-.456 1.268-1.58.835-2.507z"],"pto_24":["M22.3185 7.4915l-5.32 2.775c-.137.072-.233.204-.261.356l-1.69 9.415c-.012.071-.052.13-.106.158l-1.057.552-1.46-7.371c-.03-.154-.13-.284-.271-.353-.069-.034-.144-.051-.219-.051-.077 0-.154.018-.224.053l-4.677 2.343c-1.315.686-2.916.424-4-.674l-1.684-1.551.872-.48c.036-.019.075-.023.113-.008l2.449.901c.133.051.279.039.404-.025l16.034-8.364c.291-.154.64-.179.96-.069.312.108.557.33.692.624.3.66.051 1.453-.555 1.769zm-15.029-1.665l1.407-.791c.086-.048.184-.048.258-.009l4.922 2.844-3.428 1.788-3.159-3.832zm16.494-.518c-.25-.547-.703-.958-1.278-1.155-.575-.196-1.213-.151-1.747.127l-5.833 3.043-5.484-3.17c-.386-.207-.844-.205-1.23.008l-1.933 1.086c-.129.072-.219.198-.247.344-.026.145.012.296.106.41l3.405 4.131-4.621 2.41-2.241-.824c-.3-.112-.635-.09-.931.063l-1.491.82c-.14.078-.235.219-.255.378-.019.16.04.32.158.429l2.178 2.006c1.377 1.394 3.45 1.733 5.149.845l4.083-2.045 1.462 7.381c.031.156.132.287.274.355.069.032.143.049.217.049.079 0 .159-.019.231-.057l1.648-.86c.327-.17.562-.495.629-.869l1.646-9.173 5.103-2.662c1.07-.559 1.519-1.936 1.002-3.07z"],"pto_26":["M24.9273 7.7261c-.112.329-.347.594-.652.742l-5.916 2.766c-.146.068-.249.201-.28.358l-1.801 9.381c-.013.067-.058.126-.12.156l-1.181.576-1.562-7.37c-.032-.151-.132-.279-.27-.346-.07-.034-.145-.05-.219-.05-.076 0-.151.017-.222.052l-5.214 2.573c-1.426.691-3.158.43-4.326-.677l-1.777-1.53.918-.473c.053-.025.116-.029.17-.011l2.609.899c.125.044.264.036.383-.024l17.576-8.576c.319-.156.701-.183 1.052-.076.351.108.624.333.771.635l0 .001c.153.312.174.665.061.994zm-17.151-.864l1.673-.821c.107-.055.236-.054.332-.007l5.347 2.888-3.726 1.818-3.626-3.878zm17.989-.569c-.27-.553-.759-.963-1.377-1.153-.59-.18-1.239-.133-1.784.134l-6.372 3.109-5.989-3.235c-.394-.198-.862-.196-1.243 0l-2.27 1.113c-.143.07-.243.203-.273.36-.028.155.019.315.127.431l3.877 4.147-5.247 2.56-2.413-.831c-.307-.107-.638-.086-.942.062l-1.588.817c-.149.076-.248.221-.268.386-.019.165.044.329.17.437l2.321 1.999c1.453 1.375 3.634 1.71 5.436.832l4.641-2.289 1.56 7.367c.032.15.132.278.27.345.069.034.144.051.219.051.076 0 .151-.017.219-.051l1.758-.856c.344-.168.592-.493.663-.867l1.754-9.129 5.691-2.661c.553-.269.968-.738 1.168-1.32.2-.581.161-1.205-.108-1.758z"],"pto_28":["M26.1623739 8.89101364l-6.245 3.102c-.14.07-.24.201-.269.355l-1.984 10.52199996c-.018.097-.079.179-.163.22l-1.355.674-1.734-8.337c-.032-.15-.13-.278-.268-.346-.069-.034-.146-.052-.222-.052-.073 0-.147.016-.215.049l-5.488 2.618c-1.587.787-3.514.486-4.813-.767l-2.028-1.779 1.094-.57299996c.07-.034.147-.04.219-.014l2.874 1.00799996c.128.045.268.035.389-.024l18.821-9.34899996c.377-.188.827-.214000004 1.235-.074.378.13.675.389.838.727.362.757.055 1.672-.686 2.04zm-17.804-1.923l1.714-.916c.131-.069000004.286-.069000004.405-.008l5.865 3.226-4.19 2.081-3.794-4.383zm19.392-.549l-.001 0c-.278-.582000004-.781-1.023000004-1.414-1.240000004-.66-.2279999996-1.39-.1819999996-2.005.123l-6.898 3.427000004-6.484-3.567000004c-.42-.2179999996-.921-.2159999996-1.345.006l-2.268 1.214000004c-.134.071-.228.2-.256.35-.028.149.014.303.114.418l4.034 4.66-5.53 2.748-2.675-.938c-.324-.115-.687-.091-1.004.066l-1.750000004.916c-.146.077-.2450000002.22-.2650000002.384-.019.16399996.043.32599996.1670000002.43499996l2.559000004 2.244c1.586 1.529 3.971 1.902 5.928.93l4.905-2.34 1.737 8.346c.032.152.132.28.272.348.069.034.143.05.218.05.076 0 .152-.017.223-.052l1.934-.961c.363-.18.625-.527.701-.929l1.938-10.27899996 6.022-2.991c1.227-.61 1.74-2.12 1.143-3.368z"],"pto_32":["M30.897405 8.5267113c-.1403941.51033284-.4758946.93561021-.92082 1.16787708l-7.1621623 3.73807902c-.1455556.07524138-.2477542.21918142-.2787235.38711145l-2.168882 12.09096275c-.0908432.5026996-.400536.9367006-.8299767 1.1613343l-1.1159264.5833933-2.0037124-10.1237822c-.0330339-.1635683-.1342003-.302056-.2756266-.3762069-.0722617-.038166-.1507172-.0567037-.230205-.0567037-.0753586 0-.1507172.0174473-.2198819.0523418L9.39543342 20.305804c-1.83854296.9596002-4.07762196.5942978-5.5837613-.9323389l-2.38669923-2.1983569 1.32548521-.7306047c.09290784-.04798.20336494-.0534322.29730509-.0185377l3.29822839 1.2147666c.13110329.0468896.27459429.038166.39950372-.0261709L28.3217931 6.35234445c.8650753-.451448288 1.9108047-.17229186 2.3784408.63573514.270465.46889556.3406621 1.01521341.1971711 1.53863171zM9.56679677 7.18218054l1.49788083-.88108747c.4666039-.27588506 1.0261155-.28024688 1.4875578-.01526637l6.273344 3.80786813-4.951988 2.58437786-4.30679463-5.49589215zm22.01399703-.7622279c-.7432628-1.286736651-2.3774085-1.743637209-3.7163137-1.044655688L19.9394412 9.51139197l-6.8834388-4.1775323c-.7824905-.450357828-1.7167305-.444905554-2.4950917.015266367L8.5220997 6.54753585c-.13420021.07851275-.22814036.21700051-.25601272.37620691-.02787235.1592064.01238772.32386507.1104571.44817691l4.54629042 5.80230995-6.44057808 3.36187208-3.09279883-1.1406157c-.35717904-.1297641-.75461814-.1046836-1.10560332.0774223L.277044883 16.577539c-.151749475.0828746-.2529157917.2399001-.2735619788.4187347-.0196138778.1788345.0443893023.3565787.1723956618.4754382l2.937952424 2.7065088c1.80137983 1.8243309 4.50809496 2.2692365 6.730657 1.1089926l5.69628301-2.8537202 2.0057771 10.1335963c.0330339.1646587.1362648.3042369.2797558.3783879.0712294.0370754.1476203.0545227.2260758.0545227.0784555 0 .1558787-.0185377.2281403-.0556132l1.7136336-.8941729c.7184873-.3762069 1.2367066-1.0991785 1.3863914-1.9366477l2.1224281-11.82380133 6.9319573-3.618129c.7030027-.36748326 1.2336097-1.03811296 1.4534916-1.84177814.2219465-.80911745.1094247-1.68802402-.3076282-2.40990509z"],"pto_48":["M45.3834 16.5141l-11.122 5.224c-.145.067-.248.201-.278.358l-3.386 17.723c-.051.265-.225.495-.466.612l-2.726 1.337-3.052-14.481c-.032-.151-.132-.279-.272-.346-.068-.033-.143-.05-.218-.05-.076 0-.152.018-.221.052l-9.81 4.861c-2.843 1.397-6.294.862-8.608-1.34l-3.839-3.322 2.32-1.2c.203-.101.441-.115.654-.04l4.905 1.697c.125.044.265.034.383-.023l33.043-16.206c.734-.358 1.607-.408 2.397-.136.729.251 1.304.747 1.619 1.397.699 1.44.103 3.183-1.323 3.883m-24.502 4.412l-7.431-7.986 3.676-1.813c.326-.17.714-.172 1.03-.009l10.811 5.869-8.074 3.959c-.005-.006-.006-.014-.012-.02m26.726-8.732c-.433-.891-1.212-1.568-2.195-1.906-1.04-.359-2.193-.293-3.162.184l-12.222 5.994c-.039-.046-.084-.087-.14-.117l-11.267-6.116c-.612-.313-1.343-.31-1.946.003l-4.27 2.104c-.142.07-.242.202-.271.358-.028.156.019.315.126.431l7.699 8.275-10.565 5.181-4.709-1.629c-.462-.158-.981-.129-1.429.092l-2.986 1.544c-.148.076-.247.221-.267.386-.019.164.043.328.169.436l4.38 3.79c2.597 2.473 6.506 3.074 9.722 1.497l9.233-4.576 3.053 14.478c.032.15.132.278.27.346.069.034.144.05.219.05.075 0 .15-.016.22-.05l3.301-1.62c.522-.254.899-.749 1.009-1.322l3.338-17.473 10.9-5.119c1.924-.945 2.728-3.287 1.79-5.221"],"pto_56":["M54.8049831 16.6975c-.3079932.895-.945979 1.616-1.7969601 2.031l-12.7217175 6.204c-.1409969.069-.2419946.201-.271994.355l-4.0409103 21.048c-.0659985.343-.2929934.641-.6069865.795l-3.3669252 1.641-3.6689186-17.315c-.0309993-.15-.1289971-.277-.265994-.344-.0699985-.035-.1469968-.053-.2229951-.053-.0719984 0-.1449968.016-.2119953.047l-11.1727519 5.233c-3.4289239 1.671-7.5938314 1.034-10.38176949-1.606l-4.68589596-4.036 2.89493572-1.489c.26399414-.129.57498724-.147.85398104-.052l5.85486999 2.016c.1249972.044.2629942.036.3819915-.024l38.3401487-18.7c.854981-.417 1.8819582-.491 2.8159375-.206.9529788.293 1.7009622.913 2.1079532 1.747.4149908.852.4739895 1.812.1659963 2.708zm-39.1061317-2.406l4.05491-2.13c.4179907-.216.9159796-.217 1.3229706-.011l12.7957159 6.912-9.7667831 4.764-8.4068134-9.535zm39.8391154-.74c-.5289882-1.086-1.4929668-1.89-2.7139397-2.265-1.172974-.36-2.4669452-.265-3.5479212.264l-14.2986825 6.973-13.4367017-7.258c-.7029844-.357-1.5429657-.354-2.2489501.009l-4.6208974 2.428c-.1359969.071-.2319948.201-.2599942.351-.0269994.152.0159997.307.1169974.422l8.6458081 9.806-12.0517325 5.878-5.6588743-1.948c-.52798828-.182-1.1169752-.146-1.62696388.103l-3.564920844 1.833c-.147996714.076-.2479944932.221-.2679940491.386-.0189995782.165.0449990008.329.1709962031.437l5.23088385 4.505c3.07093182 2.909 7.68982922 3.617 11.48374502 1.766l10.5947648-4.962 3.6709184 17.326c.0319993.151.1309971.279.269994.346.0689985.034.1439969.051.2189952.051.0749983 0 .1499967-.017.2189951-.051l3.9429125-1.923c.5949868-.291 1.0249772-.853 1.1499744-1.504l3.9949113-20.803 12.4957226-6.094c1.0909758-.532 1.9089576-1.457 2.3039488-2.605.3949913-1.147.3199929-2.381-.2119953-3.471z"],"pto_8":["M6.80473107 2.61938311c-.13409923.073-.2271681.204-.25218661.354l-.61845766 3.622-.46934732-2.492c-.02902148-.156-.13109701-.289-.27420291-.358-.0690511-.033-.1431059-.05-.2171607-.05-.08005924 0-.16011849.02-.23317255.058l-1.83435742.967c-.39529252.215-.85863539.132-1.19888718-.229l-.21615996-.209.57142286.221c.13710145.053.29221624.043.42231251-.029l6.16456177-3.377c.11408443-.063.25819106-.017.31323179.102l.00100075.001c.05003702.108.00800592.236-.0960711.293l-2.06252627 1.126zm-3.04625422-1.584l1.38202269.84-.6664932.367-.87264576-1.115.15711627-.092zm6.13153733-.315c-.13109701-.304-.38428437-.539-.6935132-.6440000001-.3062266-.105-.64047395-.076-.9206813.0790000001l-2.12357144 1.165-1.99747814-1.214c-.24818365-.1430000001-.54440286-.1420000001-.79759021.004l-.75555912.447c-.12409183.073-.21015551.196-.23717551.338-.02601925.141.00900667.287.09807258.4l1.12283089 1.434-1.37902047.757-.73854653-.286c-.20515181-.08-.43332066-.066-.634469507.046l-.583431739.338c-.136100715.079-.2271681045.216-.2461821749.372-.0190140704.155.0360266598.31.1481096009.42l.841622801.816c.637471729.677 1.599183399.841 2.386766209.408l1.22690791-.647.49636731 2.639c.03002222.157.13309849.291.27820587.36.06805036.031.14110442.047.21415848.047.08306147 0 .16612293-.02.24017773-.061l.64747914-.356c.20915477-.116.35226067-.321.39329103-.564l.62145988-3.639 1.86938335-1.026c.55641174-.306.78658208-1.023.52238656-1.633z"],"q-a_16":["M13.283 1.0002c.948 0 1.717.772 1.717 1.717l0 10.566c0 .948-.772 1.717-1.717 1.717l-10.566 0c-.948 0-1.717-.773-1.717-1.717l0-10.566c0-.949.772-1.717 1.717-1.717l10.566 0zM14 13.2832l0-10.566c0-.394-.323-.717-.717-.717l-10.566 0c-.394 0-.717.323-.717.717l0 10.566c0 .394.323.717.717.717l10.566 0c.394 0 .717-.323.717-.717zM8.5137 3.5513c.947.19 1.722.951 1.926 1.894.171.785-.027 1.581-.542 2.182l-.965.979c-.279.282-.433.657-.433 1.054l0 .339c0 .277-.223.5-.5.5-.276 0-.5-.223-.5-.5l0-.339c0-.662.256-1.286.721-1.756l.941-.954c.288-.335.405-.816.301-1.293-.12-.552-.591-1.014-1.146-1.126-.465-.091-.91.016-1.266.307-.349.286-.551.71-.551 1.161 0 .277-.223.5-.5.5-.276 0-.5-.223-.5-.5 0-.752.335-1.458.917-1.935.582-.477 1.345-.663 2.097-.513zm-.8741 8.0981c.18-.19.521-.19.71 0 .09.09.14.22.14.35 0 .06-.01.13-.03.19-.03.06-.07.12-.11.16-.1.1-.23.15-.36.15-.13 0-.26-.05-.35-.15-.05-.04-.08-.1-.11-.16-.02-.06-.04-.12-.04-.19 0-.13.06-.26.15-.35z"],"q-a_20":["M16.5 1C17.875 1 19 2.125 19 3.5l0 13c0 1.381-1.119 2.5-2.5 2.5l-13 0C2.125 19 1 17.875 1 16.5l0-13C1 2.119 2.119 1 3.5 1l13 0zM18 16.5l0-13c0-.827-.673-1.5-1.5-1.5l-13 0C2.673 2 2 2.673 2 3.5l0 13c0 .827.673 1.5 1.5 1.5l13 0c.827 0 1.5-.673 1.5-1.5zm-8.3604-1.8496c.18-.19.52-.19.71 0 .09.09.14.22.14.35 0 .13-.05.26-.14.35-.05.05-.11.09-.17.11-.061.03-.12.04-.19.04-.13 0-.26-.05-.35-.15-.09-.09-.15-.22-.15-.35 0-.07.02-.13.04-.19.03-.06.06-.12.11-.16zm.4502-10.1489c1.88.053 3.41 1.592 3.41 3.432 0 1.542-.906 2.276-1.567 2.812-.12.098-.238.193-.347.291l-.511.456c-.365.326-.575.781-.575 1.249l0 .256c0 .276-.223.5-.5.5-.277 0-.5-.224-.5-.5l0-.256c0-.752.331-1.479.909-1.995l.51-.455c.121-.108.251-.214.384-.322.616-.5 1.197-.971 1.197-2.036 0-1.282-1.117-2.395-2.438-2.432-.684-.036-1.325.229-1.808.7-.487.473-.754 1.113-.754 1.8 0 .276-.223.5-.5.5-.277 0-.5-.224-.5-.5 0-.96.375-1.854 1.056-2.517.68-.66 1.581-1.013 2.534-.983z"],"q-a_24":["M20.5 1C21.881 1 23 2.119 23 3.5l0 17c0 1.381-1.119 2.5-2.5 2.5l-17 0C2.119 23 1 21.881 1 20.5l0-17C1 2.119 2.119 1 3.5 1l17 0zM22 20.5l0-17c0-.827-.673-1.5-1.5-1.5l-17 0C2.673 2 2 2.673 2 3.5l0 17c0 .827.673 1.5 1.5 1.5l17 0c.827 0 1.5-.673 1.5-1.5zm-10.3501-3.3496c.19-.19.52-.19.71 0 .09.09.15.22.15.35 0 .129-.06.259-.15.349-.09.101-.22.151-.35.151-.07 0-.13-.01-.19-.04-.06-.021-.12-.06-.17-.111-.09-.09-.14-.22-.14-.349 0-.13.05-.26.14-.35zm.4722-12.1494c2.136.062 3.941 1.925 3.941 4.07 0 1.824-1.005 2.661-1.812 3.338-.144.118-.284.238-.415.357l-.602.554c-.449.412-.706.998-.706 1.609 0 .277-.224.5-.5.5-.277 0-.5-.223-.5-.5 0-.888.375-1.741 1.029-2.345l.602-.554c.142-.132.294-.258.45-.387.748-.625 1.454-1.218 1.454-2.572 0-1.617-1.36-3.024-2.969-3.07-.816-.026-1.58.276-2.164.845-.618.599-.958 1.422-.958 2.308 0 .278-.224.5-.5.5-.276 0-.5-.222-.5-.5 0-1.16.448-2.236 1.261-3.026.78-.757 1.813-1.155 2.889-1.127z"],"q-a_36":["M31.5.9998c1.933 0 3.5 1.567 3.5 3.5l0 27c0 1.934-1.567 3.5-3.5 3.5l-27 0c-1.925 0-3.5-1.575-3.5-3.5l0-27c0-1.933 1.567-3.5 3.5-3.5l27 0zm2.5 30.5l0-27c0-1.378-1.122-2.5-2.5-2.5l-27 0c-1.378 0-2.5 1.122-2.5 2.5l0 27c0 1.379 1.122 2.5 2.5 2.5l27 0c1.378 0 2.5-1.121 2.5-2.5zm-16-4.501c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0-18.999c3.309 0 6 2.691 6 6 0 3.011-1.708 4.621-2.955 5.796l-1.347 1.3c-.761.739-1.198 1.791-1.198 2.886 0 .277-.224.5-.5.5-.276 0-.5-.223-.5-.5 0-1.364.547-2.677 1.501-3.603l1.358-1.312c1.239-1.166 2.641-2.487 2.641-5.067 0-2.757-2.243-5-5-5-2.757 0-5 2.243-5 5l0 .499c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-.499c0-3.309 2.691-6 6-6z"],"quality_16":["M12 0c1.105 0 2 .895 2 2l0 12c0 1.105-.895 2-2 2l-8 0c-1.105 0-2-.895-2-2L2 2c0-1.105.895-2 2-2l8 0zm1 14l0-12c0-.552-.448-1-1-1L4 1c-.552 0-1 .448-1 1l0 12c0 .552.448 1 1 1l8 0c.552 0 1-.448 1-1zm-2.8535-7.8535c.195-.195.512-.195.707 0 .195.195.195.512 0 .707l-3.333 3.333c-.098.098-.226.147-.353.147-.128 0-.256-.049-.354-.147l-1.667-1.666c-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0l1.314 1.312 2.979-2.979z"],"quality_24":["M18.361.0003c1.455 0 2.639 1.183 2.639 2.638l0 18.723c0 1.455-1.184 2.639-2.639 2.639l-12.722 0c-1.455 0-2.639-1.184-2.639-2.639l0-18.723C3 1.1833 4.184.0003 5.639.0003l12.722 0zM20 21.3613l0-18.723c0-.903-.735-1.638-1.639-1.638l-12.722 0c-.904 0-1.639.735-1.639 1.638l0 18.723c0 .903.735 1.639 1.639 1.639l12.722 0c.904 0 1.639-.736 1.639-1.639zM16.1465 9.1465c.195-.195.512-.195.707 0 .195.195.195.512 0 .707l-5.5 5.5c-.098.098-.226.147-.353.147-.128 0-.256-.049-.354-.147l-2.49-2.489c-.195-.196-.195-.512 0-.707.196-.196.512-.196.707 0l2.137 2.135 5.146-5.146z"],"quiet_16":["M14.334452 11.758c.4810343.526.7200513 1.249.6550467 1.983-.112008 1.267-1.177084 2.259-2.4261731 2.259l-.3840274 0L8 15.504 3.4366744 16c-1.24908912 0-2.314165116-.992-2.4261731077-2.259-.0650046382-.734.1740124157-1.457.6550467377-1.983.31702262-.347.71205081-.583 1.1450817-.691l-.03800271-.364c-.06000428-.587-.02400171-1.176.10600757-1.749l.36002568-1.582c.29602113-1.3 1.33009491-2.225 2.56318289-2.346-.49303518-.535-.80205723-1.243-.80205723-2.026 0-1.654 1.34609605-3 3.00021407-3 1.65411802 0 3.0002141 1.346 3.0002141 3 0 .783-.30902208 1.491-.80205726 2.026 1.23308796.121 2.26716176 1.046 2.56318286 2.346l.3600257 1.582c.1300093.573.1660119 1.162.1060076 1.749l-.0380027.364c.4330309.108.828059.344 1.1450817.691zM8 1c-1.10307871 0-2.00014271.897-2.00014271 2 0 1.103.897064 2 2.00014271 2 1.10307871 0 2.00014271-.897 2.00014271-2 0-1.103-.897064-2-2.00014271-2zm4.5633256 14c.7350524 0 1.3630973-.592 1.430102-1.348.041003-.455-.1040074-.899-.3960282-1.218-.2560183-.28-.5950425-.434-.9540681-.434-.1420101 0-.2760197-.06-.3720265-.165-.0940067-.105-.14001-.245-.125009-.386l.0860062-.847c.0490035-.479.0200014-.959-.0860062-1.427l-.3600256-1.581c-.2130152-.936-.97506962-1.591-1.85513241-1.593L7.99899993 6l-1.93113779.001c-.87906272.002-1.6411171.657-1.85413229 1.593l-.35902562 1.581c-.10700764.468-.13600971.948-.08700621 1.427l.08700621.847c.014001.141-.03200228.281-.12600899.386-.09600685.105-.23001641.165-.37202655.165-.35902561 0-.6980498.154-.95406807.434-.29202084.319-.437031183.763-.39602826 1.218.06700478.756.6950496 1.348 1.43010204 1.348l.3840274 0 4.11929392-.497C7.95999715 14.501 7.97999857 14.5 8 14.5c.02000143 0 .04000285.001.06000428.003l4.17829812.5.3250232-.003zm-2.16125421-3.9902c.27101934-.054.53503818.122.58804196.392.05500395.271-.12100864.534-.39202797.588l-1.96314008.393c-.21101505.042-.42203011.064-.63404524.064-.21301519 0-.42503032-.022-.63604538-.064l-1.95713964-.393c-.27101934-.054-.44603183-.317-.39202797-.588.05400385-.271.31702262-.446.58804195-.392l1.95813972.393c.29102076.057.58604181.058.87806265 0l1.96214-.393z"],"quiet_20":["M18.2498399 15.161c-.43-.473-1.003-.79-1.625-.909l.057-.514c.077-.698.031-1.398-.138-2.081l-.47-1.897c-.395-1.595-1.815-2.713-3.467-2.751.846-.734 1.393-1.804 1.393-3.009 0-2.206-1.794-4-3.99999999-4-2.205 0-4 1.794-4 4 0 1.205.547 2.274 1.393 3.009-1.652.038-3.072 1.155-3.467 2.751l-.47 1.897c-.169.683-.215 1.383-.137 2.081l.057.514c-.622.119-1.196.436-1.625000005.909-.555.611-.8159999999 1.4-.7369999999 2.223C1.154839905 18.851 2.48183991 20 4.03283991 20l.558-.003 5.409-.594L15.4648399 20l.502 0c1.552 0 2.878-1.149 3.02-2.616.079-.823-.183-1.612-.737-2.223m-2.283 3.839l-.448.003-5.46399999-.6c-.019-.002-.037-.003-.055-.003-.018 0-.036.001-.054.003l-5.41.597-.503 0c-1.042 0-1.931-.752-2.024-1.712-.052000005-.539.119-1.055.482-1.455.366-.402.89-.633 1.438-.633.142 0 .277-.06.372-.167.095-.106.141-.247.125-.388l-.113-1.017c-.065-.581-.027-1.163.114-1.731l.47-1.897c.291-1.175 1.351-1.997 2.577-1.998l2.525-.002 2.52699999.002c1.226.001 2.286.823 2.577 1.998l.47 1.897c.141.568.18 1.15.115 1.731l-.114 1.017c-.015.141.03.282.125.388.095.107.23.167.372.167.548 0 1.073.231 1.438.633.363.4.534.916.482 1.455-.092.96-.982 1.712-2.024 1.712m-2.549-4.993l-2.313.385c-.72599999.143-1.46899999.146-2.22599999-.003l-2.297-.382c-.271-.046-.53.139-.575.411-.046.273.139.53.411.575l2.283.38c.426.084.864.127 1.299.127.435 0 .873-.043 1.28499999-.124l2.297-.383c.273-.045.457-.302.411-.575-.045-.272-.304-.457-.575-.411M6.99983991 4c0-1.654 1.346-3 3-3 1.65499999 0 2.99999999 1.346 2.99999999 3 0 1.654-1.345 3-2.99999999 3-1.654 0-3-1.346-3-3"],"quiet_32":["M28.8136698 24.414c.86.942 1.285 2.228 1.166 3.524-.21 2.278-2.188 4.062-4.503 4.062l-.798 0-8.679-.997-8.62199999.994-.855.003c-2.316 0-4.293000002-1.784-4.5030000024-4.062-.119-1.296.3060000004-2.582 1.1650000024-3.524.693-.759 1.626-1.245 2.62-1.377l-.125-1.18c-.119-1.122-.048-2.247.211-3.343l.747-3.163c.604-2.557 2.803-4.345 5.349-4.348l.70499999-.001C11.06966981 9.927 9.99766981 8.087 9.99766981 6c0-3.309 2.69099999-6 5.99999999-6 3.308 0 6 2.691 6 6 0 2.087-1.073 3.927-2.695 5.002l.71.001c2.546.003 4.745 1.791 5.349 4.348l.747 3.163c.259 1.096.33 2.221.211 3.343l-.125 1.18c.994.132 1.927.618 2.619 1.377zm-3.337 6.586c1.804 0 3.344-1.385 3.507-3.153.094-1.018-.237-2.024-.908-2.758-.641-.702-1.504-1.089-2.433-1.089-.142 0-.277-.061-.372-.166-.094-.105-.14-.246-.125-.387l.18-1.695c.107-1.01.043-2.022-.19-3.008l-.747-3.163c-.497-2.104-2.297-3.575-4.377-3.578l-4.014-.003-4.00999999.003c-2.08.003-3.88 1.474-4.377 3.578l-.747 3.163c-.233.986-.297 1.998-.19 3.008l.18 1.695c.015.141-.031.282-.126.387-.094.105-.23.166-.371.166-.929 0-1.793.387-2.433 1.089-.671.734-1.002000002 1.74-.908 2.758.163 1.768 1.703 3.153 3.507 3.153l.798 0 8.62199999-.997c.019-.002.038-.003.057-.003.019 0 .038.001.057.003l8.679 1 .741-.003zM10.99766981 6c0 2.757 2.24299999 5 4.99999999 5 2.756 0 5-2.243 5-5 0-2.757-2.244-5-5-5-2.757 0-4.99999999 2.243-4.99999999 5zM21.3897698 23.0127c.267-.061.537.107.598.377.06.269-.109.537-.378.598l-3.591.809c-.669.136-1.345.203-2.019.203-.675 0-1.351-.067-2.009-.2l-3.60099999-.812c-.27-.061-.438-.329-.378-.598.061-.27.328-.439.598-.377l3.58999999.81c1.164.235 2.424.238 3.61-.003l3.58-.807z"],"quiet_8":["M6.9899 5.08178c.591.205 1.01.762 1.01 1.416 0 .828-.671 1.501-1.494 1.501l-5.012 0c-.824 0-1.494-.673-1.494-1.499 0-.657.423-1.217 1.009-1.42 0 0 .033.018.096-.252l.1-.432c.145-.621.583-1.101 1.127-1.297-.209-.316-.331-.693-.331-1.099 0-1.103.894-2 1.993-2 1.099 0 1.993.897 1.993 2 0 .406-.122.783-.33 1.099.554.195.992.673 1.138 1.297l.101.432c.064.273.094.254.094.254zm-.484 1.917c.274 0 .498-.224.498-.499 0-.276-.224-.501-.498-.501-.275 0-.512-.224-.512-.5 0 0-.023-.246-.069-.443l-.101-.432c-.088-.377-.411-.599-.752-.625l0 .001c-.001 0-1.97.005-2.186 0l-.016 0c-.319 0-.609.26-.694.623l-.102.434c-.046.194-.068.442-.068.442 0 .276-.223.5-.499.5-.288 0-.51.224-.51.499 0 .276.222.501.497.501l5.012 0zm-2.512-5.999c-.549 0-.997.448-.997 1 0 .552.448 1 .997 1 .549 0 .997-.448.997-1 0-.552-.448-1-.997-1zm.4993 3.999c.274 0 .498.225.498.5 0 .275-.224.5-.498.5l-.997 0c-.274 0-.499-.225-.499-.5 0-.275.225-.5.499-.5l.997 0z"],"raise-hand_12":["M10 2.9999c.276 0 .5.224.5.5l0 4c0 2.481-2.019 4.5-4.5 4.5-2.481 0-4.5-2.019-4.5-4.5l0-3c0-.276.224-.5.5-.5.565 0 1.081.196 1.5.513l0-3.013c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 5 0 .55c1.14.233 2 1.242 2 2.45 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.827-.673-1.5-1.5-1.5-.276 0-.5-.224-.5-.5l0-1c0-.652-.418-1.208-1-1.415l0 2.415c0 1.93 1.57 3.5 3.5 3.5 1.93 0 3.5-1.57 3.5-3.5l0-4c0-.276.224-.5.5-.5zm-2 4c-.275 0-.5-.225-.5-.5l0-5c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 5c0 .275-.225.5-.5.5zm-2 0c-.275 0-.5-.225-.5-.5l0-6c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 6c0 .275-.225.5-.5.5z"],"raise-hand_16":["M12.9978 10c0 2.757-2.243 5-5 5-2.451 0-4.504-1.838-4.774-4.274l-.208-1.872c-.13-1.167.585-2.282 1.662-2.639l.32-.078 0 4.363c0 .276.224.5.5.5.276 0 .5-.224.5-.5l0-8c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 6c0 .276.224.5.5.5.276 0 .5-.224.5-.5l0-6 0-1c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 1 0 6c0 .276.224.5.5.5.276 0 .5-.224.5-.5l0-6c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 1 0 5c0 .276.224.5.5.5.276 0 .5-.224.5-.5l0-5c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 6.5zm-.5-8c-.197 0-.386.04-.558.11-.173-.637-.751-1.11-1.442-1.11-.197 0-.386.04-.558.11C9.7668.473 9.1888 0 8.4978 0c-.691 0-1.27.473-1.442 1.11-.173-.07-.361-.11-.558-.11-.827 0-1.5.673-1.5 1.5l0 2.608-.597.147c-1.559.515-2.56 2.075-2.38 3.709l.208 1.873C2.5568 13.78 5.0368 16 7.9978 16c3.309 0 6-2.691 6-6l0-6.5c0-.827-.673-1.5-1.5-1.5z"],"raise-hand_20":["M16.9976 12c0 3.859-3.14 7-7 7l-.292 0c-1.892 0-3.683-.825-4.914-2.265-.858-1.005-1.383-2.23-1.517-3.546l-.277-2.696c0-1.257.833-2.343 2-2.703l0 4.71c0 .276.224.5.5.5.276 0 .5-.224.5-.5l0-8.5c0-.552.449-1 1-1 .551 0 1 .448 1 1l0 6.5c0 .276.224.5.5.5.276 0 .5-.224.5-.5l0-6.5 0-2c0-.552.449-1 1-1 .551 0 1 .448 1 1l0 1 0 7.5c0 .276.224.5.5.5.276 0 .5-.224.5-.5l0-7.5c0-.552.449-1 1-1 .551 0 1 .448 1 1l0 2 0 5.5c0 .276.224.5.5.5.276 0 .5-.224.5-.5l0-5.5c0-.552.449-1 1-1 .551 0 1 .448 1 1l0 7zm-1-9c-.366 0-.705.105-1 .278l0-.278c0-1.103-.897-2-2-2-.415 0-.8.127-1.12.344C11.6046.564 10.8696 0 9.9976 0c-1.103 0-2 .897-2 2l0 .278c-.295-.173-.634-.278-1-.278-1.103 0-2 .897-2 2l0 2.77c-1.729.387-3 1.923-2.998 3.774l.28 2.747c.155 1.519.76 2.935 1.753 4.095C5.4526 19.047 7.5206 20 9.7056 20l.292 0c4.411 0 8-3.589 8-8l0-7c0-1.103-.897-2-2-2z"],"raise-hand_24":["M11.9976 22l-.291 0c-1.893 0-3.684-.825-4.914-2.265-.859-1.004-1.384-2.23-1.518-3.546l-.277-2.696c0-1.257.833-2.343 2-2.703l0 4.71c0 .276.224.5.5.5.276 0 .5-.224.5-.5l0-10.548c0-.525.427-.952 1.047-.952.526 0 .953.427.953.952l0 3.096 0 4.499c0 .276.224.5.5.5.276 0 .5-.224.5-.5l0-4.499 0-3.096 0-2c0-.525.427-.952 1.048-.952.525 0 .952.427.952.952l0 2 0 3.096 0 4.499c0 .276.224.5.5.5.276 0 .5-.224.5-.5l0-4.499 0-3.096c0-.525.427-.952 1.048-.952.525 0 .952.427.952.952l0 2 0 5.595c0 .276.224.5.5.5.276 0 .5-.224.5-.5l0-5.595c0-.525.427-.952 1.048-.952.525 0 .952.427.952.952l0 1.048 0 7c0 3.859-3.14 7-7 7m5.952-17c-.348 0-.669.099-.952.259l0-.307c0-1.076-.875-1.952-2.048-1.952-.348 0-.669.099-.952.259l0-.307c0-1.076-.875-1.952-2.048-1.952-1.077 0-1.952.876-1.952 1.952l0 .322c-.304-.17-.657-.274-1.048-.274-1.077 0-1.952.876-1.952 1.952l0 4.818c-1.729.387-3 1.923-2.998 3.774l.28 2.747c.155 1.519.761 2.935 1.753 4.095C7.4536 22.047 9.5206 23 11.7066 23l.291 0c4.411 0 8-3.589 8-8l0-7 0-1.048c0-1.076-.875-1.952-2.048-1.952"],"reactions_12":["M6.0001.0003c3.309 0 6 2.69 6 6 0 3.309-2.691 6-6 6-3.309 0-6-2.691-6-6 0-3.31 2.691-6 6-6zm0 11c2.757 0 5-2.243 5-5 0-2.757-2.243-5-5-5-2.757 0-5 2.243-5 5 0 2.757 2.243 5 5 5zm-2-5c-.552 0-1-.448-1-1 0-.553.448-1 1-1 .552 0 1 .447 1 1 0 .552-.448 1-1 1zm4.0322 1.1563c.191-.198.508-.202.707-.011.197.193.202.51.01.707-.727.749-1.703 1.162-2.749 1.162-1.039 0-2.012-.408-2.739-1.149-.193-.197-.189-.515.008-.707.198-.192.514-.189.707.008 1.076 1.096 2.982 1.096 4.056-.01zm-.0322-3.1563c.552 0 1 .447 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.553.448-1 1-1zm8.5113-1.998c.275 0 .5.225.5.5 0 .274-.225.5-.5.5l-1.501 0 0 1.5c0 .275-.225.5-.5.5-.274 0-.5-.225-.5-.5l0-1.5-1.5 0c-.275 0-.5-.226-.5-.5 0-.275.225-.5.5-.5l1.5 0 0-1.501c0-.275.226-.5.5-.5.275 0 .5.225.5.5l0 1.501 1.501 0z"],"reactions_16":["M8 0c4.411 0 8 3.589 8 8 0 4.411-3.589 8-8 8-4.411 0-8-3.589-8-8 0-4.411 3.589-8 8-8zm0 15c3.86 0 7-3.141 7-7 0-3.859-3.14-7-7-7-3.86 0-7 3.141-7 7 0 3.859 3.14 7 7 7zM5.0044 7.9805c-.263 0-.519-.105-.705-.292-.186-.187-.293-.442-.293-.705 0-.263.107-.519.293-.704.369-.372 1.037-.373 1.41 0 .185.185.291.442.291.704 0 .263-.106.518-.291.705-.187.187-.444.292-.705.292zm5.9936 0c-.263 0-.52-.105-.705-.292-.187-.187-.293-.442-.293-.705 0-.263.106-.519.293-.704.369-.372 1.037-.373 1.409 0 .186.185.292.442.292.704 0 .263-.106.518-.292.705-.186.187-.443.292-.704.292zm.3282 2.2422c.153-.229.464-.292.694-.138.229.156.29.465.137.695-.931 1.39-2.485 2.22-4.157 2.22-1.671 0-3.225-.83-4.156-2.218-.154-.231-.093-.541.136-.695.23-.154.54-.093.694.137.746 1.112 1.989 1.776 3.326 1.776 1.337 0 2.581-.664 3.326-1.777zM20.5 2c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L19 3l0 1.5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5L18 3l-1.5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5L18 2l0-1.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5L19 2l1.5 0z"],"recents_12":["M6 0c3.30872727 0 6 2.69127273 6 6 0 3.30872727-2.69127273 6-6 6-3.30872727 0-6-2.69127273-6-6 0-3.30872727 2.69127273-6 6-6zm0 11c2.75666667 0 5-2.24333333 5-5 0-2.75666667-2.24333333-5-5-5-2.75666667 0-5 2.24333333-5 5 0 2.75666667 2.24333333 5 5 5zm.4990673-4.619l1.26481919 1.265c.19481813.195.19481813.512 0 .707-.09790859.098-.22578921.147-.35366982.147-.12788061 0-.25576123-.049-.35267075-.147L5.73178361 7.027C5.58292259 6.878 5.5 6.678 5.5 6.466L5.5 4c0-.277.22379107-.5.49953365-.5.27574257 0 .49953365.223.49953365.5l0 2.381z"],"recents_14":["M7.0001.0002c3.86 0 7 3.14 7 7 0 3.86-3.14 7-7 7-3.86 0-7-3.14-7-7 0-3.86 3.14-7 7-7zm0 13c3.309 0 6-2.691 6-6 0-3.309-2.691-6-6-6-3.309 0-6 2.691-6 6 0 3.309 2.691 6 6 6zm.5-5.3936l1.353 1.304c.195.195.195.511 0 .707-.098.097-.226.146-.354.146-.128 0-.256-.049-.353-.146l-1.388-1.387c-.164-.165-.258-.392-.258-.624l0-4.111c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 4.111z"],"recents_16":["M8 16c-4.41173333 0-8-3.5882667-8-8 0-4.41173333 3.58826667-8 8-8 4.4117333 0 8 3.58826667 8 8 0 4.4117333-3.5882667 8-8 8zM8 1C4.14030769 1 1 4.14030769 1 8c0 3.8596923 3.14030769 7 7 7 3.8596923 0 7-3.1403077 7-7 0-3.85969231-3.1403077-7-7-7zm1.23 9.8473398L7.76 9.135c-.162-.162-.26-.398-.26-.65L7.5 5c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 3.485 1.468 1.6883398c.186.203.172.52-.032.706-.096.088-.216.131-.337.131-.135 0-.271-.055-.369-.163z"],"recents_18":["M9 17c-4.411 0-8-3.589-8-8 0-4.411 3.589-8 8-8 4.411 0 8 3.589 8 8 0 4.411-3.589 8-8 8M9 0c4.962 0 9 4.038 9 9 0 4.962-4.038 9-9 9-4.962 0-9-4.038-9-9 0-4.962 4.038-9 9-9zm.5 9.793l0-5.293c0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5l0 5.293c0 .263.107.521.293.707l2.353 2.354c.098.097.226.146.354.146.128 0 .256-.049.354-.146.195-.196.195-.512 0-.707L9.5 9.793z"],"recents_20":["M0 10C0 4.486 4.486 0 10 0c5.514 0 10 4.486 10 10 0 5.514-4.486 10-10 10-5.514 0-10-4.486-10-10zm10-9c-4.962 0-9 4.038-9 9 0 4.962 4.038 9 9 9 4.962 0 9-4.038 9-9 0-4.962-4.038-9-9-9zm2.1601414 12.9093148L9.83 11.835c-.217-.215-.33-.488-.33-.767l0-5.46057812c0-.276.224-.5.5-.5.276 0 .5.224.5.5L10.5 11.068l2.3261414 2.0953148c.206.185.224.501.04.706-.099.111-.236.167-.373.167-.119 0-.238-.042-.333-.127z"],"recents_24":["M12 24C5.383 24 0 18.617 0 12 0 5.383 5.383 0 12 0c6.617 0 12 5.383 12 12 0 6.617-5.383 12-12 12zm0-23C5.935 1 1 5.935 1 12c0 6.065 4.935 11 11 11 6.065 0 11-4.935 11-11 0-6.065-4.935-11-11-11zm3 16.5c-.142 0-.283-.061-.382-.178l-2.802-3.319c-.193-.191-.316-.486-.316-.8l0-7.162c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 7.162c0 .046.019.091.052.124l2.83 3.351c.179.211.151.526-.06.704-.093.079-.208.118-.322.118z"],"record_12":["M6 12c-3.3137085 0-6-2.6862915-6-6 0-3.3137085 2.6862915-6 6-6 3.3137085 0 6 2.6862915 6 6 0 3.3137085-2.6862915 6-6 6zm0-1c2.76142375 0 5-2.23857625 5-5 0-2.76142375-2.23857625-5-5-5-2.76142375 0-5 2.23857625-5 5 0 2.76142375 2.23857625 5 5 5zm0-2.5C4.61928813 8.5 3.5 7.38071187 3.5 6c0-1.38071187 1.11928813-2.5 2.5-2.5 1.38071187 0 2.5 1.11928813 2.5 2.5 0 1.38071187-1.11928813 2.5-2.5 2.5zm0-1c.82842712 0 1.5-.67157288 1.5-1.5 0-.82842712-.67157288-1.5-1.5-1.5-.82842712 0-1.5.67157288-1.5 1.5 0 .82842712.67157288 1.5 1.5 1.5z"],"record_14":["M7 13c3.3137085 0 6-2.6862915 6-6 0-3.3137085-2.6862915-6-6-6-3.3137085 0-6 2.6862915-6 6 0 3.3137085 2.6862915 6 6 6zm0 1c-3.86599325 0-7-3.1340068-7-7 0-3.86599325 3.13400675-7 7-7 3.8659932 0 7 3.13400675 7 7 0 3.8659932-3.1340068 7-7 7zm0-5c-1.1045695 0-2-.8954305-2-2 0-1.1045695.8954305-2 2-2 1.1045695 0 2 .8954305 2 2 0 1.1045695-.8954305 2-2 2zm0 1c1.65685425 0 3-1.34314575 3-3 0-1.65685425-1.34314575-3-3-3-1.65685425 0-3 1.34314575-3 3 0 1.65685425 1.34314575 3 3 3z"],"record_16":["M15 7.9965C15 4.12835374 11.864935.993 7.9965.993 4.12806498.993.993 4.12835374.993 7.9965.993 11.8652906 4.12770938 15 7.9965 15 11.8652906 15 15 11.8652906 15 7.9965zm.993 0c0 4.4172094-3.5792906 7.9965-7.9965 7.9965C3.57929062 15.993 0 12.4137094 0 7.9965 0 3.57995546 3.57962575 0 7.9965 0c4.4168742 0 7.9965 3.57995546 7.9965 7.9965zm-5.993 0c0-1.10679062-.89670938-2.0035-2.0035-2.0035-1.10679062 0-2.0035.89670938-2.0035 2.0035C5.993 9.10329062 6.88970938 10 7.9965 10 9.10329062 10 10 9.10329062 10 7.9965zm.993 0c0 1.65520938-1.34129062 2.9965-2.9965 2.9965C6.34129062 10.993 5 9.65170938 5 7.9965 5 6.34129062 6.34129062 5 7.9965 5c1.65520938 0 2.9965 1.34129062 2.9965 2.9965z"],"record_20":["M10 1c-4.962 0-9 4.038-9 9 0 4.962 4.038 9 9 9 4.962 0 9-4.038 9-9 0-4.962-4.038-9-9-9m0 19C4.486 20 0 15.514 0 10 0 4.486 4.486 0 10 0c5.514 0 10 4.486 10 10 0 5.514-4.486 10-10 10zm0-13c1.654 0 3 1.346 3 3 0 1.654-1.346 3-3 3-1.654 0-3-1.346-3-3 0-1.654 1.346-3 3-3zm0 7c2.206 0 4-1.794 4-4 0-2.206-1.794-4-4-4-2.206 0-4 1.794-4 4 0 2.206 1.794 4 4 4z"],"record_24":["M12 0c6.617 0 12 5.383 12 12 0 6.617-5.383 12-12 12-6.617 0-12-5.383-12-12C0 5.383 5.383 0 12 0zm0 23c6.065 0 11-4.935 11-11 0-6.065-4.935-11-11-11C5.935 1 1 5.935 1 12c0 6.065 4.935 11 11 11zm0-16c2.757 0 5 2.243 5 5 0 2.757-2.243 5-5 5-2.757 0-5-2.243-5-5 0-2.757 2.243-5 5-5zm0 9c2.206 0 4-1.794 4-4 0-2.206-1.794-4-4-4-2.206 0-4 1.794-4 4 0 2.206 1.794 4 4 4z"],"record_28":["M14 1C6.832 1 1 6.832 1 14c0 7.168 5.832 13 13 13 7.168 0 13-5.832 13-13 0-7.168-5.832-13-13-13m0 27C6.28 28 0 21.72 0 14 0 6.28 6.28 0 14 0c7.72 0 14 6.28 14 14 0 7.72-6.28 14-14 14zm0-18c2.206 0 4 1.794 4 4 0 2.206-1.794 4-4 4-2.206 0-4-1.794-4-4 0-2.206 1.794-4 4-4zm0 9c2.757 0 5-2.243 5-5 0-2.757-2.243-5-5-5-2.757 0-5 2.243-5 5 0 2.757 2.243 5 5 5z"],"record-active_12":["M6 12c-3.3137085 0-6-2.6862915-6-6 0-3.3137085 2.6862915-6 6-6 3.3137085 0 6 2.6862915 6 6 0 3.3137085-2.6862915 6-6 6zm0-4.5c-.82842712 0-1.5-.67157288-1.5-1.5 0-.82842712.67157288-1.5 1.5-1.5.82842712 0 1.5.67157288 1.5 1.5 0 .82842712-.67157288 1.5-1.5 1.5zm0 1c1.38071187 0 2.5-1.11928813 2.5-2.5 0-1.38071187-1.11928813-2.5-2.5-2.5-1.38071187 0-2.5 1.11928813-2.5 2.5 0 1.38071187 1.11928813 2.5 2.5 2.5z"],"record-active_14":["M7 14c-3.86599325 0-7-3.1340068-7-7 0-3.86599325 3.13400675-7 7-7 3.8659932 0 7 3.13400675 7 7 0 3.8659932-3.1340068 7-7 7zm0-5c-1.1045695 0-2-.8954305-2-2 0-1.1045695.8954305-2 2-2 1.1045695 0 2 .8954305 2 2 0 1.1045695-.8954305 2-2 2zm0 1c1.65685425 0 3-1.34314575 3-3 0-1.65685425-1.34314575-3-3-3-1.65685425 0-3 1.34314575-3 3 0 1.65685425 1.34314575 3 3 3z"],"record-active_16":["M15.993 7.9965c0 4.4172094-3.5792906 7.9965-7.9965 7.9965C3.57929062 15.993 0 12.4137094 0 7.9965 0 3.57995546 3.57962575 0 7.9965 0c4.4168742 0 7.9965 3.57995546 7.9965 7.9965zm-5.993 0C10 9.10329062 9.10329062 10 7.9965 10 6.88970938 10 5.993 9.10329062 5.993 7.9965c0-1.10679062.89670938-2.0035 2.0035-2.0035C9.10329062 5.993 10 6.88970938 10 7.9965zm.993 0C10.993 6.34129062 9.65170938 5 7.9965 5 6.34129062 5 5 6.34129062 5 7.9965c0 1.65520938 1.34129062 2.9965 2.9965 2.9965 1.65520938 0 2.9965-1.34129062 2.9965-2.9965z"],"record-active_20":["M10 20C4.486 20 0 15.514 0 10 0 4.486 4.486 0 10 0c5.514 0 10 4.486 10 10 0 5.514-4.486 10-10 10zm0-13c1.654 0 3 1.346 3 3 0 1.654-1.346 3-3 3-1.654 0-3-1.346-3-3 0-1.654 1.346-3 3-3zm0 7c2.206 0 4-1.794 4-4 0-2.206-1.794-4-4-4-2.206 0-4 1.794-4 4 0 2.206 1.794 4 4 4z"],"record-active_24":["M12 0c6.617 0 12 5.383 12 12 0 6.617-5.383 12-12 12-6.617 0-12-5.383-12-12C0 5.383 5.383 0 12 0zm0 16c-2.206 0-4-1.794-4-4 0-2.206 1.794-4 4-4 2.206 0 4 1.794 4 4 0 2.206-1.794 4-4 4zm0-9c-2.757 0-5 2.243-5 5 0 2.757 2.243 5 5 5 2.757 0 5-2.243 5-5 0-2.757-2.243-5-5-5z"],"record-active-bg_12":["M6 12c-3.3137085 0-6-2.6862915-6-6 0-3.3137085 2.6862915-6 6-6 3.3137085 0 6 2.6862915 6 6 0 3.3137085-2.6862915 6-6 6z"],"record-active-bg_14":["M7 14c-3.86599325 0-7-3.1340068-7-7 0-3.86599325 3.13400675-7 7-7 3.8659932 0 7 3.13400675 7 7 0 3.8659932-3.1340068 7-7 7z"],"record-active-bg_16":["M15.993 7.9965c0 4.4172094-3.5792906 7.9965-7.9965 7.9965C3.57929062 15.993 0 12.4137094 0 7.9965 0 3.57995546 3.57962575 0 7.9965 0c4.4168742 0 7.9965 3.57995546 7.9965 7.9965z"],"record-active-bg_20":["M10 20C4.486 20 0 15.514 0 10 0 4.486 4.486 0 10 0c5.514 0 10 4.486 10 10 0 5.514-4.486 10-10 10"],"record-active-bg_24":["M12 0C5.383 0 0 5.383 0 12c0 6.617 5.383 12 12 12 6.617 0 12-5.383 12-12 0-6.617-5.383-12-12-12"],"record-active-circle_12":["M6 8.5C4.61928813 8.5 3.5 7.38071187 3.5 6c0-1.38071187 1.11928813-2.5 2.5-2.5 1.38071187 0 2.5 1.11928813 2.5 2.5 0 1.38071187-1.11928813 2.5-2.5 2.5zm0-1c.82842712 0 1.5-.67157288 1.5-1.5 0-.82842712-.67157288-1.5-1.5-1.5-.82842712 0-1.5.67157288-1.5 1.5 0 .82842712.67157288 1.5 1.5 1.5z"],"record-active-circle_14":["M7 10c-1.65685425 0-3-1.34314575-3-3 0-1.65685425 1.34314575-3 3-3 1.65685425 0 3 1.34314575 3 3 0 1.65685425-1.34314575 3-3 3zm0-1c1.1045695 0 2-.8954305 2-2 0-1.1045695-.8954305-2-2-2-1.1045695 0-2 .8954305-2 2 0 1.1045695.8954305 2 2 2z"],"record-active-circle_16":["M10.993 7.9965c0 1.65520938-1.34129062 2.9965-2.9965 2.9965C6.34129062 10.993 5 9.65170938 5 7.9965 5 6.34129062 6.34129062 5 7.9965 5c1.65520938 0 2.9965 1.34129062 2.9965 2.9965zm-.993 0c0-1.10679062-.89670938-2.0035-2.0035-2.0035-1.10679062 0-2.0035.89670938-2.0035 2.0035C5.993 9.10329062 6.88970938 10 7.9965 10 9.10329062 10 10 9.10329062 10 7.9965z"],"record-active-circle_20":["M10 14c-2.206 0-4-1.794-4-4 0-2.206 1.794-4 4-4 2.206 0 4 1.794 4 4 0 2.206-1.794 4-4 4zm0-7c-1.654 0-3 1.346-3 3 0 1.654 1.346 3 3 3 1.654 0 3-1.346 3-3 0-1.654-1.346-3-3-3z"],"record-active-circle_24":["M12 7c2.757 0 5 2.243 5 5 0 2.757-2.243 5-5 5-2.757 0-5-2.243-5-5 0-2.757 2.243-5 5-5zm0 9c2.206 0 4-1.794 4-4 0-2.206-1.794-4-4-4-2.206 0-4 1.794-4 4 0 2.206 1.794 4 4 4z"],"recurring_12":["M10.499 6.5122c.27.062.438.329.377.599-.52 2.29-2.525 3.889-4.876 3.889-1.606 0-3.067-.758-4-2.013l0 1.513c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-3c0-.275.225-.5.5-.5l3 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1.954 0c.715 1.236 2.011 2 3.454 2 1.881 0 3.485-1.28 3.901-3.111.061-.269.329-.438.598-.377zM11 4.4995c0 .069-.014.135-.04.195-.05.119-.147.215-.266.266-.06.025-.125.039-.194.039l-3 0c-.275 0-.5-.225-.5-.5 0-.274.225-.5.5-.5l1.954 0c-.715-1.236-2.012-2-3.454-2-2.044 0-3.753 1.53-3.976 3.559-.028.256-.245.445-.497.445-.018 0-.036-.001-.054-.003-.275-.03-.473-.276-.443-.551.278-2.537 2.415-4.45 4.97-4.45 1.606 0 3.066.758 4 2.013l0-1.513c0-.274.225-.5.5-.5.275 0 .5.226.5.5l0 3z"],"recurring_14":["M12.5 1.0004c.275 0 .5.225.5.5l0 4c0 .274-.225.5-.5.5l-4 0c-.275 0-.5-.226-.5-.5 0-.275.225-.5.5-.5l3.072 0c-.787-1.792-2.576-3-4.572-3-2.603 0-4.743 1.951-4.979 4.54-.024.26-.242.454-.498.454-.015 0-.03 0-.045-.002-.275-.025-.478-.268-.453-.543.284-3.106 2.852-5.449 5.975-5.449 2.044 0 3.908 1.057 5 2.701l0-2.201c0-.275.225-.5.5-.5zm.0449 6.0019c.275.025.479.269.453.543-.283 3.106-2.851 5.449-5.974 5.449-2.061 0-3.936-1.074-5.024-2.741l0 2.247c0 .274-.225.5-.5.5-.275 0-.5-.226-.5-.5l0-4c0-.275.225-.5.5-.5l4 0c.275 0 .5.225.5.5 0 .274-.225.5-.5.5l-3.047 0c.787 1.789 2.576 2.994 4.571 2.994 2.602 0 4.743-1.951 4.978-4.54.023-.26.242-.454.498-.454.015 0 .029 0 .045.002z"],"recurring_16":["M14.5 6c.276 0 .5-.224.5-.5l0-4c0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5l0 2.895C12.747 2.305 10.489 1 8 1 4.14 1 1 4.141 1 8c0 .176.006.349.019.521.019.263.238.463.498.463.012 0 .025 0 .037-.001.276-.02.483-.259.462-.535C2.005 8.3 2 8.15 2 8c0-3.309 2.691-6 6-6 2.168 0 4.127 1.158 5.189 3L10.5 5c-.276 0-.5.224-.5.5 0 .276.224.5.5.5l4 0zm-13 4c-.276 0-.5.224-.5.5l0 4c0 .276.224.5.5.5.276 0 .5-.224.5-.5l0-2.895C3.253 13.695 5.511 15 8 15c3.86 0 7-3.141 7-7 0-.181-.007-.359-.021-.537-.021-.275-.249-.511-.537-.459-.275.02-.481.262-.46.536.012.151.018.305.018.46 0 3.309-2.691 6-6 6-2.168 0-4.127-1.158-5.189-3L5.5 11c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5l-4 0z"],"recurring_24":["M23.5 9c.276 0 .5-.225.5-.5l0-8c0-.275-.224-.5-.5-.5-.276 0-.5.225-.5.5l0 6.704c-1.118-2.568-3.076-4.609-5.482-5.855-.007-.004-.015-.007-.022-.011-.249-.129-.504-.249-.763-.36-.044-.019-.088-.039-.133-.057-.224-.093-.451-.179-.682-.258-.072-.025-.145-.052-.219-.075-.206-.067-.416-.127-.627-.182-.093-.025-.187-.052-.282-.075-.199-.047-.4-.086-.602-.123-.105-.02-.209-.042-.316-.06-.209-.032-.421-.054-.633-.077-.099-.01-.197-.025-.297-.033C12.631.014 12.317 0 12 0c-.364 0-.723.021-1.079.053-.126.01-.251.029-.376.045-.222.026-.442.057-.661.096-.156.029-.312.059-.466.093-.171.037-.339.08-.506.125-.183.049-.364.096-.543.152-.067.021-.132.047-.198.07C3.601 2.167.249 6.359.014 11.436c-.014.275.2.507.475.521.271.027.51-.2.523-.477.063-1.357.379-2.642.885-3.823.094-.218.194-.431.301-.641.012-.026.026-.05.039-.075.966-1.857 2.446-3.404 4.25-4.455.028-.015.055-.032.083-.048.201-.115.407-.222.615-.325.064-.031.129-.059.193-.09.565-.261 1.156-.475 1.768-.639.175-.047.351-.093.53-.132.129-.027.259-.051.389-.074.207-.037.415-.068.625-.092.109-.014.218-.028.328-.038C11.342 1.02 11.669 1 12 1c.291 0 .579.012.864.034.088.007.174.021.261.03.198.02.396.04.591.071.08.012.159.031.239.046.201.036.403.073.601.121.055.012.109.03.163.044.223.056.445.117.661.187.024.008.047.018.07.026 3.102 1.03 5.587 3.412 6.776 6.441L15.5 8c-.276 0-.5.225-.5.5 0 .275.224.5.5.5l8 0zm-23 6c-.276 0-.5.225-.5.5l0 8c0 .275.224.5.5.5.276 0 .5-.225.5-.5l0-6.704c.064.148.139.29.209.435.029.059.055.119.085.177 1.134 2.251 2.93 4.052 5.102 5.199.029.016.058.03.087.045.233.12.47.234.711.339.062.028.126.054.189.081.21.087.423.169.639.244.087.032.175.062.263.09.197.065.397.122.598.176.104.028.208.058.313.083.193.046.389.085.585.122.113.021.223.044.336.063.208.032.418.055.629.077.102.011.202.026.305.034.314.024.63.039.949.039.396 0 .786-.02 1.172-.057.357-.035.707-.089 1.055-.154.024-.004.049-.006.073-.011 4.828-.932 8.62-4.751 9.496-9.635.003-.017.007-.034.01-.051.059-.334.101-.673.131-1.017.003-.036.011-.07.014-.106l-.004 0c.011-.135.032-.268.039-.405.014-.275-.2-.507-.475-.521-.271-.027-.51.2-.523.477-.009.2-.037.394-.056.592-.029.281-.065.558-.114.831-.009.053-.02.106-.03.159-.059.302-.127.601-.21.895-.004.013-.008.024-.012.037-1.13 3.935-4.399 6.974-8.463 7.764-.068.013-.137.018-.205.03-.273.048-.547.093-.827.119-.352.034-.709.053-1.071.053-.293 0-.583-.012-.871-.035-.09-.007-.178-.022-.268-.031-.197-.02-.396-.04-.59-.072-.089-.013-.176-.034-.265-.05-.194-.037-.389-.072-.58-.119-.072-.017-.143-.039-.215-.058-.207-.055-.414-.111-.616-.177-.048-.016-.095-.034-.142-.051-.227-.077-.451-.159-.671-.251-.02-.008-.039-.017-.059-.026-2.583-1.098-4.662-3.157-5.79-5.728-.002-.005-.004-.009-.007-.015-.055-.126-.101-.258-.152-.387L8.5 16c.276 0 .5-.225.5-.5 0-.275-.224-.5-.5-.5l-8 0z"],"redial_16":["M8 0C5.061 0 2.391 1.619 1 4.133L1 .5C1 .224.776 0 .5 0 .224 0 0 .224 0 .5l0 5c0 .276.224.5.5.5l5 0c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5L1.695 5C2.845 2.586 5.285 1 8 1c3.86 0 7 3.141 7 7 0 3.859-3.14 7-7 7-3.86 0-7-3.141-7-7 0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5 0 4.411 3.589 8 8 8 4.411 0 8-3.589 8-8 0-4.411-3.589-8-8-8"],"redial_20":["M10 0C6.097 0 2.648 2.213 1 5.637L1 .5C1 .224.776 0 .5 0 .224 0 0 .224 0 .5l0 7c0 .276.224.5.5.5l7 0c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5L1.52 7C2.789 3.398 6.147 1 10 1c4.962 0 9 4.038 9 9 0 4.962-4.038 9-9 9-4.762 0-8.709-3.72-8.985-8.47-.015-.276-.251-.481-.528-.47-.276.016-.486.253-.47.528C.323 15.866 4.708 20 10 20c5.514 0 10-4.486 10-10 0-5.514-4.486-10-10-10"],"redial_24":["M12 0C7.184 0 2.892 2.856 1 7.204L1 .5C1 .224.776 0 .5 0 .224 0 0 .224 0 .5l0 8c0 .276.224.5.5.5l8 0c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5L1.758 8C3.399 3.793 7.442 1 12 1c6.065 0 11 4.935 11 11 0 6.065-4.935 11-11 11-5.889 0-10.715-4.604-10.988-10.481-.013-.276-.252-.503-.523-.476-.275.013-.489.246-.475.522C.311 18.978 5.576 24 12 24c6.617 0 12-5.383 12-12 0-6.617-5.383-12-12-12"],"redo_12":["M6 1c1.613 0 3.073.765 4 2.013L10 1.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 3c0 .276-.224.5-.5.5l-3 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1.964 0C8.757 2.77 7.453 2 6 2 3.794 2 2 3.794 2 6c0 2.206 1.794 4 4 4 .276 0 .5.224.5.5 0 .276-.224.5-.5.5-2.757 0-5-2.243-5-5 0-2.757 2.243-5 5-5"],"redo_14":["M12.5 1c-.276 0-.5.224-.5.5l0 2.199C10.913 2.043 9.067 1 7 1 3.691 1 1 3.691 1 7c0 3.309 2.691 6 6 6 .276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5-2.757 0-5-2.243-5-5 0-2.757 2.243-5 5-5 2.018 0 3.782 1.189 4.57 3L8.5 5c-.276 0-.5.224-.5.5 0 .276.224.5.5.5l3.883 0 .117 0c.276 0 .5-.224.5-.5l0-4c0-.276-.224-.5-.5-.5"],"redo_16":["M14.5 1c-.275 0-.5.225-.5.5l0 2.938C12.757 2.342 10.51 1 8 1 4.14 1 1 4.141 1 8c0 3.859 3.14 7 7 7 .276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5-3.309 0-6-2.691-6-6 0-3.309 2.691-6 6-6 2.547 0 4.788 1.604 5.643 4L9.5 6c-.275 0-.5.225-.5.5 0 .275.225.5.5.5l5 0c.275 0 .5-.225.5-.5l0-5c0-.275-.225-.5-.5-.5"],"refresh_10":["M6 3.5c0 .276.224.5.5.5l2.973 0 0-.006c.009.001.017.006.027.006.276 0 .5-.224.5-.5l0-3c0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5l0 1.512C8.07.773 6.596 0 5 0 2.243 0 0 2.243 0 5c0 2.757 2.243 5 5 5 2.549 0 4.686-1.908 4.969-4.438.031-.275-.167-.522-.442-.553-.277-.024-.521.167-.552.441C8.749 7.474 7.04 9 5 9 2.794 9 1 7.206 1 5c0-2.206 1.794-4 4-4 1.437 0 2.753.783 3.459 2L6.5 3c-.276 0-.5.224-.5.5"],"refresh_12":["M7 4.5c0 .276.224.5.5.5l4 0c.174 0 .319-.094.409-.229.053-.079.091-.168.091-.271l0-4c0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5l0 2.2C9.913 1.044 8.066 0 6 0 2.692 0 0 2.691 0 6c0 3.309 2.692 6 6 6 3.124 0 5.693-2.344 5.975-5.451.025-.275-.177-.518-.453-.543-.275-.009-.518.179-.543.453C10.744 9.048 8.604 11 6 11c-2.757 0-5-2.243-5-5 0-2.757 2.243-5 5-5 2.015 0 3.781 1.189 4.569 3L7.5 4c-.276 0-.5.224-.5.5"],"refresh_16":["M10 5.5c0 .275.225.5.5.5l5 0c.275 0 .5-.225.5-.5l0-5c0-.275-.225-.5-.5-.5-.275 0-.5.225-.5.5l0 3.646C13.607 1.632 10.919 0 8 0 3.589 0 0 3.589 0 8c0 4.411 3.589 8 8 8 4.195 0 7.702-3.276 7.982-7.458.019-.275-.19-.514-.465-.532-.242-.014-.514.19-.533.466C14.739 12.134 11.671 15 8 15c-3.859 0-7-3.14-7-7 0-3.86 3.141-7 7-7 2.694 0 5.152 1.594 6.303 4L10.5 5c-.275 0-.5.225-.5.5"],"refresh_18":["M11 6.5c0 .276.224.5.5.5l6 0c.276 0 .5-.224.5-.5l0-6c0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5l0 4.374C15.48 1.907 12.436 0 9 0 4.037 0 0 4.037 0 9c0 4.963 4.037 9 9 9 4.763 0 8.709-3.721 8.985-8.471.016-.276-.195-.512-.47-.528-.28-.027-.513.194-.529.47C16.741 13.693 13.233 17 9 17c-4.411 0-8-3.589-8-8 0-4.411 3.589-8 8-8 3.301 0 6.176 1.99 7.392 5L11.5 6c-.276 0-.5.224-.5.5"],"refresh_20":["M12 7.5c0 .276.224.5.5.5l7 0c.276 0 .5-.224.5-.5l0-7c0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5l0 5.137C17.353 2.214 13.903 0 10 0 4.486 0 0 4.486 0 10c0 5.514 4.486 10 10 10 5.292 0 9.677-4.135 9.983-9.412.016-.276-.194-.513-.47-.528-.276-.033-.512.194-.529.469C18.709 15.279 14.763 19 10 19c-4.963 0-9-4.037-9-9 0-4.963 4.037-9 9-9 3.853 0 7.211 2.397 8.48 6L12.5 7c-.276 0-.5.224-.5.5"],"refresh_24":["M15 8.5c0 .276.224.5.5.5l8 0c.276 0 .5-.224.5-.5l0-8c0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5l0 6.704C21.108 2.856 16.816 0 12 0 5.383 0 0 5.383 0 12c0 6.617 5.383 12 12 12 6.424 0 11.689-5.022 11.986-11.435.014-.276-.2-.509-.475-.522-.271-.027-.51.2-.523.476C22.715 18.396 17.889 23 12 23 5.935 23 1 18.065 1 12 1 5.935 5.935 1 12 1c4.558 0 8.601 2.793 10.242 7L15.5 8c-.276 0-.5.224-.5.5"],"remove_12":["M6 12c-3.3137085 0-6-2.6862915-6-6 0-3.3137085 2.6862915-6 6-6 3.3137085 0 6 2.6862915 6 6 0 3.3137085-2.6862915 6-6 6zm0-1c2.76142375 0 5-2.23857625 5-5 0-2.76142375-2.23857625-5-5-5-2.76142375 0-5 2.23857625-5 5 0 2.76142375 2.23857625 5 5 5zM3.5 5.5l5 0c.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5l-5 0c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5z"],"remove_16":["M8 0c4.411 0 8 3.589 8 8 0 4.411-3.589 8-8 8-4.411 0-8-3.589-8-8 0-4.411 3.589-8 8-8zm0 15c3.86 0 7-3.14 7-7 0-3.86-3.14-7-7-7-3.86 0-7 3.14-7 7 0 3.86 3.14 7 7 7zM4 8c0-.27614237.23079681-.5.50043583-.5l6.99912837 0C11.7759472 7.5 12 7.73193359 12 8c0 .27614237-.2307968.5-.5004358.5l-6.99912837 0C4.22405275 8.5 4 8.26806641 4 8z"],"remove_20":["M0 10C0 4.477 4.477 0 10 0c5.523 0 10 4.477 10 10 0 5.523-4.477 10-10 10-5.523 0-10-4.477-10-10zm1 0c0 4.963 4.037 9 9 9 4.963 0 9-4.037 9-9 0-4.963-4.037-9-9-9-4.963 0-9 4.037-9 9zm13.5.5l-9 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l9 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5z"],"remove_24":["M12 0c6.617 0 12 5.383 12 12 0 6.617-5.383 12-12 12-6.617 0-12-5.383-12-12C0 5.383 5.383 0 12 0zm0 23c6.065 0 11-4.935 11-11 0-6.065-4.935-11-11-11C5.935 1 1 5.935 1 12c0 6.065 4.935 11 11 11zm5.5-11.5c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-11 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l11 0z"],"reply_12":["M5.60595189 6.99994802l-.10894076 0c-.27585002 0-.49972829.22400291-.49972829.5000065l0 1.87702439-3.7509605-3.37704388 3.7509605-3.37704388 0 1.87702439c0 .13200171.05197174.26000337.14592066.3540046.09394892.0930012.2208799.14600189.35380763.14600189 2.49864142 0 4.60949367 1.67902182 5.27513177 3.96805157-1.41523051-1.24801622-3.25123222-1.96802558-5.16619101-1.96802558m6.26659271 3.81504958c.0319826-.03600047.0589679-.07300095.0779576-.11600151.0019989-.00400005.0039978-.00900012.0049973-.01300017.0429766-.1000013.0579685-.20900272.0309831-.31600411-.0659641-3.35604361-2.68354086-6.09807924-5.98974319-6.35108252l0-2.519032737c0-.19700256-.11593696-.376004886-.29583914-.4570059384-.17990219-.0800010396-.39078752-.0460005978-.53770764.0850011044L.164910334 5.62793019C.0599673941 5.72293143 0 5.85793318 0 5.99993503c0 .14200184.0599673941.2770036.164910334.37200483l4.998282296 4.50005848C5.25614209 10.95599943 5.37607688 11 5.49701113 11c.0689625 0 .137925-.01400018.20388914-.04300056.17990218-.08100105.29583914-.26000338.29583914-.45700594l0-2.47703218c2.00291096.11800153 3.87789149 1.11501448 5.08023769 2.73703556.0879522.14100183.2378707.24000312.4167734.24000312.1039435 0 .1958935-.04000052.27585-.09400122.0089952-.00600008.0209886-.00400005.0299837-.01000013.0099946-.00700009.0149919-.01900025.023987-.02700035.0179902-.01600021.0329821-.03500046.0489734-.0540007"],"report_16":["M10.5 8h-5c-.3 0-.5.2-.5.5s.2.5.5.5h5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"],"report_28":["M22 0c1.657 0 3 1.343 3 3l0 22c0 1.657-1.343 3-3 3L6 28c-1.657 0-3-1.343-3-3L3 3c0-1.657 1.343-3 3-3l16 0zm2 25l0-22c0-1.104-.896-2-2-2L6 1c-1.104 0-2 .896-2 2l0 22c0 1.104.896 2 2 2l16 0c1.104 0 2-.896 2-2zm-4.5-11.4814c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-11 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l11 0zM13.5 20c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-5 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l5 0zm6-13c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-11 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l11 0z"],"reset_16":["M8 0c4.411 0 8 3.589 8 8 0 4.411-3.589 8-8 8C3.807 16 .301 12.727.018 8.548c-.018-.277.19-.515.465-.533.274-.018.515.19.533.464C1.264 12.136 4.331 15 8 15c3.86 0 7-3.141 7-7 0-3.859-3.14-7-7-7-2.694 0-5.152 1.594-6.304 4L5.5 5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-5 0C.224 6 0 5.776 0 5.5l0-5C0 .224.224 0 .5 0c.276 0 .5.224.5.5l0 3.646C2.393 1.632 5.08 0 8 0zm1 8c0 .553-.448 1-1 1-.552 0-1-.447-1-1 0-.553.448-1 1-1 .552 0 1 .447 1 1z"],"reset_24":["M12 12.5c-.07 0-.13-.01-.19-.04-.06-.021-.12-.061-.16-.11-.1-.09-.15-.22-.15-.35 0-.13.05-.26.15-.351.04-.049.1-.089.16-.109.12-.05.26-.05.38 0 .06.02.12.06.16.109.1.091.15.221.15.351 0 .13-.05.26-.15.35-.09.1-.22.15-.35.15zM12 0c6.617 0 12 5.383 12 12 0 6.617-5.383 12-12 12C5.576 24 .311 18.979.014 12.564c-.014-.275.2-.507.475-.521.271-.027.51.2.523.477C1.285 18.396 6.111 23 12 23c6.065 0 11-4.936 11-11 0-6.064-4.935-11-11-11C7.442 1 3.399 3.793 1.758 8L8.5 8c.276 0 .5.225.5.5 0 .275-.224.5-.5.5l-8 0C.224 9 0 8.775 0 8.5l0-8C0 .225.224 0 .5 0c.276 0 .5.225.5.5l0 6.704C2.892 2.855 7.184 0 12 0z"],"responsive-mobile_16":["M7 13l0-7.5C7 4.675 6.325 4 5.5 4L5 4l0-1 10 0 0 10-8 0zm7 2l-7 0 0-1 8 0c0 .551-.449 1-1 1zm-8-.5c0 .271-.229.5-.5.5l-4 0c-.271 0-.5-.229-.5-.5l0-.5 5 0 0 .5zm-5-9c0-.271.229-.5.5-.5l4 0c.271 0 .5.229.5.5L6 13l-5 0 0-7.5zM6 1l8 0c.551 0 1 .449 1 1L5 2c0-.551.449-1 1-1zm8-1L6 0C4.895 0 4 .895 4 2l0 2-2.5 0C.675 4 0 4.675 0 5.5L0 13l0 1 0 .5c0 .825.675 1.5 1.5 1.5l4.725 0L7 16l7 0c1.105 0 2-.895 2-2l0-1 0-11c0-1.105-.895-2-2-2z"],"return_12":["M7 5.4985l-5.293 0 3.644-3.645c.195-.195.195-.511 0-.707-.196-.196-.513-.196-.707 0L.146 5.6445c-.195.196-.195.512 0 .708l4.5 4.5c.098.098.226.148.354.148.128 0 .256-.05.354-.148.195-.195.195-.511 0-.707l-3.647-3.647 5.293 0c2.206 0 4 1.795 4 4.001 0 .276.224.501.5.501.276 0 .5-.225.5-.501 0-2.757-2.243-5.001-5-5.001"],"return_16":["M9.5003 7.9998l-7.793 0 5.155-5.146c.195-.195.195-.512 0-.707-.196-.196-.512-.195-.708-.001l-6.008 6c-.093.094-.146.221-.146.354 0 .133.053.26.146.354l6.008 6c.098.097.226.146.354.146.128 0 .256-.049.354-.147.195-.195.195-.512 0-.707l-5.155-5.146 7.793 0c3.032 0 5.5 2.468 5.5 5.5 0 .276.224.5.5.5.276 0 .5-.224.5-.5 0-3.584-2.916-6.5-6.5-6.5"],"ringtone_16":["M12 12.9742c-.551 0-1-.449-1-1 0-.551.449-1 1-1 .527 0 .95.414.986.933l0 .067c0 .012.006.022.007.034-.019.534-.453.966-.993.966zm-7.014-7.755l0-2.478c0-.186.137-.347.325-.383l7.199-1.351c.118-.019.242.009.336.086.052.044.14.14.14.296l0 2.328-8 1.502zM3 14.9742c-.551 0-1-.449-1-1 0-.551.449-1 1-1 .527 0 .95.414.986.933l0 .067c0 .012.006.022.007.034-.019.534-.453.966-.993.966zm10.986-3.136l0-10.449c0-.413-.183-.801-.502-1.065-.322-.269-.746-.377-1.158-.3l-7.2 1.352c-.66.123-1.14.698-1.14 1.365l0 9.503c-.292-.167-.626-.27-.986-.27-1.104 0-2 .896-2 2 0 1.104.896 2 2 2 1.104 0 2-.896 2-2 0-.046-.011-.09-.014-.136l0-7.602 8-1.502 0 5.51c-.292-.167-.626-.27-.986-.27-1.104 0-2 .896-2 2 0 1.104.896 2 2 2 1.104 0 2-.896 2-2 0-.046-.011-.09-.014-.136z"],"ringtone_24":["M20 5.2217l-12 3 0-3.723c0-.502.341-.938.826-1.06l9.815-2.404c.33-.084.671-.01.938.199.268.209.421.523.421.862l0 3.126zm-1.5 14.766c-.827 0-1.5-.673-1.5-1.5 0-.828.673-1.5 1.5-1.5.827 0 1.5.672 1.5 1.5 0 .827-.673 1.5-1.5 1.5zm-13 3c-.827 0-1.5-.673-1.5-1.5 0-.828.673-1.5 1.5-1.5.827 0 1.5.672 1.5 1.5 0 .827-.673 1.5-1.5 1.5zM21 2.0957c0-.649-.294-1.251-.806-1.65-.512-.4-1.166-.54-1.794-.381l-9.815 2.403C7.652 2.7017 7 3.5367 7 4.4987l0 15.001c-.419-.317-.935-.512-1.5-.512-1.378 0-2.5 1.121-2.5 2.5 0 1.379 1.122 2.5 2.5 2.5 1.378 0 2.5-1.121 2.5-2.5l0-12.235 12-3 0 10.245c-.419-.316-.935-.51-1.5-.51-1.381 0-2.5 1.119-2.5 2.5 0 1.38 1.119 2.5 2.5 2.5 1.38 0 2.5-1.12 2.5-2.5 0-.029-.007-.056-.008-.083.001-.015.008-.028.008-.042l0-16.267z"],"room-lights_16":["M11.7586 8.5689c-.326.343-.533.721-.616 1.125l-.281 1.303-1.862 0 0-4.5c0-.276-.224-.5-.5-.5-.277 0-.5.224-.5.5l0 4.5-1.902 0-.292-1.354c-.081-.394-.282-.766-.598-1.106-1.004-1.078-1.409-2.529-1.112-3.981.352-1.716 1.734-3.106 3.437-3.459.319-.066.639-.098.955-.098 1.039 0 2.042.348 2.852 1.007 1.055.86 1.66 2.132 1.66 3.491 0 1.14-.441 2.231-1.241 3.072zm-1.329 4.428l-3.901 0-.215-1 4.332 0-.216 1zm-1.95 2c-.714 0-1.336-.405-1.649-1l3.298 0c-.312.594-.935 1-1.649 1zm3.491-13.766c-1.289-1.051-2.98-1.453-4.64-1.113-2.09.432-3.783 2.135-4.214 4.237-.363 1.774.132 3.546 1.359 4.863.189.204.307.414.35.626l.846 3.921c.275 1.294 1.456 2.232 2.808 2.232 1.352 0 2.533-.938 2.807-2.228l.835-3.874c.045-.218.167-.431.362-.637.977-1.027 1.516-2.363 1.516-3.761 0-1.661-.74-3.216-2.029-4.266z"],"room-lights_24":["M18.0312 11.9481048c-.417.6769941-.725 1.491987-.911 2.4069791l-.154.6449944-3.966 0 0-6.49994352c0-.27699759-.224-.49999565-.5-.49999565-.277 0-.5.22299806-.5.49999565l0 6.49994352-3.967 0-.152-.6409945c-.187-.919992-.495-1.7329849-.916-2.416979-.763-1.23798919-1.083-2.66997673-.927-4.13896396.333-3.1389727 2.963-5.62995104 6.117-5.79394962.116-.00599995.232-.00899992.348-.00899992 1.671 0 3.244.62699455 4.464 1.78398449 1.311 1.24498917 2.033 2.92797454 2.033 4.73695881 0 1.21398944-.335 2.39997913-.969 3.4269702zm-2.017 7.0519387l-7.029 0-.714-2.9999739 8.457 0-.714 2.9999739zm-.374 1.5699863c-.303 1.4079878-1.614 2.4299789-3.162 2.4299789-1.504 0-2.816-1.0219911-3.121-2.4409788l-.134-.5589951 6.553 0-.136.569995zm2.016-17.51084771c-1.505-1.428987572-3.472-2.1569812422-5.553-2.0489821813-3.64.1889983563-6.675 3.0639733613-7.059 6.6879418413-.18 1.68998531.19 3.33997095 1.069 4.76795855.359.5839949.625 1.2879888.791 2.1089817l1.478 6.205946C8.7832 22.6460118 10.5062 24 12.5222 24c1.972 0 3.695-1.3539882 4.093-3.2079721l1.481-6.2209459c.166-.8149929.431-1.5209868.787-2.0979818.731-1.1849897 1.117-2.55197778 1.117-3.9519656 0-2.08698186-.833-4.02596499-2.344-5.46195251z"],"rss-circle_24":["M15.973 17.218l2.241 0C18.2 11.055 13.21 6.06 7.049 6.039l0 2.241c2.379.01 4.615.941 6.299 2.626 1.687 1.687 2.619 3.927 2.625 6.312zm-3.796 0l2.241 0c-.029-4.057-3.312-7.34-7.369-7.369l0 2.242c2.815.028 5.099 2.313 5.128 5.127zm-3.615 0c.836 0 1.512-.678 1.512-1.513 0-.835-.676-1.512-1.512-1.512-.836 0-1.513.677-1.513 1.512 0 .835.677 1.513 1.513 1.513zM12 0c6.628 0 12 5.372 12 12 0 6.628-5.372 12-12 12-6.627 0-12-5.372-12-12C0 5.372 5.373 0 12 0z"],"rss-circle_32":["M21.297 22.958l2.989 0C24.267 14.74 17.613 8.081 9.399 8.052l0 2.989c3.172.013 6.153 1.254 8.398 3.5 2.25 2.249 3.492 5.237 3.5 8.417zm-5.061 0l2.988 0c-.039-5.41-4.416-9.787-9.825-9.826l0 2.989c3.752.039 6.798 3.084 6.837 6.837zm-4.82 0c1.114 0 2.016-.904 2.016-2.017 0-1.114-.902-2.017-2.016-2.017-1.115 0-2.017.903-2.017 2.017 0 1.113.902 2.017 2.017 2.017zM16 0c8.837 0 16 7.163 16 16 0 8.837-7.163 16-16 16-8.837 0-16-7.163-16-16C0 7.163 7.163 0 16 0z"],"rss-circle_40":["M26.621 28.697l3.736 0c-.024-10.271-8.34-18.597-18.609-18.632l0 3.735c3.965.017 7.691 1.569 10.498 4.376 2.812 2.812 4.364 6.546 4.375 10.521zm-6.326 0l3.735 0c-.05-6.762-5.52-12.233-12.282-12.282l0 3.736c4.691.048 8.498 3.855 8.547 8.546zm-6.026 0c1.393 0 2.52-1.129 2.52-2.521 0-1.393-1.127-2.522-2.52-2.522-1.393 0-2.521 1.129-2.521 2.522 0 1.392 1.128 2.521 2.521 2.521zM20 0c11.045 0 20 8.954 20 20 0 11.046-8.955 20-20 20C8.954 40 0 31.046 0 20 0 8.954 8.954 0 20 0z"],"running-application_16":["M8 0c4.411 0 8 3.589 8 8 0 4.411-3.589 8-8 8-4.411 0-8-3.589-8-8 0-4.411 3.589-8 8-8zm0 15c3.86 0 7-3.141 7-7 0-3.859-3.14-7-7-7-3.86 0-7 3.141-7 7 0 3.859 3.14 7 7 7zm3.5-11c.276 0 .5.224.5.5L12 6l0 .5c0 .275-.225.5-.5.5L11 7 9.5 7c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l.712 0C9.649 5.375 8.864 5 8 5 6.346 5 5 6.346 5 8c0 1.654 1.346 3 3 3 1.155 0 2.22-.675 2.714-1.72.118-.249.413-.354.666-.238.249.118.356.416.238.666C10.959 11.101 9.54 12 8 12c-2.206 0-4-1.794-4-4 0-2.206 1.794-4 4-4 1.172 0 2.248.503 3 1.363l0-.863c0-.276.224-.5.5-.5z"],"running-application_24":["M12 0c6.617 0 12 5.383 12 12 0 6.617-5.383 12-12 12-6.617 0-12-5.383-12-12C0 5.383 5.383 0 12 0zm0 23c6.065 0 11-4.935 11-11 0-6.065-4.935-11-11-11C5.935 1 1 5.935 1 12c0 6.065 4.935 11 11 11zm5.5-17c.276 0 .5.224.5.5l0 4c0 .276-.224.5-.5.5l-4 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l3.072 0C15.775 8.175 14.007 7 12 7c-2.757 0-5 2.243-5 5 0 2.757 2.243 5 5 5 2.224 0 4.202-1.492 4.81-3.629.076-.266.353-.424.618-.344.265.076.42.352.344.618C17.042 16.209 14.669 18 12 18c-3.309 0-6-2.691-6-6 0-3.309 2.691-6 6-6 2.061 0 3.907 1.037 5 2.705L17 6.5c0-.276.224-.5.5-.5z"],"save_12":["M2.6458 5.1469c.196-.196.513-.196.707 0l2.147 2.146 0-6.793c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 6.793 2.146-2.146c.196-.196.513-.196.707 0 .196.195.196.511 0 .707l-2.999 2.999c-.046.047-.102.084-.163.109-.122.05-.26.05-.382 0-.061-.025-.117-.062-.163-.109l-3-2.999c-.097-.098-.146-.226-.146-.354 0-.128.049-.256.146-.353zm9.2363-4.23c.076.179.118.376.118.583l0 9c0 .207-.042.404-.118.584-.152.358-.44.646-.799.798-.18.076-.377.118-.583.118l-9 0c-.207 0-.404-.042-.584-.118-.358-.152-.646-.44-.798-.798-.076-.18-.118-.377-.118-.584l0-9c0-.207.042-.404.118-.583.152-.359.44-.647.798-.799.18-.076.377-.118.584-.118l2 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-2 0c-.276 0-.5.225-.5.5l0 9c0 .275.224.5.5.5l9 0c.276 0 .5-.225.5-.5l0-9c0-.275-.224-.5-.5-.5l-2 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l2 0c.206 0 .403.042.583.118.359.152.647.44.799.799z"],"save_14":["M14 1.4995l0 .201 0 10.599 0 .2 0 .001 0-.2c0 .937-.763 1.699-1.7 1.699l-10.6 0c-.937 0-1.7-.762-1.7-1.7l0-10.599c0-.938.762-1.7 1.7-1.701l-.2 0 .2 0 2.3 0 .5 0c.276 0 .5.224.5.5 0 .277-.224.5-.5.5l-2.8 0c-.386 0-.7.314-.7.701l0 10.599c0 .386.314.7.7.7l10.6 0c.386 0 .7-.314.7-.7l0-10.599c0-.387-.314-.701-.7-.701l-2.8 0c-.276 0-.5-.223-.5-.5 0-.276.224-.5.5-.5l2.8 0 .2 0-.2 0c.937.001 1.7.763 1.7 1.7l0-.2zM3.6455 6.147c.196-.196.513-.196.707 0l2.147 2.146 0-7.793c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 7.793 2.146-2.146c.196-.196.513-.196.707 0 .196.195.196.511 0 .707l-2.999 2.999c-.046.047-.102.085-.163.109-.122.05-.26.05-.382 0-.061-.024-.117-.062-.163-.109l-3-2.999c-.097-.098-.146-.226-.146-.354 0-.128.049-.256.146-.353z"],"save_16":["M7.64625 11.8535l-4-4c-.195-.195-.195-.512 0-.707.196-.195.512-.195.707 0l3.147 3.146 0-8.793c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 8.793 3.146-3.146c.196-.195.512-.195.707 0 .196.195.196.512 0 .707l-3.999 4c-.046.045-.102.082-.163.108-.061.026-.126.038-.191.038-.065 0-.13-.012-.191-.038-.062-.026-.117-.063-.163-.108zM14.999 3L15 13c0 1.105-.896 2-2 2l-9.999 0c-1.105 0-2-.895-2-2L1 3c0-1.105.896-2 2-2l2.5 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L3 2c-.552 0-1 .449-1 1l0 10c0 .551.448 1 1 1l10 0c.552 0 1-.449 1-1l0-10c0-.551-.448-1-1-1l-2.5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l2.499 0c1.104 0 2 .895 2 2z"],"save_24":["M17.638 10.1464c.195-.195.511-.195.707 0 .195.195.195.512 0 .707l-5.996 6c-.046.046-.101.082-.163.108-.061.026-.126.039-.191.039-.065 0-.129-.013-.191-.039-.061-.026-.116-.062-.162-.108l-5.995-6c-.196-.195-.196-.512 0-.707.195-.195.51-.195.706 0l5.147 5.146 0-13.792c0-.276.225-.5.5-.5.275 0 .5.224.5.5l-.005 13.792 5.143-5.146zM15.5.9999l4.875 0c1.448 0 2.625 1.178 2.625 2.625l0 16.75c0 1.447-1.177 2.625-2.625 2.625l-16.75 0c-1.448 0-2.625-1.178-2.625-2.625l0-16.75C1 2.1779 2.177.9999 3.625.9999l4.875 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-4.925 0c-.868 0-1.575.706-1.575 1.574l0 16.852c0 .868.707 1.574 1.575 1.574l16.85 0c.868 0 1.575-.706 1.575-1.574l0-16.852c0-.868-.707-1.574-1.575-1.574l-4.925 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5z"],"screen-toggle_12":["M4.5 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-3 0c-.275 0-.5.224-.5.5l0 3c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-3C0 .673.673 0 1.5 0l3 0zm7 7c.276 0 .5.224.5.5l0 3c0 .827-.673 1.5-1.5 1.5l-3 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l3 0c.275 0 .5-.224.5-.5l0-3c0-.276.224-.5.5-.5zm-6.6465.1465c.195.195.195.512 0 .707l-3.146 3.147 2.792 0c.277 0 .5.223.5.5 0 .276-.223.5-.5.5l-4 0c-.065 0-.129-.014-.191-.039-.122-.05-.22-.148-.27-.271-.025-.061-.039-.126-.039-.19l0-4c0-.277.224-.5.5-.5.277 0 .5.223.5.5l0 2.792 3.147-3.146c.195-.195.512-.195.707 0zM11.9619.3091c.024.061.038.126.038.191l0 4c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-2.793-3.146 3.146c-.098.098-.226.147-.354.147-.128 0-.256-.049-.353-.147-.196-.195-.196-.511 0-.707l3.146-3.146-2.793 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l4 0c.066 0 .13.013.191.038.123.051.22.148.271.271z"],"screen-toggle_16":["M.5 6C.224 6 0 5.776 0 5.5L0 2C0 .897.897 0 2 0l3.5 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5L2 1c-.551 0-1 .448-1 1l0 3.5c0 .276-.224.5-.5.5zm15 4c.276 0 .5.224.5.5l0 3.5c0 1.103-.897 2-2 2l-3.5 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l3.5 0c.552 0 1-.448 1-1l0-3.5c0-.276.224-.5.5-.5zm-9.3535-.8535c.195-.195.512-.195.707 0 .195.195.195.512 0 .707l-5.146 5.147 3.793 0c.276 0 .5.223.5.5 0 .276-.224.5-.5.5l-5 0c-.065 0-.13-.014-.191-.039-.123-.05-.221-.148-.271-.27-.025-.062-.038-.126-.038-.191l0-5c0-.277.223-.5.5-.5.276 0 .5.223.5.5l0 3.792 5.146-5.146zM15.9619.3086c.024.062.038.126.038.191l0 5c0 .277-.224.5-.5.5-.276 0-.5-.223-.5-.5l0-3.793-5.146 5.147c-.098.098-.226.146-.354.146-.128 0-.256-.048-.353-.146-.196-.195-.196-.512 0-.707l5.146-5.147-3.793 0c-.276 0-.5-.223-.5-.5 0-.276.224-.5.5-.5l5 0c.066 0 .13.014.191.038.123.051.22.149.271.271z"],"screen-toggle_20":["M19.5 13c.276 0 .5.224.5.5l0 4c0 1.379-1.121 2.5-2.5 2.5l-4 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l4 0c.827 0 1.5-.673 1.5-1.5l0-4c0-.276.224-.5.5-.5zM.5 7C.224 7 0 6.776 0 6.5l0-4C0 1.121 1.122 0 2.5 0l4 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-4 0C1.673 1 1 1.673 1 2.5l0 4c0 .276-.224.5-.5.5zm19-7c.276 0 .5.224.5.5l0 6c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-4.793-6.146 6.147c-.098.097-.226.146-.354.146-.128 0-.256-.049-.354-.146-.195-.196-.195-.512 0-.708L18.293 1 13.5 1c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l6 0zm-12 12c.128 0 .256.049.354.146.195.196.195.512 0 .708L1.707 19 6.5 19c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-6 0c-.276 0-.5-.224-.5-.5l0-6c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 4.793 6.146-6.147c.098-.097.226-.146.354-.146z"],"screen-toggle_24":["M1.5 9c-.276 0-.5-.224-.5-.5l0-5C1 2.122 2.122 1 3.5 1l5 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-5 0C2.673 2 2 2.673 2 3.5l0 5c0 .276-.224.5-.5.5zm21-8c.276 0 .5.224.5.5l0 7c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-5.793-7.146 7.147c-.098.097-.226.146-.354.146-.128 0-.256-.049-.354-.146-.195-.196-.195-.512 0-.708L21.293 2 15.5 2c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l7 0zm0 14c.276 0 .5.224.5.5l0 5c0 1.378-1.122 2.5-2.5 2.5l-5 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l5 0c.827 0 1.5-.673 1.5-1.5l0-5c0-.276.224-.5.5-.5zm-13.3535-.8535c.195-.195.512-.195.707 0 .195.195.195.512 0 .707l-7.146 7.147 5.793 0c.276 0 .5.223.5.5 0 .276-.224.5-.5.5l-7 0c-.277 0-.5-.224-.5-.5l0-7c0-.277.223-.5.5-.5.276 0 .5.223.5.5l0 5.792 7.146-7.146z"],"screenshot_16":["M14 2c1.105 0 2 .895 2 2l0 4.5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5L15 4c0-.551-.449-1-1-1L2 3c-.551 0-1 .449-1 1l0 8c0 .551.449 1 1 1l8.5 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L2 14c-1.105 0-2-.895-2-2l0-8c0-1.105.895-2 2-2l12 0zm1.5 9c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L14 12l0 1.5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-1.5-1.5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1.5 0 0-1.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 1.5 1.5 0z"],"screenshot_20":["M17.5 2C18.879 2 20 3.121 20 4.5l0 6c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-6c0-.827-.673-1.5-1.5-1.5l-15 0C1.673 3 1 3.673 1 4.5l0 11c0 .827.673 1.5 1.5 1.5l10 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-10 0C1.121 18 0 16.879 0 15.5l0-11C0 3.121 1.121 2 2.5 2l15 0zm2 12c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L17 15l0 2.5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-2.5-2.5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l2.5 0 0-2.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 2.5 2.5 0z"],"search_12":["M1 5c0-2.206 1.794-4 4-4 2.206 0 4 1.794 4 4 0 2.206-1.794 4-4 4-2.206 0-4-1.794-4-4m10.854 6.146L8.855 8.148C9.56 7.286 10 6.2 10 5c0-2.761-2.239-5-5-5-2.761 0-5 2.239-5 5 0 2.761 2.239 5 5 5 1.2 0 2.286-.44 3.148-1.145l2.998 2.999c.098.097.226.146.354.146.128 0 .256-.049.354-.146.195-.196.195-.512 0-.708"],"search_14":["M1 5.75C1 3.131 3.131 1 5.75 1c2.619 0 4.75 2.131 4.75 4.75 0 2.619-2.131 4.75-4.75 4.75C3.131 10.5 1 8.369 1 5.75m12.854 7.396l-3.703-3.703c.84-1 1.349-2.287 1.349-3.693C11.5 2.579 8.921 0 5.75 0 2.579 0 0 2.579 0 5.75c0 3.171 2.579 5.75 5.75 5.75 1.406 0 2.694-.509 3.694-1.35l3.702 3.704c.098.097.226.146.354.146.128 0 .256-.049.354-.146.195-.196.195-.512 0-.708"],"search_16":["M6.5 12C3.467 12 1 9.533 1 6.5 1 3.467 3.467 1 6.5 1 9.533 1 12 3.467 12 6.5 12 9.533 9.533 12 6.5 12m9.354 3.146l-4.423-4.422C12.406 9.586 13 8.112 13 6.5 13 2.916 10.084 0 6.5 0 2.916 0 0 2.916 0 6.5 0 10.084 2.916 13 6.5 13c1.612 0 3.086-.594 4.224-1.569l4.422 4.423c.098.097.226.146.354.146.128 0 .256-.049.354-.146.195-.196.195-.512 0-.708"],"search_18":["M7.5 14C3.916 14 1 11.084 1 7.5 1 3.916 3.916 1 7.5 1 11.084 1 14 3.916 14 7.5c0 3.584-2.916 6.5-6.5 6.5m10.354 3.146l-4.716-4.715C14.293 11.11 15 9.389 15 7.5 15 3.364 11.636 0 7.5 0 3.364 0 0 3.364 0 7.5 0 11.636 3.364 15 7.5 15c1.888 0 3.61-.707 4.931-1.862l4.715 4.716c.098.097.226.146.354.146.128 0 .256-.049.354-.146.195-.196.195-.512 0-.708"],"search_20":["M2 8.5C2 4.916 4.916 2 8.5 2 12.084 2 15 4.916 15 8.5c0 3.584-2.916 6.5-6.5 6.5C4.916 15 2 12.084 2 8.5m16.854 9.646l-4.716-4.715C15.293 12.111 16 10.388 16 8.5 16 4.364 12.636 1 8.5 1 4.364 1 1 4.364 1 8.5 1 12.636 4.364 16 8.5 16c1.888 0 3.611-.707 4.931-1.862l4.715 4.716c.098.097.226.146.354.146.128 0 .256-.049.354-.146.195-.196.195-.512 0-.708"],"search_24":["M10 18c-4.411 0-8-3.589-8-8 0-4.411 3.589-8 8-8 4.411 0 8 3.589 8 8 0 4.411-3.589 8-8 8m12.854 4.146l-6.156-6.155C18.124 14.398 19 12.302 19 10c0-4.963-4.037-9-9-9-4.962 0-9 4.037-9 9 0 4.963 4.038 9 9 9 2.302 0 4.398-.876 5.991-2.302l6.155 6.156c.098.097.226.146.354.146.128 0 .256-.049.354-.146.195-.196.195-.512 0-.708"],"search_28":["M11.5 21C6.262 21 2 16.738 2 11.5 2 6.262 6.262 2 11.5 2c5.238 0 9.5 4.262 9.5 9.5 0 5.238-4.262 9.5-9.5 9.5m15.354 5.146l-7.596-7.595C20.955 16.685 22 14.215 22 11.5 22 5.71 17.29 1 11.5 1 5.71 1 1 5.71 1 11.5 1 17.29 5.71 22 11.5 22c2.715 0 5.185-1.045 7.051-2.742l7.595 7.596c.098.097.226.146.354.146.128 0 .256-.049.354-.146.195-.196.195-.512 0-.708"],"secure_12":["M9.4999 4c.829 0 1.5.671 1.5 1.5l0 5c0 .829-.671 1.5-1.5 1.5l-7 0c-.828 0-1.5-.671-1.5-1.5l0-5c0-.829.672-1.5 1.5-1.5l.5 0 0-1c0-1.65 1.35-3 3-3 1.65 0 3 1.35 3 3l0 1 .5 0zm.5 6.5l0-5c0-.276-.224-.5-.5-.5l-7 0c-.275 0-.5.224-.5.5l0 5c0 .276.225.5.5.5l7 0c.276 0 .5-.224.5-.5zm-6-7.5l0 1 4 0 0-1c0-1.103-.897-2-2-2-1.103 0-2 .897-2 2zm2 4.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5z"],"secure_16":["M12 6c1.104 0 2 .896 2 2l0 6c0 1.104-.896 2-2 2l-8 0c-1.104 0-2-.896-2-2l0-6c0-1.104.896-2 2-2l0-2c0-2.2 1.8-4 4-4 2.2 0 4 1.8 4 4l0 2zm1 8l0-6c0-.551-.449-1-1-1L4 7c-.551 0-1 .449-1 1l0 6c0 .551.449 1 1 1l8 0c.551 0 1-.449 1-1zm-5.3501-3.3501c.18-.19.51-.19.7 0 .1.09.15.22.15.35 0 .13-.05.26-.15.35-.09.1-.22.15-.35.15-.13 0-.26-.05-.35-.15-.1-.09-.15-.22-.15-.35 0-.13.05-.26.15-.35zM5 4l0 2 6 0 0-2c0-1.654-1.346-3-3-3-1.654 0-3 1.346-3 3z"],"secure_20":["M15 7l.5 0C16.881 7 18 8.119 18 9.5l0 8c0 1.381-1.119 2.5-2.5 2.5l-11 0C3.119 20 2 18.881 2 17.5l0-8C2 8.119 3.119 7 4.5 7L5 7l0-2c0-2.757 2.243-5 5-5 2.757 0 5 2.243 5 5l0 2zm2 10.5l0-8c0-.827-.673-1.5-1.5-1.5l-11 0C3.673 8 3 8.673 3 9.5l0 8c0 .827.673 1.5 1.5 1.5l11 0c.827 0 1.5-.673 1.5-1.5zM6 5l0 2 8 0 0-2c0-2.206-1.794-4-4-4-2.206 0-4 1.794-4 4zm4 9c-.27614237 0-.5-.2238576-.5-.5 0-.2761424.22385763-.5.5-.5.27614237 0 .5.2238576.5.5 0 .2761424-.22385763.5-.5.5z"],"secure_24":["M18.541 9C19.897 9 21 10.103 21 11.459l0 10.082C21 22.897 19.897 24 18.541 24L5.459 24C4.103 24 3 22.897 3 21.541l0-10.082C3 10.103 4.103 9 5.459 9L6 9l0-2.99C6 2.696 8.696 0 12.01 0c3.315 0 6.011 2.696 6.011 6.01l0 2.99.52 0zM20 21.541l0-10.082c0-.805-.654-1.459-1.459-1.459L5.459 10C4.654 10 4 10.654 4 11.459l0 10.082C4 22.346 4.654 23 5.459 23l13.082 0c.805 0 1.459-.654 1.459-1.459zM7 6.01L7 9l10.021 0 0-2.99c0-2.762-2.248-5.01-5.011-5.01C9.248 1 7 3.248 7 6.01zM12 17c-.27614237 0-.5-.2238576-.5-.5 0-.2761424.22385763-.5.5-.5.27614237 0 .5.2238576.5.5 0 .2761424-.22385763.5-.5.5z"],"secure_28":["M22.015 9.9996c1.646 0 2.985 1.34 2.985 2.986l0 12.029c0 1.646-1.339 2.985-2.985 2.985l-16.03 0c-1.646 0-2.985-1.339-2.985-2.985l0-12.029c0-1.646 1.339-2.986 2.985-2.986l1.015 0 0-3c0-3.85 3.15-7 7-7 3.85 0 7 3.15 7 7l0 3 1.015 0zM24 25.0146l0-12.029c0-1.095-.891-1.986-1.985-1.986l-16.03 0c-1.094 0-1.985.891-1.985 1.986l0 12.029c0 1.095.891 1.985 1.985 1.985l16.03 0c1.094 0 1.985-.89 1.985-1.985zM8 6.9996l0 3 12 0 0-3c0-3.308-2.692-6-6-6-3.308 0-6 2.692-6 6zM14 18c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1z"],"secure_8":["M6 3.033c.561.085 1 .549 1 1.134l0 2.667C7 7.477 6.477 8 5.833 8L2.167 8C1.523 8 1 7.477 1 6.834l0-2.667c0-.585.439-1.049 1-1.134L2 2c0-1.1.9-2 2-2 1.1 0 2 .9 2 2l0 1.033zm0 3.801l0-2.667C6 4.075 5.925 4 5.833 4L2.167 4C2.075 4 2 4.075 2 4.167l0 2.667c0 .092.075.166.167.166l3.666 0C5.925 7 6 6.926 6 6.834zM4 1c-.552 0-1 .449-1 1l0 1 2 0 0-1c0-.551-.448-1-1-1zm.5 4c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0z"],"secure-active_12":["M9.4999 4c.829 0 1.5.671 1.5 1.5l0 5c0 .829-.671 1.5-1.5 1.5l-7 0c-.828 0-1.5-.671-1.5-1.5l0-5c0-.829.672-1.5 1.5-1.5l.5 0 0-1c0-1.65 1.35-3 3-3 1.65 0 3 1.35 3 3l0 1 .5 0zm-5.5-1l0 1 4 0 0-1c0-1.103-.897-2-2-2-1.103 0-2 .897-2 2zm2 4.5c-.276 0-.5.224-.5.5 0 .276.224.5.5.5.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5z"],"secure-active_16":["M12 6c1.104 0 2 .896 2 2l0 6c0 1.104-.896 2-2 2l-8 0c-1.104 0-2-.896-2-2l0-6c0-1.104.896-2 2-2l0-2c0-2.2 1.8-4 4-4 2.2 0 4 1.8 4 4l0 2zm-4.3501 4.6499c-.1.09-.15.22-.15.35 0 .13.05.26.15.35.09.1.22.15.35.15.13 0 .26-.05.35-.15.1-.09.15-.22.15-.35 0-.13-.05-.26-.15-.35-.19-.19-.52-.19-.7 0zM5 4l0 2 6 0 0-2c0-1.654-1.346-3-3-3-1.654 0-3 1.346-3 3z"],"secure-active_20":["M15 7l.5 0C16.881 7 18 8.119 18 9.5l0 8c0 1.381-1.119 2.5-2.5 2.5l-11 0C3.119 20 2 18.881 2 17.5l0-8C2 8.119 3.119 7 4.5 7L5 7l0-2c0-2.757 2.243-5 5-5 2.757 0 5 2.243 5 5l0 2zM6 5l0 2 8 0 0-2c0-2.206-1.794-4-4-4-2.206 0-4 1.794-4 4zm4 9c.27614237 0 .5-.2238576.5-.5 0-.2761424-.22385763-.5-.5-.5-.27614237 0-.5.2238576-.5.5 0 .2761424.22385763.5.5.5z"],"secure-active_24":["M18.541 9C19.897 9 21 10.103 21 11.459l0 10.082C21 22.897 19.897 24 18.541 24L5.459 24C4.103 24 3 22.897 3 21.541l0-10.082C3 10.103 4.103 9 5.459 9L6 9l0-2.99C6 2.696 8.696 0 12.01 0c3.315 0 6.011 2.696 6.011 6.01l0 2.99.52 0zM7 6.01L7 9l10.021 0 0-2.99c0-2.762-2.248-5.01-5.011-5.01C9.248 1 7 3.248 7 6.01zM12 17c.27614237 0 .5-.2238576.5-.5 0-.2761424-.22385763-.5-.5-.5-.27614237 0-.5.2238576-.5.5 0 .2761424.22385763.5.5.5z"],"secure-active_28":["M22.015 9.9996c1.646 0 2.985 1.34 2.985 2.986l0 12.029c0 1.646-1.339 2.985-2.985 2.985l-16.03 0c-1.646 0-2.985-1.339-2.985-2.985l0-12.029c0-1.646 1.339-2.986 2.985-2.986l1.015 0 0-3c0-3.85 3.15-7 7-7 3.85 0 7 3.15 7 7l0 3 1.015 0zM8 6.9996l0 3 12 0 0-3c0-3.308-2.692-6-6-6-3.308 0-6 2.692-6 6zM14 18c-.552 0-1 .448-1 1 0 .552.448 1 1 1 .552 0 1-.448 1-1 0-.552-.448-1-1-1z"],"secure-active_8":["M6 3.033c.561.085 1 .549 1 1.134l0 2.667C7 7.477 6.477 8 5.833 8L2.167 8C1.523 8 1 7.477 1 6.834l0-2.667c0-.585.439-1.049 1-1.134L2 2c0-1.1.9-2 2-2 1.1 0 2 .9 2 2l0 1.033zM4 1c-.552 0-1 .449-1 1l0 1 2 0 0-1c0-.551-.448-1-1-1zm.5 4l-1 0c-.275 0-.5.225-.5.5 0 .275.225.5.5.5l1 0c.275 0 .5-.225.5-.5 0-.275-.225-.5-.5-.5z"],"selfview_16":["M15 12c0 .551-.449 1-1 1l-.881 0-.246-.882c-.295-1.142-1.283-1.961-2.461-2.091C11.08 9.39 11.5 8.496 11.5 7.5 11.5 5.566 9.933 4 8 4 6.067 4 4.5 5.566 4.5 7.5c0 .996.42 1.89 1.088 2.527-1.178.13-2.166.948-2.458 2.081L2.881 13 2 13c-.551 0-1-.449-1-1l0-8c0-.551.449-1 1-1l12 0c.551 0 1 .449 1 1l0 8zm-4.914-1c.863 0 1.611.563 1.821 1.378l.174.622-8.162 0 .176-.632C4.303 11.563 5.051 11 5.914 11l4.172 0zM8 10c-1.378 0-2.5-1.121-2.5-2.5C5.5 6.121 6.622 5 8 5c1.378 0 2.5 1.121 2.5 2.5C10.5 8.879 9.378 10 8 10zm6-8L2 2C.895 2 0 2.895 0 4l0 8c0 1.105.895 2 2 2l12 0c1.105 0 2-.895 2-2l0-8c0-1.105-.895-2-2-2z"],"selfview_20":["M19 15.5c0 .827-.673 1.5-1.5 1.5l-.866 0c-.003-.017.001-.033-.003-.05l-.496-1.834c-.396-1.536-1.806-2.61-3.431-2.618.936-.779 1.546-1.939 1.546-3.251 0-2.344-1.906-4.25-4.25-4.25-2.344 0-4.25 1.906-4.25 4.25 0 1.312.61 2.472 1.546 3.251-1.625.008-3.035 1.082-3.429 2.609L3.343 17 2.5 17c-.207 0-.404-.042-.583-.118-.359-.152-.647-.441-.799-.798-.076-.18-.118-.377-.118-.584l0-11C1 3.673 1.673 3 2.5 3l15 0c.207 0 .404.042.583.118.359.152.647.441.799.798.076.18.118.377.118.584l0 11zM6.75 9.247c0-1.792 1.458-3.25 3.25-3.25 1.792 0 3.25 1.458 3.25 3.25 0 1.792-1.458 3.25-3.25 3.25-1.792 0-3.25-1.458-3.25-3.25zm5.937 4.25c1.176 0 2.196.769 2.481 1.875l.44 1.628-11.227 0 .452-1.634c.284-1.1 1.304-1.869 2.48-1.869l5.374 0zm6.885-10.393C19.123 2.437 18.362 2 17.5 2l-15 0C1.121 2 0 3.121 0 4.5l0 11c0 .518.158.998.428 1.396C.877 17.563 1.638 18 2.5 18l15 0c1.379 0 2.5-1.121 2.5-2.5l0-11c0-.518-.158-.998-.428-1.396z"],"selfview_24":["M23 18.5c0 .827-.673 1.5-1.5 1.5l-1.694 0-.541-1.932C18.8 16.262 17.138 15 15.224 15l-.255 0C16.194 14.088 17 12.641 17 11c0-2.757-2.243-5-5-5-2.757 0-5 2.243-5 5 0 1.641.806 3.088 2.031 4l-.255 0c-1.914 0-3.576 1.262-4.039 3.059L4.194 20 2.5 20c-.827 0-1.5-.673-1.5-1.5l0-13C1 4.673 1.673 4 2.5 4l19 0c.827 0 1.5.673 1.5 1.5l0 13zM8 11c0-2.206 1.794-4 4-4 2.206 0 4 1.794 4 4 0 2.206-1.794 4-4 4-2.206 0-4-1.794-4-4zm7.224 5c1.457 0 2.721.953 3.076 2.328L18.767 20 5.233 20l.47-1.682C6.055 16.953 7.319 16 8.776 16l6.448 0zM21.5 3l-19 0C1.122 3 0 4.121 0 5.5l0 13C0 19.879 1.122 21 2.5 21l19 0c1.378 0 2.5-1.121 2.5-2.5l0-13C24 4.121 22.878 3 21.5 3z"],"send_12":["M1.0293 10.9399l.999-4.44 7.898 0-8.897 4.44zm-.001-9.88l8.898 4.44-7.898 0-1-4.44zm10.454 4.099L1.3393.0979c-.131-.066-.272-.098-.413-.098-.196 0-.39.064-.555.189-.288.217-.423.575-.352.94l1.096 4.871-1.097 4.88c-.07.356.065.712.352.93.165.126.36.19.559.19.138 0 .278-.032.409-.096l.001-.001 10.141-5.061c.321-.159.52-.482.52-.842 0-.36-.199-.683-.518-.841z"],"send_14":["M12.9996525 7l0-.008.008.004-.008.004zM1.00065245 13.005l1.067-5.505 9.93200005 0-10.99900005 5.505zm.006-11.985L12.0116525 6.5l-9.94400005 0-1.061-5.48zM13.4526525 6.109L1.41165245.104c-.139-.07-.287-.104-.434-.104-.208 0-.414.068-.586.201-.3039999996.232-.4469999996.609-.3719999996.987L1.14665245 7 .0196524504 12.814c-.075.377.068.755.3719999996.987.174.132.38.199.587.199.147 0 .295-.033.433-.103L13.4536525 7.891c.337-.169.546-.509.546-.891 0-.38-.209-.721-.547-.891z"],"send_16":["M15.0001 8l0-.001 0 .001zm-13.977 6.992c-.014-.011-.028-.027-.021-.066L2.2491 8.5l11.825 0-13.051 6.492zm-.021-13.921c-.007-.037.007-.053.02-.063.007-.005.013-.008.019-.008l.015.004L14.0781 7.5l-11.829 0-1.247-6.429zm14.415 5.979L1.5021.109C1.3551.036 1.1981 0 1.0411 0c-.22 0-.438.071-.623.211-.324.246-.477.649-.398 1.053L1.3271 8l-1.307 6.735c-.079.404.074.807.398 1.053.185.14.403.212.623.212.157 0 .315-.037.461-.11l13.915-6.941c.359-.179.583-.543.583-.949 0-.407-.224-.771-.583-.95z"],"send_20":["M2.3324 18.4396l-.293-.455c-.019-.014-.048-.047-.037-.105l1.432-7.379 13.695 0-15.02 7.492.223.447zm-.33-16.318c-.011-.059.018-.092.107-.114l15.019 7.493-13.694 0-1.432-7.379zm16.393 6.893l-15.84-7.901c-.367-.184-.795-.142-1.121.106-.336.255-.495.674-.414 1.092l1.492 7.689-1.492 7.689c-.081.417.078.836.414 1.091.19.145.417.22.645.22.162 0 .324-.038.476-.114l15.841-7.901c.372-.186.603-.564.603-.985 0-.422-.231-.8-.604-.986z"],"send_24":["M2.2988 21.9785c-.029.015-.057.021-.086.021-.041 0-.081-.015-.116-.043-.077-.064-.111-.17-.093-.266l1.899-9.191 17.448 0-19.052 9.479zm-.274-19.564l0-.138-.023-.047c.007-.072.04-.138.093-.182.038-.032.079-.048.121-.048.026 0 .053.007.08.021l19.054 9.479-17.446 0-1.879-9.085zm20.29 8.449l-19.574-9.739c-.168-.083-.347-.125-.525-.125-.269 0-.534.093-.755.274-.36.297-.527.77-.436 1.237.001.002.001.006.001.008l1.96 9.48-1.961 9.49c-.091.468.076.942.436 1.239.221.182.485.272.752.272.18 0 .358-.041.528-.124l19.574-9.738c.422-.211.685-.647.685-1.139-.001-.491-.264-.926-.685-1.135z"],"seperate_12":["M1.5 8c-.275 0-.5-.225-.5-.5l0-5c0-.275.225-.5.5-.5l7 0c.275 0 .5.225.5.5L9 5 5 5c-.55 0-1 .45-1 1l0 2-2.5 0zm7-7l-7 0C.671 1 0 1.671 0 2.5l0 5C0 8.329.671 9 1.5 9L4 9l0 1c0 .55.45 1 1 1l6 0c.55 0 1-.45 1-1l0-4c0-.55-.45-1-1-1l-1 0 0-2.5C10 1.671 9.329 1 8.5 1zM11 6l0 4-6 0 0-1 0-1 0-2 4 0 1 0 1 0z"],"seperate_16":["M15 13.5c0 .276-.225.5-.5.5l-8 0c-.275 0-.5-.224-.5-.5l0-6c0-.276.225-.5.5-.5l8 0c.275 0 .5.224.5.5l0 6zm-10-6L5 11l-3 0c-.552 0-1-.448-1-1l0-7c0-.552.448-1 1-1l10 0c.552 0 1 .448 1 1l0 3-6.5 0C5.672 6 5 6.671 5 7.5zM14.5 6L14 6l0-3c0-1.104-.896-2-2-2L2 1C.896 1 0 1.896 0 3l0 7c0 1.104.896 2 2 2l3 0 0 1.5c0 .829.672 1.5 1.5 1.5l8 0c.828 0 1.5-.671 1.5-1.5l0-6c0-.829-.672-1.5-1.5-1.5z"],"seperate_20":["M19 16.252c0 .412-.335.748-.748.748l-8.504 0C9.335 17 9 16.664 9 16.252l0-5.505c0-.412.335-.747.748-.747l8.504 0c.413 0 .748.335.748.747l0 5.505zM8 10.747L8 14l-5.5 0c-.827 0-1.5-.673-1.5-1.5l0-8C1 3.672 1.673 3 2.5 3l12 0c.827 0 1.5.672 1.5 1.5L16 9 9.748 9C8.782 9 8 9.782 8 10.747zM18.252 9L17 9l0-4.5C17 3.119 15.881 2 14.5 2l-12 0C1.119 2 0 3.119 0 4.5l0 8C0 13.88 1.119 15 2.5 15L8 15l0 1.252C8 17.217 8.782 18 9.748 18l8.504 0c.966 0 1.748-.783 1.748-1.748l0-5.505C20 9.782 19.218 9 18.252 9z"],"seperate_24":["M23 20c0 .551-.448 1-1 1l-10 0c-.552 0-1-.449-1-1l0-7c0-.551.448-1 1-1l10 0c.552 0 1 .449 1 1l0 7zm-13-7l0 4-7.5 0c-.827 0-1.5-.673-1.5-1.5l0-11C1 3.673 1.673 3 2.5 3l16 0c.827 0 1.5.673 1.5 1.5l0 6.5-8 0c-1.104 0-2 .896-2 2zm12-2l-1 0 0-6.5C21 3.125 19.875 2 18.5 2l-16 0C1.125 2 0 3.125 0 4.5l0 11C0 16.875 1.125 18 2.5 18l7.5 0 0 2c0 1.104.896 2 2 2l10 0c1.104 0 2-.896 2-2l0-7c0-1.104-.896-2-2-2z"],"server_16":["M12-.0002c1.103 0 2 .897 2 2l0 12c0 1.104-.897 2-2 2l-8 0c-1.103 0-2-.896-2-2l0-12c0-1.103.897-2 2-2l8 0zm1 5l0-3c0-.551-.449-1-1-1l-8 0c-.551 0-1 .449-1 1l0 3 10 0zm-10 5l10 0 0-4-10 0 0 4zm10 4l0-3-10 0 0 3c0 .552.449 1 1 1l8 0c.551 0 1-.448 1-1zm-8.5-12c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5z"],"server_24":["M5.5 0l13 0C19.881 0 21 1.119 21 2.5l0 19c0 1.381-1.119 2.5-2.5 2.5l-13 0C4.119 24 3 22.881 3 21.5l0-19C3 1.119 4.119 0 5.5 0zM20 8l0-5.5c0-.827-.673-1.5-1.5-1.5l-13 0C4.673 1 4 1.673 4 2.5L4 8l16 0zM7.5051 4l-.01 0c.279 0 .505.232.505.5 0 .276-.214.5-.505.5l.01 0c-.279 0-.505-.232-.505-.5 0-.276.214-.5.505-.5zM4 15l16 0 0-6L4 9l0 6zm16 6.5l0-5.5-16 0 0 5.5c0 .827.673 1.5 1.5 1.5l13 0c.827 0 1.5-.673 1.5-1.5z"],"server-circle_100":["M50 0c27.57 0 50 22.43 50 50 0 27.57-22.43 50-50 50-27.57 0-50-22.43-50-50C0 22.43 22.43 0 50 0zm0 99c27.019 0 49-21.981 49-49C99 22.981 77.019 1 50 1 22.981 1 1 22.981 1 50c0 27.019 21.981 49 49 49zm14.8-71c2.316 0 4.2 1.884 4.2 4.2l0 35.6c0 2.316-1.884 4.2-4.2 4.2l-29.6 0c-2.316 0-4.2-1.884-4.2-4.2l0-35.6c0-2.316 1.884-4.2 4.2-4.2l29.6 0zM68 42l0-9.8c0-1.764-1.436-3.2-3.2-3.2l-29.6 0c-1.764 0-3.2 1.436-3.2 3.2l0 9.8 36 0zM32 57l36 0 0-14-36 0 0 14zm36 10.8l0-9.8-36 0 0 9.8c0 1.764 1.436 3.2 3.2 3.2l29.6 0c1.764 0 3.2-1.436 3.2-3.2zM38.5 35c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5z"],"settings_10":["M9.3045 4.035c.415.139.695.528.695.967l0 .002c0 .439-.28.828-.698.967l-.854.282-.125.303.402.802c.196.395.119.868-.191 1.177-.311.311-.784.389-1.177.193l-.805-.402-.302.126-.282.85c-.139.418-.527.698-.967.698-.44 0-.829-.279-.968-.696l-.285-.851-.302-.125-.8.402c-.396.199-.868.122-1.179-.19-.31-.31-.388-.782-.194-1.175l.403-.808-.125-.303-.853-.283c-.417-.139-.698-.527-.698-.967 0-.442.28-.83.697-.969l.855-.287.125-.303-.402-.803c-.196-.395-.119-.868.192-1.177.311-.311.784-.389 1.177-.193l.802.402.303-.125.284-.853c.138-.416.527-.696.967-.696.439 0 .829.279.968.696l.284.854.303.126.807-.404c.393-.197.865-.12 1.176.193.312.31.389.785.19 1.179l-.403.802.125.304.855.285zm-1.388 1.341l1.083-.372c0-.01-.004-.018-.011-.02l-1.073-.358c-.138-.046-.249-.149-.304-.284l-.299-.726c-.055-.134-.049-.285.016-.415l.506-1.008-1.038.479c-.13.064-.281.069-.415.015l-.723-.299c-.134-.056-.238-.167-.284-.305l-.356-1.07-.393 1.069c-.046.138-.15.249-.284.304l-.724.3c-.134.054-.285.05-.415-.015l-1.006-.504.476 1.035c.065.13.071.28.015.414l-.298.724c-.056.134-.166.237-.304.283l-1.072.36 1.069.394c.137.046.248.148.303.282l.302.725c.055.134.05.285-.015.414l-.504 1.012 1.032-.477c.07-.036.147-.054.224-.054.065 0 .13.013.191.037l.724.299c.135.056.238.167.284.305l.357 1.067.392-1.066c.045-.138.148-.249.283-.305l.723-.301c.135-.055.286-.05.415.015l1.01.503-.478-1.034c-.065-.13-.07-.281-.014-.415l.3-.725c.056-.134.167-.237.305-.283zM5 3c1.103 0 2 .897 2 2 0 1.103-.897 2-2 2-1.103 0-2-.897-2-2 0-1.103.897-2 2-2zm0 3c.551 0 1-.448 1-1 0-.552-.449-1-1-1-.551 0-1 .448-1 1 0 .552.449 1 1 1z"],"settings_12":["M11.226 4.926c.463.156.774.588.774 1.076l0 .003c0 .49-.313.923-.777 1.077l-1.092.36-.192.464.514 1.027c.219.437.133.964-.213 1.309-.345.346-.87.431-1.309.216L7.9 9.943l-.463.193-.36 1.087c-.154.465-.586.777-1.076.777-.491 0-.923-.31-1.078-.773l-.364-1.089-.464-.192-1.023.514c-.436.221-.965.137-1.311-.211-.024-.023-.047-.052-.065-.079-.282-.268-.368-.793-.151-1.23l.515-1.034-.193-.464-1.09-.361C.312 6.927 0 6.495 0 6.005c0-.492.311-.924.774-1.079l1.095-.367.191-.463-.514-1.029c-.217-.437-.132-.963.213-1.308.346-.348.874-.435 1.311-.215l1.026.513.464-.192.363-1.089C5.077.312 5.509 0 5.999 0c.491 0 .923.312 1.078.776l.363 1.09.463.193 1.033-.515c.439-.219.961-.135 1.309.213.348.348.433.875.212 1.312L9.94 4.097l.192.464 1.094.365zM11 6.005l0-.003c0-.058-.037-.109-.092-.127l-1.309-.438c-.138-.046-.249-.15-.304-.284l-.365-.886c-.056-.134-.05-.285.015-.415l.619-1.232c.026-.052.016-.114-.025-.155-.044-.043-.107-.052-.156-.027l-1.237.617c-.13.066-.281.07-.415.015l-.885-.367c-.134-.056-.237-.167-.283-.304l-.435-1.308c-.037-.11-.22-.106-.256 0l-.435 1.307c-.046.137-.149.248-.283.304l-.886.366c-.134.056-.285.05-.415-.014l-1.229-.615c-.052-.027-.115-.017-.155.024-.044.044-.053.106-.028.158l.616 1.232c.064.129.07.28.014.414l-.365.885c-.056.133-.166.237-.303.283l-1.311.44c-.055.018-.092.069-.092.127 0 .061.037.112.092.13l1.306.434c.138.045.248.148.304.282l.368.885c.056.133.051.285-.013.415l-.616 1.237c-.026.052-.016.113.024.154.024.023.047.052.065.079-.021-.035.041-.025.092-.05L3.85 8.95c.07-.036.148-.053.225-.053.065 0 .13.012.191.038l.886.366c.134.055.237.166.283.304l.436 1.304c.037.11.221.106.257-.001l.433-1.303c.045-.138.148-.249.282-.305l.886-.367c.133-.056.285-.052.415.014l1.233.616c.05.023.114.015.154-.026.043-.043.054-.105.028-.157l-.617-1.23c-.064-.129-.07-.281-.014-.415l.367-.887c.056-.134.167-.237.305-.282l1.308-.434c.055-.018.092-.069.092-.127zM6 4.0001c1.103 0 2 .897 2 2 0 1.103-.897 2-2 2-1.103 0-2-.897-2-2 0-1.103.897-2 2-2zm0 3c.551 0 1-.449 1-1 0-.551-.449-1-1-1-.551 0-1 .449-1 1 0 .551.449 1 1 1z"],"settings_14":["M4.7246 10.5146c.064 0 .129.013.19.038l1.047.432c.134.054.238.166.284.303l.516 1.542c.067.206.409.202.476-.001l.511-1.541c.046-.137.15-.249.284-.304l1.045-.435c.133-.055.285-.051.416.015l1.457.727c.093.046.211.03.289-.047.077-.079.095-.194.047-.291l-.728-1.453c-.064-.129-.07-.28-.015-.415l.434-1.048c.056-.133.167-.237.305-.283l1.546-.511c.103-.035.171-.129.171-.237l0-.004c0-.107-.068-.202-.169-.235l-1.549-.52c-.137-.045-.247-.148-.303-.282l-.433-1.048c-.055-.133-.05-.285.015-.415l.731-1.456c.049-.096.031-.212-.046-.289-.076-.077-.191-.096-.29-.048l-1.46.73c-.128.065-.28.07-.415.014l-1.045-.433c-.134-.056-.238-.167-.284-.304l-.513-1.545c-.07-.206-.409-.204-.477 0l-.514 1.544c-.045.138-.149.249-.284.304l-1.046.433c-.132.055-.285.049-.414-.015l-1.454-.727c-.095-.048-.213-.029-.288.047-.023.024-.052.046-.079.065.001.012-.018.129.03.223l.728 1.458c.064.13.07.282.014.414l-.432 1.045c-.055.135-.166.238-.303.283l-1.55.52c-.101.034-.17.13-.17.237 0 .112.069.206.171.241l1.544.512c.138.046.249.15.305.283l.434 1.045c.056.134.05.285-.014.414l-.728 1.463c-.048.096-.028.211.047.287.024.024.046.052.065.08.013 0 .129.019.226-.03l1.45-.729c.071-.035.148-.053.225-.053m2.276 3.485c-.541 0-1.016-.342-1.187-.852l-.443-1.326-.625-.258-1.247.627c-.484.241-1.064.147-1.445-.234-.023-.023-.046-.051-.064-.079-.318-.303-.412-.883-.172-1.363l.626-1.259-.26-.624-1.327-.44c-.513-.17-.857-.647-.857-1.186 0-.541.342-1.017.852-1.188l1.334-.448.259-.624-.626-1.252c-.24-.48-.148-1.06.232-1.441.024-.023.053-.047.08-.065.308-.319.887-.412 1.367-.172l1.249.625.624-.259.442-1.327c.171-.512.647-.855 1.186-.855.54 0 1.018.343 1.189.855l.441 1.329.624.259 1.257-.628c.482-.241 1.061-.147 1.442.233.384.387.477.967.234 1.448l-.628 1.251.258.625 1.332.447c.51.169.852.644.852 1.183l0 .004c0 .539-.343 1.016-.856 1.186l-1.33.439-.259.626.626 1.249c.241.484.148 1.064-.234 1.444-.384.382-.962.476-1.444.236l-1.252-.625-.625.259-.439 1.324c-.17.513-.647.856-1.186.856zM7 5c1.103 0 2 .897 2 2 0 1.103-.897 2-2 2-1.103 0-2-.897-2-2 0-1.103.897-2 2-2zm0 5c1.654 0 3-1.346 3-3 0-1.654-1.346-3-3-3-1.654 0-3 1.346-3 3 0 1.654 1.346 3 3 3z"],"settings_16":["M5.37562438 12.1486357c.06393606 0 .12887112.0130342.18881118.0370973l1.20879121.5003128c.13286714.0561473.23576424.1664367.28171828.3027945l.5934066 1.7836802c.1018981.3068051.6033966.2997866.7022977 0l.58941059-1.7846828c.04595405-.1363578.14885115-.2466472.28071928-.3027945l1.20679318-.5023181c.1318682-.0551447.2817183-.0501315.4115884.0140368l1.6803197.8422099c.1418582.0711868.3136863.0421105.4255744-.0701841.1138862-.1153026.1418582-.2867524.0699301-.429126l-.8391608-1.6824145c-.0639361-.1293394-.0699301-.279734-.014985-.4140866l.5004995-1.21218061c.055944-.1333499.1658341-.23662088.3026973-.28173926l1.7842157-.59255482C14.8981019 8.307557 15 8.16618606 15 8.00576513l0-.00401053c0-.15841567-.1008991-.29878398-.2507493-.34991815l-1.7862137-.59957323c-.1368632-.04511839-.2467533-.14838936-.3016983-.28173926l-.4975025-1.21218066c-.0549451-.1333499-.0499501-.28474715.014985-.41408653L13.022977 3.459837c.0709291-.14237358.0439561-.31482608-.068931-.42712073-.1148852-.11530255-.2867133-.14237358-.4275725-.07218942l-1.6833167.84421515c-.1278721.06617363-.2777222.07118679-.4115884.01503946l-1.11788209-.4652207c-.13286713-.05514469-.32367632-.20253142-.36963037-.33989185l-.59340659-1.78769075c-.1018981-.305802396-.6023976-.299786611-.7022977.00100263l-.59240759 1.78568549c-.04595405.13635779-.14885115.24664718-.28171829.30279451l-1.2057942.50131541c-.13386614.05514469-.28271728.05013154-.41158841-.01403683l-1.67632368-.84220989c-.14185814-.07218942-.31268731-.04411576-.42557443.06918153-.11488511.11530254-.14185814.28675241-.07192807.42812336l.83916084 1.68642503c.06393607.12933938.06993007.279734.01498502.4130839l-.4985015 1.2101754c-.05394606.1333499-.16483517.23561824-.2997003.28173926l-1.78821179.60157849C1.1008991 7.70196799 1 7.8423363 1 8.0017546c0 .16443146.1018981.3058024.25174825.35493131l1.78021978.59355745c.13686314.04612102.24575425.14838936.3016983.28073663l.50249751 1.21017541c.05494505.1333499.04995005.2837445-.01498502.4130839l-.83916084 1.6934434c-.06993007.1423736-.04195804.3128208.06893107.4251155.11588412.1163052.28571429.1453815.42857143.0721894l1.67332667-.8432125c.06993007-.0360947.14585415-.0531394.22277723-.0531394M8 16c-.588 0-1.107-.3739766-1.293-.9309418l-.523-1.5639023-.791-.3259796-1.472.7399538c-.526.2639835-1.157.1619898-1.574-.2539842-.417-.4169739-.52-1.0479345-.258-1.5729017l.739-1.4849072-.329-.78795071-1.566-.52096744C.375 9.11343041 0 8.59446285 0 8.00649959c0-.58996312.373-1.10893069.928-1.295919l1.575-.527967.326-.78895069-.739-1.47790763c-.263-.52396726-.16-1.15492782.255-1.57090182.416-.41797388 1.048-.52196738 1.575-.25798388l1.475.73795388.789-.32697957.522-1.566902064C6.893.373976626 7.412 0 7.998 0c.591 0 1.11.373976626 1.295.931941754l.523 1.566902066.789.3279795 1.482-.74095369c.524-.26298356 1.157-.15999 1.573.25498407.418.41897381.519 1.05193425.255 1.57690144l-.743 1.47790763.326.78895069 1.572.52696707c.557.18498843.93.703956.93 1.28991938l0 .00399975c0 .58896319-.375 1.10793075-.933 1.29291919l-1.57.5199675-.327.78895065.739 1.4749079c.263.5259671.16 1.1579276-.255 1.5729017-.419.4169739-1.052.5199675-1.573.2579838l-1.48-.7379538-.789.3279795-.519 1.5639022C9.108 15.6250234 8.588 16 8 16zM8 6c1.10271903 0 2 .89705512 2 1.9994966C10 9.10294488 9.10271903 10 8 10c-1.10271903 0-2-.89705512-2-2.0005034C6 6.89705512 6.89728097 6 8 6zm0 5c1.65458207 0 3-1.34619903 3-3.00050344C11 6.34519215 9.65458207 5 8 5 6.34541793 5 5 6.34519215 5 7.99949656 5 9.65380097 6.34541793 11 8 11z"],"settings_18":["M6.0249 13.75c.065 0 .129.013.191.038l1.369.566c.134.054.237.166.283.303l.674 2.016c.132.394.786.388.915-.001l.669-2.016c.045-.137.149-.249.283-.304l1.367-.568c.133-.055.285-.05.415.015l1.906.95c.185.093.407.056.554-.09.149-.149.185-.372.093-.557l-.953-1.902c-.065-.13-.071-.281-.015-.415l.568-1.369c.056-.135.167-.237.305-.283l2.022-.67c.197-.066.329-.248.329-.455l0-.005c0-.206-.132-.389-.328-.455l-2.024-.677c-.138-.047-.248-.15-.304-.284l-.565-1.369c-.055-.134-.049-.285.016-.415l.957-1.905c.093-.185.057-.408-.09-.554-.149-.149-.371-.186-.556-.093l-1.91.954c-.13.065-.283.069-.415.015l-1.368-.568c-.134-.055-.237-.166-.283-.303l-.672-2.02c-.134-.398-.786-.392-.915 0l-.672 2.019c-.046.137-.15.248-.284.303l-1.368.567c-.134.055-.285.051-.415-.015l-1.901-.951c-.185-.092-.407-.056-.554.09-.149.15-.185.372-.093.556l.952 1.906c.065.13.07.281.014.415l-.565 1.366c-.055.135-.166.237-.303.283l-2.027.679c-.196.066-.327.249-.327.456 0 .213.132.395.329.461l2.019.67c.137.046.248.148.304.282l.569 1.366c.055.134.051.285-.014.415l-.952 1.913c-.092.185-.056.408.09.553.15.15.373.188.558.093l1.897-.953c.071-.035.148-.053.225-.053M9.0009 18c-.641 0-1.205-.406-1.407-1.01l-.602-1.8-.946-.39-1.694.85c-.574.287-1.26.176-1.711-.278-.453-.452-.565-1.138-.282-1.707l.851-1.709-.393-.945-1.803-.598c-.606-.201-1.014-.766-1.014-1.405 0-.643.406-1.206 1.01-1.408l1.81-.607.391-.946-.85-1.701c-.285-.571-.173-1.256.278-1.707.454-.455 1.141-.568 1.711-.282l1.697.85.947-.393.6-1.801C7.7959.407 8.3599 0 8.9979 0c.642 0 1.206.407 1.408 1.013l.601 1.803.946.393 1.706-.853c.573-.286 1.259-.172 1.708.28.454.453.565 1.14.278 1.712l-.854 1.7.39.947 1.809.605c.604.203 1.01.766 1.01 1.403l0 .005c0 .638-.408 1.203-1.015 1.404l-1.805.598-.393.947.851 1.697c.285.571.175 1.257-.277 1.709-.454.453-1.141.567-1.711.281l-1.701-.849-.946.392-.597 1.799c-.201.607-.766 1.014-1.405 1.014zM9 6c1.654 0 3 1.346 3 3 0 1.654-1.346 3-3 3-1.654 0-3-1.346-3-3 0-1.654 1.346-3 3-3zm0 7c2.206 0 4-1.794 4-4 0-2.206-1.794-4-4-4-2.206 0-4 1.794-4 4 0 2.206 1.794 4 4 4z"],"settings_20":["M18.911 8.4903c.651.218 1.089.826 1.089 1.513l0 .005c0 .689-.439 1.297-1.094 1.514l-2.043.676-.46 1.109.963 1.92c.308.615.188 1.355-.299 1.842-.489.491-1.229.612-1.844.303l-1.925-.961-1.107.46-.676 2.036c-.216.653-.825 1.093-1.514 1.093-.691 0-1.299-.438-1.517-1.09l-.681-2.036-1.108-.457-1.916.962c-.617.311-1.357.19-1.845-.298-.488-.489-.609-1.228-.303-1.842l.962-1.933-.46-1.107-2.04-.676C.439 11.3053 0 10.6973 0 10.0083c0-.692.438-1.3 1.088-1.518l2.049-.687.457-1.107-.961-1.924c-.307-.615-.187-1.355.298-1.841.489-.491 1.23-.611 1.846-.303l1.921.961 1.107-.458.679-2.04c.218-.653.826-1.091 1.514-1.091.692 0 1.3.438 1.518 1.091l.68 2.041 1.107.459 1.93-.964c.615-.308 1.355-.186 1.841.3.49.49.61 1.23.3 1.847l-.967 1.923.457 1.108 2.047.685zm.089 1.518l0-.005c0-.256-.164-.483-.407-.564l-2.262-.758c-.138-.046-.248-.149-.304-.283l-.631-1.53c-.056-.134-.05-.286.015-.416l1.069-2.128c.116-.229.071-.506-.11-.688-.183-.183-.459-.228-.69-.114l-2.135 1.066c-.13.065-.282.07-.415.015l-1.528-.635c-.134-.055-.237-.166-.283-.303l-.752-2.258c-.164-.491-.972-.483-1.133-.001l-.752 2.257c-.046.137-.149.249-.284.304l-1.528.633c-.135.055-.286.051-.415-.014L4.33 3.5233c-.229-.115-.505-.07-.687.111-.185.185-.23.461-.116.69l1.064 2.129c.065.13.07.281.014.414l-.631 1.528c-.055.134-.165.238-.303.283l-2.265.76c-.243.081-.406.308-.406.565 0 .262.164.489.408.57l2.256.749c.138.046.249.149.304.283l.636 1.527c.056.134.051.285-.014.415l-1.064 2.138c-.114.229-.069.505.112.686.185.185.462.231.692.115l2.12-1.065c.071-.036.148-.054.225-.054.065 0 .129.013.191.038l1.53.631c.134.056.237.167.283.304l.753 2.253c.165.491.974.481 1.134-.001l.747-2.252c.046-.138.149-.249.283-.305l1.529-.635c.134-.055.286-.05.415.015l2.13 1.063c.23.113.505.069.687-.112.185-.186.229-.462.115-.691l-1.065-2.125c-.065-.129-.071-.281-.015-.415l.635-1.531c.056-.134.167-.238.305-.283l2.26-.748c.244-.081.408-.308.408-.565zM10 6c2.206 0 4 1.794 4 4 0 2.206-1.794 4-4 4-2.206 0-4-1.794-4-4 0-2.206 1.794-4 4-4zm0 7c1.654 0 3-1.346 3-3 0-1.654-1.346-3-3-3-1.654 0-3 1.346-3 3 0 1.654 1.346 3 3 3z"],"settings_24":["M7.975 18.603c.065 0 .129.013.191.038l1.852.765c.134.055.238.166.284.303l.912 2.727c.113.338.428.564.783.564.361 0 .676-.227.789-.565l.904-2.727c.046-.137.149-.248.283-.304l1.851-.769c.133-.055.286-.05.415.015l2.578 1.286c.318.158.701.097.953-.155.256-.256.318-.639.158-.958l-1.288-2.572c-.065-.129-.071-.281-.015-.416l.769-1.852c.056-.134.167-.237.305-.283l2.735-.906c.339-.112.566-.427.566-.784l0-.006c0-.355-.226-.67-.564-.783l-2.739-.916c-.138-.046-.248-.149-.304-.284l-.764-1.852c-.055-.134-.049-.286.016-.416l1.294-2.575c.161-.319.099-.702-.153-.955-.255-.255-.638-.317-.957-.158l-2.584 1.29c-.13.064-.283.069-.415.015l-1.85-.767c-.134-.056-.237-.167-.283-.304l-.91-2.734c-.113-.337-.428-.565-.784-.565-.361 0-.676.228-.788.565l-.91 2.732c-.046.137-.149.248-.283.304l-1.851.766c-.134.056-.285.05-.415-.014L5.184 4.066c-.319-.16-.702-.097-.954.155-.255.256-.318.639-.159.957l1.287 2.576c.065.129.071.281.015.414l-.764 1.85c-.055.134-.166.237-.303.283l-2.742.92c-.337.112-.564.427-.564.783 0 .364.228.679.566.791l2.732.906c.137.046.249.149.304.283l.769 1.849c.056.134.051.285-.014.415L4.07 18.835c-.159.318-.096.701.155.952.256.257.641.319.959.159l2.566-1.29c.071-.035.148-.053.225-.053M12.002 24c-.792 0-1.487-.501-1.736-1.246l-.84-2.511-1.43-.591-2.363 1.187c-.705.354-1.554.217-2.111-.34-.56-.561-.697-1.406-.348-2.109l1.186-2.384-.593-1.427-2.516-.835C.503 13.495 0 12.799 0 12.011c0-.793.501-1.489 1.246-1.739l2.526-.846.59-1.429-1.185-2.372c-.352-.704-.215-1.55.341-2.107.561-.561 1.41-.699 2.113-.347l2.368 1.185 1.429-.592.838-2.515C10.514.502 11.21 0 11.998 0c.792 0 1.488.502 1.737 1.249l.839 2.517 1.428.592 2.381-1.188c.704-.352 1.551-.213 2.107.343.561.561.697 1.409.343 2.114l-1.192 2.372.59 1.43 2.523.844c.745.249 1.246.945 1.246 1.731l0 .006c0 .789-.503 1.486-1.252 1.734l-2.518.834-.594 1.43 1.187 2.367c.352.705.215 1.552-.341 2.109-.561.56-1.407.699-2.111.347l-2.375-1.185-1.428.594-.833 2.51c-.248.748-.945 1.25-1.733 1.25zm-.0016-15.9995c2.206 0 4 1.794 4 4 0 2.206-1.794 4-4 4-2.206 0-4-1.794-4-4 0-2.206 1.794-4 4-4zm0 9c2.757 0 5-2.243 5-5 0-2.757-2.243-5-5-5-2.757 0-5 2.243-5 5 0 2.757 2.243 5 5 5z"],"settings_32":["M30.438 13.836c.935.314 1.562 1.186 1.562 2.17l0 .008c0 .988-.63 1.86-1.568 2.171l-3.47 1.148-.86 2.076 1.633 3.261c.442.882.27 1.944-.427 2.642-.704.702-1.766.874-2.644.435l-3.271-1.632-2.074.861-1.146 3.457C17.861 31.37 16.989 32 16.002 32c-.992 0-1.864-.628-2.176-1.562l-1.156-3.459-2.075-.857-3.255 1.636c-.88.442-1.944.275-2.645-.427-.701-.701-.874-1.76-.435-2.641l1.634-3.283-.862-2.073-3.465-1.149C.63 17.874 0 17.002 0 16.015c0-.994.627-1.865 1.56-2.178l3.479-1.167.857-2.072-1.633-3.269c-.441-.88-.269-1.942.427-2.639.703-.703 1.763-.874 2.648-.435L10.6 5.888l2.073-.859 1.153-3.464C14.138.629 15.011 0 15.997 0c.992 0 1.865.629 2.177 1.565l1.154 3.468 2.072.859 3.279-1.638c.884-.441 1.943-.267 2.639.43.703.703.874 1.766.431 2.647l-1.642 3.268.856 2.075 3.475 1.162zM31 16.014l0-.008c0-.554-.354-1.045-.879-1.221L26.43 13.55c-.138-.047-.249-.149-.304-.284l-1.03-2.497c-.056-.134-.05-.285.015-.415l1.745-3.472c.249-.496.153-1.094-.24-1.487-.397-.398-.994-.491-1.49-.246l-3.482 1.739c-.129.065-.281.07-.415.015l-2.495-1.035c-.133-.055-.237-.166-.283-.303l-1.226-3.684C17.05 1.354 16.559 1 16.003 1c-.562 0-1.053.354-1.228.881L13.55 5.562c-.046.138-.15.248-.283.304l-2.496 1.033c-.134.055-.286.05-.415-.015L6.891 5.15c-.497-.248-1.094-.151-1.488.242-.397.397-.494.994-.246 1.49l1.736 3.473c.064.13.07.281.014.415l-1.031 2.493c-.055.134-.166.236-.303.282l-3.695 1.24c-.525.176-.878.667-.878 1.22 0 .566.354 1.056.882 1.231l3.681 1.221c.138.046.25.149.305.284l1.036 2.493c.056.134.05.284-.014.414l-1.736 3.487c-.246.496-.149 1.092.242 1.483.401.401.999.495 1.495.247l3.459-1.739c.07-.035.147-.052.224-.052.065 0 .13.012.191.038l2.497 1.03c.134.055.237.166.284.304l1.229 3.675c.175.526.665.879 1.22.879.563 0 1.053-.354 1.229-.882l1.218-3.673c.046-.138.149-.249.283-.305l2.495-1.036c.133-.055.284-.051.415.014l3.475 1.735c.495.247 1.093.15 1.486-.242.397-.399.494-.996.245-1.493l-1.737-3.466c-.064-.129-.07-.282-.014-.415l1.036-2.497c.056-.135.167-.238.305-.284l3.686-1.22c.529-.175.883-.666.883-1.222zm-15-6.0137c3.309 0 6 2.691 6 6 0 3.309-2.691 6-6 6-3.309 0-6-2.691-6-6 0-3.309 2.691-6 6-6zm0 11c2.757 0 5-2.243 5-5 0-2.757-2.243-5-5-5-2.757 0-5 2.243-5 5 0 2.757 2.243 5 5 5z"],"settings_8":["M7.38207724 3.145C7.75303087 3.269 8 3.613 8 4.001l0 .002c0 .391-.24996875.736-.62092238.858l-.61492314.203-.05799275.142.28996375.579c.17397826.346.10598676.765-.167979 1.042-.007999.009-.01799775.017-.02699662.025-.27396576.255-.67791526.315-1.01687289.148l-.58192726-.291-.14098238.059-.20297463.613c-.12498438.371-.46894138.619-.85789276.619-.38995126 0-.73490814-.247-.85889264-.616l-.20497438-.614-.14098238-.059-.57792776.29c-.3479565.175-.76890388.106-1.04386951-.169-.274965631-.275-.343957007-.694-.17097863-1.042l.28996376-.584-.05899263-.142-.614923135-.203C.248968879 4.738 0 4.394 0 4.003c0-.392.247969004-.736.61792276-.859l.61692288-.207.05899263-.142-.28996375-.58c-.173978257-.347-.105986756-.766.167979-1.042.27796525-.279.69791276-.346 1.04586926-.171l.57792776.289.14198226-.058.2039745-.615C3.26459193.249 3.60954881 0 3.99950006 0c.38995126 0 .73490814.249.85889264.618l.2039745.615.14198226.059.58192726-.291c.34695663-.174.76590426-.106 1.04286964.17.2759655.277.343957.697.16897887 1.045l-.29096363.58.05799276.142.61692288.207zm-.98336572 1.05528638L7 4.00053696l-.6023622-.20082334c-.14817466-.04940039-.26735863-.16001432-.32641375-.30499373l-.24910522-.60461787c-.06012885-.14390549-.05368647-.30714158.01610594-.44567746l.28346456-.56703061-.56692913.28458923c-.13851109.06873098-.29957051.07517451-.44559771.0150349l-.60558339-.25022374c-.14387974-.06013961-.25447387-.1793449-.30386543-.32647216L4 1l-.19863994.59924825c-.04939156.14820119-.16105942.26740648-.30493916.32647217l-.58518253.24270628c-.14387974.06013961-.32641375.06228746-.46492484-.00751745l-.56585541-.2835153.28346457.56703061c.06979241.13960981.07516106.30177197.01610594.44567746l-.25017895.60461787c-.05905512.14283157-.17823909.25344549-.32534002.30284589L1 4.00053696l.60128848.19974942c.14710093.04940039.26628489.16001432.32534001.30391981l.25232641.60354394c.05905512.1439055.0547602.30606766-.01503221.44567747l-.28346457.57132629.56370795-.2835153c.07516106-.03758726.15783822-.05691785.24051539-.05691785.06871868 0 .1385111.01396099.20400859.04080903l.60665712.25022373c.14387974.05799177.25447388.17827099.30386543.32539825L4 7l.19863994-.59924825c.04939156-.14712726.15998569-.26740648.30386543-.32647217l.60450966-.25129766c.14387974-.06013961.30493916-.05369608.44559771.01610883l.56692914.2835153-.28346457-.56703061c-.06979241-.13960981-.07623479-.30177197-.01610594-.44675138l.25125268-.60569179c.06012885-.14390549.17931281-.25451942.32748747-.30284589zM4.00050025 3C4.55177589 3 5 3.449 5 4c0 .551-.44822411 1-.99949975 1C3.44822411 5 3 4.551 3 4c0-.551.44822411-1 1.00050025-1z"],"settings-active_10":["M9.3045 4.035c.415.139.695.528.695.967l0 .002c0 .439-.28.828-.698.967l-.854.282-.125.303.402.802c.196.395.119.868-.191 1.177-.311.311-.784.389-1.177.193l-.805-.402-.302.126-.282.85c-.139.418-.527.698-.967.698-.44 0-.829-.279-.968-.696l-.285-.851-.302-.125-.8.402c-.396.199-.868.122-1.179-.19-.31-.31-.388-.782-.194-1.175l.403-.808-.125-.303-.853-.283c-.417-.139-.698-.527-.698-.967 0-.442.28-.83.697-.969l.855-.287.125-.303-.402-.803c-.196-.395-.119-.868.192-1.177.311-.311.784-.389 1.177-.193l.802.402.303-.125.284-.853c.138-.416.527-.696.967-.696.439 0 .829.279.968.696l.284.854.303.126.807-.404c.393-.197.865-.12 1.176.193.312.31.389.785.19 1.179l-.403.802.125.304.855.285zM5 6c.551 0 1-.448 1-1 0-.552-.449-1-1-1-.551 0-1 .448-1 1 0 .552.449 1 1 1z"],"settings-active_12":["M11.226 4.926c.463.156.774.588.774 1.076l0 .003c0 .49-.313.923-.777 1.077l-1.092.36-.192.464.514 1.027c.219.437.133.964-.213 1.309-.345.346-.87.431-1.309.216L7.9 9.943l-.463.193-.36 1.087c-.154.465-.586.777-1.076.777-.491 0-.923-.31-1.078-.773l-.364-1.089-.464-.192-1.023.514c-.436.221-.965.137-1.311-.211-.024-.023-.047-.052-.065-.079-.282-.268-.368-.793-.151-1.23l.515-1.034-.193-.464-1.09-.361C.312 6.927 0 6.495 0 6.005c0-.492.311-.924.774-1.079l1.095-.367.191-.463-.514-1.029c-.217-.437-.132-.963.213-1.308.346-.348.874-.435 1.311-.215l1.026.513.464-.192.363-1.089C5.077.312 5.509 0 5.999 0c.491 0 .923.312 1.078.776l.363 1.09.463.193 1.033-.515c.439-.219.961-.135 1.309.213.348.348.433.875.212 1.312L9.94 4.097l.192.464 1.094.365zM6 7.0001c.551 0 1-.449 1-1 0-.551-.449-1-1-1-.551 0-1 .449-1 1 0 .551.449 1 1 1z"],"settings-active_14":["M7.0006 13.9996c-.541 0-1.016-.342-1.187-.852l-.443-1.326-.625-.258-1.247.627c-.484.241-1.064.147-1.445-.234-.023-.023-.046-.051-.064-.079-.318-.303-.412-.883-.172-1.363l.626-1.259-.26-.624-1.327-.44c-.513-.17-.857-.647-.857-1.186 0-.541.342-1.017.852-1.188l1.334-.448.259-.624-.626-1.252c-.24-.48-.148-1.06.232-1.441.024-.023.053-.047.08-.065.308-.319.887-.412 1.367-.172l1.249.625.624-.259.442-1.327c.171-.512.647-.855 1.186-.855.54 0 1.018.343 1.189.855l.441 1.329.624.259 1.257-.628c.482-.241 1.061-.147 1.442.233.384.387.477.967.234 1.448l-.628 1.251.258.625 1.332.447c.51.169.852.644.852 1.183l0 .004c0 .539-.343 1.016-.856 1.186l-1.33.439-.259.626.626 1.249c.241.484.148 1.064-.234 1.444-.384.382-.962.476-1.444.236l-1.252-.625-.625.259-.439 1.324c-.17.513-.647.856-1.186.856zM7 5c-1.103 0-2 .897-2 2 0 1.103.897 2 2 2 1.103 0 2-.897 2-2 0-1.103-.897-2-2-2z"],"settings-active_16":["M8 16c-.588 0-1.107-.3739766-1.293-.9309418l-.523-1.5639023-.791-.3259796-1.472.7399538c-.526.2639835-1.157.1619898-1.574-.2539842-.417-.4169739-.52-1.0479345-.258-1.5729017l.739-1.4849072-.329-.78795071-1.566-.52096744C.375 9.11343041 0 8.59446285 0 8.00649959c0-.58996312.373-1.10893069.928-1.295919l1.575-.527967.326-.78895069-.739-1.47790763c-.263-.52396726-.16-1.15492782.255-1.57090182.416-.41797388 1.048-.52196738 1.575-.25798388l1.475.73795388.789-.32697957.522-1.566902064C6.893.373976626 7.412 0 7.998 0c.591 0 1.11.373976626 1.295.931941754l.523 1.566902066.789.3279795 1.482-.74095369c.524-.26298356 1.157-.15999 1.573.25498407.418.41897381.519 1.05193425.255 1.57690144l-.743 1.47790763.326.78895069 1.572.52696707c.557.18498843.93.703956.93 1.28991938l0 .00399975c0 .58896319-.375 1.10793075-.933 1.29291919l-1.57.5199675-.327.78895065.739 1.4749079c.263.5259671.16 1.1579276-.255 1.5729017-.419.4169739-1.052.5199675-1.573.2579838l-1.48-.7379538-.789.3279795-.519 1.5639022C9.108 15.6250234 8.588 16 8 16zM8 6c-1.10271903 0-2 .89705512-2 1.9994966C6 9.10294488 6.89728097 10 8 10c1.10271903 0 2-.89705512 2-2.0005034C10 6.89705512 9.10271903 6 8 6z"],"settings-active_18":["M9.0009 18c-.641 0-1.205-.406-1.407-1.01l-.602-1.8-.946-.39-1.694.85c-.574.287-1.26.176-1.711-.278-.453-.452-.565-1.138-.282-1.707l.851-1.709-.393-.945-1.803-.598c-.606-.201-1.014-.766-1.014-1.405 0-.643.406-1.206 1.01-1.408l1.81-.607.391-.946-.85-1.701c-.285-.571-.173-1.256.278-1.707.454-.455 1.141-.568 1.711-.282l1.697.85.947-.393.6-1.801C7.7959.407 8.3599 0 8.9979 0c.642 0 1.206.407 1.408 1.013l.601 1.803.946.393 1.706-.853c.573-.286 1.259-.172 1.708.28.454.453.565 1.14.278 1.712l-.854 1.7.39.947 1.809.605c.604.203 1.01.766 1.01 1.403l0 .005c0 .638-.408 1.203-1.015 1.404l-1.805.598-.393.947.851 1.697c.285.571.175 1.257-.277 1.709-.454.453-1.141.567-1.711.281l-1.701-.849-.946.392-.597 1.799c-.201.607-.766 1.014-1.405 1.014zM9 6C7.346 6 6 7.346 6 9c0 1.654 1.346 3 3 3 1.654 0 3-1.346 3-3 0-1.654-1.346-3-3-3z"],"settings-active_20":["M18.911 8.4903c.651.218 1.089.826 1.089 1.513l0 .005c0 .689-.439 1.297-1.094 1.514l-2.043.676-.46 1.109.963 1.92c.308.615.188 1.355-.299 1.842-.489.491-1.229.612-1.844.303l-1.925-.961-1.107.46-.676 2.036c-.216.653-.825 1.093-1.514 1.093-.691 0-1.299-.438-1.517-1.09l-.681-2.036-1.108-.457-1.916.962c-.617.311-1.357.19-1.845-.298-.488-.489-.609-1.228-.303-1.842l.962-1.933-.46-1.107-2.04-.676C.439 11.3053 0 10.6973 0 10.0083c0-.692.438-1.3 1.088-1.518l2.049-.687.457-1.107-.961-1.924c-.307-.615-.187-1.355.298-1.841.489-.491 1.23-.611 1.846-.303l1.921.961 1.107-.458.679-2.04c.218-.653.826-1.091 1.514-1.091.692 0 1.3.438 1.518 1.091l.68 2.041 1.107.459 1.93-.964c.615-.308 1.355-.186 1.841.3.49.49.61 1.23.3 1.847l-.967 1.923.457 1.108 2.047.685zM10 6c-2.206 0-4 1.794-4 4 0 2.206 1.794 4 4 4 2.206 0 4-1.794 4-4 0-2.206-1.794-4-4-4z"],"settings-active_24":["M12.002 24c-.792 0-1.487-.501-1.736-1.246l-.84-2.511-1.43-.591-2.363 1.187c-.705.354-1.554.217-2.111-.34-.56-.561-.697-1.406-.348-2.109l1.186-2.384-.593-1.427-2.516-.835C.503 13.495 0 12.799 0 12.011c0-.793.501-1.489 1.246-1.739l2.526-.846.59-1.429-1.185-2.372c-.352-.704-.215-1.55.341-2.107.561-.561 1.41-.699 2.113-.347l2.368 1.185 1.429-.592.838-2.515C10.514.502 11.21 0 11.998 0c.792 0 1.488.502 1.737 1.249l.839 2.517 1.428.592 2.381-1.188c.704-.352 1.551-.213 2.107.343.561.561.697 1.409.343 2.114l-1.192 2.372.59 1.43 2.523.844c.745.249 1.246.945 1.246 1.731l0 .006c0 .789-.503 1.486-1.252 1.734l-2.518.834-.594 1.43 1.187 2.367c.352.705.215 1.552-.341 2.109-.561.56-1.407.699-2.111.347l-2.375-1.185-1.428.594-.833 2.51c-.248.748-.945 1.25-1.733 1.25zm-.0016-15.9995c-2.206 0-4 1.794-4 4 0 2.206 1.794 4 4 4 2.206 0 4-1.794 4-4 0-2.206-1.794-4-4-4z"],"settings-active_32":["M30.438 13.836c.935.314 1.562 1.186 1.562 2.17l0 .008c0 .988-.63 1.86-1.568 2.171l-3.47 1.148-.86 2.076 1.633 3.261c.442.882.27 1.944-.427 2.642-.704.702-1.766.874-2.644.435l-3.271-1.632-2.074.861-1.146 3.457C17.861 31.37 16.989 32 16.002 32c-.992 0-1.864-.628-2.176-1.562l-1.156-3.459-2.075-.857-3.255 1.636c-.88.442-1.944.275-2.645-.427-.701-.701-.874-1.76-.435-2.641l1.634-3.283-.862-2.073-3.465-1.149C.63 17.874 0 17.002 0 16.015c0-.994.627-1.865 1.56-2.178l3.479-1.167.857-2.072-1.633-3.269c-.441-.88-.269-1.942.427-2.639.703-.703 1.763-.874 2.648-.435L10.6 5.888l2.073-.859 1.153-3.464C14.138.629 15.011 0 15.997 0c.992 0 1.865.629 2.177 1.565l1.154 3.468 2.072.859 3.279-1.638c.884-.441 1.943-.267 2.639.43.703.703.874 1.766.431 2.647l-1.642 3.268.856 2.075 3.475 1.162zM16 21.0003c2.757 0 5-2.243 5-5 0-2.757-2.243-5-5-5-2.757 0-5 2.243-5 5 0 2.757 2.243 5 5 5z"],"settings-active_8":["M7.38207724 3.145C7.75303087 3.269 8 3.613 8 4.001l0 .002c0 .391-.24996875.736-.62092238.858l-.61492314.203-.05799275.142.28996375.579c.17397826.346.10598676.765-.167979 1.042-.007999.009-.01799775.017-.02699662.025-.27396576.255-.67791526.315-1.01687289.148l-.58192726-.291-.14098238.059-.20297463.613c-.12498438.371-.46894138.619-.85789276.619-.38995126 0-.73490814-.247-.85889264-.616l-.20497438-.614-.14098238-.059-.57792776.29c-.3479565.175-.76890388.106-1.04386951-.169-.274965631-.275-.343957007-.694-.17097863-1.042l.28996376-.584-.05899263-.142-.614923135-.203C.248968879 4.738 0 4.394 0 4.003c0-.392.247969004-.736.61792276-.859l.61692288-.207.05899263-.142-.28996375-.58c-.173978257-.347-.105986756-.766.167979-1.042.27796525-.279.69791276-.346 1.04586926-.171l.57792776.289.14198226-.058.2039745-.615C3.26459193.249 3.60954881 0 3.99950006 0c.38995126 0 .73490814.249.85889264.618l.2039745.615.14198226.059.58192726-.291c.34695663-.174.76590426-.106 1.04286964.17.2759655.277.343957.697.16897887 1.045l-.29096363.58.05799276.142.61692288.207zM4.00050025 3C3.44822411 3 3 3.449 3 4c0 .551.44822411 1 1.00050025 1C4.55177589 5 5 4.551 5 4c0-.551-.44822411-1-.99949975-1z"],"setup-assistant_16":["M8 1C4.14 1 1 4.14 1 8c0 3.86 3.14 7 7 7 3.86 0 7-3.14 7-7 0-3.86-3.14-7-7-7m0 15c-4.411 0-8-3.589-8-8 0-4.411 3.589-8 8-8 4.411 0 8 3.589 8 8 0 4.411-3.589 8-8 8zm-1.25-4.2402c.201 0 .391-.122.467-.321.099-.258-.03-.547-.288-.646-.791-.303-1.419-.931-1.722-1.722-.099-.258-.388-.386-.646-.288-.258.099-.387.389-.288.646.405 1.056 1.243 1.893 2.298 2.298.059.022.119.033.179.033zm2.5 0c.06 0 .12-.011.179-.033 1.055-.405 1.893-1.242 2.298-2.298.099-.257-.03-.547-.288-.646-.257-.098-.547.031-.646.288-.303.791-.931 1.419-1.722 1.722-.258.099-.387.388-.288.646.076.199.266.321.467.321zM11.2598 7.25c.06 0 .12-.011.179-.033.258-.099.387-.388.288-.646-.405-1.055-1.242-1.893-2.298-2.298-.258-.098-.547.031-.646.288-.099.258.03.547.288.646.791.303 1.419.931 1.722 1.722.076.199.266.321.467.321zm-6.5196 0c.201 0 .391-.122.467-.321.303-.791.931-1.419 1.722-1.722.258-.099.387-.388.288-.646-.099-.257-.387-.386-.646-.288-1.056.405-1.893 1.243-2.298 2.298-.099.258.03.547.288.646.059.022.119.033.179.033z"],"shake-device_18":["M8.7969 0c-.171 0-.345.022-.519.069l-5.795 1.553c-1.067.285-1.7 1.382-1.415 2.449l3.339 12.446c.24.894 1.048 1.483 1.931 1.483.171 0 .346-.022.519-.069l5.795-1.553c1.067-.285 1.701-1.382 1.415-2.449l-3.339-12.446C10.4879.589 9.6799 0 8.7969 0m0 1c.451 0 .848.305.965.742l3.339 12.446c.142.532-.175 1.082-.707 1.225l-5.796 1.552c-.086.023-.173.035-.26.035-.451 0-.848-.305-.965-.742L2.0339 3.812c-.069-.258-.033-.527.1-.759.134-.231.35-.396.608-.466l5.795-1.552c.086-.023.173-.035.26-.035zm5.7754 10.54c-.13 0-.26-.05-.36-.14-.04-.05-.08-.11-.1-.17-.03-.06-.04-.12-.04-.19 0-.13.05-.26.14-.35.19-.19.53-.19.71 0 .05.04.08.1.11.16.03.06.04.13.04.19 0 .07-.01.13-.04.19-.03.06-.06.12-.11.17-.09.09-.22.14-.35.14zm-.6899-9.1504c-.27-.07-.43-.35-.36-.61.08-.27.35-.43.62-.36.26.08.42.35.35.62-.06.22-.26.37-.48.37-.05 0-.09-.01-.13-.02zm1.69.69c-.18-.21-.16-.52.05-.7.21-.18.52-.16.71.05.17.21.15.52-.06.7-.09.09-.21.13-.32.13-.14 0-.28-.06-.38-.18zm.54 2.19c-.26-.07-.42-.35-.35-.61.07-.27.35-.43.61-.35.27.07.43.34.36.61-.06.22-.26.37-.49.37-.04 0-.08-.01-.13-.02zm-.55 2.08c-.27-.07-.43-.34-.36-.61.07-.26.35-.42.61-.35.27.07.43.34.36.61-.06.23-.26.37-.49.37-.04 0-.08 0-.12-.02zm-.56 2.09c-.27-.07-.43-.35-.36-.61.08-.27.35-.43.62-.36.26.08.42.35.35.62-.06.22-.26.37-.48.37-.05 0-.09-.01-.13-.02zm-3.08-7.59c-.07 0-.13-.01-.19-.04-.07-.03-.12-.06-.17-.11-.04-.04-.08-.1-.1-.16-.03-.06-.04-.13-.04-.19 0-.07.01-.13.04-.19.02-.06.06-.12.1-.16.05-.05.1-.09.17-.11.18-.08.4-.04.54.11.05.04.08.1.11.16.02.06.04.12.04.19 0 .06-.02.13-.04.19-.03.06-.06.12-.11.16-.09.09-.22.15-.35.15z"],"shake-device_20":["M9.6637 0c-.19 0-.384.024-.577.076l-6.439 1.726c-1.186.317-1.889 1.536-1.571 2.721l3.71 13.83c.265.992 1.164 1.647 2.145 1.647.19 0 .383-.024.576-.076l6.44-1.726c1.185-.317 1.888-1.536 1.571-2.721l-3.71-13.83C11.5427.655 10.6447 0 9.6637 0m0 1c.551 0 1.036.373 1.179.907l3.71 13.828c.085.316.041.645-.122.928-.163.282-.427.485-.742.569l-6.44 1.726c-.104.028-.211.042-.317.042-.552 0-1.037-.373-1.18-.907l-3.71-13.828c-.084-.316-.041-.645.122-.928.164-.282.427-.485.743-.569l6.439-1.726c.105-.028.212-.042.318-.042zm2.9765.7197c-.27-.07-.43-.35-.36-.61.07-.27.35-.43.62-.35.26.07.42.34.35.61-.06.22-.26.37-.48.37-.05 0-.09-.01-.13-.02zm1.93.52c-.27-.07-.43-.35-.36-.61.08-.27.35-.43.62-.36.26.07.42.35.35.62-.06.22-.26.37-.48.37-.05 0-.09-.01-.13-.02zm1.93.52c-.27-.08-.42-.35-.35-.62.07-.26.34-.42.61-.35.27.07.42.35.35.61-.06.23-.26.37-.48.37-.04 0-.09 0-.13-.01zm1.3.84c-.14-.25-.05-.55.19-.69.24-.13.55-.05.68.2.14.24.05.54-.19.68-.08.04-.16.06-.25.06-.17 0-.34-.09-.43-.25zm.4 2.17c-.27-.07-.43-.35-.36-.62.07-.26.35-.42.61-.35.27.07.43.35.36.62-.06.22-.27.37-.49.37-.04 0-.08-.01-.12-.02zm-.52 1.93c-.27-.07-.43-.35-.36-.61.08-.27.35-.43.62-.36.26.08.42.35.35.62-.06.22-.26.37-.48.37-.05 0-.09-.01-.13-.02zm-.52 1.93c-.27-.07-.43-.34-.36-.61.08-.27.35-.43.62-.36.26.08.42.35.35.62-.06.22-.26.37-.48.37-.04 0-.09-.01-.13-.02zm-.52 1.93c-.27-.07-.42-.34-.35-.61.07-.27.34-.42.61-.35.27.07.42.34.35.61-.06.22-.26.37-.48.37-.04 0-.09-.01-.13-.02zm-.52 1.93c-.26-.07-.42-.34-.35-.61.07-.27.34-.42.61-.35.27.07.43.35.36.61-.06.22-.27.37-.49.37-.04 0-.08 0-.13-.02z"],"shape-diagonal-arrowhead-dual_16":["M13.9614 2.3091c-.05-.123-.148-.22-.271-.271-.061-.025-.125-.038-.19-.038l-5 0c-.277 0-.5.224-.5.5 0 .276.223.5.5.5l3.793 0-9.293 9.293 0-3.793c0-.276-.224-.5-.5-.5-.277 0-.5.224-.5.5l0 5c0 .065.013.13.038.191.05.122.148.22.271.27.061.026.126.039.191.039l5 0c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5l-3.793 0 9.293-9.293 0 3.793c0 .276.223.5.5.5.276 0 .5-.224.5-.5l0-5c0-.065-.014-.13-.039-.191"],"shape-diagonal-arrowhead-single_16":["M13.9614 2.3091c-.05-.123-.148-.22-.271-.271-.061-.025-.125-.038-.19-.038l-5 0c-.277 0-.5.224-.5.5 0 .276.223.5.5.5l3.793 0-10.147 10.146c-.195.196-.195.512 0 .707.098.098.226.147.354.147.128 0 .255-.049.353-.147l10.147-10.146 0 3.793c0 .276.223.5.5.5.276 0 .5-.224.5-.5l0-5c0-.065-.014-.13-.039-.191"],"shape-diagonal-line_16":["M2.5 14c-.128 0-.256-.049-.354-.146-.195-.196-.195-.512 0-.708l11-11c.196-.195.512-.195.708 0 .195.196.195.512 0 .708l-11 11c-.098.097-.226.146-.354.146"],"shape-oval_16":["M8 3C4.14 3 1 5.243 1 8c0 2.757 3.14 5 7 5 3.86 0 7-2.243 7-5 0-2.757-3.14-5-7-5m0 11c-4.411 0-8-2.691-8-6 0-3.309 3.589-6 8-6 4.411 0 8 2.691 8 6 0 3.309-3.589 6-8 6"],"shape-square_16":["M2 1c-.551 0-1 .449-1 1l0 12c0 .551.449 1 1 1l12 0c.551 0 1-.449 1-1l0-12c0-.551-.449-1-1-1L2 1zm12 15L2 16c-1.103 0-2-.897-2-2L0 2C0 .897.897 0 2 0l12 0c1.103 0 2 .897 2 2l0 12c0 1.103-.897 2-2 2z"],"share_12":["M5.65225 1.146c.098-.098.226-.146.354-.146.127 0 .255.048.353.146l3.022 3.021c.195.196.195.512 0 .708-.196.195-.512.195-.708 0l-2.167-2.168 0 5.793c0 .276-.224.5-.5.5-.277 0-.5-.224-.5-.5l0-5.793-2.153 2.152c-.195.195-.512.195-.707 0-.195-.195-.195-.512 0-.707l3.006-3.006zM1.5 10l9 0c.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5l-9 0c-.276142375 0-.5-.22385763-.5-.5 0-.27614237.223857625-.5.5-.5z"],"share_14":["M6.64725 1.146c.098-.098.226-.146.354-.146.127 0 .256.048.354.146l3.999 4.001c.195.195.195.512 0 .707-.196.195-.512.195-.707 0l-3.147-3.148 0 7.794c0 .276-.225.5-.5.5-.277 0-.5-.224-.5-.5l0-7.792-3.147 3.147c-.195.195-.512.195-.707 0-.195-.195-.195-.512 0-.707l4.001-4.002zm5.8057913 10.8535c.3010932 0 .5454587.224112.5454587.50025 0 .276138-.2443655.50025-.5454587.50025L1.544958678 13C1.243865488 13 .9995 12.775888.9995 12.49975c0-.276138.244365488-.50025.545458678-.50025l10.908082622 0z"],"share_16":["M8.35425 1.146005214l3.999 4.000142866c.196.19500696.196.51201828 0 .70702525-.195.19500696-.511.19500696-.707 0l-3.146-3.14611236 0 8.79331403c0 .2760099-.224.5000179-.5.5000179-.276 0-.5-.224008-.5-.5000179l0-8.79331403-3.147 3.14611236c-.195.19500696-.511.19500696-.707 0-.195-.19500697-.195-.51201829 0-.70702525l4-4.000142866c.046-.045001607.101-.0820029282.163-.1080038568C7.87025 1.0120004286 7.93525 1 8.00025 1c.065 0 .13.0120004286.191.0380013572.061.0260009286.117.0630022498.163.1080038568zM14.4615385 13.9999643c.2972307 0 .5384615.225008.5384615.5000178C15 14.775992 14.7587692 15 14.4615385 15L1.538461538 15C1.241230769 15 1 14.775992 1 14.4999821c0-.2750098.241230769-.5000178.538461538-.5000178l12.923076962 0z"],"share_18":["M8.64354861 2.148c.04699359-.047.10298595-.084.16597736-.11.02999591-.012.06199155-.013.09298732-.019.03199564-.007.06199155-.019.09598691-.019.03499523 0 .06399128.012.09698678.019.03099577.006.06299141.007.09298732.019.06199155.026.11898377.063.1649775.11l5.0003181 4.999c.1949735.195.1949735.512 0 .707-.1949734.195-.5119302.195-.7069036 0L9.49843203 3.707l0 8.793c0 .276-.22396946.5-.49993183.5-.27596236 0-.49993182-.224-.49993182-.5l0-8.792-4.14543472 4.146c-.19497341.195-.51093032.195-.7069036 0-.19497341-.195-.19497341-.512 0-.707l4.99731855-4.999zm7.82311809 12.8524c.2944 0 .5333333.224.5333333.5 0 .276-.2389333.5-.5333333.5l-14.933333367 0c-.2944 0-.533333333-.224-.533333333-.5 0-.276.238933333-.5.533333333-.5l14.933333367 0z"],"share_20":["M5.35325 7.853c-.195.195-.512.195-.707 0-.195-.195-.195-.512 0-.707l4.999-4.999c.047-.047.102-.084.164-.109.122-.051.259-.051.381 0 .062.025.117.062.164.109l4.999 4.999c.195.195.195.512 0 .707-.098.098-.226.146-.354.146-.127 0-.255-.048-.353-.146l-4.147-4.146 0 10.737c0 .276-.223.5-.5.5-.276 0-.5-.224-.5-.5l0-10.737-4.146 4.146zm12.1134167 9.1465c.2944 0 .5333333.224.5333333.5 0 .276-.2389333.5-.5333333.5l-14.933333367 0c-.2944 0-.533333333-.224-.533333333-.5 0-.276.238933333-.5.533333333-.5l14.933333367 0z"],"share_24":["M11.65179795 2.147L5.65689972 8.146c-.19586599.196-.19586599.512 0 .707.19486667.196.51065061.196.70651659 0l5.14248146-5.146 0 13.793c0 .276.22384684.5.49965813.5.2758113 0 .4996581-.224.4996581-.5l0-13.793 5.1434808 5.146c.1948667.196.5106506.196.7065166 0 .1948667-.195.1948667-.511 0-.707l-5.9958975-5.999c-.0459686-.046-.100931-.083-.1628886-.109-.0609583-.025-.1259138-.038-.1908694-.038-.06495556 0-.12991111.013-.1908694.038-.0609583.026-.11692001.063-.16288855.109zm9.82214615 19.8529c.2903276 0 .5259559-.224.5259559-.5 0-.276-.2356283-.5-.5259559-.5l-18.948088175 0c-.290327671 0-.525955925.224-.525955925.5 0 .276.235628254.5.525955925.5l18.948088175 0z"],"share_28":["M7.35325 10.85325c-.195.195-.512.195-.707 0-.195-.195-.195-.512 0-.707l6.999-6.999c.047-.047.102-.084.164-.109.122-.051.259-.051.381 0 .062.025.117.062.164.109l6.999 6.999c.195.195.195.512 0 .707-.098.098-.226.146-.354.146-.127 0-.255-.048-.353-.146l-6.147-6.147-.002 15.792c0 .276-.224.5-.5.5-.277 0-.5-.224-.5-.5l.002-15.791-6.146 6.146zm17.1229405 13.1445c.2891428 0 .5238095.224.5238095.5 0 .276-.2346667.5-.5238095.5l-20.952380976 0C3.234666667 24.99775 3 24.77375 3 24.49775c0-.276.234666667-.5.523809524-.5l20.952380976 0z"],"share_32":["M15.64625 3.1455c.046-.046.102-.083.163-.107.061-.026.126-.039.191-.039.065 0 .13.013.191.039.061.025.116.061.163.107l7.999 8c.196.195.196.512 0 .707-.195.195-.511.195-.707 0l-7.146-7.146 0 18.793c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-18.793-7.147 7.146c-.195.195-.511.195-.707 0-.195-.195-.195-.512 0-.707l8-8zM29.4814815 28C29.7677037 28 30 28.224 30 28.5c0 .276-.2322963.5-.5185185.5L2.518518519 29C2.232296296 29 2 28.776 2 28.5c0-.276.232296296-.5.518518519-.5L29.4814815 28z"],"share-c-native-adr_14":["M10.4984 13.0005284c-.826 0-1.499-.6727117-1.499-1.4983579 0-.8266457.673-1.4993574 1.499-1.4993574.827 0 1.5.6727117 1.5 1.4993574 0 .8256462-.673 1.4983579-1.5 1.4983579m-6.999-4.50107098c-.826 0-1.499-.6727117-1.499-1.49935742 0-.82664572.673-1.49935742 1.499-1.49935742.827 0 1.5.6727117 1.5 1.49935742 0 .82664572-.673 1.49935742-1.5 1.49935742m6.999-7.499785808c.827 0 1.5.672711698 1.5 1.498357848 0 .82664572-.673 1.49935742-1.5 1.49935742-.826 0-1.499-.6727117-1.499-1.49935742 0-.82564615.673-1.498357848 1.499-1.498357848m0 8.003569898c-.766 0-1.446.35684707-1.905.90361274l-2.869-1.79323147c.17-.33785521.275-.71269456.275-1.11352278 0-.40082822-.105-.77566757-.275-1.11352278l2.869-1.79323147c.459.54676567 1.139.90361274 1.905.90361274 1.375 0 2.5-1.12451806 2.5-2.49892903 0-1.37441097-1.125-2.49792946-2.5-2.49792946-1.374 0-2.499 1.12351849-2.499 2.49792946 0 .2498929.048.4857918.117.71369413l-3.017 1.8871912c-.436-.36684278-.99-.59774382-1.6-.59774382-1.375 0-2.499 1.12451806-2.499 2.49892903 0 1.37441097 1.124 2.49892903 2.499 2.49892903.61 0 1.164-.22990147 1.6-.59774382l3.017 1.88719119c-.069.2279023-.117.4638012-.117.7136941 0 1.374411 1.125 2.4979295 2.499 2.4979295 1.375 0 2.5-1.1235185 2.5-2.4979295 0-1.3744109-1.125-2.49892899-2.5-2.49892899"],"share-c-native-adr_16":["M12 15c-1.103 0-2-.897-2-2 0-1.103.897-2 2-2 1.103 0 2 .897 2 2 0 1.103-.897 2-2 2m-8-5c-1.103 0-2-.897-2-2 0-1.103.897-2 2-2 1.103 0 2 .897 2 2 0 1.103-.897 2-2 2m8-9c1.103 0 2 .897 2 2 0 1.103-.897 2-2 2-1.103 0-2-.897-2-2 0-1.103.897-2 2-2m0 9c-.892 0-1.684.396-2.233 1.015L6.772 9.143C6.917 8.791 7 8.405 7 8c0-.405-.083-.791-.228-1.143l2.995-1.872C10.316 5.603 11.108 6 12 6c1.657 0 3-1.343 3-3 0-1.657-1.343-3-3-3-1.657 0-3 1.343-3 3 0 .405.083.791.229 1.143L6.233 6.015C5.684 5.397 4.892 5 4 5 2.343 5 1 6.343 1 8c0 1.657 1.343 3 3 3 .892 0 1.684-.396 2.233-1.015l2.996 1.871C9.083 12.209 9 12.595 9 13c0 1.657 1.343 3 3 3 1.657 0 3-1.343 3-3 0-1.657-1.343-3-3-3"],"share-c-native-adr_24":["M18 23c-1.654 0-3-1.346-3-3 0-1.654 1.346-3 3-3 1.654 0 3 1.346 3 3 0 1.654-1.346 3-3 3M6 15c-1.654 0-3-1.346-3-3 0-1.654 1.346-3 3-3 1.654 0 3 1.346 3 3 0 1.654-1.346 3-3 3M18 1c1.654 0 3 1.346 3 3 0 1.654-1.346 3-3 3-1.654 0-3-1.346-3-3 0-1.654 1.346-3 3-3m0 15c-1.208 0-2.277.547-3.01 1.393l-5.424-3.617C9.835 13.239 10 12.642 10 12c0-.642-.165-1.239-.434-1.777l5.423-3.616C15.723 7.453 16.792 8 18 8c2.209 0 4-1.791 4-4 0-2.209-1.791-4-4-4-2.209 0-4 1.791-4 4 0 .642.165 1.239.434 1.777L9.011 9.393C8.277 8.547 7.208 8 6 8c-2.209 0-4 1.791-4 4 0 2.209 1.791 4 4 4 1.208 0 2.277-.547 3.011-1.393l5.423 3.616C14.165 18.761 14 19.358 14 20c0 2.209 1.791 4 4 4 2.209 0 4-1.791 4-4 0-2.209-1.791-4-4-4"],"share-c-native-ios_10":["M3.8535 2.85275c-.195.195-.512.195-.707 0-.195-.195-.195-.512 0-.707l2-2c.017-.017.038-.023.056-.037.034-.027.066-.054.106-.07.123-.051.26-.051.383 0 .041.016.074.044.108.071.018.014.038.02.054.036l2 2c.195.195.195.512 0 .707-.098.098-.226.146-.354.146-.127 0-.255-.048-.353-.146l-1.147-1.146 0 3.792c0 .276-.225.5-.5.5-.274 0-.5-.224-.5-.5l0-3.792-1.146 1.146zm3.8164 1.1465c.735 0 1.33.596 1.33 1.33l0 3.34c0 .734-.595 1.33-1.33 1.33l-4.34 0c-.734 0-1.33-.596-1.33-1.33l0-3.34c0-.734.596-1.33 1.33-1.33l.17 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-.17 0c-.182 0-.33.148-.33.33l0 3.34c0 .182.148.33.33.33l4.34 0c.182 0 .33-.148.33-.33l0-3.34c0-.182-.148-.33-.33-.33l-.17 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l.17 0z"],"share-c-native-ios_12":["M9.5 3.9995c.827 0 1.5.673 1.5 1.5l0 5c0 .827-.673 1.5-1.5 1.5l-6 0c-.827 0-1.5-.673-1.5-1.5l0-5c0-.827.673-1.5 1.5-1.5l1 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0c-.276 0-.5.225-.5.5l0 5c0 .275.224.5.5.5l6 0c.276 0 .5-.225.5-.5l0-5c0-.275-.224-.5-.5-.5l-1 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0zM4.8535 2.853c-.195.195-.512.195-.707 0-.195-.195-.195-.512 0-.707L6.1455.147c.047-.047.102-.084.164-.109.122-.05.259-.05.381 0 .062.025.117.062.163.109l2 1.999c.195.195.195.512 0 .707-.098.098-.226.146-.354.146-.127 0-.255-.048-.353-.146l-1.147-1.146 0 5.792c0 .277-.223.5-.5.5-.276 0-.5-.223-.5-.5l0-5.792-1.146 1.146z"],"share-c-native-ios_14":["M5.877 2.8294c-.195.195-.512.195-.707 0-.195-.195-.195-.512 0-.707L7.147.1454c.015-.015.036-.022.053-.036.034-.026.068-.054.109-.071.122-.051.26-.051.382 0 .041.017.075.045.109.071.017.014.038.021.054.036l2 2c.195.196.195.512 0 .707-.098.098-.226.147-.354.147-.128 0-.256-.049-.353-.147L8 1.7064l0 6.793c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-6.793-1.123 1.123zm4.624 2.1689c.828 0 1.5.672 1.5 1.5l0 6.001c0 .828-.672 1.5-1.5 1.5l-6.001 0c-.828 0-1.5-.672-1.5-1.5l0-6.001c0-.828.672-1.5 1.5-1.5l0 .001 1 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0-.002 0c-.274.001-.498.225-.498.499l0 6.001c0 .275.225.5.5.5l6.001 0c.275 0 .5-.225.5-.5l0-6.001c0-.275-.225-.5-.5-.5l-1.001.001c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1.001-.001z"],"share-c-native-ios_16":["M12 5.9993c1.103 0 2 .897 2 2l0 6c0 1.103-.897 2-2 2l-7 0c-1.103 0-2-.897-2-2l0-6c0-1.103.897-2 2-2l.5 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-.5 0c-.551 0-1 .448-1 1l0 6c0 .552.449 1 1 1l7 0c.551 0 1-.448 1-1l0-6c0-.552-.449-1-1-1l-.5 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l.5 0zM5.8535 3.8528c-.195.195-.512.195-.707 0-.195-.195-.195-.512 0-.707l3-3c.016-.016.037-.022.054-.036.034-.027.068-.055.108-.071.123-.051.26-.051.383 0 .04.016.074.044.108.071.017.014.038.02.054.036l3 3c.195.195.195.512 0 .707-.098.098-.226.146-.354.146-.127 0-.255-.048-.353-.146l-2.147-2.146 0 8.792c0 .276-.225.5-.5.5-.274 0-.5-.224-.5-.5l0-8.792-2.146 2.146z"],"share-c-native-ios_20":["M15.25 6.9993c.965 0 1.75.785 1.75 1.75l0 9.5c0 .965-.785 1.75-1.75 1.75l-10.5 0c-.965 0-1.75-.785-1.75-1.75l0-9.5c0-.965.785-1.75 1.75-1.75l1.771 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1.771 0c-.414 0-.75.336-.75.75l0 9.5c0 .413.336.75.75.75l10.5 0c.413 0 .75-.337.75-.75l0-9.5c0-.414-.337-.75-.75-.75l-1.75 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1.75 0zM6.8535 4.3528c-.195.195-.512.195-.707 0-.195-.195-.195-.512 0-.707l3.5-3.5c.016-.016.037-.022.054-.036.034-.027.068-.055.108-.071.123-.051.26-.051.383 0 .04.016.074.044.108.071.017.014.038.02.054.036l3.5 3.5c.195.195.195.512 0 .707-.098.098-.226.146-.354.146-.127 0-.255-.048-.353-.146l-2.647-2.646 0 10.792c0 .276-.225.5-.5.5-.274 0-.5-.224-.5-.5l0-10.792-2.646 2.646z"],"share-c-native-ios_28":["M21 10c1.654 0 3 1.346 3 3l0 12c0 1.654-1.346 3-3 3L8 28c-1.654 0-3-1.346-3-3l0-12c0-1.654 1.346-3 3-3l1.5 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5L8 11c-1.103 0-2 .897-2 2l0 12c0 1.103.897 2 2 2l13 0c1.103 0 2-.897 2-2l0-12c0-1.103-.897-2-2-2l-1.5 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1.5 0zM9.853 5.854c-.194.195-.513.195-.707 0-.195-.194-.195-.513 0-.707L14.144.149c.001-.001.001-.002.002-.003.038-.039.083-.063.129-.086.012-.006.02-.016.032-.021.061-.025.127-.039.193-.039.066 0 .132.014.193.039.012.005.02.015.032.021.045.023.091.047.129.086.001.001.001.002.002.003l4.998 4.998c.195.194.195.513 0 .707-.194.195-.513.195-.707 0L15 1.707 15 17.5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-15.793-4.147 4.147z"],"share-c-native-iph_10":["M4.4995 1.706l-1.146 1.146c-.195.195-.512.195-.707 0-.195-.195-.195-.512 0-.707l2-2c.017-.017.038-.023.056-.037.034-.027.066-.054.106-.07.123-.051.26-.051.383 0 .041.016.074.044.108.071.018.014.038.02.054.036l2 2c.195.195.195.512 0 .707-.098.098-.226.146-.354.146-.127 0-.255-.048-.353-.146l-1.147-1.146 0 4.792c0 .275-.225.5-.5.5-.274 0-.5-.225-.5-.5l0-4.792zm2.5004 2.292l.67 0c.735 0 1.33.596 1.33 1.33l0 3.34c0 .734-.595 1.33-1.33 1.33l-5.34 0c-.734 0-1.33-.596-1.33-1.33l0-3.34c0-.734.596-1.33 1.33-1.33l.67 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-.67 0c-.182 0-.33.148-.33.33l0 3.34c0 .183.148.33.33.33l5.34 0c.182 0 .33-.147.33-.33l0-3.34c0-.182-.148-.33-.33-.33l-.67 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5z"],"share-c-native-iph_12":["M4.81.038c-.062.025-.118.062-.165.109L2.646 2.145c-.194.196-.194.512 0 .708.196.194.512.194.708 0l1.145-1.147 0 5.793c0 .277.225.499.501.499.276 0 .499-.222.499-.499l0-5.793 1.148 1.147c.098.098.226.146.353.146.128 0 .255-.048.353-.146.196-.196.196-.512 0-.708L5.354.147C5.308.1 5.253.063 5.191.038 5.13.012 5.065 0 5 0c-.065 0-.129.012-.19.038zM7.5 3.999c-.276 0-.5.225-.5.5 0 .276.224.5.5.5l1 0c.276 0 .5.225.5.5l0 5c0 .275-.224.5-.5.5l-7 0c-.276 0-.5-.225-.5-.5l0-5c0-.275.224-.5.5-.5l1 0c.276 0 .5-.224.5-.5 0-.275-.224-.5-.5-.5l-1 0c-.827 0-1.5.673-1.5 1.5l0 5c0 .827.673 1.5 1.5 1.5l7 0c.827 0 1.5-.673 1.5-1.5l0-5c0-.827-.673-1.5-1.5-1.5l-1 0z"],"share-c-native-iph_14":["M5.3765 2.8292c-.195.195-.512.195-.707 0-.195-.195-.195-.512 0-.707l1.977-1.977c.015-.015.036-.022.053-.036.034-.026.068-.054.109-.071.122-.051.26-.051.382 0 .041.017.075.045.109.071.017.014.038.021.054.036l2 2c.195.196.195.512 0 .707-.098.098-.226.147-.354.147-.128 0-.256-.049-.353-.147l-1.147-1.146 0 6.793c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-6.793-1.123 1.123zM10.5 4.9981c.828 0 1.5.672 1.5 1.5l0 6.001c0 .828-.672 1.5-1.5 1.5l-7 0c-.828 0-1.5-.672-1.5-1.5l0-6.001c0-.828.672-1.5 1.5-1.5l0 .001 1.5 0c.274 0 .5.225.5.5 0 .275-.226.5-.5.5l-1.5 0-.002 0c-.274.001-.498.225-.498.499l0 6.001c0 .275.225.5.5.5l7 0c.275 0 .5-.225.5-.5l0-6.001c0-.275-.225-.5-.5-.5l-1.5.001c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1.5-.001z"],"share-c-native-iph_16":["M12 5.9993c1.103 0 2 .897 2 2l0 6c0 1.103-.897 2-2 2l-7 0c-1.103 0-2-.897-2-2l0-6c0-1.103.897-2 2-2l.5 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-.5 0c-.551 0-1 .448-1 1l0 6c0 .552.449 1 1 1l7 0c.551 0 1-.448 1-1l0-6c0-.552-.449-1-1-1l-.5 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l.5 0zM5.8535 3.8528c-.195.195-.512.195-.707 0-.195-.195-.195-.512 0-.707l3-3c.016-.016.037-.022.054-.036.034-.027.068-.055.108-.071.123-.051.26-.051.383 0 .04.016.074.044.108.071.017.014.038.02.054.036l3 3c.195.195.195.512 0 .707-.098.098-.226.146-.354.146-.127 0-.255-.048-.353-.146l-2.147-2.146 0 8.792c0 .276-.225.5-.5.5-.274 0-.5-.224-.5-.5l0-8.792-2.146 2.146z"],"share-c-native-iph_20":["M15.25 6.9993c.965 0 1.75.785 1.75 1.75l0 9.5c0 .965-.785 1.75-1.75 1.75l-10.5 0c-.965 0-1.75-.785-1.75-1.75l0-9.5c0-.965.785-1.75 1.75-1.75l1.771 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1.771 0c-.414 0-.75.336-.75.75l0 9.5c0 .413.336.75.75.75l10.5 0c.413 0 .75-.337.75-.75l0-9.5c0-.414-.337-.75-.75-.75l-1.75 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1.75 0zM6.8535 4.3528c-.195.195-.512.195-.707 0-.195-.195-.195-.512 0-.707l3.5-3.5c.016-.016.037-.022.054-.036.034-.027.068-.055.108-.071.123-.051.26-.051.383 0 .04.016.074.044.108.071.017.014.038.02.054.036l3.5 3.5c.195.195.195.512 0 .707-.098.098-.226.146-.354.146-.127 0-.255-.048-.353-.146l-2.647-2.646 0 10.792c0 .276-.225.5-.5.5-.274 0-.5-.224-.5-.5l0-10.792-2.646 2.646z"],"share-c-native-iph_24":["M8.3533 4.8541c-.195.195-.512.195-.707 0-.195-.195-.195-.512 0-.707l3.996-4c.046-.046.101-.082.163-.108.061-.026.126-.039.191-.039.065 0 .128.013.191.039.061.026.115.062.162.108l3.994 4c.197.195.197.512 0 .707-.194.195-.51.195-.705 0l-3.147-3.146 0 13.792c0 .276-.225.5-.5.5-.276 0-.5-.224-.5-.5l.005-13.792-3.143 3.146zm10.0215 3.1455c1.448 0 2.625 1.178 2.625 2.625l0 10.75c0 1.447-1.177 2.625-2.625 2.625l-12.75 0c-1.447 0-2.625-1.178-2.625-2.625l0-10.75c0-1.447 1.178-2.625 2.625-2.625l2.875 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-2.925 0c-.868 0-1.575.706-1.575 1.574l0 10.852c0 .868.707 1.574 1.575 1.574l12.85 0c.868 0 1.575-.706 1.575-1.574l0-10.852c0-.868-.707-1.574-1.575-1.574l-2.925 0c-.274 0-.5-.225-.5-.5 0-.275.226-.5.5-.5l2.875 0z"],"share-c-native-iph_28":["M9.353 5.854c-.194.195-.513.195-.707 0-.195-.194-.195-.513 0-.707L13.644.149c.001-.001.001-.002.002-.003.038-.039.083-.063.129-.086.012-.006.02-.016.032-.021C13.868.014 13.934 0 14 0c.066 0 .132.014.193.039.012.005.02.015.032.021.045.023.091.047.129.086.001.001.001.002.002.003l4.998 4.998c.195.194.195.513 0 .707-.194.195-.513.195-.707 0L14.5 1.707l0 15.793c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-15.793-4.147 4.147zM21 10c1.654 0 3 1.346 3 3l0 12c0 1.654-1.346 3-3 3L7 28c-1.654 0-3-1.346-3-3l0-12c0-1.654 1.346-3 3-3l2.5 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5L7 11c-1.103 0-2 .897-2 2l0 12c0 1.103.897 2 2 2l14 0c1.103 0 2-.897 2-2l0-12c0-1.103-.897-2-2-2l-2.5 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l2.5 0z"],"share-screen_10":["M9.00009999 5.66586683c0 .1839632-.1489851.33293341-.3329667.33293341l-5.33346666 0c-.1839816 0-.3329667-.14897021-.3329667-.33293341l0-4.33213358c0-.1839632.1489851-.33393321.3329667-.33393321l5.33346666 0c.1839816 0 .3329667.14997001.3329667.33393321l0 4.33213358zM6.99930007 8.66726655c0 .1839632-.1489851.33293341-.3329667.33293341l-5.33246676 0c-.1849815 0-.3339666-.14897021-.3339666-.33293341l0-4.33213358c0-.1839632.1489851-.33393321.3339666-.33393321l.66693331 0 0 1.66466707c0 .73485303.59794021 1.33273345 1.33286671 1.33273345l3.66563344 0 0 1.66866627zM8.66713329 0L3.33366663 0c-.7349265 0-1.33286671.598880224-1.33286671 1.33373325l0 1.66766647-.66693331 0C.597940206 3.00139972 0 3.60027994 0 4.33513297l0 4.33213358C0 9.40211958.597940206 10 1.33386661 10l5.33246676 0c.7349265 0 1.33286671-.59788042 1.33286671-1.33273345l0-1.66866627.66793321 0C9.40205979 6.99860028 10 6.40071986 10 5.66586683l0-4.33213358C10 .598880224 9.40205979 0 8.66713329 0z"],"share-screen_12":["M11 6.499c0 .276-.225.501-.501.501L4.501 7C4.225 7 4 6.775 4 6.499l0-3.998C4 2.225 4.225 2 4.501 2l5.998 0c.276 0 .501.225.501.501l0 3.998zm-3 3c0 .276-.225.501-.501.501l-5.998 0C1.225 10 1 9.775 1 9.499l0-3.998C1 5.225 1.225 5 1.501 5L3 5l0 1.499C3 7.328 3.672 8 4.501 8L8 8l0 1.499zM10.499 1L4.501 1C3.672 1 3 1.672 3 2.501L3 4 1.501 4C.672 4 0 4.672 0 5.501l0 3.998C0 10.328.672 11 1.501 11l5.998 0C8.328 11 9 10.328 9 9.499L9 8l1.499 0C11.328 8 12 7.328 12 6.499l0-3.998C12 1.672 11.328 1 10.499 1z"],"share-screen_120":["M116 66c0 4.962-4.038 9-9 9l-66 0c-4.962 0-9-4.038-9-9l0-47c0-4.962 4.038-9 9-9l66 0c4.962 0 9 4.038 9 9l0 47zm-28 35c0 4.962-4.038 9-9 9l-66 0c-4.962 0-9-4.038-9-9l0-47c0-4.962 4.038-9 9-9l18 0 0 21c0 5.514 4.486 10 10 10l47 0 0 25zm19-92L41 9c-5.514 0-10 4.486-10 10l0 25-18 0C7.486 44 3 48.486 3 54l0 47c0 5.514 4.486 10 10 10l66 0c5.514 0 10-4.486 10-10l0-25 18 0c5.514 0 10-4.486 10-10l0-47c0-5.514-4.486-10-10-10z"],"share-screen_124":["M120 67.4995c0 5.238-4.262 9.5-9.5 9.5l-68 0c-5.238 0-9.5-4.262-9.5-9.5l0-48c0-5.238 4.262-9.5 9.5-9.5l68 0c5.238 0 9.5 4.262 9.5 9.5l0 48zm-29 37c0 5.239-4.262 9.5-9.5 9.5l-68 0c-5.238 0-9.5-4.261-9.5-9.5l0-48c0-5.238 4.262-9.5 9.5-9.5l18.5 0 0 20.5c0 5.79 4.71 10.5 10.5 10.5l48.5 0 0 26.5zm19.5-95.5l-68 0c-5.79 0-10.5 4.71-10.5 10.5l0 26.5-18.5 0c-5.79 0-10.5 4.711-10.5 10.5l0 48c0 5.79 4.71 10.5 10.5 10.5l68 0c5.79 0 10.5-4.71 10.5-10.5l0-26.5 18.5 0c5.79 0 10.5-4.71 10.5-10.5l0-48c0-5.79-4.71-10.5-10.5-10.5z"],"share-screen_14":["M13.0001428 8.333c0 .368-.2989573.667-.6669047.667L4.66633338 9c-.36694758 0-.66590487-.299-.66590487-.667l0-5.666c0-.368.29895729-.667.66590487-.667l7.66690472 0c.3679474 0 .6669047.299.6669047.667l0 5.666zm-3.00057131 3c0 .367-.29895729.666-.66590487.666l-7.66690473 0c-.36794743 0-.666904727-.299-.666904727-.666l0-5.667c0-.367.298957297-.666.666904727-.666l1.33380946 0 0 3.333c0 .919.7468933 1.667 1.66576203 1.667l5.33323811 0 0 1.333zM12.3332381 1L4.66633338 1c-.91886873 0-1.66576203.748-1.66576203 1.667l0 1.333-1.33380946 0C.747893158 4 0 4.748 0 5.666l0 5.667c0 .918.747893158 1.666 1.66676189 1.666l7.66690473 0c.91786888 0 1.66576208-.748 1.66576208-1.666l0-1.333 1.3338094 0C13.2521068 10 14 9.252 14 8.333l0-5.666C14 1.748 13.2521068 1 12.3332381 1z"],"share-screen_16":["M15 9.0004c0 .55-.452 1-1.009 1l-7.982 0c-.562 0-1.009-.444-1.009-1l0-6.001c0-.55.452-.999 1.009-.999l7.982 0c.562 0 1.009.444 1.009.999l0 6.001zm-4 4c0 .55-.452 1-1.009 1l-7.982 0c-.562 0-1.009-.444-1.009-1l0-6.001c0-.55.452-.999 1.009-.999l1.991 0 0 3c0 1.112.899 2 2.009 2l4.991 0 0 2zm2.991-12l-7.982 0c-1.107 0-2.009.895-2.009 1.999l0 2.001-1.991 0C.902 5.0004 0 5.8954 0 6.9994l0 6.001c0 1.112.899 2 2.009 2l7.982 0c1.107 0 2.009-.896 2.009-2l0-2 1.991 0c1.107 0 2.009-.896 2.009-2l0-6.001c0-1.112-.899-1.999-2.009-1.999z"],"share-screen_18":["M17 10c0 .551-.448 1-1 1L6 11c-.552 0-1-.449-1-1l0-7c0-.551.448-1 1-1l10 0c.552 0 1 .449 1 1l0 7zm-4 5c0 .551-.448 1-1 1L2 16c-.552 0-1-.449-1-1l0-7c0-.551.448-1 1-1l2 0 0 3c0 1.103.897 2 2 2l7 0 0 3zm3-14L6 1c-1.103 0-2 .897-2 2l0 3-2 0C.897 6 0 6.897 0 8l0 7c0 1.103.897 2 2 2l10 0c1.103 0 2-.897 2-2l0-3 2 0c1.103 0 2-.897 2-2l0-7c0-1.103-.897-2-2-2z"],"share-screen_20":["M19.0002 10.49793776c0 .82689664-.6728655 1.49981252-1.4997001 1.49981252l-8.99820036 0c-.82683463 0-1.49970006-.67291588-1.49970006-1.49981252l0-5.99825022c0-.82689664.67286543-1.499812524 1.49970006-1.499812524l8.99820036 0c.8268346 0 1.4997001.672915884 1.4997001 1.499812524l0 5.99825022zm-6.0027995 5.00237474c0 .8278965-.6728654 1.4998125-1.4997 1.4998125l-8.9982004 0c-.82683463 0-1.49970006-.671916-1.49970006-1.4998125l0-5.99825026c0-.82689664.67286543-1.49981252 1.49970006-1.49981252l3.50329934 0 0 2.49568804c0 1.38082739 1.11877624 2.49968754 2.4995001 2.49968754l4.49510096 0 0 2.5026872zM17.5004999 2L8.50229954 2c-1.38072386 0-2.4995001 1.11886014-2.4995001 2.49968754l0 2.50268716-3.50329934 0C1.11977604 7.0023747 0 8.12123485 0 9.50206224l0 5.99825026C0 16.8811399 1.11977604 18 2.4995001 18l8.9982004 0c1.3807238 0 2.4995001-1.1188601 2.4995001-2.4996875l0-2.5026872 3.5032993 0C18.8812238 12.9976253 20 11.87876515 20 10.49793776l0-5.99825022C20 3.11886014 18.8812238 2 17.5004999 2z"],"share-screen_24":["M23 13.544c0 .803-.653 1.456-1.456 1.456L8.456 15C7.653 15 7 14.347 7 13.544l0-9.089C7 3.652 7.653 3 8.456 3l13.088 0C22.347 3 23 3.652 23 4.455l0 9.089zm-6 6c0 .802-.653 1.456-1.456 1.456L2.456 21C1.653 21 1 20.346 1 19.544l0-9.089C1 9.652 1.653 9 2.456 9L6 9l0 4.544C6 14.898 7.102 16 8.456 16L17 16l0 3.544zM21.544 2L8.456 2C7.102 2 6 3.101 6 4.455L6 8 2.456 8C1.102 8 0 9.101 0 10.455l0 9.089C0 20.898 1.102 22 2.456 22l13.088 0C16.898 22 18 20.898 18 19.544L18 16l3.544 0C22.898 16 24 14.898 24 13.544l0-9.089C24 3.101 22.898 2 21.544 2z"],"share-screen_26":["M25 15.334c0 .919-.748 1.667-1.667 1.667l-14.666 0c-.919 0-1.667-.748-1.667-1.667L7 4.666C7 3.747 7.748 3 8.667 3l14.666 0C24.252 3 25 3.747 25 4.666l0 10.668zm-6.001 6.004c0 .919-.748 1.667-1.666 1.667l-14.666 0c-.919 0-1.667-.748-1.667-1.667L1 10.67c0-.919.748-1.666 1.667-1.666l3.333 0 0 6.33c0 1.471 1.197 2.667 2.667 2.667l10.332 0 0 3.337zM23.333 2L8.667 2C7.197 2 6 3.196 6 4.666l0 3.338-3.333 0C1.196 8.004 0 9.2 0 10.67l0 10.668c0 1.471 1.196 2.667 2.667 2.667l14.666 0c1.47 0 2.666-1.196 2.666-2.667l0-3.337 3.334 0c1.471 0 2.667-1.196 2.667-2.667l0-10.668C26 3.196 24.804 2 23.333 2z"],"share-screen_28":["M27 15c0 1.103-.897 2-2 2l-15 0c-1.103 0-2-.897-2-2L8 5c0-1.103.897-2 2-2l15 0c1.103 0 2 .897 2 2l0 10zm-7 8c0 1.103-.897 2-2 2L3 25c-1.103 0-2-.897-2-2l0-10c0-1.103.897-2 2-2l4 0 0 4c0 1.657 1.343 3 3 3l10 0 0 5zm5-21L10 2C8.343 2 7 3.343 7 5l0 5-4 0c-1.657 0-3 1.343-3 3l0 10c0 1.657 1.343 3 3 3l15 0c1.657 0 3-1.343 3-3l0-5 4 0c1.657 0 3-1.343 3-3l0-10c0-1.657-1.343-3-3-3z"],"share-screen_32":["M31 17.0074c0 1.1-.893 1.993-1.991 1.993l-18.018 0c-1.094 0-1.991-.9-1.991-1.993l0-12.015c0-1.099.893-1.992 1.991-1.992l18.018 0c1.094 0 1.991.899 1.991 1.992l0 12.015zm-8 10c0 1.1-.893 1.993-1.991 1.993l-18.018 0c-1.094 0-1.991-.9-1.991-1.993l0-12.015c0-1.099.893-1.992 1.991-1.992l5.009 0 0 4.007c0 1.64 1.339 2.993 2.991 2.993l12.009 0 0 7.007zm6.009-25.007l-18.018 0C9.342 2.0004 8 3.3394 8 4.9924l0 7.008-5.009 0c-1.649 0-2.991 1.339-2.991 2.992l0 12.015c0 1.64 1.339 2.993 2.991 2.993l18.018 0c1.649 0 2.991-1.34 2.991-2.993l0-7.007 5.009 0c1.649 0 2.991-1.34 2.991-2.993l0-12.015c0-1.64-1.339-2.992-2.991-2.992z"],"share-screen_36":["M34 19.5c0 1.378-1.122 2.5-2.5 2.5l-20 0C10.122 22 9 20.878 9 19.5l0-14C9 4.122 10.122 3 11.5 3l20 0C32.878 3 34 4.122 34 5.5l0 14zm-7 11c0 1.378-1.122 2.5-2.5 2.5l-20 0C3.122 33 2 31.878 2 30.5l0-14C2 15.122 3.122 14 4.5 14L8 14l0 5.5c0 1.93 1.57 3.5 3.5 3.5L27 23l0 7.5zM31.5 2l-20 0C9.57 2 8 3.57 8 5.5L8 13l-3.5 0C2.57 13 1 14.57 1 16.5l0 14C1 32.43 2.57 34 4.5 34l20 0c1.93 0 3.5-1.57 3.5-3.5l0-7.5 3.5 0c1.93 0 3.5-1.57 3.5-3.5l0-14C35 3.57 33.43 2 31.5 2z"],"share-screen_48":["M46 26.5c0 1.93-1.57 3.5-3.5 3.5l-28 0c-1.93 0-3.5-1.57-3.5-3.5l0-19C11 5.57 12.57 4 14.5 4l28 0C44.43 4 46 5.57 46 7.5l0 19zm-9 14c0 1.93-1.57 3.5-3.5 3.5l-28 0C3.57 44 2 42.43 2 40.5l0-19C2 19.57 3.57 18 5.5 18l4.5 0 0 8.5c0 2.481 2.019 4.5 4.5 4.5L37 31l0 9.5zM42.5 3l-28 0C12.019 3 10 5.019 10 7.5l0 9.5-4.5 0C3.019 17 1 19.019 1 21.5l0 19C1 42.981 3.019 45 5.5 45l28 0c2.481 0 4.5-2.019 4.5-4.5l0-9.5 4.5 0c2.481 0 4.5-2.019 4.5-4.5l0-19C47 5.019 44.981 3 42.5 3z"],"share-screen_56":["M54 31c0 2.206-1.794 4-4 4l-31 0c-2.206 0-4-1.794-4-4l0-22c0-2.206 1.794-4 4-4l31 0c2.206 0 4 1.794 4 4l0 22zM41 47c0 2.206-1.794 4-4 4L6 51c-2.206 0-4-1.794-4-4l0-22c0-2.206 1.794-4 4-4l8 0 0 10c0 2.757 2.243 5 5 5l22 0 0 11zm9-43L19 4c-2.757 0-5 2.243-5 5l0 11-8 0c-2.757 0-5 2.243-5 5l0 22c0 2.757 2.243 5 5 5l31 0c2.757 0 5-2.243 5-5l0-11 8 0c2.757 0 5-2.243 5-5l0-22c0-2.757-2.243-5-5-5z"],"share-screen_8":["M7 3.833C7 3.925 6.925 4 6.833 4L3.167 4C3.075 4 3 3.925 3 3.833l0-2.666C3 1.075 3.075 1 3.167 1l3.666 0c.092 0 .167.075.167.167l0 2.666zm-2 3C5 6.925 4.925 7 4.833 7L1.167 7C1.075 7 1 6.925 1 6.833l0-2.666C1 4.075 1.075 4 1.167 4l.867 0c.084.561.549 1 1.133 1L5 5l0 1.833zM6.833 0L3.167 0C2.523 0 2 .523 2 1.167L2 3l-.833 0C.523 3 0 3.523 0 4.167l0 2.666C0 7.477.523 8 1.167 8l3.666 0C5.477 8 6 7.477 6 6.833L6 5l.833 0C7.477 5 8 4.477 8 3.833l0-2.666C8 .523 7.477 0 6.833 0z"],"share-space_12":["M6.3523 6.1406l2 2c.195.195.195.512 0 .707-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147l-1.147-1.146 0 2.793c0 .275-.224.5-.5.5-.275 0-.5-.225-.5-.5l0-2.792-1.143 1.145c-.195.195-.513.195-.708 0-.195-.195-.195-.512 0-.707l1.998-2c.187-.187.52-.188.707 0zM10.16 1c1.014 0 1.839.824 1.84 1.838l0 4.664C11.999 8.328 11.326 9 10.5 9c-.277 0-.5-.224-.5-.5 0-.276.223-.5.5-.5.275 0 .5-.225.5-.5l0-4.66c0-.463-.377-.84-.84-.84L1.84 2c-.463 0-.84.377-.84.84L1 7.5c0 .275.224.5.5.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5C.673 9 0 8.327 0 7.5l0-4.66C0 1.825.825 1 1.84 1l8.32 0zm1.8398 6.5019l0-4.664 0 .002 0 4.66 0 .002z"],"share-space_14":["M7.3506 7.1475l3.003 2.999c.195.195.195.512 0 .707-.195.195-.512.195-.707 0l-2.15-2.146 0 3.793c0 .276-.224.5-.5.5-.277 0-.5-.224-.5-.5l0-3.793-2.143 2.146c-.195.195-.512.195-.707 0-.195-.195-.195-.512 0-.707l2.995-2.999c.047-.047.103-.084.163-.109.062-.025.126-.038.192-.038.065 0 .129.013.191.038.06.025.116.062.163.109zM12.5 1c.827 0 1.5.673 1.5 1.5l0 7c0 .827-.673 1.5-1.5 1.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.275 0 .5-.225.5-.5l0-7c0-.275-.225-.5-.5-.5l-11 0c-.275 0-.5.225-.5.5l0 7c0 .275.225.5.5.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5C.673 11 0 10.327 0 9.5l0-7C0 1.673.673 1 1.5 1l11 0z"],"share-space_18":["M16 1c1.103 0 2 .897 2 2l0 10c0 1.103-.897 2-2 2l-.5 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l.5 0c.552 0 1-.448 1-1l0-10c0-.551-.448-1-1-1L2 2c-.551 0-1 .449-1 1l0 10c0 .552.449 1 1 1l.5 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5L2 15c-1.103 0-2-.897-2-2L0 3c0-1.103.897-2 2-2l14 0zM5.0024 15.0005c-.128 0-.257-.049-.354-.147-.195-.195-.195-.513.001-.707l3.985-3.978c.091-.102.221-.168.368-.168.001 0 .003.001.004.001.001 0 .003-.001.004-.001.133 0 .26.052.354.147l3.987 4c.195.195.195.512-.002.707-.193.193-.511.195-.707-.002l-3.14-3.15 0 4.798c0 .275-.225.5-.5.5-.276 0-.5-.225-.5-.5l0-4.788-3.147 3.141c-.098.098-.225.147-.353.147z"],"share-space_20":["M17.5 1C18.875 1 20 2.125 20 3.5l0 10c0 1.375-1.125 2.5-2.5 2.5-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5.827 0 1.5-.673 1.5-1.5l0-10c0-.827-.673-1.5-1.5-1.5l-14 0C2.673 2 2 2.673 2 3.5l0 10c0 .827.673 1.5 1.5 1.5.275 0 .5.225.5.5 0 .275-.225.5-.5.5C2.125 16 1 14.875 1 13.5l0-10C1 2.125 2.125 1 3.5 1l14 0zm-6.6465 10.1465l4 4c.195.195.195.512 0 .707-.195.195-.512.195-.707 0l-3.147-3.146 0 5.793c0 .275-.224.5-.5.5-.275 0-.5-.225-.5-.5l0-5.793-3.146 3.146c-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147-.195-.195-.195-.512 0-.707l4-4c.016-.016.036-.022.054-.036.034-.026.067-.055.108-.071.122-.051.261-.051.383 0 .041.016.074.045.108.071.018.014.038.02.054.036z"],"share-space_24":["M8.3535 18.8535c-.195.195-.512.195-.707 0-.195-.195-.195-.512 0-.707l4-4c.016-.016.036-.022.054-.036.034-.026.067-.055.108-.071.122-.051.261-.051.383 0 .041.016.074.045.108.071.018.014.038.02.054.036l4 4c.195.195.195.512 0 .707-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147l-3.147-3.146 0 6.793c0 .275-.224.5-.5.5-.275 0-.5-.225-.5-.5l0-6.793-3.146 3.146zM21.5 1C22.881 1 24 2.119 24 3.5l0 13c0 1.381-1.119 2.5-2.5 2.5l-1 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0c.827 0 1.5-.673 1.5-1.5l0-13c0-.827-.673-1.5-1.5-1.5l-19 0C1.673 2 1 2.673 1 3.5l0 13c0 .827.673 1.5 1.5 1.5l1 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0C1.119 19 0 17.881 0 16.5l0-13C0 2.119 1.119 1 2.5 1l19 0z"],"show_12":["M11.832757 5.456c.2229907.332.2229907.756 0 1.088C11.1027874 7.638 9.15686846 10 6 10 2.84313154 10 .897212616 7.638.167243032 6.544c-.2229907092-.332-.2229907092-.756 0-1.088C.897212616 4.362 2.84313154 2 6 2c3.15686846 0 5.1027874 2.362 5.832757 3.456zM6 9c2.69788759 0 4.3968168-2.106 5.0017916-3.012C10.3968168 5.106 8.69788759 3 6 3 3.30211241 3 1.6031832 5.106.998208408 6.012 1.6031832 6.894 3.30211241 9 6 9zm0-4c.551977 0 .99995834.447.99995834 1 0 .553-.44798134 1-.99995834 1-.551977 0-.99995834-.447-.99995834-1 0-.553.44798134-1 .99995834-1z"],"show_16":["M8 2c4.21 0 6.803 3.543 7.778 5.184.296.498.296 1.134 0 1.632C14.803 10.457 12.21 14 8 14 3.79 14 1.197 10.457.222 8.816c-.296-.498-.296-1.134 0-1.632C1.197 5.543 3.79 2 8 2zm0 5c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1zm0-4C4.273 3 1.92 6.283 1.082 7.695c-.109.182-.109.428 0 .61C1.92 9.717 4.273 13 8 13c3.727 0 6.08-3.283 6.918-4.695.109-.182.109-.428 0-.61C14.08 6.283 11.727 3 8 3z"],"show_20":["M19.7225139 9.093c.3699815.553.3699815 1.26 0 1.814C18.5035748 12.729 15.2627369 17 10 17c-5.26273686 0-8.50357482-4.271-9.722513874-6.093-.3699815012-.554-.3699815012-1.261 0-1.814C1.49642518 7.27 4.73726314 3 10 3c5.2627369 0 8.5035748 4.27 9.7225139 6.093zm-.8312669 1.258c.145004-.217.145004-.485 0-.702C17.1691991 7.072 14.2291175 4 10 4 5.77088252 4 2.83080086 7.072 1.10875302 9.649c-.145004027.217-.145004027.485 0 .702C2.83080086 12.928 5.77188255 16 10 16c4.2271174 0 7.1681991-3.072 8.891247-5.649zM10 9c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1z"],"show_24":["M23.667 10.9122c.444.664.444 1.512 0 2.176-1.462 2.187-5.351 6.912-11.667 6.912-6.316 0-10.205-4.725-11.667-6.912-.444-.664-.444-1.512 0-2.176C1.795 8.7242 5.684 4.0002 12 4.0002c6.316 0 10.205 4.724 11.667 6.912zm-.831 1.62c.219-.328.219-.736 0-1.064-1.3-1.945-4.958-6.468-10.836-6.468-5.878 0-9.536 4.523-10.836 6.468-.219.328-.219.736 0 1.064 1.3 1.944 4.958 6.468 10.836 6.468 5.878 0 9.536-4.524 10.836-6.468zM12 11c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1z"],"sign-in_16":["M8 16c-2.137 0-4.146-.832-5.657-2.343-.195-.196-.195-.512 0-.707.196-.196.512-.196.707 0C4.373 14.272 6.13 15 8 15c1.87 0 3.627-.728 4.95-2.05C14.272 11.627 15 9.87 15 8c0-1.87-.728-3.627-2.05-4.95C11.627 1.728 9.87 1 8 1c-1.87 0-3.627.728-4.95 2.05-.195.196-.511.196-.707 0-.195-.195-.195-.511 0-.707C3.854.832 5.863 0 8 0c2.137 0 4.146.832 5.657 2.343C15.168 3.854 16 5.863 16 8c0 2.137-.832 4.146-2.343 5.657C12.146 15.168 10.137 16 8 16zm2.3535-8.3535c.098.098.146.226.146.354 0 .128-.048.256-.146.354l-3.5 3.5c-.098.097-.226.146-.354.146-.127 0-.255-.049-.353-.146-.195-.196-.195-.512 0-.708l2.647-2.646-8.294 0c-.274 0-.5-.226-.5-.5 0-.275.226-.5.5-.5l8.293 0-2.646-2.647c-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0l3.5 3.5z"],"sign-in_20":["M17.0713 2.9238c3.899 3.899 3.899 10.243 0 14.143-1.95 1.949-4.511 2.923-7.071 2.923-2.561 0-5.122-.974-7.072-2.923-.195-.196-.195-.512 0-.707.196-.196.512-.196.707 0 3.51 3.509 9.219 3.509 12.729 0 3.509-3.51 3.509-9.219 0-12.729-3.51-3.509-9.219-3.51-12.729 0-.194.195-.511.195-.707 0-.195-.195-.195-.512 0-.707 3.9-3.898 10.244-3.898 14.143 0zM7.6465 13.6416l3.146-3.146-10.292 0c-.277 0-.5-.224-.5-.5 0-.277.223-.5.5-.5l10.292 0-3.146-3.147c-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0l4 4c.195.195.195.512 0 .707l-4 4c-.098.098-.226.147-.353.147-.128 0-.256-.049-.354-.147-.195-.195-.195-.512 0-.707z"],"sign-in_24":["M20.4854 3.5146c4.678 4.679 4.678 12.292 0 16.971-2.267 2.266-5.28 3.514-8.485 3.514-3.205 0-6.219-1.248-8.486-3.514-.195-.196-.195-.512 0-.707.196-.196.512-.196.707 0 4.289 4.289 11.268 4.289 15.557 0 4.289-4.289 4.289-11.268 0-15.557-4.289-4.29-11.267-4.288-15.557 0-.195.195-.511.195-.707 0-.195-.195-.195-.512 0-.707 2.267-2.267 5.281-3.515 8.486-3.515 3.205 0 6.218 1.248 8.485 3.515zM9.6465 16.1465l3.646-3.646-12.792 0c-.275 0-.5-.225-.5-.5 0-.276.225-.5.5-.5l12.792 0-3.646-3.647c-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0l4.5 4.5c.195.195.195.512 0 .707l-4.5 4.5c-.098.098-.226.147-.353.147-.128 0-.256-.049-.354-.147-.195-.195-.195-.512 0-.707z"],"sign-in-forced_16":["M13.6567 2.3433c1.511 1.511 2.343 3.52 2.343 5.657 0 2.136-.832 4.146-2.343 5.656-1.511 1.512-3.52 2.344-5.657 2.344-2.136 0-4.146-.832-5.656-2.344-.196-.195-.196-.511 0-.707.195-.195.511-.195.707 0 1.322 1.323 3.08 2.051 4.949 2.051 1.87 0 3.628-.728 4.95-2.051 1.322-1.322 2.05-3.08 2.05-4.949 0-1.87-.728-3.628-2.05-4.95-1.322-1.322-3.08-2.05-4.95-2.05-1.869 0-3.627.728-4.949 2.05-.196.195-.512.195-.707 0-.196-.195-.196-.512 0-.707 1.51-1.511 3.52-2.343 5.656-2.343 2.137 0 4.146.832 5.657 2.343zM8.7935 8.5l-7.793 0 0 2c0 .275-.226.5-.5.5-.275 0-.5-.225-.5-.5l0-5c0-.275.225-.5.5-.5.274 0 .5.225.5.5l0 2 7.793 0-2.647-2.646c-.195-.196-.195-.512 0-.708.195-.195.512-.195.707 0l3.5 3.5c.098.098.147.226.147.354 0 .128-.049.256-.147.354l-3.5 3.5c-.098.098-.226.146-.353.146-.128 0-.256-.048-.354-.146-.195-.195-.195-.512 0-.707L8.7935 8.5z"],"sign-in-forced_24":["M20.4912 3.5146c4.678 4.679 4.678 12.292 0 16.971-2.267 2.266-5.28 3.514-8.485 3.514-3.205 0-6.219-1.248-8.486-3.514-.195-.196-.195-.512 0-.707.196-.196.512-.196.707 0 4.289 4.289 11.268 4.289 15.557 0 4.289-4.289 4.289-11.268 0-15.557-4.289-4.29-11.267-4.288-15.557 0-.195.195-.511.195-.707 0-.195-.195-.195-.512 0-.707 2.267-2.267 5.281-3.515 8.486-3.515 3.205 0 6.218 1.248 8.485 3.515zM13.2988 12.5l-12.299 0 0 5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-11c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 5 12.299 0-3.646-3.646c-.196-.196-.196-.512 0-.708.195-.195.511-.195.707 0l4.5 4.5c.195.196.195.512 0 .708l-4.5 4.5c-.098.097-.226.146-.354.146-.128 0-.256-.049-.353-.146-.196-.196-.196-.512 0-.708l3.646-3.646z"],"sign-out_10":["M8.5343 1.4634c.945.944 1.465 2.199 1.465 3.535 0 1.336-.52 2.591-1.465 3.535-.964.965-2.249 1.463-3.543 1.463-.957 0-1.918-.272-2.757-.831-.23-.152-.293-.463-.139-.692.152-.231.462-.294.693-.14 1.578 1.049 3.697.836 5.039-.507.756-.755 1.172-1.759 1.172-2.828 0-1.068-.416-2.073-1.172-2.828-1.347-1.347-3.471-1.557-5.05-.499-.229.153-.54.092-.694-.137-.153-.229-.092-.54.138-.693 1.974-1.325 4.629-1.061 6.313.622zM.1461 5.3521c-.046-.046-.083-.102-.108-.162-.051-.123-.051-.26 0-.383.025-.06.062-.116.108-.162l2-2c.195-.195.511-.195.707 0 .195.195.195.512 0 .707l-1.147 1.146 4.352 0c.276 0 .5.224.5.5 0 .277-.224.5-.5.5l-4.352 0 1.147 1.147c.195.195.195.512 0 .707-.098.098-.226.146-.354.146-.128 0-.256-.048-.353-.146l-2-2z"],"sign-out_12":["M10.2428462 1.76427766C11.3759454 2.89547873 12 4.40008599 12 5.99954241c0 1.60045482-.6240546 3.10506208-1.7571538 4.23526479C9.07074369 11.4059447 7.53760954 12 5.99947495 12c-1.34711787 0-2.69923618-.455276-3.8183341-1.3788073-.21301864-.176719-.24302126-.4902204-.06700586-.70288223.17501531-.21366022.49104296-.24261418.7040616-.06689362 1.99617467 1.64738025 4.8834273 1.50860095 6.71758779-.32248716.94408262-.94250116 1.46412812-2.19550852 1.46412812-3.52938728 0-1.33387876-.5200455-2.58688613-1.46412812-3.52938729C7.70162389.640065473 4.81337117.501286171 2.81819659 2.14866638c-.21201855.17671896-.5280462.14576818-.70306152-.06789204-.17701548-.21266181-.14701286-.52616325.06600578-.70288222 2.39520958-1.974859419 5.86151288-1.810121399 8.06170535.38638554zM.146262798 6.35278066c-.046004025-.04592697-.0830072631-.10183805-.1080094508-.16174279-.0510044629-.1228047-.0510044629-.25958718 0-.38239189.0250021877-.05990473.0620054258-.11581582.1080094508-.16174278L2.14643781 3.65007871c.19501707-.19469039.51104472-.19469039.70706187 0 .19501707.19469039.19501707.51118707 0 .70587746L1.70639931 5.5001366l5.58748891 0c.27602415 0 .50004375.22364434.50004375.49920612 0 .2765602-.2240196.49920613-.50004375.49920613l-5.58748891 0 1.14710037 1.14517884c.19501707.19469039.19501707.51118707 0 .70587746-.09800857.0978444-.22601978.14576819-.35403098.14576819-.1280112 0-.2560224-.04792379-.35303089-.14576819L.146262798 6.35278066z"],"sign-out_16":["M8 16c-2.137 0-4.146-.832-5.657-2.343-.195-.196-.195-.512 0-.707.196-.196.512-.196.707 0C4.373 14.272 6.13 15 8 15c1.87 0 3.627-.728 4.95-2.05C14.272 11.627 15 9.87 15 8c0-1.87-.728-3.627-2.05-4.95C11.627 1.728 9.87 1 8 1c-1.87 0-3.627.728-4.95 2.05-.195.196-.511.196-.707 0-.195-.195-.195-.511 0-.707C3.854.832 5.863 0 8 0c2.137 0 4.146.832 5.657 2.343C15.168 3.854 16 5.863 16 8c0 2.137-.832 4.146-2.343 5.657C12.146 15.168 10.137 16 8 16zM.1465 8.354C.0485 8.256.0005 8.128.0005 8c0-.128.048-.256.146-.354l3.5-3.5c.098-.097.226-.146.354-.146.127 0 .255.049.353.146.195.196.195.512 0 .708L1.7065 7.5l8.294 0c.274 0 .5.226.5.5 0 .275-.226.5-.5.5l-8.293 0 2.646 2.647c.195.195.195.512 0 .707-.195.195-.512.195-.707 0l-3.5-3.5z"],"sign-out_24":["M20.4852 3.5146c4.678 4.679 4.678 12.292 0 16.971-2.267 2.266-5.28 3.514-8.485 3.514-3.205 0-6.219-1.248-8.486-3.514-.195-.196-.195-.512 0-.707.196-.196.512-.196.707 0 4.289 4.289 11.268 4.289 15.557 0 4.289-4.289 4.289-11.268 0-15.557-4.289-4.29-11.267-4.288-15.557 0-.195.195-.511.195-.707 0-.195-.195-.195-.512 0-.707 2.267-2.267 5.281-3.515 8.486-3.515 3.205 0 6.218 1.248 8.485 3.515zM5.3534 7.8535l-3.646 3.646 12.792 0c.276 0 .5.225.5.5 0 .276-.224.5-.5.5l-12.792 0 3.646 3.647c.195.195.195.512 0 .707-.195.195-.512.195-.707 0l-4.5-4.5c-.195-.195-.195-.512 0-.707l4.5-4.5c.098-.098.226-.147.353-.147.128 0 .256.049.354.147.195.195.195.512 0 .707z"],"signal-0_16":["M14 13.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5zm-4 0c0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5zm-4 0c0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5zm-4 0c0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5z"],"signal-100_16":["M14.5 14c-.276 0-.5-.224-.5-.5l0-11c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 11c0 .276-.224.5-.5.5zm-12 0c-.276 0-.5-.224-.5-.5l0-2c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 2c0 .276-.224.5-.5.5zm8 0c-.276 0-.5-.224-.5-.5l0-8c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 8c0 .276-.224.5-.5.5zm-4 0c-.276 0-.5-.224-.5-.5l0-5c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 5c0 .276-.224.5-.5.5z"],"signal-25_16":["M2.5 14c-.276 0-.5-.224-.5-.5l0-2c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 2c0 .276-.224.5-.5.5zm11.5-.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5zm-4 0c0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5zm-4 0c0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5z"],"signal-50_16":["M2.5 14c-.276 0-.5-.224-.5-.5l0-2c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 2c0 .276-.224.5-.5.5zm4 0c-.276 0-.5-.224-.5-.5l0-5c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 5c0 .276-.224.5-.5.5zm7.5-.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5zm-4 0c0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5z"],"signal-75_16":["M2.5 14c-.276 0-.5-.224-.5-.5l0-2c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 2c0 .276-.224.5-.5.5zm8 0c-.276 0-.5-.224-.5-.5l0-8c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 8c0 .276-.224.5-.5.5zm-4 0c-.276 0-.5-.224-.5-.5l0-5c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 5c0 .276-.224.5-.5.5zm7.5-.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5z"],"single-number-reach_12":["M11.9902 4.132c.048.378-.08.747-.351 1.015l-.669.664c-.414.409-1.031.535-1.575.322l-.841-.333c-.469-.184-.828-.563-.988-1.037l-.171-.507c-.786-.086-1.838-.083-2.805.023l-.156.484c-.16.474-.52.852-.988 1.037l-.841.332c-.175.07-.359.103-.541.103-.38 0-.754-.147-1.034-.424l-.669-.663c-.271-.269-.399-.639-.352-1.016.047-.375.261-.7.587-.892C1.9532 2.44 3.8732 2 6.0002 2c2.128 0 4.047.44 5.404 1.241.326.191.539.516.586.891zm-1.055.305c.066-.065.068-.141.063-.181-.005-.038-.024-.109-.102-.154C9.7082 3.402 7.9242 3 6.0002 3c-1.923 0-3.708.401-4.897 1.102-.077.045-.097.116-.102.154-.004.039-.003.116.064.181l.669.663c.132.13.33.17.505.102l.84-.331c.193-.077.342-.232.407-.427l.168-.498c.121-.361.447-.621.829-.661 1.055-.116 2.164-.119 3.043-.01.377.047.697.307.817.662l.171.507c.066.195.213.35.407.427l.841.332c.174.068.372.027.504-.103l.669-.663zM1.3185 9.0635l.841 0c.045.25.224.417.561.417.317 0 .467-.117.467-.275 0-.229-.175-.296-.675-.404-.694-.154-1.082-.391-1.082-.953 0-.524.392-.898 1.253-.898.741 0 1.219.353 1.315.935l-.82 0c-.042-.237-.229-.349-.504-.349-.249 0-.37.096-.37.233 0 .175.138.237.537.316.766.154 1.219.466 1.219 1.044 0 .496-.399.941-1.348.941-.936 0-1.319-.499-1.394-1.007zm5.9341-2.0513l0 2.996-.861 0-1.036-1.848 0 1.848-.741 0 0-2.996.915 0 .982 1.76 0-1.76.741 0zm2.4049 2.9963l-.645-1.041-.237 0 0 1.041-.87 0 0-2.996 1.178 0c.903 0 1.348.349 1.348.973 0 .425-.212.679-.566.828l.816 1.195-1.024 0zm-.882-2.405l0 .773.345 0c.242 0 .417-.145.417-.391 0-.266-.158-.382-.446-.382l-.316 0z"],"single-number-reach_16":["M15.9894 5.749c.056.458-.099.907-.427 1.232l-.913.904c-.514.51-1.28.665-1.953.399l-1.147-.452c-.589-.233-1.041-.708-1.241-1.304l-.233-.691c-.019-.057-.072-.098-.138-.107-1.094-.135-2.544-.13-3.879.015-.066.007-.119.047-.138.105l-.228.678c-.201.596-.653 1.071-1.241 1.304l-1.147.452c-.218.086-.445.128-.67.128-.472 0-.935-.183-1.282-.526l-.914-.905c-.328-.325-.483-.774-.427-1.232.057-.455.316-.85.712-1.082C2.5214 3.607 5.1734 3 8.0004 3c2.829 0 5.481.607 7.277 1.667.396.232.655.627.712 1.082zm-1.132.522c.107-.106.158-.251.139-.398-.01-.085-.054-.244-.226-.345C13.1234 4.557 10.6554 4 8.0004 4c-2.654 0-5.121.557-6.77 1.528-.172.101-.216.26-.226.345-.019.147.032.292.139.398l.912.904c.231.229.577.297.882.179l1.146-.452c.314-.124.555-.377.662-.693l.227-.678c.144-.426.528-.732.978-.781 1.428-.154 2.927-.158 4.11-.012.443.054.822.361.963.78l.233.691c.106.316.347.569.661.693l1.146.452c.304.119.65.05.882-.179l.912-.904zM2.4023 11.8301l.879 0c.061.349.344.609.87.609.536 0 .741-.177.741-.46 0-.409-.426-.52-.996-.652-.664-.155-1.35-.399-1.35-1.24 0-.703.542-1.151 1.599-1.151.929 0 1.477.415 1.582 1.107l-.868 0c-.045-.299-.338-.471-.736-.471-.471 0-.642.161-.642.404 0 .327.254.427.808.548.763.166 1.538.476 1.538 1.35 0 .642-.504 1.212-1.688 1.212-1.024 0-1.627-.492-1.737-1.256zm7.2222-2.8106l0 3.983-.958 0-1.571-2.827 0 2.827-.797 0 0-3.983 1.03 0 1.504 2.722 0-2.722.792 0zm2.8729 3.9836l-.88-1.455-.509 0 0 1.455-.929 0 0-3.984 1.466 0c1.112 0 1.687.443 1.687 1.262 0 .553-.254.907-.791 1.107l1.057 1.615-1.101 0zm-1.389-3.342l0 1.245.581 0c.398 0 .68-.222.68-.625 0-.432-.243-.62-.713-.62l-.548 0z"],"skip_10":["M4.3513 1.144l3.502 3.502c.196.196.196.512 0 .707l-3.509 3.509c-.097.098-.225.147-.353.147-.128 0-.256-.049-.354-.147-.195-.195-.195-.511 0-.707L6.2933 5.5l-5.793 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l5.793 0-2.649-2.649c-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0zM9.5 0c.276 0 .5.224.5.5l0 9c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-9c0-.276.224-.5.5-.5z"],"skip_16":["M6.8455 2.1465l6.008 6c.094.094.147.221.147.354 0 .132-.053.259-.147.354l-6.008 6c-.196.193-.512.194-.708-.001-.194-.195-.194-.513 0-.707l5.155-5.146-10.793 0c-.276 0-.499-.224-.499-.5 0-.276.223-.5.499-.5l10.793 0-5.155-5.146c-.194-.195-.194-.513 0-.707.099-.099.226-.147.354-.147.128 0 .256.048.354.146zM15.5 2c.275 0 .5.225.5.5l0 12c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-12c0-.275.225-.5.5-.5z"],"skip_24":["M10.8535 3.1464l9 9c.195.195.195.512 0 .707l-9 9c-.195.195-.512.195-.707 0-.195-.195-.195-.512 0-.707l8.146-8.146-17.793 0c-.276 0-.5-.224-.5-.5 0-.277.224-.5.5-.5l17.793 0-8.146-8.147c-.195-.195-.195-.512 0-.707.098-.098.226-.146.353-.146.128 0 .256.048.354.146zM23.5 2.9999c.275 0 .5.225.5.5l0 18c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-18c0-.275.225-.5.5-.5z"],"skip-bw_16":["M12.4775 11.9736c.125 0 .222-.046.269-.075.077-.046.255-.182.255-.451l0-6.907c0-.269-.178-.405-.255-.451-.076-.046-.28-.138-.518-.013l-6.971 3.467c-.161.087-.265.26-.265.457 0 .198.104.371.278.464l6.945 3.44c.095.051.184.069.262.069m-.004-8.962c.271 0 .543.073.788.22.464.279.738.768.738 1.309l0 6.907c0 .541-.274 1.03-.738 1.309-.465.277-1.026.291-1.503.038l-6.946-3.44c-.511-.273-.82-.789-.82-1.354 0-.564.309-1.08.807-1.346l6.971-3.467c.22-.117.461-.176.703-.176zM2.5 3c.276 0 .5.224.5.5l0 9c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-9c0-.276.224-.5.5-.5z"],"skip-bw_24":["M7.1195 13.8821c-.683-.362-1.119-1.083-1.119-1.873-.001-.791.436-1.513 1.138-1.885l11.684-6.855c.331-.174.685-.261 1.036-.261.384 0 .765.103 1.107.309.648.391 1.035 1.074 1.035 1.826l0 13.719c0 .753-.387 1.436-1.035 1.826-.655.394-1.449.415-2.124.059l-11.722-6.865zm.506-2.885c-.399.212-.626.586-.625 1.012 0 .425.226.799.606.999l11.722 6.865c.16.085.338.127.518.127.206 0 .415-.056.603-.169.344-.207.551-.569.551-.969l0-13.719c0-.399-.207-.761-.551-.968-.35-.211-.778-.222-1.14-.032l-11.684 6.854zM2.5 20.999c-.276 0-.5-.224-.5-.5l0-17c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 17c0 .276-.224.5-.5.5z"],"skip-fw_16":["M3.5225 4.0264c-.125 0-.222.046-.269.075-.077.046-.255.182-.255.451l0 6.907c0 .269.178.405.255.451.076.046.28.138.518.013l6.971-3.467c.161-.087.265-.26.265-.457 0-.198-.104-.371-.278-.464l-6.945-3.44c-.095-.051-.184-.069-.262-.069m.004 8.962c-.271 0-.543-.073-.788-.22-.464-.279-.738-.768-.738-1.309l0-6.907c0-.541.274-1.03.738-1.309.465-.277 1.026-.291 1.503-.038l6.946 3.44c.511.273.82.789.82 1.354 0 .564-.309 1.08-.807 1.346l-6.971 3.467c-.22.117-.461.176-.703.176zM13.5 13c-.276 0-.5-.224-.5-.5l0-9c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 9c0 .276-.224.5-.5.5z"],"skip-fw_24":["M16.8805 10.117c.683.362 1.119 1.083 1.119 1.873.001.791-.436 1.513-1.138 1.885L5.1775 20.73c-.331.174-.685.261-1.036.261-.384 0-.765-.103-1.107-.309-.648-.391-1.035-1.074-1.035-1.826l0-13.719c0-.753.387-1.436 1.035-1.826.655-.394 1.449-.415 2.124-.059l11.722 6.865zm-.506 2.885c.399-.212.626-.586.625-1.012 0-.425-.226-.799-.606-.999L4.6715 4.126c-.16-.085-.338-.127-.518-.127-.206 0-.415.056-.603.169-.344.207-.551.569-.551.969l0 13.719c0 .399.207.761.551.968.35.211.778.222 1.14.032l11.684-6.854zM21.5 3c.276 0 .5.224.5.5l0 17c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-17c0-.276.224-.5.5-.5z"],"space_12":["M11.882.917c.076.179.118.375.118.581l0 9.003c0 .206-.042.403-.118.583-.152.357-.44.646-.799.798-.18.076-.377.118-.583.118l-9 0c-.207 0-.404-.042-.584-.118-.358-.152-.646-.441-.798-.798C.042 10.904 0 10.707 0 10.5l0-9c0-.207.042-.404.118-.583C.27.558.558.27.916.118 1.096.042 1.292 0 1.499 0l9.002 0c.206 0 .403.042.582.118.359.152.647.44.799.799zM11 10.5l0-9c0-.275-.224-.5-.5-.5l-9 0c-.276 0-.5.225-.5.5l0 9c0 .275.224.5.5.5l9 0c.276 0 .5-.225.5-.5zM7.5 4C8.878 4 10 5.121 10 6.5 10 7.879 8.878 9 7.5 9L4 9c-1.103 0-2-.897-2-2 0-.723.394-1.381 1.011-1.731C3.128 3.998 4.199 3 5.5 3c.784 0 1.52.376 1.989 1L7.5 4zm0 4C8.327 8 9 7.327 9 6.5c0-.872-.79-1.591-1.633-1.486-.203.023-.465-.063-.566-.243C6.534 4.296 6.035 4 5.5 4 4.673 4 4 4.673 4 5.5c.011.222-.117.488-.326.562C3.271 6.201 3 6.579 3 7c0 .552.448 1 1 1l3.5 0z"],"space_16":["M14 0c1.104 0 2 .897 2 2l0 12c0 1.103-.896 2-2 2L2 16c-1.104 0-2-.897-2-2L0 2C0 .897.896 0 2 0l12 0zm1 14l0-12c0-.551-.449-1-1-1L2 1c-.551 0-1 .449-1 1l0 12c0 .551.449 1 1 1l12 0c.551 0 1-.449 1-1zm-4.659-7.981c1.495.169 2.661 1.441 2.661 2.981 0 1.654-1.346 3-3 3L5.5 12C4.121 12 3 10.879 3 9.5c0-1.004.613-1.904 1.512-2.294-.007-.074-.01-.148-.01-.222 0-1.654 1.346-3 3-3 1.295 0 2.432.835 2.839 2.035zM10.002 11c1.103 0 2-.897 2-2 0-1.096-.885-1.988-1.978-2-.025.003-.054.005-.071.005-.239 0-.445-.17-.491-.404-.182-.937-1.006-1.617-1.96-1.617-1.103 0-2 .898-2 2 0 .139.019.287.057.453.03.13.006.267-.066.379-.071.114-.184.193-.315.221C4.495 8.187 4 8.802 4 9.5c0 .827.673 1.5 1.5 1.5l4.502 0z"],"spark_16":["M15.5 8L9.707 8l4.145-4.144c.194-.195.194-.513 0-.708-.195-.194-.513-.194-.708 0L9 7.293 9 1.5c0-.275-.225-.5-.5-.5-.275 0-.5.225-.5.5l0 5.798-4.15-4.15c-.194-.194-.513-.194-.707 0-.194.195-.194.513 0 .708L7.287 8 1.5 8c-.275 0-.5.225-.5.5 0 .275.225.5.5.5l5.793 0-4.15 4.15c-.194.194-.194.513 0 .707.194.194.513.194.707 0L8 9.707 8 15.5c0 .275.225.5.5.5.275 0 .5-.225.5-.5l0-5.787 4.144 4.144c.195.194.513.194.708 0 .194-.194.194-.513 0-.707L9.702 9 15.5 9c.275 0 .5-.225.5-.5 0-.275-.225-.5-.5-.5"],"spark-board_12":["M10.5 1c.827 0 1.5.673 1.5 1.5l0 7c0 .827-.673 1.5-1.5 1.5l-9 0C.673 11 0 10.327 0 9.5l0-7C0 1.673.673 1 1.5 1l9 0zm.5 8.5l0-7c0-.275-.225-.5-.5-.5l-9 0c-.276 0-.5.225-.5.5l0 7c0 .275.224.5.5.5l9 0c.275 0 .5-.225.5-.5zM5.667 4c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l.666 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-.666 0zM9.5 8c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0zm-3 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0z"],"spark-board_14":["M12.3 1.9998c.939 0 1.7.761 1.7 1.7l0 7.6c0 .939-.761 1.7-1.7 1.7l-10.6 0c-.939 0-1.7-.761-1.7-1.7l0-7.6c0-.939.761-1.7 1.7-1.7l10.6 0zm.7 9.3l0-7.6c0-.386-.314-.7-.7-.7l-10.6 0c-.386 0-.7.314-.7.7l0 7.6c0 .386.314.7.7.7l10.6 0c.386 0 .7-.314.7-.7zM7.5 4c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0zm0 6c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0zm4 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-2 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l2 0z"],"spark-board_16":["M14.006 2C15.107 2 16 2.902 16 4.009l0 7.982C16 13.1 15.105 14 14.006 14L1.994 14C.893 14 0 13.097 0 11.991l0-7.982C0 2.899.895 2 1.994 2l12.012 0zM15 11.991l0-7.982C15 3.451 14.553 3 14.006 3L1.994 3C1.447 3 1 3.451 1 4.009l0 7.982c0 .558.447 1.009.994 1.009l12.012 0c.547 0 .994-.451.994-1.009zM8.5 3.9998c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0zm0 7c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0zm5 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-2 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l2 0z"],"spark-board_20":["M19.572 3.104c.27.398.428.878.428 1.396l0 11c0 1.379-1.121 2.5-2.5 2.5l-15 0c-.862 0-1.623-.437-2.072-1.104C.158 16.498 0 16.018 0 15.5l0-11C0 3.121 1.121 2 2.5 2l15 0c.862 0 1.623.437 2.072 1.104zM19 15.5l0-11c0-.207-.042-.404-.118-.584-.152-.358-.44-.646-.799-.798C17.904 3.042 17.707 3 17.5 3l-15 0C1.673 3 1 3.673 1 4.5l0 11c0 .207.042.404.118.584.152.358.44.646.799.798.179.076.376.118.583.118l15 0c.827 0 1.5-.673 1.5-1.5zM10.5 4c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0zM10 14c.552 0 1 .447 1 1 0 .553-.448 1-1 1-.552 0-1-.447-1-1 0-.553.448-1 1-1zm7.5 1c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-3 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l3 0z"],"spark-board_24":["M0 5.50282288C0 4.12055197 1.12537944 3 2.50050165 3L21.4994984 3C22.8804873 3 24 4.12598062 24 5.50282288l0 12.99435422C24 19.879448 22.8746206 21 21.4994984 21L2.50050165 21C1.11951272 21 0 19.8740194 0 18.4971771L0 5.50282288zm1 0L1 18.4971771C1 19.3241517 1.67421141 20 2.50050165 20l18.99899675 0C22.3245167 20 23 19.3249836 23 18.4971771l0-12.99435422C23 4.67584834 22.3257886 4 21.4994984 4L2.50050165 4C1.67548327 4 1 4.67501637 1 5.50282288zM21.5 19.0625l-3 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l3 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5zm-9-13l-1 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5zM12 19c-.5522847 0-1-.4477153-1-1 0-.5522847.4477153-1 1-1 .5522847 0 1 .4477153 1 1 0 .5522847-.4477153 1-1 1z"],"spark-board_28":["M25 3L3 3C1.342 3 0 4.343 0 6l0 16c0 1.657 1.342 3 3 3l22 0c1.657 0 3-1.343 3-3l0-16c0-1.657-1.343-3-3-3m0 1c1.103 0 2 .897 2 2l0 16c0 1.103-.897 2-2 2L3 24c-1.104 0-2-.897-2-2L1 6c0-1.103.896-2 2-2l22 0zM14.4994995 7C14.7757758 7 15 6.776 15 6.5c0-.276-.2242242-.5-.5005005-.5l-.998999 0C13.2242242 6 13 6.224 13 6.5c0 .276.2242242.5.5005005.5l.998999 0zM24.5 22c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5l-3 0c-.276 0-.5.224-.5.5 0 .276.224.5.5.5l3 0zM15 21c0-.553-.447-1-1-1-.553 0-1 .447-1 1 0 .553.447 1 1 1 .553 0 1-.447 1-1z"],"spark-board_32":["M3 5c-1.1045695 0-2 .8954305-2 2l0 18c0 1.1045695.8954305 2 2 2l26 0c1.1045695 0 2-.8954305 2-2l0-18c0-1.1045695-.8954305-2-2-2L3 5zm0-1l26 0c1.6568542 0 3 1.34314575 3 3l0 18c0 1.6568542-1.3431458 3-3 3L3 28c-1.65685425 0-3-1.3431458-3-3L0 7c0-1.65685425 1.34314575-3 3-3zm12.5 3c-.2761424 0-.5.22385763-.5.5 0 .27614237.2238576.5.5.5l1 0c.2761424 0 .5-.22385763.5-.5 0-.27614237-.2238576-.5-.5-.5l-1 0zm.5 18c.5522847 0 1-.4477153 1-1 0-.5522847-.4477153-1-1-1-.5522847 0-1 .4477153-1 1 0 .5522847.4477153 1 1 1zm7.5-1c-.2761424 0-.5.2238576-.5.5 0 .2761424.2238576.5.5.5l5 0c.2761424 0 .5-.2238576.5-.5 0-.2761424-.2238576-.5-.5-.5l-5 0z"],"spark-board_48":["M4.5 6l39 0c2.4852814 0 4.5 2.01471863 4.5 4.5l0 27c0 2.4852814-2.0147186 4.5-4.5 4.5l-39 0C2.01471863 42 0 39.9852814 0 37.5l0-27C0 8.01471863 2.01471863 6 4.5 6zm0 1C2.56700338 7 1 8.56700338 1 10.5l0 27C1 39.4329966 2.56700338 41 4.5 41l39 0c1.9329966 0 3.5-1.5670034 3.5-3.5l0-27C47 8.56700338 45.4329966 7 43.5 7l-39 0zm18 3l3 0c.2761424 0 .5.22385763.5.5 0 .27614237-.2238576.5-.5.5l-3 0c-.2761424 0-.5-.22385763-.5-.5 0-.27614237.2238576-.5.5-.5zm14 27l7 0c.2761424 0 .5.2238576.5.5 0 .2761424-.2238576.5-.5.5l-7 0c-.2761424 0-.5-.2238576-.5-.5 0-.2761424.2238576-.5.5-.5zM24 38c-.5522847 0-1-.4477153-1-1 0-.5522847.4477153-1 1-1 .5522847 0 1 .4477153 1 1 0 .5522847-.4477153 1-1 1z"],"spark-quad-camera_16":["M14.5 6c.827 0 1.5.673 1.5 1.5l0 2c0 .827-.673 1.5-1.5 1.5l-13 0C.673 11 0 10.327 0 9.5l0-2C0 6.673.673 6 1.5 6l13 0zm.5 3.5l0-2c0-.276-.225-.5-.5-.5l-13 0c-.275 0-.5.224-.5.5l0 2c0 .276.225.5.5.5l13 0c.275 0 .5-.224.5-.5zM9.5 8c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm-2 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0z"],"spark-quad-camera_20":["M18 6c1.104 0 2 .896 2 2l0 4c0 1.104-.896 2-2 2L2 14c-1.104 0-2-.896-2-2l0-4c0-1.104.896-2 2-2l16 0zm1 6l0-4c0-.551-.448-1-1-1L2 7c-.552 0-1 .449-1 1l0 4c0 .551.448 1 1 1l16 0c.552 0 1-.449 1-1zm-8.5-2.5c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-3 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l3 0zm2 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5z"],"spark-room-kit_16":["M14.5 6c.827 0 1.5.673 1.5 1.5l0 2c0 .827-.673 1.5-1.5 1.5l-13 0C.673 11 0 10.327 0 9.5l0-2C0 6.673.673 6 1.5 6l13 0zm.5 3.5l0-2c0-.276-.225-.5-.5-.5l-13 0c-.275 0-.5.224-.5.5l0 2c0 .276.225.5.5.5l13 0c.275 0 .5-.224.5-.5zM8.5 8c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0z"],"spark-room-kit_20":["M19 12c0 .551-.448 1-1 1L2 13c-.552 0-1-.449-1-1l0-4c0-.551.448-1 1-1l16 0c.552 0 1 .449 1 1l0 4zm-1-6L2 6C.896 6 0 6.896 0 8l0 4c0 1.104.896 2 2 2l16 0c1.104 0 2-.896 2-2l0-4c0-1.104-.896-2-2-2z","M10.5 9.5l-1 0c-.275 0-.5.225-.5.5 0 .275.225.5.5.5l1 0c.275 0 .5-.225.5-.5 0-.275-.225-.5-.5-.5"],"spark-room-kit-plus_16":["M14 4c1.103 0 2 .897 2 2l0 4c0 1.103-.897 2-2 2L2 12c-1.103 0-2-.897-2-2l0-4c0-1.103.897-2 2-2l12 0zm1 6l0-4c0-.551-.448-1-1-1L2 5c-.552 0-1 .449-1 1l0 4c0 .551.448 1 1 1l12 0c.552 0 1-.449 1-1zm-1-1.5l0 1c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-1c0-.276.224-.5.5-.5.276 0 .5.224.5.5z"],"spark-room-kit-plus_20":["M18 5c1.1 0 2 .9 2 2l0 6c0 1.1-.9 2-2 2L2 15c-1.1 0-2-.9-2-2l0-6c0-1.1.9-2 2-2l16 0zm1 8l0-6c0-.551-.448-1-1-1L2 6c-.552 0-1 .449-1 1l0 6c0 .551.448 1 1 1l16 0c.552 0 1-.449 1-1zm-1.5-2c.276 0 .5.224.5.5l0 1c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-1c0-.276.224-.5.5-.5z"],"spark-share_16":["M14.7397374 11.148c.862 2.072-.515 4.382-2.754 4.633-1.15500004.129-2.40500004.212-3.73900004.219-.061 0-.123 0-.184 0-1.464 0-2.829-.091-4.078-.237-2.192999996-.256-3.550999996-2.506-2.754999996-4.558.425-1.096.965999996-2.272 1.658999996-3.487.733-1.284 1.516-2.405 2.288-3.371.239-.3.523-.531.823-.73l0-2.117c0-.827.673-1.5 1.5-1.5l1 0c.827 0 1.5.673 1.5 1.5l0 2.143c.308.209.598.452.84.766.74300004.966 1.49500004 2.067 2.21100004 3.309.684 1.191 1.239 2.346 1.689 3.43zm-1.068 2.479c.379-.643.432-1.407.146-2.096-.472-1.134-1.022-2.249-1.634-3.314-.638-1.108-1.35700004-2.184-2.13700004-3.198-.498-.648-1.251-1.019-2.067-1.019-.791 0-1.529.354-2.022.971-.814 1.02-1.555 2.111-2.2 3.243-.611 1.073-1.149 2.201-1.596 3.352-.265999996.686-.200999996 1.442.179 2.072.382.634 1.023 1.046 1.76 1.132 1.31.152 2.643.23 3.962.23l.179 0c1.208-.007 2.431-.078 3.63300004-.213.757-.085 1.412-.508 1.797-1.16zM6.99973736 1.5l0 1.652c.321-.09.649-.152.98-.152.345 0 .686.067 1.02.166l0-1.666c0-.276-.224-.5-.5-.5l-1 0c-.275 0-.5.224-.5.5zm1.0001 6.5c1.103 0 2 .897 2 2 0 1.103-.897 2-2 2-1.103 0-2-.897-2-2 0-1.103.897-2 2-2zm0 3c.552 0 1-.449 1-1 0-.551-.448-1-1-1-.552 0-1 .449-1 1 0 .551.448 1 1 1z"],"spark-share_20":["M18.6669 14.0273c1.108 2.551-.664 5.394-3.542 5.703-1.484.159-3.093.26-4.808.269-.079.001-.158.001-.237.001-1.883 0-3.637-.113-5.242-.292-2.82-.315-4.566-3.085-3.542-5.61.546-1.348 1.242-2.796 2.133-4.291.942-1.582 1.949-2.961 2.941-4.149.458-.549 1.019-.959 1.63-1.235l0-2.923c0-.829.672-1.5 1.5-1.5l1 0c.828 0 1.5.671 1.5 1.5l0 2.946c.624.289 1.192.717 1.651 1.288.956 1.189 1.923 2.544 2.842 4.073.882 1.466 1.595 2.887 2.174 4.22zm-1.079 3.086c.483-.831.542-1.81.161-2.688-.609-1.404-1.32-2.785-2.112-4.103-.825-1.372-1.756-2.705-2.766-3.962-.694-.864-1.751-1.36-2.897-1.36-1.114 0-2.147.473-2.836 1.299-1.055 1.264-2.014 2.616-2.85 4.02-.792 1.329-1.487 2.728-2.065 4.155-.355.873-.28 1.841.206 2.656.528.887 1.447 1.464 2.52 1.585 1.697.189 3.423.285 5.131.285l.233-.001c1.566-.008 3.149-.096 4.706-.263 1.101-.119 2.038-.71 2.569-1.623zm-8.588-15.613l0 2.6c.32-.065.647-.1.974-.1.344 0 .688.036 1.026.109l0-2.609c0-.276-.224-.5-.5-.5l-1 0c-.275 0-.5.224-.5.5zm.9757 8.5477c1.641 0 2.976 1.335 2.976 2.976 0 1.641-1.335 2.976-2.976 2.976-1.641 0-2.976-1.335-2.976-2.976 0-1.641 1.335-2.976 2.976-2.976zm0 4.952c1.09 0 1.976-.886 1.976-1.976 0-1.089-.886-1.976-1.976-1.976-1.089 0-1.976.887-1.976 1.976 0 1.09.887 1.976 1.976 1.976z"],"spark-voice_16":["M12.5 8c.332 1.328.5 2.692.5 4.062L13 14c0 1.104-.896 2-2 2l-6 0c-1.104 0-2-.896-2-2l0-1.938c0-1.37.168-2.734.5-4.062.332-1.328.5-2.692.5-4.062L4 2c0-1.104.896-2 2-2l4 0c1.104 0 2 .896 2 2l0 1.938c0 1.37.168 2.734.5 4.062zm-.5 6l0-1.938c0-1.287-.158-2.572-.47-3.819-.351-1.407-.53-2.855-.53-4.305L11 2c0-.551-.448-1-1-1L6 1c-.552 0-1 .449-1 1l0 1.938c0 1.45-.179 2.898-.53 4.305C4.158 9.49 4 10.775 4 12.062L4 14c0 .551.448 1 1 1l6 0c.552 0 1-.449 1-1zM9.5 2c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-3 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l3 0zM8 7c1.103 0 2 .897 2 2 0 1.103-.897 2-2 2-1.103 0-2-.897-2-2 0-1.103.897-2 2-2zm0 3c.55 0 1-.45 1-1 0-.55-.45-1-1-1-.55 0-1 .45-1 1 0 .55.45 1 1 1z"],"spark-voice_20":["M15.5 10c.332 1.663.5 3.354.5 5.049l0 2.451c0 1.381-1.119 2.5-2.5 2.5l-7 0C5.119 20 4 18.881 4 17.5l0-2.451c0-1.695.168-3.386.5-5.049.332-1.663.5-3.354.5-5.049L5 2.5C5 1.119 6.119 0 7.5 0l5 0C13.881 0 15 1.119 15 2.5l0 2.451c0 1.695.168 3.386.5 5.049zm-.5 7.5l0-2.451c0-1.626-.162-3.258-.48-4.853-.345-1.723-.52-3.488-.52-5.245L14 2.5c0-.827-.673-1.5-1.5-1.5l-5 0C6.673 1 6 1.673 6 2.5l0 2.451c0 1.757-.175 3.522-.52 5.245-.318 1.595-.48 3.227-.48 4.853L5 17.5c0 .827.673 1.5 1.5 1.5l7 0c.827 0 1.5-.673 1.5-1.5zM11.5 3c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-3 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l3 0zM10 10c1.103 0 2 .897 2 2 0 1.103-.897 2-2 2-1.103 0-2-.897-2-2 0-1.103.897-2 2-2zm0 3c.552 0 1-.449 1-1 0-.551-.448-1-1-1-.552 0-1 .449-1 1 0 .551.448 1 1 1z"],"speaker_12":["M6.585.05C6.837.154 7 .397 7 .67l0 10.657c0 .274-.163.517-.415.621-.084.035-.171.052-.258.052-.174 0-.345-.068-.474-.197L2.282 8l-.781.002C.673 8.002 0 7.329 0 6.502l0-1.006c0-.827.673-1.5 1.5-1.5l.782 0 3.56-3.79c.203-.204.491-.26.743-.156zM6 10.499l0-9L2.862 4.84c-.094.101-.226.158-.364.158l-.001 0-.998-.002c-.275 0-.499.225-.499.5l0 1.006c0 .275.224.5.5.5l.998 0c.138 0 .27.057.364.157L6 10.499zm4.1416-8.9864c1.198 1.198 1.858 2.791 1.858 4.485 0 1.695-.66 3.287-1.858 4.486-.098.097-.226.146-.354.146-.127 0-.255-.049-.353-.146-.195-.196-.195-.512 0-.707 1.01-1.01 1.565-2.352 1.565-3.779 0-1.426-.555-2.768-1.565-3.778-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0zm-1.5 1.2149c.874.874 1.355 2.035 1.355 3.271 0 1.235-.481 2.396-1.355 3.27-.098.098-.226.146-.354.146-.127 0-.255-.048-.353-.146-.195-.195-.195-.512 0-.707.686-.686 1.062-1.596 1.062-2.563 0-.968-.376-1.878-1.062-2.564-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0z"],"speaker_16":["M13.6572 2.3428c3.119 3.119 3.119 8.195 0 11.314-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147-.195-.195-.195-.511 0-.707 2.729-2.729 2.729-7.17 0-9.9-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0zM8.547.0568c.275.114.453.38.453.678l0 14.531c0 .298-.178.563-.453.678-.092.038-.187.056-.282.056-.191 0-.378-.075-.519-.216l-4.481-4.784-1.265 0c-1.102 0-2-.897-2-2l0-2c0-1.102.898-2 2-2l1.265 0 4.47-4.772c.004-.004.007-.008.011-.012.211-.211.525-.274.801-.159zM8 14.5928l0-13.186-4.154 4.435c-.094.101-.226.158-.365.158l-1.481 0c-.551 0-1 .448-1 1l0 2c0 .552.449 1 1 1l1.481 0c.139 0 .271.058.365.158L8 14.5928zm4.2432-10.835c1.133 1.133 1.757 2.64 1.757 4.242 0 1.603-.624 3.11-1.757 4.242-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147-.195-.195-.195-.511 0-.707.944-.944 1.464-2.199 1.464-3.535 0-1.336-.52-2.591-1.464-3.535-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0z"],"speaker_20":["M11.5148.0612c.299.123.492.412.492.735l0 18.406c0 .323-.193.613-.492.736-.099.041-.203.061-.306.061-.207 0-.41-.081-.563-.234l-5.765-5.766-2.6 0c-1.257 0-2.281-1.023-2.281-2.281l0-3.438c0-1.257 1.024-2.281 2.281-2.281l2.6 0 5.766-5.766c.228-.229.569-.295.868-.172zm-.508 18.65l0-17.424-5.566 5.566c-.094.093-.221.146-.353.146l-2.807 0c-.706 0-1.281.575-1.281 1.281l0 3.438c0 .706.575 1.281 1.281 1.281l2.807 0c.133 0 .26.053.354.147l5.565 5.565zm5.8467-16.3076c2.029 2.029 3.146 4.727 3.146 7.596 0 2.869-1.117 5.566-3.146 7.595-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147-.195-.195-.195-.511 0-.707 1.84-1.839 2.853-4.286 2.853-6.888 0-2.603-1.013-5.049-2.853-6.889-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0zm-1.9941 2.3018c1.378 1.429 2.137 3.309 2.137 5.294 0 1.984-.759 3.863-2.136 5.291-.098.103-.229.153-.359.153-.125 0-.25-.047-.347-.139-.199-.193-.205-.509-.013-.707 1.196-1.242 1.855-2.874 1.855-4.598 0-1.726-.659-3.358-1.857-4.599-.191-.199-.186-.515.013-.707.198-.191.516-.186.707.012z"],"speaker_24":["M13.477 1.0641c.316.132.521.438.521.78l0 20.318c0 .343-.205.648-.521.78-.105.043-.215.065-.323.065-.22 0-.435-.086-.596-.248l-6.63-6.743-2.428 0c-1.378 0-2.5-1.121-2.5-2.5l0-2.969c0-1.379 1.122-2.5 2.5-2.5l2.427 0 6.626-6.794.005-.005c.242-.243.602-.314.919-.184zm-.479 20.716l0-19.552-6.502 6.667c-.094.097-.224.152-.358.152l-2.638 0c-.827 0-1.5.672-1.5 1.5l0 2.969c0 .827.673 1.5 1.5 1.5l2.638 0c.134 0 .262.054.356.15l6.504 6.614zm4.8792-15.5957c1.369 1.553 2.123 3.623 2.123 5.831 0 2.222-.755 4.294-2.126 5.834-.099.111-.237.168-.374.168-.118 0-.237-.042-.332-.127-.207-.184-.225-.499-.041-.705 1.225-1.378 1.873-3.165 1.873-5.17 0-1.964-.665-3.8-1.873-5.169-.183-.207-.163-.523.044-.706.208-.184.523-.162.706.044zm1.9848-2.0097C21.915 6.3667 23 9.0897 23 12.0477c0 2.918-1.084 5.619-3.134 7.811-.098.105-.232.158-.365.158-.123 0-.245-.045-.342-.135-.201-.188-.212-.505-.023-.707 1.874-2.003 2.864-4.467 2.864-7.127 0-2.699-.992-5.185-2.868-7.189-.189-.202-.178-.518.023-.707.202-.188.518-.178.707.023z"],"speaker_28":["M15.452 1.0686c.333.138.549.46.549.821l0 24.21c0 .361-.215.683-.548.822-.111.046-.227.068-.342.068-.23 0-.457-.09-.627-.26l-7.469-7.743-3.015 0c-1.654 0-3-1.346-3-3l0-3.998c0-1.654 1.346-3 3-3l3.015 0 7.463-7.722.005-.005c.254-.255.635-.332.969-.193zm-.451 24.757l0-23.661-7.415 7.672c-.094.097-.224.152-.359.152l-3.227 0c-1.103 0-2 .898-2 2l0 3.998c0 1.103.897 2 2 2l3.227 0c.135 0 .265.055.359.153l7.415 7.686zm8.1894-21.0312c5.068 5.068 5.068 13.316 0 18.385-.098.097-.226.146-.354.146-.127 0-.255-.049-.353-.146-.195-.196-.195-.512 0-.707 4.679-4.679 4.679-12.292 0-16.971-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0zm-2.8281 2.8281c3.51 3.509 3.51 9.22 0 12.729-.098.097-.226.146-.354.146-.127 0-.255-.049-.353-.146-.195-.196-.195-.512 0-.708 3.119-3.119 3.119-8.195 0-11.314-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0z"],"speaker-bluetooth_16":["M8.0001 14.5927l-4.154-4.435c-.094-.1-.226-.158-.365-.158l-1.481 0c-.551 0-1-.448-1-1l0-2c0-.552.449-1 1-1l1.481 0c.139 0 .271-.057.365-.158l4.154-4.435 0 13.186zm.547-14.536c-.276-.115-.59-.052-.801.159-.004.004-.007.008-.011.012l-4.47 4.772-1.265 0c-1.102 0-2 .898-2 2l0 2c0 1.103.898 2 2 2l1.265 0 4.481 4.784c.141.141.328.216.519.216.095 0 .19-.018.282-.056.275-.115.453-.38.453-.678l0-14.531c0-.298-.178-.564-.453-.678zm5.4533 4.8695l0 2.011.846-.952-.846-1.059zm0 5.138l0 2.01.847-1.057-.847-.953zm-.5 3.936c-.056 0-.111-.009-.165-.028-.201-.07-.335-.26-.335-.472l0-3.934-1.126 1.266c-.186.206-.501.223-.706.042-.207-.183-.226-.5-.042-.706l1.485-1.67-1.479-1.666c-.184-.207-.164-.522.042-.706.206-.182.521-.165.706.042l1.12 1.262 0-3.93c0-.212.134-.401.335-.471.197-.072.423-.007.556.159l2 2.502c.152.19.144.463-.017.644l-1.874 2.108 0 .115 1.874 2.111c.161.183.169.454.017.645l-2 2.5c-.097.121-.243.187-.391.187z"],"speaker-disconnected_12":["M6.585.051c.252.104.415.347.415.62l0 10.656c0 .274-.163.517-.415.621-.084.035-.171.052-.258.052-.174 0-.345-.068-.474-.197L2.282 8l-.781.002C.673 8.002 0 7.329 0 6.503l0-1.006c0-.827.673-1.5 1.5-1.5l.782 0 3.56-3.79c.203-.204.491-.26.743-.156zM6 10.499L6 1.5 2.862 4.841c-.094.1-.226.158-.364.158l-.001 0-.998-.002c-.275 0-.499.225-.499.5l0 1.006c0 .274.224.5.5.5l.998 0c.138 0 .27.057.364.156L6 10.499zm4.707-4.498l1.146 1.146c.098.097.147.225.147.353 0 .128-.049.256-.147.354-.097.097-.225.146-.353.146-.128 0-.256-.049-.354-.146L10 6.708 8.853 7.854C8.756 7.951 8.628 8 8.5 8c-.128 0-.256-.049-.354-.146-.195-.196-.195-.512 0-.707l1.147-1.146-1.147-1.147c-.195-.195-.195-.512 0-.707.196-.195.512-.195.707 0L10 5.293l1.146-1.146c.196-.195.512-.195.707 0 .098.098.147.226.147.354 0 .127-.049.255-.147.353l-1.146 1.147z"],"speaker-disconnected_14":["M7.571.0537349856C7.832.161721551 8 .413690205 8 .695655127L8 13.3050865c0 .2819649-.168.5339335-.429.6419201C7.485 13.9830021 7.395 14 7.305 14c-.18 0-.357-.0699913-.491-.2029747l-3.796-3.7965277-1.351 0c-.919 0-1.667-.747907-1.667-1.66679268l0-2.66766813c0-.91888569.748-1.66679265 1.667-1.66679265l1.352 0L6.814.204716203c.199-.1999751224.496-.259967659.757-.1509812174zM7 12.5681781L7 1.43256345 3.58 4.85313792c-.094.09298843-.221.14598183-.354.14598183l-1.559 0c-.368 0-.667.29896281-.667.66691704l0 2.66766813c0 .36795422.299.66691703.667.66691703l1.558 0c.132 0 .259.05199353.353.14598184L7 12.5681781zm5.207-5.56770732l1.646 1.64579525c.196.19597562.196.51193631 0 .70791193-.097.09698794-.225.14598184-.353.14598184-.128 0-.256-.0489939-.354-.14598184L11.5 7.70738283 9.853 9.35417796c-.097.09698794-.225.14598184-.353.14598184-.128 0-.256-.0489939-.354-.14598184-.195-.19597562-.195-.51193631 0-.70791193l1.647-1.64579525-1.647-1.64579526c-.195-.19597562-.195-.51193631 0-.70791193.196-.19497574.512-.19497574.707 0L11.5 6.29355872l1.646-1.64679513c.196-.19497574.512-.19497574.707 0 .196.19597562.196.51193631 0 .70791193l-1.646 1.64579526z"],"speaker-disconnected_16":["M8.5471.0567c.275.114.453.38.453.678l0 14.531c0 .298-.178.563-.453.678-.092.038-.187.056-.282.056-.191 0-.378-.075-.519-.216l-4.481-4.784-1.265 0c-1.102 0-2-.897-2-2l0-2c0-1.102.898-2 2-2l1.265 0 4.47-4.772c.004-.004.007-.008.011-.012.211-.211.525-.274.801-.159zm-.547 14.536l0-13.186-4.154 4.435c-.094.101-.226.158-.365.158l-1.481 0c-.551 0-1 .448-1 1l0 2c0 .552.449 1 1 1l1.481 0c.139 0 .271.058.365.158l4.154 4.435zm6.1938-6.0928l1.646 1.646c.196.196.196.512 0 .708-.097.097-.225.146-.353.146-.128 0-.256-.049-.354-.146l-1.646-1.647-1.647 1.647c-.097.097-.225.146-.353.146-.128 0-.256-.049-.354-.146-.195-.196-.195-.512 0-.708l1.647-1.646-1.647-1.646c-.195-.196-.195-.512 0-.708.196-.195.512-.195.707 0l1.647 1.647 1.646-1.647c.196-.195.512-.195.707 0 .196.196.196.512 0 .708l-1.646 1.646z"],"speaker-disconnected_20":["M11.5148.061c.299.123.492.412.492.735l0 18.406c0 .323-.193.613-.492.736-.099.041-.203.061-.306.061-.207 0-.41-.081-.563-.234l-5.765-5.766-2.6 0c-1.257 0-2.281-1.023-2.281-2.281l0-3.438c0-1.257 1.024-2.281 2.281-2.281l2.6 0 5.766-5.766c.228-.229.569-.295.868-.172zm-.508 18.65l0-17.424-5.566 5.566c-.094.093-.221.146-.353.146l-2.807 0c-.706 0-1.281.575-1.281 1.281l0 3.438c0 .706.575 1.281 1.281 1.281l2.807 0c.133 0 .26.053.354.147l5.565 5.565zM17.707 10l2.146 2.146c.196.196.196.512 0 .708-.097.097-.225.146-.353.146-.128 0-.256-.049-.354-.146L17 10.707l-2.147 2.147c-.097.097-.225.146-.353.146-.128 0-.256-.049-.354-.146-.195-.196-.195-.512 0-.708L16.293 10l-2.147-2.146c-.195-.196-.195-.512 0-.708.196-.195.512-.195.707 0L17 9.293l2.146-2.147c.196-.195.512-.195.707 0 .196.196.196.512 0 .708L17.707 10z"],"speaker-disconnected_24":["M13.477 1.0644c.316.131.521.438.521.779l0 20.312c0 .343-.205.648-.521.78-.105.043-.215.065-.323.065-.22 0-.435-.086-.596-.248l-6.63-6.741-2.428 0c-1.378 0-2.5-1.121-2.5-2.499l0-2.968c0-1.379 1.122-2.5 2.5-2.5l2.427 0 6.626-6.792.005-.004c.242-.244.602-.314.919-.184zm-.479 20.709l0-19.546-6.502 6.665c-.094.097-.224.152-.358.152l-2.638 0c-.827 0-1.5.672-1.5 1.5l0 2.968c0 .826.673 1.499 1.5 1.499l2.638 0c.134 0 .262.054.356.15l6.504 6.612zM20.707 12l2.146 2.146c.196.196.196.512 0 .708-.195.195-.511.195-.707 0L20 12.707l-2.147 2.147c-.195.195-.511.195-.707 0-.195-.196-.195-.512 0-.708L19.293 12l-2.147-2.146c-.195-.196-.195-.512 0-.708.196-.195.512-.195.707 0L20 11.293l2.146-2.147c.196-.195.512-.195.707 0 .196.196.196.512 0 .708L20.707 12z"],"speaker-disconnected_28":["M16.452 1.0684375145c.333.1380562335.549.4601874445.549.8213345475l0 24.219865238c0 .3611471-.215.6832784-.548.822335C16.342 26.977991 16.226 27 16.111 27c-.23 0-.457-.0900367-.627-.2601059l-7.469-7.7461552-3.015 0c-1.654 0-3-1.3465485-3-3.0012225l0-3.9996291c0-1.65467401 1.346-3.00122248 3-3.00122248l3.015 0 7.463-7.725146623.005-.005002037c.254-.2551039097.635-.3321352862.969-.1930786455zM16.001 25.8355257l0-23.67064158-7.415 7.67512625c-.094.09703952-.224.15206193-.359.15206193l-3.227 0c-1.103 0-2 .89836593-2 2.000815l0 3.9996291c0 1.1034495.897 2.000815 2 2.000815l3.227 0c.135 0 .265.0550224.359.1530623l7.415 7.689132zM23.707 14l3.146 3.146c.196.196.196.512 0 .708-.097.097-.225.146-.353.146-.128 0-.256-.049-.354-.146L23 14.707l-3.147 3.147c-.097.097-.225.146-.353.146-.128 0-.256-.049-.354-.146-.195-.196-.195-.512 0-.708L22.293 14l-3.147-3.146c-.195-.196-.195-.512 0-.708.196-.195.512-.195.707 0L23 13.293l3.146-3.147c.196-.195.512-.195.707 0 .196.196.196.512 0 .708L23.707 14z"],"speaker-line-out-left_16":["M1.4529.0567c-.275.114-.453.38-.453.678l0 14.531c0 .298.178.563.453.678.092.038.187.056.282.056.191 0 .378-.075.519-.216l4.481-4.784 1.265 0c1.102 0 2-.897 2-2l0-2c0-1.102-.898-2-2-2l-1.265 0-4.47-4.772c-.004-.004-.007-.008-.011-.012-.211-.211-.525-.274-.801-.159zm.547 14.536l0-13.186 4.154 4.435c.094.101.226.158.365.158l1.481 0c.551 0 1 .448 1 1l0 2c0 .552-.449 1-1 1l-1.481 0c-.139 0-.271.058-.365.158l-4.154 4.435zM13 10c1.1045695 0 2-.8954305 2-2 0-1.1045695-.8954305-2-2-2-1.1045695 0-2 .8954305-2 2 0 1.1045695.8954305 2 2 2zm0-1c-.55228475 0-1-.44771525-1-1 0-.55228475.44771525-1 1-1 .55228475 0 1 .44771525 1 1 0 .55228475-.44771525 1-1 1z"],"speaker-line-out-right_16":["M14.5471.0567c.275.114.453.38.453.678l0 14.531c0 .298-.178.563-.453.678-.092.038-.187.056-.282.056-.191 0-.378-.075-.519-.216l-4.481-4.784-1.265 0c-1.102 0-2-.897-2-2l0-2c0-1.102.898-2 2-2l1.265 0 4.47-4.772c.004-.004.007-.008.011-.012.211-.211.525-.274.801-.159zm-.547 14.536l0-13.186-4.154 4.435c-.094.101-.226.158-.365.158l-1.481 0c-.551 0-1 .448-1 1l0 2c0 .552.449 1 1 1l1.481 0c.139 0 .271.058.365.158l4.154 4.435zM3 10c-1.1045695 0-2-.8954305-2-2 0-1.1045695.8954305-2 2-2 1.1045695 0 2 .8954305 2 2 0 1.1045695-.8954305 2-2 2zm0-1c.55228475 0 1-.44771525 1-1 0-.55228475-.44771525-1-1-1-.55228475 0-1 .44771525-1 1 0 .55228475.44771525 1 1 1z"],"speaker-muted_12":["M11.85425.85425l-1.24 1.239c.881 1.113 1.386 2.465 1.386 3.906 0 1.695-.66 3.287-1.858 4.486-.099.097-.226.146-.354.146-.127 0-.255-.049-.353-.146-.195-.196-.195-.512 0-.707 1.009-1.01 1.565-2.352 1.565-3.779 0-1.173-.401-2.273-1.099-3.193l-.669.669c.493.744.765 1.611.765 2.525 0 1.234-.481 2.396-1.355 3.27-.099.098-.226.146-.354.146-.127 0-.255-.048-.353-.146-.195-.195-.195-.512 0-.707.686-.687 1.062-1.596 1.062-2.563 0-.644-.18-1.253-.495-1.795l-1.502 1.502 0 5.621c0 .274-.163.517-.415.621-.084.035-.171.052-.258.052-.174 0-.345-.068-.474-.197l-2.397-2.553-2.602 2.603c-.098.097-.226.146-.354.146-.128 0-.256-.049-.354-.146-.195-.196-.195-.512 0-.708l2.625-2.624-.489-.521-.781.002c-.828 0-1.501-.673-1.501-1.5l0-1.006c0-.827.673-1.5 1.5-1.5l.782 0 3.56-3.79c.203-.204.491-.26.743-.156.252.104.415.347.415.62l0 3.622 4.146-4.147c.196-.195.512-.195.708 0 .195.196.195.512 0 .708zm-5.854 9.646l0-3.793-1.837 1.837 1.837 1.956zm-3.138-3.34l.616.655 2.522-2.522 0-3.793-3.138 3.341c-.094.101-.226.158-.364.158l-.001 0-.998-.002c-.275 0-.499.225-.499.5l0 1.006c0 .275.224.5.5.5l.998 0c.138 0 .27.057.364.157z"],"speaker-muted_16":["M13.9998283 2.7072785C16.7716804 5.84541401 16.657471 10.656529 13.6572 13.6568c-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147-.195-.195-.195-.511 0-.707 2.6101583-2.6101583 2.7238247-6.78645575.3409994-9.53389258l-.7093404.70934034C13.4998999 5.20706671 14.0002 6.56534961 14.0002 7.9998c0 1.603-.624 3.11-1.757 4.242-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147-.195-.195-.195-.511 0-.707.944-.944 1.464-2.199 1.464-3.535 0-1.16802978-.3974644-2.27414684-1.1282408-3.16465246L9 7.70710678 9 15.2658c0 .298-.178.563-.453.678-.092.038-.187.056-.282.056-.191 0-.378-.075-.519-.216l-3.29978287-3.5229103-2.59266374 2.5926637c-.19526215.1952621-.51184463.1952621-.70710678 0-.195262146-.1952622-.195262146-.5118446 0-.7071068l2.61578876-2.6157888L3.265 10.9998l-1.265 0c-1.102 0-2-.897-2-2l0-2c0-1.102.898-2 2-2l1.265 0 4.47-4.772c.004-.004.007-.008.011-.012.211-.211.525-.274.801-.159.275.114.453.38.453.678l0 5.55809322 5.1464466-5.14644661c.1952622-.195262146.5118446-.195262146.7071068 0 .1952621.19526215.1952621.51184463 0 .70710678l-.8537251.85372511zm-8.84639596 8.8463959L8 14.5928l0-5.88569322-2.84656766 2.84656762zm-.68397289-.7302406L8 7.29289322 8 1.4068l-4.154 4.435c-.094.101-.226.158-.365.158l-1.481 0c-.551 0-1 .448-1 1l0 2c0 .552.449 1 1 1l1.481 0c.139 0 .271.058.365.158l.62345945.6656338z"],"speaker-muted_24":["M12.998 21.7722817l-4.99-5.071189 4.99-4.9882186 0 10.0594076zm-6.504-6.6106392c-.094-.0969654-.222-.1509461-.356-.1509461l-2.638 0c-.827 0-1.5-.6727597-1.5-1.4994645l0-2.96694044c0-.82870405.673-1.4994645 1.5-1.4994645l2.638 0c.134 0 .264-.05598001.358-.15294538l6.502-6.66461992 0 8.07111763-5.691 5.68896831-.813-.8257051zM22.853 1.860392679c.196-.194930386.196-.511817219 0-.706747605-.195-.1949303861-.511-.1949303861-.707 0L13.998 9.29873628l0-7.455337532c0-.340878265-.205-.646769025-.521-.7797215445-.317-.1299535907-.677-.0579792943-.919.1839343125l-.005.005997858L5.927 8.04518395l-2.427 0c-1.378 0-2.5 1.12059981-2.5 2.49910751l0 2.96694044c0 1.3785077 1.122 2.4991075 2.5 2.4991075l2.428 0 .672.6837558-5.454 5.452053c-.195.1949304-.195.5118172 0 .7067476.098.097965.226.1469475.354.1469475.128 0 .256-.0489825.353-.1469475l5.448-5.4460551 5.257 5.3440915c.161.1629418.376.2489111.596.2489111.108 0 .218-.0229918.323-.0659764.316-.1319529.521-.4358444.521-.7787219l0-11.44191387 3.458-3.45676551C18.452 8.57099617 19 10.23740106 19 12.0107678c0 2.0052838-.648 3.7906462-1.873 5.1681543-.184.2059264-.166.5218136.041.7047483.096.0849697.214.1269547.332.1269547.137 0 .275-.05598.374-.1679401C19.245 16.3032348 20 14.2329742 20 12.0107678c0-2.04127106-.652-3.95958599-1.833-5.46504836l1.299-1.29853626C21.119 7.17949311 22 9.51565881 22 12.043756c0 2.6590504-.99 5.1221707-2.864 7.1254553-.189.2009283-.178.5178151.023.7067476.097.0889682.219.1339522.342.1339522.133 0 .267-.0529811.365-.1579436C21.916 17.66075 23 14.9617139 23 12.043756c0-2.79700116-.982-5.37907904-2.825-7.50531971l2.678-2.678043611z"],"speaker-muted_28":["M15.0095862 25.8353606l-5.95865197-6.1745759 5.95865197-5.954484 0 12.1290599zm-7.41954732-7.6892077c-.09405764-.0970405-.22413736-.1530639-.35922015-.1530639l-3.22897897 0c-1.10367642 0-2.00122651-.8963739-2.00122651-2.0008347l0-3.9996685c0-1.10145948.89755009-2.00083467 2.00122651-2.00083467l3.22897897 0c.13508279 0 .26516251-.05502295.35922015-.15106302l7.41954732-7.67620226 0 10.12722475-6.65307756 6.6487736-.76646976-.7943313zM23.5468184 5.17574205l2.3224234-2.32196865c.1951196-.19508138.1951196-.51221368 0-.70729506-.194119-.195081384-.5133146-.195081384-.7074336 0l-9.1516088 9.14581536 0-9.402922619c0-.361150661-.2161325-.682284627-.5493367-.8213426377-.3342048-.1390580104-.7154384-.0610254578-.9695942.1940809647l-.0050031.004001669L7.01868872 8.99133379l-3.01684896 0C2.34682544 8.99133379 1 10.33889595 1 11.9925858l0 3.9996685c0 1.6546903 1.34682544 3.0012521 3.00183976 3.0012521l3.01684896 0 .63038635.6532725-5.50937657 5.506297c-.194118976.1950814-.194118976.5132141 0 .7072951.19511958.1950814.51331459.1950814.70743357 0l5.49636859-5.4932916 6.14876844 6.3726584c.1701043.170071.3972435.2601086.6273845.2601086.1150705 0 .2311417-.0210088.3422097-.067028.3332043-.1400584.5483361-.4611924.5483361-.8233435l0-13.4025911L20.00865 8.71121693c2.765695 3.13930957 2.6576288 7.94031247-.3422098 10.93956367-.1951195.1970822-.1951195.5122136 0 .7082954.0980601.0970405.2261386.146061.3532165.146061.1280785 0 .256157-.0490205.3542171-.146061 3.3910783-3.3884135 3.4981439-8.8246813.3422097-12.35515413l2.1233014-2.12188518c4.3226492 4.70396234 4.2175848 12.04002271-.3432104 16.59892451-.194119.1950814-.194119.5112133 0 .7072951.0990607.0970405.2261386.1460609.3532165.1460609.1280785 0 .256157-.0490204.3542171-.1460609 4.9500337-4.9490646 5.0540975-12.92038998.3432103-18.01251425z"],"speaker-off_16":["M12.547.0568c.275.114.453.38.453.678l0 14.531c0 .298-.178.563-.453.678-.092.038-.187.056-.282.056-.191 0-.378-.075-.519-.216l-4.481-4.784-1.265 0c-1.102 0-2-.897-2-2l0-2c0-1.102.898-2 2-2l1.265 0 4.47-4.772c.004-.004.007-.008.011-.012.211-.211.525-.274.801-.159zM12 14.5928l0-13.186-4.154 4.435c-.094.101-.226.158-.365.158l-1.481 0c-.551 0-1 .448-1 1l0 2c0 .552.449 1 1 1l1.481 0c.139 0 .271.058.365.158L12 14.5928z"],"speaker-off_24":["M17.998 21.7734181l-6.504-6.6118732c-.094-.0959692-.222-.1499518-.356-.1499518l-2.638 0c-.827 0-1.5-.6727836-1.5-1.4995177l0-2.96804529c0-.82773376.673-1.49951767 1.5-1.49951767l2.638 0c.134 0 .264-.05498232.358-.15195113l6.502-6.6648562 0 19.54571299zm.479-20.709338704c-.317-.1299581981-.677-.0589810283-.919.183940834l-.005.004998392-6.626 6.791815368-2.427 0c-1.378 0-2.5 1.12063954-2.5 2.49919612l0 2.96804529c0 1.3785566 1.122 2.4991961 2.5 2.4991961l2.428 0 6.63 6.7408318c.161.1619479.376.2479203.596.2479203.108 0 .218-.021993.323-.0649791.316-.1319576.521-.4368595.521-.7797492l0-20.311466715c0-.341890029-.205-.647791634-.521-.779749189z"],"speaker-off_28":["M21.001 25.8355257l-7.415-7.689132c-.094-.0980399-.224-.1530623-.359-.1530623l-3.227 0c-1.103 0-2-.8973655-2-2.000815l0-3.9996291c0-1.10244907.897-2.000815 2-2.000815l3.227 0c.135 0 .265-.05502241.359-.15206193l7.415-7.67512625 0 23.67064158zm.451-24.7670881855c-.334-.1390566407-.715-.0620252642-.969.1930786455l-.005.005002037-7.463 7.725146623-3.015 0c-1.654 0-3 1.34654847-3 3.00122248l0 3.9996291c0 1.654674 1.346 3.0012225 3 3.0012225l3.015 0 7.469 7.7461552c.17.1700692.397.2601059.627.2601059.115 0 .231-.022009.342-.0680277.333-.1390566.548-.4611879.548-.822335l0-24.219865238c0-.361147103-.216-.683278314-.549-.8213345475z"],"spinner_12":["M6 11c2.76137042 0 5-2.23862958 5-5 0-2.76137042-2.23862958-5-5-5-2.76137042 0-5 2.23862958-5 5 0 2.76137042 2.23862958 5 5 5zm0 1c-3.31365517 0-6-2.68634483-6-6 0-3.31365517 2.68634483-6 6-6 3.31365517 0 6 2.68634483 6 6 0 3.31365517-2.68634483 6-6 6z",null,"M6 11c2.76137042 0 5-2.23862958 5-5 0-2.76137042-2.23862958-5-5-5-2.76137042 0-5 2.23862958-5 5 0 2.76137042 2.23862958 5 5 5zm0 1c-3.31365517 0-6-2.68634483-6-6 0-3.31365517 2.68634483-6 6-6 3.31365517 0 6 2.68634483 6 6 0 3.31365517-2.68634483 6-6 6z"],"spinner_14":["M7 13c3.3136463 0 6-2.6863537 6-6 0-3.31364628-2.6863537-6-6-6-3.31364628 0-6 2.68635372-6 6 0 3.3136463 2.68635372 6 6 6zm0 1c-3.86593103 0-7-3.134069-7-7 0-3.86593103 3.13406897-7 7-7 3.865931 0 7 3.13406897 7 7 0 3.865931-3.134069 7-7 7z",null,"M7 13c3.3136463 0 6-2.6863537 6-6 0-3.31364628-2.6863537-6-6-6-3.31364628 0-6 2.68635372-6 6 0 3.3136463 2.68635372 6 6 6zm0 1c-3.86593103 0-7-3.134069-7-7 0-3.86593103 3.13406897-7 7-7 3.865931 0 7 3.13406897 7 7 0 3.865931-3.134069 7-7 7z"],"spinner_16":["M8 15c3.8659221 0 7-3.1340779 7-7 0-3.86592215-3.1340779-7-7-7-3.86592215 0-7 3.13407785-7 7 0 3.8659221 3.13407785 7 7 7zm0 1c-4.4182069 0-8-3.5817931-8-8 0-4.4182069 3.5817931-8 8-8 4.4182069 0 8 3.5817931 8 8 0 4.4182069-3.5817931 8-8 8z",null,"M8 15c3.8659221 0 7-3.1340779 7-7 0-3.86592215-3.1340779-7-7-7-3.86592215 0-7 3.13407785-7 7 0 3.8659221 3.13407785 7 7 7zm0 1c-4.4182069 0-8-3.5817931-8-8 0-4.4182069 3.5817931-8 8-8 4.4182069 0 8 3.5817931 8 8 0 4.4182069-3.5817931 8-8 8z"],"spinner_18":["M9 17c4.418198 0 8-3.581802 8-8 0-4.41819801-3.581802-8-8-8-4.41819801 0-8 3.58180199-8 8 0 4.418198 3.58180199 8 8 8zm0 1c-4.97048276 0-9-4.0295172-9-9 0-4.97048276 4.02951724-9 9-9 4.9704828 0 9 4.02951724 9 9 0 4.9704828-4.0295172 9-9 9z",null,"M9 17c4.418198 0 8-3.581802 8-8 0-4.41819801-3.581802-8-8-8-4.41819801 0-8 3.58180199-8 8 0 4.418198 3.58180199 8 8 8zm0 1c-4.97048276 0-9-4.0295172-9-9 0-4.97048276 4.02951724-9 9-9 4.9704828 0 9 4.02951724 9 9 0 4.9704828-4.0295172 9-9 9z"],"spinner_20":["M10 19c4.9704739 0 9-4.0295261 9-9 0-4.97047387-4.0295261-9-9-9-4.97047387 0-9 4.02952613-9 9 0 4.9704739 4.02952613 9 9 9zm0 1C4.47724138 20 0 15.5227586 0 10 0 4.47724138 4.47724138 0 10 0c5.5227586 0 10 4.47724138 10 10 0 5.5227586-4.4772414 10-10 10z",null,"M10 19c4.9704739 0 9-4.0295261 9-9 0-4.97047387-4.0295261-9-9-9-4.97047387 0-9 4.02952613-9 9 0 4.9704739 4.02952613 9 9 9zm0 1C4.47724138 20 0 15.5227586 0 10 0 4.47724138 4.47724138 0 10 0c5.5227586 0 10 4.47724138 10 10 0 5.5227586-4.4772414 10-10 10z"],"spinner_24":["M12 23c6.0750256 0 11-4.9249744 11-11 0-6.07502559-4.9249744-11-11-11C5.92497441 1 1 5.92497441 1 12c0 6.0750256 4.92497441 11 11 11zm0 1C5.37268966 24 0 18.6273103 0 12 0 5.37268966 5.37268966 0 12 0c6.6273103 0 12 5.37268966 12 12 0 6.6273103-5.3726897 12-12 12z",null,"M12 23c6.0750256 0 11-4.9249744 11-11 0-6.07502559-4.9249744-11-11-11C5.92497441 1 1 5.92497441 1 12c0 6.0750256 4.92497441 11 11 11zm0 1C5.37268966 24 0 18.6273103 0 12 0 5.37268966 5.37268966 0 12 0c6.6273103 0 12 5.37268966 12 12 0 6.6273103-5.3726897 12-12 12z"],"spinner_28":["M14 27c7.1795773 0 13-5.8204227 13-13 0-7.17957732-5.8204227-13-13-13C6.82042268 1 1 6.82042268 1 14c0 7.1795773 5.82042268 13 13 13zm0 1C6.26813793 28 0 21.7318621 0 14 0 6.26813793 6.26813793 0 14 0c7.7318621 0 14 6.26813793 14 14 0 7.7318621-6.2681379 14-14 14z",null,"M14 27c7.1795773 0 13-5.8204227 13-13 0-7.17957732-5.8204227-13-13-13C6.82042268 1 1 6.82042268 1 14c0 7.1795773 5.82042268 13 13 13zm0 1C6.26813793 28 0 21.7318621 0 14 0 6.26813793 6.26813793 0 14 0c7.7318621 0 14 6.26813793 14 14 0 7.7318621-6.2681379 14-14 14z"],"spinner_32":["M16 31c8.284129 0 15-6.715871 15-15 0-8.28412904-6.715871-15-15-15C7.71587096 1 1 7.71587096 1 16c0 8.284129 6.71587096 15 15 15zm0 1C7.16358621 32 0 24.8364138 0 16 0 7.16358621 7.16358621 0 16 0c8.8364138 0 16 7.16358621 16 16 0 8.8364138-7.1635862 16-16 16z",null,"M16 31c8.284129 0 15-6.715871 15-15 0-8.28412904-6.715871-15-15-15C7.71587096 1 1 7.71587096 1 16c0 8.284129 6.71587096 15 15 15zm0 1C7.16358621 32 0 24.8364138 0 16 0 7.16358621 7.16358621 0 16 0c8.8364138 0 16 7.16358621 16 16 0 8.8364138-7.1635862 16-16 16z"],"spinner_36":["M18 35c9.3886808 0 17-7.6113192 17-17 0-9.38868077-7.6113192-17-17-17C8.61131923 1 1 8.61131923 1 18c0 9.3886808 7.61131923 17 17 17zm0 1C8.05903448 36 0 27.9409655 0 18 0 8.05903448 8.05903448 0 18 0c9.9409655 0 18 8.05903448 18 18 0 9.9409655-8.0590345 18-18 18z",null,"M18 35c9.3886808 0 17-7.6113192 17-17 0-9.38868077-7.6113192-17-17-17C8.61131923 1 1 8.61131923 1 18c0 9.3886808 7.61131923 17 17 17zm0 1C8.05903448 36 0 27.9409655 0 18 0 8.05903448 8.05903448 0 18 0c9.9409655 0 18 8.05903448 18 18 0 9.9409655-8.0590345 18-18 18z"],"spinner_40":["M20 39c10.4932325 0 19-8.5067675 19-19C39 9.50676751 30.4932325 1 20 1 9.50676751 1 1 9.50676751 1 20c0 10.4932325 8.50676751 19 19 19zm0 1C8.95448276 40 0 31.0455172 0 20 0 8.95448276 8.95448276 0 20 0c11.0455172 0 20 8.95448276 20 20 0 11.0455172-8.9544828 20-20 20z",null,"M20 39c10.4932325 0 19-8.5067675 19-19C39 9.50676751 30.4932325 1 20 1 9.50676751 1 1 9.50676751 1 20c0 10.4932325 8.50676751 19 19 19zm0 1C8.95448276 40 0 31.0455172 0 20 0 8.95448276 8.95448276 0 20 0c11.0455172 0 20 8.95448276 20 20 0 11.0455172-8.9544828 20-20 20z"],"spinner_48":["M24 47c12.7023359 0 23-10.2976641 23-23C47 11.2976641 36.7023359 1 24 1 11.2976641 1 1 11.2976641 1 24c0 12.7023359 10.2976641 23 23 23zm0 1C10.7453793 48 0 37.2546207 0 24 0 10.7453793 10.7453793 0 24 0c13.2546207 0 24 10.7453793 24 24 0 13.2546207-10.7453793 24-24 24z",null,"M24 47c12.7023359 0 23-10.2976641 23-23C47 11.2976641 36.7023359 1 24 1 11.2976641 1 1 11.2976641 1 24c0 12.7023359 10.2976641 23 23 23zm0 1C10.7453793 48 0 37.2546207 0 24 0 10.7453793 10.7453793 0 24 0c13.2546207 0 24 10.7453793 24 24 0 13.2546207-10.7453793 24-24 24z"],"spinner_56":["M28 55c14.9114394 0 27-12.0885606 27-27C55 13.0885606 42.9114394 1 28 1 13.0885606 1 1 13.0885606 1 28c0 14.9114394 12.0885606 27 27 27zm0 1C12.5362759 56 0 43.4637241 0 28 0 12.5362759 12.5362759 0 28 0c15.4637241 0 28 12.5362759 28 28 0 15.4637241-12.5362759 28-28 28z",null,"M28 55c14.9114394 0 27-12.0885606 27-27C55 13.0885606 42.9114394 1 28 1 13.0885606 1 1 13.0885606 1 28c0 14.9114394 12.0885606 27 27 27zm0 1C12.5362759 56 0 43.4637241 0 28 0 12.5362759 12.5362759 0 28 0c15.4637241 0 28 12.5362759 28 28 0 15.4637241-12.5362759 28-28 28z"],"spinner_8":["M4 7c1.6568187 0 3-1.3431813 3-3 0-1.6568187-1.3431813-3-3-3-1.6568187 0-3 1.3431813-3 3 0 1.6568187 1.3431813 3 3 3zm0 1C1.79089655 8 0 6.20910345 0 4c0-2.20910345 1.79089655-4 4-4 2.20910345 0 4 1.79089655 4 4 0 2.20910345-1.79089655 4-4 4z",null,"M4 7c1.6568187 0 3-1.3431813 3-3 0-1.6568187-1.3431813-3-3-3-1.6568187 0-3 1.3431813-3 3 0 1.6568187 1.3431813 3 3 3zm0 1C1.79089655 8 0 6.20910345 0 4c0-2.20910345 1.79089655-4 4-4 2.20910345 0 4 1.79089655 4 4 0 2.20910345-1.79089655 4-4 4z"],"spinner_80":[null,null,null],"spreadsheet_16":["M3.5 2c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-2 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l2 0zM9 2c.276 0 .5.224.5.5 0 .276-.224.5-.5.5L7 3c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l2 0zm3.5 1c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l2 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-2 0zm-9 10c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-2 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l2 0zM9 13c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-2 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l2 0zm5.5 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-2 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l2 0zm-11-5.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-2 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l2 0zm11 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-2 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l2 0zM9 7.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-2 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l2 0z"],"start-chat_20":["M19.5 16c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L17 17l0 2.5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-2.5-2.5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l2.5 0 0-2.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 2.5 2.5 0zm-7.1313 2.6846c.265-.067.541.083.614.351.073.266-.084.541-.35.614-2.446.665-5.178.355-7.441-.889l-4.562 1.223c-.043.011-.087.016-.13.016-.131 0-.258-.051-.353-.146-.127-.126-.176-.311-.13-.483l1.223-4.563c-.811-1.475-1.24-3.133-1.24-4.808 0-5.513 4.486-10 10-10 5.515 0 10 4.487 10 10 0 .897-.118 1.787-.353 2.644-.073.267-.351.423-.614.351-.266-.074-.423-.348-.351-.615.211-.771.318-1.572.318-2.38 0-4.962-4.037-9-9-9-4.962 0-9 4.038-9 9 0 1.57.418 3.123 1.209 4.491.066.115.084.251.05.38l-1.052 3.922 3.924-1.051c.127-.033.264-.018.379.05 2.071 1.198 4.603 1.509 6.859.893z"],"stickers_16":["M14.1613 8.6317l-5.53 5.53c.543-2.788 2.743-4.988 5.53-5.53m-13.161-.632c0-3.859 3.14-7 7-7 3.7 0 6.73 2.888 6.976 6.527-3.993.261-7.189 3.457-7.45 7.449-3.638-.245-6.526-3.276-6.526-6.976m14.961.193c.025-.061.039-.126.039-.193 0-4.411-3.589-8-8-8-4.411 0-8 3.589-8 8 0 4.411 3.589 8 8 8 .067 0 .132-.013.192-.039.061-.025.116-.062.162-.108l7.499-7.499c.046-.045.083-.1.108-.161"],"stickers_24":["M22.211 12.582l-9.628 9.628c.591-5.035 4.593-9.037 9.628-9.628M1 12C1 5.934 5.935 1 12 1c5.906 0 10.73 4.681 10.98 10.526-6.201.268-11.185 5.253-11.453 11.453C5.681 22.729 1 17.906 1 12m22.962.192c.025-.06.038-.126.038-.192 0-6.617-5.382-12-12-12C5.383 0 0 5.383 0 12c0 6.616 5.383 12 12 12 .067 0 .132-.014.193-.039.061-.026.116-.062.161-.108l11.499-11.499c.046-.046.083-.101.109-.162"],"stickies_12":["M8.0469 11l-.047 0 0-2.16c0-.463.377-.84.84-.84l2.158 0 0 .033L8.0469 11zm-7.047-.838l0-8.322c0-.463.377-.84.84-.84l8.129 0c.489 0 .961.416 1.031.898L10.9989 7l-2.159 0c-1.015 0-1.84.825-1.84 1.84l0 2.16-5.162 0c-.462 0-.838-.376-.838-.838zm11-8.324C11.8989.827 10.9849 0 9.9689 0l-8.129 0c-1.016 0-1.84.824-1.84 1.84l0 8.322c0 1.015.823 1.838 1.838 1.838l6.209 0c.265 0 .52-.105.707-.293l2.953-2.969c.188-.187.293-.442.293-.707l0-6.191 0-.002z"],"stickies_16":["M14.0937-.0001c1.051 0 1.906.856 1.906 1.906l0 8.907c0 .258-.1.502-.283.684l-4.219 4.219c-.181.181-.43.284-.685.284l-8.906 0c-1.051 0-1.907-.855-1.907-1.906l0-12.188c0-1.05.856-1.906 1.907-1.906l12.187 0zm-3.09 14.796l3.792-3.792-2.929 0c-.476 0-.863.387-.863.862l0 2.93zm-10.004-.702c0 .5.407.906.907.906l8.097 0 0-3.134c0-1.027.835-1.862 1.863-1.862l3.142 0-.009-8.098c0-.5-.406-.906-.906-.906l-12.187 0c-.5 0-.907.406-.907.906l0 12.188z"],"stickies_24":["M22.211 12.582l-9.628 9.628c.591-5.035 4.593-9.037 9.628-9.628M1 12C1 5.934 5.935 1 12 1c5.906 0 10.73 4.681 10.98 10.526-6.201.268-11.185 5.253-11.453 11.453C5.681 22.729 1 17.906 1 12m22.962.192c.025-.06.038-.126.038-.192 0-6.617-5.382-12-12-12C5.383 0 0 5.383 0 12c0 6.616 5.383 12 12 12 .067 0 .132-.014.193-.039.061-.026.116-.062.161-.108l11.499-11.499c.046-.046.083-.101.109-.162"],"stop_16":["M2 1c-.551 0-1 .449-1 1l0 12c0 .551.449 1 1 1l12 0c.551 0 1-.449 1-1l0-12c0-.551-.449-1-1-1L2 1zm12 15L2 16c-1.103 0-2-.897-2-2L0 2C0 .897.897 0 2 0l12 0c1.103 0 2 .897 2 2l0 12c0 1.103-.897 2-2 2z"],"stop_20":["M18 16.5c0 .827-.673 1.5-1.5 1.5l-13 0c-.827 0-1.5-.673-1.5-1.5l0-13C2 2.673 2.673 2 3.5 2l13 0c.827 0 1.5.673 1.5 1.5l0 13zM16.5 1l-13 0C2.119 1 1 2.119 1 3.5l0 13C1 17.881 2.119 19 3.5 19l13 0c1.381 0 2.5-1.119 2.5-2.5l0-13C19 2.119 17.881 1 16.5 1z"],"stop_24":["M4.375 3C3.617 3 3 3.617 3 4.375l0 15.25C3 20.383 3.617 21 4.375 21l15.25 0c.758 0 1.375-.617 1.375-1.375l0-15.25C21 3.617 20.383 3 19.625 3L4.375 3zm15.25 19l-15.25 0C3.065 22 2 20.935 2 19.625l0-15.25C2 3.065 3.065 2 4.375 2l15.25 0C20.935 2 22 3.065 22 4.375l0 15.25C22 20.935 20.935 22 19.625 22z"],"stop-circle_16":["M8 0c4.418 0 8 3.582 8 8 0 4.418-3.582 8-8 8-4.418 0-8-3.582-8-8 0-4.418 3.582-8 8-8zm0 15c3.86 0 7-3.14 7-7 0-3.86-3.14-7-7-7-3.86 0-7 3.14-7 7 0 3.86 3.14 7 7 7zM9.5 5c.825 0 1.5.675 1.5 1.5l0 3c0 .825-.675 1.5-1.5 1.5l-3 0C5.675 11 5 10.325 5 9.5l0-3C5 5.675 5.675 5 6.5 5l3 0zm.5 4.5l0-3c0-.271-.229-.5-.5-.5l-3 0c-.271 0-.5.229-.5.5l0 3c0 .271.229.5.5.5l3 0c.271 0 .5-.229.5-.5z"],"stop-circle_20":["M10-.0002c5.522 0 10 4.478 10 10 0 5.523-4.478 10-10 10-5.523 0-10-4.477-10-10 0-5.522 4.477-10 10-10zm0 19c4.963 0 9-4.037 9-9 0-4.963-4.037-9-9-9-4.963 0-9 4.037-9 9 0 4.963 4.037 9 9 9zm2.042-12.5c.805 0 1.458.653 1.458 1.459l0 4.083c0 .806-.653 1.458-1.458 1.458l-4.084 0c-.805 0-1.458-.652-1.458-1.458l0-4.083c0-.806.653-1.459 1.458-1.459l4.084 0zm.458 5.542l0-4.083c0-.253-.206-.459-.458-.459l-4.084 0c-.252 0-.458.206-.458.459l0 4.083c0 .253.206.458.458.458l4.084 0c.252 0 .458-.205.458-.458z"],"stop-circle_24":["M12 0c6.617 0 12 5.383 12 12 0 6.617-5.383 12-12 12-6.617 0-12-5.383-12-12C0 5.383 5.383 0 12 0zm0 23c6.065 0 11-4.935 11-11 0-6.065-4.935-11-11-11C5.935 1 1 5.935 1 12c0 6.065 4.935 11 11 11zm2.5-15c.825 0 1.5.675 1.5 1.5l0 5c0 .825-.675 1.5-1.5 1.5l-5 0c-.825 0-1.5-.675-1.5-1.5l0-5C8 8.675 8.675 8 9.5 8l5 0zm.5 6.5l0-5c0-.271-.229-.5-.5-.5l-5 0c-.271 0-.5.229-.5.5l0 5c0 .271.229.5.5.5l5 0c.271 0 .5-.229.5-.5z"],"stored-info_12":["M13.9999 3c0 1.103-.897 2-2 2l-.097 0c.057.325.097.656.097.998l0 .002 0 .002c-.001 3.312-2.687 5.998-6 5.998-3.314 0-6-2.687-6-6 0-3.313 2.686-6 6-6 .931 0 1.805.223 2.59.602.362-.372.857-.602 1.41-.602.729 0 1.388.401 1.736 1.018 1.173-.17 2.264.791 2.264 1.982zm-3 3c0-.346-.053-.676-.126-1l-2.124 0c-.965 0-1.75-.785-1.75-1.75 0-.697.412-1.301 1.038-1.574.012-.072.035-.14.055-.209C7.4559 1.169 6.7489 1 5.9999 1c-2.757 0-5 2.243-5 5 0 2.757 2.243 5 5 5 2.757 0 5-2.243 5-5zm-5-3c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0 2c.275 0 .5.225.5.5l0 3c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-3c0-.275.225-.5.5-.5zm4-4c-.551 0-1 .449-1 1 .007.243-.156.49-.394.539-.357.074-.606.366-.606.711 0 .414.336.75.75.75l3.25 0c.551 0 1-.449 1-1 0-.676-.711-1.191-1.371-.926-.133.052-.282.047-.409-.016-.128-.064-.223-.18-.26-.317-.118-.436-.513-.741-.96-.741z"],"stored-info_16":["M18 3.5c0 1.308-1.007 2.368-2.286 2.479C15.885 6.627 16 7.298 16 8c0 4.418-3.582 8-8 8-4.418 0-8-3.582-8-8 0-4.418 3.582-8 8-8 1.306 0 2.533.321 3.621.876C12.076.344 12.743 0 13.5 0c.815 0 1.533.396 1.989 1.001.004 0 .007-.001.011-.001C16.881 1 18 2.119 18 3.5zM15.5 5c.827 0 1.5-.673 1.5-1.5 0-.817-.658-1.484-1.473-1.5-.012.001-.025.001-.038.001-.313 0-.608-.147-.798-.397C14.402 1.22 13.968 1 13.5 1c-.771 0-1.407.584-1.48 1.359-.032.326-.22.616-.505.777-.323.181-.515.505-.515.864 0 .552.448 1 1 1l3.5 0zM8 15c3.859 0 7-3.141 7-7 0-.696-.11-1.365-.302-2L12 6c-1.104 0-2-.896-2-2 0-.748.416-1.393 1.023-1.735.017-.174.055-.341.105-.503C10.184 1.284 9.128 1 8 1 4.141 1 1 4.141 1 8c0 3.859 3.141 7 7 7zM8 4c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0 3c.275 0 .5.225.5.5l0 4c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-4c0-.275.225-.5.5-.5z"],"stored-info_20":["M20.659 2.016C22.517 2.102 24 3.621 24 5.5 24 7.434 22.433 9 20.5 9l-.565 0c.037.329.065.661.065 1 0 5.523-4.477 10-10 10-5.523 0-10-4.477-10-10C0 4.477 4.477 0 10 0c1.757 0 3.396.473 4.83 1.27C15.467.499 16.419 0 17.5 0c1.4 0 2.6.828 3.159 2.016zM20.5 8C21.878 8 23 6.879 23 5.5c0-1.332-1.048-2.424-2.387-2.484-.37-.018-.701-.239-.859-.574C19.335 1.553 18.472 1 17.5 1c-1.288 0-2.35.975-2.472 2.268-.036.39-.299.724-.671.851C13.545 4.397 13 5.153 13 6c0 1.103.897 2 2 2l5.5 0zM19 10c0-.34-.03-.672-.071-1L15 9c-1.657 0-3-1.344-3-3 0-1.316.854-2.422 2.033-2.826.035-.37.138-.718.278-1.046C13.027 1.422 11.566 1 10 1c-4.962 0-9 4.037-9 9 0 4.963 4.038 9 9 9 4.963 0 9-4.037 9-9zm-9-4c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0 3c.275 0 .5.225.5.5l0 4c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-4c0-.275.225-.5.5-.5z"],"stored-info_24":["M24.471 2.048C26.455 2.283 28 3.952 28 6c0 2.209-1.791 4-4 4l-.194 0c.114.651.194 1.315.194 2 0 6.627-5.373 12-12 12-6.627 0-12-5.373-12-12C0 5.373 5.373 0 12 0c2.133 0 4.125.571 5.86 1.548C18.589.609 19.719 0 21 0c1.496 0 2.785.831 3.471 2.048zM24 9c1.654 0 3-1.346 3-3 0-1.508-1.138-2.78-2.646-2.959-.318-.038-.597-.225-.754-.502C23.064 1.59 22.068 1 21 1c-1.456 0-2.695 1.045-2.945 2.483-.057.328-.273.605-.576.742C16.581 4.628 16 5.521 16 6.5 16 7.879 17.121 9 18.5 9L24 9zm-1 3c0-.686-.083-1.35-.206-2L18.5 10C16.567 10 15 8.433 15 6.5c0-1.422.852-2.641 2.069-3.187.056-.322.162-.623.289-.913C15.771 1.511 13.945 1 12 1 5.935 1 1 5.935 1 12c0 6.065 4.935 11 11 11 6.065 0 11-4.935 11-11zM12 6c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0 4c.275 0 .5.225.5.5l0 7c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-7c0-.275.225-.5.5-.5z"],"stored-info-active_12":["M8.7499 6l3.25 0 0 .002c-.001 3.312-2.687 5.998-6 5.998-3.314 0-6-2.687-6-6 0-3.313 2.686-6 6-6 .555 0 1.09.081 1.6.222-.175.238-.319.504-.42.791-.662.456-1.076 1.188-1.15 1.993-.01-.001-.019-.006-.03-.006-.276 0-.5.224-.5.5 0 .276.224.5.5.5.039 0 .074-.014.11-.022C6.4319 5.14 7.4869 6 8.7499 6zm-2.25 2.5l0-3c0-.275-.225-.5-.5-.5-.275 0-.5.225-.5.5l0 3c0 .275.225.5.5.5.275 0 .5-.225.5-.5zm5.2358-7.4819c1.173-.167 2.264.791 2.264 1.982 0 1.103-.897 2-2 2l-.09 0-3.16 0c-.965 0-1.75-.785-1.75-1.75 0-.697.412-1.301 1.038-1.574.035-.205.106-.394.194-.571.005-.01.009-.02.014-.03.093-.179.211-.338.349-.478.362-.369.855-.597 1.405-.597.729 0 1.388.401 1.736 1.018z"],"stored-info-active_16":["M15.777 6.979c.049-.005.094-.017.141-.023.052.341.082.689.082 1.044 0 4.418-3.582 8-8 8-4.418 0-8-3.582-8-8 0-4.418 3.582-8 8-8 .947 0 1.851.174 2.692.478-.266.37-.476.769-.582 1.203C9.416 2.245 9 3.096 9 4c0 1.654 1.346 3 3 3l3.5 0c.095 0 .186-.01.277-.021zM8 5c.276 0 .5-.225.5-.5 0-.275-.224-.5-.5-.5-.276 0-.5.225-.5.5 0 .275.224.5.5.5zm.5 6.5l0-4c0-.275-.225-.5-.5-.5-.275 0-.5.225-.5.5l0 4c0 .275.225.5.5.5.275 0 .5-.225.5-.5zm9.4492-8.5039c.033.162.051.331.051.504 0 .168-.018.331-.05.49-.013.066-.038.127-.056.192-.025.087-.047.176-.081.26-.035.086-.082.166-.127.247-.029.053-.053.108-.086.159-.064.097-.137.187-.213.275-.021.025-.041.053-.063.077-.094.099-.195.189-.303.271-.01.007-.019.017-.029.024-.361.268-.797.44-1.271.482-.074.007-.146.023-.221.023l-3.5 0c-1.105 0-2-.896-2-2 0-.748.415-1.393 1.024-1.735.05-.531.271-1.007.597-1.39.108-.126.23-.24.361-.344.013-.01.027-.019.04-.03.116-.088.242-.163.372-.23.03-.015.058-.031.088-.045.121-.056.249-.097.38-.132.039-.012.077-.027.117-.036.168-.036.341-.058.521-.058.204 0 .401.025.591.071.132.032.254.089.378.143.052.022.11.034.16.059.339.175.632.425.86.728l.001 0c.003 0 .006-.001.01-.001 1.208 0 2.216.857 2.449 1.996z"],"stored-info-active_20":["M11 6c0 2.205 1.795 4 4 4l5 0c0 5.523-4.477 10-10 10-5.523 0-10-4.477-10-10C0 4.477 4.477 0 10 0c1.393 0 2.705.307 3.906.826-.356.485-.631 1.036-.771 1.649C11.837 3.159 11 4.508 11 6zm-1 1c.276 0 .5-.225.5-.5 0-.275-.224-.5-.5-.5-.276 0-.5.225-.5.5 0 .275.224.5.5.5zm.5 6.5l0-4c0-.275-.225-.5-.5-.5-.275 0-.5.225-.5.5l0 4c0 .275.225.5.5.5.275 0 .5-.225.5-.5zM20.6592 2.0156c1.857.086 3.341 1.605 3.341 3.484 0 1.934-1.568 3.5-3.5 3.5l-5.5 0c-1.657 0-3-1.343-3-3 0-1.316.853-2.422 2.033-2.826.167-1.777 1.646-3.174 3.467-3.174 1.4 0 2.599.829 3.159 2.016z"],"stored-info-active_24":["M12 7c.276 0 .5-.225.5-.5 0-.275-.224-.5-.5-.5-.276 0-.5.225-.5.5 0 .275.224.5.5.5zm6.5 4l5.446 0c.033.329.054.662.054 1 0 6.627-5.373 12-12 12-6.627 0-12-5.373-12-12C0 5.373 5.373 0 12 0c1.769 0 3.431.41 4.939 1.101-.327.46-.584.975-.742 1.54C14.848 3.446 14 4.91 14 6.5c0 2.481 2.019 4.5 4.5 4.5zm-6 6.5l0-7c0-.275-.225-.5-.5-.5-.275 0-.5.225-.5.5l0 7c0 .275.225.5.5.5.275 0 .5-.225.5-.5zM24.4707 2.0469c1.984.236 3.529 1.905 3.529 3.953 0 2.209-1.791 4-4 4l-5.5 0c-1.933 0-3.5-1.566-3.5-3.5 0-1.422.852-2.641 2.07-3.187.327-1.881 1.957-3.313 3.93-3.313 1.496 0 2.785.831 3.471 2.047z"],"streaming_16":["M8 7c.553 0 1 .448 1 1 0 .366-.206.672-.5.847l0 6.653c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-6.653C7.206 8.672 7 8.366 7 8c0-.552.447-1 1-1zm0-7c4.411 0 8 3.589 8 8 0 3.581-2.412 6.749-5.867 7.704-.044.012-.089.018-.133.018-.22 0-.421-.146-.482-.368-.074-.265.083-.541.349-.615C12.889 13.904 15 11.133 15 8c0-3.86-3.141-7-7-7-3.859 0-7 3.14-7 7 0 3.133 2.111 5.904 5.133 6.739.266.074.423.35.349.615-.074.266-.35.419-.615.35C2.412 14.749 0 11.581 0 8c0-4.411 3.589-8 8-8zm1.7764 11.5645c1.372-.686 2.224-2.052 2.224-3.564 0-2.206-1.794-4-4-4-2.206 0-4 1.794-4 4 0 1.512.851 2.878 2.223 3.564.247.124.347.424.224.671-.124.247-.423.348-.671.224-1.713-.857-2.776-2.565-2.776-4.459 0-2.757 2.243-5 5-5 2.756 0 5 2.243 5 5 0 1.894-1.064 3.602-2.777 4.459-.072.036-.148.052-.223.052-.183 0-.36-.101-.448-.276-.123-.247-.023-.547.224-.671z"],"streaming_20":["M10 9c.552 0 1 .448 1 1 0 .366-.207.672-.5.847l0 8.653c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-8.653c-.293-.175-.5-.481-.5-.847 0-.552.448-1 1-1zm0-9c5.514 0 10 4.486 10 10 0 4.493-3.03 8.457-7.369 9.639-.044.012-.088.017-.131.017-.22 0-.422-.146-.482-.368-.073-.267.084-.541.351-.614C16.273 17.61 19 14.043 19 10c0-4.962-4.038-9-9-9-4.962 0-9 4.038-9 9 0 4.043 2.727 7.61 6.631 8.674.267.073.424.347.351.614-.072.267-.351.423-.613.351C3.03 18.457 0 14.493 0 10 0 4.486 4.486 0 10 0zm2.272 14.4492c1.683-.861 2.728-2.566 2.728-4.449 0-2.757-2.243-5-5-5-2.757 0-5 2.243-5 5 0 1.883 1.045 3.588 2.728 4.449.246.126.343.427.217.673-.126.247-.426.343-.673.218C5.254 14.3062 4 12.2612 4 10.0002c0-3.309 2.691-6 6-6 3.309 0 6 2.691 6 6 0 2.261-1.254 4.306-3.272 5.34-.073.037-.151.054-.227.054-.182 0-.357-.099-.446-.272-.126-.246-.029-.547.217-.673z"],"streaming_24":["M12 0c6.617 0 12 5.383 12 12 0 5.415-3.647 10.18-8.87 11.587-.043.012-.087.017-.13.017-.221 0-.423-.146-.482-.37-.073-.266.086-.541.352-.612C19.657 21.332 23 16.964 23 12c0-6.065-4.935-11-11-11C5.935 1 1 5.935 1 12c0 4.964 3.343 9.332 8.13 10.622.266.071.425.346.353.612-.072.268-.351.424-.613.353C3.647 22.18 0 17.415 0 12 0 5.383 5.383 0 12 0zm2.7686 17.3242c1.993-1.039 3.231-3.079 3.231-5.324 0-3.309-2.691-6-6-6-3.308 0-6 2.691-6 6 0 2.245 1.239 4.285 3.231 5.324.246.128.34.43.213.675-.128.244-.429.339-.675.212-2.324-1.212-3.769-3.592-3.769-6.211 0-3.86 3.141-7 7-7 3.86 0 7 3.14 7 7 0 2.619-1.444 4.999-3.768 6.211-.074.038-.153.056-.232.056-.179 0-.354-.097-.443-.268-.128-.245-.032-.547.212-.675zM12 11c.552 0 1 .448 1 1 0 .366-.207.672-.5.847l0 10.653c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-10.653c-.293-.175-.5-.481-.5-.847 0-.552.448-1 1-1z"],"subscribe_16":["M14 0c1.103 0 2 .897 2 2l0 12c0 1.103-.897 2-2 2L2 16c-1.103 0-2-.897-2-2L0 2C0 .897.897 0 2 0l12 0zm1 14l0-12c0-.551-.449-1-1-1L2 1c-.551 0-1 .449-1 1l0 12c0 .551.449 1 1 1l12 0c.551 0 1-.449 1-1zM3.5 12c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0-4C5.981 8 8 10.019 8 12.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5C7 10.57 5.43 9 3.5 9c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0-4C8.187 4 12 7.813 12 12.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5C11 8.364 7.636 5 3.5 5c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5z"],"swift_16":["M6.5 2l9 0c.2761424 0 .5.223857625.5.5 0 .276142375-.2238576.5-.5.5l-9 0c-.27614237 0-.5-.223857625-.5-.5 0-.276142375.22385763-.5.5-.5zm0 11l5 0c.2761424 0 .5.2238576.5.5 0 .2761424-.2238576.5-.5.5l-5 0c-.27614237 0-.5-.2238576-.5-.5 0-.2761424.22385763-.5.5-.5zm-5-5.5l12 0c.2761424 0 .5.22385763.5.5 0 .27614237-.2238576.5-.5.5l-12 0c-.276142375 0-.5-.22385763-.5-.5 0-.27614237.223857625-.5.5-.5z"],"sx10_16":["M14 3c1.103 0 2 .897 2 2l0 6c0 1.103-.897 2-2 2L2 13c-1.103 0-2-.897-2-2l0-6c0-1.103.897-2 2-2l12 0zm1 8l0-6c0-.551-.448-1-1-1L2 4c-.552 0-1 .449-1 1l0 6c0 .551.448 1 1 1l12 0c.552 0 1-.449 1-1zm-1.502-1c.275 0 .5.224.5.5 0 .276-.225.5-.5.5l-1 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0zm-5-2c.825 0 1.5.675 1.5 1.5 0 .825-.675 1.5-1.5 1.5l-1 0c-.825 0-1.5-.675-1.5-1.5 0-.825.675-1.5 1.5-1.5l1 0zm0 2c.271 0 .5-.229.5-.5 0-.271-.229-.5-.5-.5l-1 0c-.271 0-.5.229-.5.5 0 .271.229.5.5.5l1 0z"],"sx10_20":["M17.5 4C18.875 4 20 5.125 20 6.5l0 7c0 1.375-1.125 2.5-2.5 2.5l-15 0C1.125 16 0 14.875 0 13.5l0-7C0 5.125 1.125 4 2.5 4l15 0zm1.5 9.5l0-7c0-.827-.673-1.5-1.5-1.5l-15 0C1.673 5 1 5.673 1 6.5l0 7c0 .827.673 1.5 1.5 1.5l15 0c.827 0 1.5-.673 1.5-1.5zM11 10c1.1 0 2 .9 2 2 0 1.1-.9 2-2 2l-2 0c-1.1 0-2-.9-2-2 0-1.1.9-2 2-2l2 0zm0 3c.552 0 1-.449 1-1 0-.551-.448-1-1-1l-2 0c-.552 0-1 .449-1 1 0 .551.448 1 1 1l2 0zm6.5 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0z"],"sx20_16":["M14 3c1.103 0 2 .897 2 2l0 6c0 1.103-.897 2-2 2L2 13c-1.103 0-2-.897-2-2l0-6c0-1.103.897-2 2-2l12 0zm1 8l0-6c0-.551-.448-1-1-1L2 4c-.552 0-1 .449-1 1l0 6c0 .551.448 1 1 1l12 0c.552 0 1-.449 1-1zm-1.5-1c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0z"],"sx20_20":["M19 13.5c0 .827-.673 1.5-1.5 1.5l-15 0c-.827 0-1.5-.673-1.5-1.5l0-7C1 5.673 1.673 5 2.5 5l15 0c.827 0 1.5.673 1.5 1.5l0 7zM17.5 4l-15 0C1.125 4 0 5.125 0 6.5l0 7C0 14.875 1.125 16 2.5 16l15 0c1.375 0 2.5-1.125 2.5-2.5l0-7C20 5.125 18.875 4 17.5 4z","M17.5 13l-1 0c-.275 0-.5.225-.5.5 0 .275.225.5.5.5l1 0c.275 0 .5-.225.5-.5 0-.275-.225-.5-.5-.5"],"sx80-codec_16":["M14.293 10L1.707 10l.854-.854c.092-.093.221-.146.353-.146l10.172 0c.132 0 .261.053.353.146l.854.854zM1.5 7l13 0c.275 0 .5.224.5.5l0 1.792-.853-.853C13.867 8.16 13.481 8 13.086 8L2.914 8c-.394 0-.781.16-1.06.439L1 9.293 1 7.5c0-.276.225-.5.5-.5zm13-1l-13 0C.673 6 0 6.673 0 7.5l0 2c0 .827.673 1.5 1.5 1.5l13 0c.827 0 1.5-.673 1.5-1.5l0-2c0-.827-.673-1.5-1.5-1.5z"],"sx80-codec_20":["M18.293 13L1.707 13l1.561-1.561c.279-.279.666-.439 1.06-.439l11.344 0c.394 0 .781.16 1.06.439L18.293 13zM1.527 7l16.946 0c.291 0 .527.237.527.527l0 4.766-1.561-1.561C16.967 10.26 16.34 10 15.672 10L4.328 10c-.668 0-1.295.26-1.767.732L1 12.293l0-4.766c0-.29.236-.527.527-.527zm16.946-1L1.527 6C.684 6 0 6.684 0 7.527l0 4.946C0 13.316.684 14 1.527 14l16.946 0c.843 0 1.527-.684 1.527-1.527l0-4.946C20 6.684 19.316 6 18.473 6z"],"tablet_16":["M14 2c1.104 0 2 .896 2 2l0 8c0 1.104-.896 2-2 2l-2 0-1 0-9 0c-1.104 0-2-.896-2-2l0-8c0-1.104.896-2 2-2l9 0 1 0 2 0zm1 10l0-8c0-.552-.449-1-1-1l-2 0 0 10 2 0c.551 0 1-.448 1-1zM2 13l9 0 0-10-9 0c-.551 0-1 .448-1 1l0 8c0 .552.449 1 1 1zm11.5-6c.276 0 .5.224.5.5l0 1c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-1c0-.276.224-.5.5-.5z"],"tablet_24":["M.001 5.5C.001 4.121 1.12195329 3 2.50089583 3L21.5001042 3C22.8790467 3 24 4.121 24 5.5l0 13c0 1.379-1.1209533 2.5-2.4998958 2.5L2.50089583 21C1.12195329 21 .001 19.879.001 18.5l0-13zM19.0002083 4L2.50089583 4c-.82696554 0-1.4999375.673-1.4999375 1.5l0 13c0 .827.67297196 1.5 1.4999375 1.5l16.49931247 0 0-16zm2.4998959 0l-1.4999375 0 0 16 1.4999375 0c.8269655 0 1.4999375-.673 1.4999375-1.5l0-13c0-.827-.672972-1.5-1.4999375-1.5zm.4999791 8.5c0 .275-.2249906.5-.4999791.5-.2749886 0-.4999792-.225-.4999792-.5l0-1c0-.275.2249906-.5.4999792-.5.2749885 0 .4999791.225.4999791.5l0 1z"],"tag_16":["M11.612125.998366381c-.398 0-.8.069886489-1.185.214651349l-2.41599996.90453082c-.521.19468379-1.004.50717622-1.398.90153568l-5.114 5.12866977c-.665999996.66492-.665999996 1.74516542 0 2.4100854l3.95 3.944593c.644.6429557 1.769.6429557 2.414 0L12.982125 9.36877076c.394-.39535784.693-.86160054.892-1.38475082l.909-2.42306434c.465-1.23599244.16-2.63971245-.775-3.57419462-.645-.64395406-1.513-.988394599-2.396-.988394599M6.65612504 16c-.723 0-1.402-.2815427-1.914-.7917141l-3.949999996-3.944593c-1.056-1.0532892-1.056-2.76750484-.001-3.82179242L5.90412504 2.31422909c.494-.49519568 1.101-.88656 1.756-1.13116271L10.076125.277537186c1.605-.601023788 3.428-.2076627039 4.639 1.003370274 1.212 1.21103299 1.606 3.02908003 1.003 4.63047896l-.909 2.42306434c-.248.65793135-.624 1.24298109-1.118 1.73817674l-5.11999996 5.1346601c-.512.5111697-1.191.7927124-1.915.7927124zM11.1455 4.8545c.194.194.513.194.707 0l1.001-1.001c.195-.195.195-.513 0-.707-.194-.195-.512-.195-.707 0l-1.001 1.001c-.194.194-.194.513 0 .707z"],"tag_20":["M18.4134481 1.58353812c1.4992196 1.49568229 1.9872911 3.74319954 1.2431821 5.72512835l-1.153169 3.06924393c-.3050447.8117421-.7721131 1.5376173-1.3872032 2.1546611l-6.4859504 6.5039215C10.0072163 19.6585291 9.17909498 20 8.29996616 20c-.8811291 0-1.7082503-.3414709-2.3313416-.9625085L.963891236 14.0412337c-1.285188315-1.2830119-1.285188315-3.3697782 0-4.65279005L7.44084028 2.89350819c.62209115-.624033 1.35419843-1.09630117 2.17831918-1.40482309L12.6786078.34345974c1.986291-.743847335 4.2366207-.256602369 5.7348403 1.24007838zm.3060448 5.37367296c.607089-1.61549663.2090306-3.44765751-1.0131485-4.66776683-.8421233-.84169571-1.9762895-1.290999473-3.1294585-1.290999473-.5200762 0-1.044153.090859203-1.5462266.279566783L9.9702109 2.42423537c-.68910097.25760083-1.30119066.65198968-1.82026672 1.17318204L1.67199499 10.0933513c-.896131305.8936153-.896131305 2.348361-.00100015 3.2419763l5.00473333 4.9962578c.8681272.8656585 2.37934864.8656585 3.2464757 0l6.48495023-6.5029231c.5150755-.5171986.9051326-1.122261 1.16017-1.8022073l1.1521688-3.06924392zm-3.7222454-2.96121131c.5520809 0 1.0001465.4463084 1.0001465.9984528 0 .5521444-.4480656.9984528-1.0001465.9984528-.5520809 0-1.0001466-.4463084-1.0001466-.9984528 0-.5521444.4480657-.9984528 1.0001466-.9984528z"],"tasks_10":["M9.85337524 2.14625c-.195-.195-.513-.195-.708 0l-5.638 5.646-2.654999999-2.647c-.195-.193-.512-.194-.707.002-.194.195-.194.512.001.707l3.009999999 3c.097.097.224.146.352.146.128 0 .257-.049.355-.147l5.99-6c.19499996-.195.19499996-.513 0-.707"],"tasks_12":["M4.5024 9.5c-.133 0-.26-.053-.354-.147l-3.002-3.007c-.195-.196-.195-.512.001-.707.194-.195.511-.196.707.001l2.648 2.652 5.642-5.646c.195-.195.511-.195.707 0 .195.195.195.512 0 .708l-5.995 6c-.094.093-.221.146-.354.146"],"tasks_14":["M5.4970082 10.99993c-.13290862 0-.25982137-.05291236-.35375679-.14575859L1.145999522 6.85479538c-.1948660294-.19567591-.1948660294-.5111534 0-.70583097.195865343-.19467756.512647555-.19467756.707513585 0L5.4970082 9.79392744l6.6494285-6.647989266c.1958654-.1946775653.5116483-.1946775653.7065143 0 .1958653.194677565.1958653.511153402 0 .705830967L5.850765 10.85417141c-.09393542.09284623-.22084817.14575859-.3537568.14575859"],"tasks_16":["M6.0083 12.50195c-.132 0-.26-.053-.354-.146l-4.508-4.507c-.195-.195-.195-.512 0-.707.195-.195.512-.195.707 0l4.155 4.153 8.143-8.148c.195-.196.511-.196.707 0 .195.194.195.511 0 .707l-8.496 8.502c-.094.093-.221.146-.354.146"],"tasks_18":["M6.49537524 14.0068c-.133 0-.26-.053-.354-.146l-4.995999999-5.003c-.194-.196-.194-.512.001-.707.195-.195.512-.195.707 0l4.641999999 4.648 9.64599996-9.652c.196-.196.512-.196.708 0 .195.194.195.511 0 .707l-9.99999996 10.007c-.094.093-.221.146-.354.146"],"tasks_20":["M6.9971 16.25025c-.133 0-.26-.053-.354-.146l-5.497-5.5c-.195-.196-.195-.512 0-.708.196-.195.512-.195.707 0l5.144 5.147 11.149-11.147c.196-.195.512-.195.707 0 .196.196.196.512 0 .708l-11.502 11.5c-.094.093-.221.146-.354.146"],"tasks_24":["M8.4956 19.5c-.133 0-.26-.053-.354-.146l-6.995-7c-.195-.196-.195-.513 0-.708.195-.195.512-.195.707 0l6.642 6.647 13.651-13.647c.195-.195.512-.195.707 0 .195.196.195.512 0 .708l-14.004 14c-.094.093-.221.146-.354.146"],"tasks_26":["M8.5 20.9995c-.128 0-.256-.049-.354-.146l-7-7c-.195-.196-.195-.512 0-.708.196-.195.512-.195.708 0l6.657 6.658 15.647-14.669c.201-.188.517-.178.707.023.189.201.178.518-.023.707l-16 15c-.096.09-.219.135-.342.135"],"tasks_28":["M10 22.5c-.128 0-.256-.049-.354-.146l-7.5-7.5c-.195-.196-.195-.512 0-.708.196-.195.512-.195.708 0L10 21.293 25.151 6.146c.195-.195.512-.195.707 0 .195.196.195.512 0 .708l-15.504 15.5c-.098.097-.226.146-.354.146"],"tasks_32":["M11.5 25.50025c-.128 0-.256-.049-.354-.146l-9-9c-.195-.196-.195-.512 0-.708.196-.195.512-.195.708 0l8.646 8.647 17.646-17.647c.196-.195.512-.195.708 0 .195.196.195.512 0 .708l-18 18c-.098.097-.226.146-.354.146"],"tasks_36":["M12.5 29c-.128 0-.256-.049-.354-.146l-10-10c-.195-.196-.195-.512 0-.708.196-.195.512-.195.708 0l9.646 9.647L33.146 7.146c.196-.195.512-.195.708 0 .195.196.195.512 0 .708l-21 21c-.098.097-.226.146-.354.146"],"tasks_8":["M3.00025 6.75025c-.128 0-.256-.049-.354-.146l-2.5-2.5c-.195-.196-.195-.512 0-.708.196-.195.512-.195.708 0l2.146 2.147 4.146-4.147c.196-.195.512-.195.708 0 .195.196.195.512 0 .708l-4.5 4.5c-.098.097-.226.146-.354.146"],"team_12":["M10 10c-.551 0-1-.448-1-1 0-.551.449-1 1-1 .551 0 1 .449 1 1 0 .552-.449 1-1 1m-6.431.227C3.835 9.887 4 9.465 4 9c0-1.104-.896-2-2-2-.08 0-.156.015-.233.023-.007-.09-.017-.18-.017-.273 0-1.708 1.025-3.16 2.482-3.833C4.566 3.558 5.228 4 6 4c.774 0 1.438-.445 1.771-1.088 1.457.673 2.479 2.13 2.479 3.838 0 .093-.012.183-.019.273C10.154 7.014 10.079 7 10 7c-1.104 0-2 .896-2 2 0 .456.159.872.416 1.208C7.728 10.694 6.905 11 6 11c-.905 0-1.741-.289-2.431-.773M1 9c0-.551.449-1 1-1 .551 0 1 .449 1 1 0 .552-.449 1-1 1-.551 0-1-.448-1-1m5-8c.551 0 1 .449 1 1 0 .551-.449 1-1 1-.551 0-1-.449-1-1 0-.551.449-1 1-1m5.199 6.408c.03-.216.051-.434.051-.658 0-2.187-1.354-4.028-3.256-4.814C7.959.862 7.083 0 6 0 4.919 0 4.044.859 4.007 1.931 2.103 2.716.75 4.562.75 6.75c0 .224.024.44.055.655C.319 7.771 0 8.346 0 9c0 1.104.896 2 2 2 .264 0 .515-.054.746-.146C3.64 11.566 4.767 12 6 12c1.232 0 2.352-.437 3.244-1.15.233.095.488.15.756.15 1.104 0 2-.896 2-2 0-.653-.317-1.227-.801-1.592"],"team_14":["M12.9569734 11.025c-.082.307-.278.562-.553.721-.18.104-.385.159-.592.159-.423 0-.818-.228-1.03-.594-.327-.566-.132-1.294.435-1.622.18-.103.385-.159.592-.159.423 0 .818.227 1.03.594.158.275.2.594.118.901m-8.99599997.963c.483-.676.561-1.597.119-2.364-.405-.702-1.141-1.094-1.896-1.094-.12 0-.239.027-.358.046-.049-.268-.078-.543-.078-.825 0-2.167 1.323-4.021 3.201-4.82.306.84 1.104 1.444 2.049 1.444.945 0 1.743-.603 2.048-1.443 1.87899997.799 3.20199997 2.652 3.20199997 4.819 0 .283-.032.557-.082.825-.118-.02-.236-.046-.357-.046-.372 0-.748.095-1.092.293-1.04599997.604-1.40499997 1.942-.80099997 2.988.036.062.08599997.108.12699997.164-.86099997.629-1.89899997 1.026-3.04499997 1.026-1.141 0-2.178-.39-3.037-1.013m-2.804-.677c-.327-.566-.132-1.294.435-1.622.18-.103.386-.159.592-.159.423 0 .818.227 1.03.594.159.275.201.594.118.901-.082.307-.278.562-.553.721-.18.104-.385.159-.592.159-.423 0-.818-.228-1.03-.594m5.841-10.311c.655 0 1.188.533 1.188 1.187 0 .655-.533 1.188-1.188 1.188-.637 0-1.149-.507-1.177-1.137l0-.101c.028-.63.54-1.137 1.177-1.137m6.70699997 8.624c-.154-.266-.364-.471-.596-.643.082-.399.139-.807.139-1.23 0-2.692-1.706-4.978-4.09199997-5.857-.145-1.068-1.051-1.894-2.158-1.894-1.107 0-2.013.825-2.158 1.893-2.386.879-4.092 3.165-4.092 5.858 0 .42.057.824.138 1.22-.8780000005.654-1.156 1.869-.595 2.84.406.702 1.141 1.094 1.896 1.094.326 0 .652-.087.96-.238 1.062.833 2.397 1.334 3.851 1.334 1.453 0 2.785-.501 3.84599997-1.334.302.149.631.238.968.238.372 0 .748-.094 1.092-.293 1.046-.605 1.405-1.941.801-2.988"],"team_16":["M14.9474057 12.638c-.104.387-.352.71-.698.911-.229.131-.488.201-.748.201-.535 0-1.034-.288-1.302-.751-.413-.715-.167-1.634.55-2.048.227-.132.486-.202.747-.202.536 0 1.034.287 1.302.75.2.348.253.752.149 1.139m-3.949 1.558c-.912.527-1.94700003.805-2.99300003.805-1.303 0-2.532-.452-3.549-1.204.616-.78.734-1.885.207-2.798-.463-.801-1.304-1.25-2.168-1.25-.147 0-.292.031-.439.057-.107-.778-.063-1.577.146-2.359.415-1.548 1.408-2.842 2.796-3.643.224-.13.459-.234.697-.329.381.896 1.269 1.525 2.303 1.525 1.029 0 1.912-.623 2.29600003-1.512 1.197.499 2.233 1.357 2.9 2.512.673 1.165.9 2.491.719 3.803-.139-.023-.276-.054-.417-.054-.424 0-.854.109-1.247.335-1.197.691-1.606 2.22-.915 3.415.062.11.148.196.224.292-.184.138-.357.287-.56.405m-9.80000003-1.197c-.413000005-.715-.167-1.634.55-2.048.227-.132.486-.202.747-.202.536 0 1.034.287 1.302.75.413.717.167 1.636-.549 2.05-.229.131-.488.201-.748.201-.535 0-1.034-.288-1.302-.751m6.8-11.999c.827 0 1.5.673 1.5 1.5 0 .827-.673 1.5-1.5 1.5-.827 0-1.5-.673-1.5-1.5 0-.827.673-1.5 1.5-1.5m7.66600003 9.999c-.198-.341-.474-.604-.781-.811.27-1.557.03-3.212-.823-4.688-.836-1.448-2.115-2.468-3.564-3.019C10.4864057 1.109 9.37340567 0 7.99840567 0c-1.373 0-2.486 1.108-2.498 2.478-.34.127-.677.272-1.002.459-2.608 1.506-3.857000005 4.435-3.377 7.239-1.091000005.725-1.452000005 2.174-.788000005 3.323.463.803 1.302000005 1.251 2.167000005 1.251.383 0 .766-.101 1.128-.286 1.247.998 2.797 1.537 4.377 1.537 1.187 0 2.39000003-.302 3.49300003-.939.308-.178.59-.383.858-.6.355.183.745.288 1.145.288.424 0 .853-.108 1.248-.336 1.195-.689 1.605-2.218.915-3.415"],"team_18":["M15 16c-1.103 0-2-.897-2-2 0-1.103.897-2 2-2 1.103 0 2 .897 2 2 0 1.103-.897 2-2 2m-9.687-.111C5.736 15.372 6 14.72 6 14c0-1.657-1.343-3-3-3-.24 0-.471.035-.694.089-.036-.275-.056-.555-.056-.839 0-2.728 1.639-5.06 3.974-6.123C6.669 5.225 7.742 6 9 6c1.258 0 2.33-.775 2.776-1.872 2.335 1.062 3.974 3.394 3.974 6.122 0 .284-.023.563-.059.838-.222-.053-.452-.088-.691-.088-1.657 0-3 1.343-3 3 0 .715.26 1.361.677 1.877C11.616 16.574 10.361 17 9 17c-1.362 0-2.626-.413-3.687-1.111M1 14c0-1.103.897-2 2-2 1.103 0 2 .897 2 2 0 1.103-.897 2-2 2-1.103 0-2-.897-2-2M9 1c1.103 0 2 .897 2 2 0 1.103-.897 2-2 2-1.103 0-2-.897-2-2 0-1.103.897-2 2-2m7.64 10.492c.066-.405.11-.818.11-1.242 0-3.217-1.972-5.954-4.763-7.125.002-.043.013-.083.013-.125 0-1.657-1.343-3-3-3-1.657 0-3 1.343-3 3 0 .043.011.083.013.126C3.222 4.298 1.25 7.033 1.25 10.25c0 .424.047.836.113 1.24C.544 12.026 0 12.948 0 14c0 1.657 1.343 3 3 3 .562 0 1.081-.164 1.53-.433C5.794 17.465 7.332 18 9 18c1.668 0 3.208-.533 4.471-1.432.449.268.968.432 1.529.432 1.657 0 3-1.343 3-3 0-1.051-.542-1.973-1.36-2.508"],"team_20":["M17 17c-1.103 0-2-.897-2-2 0-1.103.897-2 2-2 1.103 0 2 .897 2 2 0 1.103-.897 2-2 2m-7 2c-1.888 0-3.609-.689-4.955-1.815C5.63 16.637 6 15.864 6 15c0-1.657-1.343-3-3-3-.242 0-.475.036-.699.091-.032-.277-.051-.557-.051-.841 0-3.282 2.062-6.073 4.949-7.2C7.626 5.187 8.714 6 10 6c1.285 0 2.373-.813 2.8-1.948 2.888 1.127 4.95 3.916 4.95 7.198 0 .284-.021.563-.052.84-.224-.054-.456-.09-.698-.09-1.657 0-3 1.343-3 3 0 .866.373 1.641.96 2.188C13.615 18.315 11.888 19 10 19m-9-4c0-1.103.897-2 2-2 1.103 0 2 .897 2 2 0 1.103-.897 2-2 2-1.103 0-2-.897-2-2m9-14c1.103 0 2 .897 2 2 0 1.103-.897 2-2 2-1.103 0-2-.897-2-2 0-1.103.897-2 2-2m8.646 11.496c.061-.408.104-.821.104-1.246 0-3.778-2.398-6.988-5.754-8.212 0-.013.004-.025.004-.038 0-1.657-1.343-3-3-3-1.657 0-3 1.343-3 3 0 .012.004.023.004.035C3.648 4.26 1.25 7.471 1.25 11.25c0 .425.041.839.1 1.247C.537 13.034 0 13.953 0 15c0 1.657 1.343 3 3 3 .417 0 .814-.086 1.175-.24C5.722 19.148 7.758 20 10 20c2.242 0 4.277-.853 5.825-2.239.362.153.758.239 1.175.239 1.657 0 3-1.343 3-3 0-1.048-.539-1.968-1.354-2.504"],"team_24":["M20.5 21c-1.379 0-2.5-1.121-2.5-2.5 0-1.379 1.121-2.5 2.5-2.5 1.379 0 2.5 1.121 2.5 2.5 0 1.379-1.121 2.5-2.5 2.5m-14.461-.104C6.631 20.271 7 19.43 7 18.5 7 16.567 5.433 15 3.5 15c-.302 0-.589.05-.868.122-.096-.529-.163-1.066-.163-1.622 0-4.075 2.583-7.549 6.195-8.895C9.128 5.993 10.424 7 11.969 7c1.543 0 2.839-1.006 3.303-2.394 3.612 1.347 6.197 4.819 6.197 8.894 0 .549-.068 1.08-.16 1.604-.261-.063-.53-.104-.809-.104-1.933 0-3.5 1.567-3.5 3.5 0 .917.36 1.745.938 2.369C16.306 22.196 14.231 23 11.969 23c-2.246 0-4.303-.794-5.93-2.104M1 18.5C1 17.121 2.121 16 3.5 16 4.879 16 6 17.121 6 18.5 6 19.879 4.879 21 3.5 21 2.121 21 1 19.879 1 18.5M11.969 1c1.378 0 2.5 1.122 2.5 2.5 0 1.378-1.122 2.5-2.5 2.5-1.379 0-2.5-1.122-2.5-2.5 0-1.378 1.121-2.5 2.5-2.5m10.294 14.492c.126-.646.206-1.308.206-1.992 0-4.574-2.931-8.451-7.012-9.891.002-.037.012-.071.012-.109 0-1.933-1.568-3.5-3.5-3.5-1.934 0-3.5 1.567-3.5 3.5 0 .038.01.073.01.11-4.081 1.439-7.01 5.316-7.01 9.89 0 .693.089 1.363.219 2.019C.68 16.133 0 17.232 0 18.5 0 20.433 1.567 22 3.5 22c.629 0 1.211-.18 1.721-.47C7.046 23.066 9.396 24 11.969 24c2.581 0 4.925-.954 6.749-2.503.523.313 1.128.503 1.782.503 1.933 0 3.5-1.567 3.5-3.5 0-1.287-.702-2.399-1.737-3.008"],"team_32":["M26.5 28c-1.93 0-3.5-1.57-3.5-3.5 0-1.93 1.57-3.5 3.5-3.5 1.93 0 3.5 1.57 3.5 3.5 0 1.93-1.57 3.5-3.5 3.5m-17.717-.44C9.532 26.756 10 25.686 10 24.5c0-2.485-2.015-4.5-4.5-4.5-.448 0-.873.086-1.281.208C4.08 19.492 4 18.756 4 18c0-5.105 3.213-9.459 7.717-11.189C12.28 8.652 13.974 10 16 10c2.026 0 3.721-1.349 4.284-3.191C24.788 8.539 28 12.895 28 18c0 .756-.094 1.487-.229 2.204-.406-.12-.827-.204-1.271-.204-2.485 0-4.5 2.015-4.5 4.5 0 1.182.465 2.247 1.209 3.05C21.201 29.077 18.713 30 16 30c-2.712 0-5.206-.916-7.217-2.44M2 24.5C2 22.57 3.57 21 5.5 21 7.43 21 9 22.57 9 24.5 9 26.43 7.43 28 5.5 28 3.57 28 2 26.43 2 24.5M16 2c1.93 0 3.5 1.57 3.5 3.5C19.5 7.43 17.93 9 16 9c-1.93 0-3.5-1.57-3.5-3.5C12.5 3.57 14.07 2 16 2m12.716 18.605c.176-.842.284-1.709.284-2.605 0-5.607-3.556-10.374-8.53-12.197.007-.102.03-.199.03-.303C20.5 3.015 18.485 1 16 1c-2.485 0-4.5 2.015-4.5 4.5 0 .103.023.2.03.301C6.555 7.625 3 12.393 3 18c0 .895.118 1.758.294 2.601C1.931 21.374 1 22.821 1 24.5 1 26.985 3.015 29 5.5 29c.933 0 1.798-.283 2.517-.77C10.221 29.957 12.983 31 16 31c3.016 0 5.772-1.05 7.975-2.776.72.489 1.588.776 2.525.776 2.485 0 4.5-2.015 4.5-4.5 0-1.676-.927-3.12-2.284-3.895"],"team-active_12":["M3.569 10.227C3.835 9.887 4 9.465 4 9c0-1.104-.896-2-2-2-.08 0-.156.015-.233.023-.007-.09-.017-.18-.017-.273 0-1.708 1.025-3.16 2.482-3.833C4.566 3.558 5.228 4 6 4c.774 0 1.438-.445 1.771-1.088 1.457.673 2.479 2.13 2.479 3.838 0 .093-.012.183-.019.273C10.154 7.014 10.079 7 10 7c-1.104 0-2 .896-2 2 0 .456.159.872.416 1.208C7.728 10.694 6.905 11 6 11c-.905 0-1.741-.289-2.431-.773m7.63-2.819c.03-.216.051-.434.051-.658 0-2.187-1.354-4.028-3.256-4.814C7.959.862 7.083 0 6 0 4.919 0 4.044.859 4.007 1.931 2.103 2.716.75 4.562.75 6.75c0 .224.024.44.055.655C.319 7.771 0 8.346 0 9c0 1.104.896 2 2 2 .264 0 .515-.054.746-.146C3.64 11.566 4.767 12 6 12c1.232 0 2.352-.437 3.244-1.15.233.095.488.15.756.15 1.104 0 2-.896 2-2 0-.653-.317-1.227-.801-1.592"],"team-active_14":["M3.96097343 11.988c.483-.676.561-1.597.119-2.364-.405-.702-1.141-1.094-1.896-1.094-.12 0-.239.027-.358.046-.049-.268-.078-.543-.078-.825 0-2.167 1.323-4.021 3.201-4.82.306.84 1.104 1.444 2.049 1.444.945 0 1.743-.603 2.048-1.443 1.87899997.799 3.20199997 2.652 3.20199997 4.819 0 .283-.032.557-.082.825-.118-.02-.236-.046-.357-.046-.372 0-.748.095-1.092.293-1.04599997.604-1.40499997 1.942-.80099997 2.988.036.062.08599997.108.12699997.164-.86099997.629-1.89899997 1.026-3.04499997 1.026-1.141 0-2.178-.39-3.037-1.013m9.74399997-2.364c-.154-.266-.364-.471-.596-.643.082-.399.139-.807.139-1.23 0-2.692-1.706-4.978-4.09199997-5.857-.145-1.068-1.051-1.894-2.158-1.894-1.107 0-2.013.825-2.158 1.893-2.386.879-4.092 3.165-4.092 5.858 0 .42.057.824.138 1.22-.8780000005.654-1.156 1.869-.595 2.84.406.702 1.141 1.094 1.896 1.094.326 0 .652-.087.96-.238 1.062.833 2.397 1.334 3.851 1.334 1.453 0 2.785-.501 3.84599997-1.334.302.149.631.238.968.238.372 0 .748-.094 1.092-.293 1.046-.605 1.405-1.941.801-2.988"],"team-active_16":["M10.9984057 14.196c-.912.527-1.94700003.805-2.99300003.805-1.303 0-2.532-.452-3.549-1.204.616-.78.734-1.885.207-2.798-.463-.801-1.304-1.25-2.168-1.25-.147 0-.292.031-.439.057-.107-.778-.063-1.577.146-2.359.415-1.548 1.408-2.842 2.796-3.643.224-.13.459-.234.697-.329.381.896 1.269 1.525 2.303 1.525 1.029 0 1.912-.623 2.29600003-1.512 1.197.499 2.233 1.357 2.9 2.512.673 1.165.9 2.491.719 3.803-.139-.023-.276-.054-.417-.054-.424 0-.854.109-1.247.335-1.197.691-1.606 2.22-.915 3.415.062.11.148.196.224.292-.184.138-.357.287-.56.405m4.666-3.197c-.198-.341-.474-.604-.781-.811.27-1.557.03-3.212-.823-4.688-.836-1.448-2.115-2.468-3.564-3.019C10.4864057 1.109 9.37340567 0 7.99840567 0c-1.373 0-2.486 1.108-2.498 2.478-.34.127-.677.272-1.002.459-2.608 1.506-3.857000005 4.435-3.377 7.239-1.091000005.725-1.452000005 2.174-.788000005 3.323.463.803 1.302000005 1.251 2.167000005 1.251.383 0 .766-.101 1.128-.286 1.247.998 2.797 1.537 4.377 1.537 1.187 0 2.39000003-.302 3.49300003-.939.308-.178.59-.383.858-.6.355.183.745.288 1.145.288.424 0 .853-.108 1.248-.336 1.195-.689 1.605-2.218.915-3.415"],"team-active_18":["M5.313 15.889C5.736 15.372 6 14.72 6 14c0-1.657-1.343-3-3-3-.24 0-.471.035-.694.089-.036-.275-.056-.555-.056-.839 0-2.728 1.639-5.06 3.974-6.123C6.669 5.225 7.742 6 9 6c1.258 0 2.33-.775 2.776-1.872 2.335 1.062 3.974 3.394 3.974 6.122 0 .284-.023.563-.059.838-.222-.053-.452-.088-.691-.088-1.657 0-3 1.343-3 3 0 .715.26 1.361.677 1.877C11.616 16.574 10.361 17 9 17c-1.362 0-2.626-.413-3.687-1.111m11.327-4.397c.066-.405.11-.818.11-1.242 0-3.217-1.972-5.954-4.763-7.125.002-.043.013-.083.013-.125 0-1.657-1.343-3-3-3-1.657 0-3 1.343-3 3 0 .043.011.083.013.126C3.222 4.298 1.25 7.033 1.25 10.25c0 .424.047.836.113 1.24C.544 12.026 0 12.948 0 14c0 1.657 1.343 3 3 3 .562 0 1.081-.164 1.53-.433C5.794 17.465 7.332 18 9 18c1.668 0 3.208-.533 4.471-1.432.449.268.968.432 1.529.432 1.657 0 3-1.343 3-3 0-1.051-.542-1.973-1.36-2.508"],"team-active_20":["M10 19c-1.888 0-3.609-.689-4.955-1.815C5.63 16.637 6 15.864 6 15c0-1.657-1.343-3-3-3-.242 0-.475.036-.699.091-.032-.277-.051-.557-.051-.841 0-3.282 2.062-6.073 4.949-7.2C7.626 5.187 8.714 6 10 6c1.285 0 2.373-.813 2.8-1.948 2.888 1.127 4.95 3.916 4.95 7.198 0 .284-.021.563-.052.84-.224-.054-.456-.09-.698-.09-1.657 0-3 1.343-3 3 0 .866.373 1.641.96 2.188C13.615 18.315 11.888 19 10 19m8.646-6.504c.061-.408.104-.821.104-1.246 0-3.778-2.398-6.988-5.754-8.212 0-.013.004-.025.004-.038 0-1.657-1.343-3-3-3-1.657 0-3 1.343-3 3 0 .012.004.023.004.035C3.648 4.26 1.25 7.471 1.25 11.25c0 .425.041.839.1 1.247C.537 13.034 0 13.953 0 15c0 1.657 1.343 3 3 3 .417 0 .814-.086 1.175-.24C5.722 19.148 7.758 20 10 20c2.242 0 4.277-.853 5.825-2.239.362.153.758.239 1.175.239 1.657 0 3-1.343 3-3 0-1.048-.539-1.968-1.354-2.504"],"team-active_24":["M6.039 20.896C6.631 20.271 7 19.43 7 18.5 7 16.567 5.433 15 3.5 15c-.302 0-.589.05-.868.122-.096-.529-.163-1.066-.163-1.622 0-4.075 2.583-7.549 6.195-8.895C9.128 5.993 10.424 7 11.969 7c1.543 0 2.839-1.006 3.303-2.394 3.612 1.347 6.197 4.819 6.197 8.894 0 .549-.068 1.08-.16 1.604-.261-.063-.53-.104-.809-.104-1.933 0-3.5 1.567-3.5 3.5 0 .917.36 1.745.938 2.369C16.306 22.196 14.231 23 11.969 23c-2.246 0-4.303-.794-5.93-2.104m16.224-5.404c.126-.646.206-1.308.206-1.992 0-4.574-2.931-8.451-7.012-9.891.002-.037.012-.071.012-.109 0-1.933-1.568-3.5-3.5-3.5-1.934 0-3.5 1.567-3.5 3.5 0 .038.01.073.01.11-4.081 1.439-7.01 5.316-7.01 9.89 0 .693.089 1.363.219 2.019C.68 16.133 0 17.232 0 18.5 0 20.433 1.567 22 3.5 22c.629 0 1.211-.18 1.721-.47C7.046 23.066 9.396 24 11.969 24c2.581 0 4.925-.954 6.749-2.503.523.313 1.128.503 1.782.503 1.933 0 3.5-1.567 3.5-3.5 0-1.287-.702-2.399-1.737-3.008"],"team-active_32":["M8.783 27.56C9.532 26.756 10 25.686 10 24.5c0-2.485-2.015-4.5-4.5-4.5-.448 0-.873.086-1.281.208C4.08 19.492 4 18.756 4 18c0-5.105 3.213-9.459 7.717-11.189C12.28 8.652 13.974 10 16 10c2.026 0 3.721-1.349 4.284-3.191C24.788 8.539 28 12.895 28 18c0 .756-.094 1.487-.229 2.204-.406-.12-.827-.204-1.271-.204-2.485 0-4.5 2.015-4.5 4.5 0 1.182.465 2.247 1.209 3.05C21.201 29.077 18.713 30 16 30c-2.712 0-5.206-.916-7.217-2.44m19.933-6.955c.176-.842.284-1.709.284-2.605 0-5.607-3.556-10.374-8.53-12.197.007-.102.03-.199.03-.303C20.5 3.015 18.485 1 16 1c-2.485 0-4.5 2.015-4.5 4.5 0 .103.023.2.03.301C6.555 7.625 3 12.393 3 18c0 .895.118 1.758.294 2.601C1.931 21.374 1 22.821 1 24.5 1 26.985 3.015 29 5.5 29c.933 0 1.798-.283 2.517-.77C10.221 29.957 12.983 31 16 31c3.016 0 5.772-1.05 7.975-2.776.72.489 1.588.776 2.525.776 2.485 0 4.5-2.015 4.5-4.5 0-1.676-.927-3.12-2.284-3.895"],"telepresence_12":["M11 8.5c0 .275-.224.5-.5.5l-.961 0c-.284-.451-.785-.785-1.382-.924C8.677 7.536 9 6.807 9 6c0-1.654-1.346-3-3-3-1.654 0-3 1.346-3 3 0 .807.323 1.536.843 2.076-.597.139-1.098.473-1.382.924L1.5 9c-.276 0-.5-.225-.5-.5l0-6c0-.275.224-.5.5-.5l9 0c.276 0 .5.225.5.5l0 6zM6 8c-1.103 0-2-.897-2-2 0-1.103.897-2 2-2 1.103 0 2 .897 2 2 0 1.103-.897 2-2 2zm-2.871 2l.11-.334C3.365 9.28 3.879 9 4.461 9l3.078 0c.582 0 1.096.28 1.222.666l.11.334-5.742 0zM10.5 1l-9 0C.671 1 0 1.672 0 2.5l0 6C0 9.328.671 10 1.5 10l.577 0-.045.137c-.064.194-.031.402.09.57.133.184.356.293.597.293l6.562 0c.241 0 .464-.109.597-.293.121-.168.154-.376.09-.57L9.923 10l.577 0c.829 0 1.5-.672 1.5-1.5l0-6c0-.828-.671-1.5-1.5-1.5z"],"telepresence_16":["M15 11c0 .551-.449 1-1 1l-.569 0c-.463-1.139-1.561-1.916-2.831-1.985C11.45 9.281 12 8.208 12 7c0-2.206-1.794-4-4-4-2.206 0-4 1.794-4 4 0 1.208.55 2.281 1.4 3.015-1.27.069-2.368.846-2.831 1.985L2 12c-.551 0-1-.449-1-1l0-8c0-.551.449-1 1-1l12 0c.551 0 1 .449 1 1l0 8zm-7-1c-1.654 0-3-1.346-3-3 0-1.654 1.346-3 3-3 1.654 0 3 1.346 3 3 0 1.654-1.346 3-3 3zm-4.951 4l.349-1.355C3.648 11.676 4.546 11 5.582 11l4.836 0c1.036 0 1.934.676 2.184 1.645L12.951 14l-9.902 0zM14 1L2 1C.897 1 0 1.897 0 3l0 8c0 1.103.897 2 2 2l.274 0-.248.961c-.064.249-.01.509.148.712.16.208.405.327.67.327l10.312 0c.265 0 .51-.119.67-.327.158-.203.212-.463.148-.712L13.727 13 14 13c1.103 0 2-.897 2-2l0-8c0-1.103-.897-2-2-2z"],"telepresence_20":["M19 13.5c0 .827-.673 1.5-1.5 1.5l-.485 0c-.732-1.208-2.135-2-3.718-2l-.328 0C14.194 12.088 15 10.642 15 9c0-2.757-2.243-5-5-5-2.757 0-5 2.243-5 5 0 1.642.806 3.088 2.031 4l-.328 0c-1.583 0-2.986.792-3.718 2L2.5 15c-.827 0-1.5-.673-1.5-1.5l0-10C1 2.673 1.673 2 2.5 2l15 0c.827 0 1.5.673 1.5 1.5l0 10zM6 9c0-2.206 1.794-4 4-4 2.206 0 4 1.794 4 4 0 2.206-1.794 4-4 4-2.206 0-4-1.794-4-4zm-2.971 8.999l.517-1.839C3.904 14.888 5.202 14 6.703 14l6.594 0c1.501 0 2.799.888 3.157 2.16l.518 1.84-13.943-.001zM17.5 1l-15 0C1.119 1 0 2.119 0 3.5l0 10C0 14.881 1.119 16 2.5 16l.052 0-.519 1.847c-.075.266-.021.547.148.77.181.24.476.383.788.383l14.062 0c.312 0 .607-.143.788-.383.169-.223.223-.504.148-.77L17.448 16l.052 0c1.381 0 2.5-1.119 2.5-2.5l0-10C20 2.119 18.881 1 17.5 1z"],"telepresence_24":["M12 16c-2.757 0-5-2.243-5-5 0-2.757 2.243-5 5-5 2.757 0 5 2.243 5 5 0 2.757-2.243 5-5 5zm11 1.5c0 .827-.673 1.5-1.5 1.5l-1.302 0c-.667-1.781-2.433-3-4.461-3l-.427 0c1.619-1.076 2.69-2.914 2.69-5 0-3.309-2.692-6-6-6-3.308 0-6 2.691-6 6 0 2.086 1.071 3.924 2.69 5l-.427 0c-2.028 0-3.794 1.219-4.461 3L2.5 19c-.827 0-1.5-.673-1.5-1.5l0-13C1 3.673 1.673 3 2.5 3l19 0c.827 0 1.5.673 1.5 1.5l0 13zM3.999 22.007l.624-2.349C5.039 18.093 6.536 17 8.263 17l7.474 0c1.727 0 3.224 1.093 3.64 2.658L19.969 22l-15.97.007zM21.5 2l-19 0C1.119 2 0 3.119 0 4.5l0 13C0 18.881 1.119 20 2.5 20l.998 0-.465 1.75c-.078.295-.016.604.172.848.196.256.498.402.826.402l15.938 0c.328 0 .63-.146.826-.402.188-.244.25-.553.172-.848L20.502 20l.998 0c1.381 0 2.5-1.119 2.5-2.5l0-13C24 3.119 22.881 2 21.5 2z"],"telepresence_64":["M32 42c-8.271 0-15-6.729-15-15 0-8.271 6.729-15 15-15 8.271 0 15 6.729 15 15 0 8.271-6.729 15-15 15zm31 4.5c0 3.032-2.467 5.5-5.5 5.5l-2.224 0-.136-.534C53.717 45.893 48.631 42 42.771 42l-5.256 0C43.624 39.746 48 33.882 48 27c0-8.822-7.178-16-16-16-8.822 0-16 7.178-16 16 0 6.882 4.376 12.746 10.485 15l-5.256 0c-5.86 0-10.946 3.893-12.369 9.466L8.724 52 6.5 52C3.467 52 1 49.532 1 46.5l0-37C1 6.468 3.467 4 6.5 4l51 0C60.533 4 63 6.468 63 9.5l0 37zm-7.208 13.102c-.197.252-.497.398-.824.398L9.032 60c-.327 0-.627-.146-.824-.398-.187-.242-.252-.549-.177-.842l1.798-7.046c1.31-5.131 5.997-8.714 11.4-8.714l21.542 0c5.403 0 10.09 3.583 11.4 8.714l1.798 7.045c.075.294.01.601-.177.843zM57.5 3l-51 0C2.916 3 0 5.916 0 9.5l0 37C0 50.084 2.916 53 6.5 53l1.969 0-1.407 5.513c-.152.594-.022 1.216.357 1.702.388.499.976.785 1.613.785l45.936 0c.637 0 1.225-.286 1.613-.785.379-.486.509-1.108.357-1.703L55.531 53l1.969 0c3.584 0 6.5-2.916 6.5-6.5l0-37C64 5.916 61.084 3 57.5 3z"],"telepresence-alert_12":["M15.8415 10.331c.205.341.211.752.017 1.1-.198.351-.572.569-.978.569l-5.761 0c-.406 0-.781-.218-.978-.569-.076-.136-.112-.283-.127-.431l-5.296 0c-.24 0-.464-.109-.596-.293-.121-.168-.155-.376-.091-.57l.046-.137-.577 0c-.829 0-1.5-.672-1.5-1.5l0-6c0-.828.671-1.5 1.5-1.5l9 0c.829 0 1.5.672 1.5 1.5l0 2.5c.378 0 .757.17.961.509l0 .001 2.88 4.821zm-.941.669c.077 0 .124-.084.085-.149l-2.863-4.781c-.057-.094-.194-.094-.25 0l-2.858 4.781c-.04.065.008.149.085.149l5.801 0zm-2.9004-4c.275 0 .5.225.5.5l0 1c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-1c0-.275.225-.5.5-.5zm0 2.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm-8.7616.166l-.109.334 5.227 0 .301-.504c-.203-.293-.63-.496-1.118-.496l-3.078 0c-.582 0-1.097.28-1.223.666zM8.0005 6c0-1.103-.897-2-2-2-1.103 0-2 .897-2 2 0 1.103.897 2 2 2 1.103 0 2-.897 2-2zm-5.539 3c.284-.451.785-.785 1.381-.924-.52-.54-.842-1.269-.842-2.076 0-1.654 1.345-3 3-3 1.653 0 3 1.346 3 3 0 .807-.324 1.536-.844 2.076.404.094.757.28 1.033.529l1.811-3.031 0-3.074c0-.275-.225-.5-.5-.5l-9 0c-.276 0-.5.225-.5.5l0 6c0 .275.224.5.5.5l.961 0z"],"telepresence-ix5000_16":["M11 9l4 0 0-4-4 0 0 4zm4 2.991c0 .558-.447 1.009-.994 1.009L1.994 13C1.447 13 1 12.549 1 11.991L1 10l14 0 0 1.991zM1 9l4 0 0-4-4 0 0 4zm5 0l4 0 0-4-4 0 0 4zM1.994 3l12.012 0c.544 0 .987.446.992 1L1.002 4c.005-.554.448-1 .992-1zm12.012-1L1.994 2C.895 2 0 2.899 0 4.009l0 7.982C0 13.097.893 14 1.994 14l12.012 0C15.105 14 16 13.1 16 11.991l0-7.982C16 2.902 15.107 2 14.006 2z"],"telepresence-ix5000_20":["M14 11l5 0 0-5-5 0 0 5zm5 3.5c0 .827-.673 1.5-1.5 1.5l-15 0c-.207 0-.404-.042-.583-.118-.359-.152-.647-.44-.799-.798-.076-.18-.118-.377-.118-.584L1 12l18 0 0 2.5zM1 11l5 0 0-5-5 0 0 5zm6 0l6 0 0-5-6 0 0 5zM2.5 4l15 0c.207 0 .404.042.583.118.359.152.647.44.799.798.012.026.016.057.026.084L1.092 5c.207-.581.758-1 1.408-1zm17.072.104C19.123 3.437 18.362 3 17.5 3l-15 0C1.121 3 0 4.121 0 5.5l0 9c0 .518.158.998.428 1.396C.877 16.563 1.638 17 2.5 17l15 0c1.379 0 2.5-1.121 2.5-2.5l0-9c0-.518-.158-.998-.428-1.396z"],"telepresence-muted_12":["M11 8.5c0 .275-.224.5-.5.5l-.961 0c-.284-.451-.785-.785-1.382-.924C8.677 7.536 9 6.807 9 6c0-.646-.21-1.242-.56-1.733l2.232-2.232c.19.07.328.25.328.465l0 6zM3.129 10l.11-.334C3.365 9.28 3.879 9 4.461 9l3.078 0c.582 0 1.096.28 1.222.666l.11.334-5.742 0zm4.588-5.01C7.892 5.288 8 5.63 8 6c0 1.103-.897 2-2 2-.37 0-.712-.107-1.01-.283L7.717 4.99zM4.283 7.01C4.108 6.712 4 6.37 4 6c0-1.103.897-2 2-2 .37 0 .712.107 1.01.283L4.283 7.01zM1.5 9c-.276 0-.5-.225-.5-.5l0-6c0-.275.224-.5.5-.5l7.793 0-1.56 1.56C7.243 3.211 6.647 3 6 3 4.346 3 3 4.346 3 6c0 .646.215 1.238.565 1.729L2.293 9 1.5 9zm9.9-7.693l.454-.453c.195-.196.195-.512 0-.708-.196-.195-.512-.195-.708 0L10.293 1 1.5 1C.671 1 0 1.672 0 2.5l0 6c0 .764.573 1.388 1.312 1.481L.146 11.146c-.195.196-.195.512 0 .708.098.097.226.146.354.146.128 0 .256-.049.354-.146l1.232-1.233c.015.027.017.06.036.086.133.184.356.293.597.293l6.562 0c.241 0 .464-.109.597-.293.121-.168.154-.376.09-.57L9.923 10l.577 0c.829 0 1.5-.672 1.5-1.5l0-6c0-.489-.238-.919-.6-1.193z"],"telepresence-muted_64":["M62.9997578 46.5000684c0 3.0319881-2.4669807 5.4999785-5.499957 5.4999785l-2.2239826 0-.135999-.5339979c-1.4229889-5.5729783-6.5089491-9.4659631-12.3689033-9.4659631l-5.255959 0c6.1089523-2.2539912 10.4849181-8.1179683 10.4849181-14.9999414 0-2.9489884-.8159936-5.7049777-2.2129827-8.0799684L60.0667807 4.64023187c1.7429864.9229964 2.9329771 2.75498924 2.9329771 4.85998102l0 36.99985551zm-7.0309451 12.2589521c.0749995.2939988.01.6009976-.1769986.8429967-.1969984.251999-.4969961.3979984-.8239935.3979984l-45.93564116 0c-.32699745 0-.62699511-.1459994-.82399357-.3979984-.18699854-.2419991-.25199803-.5489979-.17699861-.8419967l.71399442-2.7969891L21.7070804 43.000082l21.0638355 0c5.4029577 0 10.0899211 3.582986 11.3999109 8.713966l1.7979859 7.0449725zM9.82917321 51.714048c1.22999039-4.8189812 5.43995749-8.2719677 10.42291859-8.6739661L9.2291779 54.0630388l.59999531-2.3489908zM23.7680643 39.5250956c-4.0719682-2.6849895-6.7679471-7.2939715-6.7679471-12.5249511 0-8.2709677 6.7289474-14.9999414 14.9998828-14.9999414 5.2309591 0 9.8399231 2.6959895 12.5249021 6.7679736L23.7680643 39.5250956zm2.7169788 2.4749903l-3.7779705 0 1.2219905-1.2219952c.8109936.4769981 1.661987.8919965 2.55598 1.2219952zm-1.8379857-1.9389924L45.059898 19.6461733c1.2299904 2.1759915 1.9399848 4.6819817 1.9399848 7.3539712 0 8.2709677-6.7289474 14.9999414-14.9998828 14.9999414-2.6719791 0-5.1779595-.7109972-7.3529426-1.9389924zM6.50019922 52.0000469c-3.03297631 0-5.49995703-2.4679904-5.49995703-5.4999785l0-36.99985551c0-3.03198816 2.46698072-5.49997852 5.49995703-5.49997852l50.99960158 0c.5429957 0 1.0669916.08199968 1.5629878.22899911L45.2498965 18.0431795C42.370919 13.7971961 37.505957 11.000207 32 11.000207c-8.8219311 0-15.999875 7.177972-15.999875 15.9999375 0 5.5079785 2.8079781 10.3589596 7.0589449 13.2339483l-1.7659863 1.7659931-.0639995 0c-5.8599542 0-10.9459144 3.8929848-12.36890332 9.4659631l-.13599894.5339979-2.22398262 0zM60.797775 3.90823473L63.8537511.854246663c.1949985-.195999234.1949985-.511998 0-.707997234-.1959984-.1949992386-.511996-.1949992386-.7079944 0L59.8477824 3.44523654c-.7299943-.28299889-1.5199881-.44499826-2.3479816-.44499826l-50.99960158 0c-3.583972 0-6.499949222 2.91598861-6.499949222 6.49997461l0 36.99985551c0 3.583986 2.915977222 6.4999746 6.499949222 6.4999746l1.96898461 0-.6259951 2.4489904-7.696939873 7.6969699c-.1949984761.1959993-.1949984761.511998 0 .7079973C.244248092 63.9510002.372247092 64 .500246092 64c.127999 0 .255998-.0489998.353997234-.1459994L7.35919251 57.348026l-.29699768 1.1649954c-.15199882.5939977-.02199983 1.2159953.35699721 1.7019934.38799697.498998.97599237.7849969 1.6129874.7849969l45.93564116 0c.636995 0 1.2249904-.2859989 1.6129874-.7849969.378997-.4859981.508996-1.1079957.3569972-1.7029934l-1.406989-5.5119784 1.9689846 0c3.583972 0 6.4999492-2.9159886 6.4999492-6.4999746l0-36.99985551c0-2.37899071-1.2889899-4.45898258-3.201975-5.59197816z"],"telepresence-muted-alert_12":["M15.8413 10.331c.205.341.211.752.017 1.1-.198.351-.572.569-.978.569l-5.761 0c-.406 0-.78-.218-.977-.569-.077-.136-.113-.283-.128-.431l-5.295 0c-.241 0-.465-.109-.597-.293-.019-.026-.021-.059-.036-.086l-1.232 1.233c-.099.097-.226.146-.354.146-.128 0-.256-.049-.354-.146-.098-.098-.146-.225-.146-.353l0-.002c0-.128.048-.255.146-.353l1.166-1.165C.5733 9.888.0003 9.264.0003 8.5l0-6c0-.828.671-1.5 1.5-1.5l8.793 0 .853-.854c.097-.097.225-.146.353-.146l.002 0c.128 0 .255.049.353.146.097.098.146.225.146.353l0 .002c0 .128-.049.255-.146.353l-.454.453c.362.274.6.704.6 1.193l0 2.5c.379 0 .757.17.961.509 0 0 0 0 0 .001l2.88 4.821zm-.941.669c.077 0 .125-.084.085-.149l-2.863-4.781c-.057-.094-.194-.094-.25 0l-2.858 4.781c-.039.066.008.149.085.149l5.801 0zm-2.9004-4c.275 0 .5.225.5.5l0 1c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-1c0-.275.225-.5.5-.5zm0 2.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm-8.7606.166l-.11.334 5.227 0 .301-.504C8.4543 9.203 8.0283 9 7.5393 9l-3.078 0c-.582 0-1.096.28-1.222.666zm1.044-2.656l2.727-2.727c-.298-.176-.64-.283-1.01-.283-1.103 0-2 .897-2 2 0 .37.108.712.283 1.01zm3.433-2.02l-2.726 2.727c.298.176.639.283 1.01.283 1.103 0 2-.897 2-2 0-.37-.108-.712-.284-1.01zM2.2933 9l1.272-1.271c-.351-.491-.565-1.083-.565-1.729 0-1.654 1.346-3 3-3 .647 0 1.243.211 1.733.56L9.2933 2l-7.793 0c-.276 0-.5.225-.5.5l0 6c0 .275.224.5.5.5l.793 0zm8.378-6.965l-2.231 2.232c.35.491.56 1.087.56 1.733 0 .807-.323 1.536-.843 2.076.402.093.754.281 1.032.528l1.811-3.03 0-3.074c0-.215-.138-.395-.329-.465z"],"telepresence-private_12":["M12.5001 11c-1.207 0-2.217-.86-2.449-2l4.898 0c-.232 1.14-1.242 2-2.449 2zm-9.371-1l.11-.334c.126-.386.64-.666 1.222-.666l3.078 0c.582 0 1.096.28 1.222.666l.11.334-5.742 0zm4.871-4c0 1.104-.897 2-2 2-1.103 0-2-.896-2-2 0-1.104.897-2 2-2 1.103 0 2 .896 2 2zm-5.539 3l-.961 0c-.276 0-.5-.225-.5-.5l0-6c0-.275.224-.5.5-.5l9 0c.276 0 .5.225.5.5l0 2.85c-1.166.556-1.977 1.73-1.995 3.103-.245-.172-.531-.304-.848-.377.52-.54.843-1.269.843-2.076 0-1.654-1.346-3-3-3-1.654 0-3 1.346-3 3 0 .807.323 1.536.843 2.076-.597.139-1.098.473-1.382.924zm12.488-1l-4.898 0c.232-1.14 1.242-2 2.449-2 1.207 0 2.217.86 2.449 2zm-2.449-3c-.171 0-.335.026-.5.051l0-2.551c0-.828-.671-1.5-1.5-1.5l-9 0c-.829 0-1.5.672-1.5 1.5l0 6c0 .828.671 1.5 1.5 1.5l.577 0-.045.137c-.064.194-.031.402.09.57.133.184.356.293.597.293l6.562 0c.22 0 .418-.1.553-.257.643.763 1.592 1.257 2.666 1.257 1.933 0 3.5-1.567 3.5-3.5 0-1.933-1.567-3.5-3.5-3.5z"],"text_10":["M1.4999 3c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l7 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-7 0zm0 2.5c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l7 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-7 0zm0 2.5c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l3 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-3 0z"],"text_12":["M10.5 5.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-9 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l9 0zM5.5 9c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-4 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l4 0zm-4-6c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l9 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-9 0z"],"text-align-left_16":["M14.4998 3l-13 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l13 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5zm0 11l-13 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l13 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5zm0-3.667l-6 0c-.276 0-.5-.224-.5-.5 0-.275.224-.5.5-.5l6 0c.276 0 .5.225.5.5 0 .276-.224.5-.5.5zm0-3.6665l-6 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l6 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5zM5.0203 4.9898c.128 0 .256.049.354.146.195.196.195.512 0 .708l-2.167 2.167 2.157 2.156c.195.196.195.512 0 .707-.196.196-.512.196-.707 0l-2.511-2.51c-.195-.195-.195-.512 0-.707l2.52-2.521c.098-.097.226-.146.354-.146z"],"text-align-right_16":["M14.5 3l-13 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l13 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5zm0 11l-13 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l13 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5zm0-3.667l-6 0c-.276 0-.5-.224-.5-.5 0-.275.224-.5.5-.5l6 0c.276 0 .5.225.5.5 0 .276-.224.5-.5.5zm0-3.6665l-6 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l6 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5zm-12 4.354c-.128 0-.256-.049-.354-.146-.195-.196-.195-.512 0-.708l2.167-2.167-2.156-2.156c-.195-.196-.195-.512 0-.707.196-.196.512-.196.707 0l2.51 2.51c.195.195.195.512 0 .707l-2.52 2.521c-.098.097-.226.146-.354.146z"],"text-blockquote_12":["M10 5.99805l-2 0 0 3 2 0 0-3zm-2 4c-.482 0-.867-.35-.961-.805-.025-.06-.039-.126-.039-.195l0-3 0-1.498c0-1.378 1.121-2.5 2.5-2.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.827 0-1.5.673-1.5 1.5l0 .498 2 0c.552 0 1 .449 1 1l0 3c0 .551-.448 1-1 1l-2 0zm-5.961-.805c-.025-.06-.039-.126-.039-.195l0-3 0-1.498c0-1.378 1.121-2.5 2.5-2.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.827 0-1.5.673-1.5 1.5l0 .498 2 0c.552 0 1 .449 1 1l0 3c0 .551-.448 1-1 1l-2 0c-.482 0-.867-.35-.961-.805zM5 5.99805l-2 0 0 3 2 0 0-3z"],"text-blockquote_16":["M14 8l-4 0 0 5 4 0 0-5zm-4 6c-.552 0-1-.449-1-1l0-5.059L9 7.5l0-1C9 4.019 11.019 2 13.5 2c.276 0 .5.224.5.5 0 .276-.224.5-.5.5C11.57 3 10 4.57 10 6.5l0 .5 4 0c.552 0 1 .449 1 1l0 5c0 .551-.448 1-1 1l-4 0zm-8 0c-.552 0-1-.449-1-1l0-5.059L1 7.5l0-1C1 4.019 3.019 2 5.5 2c.276 0 .5.224.5.5 0 .276-.224.5-.5.5C3.57 3 2 4.57 2 6.5L2 7l4 0c.552 0 1 .449 1 1l0 5c0 .551-.448 1-1 1l-4 0zm4-6L2 8l0 5 4 0 0-5z"],"text-blockquote_8":["M6.9488 2.03210318c-.552.205-.949.731-.949 1.353l0 .615.872 0c.071 0 .128.057.128.128l0 2.744c0 .071-.057.128-.128.128l-1.744 0c-.07 0-.128-.057-.128-.128l0-3.487c0-1.158.816-2.131999997 1.901-2.3829999965.05-.012.099.029.099.081l0 .8769999995c0 .033-.02.060999997-.051.071999997zM2.9004 1.0021031835c.05-.012.1.029.1.081l0 .8769999995c0 .033-.021.060999997-.052.071999997-.551.205-.948.731-.948 1.353l0 .615.872 0c.07 0 .128.057.128.128l0 2.744c0 .071-.058.128-.128.128l-1.744 0c-.071 0-.128-.057-.128-.128l0-3.487c0-1.158.815-2.131999997 1.9-2.3829999965z"],"text-bold_12":["M7 5L4 5l0-2 3 0c.542 0 1 .458 1 1 0 .542-.458 1-1 1m0 4L4 9l0-2 3 0c.542 0 1 .458 1 1 0 .542-.458 1-1 1m3-5c0-1.65-1.35-3-3-3L3 1c-.55 0-1 .45-1 1l0 8c0 .55.45 1 1 1l4 0c1.65 0 3-1.35 3-3 0-.77-.302-1.467-.783-2 .481-.533.783-1.23.783-2"],"text-bold_16":["M9.507 12C10.33 12 11 11.331 11 10.507c0-.823-.67-1.493-1.493-1.493L5 9.014 5 12l4.507 0zM5 4l0 3 3.99 0c.827 0 1.5-.673 1.5-1.5 0-.827-.673-1.5-1.5-1.5L5 4zm6.639 3.761C12.461 8.4 13 9.388 13 10.507 13 12.433 11.433 14 9.507 14L4 14c-.553 0-1-.448-1-1l0-4.986c0-.002.001-.004.001-.007C3.001 8.004 3 8.002 3 8l0-5c0-.552.447-1 1-1l4.99 0c1.93 0 3.5 1.57 3.5 3.5 0 .866-.328 1.649-.851 2.261z"],"text-code-block_12":["M3.3535 3.14719c.195.195.195.512 0 .707l-2.146 2.147 2.146 2.146c.195.195.195.512 0 .707-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147l-2.5-2.5c-.195-.195-.195-.512 0-.707l2.5-2.5c.195-.195.512-.195.707 0zm8.5 2.5c.195.195.195.512 0 .707l-2.5 2.5c-.195.195-.512.195-.707 0-.195-.195-.195-.512 0-.707l2.146-2.146-2.146-2.147c-.195-.195-.195-.512 0-.707.098-.098.226-.146.353-.146.128 0 .256.048.354.146l2.5 2.5zm-4.1562-3.606c.254.109.371.403.263.656l-3 7c-.082.19-.267.303-.46.303-.067 0-.133-.012-.198-.04-.253-.109-.371-.403-.262-.656l3-7c.109-.256.404-.373.657-.263z"],"text-code-block_16":["M9.6582 3.02509c.262.087.403.37.316.632l-3 9c-.07.21-.265.342-.474.342-.053 0-.106-.008-.158-.026-.262-.087-.404-.37-.317-.632l3-9c.088-.262.371-.401.633-.316zm-5.3047 1.1206c.195.195.195.512 0 .707l-3.146 3.147 3.146 3.146c.195.195.195.512 0 .707-.098.098-.226.147-.354.147-.127 0-.255-.049-.353-.147l-3.5-3.5c-.195-.195-.195-.512 0-.707l3.5-3.5c.195-.195.512-.195.707 0zm11.5 3.5c.195.195.195.512 0 .707l-3.5 3.5c-.195.195-.512.195-.707 0-.195-.195-.195-.512 0-.707l3.146-3.146-3.146-3.147c-.195-.195-.195-.512 0-.707.098-.098.226-.146.353-.146.128 0 .256.048.354.146l3.5 3.5z"],"text-color_16":["M3.276 11.925c-.247-.124-.346-.424-.223-.671l4.5-9c.17-.339.724-.339.894 0l4.5 9c.123.247.024.547-.223.671-.073.036-.149.053-.224.053-.183 0-.359-.102-.447-.277l-1.362-2.723-5.382 0-1.362 2.723c-.123.248-.423.35-.671.224zM8 3.596L5.809 7.978l4.382 0L8 3.596zm5.5 9.3818c.276 0 .5.224.5.5l0 1c0 .276-.224.5-.5.5l-11 0c-.276 0-.5-.224-.5-.5l0-1c0-.276.224-.5.5-.5l11 0z"],"text-format_12":["M9 1.5c0 .276-.224.5-.5.5L5 2l0 8.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5L4 2 .5 2C.224 2 0 1.776 0 1.5c0-.276.224-.5.5-.5l8 0c.276 0 .5.224.5.5zM11.5 5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5L10 6l0 4.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5L9 6 7.5 6c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l4 0z"],"text-format_16":["M15.5 8L13 8l0 5.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5L12 8 9.5 8c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l6 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5zM6 13.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5L5 3 .5 3C.224 3 0 2.776 0 2.5c0-.276.224-.5.5-.5l10.667 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5L6 3l0 10.5z"],"text-format_8":["M6.5 2L4 2l0 4.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5L3 2 .5 2C.224 2 0 1.776 0 1.5c0-.276.224-.5.5-.5l6 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5zm1 1c.276 0 .5.224.5.5 0 .276-.224.5-.5.5L7 4l0 2.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5L6 4l-.5 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l2 0z"],"text-heading-1_12":["M4 4c1.654 0 3 1.346 3 3l0 3.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5L6 7c0-1.103-.897-2-2-2-1.103 0-2 .897-2 2l0 3 0 .5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-.5 0-3 0-5.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 3.28C2.532 4.301 3.229 4 4 4zm5.6045 2.3325l.627 0 0 4.667-.634 0 0-4-1.047.54 0-.661 1.054-.546z"],"text-heading-1_16":["M13.0186 14l0-6.217-1.589.87 0-.769 1.599-.88.729 0 0 6.996-.739 0zM2.5 14c-.276 0-.5-.224-.5-.5l0-.5 0-3.503L2 2.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 4.556c.636-.652 1.521-1.059 2.5-1.059 1.93 0 3.5 1.57 3.5 3.5L9 13.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-4.003c0-1.379-1.122-2.5-2.5-2.5-1.378 0-2.5 1.121-2.5 2.5L3 13l0 .5c0 .276-.224.5-.5.5z"],"text-heading-2_12":["M4 4c1.654 0 3 1.346 3 3l0 3.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5L6 7c0-1.103-.897-2-2-2-1.103 0-2 .897-2 2l0 3 0 .5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-.5 0-3 0-5.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 3.28C2.532 4.301 3.229 4 4 4zm6.1113 5.3994l-1.067 1.014 2.161 0 0 .587-3.028 0 0-.587 1.521-1.46c.633-.607.873-.934.873-1.387 0-.474-.327-.794-.88-.794-.527 0-.9.294-.954.78l-.673 0c.1-.747.72-1.32 1.64-1.32.867 0 1.52.507 1.52 1.327 0 .633-.273 1.04-1.113 1.84z"],"text-heading-2_16":["M1.5 14c-.276 0-.5-.224-.5-.5l0-.5 0-3.503L1 2.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 4.556c.636-.652 1.521-1.059 2.5-1.059 1.93 0 3.5 1.57 3.5 3.5L8 13.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-4.003c0-1.379-1.122-2.5-2.5-2.5-1.378 0-2.5 1.121-2.5 2.5L2 13l0 .5c0 .276-.224.5-.5.5zm8.9219-5.2373c.16-1.129 1.08-1.909 2.379-1.909 1.239 0 2.199.75 2.199 1.949 0 .93-.42 1.539-1.569 2.658l-1.89 1.85 3.439 0 0 .689-4.438 0 0-.689 2.448-2.419c.87-.85 1.25-1.359 1.25-2.079 0-.799-.549-1.329-1.459-1.329-.86 0-1.469.5-1.569 1.279l-.79 0z"],"text-heading-3_12":["M4 4c1.654 0 3 1.346 3 3l0 3.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5L6 7c0-1.103-.897-2-2-2-1.103 0-2 .897-2 2l0 3 0 .5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-.5 0-3 0-5.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 3.28C2.532 4.301 3.229 4 4 4zm5.6709 7c-.979 0-1.573-.507-1.68-1.253l.68 0c.106.466.42.72.987.72.64 0 1.013-.347 1.013-.847 0-.641-.493-.88-.92-.88l-.387 0 0-.554.374 0c.353 0 .774-.24.774-.78 0-.5-.441-.734-.894-.734-.52 0-.874.267-.94.667l-.674 0c.113-.727.761-1.2 1.647-1.2.781 0 1.514.387 1.514 1.22 0 .507-.353.914-.841 1.067.528.114 1.001.507 1.001 1.207 0 .8-.654 1.367-1.654 1.367z"],"text-heading-3_16":["M1.5 14c-.276 0-.5-.224-.5-.5l0-.5 0-3.503L1 2.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 4.556c.636-.652 1.521-1.059 2.5-1.059 1.93 0 3.5 1.57 3.5 3.5L8 13.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-4.003c0-1.379-1.122-2.5-2.5-2.5-1.378 0-2.5 1.121-2.5 2.5L2 13l0 .5c0 .276-.224.5-.5.5zm8.6328-1.6592l.789 0c.16.76.75 1.18 1.649 1.18 1.03 0 1.669-.571 1.669-1.44 0-.989-.719-1.439-1.508-1.439l-.651 0 0-.65.62 0c.71 0 1.32-.45 1.32-1.269 0-.819-.67-1.239-1.48-1.239-.859 0-1.449.429-1.579 1.129l-.779 0c.179-1.08 1.109-1.759 2.398-1.759 1.18 0 2.199.62 2.199 1.809 0 .8-.5 1.4-1.29 1.619.821.14 1.51.76 1.51 1.809 0 1.229-.97 2.049-2.419 2.049-1.369 0-2.268-.699-2.448-1.799z"],"text-italic_12":["M8.5 1l-2 0c-.275 0-.5.225-.5.5 0 .275.225.5.5.5l.307 0-2.667 8-.64 0c-.275 0-.5.225-.5.5 0 .275.225.5.5.5l2 0c.275 0 .5-.225.5-.5 0-.275-.225-.5-.5-.5l-.307 0L7.86 2l.64 0c.275 0 .5-.225.5-.5 0-.275-.225-.5-.5-.5"],"text-italic_16":["M11.5 2l-3 0c-.276 0-.5.224-.5.5 0 .276.224.5.5.5l.786 0L5.65 13 4.5 13c-.276 0-.5.224-.5.5 0 .276.224.5.5.5l3 0c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5l-.786 0L10.35 3l1.15 0c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5"],"text-list-bulleted_10":["M1.5 3c.276142375 0 .5.223857625.5.5 0 .276142375-.223857625.5-.5.5-.276142375 0-.5-.223857625-.5-.5 0-.276142375.223857625-.5.5-.5zm2 0l5 0c.27614237 0 .5.223857625.5.5 0 .276142375-.22385763.5-.5.5l-5 0c-.27614237 0-.5-.223857625-.5-.5 0-.276142375.22385763-.5.5-.5zm-2 3c.276142375 0 .5.22385763.5.5 0 .27614237-.223857625.5-.5.5-.276142375 0-.5-.22385763-.5-.5 0-.27614237.223857625-.5.5-.5zm2 0l5 0c.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5l-5 0c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5z"],"text-list-bulleted_12":["M5.5 4c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l5 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-5 0zm5 4c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l5 0zm-8-5c.275 0 .5.225.5.5 0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5zm0 5c.275 0 .5.225.5.5 0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5z"],"text-list-bulleted_16":["M4.5 4l10 0c.2761424 0 .5.223857625.5.5 0 .276142375-.2238576.5-.5.5l-10 0c-.27614237 0-.5-.223857625-.5-.5 0-.276142375.22385763-.5.5-.5zm0 7l10 0c.2761424 0 .5.22385763.5.5 0 .27614237-.2238576.5-.5.5l-10 0c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5zm-3-6c-.276142375 0-.5-.223857625-.5-.5 0-.276142375.223857625-.5.5-.5.276142375 0 .5.223857625.5.5 0 .276142375-.223857625.5-.5.5zm0 7c-.276142375 0-.5-.22385763-.5-.5 0-.27614237.223857625-.5.5-.5.276142375 0 .5.22385763.5.5 0 .27614237-.223857625.5-.5.5z"],"text-list-bulleted_8":["M3.5 2l3 0c.27614237 0 .5.223857625.5.5 0 .276142375-.22385763.5-.5.5l-3 0c-.27614237 0-.5-.223857625-.5-.5 0-.276142375.22385763-.5.5-.5zm-2 0c.276142375 0 .5.223857625.5.5 0 .276142375-.223857625.5-.5.5-.276142375 0-.5-.223857625-.5-.5 0-.276142375.223857625-.5.5-.5zm2 3l3 0c.27614237 0 .5.22385763.5.5 0 .27614237-.22385763.5-.5.5l-3 0c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5zm-2 0c.276142375 0 .5.22385763.5.5 0 .27614237-.223857625.5-.5.5-.276142375 0-.5-.22385763-.5-.5 0-.27614237.223857625-.5.5-.5z"],"text-list-numbered_12":["M5.5 4c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l5 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-5 0zm5 4c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-5 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l5 0zM2.5215 5.3159l0-3.113-.814.421 0-.514.818-.426.488 0 0 3.632-.492 0zm1.459 2.3618c0 .493-.213.81-.865 1.432l-.83.789 1.679 0 0 .456-2.355 0 0-.456 1.184-1.137c.492-.472.679-.726.679-1.079 0-.368-.254-.617-.685-.617-.411 0-.7.228-.743.607l-.523 0c.078-.581.561-1.027 1.277-1.027.674 0 1.182.394 1.182 1.032z"],"text-list-numbered_16":["M14.5 5l-8 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l8 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5zm0 7l-8 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l8 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5zM2.4453 7.0508l0-4.287-1.113.609 0-.767 1.219-.657.612 0 0 5.102-.718 0zm.7666 5.2451l-1.148 1.125 2.264 0 0 .683-3.309 0 0-.625.029-.03 1.716-1.694c.585-.572.846-.908.846-1.386 0-.512-.353-.832-.922-.832-.554 0-.938.311-1 .81l-.012.087-.757 0 .017-.114c.12-.851.83-1.423 1.765-1.423.966 0 1.641.602 1.641 1.465 0 .714-.349 1.174-1.13 1.934z"],"text-strikethrough_16":["M13.5 7.5l-4.729 0C5.373 6.987 4.99 5.975 5 5.257 5.009 4.578 5.318 3 7.977 3c1.634 0 2.369.76 2.698 1.398.127.247.429.344.673.216.246-.127.342-.428.215-.674C11.19 3.216 10.228 2 7.977 2 4.234 2 4.008 4.702 4 5.243c-.015 1.061.556 1.769 1.368 2.257L2.5 7.5c-.276 0-.5.224-.5.5 0 .276.224.5.5.5l6.184 0c1.658.255 2.44.994 2.319 2.2-.065.64-.733 2.3-3.026 2.3-1.655 0-2.687-.884-3.101-1.711-.124-.246-.426-.347-.671-.224-.247.124-.347.424-.224.671C4.529 12.831 5.866 14 7.977 14c3.034 0 3.931-2.31 4.02-3.2.054-.529.013-1.524-.822-2.3l2.325 0c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5"],"text-table_16":["M11 5.6665l0-2.667 3 0c.552 0 1 .449 1 1l0 1.667-4 0zm0 3.667l4 0 0-2.667-4 0 0 2.667zm4 2.666c0 .552-.448 1-1 1l-3 0 0-2.666 4 0 0 1.666zm-14 0l0-1.666 4 0 0 2.666-3 0c-.552 0-1-.448-1-1zm0-2.666l4 0 0-2.667-4 0 0 2.667zm0-5.334c0-.551.448-1 1-1l3 0 0 2.667-4 0 0-1.667zm5 9l4 0 0-2.667-4 0 0 2.667zm0-3.666l4 0 0-2.667-4 0 0 2.667zm0-3.667l4 0 0-2.667-4 0 0 2.667zm8-3.667l-3 0-1 0-4 0-1 0-3 0c-1.104 0-2 .896-2 2l0 1.667 0 1 0 2.667 0 1 0 1.666c0 1.106.896 2 2 2l12 0c1.104 0 2-.894 2-2l0-1.666 0-1 0-2.667 0-1 0-1.667c0-1.104-.896-2-2-2z"],"text-underline_12":["M9.5 10c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-7 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l7 0zm0-9c.276 0 .5.224.5.5L10 5c0 2.206-1.794 4-4 4-2.206 0-4-1.794-4-4l0-3.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5L3 5c0 1.654 1.346 3 3 3 1.654 0 3-1.346 3-3l0-3.5c0-.276.224-.5.5-.5z"],"text-underline_16":["M13.5 13c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-11 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l11 0zM13 7c0 2.757-2.243 5-5 5-2.757 0-5-2.243-5-5l0-4.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5L4 7c0 2.206 1.794 4 4 4 2.206 0 4-1.794 4-4l0-4.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5L13 7z"],"too-fast_12":["M6.5 5.9995c0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5 0 .276.224.5.5.5.276 0 .5-.224.5-.5m-2 0c0 .827.673 1.5 1.5 1.5.827 0 1.5-.673 1.5-1.5 0-.231-.057-.447-.15-.643l.504-.503c.195-.196.195-.512 0-.708-.196-.195-.512-.195-.708 0l-.503.504c-.196-.093-.412-.15-.643-.15-.827 0-1.5.673-1.5 1.5zM6 0C2.691 0 0 2.691 0 6c0 3.308 2.691 6 6 6 .276 0 .5-.224.5-.5 0-.277-.224-.5-.5-.5-2.757 0-5-2.244-5-5 0-2.757 2.243-5 5-5 2.757 0 5 2.243 5 5 0 1.095-.358 2.123-1 2.98l0-.48c0-.277-.224-.5-.5-.5-.276 0-.5.223-.5.5l0 2c0 .276.224.5.5.5l2 0c.276 0 .5-.224.5-.5 0-.277-.224-.5-.5-.5l-1.033 0C11.457 8.899 12 7.499 12 6c0-3.309-2.691-6-6-6zm-.5 2.4995c0 .276.224.5.5.5.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5zm2 .5c0 .276.224.5.5.5.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5zm-4 0c0 .276.224.5.5.5.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5z"],"too-fast_16":["M7.9998 0c4.411 0 8 3.589 8 8 0 2.332-.992 4.481-2.727 6l2.227 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-3 0c-.274 0-.5-.225-.5-.5l0-3c0-.275.226-.5.5-.5.275 0 .5.225.5.5l0 1.388c1.277-1.3 2-3.028 2-4.888 0-3.859-3.141-7-7-7-3.859 0-7 3.141-7 7 0 3.859 3.141 7 7 7 .276 0 .5.224.5.5 0 .276-.224.5-.5.5-4.411 0-8-3.589-8-8 0-4.411 3.589-8 8-8zm-.5 3.5c0-.276.225-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.275 0-.5-.224-.5-.5zm2.7314 1.1807c-.229-.154-.29-.465-.136-.694.155-.23.465-.29.694-.136.229.153.291.465.136.693-.154.23-.465.29-.694.137zM5.072 4.5469c-.154-.229-.094-.54.136-.694.228-.155.54-.094.693.135.154.229.094.539-.135.694-.229.154-.54.094-.694-.135zM7.9998 10c-1.104 0-2-.896-2-2 0-1.104.896-2 2-2 .37 0 .713.107 1.011.283l.635-.637c.196-.195.512-.195.708 0 .195.196.195.512 0 .708l-.636.636c.175.297.282.64.282 1.01 0 1.104-.896 2-2 2zm0-1c.552 0 1-.448 1-1 0-.552-.448-1-1-1-.551 0-1 .448-1 1 0 .552.449 1 1 1z"],"too-slow_12":["M5.5 5.9995c0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5m2 0c0 .827-.673 1.5-1.5 1.5-.827 0-1.5-.673-1.5-1.5 0-.231.057-.447.15-.643l-.504-.503c-.195-.196-.195-.512 0-.708.196-.195.512-.195.708 0l.503.504c.196-.093.412-.15.643-.15.827 0 1.5.673 1.5 1.5zM6 0c3.309 0 6 2.691 6 6 0 3.308-2.691 6-6 6-.276 0-.5-.224-.5-.5 0-.277.224-.5.5-.5 2.757 0 5-2.244 5-5 0-2.757-2.243-5-5-5-2.757 0-5 2.243-5 5 0 1.095.358 2.123 1 2.98l0-.48c0-.277.224-.5.5-.5.276 0 .5.223.5.5l0 2c0 .276-.224.5-.5.5l-2 0c-.276 0-.5-.224-.5-.5 0-.277.224-.5.5-.5l1.033 0C.543 8.899 0 7.499 0 6c0-3.309 2.691-6 6-6zm.5 2.4995c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5zm-2 .5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5zm4 0c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5z"],"too-slow_16":["M7.9999 0c4.411 0 8 3.589 8 8 0 4.411-3.589 8-8 8-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5 3.859 0 7-3.141 7-7 0-3.859-3.141-7-7-7-3.859 0-7 3.141-7 7 0 1.86.724 3.588 2 4.888l0-1.388c0-.275.225-.5.5-.5.275 0 .5.225.5.5l0 3c0 .275-.225.5-.5.5l-3 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l2.228 0c-1.736-1.519-2.728-3.668-2.728-6 0-4.411 3.589-8 8-8zm.5 3.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5zM5.7684 4.6807c-.229.153-.54.093-.693-.137-.155-.228-.094-.54.135-.693.23-.154.54-.094.694.136.154.229.093.54-.136.694zm5.1592-.1338c-.154.229-.465.289-.693.135-.23-.155-.29-.465-.136-.694.154-.229.465-.29.694-.135.229.154.289.465.135.694zM9.9999 8c0 1.104-.896 2-2 2-1.104 0-2-.896-2-2 0-.37.107-.713.283-1.01l-.637-.636c-.195-.196-.195-.512 0-.708.196-.195.512-.195.708 0l.636.637c.297-.176.64-.283 1.01-.283 1.104 0 2 .896 2 2zm-3 0c0 .552.449 1 1 1 .552 0 1-.448 1-1 0-.552-.448-1-1-1-.551 0-1 .448-1 1z"],"tools_16":["M14.7620217 14.7589c-.3205466.321-.8438066.322-1.1653518 0l-7.83791442-7.838c-.09586441-.096-.22368363-.146-.35350003-.146-.06490819 0-.13081498.012-.193726.039-1.14637862.483-2.4495355.231-3.32429828-.644-.68602971-.686-.990598941-1.636-.8567882-2.564l1.52883769 1.529c.36748025.367.96363708.366 1.32912016 0l1.24723597-1.248c.17874719-.177.27660878-.414.27660878-.666 0-.251-.09786159-.488-.27561019-.666l-1.52584193-1.525c1.05950149-.149 2.14696344.278 2.82800022 1.157.6540749.846.79687294 2.002.37247319 3.017-.07888843.187-.03594916.404.10784746.547l7.84290738 7.844c.1547811.154.239661.361.239661.582 0 .221-.0848799.427-.239661.582zm-2.2967516-13.325c.5791808-.58 1.5218476-.58 2.1010284 0 .2806031.281.4353842.654.4353842 1.05 0 .397-.1547811.77-.4353842 1.05l-4.2260229 4.225-.69601559-.696 4.21204269-4.21c.1957232-.196.1957232-.512.0009986-.707-.1947246-.197-.5102783-.196-.7060015-.001l-4.21403984 4.211-.69701418-.697 4.22502432-4.225zM2.03202638 14.5019l-.77690119.389-.11483757-.115.38845059-.776.77690119-.388.11483758.114-.3884506.776zm13.43599682-1.615l-4.419749-4.42L15.2723 4.2419c.4693362-.47.7279704-1.094.7279704-1.758 0-.664-.2586342-1.288-.7279704-1.758-.96863-.968-2.5444013-.967-3.5130314 0l-3.74070928 3.741c.11583617-1.026-.15278391-2.068-.79088141-2.892C6.1042668.1229 4.14503784-.3951 2.4594219.3189c-.1537825.065-.26362714.202-.29558195.365-.0319548.163.01897317.332.13680651.45l2.12998745 2.045-1.16635037 1.248-2.12998745-2.129c-.11683476-.118-.28459748-.17-.448365854-.137-.162769786.032-.299576294.142-.363485903.295-.643090444 1.521-.3065664076 3.256.858785377 4.422 1.08346759 1.082 2.66023749 1.449 4.0982037.977l1.07947324 1.079-3.6777983 3.677c-.14779097-.103-.33452686-.137-.50029241-.055l-1.247235968.624c-.096863001.048-.174752838.126-.223683632.223l-.6241172793 1.248c-.0958644141.192-.0579180835.425.0938672383.578l.624117279.624c.095864414.095.223683632.146.352501442.146.07689125 0 .15278391-.017.22368363-.053l1.24823456-.624c.09586441-.048.17375425-.127.22268504-.224l.62411728-1.247c.08987289-.18.05292515-.392-.07589266-.543l3.66681384-3.667 5.82376319 5.825c.3554972.356.8228362.534 1.2901752.534.4663404 0 .9326809-.178 1.2881781-.533.3435141-.344.5322472-.802.5322472-1.29 0-.488-.1887331-.946-.5322472-1.29z"],"tools_24":["M22.5538525 22.5538795c-.5968545.5950496-1.5666181.5960497-2.1634727 0L8.37430878 10.5338778c-.09497685-.0950079-.22294566-.1460121-.35291398-.1460121-.06598391 0-.13196783.013001-.19495248.0390032-1.85454795.7830653-3.96803279.3750313-5.38568723-1.044087C1.20305678 8.14567881.732171557 6.38053171 1.14906994 4.72139345l2.69534301 2.69622468c.4438918.44503709 1.21970269.44703726 1.66359449 0L7.42154102 5.5044587c.45788839-.45903825.45788839-1.20510042 0-1.66413867L4.72619801 1.14509542c1.86754478-.465038749 3.87605521.21201767 5.08775985 1.77814818 1.06274094 1.37211435 1.29468444 3.24727061.60685204 4.8924077-.077981.18701559-.0359912.40303359.1079737.54704559L22.5538525 20.3906992c.2869301.2870239.4448916.6710559.4448916 1.0820902 0 .4100342-.1579615.7940662-.4448916 1.0810901zM18.6568024 1.74214518c.9917583-.992082675 2.6053649-.992082675 3.5971232 0 .4808828.48104009.7448185 1.12009334.7448185 1.79914993 0 .68005667-.2639357 1.31910992-.7448185 1.79914993l-6.6663751 6.66855576-1.4456476-1.4461206 6.3284575-6.32852734c.1949524-.19601633.1949524-.51204267 0-.70705892-.1949525-.19601633-.5118753-.19601633-.7068278 0l-6.3284574 6.32852738-1.4446479-1.44612051 6.6663751-6.66755563zM3.04760717 22.1688474l-1.4416486.7220602-.44689107-.4470373.7208243-1.4421202 1.4416486-.72106.44689107.4470372-.7208243 1.4411201zm20.21307303-2.4852071l-6.9653022-6.9685807 6.6653753-6.66755564c.6698367-.66905576 1.0377471-1.55912993 1.0377471-2.50620885 0-.94607884-.3679104-1.8371531-1.0377471-2.50620885-1.3816632-1.380115012-3.6301151-1.380115012-5.0107786 0l-6.3394548 6.33952829c.4538894-1.75814651.1009754-3.63330277-1.0057548-5.06242187C8.95516719.180015001 6.07786854-.582048504 3.6074707.468039003c-.15296272.064005334-.26393567.201016752-.29592787.364030336-.03099244.163013585.01999513.332027671.13796637.449037421l3.26420435 3.26627219c.06898319.06800567.06898319.18201517.00099976.25002083L4.80117973 6.71055921c-.09097782.0900075-.15996101.0900075-.24893932 0l-3.2652041-3.2652721c-.11797125-.11900992-.28693006-.168014-.449890341-.1380115-.162960278.03200266-.298927136.14301191-.363911296.29602467C-.471535038 5.83348612.0233443345 8.37969831 1.73392738 10.0898408c1.62560376 1.6281357 4.01202206 2.1531795 6.1644974 1.3821152l1.96052212 1.9611634-5.98454127 5.9854988-.10097538-.1000083c-.15196296-.1520127-.38490618-.1890158-.57685939-.0940078l-1.91253382.9570797c-.09697636.0490041-.17595711.1270106-.22394541.2240187l-.956766791 1.9131594c-.0959766055.192016-.0589856221.4240353.093977093.5770481l.956766788.9570797c.0959766.096008.22394541.1460122.35291398.1460122.07598148 0 .15296271-.0170014.22394541-.0520043l1.91253382-.9570798c.09697636-.0490041.17595711-.1270106.22394541-.2240186l.95676679-1.9131595c.0959766-.1930161.05798586-.4250354-.0939771-.5770481l-.14996344-.1500125 5.98554101-5.9854988 9.1177775 9.1207601C20.1774318 23.7539795 20.8252738 24 21.4721162 24c.6478421 0 1.2956841-.2460205 1.788564-.7390616.9857597-.9860822.9857597-2.5912159 0-3.5772981z"],"tools_32":["M30.2920956 30.3471033c-.8714206.8719455-2.2908479.8709456-3.1622684 0L11.7976168 14.9570652c-.0958263-.0949941-.2235947-.1459909-.3533595-.1459909-.0688752 0-.1387485.0149991-.2056273.0449972-.9392975.4259734-1.94547385.6409599-2.98858321.6409599-3.99875226 0-7.251856011-3.2517967-7.251856011-7.24854693 0-.7919505.124773851-1.56190238.372325161-2.29985626l3.94285358 3.93875383c.54800674.54496596 1.44238567.54796576 1.99538337-.00099994l2.57732859-2.57783888c.26651692-.26698332.41524732-.62096119.41524732-.99893757 0-.37797638-.1487304-.73195425-.41424913-.99793763L5.94722066 1.37191426c.73866118-.24698457 1.50926446-.371976756 2.30282613-.371976756 3.99875231 0 7.25285421 3.251796766 7.25285421 7.248546966 0 1.03893507-.2166074 2.04487223-.6428349 2.98881323-.0858444.1889882-.0459167.4119742.1018155.558965l15.330214 15.3910381c.4212365.4189738.6518186.9799387.6518186 1.5789013 0 .5999625-.2305821 1.1609275-.6518186 1.5809012zM24.8429721 2.05387163c1.4054526-1.403912252 3.6953023-1.40491219 5.1027513.00099994.6807661.6799575 1.0560858 1.58390101 1.0560858 2.54684082 0 .96193988-.3753197 1.86588339-1.057084 2.54584089l-9.1224655 9.11543032-2.2139872-2.2228611 9.1953335-9.18742579c.1946472-.19498782.1946472-.51196801.0009982-.70795576-.1966436-.19498781-.5120719-.19398787-.7067191-.00099993l-9.1963317 9.18842568-1.9953833-2.0038747c.0698733-.1729892.1267702-.3509781.1836671-.528967l8.7531349-8.74545337zM4.11454239 29.8301356L1.90354982 30.896069l-.77259967-.7399538 1.13893568-2.1518655 2.11616445-1.0569339.78058519.7799512-1.05209308 2.1028686zM21.5279805 16.9719393l9.1214674-9.11543033C31.5198702 6.98756328 32 5.83063559 32 4.60171239c0-1.23092306-.4801298-2.38685082-1.3495539-3.25479657-1.7967434-1.794887822-4.7174497-1.793887884-6.5131949-.00099994l-7.6730925 7.66552091c.0239566-.25198426.0369331-.50696832.0369331-.76295232C16.5010918 3.7007687 12.7998004 0 8.25004679 0 7.06319795 0 5.92026951.245984626 4.850209.731954253c-.14972862.066995813-.25653503.203987251-.28548257.364977187-.02994572.16198988.0219602.3279795.13775033.44297232l4.47988022 4.47972001c.07785888.07699519.12078108.18098869.12078108.28998188 0 .10899319-.0429222.21298669-.12177927.29098181L6.6040302 9.17842635c-.1627051.16198987-.42522928.16198987-.5849398 0L1.53821199 4.70270608c-.11579013-.11599275-.28049161-.16298981-.44219851-.13799137-.16070872.02899818-.297460857.13699143-.364339639.28598212C.245554932 5.9216299 0 7.0655584 0 8.24848447c0 4.54871573 3.70029322 8.24848443 8.25004679 8.24848443 1.06906232 0 2.10318801-.1999875 3.08041671-.5939628l2.0542767 2.0608712-8.28697989 8.2804824-.26052779-.2589838c-.15272319-.1519905-.38430345-.1899881-.57595608-.0939941l-2.58132136 1.2899194c-.09283174.046997-.16869424.1209924-.21760559.2129867L.0728679269 30.0221236c-.1058082226.1979876-.0658805915.4409725.0948281241.5959628l1.295651629 1.2399225c.09582632.0909943.21960197.1379913.34537401.1379913.07286793 0 .14673405-.015999.2166074-.0489969l2.67515129-1.2889194c.09981908-.047997.18067253-.1269921.23058207-.2269858l1.28966249-2.5788389c.09582631-.1929879.05789506-.4249734-.09382994-.5769639l-.32341381-.3239798L14.090461 18.671833l12.3336453 12.3822261C27.0549629 31.6850197 27.882463 32 28.7109614 32c.8275001 0 1.6559985-.3149803 2.2868551-.9449409.6088963-.608962.9442884-1.4219112.9442884-2.288857 0-.8659459-.3353921-1.6788951-.9442884-2.2868571l-9.469836-9.5074057z"],"touch_16":["M3.1775 9.8083c-.081.259-.134.526-.161.797-.105 1.082.28 2.193 1.056 3.049.775.854 1.84 1.343 2.924 1.344.878-.01 1.71-.421 2.328-1.13l2.447-2.806c.368-.487.319-1.22-.137-1.677-1.243-1.248-2.402-2.417-2.592-2.614-.185-.192-.188-.494-.007-.689l3.775-4.045c.126-.125.188-.277.188-.438-.001-.161-.064-.312-.178-.424-.24-.237-.629-.236-.867.002l-5.302 5.57c-.154.162-.396.201-.593.099-.197-.103-.303-.324-.259-.542l.401-2.002c.098-.488-.199-1.11-.599-1.256l-2.404 6.716c-.006.016-.013.031-.02.046m3.876 6.189c-1.422 0-2.758-.609-3.722-1.671-.965-1.065-1.442-2.456-1.31-3.817.035-.366.112-.728.227-1.077.009-.027.02-.053.033-.078l2.452-6.709c.206-.487.734-.713 1.212-.539.955.35 1.41 1.519 1.235 2.392l-.061.307 4.119-4.327c.633-.634 1.654-.636 2.284-.015.305.301.474.703.476 1.133.001.43-.165.833-.468 1.136l-3.436 3.682c.468.475 1.336 1.349 2.249 2.265.805.809.893 2.105.203 3.014l-2.468 2.832c-.806.924-1.908 1.46-3.025 1.472"],"touch10_24":["M21.5000521 3C22.8780234 3 24 4.121 24 5.5l0 13c0 1.379-1.1219766 2.5-2.4999479 2.5L2.50044792 21C1.12247663 21 .0005 19.879.0005 18.5l0-13c0-1.379 1.12197663-2.5 2.49994792-2.5L21.5000521 3zm1.4999687 13l0-10.5c0-.827-.6729859-1.5-1.4999687-1.5L2.50044792 4c-.82698277 0-1.49996875.673-1.49996875 1.5l0 10.5 21.99954163 0zm0 2.5l0-1.5-21.99954163 0 0 1.5c0 .827.67298598 1.5 1.49996875 1.5l18.99960418 0c.8269828 0 1.4999687-.673 1.4999687-1.5zm-5.4998854.5c-.2749943 0-.4999896-.225-.4999896-.5 0-.275.2249953-.5.4999896-.5l3.9999167 0c.2749943 0 .4999896.225.4999896.5 0 .275-.2249953.5-.4999896.5l-3.9999167 0z"],"transcript_16":["M.5 1l15 0c.2761424 0 .5.223857625.5.5 0 .276142375-.2238576.5-.5.5L.5 2C.223857625 2 0 1.776142375 0 1.5c0-.276142375.223857625-.5.5-.5zm0 3.25l15 0c.2761424 0 .5.22385763.5.5 0 .27614237-.2238576.5-.5.5l-15 0c-.276142375 0-.5-.22385763-.5-.5 0-.27614237.223857625-.5.5-.5zm0 3.25l15 0c.2761424 0 .5.22385763.5.5 0 .27614237-.2238576.5-.5.5l-15 0C.223857625 8.5 0 8.27614237 0 8c0-.27614237.223857625-.5.5-.5zm0 3.25l15 0c.2761424 0 .5.22385763.5.5 0 .2761424-.2238576.5-.5.5l-15 0c-.276142375 0-.5-.2238576-.5-.5 0-.27614237.223857625-.5.5-.5zM.5 14l7 0c.27614237 0 .5.2238576.5.5 0 .2761424-.22385763.5-.5.5l-7 0c-.276142375 0-.5-.2238576-.5-.5 0-.2761424.223857625-.5.5-.5z"],"twitter_16":["M13.8711 4.9883c.192 4.261-2.986 9.012-8.61 9.012-1.71 0-3.303-.503-4.644-1.362 1.608.19 3.212-.256 4.485-1.254-1.326-.024-2.445-.9-2.83-2.104.474.09.941.064 1.368-.052-1.457-.292-2.461-1.605-2.43-3.009.409.227.877.364 1.373.38-1.35-.902-1.732-2.683-.937-4.046 1.494 1.834 3.726 3.04 6.244 3.166-.442-1.895.995-3.719 2.95-3.719.872 0 1.659.367 2.211.957.69-.137 1.339-.389 1.924-.736-.227.707-.707 1.302-1.332 1.676.613-.073 1.196-.237 1.74-.477-.406.608-.92 1.141-1.512 1.568"],"twitter-circle_24":["M17.251 10.197c.474-.341.885-.768 1.209-1.255-.434.193-.901.323-1.392.382.501-.299.885-.774 1.066-1.341-.468.277-.987.48-1.539.589-.442-.472-1.072-.766-1.769-.766-1.565 0-2.715 1.46-2.362 2.976-2.014-.101-3.8-1.066-4.996-2.533-.635 1.09-.329 2.516.75 3.237-.397-.013-.771-.122-1.098-.304-.026 1.124.778 2.174 1.944 2.408-.341.093-.714.114-1.094.042.308.963 1.203 1.663 2.264 1.683-1.019.799-2.302 1.155-3.588 1.004 1.072.688 2.346 1.089 3.715 1.089 4.501 0 7.043-3.801 6.89-7.211zM12 0c6.627 0 12 5.373 12 12 0 6.628-5.373 12-12 12-6.628 0-12-5.372-12-12C0 5.373 5.372 0 12 0z"],"twitter-circle_32":["M23.002 13.596c.631-.455 1.18-1.024 1.613-1.673-.58.257-1.203.431-1.856.509.667-.399 1.179-1.033 1.42-1.788-.624.37-1.316.639-2.052.785-.589-.629-1.429-1.021-2.359-1.021-2.086 0-3.619 1.947-3.148 3.968-2.686-.134-5.068-1.421-6.661-3.377-.848 1.453-.44 3.354 1 4.316-.53-.017-1.029-.163-1.465-.405-.034 1.498 1.038 2.898 2.592 3.21-.455.124-.953.152-1.459.056.411 1.284 1.605 2.218 3.02 2.244-1.359 1.065-3.071 1.541-4.786 1.338 1.431.917 3.13 1.453 4.954 1.453 6.001 0 9.392-5.069 9.187-9.615zM16 0c8.836 0 16 7.163 16 16 0 8.837-7.164 16-16 16-8.837 0-16-7.163-16-16C0 7.163 7.163 0 16 0z"],"twitter-circle_40":["M28.753 16.995c.789-.569 1.474-1.28 2.016-2.091-.725.321-1.504.538-2.321.636.834-.499 1.475-1.291 1.776-2.235-.781.463-1.645.799-2.565.981-.737-.786-1.787-1.276-2.949-1.276-2.607 0-4.524 2.433-3.935 4.961-3.358-.169-6.335-1.777-8.327-4.222-1.058 1.816-.549 4.192 1.25 5.394-.662-.021-1.286-.203-1.83-.505-.044 1.872 1.297 3.622 3.24 4.012-.569.155-1.191.19-1.824.069.513 1.606 2.006 2.773 3.774 2.806-1.699 1.332-3.838 1.926-5.981 1.673 1.788 1.146 3.911 1.815 6.193 1.815 7.501 0 11.738-6.335 11.483-12.018zM20 0c11.045 0 20 8.954 20 20 0 11.047-8.955 20-20 20C8.954 40 0 31.047 0 20 0 8.954 8.954 0 20 0z"],"undo_12":["M6 1c-1.613 0-3.073.765-4 2.013L2 1.5c0-.276-.224-.5-.5-.5-.276 0-.5.224-.5.5l0 3c0 .276.224.5.5.5l3 0c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5L2.536 4C3.243 2.77 4.547 2 6 2c2.206 0 4 1.794 4 4 0 2.206-1.794 4-4 4-.276 0-.5.224-.5.5 0 .276.224.5.5.5 2.757 0 5-2.243 5-5 0-2.757-2.243-5-5-5"],"undo_14":["M1.5 1c.276 0 .5.224.5.5l0 2.199C3.087 2.043 4.933 1 7 1c3.309 0 6 2.691 6 6 0 3.309-2.691 6-6 6-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5 2.757 0 5-2.243 5-5 0-2.757-2.243-5-5-5-2.018 0-3.782 1.189-4.57 3L5.5 5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5L1.617 6 1.5 6c-.276 0-.5-.224-.5-.5l0-4c0-.276.224-.5.5-.5"],"undo_16":["M1.5 1c.275 0 .5.225.5.5l0 2.938C3.243 2.342 5.49 1 8 1c3.86 0 7 3.141 7 7 0 3.859-3.14 7-7 7-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5 3.309 0 6-2.691 6-6 0-3.309-2.691-6-6-6-2.547 0-4.788 1.604-5.643 4L6.5 6c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-5 0c-.275 0-.5-.225-.5-.5l0-5c0-.275.225-.5.5-.5"],"unread-badge_10":["M0,5a5,5 0 1,0 10,0a5,5 0 1,0 -10,0"],"unread-badge_12":["M0,6a6,6 0 1,0 12,0a6,6 0 1,0 -12,0"],"unread-badge_16":["M0,8a8,8 0 1,0 16,0a8,8 0 1,0 -16,0"],"unread-badge_8":["M0,4a4,4 0 1,0 8,0a4,4 0 1,0 -8,0"],"unsecure_12":["M3.0001 4.0003l1 0 0-.0003 5.5 0c.829 0 1.5.671 1.5 1.5l0 5c0 .829-.671 1.5-1.5 1.5l-7 0c-.828 0-1.5-.671-1.5-1.5l0-5c0-.829.672-1.5 1.5-1.5l.5 0 0 .0003zm.19700241.67867832C3.28119438 4.74316549 3.38622086 4.7813 3.5001 4.7813c.11387914 0 .21890562-.03813451.30299759-.10232168C3.71900562 4.74303573 3.61397914 4.781 3.5001 4.781c-.11387914 0-.21890562-.03796427-.30299759-.10202168zM10.0001 10.5l0-5c0-.276-.224-.5-.5-.5l-7 0c-.275 0-.5.224-.5.5l0 5c0 .276.225.5.5.5l7 0c.276 0 .5-.224.5-.5zm-2.5-3c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-3 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l3 0zm-3.5-4.5l0 1-1 0 0-1c0-1.654 1.346-3 3-3 1.186 0 2.264.704 2.746 1.793.111.253-.003.548-.256.66-.253.113-.547-.003-.659-.255C7.5091 1.47 6.7911 1 6.0001 1c-1.103 0-2 .897-2 2zm-1 1.0003l0 .281c0 .16212086.07728722.30630005.19700241.39767832C3.07738722 4.58778477 3.0001 4.44370826 3.0001 4.281l0-.2807zm.80299759.67867832C3.92281278 4.58760005 4.0001 4.44342086 4.0001 4.2813l0-.281 0 .2807c0 .16270826-.07728722.30678477-.19700241.39797832z"],"unsecure_16":["M12 6c1.104 0 2 .896 2 2l0 6c0 1.104-.896 2-2 2l-8 0c-1.104 0-2-.896-2-2l0-6c0-1.104.896-2 2-2l0-2c0-2.206 1.794-4 4-4 1.751 0 3.327 1.174 3.833 2.856.079.265-.071.543-.335.623-.269.078-.544-.071-.623-.335C10.496 1.881 9.313 1 8 1 6.346 1 5 2.346 5 4l0 2 7 0zm1 8l0-6c0-.551-.449-1-1-1L4 7c-.551 0-1 .449-1 1l0 6c0 .551.449 1 1 1l8 0c.551 0 1-.449 1-1zm-3.5-3.5c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-3 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l3 0z"],"unsecure_24":["M18.541 9C19.897 9 21 10.103 21 11.459l0 10.082C21 22.897 19.897 24 18.541 24L5.459 24C4.103 24 3 22.897 3 21.541l0-10.082C3 10.103 4.103 9 5.459 9L6 9l0-3c0-3.309 2.691-6 6-6 2.443 0 4.688 1.534 5.587 3.817.101.257-.025.547-.282.648-.257.1-.547-.025-.649-.282C15.907 2.279 14.036 1 12 1 9.243 1 7 3.243 7 6l0 3 11.541 0zM20 21.541l0-10.082c0-.805-.654-1.459-1.459-1.459L5.459 10C4.654 10 4 10.654 4 11.459l0 10.082C4 22.346 4.654 23 5.459 23l13.082 0c.805 0 1.459-.654 1.459-1.459zM15.5 16c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-7 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l7 0z"],"unsecure_28":["M22.015 9.9997c1.646 0 2.985 1.34 2.985 2.986l0 12.029c0 1.646-1.339 2.985-2.985 2.985l-16.03 0c-1.646 0-2.985-1.339-2.985-2.985l0-12.029c0-1.646 1.339-2.986 2.985-2.986l1.015 0 0-3c0-3.86 3.14-7 7-7 3.039 0 5.714 1.948 6.659 4.846.085.262-.058.544-.321.63-.262.083-.546-.058-.63-.321-.81-2.485-3.104-4.155-5.708-4.155-3.309 0-6 2.692-6 6l0 3 14.015 0zM24 25.0147l0-12.029c0-1.095-.891-1.986-1.985-1.986l-16.03 0c-1.094 0-1.985.891-1.985 1.986l0 12.029c0 1.095.891 1.985 1.985 1.985l16.03 0c1.094 0 1.985-.89 1.985-1.985zM18.5 18.5c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-9 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l9 0z"],"upload_12":["M5.65225 3.146l-3.006 3.006c-.195.195-.195.512 0 .707.195.195.512.195.707 0l2.153-2.152 0 5.793c0 .276.223.5.5.5.276 0 .5-.224.5-.5l0-5.793 2.167 2.168c.196.195.512.195.708 0 .195-.196.195-.512 0-.708l-3.022-3.021c-.098-.098-.226-.146-.353-.146-.128 0-.256.048-.354.146zM1.5 2l9 0c.27614237 0 .5-.22385763.5-.5 0-.27614237-.22385763-.5-.5-.5l-9 0c-.276142375 0-.5.22385763-.5.5 0 .27614237.223857625.5.5.5z"],"upload_14":["M6.64725 3.1455l-4.001 4.002c-.195.195-.195.512 0 .707.195.195.512.195.707 0l3.147-3.147 0 7.792c0 .276.223.5.5.5.275 0 .5-.224.5-.5l0-7.794 3.147 3.148c.195.195.511.195.707 0 .195-.195.195-.512 0-.707l-3.999-4.001c-.098-.098-.227-.146-.354-.146-.128 0-.256.048-.354.146zM1.545458678 2L12.4535413 2c.3010932 0 .5454587-.224.5454587-.5 0-.276-.2443655-.5-.5454587-.5L1.545458678 1C1.244365488 1 1 1.224 1 1.5c0 .276.244365488.5.545458678.5z"],"upload_16":["M7.646 4.147L3.647 8.146c-.196.196-.196.512 0 .707.195.196.511.196.707 0L7.5 5.707l0 8.793c0 .276.224.5.5.5.276 0 .5-.224.5-.5l0-8.793 3.147 3.146c.195.196.511.196.707 0 .195-.195.195-.511 0-.707l-4-3.999c-.046-.046-.101-.083-.163-.109C8.13 4.013 8.065 4 8 4c-.065 0-.13.013-.191.038-.061.026-.117.063-.163.109zm6.8155385-2.1471c.2972307 0 .5384615-.224.5384615-.5 0-.276-.2412308-.5-.5384615-.5l-12.923076962 0C1.241230769.9999 1 1.2239 1 1.4999c0 .276.241230769.5.538461538.5l12.923076962 0z"],"upload_18":["M8.64425 5.1484l-4.998 4.999c-.195.195-.195.512 0 .707.196.195.512.195.707 0l4.146-4.146 0 8.792c0 .276.224.5.5.5.276 0 .5-.224.5-.5l0-8.793 4.149 4.147c.195.195.512.195.707 0 .195-.195.195-.512 0-.707l-5.001-4.999c-.046-.047-.103-.084-.165-.11-.03-.012-.062-.013-.093-.019-.033-.007-.062-.019-.097-.019-.034 0-.064.012-.096.019-.031.006-.063.007-.093.019-.063.026-.119.063-.166.11zM16.4666667 3C16.7610667 3 17 2.776 17 2.5c0-.276-.2389333-.5-.5333333-.5L1.533333333 2C1.238933333 2 1 2.224 1 2.5c0 .276.238933333.5.533333333.5L16.4666667 3z"],"upload_20":["M5.35325 10.87820955l4.146-4.16385655 0 10.783243534c0 .277188713.224.502153466.5.502153466.277 0 .5-.224964753.5-.502153466l0-10.783243534 4.147 4.16385655c.098.09842208.226.14662881.353.14662881.128 0 .256-.04820673.354-.14662881.195-.19583985.195-.51420515 0-.710045l-4.999-5.02053035c-.047-.0472024-.102-.0843618-.164-.1094695-.122-.0512196-.259-.0512196-.381 0-.062.0251077-.117.0622671-.164.1094695l-4.999 5.02053035c-.195.19583985-.195.51420515 0 .710045.195.19583985.512.19583985.707 0zM17.4666667 2.99975c.2944 0 .5333333-.223944.5333333-.499875C18 2.223944 17.7610667 2 17.4666667 2L2.533333333 2C2.238933333 2 2 2.223944 2 2.499875c0 .275931.238933333.499875.533333333.499875l14.933333367 0z"],"upload_24":["M11.65179795 6.1471l-5.99489823 5.999c-.19586599.196-.19586599.512 0 .707.19486667.196.51065061.196.70651659 0l5.14248146-5.146 0 13.793c0 .276.22384684.5.49965813.5.2758113 0 .4996581-.224.4996581-.5l0-13.793 5.1434808 5.146c.1948667.196.5106506.196.7065166 0 .1948667-.195.1948667-.511 0-.707l-5.9958975-5.999c-.0459686-.046-.100931-.083-.1628886-.109-.0609583-.025-.1259138-.038-.1908694-.038-.06495556 0-.12991111.013-.1908694.038-.0609583.026-.11692001.063-.16288855.109zM21.4739441 3c.2903276 0 .5259559-.224.5259559-.5 0-.276-.2356283-.5-.5259559-.5L2.525855925 2C2.235528254 2 1.9999 2.224 1.9999 2.5c0 .276.235628254.5.525955925.5L21.4739441 3z"],"upload_28":["M7.35325 14.855l6.146-6.146-.002 15.791c0 .276.223.5.5.5.276 0 .5-.224.5-.5l.002-15.792 6.147 6.147c.098.098.226.146.353.146.128 0 .256-.048.354-.146.195-.195.195-.512 0-.707l-6.999-6.999c-.047-.047-.102-.084-.164-.109-.122-.051-.259-.051-.381 0-.062.025-.117.062-.164.109l-6.999 6.999c-.195.195-.195.512 0 .707.195.195.512.195.707 0zM24.4761905 4.00225c.2891428 0 .5238095-.224.5238095-.5 0-.276-.2346667-.5-.5238095-.5l-20.952380976 0C3.234666667 3.00225 3 3.22625 3 3.50225c0 .276.234666667.5.523809524.5l20.952380976 0z"],"upload_32":["M15.64625 8.1465l-8 8c-.195.195-.195.512 0 .707.196.195.512.195.707 0l7.147-7.146 0 18.793c0 .276.224.5.5.5.276 0 .5-.224.5-.5l0-18.793 7.146 7.146c.196.195.512.195.707 0 .196-.195.196-.512 0-.707l-7.999-8c-.047-.046-.102-.082-.163-.107-.061-.026-.126-.039-.191-.039-.065 0-.13.013-.191.039-.061.024-.117.061-.163.107zM29.4814815 4C29.7677037 4 30 3.776 30 3.5c0-.276-.2322963-.5-.5185185-.5L2.518518519 3C2.232296296 3 2 3.224 2 3.5c0 .276.232296296.5.518518519.5L29.4814815 4z"],"upload_36":["M18.354 9.1465l9 9c.195.195.195.512 0 .707-.098.098-.226.147-.354.147-.128 0-.256-.049-.354-.147l-8.146-8.146 0 21.793c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-21.793-8.146 8.146c-.196.195-.512.195-.708 0-.195-.195-.195-.512 0-.707l9-9c.046-.046.102-.083.163-.107.122-.051.26-.051.382 0 .061.025.117.061.163.107zM32.5 3c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-29 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l29 0z"],"usb_16":["M12.5205 4c-.276 0-.5.224-.5.5l0 .909c0 .394-.16.781-.439 1.06l-3.078 3.078 0-7.822 1.143 1.137c.099.098.227.147.354.147.128 0 .256-.049.353-.147.196-.195.196-.511 0-.707L8.3995.209C8.3095.085 8.1685 0 8.0035 0c-.004 0-.006.002-.01.002-.132-.003-.264.044-.364.144l-1.983 1.998c-.194.195-.194.512 0 .707.196.195.512.195.707 0l1.15-1.16 0 10.843-3.065-3.065c-.283-.283-.439-.659-.439-1.06l0-.909c0-.276-.223-.5-.5-.5-.276 0-.5.224-.5.5l0 .909c0 .668.26 1.295.732 1.767l3.632 3.632c.086.086.133.202.14.322l0 1.37c0 .276.224.5.5.5.21 0 .389-.13.463-.314.027-.062.044-.129.044-.202l0-4.322c0-.132.053-.261.146-.354l3.632-3.632c.472-.472.732-1.1.732-1.767l0-.909c0-.276-.224-.5-.5-.5"],"user_16":["M3.5029 13.3564c.42-.221.889-.356 1.389-.356l6.154 0c.517 0 .999.143 1.426.379-1.214 1.011-2.773 1.621-4.472 1.621-1.712 0-3.279-.62-4.497-1.644m.497-5.356c0-2.206 1.794-4 4-4 2.206 0 4 1.794 4 4 0 2.205-1.794 4-4 4-2.206 0-4-1.795-4-4m4-7c3.859 0 7 3.14 7 7 0 1.789-.681 3.418-1.789 4.657-.629-.412-1.369-.657-2.165-.657l-.073 0c1.223-.912 2.027-2.357 2.027-4 0-2.762-2.238-5-5-5-2.762 0-5 2.238-5 5 0 1.643.804 3.088 2.027 4l-.135 0c-.78 0-1.509.232-2.129.628-1.093-1.235-1.763-2.853-1.763-4.628 0-3.86 3.141-7 7-7m0-1c-4.418 0-8 3.582-8 8 0 4.418 3.582 8 8 8 4.418 0 8-3.582 8-8 0-4.418-3.582-8-8-8"],"user_20":["M3.9263 16.6221c.618-.392 1.342-.622 2.117-.622l7.914 0c.774 0 1.496.232 2.116.622-1.603 1.472-3.731 2.378-6.073 2.378-2.342 0-4.471-.907-6.074-2.378m6.074-1.622c-2.757 0-5-2.243-5-5 0-2.757 2.243-5 5-5 2.757 0 5 2.243 5 5 0 2.757-2.243 5-5 5m0-14c4.962 0 9 4.037 9 9 0 2.26-.844 4.323-2.225 5.905-.81-.562-1.775-.905-2.818-.905l-.648 0c1.62-1.076 2.691-2.914 2.691-5 0-3.309-2.692-6-6-6-3.309 0-6 2.691-6 6 0 2.086 1.071 3.924 2.69 5l-.647 0c-1.044 0-2.009.342-2.819.905-1.381-1.583-2.224-3.645-2.224-5.905 0-4.963 4.037-9 9-9m0-1c-5.523 0-10 4.477-10 10 0 5.523 4.477 10 10 10 5.523 0 10-4.477 10-10 0-5.523-4.477-10-10-10"],"user_24":["M12 23c-3.168 0-6.018-1.354-8.027-3.504C4.844 18.571 6.054 18 7.384 18l9.232 0c1.33 0 2.546.565 3.418 1.489C18.025 21.643 15.171 23 12 23m0-6c-3.308 0-6-2.692-6-6 0-3.309 2.692-6 6-6 3.309 0 6 2.691 6 6 0 3.308-2.691 6-6 6m0-16c6.065 0 11 4.935 11 11 0 2.538-.872 4.871-2.321 6.734C19.63 17.659 18.193 17 16.616 17l-1.029 0C17.627 15.775 19 13.547 19 11c0-3.86-3.14-7-7-7-3.859 0-7 3.14-7 7 0 2.547 1.373 4.775 3.414 6l-1.03 0c-1.577 0-3.017.656-4.065 1.731C1.871 16.868 1 14.536 1 12 1 5.935 5.935 1 12 1m0-1C5.383 0 0 5.383 0 12c0 6.617 5.383 12 12 12 6.617 0 12-5.383 12-12 0-6.617-5.383-12-12-12"],"user_56":["M28 55c-7.6 0-14.471-3.161-19.383-8.231l.144-.307C10.369 42.536 14.152 40 18.399 40l19.202 0c4.324 0 8.246 2.72 9.757 6.767.002.006.009.008.012.014C42.46 51.845 35.594 55 28 55m0-16c-7.72 0-14-6.28-14-14 0-7.72 6.28-14 14-14 7.72 0 14 6.28 14 14 0 7.72-6.28 14-14 14m0-38c14.888 0 27 12.112 27 27 0 6.903-2.607 13.207-6.885 17.985C46.346 41.791 42.183 39 37.601 39l-4.26 0C38.979 36.842 43 31.389 43 25c0-8.271-6.729-15-15-15-8.271 0-15 6.729-15 15 0 6.389 4.021 11.842 9.659 14l-4.26 0c-4.617 0-8.731 2.737-10.518 6.981C3.605 41.203 1 34.901 1 28 1 13.112 13.112 1 28 1m0-1C12.561 0 0 12.561 0 28c0 15.439 12.561 28 28 28 15.439 0 28-12.561 28-28C56 12.561 43.439 0 28 0"],"video-layout_12":["M7.33333333 8L4.66666667 8l0 2-1 0 0-2L1 8l0-1 10 0 0 1-2.66666667 0 0 2-1 0 0-2zM1.5 1l9 0c.8284271 0 1.5.671572875 1.5 1.5l0 7c0 .82842712-.6715729 1.5-1.5 1.5l-9 0C.671572875 11 0 10.32842712 0 9.5l0-7C0 1.671572875.671572875 1 1.5 1zm0 1c-.27614237 0-.5.22385763-.5.5l0 7c0 .27614237.22385763.5.5.5l9 0c.2761424 0 .5-.22385763.5-.5l0-7c0-.27614237-.2238576-.5-.5-.5l-9 0zM11 7l0 1 0-1zM1 8l0-1 0 1zm3.66666667 2l-1 0 1 0zm3.66666666 0l-1 0 1 0z"],"video-layout_16":["M15 9L1 9l0-5c0-.551.449-1 1-1l12 0c.551 0 1 .449 1 1l0 5zm0 3c0 .551-.449 1-1 1l-3 0 0-3 4 0 0 2zm-9 1l4 0 0-3-4 0 0 3zm-4 0c-.551 0-1-.449-1-1l0-2 4 0 0 3-3 0zM14 2L2 2C.895 2 0 2.895 0 4l0 8c0 1.105.895 2 2 2l12 0c1.105 0 2-.895 2-2l0-8c0-1.105-.895-2-2-2z"],"video-layout-auto_12":["M10.5 1c.828 0 1.5.672 1.5 1.5l0 7c0 .828-.672 1.5-1.5 1.5l-9 0C.672 11 0 10.328 0 9.5l0-7C0 1.672.672 1 1.5 1l9 0zm.5 8.5l0-7c0-.276-.224-.5-.5-.5l-9 0c-.276 0-.5.224-.5.5l0 7c0 .276.224.5.5.5l9 0c.276 0 .5-.224.5-.5zM7.6003 7.2002c.166-.221.479-.268.7-.1.221.165.266.479.1.7-.573.762-1.447 1.2-2.4 1.2-.754 0-1.46-.283-2-.766l0 .266c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-2c0-.276.225-.5.5-.5l2 0c.275 0 .5.224.5.5 0 .275-.225.5-.5.5l-1.209 0c.356.607.994 1 1.709 1 .635 0 1.218-.292 1.6-.8zM8.5 3c.275 0 .5.225.5.5l0 2c0 .275-.225.5-.5.5l-2 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1.209 0C7.353 4.393 6.715 4 6 4c-.635 0-1.219.292-1.6.8-.166.221-.479.267-.701.099-.22-.165-.265-.478-.099-.699C4.172 3.437 5.047 3 6 3c.753 0 1.46.283 2 .766L8 3.5c0-.275.225-.5.5-.5z"],"video-layout-auto_16":["M14 2c1.105 0 2 .895 2 2l0 8c0 1.105-.895 2-2 2L2 14c-1.105 0-2-.895-2-2l0-8c0-1.105.895-2 2-2l12 0zm1 10l0-8c0-.551-.449-1-1-1L2 3c-.551 0-1 .449-1 1l0 8c0 .551.449 1 1 1l12 0c.551 0 1-.449 1-1zM9.6006 9.2002c.165-.221.479-.267.699-.1.222.165.266.479.1.7-.564.752-1.461 1.2-2.4 1.2-.753 0-1.46-.282-2-.766l0 .266c0 .275-.224.5-.5.5-.275 0-.5-.225-.5-.5l0-2c0-.276.225-.5.5-.5l2 0c.276 0 .5.224.5.5 0 .275-.224.5-.5.5l-1.209 0c.357.606.994 1 1.709 1 .635 0 1.219-.292 1.601-.8zM10.5 5c.275 0 .5.225.5.5l0 2c0 .275-.225.5-.5.5l-2 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1.209 0C9.353 6.394 8.716 6 8 6c-.635 0-1.219.292-1.601.8-.165.221-.478.267-.699.099-.221-.165-.265-.478-.099-.699C6.164 5.448 7.062 5 8 5c.754 0 1.46.282 2 .766l0-.266c0-.275.225-.5.5-.5z"],"video-layout-auto_20":["M17.5 2C18.875 2 20 3.125 20 4.5l0 11c0 1.375-1.125 2.5-2.5 2.5l-15 0C1.127 18 .003 16.877 0 15.504l0-.004 0-11 0-.004C.003 3.123 1.127 2 2.5 2l15 0zM19 15.5l0-11c0-.827-.673-1.5-1.5-1.5l-15 0C1.673 3 1 3.673 1 4.5l0 11c0 .827.673 1.5 1.5 1.5l15 0c.827 0 1.5-.673 1.5-1.5zM14.5 5c.276 0 .5.224.5.5l0 3c0 .276-.224.5-.5.5l-3 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1.954 0C12.738 6.764 11.442 6 10 6 7.959 6 6.25 7.526 6.025 9.552c-.028.255-.245.444-.496.444-.018 0-.037-.001-.056-.003-.275-.03-.472-.278-.442-.553C5.312 6.909 7.449 5 10 5c1.605 0 3.067.758 4 2.013L14 5.5c0-.276.224-.5.5-.5zm.0283 5.0049c.274.03.472.278.441.553-.281 2.532-2.418 4.442-4.969 4.442-1.606 0-3.068-.758-4-2.013l0 1.513c0 .276-.224.5-.5.5-.277 0-.5-.224-.5-.5l0-3c0-.276.223-.5.5-.5l3 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1.954 0c.715 1.236 2.011 2 3.454 2 2.041 0 3.751-1.527 3.975-3.554.031-.274.265-.471.553-.441z"],"video-layout-auto_24":["M21.5 3C22.878 3 24 4.121 24 5.5l0 13c0 1.379-1.122 2.5-2.5 2.5l-19 0C1.122 21 0 19.879 0 18.5l0-13C0 4.121 1.122 3 2.5 3l19 0zM23 18.5l0-13c0-.827-.673-1.5-1.5-1.5l-19 0C1.673 4 1 4.673 1 5.5l0 13c0 .827.673 1.5 1.5 1.5l19 0c.827 0 1.5-.673 1.5-1.5zm-6.501-5.9878c.27.062.438.329.377.599-.52 2.29-2.525 3.889-4.876 3.889-1.599 0-3.064-.757-4-2.01l0 1.51c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-3c0-.275.225-.5.5-.5l3 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1.955 0c.716 1.235 2.017 2 3.455 2 1.881 0 3.485-1.28 3.901-3.111.062-.269.327-.439.598-.377zM16.5 7c.275 0 .5.225.5.5l0 3c0 .275-.225.5-.5.5l-3 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1.953 0c-.714-1.236-2.01-2-3.453-2-1.881 0-3.485 1.279-3.901 3.111-.053.232-.259.389-.488.389-.036 0-.073-.004-.11-.012-.27-.062-.439-.329-.377-.599C7.644 8.599 9.649 7 12 7c1.605 0 3.066.757 4 2.012L16 7.5c0-.275.225-.5.5-.5z"],"video-layout-equal_12":["M10.5 10l-4 0 0-3.5 4.5 0 0 3c0 .276-.224.5-.5.5M1 9.5l0-3 4.5 0 0 3.5-4 0c-.276 0-.5-.224-.5-.5M1.5 2l4 0 0 3.5-4.5 0 0-3c0-.276.224-.5.5-.5m9.5.5l0 3-4.5 0 0-3.5 4 0c.276 0 .5.224.5.5M10.5 1l-9 0C.672 1 0 1.672 0 2.5l0 7c0 .828.672 1.5 1.5 1.5l9 0c.828 0 1.5-.672 1.5-1.5l0-7c0-.828-.672-1.5-1.5-1.5"],"video-layout-equal_16":["M15 7.5l-6.5 0 0-4.5L14 3c.551 0 1 .449 1 1l0 3.5zm0 4.5c0 .551-.449 1-1 1l-5.5 0 0-4.5 6.5 0 0 3.5zM7.5 7.5L1 7.5 1 4c0-.551.449-1 1-1l5.5 0 0 4.5zm0 5.5L2 13c-.551 0-1-.449-1-1l0-3.5 6.5 0 0 4.5zM14 2L2 2C.895 2 0 2.895 0 4l0 8c0 1.105.895 2 2 2l12 0c1.105 0 2-.895 2-2l0-8c0-1.105-.895-2-2-2z"],"video-layout-equal_20":["M19 9.5l-8.5 0 0-6.5 7 0c.827 0 1.5.673 1.5 1.5l0 5zm0 6c0 .827-.673 1.5-1.5 1.5l-7 0 0-6.5 8.5 0 0 5zm-9.5-6L1 9.5l0-5C1 3.673 1.673 3 2.5 3l7 0 0 6.5zm0 7.5l-7 0c-.827 0-1.5-.673-1.5-1.5l0-5 8.5 0 0 6.5zm8-15l-15 0C1.127 2 .003 3.123 0 4.496L0 4.5l0 11 0 .004C.003 16.877 1.127 18 2.5 18l15 0c1.375 0 2.5-1.125 2.5-2.5l0-11C20 3.125 18.875 2 17.5 2z"],"video-layout-equal_24":["M21.5 20l-9 0 0-7.5 10.5 0 0 6c0 .827-.673 1.5-1.5 1.5M1 18.5l0-6 10.5 0 0 7.5-9 0c-.827 0-1.5-.673-1.5-1.5M2.5 4l9 0 0 7.5-10.5 0 0-6C1 4.673 1.673 4 2.5 4M23 5.5l0 6-10.5 0 0-7.5 9 0c.827 0 1.5.673 1.5 1.5M21.5 3l-19 0C1.122 3 0 4.121 0 5.5l0 13C0 19.879 1.122 21 2.5 21l19 0c1.378 0 2.5-1.121 2.5-2.5l0-13C24 4.121 22.878 3 21.5 3"],"video-layout-overlay_12":["M1.5 2c-.27614237 0-.5.22385763-.5.5l0 7c0 .27614237.22385763.5.5.5l9 0c.2761424 0 .5-.22385763.5-.5l0-7c0-.27614237-.2238576-.5-.5-.5l-9 0zm5.83333333 6l1 0L11 8l0-1L1 7l0 1 2.66666667 0 1 0 2.66666666 0zM1.5 1l9 0c.8284271 0 1.5.671572875 1.5 1.5l0 7c0 .82842712-.6715729 1.5-1.5 1.5l-9 0C.671572875 11 0 10.32842712 0 9.5l0-7C0 1.671572875.671572875 1 1.5 1zm2.16666667 7l0 2 1 0 0-2-1 0zm3.66666666 0l0 2 1 0 0-2-1 0z"],"video-layout-overlay_16":["M14 2c1.105 0 2 .895 2 2l0 8c0 1.105-.895 2-2 2L2 14c-1.105 0-2-.895-2-2l0-8c0-1.105.895-2 2-2l12 0zm1 7l0-5c0-.551-.449-1-1-1L2 3c-.551 0-1 .449-1 1l0 5 14 0zm0 3l0-2-4 0 0 3 3 0c.551 0 1-.449 1-1zm-9 1l4 0 0-3-4 0 0 3zm-1 0l0-3-4 0 0 2c0 .551.449 1 1 1l3 0z"],"video-layout-overlay_20":["M17.5 2C18.875 2 20 3.125 20 4.5l0 11c0 1.375-1.125 2.5-2.5 2.5l-15 0C1.127 18 .003 16.877 0 15.504l0-.004 0-11 0-.004C.003 3.123 1.127 2 2.5 2l15 0zM19 12l0-7.5c0-.827-.673-1.5-1.5-1.5l-15 0C1.673 3 1 3.673 1 4.5L1 12l18 0zm0 3.5l0-2.5-5.333 0 0 4 3.833 0c.827 0 1.5-.673 1.5-1.5zM7.333 17l5.334 0 0-4-5.334 0 0 4zM2.5 17l3.833 0 0-4L1 13l0 2.5c0 .827.673 1.5 1.5 1.5z"],"video-layout-overlay_24":["M21.5 3C22.878 3 24 4.121 24 5.5l0 13c0 1.379-1.122 2.5-2.5 2.5l-19 0C1.122 21 0 19.879 0 18.5l0-13C0 4.121 1.122 3 2.5 3l19 0zM23 14l0-8.5c0-.827-.673-1.5-1.5-1.5l-19 0C1.673 4 1 4.673 1 5.5L1 14l22 0zm0 4.5l0-3.5-7 0 0 5 5.5 0c.827 0 1.5-.673 1.5-1.5zM9 20l6 0 0-5-6 0 0 5zm-6.5 0L8 20l0-5-7 0 0 3.5c0 .827.673 1.5 1.5 1.5z"],"video-layout-prominent_12":["M10.5 1c.828 0 1.5.672 1.5 1.5l0 7c0 .828-.672 1.5-1.5 1.5l-9 0C.672 11 0 10.328 0 9.5l0-7C0 1.672.672 1 1.5 1l9 0zm0 9c.276 0 .5-.224.5-.5L11 8 8.333 8l0 2 2.167 0zM1 9.5c0 .276.224.5.5.5l2.167 0 0-2L1 8l0 1.5zm3.666.5l2.667 0 0-2-2.667 0 0 2zM1.5 2c-.276 0-.5.224-.5.5L1 7l2.667 0 1 0 2.666 0 0-5L1.5 2zm6.833 5L11 7l0-2-2.667 0 0 2zM11 2.5c0-.276-.224-.5-.5-.5L8.333 2l0 2L11 4l0-1.5z"],"video-layout-prominent_16":["M14 2c1.105 0 2 .895 2 2l0 8c0 1.105-.895 2-2 2L2 14c-1.105 0-2-.895-2-2l0-8c0-1.105.895-2 2-2l12 0zm1 3l0-1c0-.551-.449-1-1-1l-3 0 0 2 4 0zm-4 4l4 0 0-3-4 0 0 3zm4 3l0-2-4 0 0 3 3 0c.551 0 1-.449 1-1zm-9 1l4 0 0-3-4 0 0 3zm-1 0l0-3-4 0 0 2c0 .551.449 1 1 1l3 0zM1 4l0 5 9 0 0-6-8 0c-.551 0-1 .449-1 1z"],"video-layout-prominent_20":["M17.5 2C18.875 2 20 3.125 20 4.5l0 11c0 1.375-1.125 2.5-2.5 2.5l-15 0C1.127 18 .003 16.877 0 15.504l0-.004 0-11 0-.004C.003 3.123 1.127 2 2.5 2l15 0zM19 7l0-2.5c0-.827-.673-1.5-1.5-1.5l-3.833 0 0 4L19 7zm-5.333 5L19 12l0-4-5.333 0 0 4zM19 15.5l0-2.5-5.333 0 0 4 3.833 0c.827 0 1.5-.673 1.5-1.5zM7.333 17l5.334 0 0-4-5.334 0 0 4zM2.5 17l3.833 0 0-4L1 13l0 2.5c0 .827.673 1.5 1.5 1.5zM1 4.5L1 12l11.667 0 0-9L2.5 3C1.673 3 1 3.673 1 4.5z"],"video-layout-prominent_24":["M21.5 3C22.878 3 24 4.121 24 5.5l0 13c0 1.379-1.122 2.5-2.5 2.5l-19 0C1.122 21 0 19.879 0 18.5l0-13C0 4.121 1.122 3 2.5 3l19 0zM23 9l0-3.5c0-.827-.673-1.5-1.5-1.5L16 4l0 5 7 0zm-7 5l7 0 0-4-7 0 0 4zm7 4.5l0-3.5-7 0 0 5 5.5 0c.827 0 1.5-.673 1.5-1.5zM9 20l6 0 0-5-6 0 0 5zm-6.5 0L8 20l0-5-7 0 0 3.5c0 .827.673 1.5 1.5 1.5zM1 5.5L1 14l14 0 0-10L2.5 4C1.673 4 1 4.673 1 5.5z"],"video-layout-share-dominant_12":["M10.5 1c.828 0 1.5.672 1.5 1.5l0 7c0 .828-.672 1.5-1.5 1.5l-9 0C.672 11 0 10.328 0 9.5l0-7C0 1.672.672 1 1.5 1l9 0zm.5 8.5l0-7c0-.276-.224-.5-.5-.5l-9 0c-.276 0-.5.224-.5.5l0 7c0 .276.224.5.5.5l9 0c.276 0 .5-.224.5-.5zM6 3c1.654 0 3 1.346 3 3 0 1.654-1.346 3-3 3-1.654 0-3-1.346-3-3 0-1.654 1.346-3 3-3zm0 5c.929 0 1.706-.64 1.929-1.5L6 6.5c-.276 0-.5-.224-.5-.5l0-1.929C4.64 4.294 4 5.071 4 6c0 1.103.897 2 2 2zm1.929-2.5c-.182-.699-.73-1.247-1.429-1.429l0 1.429 1.429 0z"],"video-layout-share-dominant_16":["M14 2c1.105 0 2 .895 2 2l0 8c0 1.105-.895 2-2 2L2 14c-1.105 0-2-.895-2-2l0-8c0-1.105.895-2 2-2l12 0zm1 10l0-8c0-.551-.449-1-1-1L2 3c-.551 0-1 .449-1 1l0 8c0 .551.449 1 1 1l12 0c.551 0 1-.449 1-1zM8 4c2.206 0 4 1.794 4 4 0 2.206-1.794 4-4 4-2.206 0-4-1.794-4-4 0-2.206 1.794-4 4-4zm0 7c1.483 0 2.71-1.084 2.949-2.5L8 8.5c-.276 0-.5-.224-.5-.5l0-2.949C6.084 5.29 5 6.517 5 8c0 1.654 1.346 3 3 3zm2.949-3.5C10.737 6.248 9.752 5.263 8.5 5.051l0 2.449 2.449 0z"],"video-layout-share-dominant_20":["M17.5 2C18.875 2 20 3.125 20 4.5l0 11c0 1.375-1.125 2.5-2.5 2.5l-15 0C1.127 18 .003 16.877 0 15.504l0-.004 0-11 0-.004C.003 3.123 1.127 2 2.5 2l15 0zM19 15.5l0-11c0-.827-.673-1.5-1.5-1.5l-15 0C1.673 3 1 3.673 1 4.5l0 11c0 .827.673 1.5 1.5 1.5l15 0c.827 0 1.5-.673 1.5-1.5zM10 5c2.757 0 5 2.243 5 5 0 2.757-2.243 5-5 5-2.757 0-5-2.243-5-5 0-2.757 2.243-5 5-5zm0 9c2.034 0 3.7-1.532 3.949-3.5L10 10.5c-.276 0-.5-.224-.5-.5l0-3.949C7.532 6.3 6 7.966 6 10c0 2.206 1.794 4 4 4zm3.949-4.5c-.228-1.802-1.647-3.221-3.449-3.449l0 3.449 3.449 0z"],"video-layout-share-dominant_24":["M21.5 3C22.878 3 24 4.121 24 5.5l0 13c0 1.379-1.122 2.5-2.5 2.5l-19 0C1.122 21 0 19.879 0 18.5l0-13C0 4.121 1.122 3 2.5 3l19 0zM23 18.5l0-13c0-.827-.673-1.5-1.5-1.5l-19 0C1.673 4 1 4.673 1 5.5l0 13c0 .827.673 1.5 1.5 1.5l19 0c.827 0 1.5-.673 1.5-1.5zM12 6c3.309 0 6 2.691 6 6 0 3.309-2.691 6-6 6-3.309 0-6-2.691-6-6 0-3.309 2.691-6 6-6zm0 11c2.586 0 4.694-1.98 4.949-4.5L12 12.5c-.276 0-.5-.224-.5-.5l0-4.949C8.98 7.306 7 9.415 7 12c0 2.757 2.243 5 5 5zm4.949-5.5c-.238-2.353-2.096-4.211-4.449-4.449l0 4.449 4.449 0z"],"video-layout-single_16":["M15 12c0 .551-.449 1-1 1L2 13c-.551 0-1-.449-1-1l0-8c0-.551.449-1 1-1l12 0c.551 0 1 .449 1 1l0 8zM14 2L2 2C.895 2 0 2.895 0 4l0 8c0 1.105.895 2 2 2l12 0c1.105 0 2-.895 2-2l0-8c0-1.105-.895-2-2-2z"],"video-layout-single_20":["M1 4.5C1 3.673 1.673 3 2.5 3l15 0c.827 0 1.5.673 1.5 1.5l0 11c0 .827-.673 1.5-1.5 1.5l-15 0c-.827 0-1.5-.673-1.5-1.5l0-11zM2.5 18l15 0c1.375 0 2.5-1.125 2.5-2.5l0-11C20 3.125 18.875 2 17.5 2l-15 0C1.127 2 .003 3.123 0 4.496l0 11.008C.003 16.877 1.127 18 2.5 18z"],"video-layout-video-dominant_12":["M11 9.5c0 .276-.224.5-.5.5l-.705 0-.074-.296c-.2-.8-.813-1.4-1.576-1.614C8.672 7.55 9 6.813 9 6c0-1.654-1.346-3-3-3-1.654 0-3 1.346-3 3 0 .813.328 1.55.855 2.09-.763.214-1.376.814-1.576 1.614L2.205 10 1.5 10c-.276 0-.5-.224-.5-.5l0-7c0-.276.224-.5.5-.5l9 0c.276 0 .5.224.5.5l0 7zM4.461 9l3.078 0c.574 0 1.073.39 1.212.946l.014.054-5.53 0 .014-.054C3.388 9.39 3.887 9 4.461 9zM6 8c-1.103 0-2-.897-2-2 0-1.103.897-2 2-2 1.103 0 2 .897 2 2 0 1.103-.897 2-2 2zm4.5-7l-9 0C.672 1 0 1.672 0 2.5l0 7c0 .828.672 1.5 1.5 1.5l9 0c.828 0 1.5-.672 1.5-1.5l0-7c0-.828-.672-1.5-1.5-1.5z"],"video-layout-video-dominant_16":["M15 12c0 .551-.449 1-1 1l-.599 0c-.475-1.139-1.551-1.915-2.801-1.985C11.45 10.281 12 9.209 12 8c0-2.206-1.794-4-4-4-2.206 0-4 1.794-4 4 0 1.209.55 2.281 1.4 3.015-1.25.07-2.326.846-2.801 1.985L2 13c-.551 0-1-.449-1-1l0-8c0-.551.449-1 1-1l12 0c.551 0 1 .449 1 1l0 8zm-4.582 0c.764 0 1.435.396 1.844 1l-8.524 0c.409-.604 1.08-1 1.844-1l4.836 0zM8 11c-1.654 0-3-1.346-3-3 0-1.654 1.346-3 3-3 1.654 0 3 1.346 3 3 0 1.654-1.346 3-3 3zm6-9L2 2C.895 2 0 2.895 0 4l0 8c0 1.105.895 2 2 2l12 0c1.105 0 2-.895 2-2l0-8c0-1.105-.895-2-2-2z"],"video-layout-video-dominant_20":["M19 15.5c0 .827-.673 1.5-1.5 1.5l-.552 0c-.457-1.768-2.042-3-3.87-3l-.109 0C14.194 13.088 15 11.642 15 10c0-2.757-2.243-5-5-5-2.757 0-5 2.243-5 5 0 1.642.806 3.088 2.031 4l-.109 0c-1.828 0-3.413 1.232-3.87 3L2.5 17c-.827 0-1.5-.673-1.5-1.5l0-11C1 3.673 1.673 3 2.5 3l15 0c.827 0 1.5.673 1.5 1.5l0 11zM4.105 17c.421-1.188 1.536-2 2.817-2l6.156 0c1.281 0 2.396.812 2.817 2l-11.79 0zM6 10c0-2.206 1.794-4 4-4 2.206 0 4 1.794 4 4 0 2.206-1.794 4-4 4-2.206 0-4-1.794-4-4zm11.5-8l-15 0C1.127 2 .003 3.123 0 4.496L0 4.5l0 11 0 .004C.003 16.877 1.127 18 2.5 18l15 0c1.375 0 2.5-1.125 2.5-2.5l0-11C20 3.125 18.875 2 17.5 2z"],"video-layout-video-dominant_24":["M23 18.5c0 .827-.673 1.5-1.5 1.5l-2.05 0-.492-1.97c-.446-1.784-2.042-3.03-3.881-3.03l-.104 0C16.196 14.088 17 12.644 17 11c0-2.761-2.238-5-5-5-2.762 0-5 2.239-5 5 0 1.644.804 3.088 2.027 4l-.104 0c-1.839 0-3.435 1.246-3.881 3.03L4.55 20 2.5 20c-.827 0-1.5-.673-1.5-1.5l0-13C1 4.673 1.673 4 2.5 4l19 0c.827 0 1.5.673 1.5 1.5l0 13zM8 11c0-2.206 1.795-4 4-4 2.206 0 4 1.794 4 4 0 2.206-1.794 4-4 4-2.205 0-4-1.794-4-4zm7.077 5c1.379 0 2.576.935 2.91 2.272L18.49 20 5.581 20l.432-1.728C6.347 16.935 7.544 16 8.923 16l6.154 0zM21.5 3l-19 0C1.122 3 0 4.121 0 5.5l0 13C0 19.879 1.122 21 2.5 21l19 0c1.378 0 2.5-1.121 2.5-2.5l0-13C24 4.121 22.878 3 21.5 3z"],"view-all_12":["M8.5 3c.827 0 1.5.673 1.5 1.5l0 4c0 .275-.224.5-.5.5-.276 0-.5-.225-.5-.5l0-4c0-.275-.225-.5-.5-.5l-5 0c-.276 0-.5-.225-.5-.5 0-.275.224-.5.5-.5l5 0zm2-2c.827 0 1.5.673 1.5 1.5l0 4c0 .275-.224.5-.5.5-.276 0-.5-.225-.5-.5l0-4c0-.275-.225-.5-.5-.5l-5 0c-.276 0-.5-.225-.5-.5 0-.275.224-.5.5-.5l5 0zm-9 10C.673 11 0 10.327 0 9.5l0-3C0 5.673.673 5 1.5 5l5 0C7.327 5 8 5.673 8 6.5l0 3c0 .827-.673 1.5-1.5 1.5l-5 0zM1 6.5l0 3c0 .275.225.5.5.5l5 0c.275 0 .5-.225.5-.5l0-3c0-.275-.225-.5-.5-.5l-5 0c-.275 0-.5.225-.5.5z"],"view-all_14":["M8.612 5.0003c.766 0 1.388.622 1.388 1.387l0 5.225c0 .766-.622 1.388-1.388 1.388l-7.225 0c-.765 0-1.387-.622-1.387-1.388l0-5.225c0-.765.622-1.387 1.387-1.387l7.225 0zM9 11.6123l0-5.225c0-.213-.174-.387-.388-.387l-7.225 0c-.213 0-.387.174-.387.387l0 5.225c0 .214.174.388.387.388l7.225 0c.214 0 .388-.174.388-.388zM10.6123 3c.766 0 1.388.622 1.388 1.387l0 4.113c0 .275-.225.5-.5.5-.276 0-.5-.225-.5-.5l0-4.113c0-.213-.174-.387-.388-.387l-8.112 0c-.276 0-.5-.225-.5-.5 0-.275.224-.5.5-.5l8.112 0zm2-2c.766 0 1.388.622 1.388 1.387l0 4.092c0 .275-.225.5-.5.5-.276 0-.5-.225-.5-.5l0-4.092c0-.213-.174-.387-.388-.387l-8.112 0c-.276 0-.5-.225-.5-.5 0-.275.224-.5.5-.5l8.112 0z"],"view-feed-multiple_16":["M14 2c1.105 0 2 .895 2 2l0 8c0 1.105-.895 2-2 2L2 14c-1.105 0-2-.895-2-2l0-8c0-1.105.895-2 2-2l12 0zm1 10l0-8c0-.551-.449-1-1-1l-3 0 0 10 3 0c.551 0 1-.449 1-1zm-9 1l4 0 0-10-4 0 0 10zm-1 0L5 3 2 3c-.551 0-1 .449-1 1l0 8c0 .551.449 1 1 1l3 0z"],"view-feed-panel_16":["M15 12c0 .551-.449 1-1 1l-8 0L6 3l8 0c.551 0 1 .449 1 1l0 8zM5 13l-3 0c-.551 0-1-.449-1-1l0-8c0-.551.449-1 1-1l3 0 0 10zm9-11L2 2C.895 2 0 2.895 0 4l0 8c0 1.105.895 2 2 2l12 0c1.105 0 2-.895 2-2l0-8c0-1.105-.895-2-2-2z"],"view-feed-single_16":["M14 3c.551 0 1 .449 1 1l0 8c0 .551-.449 1-1 1L2 13c-.551 0-1-.449-1-1l0-8c0-.551.449-1 1-1l12 0zM0 4l0 8c0 1.105.895 2 2 2l12 0c1.105 0 2-.895 2-2l0-8c0-1.105-.895-2-2-2L2 2C.895 2 0 2.895 0 4z"],"view-list_10":["M1 1.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5zM1 5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5zm0 3.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5zM9.5 2l-7 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l7 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5zm0 7l-7 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l7 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5zm0-3.5l-7 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l7 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5z"],"view-list_12":["M1 2.4999c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5zM1 6c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5zm0 3.4999c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5zm10.5-6.5l-8 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l8 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5zm0 3.5001l-8 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l8 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5zm0 3.4999l-8 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l8 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5z"],"view-list_14":["M4.49994445 2l8.00011105 0C12.7761672 2 13 2.223832755 13 2.499944451c0 .276111695-.2238328.49994445-.4999445.49994445l-8.00011105 0C4.22383275 2.999888901 4 2.776056146 4 2.499944451 4 2.223832755 4.22383275 2 4.49994445 2zM4.5 6.5l8 0c.2761424 0 .5.22385763.5.5 0 .27614237-.2238576.5-.5.5l-8 0c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5zm0 4.5l8 0c.2761424 0 .5.22385763.5.5 0 .27614237-.2238576.5-.5.5l-8 0c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5zm-3-8.9990001111c.276 0 .5.2239751141.5.4999444511 0 .275969336-.224.49994445-.5.49994445-.276 0-.5-.223975114-.5-.49994445 0-.275969337.224-.4999444511.5-.4999444511zM1.5 6.5c.276 0 .5.22397511.5.49994445 0 .27596934-.224.49994445-.5.49994445-.276 0-.5-.22397511-.5-.49994445C1 6.72397511 1.224 6.5 1.5 6.5zm0 4.5001111c.276 0 .5.22397511.5.49994445C2 11.77602489 1.776 12 1.5 12c-.276 0-.5-.22397511-.5-.49994445 0-.27596934.224-.49994445.5-.49994445z"],"view-list_16":["M4.5 3.0002c-.276 0-.5-.224-.5-.5 0-.277.224-.5.5-.5l9.997 0c.276 0 .5.223.5.5 0 .276-.224.5-.5.5l-9.997 0zM14.4971 7.5c.276 0 .5.224.5.5 0 .277-.224.5-.5.5l-9.997 0c-.276 0-.5-.223-.5-.5 0-.276.224-.5.5-.5l9.997 0zm0 5.5016c.276 0 .5.224.5.5 0 .277-.224.5-.5.5l-9.997 0c-.276 0-.5-.223-.5-.5 0-.276.224-.5.5-.5l9.997 0zM1.5 2c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0 5.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0 5.5016c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5z"],"view-list_20":["M17.5 4l-12 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l12 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L6.7968724 3.745049425 17.5 4zm-12 6.5c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l12 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-12 0zm0 6.5c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l12 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-12 0zM3 3.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5zM3 10c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5zm-.5 7c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5z"],"view-list_24":["M20.5 11.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-13 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l13 0zM7.5 5c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l13 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-13 0zm13 14c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-13 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l13 0zM3.5 4c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0 7.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0 7.5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5z"],"view-list_28":["M8.5 6c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l16 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-16 0zm16 7.5c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-16 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l16 0zm0 8.5c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-16 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l16 0zM3.5 5c.275 0 .5.225.5.5 0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5zm0 8.5c.275 0 .5.225.5.5 0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5zm0 8.5c.275 0 .5.225.5.5 0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5z"],"view-list-circle_100":["M50 0c27.57 0 50 22.43 50 50 0 27.57-22.43 50-50 50-27.57 0-50-22.43-50-50C0 22.43 22.43 0 50 0zm0 99c27.019 0 49-21.981 49-49C99 22.981 77.019 1 50 1 22.981 1 1 22.981 1 50c0 27.019 21.981 49 49 49zm20.5-66c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-32 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l32 0zm0 17c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-32 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l32 0zm0 17c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-32 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l32 0zm-40-34c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0 17c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0 17c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5z"],"view-mixed_12":["M1.00091659 2.5c0 .276-.223981335.5-.499958337.5-.275977001 0-.4999583363-.224-.4999583363-.5 0-.276.2239813353-.5.4999583363-.5.275977002 0 .499958337.224.499958337.5zm0 7c0 .276-.223981335.5-.499958337.5-.275977001 0-.4999583363-.224-.4999583363-.5 0-.276.2239813353-.5.4999583363-.5.275977002 0 .499958337.224.499958337.5zM11.5000417 3L3.50070827 3c-.27497708 0-.49995833-.225-.49995833-.5 0-.275.22498125-.5.49995833-.5l7.99933343 0C11.7750187 2 12 2.225 12 2.5c0 .275-.2249813.5-.4999583.5zm0 7l-7.99933343 0c-.27497708 0-.49995833-.225-.49995833-.5 0-.275.22498125-.5.49995833-.5l7.99933343 0C11.7750187 9 12 9.225 12 9.5c0 .275-.2249813.5-.4999583.5zM.999916674 7.5C.44796267 7.5 0 7.052 0 6.5l0-1c0-.552.44796267-1 .999916674-1l9.999166726 0c.551954 0 .9999167.448.9999167 1l0 1c0 .552-.4479627 1-.9999167 1l-9.999166726 0z"],"view-stack_12":["M2.5 8c-.27614237 0-.5.22385763-.5.5l0 1c0 .27614237.22385763.5.5.5l7 0c.27614237 0 .5-.22385763.5-.5l0-1c0-.27614237-.22385763-.5-.5-.5l-7 0zm0-1l7 0c.82842712 0 1.5.67157288 1.5 1.5l0 1c0 .82842712-.67157288 1.5-1.5 1.5l-7 0C1.671572875 11 1 10.32842712 1 9.5l0-1C1 7.67157288 1.671572875 7 2.5 7zm0-6l7 0c.82842712 0 1.5.671572875 1.5 1.5l0 1c0 .82842712-.67157288 1.5-1.5 1.5l-7 0C1.671572875 5 1 4.32842712 1 3.5l0-1C1 1.671572875 1.671572875 1 2.5 1zm0 1c-.27614237 0-.5.22385763-.5.5l0 1c0 .27614237.22385763.5.5.5l7 0c.27614237 0 .5-.22385763.5-.5l0-1c0-.27614237-.22385763-.5-.5-.5l-7 0z"],"view-stack_14":["M2.667 2C2.299 2 2 2.299 2 2.667l0 1.666c0 .368.299.667.667.667l8.667 0c.367 0 .666-.299.666-.667l0-1.666c0-.368-.299-.667-.666-.667L2.667 2zm8.667 4L2.667 6C1.748 6 1 5.252 1 4.333l0-1.666C1 1.748 1.748 1 2.667 1l8.667 0C12.253 1 13 1.748 13 2.667l0 1.666C13 5.252 12.253 6 11.334 6zm0 7.001l-8.667 0c-.919 0-1.667-.748-1.667-1.667l0-1.667c0-.919.748-1.666 1.667-1.666l8.667 0c.919 0 1.666.747 1.666 1.666l0 1.667c0 .919-.747 1.667-1.666 1.667zm-8.667-4c-.368 0-.667.299-.667.666l0 1.667c0 .367.299.667.667.667l8.667 0c.367 0 .666-.3.666-.667l0-1.667c0-.367-.299-.666-.666-.666l-8.667 0z"],"view-stack_20":["M4.167 2.9998c-.644 0-1.167.523-1.167 1.167l0 2.666c0 .644.523 1.167 1.167 1.167l11.666 0c.644 0 1.167-.523 1.167-1.167l0-2.666c0-.644-.523-1.167-1.167-1.167l-11.666 0zm11.666 6l-11.666 0C2.972 8.9998 2 8.0278 2 6.8328l0-2.666c0-1.195.972-2.167 2.167-2.167l11.666 0c1.195 0 2.167.972 2.167 2.167l0 2.666c0 1.195-.972 2.167-2.167 2.167zm0 9.001l-11.666 0c-1.195 0-2.167-.972-2.167-2.167l0-2.666c0-1.194.972-2.167 2.167-2.167l11.666 0c1.195 0 2.167.973 2.167 2.167l0 2.666c0 1.195-.972 2.167-2.167 2.167zm-11.666-6c-.644 0-1.167.523-1.167 1.167l0 2.666c0 .644.523 1.167 1.167 1.167l11.666 0c.644 0 1.167-.523 1.167-1.167l0-2.666c0-.644-.523-1.167-1.167-1.167l-11.666 0z"],"view-stack_24":["M3.5 4C2.67157288 4 2 4.67157288 2 5.5l0 3c0 .82842712.67157288 1.5 1.5 1.5l17 0c.8284271 0 1.5-.67157288 1.5-1.5l0-3c0-.82842712-.6715729-1.5-1.5-1.5l-17 0zm0-1l17 0C21.8807119 3 23 4.11928813 23 5.5l0 3c0 1.38071187-1.1192881 2.5-2.5 2.5l-17 0C2.11928813 11 1 9.88071187 1 8.5l0-3C1 4.11928813 2.11928813 3 3.5 3zm0 10l17 0c1.3807119 0 2.5 1.1192881 2.5 2.5l0 3c0 1.3807119-1.1192881 2.5-2.5 2.5l-17 0C2.11928813 21 1 19.8807119 1 18.5l0-3C1 14.1192881 2.11928813 13 3.5 13zm0 1c-.82842712 0-1.5.6715729-1.5 1.5l0 3c0 .8284271.67157288 1.5 1.5 1.5l17 0c.8284271 0 1.5-.6715729 1.5-1.5l0-3c0-.8284271-.6715729-1.5-1.5-1.5l-17 0z"],"view-thumbnail_12":["M3.667 1C4.402 1 5 1.598 5 2.334l0 1.332C5 4.402 4.402 5 3.667 5L2.333 5C1.598 5 1 4.402 1 3.666l0-1.332C1 1.598 1.598 1 2.333 1l1.334 0zM4 3.666l0-1.332C4 2.149 3.851 2 3.667 2L2.333 2C2.149 2 2 2.149 2 2.334l0 1.332c0 .185.149.334.333.334l1.334 0C3.851 4 4 3.851 4 3.666zM9.6677 1c.735 0 1.333.598 1.333 1.334l0 1.332c0 .736-.598 1.334-1.333 1.334l-1.334 0c-.735 0-1.333-.598-1.333-1.334l0-1.332c0-.736.598-1.334 1.333-1.334l1.334 0zm.333 2.666l0-1.332c0-.185-.15-.334-.333-.334l-1.334 0c-.184 0-.333.149-.333.334l0 1.332c0 .185.149.334.333.334l1.334 0c.183 0 .333-.149.333-.334zM3.667 7.0039c.735 0 1.333.598 1.333 1.333l0 1.333c0 .736-.598 1.334-1.333 1.334l-1.334 0c-.735 0-1.333-.598-1.333-1.334l0-1.333c0-.735.598-1.333 1.333-1.333l1.334 0zM4 9.6699l0-1.333c0-.184-.149-.333-.333-.333l-1.334 0c-.184 0-.333.149-.333.333l0 1.333c0 .185.149.334.333.334l1.334 0c.184 0 .333-.149.333-.334zm5.6677-2.666c.735 0 1.333.598 1.333 1.333l0 1.333c0 .736-.598 1.334-1.333 1.334l-1.334 0c-.735 0-1.333-.598-1.333-1.334l0-1.333c0-.735.598-1.333 1.333-1.333l1.334 0zm.333 2.666l0-1.333c0-.184-.15-.333-.333-.333l-1.334 0c-.184 0-.333.149-.333.333l0 1.333c0 .185.149.334.333.334l1.334 0c.183 0 .333-.149.333-.334z"],"view-thumbnail_14":["M2.6428 2c-.354 0-.643.288-.643.643l0 1.713c0 .355.289.644.643.644l1.714 0c.355 0 .643-.289.643-.644l0-1.713c0-.355-.288-.643-.643-.643l-1.714 0zm1.714 4l-1.714 0c-.906 0-1.643-.737-1.643-1.644l0-1.713c0-.906.737-1.643 1.643-1.643l1.714 0c.906 0 1.643.737 1.643 1.643l0 1.713c0 .907-.737 1.644-1.643 1.644zm0 7.0039l-1.714 0c-.906 0-1.643-.737-1.643-1.644l0-1.713c0-.906.737-1.643 1.643-1.643l1.714 0c.906 0 1.643.737 1.643 1.643l0 1.713c0 .907-.737 1.644-1.643 1.644zm-1.714-4c-.354 0-.643.288-.643.643l0 1.713c0 .355.289.644.643.644l1.714 0c.355 0 .643-.289.643-.644l0-1.713c0-.355-.288-.643-.643-.643l-1.714 0zM11.3568 6l-1.714 0c-.906 0-1.643-.737-1.643-1.644l0-1.713c0-.906.737-1.643 1.643-1.643l1.714 0c.906 0 1.643.737 1.643 1.643l0 1.713c0 .907-.737 1.644-1.643 1.644zm-1.714-4c-.354 0-.643.288-.643.643l0 1.713c0 .355.289.644.643.644l1.714 0c.355 0 .643-.289.643-.644l0-1.713c0-.355-.288-.643-.643-.643l-1.714 0zm1.714 11.0039l-1.714 0c-.906 0-1.643-.737-1.643-1.644l0-1.713c0-.906.737-1.643 1.643-1.643l1.714 0c.906 0 1.643.737 1.643 1.643l0 1.713c0 .907-.737 1.644-1.643 1.644zm-1.714-4c-.354 0-.643.288-.643.643l0 1.713c0 .355.289.644.643.644l1.714 0c.355 0 .643-.289.643-.644l0-1.713c0-.355-.288-.643-.643-.643l-1.714 0z"],"view-thumbnail_16":["M5 1c1.104 0 2 .895 2 2l0 2c0 1.105-.896 2-2 2L3 7c-1.104 0-2-.895-2-2l0-2c0-1.105.896-2 2-2l2 0zm8 0c1.104 0 2 .895 2 2l0 2c0 1.105-.896 2-2 2l-2 0c-1.104 0-2-.895-2-2l0-2c0-1.105.896-2 2-2l2 0zM5 9c1.104 0 2 .895 2 2l0 2c0 1.105-.896 2-2 2l-2 0c-1.104 0-2-.895-2-2l0-2c0-1.105.896-2 2-2l2 0zm8 0c1.104 0 2 .895 2 2l0 2c0 1.105-.896 2-2 2l-2 0c-1.104 0-2-.895-2-2l0-2c0-1.105.896-2 2-2l2 0zm1 4l0-2c0-.551-.448-1-1-1l-2 0c-.552 0-1 .449-1 1l0 2c0 .551.448 1 1 1l2 0c.552 0 1-.449 1-1zm-8 0l0-2c0-.551-.448-1-1-1l-2 0c-.552 0-1 .449-1 1l0 2c0 .551.448 1 1 1l2 0c.552 0 1-.449 1-1zm8-8l0-2c0-.551-.448-1-1-1l-2 0c-.552 0-1 .449-1 1l0 2c0 .551.448 1 1 1l2 0c.552 0 1-.449 1-1zM6 5l0-2c0-.551-.448-1-1-1L3 2c-.552 0-1 .449-1 1l0 2c0 .551.448 1 1 1l2 0c.552 0 1-.449 1-1z"],"view-thumbnail_20":["M7 2L4 2c-1.1 0-2 .9-2 2l0 3c0 1.1.9 2 2 2l3 0c1.1 0 2-.9 2-2l0-3c0-1.1-.9-2-2-2m0 1c.552 0 1 .448 1 1l0 3c0 .552-.448 1-1 1L4 8c-.552 0-1-.448-1-1l0-3c0-.552.448-1 1-1l3 0zm9-1c1.1 0 2 .9 2 2l0 3c0 1.1-.9 2-2 2l-3 0c-1.1 0-2-.9-2-2l0-3c0-1.1.9-2 2-2l3 0zm0 1l-3 0c-.552 0-1 .448-1 1l0 3c0 .552.448 1 1 1l3 0c.552 0 1-.448 1-1l0-3c0-.552-.448-1-1-1zm-9 8c1.1 0 2 .9 2 2l0 3c0 1.1-.9 2-2 2l-3 0c-1.1 0-2-.9-2-2l0-3c0-1.1.9-2 2-2l3 0zm0 1l-3 0c-.552 0-1 .448-1 1l0 3c0 .552.448 1 1 1l3 0c.552 0 1-.448 1-1l0-3c0-.552-.448-1-1-1zm9-1c1.1 0 2 .9 2 2l0 3c0 1.1-.9 2-2 2l-3 0c-1.1 0-2-.9-2-2l0-3c0-1.1.9-2 2-2l3 0zm0 1l-3 0c-.552 0-1 .448-1 1l0 3c0 .552.448 1 1 1l3 0c.552 0 1-.448 1-1l0-3c0-.552-.448-1-1-1z"],"view-thumbnail_24":["M8.5 1C9.881 1 11 2.119 11 3.5l0 5C11 9.881 9.881 11 8.5 11l-5 0C2.119 11 1 9.881 1 8.5l0-5C1 2.119 2.119 1 3.5 1l5 0zm12 0C21.881 1 23 2.119 23 3.5l0 5c0 1.381-1.119 2.5-2.5 2.5l-5 0C14.119 11 13 9.881 13 8.5l0-5C13 2.119 14.119 1 15.5 1l5 0zm-12 12c1.381 0 2.5 1.119 2.5 2.5l0 5c0 1.381-1.119 2.5-2.5 2.5l-5 0C2.119 23 1 21.881 1 20.5l0-5C1 14.119 2.119 13 3.5 13l5 0zm12 0c1.381 0 2.5 1.119 2.5 2.5l0 5c0 1.381-1.119 2.5-2.5 2.5l-5 0c-1.381 0-2.5-1.119-2.5-2.5l0-5c0-1.381 1.119-2.5 2.5-2.5l5 0zm1.5 7.5l0-5c0-.827-.673-1.5-1.5-1.5l-5 0c-.827 0-1.5.673-1.5 1.5l0 5c0 .827.673 1.5 1.5 1.5l5 0c.827 0 1.5-.673 1.5-1.5zm-12 0l0-5c0-.827-.673-1.5-1.5-1.5l-5 0c-.827 0-1.5.673-1.5 1.5l0 5c0 .827.673 1.5 1.5 1.5l5 0c.827 0 1.5-.673 1.5-1.5zm12-12l0-5c0-.827-.673-1.5-1.5-1.5l-5 0c-.827 0-1.5.673-1.5 1.5l0 5c0 .827.673 1.5 1.5 1.5l5 0c.827 0 1.5-.673 1.5-1.5zm-12 0l0-5C10 2.673 9.327 2 8.5 2l-5 0C2.673 2 2 2.673 2 3.5l0 5c0 .827.673 1.5 1.5 1.5l5 0c.827 0 1.5-.673 1.5-1.5z"],"voicemail_16":["M14 2c1.104 0 2 .896 2 2l0 8c0 1.104-.896 2-2 2L2 14c-1.104 0-2-.896-2-2l0-8c0-1.104.896-2 2-2l12 0zm1 10l0-8c0-.551-.448-1-1-1L2 3c-.552 0-1 .449-1 1l0 8c0 .552.448 1 1 1l12 0c.552 0 1-.448 1-1zm-4-6c1.104 0 2 .896 2 2 0 1.104-.896 2-2 2l-6 0c-1.104 0-2-.896-2-2 0-1.104.896-2 2-2 1.104 0 2 .896 2 2 0 .366-.105.705-.277 1l2.554 0C9.105 8.705 9 8.366 9 8c0-1.104.896-2 2-2zm0 3c.552 0 1-.449 1-1 0-.551-.448-1-1-1-.552 0-1 .449-1 1 0 .551.448 1 1 1zM4 8c0 .551.448 1 1 1 .552 0 1-.449 1-1 0-.551-.448-1-1-1-.552 0-1 .449-1 1z"],"voicemail_20":["M17.5 2C18.881 2 20 3.119 20 4.5l0 11c0 1.381-1.119 2.5-2.5 2.5l-15 0C1.119 18 0 16.881 0 15.5l0-11C0 3.119 1.119 2 2.5 2l15 0zM19 15.5l0-11c0-.827-.673-1.5-1.5-1.5l-15 0C1.673 3 1 3.673 1 4.5l0 11c0 .827.673 1.5 1.5 1.5l15 0c.827 0 1.5-.673 1.5-1.5zM14 7c1.657 0 3 1.343 3 3 0 1.657-1.343 3-3 3l-8 0c-1.657 0-3-1.343-3-3 0-1.657 1.343-3 3-3 1.657 0 3 1.343 3 3 0 .772-.3 1.468-.779 2l3.558 0C11.3 11.468 11 10.772 11 10c0-1.657 1.343-3 3-3zm0 5c1.103 0 2-.897 2-2 0-1.103-.897-2-2-2-1.103 0-2 .897-2 2 0 1.103.897 2 2 2zM4 10c0 1.103.897 2 2 2 1.103 0 2-.897 2-2 0-1.103-.897-2-2-2-1.103 0-2 .897-2 2z"],"voicemail_24":["M21.5 3C22.881 3 24 4.119 24 5.5l0 13c0 1.381-1.119 2.5-2.5 2.5l-19 0C1.119 21 0 19.881 0 18.5l0-13C0 4.119 1.119 3 2.5 3l19 0zM23 18.5l0-13c0-.827-.673-1.5-1.5-1.5l-19 0C1.673 4 1 4.673 1 5.5l0 13c0 .827.673 1.5 1.5 1.5l19 0c.827 0 1.5-.673 1.5-1.5zM16 9c1.657 0 3 1.343 3 3 0 1.657-1.343 3-3 3l-8 0c-1.657 0-3-1.343-3-3 0-1.657 1.343-3 3-3 1.657 0 3 1.343 3 3 0 .772-.3 1.468-.779 2l3.558 0C13.3 13.468 13 12.772 13 12c0-1.657 1.343-3 3-3zm0 5c1.103 0 2-.897 2-2 0-1.103-.897-2-2-2-1.103 0-2 .897-2 2 0 1.103.897 2 2 2zM6 12c0 1.103.897 2 2 2 1.103 0 2-.897 2-2 0-1.103-.897-2-2-2-1.103 0-2 .897-2 2z"],"voicemail_28":["M24.558 3.0002c1.901 0 3.442 1.541 3.442 3.442l0 15.116c0 1.901-1.541 3.442-3.442 3.442l-21.116 0c-1.901 0-3.442-1.541-3.442-3.442l0-15.116c0-1.901 1.541-3.442 3.442-3.442l21.116 0zM27 21.5582l0-15.116c0-1.347-1.095-2.442-2.442-2.442l-21.116 0C2.095 4.0002 1 5.0952 1 6.4422l0 15.116c0 1.346 1.095 2.442 2.442 2.442l21.116 0c1.347 0 2.442-1.096 2.442-2.442zM20 10c2.209 0 4 1.791 4 4 0 2.209-1.791 4-4 4L8 18c-2.209 0-4-1.791-4-4 0-2.209 1.791-4 4-4 2.209 0 4 1.791 4 4 0 1.202-.541 2.267-1.38 3l6.76 0c-.839-.733-1.38-1.798-1.38-3 0-2.209 1.791-4 4-4zm0 7c1.654 0 3-1.346 3-3 0-1.654-1.346-3-3-3-1.654 0-3 1.346-3 3 0 1.654 1.346 3 3 3zM5 14c0 1.654 1.346 3 3 3 1.654 0 3-1.346 3-3 0-1.654-1.346-3-3-3-1.654 0-3 1.346-3 3z"],"wallpaper_16":["M14 2c1.105 0 2 .895 2 2l0 8c0 1.105-.895 2-2 2L2 14c-1.105 0-2-.895-2-2l0-8c0-1.105.895-2 2-2l12 0zm1 10l0-8c0-.551-.449-1-1-1L2 3c-.551 0-1 .449-1 1l0 5.651 2.853-2.853c1.028-1.029 2.821-1.029 3.85 0L13.908 13 14 13c.551 0 1-.449 1-1zm-3-8.0002c1.103 0 2 .897 2 2 0 1.103-.897 2-2 2-1.103 0-2-.897-2-2 0-1.103.897-2 2-2zm0 3c.551 0 1-.448 1-1 0-.552-.449-1-1-1-.551 0-1 .448-1 1 0 .552.449 1 1 1zM2 13l10.491 0-5.495-5.495c-.651-.651-1.786-.651-2.436 0L1 11.065 1 12c0 .551.449 1 1 1z"],"wallpaper_20":["M17.5 2C18.881 2 20 3.119 20 4.5l0 11c0 1.381-1.119 2.5-2.5 2.5l-15 0C1.119 18 0 16.881 0 15.5l0-11C0 3.119 1.119 2 2.5 2l15 0zM19 15.5l0-11c0-.827-.673-1.5-1.5-1.5l-15 0C1.673 3 1 3.673 1 4.5l0 8.363 3.904-3.905c1.279-1.277 3.358-1.277 4.636 0l8.034 8.034c.792-.039 1.426-.69 1.426-1.492zm-18 0c0 .827.673 1.5 1.5 1.5l13.667 0-7.334-7.335c-.888-.889-2.333-.889-3.222 0L1 14.277 1 15.5zM15 5c1.103 0 2 .896 2 2 0 1.104-.897 2-2 2-1.103 0-2-.896-2-2 0-1.104.897-2 2-2zm0 3c.552 0 1-.448 1-1 0-.551-.448-1-1-1-.552 0-1 .449-1 1 0 .552.448 1 1 1z"],"wallpaper_24":["M21.5 3C22.879 3 24 4.122 24 5.5l0 13c0 1.378-1.121 2.5-2.5 2.5l-19 0C1.121 21 0 19.878 0 18.5l0-13C0 4.122 1.121 3 2.5 3l19 0zM23 18.5l0-13c0-.827-.673-1.5-1.5-1.5l-19 0C1.673 4 1 4.673 1 5.5l0 10.571 4.956-4.956c1.494-1.493 3.927-1.495 5.421 0L20.262 20l1.238 0c.827 0 1.5-.673 1.5-1.5zm-22 0c0 .827.673 1.5 1.5 1.5l16.348 0-8.178-8.178c-1.106-1.105-2.901-1.104-4.007 0l-5.642 5.643c-.007.006-.015.008-.021.013L1 18.5zM18.5 6C19.879 6 21 7.122 21 8.5c0 1.378-1.121 2.5-2.5 2.5-1.379 0-2.5-1.122-2.5-2.5C16 7.122 17.121 6 18.5 6zm0 4c.827 0 1.5-.673 1.5-1.5 0-.827-.673-1.5-1.5-1.5-.827 0-1.5.673-1.5 1.5 0 .827.673 1.5 1.5 1.5z"],"wallpaper_28":["M25 3c1.657 0 3 1.344 3 3l0 16c0 1.656-1.343 3-3 3L3 25c-1.657 0-3-1.344-3-3L0 6c0-1.656 1.343-3 3-3l22 0zm2 19l0-16c0-1.103-.897-2-2-2L3 4c-1.103 0-2 .897-2 2l0 12.682 6.396-6.396C8.225 11.457 9.327 11 10.5 11c1.172 0 2.274.457 3.103 1.286l11.685 11.685C26.254 23.83 27 23.004 27 22zM1 22c0 1.103.897 2 2 2l20.903 0-11.007-11.007c-1.281-1.281-3.513-1.281-4.792 0L1 20.096 1 22zM21 7c1.657 0 3 1.344 3 3 0 1.656-1.343 3-3 3-1.657 0-3-1.344-3-3 0-1.656 1.343-3 3-3zm0 5c1.103 0 2-.897 2-2 0-1.103-.897-2-2-2-1.103 0-2 .897-2 2 0 1.103.897 2 2 2z"],"wallpaper_32":["M29 4c1.657 0 3 1.343 3 3l0 18c0 1.657-1.343 3-3 3L3 28c-1.657 0-3-1.343-3-3L0 7c0-1.657 1.343-3 3-3l26 0zm2 21l0-18c0-1.103-.897-2-2-2L3 5c-1.103 0-2 .897-2 2l0 14.508 7.06-7.059c1.927-1.928 5.064-1.928 6.992 0L27.604 27 29 27c1.103 0 2-.897 2-2zM25 8.0003c1.654 0 3 1.346 3 3 0 1.654-1.346 3-3 3-1.654 0-3-1.346-3-3 0-1.654 1.346-3 3-3zm0 5c1.103 0 2-.897 2-2 0-1.103-.897-2-2-2-1.103 0-2 .897-2 2 0 1.103.897 2 2 2zM3 27l23.189 0-11.844-11.844c-1.537-1.538-4.041-1.538-5.578 0L1 22.922 1 25c0 1.103.897 2 2 2z"],"warning_100":["M96.7658 78.7421c1.62 2.738 1.646 6.023.071 8.787-1.597 2.799-4.486 4.471-7.73 4.471l-78.214 0c-3.242 0-6.133-1.672-7.73-4.471-1.576-2.764-1.548-6.049.072-8.788l39.105-66.39c1.611-2.724 4.476-4.351 7.66-4.351 3.186 0 6.049 1.627 7.659 4.351l.001 0 39.106 66.391zm-.797 8.291c1.395-2.448 1.371-5.357-.063-7.782l-39.107-66.393c-1.429-2.415-3.971-3.858-6.799-3.858-2.828 0-5.369 1.443-6.799 3.86l-39.105 66.388c-1.436 2.428-1.459 5.338-.064 7.785 1.417 2.484 3.982 3.967 6.861 3.967l78.214 0c2.879 0 5.444-1.483 6.862-3.967zM50.001 60.0004c-.276 0-.5-.224-.5-.5l0-26c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 26c0 .276-.224.5-.5.5zm0 14c.552 0 1 .448 1 1 0 .552-.448 1-1 1-.552 0-1-.448-1-1 0-.552.448-1 1-1z"],"warning_12":["M11.7823 8.8346c.273.434.29.983.041 1.432-.253.461-.724.736-1.259.736l-9.13 0c-.534 0-1.005-.275-1.259-.736-.248-.449-.232-.998.042-1.432l4.521-7.156c.268-.425.739-.679 1.26-.679l.003 0c.521 0 .992.254 1.259.679l4.522 7.156zm-.834.95c.073-.133.069-.288-.012-.416l-4.521-7.156c-.084-.134-.238-.213-.414-.213l-.003 0c-.176 0-.33.079-.414.212l-4.522 7.157c-.08.128-.085.283-.011.416.036.065.146.218.383.218l9.13 0c.238 0 .348-.153.384-.218zM5.9982 3.997c.276 0 .5.224.5.5l0 2.006c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-2.006c0-.276.224-.5.5-.5zm0 4.0059c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5z"],"warning_16":["M15.7408197 12.238c.336.563.347 1.244.025 1.818-.33.591-.936.944-1.618.944L1.85281975 15c-.682 0-1.289000003-.353-1.619000003-.945-.321-.574-.311-1.254.027-1.818L6.40681975 1.901c.337-.565.933-.901 1.593-.901.661 0 1.256.336 1.592.9.002 0 .002 0 .002.001l6.14699995 10.337zm-.849 1.331c.148-.264.144-.561-.01-.819L8.85581975 2.617l-.122-.205c-.156-.262-.424-.412-.734-.412-.31 0-.578.151-.735.413l-6.144 10.335c-.156000003.259-.160000003.557-.014.819.154.276.426.433.746.433l12.29499995 0c.32 0 .592-.157.744-.431zM8.00021975 6.0002c.275 0 .5.225.5.5l0 3c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-3c0-.275.225-.5.5-.5zm0 5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5z"],"warning_20":["M19.6975232 15.865c.4.652.403 1.432.01 2.089-.392.654-1.099 1.046-1.889 1.046l-15.637 0c-.79 0-1.496999999-.392-1.889999999-1.046-.392-.657-.3890000001-1.437.011-2.09L8.1205232 2.03c.395-.645 1.098-1.029 1.878-1.03l.001 0c.781 0 1.484.384 1.88 1.029l0 .001 7.818 13.835zm-.847 1.574c.2-.335.198-.718-.005-1.05l-7.831-13.858c-.215-.333-.593-.531-1.015-.531l-.001 0c-.43 0-.814.207-1.025.552l-7.8 13.804c-.222999999.364-.223999999.748-.023 1.084.21.35.596.56 1.031.56l15.637 0c.435 0 .821-.21 1.032-.561zm-8.5205-2.2974c.05.04.08.101.11.16.02.06.04.13.04.191 0 .129-.049.259-.15.349-.1.1-.22.151-.35.151-.14 0-.259-.051-.36-.151-.09-.09-.14-.22-.14-.349 0-.061.01-.131.04-.191.02-.059.06-.12.1-.16.19-.189.53-.189.71 0zm-.3526-2.1421c-.276 0-.5-.224-.5-.5l0-5c0-.276.224-.5.5-.5.276 0 .5.224.5.5l0 5c0 .276-.224.5-.5.5z"],"warning_24":["M23.6447 18.2008c.464.778.474 1.716.029 2.506-.456.809-1.287 1.293-2.223 1.293l-18.901 0c-.936 0-1.768-.483-2.224-1.292-.445-.79-.433-1.727.03-2.508l9.449-14.957c.463-.779 1.284-1.243 2.195-1.243.912 0 1.733.464 2.195 1.242.001 0 .001.001.001.001l9.449 14.958zm-.842 2.015c.267-.475.261-1.037-.017-1.503l-9.142-14.471-.018 0-.291-.489-.046-.073c-.287-.427-.762-.68-1.289-.68-.555 0-1.054.282-1.335.755l-9.464 14.98c-.268.452-.274 1.001-.003 1.481.28.499.773.784 1.352.784l18.901 0c.579 0 1.071-.286 1.352-.784zM12 8.0059c.276 0 .5.224.5.5l0 6c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-6c0-.276.224-.5.5-.5zm-.19 9.04c.18-.08.4-.029.54.11.1.09.15.22.15.35 0 .141-.05.261-.15.36-.04.04-.1.08-.161.1-.059.03-.12.04-.189.04-.13 0-.26-.05-.351-.14-.099-.099-.149-.219-.149-.36 0-.13.05-.26.149-.35.04-.049.101-.08.161-.11z"],"warning_28":["M16.4822423 3.379l11.115 18.397c.26.429.395.902.403 1.378l0 .001c.008.475-.111.951-.357 1.388-.514.912-1.459 1.457-2.528 1.457l-22.23 0c-1.069 0-2.014-.545-2.528-1.457-.492-.874-.475-1.908.046-2.767l11.115-18.397c.523-.864 1.451-1.379 2.482-1.379 1.03 0 1.959.515 2.482 1.378l0 .001zm10.29 20.673c.154-.273.233-.578.228-.881-.005-.303-.094-.606-.258-.876l-11.116-18.399c-.339-.56-.947-.896-1.626-.896-.678 0-1.286.336-1.626.897l-11.115 18.396c-.337.556-.347 1.197-.03 1.759.334.594.954.948 1.656.948l22.23 0c.703 0 1.323-.354 1.657-.948zm-12.7719-4.045c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm.0034-11c.276 0 .5.224.5.5l0 8c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-8c0-.276.224-.5.5-.5z"],"warning_32":["M31.5501313 25.184c.301.507.45 1.064.449 1.62-.001.557-.152 1.113-.456 1.62-.589.987-1.635 1.576-2.797 1.576L3.25313129 30c-1.162 0-2.208-.589-2.796999999-1.576-.606-1.014-.608-2.225-.007-3.241L13.1961313 3.588c.588-.995 1.636-1.588 2.804-1.588 1.167 0 2.215.593 2.803 1.587l0 .001 12.747 21.596zm-.865 2.727c.205-.343.313-.727.314-1.109.001-.382-.106-.765-.31-1.108l-12.747-21.598c-.406-.686-1.132-1.096-1.942-1.096-.811 0-1.537.41-1.943 1.097L1.31013129 25.691c-.417999999.707-.416999999 1.516.004 2.22.407.682 1.132 1.089 1.939 1.089l25.49300001 0c.807 0 1.532-.407 1.939-1.089zm-15.041-4.7724c.189-.18.517-.19.705 0 .089.1.149.221.149.351 0 .14-.06.26-.149.36-.09.09-.219.15-.347.15-.14 0-.258-.06-.358-.15-.089-.09-.148-.22-.148-.36 0-.13.059-.261.148-.351zm.3535-3.1387c-.274 0-.496-.229-.496-.511l0-8.979c0-.282.222-.51.496-.51.274 0 .496.228.496.51l0 8.979c0 .282-.222.511-.496.511z"],"warning_40":["M39.4584 31.9784c.73 1.267.728 2.78-.004 4.046-.715 1.237-1.985 1.975-3.398 1.975l-32.109 0c-1.412 0-2.682-.738-3.397-1.975-.733-1.267-.734-2.78-.004-4.047l16.054-27.995c.715-1.242 1.987-1.982 3.402-1.982 1.415 0 2.687.74 3.401 1.981 0 .001 0 .001 0 .001l16.055 27.996zm-.87 3.546c.552-.954.553-2.094.003-3.048l-16.055-27.997c-.534-.926-1.481-1.479-2.534-1.479-1.054 0-2.001.553-2.535 1.48l-16.054 27.995c-.55.955-.549 2.095.003 3.049.533.923 1.48 1.475 2.531 1.475l32.109 0c1.052 0 1.998-.551 2.532-1.475zm-18.586-10.5327c-.276 0-.5-.224-.5-.5l0-10.982c0-.277.224-.5.5-.5.276 0 .5.223.5.5l0 10.982c0 .276-.224.5-.5.5zm.355 5.1474c.04.05.08.1.11.17.02.06.04.12.04.19 0 .06-.02.13-.04.19-.03.06-.07.11-.11.16-.09.09-.22.15-.35.15-.14 0-.26-.06-.36-.15-.09-.09-.14-.22-.14-.35 0-.07.01-.13.03-.19.03-.07.06-.12.11-.17.19-.18.52-.18.71 0z"],"warning_44":["M43.4022217 34.669c.777 1.294.797 2.851.054 4.164-.768 1.357-2.172 2.167-3.756 2.167l-35.401 0c-1.584 0-2.988-.81-3.756000001-2.167-.743-1.313-.723-2.87.055-4.165L18.2972217 5.073c.781-1.298 2.164-2.073 3.703-2.073 1.538 0 2.921.775 3.701 2.073l.001 0 17.7 29.596zm-.816 3.671c.563-.996.548-2.175-.041-3.157l-17.702-29.597c-.596-.993-1.66-1.586-2.843-1.586-1.184 0-2.247.593-2.845 1.588l-17.699 29.593c-.591000001.983-.606000001 2.163-.043 3.159.588 1.04 1.667 1.66 2.886 1.66l35.401 0c1.219 0 2.298-.62 2.886-1.66zm-20.5864-22.3403c.276 0 .5.224.5.5l0 12c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-12c0-.276.224-.5.5-.5zm0 16c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5z"],"warning_56":["M55.2544755 44.165c.976 1.614.995 3.552.049 5.183-.963 1.661-2.709 2.652-4.672 2.652L5.36847554 52c-1.963 0-3.709-.991-4.671999999-2.652-.946-1.631-.927-3.569.049-5.184L23.3774755 6.571c.974-1.611 2.702-2.571 4.623-2.571 1.92 0 3.648.96 4.621 2.57.001 0 .001 0 .001.001l22.632 37.594zm-.816 4.682c.76-1.311.745-2.868-.039-4.164l-22.54-37.44-.094-.156c-.79-1.306-2.197-2.087-3.765-2.087-1.569 0-2.977.781-3.767 2.088L1.60247554 44.68c-.785999999 1.299-.800999999 2.856-.041 4.167.782 1.349 2.205 2.153 3.807 2.153l45.26299996 0c1.602 0 3.025-.804 3.807-2.153zm-26.4385-29.4922c.276 0 .5.224.5.5l0 14c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-14c0-.276.224-.5.5-.5zm-.3496 20.1426c.18-.19.52-.19.699 0 .101.09.151.22.151.35 0 .07-.01.13-.04.19-.021.06-.06.12-.111.17-.09.09-.22.14-.349.14-.13 0-.26-.05-.35-.14-.051-.05-.09-.11-.11-.17-.031-.06-.04-.12-.04-.19 0-.13.049-.26.15-.35z"],"warning_64":["M63.1556994 50.258c1.093 1.778 1.125 3.92.09 5.727-1.082 1.888-3.068 3.015-5.318 3.015L6.07169939 59c-2.249 0-4.237-1.127-5.318999998-3.015-1.035-1.807-1.001-3.949.092-5.728L26.7716994 7.863c1.102-1.793 3.056-2.863 5.228-2.863 2.174 0 4.127 1.07 5.229 2.862l0 .001 25.927 42.395zm-.777 5.23c.852-1.486.823-3.245-.075-4.706l-25.929-42.397-.032-.053c-.924-1.461-2.542-2.332-4.343-2.332-1.821 0-3.458.892-4.376 2.387L1.69669939 50.779c-.898999998 1.464-.926999998 3.224-.076 4.709.902 1.573 2.566 2.512 4.451 2.512l51.85600001 0c1.886 0 3.55-.939 4.451-2.512zm-30.3789-9.4722c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm0-24c.276 0 .5.224.5.5l0 16c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-16c0-.276.224-.5.5-.5z"],"warning_72":["M71.0619969 57.055c.612 1.016.923 2.134.938 3.255l0 .065c.003 1.118-.288 2.238-.879 3.262-1.217 2.106-3.422 3.363-5.898 3.363L6.77899691 67c-2.476 0-4.68-1.257-5.896999999-3.363-1.196-2.071-1.175-4.532.059-6.582L30.1619969 8.262c1.229-2.043 3.411-3.262 5.839-3.262 2.428 0 4.61 1.219 5.838 3.262l.001 0 29.222 48.793zm-.062 3.323l0-.068c-.013-.944-.288-1.896-.795-2.74l-29.223-48.794c-1.044-1.738-2.908-2.776-4.981-2.776-2.073 0-3.936 1.038-4.981 2.777L1.79899691 57.569c-1.043999999 1.735-1.062999999 3.816-.052 5.568 1.036 1.793 2.917 2.863 5.032 2.863l58.44399999 0c2.115 0 3.996-1.07 5.032-2.863.49-.849.748-1.803.745-2.759zm-34.8086-7.3481c.06.03.119.07.159.11.101.1.151.23.151.36 0 .13-.05.26-.151.35-.04.05-.099.08-.159.11-.061.02-.12.04-.19.04-.06 0-.13-.02-.191-.04-.059-.03-.119-.06-.159-.11-.101-.09-.15-.22-.15-.35 0-.13.049-.26.15-.36.04-.04.1-.08.159-.11.12-.05.261-.05.381 0zm-.1904-29.0298c.276 0 .5.224.5.5l0 18c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-18c0-.276.224-.5.5-.5z"],"web-sharing_16":["M15 9.001c0 .55-.452.999-1.009.999L12 10l0-3c0-1.112-.899-2-2.009-2L5 5l0-2c0-.55.452-1 1.009-1l7.982 0C14.553 2 15 2.443 15 3l0 6.001zm-4 4c0 .55-.452.999-1.009.999l-.013 0-.023-.1c-.221-.937-.925-1.63-1.79-1.834C8.679 11.527 9 10.803 9 10c0-1.654-1.346-3-3-3-1.654 0-3 1.346-3 3 0 .803.321 1.527.835 2.066-.865.204-1.569.897-1.79 1.834l-.023.1-.013 0C1.447 14 1 13.556 1 13.001L1 7c0-.55.452-1 1.009-1l7.982 0C10.553 6 11 6.443 11 7l0 6.001zM4 10c0-1.103.897-2 2-2 1.103 0 2 .897 2 2 0 1.103-.897 2-2 2-1.103 0-2-.897-2-2zm.352 3l3.296 0c.584 0 1.085.409 1.281 1l-5.858 0c.196-.591.697-1 1.281-1zm9.639-12L6.009 1C4.902 1 4 1.897 4 3l0 2-1.991 0C.902 5 0 5.897 0 7l0 6.001C0 14.113.899 15 2.009 15l7.982 0C11.098 15 12 14.105 12 13.001L12 11l1.991 0C15.098 11 16 10.105 16 9.001L16 3c0-1.112-.899-2-2.009-2z"],"web-sharing_24":["M23 13.5c0 .827-.673 1.5-1.5 1.5L18 15l0-4.5C18 9.121 16.878 8 15.5 8L7 8l0-3.5C7 3.673 7.673 3 8.5 3l13 0c.827 0 1.5.673 1.5 1.5l0 9zm-6 6c0 .827-.673 1.5-1.5 1.5l-.22 0-.164-.585c-.4-1.422-1.813-2.415-3.435-2.415l-.06 0c.84-.733 1.382-1.8 1.382-3 0-2.206-1.794-4-4-4-2.205 0-4 1.794-4 4 0 1.2.543 2.267 1.383 3l-.06 0c-1.622 0-3.035.993-3.435 2.415L2.727 21 2.5 21c-.827 0-1.5-.673-1.5-1.5l0-9C1 9.673 1.673 9 2.5 9l13 0c.827 0 1.5.673 1.5 1.5l0 9zM6.003 15c0-1.654 1.346-3 3-3 1.655 0 3 1.346 3 3 0 1.654-1.345 3-3 3-1.654 0-3-1.346-3-3zm-2.237 6l.088-.313C4.133 19.693 5.15 19 6.326 19l5.355 0c1.176 0 2.193.693 2.472 1.686l.088.314-10.475 0zM21.5 2l-13 0C7.122 2 6 3.121 6 4.5L6 8 2.5 8C1.122 8 0 9.121 0 10.5l0 9C0 20.879 1.122 22 2.5 22l13 0c1.378 0 2.5-1.121 2.5-2.5l0-3.5 3.5 0c1.378 0 2.5-1.121 2.5-2.5l0-9C24 3.121 22.878 2 21.5 2z"],"webex_10":["M5 9c-.557 0-1.087-.115-1.569-.322 2.506-1.016 4.187-3.381 4.187-6.061 0-.221-.027-.439-.05-.658C8.436 2.693 9 3.776 9 5c0 2.206-1.794 4-4 4M1 5c0-2.206 1.794-4 4-4 .507 0 .987.104 1.434.277.113.438.184.885.184 1.34 0 2.504-1.745 4.688-4.254 5.367C1.534 7.252 1 6.191 1 5m4-5C2.243 0 0 2.243 0 5c0 2.757 2.243 5 5 5 2.757 0 5-2.243 5-5 0-2.757-2.243-5-5-5"],"webex_16":["M8 15c-1.248 0-2.418-.332-3.434-.907 4.436-1.468 7.463-5.49 7.463-10.064 0-.629-.064-1.253-.177-1.868C13.746 3.415 15 5.563 15 8c0 3.86-3.141 7-7 7M1 8c0-3.86 3.141-7 7-7 .946 0 1.847.191 2.671.532.227.813.358 1.649.358 2.497 0 4.39-3.091 8.22-7.522 9.331C1.976 12.075 1 10.15 1 8m7-8C3.589 0 0 3.589 0 8c0 4.411 3.589 8 8 8 4.411 0 8-3.589 8-8 0-4.411-3.589-8-8-8"],"webex_24":["M12 23c-2.133 0-4.119-.62-5.806-1.675 6.976-2.096 11.782-8.301 11.782-15.39 0-1.144-.128-2.277-.375-3.385C20.827 4.47 23 7.981 23 12c0 6.065-4.935 11-11 11M1 12C1 5.935 5.935 1 12 1c1.567 0 3.056.335 4.407.928.372 1.3.569 2.645.569 4.007 0 6.901-4.863 12.921-11.83 14.654C2.623 18.572 1 15.474 1 12M12 0C5.383 0 0 5.383 0 12c0 6.617 5.383 12 12 12 6.617 0 12-5.383 12-12 0-6.617-5.383-12-12-12"],"webex_48":["M24 47c-4.537 0-8.768-1.326-12.335-3.603 14.385-4.045 24.336-16.718 24.336-31.2 0-2.885-.413-5.734-1.189-8.49C42.058 7.583 47 15.224 47 24c0 12.683-10.317 23-23 23M1 24C1 11.318 11.318 1 24 1c3.429 0 6.682.76 9.608 2.111.898 2.898 1.393 6.032 1.393 9.086 0 14.306-10.033 26.792-24.429 30.459C4.78 38.476 1 31.673 1 24M24 0C10.767 0 0 10.767 0 24c0 13.233 10.767 24 24 24 13.233 0 24-10.767 24-24C48 10.767 37.233 0 24 0"],"webex-board_12":["M10.5 1c.827 0 1.5.673 1.5 1.5l0 7c0 .827-.673 1.5-1.5 1.5l-9 0C.673 11 0 10.327 0 9.5l0-7C0 1.673.673 1 1.5 1l9 0zm.5 8.5l0-7c0-.275-.225-.5-.5-.5l-9 0c-.276 0-.5.225-.5.5l0 7c0 .275.224.5.5.5l9 0c.275 0 .5-.225.5-.5zM5.667 4c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l.666 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-.666 0zM9.5 8c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0zm-3 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0z"],"webex-board_14":["M12.3 1.9998c.939 0 1.7.761 1.7 1.7l0 7.6c0 .939-.761 1.7-1.7 1.7l-10.6 0c-.939 0-1.7-.761-1.7-1.7l0-7.6c0-.939.761-1.7 1.7-1.7l10.6 0zm.7 9.3l0-7.6c0-.386-.314-.7-.7-.7l-10.6 0c-.386 0-.7.314-.7.7l0 7.6c0 .386.314.7.7.7l10.6 0c.386 0 .7-.314.7-.7zM7.5 4c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0zm0 6c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0zm4 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-2 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l2 0z"],"webex-board_16":["M14.006 2C15.107 2 16 2.902 16 4.009l0 7.982C16 13.1 15.105 14 14.006 14L1.994 14C.893 14 0 13.097 0 11.991l0-7.982C0 2.899.895 2 1.994 2l12.012 0zM15 11.991l0-7.982C15 3.451 14.553 3 14.006 3L1.994 3C1.447 3 1 3.451 1 4.009l0 7.982c0 .558.447 1.009.994 1.009l12.012 0c.547 0 .994-.451.994-1.009zM8.5 3.9998c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0zm0 7c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0zm5 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-2 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l2 0z"],"webex-board_20":["M19.572 3.104c.27.398.428.878.428 1.396l0 11c0 1.379-1.121 2.5-2.5 2.5l-15 0c-.862 0-1.623-.437-2.072-1.104C.158 16.498 0 16.018 0 15.5l0-11C0 3.121 1.121 2 2.5 2l15 0c.862 0 1.623.437 2.072 1.104zM19 15.5l0-11c0-.207-.042-.404-.118-.584-.152-.358-.44-.646-.799-.798C17.904 3.042 17.707 3 17.5 3l-15 0C1.673 3 1 3.673 1 4.5l0 11c0 .207.042.404.118.584.152.358.44.646.799.798.179.076.376.118.583.118l15 0c.827 0 1.5-.673 1.5-1.5zM10.5 4c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0zM10 14c.552 0 1 .447 1 1 0 .553-.448 1-1 1-.552 0-1-.447-1-1 0-.553.448-1 1-1zm7.5 1c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-3 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l3 0z"],"webex-board_24":["M0 5.50282288C0 4.12055197 1.12537944 3 2.50050165 3L21.4994984 3C22.8804873 3 24 4.12598062 24 5.50282288l0 12.99435422C24 19.879448 22.8746206 21 21.4994984 21L2.50050165 21C1.11951272 21 0 19.8740194 0 18.4971771L0 5.50282288zm1 0L1 18.4971771C1 19.3241517 1.67421141 20 2.50050165 20l18.99899675 0C22.3245167 20 23 19.3249836 23 18.4971771l0-12.99435422C23 4.67584834 22.3257886 4 21.4994984 4L2.50050165 4C1.67548327 4 1 4.67501637 1 5.50282288zM21.5 19.0625l-3 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l3 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5zm-9-13l-1 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5zM12 19c-.5522847 0-1-.4477153-1-1 0-.5522847.4477153-1 1-1 .5522847 0 1 .4477153 1 1 0 .5522847-.4477153 1-1 1z"],"webex-board_28":["M25 3L3 3C1.342 3 0 4.343 0 6l0 16c0 1.657 1.342 3 3 3l22 0c1.657 0 3-1.343 3-3l0-16c0-1.657-1.343-3-3-3m0 1c1.103 0 2 .897 2 2l0 16c0 1.103-.897 2-2 2L3 24c-1.104 0-2-.897-2-2L1 6c0-1.103.896-2 2-2l22 0zM14.4994995 7C14.7757758 7 15 6.776 15 6.5c0-.276-.2242242-.5-.5005005-.5l-.998999 0C13.2242242 6 13 6.224 13 6.5c0 .276.2242242.5.5005005.5l.998999 0zM24.5 22c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5l-3 0c-.276 0-.5.224-.5.5 0 .276.224.5.5.5l3 0zM15 21c0-.553-.447-1-1-1-.553 0-1 .447-1 1 0 .553.447 1 1 1 .553 0 1-.447 1-1z"],"webex-board_32":["M3 4l26 0c1.6568542 0 3 1.34314575 3 3l0 18c0 1.6568542-1.3431458 3-3 3L3 28c-1.65685425 0-3-1.3431458-3-3L0 7c0-1.65685425 1.34314575-3 3-3zm0 1c-1.1045695 0-2 .8954305-2 2l0 18c0 1.1045695.8954305 2 2 2l26 0c1.1045695 0 2-.8954305 2-2l0-18c0-1.1045695-.8954305-2-2-2L3 5zm12.5 2l1 0c.2761424 0 .5.22385763.5.5 0 .27614237-.2238576.5-.5.5l-1 0c-.2761424 0-.5-.22385763-.5-.5 0-.27614237.2238576-.5.5-.5zm.5 18c-.5522847 0-1-.4477153-1-1 0-.5522847.4477153-1 1-1 .5522847 0 1 .4477153 1 1 0 .5522847-.4477153 1-1 1zm7.5-1l5 0c.2761424 0 .5.2238576.5.5 0 .2761424-.2238576.5-.5.5l-5 0c-.2761424 0-.5-.2238576-.5-.5 0-.2761424.2238576-.5.5-.5z"],"webex-board_48":["M4.5 6l39 0c2.4852814 0 4.5 2.01471863 4.5 4.5l0 27c0 2.4852814-2.0147186 4.5-4.5 4.5l-39 0C2.01471863 42 0 39.9852814 0 37.5l0-27C0 8.01471863 2.01471863 6 4.5 6zm0 1C2.56700338 7 1 8.56700338 1 10.5l0 27C1 39.4329966 2.56700338 41 4.5 41l39 0c1.9329966 0 3.5-1.5670034 3.5-3.5l0-27C47 8.56700338 45.4329966 7 43.5 7l-39 0zm18 3l3 0c.2761424 0 .5.22385763.5.5 0 .27614237-.2238576.5-.5.5l-3 0c-.2761424 0-.5-.22385763-.5-.5 0-.27614237.2238576-.5.5-.5zm14 27l7 0c.2761424 0 .5.2238576.5.5 0 .2761424-.2238576.5-.5.5l-7 0c-.2761424 0-.5-.2238576-.5-.5 0-.2761424.2238576-.5.5-.5zM24 38c-.5522847 0-1-.4477153-1-1 0-.5522847.4477153-1 1-1 .5522847 0 1 .4477153 1 1 0 .5522847-.4477153 1-1 1z"],"webex-calling_10":["M8.5356 6.4141c-.208-.208-.465-.315-.732-.376.121-.324.196-.672.196-1.038 0-.367-.075-.714-.196-1.039.267-.061.525-.168.732-.375.056-.056.08-.126.125-.188.215.492.339 1.032.339 1.602 0 .57-.124 1.11-.339 1.601-.045-.06-.07-.131-.125-.187m-5.036-.414c-.081 0-.157-.02-.236-.027-.163-.289-.264-.619-.264-.973 0-1.103.897-2 2-2 .357 0 .687.101.977.266.009.078.023.154.023.234 0 1.379-1.121 2.5-2.5 2.5m3.383-1.649c.071.206.117.42.117.649 0 1.102-.897 2-2 2-.228 0-.443-.047-.648-.117 1.243-.314 2.217-1.288 2.531-2.532m.952 3.466c-.724.73-1.727 1.183-2.835 1.183-2.205 0-4-1.794-4-4 0-2.206 1.795-4 4-4 1.108 0 2.111.453 2.835 1.183.186.196.185.503-.006.696-.195.194-.512.196-.708 0l-.001.001c-.542-.544-1.292-.88-2.12-.88-1.654 0-3 1.346-3 3 0 1.654 1.346 3 3 3 .828 0 1.578-.336 2.12-.88l.001.001c.195-.195.513-.195.707 0 .192.192.193.5.007.696m.715-6.332c-.006-.006-.007-.014-.014-.02l-.001.002c-.906-.907-2.156-1.467-3.535-1.467-2.756 0-5 2.243-5 5 0 2.757 2.244 5 5 5 1.379 0 2.629-.561 3.535-1.467l.001.002c.007-.006.008-.015.014-.02.895-.905 1.45-2.146 1.45-3.515 0-1.369-.555-2.61-1.45-3.515"],"webex-calling_12":["M10.2427 7.7676c-.279-.278-.629-.437-.993-.487.157-.398.25-.827.25-1.281 0-.452-.093-.881-.25-1.279.364-.051.714-.21.993-.488.107-.108.192-.229.267-.356.306.648.49 1.362.49 2.123 0 .762-.184 1.476-.49 2.123-.075-.126-.16-.248-.267-.355m-6.231-.269c-.316-.418-.512-.934-.512-1.499 0-1.378 1.122-2.5 2.5-2.5.565 0 1.08.196 1.499.512-.006 1.92-1.567 3.481-3.487 3.487m4.325-2.363c.1.271.163.56.163.864 0 1.379-1.121 2.5-2.5 2.5-.304 0-.593-.062-.864-.163 1.565-.411 2.79-1.636 3.201-3.201m1.214 4.377c-.907.917-2.162 1.487-3.551 1.487-2.757 0-5-2.243-5-5 0-2.756 2.243-5 5-5 1.389 0 2.644.571 3.551 1.488.13.138.205.315.205.507 0 .201-.078.389-.22.531-.282.283-.777.284-1.061 0l-.001.001c-.634-.634-1.509-1.027-2.474-1.027-1.929 0-3.5 1.571-3.5 3.5 0 1.93 1.571 3.5 3.5 3.5.965 0 1.84-.392 2.474-1.026l.001.001c.284-.284.778-.282 1.061 0 .142.142.22.33.22.531 0 .192-.075.368-.205.507m.719-7.722c-.01-.01-.017-.022-.027-.033l-.002.002c-1.086-1.087-2.586-1.76-4.241-1.76-3.308 0-6 2.692-6 6 0 3.309 2.692 6 6 6 1.655 0 3.155-.672 4.241-1.759l.002.002c.01-.011.017-.023.027-.034 1.069-1.084 1.73-2.57 1.73-4.209 0-1.638-.661-3.125-1.73-4.209"],"webex-calling_16":["M13.6562 10.8281c-.341-.341-.776-.523-1.223-.566.35-.683.567-1.444.567-2.262 0-.818-.217-1.58-.567-2.263.447-.042.882-.224 1.223-.565.187-.186.325-.402.422-.629.584 1.02.922 2.199.922 3.457 0 1.258-.338 2.436-.922 3.458-.097-.229-.236-.443-.422-.63m-8.556-.354c-.082 0-.16-.013-.238-.024-.532-.679-.862-1.522-.862-2.45 0-2.206 1.794-4 4-4 .927 0 1.772.33 2.451.862.011.078.024.156.024.237 0 2.964-2.411 5.375-5.375 5.375m6.312-4.531c.365.603.588 1.302.588 2.057 0 2.206-1.795 4-4 4-.756 0-1.454-.223-2.058-.588 2.841-.377 5.092-2.628 5.47-5.469m1.551 6.987c-1.269 1.277-3.025 2.07-4.963 2.07-3.86 0-7-3.141-7-7 0-3.859 3.14-7 7-7 1.938 0 3.694.793 4.963 2.07.372.392.371 1.01-.013 1.395-.392.388-1.026.387-1.415 0l-.001.002c-.905-.907-2.156-1.467-3.534-1.467-2.757 0-5 2.243-5 5 0 2.757 2.243 5 5 5 1.378 0 2.629-.561 3.534-1.467l.001.002c.39-.389 1.024-.389 1.414 0 .385.385.386 1.003.014 1.395m.74-10.53c-.017-.018-.028-.04-.047-.057l-.002.003c-1.449-1.449-3.449-2.346-5.654-2.346-4.411 0-8 3.589-8 8 0 4.411 3.589 8 8 8 2.205 0 4.205-.898 5.654-2.346l.002.003c.019-.017.03-.039.047-.058 1.419-1.444 2.297-3.42 2.297-5.599 0-2.179-.878-4.155-2.297-5.6"],"webex-calling_18":["M15.3643 12.1816c-.412-.412-.946-.623-1.488-.647.396-.76.624-1.621.624-2.535 0-.914-.228-1.775-.624-2.534.541-.024 1.076-.235 1.488-.647.25-.25.42-.547.527-.862.7 1.189 1.109 2.568 1.109 4.043 0 1.476-.409 2.855-1.109 4.043-.107-.314-.277-.611-.527-.861m-9.7-.189c-.716-.798-1.164-1.84-1.164-2.993 0-2.481 2.018-4.5 4.5-4.5 1.152 0 2.194.449 2.992 1.164-.087 3.454-2.875 6.242-6.328 6.329m7.217-5.23c.382.661.619 1.419.619 2.237 0 2.482-2.019 4.5-4.5 4.5-.816 0-1.572-.234-2.232-.616 3.119-.535 5.58-3 6.113-6.121m1.792 7.871c-1.451 1.46-3.457 2.366-5.673 2.366-4.411 0-8-3.589-8-8 0-4.411 3.589-8 8-8 2.216 0 4.222.907 5.673 2.367.465.489.463 1.264-.016 1.745-.485.486-1.281.486-1.769 0l-.002.002c-.996-.996-2.371-1.614-3.886-1.614-3.032 0-5.5 2.468-5.5 5.5 0 3.033 2.468 5.5 5.5 5.5 1.515 0 2.89-.617 3.886-1.613l.002.002c.489-.486 1.281-.486 1.769 0 .479.48.481 1.256.016 1.745m.744-11.933c-.02-.021-.033-.045-.053-.065l-.003.003c-1.63-1.629-3.88-2.639-6.361-2.639-4.963 0-9 4.037-9 9 0 4.963 4.037 9 9 9 2.481 0 4.731-1.009 6.361-2.638l.003.003c.02-.02.033-.044.053-.065 1.594-1.624 2.583-3.847 2.583-6.3 0-2.452-.989-4.675-2.583-6.299"],"webex-calling_20":["M17.0713 13.5352c-.488-.487-1.129-.73-1.769-.73.444-.838.698-1.791.698-2.805 0-1.014-.254-1.967-.698-2.805l.001 0c.64 0 1.281-.244 1.768-.73.31-.309.517-.688.63-1.098.819 1.356 1.299 2.938 1.299 4.633 0 1.695-.48 3.277-1.299 4.633-.113-.411-.32-.789-.63-1.098m-10.571-.535c-.167 0-.331-.011-.495-.025-.622-.834-1.005-1.857-1.005-2.975 0-2.757 2.243-5 5-5 1.116 0 2.136.38 2.969 1.001.014.165.031.33.031.499 0 3.584-2.916 6.5-6.5 6.5m7.474-6c.635.839 1.026 1.87 1.026 3 0 2.757-2.243 5-5 5-1.13 0-2.161-.391-3-1.026 3.742-.247 6.727-3.232 6.974-6.974m2.445 9.297c-1.634 1.666-3.907 2.703-6.419 2.703-4.963 0-9-4.037-9-9 0-4.963 4.037-9 9-9 2.511 0 4.784 1.037 6.419 2.702.245.275.384.623.384.995 0 .4-.156.777-.439 1.061-.564.565-1.553.567-2.121 0-1.086-1.086-2.586-1.758-4.243-1.758-3.314 0-6 2.686-6 6 0 3.313 2.686 6 6 6 1.657 0 3.157-.672 4.243-1.758.567-.566 1.556-.564 2.121 0 .283.283.439.66.439 1.061 0 .372-.139.719-.384.994m.652-13.367c-1.81-1.811-4.31-2.93-7.071-2.93-5.523 0-10 4.477-10 10 0 5.522 4.477 10 10 10 2.761 0 5.261-1.119 7.071-2.93 1.81-1.809 2.929-4.309 2.929-7.07 0-2.761-1.119-5.261-2.929-7.07"],"webex-calling_24":["M20.4854 16.9492c-.46-.459-1.085-.689-1.714-.703.774-1.232 1.229-2.684 1.229-4.246 0-1.553-.45-2.997-1.215-4.225.64-.016 1.244-.269 1.7-.724.334-.334.545-.743.649-1.17 1.177 1.751 1.866 3.855 1.866 6.119 0 2.263-.689 4.368-1.866 6.119-.104-.428-.315-.836-.649-1.17m-13.235-.6c-.254 0-.504-.013-.752-.036-.935-1.19-1.498-2.685-1.498-4.313 0-3.86 3.14-7 7-7 1.647 0 3.161.576 4.358 1.532.018.222.042.441.042.668 0 5.045-4.105 9.149-9.15 9.149m10.132-8.817c1.009 1.213 1.618 2.771 1.618 4.468 0 3.859-3.141 7-7 7-1.722 0-3.297-.627-4.518-1.662 5.386-.122 9.727-4.434 9.9-9.806m2.463 12.164c-1.997 2.036-4.775 3.304-7.845 3.304-6.066 0-11-4.935-11-11 0-6.066 4.934-11 11-11 3.071 0 5.848 1.267 7.845 3.304.238.273.372.614.372.979 0 .4-.156.776-.439 1.061-.567.566-1.556.565-2.121 0-1.448-1.449-3.448-2.344-5.657-2.344-4.418 0-8 3.582-8 8 0 4.418 3.582 8 8 8 2.209 0 4.209-.896 5.657-2.344.566-.564 1.554-.566 2.121 0 .283.284.439.66.439 1.061 0 .365-.134.706-.372.979m.641-16.181l-.001-.001c-2.172-2.171-5.172-3.514-8.485-3.514-6.627 0-12 5.373-12 12 0 6.627 5.373 12 12 12 3.313 0 6.313-1.343 8.485-3.515l.001-.001c2.171-2.172 3.514-5.171 3.514-8.484 0-3.314-1.343-6.313-3.514-8.485"],"webex-codec-plus_16":["M14 4c1.103 0 2 .897 2 2l0 4c0 1.103-.897 2-2 2L2 12c-1.103 0-2-.897-2-2l0-4c0-1.103.897-2 2-2l12 0zm1 6l0-4c0-.551-.448-1-1-1L2 5c-.552 0-1 .449-1 1l0 4c0 .551.448 1 1 1l12 0c.552 0 1-.449 1-1zm-1-1.5l0 1c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-1c0-.276.224-.5.5-.5.276 0 .5.224.5.5z"],"webex-codec-plus_20":["M18 5c1.1 0 2 .9 2 2l0 6c0 1.1-.9 2-2 2L2 15c-1.1 0-2-.9-2-2l0-6c0-1.1.9-2 2-2l16 0zm1 8l0-6c0-.551-.448-1-1-1L2 6c-.552 0-1 .449-1 1l0 6c0 .551.448 1 1 1l16 0c.552 0 1-.449 1-1zm-1.5-2c.276 0 .5.224.5.5l0 1c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-1c0-.276.224-.5.5-.5z"],"webex-instant-meeting_16":["M13.9999-.0001c1.103 0 2 .897 2 2l0 11.995c0 1.104-.897 2-2 2l-12 0c-1.103 0-2-.896-2-2l0-11.995c0-1.103.897-2 2-2l12 0zm1 13.995l0-11.995c0-.551-.449-1-1-1l-12 0c-.551 0-1 .449-1 1l0 11.995c0 .552.449 1 1 1l12 0c.551 0 1-.448 1-1zm-7-10.9952c2.757 0 5 2.243 5 5 0 2.757-2.243 5-5 5-2.757 0-5-2.243-5-5 0-2.757 2.243-5 5-5zm0 9c2.206 0 4-1.794 4-4 0-1.223-.564-2.306-1.432-3.041.023.219.05.437.05.659 0 2.68-1.681 5.044-4.186 6.061.482.206 1.011.321 1.568.321zm-4-4c0 1.192.535 2.252 1.364 2.985 2.51-.68 4.254-2.862 4.254-5.367 0-.455-.071-.903-.184-1.341-.447-.173-.927-.277-1.434-.277-2.206 0-4 1.795-4 4z"],"webex-instant-meeting_20":["M16.5 1C17.875 1 19 2.125 19 3.5l0 13c0 1.381-1.119 2.5-2.5 2.5l-13 0C2.125 19 1 17.875 1 16.5l0-13C1 2.119 2.119 1 3.5 1l13 0zM18 16.5l0-13c0-.827-.673-1.5-1.5-1.5l-13 0C2.673 2 2 2.673 2 3.5l0 13c0 .827.673 1.5 1.5 1.5l13 0c.827 0 1.5-.673 1.5-1.5zM10 4c3.309 0 6 2.691 6 6 0 3.309-2.691 6-6 6-3.309 0-6-2.691-6-6 0-3.309 2.691-6 6-6zm0 11c2.757 0 5-2.243 5-5 0-1.623-.79-3.053-1.991-3.967.048.349.079.7.079 1.055 0 3.306-2.121 6.22-5.261 7.394.659.322 1.391.518 2.173.518zm-5-5c0 1.514.69 2.855 1.755 3.772 3.144-.827 5.333-3.555 5.333-6.684 0-.586-.09-1.163-.241-1.725C11.274 5.135 10.653 5 10 5c-2.757 0-5 2.243-5 5z"],"webex-instant-meeting_24":["M20.531 1.0003c1.362 0 2.469 1.107 2.469 2.468l0 17.062c0 1.362-1.107 2.47-2.469 2.47l-17.062 0c-1.362 0-2.469-1.108-2.469-2.47l0-17.062c0-1.361 1.107-2.468 2.469-2.468l17.062 0zM22 20.5303l0-17.062c0-.809-.659-1.468-1.469-1.468l-17.062 0c-.81 0-1.469.659-1.469 1.468l0 17.062c0 .811.659 1.47 1.469 1.47l17.062 0c.81 0 1.469-.659 1.469-1.47zM12 5c3.86 0 7 3.141 7 7 0 3.859-3.14 7-7 7-3.86 0-7-3.141-7-7 0-3.859 3.14-7 7-7zm0 13c3.309 0 6-2.691 6-6 0-2.033-1.02-3.831-2.571-4.917.08.486.13.979.13 1.476 0 3.945-2.581 7.418-6.376 8.736.84.448 1.799.705 2.817.705zm-6-6c0 1.83.826 3.47 2.123 4.57 3.792-.965 6.436-4.248 6.436-8.011 0-.719-.112-1.427-.301-2.114C13.561 6.16 12.799 6 12 6c-3.309 0-6 2.691-6 6z"],"webex-meetings_10":["M5 9.0002c-.57 0-1.11-.124-1.602-.34-.455-.2-.867-.479-1.215-.825-.004-.003-.008-.003-.012-.007-.003-.004-.003-.008-.006-.012-.118-.124-.14-.266-.14-.341 0-.078.019-.226.146-.354.128-.127.277-.146.354-.146.078 0 .226.019.353.146l.001 0c.302.303.673.531 1.082.683.325.12.672.196 1.039.196 1.657 0 3-1.343 3-3 0-.367-.075-.714-.196-1.039-.151-.409-.38-.78-.682-1.082 0-.001 0-.001-.001-.001-.195-.195-.195-.512 0-.707.128-.127.276-.146.354-.146.075 0 .217.022.342.139.004.004.008.003.012.007.003.004.003.008.006.012.346.348.625.76.825 1.215.216.492.34 1.032.34 1.602 0 2.206-1.794 4-4 4m-3.66-2.398c-.216-.492-.34-1.032-.34-1.602 0-2.206 1.794-4 4-4 .57 0 1.11.124 1.602.34-.061.045-.132.069-.188.124-.207.208-.314.465-.375.732-.325-.121-.672-.196-1.039-.196-1.657 0-3 1.343-3 3 0 .367.075.714.196 1.039-.267.06-.524.168-.732.375-.055.055-.079.126-.124.188m1.965-.627c-.014 0-.028-.004-.043-.005-.162-.288-.262-.616-.262-.97 0-1.103.897-2 2-2 .354 0 .682.1.971.262 0 .015.004.028.004.043 0 1.472-1.198 2.67-2.67 2.67m3.539-1.748c.1.237.156.499.156.773 0 1.103-.897 2-2 2-.274 0-.535-.056-.773-.156 1.281-.334 2.283-1.336 2.617-2.617m1.692-2.763C7.631.5602 6.381.0002 5 .0002c-2.761 0-5 2.238-5 5 0 1.38.56 2.63 1.464 3.535.905.905 2.155 1.465 3.536 1.465 2.761 0 5-2.239 5-5 0-1.381-.56-2.631-1.464-3.536"],"webex-meetings_12":["M5.9999 11.0002c-.342 0-.676-.036-.999-.101-.058-.012-.11-.037-.168-.051-.264-.064-.526-.136-.773-.241-.035-.014-.066-.037-.1-.053-.262-.117-.517-.249-.752-.409-.016-.01-.028-.024-.043-.035-.25-.173-.487-.365-.702-.58-.283-.293-.283-.759.006-1.049.146-.147.339-.221.531-.221.192 0 .383.073.529.219.149.148.312.275.48.393.013.009.024.021.036.03.163.11.338.199.516.28.028.012.053.031.082.044.17.071.347.12.527.164.045.01.086.03.131.039.228.046.462.071.699.071 1.93 0 3.5-1.57 3.5-3.5 0-.238-.024-.471-.07-.699-.01-.045-.029-.087-.04-.131-.044-.18-.093-.358-.164-.527-.013-.029-.031-.054-.044-.083-.081-.178-.17-.352-.28-.515-.009-.013-.021-.023-.03-.036-.117-.169-.245-.331-.393-.48-.292-.293-.291-.768.002-1.06.146-.146.337-.219.529-.219.188 0 .376.073.522.214.202.203.381.427.547.661.02.029.047.054.067.083.155.23.282.478.398.732.019.041.047.079.064.121.102.24.172.496.235.754.015.063.043.123.056.186.066.323.101.657.101.999 0 2.757-2.243 5-5 5zm-1.953-3.461l0 .002c-.337-.426-.547-.957-.547-1.541 0-1.378 1.122-2.5 2.5-2.5.583 0 1.113.209 1.539.545-.07 1.899-1.593 3.422-3.492 3.494zm1.153.804c1.524-.441 2.714-1.632 3.153-3.156.044.127.081.258.106.393.023.138.041.277.041.42 0 1.378-1.122 2.5-2.5 2.5-.144 0-.285-.018-.424-.042-.137-.025-.269-.063-.398-.108l.022-.007zm-3.44-.568c-.106.107-.191.228-.265.355-.308-.649-.495-1.365-.495-2.13 0-2.757 2.243-5 5-5 .765 0 1.482.186 2.13.494-.127.075-.249.161-.357.268-.27.27-.435.616-.488.99-.399-.159-.83-.252-1.285-.252-1.93 0-3.5 1.57-3.5 3.5 0 .454.094.886.252 1.285-.374.053-.721.218-.992.49zm10.21-2.382c-.005-.045-.015-.089-.02-.135-.019-.154-.04-.307-.071-.459-.007-.04-.02-.078-.029-.117-.034-.155-.071-.309-.118-.46-.008-.027-.02-.054-.029-.081-.052-.16-.107-.317-.172-.471-.01-.024-.023-.045-.032-.068-.068-.155-.14-.308-.22-.456-.016-.03-.035-.057-.052-.087-.078-.138-.158-.274-.247-.406-.038-.056-.081-.109-.121-.164-.072-.099-.143-.2-.221-.296-.109-.132-.226-.258-.346-.381-.014-.016-.027-.032-.042-.047 0 0 0-.001-.001-.001-1.086-1.09-2.589-1.764-4.249-1.764-3.313 0-6 2.686-6 6 0 1.659.674 3.161 1.763 4.248.001 0 .001.001.002.002.042.042.088.078.131.119.097.09.193.183.296.267.105.087.215.164.325.242.045.034.088.07.135.101.141.095.286.181.434.264.019.01.038.024.059.035.156.084.316.16.48.231.014.006.028.014.043.021.161.068.326.126.492.179.021.007.04.016.061.022.158.049.319.088.481.124.032.007.064.018.096.024.16.033.324.055.488.074.035.005.07.012.106.016.201.02.404.031.608.031.244 0 .483-.019.719-.047 2.774-.332 4.967-2.552 5.25-5.34.021-.202.031-.406.031-.613 0-.204-.01-.406-.03-.607z"],"webex-meetings_16":["M12.9494 12.9494c-1.321 1.322-3.079 2.051-4.949 2.051-1.41 0-2.755-.417-3.899-1.188l.003 0c-.221-.149-.433-.313-.636-.486-.03-.025-.059-.052-.088-.078-.129-.114-.25-.237-.37-.36-.338-.393-.332-.982.04-1.353.189-.189.44-.293.707-.293.267 0 .518.103.707.292.906.907 2.195 1.428 3.536 1.428 1.34 0 2.629-.521 3.535-1.427.944-.945 1.465-2.2 1.465-3.535 0-.926-.265-1.805-.733-2.577 0-.002.001-.004.002-.005-.005-.007-.011-.013-.015-.02-.145-.237-.316-.458-.502-.671-.044-.05-.081-.105-.126-.153-.033-.035-.057-.076-.091-.11-.189-.189-.293-.44-.293-.707 0-.267.104-.518.294-.707.188-.189.439-.293.706-.293.268 0 .519.104.707.293 1.322 1.322 2.051 3.08 2.051 4.95 0 1.869-.729 3.627-2.051 4.949m-7.949-2.449c-.006 0-.042-.001-.089-.002-.559-.686-.911-1.546-.911-2.498 0-2.206 1.794-4 4-4 .948 0 1.813.34 2.499.894 0 .049.001.093.001.106 0 3.032-2.468 5.5-5.5 5.5m6.413-4.568c.012.02.021.043.034.063.134.234.242.484.329.743.034.11.076.217.103.33.01.045.03.087.04.131.052.259.081.527.081.801 0 .274-.029.541-.081.8-.01.046-.031.089-.042.136-.051.211-.108.42-.191.616-.012.028-.031.053-.044.081-.094.209-.199.413-.326.601-.003.004-.006.007-.009.01-.166.245-.365.463-.581.665-.746.695-1.733 1.053-2.726 1.053-.485 0-.967-.089-1.421-.256-.176-.068-.347-.153-.513-.245-.029-.015-.06-.027-.089-.043 2.815-.427 5.026-2.667 5.436-5.486m-9.07 4.896c-.186.185-.324.399-.421.626-.583-1.02-.922-2.197-.922-3.454 0-3.86 3.14-7 7-7 1.254 0 2.42.349 3.438.93-.22.098-.429.232-.61.413-.344.344-.527.783-.568 1.232-.68-.355-1.439-.575-2.26-.575-2.762 0-5 2.238-5 5 0 .82.211 1.583.567 2.26-.447.043-.882.226-1.224.568m11.314-8.485c-.012-.012-.026-.019-.038-.031l.004 0c-1.445-1.429-3.431-2.312-5.623-2.312-4.419 0-8 3.581-8 8 0 2.141.853 4.075 2.224 5.511.039.046.071.096.114.14.002.001.003.003.005.005.053.054.112.1.167.152.001.001.002.003.004.004 1.491 1.408 3.427 2.188 5.486 2.188 2.136 0 4.146-.832 5.657-2.344 1.511-1.511 2.343-3.52 2.343-5.656 0-2.137-.832-4.146-2.343-5.657"],"webex-meetings_20":["M10 1.0002c1.696 0 3.278.48 4.633 1.298-.41.115-.789.322-1.098.632-.472.471-.732 1.099-.732 1.767-.837-.444-1.79-.697-2.803-.697-3.313 0-6 2.686-6 6 0 1.013.253 1.966.697 2.803-.668 0-1.296.26-1.768.732-.309.309-.516.688-.63 1.098C1.48 13.2772 1 11.6962 1 10.0002c0-4.963 4.038-9 9-9m2.97 5c.014.166.03.331.03.5 0 3.584-2.916 6.5-6.5 6.5-.171 0-.337-.021-.504-.036-.618-.832-.996-1.851-.996-2.964 0-2.757 2.243-5 5-5 1.116 0 2.137.38 2.97 1m1.637 2.058c.105.247.178.51.242.775.013.057.038.11.05.167.066.323.101.657.101 1 0 .342-.035.676-.101 1-.012.057-.037.109-.05.166-.064.266-.137.528-.242.776-.009.021-.024.041-.033.062-.503 1.143-1.421 2.061-2.563 2.566-.024.011-.045.027-.069.037-.247.104-.509.177-.775.241-.056.013-.109.039-.167.051-.323.065-.658.101-1 .101-.342 0-.677-.036-1-.101-.058-.012-.11-.038-.167-.051-.266-.064-.528-.137-.775-.241-.024-.01-.045-.026-.069-.037-.356-.157-.682-.363-.989-.595 3.742-.248 6.727-3.233 6.975-6.975.233.308.44.635.597.993.01.022.026.042.035.065m-2.797 10.759c-.254.052-.514.088-.775.119-.041.004-.081.013-.122.018-.301.03-.605.046-.913.046-.308 0-.612-.016-.913-.046-.041-.005-.081-.014-.122-.018-.261-.031-.521-.067-.775-.119-.007-.002-.013-.004-.02-.005-1.757-.365-3.328-1.243-4.548-2.47-.567-.588-.565-1.521.014-2.099.293-.293.677-.44 1.061-.44.384 0 .768.147 1.06.44.019.018.04.034.059.053.121.117.243.231.372.337.119.098.243.187.368.275.031.022.061.048.093.069.15.102.306.195.464.282.01.006.019.012.029.017.161.088.327.167.496.24.01.004.019.009.029.013.162.068.327.128.495.181.02.007.038.015.058.021.154.048.311.086.469.121.037.008.072.02.109.027.152.031.305.051.459.07.046.006.09.015.136.02.201.02.403.031.607.031.204 0 .407-.011.607-.031.046-.005.09-.014.136-.02.154-.019.308-.039.459-.07.037-.007.072-.019.109-.027.158-.035.315-.073.469-.121.02-.006.038-.014.058-.021.168-.053.333-.113.495-.181.01-.004.019-.009.029-.013.169-.073.335-.152.496-.24.01-.005.019-.011.029-.017.158-.087.314-.18.465-.282.031-.021.061-.047.092-.069.125-.088.249-.177.368-.275.138-.114.27-.235.397-.361.011-.01.023-.019.034-.029.009-.01.018-.021.028-.031.126-.128.248-.261.362-.4.098-.119.187-.243.275-.368.023-.031.048-.061.07-.093.101-.151.194-.306.282-.465.005-.01.011-.018.017-.028.088-.162.166-.327.239-.496.004-.01.009-.019.013-.029.069-.162.128-.327.181-.495.007-.02.015-.039.021-.059.048-.154.086-.311.121-.468.008-.037.02-.073.027-.11.031-.151.051-.305.07-.458.006-.046.016-.09.02-.136.02-.201.031-.403.031-.607 0-.204-.011-.407-.031-.607-.004-.046-.014-.09-.02-.136-.019-.154-.039-.308-.07-.459-.007-.037-.019-.072-.027-.109-.035-.158-.073-.315-.121-.469-.006-.02-.014-.039-.021-.058-.053-.168-.112-.333-.181-.495-.004-.01-.009-.02-.013-.029-.073-.169-.151-.335-.239-.496-.006-.01-.012-.019-.017-.029-.088-.158-.181-.314-.282-.465-.022-.032-.047-.061-.07-.092-.088-.125-.177-.25-.275-.369-.123-.149-.253-.293-.39-.43-.586-.585-.586-1.535 0-2.121.292-.293.676-.439 1.06-.439.376 0 .749.144 1.039.425 1.229 1.222 2.109 2.795 2.472 4.555.001.004.002.008.003.012.052.255.089.516.119.778.004.04.014.079.018.12.03.3.046.605.046.913 0 .308-.016.612-.046.912-.004.041-.014.08-.018.121-.03.262-.067.523-.119.778-.001.003-.002.007-.003.012-.723 3.5-3.485 6.263-6.984 6.989-.007.001-.013.003-.02.005m.193.981c.059-.011.114-.029.172-.042.266-.059.531-.124.791-.204.034-.01.067-.025.101-.036.278-.089.553-.187.821-.301.019-.007.037-.018.056-.026.279-.12.553-.25.819-.395.02-.01.037-.023.056-.033.261-.144.517-.297.765-.465.066-.044.125-.095.19-.141.196-.139.392-.278.578-.432.5-.411.96-.871 1.371-1.371.154-.187.294-.383.433-.58.046-.064.096-.123.14-.188.169-.249.322-.506.467-.768.009-.018.022-.034.031-.053.147-.269.278-.545.398-.826.008-.016.016-.032.023-.048.114-.269.212-.545.302-.824.011-.033.025-.065.035-.099.08-.259.145-.524.203-.79.014-.058.032-.114.044-.173.051-.252.085-.509.117-.766.009-.076.025-.15.033-.226.033-.334.051-.671.051-1.011 0-.34-.018-.678-.051-1.012-.008-.076-.024-.15-.033-.225-.032-.258-.066-.514-.117-.766-.012-.059-.03-.115-.044-.173-.058-.266-.123-.531-.203-.79-.01-.034-.025-.067-.035-.101-.09-.278-.188-.553-.301-.822-.008-.019-.019-.036-.027-.055-.119-.279-.25-.553-.395-.82-.01-.019-.023-.037-.033-.056-.144-.261-.297-.516-.465-.764-.045-.068-.098-.13-.146-.197-.137-.193-.275-.386-.427-.571C15.889 1.4202 13.111.0002 10 .0002c-5.523 0-10 4.477-10 10 0 3.11 1.421 5.889 3.648 7.723.183.151.375.287.566.423.069.049.133.104.202.15.246.167.501.318.759.461.021.012.041.026.062.037.269.146.544.278.825.398.017.007.032.016.049.023.269.114.545.212.824.302.033.01.065.025.099.035.259.08.524.144.79.203.058.013.114.032.173.043.252.052.508.086.766.118.076.009.149.025.225.033.334.033.672.051 1.012.051.34 0 .678-.018 1.012-.051.076-.008.149-.024.225-.033.257-.032.514-.066.766-.118"],"webex-meetings_24":["M12.0003 23.0002c-.376 0-.748-.02-1.114-.057-.058-.005-.114-.018-.171-.025-.313-.036-.623-.08-.927-.142-.013-.002-.024-.006-.037-.009-2.17-.453-4.105-1.548-5.602-3.076-.234-.272-.367-.61-.367-.973 0-.401.155-.778.439-1.061.283-.283.66-.439 1.06-.439.402 0 .779.156 1.062.439 1.511 1.51 3.519 2.343 5.657 2.343 4.411 0 8-3.589 8-8 0-2.137-.832-4.146-2.344-5.657-.584-.586-.584-1.537.001-2.122.283-.283.659-.439 1.06-.439.363 0 .703.134.975.369 1.527 1.496 2.622 3.431 3.075 5.6.003.013.006.025.009.038.063.303.106.614.142.926.007.057.02.113.025.171.037.366.057.738.057 1.114 0 6.065-4.935 11-11 11m4.427-15.793c0 5.043-4.104 9.147-9.148 9.147-.258 0-.514-.015-.768-.039-.941-1.19-1.511-2.684-1.511-4.315 0-3.86 3.14-7 7-7 1.668 0 3.197.59 4.399 1.568.017.211.028.424.028.639m-8.932 10.136c5.372-.114 9.707-4.395 9.912-9.744.652.801 1.145 1.736 1.394 2.772l.001 0c.126.528.198 1.072.198 1.629 0 3.86-3.141 7-7 7-1.361 0-2.66-.39-3.778-1.11l.006-.003c-.257-.165-.5-.348-.733-.544m-3.981-.393c-.327.327-.535.724-.642 1.141-.682-1.013-1.197-2.145-1.514-3.355-.03-.115-.063-.229-.089-.346-.034-.148-.06-.3-.087-.451-.036-.195-.067-.391-.091-.59-.015-.118-.03-.236-.041-.355-.029-.328-.05-.659-.05-.994 0-6.065 4.935-11 11-11 .335 0 .666.021.994.05.119.011.236.027.355.041.199.025.395.055.591.091.151.027.301.053.45.087.119.026.234.061.351.091 1.209.317 2.34.831 3.352 1.511-.418.108-.816.316-1.143.643-.472.472-.711 1.086-.726 1.704-1.227-.768-2.671-1.218-4.224-1.218-4.419 0-8 3.582-8 8 0 1.553.448 2.998 1.215 4.224-.617.017-1.23.255-1.701.726m8.486-16.95c-6.628 0-12 5.373-12 12 0 6.627 5.372 12 12 12 6.627 0 12-5.373 12-12 0-6.627-5.373-12-12-12"],"webex-meetings_48":["M1.0002 24.0002c0-12.683 10.317-23 23-23 5.239 0 10.073 1.765 13.944 4.726-.051-.001-.102-.015-.155-.015-1.151 0-2.303.44-3.182 1.318-1.093 1.093-1.504 2.608-1.238 4.02-2.636-1.91-5.866-3.049-9.369-3.049-8.837 0-16 7.163-16 16 0 3.503 1.139 6.733 3.049 9.369-.277-.052-.558-.08-.838-.08-1.152 0-2.304.439-3.182 1.317-.919.918-1.344 2.135-1.303 3.338-2.961-3.872-4.726-8.705-4.726-13.944m33.042-9.095c0 10.529-8.565 19.095-19.095 19.095-.761 0-1.506-.068-2.242-.161-2.3-2.637-3.705-6.073-3.705-9.839 0-8.271 6.729-15 15-15 3.79 0 7.246 1.424 9.89 3.751.087.708.152 1.422.152 2.154m2.396.721c.208.306.393.626.577.948.063.11.134.217.194.329.138.255.256.521.379.784.089.192.185.38.267.575.08.193.143.393.215.591.101.273.205.546.288.824.038.122.063.25.097.373.097.357.191.713.262 1.075.006.03.008.062.013.092.344 1.832.344 3.716.003 5.549-.006.036-.009.074-.016.11-.07.355-.163.707-.258 1.057-.035.13-.063.263-.102.392-.081.272-.183.537-.28.804-.074.204-.141.413-.224.613-.078.186-.171.367-.256.551-.126.271-.247.545-.389.807-.056.104-.122.202-.18.305-.188.33-.38.658-.591.972-.008.013-.019.024-.027.037-1.063 1.564-2.415 2.915-3.976 3.981-.02.014-.039.03-.059.043-.308.208-.63.395-.954.58-.108.062-.214.132-.323.191-.256.138-.524.257-.787.38-.192.088-.379.185-.573.265-.193.08-.394.145-.592.217-.273.099-.545.204-.824.287-.122.038-.248.063-.372.097-.356.096-.714.191-1.076.262-.027.005-.057.007-.084.012-.921.174-1.855.264-2.79.264-.935 0-1.869-.09-2.79-.264-.028-.005-.057-.007-.084-.012-.362-.071-.72-.166-1.077-.262-.123-.034-.25-.059-.372-.097-.278-.083-.55-.188-.823-.287-.198-.072-.399-.137-.592-.217-.195-.08-.382-.177-.573-.265-.264-.123-.531-.242-.787-.38-.11-.059-.214-.129-.324-.191-.323-.185-.645-.372-.953-.58-.02-.013-.039-.029-.059-.043-.638-.436-1.232-.928-1.795-1.455.391.024.779.06 1.176.06 11.098 0 20.095-8.997 20.095-20.095 0-.365-.035-.722-.055-1.082.505.544.98 1.117 1.4 1.732.016.024.036.047.051.071m2.468 25.868c-.238.203-.48.402-.726.595-.343.269-.692.528-1.047.777-.262.182-.528.359-.797.531-.383.243-.77.478-1.164.697-.238.133-.48.26-.723.385-.489.25-.982.489-1.488.703-.141.059-.284.112-.426.169-.583.232-1.172.45-1.773.633-.057.017-.115.032-.171.049-2.111.626-4.325.956-6.591.956-2.266 0-4.478-.33-6.588-.955-.057-.018-.117-.033-.175-.05-.6-.184-1.188-.401-1.77-.632-.144-.058-.289-.111-.432-.172-.503-.212-.995-.452-1.482-.701-.244-.125-.488-.252-.726-.385-.394-.22-.781-.454-1.164-.698-.267-.17-.532-.346-.792-.527-.358-.25-.71-.512-1.055-.784-.242-.19-.48-.384-.714-.584-.356-.303-.704-.618-1.042-.944-.14-.136-.282-.27-.418-.409-.596-.647-.931-1.475-.931-2.359 0-.935.364-1.814 1.025-2.476.66-.661 1.539-1.024 2.475-1.024.935 0 1.813.363 2.475 1.024.084.085.176.157.262.239.288.276.578.549.886.802.269.223.553.421.834.625.136.097.264.205.402.298.312.21.636.396.959.583.124.071.242.152.367.22.302.163.615.303.926.446.163.075.322.161.489.23.248.104.502.186.755.277.246.089.487.186.738.263.147.045.301.075.45.116 1.354.373 2.773.588 4.246.588 1.472 0 2.892-.215 4.245-.588.151-.041.303-.071.451-.116.252-.077.494-.175.741-.264.251-.091.505-.172.751-.275.169-.071.33-.157.496-.234.308-.142.619-.281.919-.443.126-.068.244-.149.368-.221.324-.186.647-.372.959-.582.136-.092.263-.199.398-.296.282-.203.568-.403.838-.627.302-.248.585-.517.867-.786.092-.088.192-.165.281-.255.041-.041.076-.086.117-.128.327-.335.644-.68.941-1.042.145-.177.271-.363.406-.544.18-.239.365-.474.532-.723.127-.191.237-.39.355-.586.155-.255.315-.506.455-.77.092-.173.169-.352.254-.527.147-.3.294-.599.421-.91.055-.133.098-.27.148-.404.137-.359.27-.72.381-1.092.024-.077.038-.156.061-.234.391-1.386.615-2.842.615-4.353 0-1.518-.226-2.98-.62-4.371-.02-.071-.034-.144-.055-.214-.113-.379-.249-.747-.388-1.113-.048-.127-.089-.257-.14-.383-.131-.317-.282-.624-.433-.932-.081-.168-.154-.339-.242-.504-.145-.273-.309-.533-.47-.796-.114-.187-.218-.378-.341-.561-.174-.261-.368-.508-.557-.758-.128-.169-.244-.344-.38-.509-.326-.397-.671-.778-1.033-1.143-.01-.009-.018-.02-.028-.03-.661-.661-1.024-1.54-1.024-2.475 0-.935.364-1.814 1.025-2.475.662-.661 1.541-1.025 2.475-1.025.884 0 1.71.335 2.357.928.136.134.268.273.401.41.365.38.718.767 1.052 1.165.17.202.335.408.498.616.341.436.672.878.977 1.332.112.164.215.334.322.501.31.487.606.98.875 1.483.07.129.134.261.202.392.289.567.559 1.141.798 1.725.027.064.051.129.077.193 2.18 5.472 2.18 11.615 0 17.086-.026.065-.05.13-.077.195-.239.584-.51 1.158-.799 1.725-.067.13-.131.262-.201.391-.269.503-.565.996-.875 1.483-.107.168-.21.337-.322.502-.305.454-.636.896-.977 1.332-.163.207-.327.413-.497.615-.335.398-.688.786-1.054 1.166-.201.209-.405.413-.614.614-.334.321-.676.631-1.026.929m-1.812 2.615c.059-.039.12-.075.179-.115.615-.409 1.207-.845 1.78-1.307.047-.038.094-.073.14-.111.615-.502 1.204-1.034 1.765-1.594.004-.004.009-.007.014-.012.005-.005.008-.01.013-.015.559-.56 1.09-1.149 1.592-1.762.038-.047.074-.095.112-.143.461-.572.898-1.164 1.306-1.778.039-.059.075-.119.114-.179.399-.61.77-1.238 1.113-1.885.019-.037.038-.075.057-.113 1.735-3.319 2.721-7.091 2.721-11.095 0-4.004-.986-7.777-2.721-11.096-.019-.037-.038-.075-.057-.113-.343-.647-.714-1.275-1.113-1.885-.039-.059-.075-.119-.114-.178-.408-.614-.845-1.207-1.306-1.779-.038-.047-.074-.095-.112-.142-.502-.614-1.033-1.202-1.592-1.763-.005-.004-.008-.01-.013-.014-.002-.002-.004-.003-.005-.005-4.343-4.34-10.342-7.025-16.967-7.025-13.255 0-24 10.745-24 24 0 6.626 2.686 12.625 7.027 16.969.001 0 .001.001.002.002.001.001.003.002.005.004.564.564 1.157 1.098 1.775 1.603.045.037.09.07.134.107.575.462 1.169.9 1.785 1.31.058.039.118.075.177.113.61.398 1.238.77 1.884 1.112.039.021.078.04.118.061 3.319 1.733 7.09 2.719 11.093 2.719 4.003 0 7.774-.986 11.093-2.719.039-.021.079-.04.118-.061.646-.342 1.273-.713 1.883-1.111"],"webex-quad-camera_16":["M14.5 6c.827 0 1.5.673 1.5 1.5l0 2c0 .827-.673 1.5-1.5 1.5l-13 0C.673 11 0 10.327 0 9.5l0-2C0 6.673.673 6 1.5 6l13 0zm.5 3.5l0-2c0-.276-.225-.5-.5-.5l-13 0c-.275 0-.5.224-.5.5l0 2c0 .276.225.5.5.5l13 0c.275 0 .5-.224.5-.5zM9.5 8c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm-2 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0z"],"webex-quad-camera_20":["M18 6c1.104 0 2 .896 2 2l0 4c0 1.104-.896 2-2 2L2 14c-1.104 0-2-.896-2-2l0-4c0-1.104.896-2 2-2l16 0zm1 6l0-4c0-.551-.448-1-1-1L2 7c-.552 0-1 .449-1 1l0 4c0 .551.448 1 1 1l16 0c.552 0 1-.449 1-1zm-8.5-2.5c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-3 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l3 0zm2 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5z"],"webex-room-kit_16":["M14.5 6c.827 0 1.5.673 1.5 1.5l0 2c0 .827-.673 1.5-1.5 1.5l-13 0C.673 11 0 10.327 0 9.5l0-2C0 6.673.673 6 1.5 6l13 0zm.5 3.5l0-2c0-.276-.225-.5-.5-.5l-13 0c-.275 0-.5.224-.5.5l0 2c0 .276.225.5.5.5l13 0c.275 0 .5-.224.5-.5zM8.5 8c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-1 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l1 0z"],"webex-room-kit_20":["M19 12c0 .551-.448 1-1 1L2 13c-.552 0-1-.449-1-1l0-4c0-.551.448-1 1-1l16 0c.552 0 1 .449 1 1l0 4zm-1-6L2 6C.896 6 0 6.896 0 8l0 4c0 1.104.896 2 2 2l16 0c1.104 0 2-.896 2-2l0-4c0-1.104-.896-2-2-2z","M10.5 9.5l-1 0c-.275 0-.5.225-.5.5 0 .275.225.5.5.5l1 0c.275 0 .5-.225.5-.5 0-.275-.225-.5-.5-.5"],"webex-room-kit-plus_16":["M11 9c.552 0 1 .448 1 1l0 2c0 .552-.448 1-1 1l-6 0c-.552 0-1-.448-1-1l0-2c0-.552.448-1 1-1l6 0zm-6 3l6 0 0-2-6 0 0 2zm9.5-9c.827 0 1.5.673 1.5 1.5l0 2c0 .827-.673 1.5-1.5 1.5l-13 0C.673 8 0 7.327 0 6.5l0-2C0 3.673.673 3 1.5 3l13 0zm.5 3.5l0-2c0-.276-.225-.5-.5-.5l-13 0c-.275 0-.5.224-.5.5l0 2c0 .276.225.5.5.5l13 0c.275 0 .5-.224.5-.5zM9.5 5c.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5zm-2 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-1 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l1 0z"],"webex-room-kit-plus_20":["M18 5c1.1 0 2 .9 2 2l0 6c0 1.1-.9 2-2 2L2 15c-1.1 0-2-.9-2-2l0-6c0-1.1.9-2 2-2l16 0zm1 8l0-6c0-.551-.448-1-1-1L2 6c-.552 0-1 .449-1 1l0 6c0 .551.448 1 1 1l16 0c.552 0 1-.449 1-1zm-1.5-2c.276 0 .5.224.5.5l0 1c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5l0-1c0-.276.224-.5.5-.5z"],"webex-share_12":["M11.35 8.26746154c.683 1.594-.41 3.37099996-2.186 3.56399996-.917.099-1.909.163-2.968.169l-.15 0c-1.16 0-2.242-.071-3.232-.182-1.741-.197-2.819-1.92899996-2.187-3.50699996.337-.843.767-1.747 1.317-2.683.581-.988 1.203-1.849 1.816-2.592.213-.259.469-.452.74-.615l0-1.421c0-.553000002.448-1.0000000015 1-1.0000000015l1 0c.552 0 1 .4469999995 1 1.0000000015l0 1.441c.278.169.539.372.754.643.589.742 1.187 1.589 1.754 2.544.544.917.984 1.805 1.342 2.639zm-1.005 1.75399996c.249-.42599996.279-.90799996.086-1.35999996-.37-.863-.802-1.711-1.283-2.522-.501-.845-1.066-1.663-1.678-2.434-.355-.448-.897-.705-1.487-.705-.57 0-1.1.245-1.452.671-.639.776-1.22 1.606-1.726 2.465-.479.815-.899 1.672-1.25 2.547-.18.449-.141.927.109 1.34499996.266.445.726.735 1.262.796 1.032.117 2.081.176 3.12.176l.145 0c.953-.006 1.916-.061 2.864-.164.552-.059 1.022-.356 1.29-.815zM5.5 1.00046154l0 1.05c.16-.027.321-.05.483-.05.174 0 .346.025.517.055l0-1.055-1 0zm.5 4.2495c1.241 0 2.25 1.01 2.25 2.25 0 1.24-1.009 2.25-2.25 2.25-1.241 0-2.25-1.01-2.25-2.25 0-1.24 1.009-2.25 2.25-2.25zm0 3.5c.69 0 1.25-.56 1.25-1.25 0-.69-.56-1.25-1.25-1.25-.69 0-1.25.56-1.25 1.25 0 .69.56 1.25 1.25 1.25z"],"webex-share_16":["M14.7397374 11.148c.862 2.072-.515 4.382-2.754 4.633-1.15500004.129-2.40500004.212-3.73900004.219-.061 0-.123 0-.184 0-1.464 0-2.829-.091-4.078-.237-2.192999996-.256-3.550999996-2.506-2.754999996-4.558.425-1.096.965999996-2.272 1.658999996-3.487.733-1.284 1.516-2.405 2.288-3.371.239-.3.523-.531.823-.73l0-2.117c0-.827.673-1.5 1.5-1.5l1 0c.827 0 1.5.673 1.5 1.5l0 2.143c.308.209.598.452.84.766.74300004.966 1.49500004 2.067 2.21100004 3.309.684 1.191 1.239 2.346 1.689 3.43zm-1.068 2.479c.379-.643.432-1.407.146-2.096-.472-1.134-1.022-2.249-1.634-3.314-.638-1.108-1.35700004-2.184-2.13700004-3.198-.498-.648-1.251-1.019-2.067-1.019-.791 0-1.529.354-2.022.971-.814 1.02-1.555 2.111-2.2 3.243-.611 1.073-1.149 2.201-1.596 3.352-.265999996.686-.200999996 1.442.179 2.072.382.634 1.023 1.046 1.76 1.132 1.31.152 2.643.23 3.962.23l.179 0c1.208-.007 2.431-.078 3.63300004-.213.757-.085 1.412-.508 1.797-1.16zM6.99973736 1.5l0 1.652c.321-.09.649-.152.98-.152.345 0 .686.067 1.02.166l0-1.666c0-.276-.224-.5-.5-.5l-1 0c-.275 0-.5.224-.5.5zM8 7c1.6545 0 3 1.3455 3 3 0 1.6545-1.3455 3-3 3-1.6545 0-3-1.3455-3-3 0-1.6545 1.3455-3 3-3zm0 5c1.104 0 2-.898 2-2 0-1.102-.896-2-2-2-1.104 0-2 .898-2 2 0 1.102.896 2 2 2z"],"webex-share_20":["M18.6669 14.0273c1.108 2.551-.664 5.394-3.542 5.703-1.484.159-3.093.26-4.808.269-.079.001-.158.001-.237.001-1.883 0-3.637-.113-5.242-.292-2.82-.315-4.566-3.085-3.542-5.61.546-1.348 1.242-2.796 2.133-4.291.942-1.582 1.949-2.961 2.941-4.149.458-.549 1.019-.959 1.63-1.235l0-2.923c0-.829.672-1.5 1.5-1.5l1 0c.828 0 1.5.671 1.5 1.5l0 2.946c.624.289 1.192.717 1.651 1.288.956 1.189 1.923 2.544 2.842 4.073.882 1.466 1.595 2.887 2.174 4.22zm-1.079 3.086c.483-.831.542-1.81.161-2.688-.609-1.404-1.32-2.785-2.112-4.103-.825-1.372-1.756-2.705-2.766-3.962-.694-.864-1.751-1.36-2.897-1.36-1.114 0-2.147.473-2.836 1.299-1.055 1.264-2.014 2.616-2.85 4.02-.792 1.329-1.487 2.728-2.065 4.155-.355.873-.28 1.841.206 2.656.528.887 1.447 1.464 2.52 1.585 1.697.189 3.423.285 5.131.285l.233-.001c1.566-.008 3.149-.096 4.706-.263 1.101-.119 2.038-.71 2.569-1.623zm-8.588-15.613l0 2.6c.32-.065.647-.1.974-.1.344 0 .688.036 1.026.109l0-2.609c0-.276-.224-.5-.5-.5l-1 0c-.275 0-.5.224-.5.5zm1.00035149 7.5c2.20564511 0 4.00000001 1.7943548 4.00000001 4 0 2.2056452-1.7943549 4-4.00000001 4-2.20564516 0-4-1.7943548-4-4 0-2.2056452 1.79435484-4 4-4zm0 7c1.65485831 0 3.00000001-1.3451417 3.00000001-3 0-1.6533401-1.3451417-3-3.00000001-3-1.65334008 0-3 1.3466599-3 3 0 1.6548583 1.34665992 3 3 3z"],"webex-teams_10":["M9 5.0001l0 .002c0 .267-.029.526-.079.778-.022.107-.061.207-.091.311-.04.138-.074.278-.128.409-.057.14-.132.27-.204.401-.045.081-.084.167-.134.245-.101.156-.217.3-.338.44-.034.04-.065.083-.101.122-.147.157-.307.301-.478.433-.016.012-.03.026-.047.039-.278.207-.59.366-.918.497.007-.059.018-.116.018-.177 0-.292-.087-.562-.23-.792.031-.015.06-.034.091-.05.001 0 .003-.001.004-.002.156-.081.304-.172.443-.278.014-.011.027-.023.042-.034.124-.098.241-.202.348-.318.03-.031.053-.066.081-.098.088-.103.173-.208.246-.323.039-.06.069-.126.103-.188.053-.097.108-.192.15-.294.04-.1.066-.205.096-.309.022-.077.051-.151.067-.231.038-.187.059-.382.059-.581l0-.002c0-.276.224-.5.5-.5.275 0 .5.224.5.5m-4 4c-.009 0-.018-.002-.027-.003-.262-.001-.518-.027-.766-.077-.071-.015-.138-.044-.207-.062-.185-.048-.369-.096-.541-.169-.068-.027-.128-.07-.194-.102-.167-.081-.334-.162-.487-.264-.068-.046-.128-.106-.194-.156-.135-.104-.271-.205-.393-.325-.115-.122-.139-.262-.14-.337-.001-.077.016-.226.143-.355.127-.13.278-.15.357-.15.131 0 .256.051.35.144.086.084.184.151.279.224.052.041.099.088.154.125.113.075.234.133.355.193.053.025.101.059.156.082.127.052.26.087.394.122.057.015.11.038.167.05.185.037.375.056.567.057.009 0 .018.003.027.003.276 0 .5.224.5.5 0 .275-.224.5-.5.5m-3.521-2.549c-.054.055-.077.125-.12.185-.226-.5-.359-1.052-.359-1.636 0-.556.115-1.085.321-1.567.046.062.072.134.129.19.21.206.469.311.737.368-.114.317-.187.654-.187 1.009 0 .377.078.735.206 1.068-.266.064-.522.173-.727.383m.637-4.209c.018-.019.031-.042.05-.06.069-.071.151-.124.225-.189.702-.61 1.608-.993 2.609-.993l.001 0c.275.001.499.225.499.5 0 .275-.224.5-.5.5-.726 0-1.402.267-1.946.736-.059.051-.125.095-.18.151-.006.005-.012.009-.018.014-.127.131-.278.15-.356.15-.132 0-.256-.051-.35-.143-.185-.181-.193-.469-.034-.666M6 3.5001c0 1.378-1.122 2.5-2.5 2.5-.08 0-.155-.013-.233-.021-.165-.291-.267-.622-.267-.979 0-.549.223-1.047.583-1.409.038-.039.083-.069.124-.104.35-.299.798-.487 1.293-.487.356 0 .687.102.977.265.007.079.023.155.023.235m1 1.5c0 1.103-.897 2-2 2-.009 0-.018-.002-.027-.003-.126-.001-.25-.013-.369-.037-.04-.008-.076-.024-.115-.034-.046-.013-.092-.028-.137-.043 1.243-.314 2.217-1.288 2.531-2.531.071.204.117.42.117.648m-.521-3.709c1.016.406 1.823 1.214 2.23 2.23-.069-.01-.137-.021-.209-.021-.292 0-.562.086-.792.23-.298-.631-.807-1.14-1.438-1.438.143-.23.23-.5.23-.792 0-.072-.011-.14-.021-.209m3.49 3.40594697C9.815 2.18602186 7.814.18500185 5.304.03100031 5.206.01100011 5.104 0 5 0 3.78 0 2.644.45200452 1.734 1.24501245c-.09.07900079-.192.14700147-.277.23300233-.009.00800008-.02.01500015-.029.02400024-.015.01500015-.019.03500035-.033.05100051C.536 2.45102451 0 3.66203662 0 5.00005c0 1.38801388.57 2.64502645 1.487 3.55103551.006.00700007.008.01500015.014.02100021.15.14700147.32.26500265.485.3900039.08.06200062.152.13500135.237.19100191.195.13200132.406.23500235.618.33700337.079.03800038.15.08800088.232.12200122.22.09200092.452.15300153.684.21300213.085.02200022.165.05700057.252.07500075.314.06300063.637.09600096.965.09700097.008.00100001.017.00300003.026.00300003 2.757 0 5-2.24302243 5-5.00005 0-.10400104-.011-.20500205-.031-.30300303"],"webex-teams_12":["M10.9038 6.9518c-.018.093-.05.181-.073.272-.054.213-.114.424-.195.626-.039.097-.086.188-.131.281-.088.186-.184.368-.293.54-.057.09-.119.176-.181.261-.117.161-.244.313-.379.459-.076.082-.153.163-.234.239-.136.127-.281.242-.43.355-.101.075-.2.154-.307.221-.134.086-.279.157-.423.23-.06.031-.121.061-.183.09.024-.142.037-.286.024-.436-.033-.398-.201-.747-.449-1.021.025-.014.052-.027.077-.042.05-.028.102-.051.149-.081.099-.063.189-.136.28-.207.079-.062.157-.122.23-.19.072-.068.138-.14.204-.214.079-.087.154-.176.224-.27.052-.072.103-.145.15-.221.068-.109.128-.222.184-.338.035-.075.072-.148.103-.226.052-.134.092-.272.128-.413.018-.069.041-.136.055-.207.041-.214.066-.434.066-.66 0-.413.337-.75.75-.75.414 0 .75.337.75.75 0 .326-.036.643-.096.952m-3.545 1.141c-.098.065-.203.119-.31.169-.038.018-.074.037-.113.053-.104.042-.214.073-.325.101-.046.011-.09.027-.137.036-.152.03-.308.047-.468.047-.099 0-.196-.016-.295-.028-.061-.007-.125-.007-.186-.019-.117-.023-.231-.062-.344-.102 1.534-.437 2.731-1.632 3.172-3.163.089.256.147.527.147.813 0 .164-.018.325-.049.48-.007.043-.023.083-.033.124-.029.114-.06.225-.103.332-.016.04-.037.078-.056.117-.048.105-.102.207-.164.303-.021.032-.044.063-.066.095-.07.097-.146.189-.228.275-.024.025-.049.05-.074.074-.088.084-.181.161-.28.232-.029.02-.058.042-.088.061m-.809 2.852c-.183.02-.361.055-.55.055-.339 0-.67-.035-.99-.1-.089-.018-.173-.055-.261-.077-.229-.06-.458-.12-.674-.21-.088-.037-.168-.092-.254-.134-.203-.099-.408-.198-.595-.323-.093-.062-.173-.142-.262-.211-.162-.125-.327-.246-.472-.389-.131-.138-.208-.315-.211-.506-.002-.2.074-.39.213-.532.143-.146.334-.226.538-.226.197 0 .383.076.523.213.058.056.127.098.188.15.108.091.212.186.33.264.043.028.09.046.133.072.154.092.309.18.476.248.006.003.014.004.02.006.201.081.41.145.627.187.058.012.119.01.179.019.162.022.323.049.492.049.002 0 .004-.001.006-.001.001 0 .001.001.002.001.094 0 .188-.004.274-.011l.062-.002c.399 0 .726.295.758.686.031.364-.212.677-.552.772m-4.771-3.126c-.105.108-.188.229-.261.355-.322-.66-.518-1.391-.518-2.174 0-.75.178-1.455.475-2.094.075.126.161.247.27.355.281.277.634.434.997.483-.151.391-.242.812-.242 1.256 0 .467.095.911.261 1.318-.36.056-.707.22-.982.501m5.76-3.774c-.07 1.9-1.594 3.424-3.494 3.494-.336-.426-.545-.956-.545-1.539 0-.689.28-1.314.733-1.766.115-.115.24-.219.374-.308.001-.001.002-.001.003-.001.414-.276.905-.424 1.395-.424.581.001 1.109.209 1.534.544m-5.128-1.512c.02-.02.034-.044.053-.064.044-.044.097-.076.142-.118.641-.597 1.432-1.031 2.317-1.227.025-.005.048-.017.073-.022.325-.067.66-.102 1.004-.102.243 0 .475.038.709.072.348.099.59.427.546.797-.045.378-.363.663-.738.663-.031 0-.063-.002-.094-.006-.138-.017-.276-.026-.415-.026-.001 0-.002.001-.003.001-.001 0-.003-.001-.005-.001-.97 0-1.847.396-2.481 1.033-.004.003-.008.006-.011.009-.142.144-.332.223-.534.223-.198 0-.385-.076-.527-.216-.142-.141-.221-.329-.223-.529-.001-.182.07-.35.187-.487m5.828-.979c1.132.573 2.012 1.553 2.447 2.758-.14-.036-.284-.062-.436-.062-.393 0-.752.135-1.044.353-.296-.679-.807-1.236-1.441-1.609.257-.266.435-.61.483-1.005.017-.148.01-.293-.009-.435M6.7818.0568c-.022-.003-.042-.012-.064-.014-.015-.002-.032-.002-.048-.003-.22-.025-.443-.04-.67-.04-.205 0-.408.011-.61.031-.028.003-.055.009-.084.012-.173.02-.345.045-.514.079-.006.001-.012.003-.018.004-.941.195-1.817.612-2.567 1.226-.008.007-.016.013-.024.019-.064.053-.123.112-.185.167-.085.077-.172.152-.253.233-.005.005-.01.01-.016.015-.008.008-.013.018-.021.026-1.055 1.081-1.708 2.557-1.708 4.188 0 1.676.688 3.189 1.796 4.277.004.006.008.011.013.016.054.053.113.1.169.151.079.071.156.144.239.211.078.064.16.121.241.181.073.053.144.109.219.159.097.064.197.122.297.18.065.038.129.079.196.115.11.059.224.111.338.163.061.028.121.059.183.085.119.05.241.091.363.133.062.022.123.046.186.066.123.037.249.067.375.096.066.015.13.035.196.048.135.028.271.045.407.063.061.008.12.02.181.026.198.02.399.03.601.03.169 0 .336-.006.501-.02.012-.001.023-.006.035-.007.135-.012.266-.032.398-.053.032-.004.063-.002.095-.008.019-.003.037-.011.056-.015.308-.056.606-.137.896-.238.059-.021.117-.042.175-.064.271-.105.534-.226.785-.368.067-.038.13-.079.196-.119.237-.146.467-.302.681-.479.056-.046.106-.098.16-.146.179-.158.348-.327.507-.507.047-.053.098-.103.144-.158.175-.213.331-.441.477-.677.04-.066.081-.13.119-.197.138-.245.259-.502.362-.767.024-.062.046-.125.068-.188.099-.281.18-.569.237-.867.008-.045.013-.092.021-.139.053-.321.087-.647.087-.983 0-3.048-2.275-5.559-5.218-5.943"],"webex-teams_16":["M14.8709 9.3369c-.427 2.219-1.893 4.082-3.922 5.018.056-.247.068-.506.023-.77-.08-.471-.321-.872-.654-1.165 1.267-.66 2.186-1.835 2.525-3.237.092-.382.157-.774.157-1.183 0-.126-.005-.252-.014-.377l0-.001c-.02-.266.065-.524.239-.726.174-.204.417-.326.685-.346.026-.002.053-.003.078-.003.518 0 .953.406.992.926l0 .002c.013.174.02.348.02.525 0 .457-.046.903-.129 1.337m-5.704 5.566l-.001 0c-.382.065-.774.097-1.166.097-.235 0-.469-.014-.701-.037-1.085-.109-2.122-.479-3.036-1.057-.528-.333-1.016-.729-1.442-1.197-.001-.001-.002-.002-.002-.003-.179-.197-.271-.453-.259-.72.013-.267.129-.512.327-.692.184-.167.422-.26.671-.26.287 0 .549.116.741.327.001 0 .001.001.001.001.351.387.768.714 1.227.973.536.302 1.131.503 1.741.598.251.039.503.065.757.065.273 0 .545-.022.807-.067l.002 0c.056-.009.11-.014.165-.014.49 0 .905.351.986.834.092.543-.276 1.06-.818 1.152m-7.407-3.736c-.494-.973-.76-2.055-.76-3.167 0-1.075.248-2.125.713-3.075.111.224.264.432.464.607.359.318.801.477 1.246.493-.268.621-.423 1.288-.423 1.975 0 .715.168 1.405.455 2.044-.444.022-.885.187-1.24.51-.198.179-.347.387-.455.613m.99-7.796l0-.001c0 0 .001 0 .001-.001.42-.474.902-.878 1.423-1.219.934-.611 2.003-1 3.125-1.113.231-.023.466-.037.701-.037.392 0 .784.032 1.165.097.001 0 .002.001.002.001.263.045.492.188.646.405.156.218.216.482.172.746-.081.484-.495.835-.984.835-.056 0-.11-.005-.166-.014 0-.001-.001-.001-.002-.001-.264-.044-.534-.066-.806-.066-.254 0-.507.026-.758.065-.636.099-1.252.313-1.806.635-.454.266-.867.599-1.214.991-.19.215-.463.338-.75.338-.243 0-.479-.089-.66-.249-.414-.366-.454-.999-.089-1.412m2.25 7.129c-.031 0-.059.013-.089.019-.581-.712-.911-1.594-.911-2.519 0-.975.355-1.914.999-2.644.766-.867 1.897-1.353 3.028-1.353.215 0 .429.017.64.053l.002 0c.701.118 1.331.415 1.852.838-.007.035-.021.068-.021.106 0 3.033-2.468 5.5-5.5 5.5m6.415-4.575c.318.524.525 1.124.573 1.77 0 .001.001.002.001.003.007.1.011.201.011.302 0 1.962-1.4 3.621-3.33 3.944l-.002 0c-.212.037-.428.054-.643.054-.716 0-1.425-.215-2.05-.579 2.819-.428 5.033-2.671 5.44-5.494m-.462-4.251c1.692.787 2.99 2.211 3.617 3.97-.185-.058-.379-.097-.582-.097-.052 0-.103.002-.155.006-.475.036-.892.241-1.214.544-.444-1.085-1.256-1.978-2.296-2.521.331-.292.569-.692.649-1.161.043-.254.031-.503-.019-.741m5.024 5.731l0-.006c-.274-3.68-3.005-6.674-6.641-7.288-.001 0-.003-.001-.005-.001-.437-.073-.884-.11-1.331-.11-2.294 0-4.481.987-6 2.709-1.29 1.462-2 3.341-2 5.291 0 1.994.738 3.905 2.079 5.38.002.002.004.003.005.004 1.513 1.663 3.669 2.616 5.916 2.616.446 0 .894-.037 1.331-.11.001 0 .003-.001.004-.001 3.862-.65 6.665-3.967 6.665-7.889 0-.2-.008-.398-.023-.595"],"webex-teams_18":["M16.9619 9.751c-.011.111-.028.221-.044.331-.018.128-.035.256-.059.382-.027.145-.06.288-.095.432-.02.079-.039.158-.062.237-.048.17-.099.339-.158.504-.013.036-.025.071-.039.106-.76 2.051-2.343 3.733-4.364 4.604.097-.313.136-.65.086-.996-.086-.582-.389-1.075-.813-1.417 1.543-.758 2.681-2.215 2.994-3.959.006-.03.009-.06.014-.091.047-.288.078-.582.078-.884 0-.246-.021-.487-.054-.725-.004-.03-.002-.063-.006-.093-.1-.682.374-1.319 1.055-1.418.062-.01.123-.014.184-.014.594 0 1.099.432 1.215 1.009.01.066.021.132.03.199.045.344.076.693.076 1.042 0 .253-.015.503-.038.751m-6.017 3.289c-.107.052-.215.103-.327.147-.157.061-.319.107-.484.15-.11.029-.22.061-.334.082-.257.047-.52.08-.79.08-.626 0-1.242-.133-1.809-.38-.052-.022-.096-.055-.146-.079-.096-.046-.184-.105-.276-.157 3.115-.539 5.572-2.999 6.105-6.114.382.66.616 1.415.616 2.231 0 .292-.033.577-.086.854-.025.125-.068.244-.103.365-.041.144-.078.29-.133.428-.056.14-.127.272-.196.405-.057.11-.111.22-.176.324-.081.13-.174.251-.268.372-.076.097-.152.194-.235.285-.098.106-.202.206-.31.302-.101.092-.206.179-.315.261-.106.079-.214.153-.326.223-.131.081-.268.154-.407.221m-.711 3.855c-.063.01-.126.021-.191.029-.345.045-.694.076-1.043.076-.28 0-.559-.015-.835-.044-.024-.003-.049-.009-.073-.012-.251-.028-.5-.066-.746-.118-.031-.007-.061-.017-.091-.024-.235-.052-.47-.114-.699-.187-.052-.017-.103-.039-.155-.057-.2-.069-.399-.142-.593-.227-.083-.036-.162-.079-.243-.117-.157-.075-.312-.15-.463-.234-.107-.061-.21-.126-.314-.191-.116-.073-.233-.145-.346-.223-.121-.084-.237-.173-.352-.264-.089-.069-.178-.139-.265-.212-.121-.104-.239-.212-.354-.322-.074-.072-.148-.144-.22-.218-.072-.075-.141-.153-.21-.232-.416-.51-.375-1.262.119-1.71.231-.209.528-.324.838-.324.359 0 .689.146.928.41.037.04.078.076.116.115.053.055.107.108.162.161.076.073.154.145.236.214.062.053.126.104.192.154.075.059.151.118.229.172.086.06.176.116.266.171.062.037.121.077.184.112.127.071.258.136.391.197.03.014.059.03.089.043.677.299 1.423.467 2.209.467.245 0 .484-.021.721-.053.03-.004.063-.002.093-.007.061-.008.122-.012.181-.012.618 0 1.153.459 1.242 1.067.097.663-.352 1.273-1.003 1.4m-7.746-5.028c-.263.239-.449.529-.571.839-.583-1.109-.917-2.369-.917-3.706 0-1.047.208-2.045.575-2.962.154.295.367.563.654.774.401.295.869.438 1.332.438.081 0 .16-.019.24-.027-.192.558-.301 1.154-.301 1.777 0 .816.184 1.588.504 2.285-.002 0-.004-.001-.006-.001-.538 0-1.079.193-1.51.583m.042-7.553c.058-.08.117-.159.177-.237.092-.118.188-.232.286-.343.091-.104.182-.207.278-.306.122-.124.249-.241.378-.357.079-.072.155-.148.237-.216.22-.182.448-.354.684-.511.034-.022.069-.041.102-.062.217-.139.437-.269.665-.386.056-.029.112-.054.169-.082.211-.102.427-.197.646-.281.064-.024.128-.048.193-.07.217-.077.437-.143.661-.201.069-.018.138-.037.207-.053.227-.053.456-.092.686-.124.069-.01.135-.023.205-.031.295-.034.595-.054.896-.054.356 0 .709.032 1.057.078.059.008.118.018.176.027.654.126 1.103.74 1.003 1.404-.09.608-.619 1.066-1.228 1.066-.063 0-.126-.005-.193-.015-.032-.005-.063-.003-.094-.007-.237-.031-.476-.053-.721-.053-.204 0-.405.013-.604.035-.087.009-.173.027-.26.04-.105.016-.209.032-.312.055-.113.024-.223.055-.335.086-.067.019-.134.039-.202.06-.127.042-.253.088-.377.139-.039.016-.078.034-.116.051-.586.256-1.122.614-1.591 1.064-.039.038-.08.075-.118.114-.08.081-.155.167-.23.253-.061.069-.12.14-.176.212-.036.045-.075.086-.111.133-.237.323-.604.508-1.007.508-.268 0-.523-.084-.74-.244-.268-.198-.444-.488-.495-.818-.047-.31.032-.615.204-.874m9.462 1.35c-.087 3.453-2.875 6.241-6.328 6.328-.716-.797-1.164-1.839-1.164-2.992 0-1.233.5-2.35 1.306-3.163.013-.014.028-.027.042-.041.394-.388.86-.705 1.375-.927.017-.008.034-.015.051-.022.251-.105.514-.186.786-.244.032-.007.065-.012.097-.018.274-.052.554-.085.843-.085 1.152 0 2.194.448 2.992 1.164m.234-3.007c.052-.354.012-.697-.09-1.015 1.892.809 3.412 2.328 4.222 4.221-.216-.069-.444-.113-.679-.113-.109 0-.218.008-.328.024-.581.085-1.074.39-1.416.813-.537-1.094-1.425-1.982-2.518-2.52.421-.342.723-.833.809-1.41m5.688 5.17c-.006-.051-.003-.103-.011-.154-.006-.048-.023-.092-.033-.139-.626-3.795-3.627-6.79-7.426-7.407-.038-.008-.072-.022-.111-.028-.047-.007-.096-.005-.142-.011C9.7999.036 9.4039 0 8.9999 0c-.342 0-.677.023-1.009.061-.077.008-.152.023-.229.034-.261.037-.519.081-.773.139-.078.018-.154.04-.232.06-.252.065-.5.141-.744.227-.072.025-.145.051-.216.079-.248.094-.49.2-.728.316-.063.031-.127.06-.19.092-.257.133-.506.278-.748.434-.037.024-.076.045-.113.069-.268.179-.526.371-.772.576-.091.076-.175.16-.263.239-.146.132-.292.265-.429.406-.107.11-.208.226-.31.342-.112.127-.22.256-.324.389-.055.069-.116.131-.169.203-.025.035-.041.073-.064.109C.6289 5.25-.0001 7.051-.0001 9c0 2.273.854 4.347 2.249 5.933.03.037.052.077.084.113.063.069.132.128.196.195.083.085.168.169.254.251.128.123.258.242.393.357.099.085.202.165.306.245.127.099.254.199.387.291.13.09.264.173.399.256.114.071.227.144.344.21.172.096.349.181.527.266.09.043.177.09.268.13.219.096.445.179.672.257.058.02.113.044.171.062.258.084.523.153.791.213.032.007.065.018.097.025.274.058.553.101.837.133.029.003.057.01.086.013.309.032.622.05.939.05.399 0 .789-.035 1.174-.085.051-.007.101-.004.152-.012.001 0 .002 0 .004-.001l.001 0c.094-.013.184-.037.277-.054.117-.021.233-.043.348-.068.164-.037.325-.08.486-.126.117-.033.234-.065.349-.102.145-.048.286-.102.428-.157.127-.049.255-.096.379-.15.105-.047.208-.1.311-.151.155-.074.31-.148.459-.232.017-.008.031-.019.047-.028 1.592-.9 2.878-2.272 3.679-3.924.005-.011.011-.021.015-.032.105-.219.202-.441.29-.669.014-.039.028-.079.042-.118.076-.205.147-.413.208-.625.021-.075.039-.153.058-.229.047-.183.094-.365.129-.553.025-.131.042-.265.062-.398.02-.141.044-.281.058-.424.028-.284.044-.571.044-.862 0-.398-.035-.788-.086-1.173"],"webex-voice_16":["M12.5 8c.332 1.328.5 2.692.5 4.062L13 14c0 1.104-.896 2-2 2l-6 0c-1.104 0-2-.896-2-2l0-1.938c0-1.37.168-2.734.5-4.062.332-1.328.5-2.692.5-4.062L4 2c0-1.104.896-2 2-2l4 0c1.104 0 2 .896 2 2l0 1.938c0 1.37.168 2.734.5 4.062zm-.5 6l0-1.938c0-1.287-.158-2.572-.47-3.819-.351-1.407-.53-2.855-.53-4.305L11 2c0-.551-.448-1-1-1L6 1c-.552 0-1 .449-1 1l0 1.938c0 1.45-.179 2.898-.53 4.305C4.158 9.49 4 10.775 4 12.062L4 14c0 .551.448 1 1 1l6 0c.552 0 1-.449 1-1zM9.5 2c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-3 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l3 0zM8 7c1.103 0 2 .897 2 2 0 1.103-.897 2-2 2-1.103 0-2-.897-2-2 0-1.103.897-2 2-2zm0 3c.55 0 1-.45 1-1 0-.55-.45-1-1-1-.55 0-1 .45-1 1 0 .55.45 1 1 1z"],"webex-voice_20":["M15.5 10c.332 1.663.5 3.354.5 5.049l0 2.451c0 1.381-1.119 2.5-2.5 2.5l-7 0C5.119 20 4 18.881 4 17.5l0-2.451c0-1.695.168-3.386.5-5.049.332-1.663.5-3.354.5-5.049L5 2.5C5 1.119 6.119 0 7.5 0l5 0C13.881 0 15 1.119 15 2.5l0 2.451c0 1.695.168 3.386.5 5.049zm-.5 7.5l0-2.451c0-1.626-.162-3.258-.48-4.853-.345-1.723-.52-3.488-.52-5.245L14 2.5c0-.827-.673-1.5-1.5-1.5l-5 0C6.673 1 6 1.673 6 2.5l0 2.451c0 1.757-.175 3.522-.52 5.245-.318 1.595-.48 3.227-.48 4.853L5 17.5c0 .827.673 1.5 1.5 1.5l7 0c.827 0 1.5-.673 1.5-1.5zM11.5 3c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-3 0c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5l3 0zM10 10c1.103 0 2 .897 2 2 0 1.103-.897 2-2 2-1.103 0-2-.897-2-2 0-1.103.897-2 2-2zm0 3c.552 0 1-.449 1-1 0-.551-.448-1-1-1-.552 0-1 .449-1 1 0 .551.448 1 1 1z"],"whiteboard_10":["M8.14506079 2.9261513L7.06209628 1.84133423l.63097933-.63205869c.28899052-.289484891.79397397-.289484891 1.0829645 0 .14499525.14524328.22399266.33756542.22399266.54190769 0 .20534395-.07899741.39766609-.22399266.54290938l-.63097932.63205869zM2.53824455 8.54255879l-1.38395465.30150502.30099014-1.38632209 4.89983941-4.90822127 1.08296451 1.08481707-4.89983941 4.90822127zM6.98609878.501089325L.644306616 6.85373c-.067997771.06811409-.114996231.15425838-.135995543.24841609L.0113273611 9.39298325c-.0359988202.16627851.0149995084.33956877.1359955429.45977011C.241319824 9.94791275.369315629 10 .500311336 10c.034998852 0 .070997673-.00400671.105996526-.01101846l2.286925048-.49783387c.09399692-.02103523.1799941-.06811409.24799187-.13622818l6.34179216-6.35264067C9.817006 2.66872011 10 2.22397516 10 1.75118323c0-.47179025-.182994-.916535195-.51698306-1.250093905-.66697814-.6681191-1.82994002-.6681191-2.49691816 0z"],"whiteboard_12":["M10.6933372 2.78575l-.85000002.85-1.48-1.481.85-.849c.395-.396 1.08400002-.396 1.48000002 0 .198.197.307.46.307.74 0 .28-.109.542-.307.74zm-7.64800002 7.647l-1.892.412.412-1.892 6.091-6.091 1.48 1.481-6.091 6.09zm8.35500002-9.835c-.798-.797-2.09700002-.797-2.89500002 0l-7.751000001 7.752c-.068.068-.115.154-.135.247l-.6080000004 2.795c-.036.167.015.34.1350000004.46.095.095.223.147.354.147.035 0 .071-.004.106-.011l2.795000001-.608c.094-.021.18-.068.247-.136l7.75200002-7.751c.387-.387.6-.9.6-1.447 0-.547-.213-1.061-.6-1.448z"],"whiteboard_14":["M12.6113372 3.245l-1.069 1.068-1.87800002-1.878 1.06900002-1.068c.501-.502 1.376-.502 1.878 0 .518.518.518 1.36 0 1.878zm-9.05700002 9.057l-2.4.522.521-2.4 7.282-7.282L10.8353372 5.02l-7.28100002 7.282zM13.3183372.66c-.879-.88-2.414-.88-3.292 0L.865337179 9.821c-.068.068-.115.153-.135.247l-.7190000004 3.303c-.036.167.015.34.1350000004.46.095.095.223.147.354.147.035 0 .071-.004.106-.011l3.304000001-.719c.093-.02.179-.067.247-.135l9.16100002-9.161c.908-.908.908-2.384 0-3.292z"],"whiteboard_16":["M1.7858 11.9318705l-.632 2.9114582 2.907-.6329692 10.467-10.48205068c.305-.30446621.472-.70908579.472-1.13974524 0-.43065944-.167-.83527902-.472-1.13974523-.607-.609933961-1.668-.609933961-2.275 0L1.7858 11.9318705zM.4998 16.0001c-.131 0-.259-.0520797-.354-.1472254-.12-.1201841-.171-.2944509-.134-.4607055l.829-3.8168445c.02-.0941442.067-.1802761.134-.2483804L11.5458.740734096c.984-.987512128 2.705-.987512128 3.689 0 .493.492754534.765 1.149760574.765 1.847829484 0 .69806892-.272 1.35407343-.765 1.84782949L4.6648 15.0226032c-.067.0671028-.153.1141748-.247.135207l-3.812.8302714c-.035.0080123-.071.0120184-.106.0120184z","M10.7071070818 1.9999998763l3.1464466106 3.1464466106-.7071067812.7071067812-3.1464466106-3.1464466106z"],"whiteboard_24":["M21.281 6.186l-1.943 1.943-3.469-3.469 1.943-1.944c.957-.956 2.512-.956 3.469 0 .957.957.957 2.513 0 3.47zM6.587 20.881l-4.433.963.963-4.433L15.162 5.367l3.469 3.469L6.587 20.881zM21.988 2.009c-1.346-1.345-3.537-1.345-4.883 0L2.306 16.808c-.067.068-.114.154-.134.247l-1.161 5.337c-.036.166.015.339.135.46.095.094.223.146.354.146.035 0 .071-.004.106-.012l5.337-1.16c.094-.02.18-.067.247-.135L21.988 6.893c1.347-1.347 1.347-3.537 0-4.884z"],"whiteboard_26":["M24.1167324 6.14575l-2.381 2.381-4.265-4.265 2.381-2.381c1.14-1.139 3.125-1.139 4.265 0 .57.57.883 1.327.883 2.133 0 .805-.313 1.562-.883 2.132zm-17.51299997 17.514l-5.45 1.184 1.185-5.449 14.42499997-14.426 4.265 4.265-14.42499997 14.426zm18.21999997-22.486c-1.565-1.565-4.113-1.565-5.679 0l-17.61699997 17.618c-.068.067-.115.153-.136.247l-1.3800000041 6.353c-.037.166.015.339.1350000001.46.095.094.222.146.353.146.035 0 .071-.004.106-.011l6.353000004-1.381c.094-.021.18-.067.248-.135l17.61699997-17.618c1.566-1.565 1.566-4.113 0-5.679z"],"whiteboard_28":["M25.1168405 7.148l-2.381 2.381-4.265-4.265 2.381-2.381c1.14-1.139 3.126-1.139 4.265 0 .569.57.883 1.327.883 2.133 0 .805-.314 1.562-.883 2.132zM7.60284049 24.662l-5.449 1.184 1.185-5.449L17.7638405 5.971l4.265 4.265L7.60284049 24.662zM25.8238405 2.176c-.758-.758-1.767-1.176-2.839-1.176-1.073 0-2.081.418-2.84 1.176L2.52784049 19.794c-.068.067-.115.153-.135.247l-1.3809999987 6.353c-.037.166.014.339.1349999997.46.095.094.222.146.353.146.036 0 .071-.004.106-.012l6.353999999-1.381c.094-.02.179-.067.247-.134L25.8238405 7.855c.759-.758 1.176-1.767 1.176-2.839 0-1.073-.417-2.081-1.176-2.84z"],"whiteboard_32":["M28.9518504 8.108l-2.818 2.818-5.061-5.06 2.818-2.819c1.352-1.351 3.709-1.351 5.061 0 .676.676 1.048 1.575 1.048 2.531 0 .956-.372 1.854-1.048 2.53zM8.61885044 28.441l-6.466 1.405 1.405-6.466L20.3658504 6.573l5.061 5.06L8.61885044 28.441zM29.6588504 2.34c-.864-.865-2.015-1.34-3.237-1.34-1.223 0-2.373.475-3.238 1.34L2.74785044 22.777c-.067.067-.114.153-.135.247l-1.6009999978 7.369c-.037.166.014.34.1339999998.46.095.095.223.147.354.147.035 0 .071-.004.106-.012l7.368999998-1.602c.094-.02.18-.067.248-.134L29.6588504 8.815c.865-.864 1.341-2.015 1.341-3.237 0-1.223-.476-2.373-1.341-3.238z"],"whiteboard_36":["M32.7873372 9.068l-3.256 3.256-5.856-5.856 3.256-3.255c.782-.783 1.822-1.213 2.928-1.213 1.106 0 2.146.43 2.928 1.213.782.782 1.213 1.821 1.213 2.927 0 1.106-.431 2.146-1.213 2.928zM9.63633718 32.219l-7.483 1.627 1.627-7.483L22.9683372 7.175l5.856 5.856L9.63633718 32.219zM33.4943372 2.506c-.971-.972-2.262-1.506-3.635-1.506-1.373 0-2.664.534-3.635 1.506L2.96933718 25.76c-.068.068-.115.154-.135.247l-1.8230000014 8.386c-.036.167.015.34.1350000004.46.095.095.223.147.354.147.035 0 .071-.004.106-.012l8.386000001-1.823c.093-.02.179-.067.247-.135L33.4943372 9.775c.971-.971 1.506-2.262 1.506-3.635 0-1.373-.535-2.664-1.506-3.634z"],"whiteboard_8":["M6.8581 1.82649l-.412.412-.685-.685.412-.413c.189-.188.496-.188.685 0 .189.189.189.497 0 .686zm-4.829 4.829l-.875.19.19-.875 3.71-3.71.685.685-3.71 3.71zm5.536-6.222c-.579-.579-1.52-.578-2.099 0l-4.933 4.934c-.068.067-.115.153-.135.247l-.387 1.778c-.036.167.015.34.135.46.095.095.223.147.354.147.035 0 .071-.004.106-.011l1.779-.387c.094-.021.179-.067.247-.135l4.933-4.933c.579-.579.579-1.52 0-2.1z"],"whiteboard-content_16":["M16 7.4971l0 5.503c0 .002 0 .004 0 .006-.003 1.1-.898 1.994-2 1.994l-12 0c-1.103 0-2-.897-2-2l0-8c0-1.103.897-2 2-2l5.5 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5l-5.5 0c-.551 0-1 .449-1 1l0 8c0 .552.449 1 1 1l12 0c.551 0 1-.448 1-1l0-5.5c0-.276.225-.5.5-.5.275 0 .499.223.5.497zM5.5682 8.88c.019-.085.062-.164.124-.226l7.105-7.106c.366-.365.846-.548 1.327-.548.48 0 .961.183 1.326.548.732.732.732 1.922 0 2.654l-7.105 7.105c-.062.062-.141.105-.227.124l-2.562.557c-.032.007-.065.011-.097.011-.121 0-.238-.048-.324-.135-.11-.11-.157-.269-.124-.421l.557-2.563zm.943.369l-.344 1.583 1.583-.344 5.545-5.545-1.239-1.239-5.545 5.545zm6.993-6.993l-.741.741 1.239 1.239.741-.741c.342-.342.342-.898 0-1.239-.165-.165-.384-.256-.619-.256-.235 0-.455.091-.62.256z"],"whiteboard-content_24":["M23.1943 1.7789c.52.52.806 1.21.806 1.945 0 .734-.286 1.424-.806 1.944l-11.275 11.275c-.068.068-.154.115-.247.135l-4.066.884c-.036.008-.071.012-.106.012-.132 0-.259-.052-.354-.147-.12-.12-.171-.294-.135-.46l.884-4.065c.02-.094.067-.18.135-.247l11.275-11.276c1.039-1.039 2.85-1.039 3.889 0zm-.707 3.182c.331-.331.513-.771.513-1.237 0-.467-.182-.907-.513-1.238-.662-.661-1.812-.661-2.475 0l-1.396 1.397 2.475 2.474 1.396-1.396zm-11.172 11.172l9.068-9.068-2.474-2.475-9.068 9.068-.688 3.162 3.162-.687zM23.5 9.9736c.275 0 .5.225.5.5l0 10c0 1.379-1.122 2.5-2.5 2.5l-19 0c-1.378 0-2.5-1.121-2.5-2.5l0-13c0-1.379 1.122-2.5 2.5-2.5l9 0c.275 0 .5.225.5.5 0 .275-.225.5-.5.5l-9 0c-.827 0-1.5.673-1.5 1.5l0 13c0 .827.673 1.5 1.5 1.5l19 0c.827 0 1.5-.673 1.5-1.5l0-10c0-.275.225-.5.5-.5z"],"widgets-adr_20":["M4 18c-1.1 0-2-.9-2-2l0-3c0-1.1.9-2 2-2l3 0c1.1 0 2 .9 2 2l0 3c0 1.1-.9 2-2 2l-3 0zm-1-5l0 3c0 .552.448 1 1 1l3 0c.552 0 1-.448 1-1l0-3c0-.553-.448-1-1-1l-3 0c-.552 0-1 .447-1 1zm10 5c-1.1 0-2-.9-2-2l0-3c0-1.1.9-2 2-2l3 0c1.1 0 2 .9 2 2l0 3c0 1.1-.9 2-2 2l-3 0zm-1-5l0 3c0 .552.448 1 1 1l3 0c.552 0 1-.448 1-1l0-3c0-.553-.448-1-1-1l-3 0c-.552 0-1 .447-1 1zM4 9c-1.1 0-2-.9-2-2l0-3c0-1.1.9-2 2-2l3 0c1.1 0 2 .9 2 2l0 3c0 1.1-.9 2-2 2L4 9zM3 4l0 3c0 .552.448 1 1 1l3 0c.552 0 1-.448 1-1l0-3c0-.552-.448-1-1-1L4 3c-.552 0-1 .448-1 1zm12.9144 5.036c-.778.777-2.051.777-2.828 0l-2.122-2.122c-.778-.778-.778-2.05 0-2.828l2.122-2.122c.777-.778 2.05-.778 2.828 0l2.121 2.122c.778.778.778 2.05 0 2.828l-2.121 2.122zm-4.243-2.829l2.122 2.122c.389.39 1.023.39 1.414 0l2.121-2.122c.39-.39.39-1.024 0-1.414l-2.121-2.122c-.391-.39-1.024-.39-1.414 0l-2.122 2.122c-.39.39-.39 1.023 0 1.414z"],"wifi_12":["M11.5 5.2783c-.128 0-.256-.049-.354-.146C9.772 3.7573 7.944 3.0003 6 3.0003c-1.944 0-3.772.757-5.146 2.132-.196.195-.512.195-.708 0-.195-.196-.195-.512 0-.708C1.71 2.8613 3.789 2.0003 6 2.0003c2.211 0 4.29.861 5.854 2.424.195.196.195.512 0 .708-.098.097-.226.146-.354.146zM8.0625 8.8545c-.128 0-.256-.049-.354-.146-.912-.915-2.505-.915-3.417 0-.196.195-.512.195-.708 0-.195-.196-.195-.512 0-.708 1.29-1.291 3.543-1.291 4.833 0 .195.196.195.512 0 .708-.098.097-.226.146-.354.146zm1.7187-1.7881c-.128 0-.256-.049-.354-.146-.915-.916-2.132-1.42-3.427-1.42-1.295 0-2.513.504-3.428 1.42-.195.195-.512.195-.707 0-.195-.196-.195-.512 0-.708 1.104-1.104 2.572-1.712 4.135-1.712 1.562 0 3.03.608 4.135 1.712.195.196.195.512 0 .708-.098.097-.226.146-.354.146zM6.5 10c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5z"],"wifi_16":["M7.5 14.4998c0-.275.225-.5.5-.5.275 0 .5.225.5.5 0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5zm.49983538-8.5c1.95 0 3.78600002.646 5.31000002 1.868.215.173.25.488.077.703-.099.123-.243.187-.39.187-.11 0-.221-.036-.312-.11-1.345-1.078-2.96500002-1.648-4.68500002-1.648-1.72 0-3.34.57-4.685 1.648-.212.173-.529.14-.702-.077-.173-.215-.138-.53.077-.703 1.524-1.222 3.36-1.868 5.31-1.868zM15.8123354 4.742c.216.173.25.487.077.703-.098.123-.243.187-.389.187-.111 0-.221-.036-.313-.11-2.058-1.65-4.543-2.522-7.18700002-2.522-2.645 0-5.13.872-7.188000001 2.522-.213.172-.529.139-.702-.077-.1730000002-.216-.1390000002-.53.077-.703C2.39233538 2.974 5.16633538 2 8.00033538 2c2.83300002 0 5.60700002.974 7.81200002 2.742zM5.19803538 11.0008c1.635-1.31 3.969-1.31 5.60400002 0 .215.173.25.487.078.703-.1.123-.245.188-.391.188-.11 0-.221-.037-.312-.11-1.27800002-1.023-3.07700002-1.023-4.35400002 0-.213.171-.528.138-.703-.078-.172-.216-.138-.53.078-.703z"],"wifi_20":["M10.5 16.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5.276 0 .5.224.5.5zm3.0356-3.0356c-.128 0-.256-.049-.354-.146-1.754-1.755-4.609-1.755-6.364 0-.195.195-.511.195-.707 0-.195-.196-.195-.512 0-.708 2.145-2.144 5.634-2.144 7.779 0 .195.196.195.512 0 .708-.098.097-.226.146-.354.146zm5.6568-5.6568c-.128 0-.256-.049-.354-.146-2.36-2.361-5.5-3.662-8.838-3.662-3.339 0-6.478 1.301-8.839 3.662-.196.195-.512.195-.707 0-.196-.196-.196-.512 0-.708 2.55-2.549 5.94-3.954 9.546-3.954 3.606 0 6.996 1.405 9.546 3.954.195.196.195.512 0 .708-.098.097-.226.146-.354.146zm-2.8286 2.8286c-.128 0-.256-.049-.354-.146-1.605-1.606-3.739-2.49-6.01-2.49-2.27 0-4.405.884-6.01 2.49-.195.195-.512.195-.707 0-.195-.196-.195-.512 0-.708 1.794-1.794 4.18-2.782 6.717-2.782 2.538 0 4.923.988 6.718 2.782.195.196.195.512 0 .708-.098.097-.226.146-.354.146z"],"wifi_24":["M11.5 20.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5 0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5zm-4.3471-4.544c1.312-1.262 3.034-1.956 4.847-1.956 1.815 0 3.536.691 4.845 1.948.199.191.205.507.014.706-.191.2-.507.208-.707.015-1.122-1.076-2.596-1.669-4.152-1.669-1.554 0-3.029.596-4.153 1.677-.097.094-.222.139-.347.139-.131 0-.262-.051-.36-.153-.192-.199-.185-.516.013-.707zm16.6956-7.1464c.198.192.202.509.01.707-.192.197-.51.203-.707.01-3.003-2.919-6.963-4.527-11.152-4.527-4.188 0-8.148 1.608-11.151 4.527-.097.095-.223.141-.349.141-.13 0-.26-.05-.358-.151-.192-.198-.188-.515.01-.707 3.191-3.102 7.399-4.81 11.848-4.81 4.451 0 8.659 1.708 11.849 4.81zM11.9999 9c3.206 0 6.219 1.248 8.485 3.515.196.195.196.511 0 .707-.097.097-.225.146-.353.146-.128 0-.256-.049-.354-.146-2.077-2.077-4.84-3.222-7.778-3.222-2.938 0-5.701 1.145-7.778 3.222-.196.195-.512.195-.707 0-.196-.196-.196-.512 0-.707C5.7809 10.248 8.7939 9 11.9999 9z"],"wifi-error_12":["M8.5 5C10.43 5 12 6.57 12 8.5c0 1.93-1.57 3.5-3.5 3.5C6.57 12 5 10.43 5 8.5c0-.095.021-.184.028-.276-.27.113-.523.27-.737.484-.195.195-.512.195-.707 0-.195-.195-.195-.512 0-.707.472-.473 1.073-.768 1.709-.894.278-.638.742-1.174 1.323-1.547-.204-.028-.407-.06-.616-.06-1.295 0-2.513.504-3.428 1.42-.195.195-.511.195-.707 0-.195-.195-.195-.512 0-.707C2.97 5.108 4.438 4.5 6 4.5c.832 0 1.633.184 2.37.513.044-.001.085-.013.13-.013zm0 6C9.879 11 11 9.879 11 8.5 11 7.121 9.879 6 8.5 6 7.121 6 6 7.121 6 8.5 6 9.879 7.121 11 8.5 11zm2.6465-5.8682c-1.374-1.375-3.202-2.132-5.146-2.132-1.945 0-3.773.757-5.147 2.132-.195.195-.512.195-.707 0-.195-.195-.195-.512 0-.707 1.563-1.564 3.643-2.425 5.854-2.425 2.21 0 4.29.861 5.853 2.425.195.195.195.512 0 .707-.098.098-.226.146-.353.146-.128 0-.256-.048-.354-.146zM8.5 7c.275 0 .5.225.5.5l0 1c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5l0-1c0-.275.225-.5.5-.5zM8 9.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5 0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5z"],"wikipedia_16":["M15.9666 2.9395l-3.307 0-.042.03 0 .289c0 .034.016.063.046.084.032.023.063.035.097.035l.274.014c.339.014.432.082.563.195.131.117.146.315.045.595l-2.927 6.946-.112-.031-1.859-3.802c.026-.052.043-.089.043-.089l1.521-2.843c.177-.301.347-.569.434-.693.159-.228.247-.271.68-.292.089 0 .134-.039.134-.119l0-.287-.033-.031c0 0-1.861-.005-2.689 0l-.041.03 0 .288c0 .035.015.063.045.085.031.022.063.034.097.034l.133.015c.337.013.494.102.54.157.081.099.121.206-.075.633l-1.17 2.333-1.057-2.163c-.347-.692-.433-.906.09-.947l.207-.029c.1 0 .149-.036.149-.104l0-.303-.075-.025c0 0-1.968 0-2.853.001l-.041.03 0 .303c0 .068.072.086.208.104.49.065.48.116.964 1.075.073.144.285.577.285.577l1.103 2.166c0 0 .126.28.32.711l-1.602 3.197-.092-.023c0 0-2.486-5.245-3.207-7-.074-.181-.109-.316-.109-.399 0-.178.162-.275.483-.288l.375-.016c.1 0 .15-.038.15-.118l0-.288-.034-.029c0 0-2.978-.004-3.594 0l-.034.029 0 .303c0 .055.07.088.208.103.378.02.627.081.746.182.119.101.245.358.412.758.905 2.172 2.826 6.047 3.761 8.254.27.603.609.696 1.02-.018.423-.785 1.274-2.525 1.897-3.81.583 1.282 1.375 3.015 1.757 3.802.305.629.651.69 1.004.019.921-2.048 3.612-8.208 3.612-8.208.117-.303.279-.535.488-.704.208-.168.529-.262.962-.281.088 0 .133-.04.133-.118l0-.289-.033-.03z"],"window-corner-scrub_16":["M7.50025 13.00025c-.128 0-.256-.049-.354-.146l-4-4c-.195-.196-.195-.512 0-.708.196-.195.512-.195.708 0l4 4c.195.196.195.512 0 .708-.098.097-.226.146-.354.146zm-3 1c-.128 0-.256-.049-.354-.146l-2-2c-.195-.196-.195-.512 0-.708.196-.195.512-.195.708 0l2 2c.195.196.195.512 0 .708-.098.097-.226.146-.354.146z"],"window-vertical-scrub_16":["M14.5 7.503l-6 0 0-4.8 2.146 2.151c.196.195.512.195.708 0 .195-.196.195-.512 0-.708l-3-3.005c-.093-.092-.221-.139-.349-.14C8.003 1.001 8.002 1 8 1c-.13 0-.26.047-.354.141l-3 3.005c-.195.196-.195.512 0 .708.098.097.226.146.354.146.128 0 .256-.049.354-.146L7.5 2.702l0 4.801-6 0c-.275 0-.5.225-.5.5 0 .275.225.5.5.5l6 0 0 4.797-2.146-2.151c-.196-.195-.512-.195-.708 0-.195.196-.195.512 0 .708l3 3.005c.188.188.52.188.708 0l3-3.005c.195-.196.195-.512 0-.708-.098-.097-.226-.146-.354-.146-.128 0-.256.049-.354.146L8.5 13.301l0-4.798 6 0c.275 0 .5-.225.5-.5 0-.275-.225-.5-.5-.5"],"youtube-circle_24":["M12 0c6.628 0 12 5.372 12 12 0 6.628-5.372 12-12 12-6.627 0-12-5.372-12-12C0 5.372 5.373 0 12 0zm5.717 14.907c.251-.942.251-2.907.251-2.907 0 0 0-1.965-.251-2.907-.138-.52-.544-.929-1.061-1.068-.936-.253-4.688-.253-4.688-.253 0 0-3.752 0-4.689.253-.516.139-.922.548-1.06 1.068-.251.942-.251 2.907-.251 2.907 0 0 0 1.965.251 2.907.138.52.544.929 1.06 1.067.937.253 4.689.253 4.689.253 0 0 3.752 0 4.688-.253.517-.138.923-.547 1.061-1.067zm-6.9766-1.123l0-3.568L13.8774 12l-3.137 1.784z"],"youtube-circle_32":["M16 0c8.836 0 16 7.163 16 16 0 8.837-7.164 16-16 16-8.837 0-16-7.163-16-16C0 7.163 7.163 0 16 0zm7.665 19.884C24 18.625 24 16 24 16c0 0 0-2.626-.335-3.884-.185-.694-.728-1.241-1.417-1.426-1.251-.337-6.264-.337-6.264-.337 0 0-5.013 0-6.264.337-.69.185-1.233.732-1.417 1.426C7.968 13.374 7.968 16 7.968 16c0 0 0 2.625.335 3.884.184.694.727 1.241 1.417 1.427 1.251.337 6.264.337 6.264.337 0 0 5.013 0 6.264-.337.689-.186 1.232-.733 1.417-1.427zm-9.3208-1.5l0-4.768 4.19 2.384-4.19 2.384z"],"youtube-circle_40":["M20 0c11.045 0 20 8.954 20 20 0 11.046-8.955 20-20 20C8.954 40 0 31.046 0 20 0 8.954 8.954 0 20 0zm9.582 24.845C30 23.276 30 20 30 20c0 0 0-3.275-.418-4.844-.23-.867-.908-1.549-1.768-1.781-1.56-.421-7.814-.421-7.814-.421 0 0-6.254 0-7.814.421-.86.232-1.538.914-1.768 1.781C10 16.725 10 20 10 20c0 0 0 3.276.418 4.845.23.866.908 1.549 1.768 1.78 1.56.421 7.814.421 7.814.421 0 0 6.254 0 7.814-.421.86-.231 1.538-.914 1.768-1.78zm-11.6274-1.8711l0-5.947 5.227 2.973-5.227 2.974z"],"zoom-in_12":["M9.002 8.294l1.852 1.852c.195.196.195.512 0 .708-.098.097-.226.146-.354.146-.128 0-.256-.049-.354-.146L8.295 9.001C7.525 9.617 6.562 10 5.5 10 3.015 10 1 7.985 1 5.5 1 3.015 3.015 1 5.5 1 7.985 1 10 3.015 10 5.5c0 1.062-.383 2.025-.998 2.794zM5.5 9C7.43 9 9 7.43 9 5.5 9 3.57 7.43 2 5.5 2 3.57 2 2 3.57 2 5.5 2 7.43 3.57 9 5.5 9zm2-4c.275 0 .5.225.5.5 0 .275-.225.5-.5.5L6 6l0 1.5c0 .275-.225.5-.5.5-.275 0-.5-.225-.5-.5L5 6 3.5 6c-.275 0-.5-.225-.5-.5 0-.275.225-.5.5-.5L5 5l0-1.5c0-.275.225-.5.5-.5.275 0 .5.225.5.5L6 5l1.5 0z"],"zoom-in_16":["M15.854 15.146c.195.196.195.512 0 .708-.098.097-.226.146-.354.146-.128 0-.256-.049-.354-.146l-4.422-4.423C9.586 12.406 8.112 13 6.5 13 2.916 13 0 10.084 0 6.5 0 2.916 2.916 0 6.5 0 10.084 0 13 2.916 13 6.5c0 1.612-.594 3.086-1.569 4.224l4.423 4.422zM6.5 12C9.533 12 12 9.533 12 6.5 12 3.467 9.533 1 6.5 1 3.467 1 1 3.467 1 6.5 1 9.533 3.467 12 6.5 12zm3-6c.276 0 .5.224.5.5 0 .276-.224.5-.5.5L7 7l0 2.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5L6 7 3.5 7c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5L6 6l0-2.5c0-.276.224-.5.5-.5.276 0 .5.224.5.5L7 6l2.5 0z"],"zoom-out_12":["M5.5 9C3.57 9 2 7.43 2 5.5 2 3.57 3.57 2 5.5 2 7.43 2 9 3.57 9 5.5 9 7.43 7.43 9 5.5 9zm2-4l-4 0c-.275 0-.5.225-.5.5 0 .275.225.5.5.5l4 0c.275 0 .5-.225.5-.5 0-.275-.225-.5-.5-.5zm1.502 3.294C9.617 7.525 10 6.562 10 5.5 10 3.015 7.985 1 5.5 1 3.015 1 1 3.015 1 5.5 1 7.985 3.015 10 5.5 10c1.062 0 2.025-.383 2.795-.999l1.851 1.853c.098.097.226.146.354.146.128 0 .256-.049.354-.146.195-.196.195-.512 0-.708L9.002 8.294z"],"zoom-out_16":["M15.854 15.146c.195.196.195.512 0 .708-.098.097-.226.146-.354.146-.128 0-.256-.049-.354-.146l-4.422-4.423C9.586 12.406 8.112 13 6.5 13 2.916 13 0 10.084 0 6.5 0 2.916 2.916 0 6.5 0 10.084 0 13 2.916 13 6.5c0 1.612-.594 3.086-1.569 4.224l4.423 4.422zM6.5 12C9.533 12 12 9.533 12 6.5 12 3.467 9.533 1 6.5 1 3.467 1 1 3.467 1 6.5 1 9.533 3.467 12 6.5 12zm3-5l-6 0c-.276 0-.5-.224-.5-.5 0-.276.224-.5.5-.5l6 0c.276 0 .5.224.5.5 0 .276-.224.5-.5.5z"]}

/***/ }),
/* 519 */
/***/ (function(module, exports) {

module.exports = [{"name":"green","variations":[{"variable":"$green","hex":"#30D557"},{"variable":"$green-hover","hex":"#2AC450"},{"variable":"$green-dark","hex":"#26B249"},{"variable":"$green-dark-hover","hex":"#22A342"},{"variable":"$green-dark-press","hex":"#1F953D"},{"variable":"$green-light","hex":"#91E9A7","text":"dark"},{"variable":"$green-pastel","hex":"#DDF8E3","text":"dark"}]},{"name":"red","variations":[{"variable":"$red","hex":"#FF503C"},{"variable":"$red-hover","hex":"#EB4937"},{"variable":"$red-dark","hex":"#D64332"},{"variable":"$red-dark-hover","hex":"#C43D2D"},{"variable":"$red-dark-press","hex":"#B33829"},{"variable":"$red-light","hex":"#FFA399","text":"dark"},{"variable":"$red-pastel","hex":"#FFE2DF","text":"dark"}]},{"name":"blue","variations":[{"variable":"$blue","hex":"#07C1E4"},{"variable":"$blue-hover","hex":"#06B1D2"},{"variable":"$blue-dark","hex":"#05A1BF"},{"variable":"$blue-dark-hover","hex":"#0493AF"},{"variable":"$blue-dark-press","hex":"#0487A0"},{"variable":"$blue-light","hex":"#7DDEF0","text":"dark"},{"variable":"$blue-pastel","hex":"#D7F5FA","text":"dark"}]},{"name":"yellow","variations":[{"variable":"$yellow","hex":"#FFB400"},{"variable":"$yellow-hover","hex":"#EBA500"},{"variable":"$yellow-dark","hex":"#D69700"},{"variable":"$yellow-dark-hover","hex":"#C58B00"},{"variable":"$yellow-dark-press","hex":"#B37E00"},{"variable":"$yellow-light","hex":"#FFD87B","text":"dark"},{"variable":"$yellow-pastel","hex":"#FFF2D6","text":"dark"}]},{"name":"purple","variations":[{"variable":"$purple","hex":"#D540D8"},{"variable":"$purple-hover","hex":"#C43AC7"},{"variable":"$purple-dark","hex":"#B235B5"},{"variable":"$purple-dark-hover","hex":"#A430A6"},{"variable":"$purple-dark-press","hex":"#952C97"},{"variable":"$purple-light","hex":"#E99BEA","text":"dark"},{"variable":"$purple-pastel","hex":"#F8E1F8","text":"dark"}]},{"name":"mint","variations":[{"variable":"$mint","hex":"#00D6A2"},{"variable":"$mint-hover","hex":"#00C595"},{"variable":"$mint-dark","hex":"#00B387"},{"variable":"$mint-dark-hover","hex":"#00A47C"},{"variable":"$mint-dark-press","hex":"#009671"},{"variable":"$mint-light","hex":"#7AE9CE","text":"dark"},{"variable":"$mint-pastel","hex":"#D7F8F0","text":"dark"}]},{"name":"cyan","variations":[{"variable":"$cyan","hex":"#02BBCC"},{"variable":"$cyan-hover","hex":"#01ACBC"},{"variable":"$cyan-dark","hex":"#019CAB"},{"variable":"$cyan-dark-hover","hex":"#008F9D"},{"variable":"$cyan-dark-press","hex":"#00828F"},{"variable":"$cyan-light","hex":"#7BDBE4","text":"dark"},{"variable":"$cyan-pastel","hex":"#D6F4F6","text":"dark"}]},{"name":"violet","variations":[{"variable":"$violet","hex":"#A866FF"},{"variable":"$violet-hover","hex":"#9A5EEB"},{"variable":"$violet-dark","hex":"#8C55D6"},{"variable":"$violet-dark-hover","hex":"#814EC5"},{"variable":"$violet-dark-press","hex":"#7547B3"},{"variable":"$violet-light","hex":"#D1AFFF","text":"dark"},{"variable":"$violet-pastel","hex":"#F1E6FF","text":"dark"}]},{"name":"pink","variations":[{"variable":"$pink","hex":"#FF3D67"},{"variable":"$pink-hover","hex":"#EB385E"},{"variable":"$pink-dark","hex":"#D63356"},{"variable":"$pink-dark-hover","hex":"#C52F4F"},{"variable":"$pink-dark-press","hex":"#B32A48"},{"variable":"$pink-light","hex":"#FF99AF","text":"dark"},{"variable":"$pink-pastel","hex":"#FFDFE6","text":"dark"}]},{"name":"orange","variations":[{"variable":"$orange","hex":"#FF7033"},{"variable":"$orange-hover","hex":"#EB672F"},{"variable":"$orange-dark","hex":"#D65D2A"},{"variable":"$orange-dark-hover","hex":"#C45526"},{"variable":"$orange-dark-press","hex":"#B34E23"},{"variable":"$orange-light","hex":"#FFB494","text":"dark"},{"variable":"$orange-pastel","hex":"#FFE8DF","text":"dark"}]},{"name":"gray","variations":[{"variable":"$gray-1","hex":"#333333"},{"variable":"$gray-2","hex":"#666666"},{"variable":"$gray-3","hex":"#999999"},{"variable":"$gray-4","hex":"#C2C2C2","text":"dark"},{"variable":"$gray-4","hex":"#E0E0E0","text":"dark"},{"variable":"$gray-5","hex":"#EBEBEB","text":"dark"},{"variable":"$gray-6","hex":"#F5F5F5","text":"dark"}]},{"name":"green contrast","variations":[{"variable":"$green-base--contrast","hex":"#1D8837"},{"variable":"$green-hover--contrast","hex":"#1A7C32"},{"variable":"$green-press--contrast","hex":"#18722E"},{"variable":"$green-dark--contrast","hex":"#2ED557"},{"variable":"$green-dark-hover--contrast","hex":"#2AC450"},{"variable":"$green-dark-press--contrast","hex":"#26B249"},{"variable":"$green-pastel--contrast","hex":"#1D8837"}]},{"name":"red contrast","variations":[{"variable":"$red-base--contrast","hex":"#A33326"},{"variable":"$red-hover--contrast","hex":"#962F23"},{"variable":"$red-press--contrast","hex":"#882A1F"},{"variable":"$red-dark--contrast","hex":"#FF503C"},{"variable":"$red-dark-hover--contrast","hex":"#EB4937"},{"variable":"$red-dark-press--contrast","hex":"#D64332"},{"variable":"$red-pastel--contrast","hex":"#A33326"}]},{"name":"blue contrast","variations":[{"variable":"$blue-base--contrast","hex":"#047B91"},{"variable":"$blue-hover--contrast","hex":"#037185"},{"variable":"$blue-press--contrast","hex":"#036779"},{"variable":"$blue-dark--contrast","hex":"#07C1E4"},{"variable":"$blue-dark-hover--contrast","hex":"#06B1D2"},{"variable":"$blue-dark-press--contrast","hex":"#05A1BF"},{"variable":"$blue-pastel--contrast","hex":"#047B91"}]},{"name":"yellow contrast","variations":[{"variable":"$yellow-base--contrast","hex":"#996C00"},{"variable":"$yellow-hover--contrast","hex":"#946800"},{"variable":"$yellow-press--contrast","hex":"#8C6300"},{"variable":"$yellow-dark--contrast","hex":"#FFB400"},{"variable":"$yellow-dark-hover--contrast","hex":"#EBA500"},{"variable":"$yellow-dark-press--contrast","hex":"#D69700"},{"variable":"$yellow-pastel--contrast","hex":"#996C00"}]},{"name":"purple contrast","variations":[{"variable":"$purple-base--contrast","hex":"#88298A"},{"variable":"$purple-hover--contrast","hex":"#7D257F"},{"variable":"$purple-press--contrast","hex":"#722273"},{"variable":"$purple-dark--contrast","hex":"#D540D8"},{"variable":"$purple-dark-hover--contrast","hex":"#C33AC6"},{"variable":"$purple-dark-press--contrast","hex":"#B235B5"},{"variable":"$purple-pastel--contrast","hex":"#88298A"}]},{"name":"mint contrast","variations":[{"variable":"$mint-base--contrast","hex":"#008061"},{"variable":"$mint-hover--contrast","hex":"#007C5E"},{"variable":"$mint-press--contrast","hex":"#006E53"},{"variable":"$mint-dark--contrast","hex":"#00D6A2"},{"variable":"$mint-dark-hover--contrast","hex":"#00C494"},{"variable":"$mint-dark-press--contrast","hex":"#00B387"},{"variable":"$mint-pastel--contrast","hex":"#008061"}]},{"name":"cyan contrast","variations":[{"variable":"$cyan-base--contrast","hex":"#017782"},{"variable":"$cyan-hover--contrast","hex":"#006D77"},{"variable":"$cyan-press--contrast","hex":"#00636D"},{"variable":"$cyan-dark--contrast","hex":"#02BBCC"},{"variable":"$cyan-dark-hover--contrast","hex":"#01ACBC"},{"variable":"$cyan-dark-press--contrast","hex":"#019CAB"},{"variable":"$cyan-pastel--contrast","hex":"#017782"}]},{"name":"violet contrast","variations":[{"variable":"$violet-base--contrast","hex":"#6B41A3"},{"variable":"$violet-hover--contrast","hex":"#623B95"},{"variable":"$violet-press--contrast","hex":"#593688"},{"variable":"$violet-dark--contrast","hex":"#A866FF"},{"variable":"$violet-dark-hover--contrast","hex":"#9A5EEB"},{"variable":"$violet-dark-press--contrast","hex":"#8C55D6"},{"variable":"$violet-pastel--contrast","hex":"#6B41A3"}]},{"name":"pink contrast","variations":[{"variable":"$pink-base--contrast","hex":"#A32641"},{"variable":"$pink-hover--contrast","hex":"#96233B"},{"variable":"$pink-press--contrast","hex":"#881F36"},{"variable":"$pink-dark--contrast","hex":"#FF3D67"},{"variable":"$pink-dark-hover--contrast","hex":"#EB385E"},{"variable":"$pink-dark-press--contrast","hex":"#D63356"},{"variable":"$pink-pastel--contrast","hex":"#A32641"}]},{"name":"orange contrast","variations":[{"variable":"$orange-base--contrast","hex":"#A44820"},{"variable":"$orange-hover--contrast","hex":"#96411D"},{"variable":"$orange-press--contrast","hex":"#883B1A"},{"variable":"$orange-dark--contrast","hex":"#FF7033"},{"variable":"$orange-dark-hover--contrast","hex":"#EB672F"},{"variable":"$orange-dark-press--contrast","hex":"#D65D2A"},{"variable":"$orange-pastel--contrast","hex":"#A4482"}]},{"name":"black","opacity":true,"variations":[{"variable":"$black","opacity":"100"},{"variable":"$black-80","opacity":"80"},{"variable":"$black-60","opacity":"60"},{"variable":"$black-48","opacity":"48"},{"variable":"$black-40","opacity":"40"},{"variable":"$black-24","opacity":"24","text":"dark"},{"variable":"$black-20","opacity":"20","text":"dark"},{"variable":"$black-16","opacity":"16","text":"dark"},{"variable":"$black-12","opacity":"12","text":"dark"},{"variable":"$black-8","opacity":"8","text":"dark"},{"variable":"$black-4","opacity":"4","text":"dark"}]},{"name":"white","opacity":true,"text":"dark","variations":[{"variable":"$white","opacity":"100","text":"dark"},{"variable":"$white-92","opacity":"92","text":"dark"},{"variable":"$white-84","opacity":"84","text":"dark"},{"variable":"$white-80","opacity":"80","text":"dark"},{"variable":"$white-60","opacity":"60","text":"dark"},{"variable":"$white-40","opacity":"40","text":"dark"},{"variable":"$white-32","opacity":"32","text":"dark"},{"variable":"$white-24","opacity":"24","text":"dark"},{"variable":"$white-20","opacity":"20","text":"dark"},{"variable":"$white-16","opacity":"16","text":"dark"},{"variable":"$white-12","opacity":"12","text":"dark"},{"variable":"$white-8","opacity":"8","text":"dark"}]}]

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(7);

__webpack_require__(4);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _lodash = __webpack_require__(13);

var _ = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * @category controls
 * @component input
 * @variations collab-ui-react
 */
var determineErrorType = function determineErrorType(array) {
  return array.reduce(function (agg, e) {
    return agg === 'error' ? agg : e.type || '';
  }, '');
};

var filterErrorsByType = function filterErrorsByType(array, value) {
  return array.reduce(function (agg, e) {
    return e.type === value ? agg.concat(e.error) : agg;
  }, []);
};
/** Text input with integrated label to enforce consistency in layout, error display, label placement, and required field marker. */


var Input =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Input, _React$Component);

  function Input() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      isEditing: false,
      value: _this.props.value || _this.props.defaultValue
    };

    _this.setValue = function (value) {
      _this.setState({
        value: value
      });
    };

    _this.handleKeyDown = function (e) {
      var onKeyDown = _this.props.onKeyDown;
      onKeyDown && onKeyDown(e);
    };

    _this.handleFocus = function (e) {
      var _this$props = _this.props,
          onFocus = _this$props.onFocus,
          disabled = _this$props.disabled;

      if (disabled) {
        e.stopPropagation();
        return;
      }

      if (onFocus) {
        onFocus(e);
      }

      _this.setState({
        isEditing: true
      });
    };

    _this.handleMouseDown = function (e) {
      var _this$props2 = _this.props,
          onMouseDown = _this$props2.onMouseDown,
          disabled = _this$props2.disabled;

      if (disabled) {
        e.stopPropagation();
        return;
      }

      if (onMouseDown) {
        onMouseDown(e);
      }

      _this.setState({
        isEditing: true
      });
    };

    _this.handleChange = function (e) {
      var onChange = _this.props.onChange;
      var value = e.target.value;
      e.persist();

      _this.setState(function () {
        onChange && onChange(e);
        return {
          value: value
        };
      });
    };

    _this.handleBlur = function (e) {
      var onDoneEditing = _this.props.onDoneEditing;
      var value = e.target.value;
      e.stopPropagation();

      if (e.keyCode === 27 || e.keyCode === 13 || e.type === 'blur') {
        _this.setState({
          isEditing: false
        }, function () {
          return onDoneEditing && onDoneEditing(e, value);
        });
      }
    };

    _this.handleClear = function (e) {
      var value = '';
      e.target.value = value;
      e.persist();

      _this.input.focus();

      _this.handleChange(e);
    };

    _this.setInputRef = function (input) {
      var _this$props3 = _this.props,
          clear = _this$props3.clear,
          inputRef = _this$props3.inputRef;
      if (clear) _this.input = input;
      if (inputRef) return inputRef(input);
    };

    return _this;
  }

  var _proto = Input.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var value = this.props.value;
    value !== prevProps.value && this.setValue(value);
  };

  _proto.render = function render() {
    var _this$props4 = this.props,
        children = _this$props4.children,
        className = _this$props4.className,
        clear = _this$props4.clear,
        clearAriaLabel = _this$props4.clearAriaLabel,
        disabled = _this$props4.disabled,
        errorArr = _this$props4.errorArr,
        htmlId = _this$props4.htmlId,
        iconNode = _this$props4.iconNode,
        id = _this$props4.id,
        inputClassName = _this$props4.inputClassName,
        inputHelpText = _this$props4.inputHelpText,
        inputSize = _this$props4.inputSize,
        label = _this$props4.label,
        nestedLevel = _this$props4.nestedLevel,
        placeholder = _this$props4.placeholder,
        readOnly = _this$props4.readOnly,
        secondaryLabel = _this$props4.secondaryLabel,
        theme = _this$props4.theme,
        type = _this$props4.type,
        props = _objectWithoutPropertiesLoose(_this$props4, ["children", "className", "clear", "clearAriaLabel", "disabled", "errorArr", "htmlId", "iconNode", "id", "inputClassName", "inputHelpText", "inputSize", "label", "nestedLevel", "placeholder", "readOnly", "secondaryLabel", "theme", "type"]);

    var value = this.state.value;
    var otherProps = (0, _lodash.omit)(Object.assign({}, props), ['defaultValue', 'inputRef', 'onChange', 'onDoneEditing', 'onFocus', 'onKeyDown', 'onMouseDown', 'ref', 'value']);
    var errorType = errorArr.length > 0 && determineErrorType(errorArr) || '';
    var errors = errorType && filterErrorsByType(errorArr, errorType) || [];

    var secondaryLabelWrapper = function secondaryLabelWrapper() {
      return _react.default.createElement("div", {
        className: "cui-label__secondary-label-container"
      }, inputElement, _react.default.createElement(_.Label, {
        className: "cui-label__secondary-label",
        htmlFor: htmlId,
        label: secondaryLabel,
        theme: theme
      }));
    };

    var clearButton = clear && !disabled && value && _react.default.createElement(_.Icon, {
      name: "clear-active_16",
      onClick: this.handleClear,
      ariaLabel: clearAriaLabel || 'clear input'
    });

    var customInputIconNode = iconNode && _react.default.cloneElement(iconNode, {
      className: iconNode.props.onClick ? '' : 'cui-input__icon'
    });

    var iconContainer = function iconContainer() {
      return _react.default.createElement("div", {
        className: "cui-input__icon-container"
      }, inputElement, children, customInputIconNode || clearButton);
    };

    var inputElement = _react.default.createElement("input", _extends({
      className: 'cui-input' + ("" + (inputClassName ? " " + inputClassName : '')) + ("" + (readOnly ? ' read-only' : '')) + ("" + (disabled ? ' disabled' : '')) + ("" + (value ? " dirty" : '')),
      onBlur: this.handleBlur,
      onChange: this.handleChange,
      onFocus: this.handleFocus,
      onKeyDown: this.handleKeyDown,
      onMouseDown: this.handleMouseDown,
      ref: this.setInputRef,
      tabIndex: 0,
      type: type,
      value: value
    }, disabled && {
      disabled: disabled
    }, htmlId && {
      id: htmlId
    }, otherProps, placeholder && {
      placeholder: placeholder
    }, readOnly && {
      readOnly: readOnly
    }));

    var getInputWrapper = function getInputWrapper() {
      if (iconNode || clear || children) return iconContainer();
      if (secondaryLabel) return secondaryLabelWrapper();
      return inputElement;
    };

    return _react.default.createElement("div", {
      className: "cui-input-group" + (" " + inputSize) + ("" + (inputSize ? ' columns' : '')) + ("" + (readOnly ? ' read-only' : '')) + ("" + (disabled ? ' disabled' : '')) + ("" + (theme && " cui-input-group--" + theme || '')) + ("" + (errorType ? " " + errorType : '')) + ("" + (nestedLevel && " cui-input--nested-" + nestedLevel || '')) + ("" + (className ? " " + className : ''))
    }, label && _react.default.createElement(_.Label, {
      className: "cui-label",
      htmlFor: htmlId || id,
      label: label,
      theme: theme
    }), getInputWrapper(), inputHelpText && _react.default.createElement(_.InputHelper, {
      message: inputHelpText
    }), errors && errors.map(function (e, i) {
      return _react.default.createElement(_.InputError, {
        error: e,
        key: "input-error-" + i
      });
    }));
  };

  return Input;
}(_react.default.Component);

Input.propTypes = {
  /** @prop Child component to display next to the input | '' */
  children: _propTypes.default.node,

  /** @prop Optional css class name | '' */
  className: _propTypes.default.string,

  /** @prop Clears Input values | false */
  clear: _propTypes.default.bool,

  /** @prop Optional aria label on the clear button | null */
  clearAriaLabel: _propTypes.default.string,

  /** @prop Default Value same as value but used when onChange isn't invoked | '' */
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /*** @prop Sets the disabled attribute of the Input | false */
  disabled: _propTypes.default.bool,

  /** @prop Array of Objects with error and type [{error: '', type: ''}] to display error message and assign class | [] */
  errorArr: _propTypes.default.array,

  /** @prop Unique HTML ID used for tying label to HTML input for automated testing | null */
  htmlId: _propTypes.default.string,

  /** Optional Icon node that overrides the default clear icon | null */
  iconNode: _propTypes.default.node,

  /** Unique HTML ID used for tying label to HTML input | null */
  id: _propTypes.default.string,

  /** @prop Input css class name string | '' */
  inputClassName: _propTypes.default.string,

  /** @prop Help Text to show form validation rules | '' */
  inputHelpText: _propTypes.default.string,

  /*** @prop Optional Input ref prop type | null */
  inputRef: _propTypes.default.func,

  /** @prop Overall input group size | '' */
  inputSize: _propTypes.default.string,

  /** @prop Input label text | '' */
  label: _propTypes.default.string,

  /*** @prop Optional Input name prop type | null */
  name: _propTypes.default.string,

  /** @prop Set the level of nested Input components | 0 */
  nestedLevel: _propTypes.default.number,

  /** @prop Callback function invoked when user types into the Input field | null */
  onChange: _propTypes.default.func,

  /*** @prop Callback function invoked when user is done editing Input field | null */
  onDoneEditing: _propTypes.default.func,

  /*** @prop Callback function invoked when user focuses on the Input field | null */
  onFocus: _propTypes.default.func,

  /*** @prop Callback function invoked when user presses any key | null */
  onKeyDown: _propTypes.default.func,

  /*** @prop Callback function invoked when user clicks on the mouse/trackpad | null */
  onMouseDown: _propTypes.default.func,

  /** @prop Placeholder text to display when Input is empty | '' */
  placeholder: _propTypes.default.string,

  /*** @prop Determines if Input can be edited | false */
  readOnly: _propTypes.default.bool,

  /** @prop Secondary Input label | '' */
  secondaryLabel: _propTypes.default.string,

  /** @prop Input color theme | '' */
  theme: _propTypes.default.string,

  /** @prop Input type | 'text' */
  type: _propTypes.default.oneOf(['text', 'number', 'password', 'email']),

  /** @prop Input value | '' */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
Input.defaultProps = {
  children: '',
  className: '',
  clear: false,
  clearAriaLabel: null,
  defaultValue: '',
  disabled: false,
  errorArr: [],
  htmlId: null,
  iconNode: null,
  id: null,
  inputClassName: '',
  inputHelpText: '',
  inputRef: null,
  inputSize: '',
  label: '',
  name: null,
  nestedLevel: 0,
  onChange: null,
  onDoneEditing: null,
  onFocus: null,
  onKeyDown: null,
  onMouseDown: null,
  placeholder: '',
  readOnly: false,
  secondaryLabel: '',
  theme: '',
  type: 'text',
  value: ''
};
Input.displayName = 'Input';
var _default = Input;
/**
* @component input
* @section default
* @react
import { Input } from '@collabui/react';

export default class InputDefault extends React.PureComponent {

  render() {
    return (
      <Input
        name='defaultInput'
        label='Default Input'
        htmlId='defaultInput'
        inputSize='small-5'
        placeholder='Placeholder Text'
      />
    );
  }
}

**/

/**
* @component input
* @section clear
* @react
import { Input } from '@collabui/react';

export default class InputClear extends React.PureComponent {
  state = {
    value: 'Press or click the clear icon to clear this input'
  };

  handleChange = (event) => {
    this.setState({value: event.target.value});
  }

  render() {
    return (
      <Input
        name='clearInput'
        label='Input with clear'
        htmlId='clearInput'
        inputSize='small-5'
        placeholder='Placeholder Text'
        value={this.state.value}
        onChange={this.handleChange}
        clear
      />
    );
  }
}

**/

/**
* @component input
* @section error
* @react
import { Input } from '@collabui/react';

export default function InputError() {
  return (
    <Input
      name='inputError'
      label='Error (Error) Input'
      htmlId='inputError'
      inputSize='small-5'
      errorArr={ [{error: 'This is where the error message would be.', type: 'error'}] }
    />
  );
}

**/

/**
* @component input
* @section warning
* @react
import { Input } from '@collabui/react';

export default function InputWarning() {
  return (
    <Input
      name='inputWarning'
      label='Error (Warning) Input'
      htmlId='inputWarning'
      inputSize='small-5'
      errorArr={ [{error: 'This is where the warning message would be.', type: 'warning'}] }
    />
  );
}

**/

/**
* @component input
* @section success
* @react
import { Input } from '@collabui/react';

export default function InputSuccess() {
  return (
    <Input
      name='inputSuccess'
      label='Error (Success) Input'
      htmlId='inputSuccess'
      inputSize='small-5'
      errorArr={ [{error: 'This is where the success message would be.', type: 'success'}] }
    />
  );
}

**/

/**
* @component input
* @section disabled
* @react
import { Input } from '@collabui/react';

export default function InputDisabled() {
  return (
    <Input
      name='inputDisabled'
      label='Disabled Input'
      htmlId='inputDisabled'
      inputSize='small-5'
      value='Disabled Text'
      disabled
    />
  );
}

**/

/**
* @component input
* @section read-only
* @react
import { Input } from '@collabui/react';

export default function InputReadonly() {
  return (
    <Input
      name='inputReadonly'
      label='Read Only Input'
      htmlId='inputReadonly'
      inputSize='small-5'
      value='Read Only Text'
      readOnly
    />
  );
}

**/

/**
* @component input
* @section help-text
* @react
import { Input } from '@collabui/react';

export default function InputHelpText() {
  return (
    <div className='row'>
      <Input
        name='inputHelpText'
        label='Help Text Input'
        htmlId='inputHelpText'
        inputSize='small-5'
        inputHelpText='Help Text'
      />
    </div>
  );
}

**/

/**
* @component input
* @section secondary-label
* @react
import { Input } from '@collabui/react';

export default function InputSecondary() {
  return (
    <Input
      name='inputSecondaryLabel'
      label='Input with Secondary Label'
      htmlId='inputSecondaryLabel'
      inputSize='small-5'
      secondaryLabel='Secondary Label'
    />
  );
}
**/

/**
* @component input
* @section nested
* @react
import { Input } from '@collabui/react';

export default function InputNested() {
  return (
    <div className='row' key={'input1'}>
      <Input
        name='inputParent'
        label='Parent Input Example'
        htmlId='inputParent'
        inputSize='small-5'
      />
    </div>,
    <div className='row' key={'input2'}>
      <Input
        name='inputNested1'
        label='Child Input Nested 1 Level'
        inputSize='small-5'
        htmlId='inputNested1'
        nestedLevel={1}
      />
    </div>,
    <div className='row' key={'input3'}>
      <Input
        name='inputNested2'
        label='Child Input Nested 2 Levels'
        inputSize='small-5'
        htmlId='inputNested2'
        nestedLevel={2}
      />
    </div>,
    <div className='row' key={'input4'}>
      <Input
        name='inputNested3'
        label='Child Input Nested 3 Levels'
        inputSize='small-5'
        htmlId='inputNested3'
        nestedLevel={3}
      />
    </div>
  );
}

**/

exports.default = _default;

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** Input Error with required error */
var InputError = function InputError(_ref) {
  var error = _ref.error;
  return _react.default.createElement("div", {
    className: "cui-input__messages",
    role: "alert"
  }, _react.default.createElement("div", {
    className: "message"
  }, error));
};

InputError.propTypes = {
  /** @prop Error message for InputError component */
  error: _propTypes.default.string.isRequired
};
InputError.displayName = 'InputError';
var _default = InputError;
exports.default = _default;

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @category controls
 * @component input
 * @variations collab-ui-react
 */
var InputHelper = function InputHelper(_ref) {
  var message = _ref.message,
      className = _ref.className;
  return _react.default.createElement("p", {
    className: "cui-input__help-text " + className
  }, message);
};

InputHelper.propTypes = {
  /** @prop Optional css class name | '' */
  className: _propTypes.default.string,

  /** @prop Input help message for parent Input | null */
  message: _propTypes.default.string.isRequired
};
InputHelper.defaultProps = {
  className: '',
  message: null
};
InputHelper.displayName = 'InputHelper';
var _default = InputHelper;
/**
* @name Input Helper
* @description Inputs are useful.
*
* @category controls
* @component input
* @section Input Helper
*
* @js

import {
  Checkbox,
  InputHelper
} from '@collabui/react';

export default function InputHelperDefault() {
  return (
    <div className='row'>
      <Checkbox
        value='us'
        label='us'
        htmlId='inputHelper1'
        onChange={()=>{}}
      >
        <InputHelper message={'I\'m here to help'} />
      </Checkbox>
    </div>
  );
}

**/

exports.default = _default;

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(4);

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(7);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * @category controls
 * @component label
 * @variations collab-ui-react
 */
var Label = function Label(_ref) {
  var className = _ref.className,
      htmlFor = _ref.htmlFor,
      label = _ref.label,
      theme = _ref.theme,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "htmlFor", "label", "theme"]);

  return _react.default.createElement("label", _extends({
    className: "" + (className ? " " + className : '') + ("" + (theme ? " cui-label--" + theme : '')),
    htmlFor: htmlFor
  }, props), _react.default.createElement("span", null, label));
};

Label.propTypes = {
  /** @prop HTML class name for associated Input | '' */
  className: _propTypes.default.string,

  /** @prop HTML ID for associated Input | null */
  htmlFor: _propTypes.default.string.isRequired,

  /** @prop Required Label text | null */
  label: _propTypes.default.string.isRequired,

  /** @prop Set Label's color theme | '' */
  theme: _propTypes.default.string
};
Label.defaultProps = {
  className: '',
  htmlFor: null,
  label: null,
  theme: ''
};
Label.displayName = 'Label';
var _default = Label;
/**
* @name Default Label
* @description Labels are useful.
*
* @category controls
* @component label
* @section default
*
* @js
import { Label } from '@collabui/react';

export default function LabelDefault() {
  return (
    <Label
      htmlFor='label1'
      label='Default Label'
    />
  );
}

**/

exports.default = _default;

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(37);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _reactAriaModal = _interopRequireDefault(__webpack_require__(289));

var _ = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var Lightbox =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Lightbox, _React$Component);

  function Lightbox() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      viewportDimensions: {
        width: 600,
        height: 600
      },
      zoom: 1
    };

    _this.handleResize = function () {
      var _assertThisInitialize = _assertThisInitialized(_assertThisInitialized(_this)),
          viewport = _assertThisInitialize.viewport;

      _this.setState({
        viewportDimensions: {
          width: viewport.offsetWidth,
          height: viewport.offsetHeight
        }
      });
    };

    _this.handleKeyDown = function (e) {
      var _this$props = _this.props,
          index = _this$props.index,
          pages = _this$props.pages;
      var newIndex;

      switch (e.keyCode) {
        // Escape
        case 27:
          _this.handleClose();

          return;
        // left arrow & up arrow

        case 37:
        case 38:
          newIndex = Math.max(index - 1, 0);
          break;
        // right arrow & down arrow

        case 39:
        case 40:
          newIndex = Math.min(index + 1, pages.length - 1);
          break;
        // page up & home

        case 33:
        case 36:
          newIndex = 0;
          break;
        // page down & end

        case 34:
        case 35:
          newIndex = pages.length - 1;
          break;
        // 1 - 9

        case 49:
        case 50:
        case 51:
        case 52:
        case 53:
        case 54:
        case 55:
        case 56:
        case 57:
          newIndex = Math.min(e.keyCode - 49, pages.length - 1);
          break;

        default:
          return;
      }

      _this.triggerPageChange(newIndex, e);
    };

    _this.handleThumbnailClick = function (index) {
      var onChange = _this.props.onChange;
      onChange && onChange(index);
    };

    _this.triggerPageChange = function (index, e) {
      var _this$props2 = _this.props,
          onChange = _this$props2.onChange,
          pages = _this$props2.pages;

      var target = _this.lightBox && _this.lightBox.querySelector("[data-index='" + index + "']");

      if (index >= 0 && index <= pages.length - 1) {
        onChange && onChange(index);
      }

      e.stopPropagation();
      target && target.scrollIntoViewIfNeeded();
    };

    _this.stopPropagation = function (e) {
      e.stopPropagation();
    };

    _this.setZoom = function (increment) {
      var newZoom = _this.state.zoom + increment;

      _this.setState({
        zoom: newZoom < 0.25 ? 0.25 : newZoom
      });
    };

    _this.handleDownload = function () {
      var onDownload = _this.props.onDownload;
      onDownload && onDownload();
    };

    _this.handleClose = function () {
      var onClose = _this.props.onClose;
      onClose && onClose();
    };

    return _this;
  }

  var _proto = Lightbox.prototype;

  _proto.componentDidMount = function componentDidMount() {
    window.addEventListener('keydown', this.handleKeyDown, true);
    window.addEventListener('resize', this.handleResize, true);
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.index !== this.props.index && this.state.zoom > 1 && this.imgWrapper) {
      var viewportNode = this.viewport;
      viewportNode.scrollTop = 0;
      viewportNode.scrollLeft = (this.imgWrapper.offsetWidth - viewportNode.offsetWidth) / 2;
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown, true);
    window.removeEventListener('resize', this.handleResize, true);
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props3 = this.props,
        pages = _this$props3.pages,
        index = _this$props3.index,
        width = _this$props3.width,
        height = _this$props3.height,
        tooltips = _this$props3.tooltips,
        downloading = _this$props3.downloading,
        info = _this$props3.info,
        name = _this$props3.name,
        applicationId = _this$props3.applicationId;
    var _this$state = this.state,
        zoom = _this$state.zoom,
        viewportDimensions = _this$state.viewportDimensions;
    var currentPage = pages[index];
    var showColumn = pages.length > 1;

    var calculateAspectRatioFit = function calculateAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight) {
      var ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight, 1);
      return {
        width: Math.round(srcWidth * ratio),
        height: Math.round(srcHeight * ratio)
      };
    };

    var getThumbnails = function getThumbnails() {
      var thumbnails = pages.map(function (page, idx) {
        var key = idx + ":" + page.thumb;
        var body;

        if (page.decrypting) {
          var scale = width / 150;
          var scaleY = height / scale;
          var style = {
            height: Math.round(scaleY)
          };
          key += ':decrypting';
          body = _react.default.createElement("div", {
            className: "cui-lightbox__thumbnail" + ("" + (!!page.decrypting && " cui-lightbox__thumbnail--decrypting" || '')),
            "data-index": idx,
            style: style
          }, _react.default.createElement(_.Icon, {
            className: "cui-lightbox__thumbnail--icon",
            name: "secure_28"
          }));
        } else {
          body = _react.default.createElement("img", {
            alt: "",
            className: "cui-lightbox__thumbnail" + ("" + (!!page.decrypting && " cui-lightbox__thumbnail--decrypting" || '')),
            "data-index": idx,
            draggable: "false",
            onDragStart: function onDragStart() {
              return false;
            },
            src: page.thumb
          });
        }

        return _react.default.createElement("div", {
          className: 'cui-lightbox__thumbnail-wrapper' + ("" + (idx === index && " cui-lightbox__thumbnail-wrapper--selected" || '')),
          key: key,
          onClick: function onClick() {
            return _this2.handleThumbnailClick(idx);
          },
          onKeyPress: function onKeyPress() {
            return _this2.handleThumbnailClick(idx);
          },
          role: "button",
          tabIndex: "0"
        }, body, _react.default.createElement("div", null, idx + 1));
      });
      return _react.default.createElement("div", {
        className: "cui-lightbox__list"
      }, thumbnails);
    };

    var getViewport = function getViewport() {
      var viewport;
      var dimensions = calculateAspectRatioFit(width * zoom, height * zoom, viewportDimensions.width, viewportDimensions.height);
      var imageContainerStyles = {
        width: dimensions.width + "px",
        height: dimensions.height + "px"
      };

      if (currentPage.content) {
        if (currentPage.fullView) {
          imageContainerStyles = {
            width: '100%',
            height: '100%',
            overflow: 'hidden'
          };
        }

        viewport = _react.default.createElement("div", {
          className: "cui-lightbox__viewport-content",
          draggable: "false",
          onClick: _this2.stopPropagation,
          onKeyPress: _this2.stopPropagation,
          onDoubleClick: function onDoubleClick() {
            return _this2.setZoom(0.25);
          },
          onDragStart: function onDragStart() {
            return false;
          },
          role: "button",
          tabIndex: "0"
        }, currentPage.content);
      } else if (currentPage.image) {
        if (zoom <= 1) {
          /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
          viewport = _react.default.createElement("img", {
            alt: "",
            className: "cui-lightbox__viewport-image",
            draggable: "false",
            onClick: _this2.stopPropagation,
            onKeyPress: _this2.stopPropagation,
            onDoubleClick: function onDoubleClick() {
              return _this2.setZoom(0.25);
            },
            onDragStart: function onDragStart() {
              return false;
            },
            src: currentPage.image
          });
        } else {
          imageContainerStyles = {};
          viewport = _react.default.createElement("img", {
            alt: "",
            className: "cui-lightbox__viewport-image",
            draggable: "false",
            onClick: _this2.stopPropagation,
            onKeyPress: _this2.stopPropagation,
            onDoubleClick: function onDoubleClick() {
              return _this2.setZoom(0.25);
            },
            onDragStart: function onDragStart() {
              return false;
            },
            src: currentPage.image,
            style: {
              maxHeight: height * zoom,
              maxWidth: width * zoom,
              minHeight: height * zoom,
              minWidth: width * zoom
            }
          });
        }
      }

      return _react.default.createElement("div", {
        className: "cui-lightbox__viewport-wrapper",
        ref: function ref(_ref) {
          return _this2.imgWrapper = _ref;
        },
        style: imageContainerStyles
      }, viewport);
    };

    var leftArrowControl = _react.default.createElement(_.Tooltip, {
      tooltip: tooltips.previous,
      direction: "right-center"
    }, _react.default.createElement("div", {
      className: "cui-lightbox__page-control cui-lightbox__page-control-icon cui-lightbox__page-controls--left",
      role: "button",
      tabIndex: "0",
      onKeyPress: function onKeyPress(e) {
        return _this2.triggerPageChange(index - 1, e);
      },
      onClick: function onClick(e) {
        return _this2.triggerPageChange(index - 1, e);
      },
      style: {
        transform: 'rotate(-180deg)'
      }
    }, _react.default.createElement(_.Icon, {
      name: "arrow-right_16"
    })));

    var rightArrowControl = _react.default.createElement(_.Tooltip, {
      tooltip: tooltips.next,
      direction: "left-center"
    }, _react.default.createElement("div", {
      className: "cui-lightbox__page-control cui-lightbox__page-control-icon cui-lightbox__page-controls--right",
      role: "button",
      tabIndex: "0",
      onKeyPress: function onKeyPress(e) {
        return _this2.triggerPageChange(index + 1, e);
      },
      onClick: function onClick(e) {
        return _this2.triggerPageChange(index + 1, e);
      }
    }, _react.default.createElement(_.Icon, {
      name: "arrow-right_16"
    })));

    var viewportControls = function viewportControls() {
      var downloadButton = _react.default.createElement("div", {
        className: "cui-lightbox__control cui-lightbox__control-download",
        tabIndex: "0",
        role: "button",
        onClick: _this2.handleDownload,
        onKeyPress: _this2.handleDownload
      }, _react.default.createElement(_.Icon, {
        name: "download_16"
      }));

      var controlStyle = currentPage.content ? {
        visibility: 'hidden'
      } : {};
      var pageControl = pages.length > 1 ? _react.default.createElement("div", {
        className: "cui-lightbox__controls cui-lightbox__controls--center"
      }, _react.default.createElement(_.Tooltip, {
        tooltip: tooltips.previous
      }, _react.default.createElement("div", {
        className: "cui-lightbox__control",
        onClick: function onClick(e) {
          return _this2.triggerPageChange(index - 1, e);
        },
        role: "button",
        tabIndex: "0",
        onKeyPress: function onKeyPress(e) {
          return _this2.triggerPageChange(index - 1, e);
        },
        style: {
          transform: 'rotate(-180deg)'
        }
      }, _react.default.createElement(_.Icon, {
        name: "arrow-right_16"
      }))), _react.default.createElement("span", {
        className: "cui-lightbox__control-value"
      }, index + 1 + " / " + pages.length), _react.default.createElement(_.Tooltip, {
        tooltip: tooltips.next
      }, _react.default.createElement("div", {
        className: "cui-lightbox__control",
        role: "button",
        onClick: function onClick(e) {
          return _this2.triggerPageChange(index + 1, e);
        },
        tabIndex: "0",
        onKeyPress: function onKeyPress(e) {
          return _this2.triggerPageChange(index + 1, e);
        }
      }, _react.default.createElement(_.Icon, {
        name: "arrow-right_16"
      })))) : _react.default.createElement("div", {
        className: "cui-lightbox__controls"
      }, _react.default.createElement("span", {
        className: "cui-lightbox__control-value"
      }, index + 1));
      return _react.default.createElement("div", {
        className: "cui-lightbox__viewer-controls",
        onClick: _this2.stopPropagation,
        onKeyPress: _this2.stopPropagation,
        role: "button",
        tabIndex: "0"
      }, _react.default.createElement("div", {
        className: "cui-lightbox__controls",
        style: controlStyle
      }, _react.default.createElement(_.Tooltip, {
        tooltip: tooltips.zoomOut
      }, _react.default.createElement("div", {
        className: "cui-lightbox__control",
        onClick: function onClick() {
          return _this2.setZoom(-0.25);
        },
        role: "button",
        tabIndex: "0",
        onKeyPress: function onKeyPress() {
          return _this2.setZoom(-0.25);
        }
      }, _react.default.createElement(_.Icon, {
        name: "zoom-out_16"
      }))), _react.default.createElement("span", {
        className: "cui-lightbox__control-value"
      }, Math.round(zoom * 100), "%"), _react.default.createElement(_.Tooltip, {
        tooltip: tooltips.zoomIn
      }, _react.default.createElement("div", {
        className: "cui-lightbox__control",
        role: "button",
        onClick: function onClick() {
          return _this2.setZoom(0.25);
        },
        tabIndex: "0",
        onKeyPress: function onKeyPress() {
          return _this2.setZoom(0.25);
        }
      }, _react.default.createElement(_.Icon, {
        name: "zoom-in_16"
      })))), pageControl, _react.default.createElement("div", {
        className: "cui-lightbox__controls",
        style: controlStyle
      }, _react.default.createElement("span", {
        className: "cui-lightbox__control-value"
      }, info.size), _react.default.createElement(_.Tooltip, {
        tooltip: downloading ? tooltips.downloading : tooltips.download
      }, downloading ? _react.default.createElement("div", {
        className: "cui-lightbox__control cui-lightbox__control-spinner"
      }, _react.default.createElement(_.Spinner, {
        size: 28
      })) : downloadButton)));
    };

    return _react.default.createElement(_reactAriaModal.default, {
      includeDefaultStyles: false,
      getApplicationNode: function getApplicationNode() {
        return document.querySelector("#" + applicationId);
      },
      onExit: this.handleClose,
      focusDialog: true,
      titleId: "cui-lightbox",
      dialogClass: "cui-lightbox",
      underlayClass: "cui-lightbox__container"
    }, _react.default.createElement("div", {
      className: "cui-lightbox__header",
      ref: function ref(_ref2) {
        return _this2.lightBox = _ref2;
      }
    }, _react.default.createElement("div", {
      className: "cui-lightbox__header-item--left"
    }, _react.default.createElement("div", {
      className: "cui-lightbox__header-meta"
    }, _react.default.createElement("div", {
      className: "cui-lightbox__header-sharer"
    }, info.sharedBy), _react.default.createElement("div", {
      className: "cui-lightbox__header-timestamp"
    }, info.sharedOn))), _react.default.createElement("div", {
      className: "cui-lightbox__header-item--center"
    }, _react.default.createElement("div", {
      className: "cui-lightbox__header-name"
    }, name)), _react.default.createElement("div", {
      className: "cui-lightbox__header-item--right"
    }, _react.default.createElement(_.Tooltip, {
      tooltip: tooltips.exit,
      direction: "bottom-right"
    }, _react.default.createElement("div", {
      className: "cui-lightbox__control",
      onClick: this.handleClose,
      role: "button",
      tabIndex: "0",
      onKeyPress: this.handleClose
    }, _react.default.createElement(_.Icon, {
      name: "cancel_16"
    }))))), _react.default.createElement("div", {
      className: "cui-lightbox__body"
    }, showColumn && getThumbnails(), _react.default.createElement("div", {
      className: "cui-lightbox__content",
      onClick: this.handleClose,
      onKeyPress: this.handleClose,
      role: "button",
      tabIndex: "0"
    }, _react.default.createElement("div", {
      className: "cui-lightbox__viewport" + ("" + (!!currentPage.decrypting && " cui-lightbox__viewport--decrypting" || '')),
      ref: function ref(_ref3) {
        return _this2.viewport = _ref3;
      }
    }, pages[index].decrypting && _react.default.createElement(_.Spinner, {
      className: "cui-lightbox__decrypting-spinner"
    }), getViewport()), showColumn && leftArrowControl, showColumn && rightArrowControl, viewportControls())));
  };

  return Lightbox;
}(_react.default.Component);

Lightbox.propTypes = {
  /** @prop ID for Lightbox query lookup */
  applicationId: _propTypes.default.string.isRequired,

  /** Determines if info is decrypting | false */
  decrypting: _propTypes.default.bool,

  /** @prop Optional downloading css styling | false */
  downloading: _propTypes.default.bool,

  /** @prop Set Height value of Lightbox */
  height: _propTypes.default.number.isRequired,

  /** @prop Initial index of start page | 0 */
  index: _propTypes.default.number,

  /** @prop Lightbox information Object | {} */
  info: _propTypes.default.shape({
    sharedBy: _propTypes.default.string,
    sharedOn: _propTypes.default.string,
    size: _propTypes.default.string
  }),

  /** @prop Required name prop for Lightbox */
  name: _propTypes.default.string.isRequired,

  /** @prop Callback function invoked by user when interact with Lightbox | null */
  onChange: _propTypes.default.func,

  /** @prop Callback function invoked by user closing the Lightbox | null */
  onClose: _propTypes.default.func,

  /** @prop Callback function invoked by the download action of Lightbox | null */
  onDownload: _propTypes.default.func,

  /** @prop Array of Lightbox pages */
  pages: _propTypes.default.array.isRequired,

  /** @prop Collection of predefined tootips for various Lightbox actions | { download: 'Download', etc } */
  tooltips: _propTypes.default.shape({
    download: _propTypes.default.string,
    downloading: _propTypes.default.string,
    exit: _propTypes.default.string,
    previous: _propTypes.default.string,
    next: _propTypes.default.string,
    zoomIn: _propTypes.default.string,
    zoomOut: _propTypes.default.string
  }),

  /** @prop Set Width value for Lightbox */
  width: _propTypes.default.number.isRequired
};
Lightbox.defaultProps = {
  decrypting: false,
  downloading: false,
  index: 0,
  info: {},
  name: '',
  onChange: null,
  onClose: null,
  onDownload: null,
  tooltips: {
    download: 'Download',
    downloading: 'Downloading...',
    exit: 'Exit',
    previous: 'Previous',
    next: 'Next',
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out'
  }
};
Lightbox.displayName = 'Lightbox';
var _default = Lightbox;
/**
* @component lightbox
* @section default
* @react

import { Button, Lightbox } from '@collabui/react';
import reactIcon from '@collabui/core/docs/assets/react.png';

 export default class LightboxDefault extends React.Component {

  state = {
    index: 0,
    show: false,
    downloading: false,
  }

  render() {
    return (
      <div>
        <Button ariaLabel='Show Lightbox' onClick={() => this.setState({ show: true })}>Show</Button>
        {
          this.state.show &&
          <Lightbox
            onClose={() => this.setState({ show: false})}
            onChange={(idx) => this.setState({ index: idx })}
            name="Screen Shot 2018-04-11 at 7.32.51 PM.png"
            applicationId="app"
            onDownload={() => {
                this.setState({downloading: true});
                setTimeout(() => this.setState({downloading: false}), 2000);
              }
            }
            downloading={this.state.downloading}
            info={{sharedBy:"Shared by test", sharedOn: "At 4/17/2018, 10:02 AM", size: "34.4 KB"}}
            index={this.state.index}
            height={250}
            width={250}
            pages={[{
              decrypting: false,
              image: reactIcon,
              thumb: reactIcon
            }]}
          />
        }
      </div>
    );
  }
}
**/

/**
* @component lightbox
* @section multiple
* @react

import { Button, Lightbox } from '@collabui/react';
import reactIcon from '@collabui/core/docs/assets/react.png';
import angularIcon from '@collabui/core/docs/assets/angular.png';

 export default class LightBoxMultiple extends React.Component {

  state = {
    index: 0,
    show: false,
    downloading: false,
  }

  render() {
    return (
      <div>
        <Button ariaLabel='Show Lightbox' onClick={() => this.setState({ show: true })}>Show</Button>
        {
          this.state.show &&
          <Lightbox
            onClose={() => this.setState({ show: false})}
            onChange={(idx) => this.setState({ index: idx })}
            name="Screen Shot 2018-04-11 at 7.32.51 PM.png"
            applicationId="app"
            onDownload={() => {
                this.setState({downloading: true});
                setTimeout(() => this.setState({downloading: false}), 2000);
              }
            }
            downloading={this.state.downloading}
            info={{sharedBy:"Shared by test", sharedOn: "At 4/17/2018, 10:02 AM", size: "34.4 KB"}}
            index={this.state.index}
            height={250}
            width={250}
            pages={[{
              decrypting: false,
              image: reactIcon,
              thumb: reactIcon
            }, {
              decrypting: false,
              image: angularIcon,
              thumb: angularIcon
            }]}
          />
        }
      </div>
    );
  }
}
**/

exports.default = _default;

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(2);
var createFocusTrap = __webpack_require__(526);

var checkedProps = ['active', 'paused', 'tag', 'focusTrapOptions', '_createFocusTrap'];

var FocusTrap = function (_React$Component) {
  _inherits(FocusTrap, _React$Component);

  function FocusTrap(props) {
    _classCallCheck(this, FocusTrap);

    var _this = _possibleConstructorReturn(this, (FocusTrap.__proto__ || Object.getPrototypeOf(FocusTrap)).call(this, props));

    _this.setNode = function (el) {
      _this.node = el;
    };

    if (typeof document !== 'undefined') {
      _this.previouslyFocusedElement = document.activeElement;
    }
    return _this;
  }

  _createClass(FocusTrap, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // We need to hijack the returnFocusOnDeactivate option,
      // because React can move focus into the element before we arrived at
      // this lifecycle hook (e.g. with autoFocus inputs). So the component
      // captures the previouslyFocusedElement in componentWillMount,
      // then (optionally) returns focus to it in componentWillUnmount.
      var specifiedFocusTrapOptions = this.props.focusTrapOptions;
      var tailoredFocusTrapOptions = {
        returnFocusOnDeactivate: false
      };
      for (var optionName in specifiedFocusTrapOptions) {
        if (!specifiedFocusTrapOptions.hasOwnProperty(optionName)) continue;
        if (optionName === 'returnFocusOnDeactivate') continue;
        tailoredFocusTrapOptions[optionName] = specifiedFocusTrapOptions[optionName];
      }

      this.focusTrap = this.props._createFocusTrap(this.node, tailoredFocusTrapOptions);
      if (this.props.active) {
        this.focusTrap.activate();
      }
      if (this.props.paused) {
        this.focusTrap.pause();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.active && !this.props.active) {
        this.focusTrap.deactivate();
      } else if (!prevProps.active && this.props.active) {
        this.focusTrap.activate();
      }

      if (prevProps.paused && !this.props.paused) {
        this.focusTrap.unpause();
      } else if (!prevProps.paused && this.props.paused) {
        this.focusTrap.pause();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.focusTrap.deactivate();
      if (this.props.focusTrapOptions.returnFocusOnDeactivate !== false && this.previouslyFocusedElement && this.previouslyFocusedElement.focus) {
        this.previouslyFocusedElement.focus();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var elementProps = {
        ref: this.setNode
      };

      // This will get id, className, style, etc. -- arbitrary element props
      for (var prop in this.props) {
        if (!this.props.hasOwnProperty(prop)) continue;
        if (checkedProps.indexOf(prop) !== -1) continue;
        elementProps[prop] = this.props[prop];
      }

      return React.createElement(this.props.tag, elementProps, this.props.children);
    }
  }]);

  return FocusTrap;
}(React.Component);

FocusTrap.defaultProps = {
  active: true,
  tag: 'div',
  paused: false,
  focusTrapOptions: {},
  _createFocusTrap: createFocusTrap
};

module.exports = FocusTrap;

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

var tabbable = __webpack_require__(527);

var listeningFocusTrap = null;

function focusTrap(element, userOptions) {
  var tabbableNodes = [];
  var firstTabbableNode = null;
  var lastTabbableNode = null;
  var nodeFocusedBeforeActivation = null;
  var active = false;
  var paused = false;
  var tabEvent = null;

  var container = (typeof element === 'string')
    ? document.querySelector(element)
    : element;

  var config = userOptions || {};
  config.returnFocusOnDeactivate = (userOptions && userOptions.returnFocusOnDeactivate !== undefined)
    ? userOptions.returnFocusOnDeactivate
    : true;
  config.escapeDeactivates = (userOptions && userOptions.escapeDeactivates !== undefined)
    ? userOptions.escapeDeactivates
    : true;

  var trap = {
    activate: activate,
    deactivate: deactivate,
    pause: pause,
    unpause: unpause,
  };

  return trap;

  function activate(activateOptions) {
    if (active) return;

    var defaultedActivateOptions = {
      onActivate: (activateOptions && activateOptions.onActivate !== undefined)
        ? activateOptions.onActivate
        : config.onActivate,
    };

    active = true;
    paused = false;
    nodeFocusedBeforeActivation = document.activeElement;

    if (defaultedActivateOptions.onActivate) {
      defaultedActivateOptions.onActivate();
    }

    addListeners();
    return trap;
  }

  function deactivate(deactivateOptions) {
    if (!active) return;

    var defaultedDeactivateOptions = {
      returnFocus: (deactivateOptions && deactivateOptions.returnFocus !== undefined)
        ? deactivateOptions.returnFocus
        : config.returnFocusOnDeactivate,
      onDeactivate: (deactivateOptions && deactivateOptions.onDeactivate !== undefined)
        ? deactivateOptions.onDeactivate
        : config.onDeactivate,
    };

    removeListeners();

    if (defaultedDeactivateOptions.onDeactivate) {
      defaultedDeactivateOptions.onDeactivate();
    }

    if (defaultedDeactivateOptions.returnFocus) {
      setTimeout(function () {
        tryFocus(nodeFocusedBeforeActivation);
      }, 0);
    }

    active = false;
    paused = false;
    return this;
  }

  function pause() {
    if (paused || !active) return;
    paused = true;
    removeListeners();
  }

  function unpause() {
    if (!paused || !active) return;
    paused = false;
    addListeners();
  }

  function addListeners() {
    if (!active) return;

    // There can be only one listening focus trap at a time
    if (listeningFocusTrap) {
      listeningFocusTrap.pause();
    }
    listeningFocusTrap = trap;

    updateTabbableNodes();
    // Ensure that the focused element doesn't capture the event that caused the focus trap activation
    setTimeout(function () {
      tryFocus(firstFocusNode());
    }, 0);
    document.addEventListener('focus', checkFocus, true);
    document.addEventListener('click', checkClick, true);
    document.addEventListener('mousedown', checkPointerDown, true);
    document.addEventListener('touchstart', checkPointerDown, true);
    document.addEventListener('keydown', checkKey, true);

    return trap;
  }

  function removeListeners() {
    if (!active || listeningFocusTrap !== trap) return;

    document.removeEventListener('focus', checkFocus, true);
    document.removeEventListener('click', checkClick, true);
    document.removeEventListener('mousedown', checkPointerDown, true);
    document.removeEventListener('touchstart', checkPointerDown, true);
    document.removeEventListener('keydown', checkKey, true);

    listeningFocusTrap = null;

    return trap;
  }

  function getNodeForOption(optionName) {
    var optionValue = config[optionName];
    var node = optionValue;
    if (!optionValue) {
      return null;
    }
    if (typeof optionValue === 'string') {
      node = document.querySelector(optionValue);
      if (!node) {
        throw new Error('`' + optionName + '` refers to no known node');
      }
    }
    if (typeof optionValue === 'function') {
      node = optionValue();
      if (!node) {
        throw new Error('`' + optionName + '` did not return a node');
      }
    }
    return node;
  }

  function firstFocusNode() {
    var node;
    if (getNodeForOption('initialFocus') !== null) {
      node = getNodeForOption('initialFocus');
    } else if (container.contains(document.activeElement)) {
      node = document.activeElement;
    } else {
      node = tabbableNodes[0] || getNodeForOption('fallbackFocus');
    }

    if (!node) {
      throw new Error('You can\'t have a focus-trap without at least one focusable element');
    }

    return node;
  }

  // This needs to be done on mousedown and touchstart instead of click
  // so that it precedes the focus event
  function checkPointerDown(e) {
    if (config.clickOutsideDeactivates && !container.contains(e.target)) {
      deactivate({ returnFocus: false });
    }
  }

  function checkClick(e) {
    if (config.clickOutsideDeactivates) return;
    if (container.contains(e.target)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
  }

  function checkFocus(e) {
    if (container.contains(e.target)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    // Checking for a blur method here resolves a Firefox issue (#15)
    if (typeof e.target.blur === 'function') e.target.blur();

    if (tabEvent) {
      readjustFocus(tabEvent);
    }
  }

  function checkKey(e) {
    if (e.key === 'Tab' || e.keyCode === 9) {
      handleTab(e);
    }

    if (config.escapeDeactivates !== false && isEscapeEvent(e)) {
      deactivate();
    }
  }

  function handleTab(e) {
    updateTabbableNodes();

    if (e.target.hasAttribute('tabindex') && Number(e.target.getAttribute('tabindex')) < 0) {
      return tabEvent = e;
    }

    e.preventDefault();
    var currentFocusIndex = tabbableNodes.indexOf(e.target);

    if (e.shiftKey) {
      if (e.target === firstTabbableNode || tabbableNodes.indexOf(e.target) === -1) {
        return tryFocus(lastTabbableNode);
      }
      return tryFocus(tabbableNodes[currentFocusIndex - 1]);
    }

    if (e.target === lastTabbableNode) return tryFocus(firstTabbableNode);

    tryFocus(tabbableNodes[currentFocusIndex + 1]);
  }

  function updateTabbableNodes() {
    tabbableNodes = tabbable(container);
    firstTabbableNode = tabbableNodes[0];
    lastTabbableNode = tabbableNodes[tabbableNodes.length - 1];
  }

  function readjustFocus(e) {
    if (e.shiftKey) return tryFocus(lastTabbableNode);

    tryFocus(firstTabbableNode);
  }
}

function isEscapeEvent(e) {
  return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
}

function tryFocus(node) {
  if (!node || !node.focus) return;
  if (node === document.activeElement)  return;

  node.focus();
  if (node.tagName.toLowerCase() === 'input') {
    node.select();
  }
}

module.exports = focusTrap;


/***/ }),
/* 527 */
/***/ (function(module, exports) {

module.exports = function(el, options) {
  options = options || {};

  var elementDocument = el.ownerDocument || el;
  var basicTabbables = [];
  var orderedTabbables = [];

  // A node is "available" if
  // - it's computed style
  var isUnavailable = createIsUnavailable(elementDocument);

  var candidateSelectors = [
    'input',
    'select',
    'a[href]',
    'textarea',
    'button',
    '[tabindex]',
  ];

  var candidates = el.querySelectorAll(candidateSelectors.join(','));

  if (options.includeContainer) {
    var matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;

    if (
      candidateSelectors.some(function(candidateSelector) {
        return matches.call(el, candidateSelector);
      })
    ) {
      candidates = Array.prototype.slice.apply(candidates);
      candidates.unshift(el);
    }
  }

  var candidate, candidateIndexAttr, candidateIndex;
  for (var i = 0, l = candidates.length; i < l; i++) {
    candidate = candidates[i];
    candidateIndexAttr = parseInt(candidate.getAttribute('tabindex'), 10)
    candidateIndex = isNaN(candidateIndexAttr) ? candidate.tabIndex : candidateIndexAttr;

    if (
      candidateIndex < 0
      || (candidate.tagName === 'INPUT' && candidate.type === 'hidden')
      || candidate.disabled
      || isUnavailable(candidate, elementDocument)
    ) {
      continue;
    }

    if (candidateIndex === 0) {
      basicTabbables.push(candidate);
    } else {
      orderedTabbables.push({
        index: i,
        tabIndex: candidateIndex,
        node: candidate,
      });
    }
  }

  var tabbableNodes = orderedTabbables
    .sort(function(a, b) {
      return a.tabIndex === b.tabIndex ? a.index - b.index : a.tabIndex - b.tabIndex;
    })
    .map(function(a) {
      return a.node
    });

  Array.prototype.push.apply(tabbableNodes, basicTabbables);

  return tabbableNodes;
}

function createIsUnavailable(elementDocument) {
  // Node cache must be refreshed on every check, in case
  // the content of the element has changed
  var isOffCache = [];

  // "off" means `display: none;`, as opposed to "hidden",
  // which means `visibility: hidden;`. getComputedStyle
  // accurately reflects visiblity in context but not
  // "off" state, so we need to recursively check parents.

  function isOff(node, nodeComputedStyle) {
    if (node === elementDocument.documentElement) return false;

    // Find the cached node (Array.prototype.find not available in IE9)
    for (var i = 0, length = isOffCache.length; i < length; i++) {
      if (isOffCache[i][0] === node) return isOffCache[i][1];
    }

    nodeComputedStyle = nodeComputedStyle || elementDocument.defaultView.getComputedStyle(node);

    var result = false;

    if (nodeComputedStyle.display === 'none') {
      result = true;
    } else if (node.parentNode) {
      result = isOff(node.parentNode);
    }

    isOffCache.push([node, result]);

    return result;
  }

  return function isUnavailable(node) {
    if (node === elementDocument.documentElement) return false;

    var computedStyle = elementDocument.defaultView.getComputedStyle(node);

    if (isOff(node, computedStyle)) return true;

    return computedStyle.visibility === 'hidden';
  }
}


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(2);
var ReactDOM = __webpack_require__(61);

// React 16+ supports Portals.
var canUsePortals = !!ReactDOM.createPortal;

function displace(WrappedComponent, options) {
  if (!global.document) {
    return function (_React$Component) {
      _inherits(EmptyDisplace, _React$Component);

      function EmptyDisplace() {
        _classCallCheck(this, EmptyDisplace);

        return _possibleConstructorReturn(this, (EmptyDisplace.__proto__ || Object.getPrototypeOf(EmptyDisplace)).apply(this, arguments));
      }

      _createClass(EmptyDisplace, [{
        key: 'render',
        value: function render() {
          return false;
        }
      }]);

      return EmptyDisplace;
    }(React.Component);
  }

  options = options || {};

  var Displaced = function (_React$Component2) {
    _inherits(Displaced, _React$Component2);

    function Displaced() {
      var _ref;

      var _temp, _this2, _ret;

      _classCallCheck(this, Displaced);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = Displaced.__proto__ || Object.getPrototypeOf(Displaced)).call.apply(_ref, [this].concat(args))), _this2), _this2.renderDisplaced = function () {
        ReactDOM.unstable_renderSubtreeIntoContainer(_this2, React.createElement(WrappedComponent, _this2.props, _this2.props.children), _this2.container);
      }, _this2.removeDisplaced = function () {
        ReactDOM.unmountComponentAtNode(_this2.container);
      }, _temp), _possibleConstructorReturn(_this2, _ret);
    }

    _createClass(Displaced, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        this.container = function () {
          if (!options.renderTo) {
            var result = document.createElement('div');
            document.body.appendChild(result);
            return result;
          } else if (typeof options.renderTo === 'string') {
            return document.querySelector(options.renderTo);
          } else {
            return options.renderTo;
          }
        }();
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (canUsePortals) return;
        if (this.props.mounted) {
          this.renderDisplaced();
        }
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (canUsePortals) return;
        if (prevProps.mounted && !this.props.mounted) {
          ReactDOM.unmountComponentAtNode(this.container);
        } else if (this.props.mounted) {
          this.renderDisplaced();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (!canUsePortals) {
          ReactDOM.unmountComponentAtNode(this.container);
        }
        if (!options.renderTo) {
          this.container.parentNode.removeChild(this.container);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        if (!canUsePortals || this.props.mounted === false) {
          return null;
        }
        return ReactDOM.createPortal(React.createElement(WrappedComponent, this.props, this.props.children), this.container);
      }
    }]);

    return Displaced;
  }(React.Component);

  Displaced.defaultProps = {
    mounted: true
  };
  Displaced.WrappedComponent = WrappedComponent;


  return Displaced;
}

module.exports = displace;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)))

/***/ }),
/* 529 */
/***/ (function(module, exports) {

(function(root) {
  var isOn = false;
  var scrollbarSize;
  var scrollTop;

  function getScrollbarSize() {
    if (typeof scrollbarSize !== 'undefined') return scrollbarSize;

    var doc = document.documentElement;
    var dummyScroller = document.createElement('div');
    dummyScroller.setAttribute('style', 'width:99px;height:99px;' + 'position:absolute;top:-9999px;overflow:scroll;');
    doc.appendChild(dummyScroller);
    scrollbarSize = dummyScroller.offsetWidth - dummyScroller.clientWidth;
    doc.removeChild(dummyScroller);
    return scrollbarSize;
  }

  function hasScrollbar() {
    return document.documentElement.scrollHeight > window.innerHeight;
  }

  function on(options) {
    if (typeof document === 'undefined' || isOn) return;
    var doc = document.documentElement;
    scrollTop = window.pageYOffset;
    if (hasScrollbar()) {
      doc.style.width = 'calc(100% - '+ getScrollbarSize() +'px)';
    } else {
      doc.style.width = '100%';
    }
    doc.style.position = 'fixed';
    doc.style.top = -scrollTop + 'px';
    doc.style.overflow = 'hidden';
    isOn = true;
  }

  function off() {
    if (typeof document === 'undefined' || !isOn) return;
    var doc = document.documentElement;
    doc.style.width = '';
    doc.style.position = '';
    doc.style.top = '';
    doc.style.overflow = '';
    window.scroll(0, scrollTop);
    isOn = false;
  }

  function toggle() {
    if (isOn) {
      off();
      return;
    }
    on();
  }

  var noScroll = {
    on: on,
    off: off,
    toggle: toggle,
  };

  if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = noScroll;
  } else {
    root.noScroll = noScroll;
  }
})(this);


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(7);

__webpack_require__(4);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * @category controls
 * @component link
 * @variations collab-ui-react
 */
var Link = function Link(_ref) {
  var className = _ref.className,
      children = _ref.children,
      color = _ref.color,
      disabled = _ref.disabled,
      tag = _ref.tag,
      theme = _ref.theme,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "children", "color", "disabled", "tag", "theme"]);

  return _react.default.createElement(tag, Object.assign({
    className: 'cui-link' + ("" + (color && " cui-link--" + color || '')) + ("" + (theme && " cui-link--" + theme || '')) + ("" + (className && " " + className || '')),
    disabled: disabled
  }, !disabled && {
    tabIndex: 0
  }, props), children);
};

Link.propTypes = {
  /** @prop Children nodes to render inside Link Component | null */
  children: _propTypes.default.node.isRequired,

  /** @prop Optional css class string | '' */
  className: _propTypes.default.string,

  /** @prop Optional color css styling | 'blue' */
  color: _propTypes.default.string,

  /** @prop Sets the attribute disabled to the Link | false */
  disabled: _propTypes.default.bool,

  /** @prop Set HTML tag type | 'a' */
  tag: _propTypes.default.oneOf(['a', 'div', 'span']),

  /** @prop Set Link theme | ''  */
  theme: _propTypes.default.string
};
Link.defaultProps = {
  children: null,
  className: '',
  color: 'blue',
  disabled: false,
  tag: 'a',
  theme: ''
};
Link.displayName = 'Link';
var _default = Link;
/**
* @component link
* @section default
* @react
import { Link } from '@collabui/react';

export default function LinkDefault() {
  return(
    <div className='columns small-3'>
      <Link>Default</Link>
      <Link tag='div'>Tag Prop(div)</Link>
      <Link tag='span'>Tag Prop(span)</Link>
    </div>
  );
}

**/

/**
* @component link
* @section colored
* @react
import { Link } from '@collabui/react';

export default function LinkColored() {
  return(
    <Link tag='div' color='red'>Color Prop(red)</Link>
  );
}
**/

exports.default = _default;

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(7);

__webpack_require__(4);

__webpack_require__(58);

__webpack_require__(19);

__webpack_require__(20);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _lodash = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * List is container component used to help group list items.
 * @category containers
 * @component list-item
 * @variations collab-ui-react
 */
var List =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(List, _React$Component);

  function List() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      activeIndex: null,
      focus: null,
      id: _this.props.id || (0, _lodash.uniqueId)('cui-list-'),
      last: 0
    };

    _this.getChildContext = function () {
      return {
        setSelected: function setSelected(e, idx, value, label) {
          return _this.setSelected(e, idx, value, label);
        },
        handleListKeyDown: function handleListKeyDown(e, idx) {
          return _this.handleListKeyDown(e, idx);
        }
      };
    };

    _this.determineInitialFocus = function () {
      var nonDisabledIndex = _react.default.Children.toArray(_this.props.children).reduceRight(function (agg, child, idx) {
        return !child.props.disabled && !child.props.isReadOnly ? idx : agg;
      }, null);

      _this.setFocus(nonDisabledIndex);
    };

    _this.setSelected = function (e, index, value, label) {
      var _this$props = _this.props,
          children = _this$props.children,
          onSelect = _this$props.onSelect;
      var activeIndex = _this.state.activeIndex;

      _this.setFocus(index); // Don't do anything if onSelect Event Handler is present


      if (onSelect) {
        return onSelect(e, value, index, label);
      } // Don't do anything if index is the same or outside of the bounds


      if (index === activeIndex || index < 0 || index >= children.length) return; // Keep reference to last index for event handler

      var last = activeIndex; // Call change event handler

      _this.setState({
        activeIndex: index,
        last: last
      });
    };

    _this.setFocus = function (index) {
      _this.setState({
        focus: index
      });
    };

    _this.getIncludesFirstCharacter = function (str, char) {
      return str.charAt(0).toLowerCase().includes(char);
    };

    _this.setFocusByFirstCharacter = function (char, currentIdx, length) {
      var children = _this.props.children;

      var newIndex = _react.default.Children.toArray(children).reduce(function (agg, child, idx, arr) {
        var index = currentIdx + idx + 1 > length ? Math.abs(currentIdx + idx - length) : currentIdx + idx + 1;
        var label = arr[index].props.role === 'listItem' || arr[index].type.displayName === 'SelectOption' ? arr[index].props.label : arr[index].props.header;
        return !agg.length && !arr[index].props.disabled && !arr[index].props.isReadOnly && !['ListSeparator'].includes(arr[index].type.displayName) && _this.getIncludesFirstCharacter(label, char) ? agg.concat(index) : agg;
      }, []);

      !isNaN(newIndex[0]) && _this.setFocus(newIndex[0]);
    };

    _this.handleListKeyDown = function (e, idx) {
      var children = _this.props.children;
      var newIndex, clickEvent;
      var tgt = e.currentTarget;
      var char = e.key;
      var flag = false;
      var length = _react.default.Children.toArray(children).length - 1;

      var getNewIndex = function getNewIndex(currentIndex, change) {
        var getPossibleIndex = function getPossibleIndex() {
          if (currentIndex + change < 0) {
            return length;
          } else if (currentIndex + change > length) {
            return 0;
          }

          return currentIndex + change;
        };

        var possibleIndex = getPossibleIndex();

        var potentialTarget = _react.default.Children.toArray(_this.props.children)[possibleIndex];

        return potentialTarget.props.disabled || potentialTarget.props.isReadOnly || potentialTarget.type.displayName === "ListSeparator" ? getNewIndex(possibleIndex, change) : possibleIndex;
      };

      var isPrintableCharacter = function isPrintableCharacter(str) {
        return str.length === 1 && str.match(/\S/);
      };

      switch (e.which) {
        case 32:
        case 13:
          try {
            clickEvent = new MouseEvent('click', {
              view: window,
              bubbles: true,
              cancelable: true
            });
          } catch (err) {
            if (document.createEvent) {
              // DOM Level 3 for IE 9+
              clickEvent = document.createEvent('MouseEvents');
              clickEvent.initEvent('click', true, true);
            }
          }

          tgt.dispatchEvent(clickEvent);
          flag = true;
          break;

        case 38:
        case 37:
          newIndex = getNewIndex(idx, -1);

          _this.setFocus(newIndex);

          flag = true;
          break;

        case 39:
        case 40:
          newIndex = getNewIndex(idx, 1);

          _this.setFocus(newIndex);

          flag = true;
          break;

        case 33:
        case 36:
          _this.setFocus(0);

          flag = true;
          break;

        case 34:
        case 35:
          _this.setFocus(length);

          flag = true;
          break;

        default:
          if (isPrintableCharacter(char)) {
            _this.setFocusByFirstCharacter(char, idx, length);

            flag = true;
          }

          break;
      }

      if (flag) {
        e.stopPropagation();
        e.preventDefault();
      }
    };

    return _this;
  }

  var _proto = List.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var focusFirst = this.props.focusFirst;
    focusFirst && this.determineInitialFocus();
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        active = _this$props2.active,
        children = _this$props2.children,
        className = _this$props2.className,
        isMulti = _this$props2.isMulti,
        itemRole = _this$props2.itemRole,
        role = _this$props2.role,
        tabType = _this$props2.tabType,
        type = _this$props2.type,
        wrap = _this$props2.wrap,
        props = _objectWithoutPropertiesLoose(_this$props2, ["active", "children", "className", "isMulti", "itemRole", "role", "tabType", "type", "wrap"]);

    var _this$state = this.state,
        activeIndex = _this$state.activeIndex,
        focus = _this$state.focus,
        id = _this$state.id;
    var visibleClass = this.context.visibleClass;
    var otherProps = (0, _lodash.omit)(Object.assign({}, props), ['focusFirst']);

    var setListItems = _react.default.Children.map(children, function (child, idx) {
      var activeIndicator = typeof active === 'number' || Array.isArray(active) ? active : activeIndex;

      switch (child.type.displayName) {
        case 'ListItem':
        case 'ListItemMeeting':
          return _react.default.cloneElement(child, Object.assign({
            active: idx === activeIndicator
          }, type && {
            type: type
          }, {
            focus: focus === idx,
            itemIndex: idx,
            role: itemRole,
            id: id + "__list-item"
          }, focus === idx && {
            ref: function ref(_ref) {
              return _this2.activeChild = _ref;
            }
          }));

        case 'SpaceListItem':
          return _react.default.cloneElement(child, Object.assign({
            active: idx === activeIndicator,
            focus: focus === idx,
            itemIndex: idx,
            role: itemRole,
            id: id + "__sl-item"
          }, focus === idx && {
            ref: function ref(_ref2) {
              return _this2.activeChild = _ref2;
            }
          }));

        case 'SpaceListMeeting':
          return _react.default.cloneElement(child, Object.assign({
            active: idx === activeIndicator,
            focus: focus === idx,
            itemIndex: idx,
            role: itemRole,
            id: id + "__sl-item"
          }, focus === idx && {
            ref: function ref(_ref3) {
              return _this2.activeChild = _ref3;
            }
          }));

        case 'SelectOption':
          return _react.default.cloneElement(child, Object.assign({
            active: Array.isArray(activeIndicator) ? activeIndicator.includes(idx) : idx === activeIndicator,
            focus: focus === idx,
            itemIndex: idx,
            role: itemRole,
            isMulti: isMulti,
            id: id + "__so-item"
          }, focus === idx && {
            ref: function ref(_ref4) {
              return _this2.activeChild = _ref4;
            }
          }));

        default:
          return child;
      }
    });

    var ActiveDescendantId = this.activeChild && this.activeChild.id;
    /* eslint-disable jsx-a11y/aria-activedescendant-has-tabindex */

    return _react.default.createElement("div", _extends({
      className: 'cui-list' + (" cui-list" + (tabType && "--" + tabType || '')) + (" cui-list" + (wrap && "--wrap" || '')) + ("" + (visibleClass && " " + visibleClass || '')) + ("" + (className && " " + className || '')),
      role: role,
      "aria-activedescendant": ActiveDescendantId
    }, otherProps), setListItems);
    /* eslint-enable*/
  };

  return List;
}(_react.default.Component);

List.childContextTypes = {
  setSelected: _propTypes.default.func,
  handleListKeyDown: _propTypes.default.func
};
List.propTypes = {
  /** @prop Optional active prop to pass active prop to children | null */
  active: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.array]),

  /** @prop Children nodes to render inside List | null */
  children: _propTypes.default.node,

  /** @prop Optional css class string | '' */
  className: _propTypes.default.string,

  /** @prop Sets first List item to have focus | true */
  focusFirst: _propTypes.default.bool,

  /** @prop Optional ID value of List | null */
  id: _propTypes.default.string,

  /** @prop Optional prop to know if multiple children can be active | false */
  isMulti: _propTypes.default.bool,

  /** @prop Optional tabType prop type to manually set child role | 'listItem' */
  itemRole: _propTypes.default.string,

  /** @prop Callback function invoked by user selecting an interactive item within List | null */
  onSelect: _propTypes.default.func,

  /** @prop Sets the ARIA role for the Nav, in the context of a TabContainer | 'list' */
  role: _propTypes.default.string,

  /** @prop Sets the orientation of the List | 'vertical' */
  tabType: _propTypes.default.oneOf(['vertical', 'horizontal']),

  /** @prop Sets List size | null */
  type: _propTypes.default.oneOf(['small', 'large', 'space', 'xlarge']),

  /** @prop Optional wrap prop type to wrap items to next row */
  wrap: _propTypes.default.bool
};
List.defaultProps = {
  active: null,
  children: null,
  className: '',
  id: null,
  isMulti: false,
  itemRole: 'listItem',
  focusFirst: true,
  onSelect: null,
  role: 'list',
  tabType: 'vertical',
  type: null,
  wrap: false
};
List.contextTypes = {
  visibleClass: _propTypes.default.string
};
List.displayName = 'List';
var _default = List;
exports.default = _default;

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(7);

__webpack_require__(135);

__webpack_require__(19);

__webpack_require__(20);

__webpack_require__(4);

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(158);

var _react = _interopRequireDefault(__webpack_require__(2));

var _reactDom = _interopRequireDefault(__webpack_require__(61));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _lodash = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/**
 * @category containers
 * @component list-item
 * @variations collab-ui-react
 */
var ListItem =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ListItem, _React$Component);

  function ListItem() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      id: _this.props.id || (0, _lodash.uniqueId)('cui-list-item-')
    };

    _this.checkElements = function (tag) {
      var children = Object.values(_reactDom.default.findDOMNode(_assertThisInitialized(_assertThisInitialized(_this))).childNodes);
      return _this.countDOMChildren(children, tag);
    };

    _this.countDOMChildren = function (children, tag) {
      return children.reduce(function (agg, child) {
        return child.tagName === tag ? Object.assign({}, agg, {
          count: agg.count += 1
        }) : agg;
      }, {
        count: 0,
        children: children.length
      });
    };

    _this.getChildrenElements = function (nameArr) {
      var children = _this.props.children;
      var elementCount = 0;
      var childrenLength = 0;

      _react.default.Children.forEach(children, function (child) {
        childrenLength++;

        if (child.type && nameArr.includes(child.type.displayName)) {
          return elementCount++;
        }
      });

      return elementCount && {
        isCorrectUsage: elementCount === childrenLength,
        length: elementCount
      };
    };

    _this.handleClick = function (e) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          itemIndex = _this$props.itemIndex,
          label = _this$props.label,
          onClick = _this$props.onClick,
          value = _this$props.value;
      var setSelected = _this.context.setSelected;

      if (disabled) {
        e.preventDefault();
        e.stopPropagation();
      }

      e.persist();
      setSelected && setSelected(e, itemIndex, value, label);
      onClick && onClick(e);
    };

    _this.handleKeyDown = function (e) {
      var _this$props2 = _this.props,
          disabled = _this$props2.disabled,
          itemIndex = _this$props2.itemIndex,
          onKeyDown = _this$props2.onKeyDown;
      var handleListKeyDown = _this.context.handleListKeyDown;

      if (disabled) {
        e.preventDefault();
        e.stopPropagation();
      }

      e.persist();
      handleListKeyDown && handleListKeyDown(e, itemIndex);
      onKeyDown && onKeyDown(e);
    };

    return _this;
  }

  var _proto = ListItem.prototype;

  _proto.componentWillMount = function componentWillMount() {
    if (!this.props.children) return;
    var checkAllChildren = this.getChildrenElements(['ListItemSection', 'EventOverlay']);
    var checkSectionChildren = this.getChildrenElements(['ListItemSection']);

    if (!checkAllChildren) {
      return;
    } else if (!checkAllChildren.isCorrectUsage) {
      throw new Error("If ListItemSection Component is used all children must use ListItemSection Components.");
    } else if (checkSectionChildren.length > 3) {
      throw new Error("Only 3 ListItemSection components can be used as children. You've used " + checkSectionChildren.length);
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    var anchorCount = this.checkElements('A');
    var _this$props3 = this.props,
        focus = _this$props3.focus,
        refName = _this$props3.refName,
        focusOnLoad = _this$props3.focusOnLoad;

    if (anchorCount.count > 1) {
      throw new Error('Only 1 primary child anchor tag may be used with ListItem component');
    } else if (anchorCount.count === 1 && anchorCount.children > 1) {
      throw new Error('Anchor tag can not have sibling');
    }

    focusOnLoad && focus && this[refName] && this[refName].focus();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this$props4 = this.props,
        focus = _this$props4.focus,
        refName = _this$props4.refName;
    prevProps.focus !== focus && focus && this[refName] && this[refName].focus();
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props5 = this.props,
        active = _this$props5.active,
        children = _this$props5.children,
        className = _this$props5.className,
        customAnchorNode = _this$props5.customAnchorNode,
        customRefProp = _this$props5.customRefProp,
        disabled = _this$props5.disabled,
        focus = _this$props5.focus,
        isReadOnly = _this$props5.isReadOnly,
        label = _this$props5.label,
        link = _this$props5.link,
        refName = _this$props5.refName,
        role = _this$props5.role,
        separator = _this$props5.separator,
        title = _this$props5.title,
        type = _this$props5.type,
        props = _objectWithoutPropertiesLoose(_this$props5, ["active", "children", "className", "customAnchorNode", "customRefProp", "disabled", "focus", "isReadOnly", "label", "link", "refName", "role", "separator", "title", "type"]);

    var id = this.state.id;
    var otherProps = (0, _lodash.omit)(Object.assign({}, props), ['focusOnLoad', 'id', 'itemIndex', 'onClick', 'onKeyDown', 'value']);

    var addRefToAnchor = function addRefToAnchor(node) {
      var _ref;

      return _react.default.cloneElement(node, Object.assign({
        'aria-current': focus,
        className: 'cui-list-item' + ("" + (type && " cui-list-item--" + type || '')) + ("" + (active && " active" || '')) + ("" + (disabled && " disabled" || '')) + ("" + (isReadOnly && " cui-list-item--read-only" || '')) + ("" + (separator && " cui-list-item--separator" || '')) + ("" + (className && " " + className || '')) + ("" + (node.props.className && " " + node.props.className || '')),
        role: role
      }, customRefProp && (_ref = {}, _ref[customRefProp] = function (ref) {
        return _this2[_this2.props.refName] = ref;
      }, _ref), id && {
        id: id
      }, !isReadOnly && {
        onClick: _this2.handleClick,
        onKeyDown: _this2.handleKeyDown,
        tabIndex: !disabled && focus ? 0 : -1
      }, otherProps, (title || label) && {
        title: title || label
      }), children || node.props.children || label);
    };

    var customProps = Object.assign({
      'aria-current': focus,
      className: 'cui-list-item' + ("" + (type && " cui-list-item--" + type || '')) + ("" + (active && " active" || '')) + ("" + (disabled && " disabled" || '')) + ("" + (isReadOnly && " cui-list-item--read-only" || '')) + ("" + (separator && " cui-list-item--separator" || '')) + ("" + (className && " " + className || '')),
      id: id,
      role: role,
      ref: function ref(_ref2) {
        return _this2[refName] = _ref2;
      }
    }, !isReadOnly && {
      onClick: this.handleClick,
      onKeyDown: this.handleKeyDown,
      tabIndex: !disabled && focus ? 0 : -1
    }, link && {
      href: link
    }, otherProps, (title || label) && {
      title: title || label
    });
    return customAnchorNode ? addRefToAnchor(customAnchorNode) : _react.default.createElement(link ? 'a' : 'div', Object.assign({}, customProps), children || label);
  };

  return ListItem;
}(_react.default.Component);

ListItem.propTypes = {
  /** @prop Active prop to help determine styles | false */
  active: _propTypes.default.bool,

  /** @prop Children nodes to render inside ListItem | null  */
  children: _propTypes.default.node,

  /** @prop Optional css class string | '' */
  className: _propTypes.default.string,

  /** @prop Node in which the selection begins | null */
  customAnchorNode: _propTypes.default.element,

  /** @prop ListItem Custom Prop Name for child with custom Ref | null */
  customRefProp: _propTypes.default.string,

  /** @prop Disabled attribute for ListItem to determine styles | false */
  disabled: _propTypes.default.bool,

  /** @prop Specifies if ListItem should automatically get focus | false */
  focus: _propTypes.default.bool,

  /** @prop Specifies if ListItem should automatically get focus when page loads | false */
  focusOnLoad: _propTypes.default.bool,

  /** @prop Sets ListItem id | null */
  id: _propTypes.default.string,

  /** @prop Determines if ListItem is clickable | false */
  isReadOnly: _propTypes.default.bool,

  /** @prop ListItem index number | null */
  itemIndex: _propTypes.default.number,

  /** @prop ListItem label text | '' */
  label: _propTypes.default.string,

  /** @prop external link associated input | '' */
  link: _propTypes.default.string,

  /** @prop Callback function invoked by user tapping on ListItem | null */
  onClick: _propTypes.default.func,

  /** @prop Callback function invoked by user pressing on a key | null */
  onKeyDown: _propTypes.default.func,

  /** @prop ListItem ref name | 'navLink' */
  refName: _propTypes.default.string,

  /** @prop Aria role | 'listItem' */
  role: _propTypes.default.string,

  /** @prop Prop that controls whether to show separator or not | false */
  separator: _propTypes.default.bool,

  /** @prop ListItem Title | '' */
  title: _propTypes.default.string,

  /** @prop ListItem size | '' */
  type: _propTypes.default.oneOf(['', 'small', 'large', 'xlarge', 'space', 'header', 36, 52, 60]),

  /** @prop ListItem value for OnSelect value | '' */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.object, _propTypes.default.array])
};
ListItem.defaultProps = {
  active: false,
  children: null,
  className: '',
  customAnchorNode: null,
  customRefProp: '',
  disabled: false,
  focus: false,
  focusOnLoad: false,
  id: null,
  itemIndex: null,
  isReadOnly: false,
  label: '',
  link: '',
  onClick: null,
  onKeyDown: null,
  refName: 'navLink',
  role: 'listItem',
  separator: false,
  title: '',
  type: '',
  value: ''
};
ListItem.contextTypes = {
  setSelected: _propTypes.default.func,
  handleListKeyDown: _propTypes.default.func
};
ListItem.displayName = 'ListItem';
var _default = ListItem;
/**
* @component list
* @section default
* @react
*
import { List, ListItem } from '@collabui/react';

export default class ListItemDefault extends React.PureComponent {

  render() {
    return(
      <div className="medium-4 columns">
        <div>
          <List>
            <ListItem label='Default List Item 1' />
            <ListItem label='Default List Item 2' />
          </List>
        </div>
        <div className="cui--contrast">
          <List>
            <ListItem label='List Item 1 (with Contrast)' />
            <ListItem label='List Item 2 (with Contrast)' />
          </List>
        </div>
      </div>
    );
  }
}
**/

/**
* @component list
* @section list-item-sections
* @react
*
import { List, ListItem, ListItemSection } from '@collabui/react';

export default class ListItemSections extends React.PureComponent {

  render() {
    return(
      <div className="medium-4 columns">
        <List>
          <ListItem link='javascript:void(0)'>
            <ListItemSection position='left'>
              Left
              </ListItemSection>
              <ListItemSection position='right'>
                Right
              </ListItemSection>
          </ListItem>
          <ListItem link='javascript:void(0)'>
            <ListItemSection position='center'>
              Center
            </ListItemSection>
          </ListItem>
          <ListItem link='javascript:void(0)'>
            <ListItemSection position='center-align'>
              Center Align
            </ListItemSection>
          </ListItem>
          <ListItem link='javascript:void(0)'>
            <ListItemSection position='left'>
              Left
            </ListItemSection>
            <ListItemSection position='center'>
              Center
            </ListItemSection>
            <ListItemSection position='right'>
              Right
            </ListItemSection>
          </ListItem>
        </List>
      </div>
    );
  }
}
**/

/**
* @component list
* @section list-item-separator
* @react
*
import { List, ListItem, ListItemSection } from '@collabui/react';

export default class ListItemSeparator extends React.PureComponent {

  render() {
    return(
      <ListSeparator
        text='Text Color'
        textColor='orange'
        lineColor='red'
      />
    );
  }
}
**/

exports.default = _default;

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(4);

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(7);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _lodash = __webpack_require__(13);

var _ = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * @category containers
 * @component list-item
 * @variations collab-ui-react
 */
var ListItemHeader =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(ListItemHeader, _React$PureComponent);

  function ListItemHeader() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;
    _this.state = {
      id: _this.props.id || (0, _lodash.uniqueId)('cui-space-list-item__header-')
    };
    return _this;
  }

  var _proto = ListItemHeader.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        header = _this$props.header,
        title = _this$props.title,
        type = _this$props.type,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "className", "header", "title", "type"]);

    var id = this.state.id;
    var getTitle = !title ? header : title;
    var staticChildren = [_react.default.createElement(_.ListItemSection, {
      key: "child-0",
      position: "center"
    }, _react.default.createElement("div", {
      className: 'cui-list-item__header'
    }, header)), _react.default.createElement(_.ListItemSection, {
      key: "child-1",
      position: "right"
    }, children)];
    return _react.default.createElement(_.ListItem, _extends({
      className: 'cui-list-item-header' + ("" + (type && " cui-list-item-header--" + type || '')) + ("" + (className && " " + className || '')),
      isReadOnly: true,
      id: id,
      title: getTitle
    }, props), staticChildren);
  };

  return ListItemHeader;
}(_react.default.PureComponent);

ListItemHeader.propTypes = {
  /** @prop Children nodes to render inside ListItemHeader | null */
  children: _propTypes.default.node,

  /** @prop Optional css class string | '' */
  className: _propTypes.default.string,

  /** @prop ListItem header text */
  header: _propTypes.default.string.isRequired,

  /** @prop HTML ID for associated input | '' */
  id: _propTypes.default.string,

  /** @prop Determines if ListItemHeader is Clickable | true */
  isReadOnly: _propTypes.default.bool,

  /** @prop ListItem title | '' */
  title: _propTypes.default.string,

  /** @prop ListItemHeader type variation | '' */
  type: _propTypes.default.oneOf(['', 'space'])
};
ListItemHeader.defaultProps = {
  children: null,
  className: '',
  id: '',
  isReadOnly: true,
  title: '',
  type: ''
};
ListItemHeader.displayName = 'ListItemHeader';
var _default = ListItemHeader;
/**
* @component list
* @section list-item-header
* @react
*
import { List, ListItemHeader } from '@collabui/react';
import { NavLink } from 'react-router-dom';

export default class ListItemHeaderExample extends React.PureComponent {

  render() {
    const anchorNode = <NavLink to='/containers/list-item'>More</NavLink>;
    return(
      <div className="medium-4 columns">
        <List>
          <ListItemHeader header='Testing' children={anchorNode} />
        </List>
        <List className='cui--dark' style={{backgroundColor: 'rgba(40,40,40,0.72)'}}>
          <ListItemHeader header='Testing' children={anchorNode}/>
        </List>
      </div>
    );
  }
}
**/

exports.default = _default;

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(7);

__webpack_require__(4);

var _react = _interopRequireDefault(__webpack_require__(2));

var _reactDom = _interopRequireDefault(__webpack_require__(61));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _lodash = __webpack_require__(13);

var _ = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * @category containers
 * @component list-item
 * @variations collab-ui-react
 */
var ListItemMeeting =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(ListItemMeeting, _React$PureComponent);

  function ListItemMeeting() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;
    _this.state = {
      id: _this.props.id || (0, _lodash.uniqueId)('cui-list-item__meeting-'),
      isOpen: false,
      offset: -10
    };

    _this.handleAnchorClick = function (e) {
      var anchorOnClick = _this.props.anchorOnClick;
      e.persist();
      anchorOnClick && anchorOnClick(e);
      e.stopPropagation();
    };

    _this.handleAnchorKeyDown = function (e) {
      if (e.which === 32 || e.which === 13 || e.charCode === 32 || e.charCode === 13) {
        _this.handleAnchorClick(e);
      } else {
        e.stopPropagation();
      }
    };

    _this.handleClick = function (e) {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          ratioOffset = _this$props.ratioOffset;
      var isOpen = _this.state.isOpen;

      _this.setState(function () {
        onClick && onClick(e);
        return {
          offset: _reactDom.default.findDOMNode(_this.container).getBoundingClientRect().width * ratioOffset,
          isOpen: !isOpen
        };
      });
    };

    _this.handleClickAway = function () {
      _this.setState({
        isOpen: false
      });
    };

    return _this;
  }

  var _proto = ListItemMeeting.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        anchorLabel = _this$props2.anchorLabel,
        anchorOnClick = _this$props2.anchorOnClick,
        childrenRight = _this$props2.childrenRight,
        className = _this$props2.className,
        date = _this$props2.date,
        eventOverlayProps = _this$props2.eventOverlayProps,
        header = _this$props2.header,
        includeDate = _this$props2.includeDate,
        inProgress = _this$props2.inProgress,
        isAllDay = _this$props2.isAllDay,
        isCompleted = _this$props2.isCompleted,
        isRecurring = _this$props2.isRecurring,
        popoverContent = _this$props2.popoverContent,
        statusColor = _this$props2.statusColor,
        timeNode = _this$props2.timeNode,
        time = _this$props2.time,
        title = _this$props2.title,
        type = _this$props2.type,
        props = _objectWithoutPropertiesLoose(_this$props2, ["anchorLabel", "anchorOnClick", "childrenRight", "className", "date", "eventOverlayProps", "header", "includeDate", "inProgress", "isAllDay", "isCompleted", "isRecurring", "popoverContent", "statusColor", "timeNode", "time", "title", "type"]);

    var _this$state = this.state,
        id = _this$state.id,
        isOpen = _this$state.isOpen,
        offset = _this$state.offset;
    var otherProps = (0, _lodash.omit)(Object.assign({}, props), ['onClick', 'ratioOffset']);
    var getTitle = !title ? header : title;

    var getTime = function getTime() {
      if (timeNode) {
        return timeNode;
      } else if (isAllDay) {
        return _react.default.createElement("span", null, "All day");
      } else if (includeDate && time.start) {
        return [_react.default.createElement("span", {
          key: "date"
        }, date), _react.default.createElement("span", {
          key: "time"
        }, time.start + ("" + (time.end ? " - " + time.end : '')))];
      } else if (includeDate && date) {
        return _react.default.createElement("span", null, date);
      } else if (time.start) {
        return [_react.default.createElement("span", {
          key: "time-0"
        }, time.start), time.end && _react.default.createElement("span", {
          key: "time-1"
        }, time.end)];
      }
    };

    var children = [_react.default.createElement(_.ListItemSection, {
      key: "child-0",
      position: "left",
      inProgress: inProgress,
      includeDate: includeDate
    }, (inProgress || type === 'chip') && _react.default.createElement("span", {
      style: Object.assign({}, statusColor && {
        backgroundColor: statusColor
      }),
      className: "cui-list-item-meeting__progress-line"
    }), getTime()), _react.default.createElement(_.ListItemSection, {
      key: "child-1",
      position: "center"
    }, _react.default.createElement("div", {
      className: "cui-list-item__header"
    }, _react.default.createElement("span", null, header), isRecurring && _react.default.createElement(_.Icon, {
      name: "recurring_12"
    })), _react.default.createElement("div", {
      className: "cui-list-item__space-link"
    }, anchorLabel && anchorOnClick && _react.default.createElement(_.Link, {
      tag: "div",
      onClick: this.handleAnchorClick,
      onKeyDown: this.handleAnchorKeyDown,
      role: "button",
      title: anchorLabel
    }, anchorLabel))), _react.default.createElement(_.ListItemSection, {
      key: "child-2",
      position: "right"
    }, childrenRight), _react.default.createElement(_.EventOverlay, _extends({
      key: "child-3",
      direction: "right-center",
      isDynamic: true,
      close: this.handleClickAway,
      isOpen: isOpen,
      children: popoverContent,
      targetOffset: {
        horizontal: offset
      },
      showArrow: true,
      anchorNode: this.container,
      checkOverflow: false
    }, eventOverlayProps))];
    return _react.default.createElement(_.ListItem, _extends({
      className: 'cui-list-item-meeting' + ("" + (isCompleted && ' cui-list-item-meeting--completed' || '')) + ("" + (type && " cui-list-item-meeting--" + type || '')) + ("" + (className && " " + className || '')),
      id: id,
      title: getTitle,
      type: 60,
      ref: function ref(_ref) {
        return _this2.container = _ref;
      },
      onClick: this.handleClick
    }, otherProps), children);
  };

  return ListItemMeeting;
}(_react.default.PureComponent);

ListItemMeeting.propTypes = {
  /** @prop Callback function invoked when user taps on anchor link | '' */
  anchorOnClick: _propTypes.default.func,

  /** @prop ListItemMeeting Anchor link text | '' */
  anchorLabel: _propTypes.default.string,

  /** @prop Children nodes to render on the right inside ListItemMeeting | null */
  childrenRight: _propTypes.default.node,

  /** @prop Optional css class string | '' */
  className: _propTypes.default.string,

  /** @prop Date string | null */
  date: _propTypes.default.string,

  /** @prop Event Overlay props to be overwritten | null */
  eventOverlayProps: _propTypes.default.shape({}),

  /** @prop ListItem header text */
  header: _propTypes.default.string.isRequired,

  /** @prop HTML ID for ListItemMeeting | '' */
  id: _propTypes.default.string,

  /** @prop Determines if the ListItemMeeting includes the date | false */
  includeDate: _propTypes.default.bool,

  /** @prop Determines if the ListItemMeeting is in progress | false */
  inProgress: _propTypes.default.bool,

  /** @prop Determines if the ListItemMeeting is all day | false */
  isAllDay: _propTypes.default.bool,

  /** @prop Determines if the ListItemMeeting is recurring | false */
  isRecurring: _propTypes.default.bool,

  /** @prop Determines if the ListItemMeeting has Completed | false */
  isCompleted: _propTypes.default.bool,

  /** @prop Callback function invoked when user taps on ListItemMeeting | null */
  onClick: _propTypes.default.func,

  /** @prop ListItemMeeting Popover Content | null */
  popoverContent: _propTypes.default.node,

  /** @prop EventOverlay Ratio of Offset | -.4 */
  ratioOffset: _propTypes.default.number,

  /** @prop Sets the status Color | null */
  statusColor: _propTypes.default.string,

  /** @prop Set the Time Object | { start: '', end: '' } */
  time: _propTypes.default.shape({
    start: _propTypes.default.string,
    end: _propTypes.default.string
  }),

  /** @prop Set the Time Node | null */
  timeNode: _propTypes.default.node,

  /** @prop ListItemMeeting title | '' */
  title: _propTypes.default.string,

  /** @prop ListItemMeeting Type | '' */
  type: _propTypes.default.oneOf(['chip', ''])
};
ListItemMeeting.defaultProps = {
  anchorOnClick: null,
  anchorLabel: '',
  childrenRight: null,
  className: '',
  date: null,
  eventOverlayProps: null,
  header: '',
  id: '',
  includeDate: false,
  inProgress: false,
  isAllDay: false,
  isRecurring: false,
  isCompleted: false,
  onClick: null,
  popoverContent: null,
  ratioOffset: -.4,
  statusColor: null,
  time: {
    start: '',
    end: ''
  },
  timeNode: null,
  title: '',
  type: ''
};
ListItemMeeting.displayName = 'ListItemMeeting';
var _default = ListItemMeeting;
/**
* @component list-item
* @section default
* @react
*
import {
  Avatar,
  Icon,
  List,
  ListItemHeader,
  ListItemMeeting,
  ListSeparator,
} from '@collabui/react';

export default class ListItemDefault extends React.PureComponent {

  render() {
    return(
      <List>
        <ListItemMeeting
          isAllDay
          header='ListItemMeeting (isAllDay)'
          anchorLabel='SpaceString'
          anchorOnClick={() => console.log('anchor clicked')}
          childrenRight={<Avatar title='NA' />} popoverContent={'test'}
        />

        <ListItemMeeting
          time={{ start: '5:00PM', end: '10:00PM' }}
          header='ListItemMeeting (time object)'
          isRecurring
          anchorLabel='SpaceString'
          anchorOnClick={() => console.log('anchor clicked')}
          childrenRight={<Avatar title='NA' />} popoverContent={'test'}
        />

        <ListItemMeeting
          time={{ start: '5:00PM', end: '10:00PM' }}
          inProgress
          header='ListItemMeeting (inProgress)'
          anchorLabel='SpaceString'
          anchorOnClick={() => console.log('anchor clicked')}
          childrenRight={<Avatar title='NA' />}
          popoverContent={'test'}
        />

        <ListItemMeeting
          includeDate={true}
          date='January 24, 2018'
          time={{ start: '10:00 AM', end: '11:00 AM' }}

          header="Finish presentation on focus areas"
        />
        <ListItemMeeting
          inProgress
          type='chip'
          includeDate={true}
          date='January 25, 2018'
          time={{ start: '3:00PM', end: '4:00PM' }}
          header="I'm a flagged meeting"
        />

        <ListItemMeeting
          includeDate={true}
          date='March 2, 2019'
          isRecurring
          isCompleted
          header='ListItemMeeting (isCompleted)'
          anchorLabel='SpaceString'
          anchorOnClick={() => console.log('anchor clicked')}
          childrenRight={<Avatar title='NA' />} popoverContent={'test'}
        />
      </List>
    );
  }
}
**/

exports.default = _default;

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* @category containers
* @component list-item
* @variations collab-ui-react
*/
var ListItemSection = function ListItemSection(props) {
  var children = props.children,
      className = props.className,
      position = props.position;
  return _react.default.createElement("div", {
    className: "cui-list-item__" + position + ("" + (className && " " + className || ''))
  }, children);
};

ListItemSection.propTypes = {
  /** @prop Children nodes to render inside ListItemSection | null */
  children: _propTypes.default.node,

  /** @prop Optional css class name | '' */
  className: _propTypes.default.string,

  /** @prop Determine the ListItemSection's position | 'center' */
  position: _propTypes.default.oneOf(['left', 'center', 'right', 'center-align'])
};
ListItemSection.defaultProps = {
  children: null,
  className: '',
  position: 'center'
};
ListItemSection.displayName = 'ListItemSection';
var _default = ListItemSection;
exports.default = _default;

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(7);

__webpack_require__(4);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * @category containers
 * @component list-separator
 * @variations collab-ui-react
 */
var ListSeparator = function ListSeparator(props) {
  var children = props.children,
      className = props.className,
      lineColor = props.lineColor,
      margin = props.margin,
      textColor = props.textColor,
      text = props.text,
      textPadding = props.textPadding,
      otherProps = _objectWithoutPropertiesLoose(props, ["children", "className", "lineColor", "margin", "textColor", "text", "textPadding"]);

  return _react.default.createElement("div", _extends({
    className: 'cui-list-separator' + ("" + (className && " " + className || '')),
    style: Object.assign({}, lineColor && {
      color: lineColor
    }, margin && {
      margin: margin
    })
  }, otherProps), _react.default.createElement("span", {
    className: "cui-list-separator__container"
  }, children || text && _react.default.createElement("span", {
    className: "cui-list-separator__text",
    style: Object.assign({}, textColor && {
      color: textColor
    }, textPadding && {
      padding: textPadding
    })
  }, children ? children : text)));
};

ListSeparator.propTypes = {
  /** @prop Children nodes to render inside ListSeparator | null */
  children: _propTypes.default.node,

  /** @prop Optional css class name | null */
  className: _propTypes.default.string,

  /** @prop Color of the ListSeparator line | null */
  lineColor: _propTypes.default.string,

  /** @prop Margin of the ListSeparator | null */
  margin: _propTypes.default.string,

  /** @prop Text of the ListSeparator | null */
  text: _propTypes.default.string,

  /** @prop TextColor of the ListSeparator | null */
  textColor: _propTypes.default.string,

  /** @prop Padding around text of the ListSeparator | null */
  textPadding: _propTypes.default.string
};
ListSeparator.defaultProps = {
  children: null,
  className: null,
  lineColor: null,
  margin: null,
  text: null,
  textColor: null,
  textPadding: null
};
ListSeparator.displayName = 'ListSeparator';
var _default = ListSeparator;
exports.default = _default;

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(136);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @category communication
 * @component loading-spinner
 * @variations collab-ui-react
 */
var Loading = function Loading(props) {
  var small = props.small;
  return _react.default.createElement("div", {
    className: "cui-loading " + (small ? 'cui-loading--small' : '')
  }, _react.default.createElement("span", {
    className: "cui-loading__icon"
  }), _react.default.createElement("span", {
    className: "cui-loading__icon"
  }), _react.default.createElement("span", {
    className: "cui-loading__icon"
  }));
};

Loading.propTypes = {
  /** @prop Prop to make the Loading animation small | false */
  small: _propTypes.default.bool
};
Loading.defaultProps = {
  small: false
};
Loading.displayName = 'Loading';
var _default = Loading;
/**
* @name Default Loading
* @description Loadings are useful.
*
* @category communication
* @component loader-spinner
* @section default
*
* @js
import { Loading } from '@collabui/react';

export default function LoaderSpinnerDefault() {
  return (
    <div className="row">
      <div className="docs-example docs-example--spacing" style={{fontSize: '1rem', display: 'flex'}}>
        <Loading />
      </div>
      <div className="docs-example docs-example--spacing" style={{fontSize: '2rem', display: 'flex'}}>
        <Loading />
      </div>
      <div className="docs-example docs-example--spacing" style={{fontSize: '3rem', display: 'flex'}}>
        <Loading />
      </div>
    </div>
  );
}

**/

exports.default = _default;

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(7);

__webpack_require__(4);

__webpack_require__(58);

__webpack_require__(19);

__webpack_require__(20);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _lodash = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * Menu is container component which contains MenuItems
 * @component Menu
 * @variations collab-ui-react
 */
var Menu =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Menu, _React$Component);

  function Menu() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      menuIndex: []
    };

    _this.getChildContext = function () {
      return {
        handleClick: _this.handleClick,
        handleKeyDown: _this.handleKeyDown
      };
    };

    _this.handleClick = function (e, menuItemIndex, menuItem) {
      var onSelect = _this.context.onSelect;
      var children = menuItem.props.children;

      var selectedChildIndex = children && _this.getNewIndex(-1, 1, _react.default.Children.toArray(children));

      _this.setState({
        menuIndex: children ? menuItemIndex.concat(selectedChildIndex) : [menuItemIndex[0]]
      }, function () {
        return onSelect && onSelect(e, menuItemIndex, menuItem);
      });
    };

    _this.getNewIndex = function (currentIndex, change, siblings) {
      var getPossibleIndex = function getPossibleIndex() {
        var length = siblings.length - 1;

        if (currentIndex + change < 0) {
          return length;
        } else if (currentIndex + change > length) {
          return 0;
        }

        return currentIndex + change;
      };

      var possibleIndex = getPossibleIndex();

      var potentialTarget = _react.default.Children.toArray(siblings)[possibleIndex];

      return potentialTarget.props.disabled || potentialTarget.props.isHeader ? _this.getNewIndex(possibleIndex, change, siblings) : possibleIndex;
    };

    _this.setFocusInCurrentMenu = function (newIndex) {
      var menuIndex = _this.state.menuIndex;
      var clonedIndex = !menuIndex.length ? [].concat(newIndex) : [].concat(menuIndex.slice(0, menuIndex.length - 1), [newIndex]);

      _this.setState({
        menuIndex: clonedIndex
      });
    };

    _this.handleKeyDown = function (e, selectedIndex, menuItem) {
      var menuIndex = _this.state.menuIndex;
      var children = _this.props.children;
      var onSelect = _this.context.onSelect;
      var subMenu = menuItem.props.children;

      var subMenuIndex = subMenu && _this.getNewIndex(-1, 1, _react.default.Children.toArray(subMenu));

      var originIndex = selectedIndex[selectedIndex.length - 1];

      var getSiblings = function getSiblings(idx, menuItems) {
        if (menuItems === void 0) {
          menuItems = children;
        }

        if (idx.length === 1) {
          return menuItems;
        }

        return getSiblings(idx.slice(1), _react.default.Children.toArray(menuItems[idx[0]].props.children));
      };

      var getIncludesFirstCharacter = function getIncludesFirstCharacter(str, char) {
        return str.charAt(0).toLowerCase().includes(char);
      };

      var setFocusByFirstCharacter = function setFocusByFirstCharacter(char, currentIdx) {
        var siblings = getSiblings(currentIdx);
        var length = siblings.length - 1;
        var indexInSubmenu = currentIdx[currentIdx.length - 1];

        var newIndex = _react.default.Children.toArray(siblings).reduce(function (agg, child, idx, arr) {
          var index = indexInSubmenu + idx + 1 > length ? Math.abs(indexInSubmenu + idx - length) : indexInSubmenu + idx + 1;
          var label = arr[index].props.label;
          return !agg.length && !arr[index].props.disabled && !arr[index].props.isReadOnly && getIncludesFirstCharacter(label, char) ? agg.concat(index) : agg;
        }, []);

        !isNaN(newIndex[0]) && _this.setFocusInCurrentMenu(newIndex[0]);
      };

      var isPrintableCharacter = function isPrintableCharacter(str) {
        return str.length === 1 && str.match(/\S/);
      };

      var flag = false;
      var char = e.key;

      switch (e.which) {
        case 38:
          _this.setFocusInCurrentMenu(_this.getNewIndex(originIndex, -1, getSiblings(selectedIndex)));

          flag = true;
          break;

        case 40:
          _this.setFocusInCurrentMenu(_this.getNewIndex(originIndex, 1, getSiblings(selectedIndex)));

          flag = true;
          break;

        case 39:
          //right
          subMenu && _this.setState({
            menuIndex: menuIndex.concat(subMenuIndex)
          }, function () {
            return onSelect && onSelect(e, menuIndex, menuItem);
          });
          flag = true;
          break;

        case 37:
          //left
          menuIndex.length - 1 && _this.setState({
            menuIndex: menuIndex.slice(0, menuIndex.length - 1)
          });
          flag = true;
          break;

        default:
          if (isPrintableCharacter(char)) {
            setFocusByFirstCharacter(char, selectedIndex);
            flag = true;
          }

          break;
      }

      if (flag) {
        e.stopPropagation();
        e.preventDefault();
      }
    };

    return _this;
  }

  var _proto = Menu.prototype;

  _proto.componentWillMount = function componentWillMount() {
    var children = this.props.children;
    var initialIndex = this.getNewIndex(-1, 1, _react.default.Children.toArray(children));
    this.setState({
      menuIndex: [initialIndex]
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        ariaLabel = _this$props.ariaLabel,
        children = _this$props.children,
        className = _this$props.className,
        props = _objectWithoutPropertiesLoose(_this$props, ["ariaLabel", "children", "className"]);

    var menuIndex = this.state.menuIndex;

    var setMenuItems = function setMenuItems(menuList, currentItemIndex) {
      if (currentItemIndex === void 0) {
        currentItemIndex = [];
      }

      return _react.default.Children.toArray(menuList).map(function (child, idx) {
        if (!child.type || !['MenuItem', 'SubMenu'].includes(child.type.displayName)) {
          throw new Error('[@collabui/react] Menu: children of Menu should be of type MenuItem or SubMenu');
        }

        var menuItemIndex = currentItemIndex.concat(idx);
        var menuItems = child.props.children;
        var focus = (0, _lodash.isEqual)(menuIndex, menuItemIndex);
        var isOpen = (0, _lodash.isEqual)(menuIndex.slice(0, menuItemIndex.length), menuItemIndex) && menuIndex.length !== menuItemIndex.length;
        return _react.default.cloneElement(child, Object.assign({
          index: menuItemIndex,
          focus: focus,
          isOpen: isOpen
        }, child.type.displayName === 'SubMenu' && {
          children: menuItems && setMenuItems(_react.default.Children.toArray(menuItems), menuItemIndex)
        }));
      });
    };

    return _react.default.createElement("div", _extends({
      className: 'cui-menu' + ' cui-menu-item-container' + ("" + (className && " " + className || '')),
      "aria-label": ariaLabel,
      role: "menubar"
    }, props), setMenuItems(children));
  };

  return Menu;
}(_react.default.Component);

exports.default = Menu;
Menu.propTypes = {
  /** @prop Text to display for accessibility features | ''  */
  ariaLabel: _propTypes.default.string,

  /** @prop Children nodes to render inside Menu | null */
  children: _propTypes.default.node,

  /** @prop Optional css class name | '' */
  className: _propTypes.default.string
};
Menu.defaultProps = {
  ariaLabel: '',
  children: null,
  className: ''
};
Menu.contextTypes = {
  onSelect: _propTypes.default.func
};
Menu.childContextTypes = {
  handleClick: _propTypes.default.func,
  handleKeyDown: _propTypes.default.func
};
Menu.displayName = 'Menu';

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(4);

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(7);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * MenuContent is container component to display content in MenuOverlay
 * @component MenuContent
 * @variations collab-ui-react
 */
var MenuContent =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(MenuContent, _React$PureComponent);

  function MenuContent() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = MenuContent.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "className"]);

    return _react.default.createElement("div", _extends({
      className: 'cui-menu-content' + ("" + (className && " " + className || ''))
    }, props), children);
  };

  return MenuContent;
}(_react.default.PureComponent);

MenuContent.propTypes = {
  /** @prop Children nodes to render inside MenuContent component | null */
  children: _propTypes.default.node,

  /** @prop Optional css class name | '' */
  className: _propTypes.default.string
};
MenuContent.defaultProps = {
  children: null,
  className: ''
};
MenuContent.displayName = 'MenuContent';
var _default = MenuContent;
exports.default = _default;

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(7);

__webpack_require__(4);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _lodash = __webpack_require__(13);

var _ = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * @category containers
 * @component menu-overlay
 * @variations collab-ui-react
 */
var MenuOverlay =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(MenuOverlay, _React$Component);

  function MenuOverlay() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      isOpen: false
    };

    _this.getChildContext = function () {
      return {
        onSelect: _this.onSelect
      };
    };

    _this.verifyChildren = function () {
      var children = _this.props.children;

      var status = _react.default.Children.toArray(children).reduce(function (status, child) {
        return status && child.type && (child.type.displayName === 'MenuContent' || child.type.displayName === 'Menu');
      }, true);

      if (!status) {
        throw new Error('MenuOverlay should only contain Menu or MenuContent as children');
      }
    };

    _this.onSelect = function (e, menuIndex, menuItem) {
      var onSelect = _this.props.onSelect;
      var keepMenuOpen = menuItem.props.keepMenuOpen;
      onSelect && onSelect(e, menuIndex, menuItem);
      menuItem.constructor.displayName !== 'SubMenu' && !keepMenuOpen && _this.handleClose();
    };

    _this.handleClose = function () {
      _this.setState({
        isOpen: false
      });
    };

    return _this;
  }

  var _proto = MenuOverlay.prototype;

  _proto.componentWillMount = function componentWillMount() {
    this.verifyChildren();
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        menuTrigger = _this$props.menuTrigger,
        showArrow = _this$props.showArrow,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "className", "menuTrigger", "showArrow"]);

    var isOpen = this.state.isOpen;
    var otherProps = (0, _lodash.omit)(Object.assign({}, props), ['onSelect']);

    var setMenuTrigger = function setMenuTrigger() {
      return _react.default.cloneElement(menuTrigger, {
        onClick: function onClick() {
          return _this2.setState({
            isOpen: !isOpen
          });
        },
        ref: function ref(_ref) {
          return _this2.anchorNode = _ref;
        }
      });
    };

    return _react.default.createElement("div", {
      className: 'cui-menu-overlay-wrapper' + ("" + (className && " " + className || ''))
    }, setMenuTrigger(), _react.default.createElement(_.EventOverlay, _extends({
      allowClickAway: true,
      anchorNode: this.anchorNode,
      className: "cui-menu-overlay",
      close: this.handleClose,
      isOpen: isOpen,
      showArrow: showArrow
    }, otherProps), children));
  };

  return MenuOverlay;
}(_react.default.Component);

MenuOverlay.childContextTypes = {
  onSelect: _propTypes.default.func
};
MenuOverlay.propTypes = {
  /** @prop Children nodes to render inside MenuOverlay | null */
  children: _propTypes.default.node,

  /** @prop Optional css class name | '' */
  className: _propTypes.default.string,

  /** @prop HTML element that provides control to MenuOverlay user  */
  menuTrigger: _propTypes.default.element.isRequired,

  /** @prop Callback function invoked when user selects MenuOverlay | null */
  onSelect: _propTypes.default.func,

  /** @prop Determines if the MenuOverlay should show the open/close arrow | true */
  showArrow: _propTypes.default.bool
};
MenuOverlay.defaultProps = {
  children: null,
  className: '',
  onSelect: null,
  showArrow: true
};
MenuOverlay.displayName = 'MenuOverlay';
var _default = MenuOverlay;
/**
* @component menu
* @section default
* @react
*

import {
  Button,
  EditableTextfield,
  Menu,
  MenuContent,
  MenuItem,
  MenuOverlay,
} from '@collabui/react';

export default class MenuOverlayDefault extends React.PureComponent {
  onClick(event, value) {
    alert(`${value} clicked`);
  }

  render() {
    return(
      <MenuOverlay
        menuTrigger={<Button ariaLabel="Show Menu">Show Menu</Button>}>
        <MenuContent>
          <EditableTextfield inputText="Content Area" />
        </MenuContent>
        <Menu>
          <MenuItem onClick={this.onClick} label="Settings" />
        </Menu>
      </MenuOverlay>
    );
  }
}
**/

/**
* @component menu
* @section sub-menu
* @react
*

import {
  Button,
  Menu,
  MenuItem,
  MenuOverlay,
  SubMenu
} from '@collabui/react';

export default class MenuOverlaySubMenu extends React.PureComponent {
  onClick(event, value) {
    alert(`${value} clicked`);
  }

  render() {
    return(
      <MenuOverlay
        menuTrigger={
          <Button ariaLabel='Show Menu'>Show Menu</Button>
        }
      >
        <Menu>
          <SubMenu
            selectedValue="English"
            label="Language"
          >
            <MenuItem label="English" />
            <MenuItem label="Spanish" />
          </SubMenu>
        </Menu>
      </MenuOverlay>
    );
  }
}
**/

/**
* @component menu
* @section custom-menu-items
* @react
*

import {
  Button,
  Icon,
  ListItemSection,
  Menu,
  MenuContent,
  MenuItem,
  MenuOverlay,
} from '@collabui/react';

export default class CustomMenuItems extends React.PureComponent {
  onClick(event, value) {
    alert(`${value} clicked`);
  }

  render() {
    return(
      <MenuOverlay
        menuTrigger={
          <Button ariaLabel='Show Custom Menu'>Show Customized MenuItems</Button>
        }
        direction='top-center'
      >
        <MenuContent>Content</MenuContent>
        <Menu>
          <MenuItem>
            <ListItemSection position="left">
              <Icon name='edit_20' />
            </ListItemSection>
            <ListItemSection position="center">
              Edit space settings
          </ListItemSection>
          </MenuItem>
          <MenuItem keepMenuOpen>
            <ListItemSection position="left">
              <Icon name='favorite_20' />
            </ListItemSection>
            <ListItemSection position="center">
              Add to favorites
          </ListItemSection>
          </MenuItem>
          <MenuItem>
            <ListItemSection position="left">
              <Icon name='alert_20' />
            </ListItemSection>
            <ListItemSection position="center">
              Notifications
          </ListItemSection>
          </MenuItem>
          <MenuItem>
            <ListItemSection position="left">
              <Icon name='accessories_20' />
            </ListItemSection>
            <ListItemSection position="center">
              Add Integrations & Bots
          </ListItemSection>
          </MenuItem>
          <MenuItem>
            <ListItemSection position="left">
              <Icon name='stored-info_20' />
            </ListItemSection>
            <ListItemSection position="center">
              View space policy
          </ListItemSection>
          </MenuItem>
          <MenuItem keepMenuOpen>
            <ListItemSection position="left">
              <Icon name='archive_20' />
            </ListItemSection>
            <ListItemSection position="center">
              Archive space
          </ListItemSection>
          </MenuItem>
          <MenuItem keepMenuOpen>
            <ListItemSection position="left">
              <Icon name='cancel_20' />
            </ListItemSection>
            <ListItemSection position="center">
              Remove space from team
          </ListItemSection>
          </MenuItem>
          <MenuItem>
            <ListItemSection position="left">
              <Icon name='exit-room_20' />
            </ListItemSection>
            <ListItemSection position="center">
              Leave space
          </ListItemSection>
          </MenuItem>
        </Menu>
      </MenuOverlay>
    );
  }
}
**/

exports.default = _default;

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(7);

__webpack_require__(4);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _lodash = __webpack_require__(13);

var _ = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var MenuItem =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(MenuItem, _React$Component);

  function MenuItem() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      anchorRef: null
    };

    _this.handleKeyDown = function (e) {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          index = _this$props.index;
      var _this$context = _this.context,
          handleKeyDown = _this$context.handleKeyDown,
          handleClick = _this$context.handleClick;

      if (e.which === 32 || e.which === 13 || e.charCode === 32 || e.charCode === 13) {
        onClick && onClick(e);
        handleClick && handleClick(e, index, _assertThisInitialized(_assertThisInitialized(_this)));
        e.preventDefault();
      } else {
        handleKeyDown && handleKeyDown(e, index, _assertThisInitialized(_assertThisInitialized(_this)));
      }
    };

    _this.handleClick = function (e) {
      var handleClick = _this.context.handleClick;
      var _this$props2 = _this.props,
          index = _this$props2.index,
          onClick = _this$props2.onClick,
          value = _this$props2.value,
          label = _this$props2.label;
      onClick && onClick(e, {
        value: value,
        label: label
      });
      handleClick && handleClick(e, index, _assertThisInitialized(_assertThisInitialized(_this)));
    };

    return _this;
  }

  var _proto = MenuItem.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props3 = this.props,
        children = _this$props3.children,
        className = _this$props3.className,
        isHeader = _this$props3.isHeader,
        isOpen = _this$props3.isOpen,
        label = _this$props3.label,
        props = _objectWithoutPropertiesLoose(_this$props3, ["children", "className", "isHeader", "isOpen", "label"]);

    var otherProps = (0, _lodash.omit)(Object.assign({}, props), ['index', 'keepMenuOpen', 'onClick']);
    return _react.default.createElement("div", {
      className: 'cui-menu-item' + ("" + (className && " " + className || '')),
      "aria-expanded": isOpen,
      "aria-haspopup": !!children
    }, _react.default.createElement(_.ListItem, _extends({
      active: isOpen,
      className: "" + (isHeader && "cui-menu-item__header" || ''),
      focusOnLoad: true,
      isReadOnly: isHeader
    }, !isHeader && {
      onClick: this.handleClick
    }, !isHeader && {
      onKeyDown: this.handleKeyDown
    }, {
      ref: function ref(_ref) {
        return !_this2.state.anchorRef && _this2.setState({
          anchorRef: _ref
        });
      },
      role: "menuitem"
    }, otherProps), label || children));
  };

  return MenuItem;
}(_react.default.Component);

MenuItem.propTypes = {
  /** @prop Children nodes to render inside MenuItem | null */
  children: _propTypes.default.node,

  /** @prop Optional css class name | '' */
  className: _propTypes.default.string,

  /** @prop Index value of MenuItem | null */
  index: _propTypes.default.array,

  /** @prop Determines if MenuItem is the header | false */
  isHeader: _propTypes.default.bool,

  /** @prop Determines if MenuItem is open | false */
  isOpen: _propTypes.default.bool,

  /** @prop Set to keep the MenuItem open | false */
  keepMenuOpen: _propTypes.default.bool,

  /** @prop label text of MenuItem | '' */
  label: _propTypes.default.string,

  /** @prop Callback function invoked when user taps on MenutItem | null */
  onClick: _propTypes.default.func,

  /** @prop MenuItem value | '' */
  value: _propTypes.default.string
};
MenuItem.defaultProps = {
  children: null,
  className: '',
  index: null,
  isHeader: false,
  isOpen: false,
  keepMenuOpen: false,
  label: '',
  onClick: null,
  value: ''
};
MenuItem.contextTypes = {
  handleClick: _propTypes.default.func,
  handleKeyDown: _propTypes.default.func
};
MenuItem.displayName = 'MenuItem';
var _default = MenuItem;
exports.default = _default;

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(4);

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(7);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _reactAriaModal = _interopRequireDefault(__webpack_require__(289));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * @category containers
 * @component modal
 * @variations collab-ui-react
 */
var Modal =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Modal, _React$Component);

  function Modal() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      animationClass: _this.props.show ? 'in' : ''
    };

    _this.getChildContext = function () {
      return {
        handleClose: function handleClose(e) {
          return _this.closeModal(e);
        }
      };
    };

    _this.closeModal = function (e) {
      _this.setAnimationState();

      return setTimeout(function () {
        _this.props.onHide(e);
      }, 300);
    };

    _this.setAnimationState = function (isOpen) {
      _this.setState({
        animationClass: isOpen ? 'in' : ''
      });
    };

    return _this;
  }

  var _proto = Modal.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    prevProps.show !== this.props.show && this.props.show && this.setAnimationState(true);
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        applicationId = _this$props.applicationId,
        backdrop = _this$props.backdrop,
        backdropClickExit = _this$props.backdropClickExit,
        children = _this$props.children,
        className = _this$props.className,
        escapeExits = _this$props.escapeExits,
        focusDialog = _this$props.focusDialog,
        htmlId = _this$props.htmlId,
        renderTo = _this$props.renderTo,
        show = _this$props.show,
        size = _this$props.size,
        props = _objectWithoutPropertiesLoose(_this$props, ["applicationId", "backdrop", "backdropClickExit", "children", "className", "escapeExits", "focusDialog", "htmlId", "renderTo", "show", "size"]);

    var modalContent = _react.default.createElement("div", {
      className: "cui-modal__content"
    }, _react.default.createElement("div", {
      className: "cui-modal__flex-container"
    }, children));

    var RenderModal = renderTo ? _reactAriaModal.default.renderTo("#" + renderTo) : _reactAriaModal.default;

    var getModal = function getModal() {
      return show && _react.default.createElement(RenderModal, _extends({
        onExit: _this2.closeModal,
        getApplicationNode: function getApplicationNode() {
          return document.querySelector("#" + applicationId);
        },
        dialogClass: "cui-modal" + (" cui-modal--" + size) + (" " + _this2.state.animationClass) + ("" + (className && " " + className || '')),
        includeDefaultStyles: false,
        titleId: htmlId,
        underlayClass: backdrop ? "cui-modal__backdrop fade" + (" " + _this2.state.animationClass) : '',
        underlayClickExits: backdropClickExit,
        escapeExits: escapeExits,
        focusDialog: focusDialog
      }, props), modalContent);
    };

    return getModal();
  };

  return Modal;
}(_react.default.Component);

Modal.childContextTypes = {
  handleClose: _propTypes.default.func
};
Modal.propTypes = {
  /** @prop application DOM id, used to set aria-hidden to true when modal is open */
  applicationId: _propTypes.default.string.isRequired,

  /** @prop Determines the visibility and ability to edit the backdrop of the Modal | true */
  backdrop: _propTypes.default.bool,

  /** @prop To enable/disable clicking on underlay to exit modal | false */
  backdropClickExit: _propTypes.default.bool,

  /** @prop Children nodes to render inside the Modal | null */
  children: _propTypes.default.node,

  /** @prop Optional css class names | '' */
  className: _propTypes.default.string,

  /** @prop To enable/disable escape to exit modal | true */
  escapeExits: _propTypes.default.bool,

  /** @prop To set focus to the entire modal rather than elements within modal | true */
  focusDialog: _propTypes.default.bool,

  /** @prop Unique HTML ID used for tying label to HTML input for automated testing */
  htmlId: _propTypes.default.string.isRequired,

  /** @prop Icon node to be rendered for Dialog | null */
  icon: _propTypes.default.element,

  /** @prop Callback function invoked when user clicks on cross button or esc key */
  onHide: _propTypes.default.func.isRequired,

  /** @prop To render to an element other than the browser window | null */
  renderTo: _propTypes.default.string,

  /** @prop Show/hide modal */
  show: _propTypes.default.bool.isRequired,

  /** @prop Size of the modal | 'default' */
  size: _propTypes.default.oneOf(['large', 'medium', 'default', 'small', 'full', 'dialog'])
};
Modal.defaultProps = {
  backdrop: true,
  backdropClickExit: false,
  children: null,
  className: '',
  escapeExits: true,
  focusDialog: true,
  icon: null,
  renderTo: null,
  show: false,
  size: 'default'
};
Modal.displayName = 'Modal';
var _default = Modal;
/**
* @component modal
* @section default
* @react

import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from '@collabui/react';

export default class ModalDefault extends React.PureComponent {
  state = {
    showModal: false,
    showModal2: false,
  }

  render() {
    return (
      <div className='row'>
        <div className="docs-example docs-example--spacing">

          <Button
            children='Default/Medium Modal'
            onClick={() => this.setState({showModal: true})}
            ariaLabel='Open Modal'
            color='primary'
          />
          <Button
            children='Default/Medium Modal with Message'
            onClick={() => this.setState({showModal2: true})}
            ariaLabel='Open Modal 2'
            color='primary'
          />

          <Modal
            applicationId='app'
            onHide={() => this.setState({showModal: false})}
            show={this.state.showModal}
            ref={modal1 => this.modal1 = modal1}
            htmlId='modal1'
            backdropClickExit
          >
            <ModalHeader
              headerLabel='Default Modal'
              showCloseButton
            />
            <ModalBody>
              <form ref={form1 => this.form1 = form1} />
            </ModalBody>
            <ModalFooter>
              <Button
                children='Cancel'
                onClick={() => this.modal1.closeModal()}
                ariaLabel='Close Modal'
                color='default'
              />
              <Button
                children='OK'
                type='submit'
                onClick={(e) => {
                  e.preventDefault();
                  this.modal1.closeModal();
                }}
                ariaLabel='Submit Form'
                color='blue'
              />
            </ModalFooter>
          </Modal>

          <Modal
            applicationId='app'
            onHide={() => this.setState({showModal2: false})}
            show={this.state.showModal2}
            ref={modal2 => this.modal2 = modal2}
            htmlId='modal2'
            backdropClickExit
          >
            <ModalHeader
              headerLabel='Default Modal'
              message='To create a meeting invite manually, copy and paste the meeting information and people into your email calendar invite.'
              showCloseButton
            />
            <ModalBody>
              <form ref={form1 => this.form1 = form1} />
            </ModalBody>
            <ModalFooter>
              <Button
                children='Cancel'
                onClick={() => this.modal2.closeModal()}
                ariaLabel='Close Modal'
                color='default'
              />
              <Button
                children='OK'
                type='submit'
                onClick={(e) => {
                  e.preventDefault();
                  this.modal2.closeModal();
                }}
                ariaLabel='Submit Form'
                color='blue'
              />
            </ModalFooter>
          </Modal>

        </div>
      </div>
    );
  }
}

**/

/**
* @component modal
* @section small
* @react

import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Form
} from '@collabui/react';

export default class ModalSmall extends React.PureComponent {
  state = {
    showModal3: false,
    showModal4: false,
  }

  render() {
    return (
      <div className='row'>
        <div className="docs-example docs-example--spacing">

          <Button
            children='Small Modal'
            onClick={() => this.setState({showModal3: true})}
            ariaLabel='Open Modal'
            color='primary'
          />
          <Button
            children='Small Modal with Message'
            onClick={() => this.setState({showModal4: true})}
            ariaLabel='Open Modal'
            color='primary'
          />

          <Modal
            applicationId='app'
            onHide={() => this.setState({showModal3: false})}
            show={this.state.showModal3}
            ref={modal3 => this.modal3 = modal3}
            size='small'
            htmlId='modal3'
          >
            <ModalHeader
              headerLabel='Small Modal'
              showCloseButton
            />
            <ModalBody>
              <form ref={moform2 => this.moform2 = moform2} />
            </ModalBody>
            <ModalFooter>
              <Button
                children='Cancel'
                onClick={() => this.modal3.closeModal()}
                ariaLabel='Close Modal'
                color='default'
              />
              <Button
                children='OK'
                type='submit'
                onClick={(e) => {
                  e.preventDefault;
                  this.modal3.closeModal();
                }}
                ariaLabel='Submit Form'
                color='blue'
              />
            </ModalFooter>
          </Modal>

          <Modal
            applicationId='app'
            onHide={() => this.setState({showModal4: false})}
            show={this.state.showModal4}
            ref={modal4 => this.modal4 = modal4}
            size='small'
            htmlId='modal4'
          >
            <ModalHeader
              headerLabel='Small Modal'
              showCloseButton
              message='To create a meeting invite manually, copy and paste the meeting information and people into your email calendar invite.'
            />
            <ModalBody>
              <form ref={moform2 => this.moform2 = moform2} />
            </ModalBody>
            <ModalFooter>
              <Button
                children='Cancel'
                onClick={() => this.modal4.closeModal()}
                ariaLabel='Close Modal'
                color='default'
              />
              <Button
                children='OK'
                type='submit'
                onClick={(e) => {
                  e.preventDefault;
                  this.modal4.closeModal();
                }}
                ariaLabel='Submit Form'
                color='blue'
              />
            </ModalFooter>
          </Modal>

        </div>
      </div>
    );
  }
}
**/

/**
* @component modal
* @section large
* @react

import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from '@collabui/react';

export default class ModalLarge extends React.PureComponent {
  state = {
    showModal5: false,
    showModal6: false,
  }

  render() {
    return (
      <div className='row'>
        <div className="docs-example docs-example--spacing">

          <Button
            children='Large Modal'
            onClick={() => this.setState({showModal5: true})}
            ariaLabel='Open Modal'
            color='primary'
          />
          <Button
            children='Large Modal with Message'
            onClick={() => this.setState({showModal6: true})}
            ariaLabel='Open Modal'
            color='primary'
          />

          <Modal
            applicationId='app'
            onHide={() => this.setState({showModal5: false})}
            show={this.state.showModal5}
            ref={modal5 => this.modal5 = modal5}
            htmlId='modal5'
            size='large'
          >
            <ModalHeader
              headerLabel='Large Modal'
              showCloseButton
            />
            <ModalBody>
              <form ref={form1 => this.form1 = form1} />
            </ModalBody>
            <ModalFooter>
              <Button
                children='Cancel'
                onClick={() => this.modal5.closeModal()}
                ariaLabel='Close Modal'
                color='default'
              />
              <Button
                children='OK'
                type='submit'
                onClick={(e) => {
                  e.preventDefault();
                  this.modal5.closeModal();
                }}
                ariaLabel='Submit Form'
                color='blue'
              />
            </ModalFooter>
          </Modal>

          <Modal
            applicationId='app'
            onHide={() => this.setState({showModal6: false})}
            show={this.state.showModal6}
            ref={modal6 => this.modal6 = modal6}
            htmlId='modal6'
            size='large'
          >
            <ModalHeader
              headerLabel='Large Modal'
              showCloseButton
              message='To create a meeting invite manually, copy and paste the meeting information and people into your email calendar invite. To create a meeting invite manually, copy and paste the meeting information and people into your email calendar invite.'
            />
            <ModalBody>
              <form ref={form1 => this.form1 = form1} />
            </ModalBody>
            <ModalFooter>
              <Button
                children='Cancel'
                onClick={() => this.modal6.closeModal()}
                ariaLabel='Close Modal'
                color='default'
              />
              <Button
                children='OK'
                type='submit'
                onClick={(e) => {
                  e.preventDefault();
                  this.modal6.closeModal();
                }}
                ariaLabel='Submit Form'
                color='blue'
              />
            </ModalFooter>
          </Modal>

        </div>
      </div>
    );
  }
}
**/

/**
* @component modal
* @section full
* @react

import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from '@collabui/react';

export default class ModalFull extends React.PureComponent {
  state = {
    showModal7: false,
    showModal8: false,
  }

  render() {
    return (
      <div className='row'>
        <div className="docs-example docs-example--spacing">

          <Button
            children='Full Modal'
            onClick={() => this.setState({showModal7: true})}
            ariaLabel='Open Modal'
            color='primary'
          />
          <Button
            children='Full Modal with Message'
            onClick={() => this.setState({showModal8: true})}
            ariaLabel='Open Modal'
            color='primary'
          />

          <Modal
            applicationId='app'
            onHide={() => this.setState({showModal7: false})}
            show={this.state.showModal7}
            ref={modal7 => this.modal7 = modal7}
            htmlId='modal7'
            size='full'
          >
            <ModalHeader
              headerLabel='Full Modal'
              showCloseButton
            />
            <ModalBody>
              <form ref={form1 => this.form1 = form1} />
            </ModalBody>
            <ModalFooter>
              <Button
                children='Cancel'
                onClick={() => this.modal7.closeModal()}
                ariaLabel='Close Modal'
                color='default'
              />
              <Button
                children='OK'
                type='submit'
                onClick={(e) => {
                  e.preventDefault();
                  this.modal7.closeModal();
                }}
                ariaLabel='Submit Form'
                color='blue'
              />
            </ModalFooter>
          </Modal>

          <Modal
            applicationId='app'
            onHide={() => this.setState({showModal8: false})}
            show={this.state.showModal8}
            ref={modal8 => this.modal8 = modal8}
            htmlId='modal8'
            size='full'
          >
            <ModalHeader
              headerLabel='Full Modal'
              showCloseButton
              message='To create a meeting invite manually, copy and paste the meeting information and people into your email calendar invite.'
            />
            <ModalBody>
              <form ref={form1 => this.form1 = form1} />
            </ModalBody>
            <ModalFooter>
              <Button
                children='Cancel'
                onClick={() => this.modal8.closeModal()}
                ariaLabel='Close Modal'
                color='default'
              />
              <Button
                children='OK'
                type='submit'
                onClick={(e) => {
                  e.preventDefault();
                  this.modal8.closeModal();
                }}
                ariaLabel='Submit Form'
                color='blue'
              />
            </ModalFooter>
          </Modal>

        </div>
      </div>
    );
  }
}
**/

/**
* @component dialog
* @section dialog
* @react

import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Icon
} from '@collabui/react';

export default class Dialog extends React.PureComponent {
  state = {
    showDialog: false,
    showModalInternal: false
  }

  render() {
    return (
      <div className='row'>
        <div className="docs-example docs-example--spacing">

          <Button
            children='Dialog Modal'
            onClick={() => this.setState({showDialog: true})}
            ariaLabel='Open Modal'
            color='primary'
          />
          <Button
            children='Render To Div'
            onClick={() => this.setState({showModalInternal: true})}
            ariaLabel='Open Modal'
            color='primary'
          />

          <Modal
            icon={<Icon name="warning_72" color="$yellow"/>}
            applicationId='app'
            onHide={() => this.setState({showDialog: false})}
            show={this.state.showDialog}
            ref={modalDialog => this.modalDialog = modalDialog}
            size='dialog'
            htmlId='modalDialog'
          >
            <ModalHeader
              headerLabel='Dialog Modal'
            />
            <ModalBody>
              <span>I'm just a dialog box</span>
            </ModalBody>
            <ModalFooter>
              <Button
                children='Cancel'
                onClick={() => this.modalDialog.closeModal()}
                ariaLabel='Close Modal'
                color='default'
              />
              <Button
                children='OK'
                onClick={() => this.modalDialog.closeModal()}
                ariaLabel='Submit Form'
                color='blue'
              />
            </ModalFooter>
          </Modal>

        <div id='render-to-modal'/>

        <Modal
          icon={<Icon name="warning_72" color="$yellow"/>}
          applicationId='app'
          onHide={() => this.setState({showModalInternal: false})}
          show={this.state.showModalInternal}
          ref={ref => this.modalInternal = ref}
          size='dialog'
          htmlId='modalInternal'
          renderTo='render-to-modal'
        >
          <ModalHeader
            headerLabel='Dialog Modal'
          />
          <ModalBody>
            <span>I'm just a dialog box</span>
          </ModalBody>
          <ModalFooter>
            <Button
              children='Cancel'
              onClick={() => this.modalInternal.closeModal()}
              ariaLabel='Close Modal'
              color='default'
            />
            <Button
              children='OK'
              onClick={() => this.modalInternal.closeModal()}
              ariaLabel='Submit Form'
              color='blue'
            />
          </ModalFooter>
        </Modal>

        </div>
      </div>
    );
  }
}

**/

exports.default = _default;

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(4);

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(7);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * @category containers
 * @component modal
 * @variations collab-ui-react
 */
var ModalBody = function ModalBody(props) {
  var className = props.className,
      other = _objectWithoutPropertiesLoose(props, ["className"]);

  return _react.default.createElement("div", _extends({
    className: "cui-modal__body" + ("" + (className && " " + className || ''))
  }, other), props.children);
};

ModalBody.propTypes = {
  /** @prop Children nodes to render inside the ModalBody | null */
  children: _propTypes.default.node,

  /** @prop Optional css class names | '' */
  className: _propTypes.default.string
};
ModalBody.defaultProps = {
  children: null,
  className: ''
};
ModalBody.displayName = 'ModalBody';
var _default = ModalBody;
/**
* @name Modal Body
*
* @category containers
* @component modal
* @section Modal Body
*
* @js

import {
  Input,
  ModalBody,
} from '@collabui/react';

export default function ModalBody() {
    return (
      <div className='row'>
        <br />
        <ModalBody>
          <Input
            htmlId='testMe2'
            value='testMe2'
            name='testMe2'
            label='First Input'
            disabled
            placeholder='Disabled Input'
            onChange={() => {}}
            inputHelpText='Field Must be Disabled'
            errorArr={[]}
          />
        </ModalBody>
      </div>
    );
  }

**/

exports.default = _default;

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @category containers
 * @component modal
 * @variations collab-ui-react
 */
var ModalFooter = function ModalFooter(props) {
  var className = props.className,
      children = props.children;
  return _react.default.createElement("div", {
    className: 'cui-modal__footer' + ("" + (className && " " + className || ''))
  }, children);
};

ModalFooter.propTypes = {
  /** @prop Children nodes to render inside of ModalFooter | null */
  children: _propTypes.default.node,

  /** @prop Optional css class names | '' */
  className: _propTypes.default.string
};
ModalFooter.defaultProps = {
  children: null,
  className: ''
};
ModalFooter.displayName = 'ModalFooter';
var _default = ModalFooter;
/**
* @name Modal Footer
*
* @category containers
* @component modal
* @section Modal Footer
*
* @js

import {
  Button,
  ModalFooter,
} from '@collabui/react';

export default function ModalFooter() {
  return (
    <div className='row'>
      <br />
      <ModalFooter>
        <Button
          children='Cancel'
          onClick={()=>{}}
          ariaLabel='Close Modal'
          color='default'
        />
        <Button
          children='OK'
          onClick={()=>{}}
          ariaLabel='Submit Form'
          color='primary'
        />
      </ModalFooter>
    </div>
  );
}

**/

exports.default = _default;

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(4);

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(7);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _ = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var ModalHeader =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(ModalHeader, _React$PureComponent);

  function ModalHeader() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = ModalHeader.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        headerLabel = _this$props.headerLabel,
        message = _this$props.message,
        showCloseButton = _this$props.showCloseButton,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "className", "headerLabel", "message", "showCloseButton"]);

    var handleClose = this.context.handleClose;
    return _react.default.createElement("div", _extends({
      className: 'cui-modal__header' + ("" + (className && " " + className || ''))
    }, props), children ? children : [_react.default.createElement("span", {
      key: "title-0",
      className: "cui-modal__title"
    }, headerLabel), message && _react.default.createElement("span", {
      key: "title-1",
      className: "cui-modal__message"
    }, message)], showCloseButton && _react.default.createElement(_.CloseIcon, {
      className: "cui-modal__close",
      onClick: handleClose
    }));
  };

  return ModalHeader;
}(_react.default.PureComponent);

ModalHeader.propTypes = {
  /** @prop Children nodes to render inside of ModalHeader | null */
  children: _propTypes.default.node,

  /** @prop Optional CSS class names | '' */
  className: _propTypes.default.string,

  /** @prop ModalHeader label text | '' */
  headerLabel: _propTypes.default.string,

  /** @prop Modal message | '' */
  message: _propTypes.default.string,

  /** @prop show/hide close button | true */
  showCloseButton: _propTypes.default.bool
};
ModalHeader.defaultProps = {
  children: null,
  className: '',
  headerLabel: '',
  message: '',
  showCloseButton: true
};
ModalHeader.contextTypes = {
  handleClose: _propTypes.default.func
};
ModalHeader.displayName = 'ModalHeader';
var _default = ModalHeader;
exports.default = _default;

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(7);

__webpack_require__(4);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _ = __webpack_require__(8);

var _lodash = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * @category communication
 * @component popover
 * @variations collab-ui-react
 */
var Popover =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Popover, _React$Component);

  function Popover() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      isOpen: false,
      isHovering: false
    };

    _this.delayedHide = function (e) {
      var _this$props = _this.props,
          delay = _this$props.delay,
          hideDelay = _this$props.hideDelay,
          onClose = _this$props.onClose;
      var isHovering = _this.state.isHovering;
      if (isHovering) return;

      if (_this.showTimerId) {
        clearTimeout(_this.showTimerId);
        _this.showTimerId = null;
      }

      var popoverHideTime = hideDelay ? hideDelay : delay;
      _this.hideTimerId = setTimeout(function () {
        _this.hideTimerId = null;

        _this.setState({
          isOpen: false,
          isHovering: false
        }, onClose && onClose(e));
      }, popoverHideTime);
      e && e.stopPropagation();
    };

    _this.delayedShow = function (e) {
      var _this$props2 = _this.props,
          delay = _this$props2.delay,
          showDelay = _this$props2.showDelay;

      if (_this.hideTimerId) {
        clearTimeout(_this.hideTimerId);
        _this.hideTimerId = null;
      }

      var popoverShowTime = showDelay ? showDelay : delay;
      _this.showTimerId = setTimeout(function () {
        _this.showTimerId = null;

        _this.setState({
          isOpen: true,
          isHovering: true
        });
      }, popoverShowTime);
      e && e.stopPropagation();
    };

    _this.handleClose = function (e) {
      var onClose = _this.props.onClose;

      _this.setState({
        isOpen: false
      }, onClose && onClose(e));
    };

    _this.handleMouseEnter = function (e) {
      var children = _this.props.children;
      children.props.onMouseEnter && children.props.onMouseEnter(e);
      return !_this.showTimerId && !_this.state.isOpen && _this.delayedShow(e);
    };

    _this.delayCheckHover = function (e) {
      var hoverDelay = _this.props.hoverDelay;
      e.persist();

      _this.setState({
        isHovering: false
      }, function () {
        return setTimeout(function () {
          return _this.delayedHide(e);
        }, hoverDelay);
      });
    };

    _this.handleMouseLeave = function (e) {
      var children = _this.props.children;

      if (_this.hasFocus) {
        return false;
      }

      if (_this.showTimerId) {
        clearTimeout(_this.showTimerId);
        _this.showTimerId = null;
      }

      children.props.onMouseLeave && children.props.onMouseLeave(e);
      return !_this.hideTimerId && _this.state.isOpen && _this.delayCheckHover(e);
    };

    _this.handleBlur = function (e) {
      var children = _this.props.children;
      _this.hasFocus = false;
      children.props.onBlur && children.props.onBlur(e);

      _this.handleMouseLeave(e);
    };

    _this.handleClick = function (e) {
      var _this$props3 = _this.props,
          children = _this$props3.children,
          doesAnchorToggle = _this$props3.doesAnchorToggle;
      var isOpen = _this.state.isOpen;
      _this.hasFocus = true;
      children.props.onClick && children.props.onClick(e);

      if (!_this.showTimerId) {
        return !isOpen ? _this.delayedShow(e) : doesAnchorToggle && _this.handleBlur(e);
      }
    };

    _this.handleFocus = function (e) {
      var children = _this.props.children;
      var isOpen = _this.state.isOpen;
      _this.hasFocus = true;
      children.props.onFocus && children.props.onFocus(e);

      if (!_this.showTimerId) {
        return !isOpen ? _this.delayedShow(e) : _this.handleBlur(e);
      }
    };

    return _this;
  }

  var _proto = Popover.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.props.startOpen && this.delayedShow();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.hideTimerId && clearTimeout(this.hideTimerId);
    this.showTimerId && clearTimeout(this.showTimerId);
  };

  _proto.render = function render() {
    var _this2 = this;

    var isOpen = this.state.isOpen;

    var _this$props4 = this.props,
        children = _this$props4.children,
        className = _this$props4.className,
        content = _this$props4.content,
        overflowType = _this$props4.overflowType,
        popoverTrigger = _this$props4.popoverTrigger,
        showArrow = _this$props4.showArrow,
        props = _objectWithoutPropertiesLoose(_this$props4, ["children", "className", "content", "overflowType", "popoverTrigger", "showArrow"]);

    var otherProps = (0, _lodash.omit)(Object.assign({}, props), ['delay', 'doesAnchorToggle', 'hideDelay', 'hoverDelay', 'onClose', 'showDelay', 'startOpen']);

    var getTriggers = function getTriggers() {
      var triggerProps = {};

      triggerProps.ref = function (ele) {
        return _this2.anchorRef = ele;
      };

      triggerProps.key = 'child-1';

      switch (popoverTrigger) {
        case 'MouseEnter':
          triggerProps.onMouseEnter = _this2.handleMouseEnter;
          triggerProps.onMouseLeave = _this2.handleMouseLeave;
          triggerProps.onFocus = _this2.handleFocus;
          triggerProps.onBlur = _this2.handleBlur;
          break;

        case 'Click':
          triggerProps.onClick = _this2.handleClick;
          triggerProps.onBlur = null;
          triggerProps.onFocus = null;
          triggerProps.onMouseEnter = null;
          triggerProps.onMouseLeave = null;
          break;

        case 'Focus':
          triggerProps.onFocus = _this2.handleFocus;
          triggerProps.onBlur = _this2.handleBlur;
          triggerProps.onMouseEnter = null;
          triggerProps.onMouseLeave = null;
          break;

        case 'None':
          triggerProps.onClick = null;
          triggerProps.onFocus = null;
          triggerProps.onBlur = null;
          triggerProps.onMouseEnter = null;
          triggerProps.onMouseLeave = null;
          break;
      }

      return triggerProps;
    };

    var anchorWithTriggers = children && _react.default.cloneElement(children, getTriggers());

    return _react.default.createElement("span", null, anchorWithTriggers, _react.default.createElement(_.EventOverlay, _extends({
      anchorNode: this.anchorRef,
      className: className,
      close: this.handleClose,
      isOpen: isOpen,
      ref: function ref(_ref) {
        return _this2.overlay = _ref;
      },
      showArrow: showArrow,
      style: {
        overflow: overflowType
      }
    }, popoverTrigger === 'MouseEnter' && {
      onMouseEnter: function onMouseEnter() {
        _this2.setState({
          isHovering: true,
          isOpen: true
        });
      },
      onMouseLeave: function onMouseLeave(e) {
        e.persist();

        _this2.setState({
          isHovering: false
        }, function () {
          return _this2.delayedHide(e);
        });
      }
    }, otherProps), content));
  };

  return Popover;
}(_react.default.Component);

Popover.propTypes = {
  /** @prop Children node that should be the popover trigger(this should be a stateful component) */
  children: _propTypes.default.element.isRequired,

  /** @prop Optional CSS class names which goes over popover container | '' */
  className: _propTypes.default.string,

  /** @prop The content that goes into the popover */
  content: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.node]).isRequired,

  /** @prop The delay for popover on hover, click, focus (hide/show) | 0 */
  delay: _propTypes.default.number,

  /** @prop Boolean for whether the Anchor Toggles the Popover | true */
  doesAnchorToggle: _propTypes.default.bool,

  /** @prop The hide delay for popover on hover, click, focus | 0 */
  hideDelay: _propTypes.default.number,

  /** @prop The hover delay for checking whether we are still hovering before closing | 500 */
  hoverDelay: _propTypes.default.number,

  /** @prop Callback function that will execute on close | null */
  onClose: _propTypes.default.func,

  /** @prop Optional prop that controls overflow css style of EventOverlay | 'auto' */
  overflowType: _propTypes.default.string,

  /** @prop Event that will trigger popover appearance | 'MouseEnter' */
  popoverTrigger: _propTypes.default.oneOf(['MouseEnter', 'Click', 'Focus', 'None']),

  /** @prop Boolean for whether the Arrow should show | true */
  showArrow: _propTypes.default.bool,

  /** @prop The show delay for popover on hover, click, focus | 0 */
  showDelay: _propTypes.default.number,

  /** @prop Should Popover start open | false */
  startOpen: _propTypes.default.bool
};
Popover.defaultProps = {
  className: '',
  delay: 0,
  doesAnchorToggle: true,
  hideDelay: 0,
  hoverDelay: 500,
  onClose: null,
  overflowType: 'auto',
  popoverTrigger: 'MouseEnter',
  showArrow: true,
  showDelay: 0,
  startOpen: false
};
Popover.displayName = 'Popover';
var _default = Popover;
/**
* @component popover
* @section default
* @react
import {
  Button,
  Icon,
  List,
  ListItem,
  ListItemSection,
  Popover,
} from '@collabui/react';

 export default function ContentDefault() {

    const content = (
      <List>
        <ListItem>
          <ListItemSection position="left">
            <Icon name="edit_20" />
          </ListItemSection>
          <ListItemSection position="center">
            Edit space settings
          </ListItemSection>
        </ListItem>
        <ListItem>
          <ListItemSection position="left">
            <Icon name="favorite_20" />
          </ListItemSection>
          <ListItemSection position="center">Add to favorites</ListItemSection>
        </ListItem>
        <ListItem>
          <ListItemSection position="left">
            <Icon name="alert_20" />
          </ListItemSection>
          <ListItemSection position="center">Notifications</ListItemSection>
        </ListItem>
        <ListItem>
          <ListItemSection position="left">
            <Icon name="accessories_20" />
          </ListItemSection>
          <ListItemSection position="center">
            Add Integrations & Bots
          </ListItemSection>
        </ListItem>
        <ListItem>
          <ListItemSection position="left">
            <Icon name="stored-info_20" />
          </ListItemSection>
          <ListItemSection position="center">View space policy</ListItemSection>
        </ListItem>
        <ListItem>
          <ListItemSection position="left">
            <Icon name="archive_20" />
          </ListItemSection>
          <ListItemSection position="center">Archive space</ListItemSection>
        </ListItem>
        <ListItem>
          <ListItemSection position="left">
            <Icon name="cancel_20" />
          </ListItemSection>
          <ListItemSection position="center">
            Remove space from team
          </ListItemSection>
        </ListItem>
        <ListItem>
          <ListItemSection position="left">
            <Icon name="exit-room_20" />
          </ListItemSection>
          <ListItemSection position="center">Leave space</ListItemSection>
        </ListItem>
      </List>
    );

    const contentFocus = (
      <span key="1" style={{ padding: '10px'}}>Focus</span>
    );

  return (
    <div className="row">
      <div className="docs-example docs-example--spacing">
        <Popover
          content={content}
          popoverTrigger={'Click'}
        >
          <Button children="Click" ariaLabel="Click" />
        </Popover>
      </div>

      <div className="docs-example docs-example--spacing">
        <Popover
          content={content}
          popoverTrigger={'MouseEnter'}
        >
          <Button children="MouseEnter" ariaLabel="MouseEnter" />
        </Popover>
      </div>

      <div className="docs-example docs-example--spacing">
        <Popover
          content={contentFocus}
          popoverTrigger={'Focus'}
        >
          <Button children="Focus" ariaLabel="Focus" />
        </Popover>
      </div>
    </div>
  );
}
**/

/**
* @component popover
* @section delay
* @react

 import {
  Button,
  Popover,
} from '@collabui/react';

 export default function PopOverDelay() {

    const contentDelay = (
      <span key="1" style={{ padding: '10px'}}>Delayed</span>
    );

    return (
      <div className="docs-example docs-example--spacing">
        <Popover
          content={contentDelay}
          delay={500}
        >
          <Button children='Hover with Delay' ariaLabel='Hover with Delay' />
        </Popover>
      </div>
    );
}
**/

/**
* @component popover
* @section direction
* @react

 import {
  Button,
  Popover
} from '@collabui/react';

 export default function PopOverDirection() {

    const content = (
    <span key="1" style={{ padding: '10px'}}>right-center</span>
  );

  return (
    <div className="docs-example docs-example--spacing">
      <Popover
        content={content}
        direction={'right-center'}
      >
        <Button children='Direction' ariaLabel='Direction' />
      </Popover>
    </div>
  );
}
**/

/**
* @component popover
* @section arrow
* @react

 import {
  Button,
  Popover
} from '@collabui/react';

 export default function PopoverArrow() {

  const contentArrow = (
    <span key="1" style={{ padding: '10px'}}>Arrow</span>
  );

  return (
    <div className="docs-example docs-example--spacing">
      <Popover
        content={contentArrow}
        direction={'right-center'}
        showArrow={true}
      >
        <Button children='showArrow' ariaLabel='showArrow' />
      </Popover>
    </div>
  );
}
**/

/**
* @component popover
* @section offset
* @react

 import {
  Button,
  Popover
} from '@collabui/react';

 export default function PopoverOffset() {

  const contentOffset = (
    <span key="1" style={{ padding: '10px'}}>Offset</span>
  );

  return (
    <div className="docs-example docs-example--spacing">
      <Popover
        content={contentOffset}
        direction={'top-center'}
        targetOffset={{ vertical: 20 }}
      >
        <Button children='offset' ariaLabel='offset' />
      </Popover>
    </div>
  );
}
**/

/**
* @component popover
* @section contained
* @react

 import {
  Button,
  Popover
} from '@collabui/react';

 export default function PopoverContained() {

  const tall = (
    <span key="1" style={{ height: '3000px' }}>Popover(height: 3000px)</span>
  );

  return (
    <Popover
      isContained
      content={tall}
      direction={'bottom-center'}
      popoverTrigger={'Click'}
    >
      <Button children='Tall' ariaLabel='Tall' />
    </Popover>
  );
}
**/

/**
* @component popover
* @section overflow
* @react

 import {
  Button,
  Popover
} from '@collabui/react';

 export default function PopoverOverflow() {

  const tall = (
    <span key="1" style={{ height: '3000px' }}>Popover(height: 3000px)</span>
  );

  return (
    <div
      className="docs-example docs-example--spacing"
      style={{
        border: '2px solid #666666',
        width: '100%',
        height: '500px',
        overflow: 'scroll',
        padding: '125px'
      }}
    >
      <Popover
        isContained={true}
        checkOverflow
        content={tall}
        direction={'bottom-center'}
        popoverTrigger={'Click'}
      >
        <Button children='Tall' ariaLabel='Tall' />
      </Popover>
    </div>
  );
}
**/

exports.default = _default;

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @category communication
 * @component progress-bar
 * @variations collab-ui-react
 */
var ProgressBar = function ProgressBar(props) {
  var label = props.label,
      min = props.min,
      max = props.max,
      value = props.value,
      dynamic = props.dynamic,
      displayFormat = props.displayFormat,
      color = props.color;
  var adjustedValue = max - value < 0 ? max : value;
  var valueFraction = adjustedValue / max * 100 || 0;
  var meterWidth = valueFraction + '%';

  var getDisplayFormat = function getDisplayFormat() {
    if (displayFormat === 'none') {
      return null;
    } else if (displayFormat === 'percentage') {
      return meterWidth;
    }

    return adjustedValue + " / " + max;
  };

  var getColor = function getColor() {
    if (color) {
      return color;
    } else if (dynamic) {
      if (valueFraction < 25) {
        return 'success';
      } else if (valueFraction < 50) {
        return 'info';
      } else if (valueFraction < 75) {
        return 'warning';
      }

      return 'danger';
    }
  };

  return _react.default.createElement("span", null, _react.default.createElement("div", {
    className: "progressbar-info",
    key: 0
  }, _react.default.createElement("span", {
    className: "progressbar-label"
  }, label), _react.default.createElement("span", {
    className: "progressbar-progress"
  }, getDisplayFormat())), _react.default.createElement("div", {
    className: "progress" + (" " + (getColor() || '')),
    key: 1
  }, _react.default.createElement("span", {
    className: "meter",
    role: "progressbar",
    "aria-labelledby": "progressbar",
    "aria-valuenow": adjustedValue,
    "aria-valuemin": min,
    "aria-valuemax": max,
    "aria-valuetext": meterWidth,
    style: {
      width: meterWidth
    }
  })));
};

ProgressBar.propTypes = {
  /** @prop Color class optional that will overwrite dynamic | '' */
  color: _propTypes.default.string,

  /** @prop Format of dyanmic number | 'fraction' */
  displayFormat: _propTypes.default.oneOf(['none', 'fraction', 'percentage']),

  /** @prop Determines if the ProgressBar is dynamic | false */
  dynamic: _propTypes.default.bool,

  /** @prop Label text */
  label: _propTypes.default.string.isRequired,

  /** @prop Maximum number for progressBar | 100 */
  max: _propTypes.default.number,

  /** @prop Minimum number for progressBar | 0 */
  min: _propTypes.default.number,

  /** @prop Type of ProgressBar | 'determinate' */
  type: _propTypes.default.oneOf(['determinate', 'indeterminate']),

  /** @prop Number value */
  value: _propTypes.default.number.isRequired
};
ProgressBar.defaultProps = {
  color: '',
  displayFormat: 'fraction',
  dynamic: false,
  max: 100,
  min: 0,
  type: 'determinate'
};
ProgressBar.displayName = 'ProgressBar';
var _default = ProgressBar;
/**
* @component progress-bar
* @section default
* @react
import { ProgressBar } from '@collabui/react';

export default ProgressBarDefault() {
  return (
    <div className='columns small-6'>
      <ProgressBar
        label='ProgressBar Default'
        min={0}
        max={100}
        value={50}
      />
    </div>
  );
}

**/

exports.default = _default;

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(37);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _ = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @category controls
 * @component radio
 * @variations collab-ui-react
 */
var Radio = function Radio(props) {
  var disabled = props.disabled,
      required = props.required,
      checked = props.checked,
      name = props.name,
      label = props.label,
      value = props.value,
      inputRef = props.inputRef,
      htmlId = props.htmlId,
      onChange = props.onChange,
      children = props.children,
      className = props.className,
      nestedLevel = props.nestedLevel;
  return _react.default.createElement("div", {
    className: 'cui-input-group cui-radio' + ("" + (nestedLevel && " cui-input--nested-" + nestedLevel || '')) + (" " + className)
  }, _react.default.createElement("input", {
    className: 'cui-input cui-radio__input',
    type: "radio",
    ref: inputRef,
    disabled: disabled,
    checked: checked,
    required: required,
    name: name,
    value: value,
    id: htmlId,
    onChange: onChange,
    tabIndex: 0
  }), _react.default.createElement(_.Label, {
    className: "cui-radio__label",
    label: label,
    htmlFor: htmlId
  }), children);
};

Radio.propTypes = {
  /** @prop Boolean for whether the Radio button is checked | false */
  checked: _propTypes.default.bool,

  /** @prop Children nodes to render insdie Radio component | null */
  children: _propTypes.default.node,

  /** @prop Optional CSS class name | '' */
  className: _propTypes.default.string,

  /** @prop Sets the attribute disabled to the Radio | false */
  disabled: _propTypes.default.bool,

  /** @prop Unique HTML ID used for tying label to HTML input for automated testing */
  htmlId: _propTypes.default.string.isRequired,

  /** @prop Optional ref attribute for Radio input element | null */
  inputRef: _propTypes.default.func,

  /** @prop Radio label text | '' */
  label: _propTypes.default.string,

  /** @prop Radio name string | '' */
  name: _propTypes.default.string,

  /** @prop Set the level of nested Radios | 0 */
  nestedLevel: _propTypes.default.number,

  /** @prop Callback function invoked when user makes a change with the Radio button | null */
  onChange: _propTypes.default.func,

  /** @prop Requires the user to populate the Radio input | false */
  required: _propTypes.default.bool,

  /** @prop String value that corresponds with Radio button | '' */
  value: _propTypes.default.string
};
Radio.defaultProps = {
  checked: false,
  children: null,
  className: '',
  disabled: false,
  inputRef: null,
  label: '',
  name: '',
  nestedLevel: 0,
  onChange: function onChange() {},
  required: false,
  value: ''
};
Radio.displayName = 'Radio';
var _default = Radio;
/**
* @component radio
* @section default
* @react

import {
  Radio,
  RadioGroup,
} from '@collabui/react';

export default class DefaultRadio extends React.Component {
  render() {
    return (
      <RadioGroup>
        <Radio
          value='me'
          label='me'
          htmlId='testCheckbox1'
          onChange={()=>{}}
          inputRef={ref=>this.input=ref}
        />
        <Radio
          value='you'
          label='you'
          htmlId='testCheckbox2'
          onChange={()=>{}}
        />
        <Radio
          value='us'
          label='us'
          htmlId='testCheckbox3'
          onChange={()=>{}}
        />
      </RadioGroup>
    )
  }
}
**/

/**
* @component radio
* @section disabled
* @react
import { Radio } from '@collabui/react';

export default function DisabledRadio() {
  return (
    <Radio
      value='disabledRadio'
      label='Disabled Radio'
      htmlId='disabledRadio'
      disabled
      onChange={()=>{}}
    />
  );
}
**/

/**
* @component radio
* @section nested
* @react
import { Radio } from '@collabui/react';

export default class RadioNested extends React.PureComponent {
  state = {
    value: 'parent'
  }

  render() {
    return (
      <span>
        <Radio
          value='parent'
          label='Parent Radio Example'
          htmlId='parentRadio'
          name='nestedRadios'
          checked={this.state.value === 'parent'}
          onChange={() => this.setState({ value: 'parent' })}
          key='child-0'
        />
        <Radio
          value='child1'
          label='Child Radio Nested 1 Level'
          htmlId='childRadio1'
          name='nestedRadios'
          nestedLevel={1}
          checked={this.state.value === 'child1'}
          onChange={() => this.setState({ value: 'child1' })}
          key='child-1'
        />
        <Radio
          value='child2'
          label='Child Radio Nested 2 Level'
          htmlId='childRadio2'
          name='nestedRadios'
          nestedLevel={2}
          checked={this.state.value === 'child2'}
          onChange={() => this.setState({ value: 'child2' })}
          key='child-2'
        />
        <Radio
          value='child3'
          label='Child Radio Nested 3 Level'
          htmlId='childRadio3'
          name='nestedRadios'
          nestedLevel={3}
          checked={this.state.value === 'child3'}
          onChange={() => this.setState({ value: 'child3' })}
          key='child-3'
        />
      </span>
    );
  }
}
**/

exports.default = _default;

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(37);

__webpack_require__(19);

__webpack_require__(20);

__webpack_require__(6);

__webpack_require__(5);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * @category controls
 * @component radio
 * @variations collab-ui-react
 */
var RadioGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(RadioGroup, _React$Component);

  function RadioGroup() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      values: []
    };

    _this.handleToggle = function (value) {
      var newValues;
      var onChange = _this.props.onChange;
      var values = _this.state.values;
      var isActive = values.includes(value);

      if (!isActive) {
        newValues = [value];
        onChange(value);
      } else {
        return;
      }

      _this.setState({
        values: newValues
      });
    };

    return _this;
  }

  var _proto = RadioGroup.prototype;

  _proto.componentWillMount = function componentWillMount() {
    if (this.props.values) {
      this.setState({
        values: this.props.values
      });
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        children = _this$props.children,
        name = _this$props.name;
    var values = this.state.values;

    var addHandlersToChildren = function addHandlersToChildren() {
      return _react.default.Children.map(children, function (child) {
        var value = child.props.value;
        return _react.default.cloneElement(child, {
          name: name,
          checked: values.includes(value),
          onChange: function onChange() {
            return _this2.handleToggle(value);
          }
        });
      });
    };

    return _react.default.createElement("div", {
      className: "cui-radio-group"
    }, addHandlersToChildren());
  };

  return RadioGroup;
}(_react.default.Component);

RadioGroup.propTypes = {
  /** @prop Children nodes to render inside RadioGroup | null */
  children: _propTypes.default.node,

  /** @prop An HTML `<input>` name for each child button | '' */
  name: _propTypes.default.string,

  /** 
   * @prop Callback function called with value or array of values when invoked by user making a change with the RadioGroup | () => {}
   * @controllable values
  */
  onChange: _propTypes.default.func,

  /**
   * @prop Array of values, of the active (pressed) buttons | []
   * @controllable onChange
  */
  values: _propTypes.default.array
};
RadioGroup.defaultProps = {
  children: null,
  name: '',
  onChange: function onChange() {},
  values: []
};
RadioGroup.displayName = 'RadioGroup';
var _default = RadioGroup;
exports.default = _default;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(4);

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(7);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _ = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * @category controls
 * @component search-input
 * @variations collab-ui-react
*/
var SearchInput = function SearchInput(props) {
  var type = props.type,
      otherProps = _objectWithoutPropertiesLoose(props, ["type"]);

  return _react.default.createElement(_.Input, _extends({
    className: 'cui-search-input' + ("" + (type === 'pill' ? ' cui-search-input--pill' : ''))
  }, otherProps), _react.default.createElement(_.Icon, {
    className: "cui-search-input__icon",
    name: "" + (type === 'pill' ? 'search_16' : 'search_20')
  }));
};

SearchInput.propTypes = {
  /** @prop Style of search input normal or pill | 'normal' */
  type: _propTypes.default.oneOf(['normal', 'pill'])
};
SearchInput.defaultProps = {
  type: 'normal'
};
SearchInput.displayName = 'SearchInput';
var _default = SearchInput;
/**
* @component input-search
* @section default
* @react
import { SearchInput } from '@collabui/react';

export default class DefaultSearchInput extends React.PureComponent {
  render() {
    return (
      <SearchInput
        name='defaultSearchInput'
        htmlId='defaultSearchInput'
        inputSize='small-5'
      />
    );
  }
}

**/

/**
* @component input-search
* @section pill
* @react
import { SearchInput } from '@collabui/react';

export default class PillSearchInput extends React.PureComponent {
  render() {
    return (
      <SearchInput
        name='pillSearchInput'
        htmlId='pillSearchInput'
        type='pill'
        inputSize='small-5'
      />
    );
  }
}

**/

exports.default = _default;

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(106);

exports.__esModule = true;
exports.default = void 0;

__webpack_require__(4);

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(7);

var _react = _interopRequireDefault(__webpack_require__(2));

var _reactDom = _interopRequireDefault(__webpack_require__(61));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _ = __webpack_require__(8);

var _lodash = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var Select =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Select, _React$Component);

  function Select() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      isOpen: false,
      selected: [],
      selectedIndex: [],
      anchorNode: null,
      anchorWidth: null,
      id: _this.props.id || (0, _lodash.uniqueId)('cui-select-')
    };

    _this.hidePopover = function () {
      _this.setState({
        isOpen: false
      });
    };

    _this.handleSelect = function (e, value, index, label) {
      e.preventDefault();
      var _this$state = _this.state,
          selected = _this$state.selected,
          selectedIndex = _this$state.selectedIndex;
      var isMulti = _this.props.isMulti;
      var isActive = (0, _lodash.find)(selected, {
        value: value,
        label: label
      });
      !isMulti && _this.setState({
        isOpen: false
      });
      if (isActive && !isMulti) return;

      if (isActive && isMulti) {
        return _this.setState({
          selected: (0, _lodash.filter)(selected, function (item) {
            return !(0, _lodash.isEqual)(item, {
              value: value,
              label: label
            });
          }),
          selectedIndex: selectedIndex.filter(function (i) {
            return i !== index;
          })
        });
      } else if (!isActive && !isMulti) {
        return _this.setState({
          selected: [{
            value: value,
            label: label
          }],
          selectedIndex: [index]
        });
      } else {
        return _this.setState({
          selected: [].concat(selected, [{
            value: value,
            label: label
          }]),
          selectedIndex: [].concat(selectedIndex, [index])
        });
      }
    };

    _this.choosePosition = function () {
      var _this$state2 = _this.state,
          isOpen = _this$state2.isOpen,
          anchorNode = _this$state2.anchorNode;
      isOpen && _this.setAnchorWidth(anchorNode);
    };

    _this.handleToggle = function () {
      _this.setState({
        isOpen: !_this.state.isOpen,
        anchorNode: _reactDom.default.findDOMNode(_this.clickTextField).parentNode
      }, function () {
        return _this.choosePosition();
      });
    };

    _this.setAnchorWidth = function (elementAnchor) {
      var anchor = elementAnchor && elementAnchor.getBoundingClientRect();

      _this.setState({
        anchorWidth: anchor.width
      });
    };

    return _this;
  }

  var _proto = Select.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    prevState.selected !== this.state.selected && this.props.onSelect && this.props.onSelect(this.state.selected);
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        isDynamic = _this$props.isDynamic,
        isMulti = _this$props.isMulti,
        defaultValue = _this$props.defaultValue,
        overlayProps = _this$props.overlayProps,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "className", "isDynamic", "isMulti", "defaultValue", "overlayProps"]);

    var _this$state3 = this.state,
        selected = _this$state3.selected,
        selectedIndex = _this$state3.selectedIndex,
        isOpen = _this$state3.isOpen,
        anchorNode = _this$state3.anchorNode,
        anchorWidth = _this$state3.anchorWidth,
        id = _this$state3.id;

    var currentValue = function currentValue() {
      if (!isMulti && selected.length) return selected[0].label;

      if (selected.length === 1) {
        return selected.length + " Item Selected";
      } else if (selected.length) {
        return selected.length + " Items Selected";
      }
    };

    var label = _react.default.createElement("div", {
      className: "cui-select__label",
      id: id + "__label"
    }, currentValue() || defaultValue, _react.default.createElement(_.Icon, {
      name: "arrow-down_16"
    }));

    var text = _react.default.createElement(_.Button, _extends({
      name: id,
      id: id,
      onClick: this.handleToggle,
      ref: function ref(_ref) {
        return _this2.clickTextField = _ref;
      },
      className: 'cui-button--input' + ("" + (className && " " + className || '')),
      "aria-haspopup": "listbox",
      ariaLabelledBy: id + "__label",
      active: isOpen
    }, props), label);

    var dropdownElement = _react.default.createElement(_.EventOverlay, _extends({
      allowClickAway: true,
      anchorNode: anchorNode,
      close: this.hidePopover,
      isOpen: isOpen,
      isDynamic: isDynamic
    }, overlayProps), _react.default.createElement(_.List, {
      onSelect: this.handleSelect,
      style: {
        width: anchorWidth
      },
      ref: function ref(_ref2) {
        return _this2.list = _ref2;
      },
      role: "listbox",
      itemRole: "option",
      active: selectedIndex,
      isMulti: isMulti,
      "aria-labelledby": id + "__label",
      "aria-multiselectable": isMulti
    }, children));

    return _react.default.createElement("div", {
      className: "cui-input-group cui-select"
    }, text, dropdownElement);
  };

  return Select;
}(_react.default.Component);

Select.propTypes = {
  /** @prop Children nodes to render inside Select component | null */
  children: _propTypes.default.node,

  /** @prop Optional CSS class name | '' */
  className: _propTypes.default.string,

  /** @prop Set the default selected option | '' */
  defaultValue: _propTypes.default.string,

  /** @prop Set ID for Select Component | null */
  id: _propTypes.default.string,

  /** @prop Sets the Select EventOverlay to be dynamic | true */
  isDynamic: _propTypes.default.bool,

  /** @prop Optional prop to know if multiple Select children can be active | false */
  isMulti: _propTypes.default.bool,

  /** @prop Callback function invoked when user selects an item | null */
  onSelect: _propTypes.default.func,

  /** @prop Sets the EventOverlay props | null */
  overlayProps: _propTypes.default.shape({})
};
Select.defaultProps = {
  children: null,
  className: '',
  defaultValue: '',
  id: null,
  isDynamic: true,
  isMulti: false,
  onSelect: null,
  overlayProps: null
};
Select.displayName = 'Select';
var _default = Select;
/**
* @component select
* @section default
* @react
import { Select, SelectOption } from '@collabui/react';

export default class SelectDefault extends React.PureComponent {
  render() {
    return (
      <Select defaultValue='Select Item Here' >
        <SelectOption value='test1' label='test1' />
        <SelectOption value='test2' label='test2' />
        <SelectOption value='test3' label='test3' />
        <SelectOption value='test4' label='test4' />
      </Select>
    );
  }
}

**/

/**
* @component select
* @section multi-select
* @react
import { Select, SelectOption } from '@collabui/react';

export default class SelectMultiSelect extends React.PureComponent {
  render() {
    return (
      <Select isMulti defaultValue='Select Item Here' >
        <SelectOption value='test1' label='test1' />
        <SelectOption value='test2' label='test2' />
        <SelectOption value='test3' label='test3' />
        <SelectOption value='test4' label='test4' />
      </Select>
    );
  }
}

**/

exports.default = _default;

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(4);

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(7);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _lodash = __webpack_require__(13);

var _ = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * @category containers
 * @component select-option
 * @variations collab-ui-react
 */
var SelectOption =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(SelectOption, _React$Component);

  function SelectOption() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      id: _this.props.id || (0, _lodash.uniqueId)('cui-select-option-')
    };
    return _this;
  }

  var _proto = SelectOption.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        isMulti = _this$props.isMulti,
        active = _this$props.active,
        children = _this$props.children,
        label = _this$props.label,
        title = _this$props.title,
        props = _objectWithoutPropertiesLoose(_this$props, ["className", "isMulti", "active", "children", "label", "title"]);

    var id = this.state.id;
    var separateChildren = isMulti ? _react.default.createElement(_.Checkbox, {
      htmlId: id + "__checkbox",
      label: label,
      checked: active,
      onChange: function onChange() {}
    }) : [_react.default.createElement(_.ListItemSection, {
      key: "child-0",
      position: "center"
    }, label || children), _react.default.createElement(_.ListItemSection, {
      key: "child-1",
      position: "right"
    }, active && _react.default.createElement(_.Icon, {
      color: "blue",
      name: "check_20"
    }))];
    return _react.default.createElement(_.ListItem, _extends({
      className: "" + (className && " " + className || ''),
      id: id,
      label: label,
      title: title || label
    }, props), separateChildren);
  };

  return SelectOption;
}(_react.default.Component);

SelectOption.propTypes = {
  /** @prop SelectOption Boolean that describes active state | false */
  active: _propTypes.default.bool,

  /** @prop Children nodes to render inside SelectOption | null */
  children: _propTypes.default.node,

  /** @prop Optional HTML Class Name for ListItem | '' */
  className: _propTypes.default.string,

  /** @prop SelectOption ID | '' */
  id: _propTypes.default.string,

  /** @prop Optional prop to know if multiple SelectOptions can be active | false */
  isMulti: _propTypes.default.bool,

  /** @prop SelectOption label text | '' */
  label: _propTypes.default.string,

  /** @prop ListItem Title | '' */
  title: _propTypes.default.string,

  /** @prop SelectOption value | '' */
  value: _propTypes.default.string
};
SelectOption.defaultProps = {
  active: false,
  children: null,
  className: '',
  id: '',
  isMulti: false,
  label: '',
  title: '',
  value: ''
};
SelectOption.displayName = 'SelectOption';
var _default = SelectOption;
exports.default = _default;

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(4);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _ = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var SideNav =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(SideNav, _React$Component);

  function SideNav() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      expanded: _this.props.expanded
    };

    _this.handleNavToggle = function () {
      _this.setState({
        expanded: !_this.state.expanded
      });
    };

    _this.setExpanded = function () {
      _this.setState({
        expanded: _this.props.expanded
      });
    };

    return _this;
  }

  var _proto = SideNav.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    this.props.expanded !== prevProps.expanded && this.state.expanded !== this.props.expanded && this.setExpanded();
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        children = _this$props.children,
        navSectionNode = _this$props.navSectionNode,
        navSectionTitle = _this$props.navSectionTitle,
        topMenu = _this$props.topMenu,
        expandable = _this$props.expandable,
        className = _this$props.className;
    var expanded = this.state.expanded;
    var topMenuTitle = topMenu ? 'top' : 'sub';
    var navSectionTitleText = navSectionTitle ? _react.default.createElement("h3", {
      className: "cui-side-nav__title--" + topMenuTitle
    }, _react.default.createElement("button", {
      className: "cui-side-nav__button",
      onClick: function onClick() {
        expandable ? _this2.handleNavToggle() : false;
      }
    }, navSectionTitle, expandable && (expanded ? _react.default.createElement(_.Icon, {
      name: "arrow-up_16"
    }) : _react.default.createElement(_.Icon, {
      name: "arrow-down_16"
    })))) : navSectionNode && _react.default.cloneElement(navSectionNode, Object.assign({}, expandable && {
      onClick: function onClick() {
        return _this2.handleNavToggle();
      }
    }), [].concat(navSectionNode.props.children, expandable && _react.default.createElement(_.ListItemSection, {
      position: "right",
      key: "side-nav--expand-section"
    }, expanded ? _react.default.createElement(_.Icon, {
      name: "arrow-up_12"
    }) : _react.default.createElement(_.Icon, {
      name: "arrow-down_12"
    }))));
    return _react.default.createElement("div", {
      className: 'cui-side-nav' + (" cui-side-nav--" + (!expandable || expanded ? 'expanded' : 'collapse')) + ("" + (className && " " + className || ''))
    }, navSectionTitleText, children);
  };

  return SideNav;
}(_react.default.Component);

SideNav.propTypes = {
  /** @prop Children nodes to Render inside side navigation | null */
  children: _propTypes.default.node,

  /** @prop Optional CSS class string | '' */
  className: _propTypes.default.string,

  /** @prop Set to make the navigation expandable | false */
  expandable: _propTypes.default.bool,

  /** @prop Set navigation expanded or collapsed | false */
  expanded: _propTypes.default.bool,

  /** @prop Node to replace NavSection | null */
  navSectionNode: _propTypes.default.node,

  /** @prop Title for the side navigation | '' */
  navSectionTitle: _propTypes.default.string,

  /** @prop Sets side navigation as the top level | false */
  topMenu: _propTypes.default.bool
};
SideNav.defaultProps = {
  children: null,
  expandable: false,
  expanded: false,
  navSectionNode: null,
  navSectionTitle: '',
  topMenu: false
};
SideNav.displayName = 'SideNav';
var _default = SideNav;
/**
* @component side-nav
* @section default
* @react
import { List, ListItem, SideNav } from '@collabui/react';
import { NavLink } from 'react-router-dom'

export default class SideNavDefault extends React.PureComponent {
  render() {
    const anchorNode = <NavLink to='/containers/list-item' />;

    return (
      <SideNav navSectionTitle='OVERVIEW' topMenu>
        <List>
          <ListItem label='Platform Introduction' customAnchorNode={anchorNode} />
          <ListItem label='Bots' customAnchorNode={anchorNode} />
          <ListItem label='Widgets' customAnchorNode={anchorNode} />
          <ListItem label='Integration' customAnchorNode={anchorNode} />
          <ListItem label='Guest Issuer' customAnchorNode={anchorNode} />
        </List>
      </SideNav>
    );
  }
}
**/

/**
* @component side-nav
* @section expand
* @react
import { List, ListItem, SideNav } from '@collabui/react';
import { NavLink } from 'react-router-dom'

export default class SideNavExpand extends React.PureComponent {
  render() {
    const anchorNode = <NavLink to='/containers/list-item' />;

    return (
      <SideNav navSectionTitle='Guides' expandable expanded={false}>
        <List>
          <ListItem label='Authentication' customAnchorNode={anchorNode} />
          <ListItem label='Admin API' customAnchorNode={anchorNode} />
          <ListItem label='Webhooks' customAnchorNode={anchorNode} />
          <ListItem label='Compliance' customAnchorNode={anchorNode} />
        </List>
      </SideNav>
    );
  }
}
**/

/**
* @component side-nav
* @section nested
* @react
import { List, ListItem, SideNav } from '@collabui/react';
import { NavLink } from 'react-router-dom'

export default class SideNavNested extends React.PureComponent {
  render() {
    const anchorNode = <NavLink to='/containers/list-item' />;

    return (
      <SideNav navSectionTitle='Reference' expandable expanded={false}>
        <List>
          <ListItem label='Admins' customAnchorNode={anchorNode} />
          <ListItem label='Devices' customAnchorNode={anchorNode} />
          <ListItem label='Licenses' customAnchorNode={anchorNode} />
          <SideNav navSectionTitle='Messages' className='cui-side-nav__reference' expandable expanded={false}>
            <List>
              <ListItem label='List Messages' customAnchorNode={anchorNode} />
              <ListItem label='Create a Messages' customAnchorNode={anchorNode} />
              <ListItem label='Get Message Details' customAnchorNode={anchorNode} />
              <ListItem label='Delete a Message' customAnchorNode={anchorNode} />
            </List>
          </SideNav>
        </List>
      </SideNav>
    );
  }
}
**/

exports.default = _default;

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(91);

__webpack_require__(126);

__webpack_require__(6);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _SliderPointer = _interopRequireDefault(__webpack_require__(555));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var Slider =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Slider, _React$Component);

  function Slider() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      sliderLow: _this.props.value.low || _this.props.min,
      sliderHigh: _this.props.value.high || _this.props.value,
      scale: [_this.props.min, _this.props.max],
      selectionWidth: null
    };

    _this.setScalePos = function (scale, min, max) {
      _this.ticksContainer && _this.ticksContainer.childNodes.forEach(function (child, idx) {
        var leftValue = (scale[idx] - min) / max * 100 + "%";
        child.style.left = "calc(" + leftValue + " - " + child.offsetWidth / 2 + "px)";
      });
    };

    _this.getScale = function (low, high, tick) {
      if (low === void 0) {
        low = 0;
      }

      var value = high;
      var ticksArray = [high];

      while (value > 0 && value - tick >= low) {
        value -= tick;
        ticksArray.unshift(Math.abs(Math.round(value / tick) * tick));
      }

      _this.setState({
        scale: ticksArray
      });
    };

    _this.getSliderWidth = function () {
      return _this.sliderBar.getBoundingClientRect().width;
    };

    _this.getStepWidth = function () {
      var maxValue = _this.props.max - _this.props.min;

      var maxWidth = _this.getSliderWidth();

      return _this.props.step / maxValue * maxWidth;
    };

    _this.getSteps = function (position) {
      if (position.isKeyBoard) return 1;
      var diff = position.direction === 1 ? position.to - position.from : position.from - position.to;
      if (diff < 0) return 0;

      var steps = diff / _this.getStepWidth();

      return steps - Math.floor(steps) >= 0.5 ? Math.ceil(steps) : Math.floor(steps);
    };

    _this.getLimit = function (pointerKey, direction) {
      if (pointerKey === 'sliderLow') {
        return _this.props.canCross ? direction === 1 ? _this.props.max : _this.props.min : direction === 1 ? _this.state.sliderHigh : _this.props.min;
      } else if (pointerKey === 'sliderHigh') {
        return _this.props.canCross ? direction === 1 ? _this.props.max : _this.props.min : direction === 1 ? _this.props.max : _this.state.sliderLow;
      }
    };

    _this.returnCurrentValues = function () {
      _this.getSelectionWidth();

      if (_this.props.onChange) {
        return _this.props.onChange(typeof _this.props.value === 'object' ? {
          low: Math.min(_this.state.sliderHigh, _this.state.sliderLow),
          high: Math.max(_this.state.sliderHigh, _this.state.sliderLow)
        } : _this.state.sliderHigh);
      }
    };

    _this.moveForward = function (key, pixelMove, limit) {
      var _this$setState;

      var newPosition = _this.state[key] + pixelMove <= limit ? _this.state[key] + pixelMove : limit;

      _this.setState((_this$setState = {}, _this$setState[key] = newPosition, _this$setState), function () {
        return _this.returnCurrentValues();
      });
    };

    _this.moveBack = function (key, pixelMove, limit) {
      var _this$setState2;

      var newPosition = _this.state[key] - pixelMove >= limit ? _this.state[key] - pixelMove : limit;

      _this.setState((_this$setState2 = {}, _this$setState2[key] = newPosition, _this$setState2), function () {
        return _this.returnCurrentValues();
      });
    };

    _this.onSliderMove = function (key, position) {
      if (_this.props.disabled) return;

      var limit = _this.getLimit(key, position.direction);

      var pixelMove = _this.getSteps(position) * _this.props.step;

      position.direction === 1 ? _this.moveForward(key, pixelMove, limit) : _this.moveBack(key, pixelMove, limit);
    };

    _this.getSelectionWidth = function () {
      var baseValue = Number.isInteger(_this.state.sliderLow) ? _this.state.sliderLow : _this.props.min;

      _this.setState({
        selectionWidth: {
          width: Math.abs(_this.state.sliderHigh - baseValue) / _this.props.max * 100 + "%",
          left: (Math.min(baseValue, _this.state.sliderHigh) - _this.props.min) / _this.props.max * 100 + "%"
        }
      });
    };

    return _this;
  }

  var _proto = Slider.prototype;

  _proto.componentWillMount = function componentWillMount() {
    var _this$props = this.props,
        min = _this$props.min,
        max = _this$props.max,
        tick = _this$props.tick;
    tick && this.getScale(min, max, tick);
    this.getSelectionWidth();
  };

  _proto.componentDidMount = function componentDidMount() {
    var _this$props2 = this.props,
        min = _this$props2.min,
        max = _this$props2.max;
    var scale = this.state.scale;
    this.setScalePos(scale, min, max);
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props3 = this.props,
        value = _this$props3.value,
        disabled = _this$props3.disabled,
        className = _this$props3.className,
        max = _this$props3.max,
        min = _this$props3.min,
        translateFn = _this$props3.translateFn;
    var _this$state = this.state,
        sliderHigh = _this$state.sliderHigh,
        sliderLow = _this$state.sliderLow,
        scale = _this$state.scale,
        selectionWidth = _this$state.selectionWidth;

    var renderTicks = function renderTicks() {
      var ticks = scale.map(function (tickValue, idx) {
        var tickLabel = translateFn ? translateFn(tickValue) : tickValue;
        return _react.default.createElement("span", {
          key: "tick-" + idx,
          className: "cui-slider__hashlabel"
        }, tickLabel);
      });
      return _react.default.createElement("div", {
        ref: function ref(_ref) {
          return _this2.ticksContainer = _ref;
        }
      }, ticks);
    };

    return _react.default.createElement("div", {
      className: "cui-slider " + className + ("" + (disabled && " cui-slider--disabled" || '')) + ("" + (className && " " + className || ''))
    }, _react.default.createElement("span", {
      className: "cui-slider__bar",
      ref: function ref(_ref2) {
        return _this2.sliderBar = _ref2;
      }
    }), _react.default.createElement("span", {
      className: "cui-slider__selection",
      style: selectionWidth
    }), Number.isInteger(value.low) && _react.default.createElement(_SliderPointer.default, {
      position: (sliderLow - min) / (max - min) * 100,
      onMove: function onMove(b) {
        return _this2.onSliderMove('sliderLow', b);
      },
      ref: function ref(_ref3) {
        return _this2.sliderLow = _ref3;
      }
    }), _react.default.createElement(_SliderPointer.default, {
      position: (sliderHigh - min) / (max - min) * 100,
      onMove: function onMove(b) {
        return _this2.onSliderMove('sliderHigh', b);
      },
      ref: function ref(_ref4) {
        return _this2.sliderHigh = _ref4;
      }
    }), renderTicks());
  };

  return Slider;
}(_react.default.Component);

Slider.propTypes = {
  /** @prop Determines if minimum pointer can cross over maximum pointer | false */
  canCross: _propTypes.default.bool,

  /** @prop Optional CSS class string | '' */
  className: _propTypes.default.string,

  /** @prop Set the attribute disabled to Slider | false */
  disabled: _propTypes.default.bool,

  /** @prop Set the initial maximum value */
  max: _propTypes.default.number.isRequired,

  /** @prop Set the initial minimum value | 0 */
  min: _propTypes.default.number,

  /** @prop Callback function invoked by user when change a pointer position | null */
  onChange: _propTypes.default.func,

  /** @prop Set visual step measurement | 1 */
  step: _propTypes.default.number,

  /** @prop Set increment of x-axis labels | 0 */
  tick: _propTypes.default.number,

  /** @prop Function to compute layout of Slider | null */
  translateFn: _propTypes.default.func,

  /** @prop Set either maximum pointer value or a combination of high and low pointer values | 0 */
  value: _propTypes.default.oneOfType([_propTypes.default.shape({
    high: _propTypes.default.number.isRequired,
    low: _propTypes.default.number.isRequired
  }), _propTypes.default.number])
};
Slider.defaultProps = {
  canCross: false,
  className: '',
  disabled: false,
  min: 0,
  onChange: null,
  step: 1,
  tick: 0,
  translateFn: null,
  value: 0
};
Slider.displayName = 'Slider';
var _default = Slider;
/**
* @component slider
* @section default
* @react
import { Slider } from '@collabui/react';

export default class DefaultSlider extends React.Component {
  render() {
    return (
      <Slider
        min={0}
        max={500}
        tick={100}
        value={200}
        step={1}
      />
    );
  }
}
**/

/**
* @component slider
* @section two-handles
* @react
import { Slider } from '@collabui/react';

export default class SliderTwoHandles extends React.Component {
  state = {
    slider1: {low: 100, high: 200},
  }
  render() {
    return (
      <div className="row" key="child-0">
        <div>
          Low: {this.state.slider1.low} High: {this.state.slider1.high}
        </div>
        <Slider
          min={0}
          max={500}
          tick={100}
          value={this.state.slider1}
          step={1}
          onChange={value => this.setState({ slider1: value })}
        />
      </div>
    );
  }
}
**/

/**
* @component slider
* @section cross
* @react
import { Slider } from '@collabui/react';

export default class SliderCross extends React.Component {
  state = {
    slider1: {low: 100, high: 200},
  }
  render() {
    return (
      <div className="row" key="child-2">
        <div>
          Low: {this.state.slider1.low} High: {this.state.slider1.high}
        </div>
        <Slider
          min={0}
          max={500}
          tick={100}
          value={this.state.slider1}
          step={1}
          canCross
          onChange={value => this.setState({ slider1: value })}
        />
      </div>
    );
  }
}
**/

/**
* @component slider
* @section step
* @react
import { Slider } from '@collabui/react';

export default class SliderStep extends React.Component {
  state = {
    slider1: { low: 100, high: 200 },
    slider2: { low: 100, high: 200 },
  }
  render() {
    return (
      <span>
        <div className="row" key='child-0'>
          <div>Low: {this.state.slider1.low} High: {this.state.slider1.high}</div>
          <Slider
            min={0}
            max={500}
            tick={100}
            value={this.state.slider1}
            step={20}
            canCross
            onChange={value => this.setState({ slider1: value })}
          />
        </div>
        <br key='child-1' />
        <div className="row" key='child-2'>
          <div>Low: {this.state.slider2.low} High: {this.state.slider2.high}</div>
          <Slider
            min={0}
            max={500}
            tick={100}
            value={this.state.slider2}
            step={50}
            canCross
            onChange={value => this.setState({ slider2: value })}
          />
        </div>
      </span>
    );
  }
}
**/

exports.default = _default;

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/** Child component to display the slider pointer */
var SliderPointer =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(SliderPointer, _React$PureComponent);

  function SliderPointer() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;
    _this.state = {
      previousPosition: null
    };

    _this.getDirections = function (currentPos) {
      var previousPosition = _this.state.previousPosition;

      if (currentPos > previousPosition) {
        return 1;
      }

      return -1;
    };

    _this.getPosition = function (event, isTouch) {
      return isTouch ? event.touches[0].clientX : event.clientX;
    };

    _this.onMouseDown = function (event, isTouch) {
      if (isTouch === void 0) {
        isTouch = false;
      }

      if (!isTouch) {
        document.addEventListener('mousemove', _this.onMouseMove);
        document.addEventListener('mouseup', _this.onMouseUp);
      }

      _this.setState({
        previousPosition: _this.getPosition(event, isTouch)
      });
    };

    _this.onMouseUp = function () {
      document.removeEventListener('mousemove', _this.onMouseMove);
      document.removeEventListener('mouseup', _this.onMouseUp);
    };

    _this.onMouseMove = function (event, isTouch) {
      if (isTouch === void 0) {
        isTouch = false;
      }

      var xPos = _this.getPosition(event, isTouch);

      var direction = _this.getDirections(xPos);

      _this.props.onMove({
        from: _this.sliderRef.getBoundingClientRect().x,
        to: xPos,
        direction: direction,
        isKeyBoard: false
      });
    };

    _this.onKeyDown = function (event) {
      var KEYS = {
        LEFT: 37,
        UP: 38,
        RIGHT: 39,
        DOWN: 40
      };

      switch (event.keyCode) {
        case KEYS.UP:
        case KEYS.RIGHT:
          _this.props.onMove({
            isKeyBoard: true,
            direction: 1
          });

          event.preventDefault();
          break;

        case KEYS.DOWN:
        case KEYS.LEFT:
          _this.props.onMove({
            isKeyBoard: true,
            direction: -1
          });

          event.preventDefault();
          break;
      }
    };

    return _this;
  }

  var _proto = SliderPointer.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var position = this.props.position;
    var pointerStyle = {
      left: "calc(" + position + "%"
    };
    return _react.default.createElement("div", {
      className: "cui-slider__pointer",
      onMouseDown: function onMouseDown(e) {
        return _this2.onMouseDown(e);
      },
      onTouchStart: function onTouchStart(e) {
        return _this2.onMouseDown(e, true);
      },
      onTouchMove: function onTouchMove(e) {
        return _this2.onMouseMove(e, true);
      },
      onKeyDown: function onKeyDown(e) {
        return _this2.onKeyDown(e);
      },
      role: "button",
      tabIndex: 0,
      style: pointerStyle,
      ref: function ref(_ref) {
        return _this2.sliderRef = _ref;
      }
    });
  };

  return SliderPointer;
}(_react.default.PureComponent);

SliderPointer.propTypes = {
  /** @prop Set Slider Pointer's position | 0 */
  position: _propTypes.default.number,

  /** @prop Callback function invoked when user moves the Slider Pointer | null */
  onMove: _propTypes.default.func
};
SliderPointer.defaultProps = {
  position: 0,
  onMove: null
};
SliderPointer.displayName = 'SliderPointer';
var _default = SliderPointer;
exports.default = _default;

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var SocialList =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(SocialList, _React$Component);

  function SocialList() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = SocialList.prototype;

  _proto.render = function render() {
    var children = this.props.children;
    return _react.default.createElement("span", {
      className: "cui-social__list"
    }, children);
  };

  return SocialList;
}(_react.default.Component);

SocialList.propTypes = {
  /** @prop Children nodes to render inside SocialList | null */
  children: _propTypes.default.node
};
SocialList.defaultProps = {
  children: null
};
SocialList.displayName = 'SocialList';
var _default = SocialList;
/**
* @component social-list
* @section default
* @react
import {
  List,
  ListItem,
  SocialList,
} from '@collabui/react';

export default class SocialListDefault extends React.PureComponent {
  render() {
    return (
      <SocialList>
        <List tabType='horizontal' className='social-list'>
          <ListItem>
            <i className='icon icon-facebook-circle_40' />
          </ListItem>
          <ListItem>
            <i className='icon icon-twitter-circle_40' />
          </ListItem>
          <ListItem>
            <i className='icon icon-linkedin-circle_40' />
          </ListItem>
        </List>
      </SocialList>
    );
  }
}
**/

exports.default = _default;

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(4);

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(7);

__webpack_require__(19);

__webpack_require__(20);

__webpack_require__(58);

__webpack_require__(66);

__webpack_require__(142);

__webpack_require__(65);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _lodash = __webpack_require__(13);

var _ = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * @category containers
 * @component list-item
 * @variations collab-ui-react
 */
var SpaceListItem =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(SpaceListItem, _React$PureComponent);

  function SpaceListItem() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;
    _this.state = {
      id: _this.props.id || (0, _lodash.uniqueId)('cui-space-list-item-')
    };
    return _this;
  }

  var _proto = SpaceListItem.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        attachments = _this$props.attachments,
        className = _this$props.className,
        childrenLeft = _this$props.childrenLeft,
        childrenRight = _this$props.childrenRight,
        header = _this$props.header,
        headerSecondary = _this$props.headerSecondary,
        highlightColor = _this$props.highlightColor,
        isAlertOn = _this$props.isAlertOn,
        isBold = _this$props.isBold,
        isDecrypting = _this$props.isDecrypting,
        isMentioned = _this$props.isMentioned,
        isMuted = _this$props.isMuted,
        isOverview = _this$props.isOverview,
        isUnread = _this$props.isUnread,
        resultRight = _this$props.resultRight,
        searchTerm = _this$props.searchTerm,
        subheader = _this$props.subheader,
        title = _this$props.title,
        type = _this$props.type,
        props = _objectWithoutPropertiesLoose(_this$props, ["attachments", "className", "childrenLeft", "childrenRight", "header", "headerSecondary", "highlightColor", "isAlertOn", "isBold", "isDecrypting", "isMentioned", "isMuted", "isOverview", "isUnread", "resultRight", "searchTerm", "subheader", "title", "type"]);

    var id = this.state.id;
    var getTitle = !title && typeof header === 'string' ? header : title;

    var getIcon = function getIcon() {
      if (isMuted) {
        return _react.default.createElement(_.Icon, {
          color: "$white-60",
          name: "alert-muted_12"
        });
      } else if (isUnread) {
        return _react.default.createElement("i", {
          style: {
            fontSize: '12px',
            color: '#07C1E4'
          },
          className: "icon icon-unread-badge_16"
        });
      } else if (isMentioned) {
        return _react.default.createElement(_.Icon, {
          color: "blue",
          name: "mention_12"
        });
      } else if (isAlertOn) {
        return _react.default.createElement(_.Icon, {
          color: "$white-60",
          name: "alert_12"
        });
      }

      return null;
    };

    var leftSection = isOverview ? _react.default.createElement(_.Avatar, {
      isOverview: true,
      icon: _react.default.createElement(_.Icon, {
        name: "handset_24"
      })
    }) : childrenLeft;

    var rightSection = _react.default.createElement(_.ListItemSection, {
      key: "child-2",
      position: "right"
    }, childrenRight ? childrenRight : getIcon());

    var addEscapes = function addEscapes(text) {
      return text && text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&") || '';
    };

    var highlightSubheader = function highlightSubheader() {
      var escapedTerm = addEscapes(searchTerm);
      var re = new RegExp("(" + escapedTerm + ")", 'gi');
      return searchTerm && typeof subheader === 'string' ? subheader.split(re).map(function (ele, idx) {
        return ele.match(re) ? _react.default.createElement("span", {
          key: "subheader-" + idx,
          className: "cui-list-item__subheader--highlight",
          style: {
            color: highlightColor
          }
        }, ele) : ele;
      }) : subheader;
    };

    var highlightHeader = function highlightHeader() {
      var escapedTerm = addEscapes(searchTerm);
      var re = new RegExp("(" + escapedTerm + ")", 'gi');
      return searchTerm && typeof header === 'string' ? header.split(re).map(function (ele, idx) {
        return ele.match(re) ? _react.default.createElement("span", {
          key: "header-" + idx,
          className: "cui-list-item__header--highlight",
          style: {
            color: highlightColor
          }
        }, ele) : ele;
      }) : header;
    };

    var getHeader = ['search', 'filter', 'flag', 'filter-search'].includes(type) ? [_react.default.createElement("span", {
      key: "header-0",
      className: "cui-list-item__header-main"
    }, header), headerSecondary && _react.default.createElement("span", {
      className: "cui-list-item__header-secondary",
      key: "header-1"
    }, headerSecondary)] : highlightHeader();
    var children = [_react.default.createElement(_.ListItemSection, {
      key: "child-0",
      position: "left"
    }, leftSection || _react.default.createElement(_.Avatar, {
      title: "NA"
    })), _react.default.createElement(_.ListItemSection, {
      key: "child-1",
      position: "center"
    }, _react.default.createElement("div", {
      className: 'cui-list-item__header' + ("" + ((searchTerm || isOverview) && " cui-list-item__header--overview" || '')) + ("" + (isDecrypting && " cui-decrypting" || ''))
    }, getHeader), ['search', 'filter', 'flag', 'filter-search'].includes(type) ? _react.default.createElement(_.ListItemSection, {
      position: "center",
      className: "cui-list-item__result-container"
    }, ['flag'].includes(type) ? _react.default.createElement(_.ListItemSection, {
      position: "center",
      key: "attachment-line-1",
      className: "cui-list-item__attachment"
    }, _react.default.createElement("div", {
      className: "cui-list-item__attachment--top"
    }, _react.default.createElement(_.ListItemSection, {
      position: "center",
      className: "cui-list-item__attachment--top-left"
    }, highlightSubheader(subheader)), resultRight && _react.default.createElement(_.ListItemSection, {
      position: "right",
      className: "cui-list-item__attachment--top-right"
    }, resultRight)), attachments && attachments.length && _react.default.createElement("div", {
      className: "cui-list-item__attachment--bottom"
    }, attachments[0])) : _react.default.createElement("div", {
      className: "cui-list-item__result"
    }, highlightSubheader(subheader))) : _react.default.createElement("div", {
      className: "cui-list-item__subheader" + ("" + (isDecrypting && " cui-decrypting" || ''))
    }, subheader))].concat(!type ? [rightSection] : []);
    return _react.default.createElement(_.ListItem, _extends({
      className: "" + (isBold && " cui-list-item--unread" || '') + ("" + (type && " cui-list-item--space-" + type || '')) + ("" + (className && " " + className || '')),
      id: id,
      title: getTitle,
      type: "space"
    }, props), children);
  };

  return SpaceListItem;
}(_react.default.PureComponent);

SpaceListItem.propTypes = {
  /** @prop SpaceListItem Attachment Array | null */
  attachments: _propTypes.default.arrayOf(_propTypes.default.node),

  /** @prop Children nodes to render for left section | null */
  childrenLeft: _propTypes.default.node,

  /** @prop Children nodes to render for right section | null */
  childrenRight: _propTypes.default.node,

  /** @prop Optional HTML class string | '' */
  className: _propTypes.default.string,

  /** @prop ListItem header node */
  header: _propTypes.default.node.isRequired,

  /** @prop Secondary header for center section | '' */
  headerSecondary: _propTypes.default.string,

  /** @prop Highlight Color for Regex | '' */
  highlightColor: _propTypes.default.string,

  /** @prop HTML ID for SpaceListItem | '' */
  id: _propTypes.default.string,

  /** @prop Determines if SpaceListItem's Alert is on | false */
  isAlertOn: _propTypes.default.bool,

  /** @prop Determines if SpaceListItem is Bolded | false */
  isBold: _propTypes.default.bool,

  /** @prop Determines if SpaceListItem decrypting | false */
  isDecrypting: _propTypes.default.bool,

  /** @prop Determines if SpaceListItem has been mentioned | false */
  isMentioned: _propTypes.default.bool,

  /** @prop Determines if SpaceListItem has been muted | false */
  isMuted: _propTypes.default.bool,

  /** @prop Determines if SpaceListItem is an Overview item | false */
  isOverview: _propTypes.default.bool,

  /** @prop Determines if SpaceListItem is unread | false */
  isUnread: _propTypes.default.bool,

  /** @prop Children node for result right section | null */
  resultRight: _propTypes.default.node,

  /** @prop Word used for search | '' */
  searchTerm: _propTypes.default.string,

  /** @prop SpaceListItem subheader node | ''s */
  subheader: _propTypes.default.node,

  /** @prop SpaceListItem title | '' */
  title: _propTypes.default.string,

  /** @prop SpaceListItem type | '' */
  type: _propTypes.default.oneOf(['', 'filter', 'filter-search', 'filter-summary', 'flag', 'search'])
};
SpaceListItem.defaultProps = {
  attachments: null,
  childrenLeft: null,
  childrenRight: null,
  className: '',
  headerSecondary: '',
  highlightColor: '',
  id: '',
  isAlertOn: false,
  isBold: false,
  isDecrypting: false,
  isMentioned: false,
  isMuted: false,
  isOverview: false,
  isUnread: false,
  resultRight: null,
  searchTerm: '',
  subheader: '',
  title: '',
  type: ''
};
SpaceListItem.displayName = 'SpaceListItem';
var _default = SpaceListItem;
/**
* @component space-list
* @section default
* @react
*
import {
  Icon,
  List,
  ListItemHeader,
  SpaceListItem,
} from '@collabui/react';
import { NavLink } from 'react-router-dom';

export default class ListItemDefault extends React.PureComponent {

  render() {
    const anchorNode = <NavLink to='/containers/list-item' />;
    return(
      <div className="medium-4 columns">
        <List style={{backgroundColor: 'black'}}>
          <SpaceListItem isOverview header='Overview Item' />
          <SpaceListItem header='Header Only'/>
          <SpaceListItem header='Bold Unread' isBold isUnread/>
          <SpaceListItem header='Bold Mentioned' isBold isMentioned/>
          <SpaceListItem header='isAlertOn' isAlertOn/>
          <SpaceListItem header='isMuted' isMuted/>
          <SpaceListItem header='Disabled' subheader='subheader' disabled/>
          <SpaceListItem header='Subheader as Node' subheader={<span style={{color: '#98D5CA'}}>Marketing</span>}/>
          <ListItemHeader header='List Header-Type(space)' children={<a>More</a>} type='space'/>
          <SpaceListItem header='Header with SearchTerm' searchTerm='search'/>
          <SpaceListItem header='Both Headers w/ SearchTerm' subheader='Searchable subheader' searchTerm='search'/>
          <SpaceListItem header='Subheader(node)-searchTerm' subheader={<span style={{color: '#D7ABE1'}}>Searching</span>} searchTerm='search'/>
          <SpaceListItem header='Type(search)' headerSecondary='16:00' subheader='HighlightColor changes search color' searchTerm='search' type='search' highlightColor='white'/>
          <SpaceListItem header='Type(filter)' headerSecondary='12/03/2018' subheader='headerSecondary=string' searchTerm='Barbara' type='filter' />
          <SpaceListItem header='Type(filter-search)' headerSecondary='12/03/2018' subheader='For search after a (filter)' type='filter-search' searchTerm='(filter)'/>
          <SpaceListItem header='Type(filter-summary) (8)' type='filter-summary' childrenLeft={<Icon name='alert_12' />}/>
          <SpaceListItem header='Type(flag)-attachments' attachments={[<span><Icon name='document_12' />  <span>Ideas.pdf</span></span>]} subheader='resultRight=node, attachments=[node]' headerSecondary='12/03/2018' type='flag' resultRight={<Icon name='flag-active_12'/>}/>
          <SpaceListItem header='Type(flag)' subheader='header&subheader=node' headerSecondary='08/03/2018' type='flag' resultRight={<Icon name='flag-active_12'/>}/>
        </List>
      </div>
    );
  }
}
**/

exports.default = _default;

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(7);

__webpack_require__(4);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _ = __webpack_require__(8);

var _lodash = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * @category containers
 * @component list-item
 * @variations collab-ui-react
 */
var SpaceListMeeting =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(SpaceListMeeting, _React$PureComponent);

  function SpaceListMeeting() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;
    _this.state = {
      id: _this.props.id || (0, _lodash.uniqueId)('cui-space-list-meeting-')
    };

    _this.handleButtonClick = function (e) {
      var buttonOnClick = _this.props.buttonOnClick;
      buttonOnClick && buttonOnClick(e);
      e.stopPropagation();
    };

    return _this;
  }

  var _proto = SpaceListMeeting.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        attendees = _this$props.attendees,
        buttonLabel = _this$props.buttonLabel,
        childrenLeft = _this$props.childrenLeft,
        childrenRight = _this$props.childrenRight,
        className = _this$props.className,
        header = _this$props.header,
        isBold = _this$props.isBold,
        meetingType = _this$props.meetingType,
        subheader = _this$props.subheader,
        title = _this$props.title,
        props = _objectWithoutPropertiesLoose(_this$props, ["attendees", "buttonLabel", "childrenLeft", "childrenRight", "className", "header", "isBold", "meetingType", "subheader", "title"]);

    var id = this.state.id;
    var otherProps = (0, _lodash.omit)(Object.assign({}, props), ['buttonOnClick']);
    var getTitle = !title && typeof header === 'string' ? header : title;

    var getLeftSection = function getLeftSection() {
      switch (meetingType) {
        case 'group':
          return _react.default.createElement(_.Avatar, {
            title: getTitle,
            alt: getTitle,
            type: "group"
          });

        case 'number':
          return _react.default.createElement(_.Avatar, {
            title: "#",
            alt: getTitle
          });

        case 'device':
          return _react.default.createElement(_.Avatar, {
            icon: _react.default.createElement(_.Icon, {
              name: "spark-board_16"
            }),
            alt: getTitle
          });

        default:
          return _react.default.createElement(_.Avatar, {
            title: getTitle,
            alt: getTitle
          });
      }
    };

    var getPopoverContent = _react.default.createElement(_.List, null, attendees.map(function (ele, idx) {
      return _react.default.createElement(_.ListItem, {
        key: "attendee-" + idx
      }, _react.default.createElement(_.ListItemSection, {
        position: "left"
      }, ele.node ? ele.node : _react.default.createElement(_.Avatar, {
        size: "small",
        title: ele.title,
        alt: ele.alt || ele.title,
        src: ele.src || '',
        type: "group"
      })), _react.default.createElement(_.ListItemSection, {
        position: "center"
      }, _react.default.createElement("div", {
        className: "cui-list-item__header"
      }, ele.title)));
    }));

    var children = [_react.default.createElement(_.ListItemSection, {
      key: "child-0",
      position: "left"
    }, childrenLeft || getLeftSection()), _react.default.createElement(_.ListItemSection, {
      key: "child-1",
      position: "center"
    }, _react.default.createElement("div", {
      className: "cui-list-item__header"
    }, header), _react.default.createElement("div", {
      className: "cui-list-item__subheader"
    }, subheader)), _react.default.createElement(_.ListItemSection, {
      key: "child-2",
      position: "right"
    }, childrenRight || attendees.length > 0 && _react.default.createElement(_.Popover, {
      content: getPopoverContent,
      direction: "bottom-center",
      targetOffset: {
        vertical: 3
      },
      isDynamic: true
    }, _react.default.createElement("span", {
      role: "button",
      tabIndex: 0,
      className: "cui-list-item--space-meeting--attendees"
    }, attendees.length, _react.default.createElement(_.Icon, {
      name: "people_12"
    }))), buttonLabel && _react.default.createElement(_.Button, {
      color: "green",
      ariaLabel: buttonLabel,
      children: buttonLabel,
      onClick: this.handleButtonClick,
      size: 28
    }))];
    return _react.default.createElement(_.ListItem, _extends({
      className: 'cui-list-item--space-meeting' + ("" + (isBold && " cui-list-item--unread" || '')) + ("" + (className && " " + className || '')),
      id: id,
      title: getTitle,
      type: "space"
    }, otherProps), children);
  };

  return SpaceListMeeting;
}(_react.default.PureComponent);

SpaceListMeeting.propTypes = {
  /** @prop Array of Attendee's Data | [] */
  attendees: _propTypes.default.arrayOf(_propTypes.default.shape({
    title: _propTypes.default.string.isRequired,
    alt: _propTypes.default.string,
    src: _propTypes.default.string,
    node: _propTypes.default.element
  })),

  /** @prop Label string for button | '' */
  buttonLabel: _propTypes.default.string,

  /** @prop Callback function invoked when user clicks on button | null */
  buttonOnClick: _propTypes.default.func,

  /** @prop Children nodes to render for left section | null */
  childrenLeft: _propTypes.default.node,

  /** @prop Children nodes to render for right section | null */
  childrenRight: _propTypes.default.node,

  /** @prop Optional HTML Class string | '' */
  className: _propTypes.default.string,

  /** @prop ListItem header text | '' */
  header: _propTypes.default.node.isRequired,

  /** @prop HTML ID for SpaceListMeeting | '' */
  id: _propTypes.default.string,

  /** @prop Determines if SpaceListMeeting is Bolded | false */
  isBold: _propTypes.default.bool,

  /** @prop Set the SpaceListMeeting type | '' */
  meetingType: _propTypes.default.oneOf(['', 'group', 'number', 'device']),

  /** @prop SpaceListMeeting sub header node | '' */
  subheader: _propTypes.default.node,

  /** @prop SpaceListMeeting title | '' */
  title: _propTypes.default.string
};
SpaceListMeeting.defaultProps = {
  attendees: [],
  buttonLabel: '',
  buttonOnClick: null,
  childrenLeft: null,
  childrenRight: null,
  className: '',
  id: '',
  isBold: false,
  meetingType: '',
  subheader: '',
  title: ''
};
SpaceListMeeting.displayName = 'SpaceListMeeting';
var _default = SpaceListMeeting;
/**
* @component list-item
* @section space-list-meeting
* @react
*
import {
  Avatar,
  Icon,
  List,
  SpaceListMeeting,
} from '@collabui/react';
import { NavLink } from 'react-router-dom';

export default class ListItemSpaceListMeeting extends React.PureComponent {

  render() {
    return(
      <div className="medium-5 columns">
        <List style={{backgroundColor: 'rgba(40,40,40,0.72)'}}>
          <SpaceListMeeting
            buttonLabel='Now'
            attendees={[
              {title: 'Joe Bojangles'},
              {title: 'Joe Boe'},
              {title: 'Joe Coe'},
              {title: 'Joe Doe'},
              {title: 'Joe Foe'},
              {title: 'Joe Goe'},
              {title: 'Joe Joe'},
              {title: 'Joe Koe'},
              {title: 'Joe Loe'},
              {title: 'Joe Moe'},
              {title: 'Joe Noe'},
              {title: 'Joe Poe'},
              {title: 'Moe Moe'},
              {title: 'Toe Toe'}
            ]}
            header='Attendees Prop'
            subheader='must be very long long long long long message message'
          />
          <SpaceListMeeting
            header='isBold(true)'
            subheader='subheader'
            isBold
          />
          <SpaceListMeeting
            buttonLabel='In 5 Min'
            header='MeetingType(group)'
            subheader='subheader'
            meetingType='group'
          />
          <SpaceListMeeting
            buttonLabel='2:25'
            header='MeetingType(number)'
            subheader='subheader'
            meetingType='number'
          />
          <SpaceListMeeting
            attendees={[
              {title: 'Joe Boe'},
              {title: 'Moe Moe'},
              {title: 'Toe Toe'}
            ]}
            buttonLabel='30:25'
            header='MeetingType(device)'
            meetingType='device'
          />
          <SpaceListMeeting
            attendees={[
              {title: 'Joe Boe'},
              {title: 'Moe Moe'},
              {title: 'Toe Toe'}
            ]}
            buttonLabel='30:25'
            header='ChildrenLeft Prop'
            childrenLeft={<Avatar icon={<Icon color='blue' name='mention_12' />} />}
          />
        </List>
      </div>
    );
  }
}
**/

exports.default = _default;

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(4);

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(7);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _lodash = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * @category communication
 * @component loader-spinner
 * @variations collab-ui-react
 */
var Spinner = function Spinner(props) {
  var className = props.className,
      color = props.color,
      showCheck = props.showCheck,
      percentage = props.percentage,
      showPercentage = props.showPercentage,
      size = props.size,
      otherHTMLProps = _objectWithoutPropertiesLoose(props, ["className", "color", "showCheck", "percentage", "showPercentage", "size"]);

  if ((0, _lodash.isNumber)(percentage)) {
    if (size !== 36 && showPercentage) {
      /* eslint-disable no-console */
      console.warn('[@collabui/react] Spinner: Percentage will not be shown for sizes smaller than 36');
      /* eslint-enable no-console */
    }

    return _react.default.createElement("div", _extends({
      className: "cui-spinner-progress" + (" cui-spinner-progress__percentage-" + (0, _lodash.round)(percentage)) + ("" + (size && " cui-spinner-progress--" + size || '')) + ("" + (color && " cui-spinner-progress--" + color || '')) + ("" + (className && " " + className || ''))
    }, otherHTMLProps), _react.default.createElement("div", {
      className: "cui-spinner-progress__circle"
    }, _react.default.createElement("div", {
      className: "cui-spinner-progress__mask cui-spinner-progress__full"
    }, _react.default.createElement("div", {
      className: "cui-spinner-progress__fill"
    })), _react.default.createElement("div", {
      className: "cui-spinner-progress__mask cui-spinner-progress__half"
    }, _react.default.createElement("div", {
      className: "cui-spinner-progress__fill"
    }), _react.default.createElement("div", {
      className: "cui-spinner-progress__fill cui-spinner-progress__fix"
    })), _react.default.createElement("div", {
      className: "cui-spinner-progress__inset-circle" + ("" + (showCheck && percentage === 100 && ' cui-spinner-progress__inset-circle--check' || ''))
    }, size === 36 && showPercentage && !showCheck && _react.default.createElement("div", {
      className: "cui-spinner-progress__percentage"
    }, (0, _lodash.round)(percentage)))));
  } else {
    return _react.default.createElement("i", _extends({
      className: "cui-spinner" + ("" + (size && " cui-spinner--" + size || '')) + ("" + (color && " cui-spinner--" + color || '')) + ("" + (className && " " + className || ''))
    }, otherHTMLProps));
  }
};

Spinner.propTypes = {
  /** @prop Optional CSS class names | '' */
  className: _propTypes.default.string,

  /** @prop Set Spinner color | '' */
  color: _propTypes.default.string,

  /** @prop Show percentage value for progress on Spinner | null */
  percentage: _propTypes.default.number,

  /** @prop Show the check mark if percentage 100 | false */
  showCheck: _propTypes.default.bool,

  /** @prop Show the number value for progress on Spinner | false */
  showPercentage: _propTypes.default.bool,

  /** @prop Spinner size | 36 */
  size: _propTypes.default.oneOf([16, 20, 28, 36])
};
Spinner.defaultProps = {
  className: '',
  color: 'black',
  percentage: null,
  showCheck: false,
  showPercentage: false,
  size: 36
};
Spinner.displayName = 'Spinner';
var _default = Spinner;
/**
* @component loader-spinner
* @section default
* @react
import { Spinner } from '@collabui/react';

export default function LoaderSpinnerDefault() {
  return (
    <Spinner />
  );
}

**/

/**
* @component loader-spinner
* @section determinate
* @react
import { Spinner } from '@collabui/react';

export default function LoaderSpinnerDeterminate() {
  return (
    <Spinner percentage={65}/>
  );
}

**/

/**
* @component loader-spinner
* @section percentage
* @react
import { Spinner } from '@collabui/react';

export default function LoaderSpinnerPercentage() {
  return (
    <Spinner
      percentage={65}
      showPercentage={true}
    />
  );
}

**/

/**
* @component loader-spinner
* @section check
* @react
import { Spinner } from '@collabui/react';

export default function LoaderSpinnerCheck() {
  return (
    <Spinner
      percentage={100}
      showCheck
    />
  );
}

**/

exports.default = _default;

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(5);

__webpack_require__(7);

__webpack_require__(4);

__webpack_require__(19);

__webpack_require__(20);

__webpack_require__(6);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _lodash = __webpack_require__(13);

var _ = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var SubMenu =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(SubMenu, _React$Component);

  function SubMenu() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      anchorRef: null
    };

    _this.verifyChildrenElements = function (nameArr) {
      var children = _this.props.children;
      var elementCount = 0;
      var childrenLength = 0;

      _react.default.Children.forEach(children, function (child) {
        childrenLength++;

        if (child.type && nameArr.includes(child.type.displayName)) {
          return elementCount++;
        }
      });

      return elementCount === childrenLength;
    };

    _this.handleKeyDown = function (e) {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          index = _this$props.index;
      var _this$context = _this.context,
          handleKeyDown = _this$context.handleKeyDown,
          handleClick = _this$context.handleClick;

      if (e.which === 32 || e.which === 13 || e.charCode === 32 || e.charCode === 13) {
        onClick && onClick(e);
        handleClick && handleClick(e, index, _assertThisInitialized(_assertThisInitialized(_this)));
        e.preventDefault();
      } else {
        handleKeyDown && handleKeyDown(e, index, _assertThisInitialized(_assertThisInitialized(_this)));
      }
    };

    _this.handleClick = function (e) {
      var handleClick = _this.context.handleClick;
      var _this$props2 = _this.props,
          index = _this$props2.index,
          onClick = _this$props2.onClick;
      onClick && onClick(e);
      handleClick && handleClick(e, index, _assertThisInitialized(_assertThisInitialized(_this)));
    };

    return _this;
  }

  var _proto = SubMenu.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var children = this.props.children;

    if (!children) {
      throw new Error("[@collabui/react] SubMenu: children are required for this component.");
    } else if (!this.verifyChildrenElements(['MenuItem', 'SubMenu'])) {
      throw new Error("[@collabui/react] SubMenu: children must be SubMenu or MenuItem");
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props3 = this.props,
        children = _this$props3.children,
        className = _this$props3.className,
        content = _this$props3.content,
        customNode = _this$props3.customNode,
        isHeader = _this$props3.isHeader,
        isOpen = _this$props3.isOpen,
        label = _this$props3.label,
        selectedValue = _this$props3.selectedValue,
        props = _objectWithoutPropertiesLoose(_this$props3, ["children", "className", "content", "customNode", "isHeader", "isOpen", "label", "selectedValue"]);

    var otherProps = (0, _lodash.omit)(Object.assign({}, props), ['customNode', 'index', 'keepMenuOpen', 'onClick']);
    return _react.default.createElement("div", {
      className: 'cui-menu-item' + ("" + (className && " " + className || '')),
      "aria-expanded": isOpen,
      "aria-haspopup": !!children
    }, _react.default.createElement(_.ListItem, _extends({
      active: isOpen,
      focusOnLoad: true,
      isReadOnly: isHeader,
      onClick: this.handleClick,
      onKeyDown: this.handleKeyDown,
      ref: function ref(_ref) {
        return !_this2.state.anchorRef && _this2.setState({
          anchorRef: _ref
        });
      },
      role: "menuitem"
    }, otherProps), customNode ? customNode : [_react.default.createElement("div", {
      className: "cui-menu-item__content",
      key: "content-0"
    }, content || label), _react.default.createElement("div", {
      className: "cui-menu-item__selected-value",
      title: selectedValue,
      key: "content-1"
    }, children && selectedValue), _react.default.createElement("div", {
      className: "cui-menu-item__arrow",
      key: "content-2"
    }, children && _react.default.createElement(_.Icon, {
      name: "arrow-right_16"
    }))]), isOpen && _react.default.createElement(_.EventOverlay, {
      anchorNode: this.state.anchorRef,
      isOpen: isOpen,
      direction: "right-top",
      closeOnClick: false,
      isContained: true
    }, _react.default.createElement("div", {
      "aria-label": label,
      role: "menu",
      className: "cui-menu-item-container"
    }, children)));
  };

  return SubMenu;
}(_react.default.Component);

SubMenu.propTypes = {
  /** @prop Children nodes to render inside SubMenu | null */
  children: _propTypes.default.node,

  /** @prop Optional CSS class names | '' */
  className: _propTypes.default.string,

  /** @prop SubMenu content element | null */
  content: _propTypes.default.element,

  /** @prop SubMenu custom Node | null */
  customNode: _propTypes.default.node,

  /** @prop Index of SubMenu | [] */
  index: _propTypes.default.array,

  /** @prop Determines if the SubMenu is the header | false */
  isHeader: _propTypes.default.bool,

  /** @prop Determines if the SubMenu is Open | false */
  isOpen: _propTypes.default.bool,

  /** @prop Boolean whether to keep the SubMenu open | false */
  keepMenuOpen: _propTypes.default.bool,

  /** @prop SubMenu label string | '' */
  label: _propTypes.default.string,

  /** @prop Callback function invoked when user clicks the SubMenu | null */
  onClick: _propTypes.default.func,

  /** @prop Initial selected value within SubMenu | '' */
  selectedValue: _propTypes.default.string
};
SubMenu.defaultProps = {
  children: null,
  className: '',
  content: null,
  customNode: null,
  index: [],
  isHeader: false,
  isOpen: false,
  keepMenuOpen: false,
  label: '',
  onClick: null,
  selectedValue: ''
};
SubMenu.contextTypes = {
  handleClick: _propTypes.default.func,
  handleKeyDown: _propTypes.default.func
};
SubMenu.displayName = 'SubMenu';
var _default = SubMenu;
exports.default = _default;

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(4);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * Tab is supplemental, clickable component used to help navigate content
 * @param props
 * @returns {XML}
 * @constructor
 */
var Tab =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(Tab, _React$PureComponent);

  function Tab() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = Tab.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.props.focus && this.tabLink.focus();
  };

  _proto.render = function render() {
    var _this = this;

    var _this$props = this.props,
        heading = _this$props.heading,
        active = _this$props.active,
        onPress = _this$props.onPress,
        onKeyDown = _this$props.onKeyDown,
        role = _this$props.role,
        focus = _this$props.focus,
        className = _this$props.className,
        disabled = _this$props.disabled;
    /* Due to Collab UI must keep anchor element instead of button
     eventhough accessibility would like the anchor element to be switched
     to a button. */

    /* eslint-disable */

    return _react.default.createElement("li", _extends({
      className: 'cui-tab__item' + ("" + (className && " " + className || '')) + ("" + (active ? ' active' : '')) + ("" + (disabled ? ' disabled' : ''))
    }, !disabled ? {
      tabIndex: '-1'
    } : {}), _react.default.createElement("a", {
      ref: function ref(_ref) {
        return _this.tabLink = _ref;
      },
      role: role,
      href: "javascript:void(0)",
      onKeyDown: onKeyDown,
      onClick: onPress,
      tabIndex: focus ? 0 : -1,
      "aria-current": active
    }, heading));
  };

  return Tab;
}(_react.default.PureComponent);
/* eslint-enable */


Tab.propTypes = {
  /** @prop Set Tab with an active state | false */
  active: _propTypes.default.bool,

  /** @prop Optional CSS class name */
  className: _propTypes.default.string,

  /** @prop Sets the attribute disabled to the Tab | false */
  disabled: _propTypes.default.bool,

  /** @prop Specifies if Tab should automatically get focus when page loads | false */
  focus: _propTypes.default.bool,

  /** @prop Tab Heading Text */
  heading: _propTypes.default.string.isRequired,

  /** @prop Currently unused prop myKey | 0 */
  myKey: _propTypes.default.number,

  /** @prop Callback function invoked when user presses a key | null */
  onKeyDown: _propTypes.default.func,

  /** @prop Callback function invoked when user presses on the Tab | null */
  onPress: _propTypes.default.func,

  /** @prop Tab's anchor role type | 'tab' */
  role: _propTypes.default.string
};
Tab.defaultProps = {
  active: false,
  className: '',
  disabled: false,
  focus: false,
  myKey: 0,
  onKeyDown: null,
  onPress: null,
  role: 'tab'
};
Tab.displayName = 'Tab';
var _default = Tab;
exports.default = _default;

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * TabContent helps organize the TabPanes and provides the Tab-content CSS wrapper;
 * @param props
 * @returns {XML}
 * @constructor
 */
var TabContent = function TabContent(props) {
  var children = props.children,
      activeIndex = props.activeIndex;

  var setPanels = _react.default.Children.map(children, function (child, idx) {
    return _react.default.cloneElement(child, {
      active: activeIndex === idx ? true : false
    });
  });

  return _react.default.createElement("div", {
    className: "cui-tab__content"
  }, setPanels);
};

TabContent.propTypes = {
  /** @prop Determines the initial active index | null */
  activeIndex: _propTypes.default.number,

  /** @prop Children nodes to render inside TabContent | null */
  children: _propTypes.default.node
};
TabContent.defaultProps = {
  activeIndex: null,
  children: null
};
TabContent.displayName = 'TabContent';
var _default = TabContent;
exports.default = _default;

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Tabheader is used for Large Tabs with subheadings;
 * @param props
 * @returns {XML}
 * @constructor
 */
var TabHeader = function TabHeader(props) {
  var heading = props.heading,
      subHeading = props.subHeading;
  return (//Element type requires by UI-Collab Style
    _react.default.createElement("cui-tab-heading", null, heading, subHeading && _react.default.createElement("div", null, subHeading))
  );
};

TabHeader.propTypes = {
  /** @prop TabHeader text */
  heading: _propTypes.default.string.isRequired,

  /** @prop Subheader text | '' */
  subHeading: _propTypes.default.string
};
TabHeader.defaultProps = {
  subHeading: ''
};
TabHeader.displayName = 'TabHeader';
var _default = TabHeader;
exports.default = _default;

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(58);

__webpack_require__(19);

__webpack_require__(20);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * Tab is supplemental, non-clickable component used to help bring attention to an item or object.
 * @param props
 * @returns {XML}
 * @constructor
 */
var TabList =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TabList, _React$Component);

  function TabList() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.determineInitialFocus = function () {
      var children = _this.props.children;
      var focus = _this.context.focus;

      var childrenList = _react.default.Children.toArray(children);

      if (focus > childrenList.length - 1 || focus < 0) {
        throw new Error("focusIndex " + focus + " is out of bound.");
      }

      var focusIndex = !childrenList[focus].props.disabled ? focus : null;

      _this.setFocus(focusIndex);

      _this.context.onActivate(focusIndex);
    };

    _this.setFocus = function (index) {
      // Update state with selected index
      return _this.context.onFocus(index);
    };

    _this.handleClick = function (event, index, disabled) {
      if (disabled) {
        event.preventDefault();
        event.stopPropagation();
      }

      _this.setFocus(index);

      return _this.context.onActivate(index);
    };

    _this.getIncludesFirstCharacter = function (str, char) {
      return str.charAt(0).toLowerCase().includes(char);
    };

    _this.setFocusByFirstCharacter = function (char, currentIdx, length) {
      var children = _this.props.children;

      var newIndex = _react.default.Children.toArray(children).reduce(function (agg, child, idx, arr) {
        var index = currentIdx + idx + 1 > length ? Math.abs(currentIdx + idx - length) : currentIdx + idx + 1;
        var label = arr[index].props.role === 'menuItem' ? arr[index].props.label : arr[index].props.heading;
        return !agg.length && !arr[index].props.disabled && _this.getIncludesFirstCharacter(label, char) ? agg.concat(index) : agg;
      }, []);

      _this.setFocus(newIndex[0]);
    };

    _this.handleListKeyPress = function (e, idx, length, disabled) {
      if (disabled) {
        e.preventDefault();
        e.stopPropagation();
      }

      var newIndex, clickEvent;
      var tgt = e.currentTarget;
      var char = e.key;
      var flag = false;

      var getNewIndex = function getNewIndex(currentIndex, change) {
        var getPossibleIndex = function getPossibleIndex() {
          if (currentIndex + change < 0) {
            return length;
          } else if (currentIndex + change > length) {
            return 0;
          }

          return currentIndex + change;
        };

        var possibleIndex = getPossibleIndex();
        return _react.default.Children.toArray(_this.props.children)[possibleIndex].props.disabled ? getNewIndex(possibleIndex, change) : possibleIndex;
      };

      var isPrintableCharacter = function isPrintableCharacter(str) {
        return str.length === 1 && str.match(/\S/);
      };

      switch (e.which) {
        case 32:
        case 13:
          try {
            clickEvent = new MouseEvent('click', {
              view: window,
              bubbles: true,
              cancelable: true
            });
          } catch (err) {
            if (document.createEvent) {
              // DOM Level 3 for IE 9+
              clickEvent = document.createEvent('MouseEvents');
              clickEvent.initEvent('click', true, true);
            }
          }

          tgt.dispatchEvent(clickEvent);
          flag = true;
          break;

        case 38:
        case 37:
          // console.log('leftarrow');
          newIndex = getNewIndex(idx, -1);

          _this.setFocus(newIndex);

          flag = true;
          break;

        case 39:
        case 40:
          newIndex = getNewIndex(idx, 1);

          _this.setFocus(newIndex);

          flag = true;
          break;

        case 33:
        case 36:
          _this.setFocus(0);

          flag = true;
          break;

        case 34:
        case 35:
          _this.setFocus(length);

          flag = true;
          break;

        default:
          if (isPrintableCharacter(char)) {
            _this.setFocusByFirstCharacter(char, idx, length);

            flag = true;
          }

          break;
      }

      if (flag) {
        e.stopPropagation();
        e.preventDefault();
      }
    };

    return _this;
  }

  var _proto = TabList.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.determineInitialFocus();
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        children = _this$props.children,
        role = _this$props.role;
    var _this$context = this.context,
        activeIndex = _this$context.activeIndex,
        focus = _this$context.focus;

    var setTabs = function setTabs() {
      return _react.default.Children.map(children, function (child, idx) {
        var arrLength = children.length - 1;
        var disabled = child.props.disabled;
        return _react.default.cloneElement(child, {
          active: activeIndex === idx,
          focus: focus === idx,
          onPress: function onPress(e) {
            return _this2.handleClick(e, idx, disabled);
          },
          onKeyDown: function onKeyDown(e) {
            return _this2.handleListKeyPress(e, idx, arrLength, disabled);
          },
          refName: 'navLink'
        });
      });
    };

    return _react.default.createElement("ul", {
      className: "cui-tab__list",
      role: role
    }, setTabs());
  };

  return TabList;
}(_react.default.Component);

TabList.propTypes = {
  /** @prop Children nodes to render inside TabList | null */
  children: _propTypes.default.node,

  /**
   * @prop ARIA role for the Nav, in the context of a TabContainer, the default will
   * be set to "tablist", but can be overridden by the Nav when set explicitly.
   *
   * When the role is set to "tablist" NavItem focus is managed according to
   * the ARIA authoring practices for tabs:
   * https://www.w3.org/TR/2013/WD-wai-aria-practices-20130307/#tabpanel | 'TabList'
   */
  role: _propTypes.default.string
};
TabList.defaultProps = {
  children: null,
  role: 'tablist'
};
TabList.contextTypes = {
  onFocus: _propTypes.default.func,
  focus: _propTypes.default.number,
  activeIndex: _propTypes.default.number,
  onActivate: _propTypes.default.func
};
TabList.displayName = 'TabList';
var _default = TabList;
exports.default = _default;

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Tab is supplemental, non-clickable component used to help bring attention to an item or object.
 * @param props
 * @returns {XML}
 * @constructor
 */
var TabPane = function TabPane(props) {
  var children = props.children,
      active = props.active;
  return _react.default.createElement("div", {
    className: "cui-tab__pane" + ("" + (active ? ' active' : ''))
  }, _react.default.createElement("div", {
    className: "cui-tab__content"
  }, children));
};

TabPane.propTypes = {
  /** @prop Determines if TabPane is active | false */
  active: _propTypes.default.bool,

  /** @prop Children nodes to render inside TabPane | null */
  children: _propTypes.default.node
};
TabPane.defaultProps = {
  active: false,
  children: null
};
TabPane.displayName = 'TabPane';
var _default = TabPane;
exports.default = _default;

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(6);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * Tabs is container component for rendering tabs and tab-panels
 * @category layout
 * @component tabs
 * @variations collab-ui-react
 *
 */
var Tabs =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Tabs, _React$Component);

  function Tabs() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      activeIndex: 0,
      focus: _this.props.focus
    };

    _this.getChildContext = function () {
      return {
        activeIndex: _this.state.activeIndex,
        onActivate: function onActivate(index) {
          return _this.setSelected(index);
        },
        onFocus: function onFocus(index) {
          return _this.setState({
            focus: index
          });
        },
        focus: _this.state.focus
      };
    };

    _this.getMobileListItems = function () {
      return _react.default.Children.map(_this.props.children, function (child) {
        if (child.type.displayName === 'TopbarNav') {
          return child.props.children;
        }
      });
    };

    _this.getChildrenElements = function (name) {
      var elementCount = 0;

      _react.default.Children.forEach(_this.props.children, function (child) {
        if (child.type.displayName === name) {
          return child.props.children.length ? elementCount += child.props.children.length : elementCount++;
        }
      });

      return elementCount;
    };

    _this.setSelected = function (index) {
      // Don't do anything if index is the same or outside of the bounds
      if (index === _this.state.activeIndex || index < 0 || index >= _this.getChildrenElements('TabList')) return; // Keep reference to last index for event handler

      var last = _this.state.activeIndex; // Update state with selected index

      _this.setState({
        activeIndex: index
      }); // Call change event handler


      if (typeof _this.props.onSelect === 'function') {
        _this.props.onSelect(index, last);
      }
    };

    return _this;
  }

  var _proto = Tabs.prototype;

  _proto.componentWillMount = function componentWillMount() {
    var tabsCount = this.getChildrenElements('TabList');
    var panelsCount = this.getChildrenElements('TabContent');

    if (tabsCount !== panelsCount) {
      throw new Error("There should be an equal number of Tabs and TabPanels.\n      Received " + tabsCount + " Tabs and " + panelsCount + " TabPanels.");
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        tabType = _this$props.tabType,
        justified = _this$props.justified;

    var cloneChildren = _react.default.Children.map(children, function (child) {
      if (child.type.displayName === 'TabContent') {
        return _react.default.cloneElement(child, {
          activeIndex: _this2.state.activeIndex
        });
      } else if (child.type.displayName === 'TabList') {
        return _react.default.cloneElement(child, {
          role: 'tab'
        });
      } else {
        return child;
      }
    });

    return _react.default.createElement("div", {
      className: 'cui-tab' + ("" + (tabType && " cui-tab--" + tabType || '')) + ("" + (justified && " cui-tab--justified" || '')) + (className && " " + className) || '',
      type: tabType
    }, cloneChildren);
  };

  return Tabs;
}(_react.default.Component);

Tabs.propTypes = {
  /** @prop Determines if Tab is active | false */
  active: _propTypes.default.bool,

  /** @prop Children nodes of Tab and TabContent are required */
  children: _propTypes.default.node.isRequired,

  /** @prop Optional CSS class name | '' */
  className: _propTypes.default.string,

  /** @prop Set the index of the focused Tab | 0 */
  focus: _propTypes.default.number,

  /** @prop Determines if the Tabs are in a justified layout | false */
  justified: _propTypes.default.bool,

  /** @prop Callback function invoked when user selects a tab | null */
  onSelect: _propTypes.default.func,

  /** @prop Type of Tabs | 'pills' */
  tabType: _propTypes.default.oneOf(['pills'])
};
Tabs.defaultProps = {
  active: false,
  className: '',
  focus: 0,
  justified: false,
  onSelect: null,
  tabType: 'pills'
};
Tabs.childContextTypes = {
  focus: _propTypes.default.number,
  activeIndex: _propTypes.default.number,
  onActivate: _propTypes.default.func,
  onFocus: _propTypes.default.func
};
Tabs.displayName = 'Tabs';
var _default = Tabs;
/**
* @component tabs
* @section default
* @react

 import {
  Tab,
  TabContent,
  TabList,
  TabPane,
  Tabs,
} from '@collabui/react';

 export default function TabsDefault() {
  return (
    <Tabs>
      <TabList>
        <Tab
          heading='First Tab'
        />
        <Tab
          heading='Second Tab'
        />
        <Tab
          heading='Third Tab'
        />
      </TabList>
      <TabContent>
        <TabPane>
          Testing 1
        </TabPane>
        <TabPane>
          Testing 2
        </TabPane>
        <TabPane>
          Testing 3
        </TabPane>
      </TabContent>
    </Tabs>
  );
}
**/

/**
* @component tabs
* @section justified
* @react

 import {
  Tab,
  TabContent,
  TabList,
  TabPane,
  Tabs,
} from '@collabui/react';

 export default function TabsJustified() {
  return (
    <Tabs justified>
      <TabList>
        <Tab
          heading='First Tab'
        />
        <Tab
          heading='Second Tab'
        />
        <Tab
          heading='Third Tab'
        />
      </TabList>
      <TabContent>
        <TabPane>
          Testing 1
        </TabPane>
        <TabPane>
          Testing 2
        </TabPane>
        <TabPane>
          Testing 3
        </TabPane>
      </TabContent>
    </Tabs>
  );
}
**/

exports.default = _default;

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(19);

__webpack_require__(20);

var _react = _interopRequireDefault(__webpack_require__(2));

var _reactDom = _interopRequireDefault(__webpack_require__(61));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _moment = _interopRequireDefault(__webpack_require__(1));

var _lodash = __webpack_require__(13);

var _TimePickerDropdown = _interopRequireDefault(__webpack_require__(568));

var _TimeSelector = _interopRequireDefault(__webpack_require__(569));

var _ = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var TimePicker =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TimePicker, _React$Component);

  function TimePicker() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      inputId: _this.props.inputId || (0, _lodash.uniqueId)('cui-timepicker__input-'),
      isOpen: false,
      selectedTime: (0, _moment.default)(_this.props.selectedTime),
      activeIndex: null,
      anchorNode: null
    };

    _this.componentDidUpdate = function (prevProps, prevState) {
      var hourEntry = _this.hour;

      if (!prevState.isOpen && _this.state.isOpen) {
        _this.focusOnNode(hourEntry);
      }
    };

    _this.focusOnNode = function (node) {
      node.focus();
    };

    _this.hidePopover = function () {
      _this.setState({
        isOpen: false
      });
    };

    _this.onFocus = function () {
      _this.setState({
        isOpen: true,
        anchorNode: _reactDom.default.findDOMNode(_this.clickTextField).parentNode
      });
    };

    _this.onMouseDown = function () {
      _this.setState({
        isOpen: !_this.state.isOpen,
        anchorNode: _reactDom.default.findDOMNode(_this.clickTextField).parentNode
      });
    };

    _this.triggerOnChange = function (dayChange) {
      _this.props.onChange && _this.props.onChange(_this.state.selectedTime.hour(), _this.state.selectedTime.minute(), dayChange);
    };

    _this.changeTime = function (unit, change) {
      var newTime = (0, _moment.default)(_this.state.selectedTime).add(change, unit);
      var dayChange = 0;

      if (change >= 0) {
        if (newTime.clone().startOf('day').isAfter((0, _moment.default)().startOf('day'))) {
          newTime.add(-1, 'day');
          dayChange = 1;
        }
      } else {
        if (newTime.clone().startOf('day').isBefore((0, _moment.default)().startOf('day'))) {
          newTime.add(1, 'day');
          dayChange = -1;
        }
      }

      _this.setState({
        selectedTime: newTime
      }, function () {
        return _this.triggerOnChange(dayChange);
      });
    };

    _this.setTime = function (hour, minute, pre) {
      var meridianHour = pre === 'PM' && parseInt(hour) < 12 ? parseInt(hour) + 12 : pre === 'AM' && parseInt(hour) === 12 ? 0 : hour;

      _this.setState({
        selectedTime: _this.state.selectedTime.clone().hour(meridianHour).minute(minute)
      }, function () {
        return _this.triggerOnChange(0);
      });
    };

    _this.onSelectKeyDown = function (unit, e) {
      e.preventDefault();
      var _this$props = _this.props,
          minuteInterval = _this$props.minuteInterval,
          militaryTime = _this$props.militaryTime;
      var hour = !_this.hour.value && unit === 'h' ? militaryTime ? 0 : 1 : _this.hour.value;
      var minute = !_this.minute.value && unit === 'm' ? 0 : _this.minute.value;
      var pre = !militaryTime && _this.pre.value;

      if (e.keyCode === 65 && unit === 'pre') {
        if (_this.pre.value.includes('A')) return;
        return _this.changeTime('h', 12);
      } else if (e.keyCode === 80 && unit === 'pre') {
        if (_this.pre.value.includes('P')) return;
        return _this.changeTime('h', 12);
      } else if (e.keyCode === 38) {
        if (unit === 'pre') return _this.changeTime('h', 12);
        if (unit === 'h') return _this.changeTime('h', 1);
        return _this.changeTime(unit, minuteInterval);
      } else if (e.keyCode === 40) {
        if (unit === 'pre') return _this.changeTime('h', -12);
        if (unit === 'h') return _this.changeTime('h', -1);
        return _this.changeTime(unit, -minuteInterval);
      } else {
        _this.setTime(hour, minute, pre);
      }
    };

    _this.onSelectWheel = function (unit, e) {
      if (e.deltaY < 0) {
        _this.changeTime(unit, 1);
      } else if (e.deltaY > 0) {
        _this.changeTime(unit, -1);
      }

      e.preventDefault();
    };

    return _this;
  }

  var _proto = TimePicker.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        militaryTime = _this$props2.militaryTime,
        minuteInterval = _this$props2.minuteInterval;
    var inputId = this.state.inputId; // Force the global locale onto our display moment

    var selectedMoment = this.state.selectedTime.locale(_moment.default.locale()); // Splits the moment string into seperate parts in order to add functionality to the TimePicker

    var timeString = militaryTime ? selectedMoment.format('HH:mm') : selectedMoment.format('LT');
    var hourText = selectedMoment.format(militaryTime ? 'HH' : 'hh');
    var minuteText = selectedMoment.format('mm');
    var postText = selectedMoment.format('A');

    var text = _react.default.createElement(_.Input, {
      label: "",
      name: inputId,
      id: inputId,
      onChange: function onChange() {},
      value: timeString,
      onMouseDown: this.onMouseDown,
      onFocus: this.onFocus,
      inputRef: function inputRef(ref) {
        return _this2.clickTextField = ref;
      },
      readOnly: true
    });

    var dropdownElement = _react.default.createElement(_.EventOverlay, {
      allowClickAway: true,
      anchorNode: this.state.anchorNode,
      close: this.hidePopover,
      isOpen: this.state.isOpen
    }, _react.default.createElement(_TimePickerDropdown.default, null, _react.default.createElement(_TimeSelector.default, {
      unit: "h",
      min: 0,
      value: hourText,
      onWheel: this.onSelectWheel,
      inputRef: function inputRef(ref) {
        return _this2.hour = ref;
      },
      onKeyDown: this.onSelectKeyDown,
      onUpClick: function onUpClick() {
        return _this2.changeTime('h', 1);
      },
      onDownClick: function onDownClick() {
        return _this2.changeTime('h', -1);
      },
      militaryTime: militaryTime
    }), ":", _react.default.createElement(_TimeSelector.default, {
      unit: "m",
      min: 0,
      value: minuteText,
      onWheel: this.onSelectWheel,
      inputRef: function inputRef(ref) {
        return _this2.minute = ref;
      },
      onKeyDown: this.onSelectKeyDown,
      onUpClick: function onUpClick() {
        return _this2.changeTime('m', minuteInterval);
      },
      onDownClick: function onDownClick() {
        return _this2.changeTime('m', -minuteInterval);
      }
    }), !militaryTime && _react.default.createElement(_TimeSelector.default, {
      unit: "pre",
      value: postText,
      inputRef: function inputRef(ref) {
        return _this2.pre = ref;
      },
      onKeyDown: this.onSelectKeyDown,
      onWheel: this.onSelectWheel,
      onUpClick: function onUpClick() {
        return _this2.changeTime('h', 12);
      },
      onDownClick: function onDownClick() {
        return _this2.changeTime('h', -12);
      }
    })));

    return _react.default.createElement("div", {
      className: "cui-timepicker-container"
    }, text, dropdownElement);
  };

  return TimePicker;
}(_react.default.Component);

TimePicker.propTypes = {
  /** @prop Optional CSS class name | '' */
  className: _propTypes.default.string,

  /** @prop Set Input element ID | '' */
  inputId: _propTypes.default.string,

  /** @prop Choose to use military time | false */
  militaryTime: _propTypes.default.bool,

  /** @prop Determine the minute interval | 1 */
  minuteInterval: _propTypes.default.oneOf([1, 5, 15, 30, 60]),

  /** @prop Callback function invoked when user makes a change | null */
  onChange: _propTypes.default.func,

  /** @prop Set the initial selected time | null */
  selectedTime: _propTypes.default.instanceOf(Date)
};
TimePicker.defaultProps = {
  className: '',
  inputId: '',
  militaryTime: false,
  minuteInterval: 1,
  onChange: null,
  selectedTime: null
};
TimePicker.displayName = 'TimePicker';
var _default = TimePicker;
/**
* @component time-picker
* @section default
* @react

import { Input, TimePicker } from '@collabui/react';

export default class TimePickerDefault extends React.PureComponent {
  render() {
    return (
      <div className='timePicker-container'>
        <TimePicker
          selectedTime={new Date()}
        />
      </div>
    );
  }
}

**/

/**
* @component time-picker
* @section 24-hour
* @react

import { Input, TimePicker } from '@collabui/react';

export default class TimePicker24Hr extends React.PureComponent {
  render() {
    return (
      <div className='timePicker-container'>
        <TimePicker
          selectedTime={new Date()}
          militaryTime
        />
      </div>
    );
  }
}

**/

/**
* @component time-picker
* @section 30-minute-step
* @react

import { Input, TimePicker } from '@collabui/react';

export default class TimePicker30MinStep extends React.PureComponent {
  render() {
    return (
      <div className='timePicker-container'>
        <TimePicker
          minuteInterval={30}
          selectedTime={new Date()}
        />
      </div>
    );
  }
}

**/

exports.default = _default;

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var TimePickerDropdown =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(TimePickerDropdown, _React$PureComponent);

  function TimePickerDropdown() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = TimePickerDropdown.prototype;

  _proto.render = function render() {
    var children = this.props.children;
    return (
      /* eslint-disable */
      // Disabled due to onClick on div - needed to not close DropDown Prematurely
      _react.default.createElement("div", {
        className: 'cui-timepicker__dropdown-container',
        onClick: function onClick(e) {
          return e.stopPropagation();
        }
      }, _react.default.createElement("div", {
        className: 'cui-timepicker__dropdown'
      }, _react.default.createElement("div", {
        className: "inline-flex"
      }, children)))
      /* eslint-enable */

    );
  };

  return TimePickerDropdown;
}(_react.default.PureComponent);

TimePickerDropdown.propTypes = {
  /** @prop Children node to render within TimePickerDropdown | null */
  children: _propTypes.default.node
};
TimePickerDropdown.defaultProps = {
  children: null
};
TimePickerDropdown.displayName = 'TimePickerDropdown';
var _default = TimePickerDropdown;
exports.default = _default;

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(19);

__webpack_require__(20);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var TimeSelector =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TimeSelector, _React$Component);

  function TimeSelector() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      value: _this.props.value,
      isEditing: false
    };

    _this.componentDidUpdate = function (prevProps, prevState) {
      if (prevState.value !== _this.props.value && !_this.state.isEditing) {
        _this.setState({
          value: _this.props.value
        });
      }
    };

    _this.handleOnChange = function (e) {
      var _this$props = _this.props,
          unit = _this$props.unit,
          militaryTime = _this$props.militaryTime;
      var newValue = e.currentTarget.value;

      if (/[a-zA-Z]/.test(e.currentTarget.value)) {
        e.stopPropagation();
        return false;
      } else if (unit === 'h') {
        newValue = militaryTime ? (parseInt(newValue, 10) > 23 ? 23 : parseInt(newValue, 10)) || '' : (parseInt(newValue, 10) > 12 ? 12 : parseInt(newValue, 10)) || '';
      } else if (unit === 'm') {
        newValue = parseInt(newValue, 10) > 59 ? 59 : parseInt(newValue, 10) || '';
      }

      _this.setState({
        value: newValue,
        isEditing: true
      });
    };

    _this.submitChange = function (e) {
      var _this$props2 = _this.props,
          onKeyDown = _this$props2.onKeyDown,
          unit = _this$props2.unit;

      _this.setState({
        isEditing: false
      }, onKeyDown(unit, e));
    };

    _this.handleKey = function (e) {
      var newValue = e.currentTarget.value;
      var _this$props3 = _this.props,
          onKeyDown = _this$props3.onKeyDown,
          unit = _this$props3.unit;

      if (e.keyCode === 38 || e.keyCode === 40) {
        _this.setState({
          isEditing: false
        }, onKeyDown(unit, e));

        e.stopPropagation();
      } else if (e.keyCode === 65 && unit === 'pre') {
        if (newValue.includes('A')) return;

        _this.setState({
          isEditing: false
        }, onKeyDown(unit, e));

        e.stopPropagation();
      } else if (e.keyCode === 80 && unit === 'pre') {
        if (newValue.includes('P')) return;

        _this.setState({
          isEditing: false
        }, onKeyDown(unit, e));

        e.stopPropagation();
      }
    };

    return _this;
  }

  var _proto = TimeSelector.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props4 = this.props,
        inputRef = _this$props4.inputRef,
        onDownClick = _this$props4.onDownClick,
        onUpClick = _this$props4.onUpClick,
        _onWheel = _this$props4.onWheel,
        type = _this$props4.type,
        unit = _this$props4.unit;
    return _react.default.createElement("div", null, _react.default.createElement("i", {
      className: "icon icon-arrow-up_24",
      onClick: function onClick() {
        return _this2.setState({
          isEditing: false
        }, onUpClick);
      },
      onKeyUp: function onKeyUp() {},
      tabIndex: -1,
      role: "button"
    }), _react.default.createElement("input", {
      onWheel: function onWheel(e) {
        return _onWheel(unit, e);
      },
      type: type,
      minLength: 2,
      maxLength: 2,
      onClick: function onClick(e) {
        return e.currentTarget.focus();
      },
      ref: inputRef,
      onChange: this.handleOnChange,
      tabIndex: 0,
      value: this.state.value,
      onBlur: this.submitChange,
      onKeyUp: this.handleKey
    }), _react.default.createElement("i", {
      className: "icon icon-arrow-down_24",
      onClick: function onClick() {
        return _this2.setState({
          isEditing: false
        }, onDownClick);
      },
      onKeyUp: function onKeyUp() {},
      role: "button",
      tabIndex: -1
    }));
  };

  return TimeSelector;
}(_react.default.Component);

TimeSelector.propTypes = {
  /** @prop Ref attribute for TimeSelector input element | null */
  inputRef: _propTypes.default.func,

  /** @prop Choose to use military time | false */
  militaryTime: _propTypes.default.bool,

  /** @prop Callback function invoked when user presses down | null  */
  onDownClick: _propTypes.default.func,

  /** @prop Callback function invoked when user presses a key | null  */
  onKeyDown: _propTypes.default.func,

  /** @prop Callback function invoked when user releases a click | null  */
  onUpClick: _propTypes.default.func,

  /** @prop Callback function invoked when user wheels the mouse | null */
  onWheel: _propTypes.default.func,

  /** @prop Set the type for the Input element | 'text' */
  type: _propTypes.default.string,

  /** @prop Set the unit of time | '' */
  unit: _propTypes.default.string,

  /** @prop Set the value of the Input element | '' */
  value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
};
TimeSelector.defaultProps = {
  inputRef: null,
  militaryTime: false,
  onDownClick: null,
  onKeyDown: null,
  onUpClick: null,
  onWheel: null,
  type: 'text',
  unit: '',
  value: ''
};
TimeSelector.displayName = 'TimeSelector';
var _default = TimeSelector;
exports.default = _default;

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(37);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var ToggleSwitch =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(ToggleSwitch, _React$PureComponent);

  function ToggleSwitch() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;
    _this.state = {
      isToggleOn: _this.props.checked
    };

    _this.handleClick = function (event) {
      _this.setState({
        isToggleOn: !_this.state.isToggleOn
      });

      if (_this.props.onChange) {
        _this.props.onChange(event);
      }
    };

    return _this;
  }

  var _proto = ToggleSwitch.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        disabled = _this$props.disabled,
        name = _this$props.name,
        label = _this$props.label,
        value = _this$props.value,
        className = _this$props.className,
        htmlId = _this$props.htmlId,
        onChange = _this$props.onChange;
    return _react.default.createElement("div", {
      className: "cui-input-group cui-toggle-switch" + (" " + className)
    }, _react.default.createElement("input", {
      className: "cui-input cui-toggle-switch__input",
      type: "checkbox",
      disabled: disabled,
      "aria-checked": this.state.isToggleOn,
      checked: this.state.isToggleOn,
      name: name,
      value: value,
      id: htmlId,
      onChange: onChange,
      tabIndex: 0,
      onClick: function onClick(event) {
        return _this2.handleClick(event);
      }
    }), _react.default.createElement("label", {
      className: "cui-toggle-switch__label",
      htmlFor: htmlId
    }, _react.default.createElement("span", {
      className: "cui-toggle-switch__label__container"
    }), _react.default.createElement("span", {
      className: "cui-toggle-switch__label__text"
    }, label)));
  };

  return ToggleSwitch;
}(_react.default.PureComponent);

ToggleSwitch.propTypes = {
  /** @prop Set the toggle switch to checked | false */
  checked: _propTypes.default.bool,

  /** @prop Sets the className for the toggle switch | '' */
  className: _propTypes.default.string,

  /** @prop Set the toggle switch to disabled | false */
  disabled: _propTypes.default.bool,

  /** @prop Unique HTML ID used for tying label to HTML input for automated testing */
  htmlId: _propTypes.default.string.isRequired,

  /** @prop Sets the label string for the toggle switch | '' */
  label: _propTypes.default.string.isRequired,

  /** @prop Sets the name of the toggle switch | '' */
  name: _propTypes.default.string,

  /** @prop Callback function invoked when state is changed | null */
  onChange: _propTypes.default.func,

  /** @prop Sets the value of the toggle switch | '' */
  value: _propTypes.default.string
};
ToggleSwitch.defaultProps = {
  checked: false,
  className: '',
  disabled: false,
  label: '',
  name: '',
  onChange: null,
  value: ''
};
ToggleSwitch.displayName = 'ToggleSwitch';
var _default = ToggleSwitch;
/**
* @component toggle-switch
* @section default
* @react
import { ToggleSwitch } from '@collabui/react';

export default class ToggleSwitchDefault extends React.PureComponent {
  render() {
    return (
      <ToggleSwitch
        checked={false}
        label='Toggle Switch'
        htmlId='testToggleSwitch1'
      />
    );
  }
}

**/

/**
* @component toggle-switch
* @section filled
* @react
import { ToggleSwitch } from '@collabui/react';

export default class ToggleSwitchFilled extends React.PureComponent {
  render() {
    return (
      <ToggleSwitch
        checked={true}
        label='Toggle Switch'
        htmlId='testToggleSwitch1'
      />
    );
  }
}

**/

exports.default = _default;

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(134);

__webpack_require__(100);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var Topbar =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Topbar, _React$Component);

  function Topbar() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      isMobileOpen: false,
      activeIndex: null,
      focus: 0
    };

    _this.getChildContext = function () {
      return {
        activeIndex: _this.state.activeIndex,
        onActivate: function onActivate(index) {
          return _this.setSelected(index);
        },
        onFocus: function onFocus(index) {
          return _this.setState(function () {
            return {
              focus: index
            };
          });
        },
        focus: _this.state.focus
      };
    };

    _this.setSelected = function (index) {
      if (index === _this.state.activeIndex) return;

      _this.setState(function () {
        return {
          activeIndex: index
        };
      });
    };

    return _this;
  }

  var _proto = Topbar.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        anchor = _this$props.anchor,
        brandAnchorElement = _this$props.brandAnchorElement,
        color = _this$props.color,
        fixed = _this$props.fixed,
        icon = _this$props.icon,
        image = _this$props.image,
        title = _this$props.title;
    var cuiTopBarClass = 'cui-top-bar';
    var cuiBrandClass = 'cui-brand';
    var brandNodeChildren = [_react.default.createElement("div", {
      className: cuiBrandClass + "__logo",
      key: cuiBrandClass + "__logo"
    }, image ? image : _react.default.createElement("i", {
      className: "icon " + icon
    })), _react.default.createElement("div", {
      className: cuiBrandClass + "__title",
      key: cuiBrandClass + "__title"
    }, title)];

    var getBrandAnchor = function getBrandAnchor() {
      return brandAnchorElement ? _react.default.cloneElement(brandAnchorElement, {
        className: "" + cuiBrandClass + ("" + (brandAnchorElement.props.className && " " + brandAnchorElement.props.className || ''))
      }, brandNodeChildren) : _react.default.createElement("a", {
        className: cuiBrandClass,
        href: anchor
      }, brandNodeChildren);
    };

    var brandNode = _react.default.createElement("div", {
      className: cuiTopBarClass + "__brand"
    }, getBrandAnchor());

    var injectChildren = _react.default.Children.map(this.props.children, function (child) {
      if (!child) return;

      if (child.type.displayName === 'TopbarMobile') {
        return _react.default.cloneElement(child, {
          brandNode: brandNode
        });
      } else {
        return child;
      }
    });

    return _react.default.createElement("div", {
      className: "" + cuiTopBarClass + ("" + (fixed && " " + cuiTopBarClass + "--fixed" || '')) + (" " + cuiTopBarClass + "--" + color),
      role: "navigation",
      ref: function ref(_ref) {
        _this2.parentContainer = _ref;
      }
    }, _react.default.createElement("div", {
      className: cuiTopBarClass + "__container"
    }, brandNode, injectChildren));
  };

  return Topbar;
}(_react.default.Component);

Topbar.displayName = 'Topbar';
Topbar.propTypes = {
  /** @prop App Url/Link | null */
  anchor: _propTypes.default.string,

  /** @prop Custom Node to wrap | null */
  brandAnchorElement: _propTypes.default.element,

  /** @prop Children nodes to render inside of Topbar | null */
  children: _propTypes.default.node,

  /** @prop Optional CSS class string | '' */
  className: _propTypes.default.string,

  /** @prop Topbar header color | '' */
  color: _propTypes.default.string,

  /** @prop Determines if Topbar is fixed to top | false */
  fixed: _propTypes.default.bool,

  /** @prop Icon class name | 'icon-cisco-logo' */
  icon: _propTypes.default.string,

  /** @prop Image source URL | null */
  image: _propTypes.default.node,

  /** @prop Topbar title text | '' */
  title: _propTypes.default.string
};
Topbar.defaultProps = {
  anchor: null,
  brandAnchorElement: null,
  children: null,
  className: '',
  color: 'dark',
  fixed: false,
  icon: 'icon-cisco-logo',
  image: null,
  title: ''
};
Topbar.childContextTypes = {
  focus: _propTypes.default.number,
  activeIndex: _propTypes.default.number,
  onActivate: _propTypes.default.func,
  onFocus: _propTypes.default.func
};
Topbar.displayName = 'Topbar';
var _default = Topbar;
exports.default = _default;

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _ = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * Topbar Mobile
 * @param props
 */
var TopbarMobile =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TopbarMobile, _React$Component);

  function TopbarMobile() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      isMobileOpen: false
    };

    _this.handleClose = function () {
      _this.setState({
        isMobileOpen: false
      });
    };

    _this.handleOpen = function () {
      _this.setState({
        isMobileOpen: true
      });
    };

    _this.handleKeyDown = function (e) {
      if (e.which === 32 || e.which === 13 || e.charCode === 32 || e.charCode === 13) {
        _this.handleClose();

        e.preventDefault();
      }
    };

    return _this;
  }

  var _proto = TopbarMobile.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        brandNode = _this$props.brandNode,
        children = _this$props.children,
        closeMenuAriaLabel = _this$props.closeMenuAriaLabel,
        shouldCloseOnClick = _this$props.shouldCloseOnClick,
        openMenuAriaLabel = _this$props.openMenuAriaLabel;
    var isMobileOpen = this.state.isMobileOpen;

    var mobileButton = _react.default.createElement(_.Icon, {
      name: "list-menu_20",
      buttonClassName: "cui-top-bar__mobile-menu-button",
      onClick: this.handleOpen,
      ariaLabel: openMenuAriaLabel,
      "aria-pressed": isMobileOpen
    });

    var passClickHandlerToChildren = _react.default.Children.map(children, function (child) {
      if (!child) return;
      return _react.default.cloneElement(child, {
        onClick: _this2.handleClose
      });
    });

    return _react.default.createElement("div", null, !isMobileOpen && mobileButton, _react.default.createElement("div", {
      className: 'cui-top-bar__mobile cui-tb-mobile' + ("" + (isMobileOpen ? ' open' : '')),
      onClick: function onClick() {
        return shouldCloseOnClick ? _this2.handleClose : null;
      },
      onKeyDown: this.handleKeyDown,
      role: "menu",
      tabIndex: 0
    }, _react.default.createElement(_.Icon, {
      name: "cancel_20",
      buttonClassName: "cui-tb-mobile__close",
      "aria-pressed": isMobileOpen,
      onClick: this.handleClose,
      ariaLabel: closeMenuAriaLabel
    }), _react.default.createElement("span", {
      onClick: this.handleClose,
      onKeyDown: this.handleKeyDown
    }, brandNode), _react.default.createElement(_.ListSeparator, null), _react.default.createElement("nav", {
      className: "cui-tb-mobile__nav"
    }, !shouldCloseOnClick && passClickHandlerToChildren || children)), _react.default.createElement("div", {
      className: 'cui-tb-mobile__mask' + ("" + (isMobileOpen ? ' open' : '')),
      onClick: this.handleClose,
      role: "none"
    }));
  };

  return TopbarMobile;
}(_react.default.Component);

TopbarMobile.displayName = 'TopbarMobile';
TopbarMobile.propTypes = {
  /** @prop Brand Node | null */
  brandNode: _propTypes.default.node,

  /** @prop Children node to render inside of TopbarMobile | null */
  children: _propTypes.default.node,

  /** @prop Aria Label for close Button | 'Close Menu' */
  closeMenuAriaLabel: _propTypes.default.string,

  /** @prop Set mobile menu to close on any click | true */
  shouldCloseOnClick: _propTypes.default.bool,

  /** @prop Aria Label for open Button | 'Open Menu */
  openMenuAriaLabel: _propTypes.default.string
};
TopbarMobile.defaultProps = {
  brandNode: null,
  children: null,
  closeMenuAriaLabel: 'Close Menu',
  shouldCloseOnClick: true,
  openMenuAriaLabel: 'Open Menu'
};
TopbarMobile.displayName = 'TopbarMobile';
var _default = TopbarMobile;
exports.default = _default;

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _ = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var TopbarNav =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TopbarNav, _React$Component);

  function TopbarNav() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = TopbarNav.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className;
    return _react.default.createElement("nav", {
      className: "cui-top-bar__nav" + ("" + (className && " " + className || ''))
    }, _react.default.createElement(_.List, {
      tabType: "horizontal"
    }, children));
  };

  return TopbarNav;
}(_react.default.Component);

TopbarNav.propTypes = {
  /** @prop Children node to render inside of TopbarNav | null */
  children: _propTypes.default.node,

  /** @prop Optional CSS class string | '' */
  className: _propTypes.default.string
};
TopbarNav.defaultProps = {
  children: null,
  className: ''
};
TopbarNav.displayName = 'TopbarNav';
var _default = TopbarNav;
exports.default = _default;

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * Topbar Right
 * @param props
 */
var TopbarRight =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(TopbarRight, _React$PureComponent);

  function TopbarRight() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = TopbarRight.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children;
    return _react.default.createElement("div", {
      className: "cui-top-bar__right" + ("" + (className && " " + className || ''))
    }, children);
  };

  return TopbarRight;
}(_react.default.PureComponent);

TopbarRight.propTypes = {
  /** @prop Children node to render inside of TopbarRight | null */
  children: _propTypes.default.node,

  /** @prop Optional CSS class string | '' */
  className: _propTypes.default.string
};
TopbarRight.defaultProps = {
  children: null,
  className: ''
};
TopbarRight.displayName = 'TopbarRight';
var _default = TopbarRight;
exports.default = _default;

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

__webpack_require__(4);

__webpack_require__(6);

__webpack_require__(5);

__webpack_require__(7);

var _react = _interopRequireDefault(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _ = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * @category communication
 * @component tooltip
 * @variations collab-ui-react
 */
var Tooltip =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Tooltip, _React$Component);

  function Tooltip() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Tooltip.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        tooltip = _this$props.tooltip,
        tooltipTrigger = _this$props.tooltipTrigger,
        width = _this$props.width,
        otherProps = _objectWithoutPropertiesLoose(_this$props, ["children", "className", "tooltip", "tooltipTrigger", "width"]);

    var content = _react.default.createElement("span", _extends({
      className: "cui-tooltip__text"
    }, width && {
      style: {
        width: width + "px"
      }
    }), tooltip);

    return _react.default.createElement(_.Popover, _extends({
      className: 'cui-tooltip' + ("" + (className && " " + className || '')),
      content: content,
      popoverTrigger: tooltipTrigger,
      showArrow: true
    }, otherProps), children);
  };

  return Tooltip;
}(_react.default.Component);

Tooltip.propTypes = {
  /** @prop Children nodes to render inside Tooltip component | null */
  children: _propTypes.default.node,

  /** @prop Optional CSS class string | '' */
  className: _propTypes.default.string,

  /** @prop Tooltip text | '' */
  tooltip: _propTypes.default.string,

  /** @prop Set the action which triggers the Tooltip | 'MouseEnter' */
  tooltipTrigger: _propTypes.default.oneOf(['MouseEnter', 'Click', 'Focus']),

  /** @prop Set the Tooltip width | null */
  width: _propTypes.default.number
};
Tooltip.defaultProps = {
  children: null,
  className: '',
  tooltip: '',
  tooltipTrigger: 'MouseEnter',
  width: null
};
Tooltip.displayName = 'Tooltip';
var _default = Tooltip;
/**
* @component tooltip
* @section default
* @react

import {
  Button,
  Tooltip,
} from '@collabui/react';

export default function TooltipDefault() {
  return (
      <div className='row'>
        <div className="docs-example docs-example--spacing">
          <Tooltip
            tooltip='Hello!'
            tooltipTrigger='Click'
          >
            <Button
              children='Click'
              ariaLabel='Click'
            />
          </Tooltip>
        </div>

        <div className="docs-example docs-example--spacing">
          <Tooltip
            tooltip='Hello!'
            tooltipTrigger='MouseEnter'
          >
            <Button
              children='MouseEnter'
              ariaLabel='MouseEnter'
            />
          </Tooltip>
        </div>

        <div className="docs-example docs-example--spacing">
          <Tooltip
            tooltip='Hello!'
            tooltipTrigger='Focus'
          >
            <Button
              children='Focus'
              ariaLabel='Focus'
            />
          </Tooltip>
        </div>
      </div>
   );
 }

**/

/**
* @component tooltip
* @section delay
* @react

 import {
   Button,
   Tooltip,
 } from '@collabui/react';

 export default function TooltipDelay() {
   return (
      <div className='row'>
        <div className="docs-example docs-example--spacing">
          <Tooltip
            tooltip='Delayed!'
            tooltipTrigger='Click'
            delay={500}
          >
            <Button
              children='Delay'
              ariaLabel='Delay'
            />
          </Tooltip>
        </div>
      </div>
   );
 }

**/

/**
* @component tooltip
* @section direction
* @react

 import {
   Button,
   Tooltip,
 } from '@collabui/react';

 export default function TooltipDirection() {
   return (
      <div className="docs-example docs-example--spacing">
        <Tooltip
          tooltip='Hello!'
          tooltipTrigger='Click'
          direction='right-center'
        >
          <Button
            children='Direction'
            ariaLabel='Direction'
          />
        </Tooltip>
      </div>
   );
 }
**/

/**
* @component tooltip
* @section content
* @react

 import {
   Button,
   Tooltip,
 } from '@collabui/react';

 export default function TooltipContent() {

    const content = (
     <span style={{color: 'white', padding: '16px'}}> content! </span>
    );

   return (
      <div className="docs-example docs-example--spacing">
        <Tooltip
          tooltip='Hello!'
          tooltipTrigger='Click'
          direction='right-center'
          content={content}
        >
          <Button
            children='Content'
            ariaLabel='Content'
          />
        </Tooltip>
      </div>
   );
 }
**/

exports.default = _default;

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.dates = void 0;

var _dates = _interopRequireWildcard(__webpack_require__(60));

exports.dates = _dates;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// index.js